import "core-js/modules/esnext.global-this.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.reduce-right.js";
import "core-js/modules/es.string.trim-end.js";
import "core-js/modules/es.string.trim-start.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/esnext.string.match-all.js";
import "core-js/modules/es.promise.finally.js";
var e, t, n, r, i, o, a, s, u, c, l, f, h, d, v, p, m, g, y, b, k, w, x, j, S, C, _, $, O, A, E, P, M, I, T, N, R, D, z, L, B, q, F, V, H, W, U, J, K, G, Q, Y, Z, X, ee, te, ne, re, ie, oe, ae, se, ue, ce, le, fe, he, de, ve, pe, me, ge, ye, be, ke, we, xe, je, Se, Ce, _e, $e, Oe, Ae, Ee, Pe, Me, Ie, Te, Ne, Re, De, ze, Le, Be, qe, Fe, Ve, He, We, Ue, Je, Ke, Ge, Qe, Ye, Ze, Xe, et, tt, nt, rt, it, ot, at, st, ut, ct, lt, ft, ht, dt, vt, pt, mt, gt, yt, bt, kt, wt, xt, jt, St, Ct, _t, $t, Ot, At, Et, Pt, Mt, It, Tt, Nt, Rt, Dt, zt, Lt, Bt, qt, Ft, Vt, Ht, Wt, Ut, Jt, Kt, Gt, Qt, Yt, Zt, Xt, en, tn, nn, rn, on, an, sn, un, cn, ln, fn, hn, dn, vn, pn, mn, gn, yn, bn, kn, wn, xn, jn, Sn, Cn, _n, $n, On, An, En, Pn, Mn, In, Tn, Nn, Rn, Dn, zn, Ln, Bn, qn, Fn, Vn, Hn, Wn, Un, Jn, Kn, Gn, Qn, Yn, Zn, Xn, er, tr, nr, rr, ir, or, ar, sr, ur, cr, lr, fr, hr, dr, vr, pr, mr, gr, yr, br, kr, wr, xr, jr, Sr, Cr, _r, $r, Or, Ar, Er, Pr, Mr, Ir, Tr, Nr, Rr, Dr, zr, Lr, Br, qr, Fr, Vr, Hr, Wr, Ur, Jr, Kr, Gr, Qr, Yr, Zr, Xr, ei, ti, ni, ri, ii, oi, ai, si, ui, ci, li, fi, hi;
function di(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (di = function di(e) {
    if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
    var n;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }
    function r() {
      return vi(e, arguments, Ai(this).constructor);
    }
    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Si(r, e);
  })(e);
}
function vi(e, t, n) {
  return (vi = Oi() ? Reflect.construct.bind() : function (e, t, n) {
    var r = [null];
    r.push.apply(r, t);
    var i = new (Function.bind.apply(e, r))();
    return n && Si(i, n.prototype), i;
  }).apply(null, arguments);
}
function pi(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function mi() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */mi = function mi() {
    return e;
  };
  var e = {},
    t = Object.prototype,
    n = t.hasOwnProperty,
    r = "function" == typeof Symbol ? Symbol : {},
    i = r.iterator || "@@iterator",
    o = r.asyncIterator || "@@asyncIterator",
    a = r.toStringTag || "@@toStringTag";
  function s(e, t, n) {
    return Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    s({}, "");
  } catch (e) {
    s = function s(e, t, n) {
      return e[t] = n;
    };
  }
  function u(e, t, n, r) {
    var i = t && t.prototype instanceof f ? t : f,
      o = Object.create(i.prototype),
      a = new j(r || []);
    return o._invoke = function (e, t, n) {
      var r = "suspendedStart";
      return function (i, o) {
        if ("executing" === r) throw new Error("Generator is already running");
        if ("completed" === r) {
          if ("throw" === i) throw o;
          return C();
        }
        for (n.method = i, n.arg = o;;) {
          var a = n.delegate;
          if (a) {
            var s = k(a, n);
            if (s) {
              if (s === l) continue;
              return s;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if ("suspendedStart" === r) throw r = "completed", n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          r = "executing";
          var u = c(e, t, n);
          if ("normal" === u.type) {
            if (r = n.done ? "completed" : "suspendedYield", u.arg === l) continue;
            return {
              value: u.arg,
              done: n.done
            };
          }
          "throw" === u.type && (r = "completed", n.method = "throw", n.arg = u.arg);
        }
      };
    }(e, n, a), o;
  }
  function c(e, t, n) {
    try {
      return {
        type: "normal",
        arg: e.call(t, n)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  e.wrap = u;
  var l = {};
  function f() {}
  function h() {}
  function d() {}
  var v = {};
  s(v, i, function () {
    return this;
  });
  var p = Object.getPrototypeOf,
    m = p && p(p(S([])));
  m && m !== t && n.call(m, i) && (v = m);
  var g = d.prototype = f.prototype = Object.create(v);
  function y(e) {
    ["next", "throw", "return"].forEach(function (t) {
      s(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function b(e, t) {
    function r(i, o, a, s) {
      var u = c(e[i], e, o);
      if ("throw" !== u.type) {
        var l = u.arg,
          f = l.value;
        return f && "object" == Li(f) && n.call(f, "__await") ? t.resolve(f.__await).then(function (e) {
          r("next", e, a, s);
        }, function (e) {
          r("throw", e, a, s);
        }) : t.resolve(f).then(function (e) {
          l.value = e, a(l);
        }, function (e) {
          return r("throw", e, a, s);
        });
      }
      s(u.arg);
    }
    var i;
    this._invoke = function (e, n) {
      function o() {
        return new t(function (t, i) {
          r(e, n, t, i);
        });
      }
      return i = i ? i.then(o, o) : o();
    };
  }
  function k(e, t) {
    var n = e.iterator[t.method];
    if (void 0 === n) {
      if (t.delegate = null, "throw" === t.method) {
        if (e.iterator.return && (t.method = "return", t.arg = void 0, k(e, t), "throw" === t.method)) return l;
        t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return l;
    }
    var r = c(n, e.iterator, t.arg);
    if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, l;
    var i = r.arg;
    return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, l) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, l);
  }
  function w(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function x(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function j(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(w, this), this.reset(!0);
  }
  function S(e) {
    if (e) {
      var t = e[i];
      if (t) return t.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var r = -1,
          o = function t() {
            for (; ++r < e.length;) {
              if (n.call(e, r)) return t.value = e[r], t.done = !1, t;
            }
            return t.value = void 0, t.done = !0, t;
          };
        return o.next = o;
      }
    }
    return {
      next: C
    };
  }
  function C() {
    return {
      value: void 0,
      done: !0
    };
  }
  return h.prototype = d, s(g, "constructor", d), s(d, "constructor", h), h.displayName = s(d, a, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
  }, e.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, d) : (e.__proto__ = d, s(e, a, "GeneratorFunction")), e.prototype = Object.create(g), e;
  }, e.awrap = function (e) {
    return {
      __await: e
    };
  }, y(b.prototype), s(b.prototype, o, function () {
    return this;
  }), e.AsyncIterator = b, e.async = function (t, n, r, i, o) {
    void 0 === o && (o = Promise);
    var a = new b(u(t, n, r, i), o);
    return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
      return e.done ? e.value : a.next();
    });
  }, y(g), s(g, a, "Generator"), s(g, i, function () {
    return this;
  }), s(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (e) {
    var t = [];
    for (var n in e) {
      t.push(n);
    }
    return t.reverse(), function n() {
      for (; t.length;) {
        var r = t.pop();
        if (r in e) return n.value = r, n.done = !1, n;
      }
      return n.done = !0, n;
    };
  }, e.values = S, j.prototype = {
    constructor: j,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(x), !e) for (var t in this) {
        "t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
      }
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var t = this;
      function r(n, r) {
        return a.type = "throw", a.arg = e, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var o = this.tryEntries[i],
          a = o.completion;
        if ("root" === o.tryLoc) return r("end");
        if (o.tryLoc <= this.prev) {
          var s = n.call(o, "catchLoc"),
            u = n.call(o, "finallyLoc");
          if (s && u) {
            if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
            if (this.prev < o.finallyLoc) return r(o.finallyLoc);
          } else if (s) {
            if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < o.finallyLoc) return r(o.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var i = this.tryEntries[r];
        if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
          var o = i;
          break;
        }
      }
      o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
      var a = o ? o.completion : {};
      return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, l) : this.complete(a);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), l;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), x(n), l;
      }
    },
    catch: function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.tryLoc === e) {
          var r = n.completion;
          if ("throw" === r.type) {
            var i = r.arg;
            x(n);
          }
          return i;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, t, n) {
      return this.delegate = {
        iterator: S(e),
        resultName: t,
        nextLoc: n
      }, "next" === this.method && (this.arg = void 0), l;
    }
  }, e;
}
function gi(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a),
      u = s.value;
  } catch (e) {
    return void n(e);
  }
  s.done ? t(u) : Promise.resolve(u).then(r, i);
}
function yi(e) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (r, i) {
      var o = e.apply(t, n);
      function a(e) {
        gi(o, r, i, a, s, "next", e);
      }
      function s(e) {
        gi(o, r, i, a, s, "throw", e);
      }
      a(void 0);
    });
  };
}
function bi(e, t) {
  var _n2 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!_n2) {
    if (Array.isArray(e) || (_n2 = Ti(e)) || t && e && "number" == typeof e.length) {
      _n2 && (e = _n2);
      var r = 0,
        i = function i() {};
      return {
        s: i,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: i
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    s = !1;
  return {
    s: function s() {
      _n2 = _n2.call(e);
    },
    n: function n() {
      var e = _n2.next();
      return a = e.done, e;
    },
    e: function e(_e3) {
      s = !0, o = _e3;
    },
    f: function f() {
      try {
        a || null == _n2.return || _n2.return();
      } finally {
        if (s) throw o;
      }
    }
  };
}
function ki() {
  return (ki = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, n) {
    var r = wi(e, t);
    if (r) {
      var i = Object.getOwnPropertyDescriptor(r, t);
      return i.get ? i.get.call(arguments.length < 3 ? e : n) : i.value;
    }
  }).apply(this, arguments);
}
function wi(e, t) {
  for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Ai(e));) {
    ;
  }
  return e;
}
function xi(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == n) return;
    var r,
      i,
      o = [],
      a = !0,
      s = !1;
    try {
      for (n = n.call(e); !(a = (r = n.next()).done) && (o.push(r.value), !t || o.length !== t); a = !0) {
        ;
      }
    } catch (e) {
      s = !0, i = e;
    } finally {
      try {
        a || null == n.return || n.return();
      } finally {
        if (s) throw i;
      }
    }
    return o;
  }(e, t) || Ti(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function ji(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Si(e, t);
}
function Si(e, t) {
  return (Si = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function Ci(e) {
  var t = Oi();
  return function () {
    var n,
      r = Ai(e);
    if (t) {
      var i = Ai(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return _i(this, n);
  };
}
function _i(e, t) {
  if (t && ("object" === Li(t) || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return $i(e);
}
function $i(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Oi() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function Ai(e) {
  return (Ai = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function Ei(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Pi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ei(Object(n), !0).forEach(function (t) {
      Mi(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ei(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function Mi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ii(e) {
  return function (e) {
    if (Array.isArray(e)) return Ni(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || Ti(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Ti(e, t) {
  if (e) {
    if ("string" == typeof e) return Ni(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ni(e, t) : void 0;
  }
}
function Ni(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }
  return r;
}
function Ri(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Di(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function zi(e, t, n) {
  return t && Di(e.prototype, t), n && Di(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Li(e) {
  return (Li = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}
function Bi() {}
var qi = function qi(e) {
  return e;
};
function Fi(e, t) {
  for (var n in t) {
    e[n] = t[n];
  }
  return e;
}
function Vi(e) {
  return e();
}
function Hi() {
  return Object.create(null);
}
function Wi(e) {
  e.forEach(Vi);
}
function Ui(e) {
  return "function" == typeof e;
}
function Ji(e, t) {
  return e != e ? t == t : e !== t || e && "object" === Li(e) || "function" == typeof e;
}
function Ki(e, t) {
  return e != e ? t == t : e !== t;
}
function Gi(e, t, n, r) {
  if (e) {
    var i = Qi(e, t, n, r);
    return e[0](i);
  }
}
function Qi(e, t, n, r) {
  return e[1] && r ? Fi(n.ctx.slice(), e[1](r(t))) : n.ctx;
}
function Yi(e, t, n, r) {
  if (e[2] && r) {
    var i = e[2](r(n));
    if (void 0 === t.dirty) return i;
    if ("object" === Li(i)) {
      for (var o = [], a = Math.max(t.dirty.length, i.length), s = 0; s < a; s += 1) {
        o[s] = t.dirty[s] | i[s];
      }
      return o;
    }
    return t.dirty | i;
  }
  return t.dirty;
}
function Zi(e, t, n, r, i, o) {
  if (i) {
    var a = Qi(t, n, r, o);
    e.p(a, i);
  }
}
function Xi(e) {
  if (e.ctx.length > 32) {
    for (var t = [], n = e.ctx.length / 32, r = 0; r < n; r++) {
      t[r] = -1;
    }
    return t;
  }
  return -1;
}
function eo(e) {
  return null == e ? "" : e;
}
function to(e) {
  return e && Ui(e.destroy) ? e.destroy : Bi;
}
var no,
  ro = "undefined" != typeof window,
  io = ro ? function () {
    return window.performance.now();
  } : function () {
    return Date.now();
  },
  oo = ro ? function (e) {
    return requestAnimationFrame(e);
  } : Bi,
  ao = new Set();
function so(e) {
  ao.forEach(function (t) {
    t.c(e) || (ao.delete(t), t.f());
  }), 0 !== ao.size && oo(so);
}
function uo(e, t) {
  e.appendChild(t);
}
function co(e, t, n) {
  var r = lo(e);
  if (!r.getElementById(t)) {
    var i = go("style");
    i.id = t, i.textContent = n, ho(r, i);
  }
}
function lo(e) {
  if (!e) return document;
  var t = e.getRootNode ? e.getRootNode() : e.ownerDocument;
  return t && t.host ? t : e.ownerDocument;
}
function fo(e) {
  var t = go("style");
  return ho(lo(e), t), t.sheet;
}
function ho(e, t) {
  uo(e.head || e, t);
}
function vo(e, t, n) {
  e.insertBefore(t, n || null);
}
function po(e) {
  e.parentNode.removeChild(e);
}
function mo(e, t) {
  for (var n = 0; n < e.length; n += 1) {
    e[n] && e[n].d(t);
  }
}
function go(e) {
  return document.createElement(e);
}
function yo(e) {
  return document.createElementNS("http://www.w3.org/2000/svg", e);
}
function bo(e) {
  return document.createTextNode(e);
}
function ko() {
  return bo(" ");
}
function wo() {
  return bo("");
}
function xo(e, t, n, r) {
  return e.addEventListener(t, n, r), function () {
    return e.removeEventListener(t, n, r);
  };
}
function jo(e) {
  return function (t) {
    return t.stopPropagation(), e.call(this, t);
  };
}
function So(e, t, n) {
  null == n ? e.removeAttribute(t) : e.getAttribute(t) !== n && e.setAttribute(t, n);
}
function Co(e, t) {
  var n = Object.getOwnPropertyDescriptors(e.__proto__);
  for (var r in t) {
    null == t[r] ? e.removeAttribute(r) : "style" === r ? e.style.cssText = t[r] : "__value" === r ? e.value = e[r] = t[r] : n[r] && n[r].set ? e[r] = t[r] : So(e, r, t[r]);
  }
}
function _o(e, t) {
  for (var n in t) {
    So(e, n, t[n]);
  }
}
function $o(e, t, n) {
  t in e ? e[t] = "boolean" == typeof e[t] && "" === n || n : So(e, t, n);
}
function Oo(e) {
  return Array.from(e.childNodes);
}
function Ao(e, t) {
  t = "" + t, e.wholeText !== t && (e.data = t);
}
function Eo(e, t) {
  e.value = null == t ? "" : t;
}
function Po(e, t, n, r) {
  null === n ? e.style.removeProperty(t) : e.style.setProperty(t, n, r ? "important" : "");
}
function Mo(e, t) {
  for (var n = 0; n < e.options.length; n += 1) {
    var r = e.options[n];
    if (r.__value === t) return void (r.selected = !0);
  }
  e.selectedIndex = -1;
}
function Io() {
  if (void 0 === no) {
    no = !1;
    try {
      "undefined" != typeof window && window.parent && window.parent.document;
    } catch (e) {
      no = !0;
    }
  }
  return no;
}
function To(e, t, n) {
  e.classList[n ? "add" : "remove"](t);
}
function No(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    r = n.bubbles,
    i = void 0 !== r && r,
    o = n.cancelable,
    a = void 0 !== o && o,
    s = document.createEvent("CustomEvent");
  return s.initCustomEvent(e, i, a, t), s;
}
var Ro,
  Do = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      Ri(this, e), this.is_svg = !1, this.is_svg = t, this.e = this.n = null;
    }
    return zi(e, [{
      key: "c",
      value: function value(e) {
        this.h(e);
      }
    }, {
      key: "m",
      value: function value(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        this.e || (this.is_svg ? this.e = yo(t.nodeName) : this.e = go(t.nodeName), this.t = t, this.c(e)), this.i(n);
      }
    }, {
      key: "h",
      value: function value(e) {
        this.e.innerHTML = e, this.n = Array.from(this.e.childNodes);
      }
    }, {
      key: "i",
      value: function value(e) {
        for (var t = 0; t < this.n.length; t += 1) {
          vo(this.t, this.n[t], e);
        }
      }
    }, {
      key: "p",
      value: function value(e) {
        this.d(), this.h(e), this.i(this.a);
      }
    }, {
      key: "d",
      value: function value() {
        this.n.forEach(po);
      }
    }]), e;
  }(),
  zo = new Map(),
  Lo = 0;
function Bo(e) {
  for (var t = 5381, n = e.length; n--;) {
    t = (t << 5) - t ^ e.charCodeAt(n);
  }
  return t >>> 0;
}
function qo(e, t) {
  var n = {
    stylesheet: fo(t),
    rules: {}
  };
  return zo.set(e, n), n;
}
function Fo(e, t, n, r, i, o, a) {
  for (var s = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 0, u = 16.666 / r, c = "{\n", l = 0; l <= 1; l += u) {
    var f = t + (n - t) * o(l);
    c += 100 * l + "%{".concat(a(f, 1 - f), "}\n");
  }
  var h = c + "100% {".concat(a(n, 1 - n), "}\n}"),
    d = "__svelte_".concat(Bo(h), "_").concat(s),
    v = lo(e),
    p = zo.get(v) || qo(v, e),
    m = p.stylesheet,
    g = p.rules;
  g[d] || (g[d] = !0, m.insertRule("@keyframes ".concat(d, " ").concat(h), m.cssRules.length));
  var y = e.style.animation || "";
  return e.style.animation = "".concat(y ? "".concat(y, ", ") : "").concat(d, " ").concat(r, "ms linear ").concat(i, "ms 1 both"), Lo += 1, d;
}
function Vo(e, t) {
  var n = (e.style.animation || "").split(", "),
    r = n.filter(t ? function (e) {
      return e.indexOf(t) < 0;
    } : function (e) {
      return -1 === e.indexOf("__svelte");
    }),
    i = n.length - r.length;
  i && (e.style.animation = r.join(", "), (Lo -= i) || oo(function () {
    Lo || (zo.forEach(function (e) {
      for (var t = e.stylesheet, n = t.cssRules.length; n--;) {
        t.deleteRule(n);
      }
      e.rules = {};
    }), zo.clear());
  }));
}
function Ho(e) {
  Ro = e;
}
function Wo() {
  if (!Ro) throw new Error("Function called outside component initialization");
  return Ro;
}
function Uo(e) {
  Wo().$$.before_update.push(e);
}
function Jo(e) {
  Wo().$$.on_mount.push(e);
}
function Ko(e) {
  Wo().$$.on_destroy.push(e);
}
function Go() {
  var e = Wo();
  return function (t, n) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
      i = r.cancelable,
      o = void 0 !== i && i,
      a = e.$$.callbacks[t];
    if (a) {
      var s = No(t, n, {
        cancelable: o
      });
      return a.slice().forEach(function (t) {
        t.call(e, s);
      }), !s.defaultPrevented;
    }
    return !0;
  };
}
function Qo(e, t) {
  return Wo().$$.context.set(e, t), t;
}
function Yo(e) {
  return Wo().$$.context.get(e);
}
var Zo = [],
  Xo = [],
  ea = [],
  ta = [],
  na = Promise.resolve(),
  ra = !1;
function ia() {
  ra || (ra = !0, na.then(fa));
}
function oa() {
  return ia(), na;
}
function aa(e) {
  ea.push(e);
}
function sa(e) {
  ta.push(e);
}
var ua,
  ca = new Set(),
  la = 0;
function fa() {
  var e = Ro;
  do {
    for (; la < Zo.length;) {
      var t = Zo[la];
      la++, Ho(t), ha(t.$$);
    }
    for (Ho(null), Zo.length = 0, la = 0; Xo.length;) {
      Xo.pop()();
    }
    for (var n = 0; n < ea.length; n += 1) {
      var r = ea[n];
      ca.has(r) || (ca.add(r), r());
    }
    ea.length = 0;
  } while (Zo.length);
  for (; ta.length;) {
    ta.pop()();
  }
  ra = !1, ca.clear(), Ho(e);
}
function ha(e) {
  if (null !== e.fragment) {
    e.update(), Wi(e.before_update);
    var t = e.dirty;
    e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach(aa);
  }
}
function da(e, t, n) {
  e.dispatchEvent(No("".concat(t ? "intro" : "outro").concat(n)));
}
var va,
  pa = new Set();
function ma() {
  va = {
    r: 0,
    c: [],
    p: va
  };
}
function ga() {
  va.r || Wi(va.c), va = va.p;
}
function ya(e, t) {
  e && e.i && (pa.delete(e), e.i(t));
}
function ba(e, t, n, r) {
  if (e && e.o) {
    if (pa.has(e)) return;
    pa.add(e), va.c.push(function () {
      pa.delete(e), r && (n && e.d(1), r());
    }), e.o(t);
  }
}
var ka = {
  duration: 0
};
function wa(e, t, n, r) {
  var i = t(e, n),
    o = r ? 0 : 1,
    a = null,
    s = null,
    u = null;
  function c() {
    u && Vo(e, u);
  }
  function l(e, t) {
    var n = e.b - o;
    return t *= Math.abs(n), {
      a: o,
      b: e.b,
      d: n,
      duration: t,
      start: e.start,
      end: e.start + t,
      group: e.group
    };
  }
  function f(t) {
    var n,
      r = i || ka,
      f = r.delay,
      h = void 0 === f ? 0 : f,
      d = r.duration,
      v = void 0 === d ? 300 : d,
      p = r.easing,
      m = void 0 === p ? qi : p,
      g = r.tick,
      y = void 0 === g ? Bi : g,
      b = r.css,
      k = {
        start: io() + h,
        b: t
      };
    t || (k.group = va, va.r += 1), a || s ? s = k : (b && (c(), u = Fo(e, o, t, v, h, m, b)), t && y(0, 1), a = l(k, v), aa(function () {
      return da(e, t, "start");
    }), n = function n(t) {
      if (s && t > s.start && (a = l(s, v), s = null, da(e, a.b, "start"), b && (c(), u = Fo(e, o, a.b, a.duration, 0, m, i.css))), a) if (t >= a.end) y(o = a.b, 1 - o), da(e, a.b, "end"), s || (a.b ? c() : --a.group.r || Wi(a.group.c)), a = null;else if (t >= a.start) {
        var n = t - a.start;
        o = a.a + a.d * m(n / a.duration), y(o, 1 - o);
      }
      return !(!a && !s);
    }, 0 === ao.size && oo(so), new Promise(function (e) {
      ao.add({
        c: n,
        f: e
      });
    }));
  }
  return {
    run: function run(e) {
      Ui(i) ? (ua || (ua = Promise.resolve()).then(function () {
        ua = null;
      }), ua).then(function () {
        i = i(), f(e);
      }) : f(e);
    },
    end: function end() {
      c(), a = s = null;
    }
  };
}
var xa = "undefined" != typeof window ? window : "undefined" != typeof globalThis ? globalThis : global;
function ja(e, t) {
  e.d(1), t.delete(e.key);
}
function Sa(e, t) {
  ba(e, 1, 1, function () {
    t.delete(e.key);
  });
}
function Ca(e, t, n, r, i, o, a, s, u, c, l, f) {
  for (var h = e.length, d = o.length, v = h, p = {}; v--;) {
    p[e[v].key] = v;
  }
  var m = [],
    g = new Map(),
    y = new Map();
  for (v = d; v--;) {
    var b = f(i, o, v),
      k = n(b),
      w = a.get(k);
    w ? r && w.p(b, t) : (w = c(k, b)).c(), g.set(k, m[v] = w), k in p && y.set(k, Math.abs(v - p[k]));
  }
  var x = new Set(),
    j = new Set();
  function S(e) {
    ya(e, 1), e.m(s, l), a.set(e.key, e), l = e.first, d--;
  }
  for (; h && d;) {
    var C = m[d - 1],
      _ = e[h - 1],
      $ = C.key,
      O = _.key;
    C === _ ? (l = C.first, h--, d--) : g.has(O) ? !a.has($) || x.has($) ? S(C) : j.has(O) ? h-- : y.get($) > y.get(O) ? (j.add($), S(C)) : (x.add(O), h--) : (u(_, a), h--);
  }
  for (; h--;) {
    var A = e[h];
    g.has(A.key) || u(A, a);
  }
  for (; d;) {
    S(m[d - 1]);
  }
  return m;
}
function _a(e, t) {
  for (var n = {}, r = {}, i = {
      $$scope: 1
    }, o = e.length; o--;) {
    var a = e[o],
      s = t[o];
    if (s) {
      for (var u in a) {
        u in s || (r[u] = 1);
      }
      for (var c in s) {
        i[c] || (n[c] = s[c], i[c] = 1);
      }
      e[o] = s;
    } else for (var l in a) {
      i[l] = 1;
    }
  }
  for (var f in r) {
    f in n || (n[f] = void 0);
  }
  return n;
}
function $a(e) {
  return "object" === Li(e) && null !== e ? e : {};
}
function Oa(e, t, n) {
  var r = e.$$.props[t];
  void 0 !== r && (e.$$.bound[r] = n, n(e.$$.ctx[r]));
}
function Aa(e) {
  e && e.c();
}
function Ea(e, t, n, r) {
  var i = e.$$,
    o = i.fragment,
    a = i.on_mount,
    s = i.on_destroy,
    u = i.after_update;
  o && o.m(t, n), r || aa(function () {
    var t = a.map(Vi).filter(Ui);
    s ? s.push.apply(s, Ii(t)) : Wi(t), e.$$.on_mount = [];
  }), u.forEach(aa);
}
function Pa(e, t) {
  var n = e.$$;
  null !== n.fragment && (Wi(n.on_destroy), n.fragment && n.fragment.d(t), n.on_destroy = n.fragment = null, n.ctx = []);
}
function Ma(e, t) {
  -1 === e.$$.dirty[0] && (Zo.push(e), ia(), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function Ia(e, t, n, r, i, o, a) {
  var s = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : [-1],
    u = Ro;
  Ho(e);
  var c = e.$$ = {
    fragment: null,
    ctx: null,
    props: o,
    update: Bi,
    not_equal: i,
    bound: Hi(),
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(t.context || (u ? u.$$.context : [])),
    callbacks: Hi(),
    dirty: s,
    skip_bound: !1,
    root: t.target || u.$$.root
  };
  a && a(c.root);
  var l = !1;
  if (c.ctx = n ? n(e, t.props || {}, function (t, n) {
    var r = !(arguments.length <= 2) && arguments.length - 2 ? arguments.length <= 2 ? void 0 : arguments[2] : n;
    return c.ctx && i(c.ctx[t], c.ctx[t] = r) && (!c.skip_bound && c.bound[t] && c.bound[t](r), l && Ma(e, t)), n;
  }) : [], c.update(), l = !0, Wi(c.before_update), c.fragment = !!r && r(c.ctx), t.target) {
    if (t.hydrate) {
      var f = Oo(t.target);
      c.fragment && c.fragment.l(f), f.forEach(po);
    } else c.fragment && c.fragment.c();
    t.intro && ya(e.$$.fragment), Ea(e, t.target, t.anchor, t.customElement), fa();
  }
  Ho(u);
}
var Ta = function () {
  function e() {
    Ri(this, e);
  }
  return zi(e, [{
    key: "$destroy",
    value: function value() {
      Pa(this, 1), this.$destroy = Bi;
    }
  }, {
    key: "$on",
    value: function value(e, t) {
      var n = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
      return n.push(t), function () {
        var e = n.indexOf(t);
        -1 !== e && n.splice(e, 1);
      };
    }
  }, {
    key: "$set",
    value: function value(e) {
      var t;
      this.$$set && (t = e, 0 !== Object.keys(t).length) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
    }
  }]), e;
}();
function Na(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : !!Da("debug");
  if (t) {
    var n = za(e);
    return function () {
      for (var t, r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
        i[o] = arguments[o];
      }
      (t = console).log.apply(t, ["%c".concat(e), "color:".concat(n)].concat(i));
    };
  }
  return Ra;
}
function Ra() {}
function Da(e) {
  try {
    if ("undefined" != typeof window && void 0 !== window.localStorage) return window.localStorage[e];
  } catch (e) {}
}
function za(e) {
  for (var t = 0, n = 0; n < e.length; n++) {
    t = (t << 5) - t + e.charCodeAt(n), t |= 0;
  }
  return La[Math.abs(t) % La.length];
}
var La = ["#0000CC", "#0099FF", "#009400", "#8dd200", "#CCCC00", "#CC9933", "#ae04e7", "#ff35d7", "#FF3333", "#FF6600", "#FF9933", "#FFCC33"];
function Ba(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    n = t.delay,
    r = void 0 === n ? 0 : n,
    i = t.duration,
    o = void 0 === i ? 400 : i,
    a = t.easing,
    s = void 0 === a ? qi : a,
    u = +getComputedStyle(e).opacity;
  return {
    delay: r,
    duration: o,
    easing: s,
    css: function css(e) {
      return "opacity: ".concat(e * u);
    }
  };
}
var qa = xa.window;
function Fa(e) {
  co(e, "svelte-g4wg3a", ".svelte-g4wg3a{box-sizing:border-box}.bg.svelte-g4wg3a{position:fixed;z-index:1000;top:0;left:0;display:flex;flex-direction:column;justify-content:center;width:100vw;height:100vh;background:rgba(0, 0, 0, 0.66)}.wrap.svelte-g4wg3a{position:relative;margin:2rem;max-height:100%}.window.svelte-g4wg3a{position:relative;width:40rem;max-width:100%;max-height:100%;margin:2rem auto;color:black;border-radius:0.5rem;background:white}.content.svelte-g4wg3a{position:relative;padding:1rem;max-height:calc(100vh - 4rem);overflow:auto}.close.svelte-g4wg3a{display:block;box-sizing:border-box;position:absolute;z-index:1000;top:1rem;right:1rem;margin:0;padding:0;width:1.5rem;height:1.5rem;border:0;color:black;border-radius:1.5rem;background:white;box-shadow:0 0 0 1px black;transition:transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),\n      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);-webkit-appearance:none}.close.svelte-g4wg3a:before,.close.svelte-g4wg3a:after{content:'';display:block;box-sizing:border-box;position:absolute;top:50%;width:1rem;height:1px;background:black;transform-origin:center;transition:height 0.2s cubic-bezier(0.25, 0.1, 0.25, 1),\n      background 0.2s cubic-bezier(0.25, 0.1, 0.25, 1)}.close.svelte-g4wg3a:before{-webkit-transform:translate(0, -50%) rotate(45deg);-moz-transform:translate(0, -50%) rotate(45deg);transform:translate(0, -50%) rotate(45deg);left:0.25rem}.close.svelte-g4wg3a:after{-webkit-transform:translate(0, -50%) rotate(-45deg);-moz-transform:translate(0, -50%) rotate(-45deg);transform:translate(0, -50%) rotate(-45deg);left:0.25rem}.close.svelte-g4wg3a:hover{background:black}.close.svelte-g4wg3a:hover:before,.close.svelte-g4wg3a:hover:after{height:2px;background:white}.close.svelte-g4wg3a:focus{border-color:#3399ff;box-shadow:0 0 0 2px #3399ff}.close.svelte-g4wg3a:active{transform:scale(0.9)}.close.svelte-g4wg3a:hover,.close.svelte-g4wg3a:focus,.close.svelte-g4wg3a:active{outline:none}");
}
function Va(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    _c2,
    l,
    f,
    h,
    d,
    v,
    _p2,
    _m2,
    g,
    y = e[1].closeButton && Ha(e),
    b = e[2];
  return b && (a = new b({})), {
    c: function c() {
      t = go("div"), n = go("div"), r = go("div"), y && y.c(), i = ko(), o = go("div"), a && Aa(a.$$.fragment), So(o, "class", s = eo(e[1].classContent) + " svelte-g4wg3a"), So(o, "style", e[9]), To(o, "content", !e[0]), So(r, "class", u = eo(e[1].classWindow) + " svelte-g4wg3a"), So(r, "role", "dialog"), So(r, "aria-modal", "true"), So(r, "aria-label", _c2 = e[1].ariaLabelledBy ? null : e[1].ariaLabel || null), So(r, "aria-labelledby", l = e[1].ariaLabelledBy || null), So(r, "style", e[8]), To(r, "window", !e[0]), So(n, "class", h = eo(e[1].classWindowWrap) + " svelte-g4wg3a"), So(n, "style", e[7]), To(n, "wrap", !e[0]), So(t, "class", d = eo(e[1].classBg) + " svelte-g4wg3a"), So(t, "style", e[6]), To(t, "bg", !e[0]);
    },
    m: function m(s, u) {
      vo(s, t, u), uo(t, n), uo(n, r), y && y.m(r, null), uo(r, i), uo(r, o), a && Ea(a, o, null), e[48](r), e[49](n), e[50](t), _p2 = !0, _m2 || (g = [xo(r, "introstart", function () {
        Ui(e[13]) && e[13].apply(this, arguments);
      }), xo(r, "outrostart", function () {
        Ui(e[14]) && e[14].apply(this, arguments);
      }), xo(r, "introend", function () {
        Ui(e[15]) && e[15].apply(this, arguments);
      }), xo(r, "outroend", function () {
        Ui(e[16]) && e[16].apply(this, arguments);
      }), xo(t, "mousedown", e[20]), xo(t, "mouseup", e[21])], _m2 = !0);
    },
    p: function p(f, v) {
      if ((e = f)[1].closeButton ? y ? (y.p(e, v), 2 & v[0] && ya(y, 1)) : ((y = Ha(e)).c(), ya(y, 1), y.m(r, i)) : y && (ma(), ba(y, 1, 1, function () {
        y = null;
      }), ga()), b !== (b = e[2])) {
        if (a) {
          ma();
          var m = a;
          ba(m.$$.fragment, 1, 0, function () {
            Pa(m, 1);
          }), ga();
        }
        b ? (Aa((a = new b({})).$$.fragment), ya(a.$$.fragment, 1), Ea(a, o, null)) : a = null;
      }
      (!_p2 || 2 & v[0] && s !== (s = eo(e[1].classContent) + " svelte-g4wg3a")) && So(o, "class", s), (!_p2 || 512 & v[0]) && So(o, "style", e[9]), 3 & v[0] && To(o, "content", !e[0]), (!_p2 || 2 & v[0] && u !== (u = eo(e[1].classWindow) + " svelte-g4wg3a")) && So(r, "class", u), (!_p2 || 2 & v[0] && _c2 !== (_c2 = e[1].ariaLabelledBy ? null : e[1].ariaLabel || null)) && So(r, "aria-label", _c2), (!_p2 || 2 & v[0] && l !== (l = e[1].ariaLabelledBy || null)) && So(r, "aria-labelledby", l), (!_p2 || 256 & v[0]) && So(r, "style", e[8]), 3 & v[0] && To(r, "window", !e[0]), (!_p2 || 2 & v[0] && h !== (h = eo(e[1].classWindowWrap) + " svelte-g4wg3a")) && So(n, "class", h), (!_p2 || 128 & v[0]) && So(n, "style", e[7]), 3 & v[0] && To(n, "wrap", !e[0]), (!_p2 || 2 & v[0] && d !== (d = eo(e[1].classBg) + " svelte-g4wg3a")) && So(t, "class", d), (!_p2 || 64 & v[0]) && So(t, "style", e[6]), 3 & v[0] && To(t, "bg", !e[0]);
    },
    i: function i(n) {
      _p2 || (ya(y), a && ya(a.$$.fragment, n), aa(function () {
        f || (f = wa(r, e[12], e[1].transitionWindowProps, !0)), f.run(1);
      }), aa(function () {
        v || (v = wa(t, e[11], e[1].transitionBgProps, !0)), v.run(1);
      }), _p2 = !0);
    },
    o: function o(n) {
      ba(y), a && ba(a.$$.fragment, n), f || (f = wa(r, e[12], e[1].transitionWindowProps, !1)), f.run(0), v || (v = wa(t, e[11], e[1].transitionBgProps, !1)), v.run(0), _p2 = !1;
    },
    d: function d(n) {
      n && po(t), y && y.d(), a && Pa(a), e[48](null), n && f && f.end(), e[49](null), e[50](null), n && v && v.end(), _m2 = !1, Wi(g);
    }
  };
}
function Ha(e) {
  var t,
    n,
    r,
    i,
    _o2,
    a = [Ua, Wa],
    s = [];
  function u(e, n) {
    return 2 & n[0] && (t = null), null == t && (t = !!e[17](e[1].closeButton)), t ? 0 : 1;
  }
  return n = u(e, [-1, -1, -1]), r = s[n] = a[n](e), {
    c: function c() {
      r.c(), i = wo();
    },
    m: function m(e, t) {
      s[n].m(e, t), vo(e, i, t), _o2 = !0;
    },
    p: function p(e, t) {
      var o = n;
      (n = u(e, t)) === o ? s[n].p(e, t) : (ma(), ba(s[o], 1, 1, function () {
        s[o] = null;
      }), ga(), (r = s[n]) ? r.p(e, t) : (r = s[n] = a[n](e)).c(), ya(r, 1), r.m(i.parentNode, i));
    },
    i: function i(e) {
      _o2 || (ya(r), _o2 = !0);
    },
    o: function o(e) {
      ba(r), _o2 = !1;
    },
    d: function d(e) {
      s[n].d(e), e && po(i);
    }
  };
}
function Wa(e) {
  var t, n, r, i;
  return {
    c: function c() {
      So(t = go("button"), "class", n = eo(e[1].classCloseButton) + " svelte-g4wg3a"), So(t, "aria-label", "Close modal"), So(t, "style", e[10]), To(t, "close", !e[0]);
    },
    m: function m(n, o) {
      vo(n, t, o), r || (i = xo(t, "click", e[18]), r = !0);
    },
    p: function p(e, r) {
      2 & r[0] && n !== (n = eo(e[1].classCloseButton) + " svelte-g4wg3a") && So(t, "class", n), 1024 & r[0] && So(t, "style", e[10]), 3 & r[0] && To(t, "close", !e[0]);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t), r = !1, i();
    }
  };
}
function Ua(e) {
  var t,
    n,
    r,
    i = e[1].closeButton;
  function o(e) {
    return {
      props: {
        onClose: e[18]
      }
    };
  }
  return i && (t = new i(o(e))), {
    c: function c() {
      t && Aa(t.$$.fragment), n = wo();
    },
    m: function m(e, i) {
      t && Ea(t, e, i), vo(e, n, i), r = !0;
    },
    p: function p(e, r) {
      if (i !== (i = e[1].closeButton)) {
        if (t) {
          ma();
          var a = t;
          ba(a.$$.fragment, 1, 0, function () {
            Pa(a, 1);
          }), ga();
        }
        i ? (Aa((t = new i(o(e))).$$.fragment), ya(t.$$.fragment, 1), Ea(t, n.parentNode, n)) : t = null;
      }
    },
    i: function i(e) {
      r || (t && ya(t.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      t && ba(t.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(n), t && Pa(t, e);
    }
  };
}
function Ja(e) {
  var t,
    n,
    r,
    i,
    _o3 = e[2] && Va(e),
    a = e[47].default,
    s = Gi(a, e, e[46], null);
  return {
    c: function c() {
      _o3 && _o3.c(), t = ko(), s && s.c();
    },
    m: function m(a, u) {
      _o3 && _o3.m(a, u), vo(a, t, u), s && s.m(a, u), n = !0, r || (i = xo(qa, "keydown", e[19]), r = !0);
    },
    p: function p(e, r) {
      e[2] ? _o3 ? (_o3.p(e, r), 4 & r[0] && ya(_o3, 1)) : ((_o3 = Va(e)).c(), ya(_o3, 1), _o3.m(t.parentNode, t)) : _o3 && (ma(), ba(_o3, 1, 1, function () {
        _o3 = null;
      }), ga()), s && s.p && (!n || 32768 & r[1]) && Zi(s, a, e, e[46], n ? Yi(a, e[46], r, null) : Xi(e[46]), null);
    },
    i: function i(e) {
      n || (ya(_o3), ya(s, e), n = !0);
    },
    o: function o(e) {
      ba(_o3), ba(s, e), n = !1;
    },
    d: function d(e) {
      _o3 && _o3.d(e), e && po(t), s && s.d(e), r = !1, i();
    }
  };
}
function Ka(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return function (n) {
    return new e(Pi(Pi({}, n), {}, {
      props: Pi(Pi({}, t), n.props)
    }));
  };
}
function Ga(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f,
    h,
    d,
    v,
    p,
    m,
    g,
    y = t.$$slots,
    b = void 0 === y ? {} : y,
    k = t.$$scope,
    w = Go(),
    x = Qo,
    j = t.show,
    S = void 0 === j ? null : j,
    C = t.key,
    _ = void 0 === C ? "simple-modal" : C,
    $ = t.ariaLabel,
    O = void 0 === $ ? null : $,
    A = t.ariaLabelledBy,
    E = void 0 === A ? null : A,
    P = t.closeButton,
    M = void 0 === P || P,
    I = t.closeOnEsc,
    T = void 0 === I || I,
    N = t.closeOnOuterClick,
    R = void 0 === N || N,
    D = t.styleBg,
    z = void 0 === D ? {} : D,
    L = t.styleWindowWrap,
    B = void 0 === L ? {} : L,
    q = t.styleWindow,
    F = void 0 === q ? {} : q,
    V = t.styleContent,
    H = void 0 === V ? {} : V,
    W = t.styleCloseButton,
    U = void 0 === W ? {} : W,
    J = t.classBg,
    K = void 0 === J ? null : J,
    G = t.classWindowWrap,
    Q = void 0 === G ? null : G,
    Y = t.classWindow,
    Z = void 0 === Y ? null : Y,
    X = t.classContent,
    ee = void 0 === X ? null : X,
    te = t.classCloseButton,
    ne = void 0 === te ? null : te,
    re = t.unstyled,
    ie = void 0 !== re && re,
    oe = t.setContext,
    ae = void 0 === oe ? x : oe,
    se = t.transitionBg,
    ue = void 0 === se ? Ba : se,
    ce = t.transitionBgProps,
    le = void 0 === ce ? {
      duration: 250
    } : ce,
    fe = t.transitionWindow,
    he = void 0 === fe ? ue : fe,
    de = t.transitionWindowProps,
    ve = void 0 === de ? le : de,
    pe = t.disableFocusTrap,
    me = void 0 !== pe && pe,
    ge = {
      ariaLabel: O,
      ariaLabelledBy: E,
      closeButton: M,
      closeOnEsc: T,
      closeOnOuterClick: R,
      styleBg: z,
      styleWindowWrap: B,
      styleWindow: F,
      styleContent: H,
      styleCloseButton: U,
      classBg: K,
      classWindowWrap: Q,
      classWindow: Z,
      classContent: ee,
      classCloseButton: ne,
      transitionBg: ue,
      transitionBgProps: le,
      transitionWindow: he,
      transitionWindowProps: ve,
      disableFocusTrap: me,
      unstyled: ie
    },
    ye = Pi({}, ge),
    be = null,
    ke = function ke(e) {
      return e ? Object.keys(e).reduce(function (t, n) {
        return "".concat(t, "; ").concat(function (e) {
          return e.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
        }(n), ": ").concat(e[n]);
      }, "") : "";
    },
    we = function we(e) {
      return !!(e && e.constructor && e.call && e.apply);
    },
    xe = function xe() {
      n(6, s = ke(Object.assign({}, {
        width: window.innerWidth,
        height: window.innerHeight
      }, ye.styleBg))), n(7, u = ke(ye.styleWindowWrap)), n(8, c = ke(ye.styleWindow)), n(9, l = ke(ye.styleContent)), n(10, f = ke(ye.styleCloseButton)), n(11, h = ye.transitionBg), n(12, d = ye.transitionWindow);
    },
    je = function je() {},
    Se = je,
    Ce = je,
    _e = je,
    $e = je,
    Oe = function Oe(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      n(2, be = Ka(e, t)), n(1, ye = Pi(Pi({}, ge), r)), xe(), Ee(), n(13, Se = function Se(e) {
        i.onOpen && i.onOpen(e), w("open"), w("opening");
      }), n(14, Ce = function Ce(e) {
        i.onClose && i.onClose(e), w("close"), w("closing");
      }), n(15, _e = function _e(e) {
        i.onOpened && i.onOpened(e), w("opened");
      }), n(16, $e = function $e(e) {
        i.onClosed && i.onClosed(e), w("closed");
      });
    },
    Ae = function Ae() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      be && (n(14, Ce = e.onClose || Ce), n(16, $e = e.onClosed || $e), n(2, be = null), Pe());
    },
    Ee = function Ee() {
      a = window.scrollY, v = document.body.style.position, p = document.body.style.overflow, m = document.body.style.width, document.body.style.position = "fixed", document.body.style.top = "-".concat(a, "px"), document.body.style.overflow = "hidden", document.body.style.width = "100%";
    },
    Pe = function Pe() {
      document.body.style.position = v || "", document.body.style.top = "", document.body.style.overflow = p || "", document.body.style.width = m || "", window.scrollTo(0, a);
    };
  ae(_, {
    open: Oe,
    close: Ae
  });
  var Me = !1;
  return Ko(function () {
    Me && Ae();
  }), Jo(function () {
    n(45, Me = !0);
  }), e.$$set = function (e) {
    "show" in e && n(22, S = e.show), "key" in e && n(23, _ = e.key), "ariaLabel" in e && n(24, O = e.ariaLabel), "ariaLabelledBy" in e && n(25, E = e.ariaLabelledBy), "closeButton" in e && n(26, M = e.closeButton), "closeOnEsc" in e && n(27, T = e.closeOnEsc), "closeOnOuterClick" in e && n(28, R = e.closeOnOuterClick), "styleBg" in e && n(29, z = e.styleBg), "styleWindowWrap" in e && n(30, B = e.styleWindowWrap), "styleWindow" in e && n(31, F = e.styleWindow), "styleContent" in e && n(32, H = e.styleContent), "styleCloseButton" in e && n(33, U = e.styleCloseButton), "classBg" in e && n(34, K = e.classBg), "classWindowWrap" in e && n(35, Q = e.classWindowWrap), "classWindow" in e && n(36, Z = e.classWindow), "classContent" in e && n(37, ee = e.classContent), "classCloseButton" in e && n(38, ne = e.classCloseButton), "unstyled" in e && n(0, ie = e.unstyled), "setContext" in e && n(39, ae = e.setContext), "transitionBg" in e && n(40, ue = e.transitionBg), "transitionBgProps" in e && n(41, le = e.transitionBgProps), "transitionWindow" in e && n(42, he = e.transitionWindow), "transitionWindowProps" in e && n(43, ve = e.transitionWindowProps), "disableFocusTrap" in e && n(44, me = e.disableFocusTrap), "$$scope" in e && n(46, k = e.$$scope);
  }, e.$$.update = function () {
    4194304 & e.$$.dirty[0] | 16384 & e.$$.dirty[1] && Me && (we(S) ? Oe(S) : Ae());
  }, [ie, ye, be, r, i, o, s, u, c, l, f, h, d, Se, Ce, _e, $e, we, Ae, function (e) {
    if (ye.closeOnEsc && be && "Escape" === e.key && (e.preventDefault(), Ae()), be && "Tab" === e.key && !ye.disableFocusTrap) {
      var t = o.querySelectorAll("*"),
        n = Array.from(t).filter(function (e) {
          return e.tabIndex >= 0;
        }).sort(function (e, t) {
          return e.tabIndex - t.tabIndex;
        }),
        r = n.indexOf(document.activeElement);
      -1 === r && e.shiftKey && (r = 0), r += n.length + (e.shiftKey ? -1 : 1), n[r %= n.length].focus(), e.preventDefault();
    }
  }, function (e) {
    !ye.closeOnOuterClick || e.target !== r && e.target !== i || (g = e.target);
  }, function (e) {
    ye.closeOnOuterClick && e.target === g && (e.preventDefault(), Ae());
  }, S, _, O, E, M, T, R, z, B, F, H, U, K, Q, Z, ee, ne, ae, ue, le, he, ve, me, Me, k, b, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(5, o = e);
    });
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(4, i = e);
    });
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(3, r = e);
    });
  }];
}
var Qa = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, Ga, Ja, Ji, {
        show: 22,
        key: 23,
        ariaLabel: 24,
        ariaLabelledBy: 25,
        closeButton: 26,
        closeOnEsc: 27,
        closeOnOuterClick: 28,
        styleBg: 29,
        styleWindowWrap: 30,
        styleWindow: 31,
        styleContent: 32,
        styleCloseButton: 33,
        classBg: 34,
        classWindowWrap: 35,
        classWindow: 36,
        classContent: 37,
        classCloseButton: 38,
        unstyled: 0,
        setContext: 39,
        transitionBg: 40,
        transitionBgProps: 41,
        transitionWindow: 42,
        transitionWindowProps: 43,
        disableFocusTrap: 44
      }, Fa, [-1, -1, -1]), r;
    }
    return zi(n);
  }(),
  Ya = "tree",
  Za = "code",
  Xa = Symbol("id"),
  es = Symbol("expanded"),
  ts = Symbol("visible sections"),
  ns = Symbol("keys"),
  rs = Symbol("search:property"),
  is = Symbol("search:value"),
  os = Symbol("enforce string"),
  as = Symbol("selection"),
  ss = Symbol("validation:error"),
  us = [{
    start: 0,
    end: 100
  }],
  cs = {
    closeButton: !1,
    classBg: "jse-modal-bg",
    classWindow: "jse-modal-window",
    classWindowWrap: "jse-modal-window-wrap",
    classContent: "jse-modal-content"
  },
  ls = Pi(Pi({}, cs), {}, {
    classWindow: "jse-modal-window jse-modal-window-sort"
  }),
  fs = Pi(Pi({}, cs), {}, {
    classWindow: "jse-modal-window jse-modal-window-transform"
  }),
  hs = "Insert or paste contents, enter [ insert a new array, enter { to insert a new object, or start typing to insert a new value",
  ds = "Open context menu (Click here, right click on the selection, or use the context menu button or Ctrl+Q)",
  vs = "NO",
  ps = "SELF",
  ms = "NEXT_INSIDE",
  gs = 0;
function ys() {
  return ++gs;
}
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
function bs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ks = {
  exports: {}
};
!function (e) {
  function t(e) {
    return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function n(e, t) {
    return JSON.stringify(e) === JSON.stringify(t);
  }
  function r(e, t) {
    return e === t;
  }
  function i(e) {
    return e.slice(0, e.length - 1);
  }
  function o(e) {
    return e[e.length - 1];
  }
  function a(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : r;
    if (e.length < t.length) return !1;
    for (var i = 0; i < t.length; i++) {
      if (!n(e[i], t[i])) return !1;
    }
    return !0;
  }
  function s(e) {
    return "object" === t(e) && null !== e;
  }
  function u(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? u(Object(n), !0).forEach(function (t) {
        l(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function l(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function f(e) {
    return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function h(e) {
    if (Array.isArray(e)) {
      var t = e.slice();
      return Object.getOwnPropertySymbols(e).forEach(function (n) {
        t[n] = e[n];
      }), t;
    }
    if ("object" === f(e)) {
      var n = c({}, e);
      return Object.getOwnPropertySymbols(e).forEach(function (t) {
        n[t] = e[t];
      }), n;
    }
    return e;
  }
  function d(e, t, n) {
    if (e[t] === n) return e;
    var r = h(e);
    return r[t] = n, r;
  }
  function v(e, t) {
    for (var n = e, r = 0; r < t.length;) {
      n = s(n) ? n[t[r]] : void 0, r++;
    }
    return n;
  }
  function p(e, t, n) {
    var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    if (0 === t.length) return n;
    var i = t[0],
      o = p(e ? e[i] : void 0, t.slice(1), n, r);
    if (!s(e)) {
      if (r) {
        var a = "number" == typeof i ? [] : {};
        return a[i] = o, a;
      }
      throw new Error("Path does not exist");
    }
    return d(e, i, o);
  }
  function m(e, t, n) {
    if (0 === t.length) return n(e);
    if (!s(e)) throw new Error("Path doesn't exist");
    var r = t[0];
    return d(e, r, m(e[r], t.slice(1), n));
  }
  function g(e, t) {
    if (0 === t.length) return e;
    if (!s(e)) throw new Error("Path does not exist");
    if (1 === t.length) {
      var n = t[0];
      if (n in e) {
        var r = h(e);
        return Array.isArray(r) ? r.splice(n, 1) : delete r[n], r;
      }
      return e;
    }
    var i = t[0];
    return d(e, i, g(e[i], t.slice(1)));
  }
  function y(e, t, n) {
    var r = t.slice(0, t.length - 1),
      i = t[t.length - 1];
    return m(e, r, function (e) {
      if (!Array.isArray(e)) throw new TypeError("Array expected at path " + JSON.stringify(r));
      var t = h(e);
      return t.splice(i, 0, n), t;
    });
  }
  function b(e, t) {
    return void 0 !== e && (0 === t.length || b(e[t[0]], t.slice(1)));
  }
  function k(e) {
    var t = e.split("/");
    return t.shift(), t.map(function (e) {
      return e.replace(/~1/g, "/").replace(/~0/g, "~");
    });
  }
  function w(e) {
    return e.map(function (e) {
      return "/" + String(e).replace(/~/g, "~0").replace(/\//g, "~1");
    }).join("");
  }
  function x(e, t, n) {
    for (var r = e, i = 0; i < t.length; i++) {
      M(t[i]);
      var o = I(r, t[i]);
      if (n && n.before) {
        var a = n.before(r, o);
        void 0 !== a && (void 0 !== a.json && (r = a.json), void 0 !== a.operation && (o = a.operation));
      }
      var s = r,
        u = j[o.op];
      if (u) r = u(r, o);else {
        if ("test" !== o.op) throw new Error("Unknown JSONPatch operation " + JSON.stringify(o.op));
        A(r, o);
      }
      if (n && n.after) {
        var c = n.after(r, o, s);
        void 0 !== c && (r = c);
      }
    }
    return r;
  }
  var j = {
    add: _,
    remove: C,
    replace: S,
    copy: $,
    move: O
  };
  function S(e, t) {
    return p(e, t.path, t.value);
  }
  function C(e, t) {
    return g(e, t.path);
  }
  function _(e, t) {
    var n = t.path,
      r = t.value;
    return E(e, n) ? y(e, n, r) : p(e, n, r);
  }
  function $(e, t) {
    var n = t.path,
      r = t.from,
      i = v(e, r);
    return E(e, n) ? y(e, n, i) : p(e, n, v(e, r));
  }
  function O(e, t) {
    var n = t.path,
      r = t.from,
      i = v(e, r),
      o = g(e, r);
    return E(o, n) ? y(o, n, i) : p(o, n, i);
  }
  function A(e, t) {
    var r = t.path,
      i = t.value;
    if (void 0 === i) throw new Error('Test failed: no value provided (path: "'.concat(w(r), '")'));
    if (!b(e, r)) throw new Error('Test failed: path not found (path: "'.concat(w(r), '")'));
    if (!n(v(e, r), i)) throw new Error('Test failed, value differs (path: "'.concat(w(r), '")'));
  }
  function E(e, t) {
    if (0 === t.length) return !1;
    var n = v(e, i(t));
    return Array.isArray(n);
  }
  function P(e, t) {
    if ("-" !== o(t)) return t;
    var n = i(t),
      r = v(e, n);
    return n.concat(r.length);
  }
  function M(e) {
    if (!["add", "remove", "replace", "copy", "move", "test"].includes(e.op)) throw new Error("Unknown JSONPatch op " + JSON.stringify(e.op));
    if ("string" != typeof e.path) throw new Error('Required property "path" missing or not a string in operation ' + JSON.stringify(e));
    if (("copy" === e.op || "move" === e.op) && "string" != typeof e.from) throw new Error('Required property "from" missing or not a string in operation ' + JSON.stringify(e));
  }
  function I(e, t) {
    return {
      op: t.op,
      path: P(e, k(t.path)),
      from: void 0 !== t.from ? k(t.from) : null,
      value: t.value
    };
  }
  function T(e, t) {
    var n = [];
    return x(e, t, {
      before: function before(e, t) {
        var r = N[t.op];
        r && (n = r(e, t).concat(n));
      }
    }), n;
  }
  var N = {
    add: z,
    remove: D,
    replace: R,
    copy: L,
    move: B
  };
  function R(e, t) {
    var n = t.path;
    return [{
      op: "replace",
      path: w(n),
      value: v(e, n)
    }];
  }
  function D(e, t) {
    var n = t.path;
    return [{
      op: "add",
      path: w(n),
      value: v(e, n)
    }];
  }
  function z(e, t) {
    var n = t.path,
      r = t.value;
    return E(e, n) || !b(e, n) ? [{
      op: "remove",
      path: w(n)
    }] : R(e, {
      path: n,
      value: r
    });
  }
  function L(e, t) {
    return z(e, {
      path: t.path,
      value: t.value
    });
  }
  function B(e, t) {
    var n = t.path,
      r = t.from;
    if (n.length < r.length && a(r, n)) return [{
      op: "replace",
      path: w(n),
      value: e
    }];
    var i = [{
      op: "move",
      from: w(n),
      path: w(r)
    }];
    return !E(e, n) && b(e, n) && (i = i.concat(D(e, {
      path: n
    }))), i;
  }
  e.compileJSONPointer = w, e.deleteIn = g, e.existsIn = b, e.getIn = v, e.immutableJSONPatch = x, e.insertAt = y, e.parseJSONPointer = k, e.revertJSONPatch = T, e.setIn = p, e.updateIn = m, Object.defineProperty(e, "__esModule", {
    value: !0
  });
}(ks.exports);
var ws = {},
  xs = {
    b: "\b",
    f: "\f",
    n: "\n",
    r: "\r",
    t: "\t",
    '"': '"',
    "/": "/",
    "\\": "\\"
  },
  js = "a".charCodeAt();
ws.parse = function (e, t, n) {
  var r = {},
    i = 0,
    o = 0,
    a = 0,
    s = n && n.bigint && "undefined" != typeof BigInt;
  return {
    data: u("", !0),
    pointers: r
  };
  function u(t, n) {
    var r;
    c(), m(t, "value");
    var i = h();
    switch (i) {
      case "t":
        f("rue"), r = !0;
        break;
      case "f":
        f("alse"), r = !1;
        break;
      case "n":
        f("ull"), r = null;
        break;
      case '"':
        r = l();
        break;
      case "[":
        r = function (e) {
          c();
          var t = [],
            n = 0;
          if ("]" == h()) return t;
          d();
          for (;;) {
            var r = e + "/" + n;
            t.push(u(r)), c();
            var i = h();
            if ("]" == i) break;
            "," != i && k(), c(), n++;
          }
          return t;
        }(t);
        break;
      case "{":
        r = function (e) {
          c();
          var t = {};
          if ("}" == h()) return t;
          d();
          for (;;) {
            var n = y();
            '"' != h() && k();
            var r = l(),
              i = e + "/" + Ns(r);
            g(i, "key", n), m(i, "keyEnd"), c(), ":" != h() && k(), c(), t[r] = u(i), c();
            var o = h();
            if ("}" == o) break;
            "," != o && k(), c();
          }
          return t;
        }(t);
        break;
      default:
        d(), "-0123456789".indexOf(i) >= 0 ? r = function () {
          var t = "",
            n = !0;
          "-" == e[a] && (t += h());
          t += "0" == e[a] ? h() : p(), "." == e[a] && (t += h() + p(), n = !1);
          "e" != e[a] && "E" != e[a] || (t += h(), "+" != e[a] && "-" != e[a] || (t += h()), t += p(), n = !1);
          var r = +t;
          return s && n && (r > Number.MAX_SAFE_INTEGER || r < Number.MIN_SAFE_INTEGER) ? BigInt(t) : r;
        }() : b();
    }
    return m(t, "valueEnd"), c(), n && a < e.length && b(), r;
  }
  function c() {
    e: for (; a < e.length;) {
      switch (e[a]) {
        case " ":
          o++;
          break;
        case "\t":
          o += 4;
          break;
        case "\r":
          o = 0;
          break;
        case "\n":
          o = 0, i++;
          break;
        default:
          break e;
      }
      a++;
    }
  }
  function l() {
    for (var e, t = ""; '"' != (e = h());) {
      "\\" == e ? (e = h()) in xs ? t += xs[e] : "u" == e ? t += v() : k() : t += e;
    }
    return t;
  }
  function f(e) {
    for (var t = 0; t < e.length; t++) {
      h() !== e[t] && k();
    }
  }
  function h() {
    w();
    var t = e[a];
    return a++, o++, t;
  }
  function d() {
    a--, o--;
  }
  function v() {
    for (var e = 4, t = 0; e--;) {
      t <<= 4;
      var n = h().toLowerCase();
      n >= "a" && n <= "f" ? t += n.charCodeAt() - js + 10 : n >= "0" && n <= "9" ? t += +n : k();
    }
    return String.fromCharCode(t);
  }
  function p() {
    for (var t = ""; e[a] >= "0" && e[a] <= "9";) {
      t += h();
    }
    if (t.length) return t;
    w(), b();
  }
  function m(e, t) {
    g(e, t, y());
  }
  function g(e, t, n) {
    r[e] = r[e] || {}, r[e][t] = n;
  }
  function y() {
    return {
      line: i,
      column: o,
      pos: a
    };
  }
  function b() {
    throw new SyntaxError("Unexpected token " + e[a] + " in JSON at position " + a);
  }
  function k() {
    d(), b();
  }
  function w() {
    if (a >= e.length) throw new SyntaxError("Unexpected end of JSON input");
  }
}, ws.stringify = function (e, t, n) {
  if (Cs(e)) {
    var r,
      i,
      o = 0,
      a = "object" == Li(n) ? n.space : n;
    switch (Li(a)) {
      case "number":
        var s = a > 10 ? 10 : a < 0 ? 0 : Math.floor(a);
        a = s && y(s, " "), r = s, i = s;
        break;
      case "string":
        a = a.slice(0, 10), r = 0, i = 0;
        for (var u = 0; u < a.length; u++) {
          switch (a[u]) {
            case " ":
              i++;
              break;
            case "\t":
              i += 4;
              break;
            case "\r":
              i = 0;
              break;
            case "\n":
              i = 0, o++;
              break;
            default:
              throw new Error("whitespace characters not allowed in JSON");
          }
          r++;
        }
        break;
      default:
        a = void 0;
    }
    var c = "",
      l = {},
      f = 0,
      h = 0,
      d = 0,
      v = n && n.es6 && "function" == typeof Map;
    return function e(t, n, r) {
      switch (g(r, "value"), Li(t)) {
        case "number":
        case "bigint":
        case "boolean":
          p("" + t);
          break;
        case "string":
          p(Ms(t));
          break;
        case "object":
          null === t ? p("null") : "function" == typeof t.toJSON ? p(Ms(t.toJSON())) : Array.isArray(t) ? i() : v ? t.constructor.BYTES_PER_ELEMENT ? i() : t instanceof Map ? s() : t instanceof Set ? s(!0) : o() : o();
      }
      function i() {
        if (t.length) {
          p("[");
          for (var i = n + 1, o = 0; o < t.length; o++) {
            o && p(","), m(i);
            var a = Cs(t[o]) ? t[o] : null;
            e(a, i, r + "/" + o);
          }
          m(n), p("]");
        } else p("[]");
      }
      function o() {
        var i = Object.keys(t);
        if (i.length) {
          p("{");
          for (var o = n + 1, s = 0; s < i.length; s++) {
            var u = i[s],
              c = t[u];
            if (Cs(c)) {
              s && p(",");
              var l = r + "/" + Ns(u);
              m(o), g(l, "key"), p(Ms(u)), g(l, "keyEnd"), p(":"), a && p(" "), e(c, o, l);
            }
          }
          m(n), p("}");
        } else p("{}");
      }
      function s(i) {
        if (t.size) {
          p("{");
          for (var o = n + 1, s = !0, u = t.entries(), c = u.next(); !c.done;) {
            var l = c.value,
              f = l[0],
              h = !!i || l[1];
            if (Cs(h)) {
              s || p(","), s = !1;
              var d = r + "/" + Ns(f);
              m(o), g(d, "key"), p(Ms(f)), g(d, "keyEnd"), p(":"), a && p(" "), e(h, o, d);
            }
            c = u.next();
          }
          m(n), p("}");
        } else p("{}");
      }
      g(r, "valueEnd");
    }(e, 0, ""), {
      json: c,
      pointers: l
    };
  }
  function p(e) {
    h += e.length, d += e.length, c += e;
  }
  function m(e) {
    if (a) {
      for (c += "\n" + y(e, a), f++, h = 0; e--;) {
        o ? (f += o, h = i) : h += i, d += r;
      }
      d += 1;
    }
  }
  function g(e, t) {
    l[e] = l[e] || {}, l[e][t] = {
      line: f,
      column: h,
      pos: d
    };
  }
  function y(e, t) {
    return Array(e + 1).join(t);
  }
};
var Ss = ["number", "bigint", "boolean", "string", "object"];
function Cs(e) {
  return Ss.indexOf(Li(e)) >= 0;
}
var _s = /"|\\/g,
  $s = /[\b]/g,
  Os = /\f/g,
  As = /\n/g,
  Es = /\r/g,
  Ps = /\t/g;
function Ms(e) {
  return '"' + (e = e.replace(_s, "\\$&").replace(Os, "\\f").replace($s, "\\b").replace(As, "\\n").replace(Es, "\\r").replace(Ps, "\\t")) + '"';
}
var Is = /~/g,
  Ts = /\//g;
function Ns(e) {
  return e.replace(Is, "~0").replace(Ts, "~1");
}
var Rs = {
    exports: {}
  },
  Ds = Rs.exports = function () {
    function e(t, n) {
      if (!(this instanceof e)) throw new SyntaxError("Constructor must be called with the new operator");
      this.message = t + " (char " + n + ")", this.char = n, this.stack = new Error().stack;
    }
    (e.prototype = new Error()).constructor = Error;
    var t = {
        "'": !0,
        "‘": !0,
        "’": !0,
        "`": !0,
        "´": !0
      },
      n = {
        '"': !0,
        "“": !0,
        "”": !0
      };
    function r(e) {
      return i.test(e);
    }
    var i = /^[a-zA-Z_]$/,
      o = /^[0-9a-fA-F]$/;
    function a(e) {
      return s.test(e);
    }
    var s = /^[0-9]$/;
    function u(e) {
      return " " === e || "\t" === e || "\n" === e || "\r" === e;
    }
    function c(e) {
      return " " === e || " " <= e && e <= " " || " " === e || " " === e || "　" === e;
    }
    function l(e) {
      return !0 === t[e];
    }
    function f(e) {
      return !0 === n[e];
    }
    function h(e) {
      return !0 === t[e] ? "'" : !0 === n[e] ? '"' : e;
    }
    function d(e, t) {
      return -1 !== (t = e.lastIndexOf(t)) ? e.substring(0, t) + e.substring(t + 1) : e;
    }
    function v(e, t) {
      var n = e.length;
      if (!u(e[n - 1])) return e + t;
      for (; u(e[n - 1]);) {
        n--;
      }
      return e.substring(0, n) + t + e.substring(n);
    }
    var p = 0,
      m = 1,
      g = 2,
      y = 3,
      b = 4,
      k = 5,
      w = 6,
      x = {
        "": !0,
        "{": !0,
        "}": !0,
        "[": !0,
        "]": !0,
        ":": !0,
        ",": !0,
        "(": !0,
        ")": !0,
        ";": !0,
        "+": !0
      },
      j = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "\t"
      },
      S = {
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "\t": "\\t"
      },
      C = {
        null: "null",
        true: "true",
        false: "false"
      },
      _ = {
        None: "null",
        True: "true",
        False: "false"
      },
      $ = "",
      O = "",
      A = 0,
      E = "",
      P = "",
      M = w;
    function I() {
      A++, E = $.charAt(A);
    }
    function T() {
      I(), "\\" === E && I();
    }
    function N() {
      return M === p && ("[" === P || "{" === P) || M === g || M === m || M === y;
    }
    function R() {
      O += P, M = w, P = "", x[E] ? (M = p, P = E, I()) : function () {
        if (a(E) || "-" === E) {
          if (M = m, "-" === E) {
            if (P += E, I(), !a(E)) throw new e("Invalid number, digit expected", A);
          } else "0" === E && (P += E, I());
          for (; a(E);) {
            P += E, I();
          }
          if ("." === E) {
            if (P += E, I(), !a(E)) throw new e("Invalid number, digit expected", A);
            for (; a(E);) {
              P += E, I();
            }
          }
          if ("e" === E || "E" === E) {
            if (P += E, I(), "+" !== E && "-" !== E || (P += E, I()), !a(E)) throw new e("Invalid number, digit expected", A);
            for (; a(E);) {
              P += E, I();
            }
          }
        } else "\\" === E && '"' === $.charAt(A + 1) ? (I(), z(T)) : z(I);
      }(), M === b && (P = function (e) {
        for (var t = "", n = 0; n < e.length; n++) {
          var r = e[n];
          t += c(r) ? " " : r;
        }
        return t;
      }(P), R()), M === k && (M = w, P = "", R());
    }
    function D() {
      "," === P && (P = "", M = w, R());
    }
    function z(i) {
      if (!0 === t[s = E] || !0 === n[s]) {
        var s = h(E),
          d = l(E) ? l : f;
        for (P += '"', M = g, i(); "" !== E && !d(E);) {
          if ("\\" === E) {
            if (i(), void 0 !== j[E]) P += "\\" + E, i();else if ("u" === E) {
              P += "\\u", i();
              for (var v = 0; v < 4; v++) {
                if (p = E, !o.test(p)) throw new e("Invalid unicode character", A - P.length);
                P += E, i();
              }
            } else {
              if ("'" !== E) throw new e('Invalid escape character "\\' + E + '"', A);
              P += "'", i();
            }
          } else S[E] ? P += S[E] : P += '"' === E ? '\\"' : E, i();
        }
        if (h(E) !== s) throw new e("End of string expected", A - P.length);
        return P += '"', void i();
      }
      var p;
      !function () {
        if (r(E)) for (M = y; r(E) || a(E) || "$" === E;) {
          P += E, I();
        } else !function () {
          if (u(E) || c(E)) for (M = b; u(E) || c(E);) {
            P += E, I();
          } else !function () {
            if ("/" !== E || "*" !== $[A + 1]) {
              if ("/" !== E || "/" !== $[A + 1]) !function () {
                for (M = w; "" !== E;) {
                  P += E, I();
                }
                throw new e('Syntax error in part "' + P + '"', A - P.length);
              }();else for (M = k; "" !== E && "\n" !== E;) {
                P += E, I();
              }
            } else {
              for (M = k; "" !== E && ("*" !== E || "*" === E && "/" !== $[A + 1]);) {
                P += E, I();
              }
              "*" === E && "/" === $[A + 1] && (P += E, I(), P += E, I());
            }
          }();
        }();
      }();
    }
    function L() {
      if (M !== p || "{" !== P) !function () {
        if (M !== p || "[" !== P) !function () {
          if (M !== g) (M !== m ? function () {
            if (M !== y) !function () {
              throw new e("" === P ? "Unexpected end of json string" : "Value expected", A - P.length);
            }();else if (C[P]) R();else {
              if (_[P]) return P = _[P], R();
              var t = P,
                n = O.length;
              if (P = "", R(), M === p && "(" === P) return P = "", R(), L(), M === p && ")" === P && (P = "", R(), M === p && ";" === P && (P = "", R()));
              for (O = function (e, t, n) {
                return e.substring(0, n) + t + e.substring(n);
              }(O, '"'.concat(t), n); M === y || M === m;) {
                R();
              }
              O += '"';
            }
          } : R)();else for (R(); M === p && "+" === P;) {
            var t;
            P = "", R(), M === g && (t = O.lastIndexOf('"'), O = O.substring(0, t) + P.substring(1), P = "", R());
          }
        }();else if (R(), M !== p || "]" !== P) {
          for (;;) {
            if (L(), M === p && "," === P) {
              if (R(), M === p && "]" === P) {
                O = d(O, ",");
                break;
              }
              if ("" === P) {
                O = d(O, ",");
                break;
              }
            } else {
              if (!N()) break;
              O = v(O, ",");
            }
          }
          M === p && "]" === P ? R() : O = v(O, "]");
        } else R();
      }();else if (R(), M !== p || "}" !== P) {
        for (;;) {
          if (M !== y && M !== m || (M = g, P = '"'.concat(P, '"')), M !== g) throw new e("Object key expected", A - P.length);
          if (R(), M === p && ":" === P) R();else {
            if (!N()) throw new e("Colon expected", A - P.length);
            O = v(O, ":");
          }
          if (L(), M === p && "," === P) {
            if (R(), M === p && "}" === P) {
              O = d(O, ",");
              break;
            }
            if ("" === P) {
              O = d(O, ",");
              break;
            }
          } else {
            if (M !== g && M !== m && M !== y) break;
            O = v(O, ",");
          }
        }
        M === p && "}" === P ? R() : O = v(O, "}");
      } else R();
    }
    return function (t) {
      O = "", A = 0, E = ($ = t).charAt(0), P = "", M = w, R();
      var n = M;
      if (L(), D(), "" === P) return O;
      if (n === M && N()) {
        for (var r = ""; n === M && N();) {
          r += O = v(O, ","), O = "", L(), D();
        }
        return "[\n".concat(r).concat(O, "\n]");
      }
      throw new e("Unexpected characters", A - P.length);
    };
  }();
function zs(e) {
  return "object" === Li(e) && null !== e && !Array.isArray(e);
}
function Ls(e) {
  return "object" === Li(e) && null !== e;
}
function Bs(e) {
  var t = window.document.createElement("div");
  return t.style.color = e, t.style.color.split(/\s+/).join("").toLowerCase() || null;
}
function qs(e) {
  return null === e ? "null" : void 0 === e ? "undefined" : "number" == typeof e ? "number" : "string" == typeof e ? "string" : "boolean" == typeof e ? "boolean" : e instanceof RegExp ? "regexp" : Array.isArray(e) ? "array" : "object";
}
var Fs = /^https?:\/\/\S+$/;
function Vs(e) {
  return "string" == typeof e && Fs.test(e);
}
function Hs(e) {
  if ("" === e) return "";
  if ("null" === e) return null;
  if ("true" === e) return !0;
  if ("false" === e) return !1;
  var t = Number(e);
  return isNaN(t) || isNaN(parseFloat(e)) ? e : t;
}
function Ws(e) {
  return "string" == typeof e && "string" != typeof Hs(e);
}
var Us = [];
function Js(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
    n = {};
  if (!Array.isArray(e)) throw new TypeError("Array expected");
  function r(e, i) {
    (!Array.isArray(e) && !zs(e) || t && i.length > 0) && (n[ks.exports.compileJSONPointer(i)] = !0), zs(e) && Object.keys(e).forEach(function (t) {
      r(e[t], i.concat(t));
    });
  }
  for (var i = Math.min(e.length, 1e4), o = 0; o < i; o++) {
    var a = e[o];
    r(a, Us);
  }
  var s = Object.keys(n).sort();
  return s.map(ks.exports.parseJSONPointer);
}
function Ks(e, t, n) {
  if (!(t <= e)) for (var r = e; r < t; r++) {
    n(r);
  }
}
function Gs(e, t) {
  return e.length > t ? e.slice(0, t) : e;
}
function Qs(e) {
  return Pi({}, e);
}
function Ys(e) {
  return Object.values(e);
}
function Zs(e) {
  try {
    return JSON.parse(e);
  } catch (t) {
    return JSON.parse(Ds(e));
  }
}
function Xs(e) {
  try {
    return Zs(e);
  } catch (e) {
    return;
  }
}
function eu(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : JSON.parse;
  e = e.replace(nu, "");
  try {
    return t(e);
  } catch (e) {}
  try {
    return t("[" + e + "]");
  } catch (e) {}
  try {
    return t("{" + e + "}");
  } catch (e) {}
  throw new Error("Failed to parse partial JSON");
}
function tu(e) {
  e = e.replace(nu, "");
  try {
    return Ds(e);
  } catch (e) {}
  try {
    var t = Ds("[" + e + "]");
    return t.substring(1, t.length - 1);
  } catch (e) {}
  try {
    var n = Ds("{" + e + "}");
    return n.substring(1, n.length - 1);
  } catch (e) {}
  throw new Error("Failed to repair partial JSON");
}
var nu = /,\s*$/;
function ru(e, t) {
  var n = uu.exec(t);
  if (n) {
    var r = parseInt(n[2], 10),
      i = function (e, t) {
        for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e.length, i = 0, o = n; o < r; o++) {
          e.charAt(o) === t && i++;
        }
        return i;
      }(e, "\n", 0, r),
      o = r - e.lastIndexOf("\n", r) - 1;
    return {
      position: r,
      line: i,
      column: o,
      message: t.replace(uu, function () {
        return "line ".concat(i + 1, " column ").concat(o + 1);
      })
    };
  }
  var a = cu.exec(t),
    s = a ? parseInt(a[1], 10) : null,
    u = null !== s ? s - 1 : null,
    c = lu.exec(t),
    l = c ? parseInt(c[1], 10) : null,
    f = null !== l ? l - 1 : null;
  return {
    position: null !== u && null !== f ? function (e, t, n) {
      var r = e.indexOf("\n"),
        i = 1;
      for (; i < t && -1 !== r;) {
        r = e.indexOf("\n", r + 1), i++;
      }
      return -1 !== r ? r + n + 1 : null;
    }(e, u, f) : null,
    line: u,
    column: f,
    message: t.replace(/^JSON.parse: /, "").replace(/ of the JSON data$/, "")
  };
}
function iu(e) {
  return zs(e) ? void 0 !== e.json ? void 0 !== e.text ? 'Content must contain either a property "json" or a property "text" but not both' : null : void 0 === e.text ? 'Content must contain either a property "json" or a property "text"' : "string" != typeof e.text ? 'Content "text" property must be string' : null : "Content must be an object";
}
function ou(e) {
  return "string" == typeof e.text;
}
function au(e, t) {
  return su(e, t) > t;
}
function su(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1 / 0;
  if (ou(e)) return e.text.length;
  var n = e.json,
    r = 0;
  function i(e) {
    if (Array.isArray(e)) {
      if ((r += e.length - 1 + 2) > t) return r;
      for (var n = 0; n < e.length; n++) {
        if (i(e[n]), r > t) return r;
      }
    } else if (zs(e)) {
      var o = Object.keys(e);
      r += 2 + o.length + (o.length - 1);
      for (var a = 0; a < o.length; a++) {
        var s = o[a],
          u = e[s];
        r += s.length + 2, i(u);
      }
    } else r += "string" == typeof e ? e.length + 2 : String(e).length;
  }
  return i(n), r;
}
var uu = /(position|char) (\d+)/,
  cu = /line (\d+)/,
  lu = /column (\d+)/,
  fu = "object" == ("undefined" == typeof global ? "undefined" : Li(global)) && global && global.Object === Object && global,
  hu = "object" == ("undefined" == typeof self ? "undefined" : Li(self)) && self && self.Object === Object && self,
  du = fu || hu || Function("return this")(),
  vu = du.Symbol,
  pu = Object.prototype,
  mu = pu.hasOwnProperty,
  gu = pu.toString,
  yu = vu ? vu.toStringTag : void 0;
var bu = Object.prototype.toString;
var ku = vu ? vu.toStringTag : void 0;
function wu(e) {
  return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : ku && ku in Object(e) ? function (e) {
    var t = mu.call(e, yu),
      n = e[yu];
    try {
      e[yu] = void 0;
      var r = !0;
    } catch (e) {}
    var i = gu.call(e);
    return r && (t ? e[yu] = n : delete e[yu]), i;
  }(e) : function (e) {
    return bu.call(e);
  }(e);
}
function xu(e) {
  return null != e && "object" == Li(e);
}
function ju(e) {
  return "symbol" == Li(e) || xu(e) && "[object Symbol]" == wu(e);
}
function Su(e) {
  return "number" == typeof e ? e : ju(e) ? NaN : +e;
}
function Cu(e, t) {
  for (var n = -1, r = null == e ? 0 : e.length, i = Array(r); ++n < r;) {
    i[n] = t(e[n], n, e);
  }
  return i;
}
var _u = Array.isArray,
  $u = vu ? vu.prototype : void 0,
  Ou = $u ? $u.toString : void 0;
function Au(e) {
  if ("string" == typeof e) return e;
  if (_u(e)) return Cu(e, Au) + "";
  if (ju(e)) return Ou ? Ou.call(e) : "";
  var t = e + "";
  return "0" == t && 1 / e == -Infinity ? "-0" : t;
}
function Eu(e, t) {
  return function (n, r) {
    var i;
    if (void 0 === n && void 0 === r) return t;
    if (void 0 !== n && (i = n), void 0 !== r) {
      if (void 0 === i) return r;
      "string" == typeof n || "string" == typeof r ? (n = Au(n), r = Au(r)) : (n = Su(n), r = Su(r)), i = e(n, r);
    }
    return i;
  };
}
var Pu = Eu(function (e, t) {
    return e + t;
  }, 0),
  Mu = /\s/;
function Iu(e) {
  for (var t = e.length; t-- && Mu.test(e.charAt(t));) {
    ;
  }
  return t;
}
var Tu = /^\s+/;
function Nu(e) {
  return e ? e.slice(0, Iu(e) + 1).replace(Tu, "") : e;
}
function Ru(e) {
  var t = Li(e);
  return null != e && ("object" == t || "function" == t);
}
var Du = /^[-+]0x[0-9a-f]+$/i,
  zu = /^0b[01]+$/i,
  Lu = /^0o[0-7]+$/i,
  Bu = parseInt;
function qu(e) {
  if ("number" == typeof e) return e;
  if (ju(e)) return NaN;
  if (Ru(e)) {
    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
    e = Ru(t) ? t + "" : t;
  }
  if ("string" != typeof e) return 0 === e ? e : +e;
  e = Nu(e);
  var n = zu.test(e);
  return n || Lu.test(e) ? Bu(e.slice(2), n ? 2 : 8) : Du.test(e) ? NaN : +e;
}
function Fu(e) {
  return e ? Infinity === (e = qu(e)) || -Infinity === e ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
}
function Vu(e) {
  var t = Fu(e),
    n = t % 1;
  return t == t ? n ? t - n : t : 0;
}
function Hu(e, t) {
  if ("function" != typeof t) throw new TypeError("Expected a function");
  return e = Vu(e), function () {
    if (--e < 1) return t.apply(this, arguments);
  };
}
function Wu(e) {
  return e;
}
function Uu(e) {
  if (!Ru(e)) return !1;
  var t = wu(e);
  return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
}
var Ju,
  Ku = du["__core-js_shared__"],
  Gu = (Ju = /[^.]+$/.exec(Ku && Ku.keys && Ku.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Ju : "";
var Qu = Function.prototype.toString;
function Yu(e) {
  if (null != e) {
    try {
      return Qu.call(e);
    } catch (e) {}
    try {
      return e + "";
    } catch (e) {}
  }
  return "";
}
var Zu = /^\[object .+?Constructor\]$/,
  Xu = Function.prototype,
  ec = Object.prototype,
  tc = Xu.toString,
  nc = ec.hasOwnProperty,
  rc = RegExp("^" + tc.call(nc).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function ic(e) {
  return !(!Ru(e) || function (e) {
    return !!Gu && Gu in e;
  }(e)) && (Uu(e) ? rc : Zu).test(Yu(e));
}
function oc(e, t) {
  var n = function (e, t) {
    return null == e ? void 0 : e[t];
  }(e, t);
  return ic(n) ? n : void 0;
}
var ac = oc(du, "WeakMap"),
  sc = ac && new ac(),
  uc = sc ? function (e, t) {
    return sc.set(e, t), e;
  } : Wu,
  cc = Object.create,
  lc = function () {
    function e() {}
    return function (t) {
      if (!Ru(t)) return {};
      if (cc) return cc(t);
      e.prototype = t;
      var n = new e();
      return e.prototype = void 0, n;
    };
  }();
function fc(e) {
  return function () {
    var t = arguments;
    switch (t.length) {
      case 0:
        return new e();
      case 1:
        return new e(t[0]);
      case 2:
        return new e(t[0], t[1]);
      case 3:
        return new e(t[0], t[1], t[2]);
      case 4:
        return new e(t[0], t[1], t[2], t[3]);
      case 5:
        return new e(t[0], t[1], t[2], t[3], t[4]);
      case 6:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
      case 7:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
    }
    var n = lc(e.prototype),
      r = e.apply(n, t);
    return Ru(r) ? r : n;
  };
}
function hc(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var dc = Math.max;
function vc(e, t, n, r) {
  for (var i = -1, o = e.length, a = n.length, s = -1, u = t.length, c = dc(o - a, 0), l = Array(u + c), f = !r; ++s < u;) {
    l[s] = t[s];
  }
  for (; ++i < a;) {
    (f || i < o) && (l[n[i]] = e[i]);
  }
  for (; c--;) {
    l[s++] = e[i++];
  }
  return l;
}
var pc = Math.max;
function mc(e, t, n, r) {
  for (var i = -1, o = e.length, a = -1, s = n.length, u = -1, c = t.length, l = pc(o - s, 0), f = Array(l + c), h = !r; ++i < l;) {
    f[i] = e[i];
  }
  for (var d = i; ++u < c;) {
    f[d + u] = t[u];
  }
  for (; ++a < s;) {
    (h || i < o) && (f[d + n[a]] = e[i++]);
  }
  return f;
}
function gc(e, t) {
  for (var n = e.length, r = 0; n--;) {
    e[n] === t && ++r;
  }
  return r;
}
function yc() {}
function bc(e) {
  this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
}
function kc() {}
bc.prototype = lc(yc.prototype), bc.prototype.constructor = bc;
var wc = sc ? function (e) {
    return sc.get(e);
  } : kc,
  xc = {},
  jc = Object.prototype.hasOwnProperty;
function Sc(e) {
  for (var t = e.name + "", n = xc[t], r = jc.call(xc, t) ? n.length : 0; r--;) {
    var i = n[r],
      o = i.func;
    if (null == o || o == e) return i.name;
  }
  return t;
}
function Cc(e, t) {
  this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
}
function _c(e, t) {
  var n = -1,
    r = e.length;
  for (t || (t = Array(r)); ++n < r;) {
    t[n] = e[n];
  }
  return t;
}
function $c(e) {
  if (e instanceof bc) return e.clone();
  var t = new Cc(e.__wrapped__, e.__chain__);
  return t.__actions__ = _c(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
}
Cc.prototype = lc(yc.prototype), Cc.prototype.constructor = Cc;
var Oc = Object.prototype.hasOwnProperty;
function Ac(e) {
  if (xu(e) && !_u(e) && !(e instanceof bc)) {
    if (e instanceof Cc) return e;
    if (Oc.call(e, "__wrapped__")) return $c(e);
  }
  return new Cc(e);
}
function Ec(e) {
  var t = Sc(e),
    n = Ac[t];
  if ("function" != typeof n || !(t in bc.prototype)) return !1;
  if (e === n) return !0;
  var r = wc(n);
  return !!r && e === r[0];
}
Ac.prototype = yc.prototype, Ac.prototype.constructor = Ac;
var Pc = Date.now;
function Mc(e) {
  var t = 0,
    n = 0;
  return function () {
    var r = Pc(),
      i = 16 - (r - n);
    if (n = r, i > 0) {
      if (++t >= 800) return arguments[0];
    } else t = 0;
    return e.apply(void 0, arguments);
  };
}
var Ic = Mc(uc),
  Tc = /\{\n\/\* \[wrapped with (.+)\] \*/,
  Nc = /,? & /;
var Rc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
function Dc(e) {
  return function () {
    return e;
  };
}
var zc = function () {
    try {
      var e = oc(Object, "defineProperty");
      return e({}, "", {}), e;
    } catch (e) {}
  }(),
  Lc = Mc(zc ? function (e, t) {
    return zc(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: Dc(t),
      writable: !0
    });
  } : Wu);
function Bc(e, t) {
  for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e);) {
    ;
  }
  return e;
}
function qc(e, t, n, r) {
  for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i;) {
    if (t(e[o], o, e)) return o;
  }
  return -1;
}
function Fc(e) {
  return e != e;
}
function Vc(e, t, n) {
  return t == t ? function (e, t, n) {
    for (var r = n - 1, i = e.length; ++r < i;) {
      if (e[r] === t) return r;
    }
    return -1;
  }(e, t, n) : qc(e, Fc, n);
}
function Hc(e, t) {
  return !!(null == e ? 0 : e.length) && Vc(e, t, 0) > -1;
}
var Wc = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]];
function Uc(e, t, n) {
  var r = t + "";
  return Lc(e, function (e, t) {
    var n = t.length;
    if (!n) return e;
    var r = n - 1;
    return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(Rc, "{\n/* [wrapped with " + t + "] */\n");
  }(r, function (e, t) {
    return Bc(Wc, function (n) {
      var r = "_." + n[0];
      t & n[1] && !Hc(e, r) && e.push(r);
    }), e.sort();
  }(function (e) {
    var t = e.match(Tc);
    return t ? t[1].split(Nc) : [];
  }(r), n)));
}
function Jc(e, t, n, r, i, o, a, s, u, c) {
  var l = 8 & t;
  t |= l ? 32 : 64, 4 & (t &= ~(l ? 64 : 32)) || (t &= -4);
  var f = [e, t, i, l ? o : void 0, l ? a : void 0, l ? void 0 : o, l ? void 0 : a, s, u, c],
    h = n.apply(void 0, f);
  return Ec(e) && Ic(h, f), h.placeholder = r, Uc(h, e, t);
}
function Kc(e) {
  return e.placeholder;
}
var Gc = /^(?:0|[1-9]\d*)$/;
function Qc(e, t) {
  var n = Li(e);
  return !!(t = null == t ? 9007199254740991 : t) && ("number" == n || "symbol" != n && Gc.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Yc = Math.min;
function Zc(e, t) {
  for (var n = e.length, r = Yc(t.length, n), i = _c(e); r--;) {
    var o = t[r];
    e[r] = Qc(o, n) ? i[o] : void 0;
  }
  return e;
}
function Xc(e, t) {
  for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
    var a = e[n];
    a !== t && "__lodash_placeholder__" !== a || (e[n] = "__lodash_placeholder__", o[i++] = n);
  }
  return o;
}
function el(e, t, n, r, i, o, a, s, u, c) {
  var l = 128 & t,
    f = 1 & t,
    h = 2 & t,
    d = 24 & t,
    v = 512 & t,
    p = h ? void 0 : fc(e);
  return function m() {
    for (var g = arguments.length, y = Array(g), b = g; b--;) {
      y[b] = arguments[b];
    }
    if (d) var k = Kc(m),
      w = gc(y, k);
    if (r && (y = vc(y, r, i, d)), o && (y = mc(y, o, a, d)), g -= w, d && g < c) {
      var x = Xc(y, k);
      return Jc(e, t, el, m.placeholder, n, y, x, s, u, c - g);
    }
    var j = f ? n : this,
      S = h ? j[e] : e;
    return g = y.length, s ? y = Zc(y, s) : v && g > 1 && y.reverse(), l && u < g && (y.length = u), this && this !== du && this instanceof m && (S = p || fc(S)), S.apply(j, y);
  };
}
var tl = Math.min;
var nl = Math.max;
function rl(e, t, n, r, i, o, a, s) {
  var u = 2 & t;
  if (!u && "function" != typeof e) throw new TypeError("Expected a function");
  var c = r ? r.length : 0;
  if (c || (t &= -97, r = i = void 0), a = void 0 === a ? a : nl(Vu(a), 0), s = void 0 === s ? s : Vu(s), c -= i ? i.length : 0, 64 & t) {
    var l = r,
      f = i;
    r = i = void 0;
  }
  var h = u ? void 0 : wc(e),
    d = [e, t, n, r, i, l, f, o, a, s];
  if (h && function (e, t) {
    var n = e[1],
      r = t[1],
      i = n | r,
      o = i < 131,
      a = 128 == r && 8 == n || 128 == r && 256 == n && e[7].length <= t[8] || 384 == r && t[7].length <= t[8] && 8 == n;
    if (!o && !a) return e;
    1 & r && (e[2] = t[2], i |= 1 & n ? 0 : 4);
    var s = t[3];
    if (s) {
      var u = e[3];
      e[3] = u ? vc(u, s, t[4]) : s, e[4] = u ? Xc(e[3], "__lodash_placeholder__") : t[4];
    }
    (s = t[5]) && (u = e[5], e[5] = u ? mc(u, s, t[6]) : s, e[6] = u ? Xc(e[5], "__lodash_placeholder__") : t[6]), (s = t[7]) && (e[7] = s), 128 & r && (e[8] = null == e[8] ? t[8] : tl(e[8], t[8])), null == e[9] && (e[9] = t[9]), e[0] = t[0], e[1] = i;
  }(d, h), e = d[0], t = d[1], n = d[2], r = d[3], i = d[4], !(s = d[9] = void 0 === d[9] ? u ? 0 : e.length : nl(d[9] - c, 0)) && 24 & t && (t &= -25), t && 1 != t) v = 8 == t || 16 == t ? function (e, t, n) {
    var r = fc(e);
    return function i() {
      for (var o = arguments.length, a = Array(o), s = o, u = Kc(i); s--;) {
        a[s] = arguments[s];
      }
      var c = o < 3 && a[0] !== u && a[o - 1] !== u ? [] : Xc(a, u);
      return (o -= c.length) < n ? Jc(e, t, el, i.placeholder, void 0, a, c, void 0, void 0, n - o) : hc(this && this !== du && this instanceof i ? r : e, this, a);
    };
  }(e, t, s) : 32 != t && 33 != t || i.length ? el.apply(void 0, d) : function (e, t, n, r) {
    var i = 1 & t,
      o = fc(e);
    return function t() {
      for (var a = -1, s = arguments.length, u = -1, c = r.length, l = Array(c + s), f = this && this !== du && this instanceof t ? o : e; ++u < c;) {
        l[u] = r[u];
      }
      for (; s--;) {
        l[u++] = arguments[++a];
      }
      return hc(f, i ? n : this, l);
    };
  }(e, t, n, r);else var v = function (e, t, n) {
    var r = 1 & t,
      i = fc(e);
    return function t() {
      return (this && this !== du && this instanceof t ? i : e).apply(r ? n : this, arguments);
    };
  }(e, t, n);
  return Uc((h ? uc : Ic)(v, d), e, t);
}
function il(e, t, n) {
  return t = n ? void 0 : t, rl(e, 128, void 0, void 0, void 0, void 0, t = e && null == t ? e.length : t);
}
function ol(e, t, n) {
  "__proto__" == t && zc ? zc(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function al(e, t) {
  return e === t || e != e && t != t;
}
var sl = Object.prototype.hasOwnProperty;
function ul(e, t, n) {
  var r = e[t];
  sl.call(e, t) && al(r, n) && (void 0 !== n || t in e) || ol(e, t, n);
}
function cl(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = t.length; ++o < a;) {
    var s = t[o],
      u = r ? r(n[s], e[s], s, n, e) : void 0;
    void 0 === u && (u = e[s]), i ? ol(n, s, u) : ul(n, s, u);
  }
  return n;
}
var ll = Math.max;
function fl(e, t, n) {
  return t = ll(void 0 === t ? e.length - 1 : t, 0), function () {
    for (var r = arguments, i = -1, o = ll(r.length - t, 0), a = Array(o); ++i < o;) {
      a[i] = r[t + i];
    }
    i = -1;
    for (var s = Array(t + 1); ++i < t;) {
      s[i] = r[i];
    }
    return s[t] = n(a), hc(e, this, s);
  };
}
function hl(e, t) {
  return Lc(fl(e, t, Wu), e + "");
}
function dl(e) {
  return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
}
function vl(e) {
  return null != e && dl(e.length) && !Uu(e);
}
function pl(e, t, n) {
  if (!Ru(n)) return !1;
  var r = Li(t);
  return !!("number" == r ? vl(n) && Qc(t, n.length) : "string" == r && t in n) && al(n[t], e);
}
function ml(e) {
  return hl(function (t, n) {
    var r = -1,
      i = n.length,
      o = i > 1 ? n[i - 1] : void 0,
      a = i > 2 ? n[2] : void 0;
    for (o = e.length > 3 && "function" == typeof o ? (i--, o) : void 0, a && pl(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), t = Object(t); ++r < i;) {
      var s = n[r];
      s && e(t, s, r, o);
    }
    return t;
  });
}
var gl = Object.prototype;
function yl(e) {
  var t = e && e.constructor;
  return e === ("function" == typeof t && t.prototype || gl);
}
function bl(e, t) {
  for (var n = -1, r = Array(e); ++n < e;) {
    r[n] = t(n);
  }
  return r;
}
function kl(e) {
  return xu(e) && "[object Arguments]" == wu(e);
}
var wl = Object.prototype,
  xl = wl.hasOwnProperty,
  jl = wl.propertyIsEnumerable,
  Sl = kl(function () {
    return arguments;
  }()) ? kl : function (e) {
    return xu(e) && xl.call(e, "callee") && !jl.call(e, "callee");
  };
function Cl() {
  return !1;
}
var _l = "object" == ("undefined" == typeof exports ? "undefined" : Li(exports)) && exports && !exports.nodeType && exports,
  $l = _l && "object" == ("undefined" == typeof module ? "undefined" : Li(module)) && module && !module.nodeType && module,
  Ol = $l && $l.exports === _l ? du.Buffer : void 0,
  Al = (Ol ? Ol.isBuffer : void 0) || Cl,
  El = {};
function Pl(e) {
  return function (t) {
    return e(t);
  };
}
El["[object Float32Array]"] = El["[object Float64Array]"] = El["[object Int8Array]"] = El["[object Int16Array]"] = El["[object Int32Array]"] = El["[object Uint8Array]"] = El["[object Uint8ClampedArray]"] = El["[object Uint16Array]"] = El["[object Uint32Array]"] = !0, El["[object Arguments]"] = El["[object Array]"] = El["[object ArrayBuffer]"] = El["[object Boolean]"] = El["[object DataView]"] = El["[object Date]"] = El["[object Error]"] = El["[object Function]"] = El["[object Map]"] = El["[object Number]"] = El["[object Object]"] = El["[object RegExp]"] = El["[object Set]"] = El["[object String]"] = El["[object WeakMap]"] = !1;
var Ml = "object" == ("undefined" == typeof exports ? "undefined" : Li(exports)) && exports && !exports.nodeType && exports,
  Il = Ml && "object" == ("undefined" == typeof module ? "undefined" : Li(module)) && module && !module.nodeType && module,
  Tl = Il && Il.exports === Ml && fu.process,
  Nl = function () {
    try {
      var e = Il && Il.require && Il.require("util").types;
      return e || Tl && Tl.binding && Tl.binding("util");
    } catch (e) {}
  }(),
  Rl = Nl && Nl.isTypedArray,
  Dl = Rl ? Pl(Rl) : function (e) {
    return xu(e) && dl(e.length) && !!El[wu(e)];
  },
  zl = Object.prototype.hasOwnProperty;
function Ll(e, t) {
  var n = _u(e),
    r = !n && Sl(e),
    i = !n && !r && Al(e),
    o = !n && !r && !i && Dl(e),
    a = n || r || i || o,
    s = a ? bl(e.length, String) : [],
    u = s.length;
  for (var c in e) {
    !t && !zl.call(e, c) || a && ("length" == c || i && ("offset" == c || "parent" == c) || o && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || Qc(c, u)) || s.push(c);
  }
  return s;
}
function Bl(e, t) {
  return function (n) {
    return e(t(n));
  };
}
var ql = Bl(Object.keys, Object),
  Fl = Object.prototype.hasOwnProperty;
function Vl(e) {
  if (!yl(e)) return ql(e);
  var t = [];
  for (var n in Object(e)) {
    Fl.call(e, n) && "constructor" != n && t.push(n);
  }
  return t;
}
function Hl(e) {
  return vl(e) ? Ll(e) : Vl(e);
}
var Wl = Object.prototype.hasOwnProperty,
  Ul = ml(function (e, t) {
    if (yl(t) || vl(t)) cl(t, Hl(t), e);else for (var n in t) {
      Wl.call(t, n) && ul(e, n, t[n]);
    }
  });
var Jl = Object.prototype.hasOwnProperty;
function Kl(e) {
  if (!Ru(e)) return function (e) {
    var t = [];
    if (null != e) for (var n in Object(e)) {
      t.push(n);
    }
    return t;
  }(e);
  var t = yl(e),
    n = [];
  for (var r in e) {
    ("constructor" != r || !t && Jl.call(e, r)) && n.push(r);
  }
  return n;
}
function Gl(e) {
  return vl(e) ? Ll(e, !0) : Kl(e);
}
var Ql = ml(function (e, t) {
    cl(t, Gl(t), e);
  }),
  Yl = ml(function (e, t, n, r) {
    cl(t, Gl(t), e, r);
  }),
  Zl = ml(function (e, t, n, r) {
    cl(t, Hl(t), e, r);
  }),
  Xl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  ef = /^\w*$/;
function tf(e, t) {
  if (_u(e)) return !1;
  var n = Li(e);
  return !("number" != n && "symbol" != n && "boolean" != n && null != e && !ju(e)) || ef.test(e) || !Xl.test(e) || null != t && e in Object(t);
}
var nf = oc(Object, "create");
var rf = Object.prototype.hasOwnProperty;
var of = Object.prototype.hasOwnProperty;
function af(e) {
  var t = -1,
    n = null == e ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function sf(e, t) {
  for (var n = e.length; n--;) {
    if (al(e[n][0], t)) return n;
  }
  return -1;
}
af.prototype.clear = function () {
  this.__data__ = nf ? nf(null) : {}, this.size = 0;
}, af.prototype.delete = function (e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}, af.prototype.get = function (e) {
  var t = this.__data__;
  if (nf) {
    var n = t[e];
    return "__lodash_hash_undefined__" === n ? void 0 : n;
  }
  return rf.call(t, e) ? t[e] : void 0;
}, af.prototype.has = function (e) {
  var t = this.__data__;
  return nf ? void 0 !== t[e] : of.call(t, e);
}, af.prototype.set = function (e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = nf && void 0 === t ? "__lodash_hash_undefined__" : t, this;
};
var uf = Array.prototype.splice;
function cf(e) {
  var t = -1,
    n = null == e ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
cf.prototype.clear = function () {
  this.__data__ = [], this.size = 0;
}, cf.prototype.delete = function (e) {
  var t = this.__data__,
    n = sf(t, e);
  return !(n < 0) && (n == t.length - 1 ? t.pop() : uf.call(t, n, 1), --this.size, !0);
}, cf.prototype.get = function (e) {
  var t = this.__data__,
    n = sf(t, e);
  return n < 0 ? void 0 : t[n][1];
}, cf.prototype.has = function (e) {
  return sf(this.__data__, e) > -1;
}, cf.prototype.set = function (e, t) {
  var n = this.__data__,
    r = sf(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
};
var lf = oc(du, "Map");
function ff(e, t) {
  var n,
    r,
    i = e.__data__;
  return ("string" == (r = Li(n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? i["string" == typeof t ? "string" : "hash"] : i.map;
}
function hf(e) {
  var t = -1,
    n = null == e ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
hf.prototype.clear = function () {
  this.size = 0, this.__data__ = {
    hash: new af(),
    map: new (lf || cf)(),
    string: new af()
  };
}, hf.prototype.delete = function (e) {
  var t = ff(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}, hf.prototype.get = function (e) {
  return ff(this, e).get(e);
}, hf.prototype.has = function (e) {
  return ff(this, e).has(e);
}, hf.prototype.set = function (e, t) {
  var n = ff(this, e),
    r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
};
function df(e, t) {
  if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError("Expected a function");
  var n = function n() {
    var r = arguments,
      i = t ? t.apply(this, r) : r[0],
      o = n.cache;
    if (o.has(i)) return o.get(i);
    var a = e.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (df.Cache || hf)(), n;
}
df.Cache = hf;
var vf = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
  pf = /\\(\\)?/g,
  mf = function (e) {
    var t = df(e, function (e) {
        return 500 === n.size && n.clear(), e;
      }),
      n = t.cache;
    return t;
  }(function (e) {
    var t = [];
    return 46 === e.charCodeAt(0) && t.push(""), e.replace(vf, function (e, n, r, i) {
      t.push(r ? i.replace(pf, "$1") : n || e);
    }), t;
  });
function gf(e) {
  return null == e ? "" : Au(e);
}
function yf(e, t) {
  return _u(e) ? e : tf(e, t) ? [e] : mf(gf(e));
}
function bf(e) {
  if ("string" == typeof e || ju(e)) return e;
  var t = e + "";
  return "0" == t && 1 / e == -Infinity ? "-0" : t;
}
function kf(e, t) {
  for (var n = 0, r = (t = yf(t, e)).length; null != e && n < r;) {
    e = e[bf(t[n++])];
  }
  return n && n == r ? e : void 0;
}
function wf(e, t, n) {
  var r = null == e ? void 0 : kf(e, t);
  return void 0 === r ? n : r;
}
function xf(e, t) {
  for (var n = -1, r = t.length, i = Array(r), o = null == e; ++n < r;) {
    i[n] = o ? void 0 : wf(e, t[n]);
  }
  return i;
}
function jf(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r;) {
    e[i + n] = t[n];
  }
  return e;
}
var Sf = vu ? vu.isConcatSpreadable : void 0;
function Cf(e) {
  return _u(e) || Sl(e) || !!(Sf && e && e[Sf]);
}
function _f(e, t, n, r, i) {
  var o = -1,
    a = e.length;
  for (n || (n = Cf), i || (i = []); ++o < a;) {
    var s = e[o];
    t > 0 && n(s) ? t > 1 ? _f(s, t - 1, n, r, i) : jf(i, s) : r || (i[i.length] = s);
  }
  return i;
}
function $f(e) {
  return (null == e ? 0 : e.length) ? _f(e, 1) : [];
}
function Of(e) {
  return Lc(fl(e, void 0, $f), e + "");
}
var Af = Of(xf),
  Ef = Bl(Object.getPrototypeOf, Object),
  Pf = Function.prototype,
  Mf = Object.prototype,
  If = Pf.toString,
  Tf = Mf.hasOwnProperty,
  Nf = If.call(Object);
function Rf(e) {
  if (!xu(e) || "[object Object]" != wu(e)) return !1;
  var t = Ef(e);
  if (null === t) return !0;
  var n = Tf.call(t, "constructor") && t.constructor;
  return "function" == typeof n && n instanceof n && If.call(n) == Nf;
}
function Df(e) {
  if (!xu(e)) return !1;
  var t = wu(e);
  return "[object Error]" == t || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !Rf(e);
}
var zf = hl(function (e, t) {
  try {
    return hc(e, void 0, t);
  } catch (e) {
    return Df(e) ? e : new Error(e);
  }
});
function Lf(e, t) {
  var n;
  if ("function" != typeof t) throw new TypeError("Expected a function");
  return e = Vu(e), function () {
    return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = void 0), n;
  };
}
var Bf = hl(function (e, t, n) {
  var r = 1;
  if (n.length) {
    var i = Xc(n, Kc(Bf));
    r |= 32;
  }
  return rl(e, r, t, n, i);
});
Bf.placeholder = {};
var qf = Of(function (e, t) {
    return Bc(t, function (t) {
      t = bf(t), ol(e, t, Bf(e[t], e));
    }), e;
  }),
  Ff = hl(function (e, t, n) {
    var r = 3;
    if (n.length) {
      var i = Xc(n, Kc(Ff));
      r |= 32;
    }
    return rl(t, r, e, n, i);
  });
function Vf(e, t, n) {
  var r = -1,
    i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), (n = n > i ? i : n) < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i;) {
    o[r] = e[r + t];
  }
  return o;
}
function Hf(e, t, n) {
  var r = e.length;
  return n = void 0 === n ? r : n, !t && n >= r ? e : Vf(e, t, n);
}
Ff.placeholder = {};
var Wf = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
function Uf(e) {
  return Wf.test(e);
}
var Jf = "[\\ud800-\\udfff]",
  Kf = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
  Gf = "\\ud83c[\\udffb-\\udfff]",
  Qf = "[^\\ud800-\\udfff]",
  Yf = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  Zf = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  Xf = "(?:" + Kf + "|" + Gf + ")" + "?",
  eh = "[\\ufe0e\\ufe0f]?" + Xf + ("(?:\\u200d(?:" + [Qf, Yf, Zf].join("|") + ")[\\ufe0e\\ufe0f]?" + Xf + ")*"),
  th = "(?:" + [Qf + Kf + "?", Kf, Yf, Zf, Jf].join("|") + ")",
  nh = RegExp(Gf + "(?=" + Gf + ")|" + th + eh, "g");
function rh(e) {
  return Uf(e) ? function (e) {
    return e.match(nh) || [];
  }(e) : function (e) {
    return e.split("");
  }(e);
}
function ih(e) {
  return function (t) {
    var n = Uf(t = gf(t)) ? rh(t) : void 0,
      r = n ? n[0] : t.charAt(0),
      i = n ? Hf(n, 1).join("") : t.slice(1);
    return r[e]() + i;
  };
}
var oh = ih("toUpperCase");
function ah(e) {
  return oh(gf(e).toLowerCase());
}
function sh(e, t, n, r) {
  var i = -1,
    o = null == e ? 0 : e.length;
  for (r && o && (n = e[++i]); ++i < o;) {
    n = t(n, e[i], i, e);
  }
  return n;
}
function uh(e) {
  return function (t) {
    return null == e ? void 0 : e[t];
  };
}
var ch = uh({
    "À": "A",
    "Á": "A",
    "Â": "A",
    "Ã": "A",
    "Ä": "A",
    "Å": "A",
    "à": "a",
    "á": "a",
    "â": "a",
    "ã": "a",
    "ä": "a",
    "å": "a",
    "Ç": "C",
    "ç": "c",
    "Ð": "D",
    "ð": "d",
    "È": "E",
    "É": "E",
    "Ê": "E",
    "Ë": "E",
    "è": "e",
    "é": "e",
    "ê": "e",
    "ë": "e",
    "Ì": "I",
    "Í": "I",
    "Î": "I",
    "Ï": "I",
    "ì": "i",
    "í": "i",
    "î": "i",
    "ï": "i",
    "Ñ": "N",
    "ñ": "n",
    "Ò": "O",
    "Ó": "O",
    "Ô": "O",
    "Õ": "O",
    "Ö": "O",
    "Ø": "O",
    "ò": "o",
    "ó": "o",
    "ô": "o",
    "õ": "o",
    "ö": "o",
    "ø": "o",
    "Ù": "U",
    "Ú": "U",
    "Û": "U",
    "Ü": "U",
    "ù": "u",
    "ú": "u",
    "û": "u",
    "ü": "u",
    "Ý": "Y",
    "ý": "y",
    "ÿ": "y",
    "Æ": "Ae",
    "æ": "ae",
    "Þ": "Th",
    "þ": "th",
    "ß": "ss",
    "Ā": "A",
    "Ă": "A",
    "Ą": "A",
    "ā": "a",
    "ă": "a",
    "ą": "a",
    "Ć": "C",
    "Ĉ": "C",
    "Ċ": "C",
    "Č": "C",
    "ć": "c",
    "ĉ": "c",
    "ċ": "c",
    "č": "c",
    "Ď": "D",
    "Đ": "D",
    "ď": "d",
    "đ": "d",
    "Ē": "E",
    "Ĕ": "E",
    "Ė": "E",
    "Ę": "E",
    "Ě": "E",
    "ē": "e",
    "ĕ": "e",
    "ė": "e",
    "ę": "e",
    "ě": "e",
    "Ĝ": "G",
    "Ğ": "G",
    "Ġ": "G",
    "Ģ": "G",
    "ĝ": "g",
    "ğ": "g",
    "ġ": "g",
    "ģ": "g",
    "Ĥ": "H",
    "Ħ": "H",
    "ĥ": "h",
    "ħ": "h",
    "Ĩ": "I",
    "Ī": "I",
    "Ĭ": "I",
    "Į": "I",
    "İ": "I",
    "ĩ": "i",
    "ī": "i",
    "ĭ": "i",
    "į": "i",
    "ı": "i",
    "Ĵ": "J",
    "ĵ": "j",
    "Ķ": "K",
    "ķ": "k",
    "ĸ": "k",
    "Ĺ": "L",
    "Ļ": "L",
    "Ľ": "L",
    "Ŀ": "L",
    "Ł": "L",
    "ĺ": "l",
    "ļ": "l",
    "ľ": "l",
    "ŀ": "l",
    "ł": "l",
    "Ń": "N",
    "Ņ": "N",
    "Ň": "N",
    "Ŋ": "N",
    "ń": "n",
    "ņ": "n",
    "ň": "n",
    "ŋ": "n",
    "Ō": "O",
    "Ŏ": "O",
    "Ő": "O",
    "ō": "o",
    "ŏ": "o",
    "ő": "o",
    "Ŕ": "R",
    "Ŗ": "R",
    "Ř": "R",
    "ŕ": "r",
    "ŗ": "r",
    "ř": "r",
    "Ś": "S",
    "Ŝ": "S",
    "Ş": "S",
    "Š": "S",
    "ś": "s",
    "ŝ": "s",
    "ş": "s",
    "š": "s",
    "Ţ": "T",
    "Ť": "T",
    "Ŧ": "T",
    "ţ": "t",
    "ť": "t",
    "ŧ": "t",
    "Ũ": "U",
    "Ū": "U",
    "Ŭ": "U",
    "Ů": "U",
    "Ű": "U",
    "Ų": "U",
    "ũ": "u",
    "ū": "u",
    "ŭ": "u",
    "ů": "u",
    "ű": "u",
    "ų": "u",
    "Ŵ": "W",
    "ŵ": "w",
    "Ŷ": "Y",
    "ŷ": "y",
    "Ÿ": "Y",
    "Ź": "Z",
    "Ż": "Z",
    "Ž": "Z",
    "ź": "z",
    "ż": "z",
    "ž": "z",
    "Ĳ": "IJ",
    "ĳ": "ij",
    "Œ": "Oe",
    "œ": "oe",
    "ŉ": "'n",
    "ſ": "s"
  }),
  lh = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
  fh = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g");
function hh(e) {
  return (e = gf(e)) && e.replace(lh, ch).replace(fh, "");
}
var dh = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
var vh = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
var ph = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
  mh = "[" + ph + "]",
  gh = "\\d+",
  yh = "[\\u2700-\\u27bf]",
  bh = "[a-z\\xdf-\\xf6\\xf8-\\xff]",
  kh = "[^\\ud800-\\udfff" + ph + gh + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]",
  wh = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  xh = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  jh = "[A-Z\\xc0-\\xd6\\xd8-\\xde]",
  Sh = "(?:" + bh + "|" + kh + ")",
  Ch = "(?:" + jh + "|" + kh + ")",
  _h = "(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?",
  $h = "[\\ufe0e\\ufe0f]?" + _h + ("(?:\\u200d(?:" + ["[^\\ud800-\\udfff]", wh, xh].join("|") + ")[\\ufe0e\\ufe0f]?" + _h + ")*"),
  Oh = "(?:" + [yh, wh, xh].join("|") + ")" + $h,
  Ah = RegExp([jh + "?" + bh + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [mh, jh, "$"].join("|") + ")", Ch + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [mh, jh + Sh, "$"].join("|") + ")", jh + "?" + Sh + "+(?:['’](?:d|ll|m|re|s|t|ve))?", jh + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", gh, Oh].join("|"), "g");
function Eh(e, t, n) {
  return e = gf(e), void 0 === (t = n ? void 0 : t) ? function (e) {
    return vh.test(e);
  }(e) ? function (e) {
    return e.match(Ah) || [];
  }(e) : function (e) {
    return e.match(dh) || [];
  }(e) : e.match(t) || [];
}
var Ph = RegExp("['’]", "g");
function Mh(e) {
  return function (t) {
    return sh(Eh(hh(t).replace(Ph, "")), e, "");
  };
}
var Ih = Mh(function (e, t, n) {
  return t = t.toLowerCase(), e + (n ? ah(t) : t);
});
function Th() {
  if (!arguments.length) return [];
  var e = arguments[0];
  return _u(e) ? e : [e];
}
var Nh = du.isFinite,
  Rh = Math.min;
function Dh(e) {
  var t = Math[e];
  return function (e, n) {
    if (e = qu(e), (n = null == n ? 0 : Rh(Vu(n), 292)) && Nh(e)) {
      var r = (gf(e) + "e").split("e");
      return +((r = (gf(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"))[0] + "e" + (+r[1] - n));
    }
    return t(e);
  };
}
var zh = Dh("ceil");
function Lh(e) {
  var t = Ac(e);
  return t.__chain__ = !0, t;
}
var Bh = Math.ceil,
  qh = Math.max;
function Fh(e, t, n) {
  t = (n ? pl(e, t, n) : void 0 === t) ? 1 : qh(Vu(t), 0);
  var r = null == e ? 0 : e.length;
  if (!r || t < 1) return [];
  for (var i = 0, o = 0, a = Array(Bh(r / t)); i < r;) {
    a[o++] = Vf(e, i, i += t);
  }
  return a;
}
function Vh(e, t, n) {
  return e == e && (void 0 !== n && (e = e <= n ? e : n), void 0 !== t && (e = e >= t ? e : t)), e;
}
function Hh(e, t, n) {
  return void 0 === n && (n = t, t = void 0), void 0 !== n && (n = (n = qu(n)) == n ? n : 0), void 0 !== t && (t = (t = qu(t)) == t ? t : 0), Vh(qu(e), t, n);
}
function Wh(e) {
  var t = this.__data__ = new cf(e);
  this.size = t.size;
}
function Uh(e, t) {
  return e && cl(t, Hl(t), e);
}
Wh.prototype.clear = function () {
  this.__data__ = new cf(), this.size = 0;
}, Wh.prototype.delete = function (e) {
  var t = this.__data__,
    n = t.delete(e);
  return this.size = t.size, n;
}, Wh.prototype.get = function (e) {
  return this.__data__.get(e);
}, Wh.prototype.has = function (e) {
  return this.__data__.has(e);
}, Wh.prototype.set = function (e, t) {
  var n = this.__data__;
  if (n instanceof cf) {
    var r = n.__data__;
    if (!lf || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new hf(r);
  }
  return n.set(e, t), this.size = n.size, this;
};
var Jh = "object" == ("undefined" == typeof exports ? "undefined" : Li(exports)) && exports && !exports.nodeType && exports,
  Kh = Jh && "object" == ("undefined" == typeof module ? "undefined" : Li(module)) && module && !module.nodeType && module,
  Gh = Kh && Kh.exports === Jh ? du.Buffer : void 0,
  Qh = Gh ? Gh.allocUnsafe : void 0;
function Yh(e, t) {
  if (t) return e.slice();
  var n = e.length,
    r = Qh ? Qh(n) : new e.constructor(n);
  return e.copy(r), r;
}
function Zh(e, t) {
  for (var n = -1, r = null == e ? 0 : e.length, i = 0, o = []; ++n < r;) {
    var a = e[n];
    t(a, n, e) && (o[i++] = a);
  }
  return o;
}
function Xh() {
  return [];
}
var ed = Object.prototype.propertyIsEnumerable,
  td = Object.getOwnPropertySymbols,
  nd = td ? function (e) {
    return null == e ? [] : (e = Object(e), Zh(td(e), function (t) {
      return ed.call(e, t);
    }));
  } : Xh;
var rd = Object.getOwnPropertySymbols ? function (e) {
  for (var t = []; e;) {
    jf(t, nd(e)), e = Ef(e);
  }
  return t;
} : Xh;
function id(e, t, n) {
  var r = t(e);
  return _u(e) ? r : jf(r, n(e));
}
function od(e) {
  return id(e, Hl, nd);
}
function ad(e) {
  return id(e, Gl, rd);
}
var sd = oc(du, "DataView"),
  ud = oc(du, "Promise"),
  cd = oc(du, "Set"),
  ld = Yu(sd),
  fd = Yu(lf),
  hd = Yu(ud),
  dd = Yu(cd),
  vd = Yu(ac),
  pd = wu;
(sd && "[object DataView]" != pd(new sd(new ArrayBuffer(1))) || lf && "[object Map]" != pd(new lf()) || ud && "[object Promise]" != pd(ud.resolve()) || cd && "[object Set]" != pd(new cd()) || ac && "[object WeakMap]" != pd(new ac())) && (pd = function pd(e) {
  var t = wu(e),
    n = "[object Object]" == t ? e.constructor : void 0,
    r = n ? Yu(n) : "";
  if (r) switch (r) {
    case ld:
      return "[object DataView]";
    case fd:
      return "[object Map]";
    case hd:
      return "[object Promise]";
    case dd:
      return "[object Set]";
    case vd:
      return "[object WeakMap]";
  }
  return t;
});
var md = pd,
  gd = Object.prototype.hasOwnProperty;
var yd = du.Uint8Array;
function bd(e) {
  var t = new e.constructor(e.byteLength);
  return new yd(t).set(new yd(e)), t;
}
var kd = /\w*$/;
var wd = vu ? vu.prototype : void 0,
  xd = wd ? wd.valueOf : void 0;
function jd(e, t) {
  var n = t ? bd(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
function Sd(e, t, n) {
  var r,
    i = e.constructor;
  switch (t) {
    case "[object ArrayBuffer]":
      return bd(e);
    case "[object Boolean]":
    case "[object Date]":
      return new i(+e);
    case "[object DataView]":
      return function (e, t) {
        var n = t ? bd(e.buffer) : e.buffer;
        return new e.constructor(n, e.byteOffset, e.byteLength);
      }(e, n);
    case "[object Float32Array]":
    case "[object Float64Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object Int32Array]":
    case "[object Uint8Array]":
    case "[object Uint8ClampedArray]":
    case "[object Uint16Array]":
    case "[object Uint32Array]":
      return jd(e, n);
    case "[object Map]":
      return new i();
    case "[object Number]":
    case "[object String]":
      return new i(e);
    case "[object RegExp]":
      return function (e) {
        var t = new e.constructor(e.source, kd.exec(e));
        return t.lastIndex = e.lastIndex, t;
      }(e);
    case "[object Set]":
      return new i();
    case "[object Symbol]":
      return r = e, xd ? Object(xd.call(r)) : {};
  }
}
function Cd(e) {
  return "function" != typeof e.constructor || yl(e) ? {} : lc(Ef(e));
}
var _d = Nl && Nl.isMap,
  $d = _d ? Pl(_d) : function (e) {
    return xu(e) && "[object Map]" == md(e);
  };
var Od = Nl && Nl.isSet,
  Ad = Od ? Pl(Od) : function (e) {
    return xu(e) && "[object Set]" == md(e);
  },
  Ed = {};
function Pd(e, t, n, r, i, o) {
  var a,
    s = 1 & t,
    u = 2 & t,
    c = 4 & t;
  if (n && (a = i ? n(e, r, i, o) : n(e)), void 0 !== a) return a;
  if (!Ru(e)) return e;
  var l = _u(e);
  if (l) {
    if (a = function (e) {
      var t = e.length,
        n = new e.constructor(t);
      return t && "string" == typeof e[0] && gd.call(e, "index") && (n.index = e.index, n.input = e.input), n;
    }(e), !s) return _c(e, a);
  } else {
    var f = md(e),
      h = "[object Function]" == f || "[object GeneratorFunction]" == f;
    if (Al(e)) return Yh(e, s);
    if ("[object Object]" == f || "[object Arguments]" == f || h && !i) {
      if (a = u || h ? {} : Cd(e), !s) return u ? function (e, t) {
        return cl(e, rd(e), t);
      }(e, function (e, t) {
        return e && cl(t, Gl(t), e);
      }(a, e)) : function (e, t) {
        return cl(e, nd(e), t);
      }(e, Uh(a, e));
    } else {
      if (!Ed[f]) return i ? e : {};
      a = Sd(e, f, s);
    }
  }
  o || (o = new Wh());
  var d = o.get(e);
  if (d) return d;
  o.set(e, a), Ad(e) ? e.forEach(function (r) {
    a.add(Pd(r, t, n, r, e, o));
  }) : $d(e) && e.forEach(function (r, i) {
    a.set(i, Pd(r, t, n, i, e, o));
  });
  var v = l ? void 0 : (c ? u ? ad : od : u ? Gl : Hl)(e);
  return Bc(v || e, function (r, i) {
    v && (r = e[i = r]), ul(a, i, Pd(r, t, n, i, e, o));
  }), a;
}
Ed["[object Arguments]"] = Ed["[object Array]"] = Ed["[object ArrayBuffer]"] = Ed["[object DataView]"] = Ed["[object Boolean]"] = Ed["[object Date]"] = Ed["[object Float32Array]"] = Ed["[object Float64Array]"] = Ed["[object Int8Array]"] = Ed["[object Int16Array]"] = Ed["[object Int32Array]"] = Ed["[object Map]"] = Ed["[object Number]"] = Ed["[object Object]"] = Ed["[object RegExp]"] = Ed["[object Set]"] = Ed["[object String]"] = Ed["[object Symbol]"] = Ed["[object Uint8Array]"] = Ed["[object Uint8ClampedArray]"] = Ed["[object Uint16Array]"] = Ed["[object Uint32Array]"] = !0, Ed["[object Error]"] = Ed["[object Function]"] = Ed["[object WeakMap]"] = !1;
function Md(e) {
  return Pd(e, 4);
}
function Id(e) {
  return Pd(e, 5);
}
function Td(e, t) {
  return Pd(e, 5, t = "function" == typeof t ? t : void 0);
}
function Nd(e, t) {
  return Pd(e, 4, t = "function" == typeof t ? t : void 0);
}
function Rd() {
  return new Cc(this.value(), this.__chain__);
}
function Dd(e) {
  for (var t = -1, n = null == e ? 0 : e.length, r = 0, i = []; ++t < n;) {
    var o = e[t];
    o && (i[r++] = o);
  }
  return i;
}
function zd() {
  var e = arguments.length;
  if (!e) return [];
  for (var t = Array(e - 1), n = arguments[0], r = e; r--;) {
    t[r - 1] = arguments[r];
  }
  return jf(_u(n) ? _c(n) : [n], _f(t, 1));
}
function Ld(e) {
  var t = -1,
    n = null == e ? 0 : e.length;
  for (this.__data__ = new hf(); ++t < n;) {
    this.add(e[t]);
  }
}
function Bd(e, t) {
  for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
    if (t(e[n], n, e)) return !0;
  }
  return !1;
}
function qd(e, t) {
  return e.has(t);
}
Ld.prototype.add = Ld.prototype.push = function (e) {
  return this.__data__.set(e, "__lodash_hash_undefined__"), this;
}, Ld.prototype.has = function (e) {
  return this.__data__.has(e);
};
function Fd(e, t, n, r, i, o) {
  var a = 1 & n,
    s = e.length,
    u = t.length;
  if (s != u && !(a && u > s)) return !1;
  var c = o.get(e),
    l = o.get(t);
  if (c && l) return c == t && l == e;
  var f = -1,
    h = !0,
    d = 2 & n ? new Ld() : void 0;
  for (o.set(e, t), o.set(t, e); ++f < s;) {
    var v = e[f],
      p = t[f];
    if (r) var m = a ? r(p, v, f, t, e, o) : r(v, p, f, e, t, o);
    if (void 0 !== m) {
      if (m) continue;
      h = !1;
      break;
    }
    if (d) {
      if (!Bd(t, function (e, t) {
        if (!qd(d, t) && (v === e || i(v, e, n, r, o))) return d.push(t);
      })) {
        h = !1;
        break;
      }
    } else if (v !== p && !i(v, p, n, r, o)) {
      h = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), h;
}
function Vd(e) {
  var t = -1,
    n = Array(e.size);
  return e.forEach(function (e, r) {
    n[++t] = [r, e];
  }), n;
}
function Hd(e) {
  var t = -1,
    n = Array(e.size);
  return e.forEach(function (e) {
    n[++t] = e;
  }), n;
}
var Wd = vu ? vu.prototype : void 0,
  Ud = Wd ? Wd.valueOf : void 0;
var Jd = Object.prototype.hasOwnProperty;
var Kd = "[object Object]",
  Gd = Object.prototype.hasOwnProperty;
function Qd(e, t, n, r, i, o) {
  var a = _u(e),
    s = _u(t),
    u = a ? "[object Array]" : md(e),
    c = s ? "[object Array]" : md(t),
    l = (u = "[object Arguments]" == u ? Kd : u) == Kd,
    f = (c = "[object Arguments]" == c ? Kd : c) == Kd,
    h = u == c;
  if (h && Al(e)) {
    if (!Al(t)) return !1;
    a = !0, l = !1;
  }
  if (h && !l) return o || (o = new Wh()), a || Dl(e) ? Fd(e, t, n, r, i, o) : function (e, t, n, r, i, o, a) {
    switch (n) {
      case "[object DataView]":
        if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
        e = e.buffer, t = t.buffer;
      case "[object ArrayBuffer]":
        return !(e.byteLength != t.byteLength || !o(new yd(e), new yd(t)));
      case "[object Boolean]":
      case "[object Date]":
      case "[object Number]":
        return al(+e, +t);
      case "[object Error]":
        return e.name == t.name && e.message == t.message;
      case "[object RegExp]":
      case "[object String]":
        return e == t + "";
      case "[object Map]":
        var s = Vd;
      case "[object Set]":
        var u = 1 & r;
        if (s || (s = Hd), e.size != t.size && !u) return !1;
        var c = a.get(e);
        if (c) return c == t;
        r |= 2, a.set(e, t);
        var l = Fd(s(e), s(t), r, i, o, a);
        return a.delete(e), l;
      case "[object Symbol]":
        if (Ud) return Ud.call(e) == Ud.call(t);
    }
    return !1;
  }(e, t, u, n, r, i, o);
  if (!(1 & n)) {
    var d = l && Gd.call(e, "__wrapped__"),
      v = f && Gd.call(t, "__wrapped__");
    if (d || v) {
      var p = d ? e.value() : e,
        m = v ? t.value() : t;
      return o || (o = new Wh()), i(p, m, n, r, o);
    }
  }
  return !!h && (o || (o = new Wh()), function (e, t, n, r, i, o) {
    var a = 1 & n,
      s = od(e),
      u = s.length;
    if (u != od(t).length && !a) return !1;
    for (var c = u; c--;) {
      var l = s[c];
      if (!(a ? l in t : Jd.call(t, l))) return !1;
    }
    var f = o.get(e),
      h = o.get(t);
    if (f && h) return f == t && h == e;
    var d = !0;
    o.set(e, t), o.set(t, e);
    for (var v = a; ++c < u;) {
      var p = e[l = s[c]],
        m = t[l];
      if (r) var g = a ? r(m, p, l, t, e, o) : r(p, m, l, e, t, o);
      if (!(void 0 === g ? p === m || i(p, m, n, r, o) : g)) {
        d = !1;
        break;
      }
      v || (v = "constructor" == l);
    }
    if (d && !v) {
      var y = e.constructor,
        b = t.constructor;
      y == b || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof b && b instanceof b || (d = !1);
    }
    return o.delete(e), o.delete(t), d;
  }(e, t, n, r, i, o));
}
function Yd(e, t, n, r, i) {
  return e === t || (null == e || null == t || !xu(e) && !xu(t) ? e != e && t != t : Qd(e, t, n, r, Yd, i));
}
function Zd(e, t, n, r) {
  var i = n.length,
    o = i,
    a = !r;
  if (null == e) return !o;
  for (e = Object(e); i--;) {
    var s = n[i];
    if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
  }
  for (; ++i < o;) {
    var u = (s = n[i])[0],
      c = e[u],
      l = s[1];
    if (a && s[2]) {
      if (void 0 === c && !(u in e)) return !1;
    } else {
      var f = new Wh();
      if (r) var h = r(c, l, u, e, t, f);
      if (!(void 0 === h ? Yd(l, c, 3, r, f) : h)) return !1;
    }
  }
  return !0;
}
function Xd(e) {
  return e == e && !Ru(e);
}
function ev(e) {
  for (var t = Hl(e), n = t.length; n--;) {
    var r = t[n],
      i = e[r];
    t[n] = [r, i, Xd(i)];
  }
  return t;
}
function tv(e, t) {
  return function (n) {
    return null != n && n[e] === t && (void 0 !== t || e in Object(n));
  };
}
function nv(e) {
  var t = ev(e);
  return 1 == t.length && t[0][2] ? tv(t[0][0], t[0][1]) : function (n) {
    return n === e || Zd(n, e, t);
  };
}
function rv(e, t) {
  return null != e && t in Object(e);
}
function iv(e, t, n) {
  for (var r = -1, i = (t = yf(t, e)).length, o = !1; ++r < i;) {
    var a = bf(t[r]);
    if (!(o = null != e && n(e, a))) break;
    e = e[a];
  }
  return o || ++r != i ? o : !!(i = null == e ? 0 : e.length) && dl(i) && Qc(a, i) && (_u(e) || Sl(e));
}
function ov(e, t) {
  return null != e && iv(e, t, rv);
}
function av(e, t) {
  return tf(e) && Xd(t) ? tv(bf(e), t) : function (n) {
    var r = wf(n, e);
    return void 0 === r && r === t ? ov(n, e) : Yd(t, r, 3);
  };
}
function sv(e) {
  return function (t) {
    return null == t ? void 0 : t[e];
  };
}
function uv(e) {
  return tf(e) ? sv(bf(e)) : function (e) {
    return function (t) {
      return kf(t, e);
    };
  }(e);
}
function cv(e) {
  return "function" == typeof e ? e : null == e ? Wu : "object" == Li(e) ? _u(e) ? av(e[0], e[1]) : nv(e) : uv(e);
}
function lv(e) {
  var t = null == e ? 0 : e.length,
    n = cv;
  return e = t ? Cu(e, function (e) {
    if ("function" != typeof e[1]) throw new TypeError("Expected a function");
    return [n(e[0]), e[1]];
  }) : [], hl(function (n) {
    for (var r = -1; ++r < t;) {
      var i = e[r];
      if (hc(i[0], this, n)) return hc(i[1], this, n);
    }
  });
}
function fv(e, t, n) {
  var r = n.length;
  if (null == e) return !r;
  for (e = Object(e); r--;) {
    var i = n[r],
      o = t[i],
      a = e[i];
    if (void 0 === a && !(i in e) || !o(a)) return !1;
  }
  return !0;
}
function hv(e) {
  return function (e) {
    var t = Hl(e);
    return function (n) {
      return fv(n, e, t);
    };
  }(Pd(e, 1));
}
function dv(e, t) {
  return null == t || fv(e, t, Hl(t));
}
function vv(e, t, n, r) {
  for (var i = -1, o = null == e ? 0 : e.length; ++i < o;) {
    var a = e[i];
    t(r, a, n(a), e);
  }
  return r;
}
function pv(e) {
  return function (t, n, r) {
    for (var i = -1, o = Object(t), a = r(t), s = a.length; s--;) {
      var u = a[e ? s : ++i];
      if (!1 === n(o[u], u, o)) break;
    }
    return t;
  };
}
var mv = pv();
function gv(e, t) {
  return e && mv(e, t, Hl);
}
function yv(e, t) {
  return function (n, r) {
    if (null == n) return n;
    if (!vl(n)) return e(n, r);
    for (var i = n.length, o = t ? i : -1, a = Object(n); (t ? o-- : ++o < i) && !1 !== r(a[o], o, a);) {
      ;
    }
    return n;
  };
}
var bv = yv(gv);
function kv(e, t, n, r) {
  return bv(e, function (e, i, o) {
    t(r, e, n(e), o);
  }), r;
}
function wv(e, t) {
  return function (n, r) {
    var i = _u(n) ? vv : kv,
      o = t ? t() : {};
    return i(n, e, cv(r), o);
  };
}
var xv = Object.prototype.hasOwnProperty,
  jv = wv(function (e, t, n) {
    xv.call(e, n) ? ++e[n] : ol(e, n, 1);
  });
function Sv(e, t) {
  var n = lc(e);
  return null == t ? n : Uh(n, t);
}
function Cv(e, t, n) {
  var r = rl(e, 8, void 0, void 0, void 0, void 0, void 0, t = n ? void 0 : t);
  return r.placeholder = Cv.placeholder, r;
}
Cv.placeholder = {};
function _v(e, t, n) {
  var r = rl(e, 16, void 0, void 0, void 0, void 0, void 0, t = n ? void 0 : t);
  return r.placeholder = _v.placeholder, r;
}
_v.placeholder = {};
var $v = function $v() {
    return du.Date.now();
  },
  Ov = Math.max,
  Av = Math.min;
function Ev(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c = 0,
    l = !1,
    f = !1,
    h = !0;
  if ("function" != typeof e) throw new TypeError("Expected a function");
  function d(t) {
    var n = r,
      o = i;
    return r = i = void 0, c = t, a = e.apply(o, n);
  }
  function v(e) {
    return c = e, s = setTimeout(m, t), l ? d(e) : a;
  }
  function p(e) {
    var n = e - u;
    return void 0 === u || n >= t || n < 0 || f && e - c >= o;
  }
  function m() {
    var e = $v();
    if (p(e)) return g(e);
    s = setTimeout(m, function (e) {
      var n = t - (e - u);
      return f ? Av(n, o - (e - c)) : n;
    }(e));
  }
  function g(e) {
    return s = void 0, h && r ? d(e) : (r = i = void 0, a);
  }
  function y() {
    var e = $v(),
      n = p(e);
    if (r = arguments, i = this, u = e, n) {
      if (void 0 === s) return v(u);
      if (f) return clearTimeout(s), s = setTimeout(m, t), d(u);
    }
    return void 0 === s && (s = setTimeout(m, t)), a;
  }
  return t = qu(t) || 0, Ru(n) && (l = !!n.leading, o = (f = "maxWait" in n) ? Ov(qu(n.maxWait) || 0, t) : o, h = "trailing" in n ? !!n.trailing : h), y.cancel = function () {
    void 0 !== s && clearTimeout(s), c = 0, r = u = i = s = void 0;
  }, y.flush = function () {
    return void 0 === s ? a : g($v());
  }, y;
}
function Pv(e, t) {
  return null == e || e != e ? t : e;
}
var Mv = Object.prototype,
  Iv = Mv.hasOwnProperty,
  Tv = hl(function (e, t) {
    e = Object(e);
    var n = -1,
      r = t.length,
      i = r > 2 ? t[2] : void 0;
    for (i && pl(t[0], t[1], i) && (r = 1); ++n < r;) {
      for (var o = t[n], a = Gl(o), s = -1, u = a.length; ++s < u;) {
        var c = a[s],
          l = e[c];
        (void 0 === l || al(l, Mv[c]) && !Iv.call(e, c)) && (e[c] = o[c]);
      }
    }
    return e;
  });
function Nv(e, t, n) {
  (void 0 !== n && !al(e[t], n) || void 0 === n && !(t in e)) && ol(e, t, n);
}
function Rv(e) {
  return xu(e) && vl(e);
}
function Dv(e, t) {
  if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
}
function zv(e) {
  return cl(e, Gl(e));
}
function Lv(e, t, n, r, i) {
  e !== t && mv(t, function (o, a) {
    if (i || (i = new Wh()), Ru(o)) !function (e, t, n, r, i, o, a) {
      var s = Dv(e, n),
        u = Dv(t, n),
        c = a.get(u);
      if (c) Nv(e, n, c);else {
        var l = o ? o(s, u, n + "", e, t, a) : void 0,
          f = void 0 === l;
        if (f) {
          var h = _u(u),
            d = !h && Al(u),
            v = !h && !d && Dl(u);
          l = u, h || d || v ? _u(s) ? l = s : Rv(s) ? l = _c(s) : d ? (f = !1, l = Yh(u, !0)) : v ? (f = !1, l = jd(u, !0)) : l = [] : Rf(u) || Sl(u) ? (l = s, Sl(s) ? l = zv(s) : Ru(s) && !Uu(s) || (l = Cd(u))) : f = !1;
        }
        f && (a.set(u, l), i(l, u, r, o, a), a.delete(u)), Nv(e, n, l);
      }
    }(e, t, a, n, Lv, r, i);else {
      var s = r ? r(Dv(e, a), o, a + "", e, t, i) : void 0;
      void 0 === s && (s = o), Nv(e, a, s);
    }
  }, Gl);
}
function Bv(e, t, n, r, i, o) {
  return Ru(e) && Ru(t) && (o.set(t, e), Lv(e, t, void 0, Bv, o), o.delete(t)), e;
}
var qv = ml(function (e, t, n, r) {
    Lv(e, t, n, r);
  }),
  Fv = hl(function (e) {
    return e.push(void 0, Bv), hc(qv, void 0, e);
  });
function Vv(e, t, n) {
  if ("function" != typeof e) throw new TypeError("Expected a function");
  return setTimeout(function () {
    e.apply(void 0, n);
  }, t);
}
var Hv = hl(function (e, t) {
    return Vv(e, 1, t);
  }),
  Wv = hl(function (e, t, n) {
    return Vv(e, qu(t) || 0, n);
  });
function Uv(e, t, n) {
  for (var r = -1, i = null == e ? 0 : e.length; ++r < i;) {
    if (n(t, e[r])) return !0;
  }
  return !1;
}
function Jv(e, t, n, r) {
  var i = -1,
    o = Hc,
    a = !0,
    s = e.length,
    u = [],
    c = t.length;
  if (!s) return u;
  n && (t = Cu(t, Pl(n))), r ? (o = Uv, a = !1) : t.length >= 200 && (o = qd, a = !1, t = new Ld(t));
  e: for (; ++i < s;) {
    var l = e[i],
      f = null == n ? l : n(l);
    if (l = r || 0 !== l ? l : 0, a && f == f) {
      for (var h = c; h--;) {
        if (t[h] === f) continue e;
      }
      u.push(l);
    } else o(t, f, r) || u.push(l);
  }
  return u;
}
var Kv = hl(function (e, t) {
  return Rv(e) ? Jv(e, _f(t, 1, Rv, !0)) : [];
});
function Gv(e) {
  var t = null == e ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Qv = hl(function (e, t) {
    var n = Gv(t);
    return Rv(n) && (n = void 0), Rv(e) ? Jv(e, _f(t, 1, Rv, !0), cv(n)) : [];
  }),
  Yv = hl(function (e, t) {
    var n = Gv(t);
    return Rv(n) && (n = void 0), Rv(e) ? Jv(e, _f(t, 1, Rv, !0), void 0, n) : [];
  }),
  Zv = Eu(function (e, t) {
    return e / t;
  }, 1);
function Xv(e, t, n) {
  var r = null == e ? 0 : e.length;
  return r ? Vf(e, (t = n || void 0 === t ? 1 : Vu(t)) < 0 ? 0 : t, r) : [];
}
function ep(e, t, n) {
  var r = null == e ? 0 : e.length;
  return r ? Vf(e, 0, (t = r - (t = n || void 0 === t ? 1 : Vu(t))) < 0 ? 0 : t) : [];
}
function tp(e, t, n, r) {
  for (var i = e.length, o = r ? i : -1; (r ? o-- : ++o < i) && t(e[o], o, e);) {
    ;
  }
  return n ? Vf(e, r ? 0 : o, r ? o + 1 : i) : Vf(e, r ? o + 1 : 0, r ? i : o);
}
function np(e, t) {
  return e && e.length ? tp(e, cv(t), !0, !0) : [];
}
function rp(e, t) {
  return e && e.length ? tp(e, cv(t), !0) : [];
}
function ip(e) {
  return "function" == typeof e ? e : Wu;
}
function op(e, t) {
  return (_u(e) ? Bc : bv)(e, ip(t));
}
function ap(e, t) {
  for (var n = null == e ? 0 : e.length; n-- && !1 !== t(e[n], n, e);) {
    ;
  }
  return e;
}
var sp = pv(!0);
function up(e, t) {
  return e && sp(e, t, Hl);
}
var cp = yv(up, !0);
function lp(e, t) {
  return (_u(e) ? ap : cp)(e, ip(t));
}
function fp(e, t, n) {
  e = gf(e), t = Au(t);
  var r = e.length,
    i = n = void 0 === n ? r : Vh(Vu(n), 0, r);
  return (n -= t.length) >= 0 && e.slice(n, i) == t;
}
function hp(e) {
  return function (t) {
    var n = md(t);
    return "[object Map]" == n ? Vd(t) : "[object Set]" == n ? function (e) {
      var t = -1,
        n = Array(e.size);
      return e.forEach(function (e) {
        n[++t] = [e, e];
      }), n;
    }(t) : function (e, t) {
      return Cu(t, function (t) {
        return [t, e[t]];
      });
    }(t, e(t));
  };
}
var dp = hp(Hl),
  vp = hp(Gl),
  pp = uh({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  }),
  mp = /[&<>"']/g,
  gp = RegExp(mp.source);
function yp(e) {
  return (e = gf(e)) && gp.test(e) ? e.replace(mp, pp) : e;
}
var bp = /[\\^$.*+?()[\]{}|]/g,
  kp = RegExp(bp.source);
function wp(e) {
  return (e = gf(e)) && kp.test(e) ? e.replace(bp, "\\$&") : e;
}
function xp(e, t) {
  for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
    if (!t(e[n], n, e)) return !1;
  }
  return !0;
}
function jp(e, t) {
  var n = !0;
  return bv(e, function (e, r, i) {
    return n = !!t(e, r, i);
  }), n;
}
function Sp(e, t, n) {
  var r = _u(e) ? xp : jp;
  return n && pl(e, t, n) && (t = void 0), r(e, cv(t));
}
function Cp(e) {
  return e ? Vh(Vu(e), 0, 4294967295) : 0;
}
function _p(e, t, n, r) {
  var i = null == e ? 0 : e.length;
  return i ? (n && "number" != typeof n && pl(e, t, n) && (n = 0, r = i), function (e, t, n, r) {
    var i = e.length;
    for ((n = Vu(n)) < 0 && (n = -n > i ? 0 : i + n), (r = void 0 === r || r > i ? i : Vu(r)) < 0 && (r += i), r = n > r ? 0 : Cp(r); n < r;) {
      e[n++] = t;
    }
    return e;
  }(e, t, n, r)) : [];
}
function $p(e, t) {
  var n = [];
  return bv(e, function (e, r, i) {
    t(e, r, i) && n.push(e);
  }), n;
}
function Op(e, t) {
  return (_u(e) ? Zh : $p)(e, cv(t));
}
function Ap(e) {
  return function (t, n, r) {
    var i = Object(t);
    if (!vl(t)) {
      var o = cv(n);
      t = Hl(t), n = function n(e) {
        return o(i[e], e, i);
      };
    }
    var a = e(t, n, r);
    return a > -1 ? i[o ? t[a] : a] : void 0;
  };
}
var Ep = Math.max;
function Pp(e, t, n) {
  var r = null == e ? 0 : e.length;
  if (!r) return -1;
  var i = null == n ? 0 : Vu(n);
  return i < 0 && (i = Ep(r + i, 0)), qc(e, cv(t), i);
}
var Mp = Ap(Pp);
function Ip(e, t, n) {
  var r;
  return n(e, function (e, n, i) {
    if (t(e, n, i)) return r = n, !1;
  }), r;
}
function Tp(e, t) {
  return Ip(e, cv(t), gv);
}
var Np = Math.max,
  Rp = Math.min;
function Dp(e, t, n) {
  var r = null == e ? 0 : e.length;
  if (!r) return -1;
  var i = r - 1;
  return void 0 !== n && (i = Vu(n), i = n < 0 ? Np(r + i, 0) : Rp(i, r - 1)), qc(e, cv(t), i, !0);
}
var zp = Ap(Dp);
function Lp(e, t) {
  return Ip(e, cv(t), up);
}
function Bp(e) {
  return e && e.length ? e[0] : void 0;
}
function qp(e, t) {
  var n = -1,
    r = vl(e) ? Array(e.length) : [];
  return bv(e, function (e, i, o) {
    r[++n] = t(e, i, o);
  }), r;
}
function Fp(e, t) {
  return (_u(e) ? Cu : qp)(e, cv(t));
}
function Vp(e, t) {
  return _f(Fp(e, t), 1);
}
function Hp(e, t) {
  return _f(Fp(e, t), Infinity);
}
function Wp(e, t, n) {
  return n = void 0 === n ? 1 : Vu(n), _f(Fp(e, t), n);
}
function Up(e) {
  return (null == e ? 0 : e.length) ? _f(e, Infinity) : [];
}
function Jp(e, t) {
  return (null == e ? 0 : e.length) ? _f(e, t = void 0 === t ? 1 : Vu(t)) : [];
}
function Kp(e) {
  return rl(e, 512);
}
var Gp = Dh("floor");
function Qp(e) {
  return Of(function (t) {
    var n = t.length,
      r = n,
      i = Cc.prototype.thru;
    for (e && t.reverse(); r--;) {
      var o = t[r];
      if ("function" != typeof o) throw new TypeError("Expected a function");
      if (i && !a && "wrapper" == Sc(o)) var a = new Cc([], !0);
    }
    for (r = a ? r : n; ++r < n;) {
      var s = Sc(o = t[r]),
        u = "wrapper" == s ? wc(o) : void 0;
      a = u && Ec(u[0]) && 424 == u[1] && !u[4].length && 1 == u[9] ? a[Sc(u[0])].apply(a, u[3]) : 1 == o.length && Ec(o) ? a[s]() : a.thru(o);
    }
    return function () {
      var e = arguments,
        r = e[0];
      if (a && 1 == e.length && _u(r)) return a.plant(r).value();
      for (var i = 0, o = n ? t[i].apply(this, e) : r; ++i < n;) {
        o = t[i].call(this, o);
      }
      return o;
    };
  });
}
var Yp = Qp(),
  Zp = Qp(!0);
function Xp(e, t) {
  return null == e ? e : mv(e, ip(t), Gl);
}
function em(e, t) {
  return null == e ? e : sp(e, ip(t), Gl);
}
function tm(e, t) {
  return e && gv(e, ip(t));
}
function nm(e, t) {
  return e && up(e, ip(t));
}
function rm(e) {
  for (var t = -1, n = null == e ? 0 : e.length, r = {}; ++t < n;) {
    var i = e[t];
    r[i[0]] = i[1];
  }
  return r;
}
function im(e, t) {
  return Zh(t, function (t) {
    return Uu(e[t]);
  });
}
function om(e) {
  return null == e ? [] : im(e, Hl(e));
}
function am(e) {
  return null == e ? [] : im(e, Gl(e));
}
var sm = Object.prototype.hasOwnProperty,
  um = wv(function (e, t, n) {
    sm.call(e, n) ? e[n].push(t) : ol(e, n, [t]);
  });
function cm(e, t) {
  return e > t;
}
function lm(e) {
  return function (t, n) {
    return "string" == typeof t && "string" == typeof n || (t = qu(t), n = qu(n)), e(t, n);
  };
}
var fm = lm(cm),
  hm = lm(function (e, t) {
    return e >= t;
  }),
  dm = Object.prototype.hasOwnProperty;
function vm(e, t) {
  return null != e && dm.call(e, t);
}
function pm(e, t) {
  return null != e && iv(e, t, vm);
}
var mm = Math.max,
  gm = Math.min;
function ym(e, t, n) {
  return t = Fu(t), void 0 === n ? (n = t, t = 0) : n = Fu(n), function (e, t, n) {
    return e >= gm(t, n) && e < mm(t, n);
  }(e = qu(e), t, n);
}
function bm(e) {
  return "string" == typeof e || !_u(e) && xu(e) && "[object String]" == wu(e);
}
function km(e, t) {
  return Cu(t, function (t) {
    return e[t];
  });
}
function wm(e) {
  return null == e ? [] : km(e, Hl(e));
}
var xm = Math.max;
function jm(e, t, n, r) {
  e = vl(e) ? e : wm(e), n = n && !r ? Vu(n) : 0;
  var i = e.length;
  return n < 0 && (n = xm(i + n, 0)), bm(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && Vc(e, t, n) > -1;
}
var Sm = Math.max;
function Cm(e, t, n) {
  var r = null == e ? 0 : e.length;
  if (!r) return -1;
  var i = null == n ? 0 : Vu(n);
  return i < 0 && (i = Sm(r + i, 0)), Vc(e, t, i);
}
function _m(e) {
  return (null == e ? 0 : e.length) ? Vf(e, 0, -1) : [];
}
var $m = Math.min;
function Om(e, t, n) {
  for (var r = n ? Uv : Hc, i = e[0].length, o = e.length, a = o, s = Array(o), u = 1 / 0, c = []; a--;) {
    var l = e[a];
    a && t && (l = Cu(l, Pl(t))), u = $m(l.length, u), s[a] = !n && (t || i >= 120 && l.length >= 120) ? new Ld(a && l) : void 0;
  }
  l = e[0];
  var f = -1,
    h = s[0];
  e: for (; ++f < i && c.length < u;) {
    var d = l[f],
      v = t ? t(d) : d;
    if (d = n || 0 !== d ? d : 0, !(h ? qd(h, v) : r(c, v, n))) {
      for (a = o; --a;) {
        var p = s[a];
        if (!(p ? qd(p, v) : r(e[a], v, n))) continue e;
      }
      h && h.push(v), c.push(d);
    }
  }
  return c;
}
function Am(e) {
  return Rv(e) ? e : [];
}
var Em = hl(function (e) {
    var t = Cu(e, Am);
    return t.length && t[0] === e[0] ? Om(t) : [];
  }),
  Pm = hl(function (e) {
    var t = Gv(e),
      n = Cu(e, Am);
    return t === Gv(n) ? t = void 0 : n.pop(), n.length && n[0] === e[0] ? Om(n, cv(t)) : [];
  }),
  Mm = hl(function (e) {
    var t = Gv(e),
      n = Cu(e, Am);
    return (t = "function" == typeof t ? t : void 0) && n.pop(), n.length && n[0] === e[0] ? Om(n, void 0, t) : [];
  });
function Im(e, t) {
  return function (n, r) {
    return function (e, t, n, r) {
      return gv(e, function (e, i, o) {
        t(r, n(e), i, o);
      }), r;
    }(n, e, t(r), {});
  };
}
var Tm = Object.prototype.toString,
  Nm = Im(function (e, t, n) {
    null != t && "function" != typeof t.toString && (t = Tm.call(t)), e[t] = n;
  }, Dc(Wu)),
  Rm = Object.prototype,
  Dm = Rm.hasOwnProperty,
  zm = Rm.toString,
  Lm = Im(function (e, t, n) {
    null != t && "function" != typeof t.toString && (t = zm.call(t)), Dm.call(e, t) ? e[t].push(n) : e[t] = [n];
  }, cv);
function Bm(e, t) {
  return t.length < 2 ? e : kf(e, Vf(t, 0, -1));
}
function qm(e, t, n) {
  var r = null == (e = Bm(e, t = yf(t, e))) ? e : e[bf(Gv(t))];
  return null == r ? void 0 : hc(r, e, n);
}
var Fm = hl(qm),
  Vm = hl(function (e, t, n) {
    var r = -1,
      i = "function" == typeof t,
      o = vl(e) ? Array(e.length) : [];
    return bv(e, function (e) {
      o[++r] = i ? hc(t, e, n) : qm(e, t, n);
    }), o;
  });
var Hm = Nl && Nl.isArrayBuffer,
  Wm = Hm ? Pl(Hm) : function (e) {
    return xu(e) && "[object ArrayBuffer]" == wu(e);
  };
function Um(e) {
  return !0 === e || !1 === e || xu(e) && "[object Boolean]" == wu(e);
}
var Jm = Nl && Nl.isDate,
  Km = Jm ? Pl(Jm) : function (e) {
    return xu(e) && "[object Date]" == wu(e);
  };
function Gm(e) {
  return xu(e) && 1 === e.nodeType && !Rf(e);
}
var Qm = Object.prototype.hasOwnProperty;
function Ym(e) {
  if (null == e) return !0;
  if (vl(e) && (_u(e) || "string" == typeof e || "function" == typeof e.splice || Al(e) || Dl(e) || Sl(e))) return !e.length;
  var t = md(e);
  if ("[object Map]" == t || "[object Set]" == t) return !e.size;
  if (yl(e)) return !Vl(e).length;
  for (var n in e) {
    if (Qm.call(e, n)) return !1;
  }
  return !0;
}
function Zm(e, t) {
  return Yd(e, t);
}
function Xm(e, t, n) {
  var r = (n = "function" == typeof n ? n : void 0) ? n(e, t) : void 0;
  return void 0 === r ? Yd(e, t, void 0, n) : !!r;
}
var eg = du.isFinite;
function tg(e) {
  return "number" == typeof e && eg(e);
}
function ng(e) {
  return "number" == typeof e && e == Vu(e);
}
function rg(e, t) {
  return e === t || Zd(e, t, ev(t));
}
function ig(e, t, n) {
  return n = "function" == typeof n ? n : void 0, Zd(e, t, ev(t), n);
}
function og(e) {
  return "number" == typeof e || xu(e) && "[object Number]" == wu(e);
}
function ag(e) {
  return og(e) && e != +e;
}
var sg = Ku ? Uu : Cl;
function ug(e) {
  if (sg(e)) throw new Error("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
  return ic(e);
}
function cg(e) {
  return null == e;
}
function lg(e) {
  return null === e;
}
var fg = Nl && Nl.isRegExp,
  hg = fg ? Pl(fg) : function (e) {
    return xu(e) && "[object RegExp]" == wu(e);
  };
function dg(e) {
  return ng(e) && e >= -9007199254740991 && e <= 9007199254740991;
}
function vg(e) {
  return void 0 === e;
}
function pg(e) {
  return xu(e) && "[object WeakMap]" == md(e);
}
function mg(e) {
  return xu(e) && "[object WeakSet]" == wu(e);
}
function gg(e) {
  return cv("function" == typeof e ? e : Pd(e, 1));
}
var yg = Array.prototype.join;
function bg(e, t) {
  return null == e ? "" : yg.call(e, t);
}
var kg = Mh(function (e, t, n) {
    return e + (n ? "-" : "") + t.toLowerCase();
  }),
  wg = wv(function (e, t, n) {
    ol(e, n, t);
  });
var xg = Math.max,
  jg = Math.min;
function Sg(e, t, n) {
  var r = null == e ? 0 : e.length;
  if (!r) return -1;
  var i = r;
  return void 0 !== n && (i = (i = Vu(n)) < 0 ? xg(r + i, 0) : jg(i, r - 1)), t == t ? function (e, t, n) {
    for (var r = n + 1; r--;) {
      if (e[r] === t) return r;
    }
    return r;
  }(e, t, i) : qc(e, Fc, i, !0);
}
var Cg = Mh(function (e, t, n) {
    return e + (n ? " " : "") + t.toLowerCase();
  }),
  _g = ih("toLowerCase");
function $g(e, t) {
  return e < t;
}
var Og = lm($g),
  Ag = lm(function (e, t) {
    return e <= t;
  });
function Eg(e, t) {
  var n = {};
  return t = cv(t), gv(e, function (e, r, i) {
    ol(n, t(e, r, i), e);
  }), n;
}
function Pg(e, t) {
  var n = {};
  return t = cv(t), gv(e, function (e, r, i) {
    ol(n, r, t(e, r, i));
  }), n;
}
function Mg(e) {
  return nv(Pd(e, 1));
}
function Ig(e, t) {
  return av(e, Pd(t, 1));
}
function Tg(e, t, n) {
  for (var r = -1, i = e.length; ++r < i;) {
    var o = e[r],
      a = t(o);
    if (null != a && (void 0 === s ? a == a && !ju(a) : n(a, s))) var s = a,
      u = o;
  }
  return u;
}
function Ng(e) {
  return e && e.length ? Tg(e, Wu, cm) : void 0;
}
function Rg(e, t) {
  return e && e.length ? Tg(e, cv(t), cm) : void 0;
}
function Dg(e, t) {
  for (var n, r = -1, i = e.length; ++r < i;) {
    var o = t(e[r]);
    void 0 !== o && (n = void 0 === n ? o : n + o);
  }
  return n;
}
function zg(e, t) {
  var n = null == e ? 0 : e.length;
  return n ? Dg(e, t) / n : NaN;
}
function Lg(e) {
  return zg(e, Wu);
}
function Bg(e, t) {
  return zg(e, cv(t));
}
var qg = ml(function (e, t, n) {
    Lv(e, t, n);
  }),
  Fg = hl(function (e, t) {
    return function (n) {
      return qm(n, e, t);
    };
  }),
  Vg = hl(function (e, t) {
    return function (n) {
      return qm(e, n, t);
    };
  });
function Hg(e) {
  return e && e.length ? Tg(e, Wu, $g) : void 0;
}
function Wg(e, t) {
  return e && e.length ? Tg(e, cv(t), $g) : void 0;
}
function Ug(e, t, n) {
  var r = Hl(t),
    i = im(t, r),
    o = !(Ru(n) && "chain" in n && !n.chain),
    a = Uu(e);
  return Bc(i, function (n) {
    var r = t[n];
    e[n] = r, a && (e.prototype[n] = function () {
      var t = this.__chain__;
      if (o || t) {
        var n = e(this.__wrapped__),
          i = n.__actions__ = _c(this.__actions__);
        return i.push({
          func: r,
          args: arguments,
          thisArg: e
        }), n.__chain__ = t, n;
      }
      return r.apply(e, jf([this.value()], arguments));
    });
  }), e;
}
var Jg = Eu(function (e, t) {
  return e * t;
}, 1);
function Kg(e) {
  if ("function" != typeof e) throw new TypeError("Expected a function");
  return function () {
    var t = arguments;
    switch (t.length) {
      case 0:
        return !e.call(this);
      case 1:
        return !e.call(this, t[0]);
      case 2:
        return !e.call(this, t[0], t[1]);
      case 3:
        return !e.call(this, t[0], t[1], t[2]);
    }
    return !e.apply(this, t);
  };
}
var Gg = vu ? vu.iterator : void 0;
function Qg(e) {
  if (!e) return [];
  if (vl(e)) return bm(e) ? rh(e) : _c(e);
  if (Gg && e[Gg]) return function (e) {
    for (var t, n = []; !(t = e.next()).done;) {
      n.push(t.value);
    }
    return n;
  }(e[Gg]());
  var t = md(e);
  return ("[object Map]" == t ? Vd : "[object Set]" == t ? Hd : wm)(e);
}
function Yg() {
  void 0 === this.__values__ && (this.__values__ = Qg(this.value()));
  var e = this.__index__ >= this.__values__.length;
  return {
    done: e,
    value: e ? void 0 : this.__values__[this.__index__++]
  };
}
function Zg(e, t) {
  var n = e.length;
  if (n) return Qc(t += t < 0 ? n : 0, n) ? e[t] : void 0;
}
function Xg(e, t) {
  return e && e.length ? Zg(e, Vu(t)) : void 0;
}
function ey(e) {
  return e = Vu(e), hl(function (t) {
    return Zg(t, e);
  });
}
function ty(e, t) {
  return null == (e = Bm(e, t = yf(t, e))) || delete e[bf(Gv(t))];
}
function ny(e) {
  return Rf(e) ? void 0 : e;
}
var ry = Of(function (e, t) {
  var n = {};
  if (null == e) return n;
  var r = !1;
  t = Cu(t, function (t) {
    return t = yf(t, e), r || (r = t.length > 1), t;
  }), cl(e, ad(e), n), r && (n = Pd(n, 7, ny));
  for (var i = t.length; i--;) {
    ty(n, t[i]);
  }
  return n;
});
function iy(e, t, n, r) {
  if (!Ru(e)) return e;
  for (var i = -1, o = (t = yf(t, e)).length, a = o - 1, s = e; null != s && ++i < o;) {
    var u = bf(t[i]),
      c = n;
    if ("__proto__" === u || "constructor" === u || "prototype" === u) return e;
    if (i != a) {
      var l = s[u];
      void 0 === (c = r ? r(l, u, s) : void 0) && (c = Ru(l) ? l : Qc(t[i + 1]) ? [] : {});
    }
    ul(s, u, c), s = s[u];
  }
  return e;
}
function oy(e, t, n) {
  for (var r = -1, i = t.length, o = {}; ++r < i;) {
    var a = t[r],
      s = kf(e, a);
    n(s, a) && iy(o, yf(a, e), s);
  }
  return o;
}
function ay(e, t) {
  if (null == e) return {};
  var n = Cu(ad(e), function (e) {
    return [e];
  });
  return t = cv(t), oy(e, n, function (e, n) {
    return t(e, n[0]);
  });
}
function sy(e, t) {
  return ay(e, Kg(cv(t)));
}
function uy(e) {
  return Lf(2, e);
}
function cy(e, t) {
  if (e !== t) {
    var n = void 0 !== e,
      r = null === e,
      i = e == e,
      o = ju(e),
      a = void 0 !== t,
      s = null === t,
      u = t == t,
      c = ju(t);
    if (!s && !c && !o && e > t || o && a && u && !s && !c || r && a && u || !n && u || !i) return 1;
    if (!r && !o && !c && e < t || c && n && i && !r && !o || s && n && i || !a && i || !u) return -1;
  }
  return 0;
}
function ly(e, t, n) {
  t = t.length ? Cu(t, function (e) {
    return _u(e) ? function (t) {
      return kf(t, 1 === e.length ? e[0] : e);
    } : e;
  }) : [Wu];
  var r = -1;
  return t = Cu(t, Pl(cv)), function (e, t) {
    var n = e.length;
    for (e.sort(t); n--;) {
      e[n] = e[n].value;
    }
    return e;
  }(qp(e, function (e, n, i) {
    return {
      criteria: Cu(t, function (t) {
        return t(e);
      }),
      index: ++r,
      value: e
    };
  }), function (e, t) {
    return function (e, t, n) {
      for (var r = -1, i = e.criteria, o = t.criteria, a = i.length, s = n.length; ++r < a;) {
        var u = cy(i[r], o[r]);
        if (u) return r >= s ? u : u * ("desc" == n[r] ? -1 : 1);
      }
      return e.index - t.index;
    }(e, t, n);
  });
}
function fy(e, t, n, r) {
  return null == e ? [] : (_u(t) || (t = null == t ? [] : [t]), _u(n = r ? void 0 : n) || (n = null == n ? [] : [n]), ly(e, t, n));
}
function hy(e) {
  return Of(function (t) {
    return t = Cu(t, Pl(cv)), hl(function (n) {
      var r = this;
      return e(t, function (e) {
        return hc(e, r, n);
      });
    });
  });
}
var dy = hy(Cu),
  vy = hl,
  py = Math.min,
  my = vy(function (e, t) {
    var n = (t = 1 == t.length && _u(t[0]) ? Cu(t[0], Pl(cv)) : Cu(_f(t, 1), Pl(cv))).length;
    return hl(function (r) {
      for (var i = -1, o = py(r.length, n); ++i < o;) {
        r[i] = t[i].call(this, r[i]);
      }
      return hc(e, this, r);
    });
  }),
  gy = hy(xp),
  yy = hy(Bd),
  by = Math.floor;
function ky(e, t) {
  var n = "";
  if (!e || t < 1 || t > 9007199254740991) return n;
  do {
    t % 2 && (n += e), (t = by(t / 2)) && (e += e);
  } while (t);
  return n;
}
var wy = sv("length"),
  xy = "[\\ud800-\\udfff]",
  jy = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
  Sy = "\\ud83c[\\udffb-\\udfff]",
  Cy = "[^\\ud800-\\udfff]",
  _y = "(?:\\ud83c[\\udde6-\\uddff]){2}",
  $y = "[\\ud800-\\udbff][\\udc00-\\udfff]",
  Oy = "(?:" + jy + "|" + Sy + ")" + "?",
  Ay = "[\\ufe0e\\ufe0f]?" + Oy + ("(?:\\u200d(?:" + [Cy, _y, $y].join("|") + ")[\\ufe0e\\ufe0f]?" + Oy + ")*"),
  Ey = "(?:" + [Cy + jy + "?", jy, _y, $y, xy].join("|") + ")",
  Py = RegExp(Sy + "(?=" + Sy + ")|" + Ey + Ay, "g");
function My(e) {
  return Uf(e) ? function (e) {
    for (var t = Py.lastIndex = 0; Py.test(e);) {
      ++t;
    }
    return t;
  }(e) : wy(e);
}
var Iy = Math.ceil;
function Ty(e, t) {
  var n = (t = void 0 === t ? " " : Au(t)).length;
  if (n < 2) return n ? ky(t, e) : t;
  var r = ky(t, Iy(e / My(t)));
  return Uf(t) ? Hf(rh(r), 0, e).join("") : r.slice(0, e);
}
var Ny = Math.ceil,
  Ry = Math.floor;
function Dy(e, t, n) {
  e = gf(e);
  var r = (t = Vu(t)) ? My(e) : 0;
  if (!t || r >= t) return e;
  var i = (t - r) / 2;
  return Ty(Ry(i), n) + e + Ty(Ny(i), n);
}
function zy(e, t, n) {
  e = gf(e);
  var r = (t = Vu(t)) ? My(e) : 0;
  return t && r < t ? e + Ty(t - r, n) : e;
}
function Ly(e, t, n) {
  e = gf(e);
  var r = (t = Vu(t)) ? My(e) : 0;
  return t && r < t ? Ty(t - r, n) + e : e;
}
var By = /^\s+/,
  qy = du.parseInt;
function Fy(e, t, n) {
  return n || null == t ? t = 0 : t && (t = +t), qy(gf(e).replace(By, ""), t || 0);
}
var Vy = hl(function (e, t) {
  return rl(e, 32, void 0, t, Xc(t, Kc(Vy)));
});
Vy.placeholder = {};
var Hy = hl(function (e, t) {
  return rl(e, 64, void 0, t, Xc(t, Kc(Hy)));
});
Hy.placeholder = {};
var Wy = wv(function (e, t, n) {
  e[n ? 0 : 1].push(t);
}, function () {
  return [[], []];
});
var Uy = Of(function (e, t) {
  return null == e ? {} : function (e, t) {
    return oy(e, t, function (t, n) {
      return ov(e, n);
    });
  }(e, t);
});
function Jy(e) {
  for (var t, n = this; n instanceof yc;) {
    var r = $c(n);
    r.__index__ = 0, r.__values__ = void 0, t ? i.__wrapped__ = r : t = r;
    var i = r;
    n = n.__wrapped__;
  }
  return i.__wrapped__ = e, t;
}
function Ky(e) {
  return function (t) {
    return null == e ? void 0 : kf(e, t);
  };
}
function Gy(e, t, n, r) {
  for (var i = n - 1, o = e.length; ++i < o;) {
    if (r(e[i], t)) return i;
  }
  return -1;
}
var Qy = Array.prototype.splice;
function Yy(e, t, n, r) {
  var i = r ? Gy : Vc,
    o = -1,
    a = t.length,
    s = e;
  for (e === t && (t = _c(t)), n && (s = Cu(e, Pl(n))); ++o < a;) {
    for (var u = 0, c = t[o], l = n ? n(c) : c; (u = i(s, l, u, r)) > -1;) {
      s !== e && Qy.call(s, u, 1), Qy.call(e, u, 1);
    }
  }
  return e;
}
function Zy(e, t) {
  return e && e.length && t && t.length ? Yy(e, t) : e;
}
var Xy = hl(Zy);
function eb(e, t, n) {
  return e && e.length && t && t.length ? Yy(e, t, cv(n)) : e;
}
function tb(e, t, n) {
  return e && e.length && t && t.length ? Yy(e, t, void 0, n) : e;
}
var nb = Array.prototype.splice;
function rb(e, t) {
  for (var n = e ? t.length : 0, r = n - 1; n--;) {
    var i = t[n];
    if (n == r || i !== o) {
      var o = i;
      Qc(i) ? nb.call(e, i, 1) : ty(e, i);
    }
  }
  return e;
}
var ib = Of(function (e, t) {
    var n = null == e ? 0 : e.length,
      r = xf(e, t);
    return rb(e, Cu(t, function (e) {
      return Qc(e, n) ? +e : e;
    }).sort(cy)), r;
  }),
  ob = Math.floor,
  ab = Math.random;
function sb(e, t) {
  return e + ob(ab() * (t - e + 1));
}
var ub = parseFloat,
  cb = Math.min,
  lb = Math.random;
function fb(e, t, n) {
  if (n && "boolean" != typeof n && pl(e, t, n) && (t = n = void 0), void 0 === n && ("boolean" == typeof t ? (n = t, t = void 0) : "boolean" == typeof e && (n = e, e = void 0)), void 0 === e && void 0 === t ? (e = 0, t = 1) : (e = Fu(e), void 0 === t ? (t = e, e = 0) : t = Fu(t)), e > t) {
    var r = e;
    e = t, t = r;
  }
  if (n || e % 1 || t % 1) {
    var i = lb();
    return cb(e + i * (t - e + ub("1e-" + ((i + "").length - 1))), t);
  }
  return sb(e, t);
}
var hb = Math.ceil,
  db = Math.max;
function vb(e) {
  return function (t, n, r) {
    return r && "number" != typeof r && pl(t, n, r) && (n = r = void 0), t = Fu(t), void 0 === n ? (n = t, t = 0) : n = Fu(n), function (e, t, n, r) {
      for (var i = -1, o = db(hb((t - e) / (n || 1)), 0), a = Array(o); o--;) {
        a[r ? o : ++i] = e, e += n;
      }
      return a;
    }(t, n, r = void 0 === r ? t < n ? 1 : -1 : Fu(r), e);
  };
}
var pb = vb(),
  mb = vb(!0),
  gb = Of(function (e, t) {
    return rl(e, 256, void 0, void 0, void 0, t);
  });
function yb(e, t, n, r, i) {
  return i(e, function (e, i, o) {
    n = r ? (r = !1, e) : t(n, e, i, o);
  }), n;
}
function bb(e, t, n) {
  var r = _u(e) ? sh : yb,
    i = arguments.length < 3;
  return r(e, cv(t), n, i, bv);
}
function kb(e, t, n, r) {
  var i = null == e ? 0 : e.length;
  for (r && i && (n = e[--i]); i--;) {
    n = t(n, e[i], i, e);
  }
  return n;
}
function wb(e, t, n) {
  var r = _u(e) ? kb : yb,
    i = arguments.length < 3;
  return r(e, cv(t), n, i, cp);
}
function xb(e, t) {
  return (_u(e) ? Zh : $p)(e, Kg(cv(t)));
}
function jb(e, t) {
  var n = [];
  if (!e || !e.length) return n;
  var r = -1,
    i = [],
    o = e.length;
  for (t = cv(t); ++r < o;) {
    var a = e[r];
    t(a, r, e) && (n.push(a), i.push(r));
  }
  return rb(e, i), n;
}
function Sb(e, t, n) {
  return t = (n ? pl(e, t, n) : void 0 === t) ? 1 : Vu(t), ky(gf(e), t);
}
function Cb() {
  var e = arguments,
    t = gf(e[0]);
  return e.length < 3 ? t : t.replace(e[1], e[2]);
}
function _b(e, t) {
  if ("function" != typeof e) throw new TypeError("Expected a function");
  return hl(e, t = void 0 === t ? t : Vu(t));
}
function $b(e, t, n) {
  var r = -1,
    i = (t = yf(t, e)).length;
  for (i || (i = 1, e = void 0); ++r < i;) {
    var o = null == e ? void 0 : e[bf(t[r])];
    void 0 === o && (r = i, o = n), e = Uu(o) ? o.call(e) : o;
  }
  return e;
}
var Ob = Array.prototype.reverse;
function Ab(e) {
  return null == e ? e : Ob.call(e);
}
var Eb = Dh("round");
function Pb(e) {
  var t = e.length;
  return t ? e[sb(0, t - 1)] : void 0;
}
function Mb(e) {
  return Pb(wm(e));
}
function Ib(e) {
  return (_u(e) ? Pb : Mb)(e);
}
function Tb(e, t) {
  var n = -1,
    r = e.length,
    i = r - 1;
  for (t = void 0 === t ? r : t; ++n < t;) {
    var o = sb(n, i),
      a = e[o];
    e[o] = e[n], e[n] = a;
  }
  return e.length = t, e;
}
function Nb(e, t) {
  return Tb(_c(e), Vh(t, 0, e.length));
}
function Rb(e, t) {
  var n = wm(e);
  return Tb(n, Vh(t, 0, n.length));
}
function Db(e, t, n) {
  return t = (n ? pl(e, t, n) : void 0 === t) ? 1 : Vu(t), (_u(e) ? Nb : Rb)(e, t);
}
function zb(e, t, n) {
  return null == e ? e : iy(e, t, n);
}
function Lb(e, t, n, r) {
  return r = "function" == typeof r ? r : void 0, null == e ? e : iy(e, t, n, r);
}
function Bb(e) {
  return Tb(_c(e));
}
function qb(e) {
  return Tb(wm(e));
}
function Fb(e) {
  return (_u(e) ? Bb : qb)(e);
}
function Vb(e) {
  if (null == e) return 0;
  if (vl(e)) return bm(e) ? My(e) : e.length;
  var t = md(e);
  return "[object Map]" == t || "[object Set]" == t ? e.size : Vl(e).length;
}
function Hb(e, t, n) {
  var r = null == e ? 0 : e.length;
  return r ? (n && "number" != typeof n && pl(e, t, n) ? (t = 0, n = r) : (t = null == t ? 0 : Vu(t), n = void 0 === n ? r : Vu(n)), Vf(e, t, n)) : [];
}
var Wb = Mh(function (e, t, n) {
  return e + (n ? "_" : "") + t.toLowerCase();
});
function Ub(e, t) {
  var n;
  return bv(e, function (e, r, i) {
    return !(n = t(e, r, i));
  }), !!n;
}
function Jb(e, t, n) {
  var r = _u(e) ? Bd : Ub;
  return n && pl(e, t, n) && (t = void 0), r(e, cv(t));
}
var Kb = hl(function (e, t) {
    if (null == e) return [];
    var n = t.length;
    return n > 1 && pl(e, t[0], t[1]) ? t = [] : n > 2 && pl(t[0], t[1], t[2]) && (t = [t[0]]), ly(e, _f(t, 1), []);
  }),
  Gb = Math.floor,
  Qb = Math.min;
function Yb(e, t, n, r) {
  var i = 0,
    o = null == e ? 0 : e.length;
  if (0 === o) return 0;
  for (var a = (t = n(t)) != t, s = null === t, u = ju(t), c = void 0 === t; i < o;) {
    var l = Gb((i + o) / 2),
      f = n(e[l]),
      h = void 0 !== f,
      d = null === f,
      v = f == f,
      p = ju(f);
    if (a) var m = r || v;else m = c ? v && (r || h) : s ? v && h && (r || !d) : u ? v && h && !d && (r || !p) : !d && !p && (r ? f <= t : f < t);
    m ? i = l + 1 : o = l;
  }
  return Qb(o, 4294967294);
}
function Zb(e, t, n) {
  var r = 0,
    i = null == e ? r : e.length;
  if ("number" == typeof t && t == t && i <= 2147483647) {
    for (; r < i;) {
      var o = r + i >>> 1,
        a = e[o];
      null !== a && !ju(a) && (n ? a <= t : a < t) ? r = o + 1 : i = o;
    }
    return i;
  }
  return Yb(e, t, Wu, n);
}
function Xb(e, t) {
  return Zb(e, t);
}
function ek(e, t, n) {
  return Yb(e, t, cv(n));
}
function tk(e, t) {
  var n = null == e ? 0 : e.length;
  if (n) {
    var r = Zb(e, t);
    if (r < n && al(e[r], t)) return r;
  }
  return -1;
}
function nk(e, t) {
  return Zb(e, t, !0);
}
function rk(e, t, n) {
  return Yb(e, t, cv(n), !0);
}
function ik(e, t) {
  if (null == e ? 0 : e.length) {
    var n = Zb(e, t, !0) - 1;
    if (al(e[n], t)) return n;
  }
  return -1;
}
function ok(e, t) {
  for (var n = -1, r = e.length, i = 0, o = []; ++n < r;) {
    var a = e[n],
      s = t ? t(a) : a;
    if (!n || !al(s, u)) {
      var u = s;
      o[i++] = 0 === a ? 0 : a;
    }
  }
  return o;
}
function ak(e) {
  return e && e.length ? ok(e) : [];
}
function sk(e, t) {
  return e && e.length ? ok(e, cv(t)) : [];
}
function uk(e, t, n) {
  return n && "number" != typeof n && pl(e, t, n) && (t = n = void 0), (n = void 0 === n ? 4294967295 : n >>> 0) ? (e = gf(e)) && ("string" == typeof t || null != t && !hg(t)) && !(t = Au(t)) && Uf(e) ? Hf(rh(e), 0, n) : e.split(t, n) : [];
}
var ck = Math.max;
function lk(e, t) {
  if ("function" != typeof e) throw new TypeError("Expected a function");
  return t = null == t ? 0 : ck(Vu(t), 0), hl(function (n) {
    var r = n[t],
      i = Hf(n, 0, t);
    return r && jf(i, r), hc(e, this, i);
  });
}
var fk = Mh(function (e, t, n) {
  return e + (n ? " " : "") + oh(t);
});
function hk(e, t, n) {
  return e = gf(e), n = null == n ? 0 : Vh(Vu(n), 0, e.length), t = Au(t), e.slice(n, n + t.length) == t;
}
function dk() {
  return {};
}
function vk() {
  return "";
}
function pk() {
  return !0;
}
var mk = Eu(function (e, t) {
  return e - t;
}, 0);
function gk(e) {
  return e && e.length ? Dg(e, Wu) : 0;
}
function yk(e, t) {
  return e && e.length ? Dg(e, cv(t)) : 0;
}
function bk(e) {
  var t = null == e ? 0 : e.length;
  return t ? Vf(e, 1, t) : [];
}
function kk(e, t, n) {
  return e && e.length ? Vf(e, 0, (t = n || void 0 === t ? 1 : Vu(t)) < 0 ? 0 : t) : [];
}
function wk(e, t, n) {
  var r = null == e ? 0 : e.length;
  return r ? Vf(e, (t = r - (t = n || void 0 === t ? 1 : Vu(t))) < 0 ? 0 : t, r) : [];
}
function xk(e, t) {
  return e && e.length ? tp(e, cv(t), !1, !0) : [];
}
function jk(e, t) {
  return e && e.length ? tp(e, cv(t)) : [];
}
function Sk(e, t) {
  return t(e), e;
}
var Ck = Object.prototype,
  _k = Ck.hasOwnProperty;
function $k(e, t, n, r) {
  return void 0 === e || al(e, Ck[n]) && !_k.call(r, n) ? t : e;
}
var Ok = {
  "\\": "\\",
  "'": "'",
  "\n": "n",
  "\r": "r",
  "\u2028": "u2028",
  "\u2029": "u2029"
};
function Ak(e) {
  return "\\" + Ok[e];
}
var Ek = /<%=([\s\S]+?)%>/g,
  Pk = {
    escape: /<%-([\s\S]+?)%>/g,
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: Ek,
    variable: "",
    imports: {
      _: {
        escape: yp
      }
    }
  },
  Mk = /\b__p \+= '';/g,
  Ik = /\b(__p \+=) '' \+/g,
  Tk = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
  Nk = /[()=,{}\[\]\/\s]/,
  Rk = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
  Dk = /($^)/,
  zk = /['\n\r\u2028\u2029\\]/g,
  Lk = Object.prototype.hasOwnProperty;
function Bk(e, t, n) {
  var r = Pk.imports._.templateSettings || Pk;
  n && pl(e, t, n) && (t = void 0), e = gf(e), t = Yl({}, t, r, $k);
  var i,
    o,
    a = Yl({}, t.imports, r.imports, $k),
    s = Hl(a),
    u = km(a, s),
    c = 0,
    l = t.interpolate || Dk,
    f = "__p += '",
    h = RegExp((t.escape || Dk).source + "|" + l.source + "|" + (l === Ek ? Rk : Dk).source + "|" + (t.evaluate || Dk).source + "|$", "g"),
    d = Lk.call(t, "sourceURL") ? "//# sourceURL=" + (t.sourceURL + "").replace(/\s/g, " ") + "\n" : "";
  e.replace(h, function (t, n, r, a, s, u) {
    return r || (r = a), f += e.slice(c, u).replace(zk, Ak), n && (i = !0, f += "' +\n__e(" + n + ") +\n'"), s && (o = !0, f += "';\n" + s + ";\n__p += '"), r && (f += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), c = u + t.length, t;
  }), f += "';\n";
  var v = Lk.call(t, "variable") && t.variable;
  if (v) {
    if (Nk.test(v)) throw new Error("Invalid `variable` option passed into `_.template`");
  } else f = "with (obj) {\n" + f + "\n}\n";
  f = (o ? f.replace(Mk, "") : f).replace(Ik, "$1").replace(Tk, "$1;"), f = "function(" + (v || "obj") + ") {\n" + (v ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (o ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + f + "return __p\n}";
  var p = zf(function () {
    return Function(s, d + "return " + f).apply(void 0, u);
  });
  if (p.source = f, Df(p)) throw p;
  return p;
}
function qk(e, t, n) {
  var r = !0,
    i = !0;
  if ("function" != typeof e) throw new TypeError("Expected a function");
  return Ru(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Ev(e, t, {
    leading: r,
    maxWait: t,
    trailing: i
  });
}
function Fk(e, t) {
  return t(e);
}
var Vk = Math.min;
function Hk(e, t) {
  if ((e = Vu(e)) < 1 || e > 9007199254740991) return [];
  var n = 4294967295,
    r = Vk(e, 4294967295);
  e -= 4294967295;
  for (var i = bl(r, t = ip(t)); ++n < e;) {
    t(n);
  }
  return i;
}
function Wk() {
  return this;
}
function Uk(e, t) {
  var n = e;
  return n instanceof bc && (n = n.value()), sh(t, function (e, t) {
    return t.func.apply(t.thisArg, jf([e], t.args));
  }, n);
}
function Jk() {
  return Uk(this.__wrapped__, this.__actions__);
}
function Kk(e) {
  return gf(e).toLowerCase();
}
function Gk(e) {
  return _u(e) ? Cu(e, bf) : ju(e) ? [e] : _c(mf(gf(e)));
}
function Qk(e) {
  return e ? Vh(Vu(e), -9007199254740991, 9007199254740991) : 0 === e ? e : 0;
}
function Yk(e) {
  return gf(e).toUpperCase();
}
function Zk(e, t, n) {
  var r = _u(e),
    i = r || Al(e) || Dl(e);
  if (t = cv(t), null == n) {
    var o = e && e.constructor;
    n = i ? r ? new o() : [] : Ru(e) && Uu(o) ? lc(Ef(e)) : {};
  }
  return (i ? Bc : gv)(e, function (e, r, i) {
    return t(n, e, r, i);
  }), n;
}
function Xk(e, t) {
  for (var n = e.length; n-- && Vc(t, e[n], 0) > -1;) {
    ;
  }
  return n;
}
function ew(e, t) {
  for (var n = -1, r = e.length; ++n < r && Vc(t, e[n], 0) > -1;) {
    ;
  }
  return n;
}
function tw(e, t, n) {
  if ((e = gf(e)) && (n || void 0 === t)) return Nu(e);
  if (!e || !(t = Au(t))) return e;
  var r = rh(e),
    i = rh(t);
  return Hf(r, ew(r, i), Xk(r, i) + 1).join("");
}
function nw(e, t, n) {
  if ((e = gf(e)) && (n || void 0 === t)) return e.slice(0, Iu(e) + 1);
  if (!e || !(t = Au(t))) return e;
  var r = rh(e);
  return Hf(r, 0, Xk(r, rh(t)) + 1).join("");
}
var rw = /^\s+/;
function iw(e, t, n) {
  if ((e = gf(e)) && (n || void 0 === t)) return e.replace(rw, "");
  if (!e || !(t = Au(t))) return e;
  var r = rh(e);
  return Hf(r, ew(r, rh(t))).join("");
}
var ow = /\w*$/;
function aw(e, t) {
  var n = 30,
    r = "...";
  if (Ru(t)) {
    var i = "separator" in t ? t.separator : i;
    n = "length" in t ? Vu(t.length) : n, r = "omission" in t ? Au(t.omission) : r;
  }
  var o = (e = gf(e)).length;
  if (Uf(e)) {
    var a = rh(e);
    o = a.length;
  }
  if (n >= o) return e;
  var s = n - My(r);
  if (s < 1) return r;
  var u = a ? Hf(a, 0, s).join("") : e.slice(0, s);
  if (void 0 === i) return u + r;
  if (a && (s += u.length - s), hg(i)) {
    if (e.slice(s).search(i)) {
      var c,
        l = u;
      for (i.global || (i = RegExp(i.source, gf(ow.exec(i)) + "g")), i.lastIndex = 0; c = i.exec(l);) {
        var f = c.index;
      }
      u = u.slice(0, void 0 === f ? s : f);
    }
  } else if (e.indexOf(Au(i), s) != s) {
    var h = u.lastIndexOf(i);
    h > -1 && (u = u.slice(0, h));
  }
  return u + r;
}
function sw(e) {
  return il(e, 1);
}
var uw = uh({
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
  }),
  cw = /&(?:amp|lt|gt|quot|#39);/g,
  lw = RegExp(cw.source);
function fw(e) {
  return (e = gf(e)) && lw.test(e) ? e.replace(cw, uw) : e;
}
var hw = cd && 1 / Hd(new cd([, -0]))[1] == 1 / 0 ? function (e) {
  return new cd(e);
} : kc;
function dw(e, t, n) {
  var r = -1,
    i = Hc,
    o = e.length,
    a = !0,
    s = [],
    u = s;
  if (n) a = !1, i = Uv;else if (o >= 200) {
    var c = t ? null : hw(e);
    if (c) return Hd(c);
    a = !1, i = qd, u = new Ld();
  } else u = t ? [] : s;
  e: for (; ++r < o;) {
    var l = e[r],
      f = t ? t(l) : l;
    if (l = n || 0 !== l ? l : 0, a && f == f) {
      for (var h = u.length; h--;) {
        if (u[h] === f) continue e;
      }
      t && u.push(f), s.push(l);
    } else i(u, f, n) || (u !== s && u.push(f), s.push(l));
  }
  return s;
}
var vw = hl(function (e) {
    return dw(_f(e, 1, Rv, !0));
  }),
  pw = hl(function (e) {
    var t = Gv(e);
    return Rv(t) && (t = void 0), dw(_f(e, 1, Rv, !0), cv(t));
  }),
  mw = hl(function (e) {
    var t = Gv(e);
    return t = "function" == typeof t ? t : void 0, dw(_f(e, 1, Rv, !0), void 0, t);
  });
function gw(e) {
  return e && e.length ? dw(e) : [];
}
function yw(e, t) {
  return e && e.length ? dw(e, cv(t)) : [];
}
function bw(e, t) {
  return t = "function" == typeof t ? t : void 0, e && e.length ? dw(e, void 0, t) : [];
}
var kw = 0;
function ww(e) {
  var t = ++kw;
  return gf(e) + t;
}
function xw(e, t) {
  return null == e || ty(e, t);
}
var jw = Math.max;
function Sw(e) {
  if (!e || !e.length) return [];
  var t = 0;
  return e = Zh(e, function (e) {
    if (Rv(e)) return t = jw(e.length, t), !0;
  }), bl(t, function (t) {
    return Cu(e, sv(t));
  });
}
function Cw(e, t) {
  if (!e || !e.length) return [];
  var n = Sw(e);
  return null == t ? n : Cu(n, function (e) {
    return hc(t, void 0, e);
  });
}
function _w(e, t, n, r) {
  return iy(e, t, n(kf(e, t)), r);
}
function $w(e, t, n) {
  return null == e ? e : _w(e, t, ip(n));
}
function Ow(e, t, n, r) {
  return r = "function" == typeof r ? r : void 0, null == e ? e : _w(e, t, ip(n), r);
}
var Aw = Mh(function (e, t, n) {
  return e + (n ? " " : "") + t.toUpperCase();
});
function Ew(e) {
  return null == e ? [] : km(e, Gl(e));
}
var Pw = hl(function (e, t) {
  return Rv(e) ? Jv(e, t) : [];
});
function Mw(e, t) {
  return Vy(ip(t), e);
}
var Iw = Of(function (e) {
  var t = e.length,
    n = t ? e[0] : 0,
    r = this.__wrapped__,
    i = function i(t) {
      return xf(t, e);
    };
  return !(t > 1 || this.__actions__.length) && r instanceof bc && Qc(n) ? ((r = r.slice(n, +n + (t ? 1 : 0))).__actions__.push({
    func: Fk,
    args: [i],
    thisArg: void 0
  }), new Cc(r, this.__chain__).thru(function (e) {
    return t && !e.length && e.push(void 0), e;
  })) : this.thru(i);
});
function Tw() {
  return Lh(this);
}
function Nw() {
  var e = this.__wrapped__;
  if (e instanceof bc) {
    var t = e;
    return this.__actions__.length && (t = new bc(this)), (t = t.reverse()).__actions__.push({
      func: Fk,
      args: [Ab],
      thisArg: void 0
    }), new Cc(t, this.__chain__);
  }
  return this.thru(Ab);
}
function Rw(e, t, n) {
  var r = e.length;
  if (r < 2) return r ? dw(e[0]) : [];
  for (var i = -1, o = Array(r); ++i < r;) {
    for (var a = e[i], s = -1; ++s < r;) {
      s != i && (o[i] = Jv(o[i] || a, e[s], t, n));
    }
  }
  return dw(_f(o, 1), t, n);
}
var Dw = hl(function (e) {
    return Rw(Zh(e, Rv));
  }),
  zw = hl(function (e) {
    var t = Gv(e);
    return Rv(t) && (t = void 0), Rw(Zh(e, Rv), cv(t));
  }),
  Lw = hl(function (e) {
    var t = Gv(e);
    return t = "function" == typeof t ? t : void 0, Rw(Zh(e, Rv), void 0, t);
  }),
  Bw = hl(Sw);
function qw(e, t, n) {
  for (var r = -1, i = e.length, o = t.length, a = {}; ++r < i;) {
    var s = r < o ? t[r] : void 0;
    n(a, e[r], s);
  }
  return a;
}
function Fw(e, t) {
  return qw(e || [], t || [], ul);
}
function Vw(e, t) {
  return qw(e || [], t || [], iy);
}
var Hw = hl(function (e) {
    var t = e.length,
      n = t > 1 ? e[t - 1] : void 0;
    return n = "function" == typeof n ? (e.pop(), n) : void 0, Cw(e, n);
  }),
  Ww = {
    chunk: Fh,
    compact: Dd,
    concat: zd,
    difference: Kv,
    differenceBy: Qv,
    differenceWith: Yv,
    drop: Xv,
    dropRight: ep,
    dropRightWhile: np,
    dropWhile: rp,
    fill: _p,
    findIndex: Pp,
    findLastIndex: Dp,
    first: Bp,
    flatten: $f,
    flattenDeep: Up,
    flattenDepth: Jp,
    fromPairs: rm,
    head: Bp,
    indexOf: Cm,
    initial: _m,
    intersection: Em,
    intersectionBy: Pm,
    intersectionWith: Mm,
    join: bg,
    last: Gv,
    lastIndexOf: Sg,
    nth: Xg,
    pull: Xy,
    pullAll: Zy,
    pullAllBy: eb,
    pullAllWith: tb,
    pullAt: ib,
    remove: jb,
    reverse: Ab,
    slice: Hb,
    sortedIndex: Xb,
    sortedIndexBy: ek,
    sortedIndexOf: tk,
    sortedLastIndex: nk,
    sortedLastIndexBy: rk,
    sortedLastIndexOf: ik,
    sortedUniq: ak,
    sortedUniqBy: sk,
    tail: bk,
    take: kk,
    takeRight: wk,
    takeRightWhile: xk,
    takeWhile: jk,
    union: vw,
    unionBy: pw,
    unionWith: mw,
    uniq: gw,
    uniqBy: yw,
    uniqWith: bw,
    unzip: Sw,
    unzipWith: Cw,
    without: Pw,
    xor: Dw,
    xorBy: zw,
    xorWith: Lw,
    zip: Bw,
    zipObject: Fw,
    zipObjectDeep: Vw,
    zipWith: Hw
  },
  Uw = {
    countBy: jv,
    each: op,
    eachRight: lp,
    every: Sp,
    filter: Op,
    find: Mp,
    findLast: zp,
    flatMap: Vp,
    flatMapDeep: Hp,
    flatMapDepth: Wp,
    forEach: op,
    forEachRight: lp,
    groupBy: um,
    includes: jm,
    invokeMap: Vm,
    keyBy: wg,
    map: Fp,
    orderBy: fy,
    partition: Wy,
    reduce: bb,
    reduceRight: wb,
    reject: xb,
    sample: Ib,
    sampleSize: Db,
    shuffle: Fb,
    size: Vb,
    some: Jb,
    sortBy: Kb
  },
  Jw = $v,
  Kw = {
    after: Hu,
    ary: il,
    before: Lf,
    bind: Bf,
    bindKey: Ff,
    curry: Cv,
    curryRight: _v,
    debounce: Ev,
    defer: Hv,
    delay: Wv,
    flip: Kp,
    memoize: df,
    negate: Kg,
    once: uy,
    overArgs: my,
    partial: Vy,
    partialRight: Hy,
    rearg: gb,
    rest: _b,
    spread: lk,
    throttle: qk,
    unary: sw,
    wrap: Mw
  },
  Gw = {
    castArray: Th,
    clone: Md,
    cloneDeep: Id,
    cloneDeepWith: Td,
    cloneWith: Nd,
    conformsTo: dv,
    eq: al,
    gt: fm,
    gte: hm,
    isArguments: Sl,
    isArray: _u,
    isArrayBuffer: Wm,
    isArrayLike: vl,
    isArrayLikeObject: Rv,
    isBoolean: Um,
    isBuffer: Al,
    isDate: Km,
    isElement: Gm,
    isEmpty: Ym,
    isEqual: Zm,
    isEqualWith: Xm,
    isError: Df,
    isFinite: tg,
    isFunction: Uu,
    isInteger: ng,
    isLength: dl,
    isMap: $d,
    isMatch: rg,
    isMatchWith: ig,
    isNaN: ag,
    isNative: ug,
    isNil: cg,
    isNull: lg,
    isNumber: og,
    isObject: Ru,
    isObjectLike: xu,
    isPlainObject: Rf,
    isRegExp: hg,
    isSafeInteger: dg,
    isSet: Ad,
    isString: bm,
    isSymbol: ju,
    isTypedArray: Dl,
    isUndefined: vg,
    isWeakMap: pg,
    isWeakSet: mg,
    lt: Og,
    lte: Ag,
    toArray: Qg,
    toFinite: Fu,
    toInteger: Vu,
    toLength: Cp,
    toNumber: qu,
    toPlainObject: zv,
    toSafeInteger: Qk,
    toString: gf
  },
  Qw = {
    add: Pu,
    ceil: zh,
    divide: Zv,
    floor: Gp,
    max: Ng,
    maxBy: Rg,
    mean: Lg,
    meanBy: Bg,
    min: Hg,
    minBy: Wg,
    multiply: Jg,
    round: Eb,
    subtract: mk,
    sum: gk,
    sumBy: yk
  },
  Yw = Hh,
  Zw = ym,
  Xw = fb,
  ex = {
    assign: Ul,
    assignIn: Ql,
    assignInWith: Yl,
    assignWith: Zl,
    at: Af,
    create: Sv,
    defaults: Tv,
    defaultsDeep: Fv,
    entries: dp,
    entriesIn: vp,
    extend: Ql,
    extendWith: Yl,
    findKey: Tp,
    findLastKey: Lp,
    forIn: Xp,
    forInRight: em,
    forOwn: tm,
    forOwnRight: nm,
    functions: om,
    functionsIn: am,
    get: wf,
    has: pm,
    hasIn: ov,
    invert: Nm,
    invertBy: Lm,
    invoke: Fm,
    keys: Hl,
    keysIn: Gl,
    mapKeys: Eg,
    mapValues: Pg,
    merge: qg,
    mergeWith: qv,
    omit: ry,
    omitBy: sy,
    pick: Uy,
    pickBy: ay,
    result: $b,
    set: zb,
    setWith: Lb,
    toPairs: dp,
    toPairsIn: vp,
    transform: Zk,
    unset: xw,
    update: $w,
    updateWith: Ow,
    values: wm,
    valuesIn: Ew
  },
  tx = {
    at: Iw,
    chain: Lh,
    commit: Rd,
    lodash: Ac,
    next: Yg,
    plant: Jy,
    reverse: Nw,
    tap: Sk,
    thru: Fk,
    toIterator: Wk,
    toJSON: Jk,
    value: Jk,
    valueOf: Jk,
    wrapperChain: Tw
  },
  nx = {
    camelCase: Ih,
    capitalize: ah,
    deburr: hh,
    endsWith: fp,
    escape: yp,
    escapeRegExp: wp,
    kebabCase: kg,
    lowerCase: Cg,
    lowerFirst: _g,
    pad: Dy,
    padEnd: zy,
    padStart: Ly,
    parseInt: Fy,
    repeat: Sb,
    replace: Cb,
    snakeCase: Wb,
    split: uk,
    startCase: fk,
    startsWith: hk,
    template: Bk,
    templateSettings: Pk,
    toLower: Kk,
    toUpper: Yk,
    trim: tw,
    trimEnd: nw,
    trimStart: iw,
    truncate: aw,
    unescape: fw,
    upperCase: Aw,
    upperFirst: oh,
    words: Eh
  },
  rx = {
    attempt: zf,
    bindAll: qf,
    cond: lv,
    conforms: hv,
    constant: Dc,
    defaultTo: Pv,
    flow: Yp,
    flowRight: Zp,
    identity: Wu,
    iteratee: gg,
    matches: Mg,
    matchesProperty: Ig,
    method: Fg,
    methodOf: Vg,
    mixin: Ug,
    noop: kc,
    nthArg: ey,
    over: dy,
    overEvery: gy,
    overSome: yy,
    property: uv,
    propertyOf: Ky,
    range: pb,
    rangeRight: mb,
    stubArray: Xh,
    stubFalse: Cl,
    stubObject: dk,
    stubString: vk,
    stubTrue: pk,
    times: Hk,
    toPath: Gk,
    uniqueId: ww
  };
var ix = Math.max,
  ox = Math.min;
var ax = Math.min;
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var sx,
  ux = Array.prototype,
  cx = Object.prototype.hasOwnProperty,
  lx = vu ? vu.iterator : void 0,
  fx = Math.max,
  hx = Math.min,
  dx = function (e) {
    return function (t, n, r) {
      if (null == r) {
        var i = Ru(n),
          o = i && Hl(n),
          a = o && o.length && im(n, o);
        (a ? a.length : i) || (r = n, n = t, t = this);
      }
      return e(t, n, r);
    };
  }(Ug);
Ac.after = Kw.after, Ac.ary = Kw.ary, Ac.assign = ex.assign, Ac.assignIn = ex.assignIn, Ac.assignInWith = ex.assignInWith, Ac.assignWith = ex.assignWith, Ac.at = ex.at, Ac.before = Kw.before, Ac.bind = Kw.bind, Ac.bindAll = rx.bindAll, Ac.bindKey = Kw.bindKey, Ac.castArray = Gw.castArray, Ac.chain = tx.chain, Ac.chunk = Ww.chunk, Ac.compact = Ww.compact, Ac.concat = Ww.concat, Ac.cond = rx.cond, Ac.conforms = rx.conforms, Ac.constant = rx.constant, Ac.countBy = Uw.countBy, Ac.create = ex.create, Ac.curry = Kw.curry, Ac.curryRight = Kw.curryRight, Ac.debounce = Kw.debounce, Ac.defaults = ex.defaults, Ac.defaultsDeep = ex.defaultsDeep, Ac.defer = Kw.defer, Ac.delay = Kw.delay, Ac.difference = Ww.difference, Ac.differenceBy = Ww.differenceBy, Ac.differenceWith = Ww.differenceWith, Ac.drop = Ww.drop, Ac.dropRight = Ww.dropRight, Ac.dropRightWhile = Ww.dropRightWhile, Ac.dropWhile = Ww.dropWhile, Ac.fill = Ww.fill, Ac.filter = Uw.filter, Ac.flatMap = Uw.flatMap, Ac.flatMapDeep = Uw.flatMapDeep, Ac.flatMapDepth = Uw.flatMapDepth, Ac.flatten = Ww.flatten, Ac.flattenDeep = Ww.flattenDeep, Ac.flattenDepth = Ww.flattenDepth, Ac.flip = Kw.flip, Ac.flow = rx.flow, Ac.flowRight = rx.flowRight, Ac.fromPairs = Ww.fromPairs, Ac.functions = ex.functions, Ac.functionsIn = ex.functionsIn, Ac.groupBy = Uw.groupBy, Ac.initial = Ww.initial, Ac.intersection = Ww.intersection, Ac.intersectionBy = Ww.intersectionBy, Ac.intersectionWith = Ww.intersectionWith, Ac.invert = ex.invert, Ac.invertBy = ex.invertBy, Ac.invokeMap = Uw.invokeMap, Ac.iteratee = rx.iteratee, Ac.keyBy = Uw.keyBy, Ac.keys = Hl, Ac.keysIn = ex.keysIn, Ac.map = Uw.map, Ac.mapKeys = ex.mapKeys, Ac.mapValues = ex.mapValues, Ac.matches = rx.matches, Ac.matchesProperty = rx.matchesProperty, Ac.memoize = Kw.memoize, Ac.merge = ex.merge, Ac.mergeWith = ex.mergeWith, Ac.method = rx.method, Ac.methodOf = rx.methodOf, Ac.mixin = dx, Ac.negate = Kg, Ac.nthArg = rx.nthArg, Ac.omit = ex.omit, Ac.omitBy = ex.omitBy, Ac.once = Kw.once, Ac.orderBy = Uw.orderBy, Ac.over = rx.over, Ac.overArgs = Kw.overArgs, Ac.overEvery = rx.overEvery, Ac.overSome = rx.overSome, Ac.partial = Kw.partial, Ac.partialRight = Kw.partialRight, Ac.partition = Uw.partition, Ac.pick = ex.pick, Ac.pickBy = ex.pickBy, Ac.property = rx.property, Ac.propertyOf = rx.propertyOf, Ac.pull = Ww.pull, Ac.pullAll = Ww.pullAll, Ac.pullAllBy = Ww.pullAllBy, Ac.pullAllWith = Ww.pullAllWith, Ac.pullAt = Ww.pullAt, Ac.range = rx.range, Ac.rangeRight = rx.rangeRight, Ac.rearg = Kw.rearg, Ac.reject = Uw.reject, Ac.remove = Ww.remove, Ac.rest = Kw.rest, Ac.reverse = Ww.reverse, Ac.sampleSize = Uw.sampleSize, Ac.set = ex.set, Ac.setWith = ex.setWith, Ac.shuffle = Uw.shuffle, Ac.slice = Ww.slice, Ac.sortBy = Uw.sortBy, Ac.sortedUniq = Ww.sortedUniq, Ac.sortedUniqBy = Ww.sortedUniqBy, Ac.split = nx.split, Ac.spread = Kw.spread, Ac.tail = Ww.tail, Ac.take = Ww.take, Ac.takeRight = Ww.takeRight, Ac.takeRightWhile = Ww.takeRightWhile, Ac.takeWhile = Ww.takeWhile, Ac.tap = tx.tap, Ac.throttle = Kw.throttle, Ac.thru = Fk, Ac.toArray = Gw.toArray, Ac.toPairs = ex.toPairs, Ac.toPairsIn = ex.toPairsIn, Ac.toPath = rx.toPath, Ac.toPlainObject = Gw.toPlainObject, Ac.transform = ex.transform, Ac.unary = Kw.unary, Ac.union = Ww.union, Ac.unionBy = Ww.unionBy, Ac.unionWith = Ww.unionWith, Ac.uniq = Ww.uniq, Ac.uniqBy = Ww.uniqBy, Ac.uniqWith = Ww.uniqWith, Ac.unset = ex.unset, Ac.unzip = Ww.unzip, Ac.unzipWith = Ww.unzipWith, Ac.update = ex.update, Ac.updateWith = ex.updateWith, Ac.values = ex.values, Ac.valuesIn = ex.valuesIn, Ac.without = Ww.without, Ac.words = nx.words, Ac.wrap = Kw.wrap, Ac.xor = Ww.xor, Ac.xorBy = Ww.xorBy, Ac.xorWith = Ww.xorWith, Ac.zip = Ww.zip, Ac.zipObject = Ww.zipObject, Ac.zipObjectDeep = Ww.zipObjectDeep, Ac.zipWith = Ww.zipWith, Ac.entries = ex.toPairs, Ac.entriesIn = ex.toPairsIn, Ac.extend = ex.assignIn, Ac.extendWith = ex.assignInWith, dx(Ac, Ac), Ac.add = Qw.add, Ac.attempt = rx.attempt, Ac.camelCase = nx.camelCase, Ac.capitalize = nx.capitalize, Ac.ceil = Qw.ceil, Ac.clamp = Yw, Ac.clone = Gw.clone, Ac.cloneDeep = Gw.cloneDeep, Ac.cloneDeepWith = Gw.cloneDeepWith, Ac.cloneWith = Gw.cloneWith, Ac.conformsTo = Gw.conformsTo, Ac.deburr = nx.deburr, Ac.defaultTo = rx.defaultTo, Ac.divide = Qw.divide, Ac.endsWith = nx.endsWith, Ac.eq = Gw.eq, Ac.escape = nx.escape, Ac.escapeRegExp = nx.escapeRegExp, Ac.every = Uw.every, Ac.find = Uw.find, Ac.findIndex = Ww.findIndex, Ac.findKey = ex.findKey, Ac.findLast = Uw.findLast, Ac.findLastIndex = Ww.findLastIndex, Ac.findLastKey = ex.findLastKey, Ac.floor = Qw.floor, Ac.forEach = Uw.forEach, Ac.forEachRight = Uw.forEachRight, Ac.forIn = ex.forIn, Ac.forInRight = ex.forInRight, Ac.forOwn = ex.forOwn, Ac.forOwnRight = ex.forOwnRight, Ac.get = ex.get, Ac.gt = Gw.gt, Ac.gte = Gw.gte, Ac.has = ex.has, Ac.hasIn = ex.hasIn, Ac.head = Ww.head, Ac.identity = Wu, Ac.includes = Uw.includes, Ac.indexOf = Ww.indexOf, Ac.inRange = Zw, Ac.invoke = ex.invoke, Ac.isArguments = Gw.isArguments, Ac.isArray = _u, Ac.isArrayBuffer = Gw.isArrayBuffer, Ac.isArrayLike = Gw.isArrayLike, Ac.isArrayLikeObject = Gw.isArrayLikeObject, Ac.isBoolean = Gw.isBoolean, Ac.isBuffer = Gw.isBuffer, Ac.isDate = Gw.isDate, Ac.isElement = Gw.isElement, Ac.isEmpty = Gw.isEmpty, Ac.isEqual = Gw.isEqual, Ac.isEqualWith = Gw.isEqualWith, Ac.isError = Gw.isError, Ac.isFinite = Gw.isFinite, Ac.isFunction = Gw.isFunction, Ac.isInteger = Gw.isInteger, Ac.isLength = Gw.isLength, Ac.isMap = Gw.isMap, Ac.isMatch = Gw.isMatch, Ac.isMatchWith = Gw.isMatchWith, Ac.isNaN = Gw.isNaN, Ac.isNative = Gw.isNative, Ac.isNil = Gw.isNil, Ac.isNull = Gw.isNull, Ac.isNumber = Gw.isNumber, Ac.isObject = Ru, Ac.isObjectLike = Gw.isObjectLike, Ac.isPlainObject = Gw.isPlainObject, Ac.isRegExp = Gw.isRegExp, Ac.isSafeInteger = Gw.isSafeInteger, Ac.isSet = Gw.isSet, Ac.isString = Gw.isString, Ac.isSymbol = Gw.isSymbol, Ac.isTypedArray = Gw.isTypedArray, Ac.isUndefined = Gw.isUndefined, Ac.isWeakMap = Gw.isWeakMap, Ac.isWeakSet = Gw.isWeakSet, Ac.join = Ww.join, Ac.kebabCase = nx.kebabCase, Ac.last = Gv, Ac.lastIndexOf = Ww.lastIndexOf, Ac.lowerCase = nx.lowerCase, Ac.lowerFirst = nx.lowerFirst, Ac.lt = Gw.lt, Ac.lte = Gw.lte, Ac.max = Qw.max, Ac.maxBy = Qw.maxBy, Ac.mean = Qw.mean, Ac.meanBy = Qw.meanBy, Ac.min = Qw.min, Ac.minBy = Qw.minBy, Ac.stubArray = rx.stubArray, Ac.stubFalse = rx.stubFalse, Ac.stubObject = rx.stubObject, Ac.stubString = rx.stubString, Ac.stubTrue = rx.stubTrue, Ac.multiply = Qw.multiply, Ac.nth = Ww.nth, Ac.noop = rx.noop, Ac.now = Jw, Ac.pad = nx.pad, Ac.padEnd = nx.padEnd, Ac.padStart = nx.padStart, Ac.parseInt = nx.parseInt, Ac.random = Xw, Ac.reduce = Uw.reduce, Ac.reduceRight = Uw.reduceRight, Ac.repeat = nx.repeat, Ac.replace = nx.replace, Ac.result = ex.result, Ac.round = Qw.round, Ac.sample = Uw.sample, Ac.size = Uw.size, Ac.snakeCase = nx.snakeCase, Ac.some = Uw.some, Ac.sortedIndex = Ww.sortedIndex, Ac.sortedIndexBy = Ww.sortedIndexBy, Ac.sortedIndexOf = Ww.sortedIndexOf, Ac.sortedLastIndex = Ww.sortedLastIndex, Ac.sortedLastIndexBy = Ww.sortedLastIndexBy, Ac.sortedLastIndexOf = Ww.sortedLastIndexOf, Ac.startCase = nx.startCase, Ac.startsWith = nx.startsWith, Ac.subtract = Qw.subtract, Ac.sum = Qw.sum, Ac.sumBy = Qw.sumBy, Ac.template = nx.template, Ac.times = rx.times, Ac.toFinite = Gw.toFinite, Ac.toInteger = Vu, Ac.toLength = Gw.toLength, Ac.toLower = nx.toLower, Ac.toNumber = Gw.toNumber, Ac.toSafeInteger = Gw.toSafeInteger, Ac.toString = Gw.toString, Ac.toUpper = nx.toUpper, Ac.trim = nx.trim, Ac.trimEnd = nx.trimEnd, Ac.trimStart = nx.trimStart, Ac.truncate = nx.truncate, Ac.unescape = nx.unescape, Ac.uniqueId = rx.uniqueId, Ac.upperCase = nx.upperCase, Ac.upperFirst = nx.upperFirst, Ac.each = Uw.forEach, Ac.eachRight = Uw.forEachRight, Ac.first = Ww.head, dx(Ac, (sx = {}, gv(Ac, function (e, t) {
  cx.call(Ac.prototype, t) || (sx[t] = e);
}), sx), {
  chain: !1
}), Ac.VERSION = "4.17.21", (Ac.templateSettings = nx.templateSettings).imports._ = Ac, Bc(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
  Ac[e].placeholder = Ac;
}), Bc(["drop", "take"], function (e, t) {
  bc.prototype[e] = function (n) {
    n = void 0 === n ? 1 : fx(Vu(n), 0);
    var r = this.__filtered__ && !t ? new bc(this) : this.clone();
    return r.__filtered__ ? r.__takeCount__ = hx(n, r.__takeCount__) : r.__views__.push({
      size: hx(n, 4294967295),
      type: e + (r.__dir__ < 0 ? "Right" : "")
    }), r;
  }, bc.prototype[e + "Right"] = function (t) {
    return this.reverse()[e](t).reverse();
  };
}), Bc(["filter", "map", "takeWhile"], function (e, t) {
  var n = t + 1,
    r = 1 == n || 3 == n;
  bc.prototype[e] = function (e) {
    var t = this.clone();
    return t.__iteratees__.push({
      iteratee: cv(e),
      type: n
    }), t.__filtered__ = t.__filtered__ || r, t;
  };
}), Bc(["head", "last"], function (e, t) {
  var n = "take" + (t ? "Right" : "");
  bc.prototype[e] = function () {
    return this[n](1).value()[0];
  };
}), Bc(["initial", "tail"], function (e, t) {
  var n = "drop" + (t ? "" : "Right");
  bc.prototype[e] = function () {
    return this.__filtered__ ? new bc(this) : this[n](1);
  };
}), bc.prototype.compact = function () {
  return this.filter(Wu);
}, bc.prototype.find = function (e) {
  return this.filter(e).head();
}, bc.prototype.findLast = function (e) {
  return this.reverse().find(e);
}, bc.prototype.invokeMap = hl(function (e, t) {
  return "function" == typeof e ? new bc(this) : this.map(function (n) {
    return qm(n, e, t);
  });
}), bc.prototype.reject = function (e) {
  return this.filter(Kg(cv(e)));
}, bc.prototype.slice = function (e, t) {
  e = Vu(e);
  var n = this;
  return n.__filtered__ && (e > 0 || t < 0) ? new bc(n) : (e < 0 ? n = n.takeRight(-e) : e && (n = n.drop(e)), void 0 !== t && (n = (t = Vu(t)) < 0 ? n.dropRight(-t) : n.take(t - e)), n);
}, bc.prototype.takeRightWhile = function (e) {
  return this.reverse().takeWhile(e).reverse();
}, bc.prototype.toArray = function () {
  return this.take(4294967295);
}, gv(bc.prototype, function (e, t) {
  var n = /^(?:filter|find|map|reject)|While$/.test(t),
    r = /^(?:head|last)$/.test(t),
    i = Ac[r ? "take" + ("last" == t ? "Right" : "") : t],
    o = r || /^find/.test(t);
  i && (Ac.prototype[t] = function () {
    var t = this.__wrapped__,
      a = r ? [1] : arguments,
      s = t instanceof bc,
      u = a[0],
      c = s || _u(t),
      l = function l(e) {
        var t = i.apply(Ac, jf([e], a));
        return r && f ? t[0] : t;
      };
    c && n && "function" == typeof u && 1 != u.length && (s = c = !1);
    var f = this.__chain__,
      h = !!this.__actions__.length,
      d = o && !f,
      v = s && !h;
    if (!o && c) {
      t = v ? t : new bc(this);
      var p = e.apply(t, a);
      return p.__actions__.push({
        func: Fk,
        args: [l],
        thisArg: void 0
      }), new Cc(p, f);
    }
    return d && v ? e.apply(this, a) : (p = this.thru(l), d ? r ? p.value()[0] : p.value() : p);
  });
}), Bc(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
  var t = ux[e],
    n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
    r = /^(?:pop|shift)$/.test(e);
  Ac.prototype[e] = function () {
    var e = arguments;
    if (r && !this.__chain__) {
      var i = this.value();
      return t.apply(_u(i) ? i : [], e);
    }
    return this[n](function (n) {
      return t.apply(_u(n) ? n : [], e);
    });
  };
}), gv(bc.prototype, function (e, t) {
  var n = Ac[t];
  if (n) {
    var r = n.name + "";
    cx.call(xc, r) || (xc[r] = []), xc[r].push({
      name: t,
      func: n
    });
  }
}), xc[el(void 0, 2).name] = [{
  name: "wrapper",
  func: void 0
}], bc.prototype.clone = function () {
  var e = new bc(this.__wrapped__);
  return e.__actions__ = _c(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = _c(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = _c(this.__views__), e;
}, bc.prototype.reverse = function () {
  if (this.__filtered__) {
    var e = new bc(this);
    e.__dir__ = -1, e.__filtered__ = !0;
  } else (e = this.clone()).__dir__ *= -1;
  return e;
}, bc.prototype.value = function () {
  var e = this.__wrapped__.value(),
    t = this.__dir__,
    n = _u(e),
    r = t < 0,
    i = n ? e.length : 0,
    o = function (e, t, n) {
      for (var r = -1, i = n.length; ++r < i;) {
        var o = n[r],
          a = o.size;
        switch (o.type) {
          case "drop":
            e += a;
            break;
          case "dropRight":
            t -= a;
            break;
          case "take":
            t = ox(t, e + a);
            break;
          case "takeRight":
            e = ix(e, t - a);
        }
      }
      return {
        start: e,
        end: t
      };
    }(0, i, this.__views__),
    a = o.start,
    s = o.end,
    u = s - a,
    c = r ? s : a - 1,
    l = this.__iteratees__,
    f = l.length,
    h = 0,
    d = ax(u, this.__takeCount__);
  if (!n || !r && i == u && d == u) return Uk(e, this.__actions__);
  var v = [];
  e: for (; u-- && h < d;) {
    for (var p = -1, m = e[c += t]; ++p < f;) {
      var g = l[p],
        y = g.iteratee,
        b = g.type,
        k = y(m);
      if (2 == b) m = k;else if (!k) {
        if (1 == b) continue e;
        break e;
      }
    }
    v[h++] = m;
  }
  return v;
}, Ac.prototype.at = tx.at, Ac.prototype.chain = tx.wrapperChain, Ac.prototype.commit = tx.commit, Ac.prototype.next = tx.next, Ac.prototype.plant = tx.plant, Ac.prototype.reverse = tx.reverse, Ac.prototype.toJSON = Ac.prototype.valueOf = Ac.prototype.value = tx.value, Ac.prototype.first = Ac.prototype.head, lx && (Ac.prototype[lx] = tx.toIterator)
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */;
var vx = Object.freeze({
  __proto__: null,
  add: Pu,
  after: Hu,
  ary: il,
  assign: Ul,
  assignIn: Ql,
  assignInWith: Yl,
  assignWith: Zl,
  at: Af,
  attempt: zf,
  before: Lf,
  bind: Bf,
  bindAll: qf,
  bindKey: Ff,
  camelCase: Ih,
  capitalize: ah,
  castArray: Th,
  ceil: zh,
  chain: Lh,
  chunk: Fh,
  clamp: Hh,
  clone: Md,
  cloneDeep: Id,
  cloneDeepWith: Td,
  cloneWith: Nd,
  commit: Rd,
  compact: Dd,
  concat: zd,
  cond: lv,
  conforms: hv,
  conformsTo: dv,
  constant: Dc,
  countBy: jv,
  create: Sv,
  curry: Cv,
  curryRight: _v,
  debounce: Ev,
  deburr: hh,
  defaultTo: Pv,
  defaults: Tv,
  defaultsDeep: Fv,
  defer: Hv,
  delay: Wv,
  difference: Kv,
  differenceBy: Qv,
  differenceWith: Yv,
  divide: Zv,
  drop: Xv,
  dropRight: ep,
  dropRightWhile: np,
  dropWhile: rp,
  each: op,
  eachRight: lp,
  endsWith: fp,
  entries: dp,
  entriesIn: vp,
  eq: al,
  escape: yp,
  escapeRegExp: wp,
  every: Sp,
  extend: Ql,
  extendWith: Yl,
  fill: _p,
  filter: Op,
  find: Mp,
  findIndex: Pp,
  findKey: Tp,
  findLast: zp,
  findLastIndex: Dp,
  findLastKey: Lp,
  first: Bp,
  flatMap: Vp,
  flatMapDeep: Hp,
  flatMapDepth: Wp,
  flatten: $f,
  flattenDeep: Up,
  flattenDepth: Jp,
  flip: Kp,
  floor: Gp,
  flow: Yp,
  flowRight: Zp,
  forEach: op,
  forEachRight: lp,
  forIn: Xp,
  forInRight: em,
  forOwn: tm,
  forOwnRight: nm,
  fromPairs: rm,
  functions: om,
  functionsIn: am,
  get: wf,
  groupBy: um,
  gt: fm,
  gte: hm,
  has: pm,
  hasIn: ov,
  head: Bp,
  identity: Wu,
  inRange: ym,
  includes: jm,
  indexOf: Cm,
  initial: _m,
  intersection: Em,
  intersectionBy: Pm,
  intersectionWith: Mm,
  invert: Nm,
  invertBy: Lm,
  invoke: Fm,
  invokeMap: Vm,
  isArguments: Sl,
  isArray: _u,
  isArrayBuffer: Wm,
  isArrayLike: vl,
  isArrayLikeObject: Rv,
  isBoolean: Um,
  isBuffer: Al,
  isDate: Km,
  isElement: Gm,
  isEmpty: Ym,
  isEqual: Zm,
  isEqualWith: Xm,
  isError: Df,
  isFinite: tg,
  isFunction: Uu,
  isInteger: ng,
  isLength: dl,
  isMap: $d,
  isMatch: rg,
  isMatchWith: ig,
  isNaN: ag,
  isNative: ug,
  isNil: cg,
  isNull: lg,
  isNumber: og,
  isObject: Ru,
  isObjectLike: xu,
  isPlainObject: Rf,
  isRegExp: hg,
  isSafeInteger: dg,
  isSet: Ad,
  isString: bm,
  isSymbol: ju,
  isTypedArray: Dl,
  isUndefined: vg,
  isWeakMap: pg,
  isWeakSet: mg,
  iteratee: gg,
  join: bg,
  kebabCase: kg,
  keyBy: wg,
  keys: Hl,
  keysIn: Gl,
  last: Gv,
  lastIndexOf: Sg,
  lodash: Ac,
  lowerCase: Cg,
  lowerFirst: _g,
  lt: Og,
  lte: Ag,
  map: Fp,
  mapKeys: Eg,
  mapValues: Pg,
  matches: Mg,
  matchesProperty: Ig,
  max: Ng,
  maxBy: Rg,
  mean: Lg,
  meanBy: Bg,
  memoize: df,
  merge: qg,
  mergeWith: qv,
  method: Fg,
  methodOf: Vg,
  min: Hg,
  minBy: Wg,
  mixin: Ug,
  multiply: Jg,
  negate: Kg,
  next: Yg,
  noop: kc,
  now: $v,
  nth: Xg,
  nthArg: ey,
  omit: ry,
  omitBy: sy,
  once: uy,
  orderBy: fy,
  over: dy,
  overArgs: my,
  overEvery: gy,
  overSome: yy,
  pad: Dy,
  padEnd: zy,
  padStart: Ly,
  parseInt: Fy,
  partial: Vy,
  partialRight: Hy,
  partition: Wy,
  pick: Uy,
  pickBy: ay,
  plant: Jy,
  property: uv,
  propertyOf: Ky,
  pull: Xy,
  pullAll: Zy,
  pullAllBy: eb,
  pullAllWith: tb,
  pullAt: ib,
  random: fb,
  range: pb,
  rangeRight: mb,
  rearg: gb,
  reduce: bb,
  reduceRight: wb,
  reject: xb,
  remove: jb,
  repeat: Sb,
  replace: Cb,
  rest: _b,
  result: $b,
  reverse: Ab,
  round: Eb,
  sample: Ib,
  sampleSize: Db,
  set: zb,
  setWith: Lb,
  shuffle: Fb,
  size: Vb,
  slice: Hb,
  snakeCase: Wb,
  some: Jb,
  sortBy: Kb,
  sortedIndex: Xb,
  sortedIndexBy: ek,
  sortedIndexOf: tk,
  sortedLastIndex: nk,
  sortedLastIndexBy: rk,
  sortedLastIndexOf: ik,
  sortedUniq: ak,
  sortedUniqBy: sk,
  split: uk,
  spread: lk,
  startCase: fk,
  startsWith: hk,
  stubArray: Xh,
  stubFalse: Cl,
  stubObject: dk,
  stubString: vk,
  stubTrue: pk,
  subtract: mk,
  sum: gk,
  sumBy: yk,
  tail: bk,
  take: kk,
  takeRight: wk,
  takeRightWhile: xk,
  takeWhile: jk,
  tap: Sk,
  template: Bk,
  templateSettings: Pk,
  throttle: qk,
  thru: Fk,
  times: Hk,
  toArray: Qg,
  toFinite: Fu,
  toInteger: Vu,
  toIterator: Wk,
  toJSON: Jk,
  toLength: Cp,
  toLower: Kk,
  toNumber: qu,
  toPairs: dp,
  toPairsIn: vp,
  toPath: Gk,
  toPlainObject: zv,
  toSafeInteger: Qk,
  toString: gf,
  toUpper: Yk,
  transform: Zk,
  trim: tw,
  trimEnd: nw,
  trimStart: iw,
  truncate: aw,
  unary: sw,
  unescape: fw,
  union: vw,
  unionBy: pw,
  unionWith: mw,
  uniq: gw,
  uniqBy: yw,
  uniqWith: bw,
  uniqueId: ww,
  unset: xw,
  unzip: Sw,
  unzipWith: Cw,
  update: $w,
  updateWith: Ow,
  upperCase: Aw,
  upperFirst: oh,
  value: Jk,
  valueOf: Jk,
  values: wm,
  valuesIn: Ew,
  without: Pw,
  words: Eh,
  wrap: Mw,
  wrapperAt: Iw,
  wrapperChain: Tw,
  wrapperCommit: Rd,
  wrapperLodash: Ac,
  wrapperNext: Yg,
  wrapperPlant: Jy,
  wrapperReverse: Nw,
  wrapperToIterator: Wk,
  wrapperValue: Jk,
  xor: Dw,
  xorBy: zw,
  xorWith: Lw,
  zip: Bw,
  zipObject: Fw,
  zipObjectDeep: Vw,
  zipWith: Hw,
  default: Ac
});
function px(e, t) {
  for (var n = ks.exports.parseJSONPointer(t), r = 0; r < n.length; r++) {
    var i = n[r];
    if (mx.exec(i)) {
      var o = n.slice(0, r),
        a = ks.exports.getIn(e, o);
      Array.isArray(a) && (n[r] = parseInt(i));
    }
  }
  return n;
}
var mx = /^\d+$/;
function gx(e) {
  for (var t = Kb(e, function (e) {
      return e.start;
    }), n = [t[0]], r = 0; r < t.length; r++) {
    var i = n.length - 1,
      o = n[i],
      a = t[r];
    a.start <= o.end ? n[i] = {
      start: Math.min(o.start, a.start),
      end: Math.max(o.end, a.end)
    } : n.push(a);
  }
  return n;
}
function yx(e) {
  return bx(e) + 100;
}
function bx(e) {
  return 100 * Math.floor(e / 100);
}
function kx(e, t, n, r) {
  var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
    o = Array.isArray(e) ? [] : {};
  return o[Xa] = t && t[Xa] ? t[Xa] : ww(), zs(e) ? (o[ns] = $x(e, t && t[ns]), o[es] = t && !i ? t[es] : r(n), o[es] && Object.keys(e).forEach(function (a) {
    var s = e[a],
      u = t && t[a];
    o[a] = kx(s, u, n.concat(a), r, i);
  })) : Array.isArray(e) ? (o[es] = t && !i ? t[es] : r(n), o[ts] = t && o[es] && t[ts] || us, o[es] && o[ts].forEach(function (a) {
    var s = a.start,
      u = a.end;
    Ks(s, Math.min(e.length, u), function (a) {
      var s = e[a],
        u = t && t[a];
      o[a] = kx(s, u, n.concat(a), r, i);
    });
  })) : t && void 0 !== t[os] ? o[os] = t[os] : Ws(e) && (o[os] = !0), o;
}
function wx(e) {
  if (Array.isArray(e)) {
    var t = [];
    return t[Xa] = ww(), t[es] = !1, t[ts] = us, t;
  }
  if (zs(e)) {
    var n = {};
    return n[Xa] = ww(), n[es] = !1, n[ns] = Object.keys(e), n;
  }
  var r = Mi({}, Xa, ww());
  return Ws(e) && (r[os] = !0), r;
}
function xx(e, t, n) {
  t[ts].forEach(function (t) {
    var r = t.start,
      i = t.end;
    Ks(r, Math.min(e.length, i), n);
  });
}
function jx(e, t) {
  e[ns].forEach(function (e) {
    return t(e);
  });
}
function Sx(e, t, n) {
  for (var r = t, i = function i(t) {
      var i = n.slice(0, t),
        o = i.concat(es);
      if (r = ks.exports.setIn(r, o, !0, !0), Array.isArray(ks.exports.getIn(r, i))) {
        var a = n[t],
          s = i.concat(ts),
          u = ks.exports.getIn(r, s) || us;
        if (!function (e, t) {
          return e.some(function (e) {
            return t >= e.start && t < e.end;
          });
        }(u, a)) {
          var c = bx(a),
            l = {
              start: c,
              end: yx(c)
            },
            f = gx(u.concat(l));
          r = ks.exports.setIn(r, s, f);
        }
      }
      var h = ks.exports.getIn(e, i);
      r = ks.exports.updateIn(r, i, function (e) {
        return kx(h, e, [], function () {
          return !1;
        });
      });
    }, o = 0; o < n.length; o++) {
    i(o);
  }
  return r;
}
function Cx(e, t, n, r) {
  var i = ks.exports.setIn(t, n.concat(es), !0, !0);
  return ks.exports.updateIn(i, n, function (t) {
    return kx(ks.exports.getIn(e, n), t, [], r, !0);
  });
}
function _x(e, t, n) {
  return ks.exports.updateIn(t, n, function (t) {
    return kx(ks.exports.getIn(e, n), t, [], function () {
      return !1;
    }, !0);
  });
}
function $x(e, t) {
  if (!t) return Object.keys(e);
  var n = t.filter(function (t) {
      return void 0 !== e[t];
    }),
    r = new Set(n);
  return Object.keys(e).filter(function (e) {
    return !r.has(e);
  }).forEach(function (e) {
    return n.push(e);
  }), n;
}
function Ox(e, t, n) {
  var r = ks.exports.immutableJSONPatch(e, n),
    i = function (e, t, n) {
      var r = t;
      function i(e, t, n) {
        var r = t;
        return ks.exports.existsIn(e, n) && !ks.exports.existsIn(r, n) && (n.length > 0 && (r = i(e, r, _m(n))), r = ks.exports.setIn(r, n, wx(ks.exports.getIn(e, n)))), r;
      }
      return n.forEach(function (t) {
        var n = "string" == typeof t.from ? px(e, t.from) : null,
          o = "string" == typeof t.path ? px(e, t.path) : null;
        "add" === t.op && (r = i(e, r, _m(o))), "copy" !== t.op && "move" !== t.op || (r = i(e, r, n), r = i(e, r, _m(o))), "remove" !== t.op && "replace" !== t.op && "test" !== t.op || (r = i(e, r, o));
      }), r;
    }(e, t, n);
  return {
    json: r,
    state: ks.exports.immutableJSONPatch(i, n, {
      before: function before(e, t) {
        var n = t.op,
          r = t.path,
          i = t.from,
          o = _m(r),
          a = e,
          s = t;
        if (void 0 !== t.value && (s = Pi(Pi({}, s), {}, {
          value: wx(t.value)
        })), "add" === n || "copy" === n) {
          var u = Ex(e, o);
          if (u) {
            var c = Gv(r);
            u.includes(c) || (a = Mx(a, o, c));
          }
          a = Ax(a, r, 1);
        }
        if ("move" === n) {
          var l = _m(r),
            f = Ex(a, l),
            h = Gv(i),
            d = Gv(r);
          if (Zm(_m(i), _m(r))) f && (a = h !== d ? function (e, t, n, r) {
            return ks.exports.updateIn(e, t.concat([ns]), function (e) {
              var t = e.indexOf(n);
              if (-1 === t) return e;
              var i = e.slice(0);
              return i.splice(t, 1, r), i;
            });
          }(a = Px(a, l, d), l, h, d) : Mx(a = Px(a, l, d), l, d));else {
            var v = _m(i);
            Ex(a, v) && (a = Px(a, v, h)), f && (a = Mx(a, l, d));
          }
          a = Ax(a, i, -1), a = Ax(a, r, 1);
          var p = ks.exports.getIn(e, i);
          s = Pi(Pi({}, s), {}, {
            value: p
          });
        }
        if ("remove" === n) {
          var m = _m(r);
          if (Ex(a, m)) a = Px(a, m, Gv(r));else a = Ax(a, r, -1);
        }
        if ("replace" === n) {
          var g = _m(r),
            y = Ex(a, g);
          if (y) {
            var b = Gv(r);
            y.includes(b) || (a = Mx(a, g, b));
          }
        }
        return {
          json: a,
          operation: s
        };
      },
      after: function after(e, t, n) {
        var r = t.op,
          i = t.path,
          o = e;
        if ("copy" === r && ks.exports.existsIn(o, i.concat([Xa])) && (o = ks.exports.setIn(o, i.concat([Xa]), ww())), "replace" === r) {
          var a = ks.exports.getIn(n, i.concat([os]));
          "boolean" == typeof a && (o = ks.exports.setIn(o, i.concat([os]), a));
        }
        return o;
      }
    })
  };
}
function Ax(e, t, n) {
  var r = _m(t).concat([ts]),
    i = ks.exports.getIn(e, r);
  if (!i) return e;
  var o = parseInt(Gv(t), 10),
    a = i.map(function (e) {
      return {
        start: e.start > o ? e.start + n : e.start,
        end: e.end >= o ? e.end + n : e.end
      };
    });
  return ks.exports.setIn(e, r, a);
}
function Ex(e, t) {
  return ks.exports.getIn(e, t.concat([ns]));
}
function Px(e, t, n) {
  return ks.exports.updateIn(e, t.concat([ns]), function (e) {
    var t = e.indexOf(n);
    if (-1 === t) return e;
    var r = e.slice(0);
    return r.splice(t, 1), r;
  });
}
function Mx(e, t, n) {
  return ks.exports.updateIn(e, t.concat([ns]), function (e) {
    return e.concat(n);
  });
}
function Ix(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
    r = e.indexOf(t);
  return -1 !== r ? n ? e.slice(r) : e.slice(r + 1) : [];
}
function Tx(e, t) {
  var n = [];
  return function e(t, r, i) {
    n.push(i), t && r && !0 === r[es] && (Array.isArray(t) ? xx(t, r, function (n) {
      e(t[n], r[n], i.concat(n));
    }) : jx(r, function (n) {
      e(t[n], r[n], i.concat(n));
    }));
  }(e, t, []), n;
}
var Nx = "inside",
  Rx = "after",
  Dx = "key",
  zx = "value";
function Lx(e, t) {
  var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
    r = [];
  function i(e, t, o) {
    r.push({
      path: o,
      type: zx
    }), e && t && !0 === t[es] && (n && r.push({
      path: o,
      type: Nx
    }), Array.isArray(e) ? xx(e, t, function (a) {
      var s = o.concat(a);
      i(e[a], t[a], s), n && r.push({
        path: s,
        type: Rx
      });
    }) : jx(t, function (a) {
      var s = o.concat(a);
      r.push({
        path: s,
        type: Dx
      }), i(e[a], t[a], s), n && r.push({
        path: s,
        type: Rx
      });
    }));
  }
  return i(e, t, []), r;
}
function Bx(e, t, n) {
  var r = Tx(e, t),
    i = r.map(ks.exports.compileJSONPointer),
    o = ks.exports.compileJSONPointer(n),
    a = i.indexOf(o);
  return -1 !== a && a > 0 ? r[a - 1] : null;
}
function qx(e, t, n) {
  var r = Tx(e, t),
    i = r.map(ks.exports.compileJSONPointer).indexOf(ks.exports.compileJSONPointer(n));
  return -1 !== i && i < r.length - 1 ? r[i + 1] : null;
}
var Fx = "after",
  Vx = "inside",
  Hx = "key",
  Wx = "value",
  Ux = "multi";
function Jx(e) {
  return e.type === Vx ? e.focusPath : _m(e.focusPath);
}
function Kx(e) {
  return e.paths ? Bp(e.paths) : e.focusPath;
}
function Gx(e) {
  return e.paths ? Gv(e.paths) : e.focusPath;
}
function Qx(e, t) {
  return oj(e.focusPath, t) && (e.focusPath.length > t.length || e.type === Vx);
}
function Yx(e, t, n) {
  var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
    i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
    o = !i && n.paths ? Bp(n.paths) : n.focusPath,
    a = Bx(e, t, o);
  if (null === a) return null;
  var s = a,
    u = a;
  if (r) return n.type === Fx || n.type === Vx ? sj(e, t, {
    type: Ux,
    anchorPath: n.anchorPath,
    focusPath: n.anchorPath
  }) : sj(e, t, {
    type: Ux,
    anchorPath: n.anchorPath,
    focusPath: u
  });
  if (n.type === Hx) {
    var c = _m(a),
      l = ks.exports.getIn(e, c);
    return Array.isArray(l) || Ym(a) ? {
      type: Wx,
      anchorPath: s,
      focusPath: u
    } : {
      type: Hx,
      anchorPath: s,
      focusPath: u
    };
  }
  return n.type === Wx ? {
    type: Wx,
    anchorPath: s,
    focusPath: u
  } : n.type === Fx || n.type === Vx ? sj(e, t, {
    type: Ux,
    anchorPath: o,
    focusPath: o
  }) : sj(e, t, {
    type: Ux,
    anchorPath: s,
    focusPath: u
  });
}
function Zx(e, t, n) {
  var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
    i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
    o = !i && n.paths ? Gv(n.paths) : n.focusPath,
    a = qx(e, t, o),
    s = a,
    u = a;
  if (null === a) return null;
  if (r) {
    var c = Ls(ks.exports.getIn(e, o)) ? ks.exports.setIn(t, o.concat(es), !1, !0) : t,
      l = qx(e, c, o);
    return null === l ? null : n.type === Fx ? sj(e, t, {
      type: Ux,
      anchorPath: l,
      focusPath: l
    }) : n.type === Vx ? sj(e, t, {
      type: Ux,
      anchorPath: s,
      focusPath: u
    }) : sj(e, t, {
      type: Ux,
      anchorPath: n.anchorPath,
      focusPath: l
    });
  }
  if (n.type === Hx) {
    var f = _m(a),
      h = ks.exports.getIn(e, f);
    return Array.isArray(h) ? {
      type: Wx,
      anchorPath: s,
      focusPath: u
    } : {
      type: Hx,
      anchorPath: s,
      focusPath: u
    };
  }
  return n.type === Wx ? {
    type: Wx,
    anchorPath: s,
    focusPath: u
  } : n.type === Vx ? sj(e, t, {
    type: Ux,
    anchorPath: s,
    focusPath: u
  }) : sj(e, t, {
    type: Ux,
    anchorPath: a,
    focusPath: a
  });
}
function Xx(e, t, n, r) {
  var i = Lx(e, t, r),
    o = i.findIndex(function (e) {
      return Zm(e.path, n.focusPath) && e.type === n.type;
    });
  return {
    caret: -1 !== o ? i[o] : null,
    previous: -1 !== o && o > 0 ? i[o - 1] : null,
    next: -1 !== o && o < i.length - 1 ? i[o + 1] : null
  };
}
function ej(e, t) {
  for (var n = Tx(e, t), r = 0; r < n.length - 1 && n[r + 1].length > n[r].length;) {
    r++;
  }
  var i = n[r];
  return 0 === i.length || Array.isArray(ks.exports.getIn(e, _m(i))) ? {
    type: Wx,
    anchorPath: i,
    focusPath: i
  } : {
    type: Hx,
    anchorPath: i,
    focusPath: i
  };
}
function tj(e, t, n) {
  if (1 === n.length) {
    var r = Bp(n);
    if ("replace" === r.op || "move" === r.op) {
      var i = px(e, r.path);
      return {
        type: Wx,
        anchorPath: i,
        focusPath: i,
        edit: !1
      };
    }
  }
  if (!Ym(n) && n.every(function (e) {
    return "move" === e.op;
  })) {
    var o = Bp(n),
      a = n.slice(1);
    if (o.from !== o.path && a.every(function (e) {
      return e.from === e.path;
    })) {
      var s = px(e, o.path);
      return {
        type: Hx,
        anchorPath: s,
        focusPath: s,
        edit: !1
      };
    }
  }
  var u = n.filter(function (e) {
    return "test" !== e.op && "remove" !== e.op && ("move" !== e.op || e.from !== e.path) && "string" == typeof e.path;
  }).map(function (t) {
    return px(e, t.path);
  });
  return Ym(u) ? null : {
    type: Ux,
    paths: u,
    anchorPath: Bp(u),
    focusPath: Gv(u),
    pathsMap: nj(u)
  };
}
function nj(e) {
  var t = {};
  return e.forEach(function (e) {
    t[ks.exports.compileJSONPointer(e)] = !0;
  }), t;
}
function rj(e) {
  return e && (e.type === Hx || e.type === Wx || e.type === Ux && 1 === e.paths.length);
}
function ij(e, t) {
  return rj(t) && Ls(ks.exports.getIn(e, t.focusPath)) ? t.focusPath : _m(t.focusPath);
}
function oj(e, t) {
  if (e.length < t.length) return !1;
  for (var n = 0; n < t.length; n++) {
    if (e[n] !== t[n]) return !1;
  }
  return !0;
}
function aj(e) {
  return e && e.edit ? Pi(Pi({}, e), {}, {
    edit: !1
  }) : e;
}
function sj(e, t, n) {
  var r = n.type,
    i = n.anchorPath,
    o = n.focusPath,
    a = n.path,
    s = n.edit,
    u = void 0 !== s && s,
    c = n.next,
    l = void 0 !== c && c,
    f = n.nextInside,
    h = void 0 !== f && f;
  if (r === Hx) {
    var d = {
      type: r,
      anchorPath: a,
      focusPath: a,
      edit: u
    };
    return l && (d = Pi(Pi({}, d), {}, {
      type: Wx
    })), d;
  }
  if (r === Wx) {
    var v = {
      type: Wx,
      anchorPath: a,
      focusPath: a,
      edit: u
    };
    return l && (v = Zx(e, t, v) || v), h && (v = function (e, t, n) {
      var r = n.focusPath,
        i = _m(r),
        o = [Gv(r)],
        a = qx(ks.exports.getIn(e, i), ks.exports.getIn(t, i), o);
      return sj(e, t, a ? {
        type: Wx,
        path: i.concat(a)
      } : {
        type: Fx,
        path: r
      });
    }(e, t, v) || v), v;
  }
  if (r === Fx) return {
    type: r,
    anchorPath: a,
    focusPath: a
  };
  if (r === Vx) return {
    type: r,
    anchorPath: a,
    focusPath: a
  };
  if (r === Ux && a) {
    var p = [a];
    return {
      type: Ux,
      anchorPath: a,
      focusPath: a,
      paths: p,
      pathsMap: nj(p)
    };
  }
  if (i && o) {
    var m = function (e, t, n, r) {
        if (Zm(n, r)) return [n];
        var i = function (e, t) {
          for (var n = 0; n < e.length && n < t.length && e[n] === t[n];) {
            n++;
          }
          return e.slice(0, n);
        }(n, r);
        if (n.length === i.length || r.length === i.length) return [i];
        var o = n[i.length],
          a = r[i.length],
          s = ks.exports.getIn(e, i);
        if (zs(s)) {
          var u = Ex(t, i),
            c = u.indexOf(o),
            l = u.indexOf(a);
          if (-1 !== c && -1 !== l) {
            for (var f = Math.min(c, l), h = Math.max(c, l), d = [], v = f; v <= h; v++) {
              d.push(i.concat(u[v]));
            }
            return d;
          }
        }
        if (Array.isArray(s)) {
          for (var p = Math.min(o, a), m = Math.max(o, a), g = [], y = p; y <= m; y++) {
            g.push(i.concat(y));
          }
          return g;
        }
        throw new Error("Failed to create selection");
      }(e, t, i, o),
      g = oj(o, Gv(m)) || oj(i, Bp(m));
    return {
      type: Ux,
      anchorPath: g ? Bp(m) : Gv(m),
      focusPath: g ? Gv(m) : Bp(m),
      paths: m,
      pathsMap: nj(m)
    };
  }
  throw new TypeError("Unknown type of selection ".concat(JSON.stringify(n)));
}
function uj(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2;
  if (t.type === Hx) return Gv(t.focusPath);
  if (t.type === Wx) {
    var r = ks.exports.getIn(e, t.focusPath);
    return "string" == typeof r ? r : JSON.stringify(r, null, n);
  }
  if (t.type === Ux) {
    if (Ym(t.focusPath)) return JSON.stringify(e, null, n);
    var i = Jx(t),
      o = ks.exports.getIn(e, i);
    if (Array.isArray(o)) {
      if (1 === t.paths.length) {
        var a = ks.exports.getIn(e, Bp(t.paths));
        return JSON.stringify(a, null, n);
      }
      return t.paths.map(function (t) {
        var r = ks.exports.getIn(e, t);
        return "".concat(JSON.stringify(r, null, n), ",");
      }).join("\n");
    }
    return t.paths.map(function (t) {
      var r = Gv(t),
        i = ks.exports.getIn(e, t);
      return "".concat(JSON.stringify(r), ": ").concat(JSON.stringify(i, null, n), ",");
    }).join("\n");
  }
  return null;
}
function cj(e, t) {
  if (!t) return null;
  var n = {};
  return (t.type === Ux ? t.paths : [t.focusPath]).forEach(function (r) {
    var i = r.concat(as);
    if (!ks.exports.existsIn(n, i)) {
      var o = ks.exports.getIn(e, i);
      n = ks.exports.setIn(n, i, Array.isArray(o) ? [] : {}, !0);
    }
    n = ks.exports.setIn(n, i, t, !0);
  }), n;
}
function lj(e) {
  return !!e && (e.type === Hx || e.type === Wx || e.type === Ux && 1 === e.paths.length || void 0);
}
function fj(e, t, n) {
  var r,
    i = null === (r = null == n ? void 0 : n[t]) || void 0 === r ? void 0 : r[as];
  return !(!i || i.type !== Hx || i.edit) && Zm(i.focusPath, e.concat(t));
}
function hj(e) {
  var t = e.escapeControlCharacters,
    n = e.escapeUnicodeCharacters;
  return t ? n ? dj : vj : n ? pj : mj;
}
var dj = {
    escapeValue: function escapeValue(e) {
      return gj(wj(String(e)));
    },
    unescapeValue: function unescapeValue(e) {
      return xj(yj(e));
    }
  },
  vj = {
    escapeValue: function escapeValue(e) {
      return wj(String(e));
    },
    unescapeValue: function unescapeValue(e) {
      return xj(e);
    }
  },
  pj = {
    escapeValue: function escapeValue(e) {
      return gj(String(e));
    },
    unescapeValue: function unescapeValue(e) {
      return yj(e);
    }
  },
  mj = {
    escapeValue: function escapeValue(e) {
      return String(e);
    },
    unescapeValue: function unescapeValue(e) {
      return e;
    }
  };
function gj(e) {
  return e.replace(/[^\x20-\x7F]/g, function (e) {
    return "\b" === e || "\f" === e || "\n" === e || "\r" === e || "\t" === e ? e : "\\u" + ("000" + e.codePointAt(0).toString(16)).slice(-4);
  });
}
function yj(e) {
  return e.replace(/\\u[a-fA-F0-9]{4}/g, function (e) {
    try {
      return JSON.parse('"' + e + '"');
    } catch (t) {
      return e;
    }
  });
}
var bj = {
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "\t": "\\t"
  },
  kj = {
    "\\b": "\b",
    "\\f": "\f",
    "\\n": "\n",
    "\\r": "\r",
    "\\t": "\t"
  };
function wj(e) {
  return e.replace(/[\b\f\n\r\t]/g, function (e) {
    return bj[e] || e;
  });
}
function xj(e) {
  return e.replace(/\\[bfnrt]/g, function (e) {
    return kj[e] || e;
  });
}
function jj(e) {
  return "string" != typeof e ? String(e) : e.endsWith("\n") ? e + "\n" : e;
}
function Sj(e, t) {
  return _j(e, function (e) {
    return e.nodeName.toUpperCase() === t.toUpperCase();
  });
}
function Cj(e, t, n) {
  return _j(e, function (e) {
    return function (e, t, n) {
      return "function" == typeof e.getAttribute && e.getAttribute(t) === n;
    }(e, t, n);
  });
}
function _j(e, t) {
  return !!$j(e, t);
}
function $j(e, t) {
  for (var n = e; n && !t(n);) {
    n = n.parentNode;
  }
  return n || void 0;
}
function Oj(e) {
  if (null != e.firstChild) {
    var t = document.createRange(),
      n = window.getSelection();
    t.setStart(e, 1), t.collapse(!0), n.removeAllRanges(), n.addRange(t);
  } else e.focus();
}
function Aj(e) {
  return e && e.ownerDocument && e.ownerDocument.defaultView;
}
function Ej(e) {
  return _j(Aj(e).document.activeElement, function (t) {
    return t === e;
  });
}
function Pj(e, t) {
  return $j(e, function (e) {
    return e.nodeName === t;
  });
}
function Mj(e) {
  return Cj(e, "data-type", "selectable-key") ? Hx : Cj(e, "data-type", "selectable-value") ? Wx : Cj(e, "data-type", "insert-selection-area-inside") ? Vx : Cj(e, "data-type", "insert-selection-area-after") ? Fx : Ux;
}
function Ij(e) {
  return encodeURIComponent(JSON.stringify(e));
}
function Tj(e) {
  var t,
    n = $j(e, function (e) {
      return e.hasAttribute("data-path");
    });
  return n ? (t = n.getAttribute("data-path"), JSON.parse(decodeURIComponent(t))) : null;
}
function Nj(e) {
  var t = e.allElements,
    n = e.currentElement,
    r = e.direction,
    i = e.hasPrio,
    o = void 0 === i ? function () {
      return !0;
    } : i,
    a = e.margin,
    s = void 0 === a ? 10 : a,
    u = Fp(t.filter(function (e) {
      var t = e.getBoundingClientRect();
      return t.width > 0 && t.height > 0;
    }), l),
    c = l(n);
  function l(e) {
    var t = e.getBoundingClientRect();
    return {
      x: t.left + t.width / 2,
      y: t.top + t.height / 2,
      rect: t,
      element: e
    };
  }
  function f(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
      r = e.x - t.x,
      i = (e.y - t.y) * n;
    return Math.sqrt(r * r + i * i);
  }
  var h = function h(e) {
    return f(e, c);
  };
  if ("Left" === r || "Right" === r) {
    var d = "Left" === r ? u.filter(function (e) {
        return t = c, e.rect.left + s < t.rect.left;
        var t;
      }) : u.filter(function (e) {
        return t = c, e.rect.right > t.rect.right + s;
        var t;
      }),
      v = Wg(d.filter(function (e) {
        return t = e, n = c, Math.abs(t.y - n.y) < s;
        var t, n;
      }), h) || Wg(d, function (e) {
        return f(e, c, 10);
      });
    return null == v ? void 0 : v.element;
  }
  if ("Up" === r || "Down" === r) {
    var p = "Up" === r ? u.filter(function (e) {
        return t = c, e.y + s < t.y;
        var t;
      }) : u.filter(function (e) {
        return t = c, e.y > t.y + s;
        var t;
      }),
      m = Wg(p.filter(function (e) {
        return o(e.element);
      }), h) || Wg(p, h);
    return null == m ? void 0 : m.element;
  }
}
var Rj = "undefined" != typeof navigator && navigator.platform.toUpperCase().indexOf("MAC") >= 0;
function Dj(e) {
  var t = [];
  e.ctrlKey && t.push("Ctrl"), e.metaKey && t.push("Command"), e.altKey && t.push(Rj ? "Option" : "Alt"), e.shiftKey && t.push("Shift");
  var n = function (e) {
    return Lj[e] || "";
  }(e.which);
  return zj[n] || t.push(n), t.join("+");
}
var zj = {
    Ctrl: !0,
    Command: !0,
    Alt: !0,
    Option: !0,
    Shift: !0
  },
  Lj = {
    8: "Backspace",
    9: "Tab",
    13: "Enter",
    16: "Shift",
    17: "Ctrl",
    18: "Alt",
    19: "Pause_Break",
    20: "Caps_Lock",
    27: "Escape",
    33: "Page_Up",
    34: "Page_Down",
    35: "End",
    36: "Home",
    37: "Left",
    38: "Up",
    39: "Right",
    40: "Down",
    45: "Insert",
    46: "Delete",
    48: "0",
    49: "1",
    50: "2",
    51: "3",
    52: "4",
    53: "5",
    54: "6",
    55: "7",
    56: "8",
    57: "9",
    65: "A",
    66: "B",
    67: "C",
    68: "D",
    69: "E",
    70: "F",
    71: "G",
    72: "H",
    73: "I",
    74: "J",
    75: "K",
    76: "L",
    77: "M",
    78: "N",
    79: "O",
    80: "P",
    81: "Q",
    82: "R",
    83: "S",
    84: "T",
    85: "U",
    86: "V",
    87: "W",
    88: "X",
    89: "Y",
    90: "Z",
    91: "Left_Window_Key",
    92: "Right_Window_Key",
    93: "Select_Key",
    96: "Numpad_0",
    97: "Numpad_1",
    98: "Numpad_2",
    99: "Numpad_3",
    100: "Numpad_4",
    101: "Numpad_5",
    102: "Numpad_6",
    103: "Numpad_7",
    104: "Numpad_8",
    105: "Numpad_9",
    106: "Numpad_*",
    107: "Numpad_+",
    109: "Numpad_-",
    110: "Numpad_.",
    111: "Numpad_/",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "Num_Lock",
    145: "Scroll_Lock",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
  },
  Bj = xa.window;
function qj(e) {
  co(e, "svelte-p9zniz", ".jse-absolute-popup.svelte-p9zniz.svelte-p9zniz{position:relative;left:0;top:0;width:0;height:0;z-index:1001}.jse-absolute-popup.svelte-p9zniz .jse-hidden-input.svelte-p9zniz{position:absolute;left:0;top:0;width:0;height:0;padding:0;margin:0;border:none;outline:none;overflow:hidden}.jse-absolute-popup.svelte-p9zniz .jse-absolute-popup-content.svelte-p9zniz{position:absolute}");
}
function Fj(e) {
  var t,
    n,
    r,
    _i2,
    _o4,
    a = [e[1]],
    s = e[0];
  function u(e) {
    for (var t = {}, n = 0; n < a.length; n += 1) {
      t = Fi(t, a[n]);
    }
    return {
      props: t
    };
  }
  return s && (_i2 = new s(u())), {
    c: function c() {
      t = go("div"), n = go("input"), r = ko(), _i2 && Aa(_i2.$$.fragment), So(n, "class", "jse-hidden-input svelte-p9zniz"), So(t, "class", "jse-absolute-popup-content svelte-p9zniz"), So(t, "style", e[7]());
    },
    m: function m(a, s) {
      vo(a, t, s), uo(t, n), e[10](n), uo(t, r), _i2 && Ea(_i2, t, null), _o4 = !0;
    },
    p: function p(e, n) {
      var r = 2 & n ? _a(a, [$a(e[1])]) : {};
      if (s !== (s = e[0])) {
        if (_i2) {
          ma();
          var o = _i2;
          ba(o.$$.fragment, 1, 0, function () {
            Pa(o, 1);
          }), ga();
        }
        s ? (Aa((_i2 = new s(u())).$$.fragment), ya(_i2.$$.fragment, 1), Ea(_i2, t, null)) : _i2 = null;
      } else s && _i2.$set(r);
    },
    i: function i(e) {
      _o4 || (_i2 && ya(_i2.$$.fragment, e), _o4 = !0);
    },
    o: function o(e) {
      _i2 && ba(_i2.$$.fragment, e), _o4 = !1;
    },
    d: function d(n) {
      n && po(t), e[10](null), _i2 && Pa(_i2);
    }
  };
}
function Vj(e) {
  var t,
    n,
    r,
    i,
    o,
    a = e[0] && e[1] && Fj(e),
    s = e[9].default,
    u = Gi(s, e, e[8], null);
  return {
    c: function c() {
      t = go("div"), a && a.c(), n = ko(), u && u.c(), So(t, "class", "jse-absolute-popup svelte-p9zniz");
    },
    m: function m(s, c) {
      vo(s, t, c), a && a.m(t, null), e[11](t), vo(s, n, c), u && u.m(s, c), r = !0, i || (o = [xo(Bj, "mousedown", e[4], !0), xo(Bj, "keydown", e[5], !0), xo(Bj, "wheel", e[6], !0), xo(t, "mousedown", Hj), xo(t, "keydown", e[5])], i = !0);
    },
    p: function p(e, n) {
      var i = xi(n, 1)[0];
      e[0] && e[1] ? a ? (a.p(e, i), 3 & i && ya(a, 1)) : ((a = Fj(e)).c(), ya(a, 1), a.m(t, null)) : a && (ma(), ba(a, 1, 1, function () {
        a = null;
      }), ga()), u && u.p && (!r || 256 & i) && Zi(u, s, e, e[8], r ? Yi(s, e[8], i, null) : Xi(e[8]), null);
    },
    i: function i(e) {
      r || (ya(a), ya(u, e), r = !0);
    },
    o: function o(e) {
      ba(a), ba(u, e), r = !1;
    },
    d: function d(r) {
      r && po(t), a && a.d(), e[11](null), r && po(n), u && u.d(r), i = !1, Wi(o);
    }
  };
}
function Hj(e) {
  e.stopPropagation();
}
function Wj(e, t, n) {
  var r,
    i,
    o = t.$$slots,
    a = void 0 === o ? {} : o,
    s = t.$$scope,
    u = Na("jsoneditor:AbsolutePopup"),
    c = null,
    l = null,
    f = {};
  function h() {
    if (c) {
      var e = f.onClose;
      n(0, c = null), n(1, l = null), f = {}, e && e();
    }
  }
  function d(e) {
    f && f.closeOnOuterClick && !_j(e.target, function (e) {
      return e === r;
    }) && h();
  }
  function v() {
    i && i.focus();
  }
  return Qo("absolute-popup", {
    openAbsolutePopup: function openAbsolutePopup(e, t, r) {
      u("open...", r), n(0, c = e), n(1, l = t || {}), f = r || {}, oa().then(v);
    },
    closeAbsolutePopup: h
  }), e.$$set = function (e) {
    "$$scope" in e && n(8, s = e.$$scope);
  }, [c, l, r, i, function (e) {
    d(e);
  }, function (e) {
    "Escape" === Dj(e) && h();
  }, function (e) {
    d(e);
  }, function () {
    var e = r.getBoundingClientRect(),
      t = function () {
        if (f.anchor) {
          var e = f,
            t = e.anchor,
            n = e.width,
            r = void 0 === n ? 0 : n,
            i = e.height,
            o = void 0 === i ? 0 : i,
            a = e.offsetTop,
            s = void 0 === a ? 0 : a,
            u = e.offsetLeft,
            c = void 0 === u ? 0 : u,
            l = e.position,
            h = t.getBoundingClientRect(),
            d = h.left,
            v = h.top,
            p = h.bottom,
            m = h.right,
            g = "top" === l || v + o > window.innerHeight && v > o,
            y = "left" === l || d + r > window.innerWidth && d > r;
          return {
            left: y ? m - c : d + c,
            top: g ? v - s : p + s,
            positionAbove: g,
            positionLeft: y
          };
        }
        if ("number" == typeof f.left && "number" == typeof f.top) {
          var b = f,
            k = b.left,
            w = b.top,
            x = b.width,
            j = void 0 === x ? 0 : x,
            S = b.height,
            C = void 0 === S ? 0 : S;
          return {
            left: k,
            top: w,
            positionAbove: w + C > window.innerHeight && w > C,
            positionLeft: k + j > window.innerWidth && k > j
          };
        }
        throw new Error('Invalid config: pass either "left" and "top", or pass "anchor"');
      }(),
      n = t.left,
      i = t.top,
      o = t.positionAbove,
      a = t.positionLeft;
    return (o ? "bottom: ".concat(e.top - i, "px;") : "top: ".concat(i - e.top, "px;")) + (a ? "right: ".concat(e.left - n, "px;") : "left: ".concat(n - e.left, "px;"));
  }, s, a, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(3, i = e);
    });
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(2, r = e);
    });
  }];
}
var Uj = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, Wj, Vj, Ki, {}, qj), r;
    }
    return zi(n);
  }(),
  Jj = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [384, 512, [8964], "f107", "M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"]
  },
  Kj = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [256, 512, [8250], "f105", "M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"]
  },
  Gj = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [384, 512, [8595], "f063", "M374.6 310.6l-160 160C208.4 476.9 200.2 480 192 480s-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 370.8V64c0-17.69 14.33-31.1 31.1-31.1S224 46.31 224 64v306.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0S387.1 298.1 374.6 310.6z"]
  },
  Qj = {
    prefix: "fas",
    iconName: "arrow-down-short-wide",
    icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M320 224H416c17.67 0 32-14.33 32-32s-14.33-32-32-32h-95.1c-17.67 0-32 14.33-32 32S302.3 224 320 224zM320 352H480c17.67 0 32-14.33 32-32s-14.33-32-32-32h-159.1c-17.67 0-32 14.33-32 32S302.3 352 320 352zM320 96h32c17.67 0 31.1-14.33 31.1-32s-14.33-32-31.1-32h-32c-17.67 0-32 14.33-32 32S302.3 96 320 96zM544 416h-223.1c-17.67 0-32 14.33-32 32s14.33 32 32 32H544c17.67 0 32-14.33 32-32S561.7 416 544 416zM192.4 330.7L160 366.1V64.03C160 46.33 145.7 32 128 32S96 46.33 96 64.03v302L63.6 330.7c-6.312-6.883-14.94-10.38-23.61-10.38c-7.719 0-15.47 2.781-21.61 8.414c-13.03 11.95-13.9 32.22-1.969 45.27l87.1 96.09c12.12 13.26 35.06 13.26 47.19 0l87.1-96.09c11.94-13.05 11.06-33.31-1.969-45.27C224.6 316.8 204.4 317.7 192.4 330.7z"]
  },
  Yj = {
    prefix: "fas",
    iconName: "arrow-rotate-left",
    icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M480 256c0 123.4-100.5 223.9-223.9 223.9c-48.86 0-95.19-15.58-134.2-44.86c-14.14-10.59-17-30.66-6.391-44.81c10.61-14.09 30.69-16.97 44.8-6.375c27.84 20.91 61 31.94 95.89 31.94C344.3 415.8 416 344.1 416 256s-71.67-159.8-159.8-159.8C205.9 96.22 158.6 120.3 128.6 160H192c17.67 0 32 14.31 32 32S209.7 224 192 224H48c-17.67 0-32-14.31-32-32V48c0-17.69 14.33-32 32-32s32 14.31 32 32v70.23C122.1 64.58 186.1 32.11 256.1 32.11C379.5 32.11 480 132.6 480 256z"]
  },
  Zj = {
    prefix: "fas",
    iconName: "arrow-rotate-right",
    icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M496 48V192c0 17.69-14.31 32-32 32H320c-17.69 0-32-14.31-32-32s14.31-32 32-32h63.39c-29.97-39.7-77.25-63.78-127.6-63.78C167.7 96.22 96 167.9 96 256s71.69 159.8 159.8 159.8c34.88 0 68.03-11.03 95.88-31.94c14.22-10.53 34.22-7.75 44.81 6.375c10.59 14.16 7.75 34.22-6.375 44.81c-39.03 29.28-85.36 44.86-134.2 44.86C132.5 479.9 32 379.4 32 256s100.5-223.9 223.9-223.9c69.15 0 134 32.47 176.1 86.12V48c0-17.69 14.31-32 32-32S496 30.31 496 48z"]
  },
  Xj = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [320, 512, [], "f0d7", "M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z"]
  },
  eS = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [256, 512, [], "f0da", "M118.6 105.4l128 127.1C252.9 239.6 256 247.8 256 255.1s-3.125 16.38-9.375 22.63l-128 127.1c-9.156 9.156-22.91 11.9-34.88 6.943S64 396.9 64 383.1V128c0-12.94 7.781-24.62 19.75-29.58S109.5 96.23 118.6 105.4z"]
  },
  tS = {
    prefix: "fas",
    iconName: "check",
    icon: [448, 512, [10004, 10003], "f00c", "M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"]
  },
  nS = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [448, 512, [], "f078", "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"]
  },
  rS = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [448, 512, [], "f077", "M416 352c-8.188 0-16.38-3.125-22.62-9.375L224 173.3l-169.4 169.4c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25C432.4 348.9 424.2 352 416 352z"]
  },
  iS = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [512, 512, [], "f1ce", "M222.7 32.15C227.7 49.08 218.1 66.9 201.1 71.94C121.8 95.55 64 169.1 64 255.1C64 362 149.1 447.1 256 447.1C362 447.1 448 362 448 255.1C448 169.1 390.2 95.55 310.9 71.94C293.9 66.9 284.3 49.08 289.3 32.15C294.4 15.21 312.2 5.562 329.1 10.6C434.9 42.07 512 139.1 512 255.1C512 397.4 397.4 511.1 256 511.1C114.6 511.1 0 397.4 0 255.1C0 139.1 77.15 42.07 182.9 10.6C199.8 5.562 217.6 15.21 222.7 32.15V32.15z"]
  },
  oS = {
    prefix: "fas",
    iconName: "clone",
    icon: [512, 512, [], "f24d", "M0 224C0 188.7 28.65 160 64 160H128V288C128 341 170.1 384 224 384H352V448C352 483.3 323.3 512 288 512H64C28.65 512 0 483.3 0 448V224zM224 352C188.7 352 160 323.3 160 288V64C160 28.65 188.7 0 224 0H448C483.3 0 512 28.65 512 64V288C512 323.3 483.3 352 448 352H224z"]
  },
  aS = {
    prefix: "fas",
    iconName: "code",
    icon: [640, 512, [], "f121", "M414.8 40.79L286.8 488.8C281.9 505.8 264.2 515.6 247.2 510.8C230.2 505.9 220.4 488.2 225.2 471.2L353.2 23.21C358.1 6.216 375.8-3.624 392.8 1.232C409.8 6.087 419.6 23.8 414.8 40.79H414.8zM518.6 121.4L630.6 233.4C643.1 245.9 643.1 266.1 630.6 278.6L518.6 390.6C506.1 403.1 485.9 403.1 473.4 390.6C460.9 378.1 460.9 357.9 473.4 345.4L562.7 256L473.4 166.6C460.9 154.1 460.9 133.9 473.4 121.4C485.9 108.9 506.1 108.9 518.6 121.4V121.4zM166.6 166.6L77.25 256L166.6 345.4C179.1 357.9 179.1 378.1 166.6 390.6C154.1 403.1 133.9 403.1 121.4 390.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4L121.4 121.4C133.9 108.9 154.1 108.9 166.6 121.4C179.1 133.9 179.1 154.1 166.6 166.6V166.6z"]
  },
  sS = {
    prefix: "fas",
    iconName: "copy",
    icon: [512, 512, [], "f0c5", "M384 96L384 0h-112c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48H464c26.51 0 48-21.49 48-48V128h-95.1C398.4 128 384 113.6 384 96zM416 0v96h96L416 0zM192 352V128h-144c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h192c26.51 0 48-21.49 48-48L288 416h-32C220.7 416 192 387.3 192 352z"]
  },
  uS = {
    prefix: "fas",
    iconName: "crop-simple",
    icon: [512, 512, ["crop-alt"], "f565", "M128 384H352V448H128C92.65 448 64 419.3 64 384V128H32C14.33 128 0 113.7 0 96C0 78.33 14.33 64 32 64H64V32C64 14.33 78.33 0 96 0C113.7 0 128 14.33 128 32V384zM384 128H160V64H384C419.3 64 448 92.65 448 128V384H480C497.7 384 512 398.3 512 416C512 433.7 497.7 448 480 448H448V480C448 497.7 433.7 512 416 512C398.3 512 384 497.7 384 480V128z"]
  },
  cS = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", "M64 360C94.93 360 120 385.1 120 416C120 446.9 94.93 472 64 472C33.07 472 8 446.9 8 416C8 385.1 33.07 360 64 360zM64 200C94.93 200 120 225.1 120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200zM64 152C33.07 152 8 126.9 8 96C8 65.07 33.07 40 64 40C94.93 40 120 65.07 120 96C120 126.9 94.93 152 64 152z"]
  },
  lS = {
    prefix: "fas",
    iconName: "filter",
    icon: [512, 512, [], "f0b0", "M3.853 54.87C10.47 40.9 24.54 32 40 32H472C487.5 32 501.5 40.9 508.1 54.87C514.8 68.84 512.7 85.37 502.1 97.33L320 320.9V448C320 460.1 313.2 471.2 302.3 476.6C291.5 482 278.5 480.9 268.8 473.6L204.8 425.6C196.7 419.6 192 410.1 192 400V320.9L9.042 97.33C-.745 85.37-2.765 68.84 3.854 54.87L3.853 54.87z"]
  },
  fS = {
    prefix: "fas",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6C499.2 175.2 496.4 184.9 489.6 191.2L446.3 230.6C447.4 238.9 448 247.4 448 256C448 264.6 447.4 273.1 446.3 281.4L489.6 320.8C496.4 327.1 499.2 336.8 495.9 345.4C491.5 357.3 486.2 368.8 480.2 379.7L475.5 387.8C468.9 398.8 461.5 409.2 453.4 419.1C447.4 426.2 437.7 428.7 428.9 425.9L373.2 408.1C359.8 418.4 344.1 427 329.2 433.6L316.7 490.7C314.7 499.7 307.7 506.1 298.5 508.5C284.7 510.8 270.5 512 255.1 512C241.5 512 227.3 510.8 213.5 508.5C204.3 506.1 197.3 499.7 195.3 490.7L182.8 433.6C167 427 152.2 418.4 138.8 408.1L83.14 425.9C74.3 428.7 64.55 426.2 58.63 419.1C50.52 409.2 43.12 398.8 36.52 387.8L31.84 379.7C25.77 368.8 20.49 357.3 16.06 345.4C12.82 336.8 15.55 327.1 22.41 320.8L65.67 281.4C64.57 273.1 64 264.6 64 256C64 247.4 64.57 238.9 65.67 230.6L22.41 191.2C15.55 184.9 12.82 175.3 16.06 166.6C20.49 154.7 25.78 143.2 31.84 132.3L36.51 124.2C43.12 113.2 50.52 102.8 58.63 92.95C64.55 85.8 74.3 83.32 83.14 86.14L138.8 103.9C152.2 93.56 167 84.96 182.8 78.43L195.3 21.33C197.3 12.25 204.3 5.04 213.5 3.51C227.3 1.201 241.5 0 256 0C270.5 0 284.7 1.201 298.5 3.51C307.7 5.04 314.7 12.25 316.7 21.33L329.2 78.43C344.1 84.96 359.8 93.56 373.2 103.9L428.9 86.14C437.7 83.32 447.4 85.8 453.4 92.95C461.5 102.8 468.9 113.2 475.5 124.2L480.2 132.3C486.2 143.2 491.5 154.7 495.9 166.6V166.6zM256 336C300.2 336 336 300.2 336 255.1C336 211.8 300.2 175.1 256 175.1C211.8 175.1 176 211.8 176 255.1C176 300.2 211.8 336 256 336z"]
  },
  hS = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", "M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"]
  },
  dS = {
    prefix: "fas",
    iconName: "paste",
    icon: [512, 512, ["file-clipboard"], "f0ea", "M320 96V80C320 53.49 298.5 32 272 32H215.4C204.3 12.89 183.6 0 160 0S115.7 12.89 104.6 32H48C21.49 32 0 53.49 0 80v320C0 426.5 21.49 448 48 448l144 .0013L192 176C192 131.8 227.8 96 272 96H320zM160 88C146.8 88 136 77.25 136 64S146.8 40 160 40S184 50.75 184 64S173.3 88 160 88zM416 128v96h96L416 128zM384 224L384 128h-112C245.5 128 224 149.5 224 176v288c0 26.51 21.49 48 48 48h192c26.51 0 48-21.49 48-48V256h-95.99C398.4 256 384 241.6 384 224z"]
  },
  vS = {
    prefix: "fas",
    iconName: "pen",
    icon: [512, 512, [128394], "f304", "M362.7 19.32C387.7-5.678 428.3-5.678 453.3 19.32L492.7 58.75C517.7 83.74 517.7 124.3 492.7 149.3L444.3 197.7L314.3 67.72L362.7 19.32zM421.7 220.3L188.5 453.4C178.1 463.8 165.2 471.5 151.1 475.6L30.77 511C22.35 513.5 13.24 511.2 7.03 504.1C.8198 498.8-1.502 489.7 .976 481.2L36.37 360.9C40.53 346.8 48.16 333.9 58.57 323.5L291.7 90.34L421.7 220.3z"]
  },
  pS = {
    prefix: "fas",
    iconName: "scissors",
    icon: [512, 512, [9986, 9988, 9984, "cut"], "f0c4", "M396.8 51.2C425.1 22.92 470.9 22.92 499.2 51.2C506.3 58.27 506.3 69.73 499.2 76.8L216.5 359.5C221.3 372.1 224 385.7 224 400C224 461.9 173.9 512 112 512C50.14 512 0 461.9 0 400C0 338.1 50.14 287.1 112 287.1C126.3 287.1 139.9 290.7 152.5 295.5L191.1 255.1L152.5 216.5C139.9 221.3 126.3 224 112 224C50.14 224 0 173.9 0 112C0 50.14 50.14 0 112 0C173.9 0 224 50.14 224 112C224 126.3 221.3 139.9 216.5 152.5L255.1 191.1L396.8 51.2zM160 111.1C160 85.49 138.5 63.1 112 63.1C85.49 63.1 64 85.49 64 111.1C64 138.5 85.49 159.1 112 159.1C138.5 159.1 160 138.5 160 111.1zM112 448C138.5 448 160 426.5 160 400C160 373.5 138.5 352 112 352C85.49 352 64 373.5 64 400C64 426.5 85.49 448 112 448zM278.6 342.6L342.6 278.6L499.2 435.2C506.3 442.3 506.3 453.7 499.2 460.8C470.9 489.1 425.1 489.1 396.8 460.8L278.6 342.6z"]
  },
  mS = {
    prefix: "fas",
    iconName: "square-caret-down",
    icon: [448, 512, ["caret-square-down"], "f150", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64V96C448 60.65 419.3 32 384 32zM345.6 232.3l-104 112C237 349.2 230.7 352 224 352s-13.03-2.781-17.59-7.656l-104-112c-6.5-7-8.219-17.19-4.407-25.94C101.8 197.7 110.5 192 120 192h208c9.531 0 18.19 5.656 21.1 14.41C353.8 215.2 352.1 225.3 345.6 232.3z"]
  },
  gS = {
    prefix: "fas",
    iconName: "square-caret-up",
    icon: [448, 512, ["caret-square-up"], "f151", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64V96C448 60.65 419.3 32 384 32zM349.1 305.6C346.2 314.3 337.5 320 328 320h-208c-9.531 0-18.19-5.656-22-14.41C94.19 296.8 95.91 286.7 102.4 279.7l104-112c9.125-9.75 26.06-9.75 35.19 0l104 112C352.1 286.7 353.8 296.8 349.1 305.6z"]
  },
  yS = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"]
  },
  bS = {
    prefix: "fas",
    iconName: "wrench",
    icon: [512, 512, [128295], "f0ad", "M507.6 122.8c-2.904-12.09-18.25-16.13-27.04-7.338l-76.55 76.56l-83.1-.0002l0-83.1l76.55-76.56c8.791-8.789 4.75-24.14-7.336-27.04c-23.69-5.693-49.34-6.111-75.92 .2484c-61.45 14.7-109.4 66.9-119.2 129.3C189.8 160.8 192.3 186.7 200.1 210.1l-178.1 178.1c-28.12 28.12-28.12 73.69 0 101.8C35.16 504.1 53.56 512 71.1 512s36.84-7.031 50.91-21.09l178.1-178.1c23.46 7.736 49.31 10.24 76.17 6.004c62.41-9.84 114.6-57.8 129.3-119.2C513.7 172.1 513.3 146.5 507.6 122.8zM80 456c-13.25 0-24-10.75-24-24c0-13.26 10.75-24 24-24s24 10.74 24 24C104 445.3 93.25 456 80 456z"]
  },
  kS = {
    prefix: "fas",
    iconName: "xmark",
    icon: [320, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"]
  };
/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function wS(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e3;
  if (e < .9 * t) return e.toFixed() + " B";
  var n = e / t;
  if (n < .9 * t) return n.toFixed(1) + " KB";
  var r = n / t;
  if (r < .9 * t) return r.toFixed(1) + " MB";
  var i = r / t;
  if (i < .9 * t) return i.toFixed(1) + " GB";
  var o = i / t;
  return o.toFixed(1) + " TB";
}
var xS = Na("jsoneditor:FocusTracker");
function jS(e) {
  var t,
    n = e.onMount,
    r = e.onDestroy,
    i = e.getWindow,
    o = e.hasFocus,
    a = e.onFocus,
    s = e.onBlur,
    u = !1;
  function c() {
    var e = o();
    e && (clearTimeout(t), u || (xS("focus"), a(), u = e));
  }
  function l() {
    u && (clearTimeout(t), t = setTimeout(function () {
      xS("blur"), u = !1, s();
    }));
  }
  n(function () {
    xS("mount FocusTracker");
    var e = i();
    e && (e.addEventListener("focusin", c, !0), e.addEventListener("focusout", l, !0));
  }), r(function () {
    xS("destroy FocusTracker");
    var e = i();
    e && (e.removeEventListener("focusin", c, !0), e.removeEventListener("focusout", l, !0));
  });
}
function SS(e) {
  for (var t, n, r = [{
      id: n = "path-" + e[0]
    }, e[1]], i = {}, o = 0; o < r.length; o += 1) {
    i = Fi(i, r[o]);
  }
  return {
    c: function c() {
      _o(t = yo("path"), i);
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: function p(e, o) {
      var a = xi(o, 1)[0];
      _o(t, i = _a(r, [1 & a && n !== (n = "path-" + e[0]) && {
        id: n
      }, 2 & a && e[1]]));
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function CS(e, t, n) {
  var r = t.id,
    i = t.data,
    o = void 0 === i ? {} : i;
  return e.$$set = function (e) {
    "id" in e && n(0, r = e.id), "data" in e && n(1, o = e.data);
  }, [r, o];
}
var _S = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, CS, SS, Ji, {
      id: 0,
      data: 1
    }), r;
  }
  return zi(n);
}();
function $S(e) {
  for (var t, n, r = [{
      id: n = "polygon-" + e[0]
    }, e[1]], i = {}, o = 0; o < r.length; o += 1) {
    i = Fi(i, r[o]);
  }
  return {
    c: function c() {
      _o(t = yo("polygon"), i);
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: function p(e, o) {
      var a = xi(o, 1)[0];
      _o(t, i = _a(r, [1 & a && n !== (n = "polygon-" + e[0]) && {
        id: n
      }, 2 & a && e[1]]));
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function OS(e, t, n) {
  var r = t.id,
    i = t.data,
    o = void 0 === i ? {} : i;
  return e.$$set = function (e) {
    "id" in e && n(0, r = e.id), "data" in e && n(1, o = e.data);
  }, [r, o];
}
var AS = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, OS, $S, Ji, {
      id: 0,
      data: 1
    }), r;
  }
  return zi(n);
}();
function ES(e) {
  var t;
  return {
    c: function c() {
      t = yo("g");
    },
    m: function m(n, r) {
      vo(n, t, r), t.innerHTML = e[0];
    },
    p: function p(e, n) {
      1 & xi(n, 1)[0] && (t.innerHTML = e[0]);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function PS(e, t, n) {
  var r,
    i = 870711;
  var o = t.data;
  function a(e) {
    if (!e || !e.raw) return null;
    var t = e.raw,
      n = {};
    return t = (t = t.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (e, t) {
      var r = "fa-".concat((i += 1).toString(16));
      return n[t] = r, ' id="'.concat(r, '"');
    })).replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (e, t, r, i) {
      var o = t || i;
      return o && n[o] ? "#".concat(n[o]) : e;
    });
  }
  return e.$$set = function (e) {
    "data" in e && n(1, o = e.data);
  }, e.$$.update = function () {
    2 & e.$$.dirty && n(0, r = a(o));
  }, [r, o];
}
var MS = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, PS, ES, Ji, {
      data: 1
    }), r;
  }
  return zi(n);
}();
function IS(e) {
  co(e, "svelte-1dof0an", ".fa-icon.svelte-1dof0an{display:inline-block;fill:currentColor}.fa-flip-horizontal.svelte-1dof0an{transform:scale(-1, 1)}.fa-flip-vertical.svelte-1dof0an{transform:scale(1, -1)}.fa-spin.svelte-1dof0an{animation:svelte-1dof0an-fa-spin 1s 0s infinite linear}.fa-inverse.svelte-1dof0an{color:#fff}.fa-pulse.svelte-1dof0an{animation:svelte-1dof0an-fa-spin 1s infinite steps(8)}@keyframes svelte-1dof0an-fa-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}");
}
function TS(e) {
  var t,
    n,
    r,
    _i3,
    o = e[13].default,
    a = Gi(o, e, e[12], null);
  return {
    c: function c() {
      t = yo("svg"), a && a.c(), So(t, "version", "1.1"), So(t, "class", n = "fa-icon " + e[0] + " svelte-1dof0an"), So(t, "x", e[8]), So(t, "y", e[9]), So(t, "width", e[1]), So(t, "height", e[2]), So(t, "aria-label", e[11]), So(t, "role", r = e[11] ? "img" : "presentation"), So(t, "viewBox", e[3]), So(t, "style", e[10]), To(t, "fa-spin", e[4]), To(t, "fa-pulse", e[6]), To(t, "fa-inverse", e[5]), To(t, "fa-flip-horizontal", "horizontal" === e[7]), To(t, "fa-flip-vertical", "vertical" === e[7]);
    },
    m: function m(e, n) {
      vo(e, t, n), a && a.m(t, null), _i3 = !0;
    },
    p: function p(e, s) {
      var u = xi(s, 1)[0];
      a && a.p && (!_i3 || 4096 & u) && Zi(a, o, e, e[12], _i3 ? Yi(o, e[12], u, null) : Xi(e[12]), null), (!_i3 || 1 & u && n !== (n = "fa-icon " + e[0] + " svelte-1dof0an")) && So(t, "class", n), (!_i3 || 256 & u) && So(t, "x", e[8]), (!_i3 || 512 & u) && So(t, "y", e[9]), (!_i3 || 2 & u) && So(t, "width", e[1]), (!_i3 || 4 & u) && So(t, "height", e[2]), (!_i3 || 2048 & u) && So(t, "aria-label", e[11]), (!_i3 || 2048 & u && r !== (r = e[11] ? "img" : "presentation")) && So(t, "role", r), (!_i3 || 8 & u) && So(t, "viewBox", e[3]), (!_i3 || 1024 & u) && So(t, "style", e[10]), 17 & u && To(t, "fa-spin", e[4]), 65 & u && To(t, "fa-pulse", e[6]), 33 & u && To(t, "fa-inverse", e[5]), 129 & u && To(t, "fa-flip-horizontal", "horizontal" === e[7]), 129 & u && To(t, "fa-flip-vertical", "vertical" === e[7]);
    },
    i: function i(e) {
      _i3 || (ya(a, e), _i3 = !0);
    },
    o: function o(e) {
      ba(a, e), _i3 = !1;
    },
    d: function d(e) {
      e && po(t), a && a.d(e);
    }
  };
}
function NS(e, t, n) {
  var r = t.$$slots,
    i = void 0 === r ? {} : r,
    o = t.$$scope,
    a = t.class,
    s = t.width,
    u = t.height,
    c = t.box,
    l = t.spin,
    f = void 0 !== l && l,
    h = t.inverse,
    d = void 0 !== h && h,
    v = t.pulse,
    p = void 0 !== v && v,
    m = t.flip,
    g = void 0 === m ? null : m,
    y = t.x,
    b = void 0 === y ? void 0 : y,
    k = t.y,
    w = void 0 === k ? void 0 : k,
    x = t.style,
    j = void 0 === x ? void 0 : x,
    S = t.label,
    C = void 0 === S ? void 0 : S;
  return e.$$set = function (e) {
    "class" in e && n(0, a = e.class), "width" in e && n(1, s = e.width), "height" in e && n(2, u = e.height), "box" in e && n(3, c = e.box), "spin" in e && n(4, f = e.spin), "inverse" in e && n(5, d = e.inverse), "pulse" in e && n(6, p = e.pulse), "flip" in e && n(7, g = e.flip), "x" in e && n(8, b = e.x), "y" in e && n(9, w = e.y), "style" in e && n(10, j = e.style), "label" in e && n(11, C = e.label), "$$scope" in e && n(12, o = e.$$scope);
  }, [a, s, u, c, f, d, p, g, b, w, j, C, o, i];
}
var RS = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, NS, TS, Ji, {
      class: 0,
      width: 1,
      height: 2,
      box: 3,
      spin: 4,
      inverse: 5,
      pulse: 6,
      flip: 7,
      x: 8,
      y: 9,
      style: 10,
      label: 11
    }, IS), r;
  }
  return zi(n);
}();
function DS(e, t, n) {
  var r = e.slice();
  return r[24] = t[n], r[26] = n, r;
}
function zS(e, t, n) {
  var r = e.slice();
  return r[27] = t[n], r[26] = n, r;
}
function LS(e) {
  var t,
    n,
    r,
    _i4,
    _o5 = e[6].paths && BS(e),
    a = e[6].polygons && FS(e),
    s = e[6].raw && HS(e);
  return {
    c: function c() {
      _o5 && _o5.c(), t = ko(), a && a.c(), n = ko(), s && s.c(), r = wo();
    },
    m: function m(e, u) {
      _o5 && _o5.m(e, u), vo(e, t, u), a && a.m(e, u), vo(e, n, u), s && s.m(e, u), vo(e, r, u), _i4 = !0;
    },
    p: function p(e, i) {
      e[6].paths ? _o5 ? (_o5.p(e, i), 64 & i && ya(_o5, 1)) : ((_o5 = BS(e)).c(), ya(_o5, 1), _o5.m(t.parentNode, t)) : _o5 && (ma(), ba(_o5, 1, 1, function () {
        _o5 = null;
      }), ga()), e[6].polygons ? a ? (a.p(e, i), 64 & i && ya(a, 1)) : ((a = FS(e)).c(), ya(a, 1), a.m(n.parentNode, n)) : a && (ma(), ba(a, 1, 1, function () {
        a = null;
      }), ga()), e[6].raw ? s ? (s.p(e, i), 64 & i && ya(s, 1)) : ((s = HS(e)).c(), ya(s, 1), s.m(r.parentNode, r)) : s && (ma(), ba(s, 1, 1, function () {
        s = null;
      }), ga());
    },
    i: function i(e) {
      _i4 || (ya(_o5), ya(a), ya(s), _i4 = !0);
    },
    o: function o(e) {
      ba(_o5), ba(a), ba(s), _i4 = !1;
    },
    d: function d(e) {
      _o5 && _o5.d(e), e && po(t), a && a.d(e), e && po(n), s && s.d(e), e && po(r);
    }
  };
}
function BS(e) {
  for (var t, n, r = e[6].paths, _i5 = [], o = 0; o < r.length; o += 1) {
    _i5[o] = qS(zS(e, r, o));
  }
  var a = function a(e) {
    return ba(_i5[e], 1, 1, function () {
      _i5[e] = null;
    });
  };
  return {
    c: function c() {
      for (var e = 0; e < _i5.length; e += 1) {
        _i5[e].c();
      }
      t = wo();
    },
    m: function m(e, r) {
      for (var o = 0; o < _i5.length; o += 1) {
        _i5[o].m(e, r);
      }
      vo(e, t, r), n = !0;
    },
    p: function p(e, n) {
      if (64 & n) {
        var o;
        for (r = e[6].paths, o = 0; o < r.length; o += 1) {
          var s = zS(e, r, o);
          _i5[o] ? (_i5[o].p(s, n), ya(_i5[o], 1)) : (_i5[o] = qS(s), _i5[o].c(), ya(_i5[o], 1), _i5[o].m(t.parentNode, t));
        }
        for (ma(), o = r.length; o < _i5.length; o += 1) {
          a(o);
        }
        ga();
      }
    },
    i: function i(e) {
      if (!n) {
        for (var t = 0; t < r.length; t += 1) {
          ya(_i5[t]);
        }
        n = !0;
      }
    },
    o: function o(e) {
      _i5 = _i5.filter(Boolean);
      for (var t = 0; t < _i5.length; t += 1) {
        ba(_i5[t]);
      }
      n = !1;
    },
    d: function d(e) {
      mo(_i5, e), e && po(t);
    }
  };
}
function qS(e) {
  var t, n;
  return t = new _S({
    props: {
      id: e[26],
      data: e[27]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      64 & n && (r.data = e[27]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function FS(e) {
  for (var t, n, r = e[6].polygons, _i6 = [], o = 0; o < r.length; o += 1) {
    _i6[o] = VS(DS(e, r, o));
  }
  var a = function a(e) {
    return ba(_i6[e], 1, 1, function () {
      _i6[e] = null;
    });
  };
  return {
    c: function c() {
      for (var e = 0; e < _i6.length; e += 1) {
        _i6[e].c();
      }
      t = wo();
    },
    m: function m(e, r) {
      for (var o = 0; o < _i6.length; o += 1) {
        _i6[o].m(e, r);
      }
      vo(e, t, r), n = !0;
    },
    p: function p(e, n) {
      if (64 & n) {
        var o;
        for (r = e[6].polygons, o = 0; o < r.length; o += 1) {
          var s = DS(e, r, o);
          _i6[o] ? (_i6[o].p(s, n), ya(_i6[o], 1)) : (_i6[o] = VS(s), _i6[o].c(), ya(_i6[o], 1), _i6[o].m(t.parentNode, t));
        }
        for (ma(), o = r.length; o < _i6.length; o += 1) {
          a(o);
        }
        ga();
      }
    },
    i: function i(e) {
      if (!n) {
        for (var t = 0; t < r.length; t += 1) {
          ya(_i6[t]);
        }
        n = !0;
      }
    },
    o: function o(e) {
      _i6 = _i6.filter(Boolean);
      for (var t = 0; t < _i6.length; t += 1) {
        ba(_i6[t]);
      }
      n = !1;
    },
    d: function d(e) {
      mo(_i6, e), e && po(t);
    }
  };
}
function VS(e) {
  var t, n;
  return t = new AS({
    props: {
      id: e[26],
      data: e[24]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      64 & n && (r.data = e[24]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function HS(e) {
  var t, n, r;
  function i(t) {
    e[15](t);
  }
  var o = {};
  return void 0 !== e[6] && (o.data = e[6]), t = new MS({
    props: o
  }), Xo.push(function () {
    return Oa(t, "data", i);
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, n) {
      Ea(t, e, n), r = !0;
    },
    p: function p(e, r) {
      var i = {};
      !n && 64 & r && (n = !0, i.data = e[6], sa(function () {
        return n = !1;
      })), t.$set(i);
    },
    i: function i(e) {
      r || (ya(t.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function WS(e) {
  var t,
    n = e[14].default,
    r = Gi(n, e, e[16], null),
    _i7 = r || function (e) {
      var t,
        n,
        r = e[6] && LS(e);
      return {
        c: function c() {
          r && r.c(), t = wo();
        },
        m: function m(e, i) {
          r && r.m(e, i), vo(e, t, i), n = !0;
        },
        p: function p(e, n) {
          e[6] ? r ? (r.p(e, n), 64 & n && ya(r, 1)) : ((r = LS(e)).c(), ya(r, 1), r.m(t.parentNode, t)) : r && (ma(), ba(r, 1, 1, function () {
            r = null;
          }), ga());
        },
        i: function i(e) {
          n || (ya(r), n = !0);
        },
        o: function o(e) {
          ba(r), n = !1;
        },
        d: function d(e) {
          r && r.d(e), e && po(t);
        }
      };
    }(e);
  return {
    c: function c() {
      _i7 && _i7.c();
    },
    m: function m(e, n) {
      _i7 && _i7.m(e, n), t = !0;
    },
    p: function p(e, o) {
      r ? r.p && (!t || 65536 & o) && Zi(r, n, e, e[16], t ? Yi(n, e[16], o, null) : Xi(e[16]), null) : _i7 && _i7.p && (!t || 64 & o) && _i7.p(e, t ? o : -1);
    },
    i: function i(e) {
      t || (ya(_i7, e), t = !0);
    },
    o: function o(e) {
      ba(_i7, e), t = !1;
    },
    d: function d(e) {
      _i7 && _i7.d(e);
    }
  };
}
function US(e) {
  var t, n;
  return t = new RS({
    props: {
      label: e[5],
      width: e[7],
      height: e[8],
      box: e[10],
      style: e[9],
      spin: e[1],
      flip: e[4],
      inverse: e[2],
      pulse: e[3],
      class: e[0],
      $$slots: {
        default: [WS]
      },
      $$scope: {
        ctx: e
      }
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = xi(n, 1)[0],
        i = {};
      32 & r && (i.label = e[5]), 128 & r && (i.width = e[7]), 256 & r && (i.height = e[8]), 1024 & r && (i.box = e[10]), 512 & r && (i.style = e[9]), 2 & r && (i.spin = e[1]), 16 & r && (i.flip = e[4]), 4 & r && (i.inverse = e[2]), 8 & r && (i.pulse = e[3]), 1 & r && (i.class = e[0]), 65600 & r && (i.$$scope = {
        dirty: r,
        ctx: e
      }), t.$set(i);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function JS(e, t, n) {
  var r,
    i,
    o,
    a,
    s = t.$$slots,
    u = void 0 === s ? {} : s,
    c = t.$$scope,
    l = t.class,
    f = void 0 === l ? "" : l,
    h = t.data,
    d = t.scale,
    v = void 0 === d ? 1 : d,
    p = t.spin,
    m = void 0 !== p && p,
    g = t.inverse,
    y = void 0 !== g && g,
    b = t.pulse,
    k = void 0 !== b && b,
    w = t.flip,
    x = void 0 === w ? null : w,
    j = t.label,
    S = void 0 === j ? null : j,
    C = null,
    _ = t.style,
    $ = void 0 === _ ? null : _;
  function O() {
    var e = 1;
    return void 0 !== v && (e = Number(v)), isNaN(e) || e <= 0 ? (console.warn('Invalid prop: prop "scale" should be a number over 0.'), 1) : 1 * e;
  }
  function A() {
    return C ? Math.max(C.width, C.height) / 16 : 1;
  }
  return e.$$set = function (e) {
    "class" in e && n(0, f = e.class), "data" in e && n(11, h = e.data), "scale" in e && n(12, v = e.scale), "spin" in e && n(1, m = e.spin), "inverse" in e && n(2, y = e.inverse), "pulse" in e && n(3, k = e.pulse), "flip" in e && n(4, x = e.flip), "label" in e && n(5, S = e.label), "style" in e && n(13, $ = e.style), "$$scope" in e && n(16, c = e.$$scope);
  }, e.$$.update = function () {
    14336 & e.$$.dirty && (!function () {
      if (void 0 !== h) {
        var e = function (e) {
            if ("iconName" in e && "icon" in e) {
              var t = {},
                n = e.icon,
                r = e.iconName,
                i = {
                  width: n[0],
                  height: n[1],
                  paths: [{
                    d: n[4]
                  }]
                };
              return t[r] = i, t;
            }
            return e;
          }(h),
          t = e[xi(Object.keys(e), 1)[0]];
        t.paths || (t.paths = []), t.d && t.paths.push({
          d: t.d
        }), t.polygons || (t.polygons = []), t.points && t.polygons.push({
          points: t.points
        }), n(6, C = t);
      }
    }(), n(7, r = C ? C.width / A() * O() : 0), n(8, i = C ? C.height / A() * O() : 0), n(9, o = function () {
      var e = "";
      null !== $ && (e += $);
      var t = O();
      if (1 === t) {
        if (0 === e.length) return;
        return e;
      }
      return "" === e || e.endsWith(";") || (e += "; "), "".concat(e, "font-size: ").concat(t, "em");
    }()), n(10, a = C ? "0 0 ".concat(C.width, " ").concat(C.height) : "0 0 ".concat(r, " ").concat(i)));
  }, [f, m, y, k, x, S, C, r, i, o, a, h, v, $, u, function (e) {
    n(6, C = e);
  }, c];
}
var KS = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, JS, US, Ji, {
      class: 0,
      data: 11,
      scale: 12,
      spin: 1,
      inverse: 2,
      pulse: 3,
      flip: 4,
      label: 5,
      style: 13
    }), r;
  }
  return zi(n);
}();
function GS(e) {
  co(e, "svelte-kvi5ls", ".jse-message.svelte-kvi5ls.svelte-kvi5ls{font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);padding:var(--jse-padding);display:flex;gap:var(--jse-padding);flex-wrap:wrap;align-items:center}.jse-message.jse-success.svelte-kvi5ls.svelte-kvi5ls{background:var(--jse-message-success-background);color:var(--jse-message-success-color)}.jse-message.svelte-kvi5ls .jse-text.svelte-kvi5ls{flex:1;min-width:60%}.jse-message.svelte-kvi5ls .jse-text.jse-clickable.svelte-kvi5ls{cursor:pointer}.jse-message.svelte-kvi5ls .jse-text.jse-clickable.svelte-kvi5ls:hover{background-color:rgba(255, 255, 255, 0.1)}.jse-message.jse-error.svelte-kvi5ls.svelte-kvi5ls{background:var(--jse-message-error-background);color:var(--jse-message-error-color)}.jse-message.jse-warning.svelte-kvi5ls.svelte-kvi5ls{background:var(--jse-message-warning-background);color:var(--jse-message-warning-color)}.jse-message.jse-info.svelte-kvi5ls.svelte-kvi5ls{background:var(--jse-message-info-background);color:var(--jse-message-info-color)}.jse-message.svelte-kvi5ls .jse-actions.svelte-kvi5ls{display:flex;gap:var(--jse-padding)}.jse-message.svelte-kvi5ls .jse-actions button.jse-action.svelte-kvi5ls{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;background:var(--jse-message-action-background);color:inherit;padding:calc(0.5 * var(--jse-padding)) var(--jse-padding)}.jse-message.svelte-kvi5ls .jse-actions button.jse-action.svelte-kvi5ls:hover{background:var(--jse-message-action-background-highlight)}");
}
function QS(e, t, n) {
  var r = e.slice();
  return r[8] = t[n], r;
}
function YS(e) {
  var t, n;
  return t = new KS({
    props: {
      data: e[1]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      2 & n && (r.data = e[1]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function ZS(e) {
  var t, n;
  return t = new KS({
    props: {
      data: e[8].icon
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      8 & n && (r.data = e[8].icon), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function XS(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    c,
    l = e[8].text + "",
    f = e[8].icon && ZS(e);
  function h() {
    return e[6](e[8]);
  }
  function d() {
    return e[7](e[8]);
  }
  return {
    c: function c() {
      t = go("button"), f && f.c(), n = ko(), r = bo(l), i = ko(), So(t, "type", "button"), So(t, "class", "jse-button jse-action jse-primary svelte-kvi5ls"), So(t, "title", o = e[8].title), t.disabled = a = e[8].disabled;
    },
    m: function m(e, o) {
      vo(e, t, o), f && f.m(t, null), uo(t, n), uo(t, r), uo(t, i), s = !0, u || (c = [xo(t, "click", h), xo(t, "mousedown", d)], u = !0);
    },
    p: function p(i, u) {
      (e = i)[8].icon ? f ? (f.p(e, u), 8 & u && ya(f, 1)) : ((f = ZS(e)).c(), ya(f, 1), f.m(t, n)) : f && (ma(), ba(f, 1, 1, function () {
        f = null;
      }), ga()), (!s || 8 & u) && l !== (l = e[8].text + "") && Ao(r, l), (!s || 8 & u && o !== (o = e[8].title)) && So(t, "title", o), (!s || 8 & u && a !== (a = e[8].disabled)) && (t.disabled = a);
    },
    i: function i(e) {
      s || (ya(f), s = !0);
    },
    o: function o(e) {
      ba(f), s = !1;
    },
    d: function d(e) {
      e && po(t), f && f.d(), u = !1, Wi(c);
    }
  };
}
function eC(e) {
  for (var t, n, r, i, o, a, s, u, c, l, f = e[1] && YS(e), h = e[3], _d2 = [], v = 0; v < h.length; v += 1) {
    _d2[v] = XS(QS(e, h, v));
  }
  var _p3 = function p(e) {
    return ba(_d2[e], 1, 1, function () {
      _d2[e] = null;
    });
  };
  return {
    c: function c() {
      t = go("div"), n = go("div"), f && f.c(), r = ko(), i = bo(e[2]), o = ko(), a = go("div");
      for (var u = 0; u < _d2.length; u += 1) {
        _d2[u].c();
      }
      So(n, "class", "jse-text svelte-kvi5ls"), To(n, "jse-clickable", null !== e[4]), So(a, "class", "jse-actions svelte-kvi5ls"), So(t, "class", s = "jse-message jse-" + e[0] + " svelte-kvi5ls");
    },
    m: function m(s, h) {
      vo(s, t, h), uo(t, n), f && f.m(n, null), uo(n, r), uo(n, i), uo(t, o), uo(t, a);
      for (var v = 0; v < _d2.length; v += 1) {
        _d2[v].m(a, null);
      }
      u = !0, c || (l = xo(n, "click", e[5]), c = !0);
    },
    p: function p(e, o) {
      var c = xi(o, 1)[0];
      if (e[1] ? f ? (f.p(e, c), 2 & c && ya(f, 1)) : ((f = YS(e)).c(), ya(f, 1), f.m(n, r)) : f && (ma(), ba(f, 1, 1, function () {
        f = null;
      }), ga()), (!u || 4 & c) && Ao(i, e[2]), 16 & c && To(n, "jse-clickable", null !== e[4]), 8 & c) {
        var l;
        for (h = e[3], l = 0; l < h.length; l += 1) {
          var v = QS(e, h, l);
          _d2[l] ? (_d2[l].p(v, c), ya(_d2[l], 1)) : (_d2[l] = XS(v), _d2[l].c(), ya(_d2[l], 1), _d2[l].m(a, null));
        }
        for (ma(), l = h.length; l < _d2.length; l += 1) {
          _p3(l);
        }
        ga();
      }
      (!u || 1 & c && s !== (s = "jse-message jse-" + e[0] + " svelte-kvi5ls")) && So(t, "class", s);
    },
    i: function i(e) {
      if (!u) {
        ya(f);
        for (var t = 0; t < h.length; t += 1) {
          ya(_d2[t]);
        }
        u = !0;
      }
    },
    o: function o(e) {
      ba(f), _d2 = _d2.filter(Boolean);
      for (var t = 0; t < _d2.length; t += 1) {
        ba(_d2[t]);
      }
      u = !1;
    },
    d: function d(e) {
      e && po(t), f && f.d(), mo(_d2, e), c = !1, l();
    }
  };
}
function tC(e, t, n) {
  var r = t.type,
    i = void 0 === r ? "success" : r,
    o = t.icon,
    a = void 0 === o ? void 0 : o,
    s = t.message,
    u = void 0 === s ? void 0 : s,
    c = t.actions,
    l = void 0 === c ? [] : c,
    f = t.onClick,
    h = void 0 === f ? void 0 : f;
  return e.$$set = function (e) {
    "type" in e && n(0, i = e.type), "icon" in e && n(1, a = e.icon), "message" in e && n(2, u = e.message), "actions" in e && n(3, l = e.actions), "onClick" in e && n(4, h = e.onClick);
  }, [i, a, u, l, h, function () {
    h && h();
  }, function (e) {
    return e.onClick();
  }, function (e) {
    return e.onMouseDown();
  }];
}
var nC = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, tC, eC, Ki, {
      type: 0,
      icon: 1,
      message: 2,
      actions: 3,
      onClick: 4
    }, GS), r;
  }
  return zi(n);
}();
function rC(e) {
  return e.map(function (e) {
    return "number" == typeof e ? "[" + e + "]" : "string" == typeof e && e.match(/^[A-Za-z0-9_$]+$/) ? "." + e : '["' + String(e) + '"]';
  }).join("");
}
function iC(e) {
  return e.map(function (e) {
    var t = String(e);
    return oC.test(t) ? "?.".concat(t) : "?.[".concat(JSON.stringify(e), "]");
  }).join("");
}
var oC = /^[A-z$_][A-z$_\d]*$/i;
function aC(e) {
  co(e, "svelte-1oe8e8r", ".jse-validation-errors-overview.svelte-1oe8e8r.svelte-1oe8e8r{font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);background:var(--jse-message-warning-background);color:var(--jse-message-warning-color);overflow:auto;max-height:25%}.jse-validation-errors-overview.svelte-1oe8e8r table.svelte-1oe8e8r{border-collapse:collapse;width:100%}.jse-validation-errors-overview.svelte-1oe8e8r table tr.svelte-1oe8e8r{cursor:pointer}.jse-validation-errors-overview.svelte-1oe8e8r table tr.svelte-1oe8e8r:hover{background-color:rgba(255, 255, 255, 0.1)}.jse-validation-errors-overview.svelte-1oe8e8r table tr td.svelte-1oe8e8r{padding:4px var(--jse-padding);vertical-align:middle}.jse-validation-errors-overview.svelte-1oe8e8r table tr td.jse-validation-error-icon.svelte-1oe8e8r{width:36px;box-sizing:border-box}.jse-validation-errors-overview.svelte-1oe8e8r table tr td.jse-validation-error-action.svelte-1oe8e8r{width:36px;box-sizing:border-box;padding:0}.jse-validation-errors-overview.svelte-1oe8e8r table tr td.jse-validation-error-action button.jse-validation-errors-collapse.svelte-1oe8e8r{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;width:36px;height:26px;cursor:pointer}.jse-validation-errors-overview.svelte-1oe8e8r table tr td.jse-validation-error-action button.jse-validation-errors-collapse.svelte-1oe8e8r:hover{background-color:rgba(255, 255, 255, 0.2)}.jse-validation-errors-overview.svelte-1oe8e8r table tr td div.jse-validation-errors-expand.svelte-1oe8e8r{display:inline-block;position:relative;top:3px}");
}
function sC(e, t, n) {
  var r = e.slice();
  return r[6] = t[n], r[8] = n, r;
}
function uC(e) {
  var t,
    n,
    r,
    _i8,
    o = [lC, cC],
    a = [];
  function s(e, t) {
    return e[2] || 1 === e[0].length ? 0 : 1;
  }
  return n = s(e), r = a[n] = o[n](e), {
    c: function c() {
      t = go("div"), r.c(), So(t, "class", "jse-validation-errors-overview svelte-1oe8e8r");
    },
    m: function m(e, r) {
      vo(e, t, r), a[n].m(t, null), _i8 = !0;
    },
    p: function p(e, i) {
      var u = n;
      (n = s(e)) === u ? a[n].p(e, i) : (ma(), ba(a[u], 1, 1, function () {
        a[u] = null;
      }), ga(), (r = a[n]) ? r.p(e, i) : (r = a[n] = o[n](e)).c(), ya(r, 1), r.m(t, null));
    },
    i: function i(e) {
      _i8 || (ya(r), _i8 = !0);
    },
    o: function o(e) {
      ba(r), _i8 = !1;
    },
    d: function d(e) {
      e && po(t), a[n].d();
    }
  };
}
function cC(e) {
  var t,
    n,
    r,
    i,
    _o6,
    a,
    s,
    u,
    _c3,
    l,
    f,
    h,
    _d3,
    v,
    _p4 = e[0].length + "";
  return _o6 = new KS({
    props: {
      data: yS
    }
  }), f = new KS({
    props: {
      data: Kj
    }
  }), {
    c: function c() {
      t = go("table"), n = go("tbody"), r = go("tr"), i = go("td"), Aa(_o6.$$.fragment), a = ko(), s = go("td"), u = bo(_p4), _c3 = bo(" validation errors\n              "), l = go("div"), Aa(f.$$.fragment), So(i, "class", "jse-validation-error-icon svelte-1oe8e8r"), So(l, "class", "jse-validation-errors-expand svelte-1oe8e8r"), So(s, "class", "svelte-1oe8e8r"), So(r, "class", "jse-validation-error svelte-1oe8e8r"), So(t, "class", "svelte-1oe8e8r");
    },
    m: function m(p, _m3) {
      vo(p, t, _m3), uo(t, n), uo(n, r), uo(r, i), Ea(_o6, i, null), uo(r, a), uo(r, s), uo(s, u), uo(s, _c3), uo(s, l), Ea(f, l, null), h = !0, _d3 || (v = xo(r, "click", e[4]), _d3 = !0);
    },
    p: function p(e, t) {
      (!h || 1 & t) && _p4 !== (_p4 = e[0].length + "") && Ao(u, _p4);
    },
    i: function i(e) {
      h || (ya(_o6.$$.fragment, e), ya(f.$$.fragment, e), h = !0);
    },
    o: function o(e) {
      ba(_o6.$$.fragment, e), ba(f.$$.fragment, e), h = !1;
    },
    d: function d(e) {
      e && po(t), Pa(_o6), Pa(f), _d3 = !1, v();
    }
  };
}
function lC(e) {
  for (var t, n, r, _i9 = e[0], _o7 = [], a = 0; a < _i9.length; a += 1) {
    _o7[a] = hC(sC(e, _i9, a));
  }
  var s = function s(e) {
    return ba(_o7[e], 1, 1, function () {
      _o7[e] = null;
    });
  };
  return {
    c: function c() {
      t = go("table"), n = go("tbody");
      for (var e = 0; e < _o7.length; e += 1) {
        _o7[e].c();
      }
      So(t, "class", "svelte-1oe8e8r");
    },
    m: function m(e, i) {
      vo(e, t, i), uo(t, n);
      for (var a = 0; a < _o7.length; a += 1) {
        _o7[a].m(n, null);
      }
      r = !0;
    },
    p: function p(e, t) {
      if (11 & t) {
        var r;
        for (_i9 = e[0], r = 0; r < _i9.length; r += 1) {
          var a = sC(e, _i9, r);
          _o7[r] ? (_o7[r].p(a, t), ya(_o7[r], 1)) : (_o7[r] = hC(a), _o7[r].c(), ya(_o7[r], 1), _o7[r].m(n, null));
        }
        for (ma(), r = _i9.length; r < _o7.length; r += 1) {
          s(r);
        }
        ga();
      }
    },
    i: function i(e) {
      if (!r) {
        for (var t = 0; t < _i9.length; t += 1) {
          ya(_o7[t]);
        }
        r = !0;
      }
    },
    o: function o(e) {
      _o7 = _o7.filter(Boolean);
      for (var t = 0; t < _o7.length; t += 1) {
        ba(_o7[t]);
      }
      r = !1;
    },
    d: function d(e) {
      e && po(t), mo(_o7, e);
    }
  };
}
function fC(e) {
  var t, n, r, i, o;
  return n = new KS({
    props: {
      data: Jj
    }
  }), {
    c: function c() {
      t = go("button"), Aa(n.$$.fragment), So(t, "type", "button"), So(t, "class", "jse-validation-errors-collapse svelte-1oe8e8r"), So(t, "title", "Collapse validation errors");
    },
    m: function m(a, s) {
      vo(a, t, s), Ea(n, t, null), r = !0, i || (o = xo(t, "click", jo(e[3])), i = !0);
    },
    p: Bi,
    i: function i(e) {
      r || (ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), i = !1, o();
    }
  };
}
function hC(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    _c4,
    l,
    f,
    h,
    d,
    v,
    p,
    m = rC(e[6].path) + "",
    g = e[6].message + "";
  r = new KS({
    props: {
      data: yS
    }
  });
  var y = 0 === e[8] && e[0].length > 1 && fC(e);
  function b() {
    return e[5](e[6]);
  }
  return {
    c: function c() {
      t = go("tr"), n = go("td"), Aa(r.$$.fragment), i = ko(), o = go("td"), a = bo(m), s = ko(), u = go("td"), _c4 = bo(g), l = ko(), f = go("td"), y && y.c(), h = ko(), So(n, "class", "jse-validation-error-icon svelte-1oe8e8r"), So(o, "class", "svelte-1oe8e8r"), So(u, "class", "svelte-1oe8e8r"), So(f, "class", "jse-validation-error-action svelte-1oe8e8r"), So(t, "class", "jse-validation-error svelte-1oe8e8r");
    },
    m: function m(e, _m4) {
      vo(e, t, _m4), uo(t, n), Ea(r, n, null), uo(t, i), uo(t, o), uo(o, a), uo(t, s), uo(t, u), uo(u, _c4), uo(t, l), uo(t, f), y && y.m(f, null), uo(t, h), d = !0, v || (p = xo(t, "click", b), v = !0);
    },
    p: function p(t, n) {
      e = t, (!d || 1 & n) && m !== (m = rC(e[6].path) + "") && Ao(a, m), (!d || 1 & n) && g !== (g = e[6].message + "") && Ao(_c4, g), 0 === e[8] && e[0].length > 1 ? y ? (y.p(e, n), 1 & n && ya(y, 1)) : ((y = fC(e)).c(), ya(y, 1), y.m(f, null)) : y && (ma(), ba(y, 1, 1, function () {
        y = null;
      }), ga());
    },
    i: function i(e) {
      d || (ya(r.$$.fragment, e), ya(y), d = !0);
    },
    o: function o(e) {
      ba(r.$$.fragment, e), ba(y), d = !1;
    },
    d: function d(e) {
      e && po(t), Pa(r), y && y.d(), v = !1, p();
    }
  };
}
function dC(e) {
  var t,
    n,
    r = !Ym(e[0]),
    _i10 = r && uC(e);
  return {
    c: function c() {
      _i10 && _i10.c(), t = wo();
    },
    m: function m(e, r) {
      _i10 && _i10.m(e, r), vo(e, t, r), n = !0;
    },
    p: function p(e, n) {
      var o = xi(n, 1)[0];
      1 & o && (r = !Ym(e[0])), r ? _i10 ? (_i10.p(e, o), 1 & o && ya(_i10, 1)) : ((_i10 = uC(e)).c(), ya(_i10, 1), _i10.m(t.parentNode, t)) : _i10 && (ma(), ba(_i10, 1, 1, function () {
        _i10 = null;
      }), ga());
    },
    i: function i(e) {
      n || (ya(_i10), n = !0);
    },
    o: function o(e) {
      ba(_i10), n = !1;
    },
    d: function d(e) {
      _i10 && _i10.d(e), e && po(t);
    }
  };
}
function vC(e, t, n) {
  var r = t.validationErrors,
    i = t.selectError,
    o = !0;
  return e.$$set = function (e) {
    "validationErrors" in e && n(0, r = e.validationErrors), "selectError" in e && n(1, i = e.selectError);
  }, [r, i, o, function () {
    n(2, o = !1);
  }, function () {
    n(2, o = !0);
  }, function (e) {
    setTimeout(function () {
      return i(e);
    });
  }];
}
var pC = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, vC, dC, Ki, {
        validationErrors: 0,
        selectError: 1
      }, aC), r;
    }
    return zi(n);
  }(),
  mC = {
    prefix: "fas",
    iconName: "jsoneditor-expand",
    icon: [512, 512, [], null, "M 0,448 V 512 h 512 v -64 z M 0,0 V 64 H 512 V 0 Z M 256,96 128,224 h 256 z M 256,416 384,288 H 128 Z"]
  },
  gC = {
    prefix: "fas",
    iconName: "jsoneditor-collapse",
    icon: [512, 512, [], null, "m 0,224 v 64 h 512 v -64 z M 256,192 384,64 H 128 Z M 256,320 128,448 h 256 z"]
  },
  yC = {
    prefix: "fas",
    iconName: "jsoneditor-format",
    icon: [512, 512, [], null, "M 0,32 v 64 h 416 v -64 z M 160,160 v 64 h 352 v -64 z M 160,288 v 64 h 288 v -64 z M 0,416 v 64 h 320 v -64 z"]
  },
  bC = {
    prefix: "fas",
    iconName: "jsoneditor-compact",
    icon: [512, 512, [], null, "M 0,32 v 64 h 512 v -64 z M 0,160 v 64 h 512 v -64 z M 0,288 v 64 h 352 v -64 z"]
  };
function kC(e) {
  co(e, "svelte-v4jelk", ".jse-menu.svelte-v4jelk.svelte-v4jelk{background:var(--jse-theme-color);border-bottom:1px solid var(--jse-theme-color);color:var(--jse-menu-color);display:flex;flex-wrap:wrap;align-items:center;position:relative}.jse-menu.svelte-v4jelk .jse-button.svelte-v4jelk{width:var(--jse-menu-button-size);height:var(--jse-menu-button-size);border:none;background:transparent;color:inherit;cursor:pointer;padding:calc(0.5 * var(--jse-padding));margin:0;border-radius:0}.jse-menu.svelte-v4jelk .jse-button.svelte-v4jelk:hover,.jse-menu.svelte-v4jelk .jse-button.svelte-v4jelk:focus{background:var(--jse-theme-color-highlight)}.jse-menu.svelte-v4jelk .jse-button.svelte-v4jelk:disabled{color:var(--jse-menu-color);opacity:0.5;background:transparent}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.svelte-v4jelk{border:1px solid var(--jse-menu-color);padding:0;margin:calc(0.5 * var(--jse-padding)) 0;height:calc(var(--jse-menu-button-size) - var(--jse-padding));width:40px}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.svelte-v4jelk:not(.jse-last){border-right:none}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.jse-first.svelte-v4jelk{margin-left:calc(0.5 * var(--jse-padding))}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.jse-last.svelte-v4jelk{margin-right:calc(0.5 * var(--jse-padding))}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.svelte-v4jelk:hover,.jse-menu.svelte-v4jelk .jse-button.jse-group-button.svelte-v4jelk:focus{background:var(--jse-theme-color-highlight)}.jse-menu.svelte-v4jelk .jse-button.jse-group-button.jse-selected.svelte-v4jelk{background:var(--jse-menu-color);color:var(--jse-theme-color)}.jse-menu.svelte-v4jelk .jse-space.svelte-v4jelk{flex:1}.jse-menu.svelte-v4jelk .jse-separator.svelte-v4jelk{background:var(--jse-menu-color);opacity:0.3;box-sizing:border-box;width:1px;height:calc(var(--jse-menu-button-size) - 6px);margin:3px}");
}
var wC = function wC(e) {
    return {};
  },
  xC = function xC(e) {
    return {};
  };
function jC(e, t, n) {
  var r = e.slice();
  return r[3] = t[n], r;
}
var SC = function SC(e) {
    return {};
  },
  CC = function CC(e) {
    return {};
  };
function _C(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    _c5 = e[3].icon && AC(e),
    l = e[3].text && EC(e);
  return {
    c: function c() {
      t = go("button"), _c5 && _c5.c(), n = ko(), l && l.c(), So(t, "type", "button"), So(t, "class", r = "jse-button " + e[3].className + " svelte-v4jelk"), So(t, "title", i = e[3].title), t.disabled = o = e[3].disabled || !1;
    },
    m: function m(r, i) {
      vo(r, t, i), _c5 && _c5.m(t, null), uo(t, n), l && l.m(t, null), a = !0, s || (u = xo(t, "click", function () {
        Ui(e[3].onClick) && e[3].onClick.apply(this, arguments);
      }), s = !0);
    },
    p: function p(s, u) {
      (e = s)[3].icon ? _c5 ? (_c5.p(e, u), 1 & u && ya(_c5, 1)) : ((_c5 = AC(e)).c(), ya(_c5, 1), _c5.m(t, n)) : _c5 && (ma(), ba(_c5, 1, 1, function () {
        _c5 = null;
      }), ga()), e[3].text ? l ? l.p(e, u) : ((l = EC(e)).c(), l.m(t, null)) : l && (l.d(1), l = null), (!a || 1 & u && r !== (r = "jse-button " + e[3].className + " svelte-v4jelk")) && So(t, "class", r), (!a || 1 & u && i !== (i = e[3].title)) && So(t, "title", i), (!a || 1 & u && o !== (o = e[3].disabled || !1)) && (t.disabled = o);
    },
    i: function i(e) {
      a || (ya(_c5), a = !0);
    },
    o: function o(e) {
      ba(_c5), a = !1;
    },
    d: function d(e) {
      e && po(t), _c5 && _c5.d(), l && l.d(), s = !1, u();
    }
  };
}
function $C(e) {
  var t;
  return {
    c: function c() {
      So(t = go("div"), "class", "jse-space svelte-v4jelk");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: Bi,
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function OC(e) {
  var t;
  return {
    c: function c() {
      So(t = go("div"), "class", "jse-separator svelte-v4jelk");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: Bi,
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function AC(e) {
  var t, n;
  return t = new KS({
    props: {
      data: e[3].icon
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      1 & n && (r.data = e[3].icon), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function EC(e) {
  var t,
    n = e[3].text + "";
  return {
    c: function c() {
      t = bo(n);
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: function p(e, r) {
      1 & r && n !== (n = e[3].text + "") && Ao(t, n);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function PC(e) {
  var t,
    n,
    r,
    _i11,
    o = [OC, $C, _C],
    a = [];
  function s(e, t) {
    return !0 === e[3].separator ? 0 : !0 === e[3].space ? 1 : 2;
  }
  return t = s(e), n = a[t] = o[t](e), {
    c: function c() {
      n.c(), r = wo();
    },
    m: function m(e, n) {
      a[t].m(e, n), vo(e, r, n), _i11 = !0;
    },
    p: function p(e, i) {
      var u = t;
      (t = s(e)) === u ? a[t].p(e, i) : (ma(), ba(a[u], 1, 1, function () {
        a[u] = null;
      }), ga(), (n = a[t]) ? n.p(e, i) : (n = a[t] = o[t](e)).c(), ya(n, 1), n.m(r.parentNode, r));
    },
    i: function i(e) {
      _i11 || (ya(n), _i11 = !0);
    },
    o: function o(e) {
      ba(n), _i11 = !1;
    },
    d: function d(e) {
      a[t].d(e), e && po(r);
    }
  };
}
function MC(e) {
  for (var t, n, r, _i12, o = e[2].left, a = Gi(o, e, e[1], CC), s = e[0], u = [], c = 0; c < s.length; c += 1) {
    u[c] = PC(jC(e, s, c));
  }
  var l = function l(e) {
      return ba(u[e], 1, 1, function () {
        u[e] = null;
      });
    },
    f = e[2].right,
    h = Gi(f, e, e[1], xC);
  return {
    c: function c() {
      t = go("div"), a && a.c(), n = ko();
      for (var e = 0; e < u.length; e += 1) {
        u[e].c();
      }
      r = ko(), h && h.c(), So(t, "class", "jse-menu svelte-v4jelk");
    },
    m: function m(e, o) {
      vo(e, t, o), a && a.m(t, null), uo(t, n);
      for (var s = 0; s < u.length; s += 1) {
        u[s].m(t, null);
      }
      uo(t, r), h && h.m(t, null), _i12 = !0;
    },
    p: function p(e, n) {
      var c = xi(n, 1)[0];
      if (a && a.p && (!_i12 || 2 & c) && Zi(a, o, e, e[1], _i12 ? Yi(o, e[1], c, SC) : Xi(e[1]), CC), 1 & c) {
        var d;
        for (s = e[0], d = 0; d < s.length; d += 1) {
          var v = jC(e, s, d);
          u[d] ? (u[d].p(v, c), ya(u[d], 1)) : (u[d] = PC(v), u[d].c(), ya(u[d], 1), u[d].m(t, r));
        }
        for (ma(), d = s.length; d < u.length; d += 1) {
          l(d);
        }
        ga();
      }
      h && h.p && (!_i12 || 2 & c) && Zi(h, f, e, e[1], _i12 ? Yi(f, e[1], c, wC) : Xi(e[1]), xC);
    },
    i: function i(e) {
      if (!_i12) {
        ya(a, e);
        for (var t = 0; t < s.length; t += 1) {
          ya(u[t]);
        }
        ya(h, e), _i12 = !0;
      }
    },
    o: function o(e) {
      ba(a, e), u = u.filter(Boolean);
      for (var t = 0; t < u.length; t += 1) {
        ba(u[t]);
      }
      ba(h, e), _i12 = !1;
    },
    d: function d(e) {
      e && po(t), a && a.d(e), mo(u, e), h && h.d(e);
    }
  };
}
function IC(e, t, n) {
  var r = t.$$slots,
    i = void 0 === r ? {} : r,
    o = t.$$scope,
    a = t.items,
    s = void 0 === a ? [] : a;
  return e.$$set = function (e) {
    "items" in e && n(0, s = e.items), "$$scope" in e && n(1, o = e.$$scope);
  }, [s, o, i];
}
var TC = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, IC, MC, Ki, {
      items: 0
    }, kC), r;
  }
  return zi(n);
}();
function NC(e) {
  co(e, "svelte-1yyupsl", ".jse-powered-by.svelte-1yyupsl.svelte-1yyupsl{font-size:8pt;padding:0 10px 3px}.jse-powered-by.svelte-1yyupsl a.svelte-1yyupsl{color:inherit;opacity:0.7}.jse-powered-by.svelte-1yyupsl a.svelte-1yyupsl:hover{opacity:1}");
}
function RC(e) {
  var t;
  return {
    c: function c() {
      (t = go("div")).innerHTML = '<a href="https://codemirror.net" target="_blank" rel="noopener noreferrer" title="Code mode is powered by CodeMirror" class="svelte-1yyupsl">powered by CodeMirror</a>', So(t, "slot", "right"), So(t, "class", "jse-powered-by svelte-1yyupsl");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function DC(e) {
  var t, n;
  return t = new TC({
    props: {
      items: e[0],
      $$slots: {
        right: [RC]
      },
      $$scope: {
        ctx: e
      }
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = xi(n, 1)[0],
        i = {};
      1 & r && (i.items = e[0]), 131072 & r && (i.$$scope = {
        dirty: r,
        ctx: e
      }), t.$set(i);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function zC(e, t, n) {
  var r,
    i,
    o = t.readOnly,
    a = void 0 !== o && o,
    s = t.onFormat,
    u = t.onCompact,
    c = t.onSort,
    l = t.onTransform,
    f = t.onToggleSearch,
    h = t.onUndo,
    d = t.onRedo,
    v = t.canUndo,
    p = t.canRedo,
    m = t.canFormat,
    g = t.canCompact,
    y = t.canSort,
    b = t.canTransform,
    k = t.onRenderMenu,
    w = void 0 === k ? kc : k;
  return e.$$set = function (e) {
    "readOnly" in e && n(1, a = e.readOnly), "onFormat" in e && n(2, s = e.onFormat), "onCompact" in e && n(3, u = e.onCompact), "onSort" in e && n(4, c = e.onSort), "onTransform" in e && n(5, l = e.onTransform), "onToggleSearch" in e && n(6, f = e.onToggleSearch), "onUndo" in e && n(7, h = e.onUndo), "onRedo" in e && n(8, d = e.onRedo), "canUndo" in e && n(9, v = e.canUndo), "canRedo" in e && n(10, p = e.canRedo), "canFormat" in e && n(11, m = e.canFormat), "canCompact" in e && n(12, g = e.canCompact), "canSort" in e && n(13, y = e.canSort), "canTransform" in e && n(14, b = e.canTransform), "onRenderMenu" in e && n(15, w = e.onRenderMenu);
  }, e.$$.update = function () {
    32766 & e.$$.dirty && n(16, r = a ? [{
      space: !0
    }] : [{
      icon: yC,
      title: "Format JSON: add proper indentation and new lines (Ctrl+I)",
      className: "jse-format",
      onClick: s,
      disabled: a || !m
    }, {
      icon: bC,
      title: "Compact JSON: remove all white spacing and new lines (Ctrl+Shift+I)",
      className: "jse-compact",
      onClick: u,
      disabled: a || !g
    }, {
      separator: !0
    }, {
      icon: Qj,
      title: "Sort",
      className: "jse-sort",
      onClick: c,
      disabled: a || !y
    }, {
      icon: lS,
      title: "Transform contents (filter, sort, project)",
      className: "jse-transform",
      onClick: l,
      disabled: a || !b
    }, {
      icon: hS,
      title: "Search (Ctrl+F)",
      className: "jse-search",
      onClick: f
    }, {
      separator: !0
    }, {
      icon: Yj,
      title: "Undo (Ctrl+Z)",
      className: "jse-undo",
      onClick: h,
      disabled: !v
    }, {
      icon: Zj,
      title: "Redo (Ctrl+Shift+Z)",
      className: "jse-redo",
      onClick: d,
      disabled: !p
    }, {
      space: !0
    }]), 98304 & e.$$.dirty && n(0, i = w("code", r) || r);
  }, [i, a, s, u, c, l, f, h, d, v, p, m, g, y, b, w, r];
}
var LC = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, zC, DC, Ki, {
        readOnly: 1,
        onFormat: 2,
        onCompact: 3,
        onSort: 4,
        onTransform: 5,
        onToggleSearch: 6,
        onUndo: 7,
        onRedo: 8,
        canUndo: 9,
        canRedo: 10,
        canFormat: 11,
        canCompact: 12,
        canSort: 13,
        canTransform: 14,
        onRenderMenu: 15
      }, NC), r;
    }
    return zi(n);
  }(),
  BC = function () {
    function e() {
      Ri(this, e);
    }
    return zi(e, [{
      key: "lineAt",
      value: function value(e) {
        if (e < 0 || e > this.length) throw new RangeError("Invalid position ".concat(e, " in document of length ").concat(this.length));
        return this.lineInner(e, !1, 1, 0);
      }
    }, {
      key: "line",
      value: function value(e) {
        if (e < 1 || e > this.lines) throw new RangeError("Invalid line number ".concat(e, " in ").concat(this.lines, "-line document"));
        return this.lineInner(e, !0, 1, 0);
      }
    }, {
      key: "replace",
      value: function value(e, t, n) {
        var r = [];
        return this.decompose(0, e, r, 2), n.length && n.decompose(0, n.length, r, 3), this.decompose(t, this.length, r, 1), FC.from(r, this.length - (t - e) + n.length);
      }
    }, {
      key: "append",
      value: function value(e) {
        return this.replace(this.length, this.length, e);
      }
    }, {
      key: "slice",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length,
          n = [];
        return this.decompose(e, t, n, 0), FC.from(n, t - e);
      }
    }, {
      key: "eq",
      value: function value(e) {
        if (e == this) return !0;
        if (e.length != this.length || e.lines != this.lines) return !1;
        for (var t = this.scanIdentical(e, 1), n = this.length - this.scanIdentical(e, -1), r = new UC(this), i = new UC(e), o = t, a = t;;) {
          if (r.next(o), i.next(o), o = 0, r.lineBreak != i.lineBreak || r.done != i.done || r.value != i.value) return !1;
          if (a += r.value.length, r.done || a >= n) return !0;
        }
      }
    }, {
      key: "iter",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        return new UC(this, e);
      }
    }, {
      key: "iterRange",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length;
        return new JC(this, e, t);
      }
    }, {
      key: "iterLines",
      value: function value(e, t) {
        var n;
        if (null == e) n = this.iter();else {
          null == t && (t = this.lines + 1);
          var r = this.line(e).from;
          n = this.iterRange(r, Math.max(r, t == this.lines + 1 ? this.length : t <= 1 ? 0 : this.line(t - 1).to));
        }
        return new KC(n);
      }
    }, {
      key: "toString",
      value: function value() {
        return this.sliceString(0);
      }
    }, {
      key: "toJSON",
      value: function value() {
        var e = [];
        return this.flatten(e), e;
      }
    }], [{
      key: "of",
      value: function value(t) {
        if (0 == t.length) throw new RangeError("A document must have at least one line");
        return 1 != t.length || t[0] ? t.length <= 32 ? new qC(t) : FC.from(qC.split(t, [])) : e.empty;
      }
    }]), e;
  }(),
  qC = function (e) {
    ji(n, BC);
    var t = Ci(n);
    function n(e) {
      var r,
        i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : VC(e);
      return Ri(this, n), (r = t.call(this)).text = e, r.length = i, r;
    }
    return zi(n, [{
      key: "lines",
      get: function get() {
        return this.text.length;
      }
    }, {
      key: "children",
      get: function get() {
        return null;
      }
    }, {
      key: "lineInner",
      value: function value(e, t, n, r) {
        for (var i = 0;; i++) {
          var o = this.text[i],
            a = r + o.length;
          if ((t ? n : a) >= e) return new GC(r, a, n, o);
          r = a + 1, n++;
        }
      }
    }, {
      key: "decompose",
      value: function value(e, t, r, i) {
        var o = e <= 0 && t >= this.length ? this : new n(WC(this.text, e, t), Math.min(t, this.length) - Math.max(0, e));
        if (1 & i) {
          var a = r.pop(),
            s = HC(o.text, a.text.slice(), 0, o.length);
          if (s.length <= 32) r.push(new n(s, a.length + o.length));else {
            var u = s.length >> 1;
            r.push(new n(s.slice(0, u)), new n(s.slice(u)));
          }
        } else r.push(o);
      }
    }, {
      key: "replace",
      value: function value(e, t, r) {
        if (!(r instanceof n)) return ki(Ai(n.prototype), "replace", this).call(this, e, t, r);
        var i = HC(this.text, HC(r.text, WC(this.text, 0, e)), t),
          o = this.length + r.length - (t - e);
        return i.length <= 32 ? new n(i, o) : FC.from(n.split(i, []), o);
      }
    }, {
      key: "sliceString",
      value: function value(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "\n", r = "", i = 0, o = 0; i <= t && o < this.text.length; o++) {
          var a = this.text[o],
            s = i + a.length;
          i > e && o && (r += n), e < s && t > i && (r += a.slice(Math.max(0, e - i), t - i)), i = s + 1;
        }
        return r;
      }
    }, {
      key: "flatten",
      value: function value(e) {
        var t,
          n = bi(this.text);
        try {
          for (n.s(); !(t = n.n()).done;) {
            var r = t.value;
            e.push(r);
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
      }
    }, {
      key: "scanIdentical",
      value: function value() {
        return 0;
      }
    }], [{
      key: "split",
      value: function value(e, t) {
        var r,
          i = [],
          o = -1,
          a = bi(e);
        try {
          for (a.s(); !(r = a.n()).done;) {
            var s = r.value;
            i.push(s), o += s.length + 1, 32 == i.length && (t.push(new n(i, o)), i = [], o = -1);
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
        return o > -1 && t.push(new n(i, o)), t;
      }
    }]), n;
  }(),
  FC = function (e) {
    ji(n, BC);
    var t = Ci(n);
    function n(e, r) {
      var i;
      Ri(this, n), (i = t.call(this)).children = e, i.length = r, i.lines = 0;
      var o,
        a = bi(e);
      try {
        for (a.s(); !(o = a.n()).done;) {
          var s = o.value;
          i.lines += s.lines;
        }
      } catch (e) {
        a.e(e);
      } finally {
        a.f();
      }
      return i;
    }
    return zi(n, [{
      key: "lineInner",
      value: function value(e, t, n, r) {
        for (var i = 0;; i++) {
          var o = this.children[i],
            a = r + o.length,
            s = n + o.lines - 1;
          if ((t ? s : a) >= e) return o.lineInner(e, t, n, r);
          r = a + 1, n = s + 1;
        }
      }
    }, {
      key: "decompose",
      value: function value(e, t, n, r) {
        for (var i = 0, o = 0; o <= t && i < this.children.length; i++) {
          var a = this.children[i],
            s = o + a.length;
          if (e <= s && t >= o) {
            var u = r & ((o <= e ? 1 : 0) | (s >= t ? 2 : 0));
            o >= e && s <= t && !u ? n.push(a) : a.decompose(e - o, t - o, n, u);
          }
          o = s + 1;
        }
      }
    }, {
      key: "replace",
      value: function value(e, t, r) {
        if (r.lines < this.lines) for (var i = 0, o = 0; i < this.children.length; i++) {
          var a = this.children[i],
            s = o + a.length;
          if (e >= o && t <= s) {
            var u = a.replace(e - o, t - o, r),
              c = this.lines - a.lines + u.lines;
            if (u.lines < c >> 4 && u.lines > c >> 6) {
              var l = this.children.slice();
              return l[i] = u, new n(l, this.length - (t - e) + r.length);
            }
            return ki(Ai(n.prototype), "replace", this).call(this, o, s, u);
          }
          o = s + 1;
        }
        return ki(Ai(n.prototype), "replace", this).call(this, e, t, r);
      }
    }, {
      key: "sliceString",
      value: function value(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "\n", r = "", i = 0, o = 0; i < this.children.length && o <= t; i++) {
          var a = this.children[i],
            s = o + a.length;
          o > e && i && (r += n), e < s && t > o && (r += a.sliceString(e - o, t - o, n)), o = s + 1;
        }
        return r;
      }
    }, {
      key: "flatten",
      value: function value(e) {
        var t,
          n = bi(this.children);
        try {
          for (n.s(); !(t = n.n()).done;) {
            t.value.flatten(e);
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
      }
    }, {
      key: "scanIdentical",
      value: function value(e, t) {
        if (!(e instanceof n)) return 0;
        for (var r = 0, i = xi(t > 0 ? [0, 0, this.children.length, e.children.length] : [this.children.length - 1, e.children.length - 1, -1, -1], 4), o = i[0], a = i[1], s = i[2], u = i[3];; o += t, a += t) {
          if (o == s || a == u) return r;
          var c = this.children[o],
            l = e.children[a];
          if (c != l) return r + c.scanIdentical(l, t);
          r += c.length + 1;
        }
      }
    }], [{
      key: "from",
      value: function value(e) {
        var t,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.reduce(function (e, t) {
            return e + t.length + 1;
          }, -1),
          i = 0,
          o = bi(e);
        try {
          for (o.s(); !(t = o.n()).done;) {
            var a = t.value;
            i += a.lines;
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        if (i < 32) {
          var s,
            u = [],
            c = bi(e);
          try {
            for (c.s(); !(s = c.n()).done;) {
              var l = s.value;
              l.flatten(u);
            }
          } catch (e) {
            c.e(e);
          } finally {
            c.f();
          }
          return new qC(u, r);
        }
        var f = Math.max(32, i >> 5),
          h = f << 1,
          d = f >> 1,
          v = [],
          p = 0,
          m = -1,
          g = [];
        function y(e) {
          var t;
          if (e.lines > h && e instanceof n) {
            var r,
              i = bi(e.children);
            try {
              for (i.s(); !(r = i.n()).done;) {
                y(r.value);
              }
            } catch (e) {
              i.e(e);
            } finally {
              i.f();
            }
          } else e.lines > d && (p > d || !p) ? (b(), v.push(e)) : e instanceof qC && p && (t = g[g.length - 1]) instanceof qC && e.lines + t.lines <= 32 ? (p += e.lines, m += e.length + 1, g[g.length - 1] = new qC(t.text.concat(e.text), t.length + 1 + e.length)) : (p + e.lines > f && b(), p += e.lines, m += e.length + 1, g.push(e));
        }
        function b() {
          0 != p && (v.push(1 == g.length ? g[0] : n.from(g, m)), m = -1, p = g.length = 0);
        }
        var k,
          w = bi(e);
        try {
          for (w.s(); !(k = w.n()).done;) {
            var x = k.value;
            y(x);
          }
        } catch (e) {
          w.e(e);
        } finally {
          w.f();
        }
        return b(), 1 == v.length ? v[0] : new n(v, r);
      }
    }]), n;
  }();
function VC(e) {
  var t,
    n = -1,
    r = bi(e);
  try {
    for (r.s(); !(t = r.n()).done;) {
      n += t.value.length + 1;
    }
  } catch (e) {
    r.e(e);
  } finally {
    r.f();
  }
  return n;
}
function HC(e, t) {
  for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1e9, i = 0, o = 0, a = !0; o < e.length && i <= r; o++) {
    var s = e[o],
      u = i + s.length;
    u >= n && (u > r && (s = s.slice(0, r - i)), i < n && (s = s.slice(n - i)), a ? (t[t.length - 1] += s, a = !1) : t.push(s)), i = u + 1;
  }
  return t;
}
function WC(e, t, n) {
  return HC(e, [""], t, n);
}
BC.empty = new qC([""], 0);
var UC = function () {
    function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
      Ri(this, e), this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [t], this.offsets = [n > 0 ? 1 : (t instanceof qC ? t.text.length : t.children.length) << 1];
    }
    return zi(e, [{
      key: "nextInner",
      value: function value(e, t) {
        for (this.done = this.lineBreak = !1;;) {
          var n = this.nodes.length - 1,
            r = this.nodes[n],
            i = this.offsets[n],
            o = i >> 1,
            a = r instanceof qC ? r.text.length : r.children.length;
          if (o == (t > 0 ? a : 0)) {
            if (0 == n) return this.done = !0, this.value = "", this;
            t > 0 && this.offsets[n - 1]++, this.nodes.pop(), this.offsets.pop();
          } else if ((1 & i) == (t > 0 ? 0 : 1)) {
            if (this.offsets[n] += t, 0 == e) return this.lineBreak = !0, this.value = "\n", this;
            e--;
          } else if (r instanceof qC) {
            var s = r.text[o + (t < 0 ? -1 : 0)];
            if (this.offsets[n] += t, s.length > Math.max(0, e)) return this.value = 0 == e ? s : t > 0 ? s.slice(e) : s.slice(0, s.length - e), this;
            e -= s.length;
          } else {
            var u = r.children[o + (t < 0 ? -1 : 0)];
            e > u.length ? (e -= u.length, this.offsets[n] += t) : (t < 0 && this.offsets[n]--, this.nodes.push(u), this.offsets.push(t > 0 ? 1 : (u instanceof qC ? u.text.length : u.children.length) << 1));
          }
        }
      }
    }, {
      key: "next",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
        return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
      }
    }]), e;
  }(),
  JC = function () {
    function e(t, n, r) {
      Ri(this, e), this.value = "", this.done = !1, this.cursor = new UC(t, n > r ? -1 : 1), this.pos = n > r ? t.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
    }
    return zi(e, [{
      key: "nextInner",
      value: function value(e, t) {
        if (t < 0 ? this.pos <= this.from : this.pos >= this.to) return this.value = "", this.done = !0, this;
        e += Math.max(0, t < 0 ? this.pos - this.to : this.from - this.pos);
        var n = t < 0 ? this.pos - this.from : this.to - this.pos;
        e > n && (e = n), n -= e;
        var r = this.cursor.next(e).value;
        return this.pos += (r.length + e) * t, this.value = r.length <= n ? r : t < 0 ? r.slice(r.length - n) : r.slice(0, n), this.done = !this.value, this;
      }
    }, {
      key: "next",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
        return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
      }
    }, {
      key: "lineBreak",
      get: function get() {
        return this.cursor.lineBreak && "" != this.value;
      }
    }]), e;
  }(),
  KC = function () {
    function e(t) {
      Ri(this, e), this.inner = t, this.afterBreak = !0, this.value = "", this.done = !1;
    }
    return zi(e, [{
      key: "next",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          t = this.inner.next(e),
          n = t.done,
          r = t.lineBreak,
          i = t.value;
        return n ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = i, this.afterBreak = !1), this;
      }
    }, {
      key: "lineBreak",
      get: function get() {
        return !1;
      }
    }]), e;
  }();
"undefined" != typeof Symbol && (BC.prototype[Symbol.iterator] = function () {
  return this.iter();
}, UC.prototype[Symbol.iterator] = JC.prototype[Symbol.iterator] = KC.prototype[Symbol.iterator] = function () {
  return this;
});
for (var GC = function () {
    function e(t, n, r, i) {
      Ri(this, e), this.from = t, this.to = n, this.number = r, this.text = i;
    }
    return zi(e, [{
      key: "length",
      get: function get() {
        return this.to - this.from;
      }
    }]), e;
  }(), QC = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map(function (e) {
    return e ? parseInt(e, 36) : 1;
  }), YC = 1; YC < QC.length; YC++) {
  QC[YC] += QC[YC - 1];
}
function ZC(e) {
  for (var t = 1; t < QC.length; t += 2) {
    if (QC[t] > e) return QC[t - 1] <= e;
  }
  return !1;
}
function XC(e) {
  return e >= 127462 && e <= 127487;
}
function e_(e, t) {
  var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
    r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
  return (n ? t_ : n_)(e, t, r);
}
function t_(e, t, n) {
  if (t == e.length) return t;
  t && r_(e.charCodeAt(t)) && i_(e.charCodeAt(t - 1)) && t--;
  var r = o_(e, t);
  for (t += s_(r); t < e.length;) {
    var i = o_(e, t);
    if (8205 == r || 8205 == i || n && ZC(i)) t += s_(i), r = i;else {
      if (!XC(i)) break;
      for (var o = 0, a = t - 2; a >= 0 && XC(o_(e, a));) {
        o++, a -= 2;
      }
      if (o % 2 == 0) break;
      t += 2;
    }
  }
  return t;
}
function n_(e, t, n) {
  for (; t > 0;) {
    var r = t_(e, t - 2, n);
    if (r < t) return r;
    t--;
  }
  return 0;
}
function r_(e) {
  return e >= 56320 && e < 57344;
}
function i_(e) {
  return e >= 55296 && e < 56320;
}
function o_(e, t) {
  var n = e.charCodeAt(t);
  if (!i_(n) || t + 1 == e.length) return n;
  var r = e.charCodeAt(t + 1);
  return r_(r) ? r - 56320 + (n - 55296 << 10) + 65536 : n;
}
function a_(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10), 56320 + (1023 & e)));
}
function s_(e) {
  return e < 65536 ? 1 : 2;
}
var u_ = /\r\n?|\n/,
  c_ = function (e) {
    return e[e.Simple = 0] = "Simple", e[e.TrackDel = 1] = "TrackDel", e[e.TrackBefore = 2] = "TrackBefore", e[e.TrackAfter = 3] = "TrackAfter", e;
  }(c_ || (c_ = {})),
  l_ = function () {
    function e(t) {
      Ri(this, e), this.sections = t;
    }
    return zi(e, [{
      key: "length",
      get: function get() {
        for (var e = 0, t = 0; t < this.sections.length; t += 2) {
          e += this.sections[t];
        }
        return e;
      }
    }, {
      key: "newLength",
      get: function get() {
        for (var e = 0, t = 0; t < this.sections.length; t += 2) {
          var n = this.sections[t + 1];
          e += n < 0 ? this.sections[t] : n;
        }
        return e;
      }
    }, {
      key: "empty",
      get: function get() {
        return 0 == this.sections.length || 2 == this.sections.length && this.sections[1] < 0;
      }
    }, {
      key: "iterGaps",
      value: function value(e) {
        for (var t = 0, n = 0, r = 0; t < this.sections.length;) {
          var i = this.sections[t++],
            o = this.sections[t++];
          o < 0 ? (e(n, r, i), r += i) : r += o, n += i;
        }
      }
    }, {
      key: "iterChangedRanges",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        v_(this, e, t);
      }
    }, {
      key: "invertedDesc",
      get: function get() {
        for (var t = [], n = 0; n < this.sections.length;) {
          var r = this.sections[n++],
            i = this.sections[n++];
          i < 0 ? t.push(r, i) : t.push(i, r);
        }
        return new e(t);
      }
    }, {
      key: "composeDesc",
      value: function value(e) {
        return this.empty ? e : e.empty ? this : m_(this, e);
      }
    }, {
      key: "mapDesc",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return e.empty ? this : p_(this, e, t);
      }
    }, {
      key: "mapPos",
      value: function value(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : c_.Simple, r = 0, i = 0, o = 0; o < this.sections.length;) {
          var a = this.sections[o++],
            s = this.sections[o++],
            u = r + a;
          if (s < 0) {
            if (u > e) return i + (e - r);
            i += a;
          } else {
            if (n != c_.Simple && u >= e && (n == c_.TrackDel && r < e && u > e || n == c_.TrackBefore && r < e || n == c_.TrackAfter && u > e)) return null;
            if (u > e || u == e && t < 0 && !a) return e == r || t < 0 ? i : i + s;
            i += s;
          }
          r = u;
        }
        if (e > r) throw new RangeError("Position ".concat(e, " is out of range for changeset of length ").concat(r));
        return i;
      }
    }, {
      key: "touchesRange",
      value: function value(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e, n = 0, r = 0; n < this.sections.length && r <= t;) {
          var i = this.sections[n++],
            o = this.sections[n++],
            a = r + i;
          if (o >= 0 && r <= t && a >= e) return !(r < e && a > t) || "cover";
          r = a;
        }
        return !1;
      }
    }, {
      key: "toString",
      value: function value() {
        for (var e = "", t = 0; t < this.sections.length;) {
          var n = this.sections[t++],
            r = this.sections[t++];
          e += (e ? " " : "") + n + (r >= 0 ? ":" + r : "");
        }
        return e;
      }
    }, {
      key: "toJSON",
      value: function value() {
        return this.sections;
      }
    }], [{
      key: "fromJSON",
      value: function value(t) {
        if (!Array.isArray(t) || t.length % 2 || t.some(function (e) {
          return "number" != typeof e;
        })) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new e(t);
      }
    }, {
      key: "create",
      value: function value(t) {
        return new e(t);
      }
    }]), e;
  }(),
  f_ = function (e) {
    ji(n, l_);
    var t = Ci(n);
    function n(e, r) {
      var i;
      return Ri(this, n), (i = t.call(this, e)).inserted = r, i;
    }
    return zi(n, [{
      key: "apply",
      value: function value(e) {
        if (this.length != e.length) throw new RangeError("Applying change set to a document with the wrong length");
        return v_(this, function (t, n, r, i, o) {
          return e = e.replace(r, r + (n - t), o);
        }, !1), e;
      }
    }, {
      key: "mapDesc",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return p_(this, e, t, !0);
      }
    }, {
      key: "invert",
      value: function value(e) {
        for (var t = this.sections.slice(), r = [], i = 0, o = 0; i < t.length; i += 2) {
          var a = t[i],
            s = t[i + 1];
          if (s >= 0) {
            t[i] = s, t[i + 1] = a;
            for (var u = i >> 1; r.length < u;) {
              r.push(BC.empty);
            }
            r.push(a ? e.slice(o, o + a) : BC.empty);
          }
          o += a;
        }
        return new n(t, r);
      }
    }, {
      key: "compose",
      value: function value(e) {
        return this.empty ? e : e.empty ? this : m_(this, e, !0);
      }
    }, {
      key: "map",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return e.empty ? this : p_(this, e, t, !0);
      }
    }, {
      key: "iterChanges",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        v_(this, e, t);
      }
    }, {
      key: "desc",
      get: function get() {
        return l_.create(this.sections);
      }
    }, {
      key: "filter",
      value: function value(e) {
        var t = [],
          r = [],
          i = [],
          o = new g_(this);
        e: for (var a = 0, s = 0;;) {
          for (var u = a == e.length ? 1e9 : e[a++]; s < u || s == u && 0 == o.len;) {
            if (o.done) break e;
            var c = Math.min(o.len, u - s);
            h_(i, c, -1);
            var l = -1 == o.ins ? -1 : 0 == o.off ? o.ins : 0;
            h_(t, c, l), l > 0 && d_(r, t, o.text), o.forward(c), s += c;
          }
          for (var f = e[a++]; s < f;) {
            if (o.done) break e;
            var h = Math.min(o.len, f - s);
            h_(t, h, -1), h_(i, h, -1 == o.ins ? -1 : 0 == o.off ? o.ins : 0), o.forward(h), s += h;
          }
        }
        return {
          changes: new n(t, r),
          filtered: l_.create(i)
        };
      }
    }, {
      key: "toJSON",
      value: function value() {
        for (var e = [], t = 0; t < this.sections.length; t += 2) {
          var n = this.sections[t],
            r = this.sections[t + 1];
          r < 0 ? e.push(n) : 0 == r ? e.push([n]) : e.push([n].concat(this.inserted[t >> 1].toJSON()));
        }
        return e;
      }
    }], [{
      key: "of",
      value: function value(e, t, r) {
        var i = [],
          o = [],
          a = 0,
          s = null;
        function u() {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (e || i.length) {
            a < t && h_(i, t - a, -1);
            var r = new n(i, o);
            s = s ? s.compose(r.map(s)) : r, i = [], o = [], a = 0;
          }
        }
        return function e(c) {
          if (Array.isArray(c)) {
            var l,
              f = bi(c);
            try {
              for (f.s(); !(l = f.n()).done;) {
                e(l.value);
              }
            } catch (e) {
              f.e(e);
            } finally {
              f.f();
            }
          } else if (c instanceof n) {
            if (c.length != t) throw new RangeError("Mismatched change set length (got ".concat(c.length, ", expected ").concat(t, ")"));
            u(), s = s ? s.compose(c.map(s)) : c;
          } else {
            var h = c.from,
              d = c.to,
              v = void 0 === d ? h : d,
              p = c.insert;
            if (h > v || h < 0 || v > t) throw new RangeError("Invalid change range ".concat(h, " to ").concat(v, " (in doc of length ").concat(t, ")"));
            var m = p ? "string" == typeof p ? BC.of(p.split(r || u_)) : p : BC.empty,
              g = m.length;
            if (h == v && 0 == g) return;
            h < a && u(), h > a && h_(i, h - a, -1), h_(i, v - h, g), d_(o, i, m), a = v;
          }
        }(e), u(!s), s;
      }
    }, {
      key: "empty",
      value: function value(e) {
        return new n(e ? [e, -1] : [], []);
      }
    }, {
      key: "fromJSON",
      value: function value(e) {
        if (!Array.isArray(e)) throw new RangeError("Invalid JSON representation of ChangeSet");
        for (var t = [], r = [], i = 0; i < e.length; i++) {
          var o = e[i];
          if ("number" == typeof o) t.push(o, -1);else {
            if (!Array.isArray(o) || "number" != typeof o[0] || o.some(function (e, t) {
              return t && "string" != typeof e;
            })) throw new RangeError("Invalid JSON representation of ChangeSet");
            if (1 == o.length) t.push(o[0], 0);else {
              for (; r.length < i;) {
                r.push(BC.empty);
              }
              r[i] = BC.of(o.slice(1)), t.push(o[0], r[i].length);
            }
          }
        }
        return new n(t, r);
      }
    }, {
      key: "createSet",
      value: function value(e, t) {
        return new n(e, t);
      }
    }]), n;
  }();
function h_(e, t, n) {
  var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
  if (!(0 == t && n <= 0)) {
    var i = e.length - 2;
    i >= 0 && n <= 0 && n == e[i + 1] ? e[i] += t : 0 == t && 0 == e[i] ? e[i + 1] += n : r ? (e[i] += t, e[i + 1] += n) : e.push(t, n);
  }
}
function d_(e, t, n) {
  if (0 != n.length) {
    var r = t.length - 2 >> 1;
    if (r < e.length) e[e.length - 1] = e[e.length - 1].append(n);else {
      for (; e.length < r;) {
        e.push(BC.empty);
      }
      e.push(n);
    }
  }
}
function v_(e, t, n) {
  for (var r = e.inserted, i = 0, o = 0, a = 0; a < e.sections.length;) {
    var s = e.sections[a++],
      u = e.sections[a++];
    if (u < 0) i += s, o += s;else {
      for (var c = i, l = o, f = BC.empty; c += s, l += u, u && r && (f = f.append(r[a - 2 >> 1])), !(n || a == e.sections.length || e.sections[a + 1] < 0);) {
        s = e.sections[a++], u = e.sections[a++];
      }
      t(i, c, o, l, f), i = c, o = l;
    }
  }
}
function p_(e, t, n) {
  for (var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], i = [], o = r ? [] : null, a = new g_(e), s = new g_(t), u = 0, c = 0;;) {
    if (-1 == a.ins) u += a.len, a.next();else if (-1 == s.ins && c < u) {
      var l = Math.min(s.len, u - c);
      s.forward(l), h_(i, l, -1), c += l;
    } else if (s.ins >= 0 && (a.done || c < u || c == u && (s.len < a.len || s.len == a.len && !n))) {
      for (h_(i, s.ins, -1); u > c && !a.done && u + a.len < c + s.len;) {
        u += a.len, a.next();
      }
      c += s.len, s.next();
    } else {
      if (!(a.ins >= 0)) {
        if (a.done && s.done) return o ? f_.createSet(i, o) : l_.create(i);
        throw new Error("Mismatched change set lengths");
      }
      for (var f = 0, h = u + a.len;;) {
        if (s.ins >= 0 && c > u && c + s.len < h) f += s.ins, c += s.len, s.next();else {
          if (!(-1 == s.ins && c < h)) break;
          var d = Math.min(s.len, h - c);
          f += d, s.forward(d), c += d;
        }
      }
      h_(i, f, a.ins), o && d_(o, i, a.text), u = h, a.next();
    }
  }
}
function m_(e, t) {
  for (var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = [], i = n ? [] : null, o = new g_(e), a = new g_(t), s = !1;;) {
    if (o.done && a.done) return i ? f_.createSet(r, i) : l_.create(r);
    if (0 == o.ins) h_(r, o.len, 0, s), o.next();else if (0 != a.len || a.done) {
      if (o.done || a.done) throw new Error("Mismatched change set lengths");
      var u = Math.min(o.len2, a.len),
        c = r.length;
      if (-1 == o.ins) {
        var l = -1 == a.ins ? -1 : a.off ? 0 : a.ins;
        h_(r, u, l, s), i && l && d_(i, r, a.text);
      } else -1 == a.ins ? (h_(r, o.off ? 0 : o.len, u, s), i && d_(i, r, o.textBit(u))) : (h_(r, o.off ? 0 : o.len, a.off ? 0 : a.ins, s), i && !a.off && d_(i, r, a.text));
      s = (o.ins > u || a.ins >= 0 && a.len > u) && (s || r.length > c), o.forward2(u), a.forward(u);
    } else h_(r, 0, a.ins, s), i && d_(i, r, a.text), a.next();
  }
}
var g_ = function () {
    function e(t) {
      Ri(this, e), this.set = t, this.i = 0, this.next();
    }
    return zi(e, [{
      key: "next",
      value: function value() {
        var e = this.set.sections;
        this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
      }
    }, {
      key: "done",
      get: function get() {
        return -2 == this.ins;
      }
    }, {
      key: "len2",
      get: function get() {
        return this.ins < 0 ? this.len : this.ins;
      }
    }, {
      key: "text",
      get: function get() {
        var e = this.set.inserted,
          t = this.i - 2 >> 1;
        return t >= e.length ? BC.empty : e[t];
      }
    }, {
      key: "textBit",
      value: function value(e) {
        var t = this.set.inserted,
          n = this.i - 2 >> 1;
        return n >= t.length && !e ? BC.empty : t[n].slice(this.off, null == e ? void 0 : this.off + e);
      }
    }, {
      key: "forward",
      value: function value(e) {
        e == this.len ? this.next() : (this.len -= e, this.off += e);
      }
    }, {
      key: "forward2",
      value: function value(e) {
        -1 == this.ins ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
      }
    }]), e;
  }(),
  y_ = function () {
    function e(t, n, r) {
      Ri(this, e), this.from = t, this.to = n, this.flags = r;
    }
    return zi(e, [{
      key: "anchor",
      get: function get() {
        return 16 & this.flags ? this.to : this.from;
      }
    }, {
      key: "head",
      get: function get() {
        return 16 & this.flags ? this.from : this.to;
      }
    }, {
      key: "empty",
      get: function get() {
        return this.from == this.to;
      }
    }, {
      key: "assoc",
      get: function get() {
        return 4 & this.flags ? -1 : 8 & this.flags ? 1 : 0;
      }
    }, {
      key: "bidiLevel",
      get: function get() {
        var e = 3 & this.flags;
        return 3 == e ? null : e;
      }
    }, {
      key: "goalColumn",
      get: function get() {
        var e = this.flags >> 5;
        return 33554431 == e ? void 0 : e;
      }
    }, {
      key: "map",
      value: function value(t) {
        var n,
          r,
          i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
        return this.empty ? n = r = t.mapPos(this.from, i) : (n = t.mapPos(this.from, 1), r = t.mapPos(this.to, -1)), n == this.from && r == this.to ? this : new e(n, r, this.flags);
      }
    }, {
      key: "extend",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
        if (e <= this.anchor && t >= this.anchor) return b_.range(e, t);
        var n = Math.abs(e - this.anchor) > Math.abs(t - this.anchor) ? e : t;
        return b_.range(this.anchor, n);
      }
    }, {
      key: "eq",
      value: function value(e) {
        return this.anchor == e.anchor && this.head == e.head;
      }
    }, {
      key: "toJSON",
      value: function value() {
        return {
          anchor: this.anchor,
          head: this.head
        };
      }
    }], [{
      key: "fromJSON",
      value: function value(e) {
        if (!e || "number" != typeof e.anchor || "number" != typeof e.head) throw new RangeError("Invalid JSON representation for SelectionRange");
        return b_.range(e.anchor, e.head);
      }
    }, {
      key: "create",
      value: function value(t, n, r) {
        return new e(t, n, r);
      }
    }]), e;
  }(),
  b_ = function () {
    function e(t, n) {
      Ri(this, e), this.ranges = t, this.mainIndex = n;
    }
    return zi(e, [{
      key: "map",
      value: function value(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
        return t.empty ? this : e.create(this.ranges.map(function (e) {
          return e.map(t, n);
        }), this.mainIndex);
      }
    }, {
      key: "eq",
      value: function value(e) {
        if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex) return !1;
        for (var t = 0; t < this.ranges.length; t++) {
          if (!this.ranges[t].eq(e.ranges[t])) return !1;
        }
        return !0;
      }
    }, {
      key: "main",
      get: function get() {
        return this.ranges[this.mainIndex];
      }
    }, {
      key: "asSingle",
      value: function value() {
        return 1 == this.ranges.length ? this : new e([this.main], 0);
      }
    }, {
      key: "addRange",
      value: function value(t) {
        var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        return e.create([t].concat(this.ranges), n ? 0 : this.mainIndex + 1);
      }
    }, {
      key: "replaceRange",
      value: function value(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.mainIndex,
          r = this.ranges.slice();
        return r[n] = t, e.create(r, this.mainIndex);
      }
    }, {
      key: "toJSON",
      value: function value() {
        return {
          ranges: this.ranges.map(function (e) {
            return e.toJSON();
          }),
          main: this.mainIndex
        };
      }
    }], [{
      key: "fromJSON",
      value: function value(t) {
        if (!t || !Array.isArray(t.ranges) || "number" != typeof t.main || t.main >= t.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new e(t.ranges.map(function (e) {
          return y_.fromJSON(e);
        }), t.main);
      }
    }, {
      key: "single",
      value: function value(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
        return new e([e.range(t, n)], 0);
      }
    }, {
      key: "create",
      value: function value(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        if (0 == t.length) throw new RangeError("A selection needs at least one range");
        for (var r = 0, i = 0; i < t.length; i++) {
          var o = t[i];
          if (o.empty ? o.from <= r : o.from < r) return e.normalized(t.slice(), n);
          r = o.to;
        }
        return new e(t, n);
      }
    }, {
      key: "cursor",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = arguments.length > 2 ? arguments[2] : void 0,
          r = arguments.length > 3 ? arguments[3] : void 0;
        return y_.create(e, e, (0 == t ? 0 : t < 0 ? 4 : 8) | (null == n ? 3 : Math.min(2, n)) | (null != r ? r : 33554431) << 5);
      }
    }, {
      key: "range",
      value: function value(e, t, n) {
        var r = (null != n ? n : 33554431) << 5;
        return t < e ? y_.create(t, e, 24 | r) : y_.create(e, t, r | (t > e ? 4 : 0));
      }
    }, {
      key: "normalized",
      value: function value(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          r = t[n];
        t.sort(function (e, t) {
          return e.from - t.from;
        }), n = t.indexOf(r);
        for (var i = 1; i < t.length; i++) {
          var o = t[i],
            a = t[i - 1];
          if (o.empty ? o.from <= a.to : o.from < a.to) {
            var s = a.from,
              u = Math.max(o.to, a.to);
            i <= n && n--, t.splice(--i, 2, o.anchor > o.head ? e.range(u, s) : e.range(s, u));
          }
        }
        return new e(t, n);
      }
    }]), e;
  }();
function k_(e, t) {
  var n,
    r = bi(e.ranges);
  try {
    for (r.s(); !(n = r.n()).done;) {
      if (n.value.to > t) throw new RangeError("Selection points outside of document");
    }
  } catch (e) {
    r.e(e);
  } finally {
    r.f();
  }
}
var w_ = 0,
  x_ = function () {
    function e(t, n, r, i, o) {
      Ri(this, e), this.combine = t, this.compareInput = n, this.compare = r, this.isStatic = i, this.extensions = o, this.id = w_++, this.default = t([]);
    }
    return zi(e, [{
      key: "of",
      value: function value(e) {
        return new S_([], this, 0, e);
      }
    }, {
      key: "compute",
      value: function value(e, t) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new S_(e, this, 1, t);
      }
    }, {
      key: "computeN",
      value: function value(e, t) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new S_(e, this, 2, t);
      }
    }, {
      key: "from",
      value: function value(e, t) {
        return t || (t = function t(e) {
          return e;
        }), this.compute([e], function (n) {
          return t(n.field(e));
        });
      }
    }], [{
      key: "define",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return new e(t.combine || function (e) {
          return e;
        }, t.compareInput || function (e, t) {
          return e === t;
        }, t.compare || (t.combine ? function (e, t) {
          return e === t;
        } : j_), !!t.static, t.enables);
      }
    }]), e;
  }();
function j_(e, t) {
  return e == t || e.length == t.length && e.every(function (e, n) {
    return e === t[n];
  });
}
var S_ = function () {
  function e(t, n, r, i) {
    Ri(this, e), this.dependencies = t, this.facet = n, this.type = r, this.value = i, this.id = w_++;
  }
  return zi(e, [{
    key: "dynamicSlot",
    value: function value(e) {
      var t,
        n,
        r = this,
        i = this.value,
        o = this.facet.compareInput,
        a = this.id,
        s = e[a] >> 1,
        u = 2 == this.type,
        c = !1,
        l = !1,
        f = [],
        h = bi(this.dependencies);
      try {
        for (h.s(); !(n = h.n()).done;) {
          var d = n.value;
          "doc" == d ? c = !0 : "selection" == d ? l = !0 : 0 == (1 & (null !== (t = e[d.id]) && void 0 !== t ? t : 1)) && f.push(e[d.id]);
        }
      } catch (e) {
        h.e(e);
      } finally {
        h.f();
      }
      return {
        create: function create(e) {
          return e.values[s] = i(e), 1;
        },
        update: function update(e, t) {
          if (c && t.docChanged || l && (t.docChanged || t.selection) || __(e, f)) {
            var n = i(e);
            if (u ? !C_(n, e.values[s], o) : !o(n, e.values[s])) return e.values[s] = n, 1;
          }
          return 0;
        },
        reconfigure: function reconfigure(e, t) {
          var n = i(e),
            c = t.config.address[a];
          if (null != c) {
            var l = B_(t, c);
            if (r.dependencies.every(function (n) {
              return n instanceof x_ ? t.facet(n) === e.facet(n) : !(n instanceof O_) || t.field(n, !1) == e.field(n, !1);
            }) || (u ? C_(n, l, o) : o(n, l))) return e.values[s] = l, 0;
          }
          return e.values[s] = n, 1;
        }
      };
    }
  }]), e;
}();
function C_(e, t, n) {
  if (e.length != t.length) return !1;
  for (var r = 0; r < e.length; r++) {
    if (!n(e[r], t[r])) return !1;
  }
  return !0;
}
function __(e, t) {
  var n,
    r = !1,
    i = bi(t);
  try {
    for (i.s(); !(n = i.n()).done;) {
      1 & L_(e, n.value) && (r = !0);
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }
  return r;
}
var $_ = x_.define({
    static: !0
  }),
  O_ = function () {
    function e(t, n, r, i, o) {
      Ri(this, e), this.id = t, this.createF = n, this.updateF = r, this.compareF = i, this.spec = o, this.provides = void 0;
    }
    return zi(e, [{
      key: "create",
      value: function value(e) {
        var t = this,
          n = e.facet($_).find(function (e) {
            return e.field == t;
          });
        return ((null == n ? void 0 : n.create) || this.createF)(e);
      }
    }, {
      key: "slot",
      value: function value(e) {
        var t = this,
          n = e[this.id] >> 1;
        return {
          create: function create(e) {
            return e.values[n] = t.create(e), 1;
          },
          update: function update(e, r) {
            var i = e.values[n],
              o = t.updateF(i, r);
            return t.compareF(i, o) ? 0 : (e.values[n] = o, 1);
          },
          reconfigure: function reconfigure(e, r) {
            return null != r.config.address[t.id] ? (e.values[n] = r.field(t), 0) : (e.values[n] = t.create(e), 1);
          }
        };
      }
    }, {
      key: "init",
      value: function value(e) {
        return [this, $_.of({
          field: this,
          create: e
        })];
      }
    }, {
      key: "extension",
      get: function get() {
        return this;
      }
    }], [{
      key: "define",
      value: function value(t) {
        var n = new e(w_++, t.create, t.update, t.compare || function (e, t) {
          return e === t;
        }, t);
        return t.provide && (n.provides = t.provide(n)), n;
      }
    }]), e;
  }(),
  A_ = 4,
  E_ = 3,
  P_ = 2,
  M_ = 1;
function I_(e) {
  return function (t) {
    return new N_(t, e);
  };
}
var T_ = {
    highest: I_(0),
    high: I_(M_),
    default: I_(P_),
    low: I_(E_),
    lowest: I_(A_)
  },
  N_ = zi(function e(t, n) {
    Ri(this, e), this.inner = t, this.prec = n;
  }),
  R_ = function () {
    function e() {
      Ri(this, e);
    }
    return zi(e, [{
      key: "of",
      value: function value(e) {
        return new D_(this, e);
      }
    }, {
      key: "reconfigure",
      value: function value(t) {
        return e.reconfigure.of({
          compartment: this,
          extension: t
        });
      }
    }, {
      key: "get",
      value: function value(e) {
        return e.config.compartments.get(this);
      }
    }]), e;
  }(),
  D_ = zi(function e(t, n) {
    Ri(this, e), this.compartment = t, this.inner = n;
  }),
  z_ = function () {
    function e(t, n, r, i, o, a) {
      for (Ri(this, e), this.base = t, this.compartments = n, this.dynamicSlots = r, this.address = i, this.staticValues = o, this.facets = a, this.statusTemplate = []; this.statusTemplate.length < r.length;) {
        this.statusTemplate.push(0);
      }
    }
    return zi(e, [{
      key: "staticFacet",
      value: function value(e) {
        var t = this.address[e.id];
        return null == t ? e.default : this.staticValues[t >> 1];
      }
    }], [{
      key: "resolve",
      value: function value(t, n, r) {
        var i,
          o = [],
          a = Object.create(null),
          s = new Map(),
          u = bi(function (e, t, n) {
            var r = [[], [], [], [], []],
              i = new Map();
            function o(e, a) {
              var s = i.get(e);
              if (null != s) {
                if (s <= a) return;
                var u = r[s].indexOf(e);
                u > -1 && r[s].splice(u, 1), e instanceof D_ && n.delete(e.compartment);
              }
              if (i.set(e, a), Array.isArray(e)) {
                var c,
                  l = bi(e);
                try {
                  for (l.s(); !(c = l.n()).done;) {
                    o(c.value, a);
                  }
                } catch (e) {
                  l.e(e);
                } finally {
                  l.f();
                }
              } else if (e instanceof D_) {
                if (n.has(e.compartment)) throw new RangeError("Duplicate use of compartment in extensions");
                var f = t.get(e.compartment) || e.inner;
                n.set(e.compartment, f), o(f, a);
              } else if (e instanceof N_) o(e.inner, e.prec);else if (e instanceof O_) r[a].push(e), e.provides && o(e.provides, a);else if (e instanceof S_) r[a].push(e), e.facet.extensions && o(e.facet.extensions, a);else {
                var h = e.extension;
                if (!h) throw new Error("Unrecognized extension value in extension set (".concat(e, "). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks."));
                o(h, a);
              }
            }
            return o(e, P_), r.reduce(function (e, t) {
              return e.concat(t);
            });
          }(t, n, s));
        try {
          for (u.s(); !(i = u.n()).done;) {
            var c = i.value;
            c instanceof O_ ? o.push(c) : (a[c.facet.id] || (a[c.facet.id] = [])).push(c);
          }
        } catch (e) {
          u.e(e);
        } finally {
          u.f();
        }
        for (var l = Object.create(null), f = [], h = [], d = function d() {
            var e = p[v];
            l[e.id] = h.length << 1, h.push(function (t) {
              return e.slot(t);
            });
          }, v = 0, p = o; v < p.length; v++) {
          d();
        }
        var m = null == r ? void 0 : r.config.facets,
          g = function g(e) {
            var t = a[e],
              n = t[0].facet,
              i = m && m[e] || [];
            if (t.every(function (e) {
              return 0 == e.type;
            })) {
              if (l[n.id] = f.length << 1 | 1, j_(i, t)) f.push(r.facet(n));else {
                var o = n.combine(t.map(function (e) {
                  return e.value;
                }));
                f.push(r && n.compare(o, r.facet(n)) ? r.facet(n) : o);
              }
            } else {
              var s,
                u = bi(t);
              try {
                var c = function c() {
                  var e = s.value;
                  0 == e.type ? (l[e.id] = f.length << 1 | 1, f.push(e.value)) : (l[e.id] = h.length << 1, h.push(function (t) {
                    return e.dynamicSlot(t);
                  }));
                };
                for (u.s(); !(s = u.n()).done;) {
                  c();
                }
              } catch (e) {
                u.e(e);
              } finally {
                u.f();
              }
              l[n.id] = h.length << 1, h.push(function (e) {
                return function (e, t, n) {
                  var r = n.map(function (t) {
                      return e[t.id];
                    }),
                    i = n.map(function (e) {
                      return e.type;
                    }),
                    o = r.filter(function (e) {
                      return !(1 & e);
                    }),
                    a = e[t.id] >> 1;
                  function s(e) {
                    for (var n = [], o = 0; o < r.length; o++) {
                      var a = B_(e, r[o]);
                      if (2 == i[o]) {
                        var s,
                          u = bi(a);
                        try {
                          for (u.s(); !(s = u.n()).done;) {
                            var c = s.value;
                            n.push(c);
                          }
                        } catch (e) {
                          u.e(e);
                        } finally {
                          u.f();
                        }
                      } else n.push(a);
                    }
                    return t.combine(n);
                  }
                  return {
                    create: function create(e) {
                      var t,
                        n = bi(r);
                      try {
                        for (n.s(); !(t = n.n()).done;) {
                          L_(e, t.value);
                        }
                      } catch (e) {
                        n.e(e);
                      } finally {
                        n.f();
                      }
                      return e.values[a] = s(e), 1;
                    },
                    update: function update(e, n) {
                      if (!__(e, o)) return 0;
                      var r = s(e);
                      return t.compare(r, e.values[a]) ? 0 : (e.values[a] = r, 1);
                    },
                    reconfigure: function reconfigure(e, i) {
                      var o = __(e, r),
                        u = i.config.facets[t.id],
                        c = i.facet(t);
                      if (u && !o && j_(n, u)) return e.values[a] = c, 0;
                      var l = s(e);
                      return t.compare(l, c) ? (e.values[a] = c, 0) : (e.values[a] = l, 1);
                    }
                  };
                }(e, n, t);
              });
            }
          };
        for (var y in a) {
          g(y);
        }
        return new e(t, s, h.map(function (e) {
          return e(l);
        }), l, f, a);
      }
    }]), e;
  }();
function L_(e, t) {
  if (1 & t) return 2;
  var n = t >> 1,
    r = e.status[n];
  if (4 == r) throw new Error("Cyclic dependency between fields and/or facets");
  if (2 & r) return r;
  e.status[n] = 4;
  var i = e.computeSlot(e, e.config.dynamicSlots[n]);
  return e.status[n] = 2 | i;
}
function B_(e, t) {
  return 1 & t ? e.config.staticValues[t >> 1] : e.values[t >> 1];
}
var q_ = x_.define(),
  F_ = x_.define({
    combine: function combine(e) {
      return e.some(function (e) {
        return e;
      });
    },
    static: !0
  }),
  V_ = x_.define({
    combine: function combine(e) {
      return e.length ? e[0] : void 0;
    },
    static: !0
  }),
  H_ = x_.define(),
  W_ = x_.define(),
  U_ = x_.define(),
  J_ = x_.define({
    combine: function combine(e) {
      return !!e.length && e[0];
    }
  }),
  K_ = function () {
    function e(t, n) {
      Ri(this, e), this.type = t, this.value = n;
    }
    return zi(e, null, [{
      key: "define",
      value: function value() {
        return new G_();
      }
    }]), e;
  }(),
  G_ = function () {
    function e() {
      Ri(this, e);
    }
    return zi(e, [{
      key: "of",
      value: function value(e) {
        return new K_(this, e);
      }
    }]), e;
  }(),
  Q_ = function () {
    function e(t) {
      Ri(this, e), this.map = t;
    }
    return zi(e, [{
      key: "of",
      value: function value(e) {
        return new Y_(this, e);
      }
    }]), e;
  }(),
  Y_ = function () {
    function e(t, n) {
      Ri(this, e), this.type = t, this.value = n;
    }
    return zi(e, [{
      key: "map",
      value: function value(t) {
        var n = this.type.map(this.value, t);
        return void 0 === n ? void 0 : n == this.value ? this : new e(this.type, n);
      }
    }, {
      key: "is",
      value: function value(e) {
        return this.type == e;
      }
    }], [{
      key: "define",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return new Q_(e.map || function (e) {
          return e;
        });
      }
    }, {
      key: "mapEffects",
      value: function value(e, t) {
        if (!e.length) return e;
        var n,
          r = [],
          i = bi(e);
        try {
          for (i.s(); !(n = i.n()).done;) {
            var o = n.value.map(t);
            o && r.push(o);
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        return r;
      }
    }]), e;
  }();
Y_.reconfigure = Y_.define(), Y_.appendConfig = Y_.define();
var Z_ = function () {
  function e(t, n, r, i, o, a) {
    Ri(this, e), this.startState = t, this.changes = n, this.selection = r, this.effects = i, this.annotations = o, this.scrollIntoView = a, this._doc = null, this._state = null, r && k_(r, n.newLength), o.some(function (t) {
      return t.type == e.time;
    }) || (this.annotations = o.concat(e.time.of(Date.now())));
  }
  return zi(e, [{
    key: "newDoc",
    get: function get() {
      return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
  }, {
    key: "newSelection",
    get: function get() {
      return this.selection || this.startState.selection.map(this.changes);
    }
  }, {
    key: "state",
    get: function get() {
      return this._state || this.startState.applyTransaction(this), this._state;
    }
  }, {
    key: "annotation",
    value: function value(e) {
      var t,
        n = bi(this.annotations);
      try {
        for (n.s(); !(t = n.n()).done;) {
          var r = t.value;
          if (r.type == e) return r.value;
        }
      } catch (e) {
        n.e(e);
      } finally {
        n.f();
      }
    }
  }, {
    key: "docChanged",
    get: function get() {
      return !this.changes.empty;
    }
  }, {
    key: "reconfigured",
    get: function get() {
      return this.startState.config != this.state.config;
    }
  }, {
    key: "isUserEvent",
    value: function value(t) {
      var n = this.annotation(e.userEvent);
      return !(!n || !(n == t || n.length > t.length && n.slice(0, t.length) == t && "." == n[t.length]));
    }
  }], [{
    key: "create",
    value: function value(t, n, r, i, o, a) {
      return new e(t, n, r, i, o, a);
    }
  }]), e;
}();
function X_(e, t) {
  for (var n = [], r = 0, i = 0;;) {
    var o = void 0,
      a = void 0;
    if (r < e.length && (i == t.length || t[i] >= e[r])) o = e[r++], a = e[r++];else {
      if (!(i < t.length)) return n;
      o = t[i++], a = t[i++];
    }
    !n.length || n[n.length - 1] < o ? n.push(o, a) : n[n.length - 1] < a && (n[n.length - 1] = a);
  }
}
function e$(e, t, n) {
  var r, i, o, a;
  return n ? (i = t.changes, o = f_.empty(t.changes.length), a = e.changes.compose(t.changes)) : (i = t.changes.map(e.changes), o = e.changes.mapDesc(t.changes, !0), a = e.changes.compose(i)), {
    changes: a,
    selection: t.selection ? t.selection.map(o) : null === (r = e.selection) || void 0 === r ? void 0 : r.map(i),
    effects: Y_.mapEffects(e.effects, i).concat(Y_.mapEffects(t.effects, o)),
    annotations: e.annotations.length ? e.annotations.concat(t.annotations) : t.annotations,
    scrollIntoView: e.scrollIntoView || t.scrollIntoView
  };
}
function t$(e, t, n) {
  var r = t.selection,
    i = i$(t.annotations);
  return t.userEvent && (i = i.concat(Z_.userEvent.of(t.userEvent))), {
    changes: t.changes instanceof f_ ? t.changes : f_.of(t.changes || [], n, e.facet(V_)),
    selection: r && (r instanceof b_ ? r : b_.single(r.anchor, r.head)),
    effects: i$(t.effects),
    annotations: i,
    scrollIntoView: !!t.scrollIntoView
  };
}
function n$(e, t, n) {
  var r = t$(e, t.length ? t[0] : {}, e.doc.length);
  t.length && !1 === t[0].filter && (n = !1);
  for (var i = 1; i < t.length; i++) {
    !1 === t[i].filter && (n = !1);
    var o = !!t[i].sequential;
    r = e$(r, t$(e, t[i], o ? r.changes.newLength : e.doc.length), o);
  }
  var a = Z_.create(e, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return function (e) {
    for (var t = e.startState, n = t.facet(U_), r = e, i = n.length - 1; i >= 0; i--) {
      var o = n[i](e);
      o && Object.keys(o).length && (r = e$(e, t$(t, o, e.changes.newLength), !0));
    }
    return r == e ? e : Z_.create(t, e.changes, e.selection, r.effects, r.annotations, r.scrollIntoView);
  }(n ? function (e) {
    var t,
      n = e.startState,
      r = !0,
      i = bi(n.facet(H_));
    try {
      for (i.s(); !(t = i.n()).done;) {
        var o = (0, t.value)(e);
        if (!1 === o) {
          r = !1;
          break;
        }
        Array.isArray(o) && (r = !0 === r ? o : X_(r, o));
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
    if (!0 !== r) {
      var a, s;
      if (!1 === r) s = e.changes.invertedDesc, a = f_.empty(n.doc.length);else {
        var u = e.changes.filter(r);
        a = u.changes, s = u.filtered.invertedDesc;
      }
      e = Z_.create(n, a, e.selection && e.selection.map(s), Y_.mapEffects(e.effects, s), e.annotations, e.scrollIntoView);
    }
    for (var c = n.facet(W_), l = c.length - 1; l >= 0; l--) {
      var f = c[l](e);
      e = f instanceof Z_ ? f : Array.isArray(f) && 1 == f.length && f[0] instanceof Z_ ? f[0] : n$(n, i$(f), !1);
    }
    return e;
  }(a) : a);
}
Z_.time = K_.define(), Z_.userEvent = K_.define(), Z_.addToHistory = K_.define(), Z_.remote = K_.define();
var r$ = [];
function i$(e) {
  return null == e ? r$ : Array.isArray(e) ? e : [e];
}
var o$,
  a$ = function (e) {
    return e[e.Word = 0] = "Word", e[e.Space = 1] = "Space", e[e.Other = 2] = "Other", e;
  }(a$ || (a$ = {})),
  s$ = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
try {
  o$ = new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (vx) {}
function u$(e) {
  return function (t) {
    if (!/\S/.test(t)) return a$.Space;
    if (function (e) {
      if (o$) return o$.test(e);
      for (var t = 0; t < e.length; t++) {
        var n = e[t];
        if (/\w/.test(n) || n > "" && (n.toUpperCase() != n.toLowerCase() || s$.test(n))) return !0;
      }
      return !1;
    }(t)) return a$.Word;
    for (var n = 0; n < e.length; n++) {
      if (t.indexOf(e[n]) > -1) return a$.Word;
    }
    return a$.Other;
  };
}
var c$ = function () {
  function e(t, n, r, i, o, a) {
    Ri(this, e), this.config = t, this.doc = n, this.selection = r, this.values = i, this.status = t.statusTemplate.slice(), this.computeSlot = o, a && (a._state = this);
    for (var s = 0; s < this.config.dynamicSlots.length; s++) {
      L_(this, s << 1);
    }
    this.computeSlot = null;
  }
  return zi(e, [{
    key: "field",
    value: function value(e) {
      var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        n = this.config.address[e.id];
      if (null != n) return L_(this, n), B_(this, n);
      if (t) throw new RangeError("Field is not present in this state");
    }
  }, {
    key: "update",
    value: function value() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }
      return n$(this, t, !0);
    }
  }, {
    key: "applyTransaction",
    value: function value(t) {
      var n,
        r,
        i = this,
        o = this.config,
        a = o,
        s = a.base,
        u = a.compartments,
        c = bi(t.effects);
      try {
        for (c.s(); !(n = c.n()).done;) {
          var l = n.value;
          l.is(R_.reconfigure) ? (o && (u = new Map(), o.compartments.forEach(function (e, t) {
            return u.set(t, e);
          }), o = null), u.set(l.value.compartment, l.value.extension)) : l.is(Y_.reconfigure) ? (o = null, s = l.value) : l.is(Y_.appendConfig) && (o = null, s = i$(s).concat(l.value));
        }
      } catch (e) {
        c.e(e);
      } finally {
        c.f();
      }
      o ? r = t.startState.values.slice() : r = new e(o = z_.resolve(s, u, this), this.doc, this.selection, o.dynamicSlots.map(function () {
        return null;
      }), function (e, t) {
        return t.reconfigure(e, i);
      }, null).values;
      new e(o, t.newDoc, t.newSelection, r, function (e, n) {
        return n.update(e, t);
      }, t);
    }
  }, {
    key: "replaceSelection",
    value: function value(e) {
      return "string" == typeof e && (e = this.toText(e)), this.changeByRange(function (t) {
        return {
          changes: {
            from: t.from,
            to: t.to,
            insert: e
          },
          range: b_.cursor(t.from + e.length)
        };
      });
    }
  }, {
    key: "changeByRange",
    value: function value(e) {
      for (var t = this.selection, n = e(t.ranges[0]), r = this.changes(n.changes), i = [n.range], o = i$(n.effects), a = 1; a < t.ranges.length; a++) {
        for (var s = e(t.ranges[a]), u = this.changes(s.changes), c = u.map(r), l = 0; l < a; l++) {
          i[l] = i[l].map(c);
        }
        var f = r.mapDesc(u, !0);
        i.push(s.range.map(f)), r = r.compose(c), o = Y_.mapEffects(o, c).concat(Y_.mapEffects(i$(s.effects), f));
      }
      return {
        changes: r,
        selection: b_.create(i, t.mainIndex),
        effects: o
      };
    }
  }, {
    key: "changes",
    value: function value() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
      return t instanceof f_ ? t : f_.of(t, this.doc.length, this.facet(e.lineSeparator));
    }
  }, {
    key: "toText",
    value: function value(t) {
      return BC.of(t.split(this.facet(e.lineSeparator) || u_));
    }
  }, {
    key: "sliceDoc",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.doc.length;
      return this.doc.sliceString(e, t, this.lineBreak);
    }
  }, {
    key: "facet",
    value: function value(e) {
      var t = this.config.address[e.id];
      return null == t ? e.default : (L_(this, t), B_(this, t));
    }
  }, {
    key: "toJSON",
    value: function value(e) {
      var t = {
        doc: this.sliceDoc(),
        selection: this.selection.toJSON()
      };
      if (e) for (var n in e) {
        var r = e[n];
        r instanceof O_ && (t[n] = r.spec.toJSON(this.field(e[n]), this));
      }
      return t;
    }
  }, {
    key: "tabSize",
    get: function get() {
      return this.facet(e.tabSize);
    }
  }, {
    key: "lineBreak",
    get: function get() {
      return this.facet(e.lineSeparator) || "\n";
    }
  }, {
    key: "readOnly",
    get: function get() {
      return this.facet(J_);
    }
  }, {
    key: "phrase",
    value: function value(t) {
      for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
        r[i - 1] = arguments[i];
      }
      var o,
        a = bi(this.facet(e.phrases));
      try {
        for (a.s(); !(o = a.n()).done;) {
          var s = o.value;
          if (Object.prototype.hasOwnProperty.call(s, t)) {
            t = s[t];
            break;
          }
        }
      } catch (e) {
        a.e(e);
      } finally {
        a.f();
      }
      return r.length && (t = t.replace(/\$(\$|\d*)/g, function (e, t) {
        if ("$" == t) return "$";
        var n = +(t || 1);
        return n > r.length ? e : r[n - 1];
      })), t;
    }
  }, {
    key: "languageDataAt",
    value: function value(e, t) {
      var n,
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1,
        i = [],
        o = bi(this.facet(q_));
      try {
        for (o.s(); !(n = o.n()).done;) {
          var a,
            s = n.value,
            u = bi(s(this, t, r));
          try {
            for (u.s(); !(a = u.n()).done;) {
              var c = a.value;
              Object.prototype.hasOwnProperty.call(c, e) && i.push(c[e]);
            }
          } catch (e) {
            u.e(e);
          } finally {
            u.f();
          }
        }
      } catch (e) {
        o.e(e);
      } finally {
        o.f();
      }
      return i;
    }
  }, {
    key: "charCategorizer",
    value: function value(e) {
      return u$(this.languageDataAt("wordChars", e).join(""));
    }
  }, {
    key: "wordAt",
    value: function value(e) {
      for (var t = this.doc.lineAt(e), n = t.text, r = t.from, i = t.length, o = this.charCategorizer(e), a = e - r, s = e - r; a > 0;) {
        var u = e_(n, a, !1);
        if (o(n.slice(u, a)) != a$.Word) break;
        a = u;
      }
      for (; s < i;) {
        var c = e_(n, s);
        if (o(n.slice(s, c)) != a$.Word) break;
        s = c;
      }
      return a == s ? null : b_.range(a + r, s + r);
    }
  }], [{
    key: "fromJSON",
    value: function value(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = arguments.length > 2 ? arguments[2] : void 0;
      if (!t || "string" != typeof t.doc) throw new RangeError("Invalid JSON representation for EditorState");
      var i = [];
      if (r) {
        var o = function o(e) {
          var n = r[e],
            o = t[e];
          i.push(n.init(function (e) {
            return n.spec.fromJSON(o, e);
          }));
        };
        for (var a in r) {
          o(a);
        }
      }
      return e.create({
        doc: t.doc,
        selection: b_.fromJSON(t.selection),
        extensions: n.extensions ? i.concat([n.extensions]) : i
      });
    }
  }, {
    key: "create",
    value: function value() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        n = z_.resolve(t.extensions || [], new Map()),
        r = t.doc instanceof BC ? t.doc : BC.of((t.doc || "").split(n.staticFacet(e.lineSeparator) || u_)),
        i = t.selection ? t.selection instanceof b_ ? t.selection : b_.single(t.selection.anchor, t.selection.head) : b_.single(0);
      return k_(i, r.length), n.staticFacet(F_) || (i = i.asSingle()), new e(n, r, i, n.dynamicSlots.map(function () {
        return null;
      }), function (e, t) {
        return t.create(e);
      }, null);
    }
  }]), e;
}();
function l$(e, t) {
  var n,
    r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    i = {},
    o = bi(e);
  try {
    for (o.s(); !(n = o.n()).done;) {
      for (var a = n.value, s = 0, u = Object.keys(a); s < u.length; s++) {
        var c = u[s],
          l = a[c],
          f = i[c];
        if (void 0 === f) i[c] = l;else if (f === l || void 0 === l) ;else {
          if (!Object.hasOwnProperty.call(r, c)) throw new Error("Config merge conflict for field " + c);
          i[c] = r[c](f, l);
        }
      }
    }
  } catch (e) {
    o.e(e);
  } finally {
    o.f();
  }
  for (var h in t) {
    void 0 === i[h] && (i[h] = t[h]);
  }
  return i;
}
c$.allowMultipleSelections = F_, c$.tabSize = x_.define({
  combine: function combine(e) {
    return e.length ? e[0] : 4;
  }
}), c$.lineSeparator = V_, c$.readOnly = J_, c$.phrases = x_.define({
  compare: function compare(e, t) {
    var n = Object.keys(e),
      r = Object.keys(t);
    return n.length == r.length && n.every(function (n) {
      return e[n] == t[n];
    });
  }
}), c$.languageData = q_, c$.changeFilter = H_, c$.transactionFilter = W_, c$.transactionExtender = U_, R_.reconfigure = Y_.define();
var f$ = function () {
  function e() {
    Ri(this, e);
  }
  return zi(e, [{
    key: "eq",
    value: function value(e) {
      return this == e;
    }
  }, {
    key: "range",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
      return h$.create(e, t, this);
    }
  }]), e;
}();
f$.prototype.startSide = f$.prototype.endSide = 0, f$.prototype.point = !1, f$.prototype.mapMode = c_.TrackDel;
var h$ = function () {
  function e(t, n, r) {
    Ri(this, e), this.from = t, this.to = n, this.value = r;
  }
  return zi(e, null, [{
    key: "create",
    value: function value(t, n, r) {
      return new e(t, n, r);
    }
  }]), e;
}();
function d$(e, t) {
  return e.from - t.from || e.value.startSide - t.value.startSide;
}
var v$ = function () {
    function e(t, n, r, i) {
      Ri(this, e), this.from = t, this.to = n, this.value = r, this.maxPoint = i;
    }
    return zi(e, [{
      key: "length",
      get: function get() {
        return this.to[this.to.length - 1];
      }
    }, {
      key: "findIndex",
      value: function value(e, t, n) {
        for (var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, i = n ? this.to : this.from, o = r, a = i.length;;) {
          if (o == a) return o;
          var s = o + a >> 1,
            u = i[s] - e || (n ? this.value[s].endSide : this.value[s].startSide) - t;
          if (s == o) return u >= 0 ? o : a;
          u >= 0 ? a = s : o = s + 1;
        }
      }
    }, {
      key: "between",
      value: function value(e, t, n, r) {
        for (var i = this.findIndex(t, -1e9, !0), o = this.findIndex(n, 1e9, !1, i); i < o; i++) {
          if (!1 === r(this.from[i] + e, this.to[i] + e, this.value[i])) return !1;
        }
      }
    }, {
      key: "map",
      value: function value(t, n) {
        for (var r = [], i = [], o = [], a = -1, s = -1, u = 0; u < this.value.length; u++) {
          var c = this.value[u],
            l = this.from[u] + t,
            f = this.to[u] + t,
            h = void 0,
            d = void 0;
          if (l == f) {
            var v = n.mapPos(l, c.startSide, c.mapMode);
            if (null == v) continue;
            if (h = d = v, c.startSide != c.endSide && (d = n.mapPos(l, c.endSide)) < h) continue;
          } else if ((h = n.mapPos(l, c.startSide)) > (d = n.mapPos(f, c.endSide)) || h == d && c.startSide > 0 && c.endSide <= 0) continue;
          (d - h || c.endSide - c.startSide) < 0 || (a < 0 && (a = h), c.point && (s = Math.max(s, d - h)), r.push(c), i.push(h - a), o.push(d - a));
        }
        return {
          mapped: r.length ? new e(i, o, r, s) : null,
          pos: a
        };
      }
    }]), e;
  }(),
  p$ = function () {
    function e(t, n, r, i) {
      Ri(this, e), this.chunkPos = t, this.chunk = n, this.nextLayer = r, this.maxPoint = i;
    }
    return zi(e, [{
      key: "length",
      get: function get() {
        var e = this.chunk.length - 1;
        return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
      }
    }, {
      key: "size",
      get: function get() {
        if (this.isEmpty) return 0;
        var e,
          t = this.nextLayer.size,
          n = bi(this.chunk);
        try {
          for (n.s(); !(e = n.n()).done;) {
            t += e.value.value.length;
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
        return t;
      }
    }, {
      key: "chunkEnd",
      value: function value(e) {
        return this.chunkPos[e] + this.chunk[e].length;
      }
    }, {
      key: "update",
      value: function value(t) {
        var n = t.add,
          r = void 0 === n ? [] : n,
          i = t.sort,
          o = void 0 !== i && i,
          a = t.filterFrom,
          s = void 0 === a ? 0 : a,
          u = t.filterTo,
          c = void 0 === u ? this.length : u,
          l = t.filter;
        if (0 == r.length && !l) return this;
        if (o && (r = r.slice().sort(d$)), this.isEmpty) return r.length ? e.of(r) : this;
        for (var f = new b$(this, null, -1).goto(0), h = 0, d = [], v = new g$(); f.value || h < r.length;) {
          if (h < r.length && (f.from - r[h].from || f.startSide - r[h].value.startSide) >= 0) {
            var p = r[h++];
            v.addInner(p.from, p.to, p.value) || d.push(p);
          } else 1 == f.rangeIndex && f.chunkIndex < this.chunk.length && (h == r.length || this.chunkEnd(f.chunkIndex) < r[h].from) && (!l || s > this.chunkEnd(f.chunkIndex) || c < this.chunkPos[f.chunkIndex]) && v.addChunk(this.chunkPos[f.chunkIndex], this.chunk[f.chunkIndex]) ? f.nextChunk() : ((!l || s > f.to || c < f.from || l(f.from, f.to, f.value)) && (v.addInner(f.from, f.to, f.value) || d.push(h$.create(f.from, f.to, f.value))), f.next());
        }
        return v.finishInner(this.nextLayer.isEmpty && !d.length ? e.empty : this.nextLayer.update({
          add: d,
          filter: l,
          filterFrom: s,
          filterTo: c
        }));
      }
    }, {
      key: "map",
      value: function value(t) {
        if (t.empty || this.isEmpty) return this;
        for (var n = [], r = [], i = -1, o = 0; o < this.chunk.length; o++) {
          var a = this.chunkPos[o],
            s = this.chunk[o],
            u = t.touchesRange(a, a + s.length);
          if (!1 === u) i = Math.max(i, s.maxPoint), n.push(s), r.push(t.mapPos(a));else if (!0 === u) {
            var c = s.map(a, t),
              l = c.mapped,
              f = c.pos;
            l && (i = Math.max(i, l.maxPoint), n.push(l), r.push(f));
          }
        }
        var h = this.nextLayer.map(t);
        return 0 == n.length ? h : new e(r, n, h || e.empty, i);
      }
    }, {
      key: "between",
      value: function value(e, t, n) {
        if (!this.isEmpty) {
          for (var r = 0; r < this.chunk.length; r++) {
            var i = this.chunkPos[r],
              o = this.chunk[r];
            if (t >= i && e <= i + o.length && !1 === o.between(i, e - i, t - i, n)) return;
          }
          this.nextLayer.between(e, t, n);
        }
      }
    }, {
      key: "iter",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
        return k$.from([this]).goto(e);
      }
    }, {
      key: "isEmpty",
      get: function get() {
        return this.nextLayer == this;
      }
    }], [{
      key: "create",
      value: function value(t, n, r, i) {
        return new e(t, n, r, i);
      }
    }, {
      key: "iter",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return k$.from(e).goto(t);
      }
    }, {
      key: "compare",
      value: function value(e, t, n, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : -1,
          o = e.filter(function (e) {
            return e.maxPoint > 0 || !e.isEmpty && e.maxPoint >= i;
          }),
          a = t.filter(function (e) {
            return e.maxPoint > 0 || !e.isEmpty && e.maxPoint >= i;
          }),
          s = y$(o, a, n),
          u = new x$(o, s, i),
          c = new x$(a, s, i);
        n.iterGaps(function (e, t, n) {
          return j$(u, e, c, t, n, r);
        }), n.empty && 0 == n.length && j$(u, 0, c, 0, 0, r);
      }
    }, {
      key: "eq",
      value: function value(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
          r = arguments.length > 3 ? arguments[3] : void 0;
        null == r && (r = 1e9);
        var i = e.filter(function (e) {
            return !e.isEmpty && t.indexOf(e) < 0;
          }),
          o = t.filter(function (t) {
            return !t.isEmpty && e.indexOf(t) < 0;
          });
        if (i.length != o.length) return !1;
        if (!i.length) return !0;
        for (var a = y$(i, o), s = new x$(i, a, 0).goto(n), u = new x$(o, a, 0).goto(n);;) {
          if (s.to != u.to || !S$(s.active, u.active) || s.point && (!u.point || !s.point.eq(u.point))) return !1;
          if (s.to > r) return !0;
          s.next(), u.next();
        }
      }
    }, {
      key: "spans",
      value: function value(e, t, n, r) {
        for (var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : -1, o = new x$(e, null, i).goto(t), a = t, s = o.openStart;;) {
          var u = Math.min(o.to, n);
          if (o.point ? (r.point(a, u, o.point, o.activeForPoint(o.to), s, o.pointRank), s = o.openEnd(u) + (o.to > u ? 1 : 0)) : u > a && (r.span(a, u, o.active, s), s = o.openEnd(u)), o.to > n) break;
          a = o.to, o.next();
        }
        return s;
      }
    }, {
      key: "of",
      value: function value(e) {
        var t,
          n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          r = new g$(),
          i = bi(e instanceof h$ ? [e] : n ? m$(e) : e);
        try {
          for (i.s(); !(t = i.n()).done;) {
            var o = t.value;
            r.add(o.from, o.to, o.value);
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        return r.finish();
      }
    }]), e;
  }();
function m$(e) {
  if (e.length > 1) for (var t = e[0], n = 1; n < e.length; n++) {
    var r = e[n];
    if (d$(t, r) > 0) return e.slice().sort(d$);
    t = r;
  }
  return e;
}
p$.empty = new p$([], [], null, -1), p$.empty.nextLayer = p$.empty;
var g$ = function () {
  function e() {
    Ri(this, e), this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  return zi(e, [{
    key: "finishChunk",
    value: function value(e) {
      this.chunks.push(new v$(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
    }
  }, {
    key: "add",
    value: function value(t, n, r) {
      this.addInner(t, n, r) || (this.nextLayer || (this.nextLayer = new e())).add(t, n, r);
    }
  }, {
    key: "addInner",
    value: function value(e, t, n) {
      var r = e - this.lastTo || n.startSide - this.last.endSide;
      if (r <= 0 && (e - this.lastFrom || n.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
      return !(r < 0) && (250 == this.from.length && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(t - this.chunkStart), this.last = n, this.lastFrom = e, this.lastTo = t, this.value.push(n), n.point && (this.maxPoint = Math.max(this.maxPoint, t - e)), !0);
    }
  }, {
    key: "addChunk",
    value: function value(e, t) {
      if ((e - this.lastTo || t.value[0].startSide - this.last.endSide) < 0) return !1;
      this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, t.maxPoint), this.chunks.push(t), this.chunkPos.push(e);
      var n = t.value.length - 1;
      return this.last = t.value[n], this.lastFrom = t.from[n] + e, this.lastTo = t.to[n] + e, !0;
    }
  }, {
    key: "finish",
    value: function value() {
      return this.finishInner(p$.empty);
    }
  }, {
    key: "finishInner",
    value: function value(e) {
      if (this.from.length && this.finishChunk(!1), 0 == this.chunks.length) return e;
      var t = p$.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
      return this.from = null, t;
    }
  }]), e;
}();
function y$(e, t, n) {
  var r,
    i = new Map(),
    o = bi(e);
  try {
    for (o.s(); !(r = o.n()).done;) {
      for (var a = r.value, s = 0; s < a.chunk.length; s++) {
        a.chunk[s].maxPoint <= 0 && i.set(a.chunk[s], a.chunkPos[s]);
      }
    }
  } catch (e) {
    o.e(e);
  } finally {
    o.f();
  }
  var u,
    c = new Set(),
    l = bi(t);
  try {
    for (l.s(); !(u = l.n()).done;) {
      for (var f = u.value, h = 0; h < f.chunk.length; h++) {
        var d = i.get(f.chunk[h]);
        null == d || (n ? n.mapPos(d) : d) != f.chunkPos[h] || (null == n ? void 0 : n.touchesRange(d, d + f.chunk[h].length)) || c.add(f.chunk[h]);
      }
    }
  } catch (e) {
    l.e(e);
  } finally {
    l.f();
  }
  return c;
}
var b$ = function () {
    function e(t, n, r) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
      Ri(this, e), this.layer = t, this.skip = n, this.minPoint = r, this.rank = i;
    }
    return zi(e, [{
      key: "startSide",
      get: function get() {
        return this.value ? this.value.startSide : 0;
      }
    }, {
      key: "endSide",
      get: function get() {
        return this.value ? this.value.endSide : 0;
      }
    }, {
      key: "goto",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1e9;
        return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, t, !1), this;
      }
    }, {
      key: "gotoInner",
      value: function value(e, t, n) {
        for (; this.chunkIndex < this.layer.chunk.length;) {
          var r = this.layer.chunk[this.chunkIndex];
          if (!(this.skip && this.skip.has(r) || this.layer.chunkEnd(this.chunkIndex) < e || r.maxPoint < this.minPoint)) break;
          this.chunkIndex++, n = !1;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
          var i = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], t, !0);
          (!n || this.rangeIndex < i) && this.setRangeIndex(i);
        }
        this.next();
      }
    }, {
      key: "forward",
      value: function value(e, t) {
        (this.to - e || this.endSide - t) < 0 && this.gotoInner(e, t, !0);
      }
    }, {
      key: "next",
      value: function value() {
        for (;;) {
          if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1e9, this.value = null;
            break;
          }
          var e = this.layer.chunkPos[this.chunkIndex],
            t = this.layer.chunk[this.chunkIndex],
            n = e + t.from[this.rangeIndex];
          if (this.from = n, this.to = e + t.to[this.rangeIndex], this.value = t.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
      }
    }, {
      key: "setRangeIndex",
      value: function value(e) {
        if (e == this.layer.chunk[this.chunkIndex].value.length) {
          if (this.chunkIndex++, this.skip) for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]);) {
            this.chunkIndex++;
          }
          this.rangeIndex = 0;
        } else this.rangeIndex = e;
      }
    }, {
      key: "nextChunk",
      value: function value() {
        this.chunkIndex++, this.rangeIndex = 0, this.next();
      }
    }, {
      key: "compare",
      value: function value(e) {
        return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
      }
    }]), e;
  }(),
  k$ = function () {
    function e(t) {
      Ri(this, e), this.heap = t;
    }
    return zi(e, [{
      key: "startSide",
      get: function get() {
        return this.value ? this.value.startSide : 0;
      }
    }, {
      key: "goto",
      value: function value(e) {
        var t,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1e9,
          r = bi(this.heap);
        try {
          for (r.s(); !(t = r.n()).done;) {
            var i = t.value;
            i.goto(e, n);
          }
        } catch (e) {
          r.e(e);
        } finally {
          r.f();
        }
        for (var o = this.heap.length >> 1; o >= 0; o--) {
          w$(this.heap, o);
        }
        return this.next(), this;
      }
    }, {
      key: "forward",
      value: function value(e, t) {
        var n,
          r = bi(this.heap);
        try {
          for (r.s(); !(n = r.n()).done;) {
            n.value.forward(e, t);
          }
        } catch (e) {
          r.e(e);
        } finally {
          r.f();
        }
        for (var i = this.heap.length >> 1; i >= 0; i--) {
          w$(this.heap, i);
        }
        (this.to - e || this.value.endSide - t) < 0 && this.next();
      }
    }, {
      key: "next",
      value: function value() {
        if (0 == this.heap.length) this.from = this.to = 1e9, this.value = null, this.rank = -1;else {
          var e = this.heap[0];
          this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), w$(this.heap, 0);
        }
      }
    }], [{
      key: "from",
      value: function value(t) {
        for (var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1, i = [], o = 0; o < t.length; o++) {
          for (var a = t[o]; !a.isEmpty; a = a.nextLayer) {
            a.maxPoint >= r && i.push(new b$(a, n, r, o));
          }
        }
        return 1 == i.length ? i[0] : new e(i);
      }
    }]), e;
  }();
function w$(e, t) {
  for (var n = e[t];;) {
    var r = 1 + (t << 1);
    if (r >= e.length) break;
    var i = e[r];
    if (r + 1 < e.length && i.compare(e[r + 1]) >= 0 && (i = e[r + 1], r++), n.compare(i) < 0) break;
    e[r] = n, e[t] = i, t = r;
  }
}
var x$ = function () {
  function e(t, n, r) {
    Ri(this, e), this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = k$.from(t, n, r);
  }
  return zi(e, [{
    key: "goto",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1e9;
      return this.cursor.goto(e, t), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = t, this.openStart = -1, this.next(), this;
    }
  }, {
    key: "forward",
    value: function value(e, t) {
      for (; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - t) < 0;) {
        this.removeActive(this.minActive);
      }
      this.cursor.forward(e, t);
    }
  }, {
    key: "removeActive",
    value: function value(e) {
      C$(this.active, e), C$(this.activeTo, e), C$(this.activeRank, e), this.minActive = $$(this.active, this.activeTo);
    }
  }, {
    key: "addActive",
    value: function value(e) {
      for (var t = 0, n = this.cursor, r = n.value, i = n.to, o = n.rank; t < this.activeRank.length && this.activeRank[t] <= o;) {
        t++;
      }
      _$(this.active, t, r), _$(this.activeTo, t, i), _$(this.activeRank, t, o), e && _$(e, t, this.cursor.from), this.minActive = $$(this.active, this.activeTo);
    }
  }, {
    key: "next",
    value: function value() {
      var e = this.to,
        t = this.point;
      this.point = null;
      for (var n = this.openStart < 0 ? [] : null, r = 0;;) {
        var i = this.minActive;
        if (i > -1 && (this.activeTo[i] - this.cursor.from || this.active[i].endSide - this.cursor.startSide) < 0) {
          if (this.activeTo[i] > e) {
            this.to = this.activeTo[i], this.endSide = this.active[i].endSide;
            break;
          }
          this.removeActive(i), n && C$(n, i);
        } else {
          if (!this.cursor.value) {
            this.to = this.endSide = 1e9;
            break;
          }
          if (this.cursor.from > e) {
            this.to = this.cursor.from, this.endSide = this.cursor.startSide;
            break;
          }
          var o = this.cursor.value;
          if (o.point) {
            if (!(t && this.cursor.to == this.to && this.cursor.from < this.cursor.to)) {
              this.point = o, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = o.endSide, this.cursor.from < e && (r = 1), this.cursor.next(), this.forward(this.to, this.endSide);
              break;
            }
            this.cursor.next();
          } else this.addActive(n), this.cursor.next();
        }
      }
      if (n) {
        for (var a = 0; a < n.length && n[a] < e;) {
          a++;
        }
        this.openStart = a + r;
      }
    }
  }, {
    key: "activeForPoint",
    value: function value(e) {
      if (!this.active.length) return this.active;
      for (var t = [], n = this.active.length - 1; n >= 0 && !(this.activeRank[n] < this.pointRank); n--) {
        (this.activeTo[n] > e || this.activeTo[n] == e && this.active[n].endSide >= this.point.endSide) && t.push(this.active[n]);
      }
      return t.reverse();
    }
  }, {
    key: "openEnd",
    value: function value(e) {
      for (var t = 0, n = this.activeTo.length - 1; n >= 0 && this.activeTo[n] > e; n--) {
        t++;
      }
      return t;
    }
  }]), e;
}();
function j$(e, t, n, r, i, o) {
  e.goto(t), n.goto(r);
  for (var a = r + i, s = r, u = r - t;;) {
    var c = e.to + u - n.to || e.endSide - n.endSide,
      l = c < 0 ? e.to + u : n.to,
      f = Math.min(l, a);
    if (e.point || n.point ? e.point && n.point && (e.point == n.point || e.point.eq(n.point)) && S$(e.activeForPoint(e.to + u), n.activeForPoint(n.to)) || o.comparePoint(s, f, e.point, n.point) : f > s && !S$(e.active, n.active) && o.compareRange(s, f, e.active, n.active), l > a) break;
    s = l, c <= 0 && e.next(), c >= 0 && n.next();
  }
}
function S$(e, t) {
  if (e.length != t.length) return !1;
  for (var n = 0; n < e.length; n++) {
    if (e[n] != t[n] && !e[n].eq(t[n])) return !1;
  }
  return !0;
}
function C$(e, t) {
  for (var n = t, r = e.length - 1; n < r; n++) {
    e[n] = e[n + 1];
  }
  e.pop();
}
function _$(e, t, n) {
  for (var r = e.length - 1; r >= t; r--) {
    e[r + 1] = e[r];
  }
  e[t] = n;
}
function $$(e, t) {
  for (var n = -1, r = 1e9, i = 0; i < t.length; i++) {
    (t[i] - r || e[i].endSide - e[n].endSide) < 0 && (n = i, r = t[i]);
  }
  return n;
}
function O$(e, t) {
  for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.length, r = 0, i = 0; i < n;) {
    9 == e.charCodeAt(i) ? (r += t - r % t, i++) : (r++, i = e_(e, i));
  }
  return r;
}
function A$(e, t, n, r) {
  for (var i = 0, o = 0;;) {
    if (o >= t) return i;
    if (i == e.length) break;
    o += 9 == e.charCodeAt(i) ? n - o % n : 1, i = e_(e, i);
  }
  return !0 === r ? -1 : e.length;
}
for (var E$ = "undefined" == typeof Symbol ? "__ͼ" : Symbol.for("ͼ"), P$ = "undefined" == typeof Symbol ? "__styleSet" + Math.floor(1e8 * Math.random()) : Symbol("styleSet"), M$ = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : {}, I$ = function () {
    function e(t, n) {
      Ri(this, e), this.rules = [];
      var r = (n || {}).finish;
      function i(e) {
        return /^@/.test(e) ? [e] : e.split(/,\s*/);
      }
      function o(e, t, n, a) {
        var s = [],
          u = /^@(\w+)\b/.exec(e[0]),
          c = u && "keyframes" == u[1];
        if (u && null == t) return n.push(e[0] + ";");
        for (var l in t) {
          var f = t[l];
          if (/&/.test(l)) o(l.split(/,\s*/).map(function (t) {
            return e.map(function (e) {
              return t.replace(/&/, e);
            });
          }).reduce(function (e, t) {
            return e.concat(t);
          }), f, n);else if (f && "object" == Li(f)) {
            if (!u) throw new RangeError("The value of a property (" + l + ") should be a primitive value.");
            o(i(l), f, s, c);
          } else null != f && s.push(l.replace(/_.*/, "").replace(/[A-Z]/g, function (e) {
            return "-" + e.toLowerCase();
          }) + ": " + f + ";");
        }
        (s.length || c) && n.push((!r || u || a ? e : e.map(r)).join(", ") + " {" + s.join(" ") + "}");
      }
      for (var a in t) {
        o(i(a), t[a], this.rules);
      }
    }
    return zi(e, [{
      key: "getRules",
      value: function value() {
        return this.rules.join("\n");
      }
    }], [{
      key: "newName",
      value: function value() {
        var e = M$[E$] || 1;
        return M$[E$] = e + 1, "ͼ" + e.toString(36);
      }
    }, {
      key: "mount",
      value: function value(e, t) {
        (e[P$] || new N$(e)).mount(Array.isArray(t) ? t : [t]);
      }
    }]), e;
  }(), T$ = null, N$ = function () {
    function e(t) {
      if (Ri(this, e), !t.head && t.adoptedStyleSheets && "undefined" != typeof CSSStyleSheet) {
        if (T$) return t.adoptedStyleSheets = [T$.sheet].concat(t.adoptedStyleSheets), t[P$] = T$;
        this.sheet = new CSSStyleSheet(), t.adoptedStyleSheets = [this.sheet].concat(t.adoptedStyleSheets), T$ = this;
      } else {
        this.styleTag = (t.ownerDocument || t).createElement("style");
        var n = t.head || t;
        n.insertBefore(this.styleTag, n.firstChild);
      }
      this.modules = [], t[P$] = this;
    }
    return zi(e, [{
      key: "mount",
      value: function value(e) {
        for (var t = this.sheet, n = 0, r = 0, i = 0; i < e.length; i++) {
          var o = e[i],
            a = this.modules.indexOf(o);
          if (a < r && a > -1 && (this.modules.splice(a, 1), r--, a = -1), -1 == a) {
            if (this.modules.splice(r++, 0, o), t) for (var s = 0; s < o.rules.length; s++) {
              t.insertRule(o.rules[s], n++);
            }
          } else {
            for (; r < a;) {
              n += this.modules[r++].rules.length;
            }
            n += o.rules.length, r++;
          }
        }
        if (!t) {
          for (var u = "", c = 0; c < this.modules.length; c++) {
            u += this.modules[c].getRules() + "\n";
          }
          this.styleTag.textContent = u;
        }
      }
    }]), e;
  }(), R$ = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'",
    229: "q"
  }, D$ = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"',
    229: "Q"
  }, z$ = "undefined" != typeof navigator && /Chrome\/(\d+)/.exec(navigator.userAgent), L$ = "undefined" != typeof navigator && /Apple Computer/.test(navigator.vendor), B$ = "undefined" != typeof navigator && /Gecko\/\d+/.test(navigator.userAgent), q$ = "undefined" != typeof navigator && /Mac/.test(navigator.platform), F$ = "undefined" != typeof navigator && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent), V$ = z$ && (q$ || +z$[1] < 57) || B$ && q$, H$ = 0; H$ < 10; H$++) {
  R$[48 + H$] = R$[96 + H$] = String(H$);
}
for (H$ = 1; H$ <= 24; H$++) {
  R$[H$ + 111] = "F" + H$;
}
for (H$ = 65; H$ <= 90; H$++) {
  R$[H$] = String.fromCharCode(H$ + 32), D$[H$] = String.fromCharCode(H$);
}
for (var W$ in R$) {
  D$.hasOwnProperty(W$) || (D$[W$] = R$[W$]);
}
function U$(e) {
  return (11 == e.nodeType ? e.getSelection ? e : e.ownerDocument : e).getSelection();
}
function J$(e, t) {
  return !!t && (e == t || e.contains(1 != t.nodeType ? t.parentNode : t));
}
function K$(e, t) {
  if (!t.anchorNode) return !1;
  try {
    return J$(e, t.anchorNode);
  } catch (e) {
    return !1;
  }
}
function G$(e) {
  return 3 == e.nodeType ? sO(e, 0, e.nodeValue.length).getClientRects() : 1 == e.nodeType ? e.getClientRects() : [];
}
function Q$(e, t, n, r) {
  return !!n && (Z$(e, t, n, r, -1) || Z$(e, t, n, r, 1));
}
function Y$(e) {
  for (var t = 0;; t++) {
    if (!(e = e.previousSibling)) return t;
  }
}
function Z$(e, t, n, r, i) {
  for (;;) {
    if (e == n && t == r) return !0;
    if (t == (i < 0 ? 0 : X$(e))) {
      if ("DIV" == e.nodeName) return !1;
      var o = e.parentNode;
      if (!o || 1 != o.nodeType) return !1;
      t = Y$(e) + (i < 0 ? 0 : 1), e = o;
    } else {
      if (1 != e.nodeType) return !1;
      if (1 == (e = e.childNodes[t + (i < 0 ? -1 : 0)]).nodeType && "false" == e.contentEditable) return !1;
      t = i < 0 ? X$(e) : 0;
    }
  }
}
function X$(e) {
  return 3 == e.nodeType ? e.nodeValue.length : e.childNodes.length;
}
var eO = {
  left: 0,
  right: 0,
  top: 0,
  bottom: 0
};
function tO(e, t) {
  var n = t ? e.left : e.right;
  return {
    left: n,
    right: n,
    top: e.top,
    bottom: e.bottom
  };
}
function nO(e) {
  return {
    left: 0,
    right: e.innerWidth,
    top: 0,
    bottom: e.innerHeight
  };
}
var rO,
  iO = function () {
    function e() {
      Ri(this, e), this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
    }
    return zi(e, [{
      key: "eq",
      value: function value(e) {
        return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
      }
    }, {
      key: "setRange",
      value: function value(e) {
        this.set(e.anchorNode, e.anchorOffset, e.focusNode, e.focusOffset);
      }
    }, {
      key: "set",
      value: function value(e, t, n, r) {
        this.anchorNode = e, this.anchorOffset = t, this.focusNode = n, this.focusOffset = r;
      }
    }]), e;
  }(),
  oO = null;
function aO(e) {
  if (e.setActive) return e.setActive();
  if (oO) return e.focus(oO);
  for (var t = [], n = e; n && (t.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode) {
    ;
  }
  if (e.focus(null == oO ? {
    get preventScroll() {
      return oO = {
        preventScroll: !0
      }, !0;
    }
  } : void 0), !oO) {
    oO = !1;
    for (var r = 0; r < t.length;) {
      var i = t[r++],
        o = t[r++],
        a = t[r++];
      i.scrollTop != o && (i.scrollTop = o), i.scrollLeft != a && (i.scrollLeft = a);
    }
  }
}
function sO(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t,
    r = rO || (rO = document.createRange());
  return r.setEnd(e, n), r.setStart(e, t), r;
}
function uO(e, t, n) {
  var r = {
      key: t,
      code: t,
      keyCode: n,
      which: n,
      cancelable: !0
    },
    i = new KeyboardEvent("keydown", r);
  i.synthetic = !0, e.dispatchEvent(i);
  var o = new KeyboardEvent("keyup", r);
  return o.synthetic = !0, e.dispatchEvent(o), i.defaultPrevented || o.defaultPrevented;
}
function cO(e) {
  for (; e;) {
    if (e && (9 == e.nodeType || 11 == e.nodeType && e.host)) return e;
    e = e.assignedSlot || e.parentNode;
  }
  return null;
}
function lO(e) {
  for (; e.attributes.length;) {
    e.removeAttributeNode(e.attributes[0]);
  }
}
var fO = function () {
    function e(t, n) {
      var r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
      Ri(this, e), this.node = t, this.offset = n, this.precise = r;
    }
    return zi(e, null, [{
      key: "before",
      value: function value(t, n) {
        return new e(t.parentNode, Y$(t), n);
      }
    }, {
      key: "after",
      value: function value(t, n) {
        return new e(t.parentNode, Y$(t) + 1, n);
      }
    }]), e;
  }(),
  hO = [],
  dO = function () {
    function e() {
      Ri(this, e), this.parent = null, this.dom = null, this.dirty = 2;
    }
    return zi(e, [{
      key: "editorView",
      get: function get() {
        if (!this.parent) throw new Error("Accessing view in orphan content view");
        return this.parent.editorView;
      }
    }, {
      key: "overrideDOMText",
      get: function get() {
        return null;
      }
    }, {
      key: "posAtStart",
      get: function get() {
        return this.parent ? this.parent.posBefore(this) : 0;
      }
    }, {
      key: "posAtEnd",
      get: function get() {
        return this.posAtStart + this.length;
      }
    }, {
      key: "posBefore",
      value: function value(e) {
        var t,
          n = this.posAtStart,
          r = bi(this.children);
        try {
          for (r.s(); !(t = r.n()).done;) {
            var i = t.value;
            if (i == e) return n;
            n += i.length + i.breakAfter;
          }
        } catch (e) {
          r.e(e);
        } finally {
          r.f();
        }
        throw new RangeError("Invalid child in posBefore");
      }
    }, {
      key: "posAfter",
      value: function value(e) {
        return this.posBefore(e) + e.length;
      }
    }, {
      key: "coordsAt",
      value: function value(e, t) {
        return null;
      }
    }, {
      key: "sync",
      value: function value(t) {
        if (2 & this.dirty) {
          var n,
            r,
            i = this.dom,
            o = null,
            a = bi(this.children);
          try {
            for (a.s(); !(r = a.n()).done;) {
              var s = r.value;
              if (s.dirty) {
                if (!s.dom && (n = o ? o.nextSibling : i.firstChild)) {
                  var u = e.get(n);
                  u && (u.parent || u.constructor != s.constructor) || s.reuseDOM(n);
                }
                s.sync(t), s.dirty = 0;
              }
              if (n = o ? o.nextSibling : i.firstChild, t && !t.written && t.node == i && n != s.dom && (t.written = !0), s.dom.parentNode == i) for (; n && n != s.dom;) {
                n = vO(n);
              } else i.insertBefore(s.dom, n);
              o = s.dom;
            }
          } catch (e) {
            a.e(e);
          } finally {
            a.f();
          }
          for ((n = o ? o.nextSibling : i.firstChild) && t && t.node == i && (t.written = !0); n;) {
            n = vO(n);
          }
        } else if (1 & this.dirty) {
          var c,
            l = bi(this.children);
          try {
            for (l.s(); !(c = l.n()).done;) {
              var f = c.value;
              f.dirty && (f.sync(t), f.dirty = 0);
            }
          } catch (e) {
            l.e(e);
          } finally {
            l.f();
          }
        }
      }
    }, {
      key: "reuseDOM",
      value: function value(e) {}
    }, {
      key: "localPosFromDOM",
      value: function value(t, n) {
        var r;
        if (t == this.dom) r = this.dom.childNodes[n];else {
          for (var i = 0 == X$(t) ? 0 : 0 == n ? -1 : 1;;) {
            var o = t.parentNode;
            if (o == this.dom) break;
            0 == i && o.firstChild != o.lastChild && (i = t == o.firstChild ? -1 : 1), t = o;
          }
          r = i < 0 ? t : t.nextSibling;
        }
        if (r == this.dom.firstChild) return 0;
        for (; r && !e.get(r);) {
          r = r.nextSibling;
        }
        if (!r) return this.length;
        for (var a = 0, s = 0;; a++) {
          var u = this.children[a];
          if (u.dom == r) return s;
          s += u.length + u.breakAfter;
        }
      }
    }, {
      key: "domBoundsAround",
      value: function value(e, t) {
        for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = -1, i = -1, o = -1, a = -1, s = 0, u = n, c = n; s < this.children.length; s++) {
          var l = this.children[s],
            f = u + l.length;
          if (u < e && f > t) return l.domBoundsAround(e, t, u);
          if (f >= e && -1 == r && (r = s, i = u), u > t && l.dom.parentNode == this.dom) {
            o = s, a = c;
            break;
          }
          c = f, u = f + l.breakAfter;
        }
        return {
          from: i,
          to: a < 0 ? n + this.length : a,
          startDOM: (r ? this.children[r - 1].dom.nextSibling : null) || this.dom.firstChild,
          endDOM: o < this.children.length && o >= 0 ? this.children[o].dom : null
        };
      }
    }, {
      key: "markDirty",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.dirty |= 2, this.markParentsDirty(e);
      }
    }, {
      key: "markParentsDirty",
      value: function value(e) {
        for (var t = this.parent; t; t = t.parent) {
          if (e && (t.dirty |= 2), 1 & t.dirty) return;
          t.dirty |= 1, e = !1;
        }
      }
    }, {
      key: "setParent",
      value: function value(e) {
        this.parent != e && (this.parent = e, this.dirty && this.markParentsDirty(!0));
      }
    }, {
      key: "setDOM",
      value: function value(e) {
        this.dom && (this.dom.cmView = null), this.dom = e, e.cmView = this;
      }
    }, {
      key: "rootView",
      get: function get() {
        for (var e = this;;) {
          var t = e.parent;
          if (!t) return e;
          e = t;
        }
      }
    }, {
      key: "replaceChildren",
      value: function value(e, t) {
        var n,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : hO;
        this.markDirty();
        for (var i = e; i < t; i++) {
          var o = this.children[i];
          o.parent == this && o.destroy();
        }
        (n = this.children).splice.apply(n, [e, t - e].concat(Ii(r)));
        for (var a = 0; a < r.length; a++) {
          r[a].setParent(this);
        }
      }
    }, {
      key: "ignoreMutation",
      value: function value(e) {
        return !1;
      }
    }, {
      key: "ignoreEvent",
      value: function value(e) {
        return !1;
      }
    }, {
      key: "childCursor",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.length;
        return new pO(this.children, e, this.children.length);
      }
    }, {
      key: "childPos",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
        return this.childCursor().findPos(e, t);
      }
    }, {
      key: "toString",
      value: function value() {
        var e = this.constructor.name.replace("View", "");
        return e + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + ("Text" == e ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
      }
    }, {
      key: "isEditable",
      get: function get() {
        return !0;
      }
    }, {
      key: "merge",
      value: function value(e, t, n, r, i, o) {
        return !1;
      }
    }, {
      key: "become",
      value: function value(e) {
        return !1;
      }
    }, {
      key: "getSide",
      value: function value() {
        return 0;
      }
    }, {
      key: "destroy",
      value: function value() {
        this.parent = null;
      }
    }], [{
      key: "get",
      value: function value(e) {
        return e.cmView;
      }
    }]), e;
  }();
function vO(e) {
  var t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
dO.prototype.breakAfter = 0;
var pO = function () {
  function e(t, n, r) {
    Ri(this, e), this.children = t, this.pos = n, this.i = r, this.off = 0;
  }
  return zi(e, [{
    key: "findPos",
    value: function value(e) {
      for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;;) {
        if (e > this.pos || e == this.pos && (t > 0 || 0 == this.i || this.children[this.i - 1].breakAfter)) return this.off = e - this.pos, this;
        var n = this.children[--this.i];
        this.pos -= n.length + n.breakAfter;
      }
    }
  }]), e;
}();
function mO(e, t, n, r, i, o, a, s, u) {
  var c = e.children,
    l = c.length ? c[t] : null,
    f = o.length ? o[o.length - 1] : null,
    h = f ? f.breakAfter : a;
  if (!(t == r && l && !a && !h && o.length < 2 && l.merge(n, i, o.length ? f : null, 0 == n, s, u))) {
    if (r < c.length) {
      var d = c[r];
      d && i < d.length ? (t == r && (d = d.split(i), i = 0), !h && f && d.merge(0, i, f, !0, 0, u) ? o[o.length - 1] = d : (i && d.merge(0, i, null, !1, 0, u), o.push(d))) : (null == d ? void 0 : d.breakAfter) && (f ? f.breakAfter = 1 : a = 1), r++;
    }
    for (l && (l.breakAfter = a, n > 0 && (!a && o.length && l.merge(n, l.length, o[0], !1, s, 0) ? l.breakAfter = o.shift().breakAfter : (n < l.length || l.children.length && 0 == l.children[l.children.length - 1].length) && l.merge(n, l.length, null, !1, s, 0), t++)); t < r && o.length;) {
      if (c[r - 1].become(o[o.length - 1])) r--, o.pop(), u = o.length ? 0 : s;else {
        if (!c[t].become(o[0])) break;
        t++, o.shift(), s = o.length ? 0 : u;
      }
    }
    !o.length && t && r < c.length && !c[t - 1].breakAfter && c[r].merge(0, 0, c[t - 1], !1, s, u) && t--, (t < r || o.length) && e.replaceChildren(t, r, o);
  }
}
function gO(e, t, n, r, i, o) {
  var a,
    s = e.childCursor(),
    u = s.findPos(n, 1),
    c = u.i,
    l = u.off,
    f = s.findPos(t, -1),
    h = f.i,
    d = f.off,
    v = t - n,
    p = bi(r);
  try {
    for (p.s(); !(a = p.n()).done;) {
      v += a.value.length;
    }
  } catch (e) {
    p.e(e);
  } finally {
    p.f();
  }
  e.length += v, mO(e, h, d, c, l, r, 0, i, o);
}
var yO = "undefined" != typeof navigator ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
  },
  bO = "undefined" != typeof document ? document : {
    documentElement: {
      style: {}
    }
  },
  kO = /Edge\/(\d+)/.exec(yO.userAgent),
  wO = /MSIE \d/.test(yO.userAgent),
  xO = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(yO.userAgent),
  jO = !!(wO || xO || kO),
  SO = !jO && /gecko\/(\d+)/i.test(yO.userAgent),
  CO = !jO && /Chrome\/(\d+)/.exec(yO.userAgent),
  _O = ("webkitFontSmoothing" in bO.documentElement.style),
  $O = !jO && /Apple Computer/.test(yO.vendor),
  OO = $O && (/Mobile\/\w+/.test(yO.userAgent) || yO.maxTouchPoints > 2),
  AO = {
    mac: OO || /Mac/.test(yO.platform),
    windows: /Win/.test(yO.platform),
    linux: /Linux|X11/.test(yO.platform),
    ie: jO,
    ie_version: wO ? bO.documentMode || 6 : xO ? +xO[1] : kO ? +kO[1] : 0,
    gecko: SO,
    gecko_version: SO ? +(/Firefox\/(\d+)/.exec(yO.userAgent) || [0, 0])[1] : 0,
    chrome: !!CO,
    chrome_version: CO ? +CO[1] : 0,
    ios: OO,
    android: /Android\b/.test(yO.userAgent),
    webkit: _O,
    safari: $O,
    webkit_version: _O ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0,
    tabSize: null != bO.documentElement.style.tabSize ? "tab-size" : "-moz-tab-size"
  },
  EO = function (e) {
    ji(n, dO);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), (r = t.call(this)).text = e, r;
    }
    return zi(n, [{
      key: "length",
      get: function get() {
        return this.text.length;
      }
    }, {
      key: "createDOM",
      value: function value(e) {
        this.setDOM(e || document.createTextNode(this.text));
      }
    }, {
      key: "sync",
      value: function value(e) {
        this.dom || this.createDOM(), this.dom.nodeValue != this.text && (e && e.node == this.dom && (e.written = !0), this.dom.nodeValue = this.text);
      }
    }, {
      key: "reuseDOM",
      value: function value(e) {
        3 == e.nodeType && this.createDOM(e);
      }
    }, {
      key: "merge",
      value: function value(e, t, r) {
        return (!r || r instanceof n && !(this.length - (t - e) + r.length > 256)) && (this.text = this.text.slice(0, e) + (r ? r.text : "") + this.text.slice(t), this.markDirty(), !0);
      }
    }, {
      key: "split",
      value: function value(e) {
        var t = new n(this.text.slice(e));
        return this.text = this.text.slice(0, e), this.markDirty(), t;
      }
    }, {
      key: "localPosFromDOM",
      value: function value(e, t) {
        return e == this.dom ? t : t ? this.text.length : 0;
      }
    }, {
      key: "domAtPos",
      value: function value(e) {
        return new fO(this.dom, e);
      }
    }, {
      key: "domBoundsAround",
      value: function value(e, t, n) {
        return {
          from: n,
          to: n + this.length,
          startDOM: this.dom,
          endDOM: this.dom.nextSibling
        };
      }
    }, {
      key: "coordsAt",
      value: function value(e, t) {
        return MO(this.dom, e, t);
      }
    }]), n;
  }(),
  PO = function (e) {
    ji(n, dO);
    var t = Ci(n);
    function n(e) {
      var r,
        i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
        o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
      Ri(this, n), (r = t.call(this)).mark = e, r.children = i, r.length = o;
      var a,
        s = bi(i);
      try {
        for (s.s(); !(a = s.n()).done;) {
          var u = a.value;
          u.setParent($i(r));
        }
      } catch (e) {
        s.e(e);
      } finally {
        s.f();
      }
      return r;
    }
    return zi(n, [{
      key: "setAttrs",
      value: function value(e) {
        if (lO(e), this.mark.class && (e.className = this.mark.class), this.mark.attrs) for (var t in this.mark.attrs) {
          e.setAttribute(t, this.mark.attrs[t]);
        }
        return e;
      }
    }, {
      key: "reuseDOM",
      value: function value(e) {
        e.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(e), this.dirty |= 6);
      }
    }, {
      key: "sync",
      value: function value(e) {
        this.dom ? 4 & this.dirty && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), ki(Ai(n.prototype), "sync", this).call(this, e);
      }
    }, {
      key: "merge",
      value: function value(e, t, r, i, o, a) {
        return (!r || !(!(r instanceof n && r.mark.eq(this.mark)) || e && o <= 0 || t < this.length && a <= 0)) && (gO(this, e, t, r ? r.children : [], o - 1, a - 1), this.markDirty(), !0);
      }
    }, {
      key: "split",
      value: function value(e) {
        var t,
          r = [],
          i = 0,
          o = -1,
          a = 0,
          s = bi(this.children);
        try {
          for (s.s(); !(t = s.n()).done;) {
            var u = t.value,
              c = i + u.length;
            c > e && r.push(i < e ? u.split(e - i) : u), o < 0 && i >= e && (o = a), i = c, a++;
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
        var l = this.length - e;
        return this.length = e, o > -1 && (this.children.length = o, this.markDirty()), new n(this.mark, r, l);
      }
    }, {
      key: "domAtPos",
      value: function value(e) {
        return zO(this.dom, this.children, e);
      }
    }, {
      key: "coordsAt",
      value: function value(e, t) {
        return BO(this, e, t);
      }
    }]), n;
  }();
function MO(e, t, n) {
  var r = e.nodeValue.length;
  t > r && (t = r);
  var i = t,
    o = t,
    a = 0;
  0 == t && n < 0 || t == r && n >= 0 ? AO.chrome || AO.gecko || (t ? (i--, a = 1) : o < r && (o++, a = -1)) : n < 0 ? i-- : o < r && o++;
  var s = sO(e, i, o).getClientRects();
  if (!s.length) return eO;
  var u = s[(a ? a < 0 : n >= 0) ? 0 : s.length - 1];
  return AO.safari && !a && 0 == u.width && (u = Array.prototype.find.call(s, function (e) {
    return e.width;
  }) || u), a ? tO(u, a < 0) : u || null;
}
var IO = function (e) {
    ji(n, dO);
    var t = Ci(n);
    function n(e, r, i) {
      var o;
      return Ri(this, n), (o = t.call(this)).widget = e, o.length = r, o.side = i, o.prevWidget = null, o;
    }
    return zi(n, [{
      key: "split",
      value: function value(e) {
        var t = n.create(this.widget, this.length - e, this.side);
        return this.length -= e, t;
      }
    }, {
      key: "sync",
      value: function value() {
        this.dom && this.widget.updateDOM(this.dom) || (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(this.editorView)), this.dom.contentEditable = "false");
      }
    }, {
      key: "getSide",
      value: function value() {
        return this.side;
      }
    }, {
      key: "merge",
      value: function value(e, t, r, i, o, a) {
        return !(r && (!(r instanceof n && this.widget.compare(r.widget)) || e > 0 && o <= 0 || t < this.length && a <= 0)) && (this.length = e + (r ? r.length : 0) + (this.length - t), !0);
      }
    }, {
      key: "become",
      value: function value(e) {
        return e.length == this.length && e instanceof n && e.side == this.side && this.widget.constructor == e.widget.constructor && (this.widget.eq(e.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, !0);
      }
    }, {
      key: "ignoreMutation",
      value: function value() {
        return !0;
      }
    }, {
      key: "ignoreEvent",
      value: function value(e) {
        return this.widget.ignoreEvent(e);
      }
    }, {
      key: "overrideDOMText",
      get: function get() {
        if (0 == this.length) return BC.empty;
        for (var e = this; e.parent;) {
          e = e.parent;
        }
        var t = e.editorView,
          n = t && t.state.doc,
          r = this.posAtStart;
        return n ? n.slice(r, r + this.length) : BC.empty;
      }
    }, {
      key: "domAtPos",
      value: function value(e) {
        return 0 == e ? fO.before(this.dom) : fO.after(this.dom, e == this.length);
      }
    }, {
      key: "domBoundsAround",
      value: function value() {
        return null;
      }
    }, {
      key: "coordsAt",
      value: function value(e, t) {
        var n = this.dom.getClientRects(),
          r = null;
        if (!n.length) return eO;
        for (var i = e > 0 ? n.length - 1 : 0; r = n[i], !(e > 0 ? 0 == i : i == n.length - 1 || r.top < r.bottom); i += e > 0 ? -1 : 1) {
          ;
        }
        return 0 == e && t > 0 || e == this.length && t <= 0 ? r : tO(r, 0 == e);
      }
    }, {
      key: "isEditable",
      get: function get() {
        return !1;
      }
    }, {
      key: "destroy",
      value: function value() {
        ki(Ai(n.prototype), "destroy", this).call(this), this.dom && this.widget.destroy(this.dom);
      }
    }], [{
      key: "create",
      value: function value(e, t, r) {
        return new (e.customView || n)(e, t, r);
      }
    }]), n;
  }(),
  TO = function (e) {
    ji(n, IO);
    var t = Ci(n);
    function n() {
      return Ri(this, n), t.apply(this, arguments);
    }
    return zi(n, [{
      key: "domAtPos",
      value: function value(e) {
        var t = this.widget,
          n = t.topView,
          r = t.text;
        return n ? NO(e, 0, n, r, function (e, t) {
          return e.domAtPos(t);
        }, function (e) {
          return new fO(r, Math.min(e, r.nodeValue.length));
        }) : new fO(r, Math.min(e, r.nodeValue.length));
      }
    }, {
      key: "sync",
      value: function value() {
        this.setDOM(this.widget.toDOM());
      }
    }, {
      key: "localPosFromDOM",
      value: function value(e, t) {
        var n = this.widget,
          r = n.topView,
          i = n.text;
        return r ? RO(e, t, r, i) : Math.min(t, this.length);
      }
    }, {
      key: "ignoreMutation",
      value: function value() {
        return !1;
      }
    }, {
      key: "overrideDOMText",
      get: function get() {
        return null;
      }
    }, {
      key: "coordsAt",
      value: function value(e, t) {
        var n = this.widget,
          r = n.topView,
          i = n.text;
        return r ? NO(e, t, r, i, function (e, t, n) {
          return e.coordsAt(t, n);
        }, function (e, t) {
          return MO(i, e, t);
        }) : MO(i, e, t);
      }
    }, {
      key: "destroy",
      value: function value() {
        var e;
        ki(Ai(n.prototype), "destroy", this).call(this), null === (e = this.widget.topView) || void 0 === e || e.destroy();
      }
    }, {
      key: "isEditable",
      get: function get() {
        return !0;
      }
    }]), n;
  }();
function NO(e, t, n, r, i, o) {
  if (n instanceof PO) {
    var a,
      s = bi(n.children);
    try {
      for (s.s(); !(a = s.n()).done;) {
        var u = a.value,
          c = J$(u.dom, r),
          l = c ? r.nodeValue.length : u.length;
        if (e < l || e == l && u.getSide() <= 0) return c ? NO(e, t, u, r, i, o) : i(u, e, t);
        e -= l;
      }
    } catch (e) {
      s.e(e);
    } finally {
      s.f();
    }
    return i(n, n.length, -1);
  }
  return n.dom == r ? o(e, t) : i(n, e, t);
}
function RO(e, t, n, r) {
  if (n instanceof PO) {
    var i,
      o = bi(n.children);
    try {
      for (o.s(); !(i = o.n()).done;) {
        var a = i.value,
          s = 0,
          u = J$(a.dom, r);
        if (J$(a.dom, e)) return s + (u ? RO(e, t, a, r) : a.localPosFromDOM(e, t));
        s += u ? r.nodeValue.length : a.length;
      }
    } catch (e) {
      o.e(e);
    } finally {
      o.f();
    }
  } else if (n.dom == r) return Math.min(t, r.nodeValue.length);
  return n.localPosFromDOM(e, t);
}
var DO = function (e) {
  ji(n, dO);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), (r = t.call(this)).side = e, r;
  }
  return zi(n, [{
    key: "length",
    get: function get() {
      return 0;
    }
  }, {
    key: "merge",
    value: function value() {
      return !1;
    }
  }, {
    key: "become",
    value: function value(e) {
      return e instanceof n && e.side == this.side;
    }
  }, {
    key: "split",
    value: function value() {
      return new n(this.side);
    }
  }, {
    key: "sync",
    value: function value() {
      if (!this.dom) {
        var e = document.createElement("img");
        e.className = "cm-widgetBuffer", e.setAttribute("aria-hidden", "true"), this.setDOM(e);
      }
    }
  }, {
    key: "getSide",
    value: function value() {
      return this.side;
    }
  }, {
    key: "domAtPos",
    value: function value(e) {
      return fO.before(this.dom);
    }
  }, {
    key: "localPosFromDOM",
    value: function value() {
      return 0;
    }
  }, {
    key: "domBoundsAround",
    value: function value() {
      return null;
    }
  }, {
    key: "coordsAt",
    value: function value(e) {
      var t = this.dom.getBoundingClientRect(),
        n = function (e, t) {
          var n = e.parent,
            r = n ? n.children.indexOf(e) : -1;
          for (; n && r >= 0;) {
            if (t < 0 ? r > 0 : r < n.children.length) {
              var i = n.children[r + t];
              if (i instanceof EO) {
                var o = i.coordsAt(t < 0 ? i.length : 0, t);
                if (o) return o;
              }
              r += t;
            } else {
              if (!(n instanceof PO && n.parent)) {
                var a = n.dom.lastChild;
                if (a && "BR" == a.nodeName) return a.getClientRects()[0];
                break;
              }
              r = n.parent.children.indexOf(n) + (t < 0 ? 0 : 1), n = n.parent;
            }
          }
          return;
        }(this, this.side > 0 ? -1 : 1);
      return n && n.top < t.bottom && n.bottom > t.top ? {
        left: t.left,
        right: t.right,
        top: n.top,
        bottom: n.bottom
      } : t;
    }
  }, {
    key: "overrideDOMText",
    get: function get() {
      return BC.empty;
    }
  }]), n;
}();
function zO(e, t, n) {
  for (var r = 0, i = 0; r < t.length; r++) {
    var o = t[r],
      a = i + o.length;
    if (!(a == i && o.getSide() <= 0)) {
      if (n > i && n < a && o.dom.parentNode == e) return o.domAtPos(n - i);
      if (n <= i) break;
      i = a;
    }
  }
  for (; r > 0; r--) {
    var s = t[r - 1].dom;
    if (s.parentNode == e) return fO.after(s);
  }
  return new fO(e, 0);
}
function LO(e, t, n) {
  var r,
    i = e.children;
  n > 0 && t instanceof PO && i.length && (r = i[i.length - 1]) instanceof PO && r.mark.eq(t.mark) ? LO(r, t.children[0], n - 1) : (i.push(t), t.setParent(e)), e.length += t.length;
}
function BO(e, t, n) {
  for (var r = 0, i = 0; i < e.children.length; i++) {
    var o = e.children[i],
      a = r + o.length,
      s = void 0;
    if ((n <= 0 || a == e.length || o.getSide() > 0 ? a >= t : a > t) && (t < a || i + 1 == e.children.length || (s = e.children[i + 1]).length || s.getSide() > 0)) {
      var u = 0;
      if (a == r) {
        if (o.getSide() <= 0) continue;
        u = n = -o.getSide();
      }
      var c = o.coordsAt(Math.max(0, t - r), n);
      return u && c ? tO(c, n < 0) : c;
    }
    r = a;
  }
  var l = e.dom.lastChild;
  if (!l) return e.dom.getBoundingClientRect();
  var f = G$(l);
  return f[f.length - 1] || null;
}
function qO(e, t) {
  for (var n in e) {
    "class" == n && t.class ? t.class += " " + e.class : "style" == n && t.style ? t.style += ";" + e.style : t[n] = e[n];
  }
  return t;
}
function FO(e, t) {
  if (e == t) return !0;
  if (!e || !t) return !1;
  var n = Object.keys(e),
    r = Object.keys(t);
  if (n.length != r.length) return !1;
  for (var i = 0, o = n; i < o.length; i++) {
    var a = o[i];
    if (-1 == r.indexOf(a) || e[a] !== t[a]) return !1;
  }
  return !0;
}
function VO(e, t, n) {
  var r = null;
  if (t) for (var i in t) {
    n && i in n || e.removeAttribute(r = i);
  }
  if (n) for (var o in n) {
    t && t[o] == n[o] || e.setAttribute(r = o, n[o]);
  }
  return !!r;
}
EO.prototype.children = IO.prototype.children = DO.prototype.children = hO;
var HO = function () {
    function e() {
      Ri(this, e);
    }
    return zi(e, [{
      key: "eq",
      value: function value(e) {
        return !1;
      }
    }, {
      key: "updateDOM",
      value: function value(e) {
        return !1;
      }
    }, {
      key: "compare",
      value: function value(e) {
        return this == e || this.constructor == e.constructor && this.eq(e);
      }
    }, {
      key: "estimatedHeight",
      get: function get() {
        return -1;
      }
    }, {
      key: "ignoreEvent",
      value: function value(e) {
        return !0;
      }
    }, {
      key: "customView",
      get: function get() {
        return null;
      }
    }, {
      key: "destroy",
      value: function value(e) {}
    }]), e;
  }(),
  WO = function (e) {
    return e[e.Text = 0] = "Text", e[e.WidgetBefore = 1] = "WidgetBefore", e[e.WidgetAfter = 2] = "WidgetAfter", e[e.WidgetRange = 3] = "WidgetRange", e;
  }(WO || (WO = {})),
  UO = function (e) {
    ji(n, f$);
    var t = Ci(n);
    function n(e, r, i, o) {
      var a;
      return Ri(this, n), (a = t.call(this)).startSide = e, a.endSide = r, a.widget = i, a.spec = o, a;
    }
    return zi(n, [{
      key: "heightRelevant",
      get: function get() {
        return !1;
      }
    }, {
      key: "hasHeight",
      value: function value() {
        return !!this.widget && this.widget.estimatedHeight > -1;
      }
    }], [{
      key: "mark",
      value: function value(e) {
        return new JO(e);
      }
    }, {
      key: "widget",
      value: function value(e) {
        var t = e.side || 0,
          n = !!e.block;
        return new GO(e, t += n ? t > 0 ? 3e8 : -4e8 : t > 0 ? 1e8 : -1e8, t, n, e.widget || null, !1);
      }
    }, {
      key: "replace",
      value: function value(e) {
        var t,
          n,
          r = !!e.block;
        if (e.isBlockGap) t = -5e8, n = 4e8;else {
          var i = QO(e, r);
          t = (i.start ? r ? -3e8 : -1 : 5e8) - 1, n = 1 + (i.end ? r ? 2e8 : 1 : -6e8);
        }
        return new GO(e, t, n, r, e.widget || null, !0);
      }
    }, {
      key: "line",
      value: function value(e) {
        return new KO(e);
      }
    }, {
      key: "set",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return p$.of(e, t);
      }
    }]), n;
  }();
UO.none = p$.empty;
var JO = function (e) {
  ji(n, UO);
  var t = Ci(n);
  function n(e) {
    var r;
    Ri(this, n);
    var i = QO(e),
      o = i.start,
      a = i.end;
    return (r = t.call(this, o ? -1 : 5e8, a ? 1 : -6e8, null, e)).tagName = e.tagName || "span", r.class = e.class || "", r.attrs = e.attributes || null, r;
  }
  return zi(n, [{
    key: "eq",
    value: function value(e) {
      return this == e || e instanceof n && this.tagName == e.tagName && this.class == e.class && FO(this.attrs, e.attrs);
    }
  }, {
    key: "range",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
      if (e >= t) throw new RangeError("Mark decorations may not be empty");
      return ki(Ai(n.prototype), "range", this).call(this, e, t);
    }
  }]), n;
}();
JO.prototype.point = !1;
var KO = function (e) {
  ji(n, UO);
  var t = Ci(n);
  function n(e) {
    return Ri(this, n), t.call(this, -2e8, -2e8, null, e);
  }
  return zi(n, [{
    key: "eq",
    value: function value(e) {
      return e instanceof n && FO(this.spec.attributes, e.spec.attributes);
    }
  }, {
    key: "range",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
      if (t != e) throw new RangeError("Line decoration ranges must be zero-length");
      return ki(Ai(n.prototype), "range", this).call(this, e, t);
    }
  }]), n;
}();
KO.prototype.mapMode = c_.TrackBefore, KO.prototype.point = !0;
var GO = function (e) {
  ji(n, UO);
  var t = Ci(n);
  function n(e, r, i, o, a, s) {
    var u;
    return Ri(this, n), (u = t.call(this, r, i, a, e)).block = o, u.isReplace = s, u.mapMode = o ? r <= 0 ? c_.TrackBefore : c_.TrackAfter : c_.TrackDel, u;
  }
  return zi(n, [{
    key: "type",
    get: function get() {
      return this.startSide < this.endSide ? WO.WidgetRange : this.startSide <= 0 ? WO.WidgetBefore : WO.WidgetAfter;
    }
  }, {
    key: "heightRelevant",
    get: function get() {
      return this.block || !!this.widget && this.widget.estimatedHeight >= 5;
    }
  }, {
    key: "eq",
    value: function value(e) {
      return e instanceof n && (t = this.widget, r = e.widget, t == r || !!(t && r && t.compare(r))) && this.block == e.block && this.startSide == e.startSide && this.endSide == e.endSide;
      var t, r;
    }
  }, {
    key: "range",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
      if (this.isReplace && (e > t || e == t && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
      if (!this.isReplace && t != e) throw new RangeError("Widget decorations can only have zero-length ranges");
      return ki(Ai(n.prototype), "range", this).call(this, e, t);
    }
  }]), n;
}();
function QO(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
    n = e.inclusiveStart,
    r = e.inclusiveEnd;
  return null == n && (n = e.inclusive), null == r && (r = e.inclusive), {
    start: null != n ? n : t,
    end: null != r ? r : t
  };
}
function YO(e, t, n) {
  var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
    i = n.length - 1;
  i >= 0 && n[i] + r >= e ? n[i] = Math.max(n[i], t) : n.push(e, t);
}
GO.prototype.point = !0;
var ZO = function (e) {
    ji(n, dO);
    var t = Ci(n);
    function n() {
      var e;
      return Ri(this, n), (e = t.apply(this, arguments)).children = [], e.length = 0, e.prevAttrs = void 0, e.attrs = null, e.breakAfter = 0, e;
    }
    return zi(n, [{
      key: "merge",
      value: function value(e, t, r, i, o, a) {
        if (r) {
          if (!(r instanceof n)) return !1;
          this.dom || r.transferDOM(this);
        }
        return i && this.setDeco(r ? r.attrs : null), gO(this, e, t, r ? r.children : [], o, a), !0;
      }
    }, {
      key: "split",
      value: function value(e) {
        var t = new n();
        if (t.breakAfter = this.breakAfter, 0 == this.length) return t;
        var r = this.childPos(e),
          i = r.i,
          o = r.off;
        o && (t.append(this.children[i].split(o), 0), this.children[i].merge(o, this.children[i].length, null, !1, 0, 0), i++);
        for (var a = i; a < this.children.length; a++) {
          t.append(this.children[a], 0);
        }
        for (; i > 0 && 0 == this.children[i - 1].length;) {
          this.children[--i].destroy();
        }
        return this.children.length = i, this.markDirty(), this.length = e, t;
      }
    }, {
      key: "transferDOM",
      value: function value(e) {
        this.dom && (this.markDirty(), e.setDOM(this.dom), e.prevAttrs = void 0 === this.prevAttrs ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
      }
    }, {
      key: "setDeco",
      value: function value(e) {
        FO(this.attrs, e) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = e);
      }
    }, {
      key: "append",
      value: function value(e, t) {
        LO(this, e, t);
      }
    }, {
      key: "addLineDeco",
      value: function value(e) {
        var t = e.spec.attributes,
          n = e.spec.class;
        t && (this.attrs = qO(t, this.attrs || {})), n && (this.attrs = qO({
          class: n
        }, this.attrs || {}));
      }
    }, {
      key: "domAtPos",
      value: function value(e) {
        return zO(this.dom, this.children, e);
      }
    }, {
      key: "reuseDOM",
      value: function value(e) {
        "DIV" == e.nodeName && (this.setDOM(e), this.dirty |= 6);
      }
    }, {
      key: "sync",
      value: function value(e) {
        var t;
        this.dom ? 4 & this.dirty && (lO(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), void 0 !== this.prevAttrs && (VO(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), ki(Ai(n.prototype), "sync", this).call(this, e);
        for (var r = this.dom.lastChild; r && dO.get(r) instanceof PO;) {
          r = r.lastChild;
        }
        if (!(r && this.length && ("BR" == r.nodeName || 0 != (null === (t = dO.get(r)) || void 0 === t ? void 0 : t.isEditable) || AO.ios && this.children.some(function (e) {
          return e instanceof EO;
        })))) {
          var i = document.createElement("BR");
          i.cmIgnore = !0, this.dom.appendChild(i);
        }
      }
    }, {
      key: "measureTextSize",
      value: function value() {
        if (0 == this.children.length || this.length > 20) return null;
        var e,
          t = 0,
          n = bi(this.children);
        try {
          for (n.s(); !(e = n.n()).done;) {
            var r = e.value;
            if (!(r instanceof EO)) return null;
            var i = G$(r.dom);
            if (1 != i.length) return null;
            t += i[0].width;
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
        return {
          lineHeight: this.dom.getBoundingClientRect().height,
          charWidth: t / this.length
        };
      }
    }, {
      key: "coordsAt",
      value: function value(e, t) {
        return BO(this, e, t);
      }
    }, {
      key: "become",
      value: function value(e) {
        return !1;
      }
    }, {
      key: "type",
      get: function get() {
        return WO.Text;
      }
    }], [{
      key: "find",
      value: function value(e, t) {
        for (var r = 0, i = 0; r < e.children.length; r++) {
          var o = e.children[r],
            a = i + o.length;
          if (a >= t) {
            if (o instanceof n) return o;
            if (a > t) break;
          }
          i = a + o.breakAfter;
        }
        return null;
      }
    }]), n;
  }(),
  XO = function (e) {
    ji(n, dO);
    var t = Ci(n);
    function n(e, r, i) {
      var o;
      return Ri(this, n), (o = t.call(this)).widget = e, o.length = r, o.type = i, o.breakAfter = 0, o.prevWidget = null, o;
    }
    return zi(n, [{
      key: "merge",
      value: function value(e, t, r, i, o, a) {
        return !(r && (!(r instanceof n && this.widget.compare(r.widget)) || e > 0 && o <= 0 || t < this.length && a <= 0)) && (this.length = e + (r ? r.length : 0) + (this.length - t), !0);
      }
    }, {
      key: "domAtPos",
      value: function value(e) {
        return 0 == e ? fO.before(this.dom) : fO.after(this.dom, e == this.length);
      }
    }, {
      key: "split",
      value: function value(e) {
        var t = this.length - e;
        this.length = e;
        var r = new n(this.widget, t, this.type);
        return r.breakAfter = this.breakAfter, r;
      }
    }, {
      key: "children",
      get: function get() {
        return hO;
      }
    }, {
      key: "sync",
      value: function value() {
        this.dom && this.widget.updateDOM(this.dom) || (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(this.editorView)), this.dom.contentEditable = "false");
      }
    }, {
      key: "overrideDOMText",
      get: function get() {
        return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : BC.empty;
      }
    }, {
      key: "domBoundsAround",
      value: function value() {
        return null;
      }
    }, {
      key: "become",
      value: function value(e) {
        return e instanceof n && e.type == this.type && e.widget.constructor == this.widget.constructor && (e.widget.eq(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, this.breakAfter = e.breakAfter, !0);
      }
    }, {
      key: "ignoreMutation",
      value: function value() {
        return !0;
      }
    }, {
      key: "ignoreEvent",
      value: function value(e) {
        return this.widget.ignoreEvent(e);
      }
    }, {
      key: "destroy",
      value: function value() {
        ki(Ai(n.prototype), "destroy", this).call(this), this.dom && this.widget.destroy(this.dom);
      }
    }]), n;
  }(),
  eA = function () {
    function e(t, n, r, i) {
      Ri(this, e), this.doc = t, this.pos = n, this.end = r, this.disallowBlockEffectsFor = i, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = t.iter(), this.skip = n;
    }
    return zi(e, [{
      key: "posCovered",
      value: function value() {
        if (0 == this.content.length) return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
        var e = this.content[this.content.length - 1];
        return !(e.breakAfter || e instanceof XO && e.type == WO.WidgetBefore);
      }
    }, {
      key: "getLine",
      value: function value() {
        return this.curLine || (this.content.push(this.curLine = new ZO()), this.atCursorPos = !0), this.curLine;
      }
    }, {
      key: "flushBuffer",
      value: function value(e) {
        this.pendingBuffer && (this.curLine.append(tA(new DO(-1), e), e.length), this.pendingBuffer = 0);
      }
    }, {
      key: "addBlockWidget",
      value: function value(e) {
        this.flushBuffer([]), this.curLine = null, this.content.push(e);
      }
    }, {
      key: "finish",
      value: function value(e) {
        e ? this.pendingBuffer = 0 : this.flushBuffer([]), this.posCovered() || this.getLine();
      }
    }, {
      key: "buildText",
      value: function value(e, t, n) {
        for (; e > 0;) {
          if (this.textOff == this.text.length) {
            var r = this.cursor.next(this.skip),
              i = r.value,
              o = r.lineBreak,
              a = r.done;
            if (this.skip = 0, a) throw new Error("Ran out of text content when drawing inline views");
            if (o) {
              this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer([]), this.curLine = null, e--;
              continue;
            }
            this.text = i, this.textOff = 0;
          }
          var s = Math.min(this.text.length - this.textOff, e, 512);
          this.flushBuffer(t.slice(0, n)), this.getLine().append(tA(new EO(this.text.slice(this.textOff, this.textOff + s)), t), n), this.atCursorPos = !0, this.textOff += s, e -= s, n = 0;
        }
      }
    }, {
      key: "span",
      value: function value(e, t, n, r) {
        this.buildText(t - e, n, r), this.pos = t, this.openStart < 0 && (this.openStart = r);
      }
    }, {
      key: "point",
      value: function value(e, t, n, r, i, o) {
        if (this.disallowBlockEffectsFor[o] && n instanceof GO) {
          if (n.block) throw new RangeError("Block decorations may not be specified via plugins");
          if (t > this.doc.lineAt(this.pos).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
        }
        var a = t - e;
        if (n instanceof GO) {
          if (n.block) {
            var s = n.type;
            s != WO.WidgetAfter || this.posCovered() || this.getLine(), this.addBlockWidget(new XO(n.widget || new nA("div"), a, s));
          } else {
            var u = IO.create(n.widget || new nA("span"), a, n.startSide),
              c = this.atCursorPos && !u.isEditable && i <= r.length && (e < t || n.startSide > 0),
              l = !u.isEditable && (e < t || n.startSide <= 0),
              f = this.getLine();
            2 != this.pendingBuffer || c || (this.pendingBuffer = 0), this.flushBuffer(r), c && (f.append(tA(new DO(1), r), i), i = r.length + Math.max(0, i - r.length)), f.append(tA(u, r), i), this.atCursorPos = l, this.pendingBuffer = l ? e < t ? 1 : 2 : 0;
          }
        } else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(n);
        a && (this.textOff + a <= this.text.length ? this.textOff += a : (this.skip += a - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = t), this.openStart < 0 && (this.openStart = i);
      }
    }], [{
      key: "build",
      value: function value(t, n, r, i, o) {
        var a = new e(t, n, r, o);
        return a.openEnd = p$.spans(i, n, r, a), a.openStart < 0 && (a.openStart = a.openEnd), a.finish(a.openEnd), a;
      }
    }]), e;
  }();
function tA(e, t) {
  var n,
    r = bi(t);
  try {
    for (r.s(); !(n = r.n()).done;) {
      var i = n.value;
      e = new PO(i, [e], e.length);
    }
  } catch (e) {
    r.e(e);
  } finally {
    r.f();
  }
  return e;
}
var nA = function (e) {
    ji(n, HO);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), (r = t.call(this)).tag = e, r;
    }
    return zi(n, [{
      key: "eq",
      value: function value(e) {
        return e.tag == this.tag;
      }
    }, {
      key: "toDOM",
      value: function value() {
        return document.createElement(this.tag);
      }
    }, {
      key: "updateDOM",
      value: function value(e) {
        return e.nodeName.toLowerCase() == this.tag;
      }
    }]), n;
  }(),
  rA = x_.define(),
  iA = x_.define(),
  oA = x_.define(),
  aA = x_.define(),
  sA = x_.define(),
  uA = x_.define(),
  cA = x_.define({
    combine: function combine(e) {
      return e.some(function (e) {
        return e;
      });
    }
  }),
  lA = function () {
    function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "nearest",
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "nearest",
        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 5,
        o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 5;
      Ri(this, e), this.range = t, this.y = n, this.x = r, this.yMargin = i, this.xMargin = o;
    }
    return zi(e, [{
      key: "map",
      value: function value(t) {
        return t.empty ? this : new e(this.range.map(t), this.y, this.x, this.yMargin, this.xMargin);
      }
    }]), e;
  }(),
  fA = Y_.define({
    map: function map(e, t) {
      return e.map(t);
    }
  });
function hA(e, t, n) {
  var r = e.facet(aA);
  r.length ? r[0](t) : window.onerror ? window.onerror(String(t), n, void 0, void 0, t) : n ? console.error(n + ":", t) : console.error(t);
}
var dA = x_.define({
    combine: function combine(e) {
      return !e.length || e[0];
    }
  }),
  vA = 0,
  pA = x_.define(),
  mA = function () {
    function e(t, n, r, i) {
      Ri(this, e), this.id = t, this.create = n, this.domEventHandlers = r, this.extension = i(this);
    }
    return zi(e, null, [{
      key: "define",
      value: function value(t, n) {
        var r = n || {},
          i = r.eventHandlers,
          o = r.provide,
          a = r.decorations;
        return new e(vA++, t, i, function (e) {
          var t = [pA.of(e)];
          return a && t.push(kA.of(function (t) {
            var n = t.plugin(e);
            return n ? a(n) : UO.none;
          })), o && t.push(o(e)), t;
        });
      }
    }, {
      key: "fromClass",
      value: function value(t, n) {
        return e.define(function (e) {
          return new t(e);
        }, n);
      }
    }]), e;
  }(),
  gA = function () {
    function e(t) {
      Ri(this, e), this.spec = t, this.mustUpdate = null, this.value = null;
    }
    return zi(e, [{
      key: "update",
      value: function value(e) {
        if (this.value) {
          if (this.mustUpdate) {
            var t = this.mustUpdate;
            if (this.mustUpdate = null, this.value.update) try {
              this.value.update(t);
            } catch (e) {
              if (hA(t.state, e, "CodeMirror plugin crashed"), this.value.destroy) try {
                this.value.destroy();
              } catch (e) {}
              this.deactivate();
            }
          }
        } else if (this.spec) try {
          this.value = this.spec.create(e);
        } catch (t) {
          hA(e.state, t, "CodeMirror plugin crashed"), this.deactivate();
        }
        return this;
      }
    }, {
      key: "destroy",
      value: function value(e) {
        var t;
        if (null === (t = this.value) || void 0 === t ? void 0 : t.destroy) try {
          this.value.destroy();
        } catch (t) {
          hA(e.state, t, "CodeMirror plugin crashed");
        }
      }
    }, {
      key: "deactivate",
      value: function value() {
        this.spec = this.value = null;
      }
    }]), e;
  }(),
  yA = x_.define(),
  bA = x_.define(),
  kA = x_.define(),
  wA = x_.define(),
  xA = x_.define(),
  jA = x_.define(),
  SA = function () {
    function e(t, n, r, i) {
      Ri(this, e), this.fromA = t, this.toA = n, this.fromB = r, this.toB = i;
    }
    return zi(e, [{
      key: "join",
      value: function value(t) {
        return new e(Math.min(this.fromA, t.fromA), Math.max(this.toA, t.toA), Math.min(this.fromB, t.fromB), Math.max(this.toB, t.toB));
      }
    }, {
      key: "addToSet",
      value: function value(e) {
        for (var t = e.length, n = this; t > 0; t--) {
          var r = e[t - 1];
          if (!(r.fromA > n.toA)) {
            if (r.toA < n.fromA) break;
            n = n.join(r), e.splice(t - 1, 1);
          }
        }
        return e.splice(t, 0, n), e;
      }
    }], [{
      key: "extendWithRanges",
      value: function value(t, n) {
        if (0 == n.length) return t;
        for (var r = [], i = 0, o = 0, a = 0, s = 0;; i++) {
          for (var u = i == t.length ? null : t[i], c = a - s, l = u ? u.fromB : 1e9; o < n.length && n[o] < l;) {
            var f = n[o],
              h = n[o + 1],
              d = Math.max(s, f),
              v = Math.min(l, h);
            if (d <= v && new e(d + c, v + c, d, v).addToSet(r), h > l) break;
            o += 2;
          }
          if (!u) return r;
          new e(u.fromA, u.toA, u.fromB, u.toB).addToSet(r), a = u.toA, s = u.toB;
        }
      }
    }]), e;
  }(),
  CA = function () {
    function e(t, n, r) {
      Ri(this, e), this.view = t, this.state = n, this.transactions = r, this.flags = 0, this.startState = t.state, this.changes = f_.empty(this.startState.doc.length);
      var i,
        o = bi(r);
      try {
        for (o.s(); !(i = o.n()).done;) {
          var a = i.value;
          this.changes = this.changes.compose(a.changes);
        }
      } catch (e) {
        o.e(e);
      } finally {
        o.f();
      }
      var s = [];
      this.changes.iterChangedRanges(function (e, t, n, r) {
        return s.push(new SA(e, t, n, r));
      }), this.changedRanges = s;
      var u = t.hasFocus;
      u != t.inputState.notifiedFocused && (t.inputState.notifiedFocused = u, this.flags |= 1);
    }
    return zi(e, [{
      key: "viewportChanged",
      get: function get() {
        return (4 & this.flags) > 0;
      }
    }, {
      key: "heightChanged",
      get: function get() {
        return (2 & this.flags) > 0;
      }
    }, {
      key: "geometryChanged",
      get: function get() {
        return this.docChanged || (10 & this.flags) > 0;
      }
    }, {
      key: "focusChanged",
      get: function get() {
        return (1 & this.flags) > 0;
      }
    }, {
      key: "docChanged",
      get: function get() {
        return !this.changes.empty;
      }
    }, {
      key: "selectionSet",
      get: function get() {
        return this.transactions.some(function (e) {
          return e.selection;
        });
      }
    }, {
      key: "empty",
      get: function get() {
        return 0 == this.flags && 0 == this.transactions.length;
      }
    }], [{
      key: "create",
      value: function value(t, n, r) {
        return new e(t, n, r);
      }
    }]), e;
  }(),
  _A = function (e) {
    return e[e.LTR = 0] = "LTR", e[e.RTL = 1] = "RTL", e;
  }(_A || (_A = {})),
  $A = _A.LTR,
  OA = _A.RTL;
function AA(e) {
  for (var t = [], n = 0; n < e.length; n++) {
    t.push(1 << +e[n]);
  }
  return t;
}
for (var EA = AA("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), PA = AA("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), MA = Object.create(null), IA = [], TA = 0, NA = ["()", "[]", "{}"]; TA < NA.length; TA++) {
  var RA = NA[TA],
    DA = RA.charCodeAt(0),
    zA = RA.charCodeAt(1);
  MA[DA] = zA, MA[zA] = -DA;
}
function LA(e) {
  return e <= 247 ? EA[e] : 1424 <= e && e <= 1524 ? 2 : 1536 <= e && e <= 1785 ? PA[e - 1536] : 1774 <= e && e <= 2220 ? 4 : 8192 <= e && e <= 8203 || 8204 == e ? 256 : 1;
}
var BA = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/,
  qA = function () {
    function e(t, n, r) {
      Ri(this, e), this.from = t, this.to = n, this.level = r;
    }
    return zi(e, [{
      key: "dir",
      get: function get() {
        return this.level % 2 ? OA : $A;
      }
    }, {
      key: "side",
      value: function value(e, t) {
        return this.dir == t == e ? this.to : this.from;
      }
    }], [{
      key: "find",
      value: function value(e, t, n, r) {
        for (var i = -1, o = 0; o < e.length; o++) {
          var a = e[o];
          if (a.from <= t && a.to >= t) {
            if (a.level == n) return o;
            (i < 0 || (0 != r ? r < 0 ? a.from < t : a.to > t : e[i].level > a.level)) && (i = o);
          }
        }
        if (i < 0) throw new RangeError("Index out of range");
        return i;
      }
    }]), e;
  }(),
  FA = [];
function VA(e) {
  return [new qA(0, e, 0)];
}
var HA = "";
function WA(e, t, n, r, i) {
  var o,
    a = r.head - e.from,
    s = -1;
  if (0 == a) {
    if (!i || !e.length) return null;
    t[0].level != n && (a = t[0].side(!1, n), s = 0);
  } else if (a == e.length) {
    if (i) return null;
    var u = t[t.length - 1];
    u.level != n && (a = u.side(!0, n), s = t.length - 1);
  }
  s < 0 && (s = qA.find(t, a, null !== (o = r.bidiLevel) && void 0 !== o ? o : -1, r.assoc));
  var c = t[s];
  a == c.side(i, n) && (a = (c = t[s += i ? 1 : -1]).side(!i, n));
  var l = i == (c.dir == n),
    f = e_(e.text, a, l);
  if (HA = e.text.slice(Math.min(a, f), Math.max(a, f)), f != c.side(i, n)) return b_.cursor(f + e.from, l ? -1 : 1, c.level);
  var h = s == (i ? t.length - 1 : 0) ? null : t[s + (i ? 1 : -1)];
  return h || c.level == n ? h && h.level < c.level ? b_.cursor(h.side(!i, n) + e.from, i ? 1 : -1, h.level) : b_.cursor(f + e.from, i ? -1 : 1, c.level) : b_.cursor(i ? e.to : e.from, i ? -1 : 1, n);
}
var UA = function () {
  function e(t, n) {
    Ri(this, e), this.points = t, this.text = "", this.lineSeparator = n.facet(c$.lineSeparator);
  }
  return zi(e, [{
    key: "append",
    value: function value(e) {
      this.text += e;
    }
  }, {
    key: "lineBreak",
    value: function value() {
      this.text += "￿";
    }
  }, {
    key: "readRange",
    value: function value(e, t) {
      if (!e) return this;
      for (var n = e.parentNode, r = e;;) {
        this.findPointBefore(n, r), this.readNode(r);
        var i = r.nextSibling;
        if (i == t) break;
        var o = dO.get(r),
          a = dO.get(i);
        (o && a ? o.breakAfter : (o ? o.breakAfter : JA(r)) || JA(i) && ("BR" != r.nodeName || r.cmIgnore)) && this.lineBreak(), r = i;
      }
      return this.findPointBefore(n, t), this;
    }
  }, {
    key: "readTextNode",
    value: function value(e) {
      var t,
        n = e.nodeValue,
        r = bi(this.points);
      try {
        for (r.s(); !(t = r.n()).done;) {
          var i = t.value;
          i.node == e && (i.pos = this.text.length + Math.min(i.offset, n.length));
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
      for (var o = 0, a = this.lineSeparator ? null : /\r\n?|\n/g;;) {
        var s = -1,
          u = 1,
          c = void 0;
        if (this.lineSeparator ? (s = n.indexOf(this.lineSeparator, o), u = this.lineSeparator.length) : (c = a.exec(n)) && (s = c.index, u = c[0].length), this.append(n.slice(o, s < 0 ? n.length : s)), s < 0) break;
        if (this.lineBreak(), u > 1) {
          var l,
            f = bi(this.points);
          try {
            for (f.s(); !(l = f.n()).done;) {
              var h = l.value;
              h.node == e && h.pos > this.text.length && (h.pos -= u - 1);
            }
          } catch (e) {
            f.e(e);
          } finally {
            f.f();
          }
        }
        o = s + u;
      }
    }
  }, {
    key: "readNode",
    value: function value(e) {
      if (!e.cmIgnore) {
        var t = dO.get(e),
          n = t && t.overrideDOMText;
        if (null != n) {
          this.findPointInside(e, n.length);
          for (var r = n.iter(); !r.next().done;) {
            r.lineBreak ? this.lineBreak() : this.append(r.value);
          }
        } else 3 == e.nodeType ? this.readTextNode(e) : "BR" == e.nodeName ? e.nextSibling && this.lineBreak() : 1 == e.nodeType && this.readRange(e.firstChild, null);
      }
    }
  }, {
    key: "findPointBefore",
    value: function value(e, t) {
      var n,
        r = bi(this.points);
      try {
        for (r.s(); !(n = r.n()).done;) {
          var i = n.value;
          i.node == e && e.childNodes[i.offset] == t && (i.pos = this.text.length);
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
    }
  }, {
    key: "findPointInside",
    value: function value(e, t) {
      var n,
        r = bi(this.points);
      try {
        for (r.s(); !(n = r.n()).done;) {
          var i = n.value;
          (3 == e.nodeType ? i.node == e : e.contains(i.node)) && (i.pos = this.text.length + Math.min(t, i.offset));
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
    }
  }]), e;
}();
function JA(e) {
  return 1 == e.nodeType && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(e.nodeName);
}
var KA = zi(function e(t, n) {
    Ri(this, e), this.node = t, this.offset = n, this.pos = -1;
  }),
  GA = function (e) {
    ji(n, dO);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), (r = t.call(this)).view = e, r.compositionDeco = UO.none, r.decorations = [], r.dynamicDecorationMap = [], r.minWidth = 0, r.minWidthFrom = 0, r.minWidthTo = 0, r.impreciseAnchor = null, r.impreciseHead = null, r.forceSelection = !1, r.lastUpdate = Date.now(), r.setDOM(e.contentDOM), r.children = [new ZO()], r.children[0].setParent($i(r)), r.updateDeco(), r.updateInner([new SA(0, 0, 0, e.state.doc.length)], 0), r;
    }
    return zi(n, [{
      key: "root",
      get: function get() {
        return this.view.root;
      }
    }, {
      key: "editorView",
      get: function get() {
        return this.view;
      }
    }, {
      key: "length",
      get: function get() {
        return this.view.state.doc.length;
      }
    }, {
      key: "update",
      value: function value(e) {
        var t = this,
          n = e.changedRanges;
        this.minWidth > 0 && n.length && (n.every(function (e) {
          var n = e.fromA;
          return e.toA < t.minWidthFrom || n > t.minWidthTo;
        }) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.view.inputState.composing < 0 ? this.compositionDeco = UO.none : (e.transactions.length || this.dirty) && (this.compositionDeco = function (e, t) {
          var n = ZA(e);
          if (!n) return UO.none;
          var r = n.from,
            i = n.to,
            o = n.node,
            a = n.text,
            s = t.mapPos(r, 1),
            u = Math.max(s, t.mapPos(i, -1)),
            c = e.state,
            l = 3 == o.nodeType ? o.nodeValue : new UA([], c).readRange(o.firstChild, null).text;
          if (u - s < l.length) {
            if (c.doc.sliceString(s, Math.min(c.doc.length, s + l.length), "￿") == l) u = s + l.length;else {
              if (c.doc.sliceString(Math.max(0, u - l.length), u, "￿") != l) return UO.none;
              s = u - l.length;
            }
          } else if (c.doc.sliceString(s, u, "￿") != l) return UO.none;
          var f = dO.get(o);
          f instanceof TO ? f = f.widget.topView : f && (f.parent = null);
          return UO.set(UO.replace({
            widget: new XA(o, a, f),
            inclusive: !0
          }).range(s, u));
        }(this.view, e.changes)), (AO.ie || AO.chrome) && !this.compositionDeco.size && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
        var r,
          i,
          o,
          a,
          s = this.decorations,
          u = this.updateDeco(),
          c = (r = s, i = u, o = e.changes, a = new nE(), p$.compare(r, i, o, a), a.changes);
        return n = SA.extendWithRanges(n, c), (0 != this.dirty || 0 != n.length) && (this.updateInner(n, e.startState.doc.length), e.transactions.length && (this.lastUpdate = Date.now()), !0);
      }
    }, {
      key: "updateInner",
      value: function value(e, t) {
        var n = this;
        this.view.viewState.mustMeasureContent = !0, this.updateChildren(e, t);
        var r = this.view.observer;
        r.ignore(function () {
          n.dom.style.height = n.view.viewState.contentHeight + "px", n.dom.style.flexBasis = n.minWidth ? n.minWidth + "px" : "";
          var e = AO.chrome || AO.ios ? {
            node: r.selectionRange.focusNode,
            written: !1
          } : void 0;
          n.sync(e), n.dirty = 0, e && (e.written || r.selectionRange.focusNode != e.node) && (n.forceSelection = !0), n.dom.style.height = "";
        });
        var i = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
          var o,
            a = bi(this.children);
          try {
            for (a.s(); !(o = a.n()).done;) {
              var s = o.value;
              s instanceof XO && s.widget instanceof YA && i.push(s.dom);
            }
          } catch (e) {
            a.e(e);
          } finally {
            a.f();
          }
        }
        r.updateGaps(i);
      }
    }, {
      key: "updateChildren",
      value: function value(e, t) {
        for (var n = this.childCursor(t), r = e.length - 1;; r--) {
          var i = r >= 0 ? e[r] : null;
          if (!i) break;
          var o = i.fromA,
            a = i.toA,
            s = i.fromB,
            u = i.toB,
            c = eA.build(this.view.state.doc, s, u, this.decorations, this.dynamicDecorationMap),
            l = c.content,
            f = c.breakAtStart,
            h = c.openStart,
            d = c.openEnd,
            v = n.findPos(a, 1),
            p = v.i,
            m = v.off,
            g = n.findPos(o, -1);
          mO(this, g.i, g.off, p, m, l, f, h, d);
        }
      }
    }, {
      key: "updateSelection",
      value: function value() {
        var e = this,
          t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
          n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if (t && this.view.observer.readSelectionRange(), !(!n && !this.mayControlSelection() || AO.ios && this.view.inputState.rapidCompositionStart)) {
          var r = this.forceSelection;
          this.forceSelection = !1;
          var i = this.view.state.selection.main,
            o = this.domAtPos(i.anchor),
            a = i.empty ? o : this.domAtPos(i.head);
          if (AO.gecko && i.empty && QA(o)) {
            var s = document.createTextNode("");
            this.view.observer.ignore(function () {
              return o.node.insertBefore(s, o.node.childNodes[o.offset] || null);
            }), o = a = new fO(s, 0), r = !0;
          }
          var u = this.view.observer.selectionRange;
          !r && u.focusNode && Q$(o.node, o.offset, u.anchorNode, u.anchorOffset) && Q$(a.node, a.offset, u.focusNode, u.focusOffset) || (this.view.observer.ignore(function () {
            AO.android && AO.chrome && e.dom.contains(u.focusNode) && rE(u.focusNode, e.dom) && (e.dom.blur(), e.dom.focus({
              preventScroll: !0
            }));
            var t = U$(e.root);
            if (i.empty) {
              if (AO.gecko) {
                var n = tE(o.node, o.offset);
                if (n && 3 != n) {
                  var r = eE(o.node, o.offset, 1 == n ? 1 : -1);
                  r && (o = new fO(r, 1 == n ? 0 : r.nodeValue.length));
                }
              }
              t.collapse(o.node, o.offset), null != i.bidiLevel && null != u.cursorBidiLevel && (u.cursorBidiLevel = i.bidiLevel);
            } else if (t.extend) t.collapse(o.node, o.offset), t.extend(a.node, a.offset);else {
              var s = document.createRange();
              if (i.anchor > i.head) {
                var c = [a, o];
                o = c[0], a = c[1];
              }
              s.setEnd(a.node, a.offset), s.setStart(o.node, o.offset), t.removeAllRanges(), t.addRange(s);
            }
          }), this.view.observer.setSelectionRange(o, a)), this.impreciseAnchor = o.precise ? null : new fO(u.anchorNode, u.anchorOffset), this.impreciseHead = a.precise ? null : new fO(u.focusNode, u.focusOffset);
        }
      }
    }, {
      key: "enforceCursorAssoc",
      value: function value() {
        if (!this.compositionDeco.size) {
          var e = this.view.state.selection.main,
            t = U$(this.root);
          if (e.empty && e.assoc && t.modify) {
            var n = ZO.find(this, e.head);
            if (n) {
              var r = n.posAtStart;
              if (e.head != r && e.head != r + n.length) {
                var i = this.coordsAt(e.head, -1),
                  o = this.coordsAt(e.head, 1);
                if (i && o && !(i.bottom > o.top)) {
                  var a = this.domAtPos(e.head + e.assoc);
                  t.collapse(a.node, a.offset), t.modify("move", e.assoc < 0 ? "forward" : "backward", "lineboundary");
                }
              }
            }
          }
        }
      }
    }, {
      key: "mayControlSelection",
      value: function value() {
        return this.view.state.facet(dA) ? this.root.activeElement == this.dom : K$(this.dom, this.view.observer.selectionRange);
      }
    }, {
      key: "nearest",
      value: function value(e) {
        for (var t = e; t;) {
          var n = dO.get(t);
          if (n && n.rootView == this) return n;
          t = t.parentNode;
        }
        return null;
      }
    }, {
      key: "posFromDOM",
      value: function value(e, t) {
        var n = this.nearest(e);
        if (!n) throw new RangeError("Trying to find position for a DOM position outside of the document");
        return n.localPosFromDOM(e, t) + n.posAtStart;
      }
    }, {
      key: "domAtPos",
      value: function value(e) {
        for (var t = this.childCursor().findPos(e, -1), n = t.i, r = t.off; n < this.children.length - 1;) {
          var i = this.children[n];
          if (r < i.length || i instanceof ZO) break;
          n++, r = 0;
        }
        return this.children[n].domAtPos(r);
      }
    }, {
      key: "coordsAt",
      value: function value(e, t) {
        for (var n = this.length, r = this.children.length - 1;; r--) {
          var i = this.children[r],
            o = n - i.breakAfter - i.length;
          if (e > o || e == o && i.type != WO.WidgetBefore && i.type != WO.WidgetAfter && (!r || 2 == t || this.children[r - 1].breakAfter || this.children[r - 1].type == WO.WidgetBefore && t > -2)) return i.coordsAt(e - o, t);
          n = o;
        }
      }
    }, {
      key: "measureVisibleLineHeights",
      value: function value(e) {
        for (var t = [], n = e.from, r = e.to, i = this.view.contentDOM.clientWidth, o = i > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, a = -1, s = this.view.textDirection == _A.LTR, u = 0, c = 0; c < this.children.length; c++) {
          var l = this.children[c],
            f = u + l.length;
          if (f > r) break;
          if (u >= n) {
            var h = l.dom.getBoundingClientRect();
            if (t.push(h.height), o) {
              var d = l.dom.lastChild,
                v = d ? G$(d) : [];
              if (v.length) {
                var p = v[v.length - 1],
                  m = s ? p.right - h.left : h.right - p.left;
                m > a && (a = m, this.minWidth = i, this.minWidthFrom = u, this.minWidthTo = f);
              }
            }
          }
          u = f + l.breakAfter;
        }
        return t;
      }
    }, {
      key: "textDirectionAt",
      value: function value(e) {
        var t = this.childPos(e, 1).i;
        return "rtl" == getComputedStyle(this.children[t].dom).direction ? _A.RTL : _A.LTR;
      }
    }, {
      key: "measureTextSize",
      value: function value() {
        var e,
          t = this,
          n = bi(this.children);
        try {
          for (n.s(); !(e = n.n()).done;) {
            var r = e.value;
            if (r instanceof ZO) {
              var i = r.measureTextSize();
              if (i) return i;
            }
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
        var o,
          a,
          s = document.createElement("div");
        return s.className = "cm-line", s.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(function () {
          t.dom.appendChild(s);
          var e = G$(s.firstChild)[0];
          o = s.getBoundingClientRect().height, a = e ? e.width / 27 : 7, s.remove();
        }), {
          lineHeight: o,
          charWidth: a
        };
      }
    }, {
      key: "childCursor",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.length,
          t = this.children.length;
        return t && (e -= this.children[--t].length), new pO(this.children, e, t);
      }
    }, {
      key: "computeBlockGapDeco",
      value: function value() {
        for (var e = [], t = this.view.viewState, n = 0, r = 0;; r++) {
          var i = r == t.viewports.length ? null : t.viewports[r],
            o = i ? i.from - 1 : this.length;
          if (o > n) {
            var a = t.lineBlockAt(o).bottom - t.lineBlockAt(n).top;
            e.push(UO.replace({
              widget: new YA(a),
              block: !0,
              inclusive: !0,
              isBlockGap: !0
            }).range(n, o));
          }
          if (!i) break;
          n = i.to + 1;
        }
        return UO.set(e);
      }
    }, {
      key: "updateDeco",
      value: function value() {
        for (var e = this, t = this.view.state.facet(kA).map(function (t, n) {
            return (e.dynamicDecorationMap[n] = "function" == typeof t) ? t(e.view) : t;
          }), n = t.length; n < t.length + 3; n++) {
          this.dynamicDecorationMap[n] = !1;
        }
        return this.decorations = [].concat(Ii(t), [this.compositionDeco, this.computeBlockGapDeco(), this.view.viewState.lineGapDeco]);
      }
    }, {
      key: "scrollIntoView",
      value: function value(e) {
        var t,
          n = this,
          r = e.range,
          i = this.coordsAt(r.head, r.empty ? r.assoc : r.head > r.anchor ? -1 : 1);
        if (i) {
          !r.empty && (t = this.coordsAt(r.anchor, r.anchor > r.head ? -1 : 1)) && (i = {
            left: Math.min(i.left, t.left),
            top: Math.min(i.top, t.top),
            right: Math.max(i.right, t.right),
            bottom: Math.max(i.bottom, t.bottom)
          });
          var o,
            a = 0,
            s = 0,
            u = 0,
            c = 0,
            l = bi(this.view.state.facet(xA).map(function (e) {
              return e(n.view);
            }));
          try {
            for (l.s(); !(o = l.n()).done;) {
              var f = o.value;
              if (f) {
                var h = f.left,
                  d = f.right,
                  v = f.top,
                  p = f.bottom;
                null != h && (a = Math.max(a, h)), null != d && (s = Math.max(s, d)), null != v && (u = Math.max(u, v)), null != p && (c = Math.max(c, p));
              }
            }
          } catch (e) {
            l.e(e);
          } finally {
            l.f();
          }
          var m = {
            left: i.left - a,
            top: i.top - u,
            right: i.right + s,
            bottom: i.bottom + c
          };
          !function (e, t, n, r, i, o, a, s) {
            for (var u = e.ownerDocument, c = u.defaultView, l = e; l;) {
              if (1 == l.nodeType) {
                var f = void 0,
                  h = l == u.body;
                if (h) f = nO(c);else {
                  if (l.scrollHeight <= l.clientHeight && l.scrollWidth <= l.clientWidth) {
                    l = l.parentNode;
                    continue;
                  }
                  var d = l.getBoundingClientRect();
                  f = {
                    left: d.left,
                    right: d.left + l.clientWidth,
                    top: d.top,
                    bottom: d.top + l.clientHeight
                  };
                }
                var v = 0,
                  p = 0;
                if ("nearest" == i) t.top < f.top ? (p = -(f.top - t.top + a), n > 0 && t.bottom > f.bottom + p && (p = t.bottom - f.bottom + p + a)) : t.bottom > f.bottom && (p = t.bottom - f.bottom + a, n < 0 && t.top - p < f.top && (p = -(f.top + p - t.top + a)));else {
                  var m = t.bottom - t.top,
                    g = f.bottom - f.top;
                  p = ("center" == i && m <= g ? t.top + m / 2 - g / 2 : "start" == i || "center" == i && n < 0 ? t.top - a : t.bottom - g + a) - f.top;
                }
                if ("nearest" == r ? t.left < f.left ? (v = -(f.left - t.left + o), n > 0 && t.right > f.right + v && (v = t.right - f.right + v + o)) : t.right > f.right && (v = t.right - f.right + o, n < 0 && t.left < f.left + v && (v = -(f.left + v - t.left + o))) : v = ("center" == r ? t.left + (t.right - t.left) / 2 - (f.right - f.left) / 2 : "start" == r == s ? t.left - o : t.right - (f.right - f.left) + o) - f.left, v || p) if (h) c.scrollBy(v, p);else {
                  if (p) {
                    var y = l.scrollTop;
                    l.scrollTop += p, p = l.scrollTop - y;
                  }
                  if (v) {
                    var b = l.scrollLeft;
                    l.scrollLeft += v, v = l.scrollLeft - b;
                  }
                  t = {
                    left: t.left - v,
                    top: t.top - p,
                    right: t.right - v,
                    bottom: t.bottom - p
                  };
                }
                if (h) break;
                l = l.assignedSlot || l.parentNode, r = i = "nearest";
              } else {
                if (11 != l.nodeType) break;
                l = l.host;
              }
            }
          }(this.view.scrollDOM, m, r.head < r.anchor ? -1 : 1, e.x, e.y, e.xMargin, e.yMargin, this.view.textDirection == _A.LTR);
        }
      }
    }]), n;
  }();
function QA(e) {
  return 1 == e.node.nodeType && e.node.firstChild && (0 == e.offset || "false" == e.node.childNodes[e.offset - 1].contentEditable) && (e.offset == e.node.childNodes.length || "false" == e.node.childNodes[e.offset].contentEditable);
}
var YA = function (e) {
  ji(n, HO);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), (r = t.call(this)).height = e, r;
  }
  return zi(n, [{
    key: "toDOM",
    value: function value() {
      var e = document.createElement("div");
      return this.updateDOM(e), e;
    }
  }, {
    key: "eq",
    value: function value(e) {
      return e.height == this.height;
    }
  }, {
    key: "updateDOM",
    value: function value(e) {
      return e.style.height = this.height + "px", !0;
    }
  }, {
    key: "estimatedHeight",
    get: function get() {
      return this.height;
    }
  }]), n;
}();
function ZA(e) {
  var t = e.observer.selectionRange,
    n = t.focusNode && eE(t.focusNode, t.focusOffset, 0);
  if (!n) return null;
  var r = e.docView.nearest(n);
  if (!r) return null;
  if (r instanceof ZO) {
    for (var i = n; i.parentNode != r.dom;) {
      i = i.parentNode;
    }
    for (var o = i.previousSibling; o && !dO.get(o);) {
      o = o.previousSibling;
    }
    var a = o ? dO.get(o).posAtEnd : r.posAtStart;
    return {
      from: a,
      to: a,
      node: i,
      text: n
    };
  }
  for (;;) {
    var s = r.parent;
    if (!s) return null;
    if (s instanceof ZO) break;
    r = s;
  }
  var u = r.posAtStart;
  return {
    from: u,
    to: u + r.length,
    node: r.dom,
    text: n
  };
}
var XA = function (e) {
  ji(n, HO);
  var t = Ci(n);
  function n(e, r, i) {
    var o;
    return Ri(this, n), (o = t.call(this)).top = e, o.text = r, o.topView = i, o;
  }
  return zi(n, [{
    key: "eq",
    value: function value(e) {
      return this.top == e.top && this.text == e.text;
    }
  }, {
    key: "toDOM",
    value: function value() {
      return this.top;
    }
  }, {
    key: "ignoreEvent",
    value: function value() {
      return !1;
    }
  }, {
    key: "customView",
    get: function get() {
      return TO;
    }
  }]), n;
}();
function eE(e, t, n) {
  for (;;) {
    if (3 == e.nodeType) return e;
    if (1 == e.nodeType && t > 0 && n <= 0) t = X$(e = e.childNodes[t - 1]);else {
      if (!(1 == e.nodeType && t < e.childNodes.length && n >= 0)) return null;
      e = e.childNodes[t], t = 0;
    }
  }
}
function tE(e, t) {
  return 1 != e.nodeType ? 0 : (t && "false" == e.childNodes[t - 1].contentEditable ? 1 : 0) | (t < e.childNodes.length && "false" == e.childNodes[t].contentEditable ? 2 : 0);
}
var nE = function () {
  function e() {
    Ri(this, e), this.changes = [];
  }
  return zi(e, [{
    key: "compareRange",
    value: function value(e, t) {
      YO(e, t, this.changes);
    }
  }, {
    key: "comparePoint",
    value: function value(e, t) {
      YO(e, t, this.changes);
    }
  }]), e;
}();
function rE(e, t) {
  for (var n = e; n && n != t; n = n.assignedSlot || n.parentNode) {
    if (1 == n.nodeType && "false" == n.contentEditable) return !0;
  }
  return !1;
}
function iE(e, t) {
  return t.left > e ? t.left - e : Math.max(0, e - t.right);
}
function oE(e, t) {
  return t.top > e ? t.top - e : Math.max(0, e - t.bottom);
}
function aE(e, t) {
  return e.top < t.bottom - 1 && e.bottom > t.top + 1;
}
function sE(e, t) {
  return t < e.top ? {
    top: t,
    left: e.left,
    right: e.right,
    bottom: e.bottom
  } : e;
}
function uE(e, t) {
  return t > e.bottom ? {
    top: e.top,
    left: e.left,
    right: e.right,
    bottom: t
  } : e;
}
function cE(e, t, n) {
  for (var r, i, o, a, s, u, c, l, f = e.firstChild; f; f = f.nextSibling) {
    for (var h = G$(f), d = 0; d < h.length; d++) {
      var v = h[d];
      i && aE(i, v) && (v = sE(uE(v, i.bottom), i.top));
      var p = iE(t, v),
        m = oE(n, v);
      if (0 == p && 0 == m) return 3 == f.nodeType ? lE(f, t, n) : cE(f, t, n);
      (!r || a > m || a == m && o > p) && (r = f, i = v, o = p, a = m), 0 == p ? n > v.bottom && (!c || c.bottom < v.bottom) ? (s = f, c = v) : n < v.top && (!l || l.top > v.top) && (u = f, l = v) : c && aE(c, v) ? c = uE(c, v.bottom) : l && aE(l, v) && (l = sE(l, v.top));
    }
  }
  if (c && c.bottom >= n ? (r = s, i = c) : l && l.top <= n && (r = u, i = l), !r) return {
    node: e,
    offset: 0
  };
  var g = Math.max(i.left, Math.min(i.right, t));
  return 3 == r.nodeType ? lE(r, g, n) : o || "true" != r.contentEditable ? {
    node: e,
    offset: Array.prototype.indexOf.call(e.childNodes, r) + (t >= (i.left + i.right) / 2 ? 1 : 0)
  } : cE(r, g, n);
}
function lE(e, t, n) {
  for (var r = e.nodeValue.length, i = -1, o = 1e9, a = 0, s = 0; s < r; s++) {
    for (var u = sO(e, s, s + 1).getClientRects(), c = 0; c < u.length; c++) {
      var l = u[c];
      if (l.top != l.bottom) {
        a || (a = t - l.left);
        var f = (l.top > n ? l.top - n : n - l.bottom) - 1;
        if (l.left - 1 <= t && l.right + 1 >= t && f < o) {
          var h = t >= (l.left + l.right) / 2,
            d = h;
          if (AO.chrome || AO.gecko) sO(e, s).getBoundingClientRect().left == l.right && (d = !h);
          if (f <= 0) return {
            node: e,
            offset: s + (d ? 1 : 0)
          };
          i = s + (d ? 1 : 0), o = f;
        }
      }
    }
  }
  return {
    node: e,
    offset: i > -1 ? i : a > 0 ? e.nodeValue.length : 0
  };
}
function fE(e, t, n) {
  var r,
    i,
    o = t.x,
    a = t.y,
    s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : -1,
    u = e.contentDOM.getBoundingClientRect(),
    c = u.top + e.viewState.paddingTop,
    l = e.viewState.docHeight,
    f = a - c;
  if (f < 0) return 0;
  if (f > l) return e.state.doc.length;
  for (var h = e.defaultLineHeight / 2, d = !1; (i = e.elementAtHeight(f)).type != WO.Text;) {
    for (; !((f = s > 0 ? i.bottom + h : i.top - h) >= 0 && f <= l);) {
      if (d) return n ? null : 0;
      d = !0, s = -s;
    }
  }
  a = c + f;
  var v = i.from;
  if (v < e.viewport.from) return 0 == e.viewport.from ? 0 : n ? null : hE(e, u, i, o, a);
  if (v > e.viewport.to) return e.viewport.to == e.state.doc.length ? e.state.doc.length : n ? null : hE(e, u, i, o, a);
  var p = e.dom.ownerDocument,
    m = e.root.elementFromPoint ? e.root : p,
    g = m.elementFromPoint(o, a);
  g && !e.contentDOM.contains(g) && (g = null), g || (o = Math.max(u.left + 1, Math.min(u.right - 1, o)), (g = m.elementFromPoint(o, a)) && !e.contentDOM.contains(g) && (g = null));
  var y,
    b = -1;
  if (g && 0 != (null === (r = e.docView.nearest(g)) || void 0 === r ? void 0 : r.isEditable)) if (p.caretPositionFromPoint) {
    var k = p.caretPositionFromPoint(o, a);
    k && (y = k.offsetNode, b = k.offset);
  } else if (p.caretRangeFromPoint) {
    var w = p.caretRangeFromPoint(o, a);
    w && (y = w.startContainer, b = w.startOffset, AO.safari && dE(y, b, o) && (y = void 0));
  }
  if (!y || !e.docView.dom.contains(y)) {
    var x = ZO.find(e.docView, v);
    if (!x) return f > i.top + i.height / 2 ? i.to : i.from;
    var j = cE(x.dom, o, a);
    y = j.node, b = j.offset;
  }
  return e.docView.posFromDOM(y, b);
}
function hE(e, t, n, r, i) {
  var o = Math.round((r - t.left) * e.defaultCharacterWidth);
  e.lineWrapping && n.height > 1.5 * e.defaultLineHeight && (o += Math.floor((i - n.top) / e.defaultLineHeight) * e.viewState.heightOracle.lineLength);
  var a = e.state.sliceDoc(n.from, n.to);
  return n.from + A$(a, o, e.state.tabSize);
}
function dE(e, t, n) {
  var r;
  if (3 != e.nodeType || t != (r = e.nodeValue.length)) return !1;
  for (var i = e.nextSibling; i; i = i.nextSibling) {
    if (1 != i.nodeType || "BR" != i.nodeName) return !1;
  }
  return sO(e, r - 1, r).getBoundingClientRect().left > n;
}
function vE(e, t, n, r) {
  var i = e.state.doc.lineAt(t.head),
    o = r && e.lineWrapping ? e.coordsAtPos(t.assoc < 0 && t.head > i.from ? t.head - 1 : t.head) : null;
  if (o) {
    var a = e.dom.getBoundingClientRect(),
      s = e.textDirectionAt(i.from),
      u = e.posAtCoords({
        x: n == (s == _A.LTR) ? a.right - 1 : a.left + 1,
        y: (o.top + o.bottom) / 2
      });
    if (null != u) return b_.cursor(u, n ? -1 : 1);
  }
  var c = ZO.find(e.docView, t.head),
    l = c ? n ? c.posAtEnd : c.posAtStart : n ? i.to : i.from;
  return b_.cursor(l, n ? -1 : 1);
}
function pE(e, t, n, r) {
  for (var i = e.state.doc.lineAt(t.head), o = e.bidiSpans(i), a = e.textDirectionAt(i.from), s = t, u = null;;) {
    var c = WA(i, o, a, s, n),
      l = HA;
    if (!c) {
      if (i.number == (n ? e.state.doc.lines : 1)) return s;
      l = "\n", i = e.state.doc.line(i.number + (n ? 1 : -1)), o = e.bidiSpans(i), c = b_.cursor(n ? i.from : i.to);
    }
    if (u) {
      if (!u(l)) return s;
    } else {
      if (!r) return c;
      u = r(l);
    }
    s = c;
  }
}
function mE(e, t, n) {
  for (var r = e.state.facet(wA).map(function (t) {
    return t(e);
  });;) {
    var i,
      o = !1,
      a = bi(r);
    try {
      for (a.s(); !(i = a.n()).done;) {
        i.value.between(n.from - 1, n.from + 1, function (e, r, i) {
          n.from > e && n.from < r && (n = t.from > n.from ? b_.cursor(e, 1) : b_.cursor(r, -1), o = !0);
        });
      }
    } catch (e) {
      a.e(e);
    } finally {
      a.f();
    }
    if (!o) return n;
  }
}
var gE = function () {
    function e(t) {
      var n = this;
      Ri(this, e), this.lastKeyCode = 0, this.lastKeyTime = 0, this.chromeScrollHack = -1, this.pendingIOSKey = void 0, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastEscPress = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.registeredEvents = [], this.customHandlers = [], this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.rapidCompositionStart = !1, this.mouseSelection = null;
      var r = function r(e) {
        var r = xE[e];
        t.contentDOM.addEventListener(e, function (i) {
          wE(t, i) && !n.ignoreDuringComposition(i) && ("keydown" == e && n.keydown(t, i) || (n.mustFlushObserver(i) && t.observer.forceFlush(), n.runCustomHandlers(e, t, i) ? i.preventDefault() : r(t, i)));
        }), n.registeredEvents.push(e);
      };
      for (var i in xE) {
        r(i);
      }
      AO.chrome && AO.chrome_version >= 102 && t.scrollDOM.addEventListener("wheel", function () {
        n.chromeScrollHack < 0 ? t.contentDOM.style.pointerEvents = "none" : window.clearTimeout(n.chromeScrollHack), n.chromeScrollHack = setTimeout(function () {
          n.chromeScrollHack = -1, t.contentDOM.style.pointerEvents = "";
        }, 100);
      }, {
        passive: !0
      }), this.notifiedFocused = t.hasFocus, AO.safari && t.contentDOM.addEventListener("input", function () {
        return null;
      });
    }
    return zi(e, [{
      key: "setSelectionOrigin",
      value: function value(e) {
        this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
      }
    }, {
      key: "ensureHandlers",
      value: function value(e, t) {
        var n,
          r,
          i = this;
        this.customHandlers = [];
        var o,
          a = bi(t);
        try {
          for (a.s(); !(o = a.n()).done;) {
            var s = o.value;
            if (r = null === (n = s.update(e).spec) || void 0 === n ? void 0 : n.domEventHandlers) {
              this.customHandlers.push({
                plugin: s.value,
                handlers: r
              });
              var u = function u(t) {
                i.registeredEvents.indexOf(t) < 0 && "scroll" != t && (i.registeredEvents.push(t), e.contentDOM.addEventListener(t, function (n) {
                  wE(e, n) && i.runCustomHandlers(t, e, n) && n.preventDefault();
                }));
              };
              for (var c in r) {
                u(c);
              }
            }
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
      }
    }, {
      key: "runCustomHandlers",
      value: function value(e, t, n) {
        var r,
          i = bi(this.customHandlers);
        try {
          for (i.s(); !(r = i.n()).done;) {
            var o = r.value,
              a = o.handlers[e];
            if (a) try {
              if (a.call(o.plugin, n, t) || n.defaultPrevented) return !0;
            } catch (e) {
              hA(t.state, e);
            }
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        return !1;
      }
    }, {
      key: "runScrollHandlers",
      value: function value(e, t) {
        var n,
          r = bi(this.customHandlers);
        try {
          for (r.s(); !(n = r.n()).done;) {
            var i = n.value,
              o = i.handlers.scroll;
            if (o) try {
              o.call(i.plugin, t, e);
            } catch (t) {
              hA(e.state, t);
            }
          }
        } catch (e) {
          r.e(e);
        } finally {
          r.f();
        }
      }
    }, {
      key: "keydown",
      value: function value(e, t) {
        var n,
          r = this;
        return this.lastKeyCode = t.keyCode, this.lastKeyTime = Date.now(), 9 == t.keyCode && Date.now() < this.lastEscPress + 2e3 || (!AO.android || !AO.chrome || t.synthetic || 13 != t.keyCode && 8 != t.keyCode ? !(!AO.ios || !(n = yE.find(function (e) {
          return e.keyCode == t.keyCode;
        })) || t.ctrlKey || t.altKey || t.metaKey || t.synthetic) && (this.pendingIOSKey = n, setTimeout(function () {
          return r.flushIOSKey(e);
        }, 250), !0) : (e.observer.delayAndroidKey(t.key, t.keyCode), !0));
      }
    }, {
      key: "flushIOSKey",
      value: function value(e) {
        var t = this.pendingIOSKey;
        return !!t && (this.pendingIOSKey = void 0, uO(e.contentDOM, t.key, t.keyCode));
      }
    }, {
      key: "ignoreDuringComposition",
      value: function value(e) {
        return !!/^key/.test(e.type) && (this.composing > 0 || !!(AO.safari && Date.now() - this.compositionEndedAt < 100) && (this.compositionEndedAt = 0, !0));
      }
    }, {
      key: "mustFlushObserver",
      value: function value(e) {
        return "keydown" == e.type && 229 != e.keyCode || "compositionend" == e.type && !AO.ios;
      }
    }, {
      key: "startMouseSelection",
      value: function value(e) {
        this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
      }
    }, {
      key: "update",
      value: function value(e) {
        this.mouseSelection && this.mouseSelection.update(e), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
      }
    }, {
      key: "destroy",
      value: function value() {
        this.mouseSelection && this.mouseSelection.destroy();
      }
    }]), e;
  }(),
  yE = [{
    key: "Backspace",
    keyCode: 8,
    inputType: "deleteContentBackward"
  }, {
    key: "Enter",
    keyCode: 13,
    inputType: "insertParagraph"
  }, {
    key: "Delete",
    keyCode: 46,
    inputType: "deleteContentForward"
  }],
  bE = [16, 17, 18, 20, 91, 92, 224, 225],
  kE = function () {
    function e(t, n, r, i) {
      Ri(this, e), this.view = t, this.style = r, this.mustSelect = i, this.lastEvent = n;
      var o = t.contentDOM.ownerDocument;
      o.addEventListener("mousemove", this.move = this.move.bind(this)), o.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = t.state.facet(c$.allowMultipleSelections) && function (e, t) {
        var n = e.state.facet(rA);
        return n.length ? n[0](t) : AO.mac ? t.metaKey : t.ctrlKey;
      }(t, n), this.dragMove = function (e, t) {
        var n = e.state.facet(iA);
        return n.length ? n[0](t) : AO.mac ? !t.altKey : !t.ctrlKey;
      }(t, n), this.dragging = !(!function (e, t) {
        if (e.state.selection.main.empty) return !1;
        var n = U$(e.root);
        if (0 == n.rangeCount) return !0;
        for (var r = n.getRangeAt(0).getClientRects(), i = 0; i < r.length; i++) {
          var o = r[i];
          if (o.left <= t.clientX && o.right >= t.clientX && o.top <= t.clientY && o.bottom >= t.clientY) return !0;
        }
        return !1;
      }(t, n) || 1 != NE(n)) && null, !1 === this.dragging && (n.preventDefault(), this.select(n));
    }
    return zi(e, [{
      key: "move",
      value: function value(e) {
        if (0 == e.buttons) return this.destroy();
        !1 === this.dragging && this.select(this.lastEvent = e);
      }
    }, {
      key: "up",
      value: function value(e) {
        null == this.dragging && this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
      }
    }, {
      key: "destroy",
      value: function value() {
        var e = this.view.contentDOM.ownerDocument;
        e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = null;
      }
    }, {
      key: "select",
      value: function value(e) {
        var t = this.style.get(e, this.extend, this.multiple);
        !this.mustSelect && t.eq(this.view.state.selection) && t.main.assoc == this.view.state.selection.main.assoc || this.view.dispatch({
          selection: t,
          userEvent: "select.pointer",
          scrollIntoView: !0
        }), this.mustSelect = !1;
      }
    }, {
      key: "update",
      value: function value(e) {
        var t = this;
        e.docChanged && this.dragging && (this.dragging = this.dragging.map(e.changes)), this.style.update(e) && setTimeout(function () {
          return t.select(t.lastEvent);
        }, 20);
      }
    }]), e;
  }();
function wE(e, t) {
  if (!t.bubbles) return !0;
  if (t.defaultPrevented) return !1;
  for (var n, r = t.target; r != e.contentDOM; r = r.parentNode) {
    if (!r || 11 == r.nodeType || (n = dO.get(r)) && n.ignoreEvent(t)) return !1;
  }
  return !0;
}
var xE = Object.create(null),
  jE = AO.ie && AO.ie_version < 15 || AO.ios && AO.webkit_version < 604;
function SE(e, t) {
  var n,
    r = e.state,
    i = 1,
    o = r.toText(t),
    a = o.lines == r.selection.ranges.length;
  if (null != DE && r.selection.ranges.every(function (e) {
    return e.empty;
  }) && DE == o.toString()) {
    var s = -1;
    n = r.changeByRange(function (e) {
      var n = r.doc.lineAt(e.from);
      if (n.from == s) return {
        range: e
      };
      s = n.from;
      var u = r.toText((a ? o.line(i++).text : t) + r.lineBreak);
      return {
        changes: {
          from: n.from,
          insert: u
        },
        range: b_.cursor(e.from + u.length)
      };
    });
  } else n = a ? r.changeByRange(function (e) {
    var t = o.line(i++);
    return {
      changes: {
        from: e.from,
        to: e.to,
        insert: t.text
      },
      range: b_.cursor(e.from + t.length)
    };
  }) : r.replaceSelection(o);
  e.dispatch(n, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
xE.keydown = function (e, t) {
  e.inputState.setSelectionOrigin("select"), 27 == t.keyCode ? e.inputState.lastEscPress = Date.now() : bE.indexOf(t.keyCode) < 0 && (e.inputState.lastEscPress = 0);
};
var CE = 0;
function _E(e, t, n, r) {
  if (1 == r) return b_.cursor(t, n);
  if (2 == r) return function (e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
      r = e.charCategorizer(t),
      i = e.doc.lineAt(t),
      o = t - i.from;
    if (0 == i.length) return b_.cursor(t);
    0 == o ? n = 1 : o == i.length && (n = -1);
    var a = o,
      s = o;
    n < 0 ? a = e_(i.text, o, !1) : s = e_(i.text, o);
    for (var u = r(i.text.slice(a, s)); a > 0;) {
      var c = e_(i.text, a, !1);
      if (r(i.text.slice(c, a)) != u) break;
      a = c;
    }
    for (; s < i.length;) {
      var l = e_(i.text, s);
      if (r(i.text.slice(s, l)) != u) break;
      s = l;
    }
    return b_.range(a + i.from, s + i.from);
  }(e.state, t, n);
  var i = ZO.find(e.docView, t),
    o = e.state.doc.lineAt(i ? i.posAtEnd : t),
    a = i ? i.posAtStart : o.from,
    s = i ? i.posAtEnd : o.to;
  return s < e.state.doc.length && s == o.to && s++, b_.range(a, s);
}
xE.touchstart = function (e, t) {
  CE = Date.now(), e.inputState.setSelectionOrigin("select.pointer");
}, xE.touchmove = function (e) {
  e.inputState.setSelectionOrigin("select.pointer");
}, xE.mousedown = function (e, t) {
  if (e.observer.flush(), !(CE > Date.now() - 2e3 && 1 == NE(t))) {
    var n,
      r = null,
      i = bi(e.state.facet(oA));
    try {
      for (i.s(); !(n = i.n()).done;) {
        if (r = (0, n.value)(e, t)) break;
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
    if (r || 0 != t.button || (r = function (e, t) {
      var n = EE(e, t),
        r = NE(t),
        i = e.state.selection,
        o = n,
        a = t;
      return {
        update: function update(e) {
          e.docChanged && (n && (n.pos = e.changes.mapPos(n.pos)), i = i.map(e.changes), a = null);
        },
        get: function get(t, s, u) {
          var c;
          if (a && t.clientX == a.clientX && t.clientY == a.clientY ? c = o : (c = o = EE(e, t), a = t), !c || !n) return i;
          var l = _E(e, c.pos, c.bias, r);
          if (n.pos != c.pos && !s) {
            var f = _E(e, n.pos, n.bias, r),
              h = Math.min(f.from, l.from),
              d = Math.max(f.to, l.to);
            l = h < l.from ? b_.range(h, d) : b_.range(d, h);
          }
          return s ? i.replaceRange(i.main.extend(l.from, l.to)) : u ? i.addRange(l) : b_.create([l]);
        }
      };
    }(e, t)), r) {
      var o = e.root.activeElement != e.contentDOM;
      o && e.observer.ignore(function () {
        return aO(e.contentDOM);
      }), e.inputState.startMouseSelection(new kE(e, t, r, o));
    }
  }
};
var $E = function $E(e, t) {
    return e >= t.top && e <= t.bottom;
  },
  OE = function OE(e, t, n) {
    return $E(t, n) && e >= n.left && e <= n.right;
  };
function AE(e, t, n, r) {
  var i = ZO.find(e.docView, t);
  if (!i) return 1;
  var o = t - i.posAtStart;
  if (0 == o) return 1;
  if (o == i.length) return -1;
  var a = i.coordsAt(o, -1);
  if (a && OE(n, r, a)) return -1;
  var s = i.coordsAt(o, 1);
  return s && OE(n, r, s) ? 1 : a && $E(r, a) ? -1 : 1;
}
function EE(e, t) {
  var n = e.posAtCoords({
    x: t.clientX,
    y: t.clientY
  }, !1);
  return {
    pos: n,
    bias: AE(e, n, t.clientX, t.clientY)
  };
}
var PE = AO.ie && AO.ie_version <= 11,
  ME = null,
  IE = 0,
  TE = 0;
function NE(e) {
  if (!PE) return e.detail;
  var t = ME,
    n = TE;
  return ME = e, TE = Date.now(), IE = !t || n > Date.now() - 400 && Math.abs(t.clientX - e.clientX) < 2 && Math.abs(t.clientY - e.clientY) < 2 ? (IE + 1) % 3 : 1;
}
function RE(e, t, n, r) {
  if (n) {
    var i = e.posAtCoords({
      x: t.clientX,
      y: t.clientY
    }, !1);
    t.preventDefault();
    var o = e.inputState.mouseSelection,
      a = r && o && o.dragging && o.dragMove ? {
        from: o.dragging.from,
        to: o.dragging.to
      } : null,
      s = {
        from: i,
        insert: n
      },
      u = e.state.changes(a ? [a, s] : s);
    e.focus(), e.dispatch({
      changes: u,
      selection: {
        anchor: u.mapPos(i, -1),
        head: u.mapPos(i, 1)
      },
      userEvent: a ? "move.drop" : "input.drop"
    });
  }
}
xE.dragstart = function (e, t) {
  var n = e.state.selection.main,
    r = e.inputState.mouseSelection;
  r && (r.dragging = n), t.dataTransfer && (t.dataTransfer.setData("Text", e.state.sliceDoc(n.from, n.to)), t.dataTransfer.effectAllowed = "copyMove");
}, xE.drop = function (e, t) {
  if (t.dataTransfer) {
    if (e.state.readOnly) return t.preventDefault();
    var n = t.dataTransfer.files;
    n && n.length ? function () {
      t.preventDefault();
      for (var r = Array(n.length), i = 0, o = function o() {
          ++i == n.length && RE(e, t, r.filter(function (e) {
            return null != e;
          }).join(e.state.lineBreak), !1);
        }, a = function a(e) {
          var t = new FileReader();
          t.onerror = o, t.onload = function () {
            /[\x00-\x08\x0e-\x1f]{2}/.test(t.result) || (r[e] = t.result), o();
          }, t.readAsText(n[e]);
        }, s = 0; s < n.length; s++) {
        a(s);
      }
    }() : RE(e, t, t.dataTransfer.getData("Text"), !0);
  }
}, xE.paste = function (e, t) {
  if (e.state.readOnly) return t.preventDefault();
  e.observer.flush();
  var n = jE ? null : t.clipboardData;
  n ? (SE(e, n.getData("text/plain")), t.preventDefault()) : function (e) {
    var t = e.dom.parentNode;
    if (t) {
      var n = t.appendChild(document.createElement("textarea"));
      n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(function () {
        e.focus(), n.remove(), SE(e, n.value);
      }, 50);
    }
  }(e);
};
var DE = null;
function zE(e) {
  setTimeout(function () {
    e.hasFocus != e.inputState.notifiedFocused && e.update([]);
  }, 10);
}
function LE(e, t) {
  if (e.docView.compositionDeco.size) {
    e.inputState.rapidCompositionStart = t;
    try {
      e.update([]);
    } finally {
      e.inputState.rapidCompositionStart = !1;
    }
  }
}
xE.copy = xE.cut = function (e, t) {
  var n = function (e) {
      var t,
        n = [],
        r = [],
        i = !1,
        o = bi(e.selection.ranges);
      try {
        for (o.s(); !(t = o.n()).done;) {
          var a = t.value;
          a.empty || (n.push(e.sliceDoc(a.from, a.to)), r.push(a));
        }
      } catch (e) {
        o.e(e);
      } finally {
        o.f();
      }
      if (!n.length) {
        var s,
          u = -1,
          c = bi(e.selection.ranges);
        try {
          for (c.s(); !(s = c.n()).done;) {
            var l = s.value.from,
              f = e.doc.lineAt(l);
            f.number > u && (n.push(f.text), r.push({
              from: f.from,
              to: Math.min(e.doc.length, f.to + 1)
            })), u = f.number;
          }
        } catch (e) {
          c.e(e);
        } finally {
          c.f();
        }
        i = !0;
      }
      return {
        text: n.join(e.lineBreak),
        ranges: r,
        linewise: i
      };
    }(e.state),
    r = n.text,
    i = n.ranges,
    o = n.linewise;
  if (r || o) {
    DE = o ? r : null;
    var a = jE ? null : t.clipboardData;
    a ? (t.preventDefault(), a.clearData(), a.setData("text/plain", r)) : function (e, t) {
      var n = e.dom.parentNode;
      if (n) {
        var r = n.appendChild(document.createElement("textarea"));
        r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = t, r.focus(), r.selectionEnd = t.length, r.selectionStart = 0, setTimeout(function () {
          r.remove(), e.focus();
        }, 50);
      }
    }(e, r), "cut" != t.type || e.state.readOnly || e.dispatch({
      changes: i,
      scrollIntoView: !0,
      userEvent: "delete.cut"
    });
  }
}, xE.focus = zE, xE.blur = function (e) {
  e.observer.clearSelectionRange(), zE(e);
}, xE.compositionstart = xE.compositionupdate = function (e) {
  null == e.inputState.compositionFirstChange && (e.inputState.compositionFirstChange = !0), e.inputState.composing < 0 && (e.inputState.composing = 0, e.docView.compositionDeco.size && (e.observer.flush(), LE(e, !0)));
}, xE.compositionend = function (e) {
  e.inputState.composing = -1, e.inputState.compositionEndedAt = Date.now(), e.inputState.compositionFirstChange = null, setTimeout(function () {
    e.inputState.composing < 0 && LE(e, !1);
  }, 50);
}, xE.contextmenu = function (e) {
  e.inputState.lastContextMenu = Date.now();
}, xE.beforeinput = function (e, t) {
  var n, r;
  if (AO.chrome && AO.android && (r = yE.find(function (e) {
    return e.inputType == t.inputType;
  })) && (e.observer.delayAndroidKey(r.key, r.keyCode), "Backspace" == r.key || "Delete" == r.key)) {
    var i = (null === (n = window.visualViewport) || void 0 === n ? void 0 : n.height) || 0;
    setTimeout(function () {
      var t;
      ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.height) || 0) > i + 10 && e.hasFocus && (e.contentDOM.blur(), e.focus());
    }, 100);
  }
};
var BE = ["pre-wrap", "normal", "pre-line", "break-spaces"],
  qE = function () {
    function e() {
      Ri(this, e), this.doc = BC.empty, this.lineWrapping = !1, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.lineLength = 30, this.heightChanged = !1;
    }
    return zi(e, [{
      key: "heightForGap",
      value: function value(e, t) {
        var n = this.doc.lineAt(t).number - this.doc.lineAt(e).number + 1;
        return this.lineWrapping && (n += Math.ceil((t - e - n * this.lineLength * .5) / this.lineLength)), this.lineHeight * n;
      }
    }, {
      key: "heightForLine",
      value: function value(e) {
        return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
      }
    }, {
      key: "setDoc",
      value: function value(e) {
        return this.doc = e, this;
      }
    }, {
      key: "mustRefreshForWrapping",
      value: function value(e) {
        return BE.indexOf(e) > -1 != this.lineWrapping;
      }
    }, {
      key: "mustRefreshForHeights",
      value: function value(e) {
        for (var t = !1, n = 0; n < e.length; n++) {
          var r = e[n];
          r < 0 ? n++ : this.heightSamples[Math.floor(10 * r)] || (t = !0, this.heightSamples[Math.floor(10 * r)] = !0);
        }
        return t;
      }
    }, {
      key: "refresh",
      value: function value(e, t, n, r, i) {
        var o = BE.indexOf(e) > -1,
          a = Math.round(t) != Math.round(this.lineHeight) || this.lineWrapping != o;
        if (this.lineWrapping = o, this.lineHeight = t, this.charWidth = n, this.lineLength = r, a) {
          this.heightSamples = {};
          for (var s = 0; s < i.length; s++) {
            var u = i[s];
            u < 0 ? s++ : this.heightSamples[Math.floor(10 * u)] = !0;
          }
        }
        return a;
      }
    }]), e;
  }(),
  FE = function () {
    function e(t, n) {
      Ri(this, e), this.from = t, this.heights = n, this.index = 0;
    }
    return zi(e, [{
      key: "more",
      get: function get() {
        return this.index < this.heights.length;
      }
    }]), e;
  }(),
  VE = function () {
    function e(t, n, r, i, o) {
      Ri(this, e), this.from = t, this.length = n, this.top = r, this.height = i, this.type = o;
    }
    return zi(e, [{
      key: "to",
      get: function get() {
        return this.from + this.length;
      }
    }, {
      key: "bottom",
      get: function get() {
        return this.top + this.height;
      }
    }, {
      key: "join",
      value: function value(t) {
        var n = (Array.isArray(this.type) ? this.type : [this]).concat(Array.isArray(t.type) ? t.type : [t]);
        return new e(this.from, this.length + t.length, this.top, this.height + t.height, n);
      }
    }]), e;
  }(),
  HE = function (e) {
    return e[e.ByPos = 0] = "ByPos", e[e.ByHeight = 1] = "ByHeight", e[e.ByPosNoHeight = 2] = "ByPosNoHeight", e;
  }(HE || (HE = {})),
  WE = function () {
    function e(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2;
      Ri(this, e), this.length = t, this.height = n, this.flags = r;
    }
    return zi(e, [{
      key: "outdated",
      get: function get() {
        return (2 & this.flags) > 0;
      },
      set: function set(e) {
        this.flags = (e ? 2 : 0) | -3 & this.flags;
      }
    }, {
      key: "setHeight",
      value: function value(e, t) {
        this.height != t && (Math.abs(this.height - t) > .001 && (e.heightChanged = !0), this.height = t);
      }
    }, {
      key: "replace",
      value: function value(t, n, r) {
        return e.of(r);
      }
    }, {
      key: "decomposeLeft",
      value: function value(e, t) {
        t.push(this);
      }
    }, {
      key: "decomposeRight",
      value: function value(e, t) {
        t.push(this);
      }
    }, {
      key: "applyChanges",
      value: function value(e, t, n, r) {
        for (var i = this, o = r.length - 1; o >= 0; o--) {
          var a = r[o],
            s = a.fromA,
            u = a.toA,
            c = a.fromB,
            l = a.toB,
            f = i.lineAt(s, HE.ByPosNoHeight, t, 0, 0),
            h = f.to >= u ? f : i.lineAt(u, HE.ByPosNoHeight, t, 0, 0);
          for (l += h.to - u, u = h.to; o > 0 && f.from <= r[o - 1].toA;) {
            s = r[o - 1].fromA, c = r[o - 1].fromB, o--, s < f.from && (f = i.lineAt(s, HE.ByPosNoHeight, t, 0, 0));
          }
          c += f.from - s, s = f.from;
          var d = YE.build(n, e, c, l);
          i = i.replace(s, u, d);
        }
        return i.updateHeight(n, 0);
      }
    }], [{
      key: "empty",
      value: function value() {
        return new JE(0, 0);
      }
    }, {
      key: "of",
      value: function value(t) {
        if (1 == t.length) return t[0];
        for (var n = 0, r = t.length, i = 0, o = 0;;) {
          if (n == r) {
            if (i > 2 * o) {
              var a = t[n - 1];
              a.break ? t.splice(--n, 1, a.left, null, a.right) : t.splice(--n, 1, a.left, a.right), r += 1 + a.break, i -= a.size;
            } else {
              if (!(o > 2 * i)) break;
              var s = t[r];
              s.break ? t.splice(r, 1, s.left, null, s.right) : t.splice(r, 1, s.left, s.right), r += 2 + s.break, o -= s.size;
            }
          } else if (i < o) {
            var u = t[n++];
            u && (i += u.size);
          } else {
            var c = t[--r];
            c && (o += c.size);
          }
        }
        var l = 0;
        return null == t[n - 1] ? (l = 1, n--) : null == t[n] && (l = 1, r++), new GE(e.of(t.slice(0, n)), l, e.of(t.slice(r)));
      }
    }]), e;
  }();
WE.prototype.size = 1;
var UE = function (e) {
    ji(n, WE);
    var t = Ci(n);
    function n(e, r, i) {
      var o;
      return Ri(this, n), (o = t.call(this, e, r)).type = i, o;
    }
    return zi(n, [{
      key: "blockAt",
      value: function value(e, t, n, r) {
        return new VE(r, this.length, n, this.height, this.type);
      }
    }, {
      key: "lineAt",
      value: function value(e, t, n, r, i) {
        return this.blockAt(0, n, r, i);
      }
    }, {
      key: "forEachLine",
      value: function value(e, t, n, r, i, o) {
        e <= i + this.length && t >= i && o(this.blockAt(0, n, r, i));
      }
    }, {
      key: "updateHeight",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = arguments.length > 3 ? arguments[3] : void 0;
        return n && n.from <= t && n.more && this.setHeight(e, n.heights[n.index++]), this.outdated = !1, this;
      }
    }, {
      key: "toString",
      value: function value() {
        return "block(".concat(this.length, ")");
      }
    }]), n;
  }(),
  JE = function (e) {
    ji(n, UE);
    var t = Ci(n);
    function n(e, r) {
      var i;
      return Ri(this, n), (i = t.call(this, e, r, WO.Text)).collapsed = 0, i.widgetHeight = 0, i;
    }
    return zi(n, [{
      key: "replace",
      value: function value(e, t, r) {
        var i = r[0];
        return 1 == r.length && (i instanceof n || i instanceof KE && 4 & i.flags) && Math.abs(this.length - i.length) < 10 ? (i instanceof KE ? i = new n(i.length, this.height) : i.height = this.height, this.outdated || (i.outdated = !1), i) : WE.of(r);
      }
    }, {
      key: "updateHeight",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          r = arguments.length > 3 ? arguments[3] : void 0;
        return r && r.from <= t && r.more ? this.setHeight(e, r.heights[r.index++]) : (n || this.outdated) && this.setHeight(e, Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed))), this.outdated = !1, this;
      }
    }, {
      key: "toString",
      value: function value() {
        return "line(".concat(this.length).concat(this.collapsed ? -this.collapsed : "").concat(this.widgetHeight ? ":" + this.widgetHeight : "", ")");
      }
    }]), n;
  }(),
  KE = function (e) {
    ji(n, WE);
    var t = Ci(n);
    function n(e) {
      return Ri(this, n), t.call(this, e, 0);
    }
    return zi(n, [{
      key: "lines",
      value: function value(e, t) {
        var n = e.lineAt(t).number,
          r = e.lineAt(t + this.length).number;
        return {
          firstLine: n,
          lastLine: r,
          lineHeight: this.height / (r - n + 1)
        };
      }
    }, {
      key: "blockAt",
      value: function value(e, t, n, r) {
        var i = this.lines(t, r),
          o = i.firstLine,
          a = i.lastLine,
          s = i.lineHeight,
          u = Math.max(0, Math.min(a - o, Math.floor((e - n) / s))),
          c = t.line(o + u),
          l = c.from,
          f = c.length;
        return new VE(l, f, n + s * u, s, WO.Text);
      }
    }, {
      key: "lineAt",
      value: function value(e, t, n, r, i) {
        if (t == HE.ByHeight) return this.blockAt(e, n, r, i);
        if (t == HE.ByPosNoHeight) {
          var o = n.lineAt(e),
            a = o.from,
            s = o.to;
          return new VE(a, s - a, 0, 0, WO.Text);
        }
        var u = this.lines(n, i),
          c = u.firstLine,
          l = u.lineHeight,
          f = n.lineAt(e),
          h = f.from,
          d = f.length,
          v = f.number;
        return new VE(h, d, r + l * (v - c), l, WO.Text);
      }
    }, {
      key: "forEachLine",
      value: function value(e, t, n, r, i, o) {
        for (var a = this.lines(n, i), s = a.firstLine, u = a.lineHeight, c = Math.max(e, i), l = Math.min(i + this.length, t); c <= l;) {
          var f = n.lineAt(c);
          c == e && (r += u * (f.number - s)), o(new VE(f.from, f.length, r, u, WO.Text)), r += u, c = f.to + 1;
        }
      }
    }, {
      key: "replace",
      value: function value(e, t, r) {
        var i = this.length - t;
        if (i > 0) {
          var o = r[r.length - 1];
          o instanceof n ? r[r.length - 1] = new n(o.length + i) : r.push(null, new n(i - 1));
        }
        if (e > 0) {
          var a = r[0];
          a instanceof n ? r[0] = new n(e + a.length) : r.unshift(new n(e - 1), null);
        }
        return WE.of(r);
      }
    }, {
      key: "decomposeLeft",
      value: function value(e, t) {
        t.push(new n(e - 1), null);
      }
    }, {
      key: "decomposeRight",
      value: function value(e, t) {
        t.push(null, new n(this.length - e - 1));
      }
    }, {
      key: "updateHeight",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          i = arguments.length > 3 ? arguments[3] : void 0,
          o = t + this.length;
        if (i && i.from <= t + this.length && i.more) {
          var a = [],
            s = Math.max(t, i.from),
            u = -1,
            c = e.heightChanged;
          for (i.from > t && a.push(new n(i.from - t - 1).updateHeight(e, t)); s <= o && i.more;) {
            var l = e.doc.lineAt(s).length;
            a.length && a.push(null);
            var f = i.heights[i.index++];
            -1 == u ? u = f : Math.abs(f - u) >= .001 && (u = -2);
            var h = new JE(l, f);
            h.outdated = !1, a.push(h), s += l + 1;
          }
          s <= o && a.push(null, new n(o - s).updateHeight(e, s));
          var d = WE.of(a);
          return e.heightChanged = c || u < 0 || Math.abs(d.height - this.height) >= .001 || Math.abs(u - this.lines(e.doc, t).lineHeight) >= .001, d;
        }
        return (r || this.outdated) && (this.setHeight(e, e.heightForGap(t, t + this.length)), this.outdated = !1), this;
      }
    }, {
      key: "toString",
      value: function value() {
        return "gap(".concat(this.length, ")");
      }
    }]), n;
  }(),
  GE = function (e) {
    ji(n, WE);
    var t = Ci(n);
    function n(e, r, i) {
      var o;
      return Ri(this, n), (o = t.call(this, e.length + r + i.length, e.height + i.height, r | (e.outdated || i.outdated ? 2 : 0))).left = e, o.right = i, o.size = e.size + i.size, o;
    }
    return zi(n, [{
      key: "break",
      get: function get() {
        return 1 & this.flags;
      }
    }, {
      key: "blockAt",
      value: function value(e, t, n, r) {
        var i = n + this.left.height;
        return e < i ? this.left.blockAt(e, t, n, r) : this.right.blockAt(e, t, i, r + this.left.length + this.break);
      }
    }, {
      key: "lineAt",
      value: function value(e, t, n, r, i) {
        var o = r + this.left.height,
          a = i + this.left.length + this.break,
          s = t == HE.ByHeight ? e < o : e < a,
          u = s ? this.left.lineAt(e, t, n, r, i) : this.right.lineAt(e, t, n, o, a);
        if (this.break || (s ? u.to < a : u.from > a)) return u;
        var c = t == HE.ByPosNoHeight ? HE.ByPosNoHeight : HE.ByPos;
        return s ? u.join(this.right.lineAt(a, c, n, o, a)) : this.left.lineAt(a, c, n, r, i).join(u);
      }
    }, {
      key: "forEachLine",
      value: function value(e, t, n, r, i, o) {
        var a = r + this.left.height,
          s = i + this.left.length + this.break;
        if (this.break) e < s && this.left.forEachLine(e, t, n, r, i, o), t >= s && this.right.forEachLine(e, t, n, a, s, o);else {
          var u = this.lineAt(s, HE.ByPos, n, r, i);
          e < u.from && this.left.forEachLine(e, u.from - 1, n, r, i, o), u.to >= e && u.from <= t && o(u), t > u.to && this.right.forEachLine(u.to + 1, t, n, a, s, o);
        }
      }
    }, {
      key: "replace",
      value: function value(e, t, n) {
        var r = this.left.length + this.break;
        if (t < r) return this.balanced(this.left.replace(e, t, n), this.right);
        if (e > this.left.length) return this.balanced(this.left, this.right.replace(e - r, t - r, n));
        var i = [];
        e > 0 && this.decomposeLeft(e, i);
        var o,
          a = i.length,
          s = bi(n);
        try {
          for (s.s(); !(o = s.n()).done;) {
            var u = o.value;
            i.push(u);
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
        if (e > 0 && QE(i, a - 1), t < this.length) {
          var c = i.length;
          this.decomposeRight(t, i), QE(i, c);
        }
        return WE.of(i);
      }
    }, {
      key: "decomposeLeft",
      value: function value(e, t) {
        var n = this.left.length;
        if (e <= n) return this.left.decomposeLeft(e, t);
        t.push(this.left), this.break && e >= ++n && t.push(null), e > n && this.right.decomposeLeft(e - n, t);
      }
    }, {
      key: "decomposeRight",
      value: function value(e, t) {
        var n = this.left.length,
          r = n + this.break;
        if (e >= r) return this.right.decomposeRight(e - r, t);
        e < n && this.left.decomposeRight(e, t), this.break && e < r && t.push(null), t.push(this.right);
      }
    }, {
      key: "balanced",
      value: function value(e, t) {
        return e.size > 2 * t.size || t.size > 2 * e.size ? WE.of(this.break ? [e, null, t] : [e, t]) : (this.left = e, this.right = t, this.height = e.height + t.height, this.outdated = e.outdated || t.outdated, this.size = e.size + t.size, this.length = e.length + this.break + t.length, this);
      }
    }, {
      key: "updateHeight",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          r = arguments.length > 3 ? arguments[3] : void 0,
          i = this.left,
          o = this.right,
          a = t + i.length + this.break,
          s = null;
        return r && r.from <= t + i.length && r.more ? s = i = i.updateHeight(e, t, n, r) : i.updateHeight(e, t, n), r && r.from <= a + o.length && r.more ? s = o = o.updateHeight(e, a, n, r) : o.updateHeight(e, a, n), s ? this.balanced(i, o) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
      }
    }, {
      key: "toString",
      value: function value() {
        return this.left + (this.break ? " " : "-") + this.right;
      }
    }]), n;
  }();
function QE(e, t) {
  var n, r;
  null == e[t] && (n = e[t - 1]) instanceof KE && (r = e[t + 1]) instanceof KE && e.splice(t - 1, 3, new KE(n.length + 1 + r.length));
}
var YE = function () {
  function e(t, n) {
    Ri(this, e), this.pos = t, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = t;
  }
  return zi(e, [{
    key: "isCovered",
    get: function get() {
      return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
  }, {
    key: "span",
    value: function value(e, t) {
      if (this.lineStart > -1) {
        var n = Math.min(t, this.lineEnd),
          r = this.nodes[this.nodes.length - 1];
        r instanceof JE ? r.length += n - this.pos : (n > this.pos || !this.isCovered) && this.nodes.push(new JE(n - this.pos, -1)), this.writtenTo = n, t > n && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
      }
      this.pos = t;
    }
  }, {
    key: "point",
    value: function value(e, t, n) {
      if (e < t || n.heightRelevant) {
        var r = n.widget ? n.widget.estimatedHeight : 0;
        r < 0 && (r = this.oracle.lineHeight);
        var i = t - e;
        n.block ? this.addBlock(new UE(i, r, n.type)) : (i || r >= 5) && this.addLineDeco(r, i);
      } else t > e && this.span(e, t);
      this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
    }
  }, {
    key: "enterLine",
    value: function value() {
      if (!(this.lineStart > -1)) {
        var e = this.oracle.doc.lineAt(this.pos),
          t = e.from,
          n = e.to;
        this.lineStart = t, this.lineEnd = n, this.writtenTo < t && ((this.writtenTo < t - 1 || null == this.nodes[this.nodes.length - 1]) && this.nodes.push(this.blankContent(this.writtenTo, t - 1)), this.nodes.push(null)), this.pos > t && this.nodes.push(new JE(this.pos - t, -1)), this.writtenTo = this.pos;
      }
    }
  }, {
    key: "blankContent",
    value: function value(e, t) {
      var n = new KE(t - e);
      return this.oracle.doc.lineAt(e).to == t && (n.flags |= 4), n;
    }
  }, {
    key: "ensureLine",
    value: function value() {
      this.enterLine();
      var e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
      if (e instanceof JE) return e;
      var t = new JE(0, -1);
      return this.nodes.push(t), t;
    }
  }, {
    key: "addBlock",
    value: function value(e) {
      this.enterLine(), e.type != WO.WidgetAfter || this.isCovered || this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos = this.pos + e.length, e.type != WO.WidgetBefore && (this.covering = e);
    }
  }, {
    key: "addLineDeco",
    value: function value(e, t) {
      var n = this.ensureLine();
      n.length += t, n.collapsed += t, n.widgetHeight = Math.max(n.widgetHeight, e), this.writtenTo = this.pos = this.pos + t;
    }
  }, {
    key: "finish",
    value: function value(e) {
      var t = 0 == this.nodes.length ? null : this.nodes[this.nodes.length - 1];
      !(this.lineStart > -1) || t instanceof JE || this.isCovered ? (this.writtenTo < this.pos || null == t) && this.nodes.push(this.blankContent(this.writtenTo, this.pos)) : this.nodes.push(new JE(0, -1));
      var n,
        r = e,
        i = bi(this.nodes);
      try {
        for (i.s(); !(n = i.n()).done;) {
          var o = n.value;
          o instanceof JE && o.updateHeight(this.oracle, r), r += o ? o.length : 1;
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }
      return this.nodes;
    }
  }], [{
    key: "build",
    value: function value(t, n, r, i) {
      var o = new e(r, t);
      return p$.spans(n, r, i, o, 0), o.finish(r);
    }
  }]), e;
}();
function ZE(e, t, n) {
  var r = new XE();
  return p$.compare(e, t, n, r, 0), r.changes;
}
var XE = function () {
  function e() {
    Ri(this, e), this.changes = [];
  }
  return zi(e, [{
    key: "compareRange",
    value: function value() {}
  }, {
    key: "comparePoint",
    value: function value(e, t, n, r) {
      (e < t || n && n.heightRelevant || r && r.heightRelevant) && YO(e, t, this.changes, 5);
    }
  }]), e;
}();
function eP(e, t) {
  for (var n = e.getBoundingClientRect(), r = Math.max(0, n.left), i = Math.min(innerWidth, n.right), o = Math.max(0, n.top), a = Math.min(innerHeight, n.bottom), s = e.ownerDocument.body, u = e.parentNode; u && u != s;) {
    if (1 == u.nodeType) {
      var c = u,
        l = window.getComputedStyle(c);
      if ((c.scrollHeight > c.clientHeight || c.scrollWidth > c.clientWidth) && "visible" != l.overflow) {
        var f = c.getBoundingClientRect();
        r = Math.max(r, f.left), i = Math.min(i, f.right), o = Math.max(o, f.top), a = Math.min(a, f.bottom);
      }
      u = "absolute" == l.position || "fixed" == l.position ? c.offsetParent : c.parentNode;
    } else {
      if (11 != u.nodeType) break;
      u = u.host;
    }
  }
  return {
    left: r - n.left,
    right: Math.max(r, i) - n.left,
    top: o - (n.top + t),
    bottom: Math.max(o, a) - (n.top + t)
  };
}
function tP(e, t) {
  var n = e.getBoundingClientRect();
  return {
    left: 0,
    right: n.right - n.left,
    top: t,
    bottom: n.bottom - (n.top + t)
  };
}
var nP = function () {
    function e(t, n, r) {
      Ri(this, e), this.from = t, this.to = n, this.size = r;
    }
    return zi(e, [{
      key: "draw",
      value: function value(e) {
        return UO.replace({
          widget: new rP(this.size, e)
        }).range(this.from, this.to);
      }
    }], [{
      key: "same",
      value: function value(e, t) {
        if (e.length != t.length) return !1;
        for (var n = 0; n < e.length; n++) {
          var r = e[n],
            i = t[n];
          if (r.from != i.from || r.to != i.to || r.size != i.size) return !1;
        }
        return !0;
      }
    }]), e;
  }(),
  rP = function (e) {
    ji(n, HO);
    var t = Ci(n);
    function n(e, r) {
      var i;
      return Ri(this, n), (i = t.call(this)).size = e, i.vertical = r, i;
    }
    return zi(n, [{
      key: "eq",
      value: function value(e) {
        return e.size == this.size && e.vertical == this.vertical;
      }
    }, {
      key: "toDOM",
      value: function value() {
        var e = document.createElement("div");
        return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
      }
    }, {
      key: "estimatedHeight",
      get: function get() {
        return this.vertical ? this.size : -1;
      }
    }]), n;
  }(),
  iP = function () {
    function e(t) {
      Ri(this, e), this.state = t, this.pixelViewport = {
        left: 0,
        right: window.innerWidth,
        top: 0,
        bottom: 0
      }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.heightOracle = new qE(), this.scaler = cP, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = _A.RTL, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1, this.stateDeco = t.facet(kA).filter(function (e) {
        return "function" != typeof e;
      }), this.heightMap = WE.empty().applyChanges(this.stateDeco, BC.empty, this.heightOracle.setDoc(t.doc), [new SA(0, 0, 0, t.doc.length)]), this.viewport = this.getViewport(0, null), this.updateViewportLines(), this.updateForViewport(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = UO.set(this.lineGaps.map(function (e) {
        return e.draw(!1);
      })), this.computeVisibleRanges();
    }
    return zi(e, [{
      key: "updateForViewport",
      value: function value() {
        for (var e = this, t = [this.viewport], n = this.state.selection.main, r = function r(_r2) {
            var i = _r2 ? n.head : n.anchor;
            if (!t.some(function (e) {
              var t = e.from,
                n = e.to;
              return i >= t && i <= n;
            })) {
              var o = e.lineBlockAt(i),
                a = o.from,
                s = o.to;
              t.push(new oP(a, s));
            }
          }, i = 0; i <= 1; i++) {
          r(i);
        }
        this.viewports = t.sort(function (e, t) {
          return e.from - t.from;
        }), this.scaler = this.heightMap.height <= 7e6 ? cP : new lP(this.heightOracle.doc, this.heightMap, this.viewports);
      }
    }, {
      key: "updateViewportLines",
      value: function value() {
        var e = this;
        this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.state.doc, 0, 0, function (t) {
          e.viewportLines.push(1 == e.scaler.scale ? t : fP(t, e.scaler));
        });
      }
    }, {
      key: "update",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        this.state = e.state;
        var n = this.stateDeco;
        this.stateDeco = this.state.facet(kA).filter(function (e) {
          return "function" != typeof e;
        });
        var r = e.changedRanges,
          i = SA.extendWithRanges(r, ZE(n, this.stateDeco, e ? e.changes : f_.empty(this.state.doc.length))),
          o = this.heightMap.height;
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), i), this.heightMap.height != o && (e.flags |= 2);
        var a = i.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
        (t && (t.range.head < a.from || t.range.head > a.to) || !this.viewportIsAppropriate(a)) && (a = this.getViewport(0, t));
        var s = !e.changes.empty || 2 & e.flags || a.from != this.viewport.from || a.to != this.viewport.to;
        this.viewport = a, this.updateForViewport(), s && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(), t && (this.scrollTarget = t), !this.mustEnforceCursorAssoc && e.selectionSet && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && (this.mustEnforceCursorAssoc = !0);
      }
    }, {
      key: "measure",
      value: function value(e) {
        var t = e.contentDOM,
          n = window.getComputedStyle(t),
          r = this.heightOracle,
          i = n.whiteSpace;
        this.defaultTextDirection = "rtl" == n.direction ? _A.RTL : _A.LTR;
        var o = this.heightOracle.mustRefreshForWrapping(i),
          a = o || this.mustMeasureContent || this.contentDOMHeight != t.clientHeight;
        this.contentDOMHeight = t.clientHeight, this.mustMeasureContent = !1;
        var s = 0,
          u = 0,
          c = parseInt(n.paddingTop) || 0,
          l = parseInt(n.paddingBottom) || 0;
        this.paddingTop == c && this.paddingBottom == l || (this.paddingTop = c, this.paddingBottom = l, s |= 10), this.editorWidth != e.scrollDOM.clientWidth && (r.lineWrapping && (a = !0), this.editorWidth = e.scrollDOM.clientWidth, s |= 8);
        var f = (this.printing ? tP : eP)(t, this.paddingTop),
          h = f.top - this.pixelViewport.top,
          d = f.bottom - this.pixelViewport.bottom;
        this.pixelViewport = f;
        var v = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (v != this.inView && (this.inView = v, v && (a = !0)), !this.inView) return 0;
        var p = t.clientWidth;
        if (this.contentDOMWidth == p && this.editorHeight == e.scrollDOM.clientHeight || (this.contentDOMWidth = p, this.editorHeight = e.scrollDOM.clientHeight, s |= 8), a) {
          var m = e.docView.measureVisibleLineHeights(this.viewport);
          if (r.mustRefreshForHeights(m) && (o = !0), o || r.lineWrapping && Math.abs(p - this.contentDOMWidth) > r.charWidth) {
            var g = e.docView.measureTextSize(),
              y = g.lineHeight,
              b = g.charWidth;
            (o = r.refresh(i, y, b, p / b, m)) && (e.docView.minWidth = 0, s |= 8);
          }
          h > 0 && d > 0 ? u = Math.max(h, d) : h < 0 && d < 0 && (u = Math.min(h, d)), r.heightChanged = !1;
          var k,
            w = bi(this.viewports);
          try {
            for (w.s(); !(k = w.n()).done;) {
              var x = k.value,
                j = x.from == this.viewport.from ? m : e.docView.measureVisibleLineHeights(x);
              this.heightMap = this.heightMap.updateHeight(r, 0, o, new FE(x.from, j));
            }
          } catch (e) {
            w.e(e);
          } finally {
            w.f();
          }
          r.heightChanged && (s |= 2);
        }
        var S = !this.viewportIsAppropriate(this.viewport, u) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        return S && (this.viewport = this.getViewport(u, this.scrollTarget)), this.updateForViewport(), (2 & s || S) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(o ? [] : this.lineGaps)), s |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), s;
      }
    }, {
      key: "visibleTop",
      get: function get() {
        return this.scaler.fromDOM(this.pixelViewport.top);
      }
    }, {
      key: "visibleBottom",
      get: function get() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
      }
    }, {
      key: "getViewport",
      value: function value(e, t) {
        var n = .5 - Math.max(-.5, Math.min(.5, e / 1e3 / 2)),
          r = this.heightMap,
          i = this.state.doc,
          o = this.visibleTop,
          a = this.visibleBottom,
          s = new oP(r.lineAt(o - 1e3 * n, HE.ByHeight, i, 0, 0).from, r.lineAt(a + 1e3 * (1 - n), HE.ByHeight, i, 0, 0).to);
        if (t) {
          var u = t.range.head;
          if (u < s.from || u > s.to) {
            var c,
              l = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top),
              f = r.lineAt(u, HE.ByPos, i, 0, 0);
            c = "center" == t.y ? (f.top + f.bottom) / 2 - l / 2 : "start" == t.y || "nearest" == t.y && u < s.from ? f.top : f.bottom - l, s = new oP(r.lineAt(c - 500, HE.ByHeight, i, 0, 0).from, r.lineAt(c + l + 500, HE.ByHeight, i, 0, 0).to);
          }
        }
        return s;
      }
    }, {
      key: "mapViewport",
      value: function value(e, t) {
        var n = t.mapPos(e.from, -1),
          r = t.mapPos(e.to, 1);
        return new oP(this.heightMap.lineAt(n, HE.ByPos, this.state.doc, 0, 0).from, this.heightMap.lineAt(r, HE.ByPos, this.state.doc, 0, 0).to);
      }
    }, {
      key: "viewportIsAppropriate",
      value: function value(e) {
        var t = e.from,
          n = e.to,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        if (!this.inView) return !0;
        var i = this.heightMap.lineAt(t, HE.ByPos, this.state.doc, 0, 0),
          o = i.top,
          a = this.heightMap.lineAt(n, HE.ByPos, this.state.doc, 0, 0),
          s = a.bottom,
          u = this.visibleTop,
          c = this.visibleBottom;
        return (0 == t || o <= u - Math.max(10, Math.min(-r, 250))) && (n == this.state.doc.length || s >= c + Math.max(10, Math.min(r, 250))) && o > u - 2e3 && s < c + 2e3;
      }
    }, {
      key: "mapLineGaps",
      value: function value(e, t) {
        if (!e.length || t.empty) return e;
        var n,
          r = [],
          i = bi(e);
        try {
          for (i.s(); !(n = i.n()).done;) {
            var o = n.value;
            t.touchesRange(o.from, o.to) || r.push(new nP(t.mapPos(o.from), t.mapPos(o.to), o.size));
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        return r;
      }
    }, {
      key: "ensureLineGaps",
      value: function value(e) {
        var t = this,
          n = [];
        if (this.defaultTextDirection != _A.LTR) return n;
        var r,
          i = bi(this.viewportLines);
        try {
          var o = function o() {
            var i = r.value;
            if (i.length < 4e3) return "continue";
            var o = function (e, t, n) {
              var r = [],
                i = e,
                o = 0;
              p$.spans(n, e, t, {
                span: function span() {},
                point: function point(e, t) {
                  e > i && (r.push({
                    from: i,
                    to: e
                  }), o += e - i), i = t;
                }
              }, 20), i < t && (r.push({
                from: i,
                to: t
              }), o += t - i);
              return {
                total: o,
                ranges: r
              };
            }(i.from, i.to, t.stateDeco);
            if (o.total < 4e3) return "continue";
            var a = void 0,
              s = void 0;
            if (t.heightOracle.lineWrapping) {
              var u = 2e3 / t.heightOracle.lineLength * t.heightOracle.lineHeight;
              a = aP(o, (t.visibleTop - i.top - u) / i.height), s = aP(o, (t.visibleBottom - i.top + u) / i.height);
            } else {
              var c = o.total * t.heightOracle.charWidth,
                l = 2e3 * t.heightOracle.charWidth;
              a = aP(o, (t.pixelViewport.left - l) / c), s = aP(o, (t.pixelViewport.right + l) / c);
            }
            var f = [];
            a > i.from && f.push({
              from: i.from,
              to: a
            }), s < i.to && f.push({
              from: s,
              to: i.to
            });
            var h = t.state.selection.main;
            h.from >= i.from && h.from <= i.to && uP(f, h.from - 10, h.from + 10), !h.empty && h.to >= i.from && h.to <= i.to && uP(f, h.to - 10, h.to + 10);
            for (var d = function d() {
                var r = p[v],
                  a = r.from,
                  s = r.to;
                s - a > 1e3 && n.push(function (e, t) {
                  var n,
                    r = bi(e);
                  try {
                    for (r.s(); !(n = r.n()).done;) {
                      var i = n.value;
                      if (t(i)) return i;
                    }
                  } catch (e) {
                    r.e(e);
                  } finally {
                    r.f();
                  }
                  return;
                }(e, function (e) {
                  return e.from >= i.from && e.to <= i.to && Math.abs(e.from - a) < 1e3 && Math.abs(e.to - s) < 1e3;
                }) || new nP(a, s, t.gapSize(i, a, s, o)));
              }, v = 0, p = f; v < p.length; v++) {
              d();
            }
          };
          for (i.s(); !(r = i.n()).done;) {
            o();
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        return n;
      }
    }, {
      key: "gapSize",
      value: function value(e, t, n, r) {
        var i = sP(r, n) - sP(r, t);
        return this.heightOracle.lineWrapping ? e.height * i : r.total * this.heightOracle.charWidth * i;
      }
    }, {
      key: "updateLineGaps",
      value: function value(e) {
        var t = this;
        nP.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = UO.set(e.map(function (e) {
          return e.draw(t.heightOracle.lineWrapping);
        })));
      }
    }, {
      key: "computeVisibleRanges",
      value: function value() {
        var e = this.stateDeco;
        this.lineGaps.length && (e = e.concat(this.lineGapDeco));
        var t = [];
        p$.spans(e, this.viewport.from, this.viewport.to, {
          span: function span(e, n) {
            t.push({
              from: e,
              to: n
            });
          },
          point: function point() {}
        }, 20);
        var n = t.length != this.visibleRanges.length || this.visibleRanges.some(function (e, n) {
          return e.from != t[n].from || e.to != t[n].to;
        });
        return this.visibleRanges = t, n ? 4 : 0;
      }
    }, {
      key: "lineBlockAt",
      value: function value(e) {
        return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find(function (t) {
          return t.from <= e && t.to >= e;
        }) || fP(this.heightMap.lineAt(e, HE.ByPos, this.state.doc, 0, 0), this.scaler);
      }
    }, {
      key: "lineBlockAtHeight",
      value: function value(e) {
        return fP(this.heightMap.lineAt(this.scaler.fromDOM(e), HE.ByHeight, this.state.doc, 0, 0), this.scaler);
      }
    }, {
      key: "elementAtHeight",
      value: function value(e) {
        return fP(this.heightMap.blockAt(this.scaler.fromDOM(e), this.state.doc, 0, 0), this.scaler);
      }
    }, {
      key: "docHeight",
      get: function get() {
        return this.scaler.toDOM(this.heightMap.height);
      }
    }, {
      key: "contentHeight",
      get: function get() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
      }
    }]), e;
  }(),
  oP = zi(function e(t, n) {
    Ri(this, e), this.from = t, this.to = n;
  });
function aP(e, t) {
  var n = e.total,
    r = e.ranges;
  if (t <= 0) return r[0].from;
  if (t >= 1) return r[r.length - 1].to;
  for (var i = Math.floor(n * t), o = 0;; o++) {
    var a = r[o],
      s = a.from,
      u = a.to - s;
    if (i <= u) return s + i;
    i -= u;
  }
}
function sP(e, t) {
  var n,
    r = 0,
    i = bi(e.ranges);
  try {
    for (i.s(); !(n = i.n()).done;) {
      var o = n.value,
        a = o.from,
        s = o.to;
      if (t <= s) {
        r += t - a;
        break;
      }
      r += s - a;
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }
  return r / e.total;
}
function uP(e, t, n) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    if (i.from < n && i.to > t) {
      var o = [];
      i.from < t && o.push({
        from: i.from,
        to: t
      }), i.to > n && o.push({
        from: n,
        to: i.to
      }), e.splice.apply(e, [r, 1].concat(o)), r += o.length - 1;
    }
  }
}
var cP = {
    toDOM: function toDOM(e) {
      return e;
    },
    fromDOM: function fromDOM(e) {
      return e;
    },
    scale: 1
  },
  lP = function () {
    function e(t, n, r) {
      Ri(this, e);
      var i = 0,
        o = 0,
        a = 0;
      this.viewports = r.map(function (e) {
        var r = e.from,
          o = e.to,
          a = n.lineAt(r, HE.ByPos, t, 0, 0).top,
          s = n.lineAt(o, HE.ByPos, t, 0, 0).bottom;
        return i += s - a, {
          from: r,
          to: o,
          top: a,
          bottom: s,
          domTop: 0,
          domBottom: 0
        };
      }), this.scale = (7e6 - i) / (n.height - i);
      var s,
        u = bi(this.viewports);
      try {
        for (u.s(); !(s = u.n()).done;) {
          var c = s.value;
          c.domTop = a + (c.top - o) * this.scale, a = c.domBottom = c.domTop + (c.bottom - c.top), o = c.bottom;
        }
      } catch (e) {
        u.e(e);
      } finally {
        u.f();
      }
    }
    return zi(e, [{
      key: "toDOM",
      value: function value(e) {
        for (var t = 0, n = 0, r = 0;; t++) {
          var i = t < this.viewports.length ? this.viewports[t] : null;
          if (!i || e < i.top) return r + (e - n) * this.scale;
          if (e <= i.bottom) return i.domTop + (e - i.top);
          n = i.bottom, r = i.domBottom;
        }
      }
    }, {
      key: "fromDOM",
      value: function value(e) {
        for (var t = 0, n = 0, r = 0;; t++) {
          var i = t < this.viewports.length ? this.viewports[t] : null;
          if (!i || e < i.domTop) return n + (e - r) / this.scale;
          if (e <= i.domBottom) return i.top + (e - i.domTop);
          n = i.bottom, r = i.domBottom;
        }
      }
    }]), e;
  }();
function fP(e, t) {
  if (1 == t.scale) return e;
  var n = t.toDOM(e.top),
    r = t.toDOM(e.bottom);
  return new VE(e.from, e.length, n, r - n, Array.isArray(e.type) ? e.type.map(function (e) {
    return fP(e, t);
  }) : e.type);
}
var hP = x_.define({
    combine: function combine(e) {
      return e.join(" ");
    }
  }),
  dP = x_.define({
    combine: function combine(e) {
      return e.indexOf(!0) > -1;
    }
  }),
  vP = I$.newName(),
  pP = I$.newName(),
  mP = I$.newName(),
  gP = {
    "&light": "." + pP,
    "&dark": "." + mP
  };
function yP(e, t, n) {
  return new I$(t, {
    finish: function finish(t) {
      return /&/.test(t) ? t.replace(/&\w*/, function (t) {
        if ("&" == t) return e;
        if (!n || !n[t]) throw new RangeError("Unsupported selector: ".concat(t));
        return n[t];
      }) : e + " " + t;
    }
  });
}
var bP = yP("." + vP, {
    "&.cm-editor": {
      position: "relative !important",
      boxSizing: "border-box",
      "&.cm-focused": {
        outline: "1px dotted #212121"
      },
      display: "flex !important",
      flexDirection: "column"
    },
    ".cm-scroller": {
      display: "flex !important",
      alignItems: "flex-start !important",
      fontFamily: "monospace",
      lineHeight: 1.4,
      height: "100%",
      overflowX: "auto",
      position: "relative",
      zIndex: 0
    },
    ".cm-content": {
      margin: 0,
      flexGrow: 2,
      minHeight: "100%",
      display: "block",
      whiteSpace: "pre",
      wordWrap: "normal",
      boxSizing: "border-box",
      padding: "4px 0",
      outline: "none",
      "&[contenteditable=true]": {
        WebkitUserModify: "read-write-plaintext-only"
      }
    },
    ".cm-lineWrapping": {
      whiteSpace_fallback: "pre-wrap",
      whiteSpace: "break-spaces",
      wordBreak: "break-word",
      overflowWrap: "anywhere"
    },
    "&light .cm-content": {
      caretColor: "black"
    },
    "&dark .cm-content": {
      caretColor: "white"
    },
    ".cm-line": {
      display: "block",
      padding: "0 2px 0 4px"
    },
    ".cm-selectionLayer": {
      zIndex: -1,
      contain: "size style"
    },
    ".cm-selectionBackground": {
      position: "absolute"
    },
    "&light .cm-selectionBackground": {
      background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
      background: "#222"
    },
    "&light.cm-focused .cm-selectionBackground": {
      background: "#d7d4f0"
    },
    "&dark.cm-focused .cm-selectionBackground": {
      background: "#233"
    },
    ".cm-cursorLayer": {
      zIndex: 100,
      contain: "size style",
      pointerEvents: "none"
    },
    "&.cm-focused .cm-cursorLayer": {
      animation: "steps(1) cm-blink 1.2s infinite"
    },
    "@keyframes cm-blink": {
      "0%": {},
      "50%": {
        visibility: "hidden"
      },
      "100%": {}
    },
    "@keyframes cm-blink2": {
      "0%": {},
      "50%": {
        visibility: "hidden"
      },
      "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
      position: "absolute",
      borderLeft: "1.2px solid black",
      marginLeft: "-0.6px",
      pointerEvents: "none"
    },
    ".cm-cursor": {
      display: "none"
    },
    "&dark .cm-cursor": {
      borderLeftColor: "#444"
    },
    "&.cm-focused .cm-cursor": {
      display: "block"
    },
    "&light .cm-activeLine": {
      backgroundColor: "#f3f9ff"
    },
    "&dark .cm-activeLine": {
      backgroundColor: "#223039"
    },
    "&light .cm-specialChar": {
      color: "red"
    },
    "&dark .cm-specialChar": {
      color: "#f78"
    },
    ".cm-gutters": {
      display: "flex",
      height: "100%",
      boxSizing: "border-box",
      left: 0,
      zIndex: 200
    },
    "&light .cm-gutters": {
      backgroundColor: "#f5f5f5",
      color: "#6c6c6c",
      borderRight: "1px solid #ddd"
    },
    "&dark .cm-gutters": {
      backgroundColor: "#333338",
      color: "#ccc"
    },
    ".cm-gutter": {
      display: "flex !important",
      flexDirection: "column",
      flexShrink: 0,
      boxSizing: "border-box",
      minHeight: "100%",
      overflow: "hidden"
    },
    ".cm-gutterElement": {
      boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
      padding: "0 3px 0 5px",
      minWidth: "20px",
      textAlign: "right",
      whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
      backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
      backgroundColor: "#222227"
    },
    ".cm-panels": {
      boxSizing: "border-box",
      position: "sticky",
      left: 0,
      right: 0
    },
    "&light .cm-panels": {
      backgroundColor: "#f5f5f5",
      color: "black"
    },
    "&light .cm-panels-top": {
      borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
      borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
      backgroundColor: "#333338",
      color: "white"
    },
    ".cm-tab": {
      display: "inline-block",
      overflow: "hidden",
      verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
      verticalAlign: "text-top",
      height: "1em",
      display: "inline"
    },
    ".cm-placeholder": {
      color: "#888",
      display: "inline-block",
      verticalAlign: "top"
    },
    ".cm-button": {
      verticalAlign: "middle",
      color: "inherit",
      fontSize: "70%",
      padding: ".2em 1em",
      borderRadius: "1px"
    },
    "&light .cm-button": {
      backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
      border: "1px solid #888",
      "&:active": {
        backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
      }
    },
    "&dark .cm-button": {
      backgroundImage: "linear-gradient(#393939, #111)",
      border: "1px solid #888",
      "&:active": {
        backgroundImage: "linear-gradient(#111, #333)"
      }
    },
    ".cm-textfield": {
      verticalAlign: "middle",
      color: "inherit",
      fontSize: "70%",
      border: "1px solid silver",
      padding: ".2em .5em"
    },
    "&light .cm-textfield": {
      backgroundColor: "white"
    },
    "&dark .cm-textfield": {
      border: "1px solid #555",
      backgroundColor: "inherit"
    }
  }, gP),
  kP = {
    childList: !0,
    characterData: !0,
    subtree: !0,
    attributes: !0,
    characterDataOldValue: !0
  },
  wP = AO.ie && AO.ie_version <= 11,
  xP = function () {
    function e(t, n, r) {
      var i = this;
      Ri(this, e), this.view = t, this.onChange = n, this.onScrollChanged = r, this.active = !1, this.selectionRange = new iO(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.scrollTargets = [], this.intersection = null, this.resize = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.parentCheck = -1, this.dom = t.contentDOM, this.observer = new MutationObserver(function (e) {
        var n,
          r = bi(e);
        try {
          for (r.s(); !(n = r.n()).done;) {
            var o = n.value;
            i.queue.push(o);
          }
        } catch (e) {
          r.e(e);
        } finally {
          r.f();
        }
        (AO.ie && AO.ie_version <= 11 || AO.ios && t.composing) && e.some(function (e) {
          return "childList" == e.type && e.removedNodes.length || "characterData" == e.type && e.oldValue.length > e.target.nodeValue.length;
        }) ? i.flushSoon() : i.flush();
      }), wP && (this.onCharData = function (e) {
        i.queue.push({
          target: e.target,
          type: "characterData",
          oldValue: e.prevValue
        }), i.flushSoon();
      }), this.onSelectionChange = this.onSelectionChange.bind(this), window.addEventListener("resize", this.onResize = this.onResize.bind(this)), "function" == typeof ResizeObserver && (this.resize = new ResizeObserver(function () {
        i.view.docView.lastUpdate < Date.now() - 75 && i.onResize();
      }), this.resize.observe(t.scrollDOM)), window.addEventListener("beforeprint", this.onPrint = this.onPrint.bind(this)), this.start(), window.addEventListener("scroll", this.onScroll = this.onScroll.bind(this)), "function" == typeof IntersectionObserver && (this.intersection = new IntersectionObserver(function (e) {
        i.parentCheck < 0 && (i.parentCheck = setTimeout(i.listenForScroll.bind(i), 1e3)), e.length > 0 && e[e.length - 1].intersectionRatio > 0 != i.intersecting && (i.intersecting = !i.intersecting, i.intersecting != i.view.inView && i.onScrollChanged(document.createEvent("Event")));
      }, {}), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver(function (e) {
        e.length > 0 && e[e.length - 1].intersectionRatio > 0 && i.onScrollChanged(document.createEvent("Event"));
      }, {})), this.listenForScroll(), this.readSelectionRange(), this.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    return zi(e, [{
      key: "onScroll",
      value: function value(e) {
        this.intersecting && this.flush(!1), this.onScrollChanged(e);
      }
    }, {
      key: "onResize",
      value: function value() {
        var e = this;
        this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(function () {
          e.resizeTimeout = -1, e.view.requestMeasure();
        }, 50));
      }
    }, {
      key: "onPrint",
      value: function value() {
        var e = this;
        this.view.viewState.printing = !0, this.view.measure(), setTimeout(function () {
          e.view.viewState.printing = !1, e.view.requestMeasure();
        }, 500);
      }
    }, {
      key: "updateGaps",
      value: function value(e) {
        if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some(function (t, n) {
          return t != e[n];
        }))) {
          this.gapIntersection.disconnect();
          var t,
            n = bi(e);
          try {
            for (n.s(); !(t = n.n()).done;) {
              var r = t.value;
              this.gapIntersection.observe(r);
            }
          } catch (e) {
            n.e(e);
          } finally {
            n.f();
          }
          this.gaps = e;
        }
      }
    }, {
      key: "onSelectionChange",
      value: function value(e) {
        if (this.readSelectionRange() && !this.delayedAndroidKey) {
          var t = this.view,
            n = this.selectionRange;
          if (t.state.facet(dA) ? t.root.activeElement == this.dom : K$(t.dom, n)) {
            var r = n.anchorNode && t.docView.nearest(n.anchorNode);
            r && r.ignoreEvent(e) || ((AO.ie && AO.ie_version <= 11 || AO.android && AO.chrome) && !t.state.selection.main.empty && n.focusNode && Q$(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset) ? this.flushSoon() : this.flush(!1));
          }
        }
      }
    }, {
      key: "readSelectionRange",
      value: function value() {
        var e = this.view.root,
          t = U$(e),
          n = AO.safari && 11 == e.nodeType && function () {
            for (var e = document.activeElement; e && e.shadowRoot;) {
              e = e.shadowRoot.activeElement;
            }
            return e;
          }() == this.view.contentDOM && function (e) {
            var t = null;
            function n(e) {
              e.preventDefault(), e.stopImmediatePropagation(), t = e.getTargetRanges()[0];
            }
            if (e.contentDOM.addEventListener("beforeinput", n, !0), document.execCommand("indent"), e.contentDOM.removeEventListener("beforeinput", n, !0), !t) return null;
            var r = t.startContainer,
              i = t.startOffset,
              o = t.endContainer,
              a = t.endOffset,
              s = e.docView.domAtPos(e.state.selection.main.anchor);
            if (Q$(s.node, s.offset, o, a)) {
              var u = [o, a, r, i];
              r = u[0], i = u[1], o = u[2], a = u[3];
            }
            return {
              anchorNode: r,
              anchorOffset: i,
              focusNode: o,
              focusOffset: a
            };
          }(this.view) || t;
        return !this.selectionRange.eq(n) && (this.selectionRange.setRange(n), this.selectionChanged = !0);
      }
    }, {
      key: "setSelectionRange",
      value: function value(e, t) {
        this.selectionRange.set(e.node, e.offset, t.node, t.offset), this.selectionChanged = !1;
      }
    }, {
      key: "clearSelectionRange",
      value: function value() {
        this.selectionRange.set(null, 0, null, 0);
      }
    }, {
      key: "listenForScroll",
      value: function value() {
        this.parentCheck = -1;
        for (var e = 0, t = null, n = this.dom; n;) {
          if (1 == n.nodeType) !t && e < this.scrollTargets.length && this.scrollTargets[e] == n ? e++ : t || (t = this.scrollTargets.slice(0, e)), t && t.push(n), n = n.assignedSlot || n.parentNode;else {
            if (11 != n.nodeType) break;
            n = n.host;
          }
        }
        if (e < this.scrollTargets.length && !t && (t = this.scrollTargets.slice(0, e)), t) {
          var r,
            i = bi(this.scrollTargets);
          try {
            for (i.s(); !(r = i.n()).done;) {
              r.value.removeEventListener("scroll", this.onScroll);
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
          var o,
            a = bi(this.scrollTargets = t);
          try {
            for (a.s(); !(o = a.n()).done;) {
              o.value.addEventListener("scroll", this.onScroll);
            }
          } catch (e) {
            a.e(e);
          } finally {
            a.f();
          }
        }
      }
    }, {
      key: "ignore",
      value: function value(e) {
        if (!this.active) return e();
        try {
          return this.stop(), e();
        } finally {
          this.start(), this.clear();
        }
      }
    }, {
      key: "start",
      value: function value() {
        this.active || (this.observer.observe(this.dom, kP), wP && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
      }
    }, {
      key: "stop",
      value: function value() {
        this.active && (this.active = !1, this.observer.disconnect(), wP && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
      }
    }, {
      key: "clear",
      value: function value() {
        this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
      }
    }, {
      key: "delayAndroidKey",
      value: function value(e, t) {
        var n = this;
        this.delayedAndroidKey || requestAnimationFrame(function () {
          var e = n.delayedAndroidKey;
          n.delayedAndroidKey = null, n.delayedFlush = -1, n.flush() || uO(n.view.contentDOM, e.key, e.keyCode);
        }), this.delayedAndroidKey && "Enter" != e || (this.delayedAndroidKey = {
          key: e,
          keyCode: t
        });
      }
    }, {
      key: "flushSoon",
      value: function value() {
        var e = this;
        this.delayedFlush < 0 && (this.delayedFlush = window.setTimeout(function () {
          e.delayedFlush = -1, e.flush();
        }, 20));
      }
    }, {
      key: "forceFlush",
      value: function value() {
        this.delayedFlush >= 0 && (window.clearTimeout(this.delayedFlush), this.delayedFlush = -1, this.flush());
      }
    }, {
      key: "processRecords",
      value: function value() {
        var e,
          t = this.queue,
          n = bi(this.observer.takeRecords());
        try {
          for (n.s(); !(e = n.n()).done;) {
            var r = e.value;
            t.push(r);
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
        t.length && (this.queue = []);
        var i,
          o = -1,
          a = -1,
          s = !1,
          u = bi(t);
        try {
          for (u.s(); !(i = u.n()).done;) {
            var c = i.value,
              l = this.readMutation(c);
            l && (l.typeOver && (s = !0), -1 == o ? (o = l.from, a = l.to) : (o = Math.min(l.from, o), a = Math.max(l.to, a)));
          }
        } catch (e) {
          u.e(e);
        } finally {
          u.f();
        }
        return {
          from: o,
          to: a,
          typeOver: s
        };
      }
    }, {
      key: "flush",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        if (!(this.delayedFlush >= 0 || this.delayedAndroidKey)) {
          e && this.readSelectionRange();
          var t = this.processRecords(),
            n = t.from,
            r = t.to,
            i = t.typeOver,
            o = this.selectionChanged && K$(this.dom, this.selectionRange);
          if (!(n < 0) || o) {
            this.selectionChanged = !1;
            var a = this.view.state,
              s = this.onChange(n, r, i);
            return this.view.state == a && this.view.update([]), s;
          }
        }
      }
    }, {
      key: "readMutation",
      value: function value(e) {
        var t = this.view.docView.nearest(e.target);
        if (!t || t.ignoreMutation(e)) return null;
        if (t.markDirty("attributes" == e.type), "attributes" == e.type && (t.dirty |= 4), "childList" == e.type) {
          var n = jP(t, e.previousSibling || e.target.previousSibling, -1),
            r = jP(t, e.nextSibling || e.target.nextSibling, 1);
          return {
            from: n ? t.posAfter(n) : t.posAtStart,
            to: r ? t.posBefore(r) : t.posAtEnd,
            typeOver: !1
          };
        }
        return "characterData" == e.type ? {
          from: t.posAtStart,
          to: t.posAtEnd,
          typeOver: e.target.nodeValue == e.oldValue
        } : null;
      }
    }, {
      key: "destroy",
      value: function value() {
        var e, t, n;
        this.stop(), null === (e = this.intersection) || void 0 === e || e.disconnect(), null === (t = this.gapIntersection) || void 0 === t || t.disconnect(), null === (n = this.resize) || void 0 === n || n.disconnect();
        var r,
          i = bi(this.scrollTargets);
        try {
          for (i.s(); !(r = i.n()).done;) {
            r.value.removeEventListener("scroll", this.onScroll);
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onResize), window.removeEventListener("beforeprint", this.onPrint), this.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout);
      }
    }]), e;
  }();
function jP(e, t, n) {
  for (; t;) {
    var r = dO.get(t);
    if (r && r.parent == e) return r;
    var i = t.parentNode;
    t = i != e.dom ? i : n > 0 ? t.nextSibling : t.previousSibling;
  }
  return null;
}
function SP(e, t, n, r) {
  var i,
    o,
    a = e.state.selection.main;
  if (t > -1) {
    var s = e.docView.domBoundsAround(t, n, 0);
    if (!s || e.state.readOnly) return !1;
    var u = s.from,
      c = s.to,
      l = e.docView.impreciseHead || e.docView.impreciseAnchor ? [] : function (e) {
        var t = [];
        if (e.root.activeElement != e.contentDOM) return t;
        var n = e.observer.selectionRange,
          r = n.anchorNode,
          i = n.anchorOffset,
          o = n.focusNode,
          a = n.focusOffset;
        r && (t.push(new KA(r, i)), o == r && a == i || t.push(new KA(o, a)));
        return t;
      }(e),
      f = new UA(l, e.state);
    f.readRange(s.startDOM, s.endDOM);
    var h = a.from,
      d = null;
    (8 === e.inputState.lastKeyCode && e.inputState.lastKeyTime > Date.now() - 100 || AO.android && f.text.length < c - u) && (h = a.to, d = "end");
    var v = function (e, t, n, r) {
      var i = Math.min(e.length, t.length),
        o = 0;
      for (; o < i && e.charCodeAt(o) == t.charCodeAt(o);) {
        o++;
      }
      if (o == i && e.length == t.length) return null;
      var a = e.length,
        s = t.length;
      for (; a > 0 && s > 0 && e.charCodeAt(a - 1) == t.charCodeAt(s - 1);) {
        a--, s--;
      }
      if ("end" == r) {
        n -= a + Math.max(0, o - Math.min(a, s)) - o;
      }
      if (a < o && e.length < t.length) {
        s = (o -= n <= o && n >= a ? o - n : 0) + (s - a), a = o;
      } else if (s < o) {
        a = (o -= n <= o && n >= s ? o - n : 0) + (a - s), s = o;
      }
      return {
        from: o,
        toA: a,
        toB: s
      };
    }(e.state.doc.sliceString(u, c, "￿"), f.text, h - u, d);
    v && (AO.chrome && 13 == e.inputState.lastKeyCode && v.toB == v.from + 2 && "￿￿" == f.text.slice(v.from, v.toB) && v.toB--, i = {
      from: u + v.from,
      to: u + v.toA,
      insert: BC.of(f.text.slice(v.from, v.toB).split("￿"))
    }), o = function (e, t) {
      if (0 == e.length) return null;
      var n = e[0].pos,
        r = 2 == e.length ? e[1].pos : n;
      return n > -1 && r > -1 ? b_.single(n + t, r + t) : null;
    }(l, u);
  } else if (e.hasFocus || !e.state.facet(dA)) {
    var p = e.observer.selectionRange,
      m = e.docView,
      g = m.impreciseHead,
      y = m.impreciseAnchor,
      b = g && g.node == p.focusNode && g.offset == p.focusOffset || !J$(e.contentDOM, p.focusNode) ? e.state.selection.main.head : e.docView.posFromDOM(p.focusNode, p.focusOffset),
      k = y && y.node == p.anchorNode && y.offset == p.anchorOffset || !J$(e.contentDOM, p.anchorNode) ? e.state.selection.main.anchor : e.docView.posFromDOM(p.anchorNode, p.anchorOffset);
    b == a.head && k == a.anchor || (o = b_.single(k, b));
  }
  if (!i && !o) return !1;
  if (!i && r && !a.empty && o && o.main.empty ? i = {
    from: a.from,
    to: a.to,
    insert: e.state.doc.slice(a.from, a.to)
  } : i && i.from >= a.from && i.to <= a.to && (i.from != a.from || i.to != a.to) && a.to - a.from - (i.to - i.from) <= 4 ? i = {
    from: a.from,
    to: a.to,
    insert: e.state.doc.slice(a.from, i.from).append(i.insert).append(e.state.doc.slice(i.to, a.to))
  } : (AO.mac || AO.android) && i && i.from == i.to && i.from == a.head - 1 && "." == i.insert.toString() && (i = {
    from: a.from,
    to: a.to,
    insert: BC.of([" "])
  }), i) {
    var w = e.state;
    if (AO.ios && e.inputState.flushIOSKey(e)) return !0;
    if (AO.android && (i.from == a.from && i.to == a.to && 1 == i.insert.length && 2 == i.insert.lines && uO(e.contentDOM, "Enter", 13) || i.from == a.from - 1 && i.to == a.to && 0 == i.insert.length && uO(e.contentDOM, "Backspace", 8) || i.from == a.from && i.to == a.to + 1 && 0 == i.insert.length && uO(e.contentDOM, "Delete", 46))) return !0;
    var x,
      j = i.insert.toString();
    if (e.state.facet(uA).some(function (t) {
      return t(e, i.from, i.to, j);
    })) return !0;
    if (e.inputState.composing >= 0 && e.inputState.composing++, i.from >= a.from && i.to <= a.to && i.to - i.from >= (a.to - a.from) / 3 && (!o || o.main.empty && o.main.from == i.from + i.insert.length) && e.inputState.composing < 0) {
      var S = a.from < i.from ? w.sliceDoc(a.from, i.from) : "",
        C = a.to > i.to ? w.sliceDoc(i.to, a.to) : "";
      x = w.replaceSelection(e.state.toText(S + i.insert.sliceString(0, void 0, e.state.lineBreak) + C));
    } else {
      var _ = w.changes(i),
        $ = o && !w.selection.main.eq(o.main) && o.main.to <= _.newLength ? o.main : void 0;
      if (w.selection.ranges.length > 1 && e.inputState.composing >= 0 && i.to <= a.to && i.to >= a.to - 10) {
        var O = e.state.sliceDoc(i.from, i.to),
          A = ZA(e) || e.state.doc.lineAt(a.head),
          E = a.to - i.to,
          P = a.to - a.from;
        x = w.changeByRange(function (t) {
          if (t.from == a.from && t.to == a.to) return {
            changes: _,
            range: $ || t.map(_)
          };
          var n = t.to - E,
            r = n - O.length;
          if (t.to - t.from != P || e.state.sliceDoc(r, n) != O || A && t.to >= A.from && t.from <= A.to) return {
            range: t
          };
          var o = w.changes({
              from: r,
              to: n,
              insert: i.insert
            }),
            s = t.to - a.to;
          return {
            changes: o,
            range: $ ? b_.range(Math.max(0, $.anchor + s), Math.max(0, $.head + s)) : t.map(o)
          };
        });
      } else x = {
        changes: _,
        selection: $ && w.selection.replaceRange($)
      };
    }
    var M = "input.type";
    return e.composing && (M += ".compose", e.inputState.compositionFirstChange && (M += ".start", e.inputState.compositionFirstChange = !1)), e.dispatch(x, {
      scrollIntoView: !0,
      userEvent: M
    }), !0;
  }
  if (o && !o.main.eq(a)) {
    var I = !1,
      T = "select";
    return e.inputState.lastSelectionTime > Date.now() - 50 && ("select" == e.inputState.lastSelectionOrigin && (I = !0), T = e.inputState.lastSelectionOrigin), e.dispatch({
      selection: o,
      scrollIntoView: I,
      userEvent: T
    }), !0;
  }
  return !1;
}
var CP = function () {
  function e() {
    var t = this,
      n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    Ri(this, e), this.plugins = [], this.pluginMap = new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.style.cssText = "position: absolute; top: -10000px", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), this._dispatch = n.dispatch || function (e) {
      return t.update([e]);
    }, this.dispatch = this.dispatch.bind(this), this.root = n.root || cO(n.parent) || document, this.viewState = new iP(n.state || c$.create(n)), this.plugins = this.state.facet(pA).map(function (e) {
      return new gA(e);
    });
    var r,
      i = bi(this.plugins);
    try {
      for (i.s(); !(r = i.n()).done;) {
        var o = r.value;
        o.update(this);
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
    this.observer = new xP(this, function (e, n, r) {
      return SP(t, e, n, r);
    }, function (e) {
      t.inputState.runScrollHandlers(t, e), t.observer.intersecting && t.measure();
    }), this.inputState = new gE(this), this.inputState.ensureHandlers(this, this.plugins), this.docView = new GA(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), n.parent && n.parent.appendChild(this.dom);
  }
  return zi(e, [{
    key: "state",
    get: function get() {
      return this.viewState.state;
    }
  }, {
    key: "viewport",
    get: function get() {
      return this.viewState.viewport;
    }
  }, {
    key: "visibleRanges",
    get: function get() {
      return this.viewState.visibleRanges;
    }
  }, {
    key: "inView",
    get: function get() {
      return this.viewState.inView;
    }
  }, {
    key: "composing",
    get: function get() {
      return this.inputState.composing > 0;
    }
  }, {
    key: "compositionStarted",
    get: function get() {
      return this.inputState.composing >= 0;
    }
  }, {
    key: "dispatch",
    value: function value() {
      var e;
      this._dispatch(1 == arguments.length && (arguments.length <= 0 ? void 0 : arguments[0]) instanceof Z_ ? arguments.length <= 0 ? void 0 : arguments[0] : (e = this.state).update.apply(e, arguments));
    }
  }, {
    key: "update",
    value: function value(e) {
      if (0 != this.updateState) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
      var t,
        n,
        r = !1,
        i = !1,
        o = this.state,
        a = bi(e);
      try {
        for (a.s(); !(n = a.n()).done;) {
          var s = n.value;
          if (s.startState != o) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
          o = s.state;
        }
      } catch (e) {
        a.e(e);
      } finally {
        a.f();
      }
      if (this.destroyed) this.viewState.state = o;else {
        if (this.observer.clear(), o.facet(c$.phrases) != this.state.facet(c$.phrases)) return this.setState(o);
        t = CA.create(this, o, e);
        var u = this.viewState.scrollTarget;
        try {
          this.updateState = 2;
          var c,
            l = bi(e);
          try {
            for (l.s(); !(c = l.n()).done;) {
              var f = c.value;
              if (u && (u = u.map(f.changes)), f.scrollIntoView) {
                var h = f.state.selection.main;
                u = new lA(h.empty ? h : b_.cursor(h.head, h.head > h.anchor ? -1 : 1));
              }
              var d,
                v = bi(f.effects);
              try {
                for (v.s(); !(d = v.n()).done;) {
                  var p = d.value;
                  p.is(fA) && (u = p.value);
                }
              } catch (e) {
                v.e(e);
              } finally {
                v.f();
              }
            }
          } catch (e) {
            l.e(e);
          } finally {
            l.f();
          }
          this.viewState.update(t, u), this.bidiCache = OP.update(this.bidiCache, t.changes), t.empty || (this.updatePlugins(t), this.inputState.update(t)), r = this.docView.update(t), this.state.facet(jA) != this.styleModules && this.mountStyles(), i = this.updateAttrs(), this.showAnnouncements(e), this.docView.updateSelection(r, e.some(function (e) {
            return e.isUserEvent("select.pointer");
          }));
        } finally {
          this.updateState = 0;
        }
        if (t.startState.facet(hP) != t.state.facet(hP) && (this.viewState.mustMeasureContent = !0), (r || i || u || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), !t.empty) {
          var m,
            g = bi(this.state.facet(sA));
          try {
            for (g.s(); !(m = g.n()).done;) {
              (0, m.value)(t);
            }
          } catch (e) {
            g.e(e);
          } finally {
            g.f();
          }
        }
      }
    }
  }, {
    key: "setState",
    value: function value(e) {
      if (0 != this.updateState) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
      if (this.destroyed) this.viewState.state = e;else {
        this.updateState = 2;
        var t = this.hasFocus;
        try {
          var n,
            r = bi(this.plugins);
          try {
            for (r.s(); !(n = r.n()).done;) {
              n.value.destroy(this);
            }
          } catch (e) {
            r.e(e);
          } finally {
            r.f();
          }
          this.viewState = new iP(e), this.plugins = e.facet(pA).map(function (e) {
            return new gA(e);
          }), this.pluginMap.clear();
          var i,
            o = bi(this.plugins);
          try {
            for (o.s(); !(i = o.n()).done;) {
              i.value.update(this);
            }
          } catch (e) {
            o.e(e);
          } finally {
            o.f();
          }
          this.docView = new GA(this), this.inputState.ensureHandlers(this, this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
        } finally {
          this.updateState = 0;
        }
        t && this.focus(), this.requestMeasure();
      }
    }
  }, {
    key: "updatePlugins",
    value: function value(e) {
      var t = e.startState.facet(pA),
        n = e.state.facet(pA);
      if (t != n) {
        var r,
          i = [],
          o = bi(n);
        try {
          for (o.s(); !(r = o.n()).done;) {
            var a = r.value,
              s = t.indexOf(a);
            if (s < 0) i.push(new gA(a));else {
              var u = this.plugins[s];
              u.mustUpdate = e, i.push(u);
            }
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        var c,
          l = bi(this.plugins);
        try {
          for (l.s(); !(c = l.n()).done;) {
            var f = c.value;
            f.mustUpdate != e && f.destroy(this);
          }
        } catch (e) {
          l.e(e);
        } finally {
          l.f();
        }
        this.plugins = i, this.pluginMap.clear(), this.inputState.ensureHandlers(this, this.plugins);
      } else {
        var h,
          d = bi(this.plugins);
        try {
          for (d.s(); !(h = d.n()).done;) {
            h.value.mustUpdate = e;
          }
        } catch (e) {
          d.e(e);
        } finally {
          d.f();
        }
      }
      for (var v = 0; v < this.plugins.length; v++) {
        this.plugins[v].update(this);
      }
    }
  }, {
    key: "measure",
    value: function value() {
      var e = this,
        t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
      if (!this.destroyed) {
        this.measureScheduled > -1 && cancelAnimationFrame(this.measureScheduled), this.measureScheduled = 0, t && this.observer.flush();
        var n = null;
        try {
          for (var r = 0;; r++) {
            this.updateState = 1;
            var i = this.viewport,
              o = this.viewState.measure(this);
            if (!o && !this.measureRequests.length && null == this.viewState.scrollTarget) break;
            if (r > 5) {
              console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
              break;
            }
            var a = [];
            if (!(4 & o)) {
              var s = [a, this.measureRequests];
              this.measureRequests = s[0], a = s[1];
            }
            var u = a.map(function (t) {
                try {
                  return t.read(e);
                } catch (t) {
                  return hA(e.state, t), $P;
                }
              }),
              c = CA.create(this, this.state, []),
              l = !1,
              f = !1;
            c.flags |= o, n ? n.flags |= o : n = c, this.updateState = 2, c.empty || (this.updatePlugins(c), this.inputState.update(c), this.updateAttrs(), l = this.docView.update(c));
            for (var h = 0; h < a.length; h++) {
              if (u[h] != $P) try {
                var d = a[h];
                d.write && d.write(u[h], this);
              } catch (e) {
                hA(this.state, e);
              }
            }
            if (this.viewState.scrollTarget && (this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, f = !0), l && this.docView.updateSelection(!0), this.viewport.from == i.from && this.viewport.to == i.to && !f && 0 == this.measureRequests.length) break;
          }
        } finally {
          this.updateState = 0, this.measureScheduled = -1;
        }
        if (n && !n.empty) {
          var v,
            p = bi(this.state.facet(sA));
          try {
            for (p.s(); !(v = p.n()).done;) {
              var m = v.value;
              m(n);
            }
          } catch (e) {
            p.e(e);
          } finally {
            p.f();
          }
        }
      }
    }
  }, {
    key: "themeClasses",
    get: function get() {
      return vP + " " + (this.state.facet(dP) ? mP : pP) + " " + this.state.facet(hP);
    }
  }, {
    key: "updateAttrs",
    value: function value() {
      var e = this,
        t = AP(this, yA, {
          class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        }),
        n = {
          spellcheck: "false",
          autocorrect: "off",
          autocapitalize: "off",
          translate: "no",
          contenteditable: this.state.facet(dA) ? "true" : "false",
          class: "cm-content",
          style: "".concat(AO.tabSize, ": ").concat(this.state.tabSize),
          role: "textbox",
          "aria-multiline": "true"
        };
      this.state.readOnly && (n["aria-readonly"] = "true"), AP(this, bA, n);
      var r = this.observer.ignore(function () {
        var r = VO(e.contentDOM, e.contentAttrs, n),
          i = VO(e.dom, e.editorAttrs, t);
        return r || i;
      });
      return this.editorAttrs = t, this.contentAttrs = n, r;
    }
  }, {
    key: "showAnnouncements",
    value: function value(t) {
      var n,
        r = !0,
        i = bi(t);
      try {
        for (i.s(); !(n = i.n()).done;) {
          var o,
            a = bi(n.value.effects);
          try {
            for (a.s(); !(o = a.n()).done;) {
              var s = o.value;
              if (s.is(e.announce)) r && (this.announceDOM.textContent = ""), r = !1, this.announceDOM.appendChild(document.createElement("div")).textContent = s.value;
            }
          } catch (e) {
            a.e(e);
          } finally {
            a.f();
          }
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }
    }
  }, {
    key: "mountStyles",
    value: function value() {
      this.styleModules = this.state.facet(jA), I$.mount(this.root, this.styleModules.concat(bP).reverse());
    }
  }, {
    key: "readMeasured",
    value: function value() {
      if (2 == this.updateState) throw new Error("Reading the editor layout isn't allowed during an update");
      0 == this.updateState && this.measureScheduled > -1 && this.measure(!1);
    }
  }, {
    key: "requestMeasure",
    value: function value(e) {
      var t = this;
      if (this.measureScheduled < 0 && (this.measureScheduled = requestAnimationFrame(function () {
        return t.measure();
      })), e) {
        if (null != e.key) for (var n = 0; n < this.measureRequests.length; n++) {
          if (this.measureRequests[n].key === e.key) return void (this.measureRequests[n] = e);
        }
        this.measureRequests.push(e);
      }
    }
  }, {
    key: "plugin",
    value: function value(e) {
      var t = this.pluginMap.get(e);
      return (void 0 === t || t && t.spec != e) && this.pluginMap.set(e, t = this.plugins.find(function (t) {
        return t.spec == e;
      }) || null), t && t.update(this).value;
    }
  }, {
    key: "documentTop",
    get: function get() {
      return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
  }, {
    key: "documentPadding",
    get: function get() {
      return {
        top: this.viewState.paddingTop,
        bottom: this.viewState.paddingBottom
      };
    }
  }, {
    key: "elementAtHeight",
    value: function value(e) {
      return this.readMeasured(), this.viewState.elementAtHeight(e);
    }
  }, {
    key: "lineBlockAtHeight",
    value: function value(e) {
      return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
    }
  }, {
    key: "viewportLineBlocks",
    get: function get() {
      return this.viewState.viewportLines;
    }
  }, {
    key: "lineBlockAt",
    value: function value(e) {
      return this.viewState.lineBlockAt(e);
    }
  }, {
    key: "contentHeight",
    get: function get() {
      return this.viewState.contentHeight;
    }
  }, {
    key: "moveByChar",
    value: function value(e, t, n) {
      return mE(this, e, pE(this, e, t, n));
    }
  }, {
    key: "moveByGroup",
    value: function value(e, t) {
      var n = this;
      return mE(this, e, pE(this, e, t, function (t) {
        return function (e, t, n) {
          var r = e.state.charCategorizer(t),
            i = r(n);
          return function (e) {
            var t = r(e);
            return i == a$.Space && (i = t), i == t;
          };
        }(n, e.head, t);
      }));
    }
  }, {
    key: "moveToLineBoundary",
    value: function value(e, t) {
      var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
      return vE(this, e, t, n);
    }
  }, {
    key: "moveVertically",
    value: function value(e, t, n) {
      return mE(this, e, function (e, t, n, r) {
        var i = t.head,
          o = n ? 1 : -1;
        if (i == (n ? e.state.doc.length : 0)) return b_.cursor(i, t.assoc);
        var a,
          s = t.goalColumn,
          u = e.contentDOM.getBoundingClientRect(),
          c = e.coordsAtPos(i),
          l = e.documentTop;
        if (c) null == s && (s = c.left - u.left), a = o < 0 ? c.top : c.bottom;else {
          var f = e.viewState.lineBlockAt(i);
          null == s && (s = Math.min(u.right - u.left, e.defaultCharacterWidth * (i - f.from))), a = (o < 0 ? f.top : f.bottom) + l;
        }
        for (var h = u.left + s, d = null != r ? r : e.defaultLineHeight >> 1, v = 0;; v += 10) {
          var p = a + (d + v) * o,
            m = fE(e, {
              x: h,
              y: p
            }, !1, o);
          if (p < u.top || p > u.bottom || (o < 0 ? m < i : m > i)) return b_.cursor(m, t.assoc, void 0, s);
        }
      }(this, e, t, n));
    }
  }, {
    key: "domAtPos",
    value: function value(e) {
      return this.docView.domAtPos(e);
    }
  }, {
    key: "posAtDOM",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return this.docView.posFromDOM(e, t);
    }
  }, {
    key: "posAtCoords",
    value: function value(e) {
      var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      return this.readMeasured(), fE(this, e, t);
    }
  }, {
    key: "coordsAtPos",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
      this.readMeasured();
      var n = this.docView.coordsAt(e, t);
      if (!n || n.left == n.right) return n;
      var r = this.state.doc.lineAt(e),
        i = this.bidiSpans(r),
        o = i[qA.find(i, e - r.from, -1, t)];
      return tO(n, o.dir == _A.LTR == t > 0);
    }
  }, {
    key: "defaultCharacterWidth",
    get: function get() {
      return this.viewState.heightOracle.charWidth;
    }
  }, {
    key: "defaultLineHeight",
    get: function get() {
      return this.viewState.heightOracle.lineHeight;
    }
  }, {
    key: "textDirection",
    get: function get() {
      return this.viewState.defaultTextDirection;
    }
  }, {
    key: "textDirectionAt",
    value: function value(e) {
      return !this.state.facet(cA) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
    }
  }, {
    key: "lineWrapping",
    get: function get() {
      return this.viewState.heightOracle.lineWrapping;
    }
  }, {
    key: "bidiSpans",
    value: function value(e) {
      if (e.length > _P) return VA(e.length);
      var t,
        n = this.textDirectionAt(e.from),
        r = bi(this.bidiCache);
      try {
        for (r.s(); !(t = r.n()).done;) {
          var i = t.value;
          if (i.from == e.from && i.dir == n) return i.order;
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
      var o = function (e, t) {
        var n = e.length,
          r = t == $A ? 1 : 2,
          i = t == $A ? 2 : 1;
        if (!e || 1 == r && !BA.test(e)) return VA(n);
        for (var o = 0, a = r, s = r; o < n; o++) {
          var u = LA(e.charCodeAt(o));
          512 == u ? u = a : 8 == u && 4 == s && (u = 16), FA[o] = 4 == u ? 2 : u, 7 & u && (s = u), a = u;
        }
        for (var c = 0, l = r, f = r; c < n; c++) {
          var h = FA[c];
          if (128 == h) c < n - 1 && l == FA[c + 1] && 24 & l ? h = FA[c] = l : FA[c] = 256;else if (64 == h) {
            for (var d = c + 1; d < n && 64 == FA[d];) {
              d++;
            }
            for (var v = c && 8 == l || d < n && 8 == FA[d] ? 1 == f ? 1 : 8 : 256, p = c; p < d; p++) {
              FA[p] = v;
            }
            c = d - 1;
          } else 8 == h && 1 == f && (FA[c] = 1);
          l = h, 7 & h && (f = h);
        }
        for (var m, g, y, b = 0, k = 0, w = 0; b < n; b++) {
          if (g = MA[m = e.charCodeAt(b)]) {
            if (g < 0) {
              for (var x = k - 3; x >= 0; x -= 3) {
                if (IA[x + 1] == -g) {
                  var j = IA[x + 2],
                    S = 2 & j ? r : 4 & j ? 1 & j ? i : r : 0;
                  S && (FA[b] = FA[IA[x]] = S), k = x;
                  break;
                }
              }
            } else {
              if (189 == IA.length) break;
              IA[k++] = b, IA[k++] = m, IA[k++] = w;
            }
          } else if (2 == (y = FA[b]) || 1 == y) {
            var C = y == r;
            w = C ? 0 : 1;
            for (var _ = k - 3; _ >= 0; _ -= 3) {
              var $ = IA[_ + 2];
              if (2 & $) break;
              if (C) IA[_ + 2] |= 2;else {
                if (4 & $) break;
                IA[_ + 2] |= 4;
              }
            }
          }
        }
        for (var O = 0; O < n; O++) {
          if (256 == FA[O]) {
            for (var A = O + 1; A < n && 256 == FA[A];) {
              A++;
            }
            for (var E = 1 == (O ? FA[O - 1] : r), P = E == (1 == (A < n ? FA[A] : r)) ? E ? 1 : 2 : r, M = O; M < A; M++) {
              FA[M] = P;
            }
            O = A - 1;
          }
        }
        var I = [];
        if (1 == r) for (var T = 0; T < n;) {
          for (var N = T, R = 1 != FA[T++]; T < n && R == (1 != FA[T]);) {
            T++;
          }
          if (R) for (var D = T; D > N;) {
            for (var z = D, L = 2 != FA[--D]; D > N && L == (2 != FA[D - 1]);) {
              D--;
            }
            I.push(new qA(D, z, L ? 2 : 1));
          } else I.push(new qA(N, T, 0));
        } else for (var B = 0; B < n;) {
          for (var q = B, F = 2 == FA[B++]; B < n && F == (2 == FA[B]);) {
            B++;
          }
          I.push(new qA(q, B, F ? 1 : 2));
        }
        return I;
      }(e.text, n);
      return this.bidiCache.push(new OP(e.from, e.to, n, o)), o;
    }
  }, {
    key: "hasFocus",
    get: function get() {
      var e;
      return (document.hasFocus() || AO.safari && (null === (e = this.inputState) || void 0 === e ? void 0 : e.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
  }, {
    key: "focus",
    value: function value() {
      var e = this;
      this.observer.ignore(function () {
        aO(e.contentDOM), e.docView.updateSelection();
      });
    }
  }, {
    key: "destroy",
    value: function value() {
      var e,
        t = bi(this.plugins);
      try {
        for (t.s(); !(e = t.n()).done;) {
          e.value.destroy(this);
        }
      } catch (e) {
        t.e(e);
      } finally {
        t.f();
      }
      this.plugins = [], this.inputState.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
    }
  }], [{
    key: "scrollIntoView",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return fA.of(new lA("number" == typeof e ? b_.cursor(e) : e, t.y, t.x, t.yMargin, t.xMargin));
    }
  }, {
    key: "domEventHandlers",
    value: function value(e) {
      return mA.define(function () {
        return {};
      }, {
        eventHandlers: e
      });
    }
  }, {
    key: "theme",
    value: function value(e, t) {
      var n = I$.newName(),
        r = [hP.of(n), jA.of(yP(".".concat(n), e))];
      return t && t.dark && r.push(dP.of(!0)), r;
    }
  }, {
    key: "baseTheme",
    value: function value(e) {
      return T_.lowest(jA.of(yP("." + vP, e, gP)));
    }
  }, {
    key: "findFromDOM",
    value: function value(e) {
      var t,
        n = e.querySelector(".cm-content"),
        r = n && dO.get(n) || dO.get(e);
      return (null === (t = null == r ? void 0 : r.rootView) || void 0 === t ? void 0 : t.view) || null;
    }
  }]), e;
}();
CP.styleModule = jA, CP.inputHandler = uA, CP.perLineTextDirection = cA, CP.exceptionSink = aA, CP.updateListener = sA, CP.editable = dA, CP.mouseSelectionStyle = oA, CP.dragMovesSelection = iA, CP.clickAddsSelectionRange = rA, CP.decorations = kA, CP.atomicRanges = wA, CP.scrollMargins = xA, CP.darkTheme = dP, CP.contentAttributes = bA, CP.editorAttributes = yA, CP.lineWrapping = CP.contentAttributes.of({
  class: "cm-lineWrapping"
}), CP.announce = Y_.define();
var _P = 4096,
  $P = {},
  OP = function () {
    function e(t, n, r, i) {
      Ri(this, e), this.from = t, this.to = n, this.dir = r, this.order = i;
    }
    return zi(e, null, [{
      key: "update",
      value: function value(t, n) {
        if (n.empty) return t;
        for (var r = [], i = t.length ? t[t.length - 1].dir : _A.LTR, o = Math.max(0, t.length - 10); o < t.length; o++) {
          var a = t[o];
          a.dir != i || n.touchesRange(a.from, a.to) || r.push(new e(n.mapPos(a.from, 1), n.mapPos(a.to, -1), a.dir, a.order));
        }
        return r;
      }
    }]), e;
  }();
function AP(e, t, n) {
  for (var r = e.state.facet(t), i = r.length - 1; i >= 0; i--) {
    var o = r[i],
      a = "function" == typeof o ? o(e) : o;
    a && qO(a, n);
  }
  return n;
}
var EP = AO.mac ? "mac" : AO.windows ? "win" : AO.linux ? "linux" : "key";
function PP(e, t) {
  var n,
    r,
    i,
    o,
    a = e.split(/-(?!$)/),
    s = a[a.length - 1];
  "Space" == s && (s = " ");
  for (var u = 0; u < a.length - 1; ++u) {
    var c = a[u];
    if (/^(cmd|meta|m)$/i.test(c)) o = !0;else if (/^a(lt)?$/i.test(c)) n = !0;else if (/^(c|ctrl|control)$/i.test(c)) r = !0;else if (/^s(hift)?$/i.test(c)) i = !0;else {
      if (!/^mod$/i.test(c)) throw new Error("Unrecognized modifier name: " + c);
      "mac" == t ? o = !0 : r = !0;
    }
  }
  return n && (s = "Alt-" + s), r && (s = "Ctrl-" + s), o && (s = "Meta-" + s), i && (s = "Shift-" + s), s;
}
function MP(e, t, n) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), !1 !== n && t.shiftKey && (e = "Shift-" + e), e;
}
var IP = CP.domEventHandlers({
    keydown: function keydown(e, t) {
      return zP(RP(t.state), e, t, "editor");
    }
  }),
  TP = x_.define({
    enables: IP
  }),
  NP = new WeakMap();
function RP(e) {
  var t = e.facet(TP),
    n = NP.get(t);
  return n || NP.set(t, n = function (e) {
    var t,
      n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : EP,
      r = Object.create(null),
      i = Object.create(null),
      o = function o(e, t) {
        var n = i[e];
        if (null == n) i[e] = t;else if (n != t) throw new Error("Key binding " + e + " is used both as a regular binding and as a multi-stroke prefix");
      },
      a = function a(e, t, i, _a2) {
        for (var s = r[e] || (r[e] = Object.create(null)), u = t.split(/ (?!$)/).map(function (e) {
            return PP(e, n);
          }), c = function c(t) {
            var n = u.slice(0, t).join(" ");
            o(n, !0), s[n] || (s[n] = {
              preventDefault: !0,
              commands: [function (t) {
                var r = DP = {
                  view: t,
                  prefix: n,
                  scope: e
                };
                return setTimeout(function () {
                  DP == r && (DP = null);
                }, 4e3), !0;
              }]
            });
          }, l = 1; l < u.length; l++) {
          c(l);
        }
        var f = u.join(" ");
        o(f, !1);
        var h = s[f] || (s[f] = {
          preventDefault: !1,
          commands: []
        });
        h.commands.push(i), _a2 && (h.preventDefault = !0);
      },
      s = bi(e);
    try {
      for (s.s(); !(t = s.n()).done;) {
        var u = t.value,
          c = u[n] || u.key;
        if (c) {
          var l,
            f = bi(u.scope ? u.scope.split(" ") : ["editor"]);
          try {
            for (f.s(); !(l = f.n()).done;) {
              var h = l.value;
              a(h, c, u.run, u.preventDefault), u.shift && a(h, "Shift-" + c, u.shift, u.preventDefault);
            }
          } catch (e) {
            f.e(e);
          } finally {
            f.f();
          }
        }
      }
    } catch (e) {
      s.e(e);
    } finally {
      s.f();
    }
    return r;
  }(t.reduce(function (e, t) {
    return e.concat(t);
  }, []))), n;
}
var DP = null;
function zP(e, t, n, r) {
  var i = function (e) {
      var t = !(V$ && (e.ctrlKey || e.altKey || e.metaKey) || (L$ || F$) && e.shiftKey && e.key && 1 == e.key.length) && e.key || (e.shiftKey ? D$ : R$)[e.keyCode] || e.key || "Unidentified";
      return "Esc" == t && (t = "Escape"), "Del" == t && (t = "Delete"), "Left" == t && (t = "ArrowLeft"), "Up" == t && (t = "ArrowUp"), "Right" == t && (t = "ArrowRight"), "Down" == t && (t = "ArrowDown"), t;
    }(t),
    o = 1 == i.length && " " != i,
    a = "",
    s = !1;
  DP && DP.view == n && DP.scope == r && (a = DP.prefix + " ", (s = bE.indexOf(t.keyCode) < 0) && (DP = null));
  var u,
    c = function c(e) {
      if (e) {
        var t,
          r = bi(e.commands);
        try {
          for (r.s(); !(t = r.n()).done;) {
            if ((0, t.value)(n)) return !0;
          }
        } catch (e) {
          r.e(e);
        } finally {
          r.f();
        }
        e.preventDefault && (s = !0);
      }
      return !1;
    },
    l = e[r];
  if (l) {
    if (c(l[a + MP(i, t, !o)])) return !0;
    if (o && (t.shiftKey || t.altKey || t.metaKey) && (u = R$[t.keyCode]) && u != i) {
      if (c(l[a + MP(u, t, !0)])) return !0;
    } else if (o && t.shiftKey && c(l[a + MP(i, t, !0)])) return !0;
  }
  return s;
}
var LP = !AO.ios,
  BP = x_.define({
    combine: function combine(e) {
      return l$(e, {
        cursorBlinkRate: 1200,
        drawRangeCursor: !0
      }, {
        cursorBlinkRate: function cursorBlinkRate(e, t) {
          return Math.min(e, t);
        },
        drawRangeCursor: function drawRangeCursor(e, t) {
          return e || t;
        }
      });
    }
  });
function qP() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return [BP.of(e), VP, WP];
}
var FP = function () {
    function e(t, n, r, i, o) {
      Ri(this, e), this.left = t, this.top = n, this.width = r, this.height = i, this.className = o;
    }
    return zi(e, [{
      key: "draw",
      value: function value() {
        var e = document.createElement("div");
        return e.className = this.className, this.adjust(e), e;
      }
    }, {
      key: "adjust",
      value: function value(e) {
        e.style.left = this.left + "px", e.style.top = this.top + "px", this.width >= 0 && (e.style.width = this.width + "px"), e.style.height = this.height + "px";
      }
    }, {
      key: "eq",
      value: function value(e) {
        return this.left == e.left && this.top == e.top && this.width == e.width && this.height == e.height && this.className == e.className;
      }
    }]), e;
  }(),
  VP = mA.fromClass(function () {
    function e(t) {
      Ri(this, e), this.view = t, this.rangePieces = [], this.cursors = [], this.measureReq = {
        read: this.readPos.bind(this),
        write: this.drawSel.bind(this)
      }, this.selectionLayer = t.scrollDOM.appendChild(document.createElement("div")), this.selectionLayer.className = "cm-selectionLayer", this.selectionLayer.setAttribute("aria-hidden", "true"), this.cursorLayer = t.scrollDOM.appendChild(document.createElement("div")), this.cursorLayer.className = "cm-cursorLayer", this.cursorLayer.setAttribute("aria-hidden", "true"), t.requestMeasure(this.measureReq), this.setBlinkRate();
    }
    return zi(e, [{
      key: "setBlinkRate",
      value: function value() {
        this.cursorLayer.style.animationDuration = this.view.state.facet(BP).cursorBlinkRate + "ms";
      }
    }, {
      key: "update",
      value: function value(e) {
        var t = e.startState.facet(BP) != e.state.facet(BP);
        (t || e.selectionSet || e.geometryChanged || e.viewportChanged) && this.view.requestMeasure(this.measureReq), e.transactions.some(function (e) {
          return e.scrollIntoView;
        }) && (this.cursorLayer.style.animationName = "cm-blink" == this.cursorLayer.style.animationName ? "cm-blink2" : "cm-blink"), t && this.setBlinkRate();
      }
    }, {
      key: "readPos",
      value: function value() {
        var e,
          t = this,
          n = this.view.state,
          r = n.facet(BP),
          i = n.selection.ranges.map(function (e) {
            return e.empty ? [] : function (e, t) {
              if (t.to <= e.viewport.from || t.from >= e.viewport.to) return [];
              var n = Math.max(t.from, e.viewport.from),
                r = Math.min(t.to, e.viewport.to),
                i = e.textDirection == _A.LTR,
                o = e.contentDOM,
                a = o.getBoundingClientRect(),
                s = UP(e),
                u = window.getComputedStyle(o.firstChild),
                c = a.left + parseInt(u.paddingLeft) + Math.min(0, parseInt(u.textIndent)),
                l = a.right - parseInt(u.paddingRight),
                f = KP(e, n),
                h = KP(e, r),
                d = f.type == WO.Text ? f : null,
                v = h.type == WO.Text ? h : null;
              e.lineWrapping && (d && (d = JP(e, n, d)), v && (v = JP(e, r, v)));
              if (d && v && d.from == v.from) return b(k(t.from, t.to, d));
              var p = d ? k(t.from, null, d) : w(f, !1),
                m = v ? k(null, t.to, v) : w(h, !0),
                g = [];
              return (d || f).to < (v || h).from - 1 ? g.push(y(c, p.bottom, l, m.top)) : p.bottom < m.top && e.elementAtHeight((p.bottom + m.top) / 2).type == WO.Text && (p.bottom = m.top = (p.bottom + m.top) / 2), b(p).concat(g).concat(b(m));
              function y(e, t, n, r) {
                return new FP(e - s.left, t - s.top - .01, n - e, r - t + .01, "cm-selectionBackground");
              }
              function b(e) {
                for (var t = e.top, n = e.bottom, r = e.horizontal, i = [], o = 0; o < r.length; o += 2) {
                  i.push(y(r[o], t, r[o + 1], n));
                }
                return i;
              }
              function k(t, n, r) {
                var o = 1e9,
                  a = -1e9,
                  s = [];
                function u(t, n, u, f, h) {
                  var d = e.coordsAtPos(t, t == r.to ? -2 : 2),
                    v = e.coordsAtPos(u, u == r.from ? 2 : -2);
                  o = Math.min(d.top, v.top, o), a = Math.max(d.bottom, v.bottom, a), h == _A.LTR ? s.push(i && n ? c : d.left, i && f ? l : v.right) : s.push(!i && f ? c : v.left, !i && n ? l : d.right);
                }
                var f,
                  h = null != t ? t : r.from,
                  d = null != n ? n : r.to,
                  v = bi(e.visibleRanges);
                try {
                  for (v.s(); !(f = v.n()).done;) {
                    var p = f.value;
                    if (p.to > h && p.from < d) for (var m = Math.max(p.from, h), g = Math.min(p.to, d);;) {
                      var y,
                        b = e.state.doc.lineAt(m),
                        k = bi(e.bidiSpans(b));
                      try {
                        for (k.s(); !(y = k.n()).done;) {
                          var w = y.value,
                            x = w.from + b.from,
                            j = w.to + b.from;
                          if (x >= g) break;
                          j > m && u(Math.max(x, m), null == t && x <= h, Math.min(j, g), null == n && j >= d, w.dir);
                        }
                      } catch (e) {
                        k.e(e);
                      } finally {
                        k.f();
                      }
                      if ((m = b.to + 1) >= g) break;
                    }
                  }
                } catch (e) {
                  v.e(e);
                } finally {
                  v.f();
                }
                return 0 == s.length && u(h, null == t, d, null == n, e.textDirection), {
                  top: o,
                  bottom: a,
                  horizontal: s
                };
              }
              function w(e, t) {
                var n = a.top + (t ? e.top : e.bottom);
                return {
                  top: n,
                  bottom: n,
                  horizontal: []
                };
              }
            }(t.view, e);
          }).reduce(function (e, t) {
            return e.concat(t);
          }),
          o = [],
          a = bi(n.selection.ranges);
        try {
          for (a.s(); !(e = a.n()).done;) {
            var s = e.value,
              u = s == n.selection.main;
            if (s.empty ? !u || LP : r.drawRangeCursor) {
              var c = GP(this.view, s, u);
              c && o.push(c);
            }
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
        return {
          rangePieces: i,
          cursors: o
        };
      }
    }, {
      key: "drawSel",
      value: function value(e) {
        var t = this,
          n = e.rangePieces,
          r = e.cursors;
        if (n.length != this.rangePieces.length || n.some(function (e, n) {
          return !e.eq(t.rangePieces[n]);
        })) {
          this.selectionLayer.textContent = "";
          var i,
            o = bi(n);
          try {
            for (o.s(); !(i = o.n()).done;) {
              var a = i.value;
              this.selectionLayer.appendChild(a.draw());
            }
          } catch (e) {
            o.e(e);
          } finally {
            o.f();
          }
          this.rangePieces = n;
        }
        if (r.length != this.cursors.length || r.some(function (e, n) {
          return !e.eq(t.cursors[n]);
        })) {
          var s = this.cursorLayer.children;
          if (s.length !== r.length) {
            this.cursorLayer.textContent = "";
            var u,
              c = bi(r);
            try {
              for (c.s(); !(u = c.n()).done;) {
                var l = u.value;
                this.cursorLayer.appendChild(l.draw());
              }
            } catch (e) {
              c.e(e);
            } finally {
              c.f();
            }
          } else r.forEach(function (e, t) {
            return e.adjust(s[t]);
          });
          this.cursors = r;
        }
      }
    }, {
      key: "destroy",
      value: function value() {
        this.selectionLayer.remove(), this.cursorLayer.remove();
      }
    }]), e;
  }()),
  HP = {
    ".cm-line": {
      "& ::selection": {
        backgroundColor: "transparent !important"
      },
      "&::selection": {
        backgroundColor: "transparent !important"
      }
    }
  };
LP && (HP[".cm-line"].caretColor = "transparent !important");
var WP = T_.highest(CP.theme(HP));
function UP(e) {
  var t = e.scrollDOM.getBoundingClientRect();
  return {
    left: (e.textDirection == _A.LTR ? t.left : t.right - e.scrollDOM.clientWidth) - e.scrollDOM.scrollLeft,
    top: t.top - e.scrollDOM.scrollTop
  };
}
function JP(e, t, n) {
  var r = b_.cursor(t);
  return {
    from: Math.max(n.from, e.moveToLineBoundary(r, !1, !0).from),
    to: Math.min(n.to, e.moveToLineBoundary(r, !0, !0).from),
    type: WO.Text
  };
}
function KP(e, t) {
  var n = e.lineBlockAt(t);
  if (Array.isArray(n.type)) {
    var r,
      i = bi(n.type);
    try {
      for (i.s(); !(r = i.n()).done;) {
        var o = r.value;
        if (o.to > t || o.to == t && (o.to == n.to || o.type == WO.Text)) return o;
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
  }
  return n;
}
function GP(e, t, n) {
  var r = e.coordsAtPos(t.head, t.assoc || 1);
  if (!r) return null;
  var i = UP(e);
  return new FP(r.left - i.left, r.top - i.top, -1, r.bottom - r.top, n ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary");
}
var QP = Y_.define({
    map: function map(e, t) {
      return null == e ? null : t.mapPos(e);
    }
  }),
  YP = O_.define({
    create: function create() {
      return null;
    },
    update: function update(e, t) {
      return null != e && (e = t.changes.mapPos(e)), t.effects.reduce(function (e, t) {
        return t.is(QP) ? t.value : e;
      }, e);
    }
  }),
  ZP = mA.fromClass(function () {
    function e(t) {
      Ri(this, e), this.view = t, this.cursor = null, this.measureReq = {
        read: this.readPos.bind(this),
        write: this.drawCursor.bind(this)
      };
    }
    return zi(e, [{
      key: "update",
      value: function value(e) {
        var t,
          n = e.state.field(YP);
        null == n ? null != this.cursor && (null === (t = this.cursor) || void 0 === t || t.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (e.startState.field(YP) != n || e.docChanged || e.geometryChanged) && this.view.requestMeasure(this.measureReq));
      }
    }, {
      key: "readPos",
      value: function value() {
        var e = this.view.state.field(YP),
          t = null != e && this.view.coordsAtPos(e);
        if (!t) return null;
        var n = this.view.scrollDOM.getBoundingClientRect();
        return {
          left: t.left - n.left + this.view.scrollDOM.scrollLeft,
          top: t.top - n.top + this.view.scrollDOM.scrollTop,
          height: t.bottom - t.top
        };
      }
    }, {
      key: "drawCursor",
      value: function value(e) {
        this.cursor && (e ? (this.cursor.style.left = e.left + "px", this.cursor.style.top = e.top + "px", this.cursor.style.height = e.height + "px") : this.cursor.style.left = "-100000px");
      }
    }, {
      key: "destroy",
      value: function value() {
        this.cursor && this.cursor.remove();
      }
    }, {
      key: "setDropPos",
      value: function value(e) {
        this.view.state.field(YP) != e && this.view.dispatch({
          effects: QP.of(e)
        });
      }
    }]), e;
  }(), {
    eventHandlers: {
      dragover: function dragover(e) {
        this.setDropPos(this.view.posAtCoords({
          x: e.clientX,
          y: e.clientY
        }));
      },
      dragleave: function dragleave(e) {
        e.target != this.view.contentDOM && this.view.contentDOM.contains(e.relatedTarget) || this.setDropPos(null);
      },
      dragend: function dragend() {
        this.setDropPos(null);
      },
      drop: function drop() {
        this.setDropPos(null);
      }
    }
  });
function XP() {
  return [YP, ZP];
}
function eM(e, t, n, r, i) {
  t.lastIndex = 0;
  for (var o, a = e.iterRange(n, r), s = n; !a.next().done; s += a.value.length) {
    if (!a.lineBreak) for (; o = t.exec(a.value);) {
      i(s + o.index, s + o.index + o[0].length, o);
    }
  }
}
var tM = function () {
    function e(t) {
      Ri(this, e);
      var n = t.regexp,
        r = t.decoration,
        i = t.boundary,
        o = t.maxLength,
        a = void 0 === o ? 1e3 : o;
      if (!n.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
      this.regexp = n, this.getDeco = "function" == typeof r ? r : function () {
        return r;
      }, this.boundary = i, this.maxLength = a;
    }
    return zi(e, [{
      key: "createDeco",
      value: function value(e) {
        var t,
          n = this,
          r = new g$(),
          i = bi(function (e, t) {
            var n = e.visibleRanges;
            if (1 == n.length && n[0].from == e.viewport.from && n[0].to == e.viewport.to) return n;
            var r,
              i = [],
              o = bi(n);
            try {
              for (o.s(); !(r = o.n()).done;) {
                var a = r.value,
                  s = a.from,
                  u = a.to;
                s = Math.max(e.state.doc.lineAt(s).from, s - t), u = Math.min(e.state.doc.lineAt(u).to, u + t), i.length && i[i.length - 1].to >= s ? i[i.length - 1].to = u : i.push({
                  from: s,
                  to: u
                });
              }
            } catch (e) {
              o.e(e);
            } finally {
              o.f();
            }
            return i;
          }(e, this.maxLength));
        try {
          for (i.s(); !(t = i.n()).done;) {
            var o = t.value,
              a = o.from,
              s = o.to;
            eM(e.state.doc, this.regexp, a, s, function (t, i, o) {
              return r.add(t, i, n.getDeco(o, e, t));
            });
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        return r.finish();
      }
    }, {
      key: "updateDeco",
      value: function value(e, t) {
        var n = 1e9,
          r = -1;
        return e.docChanged && e.changes.iterChanges(function (t, i, o, a) {
          a > e.view.viewport.from && o < e.view.viewport.to && (n = Math.min(o, n), r = Math.max(a, r));
        }), e.viewportChanged || r - n > 1e3 ? this.createDeco(e.view) : r > -1 ? this.updateRange(e.view, t.map(e.changes), n, r) : t;
      }
    }, {
      key: "updateRange",
      value: function value(e, t, n, r) {
        var i,
          o = this,
          a = bi(e.visibleRanges);
        try {
          for (a.s(); !(i = a.n()).done;) {
            var s = i.value,
              u = Math.max(s.from, n),
              c = Math.min(s.to, r);
            c > u && function () {
              var n = e.state.doc.lineAt(u),
                r = n.to < c ? e.state.doc.lineAt(c) : n,
                i = Math.max(s.from, n.from),
                a = Math.min(s.to, r.to);
              if (o.boundary) {
                for (; u > n.from; u--) {
                  if (o.boundary.test(n.text[u - 1 - n.from])) {
                    i = u;
                    break;
                  }
                }
                for (; c < r.to; c++) {
                  if (o.boundary.test(r.text[c - r.from])) {
                    a = c;
                    break;
                  }
                }
              }
              var l = [],
                f = void 0;
              if (n == r) for (o.regexp.lastIndex = i - n.from; (f = o.regexp.exec(n.text)) && f.index < a - n.from;) {
                var h = f.index + n.from;
                l.push(o.getDeco(f, e, h).range(h, h + f[0].length));
              } else eM(e.state.doc, o.regexp, i, a, function (t, n, r) {
                return l.push(o.getDeco(r, e, t).range(t, n));
              });
              t = t.update({
                filterFrom: i,
                filterTo: a,
                filter: function filter(e, t) {
                  return e < i || t > a;
                },
                add: l
              });
            }();
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
        return t;
      }
    }]), e;
  }(),
  nM = null != /x/.unicode ? "gu" : "g",
  rM = new RegExp("[\0-\b\n-\x1F\x7F-\x9F\xAD\u061C\u200B\u200E\u200F\u2028\u2029\u202D\u202E\uFEFF\uFFF9-\uFFFC]", nM),
  iM = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
  },
  oM = null;
var aM = x_.define({
  combine: function combine(e) {
    var t = l$(e, {
      render: null,
      specialChars: rM,
      addSpecialChars: null
    });
    return (t.replaceTabs = !function () {
      var e;
      if (null == oM && "undefined" != typeof document && document.body) {
        var t = document.body.style;
        oM = null != (null !== (e = t.tabSize) && void 0 !== e ? e : t.MozTabSize);
      }
      return oM || !1;
    }()) && (t.specialChars = new RegExp("\t|" + t.specialChars.source, nM)), t.addSpecialChars && (t.specialChars = new RegExp(t.specialChars.source + "|" + t.addSpecialChars.source, nM)), t;
  }
});
function sM() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return [aM.of(e), cM()];
}
var uM = null;
function cM() {
  return uM || (uM = mA.fromClass(function () {
    function e(t) {
      Ri(this, e), this.view = t, this.decorations = UO.none, this.decorationCache = Object.create(null), this.decorator = this.makeDecorator(t.state.facet(aM)), this.decorations = this.decorator.createDeco(t);
    }
    return zi(e, [{
      key: "makeDecorator",
      value: function value(e) {
        var t = this;
        return new tM({
          regexp: e.specialChars,
          decoration: function decoration(n, r, i) {
            var o = r.state.doc,
              a = o_(n[0], 0);
            if (9 == a) {
              var s = o.lineAt(i),
                u = r.state.tabSize,
                c = O$(s.text, u, i - s.from);
              return UO.replace({
                widget: new fM((u - c % u) * t.view.defaultCharacterWidth)
              });
            }
            return t.decorationCache[a] || (t.decorationCache[a] = UO.replace({
              widget: new lM(e, a)
            }));
          },
          boundary: e.replaceTabs ? void 0 : /[^]/
        });
      }
    }, {
      key: "update",
      value: function value(e) {
        var t = e.state.facet(aM);
        e.startState.facet(aM) != t ? (this.decorator = this.makeDecorator(t), this.decorations = this.decorator.createDeco(e.view)) : this.decorations = this.decorator.updateDeco(e, this.decorations);
      }
    }]), e;
  }(), {
    decorations: function decorations(e) {
      return e.decorations;
    }
  }));
}
var lM = function (e) {
    ji(n, HO);
    var t = Ci(n);
    function n(e, r) {
      var i;
      return Ri(this, n), (i = t.call(this)).options = e, i.code = r, i;
    }
    return zi(n, [{
      key: "eq",
      value: function value(e) {
        return e.code == this.code;
      }
    }, {
      key: "toDOM",
      value: function value(e) {
        var t = function (e) {
            return e >= 32 ? "•" : 10 == e ? "␤" : String.fromCharCode(9216 + e);
          }(this.code),
          n = e.state.phrase("Control character") + " " + (iM[this.code] || "0x" + this.code.toString(16)),
          r = this.options.render && this.options.render(this.code, n, t);
        if (r) return r;
        var i = document.createElement("span");
        return i.textContent = t, i.title = n, i.setAttribute("aria-label", n), i.className = "cm-specialChar", i;
      }
    }, {
      key: "ignoreEvent",
      value: function value() {
        return !1;
      }
    }]), n;
  }(),
  fM = function (e) {
    ji(n, HO);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), (r = t.call(this)).width = e, r;
    }
    return zi(n, [{
      key: "eq",
      value: function value(e) {
        return e.width == this.width;
      }
    }, {
      key: "toDOM",
      value: function value() {
        var e = document.createElement("span");
        return e.textContent = "\t", e.className = "cm-tab", e.style.width = this.width + "px", e;
      }
    }, {
      key: "ignoreEvent",
      value: function value() {
        return !1;
      }
    }]), n;
  }();
function hM() {
  return vM;
}
var dM = UO.line({
    class: "cm-activeLine"
  }),
  vM = mA.fromClass(function () {
    function e(t) {
      Ri(this, e), this.decorations = this.getDeco(t);
    }
    return zi(e, [{
      key: "update",
      value: function value(e) {
        (e.docChanged || e.selectionSet) && (this.decorations = this.getDeco(e.view));
      }
    }, {
      key: "getDeco",
      value: function value(e) {
        var t,
          n = -1,
          r = [],
          i = bi(e.state.selection.ranges);
        try {
          for (i.s(); !(t = i.n()).done;) {
            var o = t.value;
            if (!o.empty) return UO.none;
            var a = e.lineBlockAt(o.head);
            a.from > n && (r.push(dM.range(a.from)), n = a.from);
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        return UO.set(r);
      }
    }]), e;
  }(), {
    decorations: function decorations(e) {
      return e.decorations;
    }
  });
function pM(e, t) {
  var n = e.posAtCoords({
      x: t.clientX,
      y: t.clientY
    }, !1),
    r = e.state.doc.lineAt(n),
    i = n - r.from,
    o = i > 2e3 ? -1 : i == r.length ? function (e, t) {
      var n = e.coordsAtPos(e.viewport.from);
      return n ? Math.round(Math.abs((n.left - t) / e.defaultCharacterWidth)) : -1;
    }(e, t.clientX) : O$(r.text, e.state.tabSize, n - r.from);
  return {
    line: r.number,
    col: o,
    off: i
  };
}
function mM(e, t) {
  var n = pM(e, t),
    r = e.state.selection;
  return n ? {
    update: function update(e) {
      if (e.docChanged) {
        var t = e.changes.mapPos(e.startState.doc.line(n.line).from),
          i = e.state.doc.lineAt(t);
        n = {
          line: i.number,
          col: n.col,
          off: Math.min(n.off, i.length)
        }, r = r.map(e.changes);
      }
    },
    get: function get(t, i, o) {
      var a = pM(e, t);
      if (!a) return r;
      var s = function (e, t, n) {
        var r = Math.min(t.line, n.line),
          i = Math.max(t.line, n.line),
          o = [];
        if (t.off > 2e3 || n.off > 2e3 || t.col < 0 || n.col < 0) for (var a = Math.min(t.off, n.off), s = Math.max(t.off, n.off), u = r; u <= i; u++) {
          var c = e.doc.line(u);
          c.length <= s && o.push(b_.range(c.from + a, c.to + s));
        } else for (var l = Math.min(t.col, n.col), f = Math.max(t.col, n.col), h = r; h <= i; h++) {
          var d = e.doc.line(h),
            v = A$(d.text, l, e.tabSize, !0);
          if (v > -1) {
            var p = A$(d.text, f, e.tabSize);
            o.push(b_.range(d.from + v, d.from + p));
          }
        }
        return o;
      }(e.state, n, a);
      return s.length ? o ? b_.create(s.concat(r.ranges)) : b_.create(s) : r;
    }
  } : null;
}
function gM(e) {
  var t = (null == e ? void 0 : e.eventFilter) || function (e) {
    return e.altKey && 0 == e.button;
  };
  return CP.mouseSelectionStyle.of(function (e, n) {
    return t(n) ? mM(e, n) : null;
  });
}
var yM = {
    Alt: [18, function (e) {
      return e.altKey;
    }],
    Control: [17, function (e) {
      return e.ctrlKey;
    }],
    Shift: [16, function (e) {
      return e.shiftKey;
    }],
    Meta: [91, function (e) {
      return e.metaKey;
    }]
  },
  bM = {
    style: "cursor: crosshair"
  };
function kM() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    t = xi(yM[e.key || "Alt"], 2),
    n = t[0],
    r = t[1],
    i = mA.fromClass(function () {
      function e(t) {
        Ri(this, e), this.view = t, this.isDown = !1;
      }
      return zi(e, [{
        key: "set",
        value: function value(e) {
          this.isDown != e && (this.isDown = e, this.view.update([]));
        }
      }]), e;
    }(), {
      eventHandlers: {
        keydown: function keydown(e) {
          this.set(e.keyCode == n || r(e));
        },
        keyup: function keyup(e) {
          e.keyCode != n && r(e) || this.set(!1);
        }
      }
    });
  return [i, CP.contentAttributes.of(function (e) {
    var t;
    return (null === (t = e.plugin(i)) || void 0 === t ? void 0 : t.isDown) ? bM : null;
  })];
}
var wM = function () {
  function e(t, n, r) {
    Ri(this, e), this.facet = n, this.createTooltipView = r, this.input = t.state.facet(n), this.tooltips = this.input.filter(function (e) {
      return e;
    }), this.tooltipViews = this.tooltips.map(r);
  }
  return zi(e, [{
    key: "update",
    value: function value(e) {
      var t = e.state.facet(this.facet),
        n = t.filter(function (e) {
          return e;
        });
      if (t === this.input) {
        var r,
          i = bi(this.tooltipViews);
        try {
          for (i.s(); !(r = i.n()).done;) {
            var o = r.value;
            o.update && o.update(e);
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        return !1;
      }
      for (var a = [], s = 0; s < n.length; s++) {
        var u = n[s],
          c = -1;
        if (u) {
          for (var l = 0; l < this.tooltips.length; l++) {
            var f = this.tooltips[l];
            f && f.create == u.create && (c = l);
          }
          if (c < 0) a[s] = this.createTooltipView(u);else {
            var h = a[s] = this.tooltipViews[c];
            h.update && h.update(e);
          }
        }
      }
      var d,
        v = bi(this.tooltipViews);
      try {
        for (v.s(); !(d = v.n()).done;) {
          var p = d.value;
          a.indexOf(p) < 0 && p.dom.remove();
        }
      } catch (e) {
        v.e(e);
      } finally {
        v.f();
      }
      return this.input = t, this.tooltips = n, this.tooltipViews = a, !0;
    }
  }]), e;
}();
function xM() {
  return {
    top: 0,
    left: 0,
    bottom: innerHeight,
    right: innerWidth
  };
}
var jM = x_.define({
    combine: function combine(e) {
      var t, n, r;
      return {
        position: AO.ios ? "absolute" : (null === (t = e.find(function (e) {
          return e.position;
        })) || void 0 === t ? void 0 : t.position) || "fixed",
        parent: (null === (n = e.find(function (e) {
          return e.parent;
        })) || void 0 === n ? void 0 : n.parent) || null,
        tooltipSpace: (null === (r = e.find(function (e) {
          return e.tooltipSpace;
        })) || void 0 === r ? void 0 : r.tooltipSpace) || xM
      };
    }
  }),
  SM = mA.fromClass(function () {
    function e(t) {
      var n,
        r = this;
      Ri(this, e), this.view = t, this.inView = !0, this.lastTransaction = 0, this.measureTimeout = -1;
      var i = t.state.facet(jM);
      this.position = i.position, this.parent = i.parent, this.classes = t.themeClasses, this.createContainer(), this.measureReq = {
        read: this.readMeasure.bind(this),
        write: this.writeMeasure.bind(this),
        key: this
      }, this.manager = new wM(t, $M, function (e) {
        return r.createTooltip(e);
      }), this.intersectionObserver = "function" == typeof IntersectionObserver ? new IntersectionObserver(function (e) {
        Date.now() > r.lastTransaction - 50 && e.length > 0 && e[e.length - 1].intersectionRatio < 1 && r.measureSoon();
      }, {
        threshold: [1]
      }) : null, this.observeIntersection(), null === (n = t.dom.ownerDocument.defaultView) || void 0 === n || n.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
    }
    return zi(e, [{
      key: "createContainer",
      value: function value() {
        this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
      }
    }, {
      key: "observeIntersection",
      value: function value() {
        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
          var e,
            t = bi(this.manager.tooltipViews);
          try {
            for (t.s(); !(e = t.n()).done;) {
              var n = e.value;
              this.intersectionObserver.observe(n.dom);
            }
          } catch (e) {
            t.e(e);
          } finally {
            t.f();
          }
        }
      }
    }, {
      key: "measureSoon",
      value: function value() {
        var e = this;
        this.measureTimeout < 0 && (this.measureTimeout = setTimeout(function () {
          e.measureTimeout = -1, e.maybeMeasure();
        }, 50));
      }
    }, {
      key: "update",
      value: function value(e) {
        e.transactions.length && (this.lastTransaction = Date.now());
        var t = this.manager.update(e);
        t && this.observeIntersection();
        var n = t || e.geometryChanged,
          r = e.state.facet(jM);
        if (r.position != this.position) {
          this.position = r.position;
          var i,
            o = bi(this.manager.tooltipViews);
          try {
            for (o.s(); !(i = o.n()).done;) {
              i.value.dom.style.position = this.position;
            }
          } catch (e) {
            o.e(e);
          } finally {
            o.f();
          }
          n = !0;
        }
        if (r.parent != this.parent) {
          this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
          var a,
            s = bi(this.manager.tooltipViews);
          try {
            for (s.s(); !(a = s.n()).done;) {
              var u = a.value;
              this.container.appendChild(u.dom);
            }
          } catch (e) {
            s.e(e);
          } finally {
            s.f();
          }
          n = !0;
        } else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
        n && this.maybeMeasure();
      }
    }, {
      key: "createTooltip",
      value: function value(e) {
        var t = e.create(this.view);
        if (t.dom.classList.add("cm-tooltip"), e.arrow && !t.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
          var n = document.createElement("div");
          n.className = "cm-tooltip-arrow", t.dom.appendChild(n);
        }
        return t.dom.style.position = this.position, t.dom.style.top = "-10000px", this.container.appendChild(t.dom), t.mount && t.mount(this.view), t;
      }
    }, {
      key: "destroy",
      value: function value() {
        var e, t;
        null === (e = this.view.dom.ownerDocument.defaultView) || void 0 === e || e.removeEventListener("resize", this.measureSoon);
        var n,
          r = bi(this.manager.tooltipViews);
        try {
          for (r.s(); !(n = r.n()).done;) {
            n.value.dom.remove();
          }
        } catch (e) {
          r.e(e);
        } finally {
          r.f();
        }
        null === (t = this.intersectionObserver) || void 0 === t || t.disconnect(), clearTimeout(this.measureTimeout);
      }
    }, {
      key: "readMeasure",
      value: function value() {
        var e = this,
          t = this.view.dom.getBoundingClientRect();
        return {
          editor: t,
          parent: this.parent ? this.container.getBoundingClientRect() : t,
          pos: this.manager.tooltips.map(function (t, n) {
            var r = e.manager.tooltipViews[n];
            return r.getCoords ? r.getCoords(t.pos) : e.view.coordsAtPos(t.pos);
          }),
          size: this.manager.tooltipViews.map(function (e) {
            return e.dom.getBoundingClientRect();
          }),
          space: this.view.state.facet(jM).tooltipSpace(this.view)
        };
      }
    }, {
      key: "writeMeasure",
      value: function value(e) {
        for (var t = e.editor, n = e.space, r = [], i = 0; i < this.manager.tooltips.length; i++) {
          var o = this.manager.tooltips[i],
            a = this.manager.tooltipViews[i],
            s = a.dom,
            u = e.pos[i],
            c = e.size[i];
          if (!u || u.bottom <= Math.max(t.top, n.top) || u.top >= Math.min(t.bottom, n.bottom) || u.right < Math.max(t.left, n.left) - .1 || u.left > Math.min(t.right, n.right) + .1) s.style.top = "-10000px";else {
            var l = o.arrow ? a.dom.querySelector(".cm-tooltip-arrow") : null,
              f = l ? 7 : 0,
              h = c.right - c.left,
              d = c.bottom - c.top,
              v = a.offset || _M,
              p = this.view.textDirection == _A.LTR,
              m = c.width > n.right - n.left ? p ? n.left : n.right - c.width : p ? Math.min(u.left - (l ? 14 : 0) + v.x, n.right - h) : Math.max(n.left, u.left - h + (l ? 14 : 0) - v.x),
              g = !!o.above;
            !o.strictSide && (g ? u.top - (c.bottom - c.top) - v.y < n.top : u.bottom + (c.bottom - c.top) + v.y > n.bottom) && g == n.bottom - u.bottom > u.top - n.top && (g = !g);
            var y = g ? u.top - d - f - v.y : u.bottom + f + v.y,
              b = m + h;
            if (!0 !== a.overlap) {
              var k,
                w = bi(r);
              try {
                for (w.s(); !(k = w.n()).done;) {
                  var x = k.value;
                  x.left < b && x.right > m && x.top < y + d && x.bottom > y && (y = g ? x.top - d - 2 - f : x.bottom + f + 2);
                }
              } catch (e) {
                w.e(e);
              } finally {
                w.f();
              }
            }
            "absolute" == this.position ? (s.style.top = y - e.parent.top + "px", s.style.left = m - e.parent.left + "px") : (s.style.top = y + "px", s.style.left = m + "px"), l && (l.style.left = "".concat(u.left + (p ? v.x : -v.x) - (m + 14 - 7), "px")), !0 !== a.overlap && r.push({
              left: m,
              top: y,
              right: b,
              bottom: y + d
            }), s.classList.toggle("cm-tooltip-above", g), s.classList.toggle("cm-tooltip-below", !g), a.positioned && a.positioned();
          }
        }
      }
    }, {
      key: "maybeMeasure",
      value: function value() {
        if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView))) {
          var e,
            t = bi(this.manager.tooltipViews);
          try {
            for (t.s(); !(e = t.n()).done;) {
              e.value.dom.style.top = "-10000px";
            }
          } catch (e) {
            t.e(e);
          } finally {
            t.f();
          }
        }
      }
    }]), e;
  }(), {
    eventHandlers: {
      scroll: function scroll() {
        this.maybeMeasure();
      }
    }
  }),
  CM = CP.baseTheme({
    ".cm-tooltip": {
      zIndex: 100
    },
    "&light .cm-tooltip": {
      border: "1px solid #bbb",
      backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
      borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
      backgroundColor: "#333338",
      color: "white"
    },
    ".cm-tooltip-arrow": {
      height: "".concat(7, "px"),
      width: "".concat(14, "px"),
      position: "absolute",
      zIndex: -1,
      overflow: "hidden",
      "&:before, &:after": {
        content: "''",
        position: "absolute",
        width: 0,
        height: 0,
        borderLeft: "".concat(7, "px solid transparent"),
        borderRight: "".concat(7, "px solid transparent")
      },
      ".cm-tooltip-above &": {
        bottom: "-".concat(7, "px"),
        "&:before": {
          borderTop: "".concat(7, "px solid #bbb")
        },
        "&:after": {
          borderTop: "".concat(7, "px solid #f5f5f5"),
          bottom: "1px"
        }
      },
      ".cm-tooltip-below &": {
        top: "-".concat(7, "px"),
        "&:before": {
          borderBottom: "".concat(7, "px solid #bbb")
        },
        "&:after": {
          borderBottom: "".concat(7, "px solid #f5f5f5"),
          top: "1px"
        }
      }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
      "&:before": {
        borderTopColor: "#333338",
        borderBottomColor: "#333338"
      },
      "&:after": {
        borderTopColor: "transparent",
        borderBottomColor: "transparent"
      }
    }
  }),
  _M = {
    x: 0,
    y: 0
  },
  $M = x_.define({
    enables: [SM, CM]
  }),
  OM = x_.define(),
  AM = function () {
    function e(t) {
      var n = this;
      Ri(this, e), this.view = t, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new wM(t, OM, function (e) {
        return n.createHostedView(e);
      });
    }
    return zi(e, [{
      key: "createHostedView",
      value: function value(e) {
        var t = e.create(this.view);
        return t.dom.classList.add("cm-tooltip-section"), this.dom.appendChild(t.dom), this.mounted && t.mount && t.mount(this.view), t;
      }
    }, {
      key: "mount",
      value: function value(e) {
        var t,
          n = bi(this.manager.tooltipViews);
        try {
          for (n.s(); !(t = n.n()).done;) {
            var r = t.value;
            r.mount && r.mount(e);
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
        this.mounted = !0;
      }
    }, {
      key: "positioned",
      value: function value() {
        var e,
          t = bi(this.manager.tooltipViews);
        try {
          for (t.s(); !(e = t.n()).done;) {
            var n = e.value;
            n.positioned && n.positioned();
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }, {
      key: "update",
      value: function value(e) {
        this.manager.update(e);
      }
    }], [{
      key: "create",
      value: function value(t) {
        return new e(t);
      }
    }]), e;
  }(),
  EM = $M.compute([OM], function (e) {
    var t = e.facet(OM).filter(function (e) {
      return e;
    });
    return 0 === t.length ? null : {
      pos: Math.min.apply(Math, Ii(t.map(function (e) {
        return e.pos;
      }))),
      end: Math.max.apply(Math, Ii(t.filter(function (e) {
        return null != e.end;
      }).map(function (e) {
        return e.end;
      }))),
      create: AM.create,
      above: t[0].above,
      arrow: t.some(function (e) {
        return e.arrow;
      })
    };
  }),
  PM = function () {
    function e(t, n, r, i, o) {
      Ri(this, e), this.view = t, this.source = n, this.field = r, this.setHover = i, this.hoverTime = o, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = {
        x: 0,
        y: 0,
        target: t.dom,
        time: 0
      }, this.checkHover = this.checkHover.bind(this), t.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), t.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    return zi(e, [{
      key: "update",
      value: function value() {
        var e = this;
        this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(function () {
          return e.startHover();
        }, 20));
      }
    }, {
      key: "active",
      get: function get() {
        return this.view.state.field(this.field);
      }
    }, {
      key: "checkHover",
      value: function value() {
        if (this.hoverTimeout = -1, !this.active) {
          var e = Date.now() - this.lastMove.time;
          e < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - e) : this.startHover();
        }
      }
    }, {
      key: "startHover",
      value: function value() {
        var e = this;
        clearTimeout(this.restartTimeout);
        var t = this.lastMove,
          n = this.view.contentDOM.contains(t.target) ? this.view.posAtCoords(t) : null;
        if (null != n) {
          var r = this.view.coordsAtPos(n);
          if (!(null == r || t.y < r.top || t.y > r.bottom || t.x < r.left - this.view.defaultCharacterWidth || t.x > r.right + this.view.defaultCharacterWidth)) {
            var i = this.view.bidiSpans(this.view.state.doc.lineAt(n)).find(function (e) {
                return e.from <= n && e.to >= n;
              }),
              o = i && i.dir == _A.RTL ? -1 : 1,
              a = this.source(this.view, n, t.x < r.left ? -o : o);
            if (null == a ? void 0 : a.then) {
              var s = this.pending = {
                pos: n
              };
              a.then(function (t) {
                e.pending == s && (e.pending = null, t && e.view.dispatch({
                  effects: e.setHover.of(t)
                }));
              }, function (t) {
                return hA(e.view.state, t, "hover tooltip");
              });
            } else a && this.view.dispatch({
              effects: this.setHover.of(a)
            });
          }
        }
      }
    }, {
      key: "mousemove",
      value: function value(e) {
        var t;
        this.lastMove = {
          x: e.clientX,
          y: e.clientY,
          target: e.target,
          time: Date.now()
        }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
        var n = this.active;
        if (n && !function (e) {
          for (var t = e; t; t = t.parentNode) {
            if (1 == t.nodeType && t.classList.contains("cm-tooltip")) return !0;
          }
          return !1;
        }(this.lastMove.target) || this.pending) {
          var r = (n || this.pending).pos,
            i = null !== (t = null == n ? void 0 : n.end) && void 0 !== t ? t : r;
          (r == i ? this.view.posAtCoords(this.lastMove) == r : function (e, t, n, r, i, o) {
            var a = document.createRange(),
              s = e.domAtPos(t),
              u = e.domAtPos(n);
            a.setEnd(u.node, u.offset), a.setStart(s.node, s.offset);
            var c = a.getClientRects();
            a.detach();
            for (var l = 0; l < c.length; l++) {
              var f = c[l];
              if (Math.max(f.top - i, i - f.bottom, f.left - r, r - f.right) <= o) return !0;
            }
            return !1;
          }(this.view, r, i, e.clientX, e.clientY, 6)) || (this.view.dispatch({
            effects: this.setHover.of(null)
          }), this.pending = null);
        }
      }
    }, {
      key: "mouseleave",
      value: function value() {
        clearTimeout(this.hoverTimeout), this.hoverTimeout = -1, this.active && this.view.dispatch({
          effects: this.setHover.of(null)
        });
      }
    }, {
      key: "destroy",
      value: function value() {
        clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
      }
    }]), e;
  }();
function MM(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    n = Y_.define(),
    r = O_.define({
      create: function create() {
        return null;
      },
      update: function update(e, r) {
        if (e && (t.hideOnChange && (r.docChanged || r.selection) || t.hideOn && t.hideOn(r, e))) return null;
        if (e && r.docChanged) {
          var i = r.changes.mapPos(e.pos, -1, c_.TrackDel);
          if (null == i) return null;
          var o = Object.assign(Object.create(null), e);
          o.pos = i, null != e.end && (o.end = r.changes.mapPos(e.end)), e = o;
        }
        var a,
          s = bi(r.effects);
        try {
          for (s.s(); !(a = s.n()).done;) {
            var u = a.value;
            u.is(n) && (e = u.value), u.is(TM) && (e = null);
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
        return e;
      },
      provide: function provide(e) {
        return OM.from(e);
      }
    });
  return [r, mA.define(function (i) {
    return new PM(i, e, r, n, t.hoverTime || 300);
  }), EM];
}
function IM(e, t) {
  var n = e.plugin(SM);
  if (!n) return null;
  var r = n.manager.tooltips.indexOf(t);
  return r < 0 ? null : n.manager.tooltipViews[r];
}
var TM = Y_.define(),
  NM = x_.define({
    combine: function combine(e) {
      var t,
        n,
        r,
        i = bi(e);
      try {
        for (i.s(); !(r = i.n()).done;) {
          var o = r.value;
          t = t || o.topContainer, n = n || o.bottomContainer;
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }
      return {
        topContainer: t,
        bottomContainer: n
      };
    }
  });
function RM(e, t) {
  var n = e.plugin(DM),
    r = n ? n.specs.indexOf(t) : -1;
  return r > -1 ? n.panels[r] : null;
}
var DM = mA.fromClass(function () {
    function e(t) {
      Ri(this, e), this.input = t.state.facet(BM), this.specs = this.input.filter(function (e) {
        return e;
      }), this.panels = this.specs.map(function (e) {
        return e(t);
      });
      var n = t.state.facet(NM);
      this.top = new zM(t, !0, n.topContainer), this.bottom = new zM(t, !1, n.bottomContainer), this.top.sync(this.panels.filter(function (e) {
        return e.top;
      })), this.bottom.sync(this.panels.filter(function (e) {
        return !e.top;
      }));
      var r,
        i = bi(this.panels);
      try {
        for (i.s(); !(r = i.n()).done;) {
          var o = r.value;
          o.dom.classList.add("cm-panel"), o.mount && o.mount();
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }
    }
    return zi(e, [{
      key: "update",
      value: function value(e) {
        var t = e.state.facet(NM);
        this.top.container != t.topContainer && (this.top.sync([]), this.top = new zM(e.view, !0, t.topContainer)), this.bottom.container != t.bottomContainer && (this.bottom.sync([]), this.bottom = new zM(e.view, !1, t.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
        var n = e.state.facet(BM);
        if (n != this.input) {
          var r,
            i = n.filter(function (e) {
              return e;
            }),
            o = [],
            a = [],
            s = [],
            u = [],
            c = bi(i);
          try {
            for (c.s(); !(r = c.n()).done;) {
              var l = r.value,
                f = this.specs.indexOf(l),
                h = void 0;
              f < 0 ? (h = l(e.view), u.push(h)) : (h = this.panels[f]).update && h.update(e), o.push(h), (h.top ? a : s).push(h);
            }
          } catch (e) {
            c.e(e);
          } finally {
            c.f();
          }
          this.specs = i, this.panels = o, this.top.sync(a), this.bottom.sync(s);
          for (var d = 0, v = u; d < v.length; d++) {
            var p = v[d];
            p.dom.classList.add("cm-panel"), p.mount && p.mount();
          }
        } else {
          var m,
            g = bi(this.panels);
          try {
            for (g.s(); !(m = g.n()).done;) {
              var y = m.value;
              y.update && y.update(e);
            }
          } catch (e) {
            g.e(e);
          } finally {
            g.f();
          }
        }
      }
    }, {
      key: "destroy",
      value: function value() {
        this.top.sync([]), this.bottom.sync([]);
      }
    }]), e;
  }(), {
    provide: function provide(e) {
      return CP.scrollMargins.of(function (t) {
        var n = t.plugin(e);
        return n && {
          top: n.top.scrollMargin(),
          bottom: n.bottom.scrollMargin()
        };
      });
    }
  }),
  zM = function () {
    function e(t, n, r) {
      Ri(this, e), this.view = t, this.top = n, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
    }
    return zi(e, [{
      key: "sync",
      value: function value(e) {
        var t,
          n = bi(this.panels);
        try {
          for (n.s(); !(t = n.n()).done;) {
            var r = t.value;
            r.destroy && e.indexOf(r) < 0 && r.destroy();
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
        this.panels = e, this.syncDOM();
      }
    }, {
      key: "syncDOM",
      value: function value() {
        if (0 != this.panels.length) {
          if (!this.dom) {
            this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
            var e = this.container || this.view.dom;
            e.insertBefore(this.dom, this.top ? e.firstChild : null);
          }
          var t,
            n = this.dom.firstChild,
            r = bi(this.panels);
          try {
            for (r.s(); !(t = r.n()).done;) {
              var i = t.value;
              if (i.dom.parentNode == this.dom) {
                for (; n != i.dom;) {
                  n = LM(n);
                }
                n = n.nextSibling;
              } else this.dom.insertBefore(i.dom, n);
            }
          } catch (e) {
            r.e(e);
          } finally {
            r.f();
          }
          for (; n;) {
            n = LM(n);
          }
        } else this.dom && (this.dom.remove(), this.dom = void 0);
      }
    }, {
      key: "scrollMargin",
      value: function value() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
      }
    }, {
      key: "syncClasses",
      value: function value() {
        if (this.container && this.classes != this.view.themeClasses) {
          var e,
            t = bi(this.classes.split(" "));
          try {
            for (t.s(); !(e = t.n()).done;) {
              var n = e.value;
              n && this.container.classList.remove(n);
            }
          } catch (e) {
            t.e(e);
          } finally {
            t.f();
          }
          var r,
            i = bi((this.classes = this.view.themeClasses).split(" "));
          try {
            for (i.s(); !(r = i.n()).done;) {
              var o = r.value;
              o && this.container.classList.add(o);
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        }
      }
    }]), e;
  }();
function LM(e) {
  var t = e.nextSibling;
  return e.remove(), t;
}
var BM = x_.define({
    enables: DM
  }),
  qM = function (e) {
    ji(n, f$);
    var t = Ci(n);
    function n() {
      return Ri(this, n), t.apply(this, arguments);
    }
    return zi(n, [{
      key: "compare",
      value: function value(e) {
        return this == e || this.constructor == e.constructor && this.eq(e);
      }
    }, {
      key: "eq",
      value: function value(e) {
        return !1;
      }
    }, {
      key: "destroy",
      value: function value(e) {}
    }]), n;
  }();
qM.prototype.elementClass = "", qM.prototype.toDOM = void 0, qM.prototype.mapMode = c_.TrackBefore, qM.prototype.startSide = qM.prototype.endSide = -1, qM.prototype.point = !0;
var FM = x_.define(),
  VM = {
    class: "",
    renderEmptyElements: !1,
    elementStyle: "",
    markers: function markers() {
      return p$.empty;
    },
    lineMarker: function lineMarker() {
      return null;
    },
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {}
  },
  HM = x_.define();
function WM(e) {
  return [JM(), HM.of(Object.assign(Object.assign({}, VM), e))];
}
var UM = x_.define({
  combine: function combine(e) {
    return e.some(function (e) {
      return e;
    });
  }
});
function JM(e) {
  var t = [KM];
  return e && !1 === e.fixed && t.push(UM.of(!0)), t;
}
var KM = mA.fromClass(function () {
  function e(t) {
    Ri(this, e), this.view = t, this.prevViewport = t.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight + "px", this.gutters = t.state.facet(HM).map(function (e) {
      return new ZM(t, e);
    });
    var n,
      r = bi(this.gutters);
    try {
      for (r.s(); !(n = r.n()).done;) {
        var i = n.value;
        this.dom.appendChild(i.dom);
      }
    } catch (e) {
      r.e(e);
    } finally {
      r.f();
    }
    this.fixed = !t.state.facet(UM), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), t.scrollDOM.insertBefore(this.dom, t.contentDOM);
  }
  return zi(e, [{
    key: "update",
    value: function value(e) {
      if (this.updateGutters(e)) {
        var t = this.prevViewport,
          n = e.view.viewport,
          r = Math.min(t.to, n.to) - Math.max(t.from, n.from);
        this.syncGutters(r < .8 * (n.to - n.from));
      }
      e.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight + "px"), this.view.state.facet(UM) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = e.view.viewport;
    }
  }, {
    key: "syncGutters",
    value: function value(e) {
      var t = this,
        n = this.dom.nextSibling;
      e && this.dom.remove();
      var r,
        i = p$.iter(this.view.state.facet(FM), this.view.viewport.from),
        o = [],
        a = this.gutters.map(function (e) {
          return new YM(e, t.view.viewport, -t.view.documentPadding.top);
        }),
        s = bi(this.view.viewportLineBlocks);
      try {
        for (s.s(); !(r = s.n()).done;) {
          var u = r.value,
            c = void 0;
          if (Array.isArray(u.type)) {
            var l,
              f = bi(u.type);
            try {
              for (f.s(); !(l = f.n()).done;) {
                var h = l.value;
                if (h.type == WO.Text) {
                  c = h;
                  break;
                }
              }
            } catch (e) {
              f.e(e);
            } finally {
              f.f();
            }
          } else c = u.type == WO.Text ? u : void 0;
          if (c) {
            o.length && (o = []), QM(i, o, u.from);
            var d,
              v = bi(a);
            try {
              for (v.s(); !(d = v.n()).done;) {
                d.value.line(this.view, c, o);
              }
            } catch (e) {
              v.e(e);
            } finally {
              v.f();
            }
          }
        }
      } catch (e) {
        s.e(e);
      } finally {
        s.f();
      }
      var p,
        m = bi(a);
      try {
        for (m.s(); !(p = m.n()).done;) {
          p.value.finish();
        }
      } catch (e) {
        m.e(e);
      } finally {
        m.f();
      }
      e && this.view.scrollDOM.insertBefore(this.dom, n);
    }
  }, {
    key: "updateGutters",
    value: function value(e) {
      var t = e.startState.facet(HM),
        n = e.state.facet(HM),
        r = e.docChanged || e.heightChanged || e.viewportChanged || !p$.eq(e.startState.facet(FM), e.state.facet(FM), e.view.viewport.from, e.view.viewport.to);
      if (t == n) {
        var i,
          o = bi(this.gutters);
        try {
          for (o.s(); !(i = o.n()).done;) {
            i.value.update(e) && (r = !0);
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
      } else {
        r = !0;
        var a,
          s = [],
          u = bi(n);
        try {
          for (u.s(); !(a = u.n()).done;) {
            var c = a.value,
              l = t.indexOf(c);
            l < 0 ? s.push(new ZM(this.view, c)) : (this.gutters[l].update(e), s.push(this.gutters[l]));
          }
        } catch (e) {
          u.e(e);
        } finally {
          u.f();
        }
        var f,
          h = bi(this.gutters);
        try {
          for (h.s(); !(f = h.n()).done;) {
            var d = f.value;
            d.dom.remove(), s.indexOf(d) < 0 && d.destroy();
          }
        } catch (e) {
          h.e(e);
        } finally {
          h.f();
        }
        for (var v = 0, p = s; v < p.length; v++) {
          var m = p[v];
          this.dom.appendChild(m.dom);
        }
        this.gutters = s;
      }
      return r;
    }
  }, {
    key: "destroy",
    value: function value() {
      var e,
        t = bi(this.gutters);
      try {
        for (t.s(); !(e = t.n()).done;) {
          e.value.destroy();
        }
      } catch (e) {
        t.e(e);
      } finally {
        t.f();
      }
      this.dom.remove();
    }
  }]), e;
}(), {
  provide: function provide(e) {
    return CP.scrollMargins.of(function (t) {
      var n = t.plugin(e);
      return n && 0 != n.gutters.length && n.fixed ? t.textDirection == _A.LTR ? {
        left: n.dom.offsetWidth
      } : {
        right: n.dom.offsetWidth
      } : null;
    });
  }
});
function GM(e) {
  return Array.isArray(e) ? e : [e];
}
function QM(e, t, n) {
  for (; e.value && e.from <= n;) {
    e.from == n && t.push(e.value), e.next();
  }
}
var YM = function () {
    function e(t, n, r) {
      Ri(this, e), this.gutter = t, this.height = r, this.localMarkers = [], this.i = 0, this.cursor = p$.iter(t.markers, n.from);
    }
    return zi(e, [{
      key: "line",
      value: function value(e, t, n) {
        this.localMarkers.length && (this.localMarkers = []), QM(this.cursor, this.localMarkers, t.from);
        var r = n.length ? this.localMarkers.concat(n) : this.localMarkers,
          i = this.gutter.config.lineMarker(e, t, r);
        i && r.unshift(i);
        var o = this.gutter;
        if (0 != r.length || o.config.renderEmptyElements) {
          var a = t.top - this.height;
          if (this.i == o.elements.length) {
            var s = new XM(e, t.height, a, r);
            o.elements.push(s), o.dom.appendChild(s.dom);
          } else o.elements[this.i].update(e, t.height, a, r);
          this.height = t.bottom, this.i++;
        }
      }
    }, {
      key: "finish",
      value: function value() {
        for (var e = this.gutter; e.elements.length > this.i;) {
          var t = e.elements.pop();
          e.dom.removeChild(t.dom), t.destroy();
        }
      }
    }]), e;
  }(),
  ZM = function () {
    function e(t, n) {
      var r = this;
      Ri(this, e), this.view = t, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
      var i = function i(e) {
        r.dom.addEventListener(e, function (r) {
          var i = t.lineBlockAtHeight(r.clientY - t.documentTop);
          n.domEventHandlers[e](t, i, r) && r.preventDefault();
        });
      };
      for (var o in n.domEventHandlers) {
        i(o);
      }
      this.markers = GM(n.markers(t)), n.initialSpacer && (this.spacer = new XM(t, 0, 0, [n.initialSpacer(t)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
    }
    return zi(e, [{
      key: "update",
      value: function value(e) {
        var t = this.markers;
        if (this.markers = GM(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
          var n = this.config.updateSpacer(this.spacer.markers[0], e);
          n != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [n]);
        }
        var r = e.view.viewport;
        return !p$.eq(this.markers, t, r.from, r.to) || !!this.config.lineMarkerChange && this.config.lineMarkerChange(e);
      }
    }, {
      key: "destroy",
      value: function value() {
        var e,
          t = bi(this.elements);
        try {
          for (t.s(); !(e = t.n()).done;) {
            e.value.destroy();
          }
        } catch (e) {
          t.e(e);
        } finally {
          t.f();
        }
      }
    }]), e;
  }(),
  XM = function () {
    function e(t, n, r, i) {
      Ri(this, e), this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(t, n, r, i);
    }
    return zi(e, [{
      key: "update",
      value: function value(e, t, n, r) {
        this.height != t && (this.dom.style.height = (this.height = t) + "px"), this.above != n && (this.dom.style.marginTop = (this.above = n) ? n + "px" : ""), function (e, t) {
          if (e.length != t.length) return !1;
          for (var n = 0; n < e.length; n++) {
            if (!e[n].compare(t[n])) return !1;
          }
          return !0;
        }(this.markers, r) || this.setMarkers(e, r);
      }
    }, {
      key: "setMarkers",
      value: function value(e, t) {
        for (var n = "cm-gutterElement", r = this.dom.firstChild, i = 0, o = 0;;) {
          var a = o,
            s = i < t.length ? t[i++] : null,
            u = !1;
          if (s) {
            var c = s.elementClass;
            c && (n += " " + c);
            for (var l = o; l < this.markers.length; l++) {
              if (this.markers[l].compare(s)) {
                a = l, u = !0;
                break;
              }
            }
          } else a = this.markers.length;
          for (; o < a;) {
            var f = this.markers[o++];
            if (f.toDOM) {
              f.destroy(r);
              var h = r.nextSibling;
              r.remove(), r = h;
            }
          }
          if (!s) break;
          s.toDOM && (u ? r = r.nextSibling : this.dom.insertBefore(s.toDOM(e), r)), u && o++;
        }
        this.dom.className = n, this.markers = t;
      }
    }, {
      key: "destroy",
      value: function value() {
        this.setMarkers(null, []);
      }
    }]), e;
  }();
var eI = x_.define(),
  tI = x_.define({
    combine: function combine(e) {
      return l$(e, {
        formatNumber: String,
        domEventHandlers: {}
      }, {
        domEventHandlers: function domEventHandlers(e, t) {
          var n = Object.assign({}, e),
            r = function r(e) {
              var r = n[e],
                i = t[e];
              n[e] = r ? function (e, t, n) {
                return r(e, t, n) || i(e, t, n);
              } : i;
            };
          for (var i in t) {
            r(i);
          }
          return n;
        }
      });
    }
  }),
  nI = function (e) {
    ji(n, qM);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), (r = t.call(this)).number = e, r;
    }
    return zi(n, [{
      key: "eq",
      value: function value(e) {
        return this.number == e.number;
      }
    }, {
      key: "toDOM",
      value: function value() {
        return document.createTextNode(this.number);
      }
    }]), n;
  }();
function rI(e, t) {
  return e.state.facet(tI).formatNumber(t, e.state);
}
var iI = HM.compute([tI], function (e) {
  return {
    class: "cm-lineNumbers",
    renderEmptyElements: !1,
    markers: function markers(e) {
      return e.state.facet(eI);
    },
    lineMarker: function lineMarker(e, t, n) {
      return n.some(function (e) {
        return e.toDOM;
      }) ? null : new nI(rI(e, e.state.doc.lineAt(t.from).number));
    },
    lineMarkerChange: function lineMarkerChange(e) {
      return e.startState.facet(tI) != e.state.facet(tI);
    },
    initialSpacer: function initialSpacer(e) {
      return new nI(rI(e, aI(e.state.doc.lines)));
    },
    updateSpacer: function updateSpacer(e, t) {
      var n = rI(t.view, aI(t.view.state.doc.lines));
      return n == e.number ? e : new nI(n);
    },
    domEventHandlers: e.facet(tI).domEventHandlers
  };
});
function oI() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return [tI.of(e), JM(), iI];
}
function aI(e) {
  for (var t = 9; t < e;) {
    t = 10 * t + 9;
  }
  return t;
}
var sI = new (function (e) {
    ji(n, qM);
    var t = Ci(n);
    function n() {
      var e;
      return Ri(this, n), (e = t.apply(this, arguments)).elementClass = "cm-activeLineGutter", e;
    }
    return zi(n);
  }())(),
  uI = FM.compute(["selection"], function (e) {
    var t,
      n = [],
      r = -1,
      i = bi(e.selection.ranges);
    try {
      for (i.s(); !(t = i.n()).done;) {
        var o = t.value;
        if (o.empty) {
          var a = e.doc.lineAt(o.head).from;
          a > r && (r = a, n.push(sI.range(a)));
        }
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
    return p$.of(n);
  });
function cI() {
  return uI;
}
var lI = 0,
  fI = zi(function e(t, n) {
    Ri(this, e), this.from = t, this.to = n;
  }),
  hI = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      Ri(this, e), this.id = lI++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || function () {
        throw new Error("This node type doesn't define a deserialize function");
      };
    }
    return zi(e, [{
      key: "add",
      value: function value(e) {
        var t = this;
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        return "function" != typeof e && (e = vI.match(e)), function (n) {
          var r = e(n);
          return void 0 === r ? null : [t, r];
        };
      }
    }]), e;
  }();
hI.closedBy = new hI({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), hI.openedBy = new hI({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), hI.group = new hI({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), hI.contextHash = new hI({
  perNode: !0
}), hI.lookAhead = new hI({
  perNode: !0
}), hI.mounted = new hI({
  perNode: !0
});
var dI = Object.create(null),
  vI = function () {
    function e(t, n, r) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
      Ri(this, e), this.name = t, this.props = n, this.id = r, this.flags = i;
    }
    return zi(e, [{
      key: "prop",
      value: function value(e) {
        return this.props[e.id];
      }
    }, {
      key: "isTop",
      get: function get() {
        return (1 & this.flags) > 0;
      }
    }, {
      key: "isSkipped",
      get: function get() {
        return (2 & this.flags) > 0;
      }
    }, {
      key: "isError",
      get: function get() {
        return (4 & this.flags) > 0;
      }
    }, {
      key: "isAnonymous",
      get: function get() {
        return (8 & this.flags) > 0;
      }
    }, {
      key: "is",
      value: function value(e) {
        if ("string" == typeof e) {
          if (this.name == e) return !0;
          var t = this.prop(hI.group);
          return !!t && t.indexOf(e) > -1;
        }
        return this.id == e;
      }
    }], [{
      key: "define",
      value: function value(t) {
        var n = t.props && t.props.length ? Object.create(null) : dI,
          r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (null == t.name ? 8 : 0),
          i = new e(t.name || "", n, t.id, r);
        if (t.props) {
          var o,
            a = bi(t.props);
          try {
            for (a.s(); !(o = a.n()).done;) {
              var s = o.value;
              if (Array.isArray(s) || (s = s(i)), s) {
                if (s[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                n[s[0].id] = s[1];
              }
            }
          } catch (e) {
            a.e(e);
          } finally {
            a.f();
          }
        }
        return i;
      }
    }, {
      key: "match",
      value: function value(e) {
        var t = Object.create(null);
        for (var n in e) {
          var r,
            i = bi(n.split(" "));
          try {
            for (i.s(); !(r = i.n()).done;) {
              var o = r.value;
              t[o] = e[n];
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        }
        return function (e) {
          for (var n = e.prop(hI.group), r = -1; r < (n ? n.length : 0); r++) {
            var i = t[r < 0 ? e.name : n[r]];
            if (i) return i;
          }
        };
      }
    }]), e;
  }();
vI.none = new vI("", Object.create(null), 0, 8);
var pI,
  mI = new WeakMap(),
  gI = new WeakMap();
!function (e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
}(pI || (pI = {}));
var yI = function () {
  function e(t, n, r, i, o) {
    if (Ri(this, e), this.type = t, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = Object.create(null);
      var a,
        s = bi(o);
      try {
        for (s.s(); !(a = s.n()).done;) {
          var u = xi(a.value, 2),
            c = u[0],
            l = u[1];
          this.props["number" == typeof c ? c : c.id] = l;
        }
      } catch (e) {
        s.e(e);
      } finally {
        s.f();
      }
    }
  }
  return zi(e, [{
    key: "toString",
    value: function value() {
      var e = this.prop(hI.mounted);
      if (e && !e.overlay) return e.tree.toString();
      var t,
        n = "",
        r = bi(this.children);
      try {
        for (r.s(); !(t = r.n()).done;) {
          var i = t.value.toString();
          i && (n && (n += ","), n += i);
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
      return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
    }
  }, {
    key: "cursor",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      return new AI(this.topNode, e);
    }
  }, {
    key: "cursorAt",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = mI.get(this) || this.topNode,
        r = new AI(n);
      return r.moveTo(e, t), mI.set(this, r._tree), r;
    }
  }, {
    key: "topNode",
    get: function get() {
      return new SI(this, 0, 0, null);
    }
  }, {
    key: "resolve",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = jI(mI.get(this) || this.topNode, e, t, !1);
      return mI.set(this, n), n;
    }
  }, {
    key: "resolveInner",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = jI(gI.get(this) || this.topNode, e, t, !0);
      return gI.set(this, n), n;
    }
  }, {
    key: "iterate",
    value: function value(e) {
      for (var t = e.enter, n = e.leave, r = e.from, i = void 0 === r ? 0 : r, o = e.to, a = void 0 === o ? this.length : o, s = this.cursor((e.mode || 0) | pI.IncludeAnonymous);;) {
        var u = !1;
        if (s.from <= a && s.to >= i && (s.type.isAnonymous || !1 !== t(s))) {
          if (s.firstChild()) continue;
          u = !0;
        }
        for (; u && n && !s.type.isAnonymous && n(s), !s.nextSibling();) {
          if (!s.parent()) return;
          u = !0;
        }
      }
    }
  }, {
    key: "prop",
    value: function value(e) {
      return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
    }
  }, {
    key: "propValues",
    get: function get() {
      var e = [];
      if (this.props) for (var t in this.props) {
        e.push([+t, this.props[t]]);
      }
      return e;
    }
  }, {
    key: "balance",
    value: function value() {
      var t = this,
        n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return this.children.length <= 8 ? this : TI(vI.none, this.children, this.positions, 0, this.children.length, 0, this.length, function (n, r, i) {
        return new e(t.type, n, r, i, t.propValues);
      }, n.makeTree || function (t, n, r) {
        return new e(vI.none, t, n, r);
      });
    }
  }], [{
    key: "build",
    value: function value(e) {
      return PI(e);
    }
  }]), e;
}();
yI.empty = new yI(vI.none, [], [], 0);
var bI = function () {
    function e(t, n) {
      Ri(this, e), this.buffer = t, this.index = n;
    }
    return zi(e, [{
      key: "id",
      get: function get() {
        return this.buffer[this.index - 4];
      }
    }, {
      key: "start",
      get: function get() {
        return this.buffer[this.index - 3];
      }
    }, {
      key: "end",
      get: function get() {
        return this.buffer[this.index - 2];
      }
    }, {
      key: "size",
      get: function get() {
        return this.buffer[this.index - 1];
      }
    }, {
      key: "pos",
      get: function get() {
        return this.index;
      }
    }, {
      key: "next",
      value: function value() {
        this.index -= 4;
      }
    }, {
      key: "fork",
      value: function value() {
        return new e(this.buffer, this.index);
      }
    }]), e;
  }(),
  kI = function () {
    function e(t, n, r) {
      Ri(this, e), this.buffer = t, this.length = n, this.set = r;
    }
    return zi(e, [{
      key: "type",
      get: function get() {
        return vI.none;
      }
    }, {
      key: "toString",
      value: function value() {
        for (var e = [], t = 0; t < this.buffer.length;) {
          e.push(this.childString(t)), t = this.buffer[t + 3];
        }
        return e.join(",");
      }
    }, {
      key: "childString",
      value: function value(e) {
        var t = this.buffer[e],
          n = this.buffer[e + 3],
          r = this.set.types[t],
          i = r.name;
        if (/\W/.test(i) && !r.isError && (i = JSON.stringify(i)), n == (e += 4)) return i;
        for (var o = []; e < n;) {
          o.push(this.childString(e)), e = this.buffer[e + 3];
        }
        return i + "(" + o.join(",") + ")";
      }
    }, {
      key: "findChild",
      value: function value(e, t, n, r, i) {
        for (var o = this.buffer, a = -1, s = e; s != t && !(wI(i, r, o[s + 1], o[s + 2]) && (a = s, n > 0)); s = o[s + 3]) {
          ;
        }
        return a;
      }
    }, {
      key: "slice",
      value: function value(t, n, r, i) {
        for (var o = this.buffer, a = new Uint16Array(n - t), s = t, u = 0; s < n;) {
          a[u++] = o[s++], a[u++] = o[s++] - r, a[u++] = o[s++] - r, a[u++] = o[s++] - t;
        }
        return new e(a, i - r, this.set);
      }
    }]), e;
  }();
function wI(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function xI(e, t) {
  for (var n = e.childBefore(t); n;) {
    var r = n.lastChild;
    if (!r || r.to != n.to) break;
    r.type.isError && r.from == r.to ? (e = n, n = r.prevSibling) : n = r;
  }
  return e;
}
function jI(e, t, n, r) {
  for (var i; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t);) {
    var o = !r && e instanceof SI && e.index < 0 ? null : e.parent;
    if (!o) return e;
    e = o;
  }
  var a = r ? 0 : pI.IgnoreOverlays;
  if (r) for (var s = e, u = s.parent; u; u = (s = u).parent) {
    s instanceof SI && s.index < 0 && (null === (i = u.enter(t, n, a)) || void 0 === i ? void 0 : i.from) != s.from && (e = u);
  }
  for (;;) {
    var c = e.enter(t, n, a);
    if (!c) return e;
    e = c;
  }
}
var SI = function () {
  function e(t, n, r, i) {
    Ri(this, e), this._tree = t, this.from = n, this.index = r, this._parent = i;
  }
  return zi(e, [{
    key: "type",
    get: function get() {
      return this._tree.type;
    }
  }, {
    key: "name",
    get: function get() {
      return this._tree.type.name;
    }
  }, {
    key: "to",
    get: function get() {
      return this.from + this._tree.length;
    }
  }, {
    key: "nextChild",
    value: function value(t, n, r, i) {
      for (var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = this;;) {
        for (var s = a._tree, u = s.children, c = s.positions, l = n > 0 ? u.length : -1; t != l; t += n) {
          var f = u[t],
            h = c[t] + a.from;
          if (wI(i, r, h, h + f.length)) if (f instanceof kI) {
            if (o & pI.ExcludeBuffers) continue;
            var d = f.findChild(0, f.buffer.length, n, r - h, i);
            if (d > -1) return new OI(new $I(a, f, t, h), null, d);
          } else if (o & pI.IncludeAnonymous || !f.type.isAnonymous || EI(f)) {
            var v = void 0;
            if (!(o & pI.IgnoreMounts) && f.props && (v = f.prop(hI.mounted)) && !v.overlay) return new e(v.tree, h, t, a);
            var p = new e(f, h, t, a);
            return o & pI.IncludeAnonymous || !p.type.isAnonymous ? p : p.nextChild(n < 0 ? f.children.length - 1 : 0, n, r, i);
          }
        }
        if (o & pI.IncludeAnonymous || !a.type.isAnonymous) return null;
        if (t = a.index >= 0 ? a.index + n : n < 0 ? -1 : a._parent._tree.children.length, !(a = a._parent)) return null;
      }
    }
  }, {
    key: "firstChild",
    get: function get() {
      return this.nextChild(0, 1, 0, 4);
    }
  }, {
    key: "lastChild",
    get: function get() {
      return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
    }
  }, {
    key: "childAfter",
    value: function value(e) {
      return this.nextChild(0, 1, e, 2);
    }
  }, {
    key: "childBefore",
    value: function value(e) {
      return this.nextChild(this._tree.children.length - 1, -1, e, -2);
    }
  }, {
    key: "enter",
    value: function value(t, n) {
      var r,
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
      if (!(i & pI.IgnoreOverlays) && (r = this._tree.prop(hI.mounted)) && r.overlay) {
        var o,
          a = t - this.from,
          s = bi(r.overlay);
        try {
          for (s.s(); !(o = s.n()).done;) {
            var u = o.value,
              c = u.from,
              l = u.to;
            if ((n > 0 ? c <= a : c < a) && (n < 0 ? l >= a : l > a)) return new e(r.tree, r.overlay[0].from + this.from, -1, this);
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
      }
      return this.nextChild(0, 1, t, n, i);
    }
  }, {
    key: "nextSignificantParent",
    value: function value() {
      for (var e = this; e.type.isAnonymous && e._parent;) {
        e = e._parent;
      }
      return e;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent ? this._parent.nextSignificantParent() : null;
    }
  }, {
    key: "nextSibling",
    get: function get() {
      return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
    }
  }, {
    key: "prevSibling",
    get: function get() {
      return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
    }
  }, {
    key: "cursor",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      return new AI(this, e);
    }
  }, {
    key: "tree",
    get: function get() {
      return this._tree;
    }
  }, {
    key: "toTree",
    value: function value() {
      return this._tree;
    }
  }, {
    key: "resolve",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return jI(this, e, t, !1);
    }
  }, {
    key: "resolveInner",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return jI(this, e, t, !0);
    }
  }, {
    key: "enterUnfinishedNodesBefore",
    value: function value(e) {
      return xI(this, e);
    }
  }, {
    key: "getChild",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
        r = CI(this, e, t, n);
      return r.length ? r[0] : null;
    }
  }, {
    key: "getChildren",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
      return CI(this, e, t, n);
    }
  }, {
    key: "toString",
    value: function value() {
      return this._tree.toString();
    }
  }, {
    key: "node",
    get: function get() {
      return this;
    }
  }, {
    key: "matchContext",
    value: function value(e) {
      return _I(this, e);
    }
  }]), e;
}();
function CI(e, t, n, r) {
  var i = e.cursor(),
    o = [];
  if (!i.firstChild()) return o;
  if (null != n) for (; !i.type.is(n);) {
    if (!i.nextSibling()) return o;
  }
  for (;;) {
    if (null != r && i.type.is(r)) return o;
    if (i.type.is(t) && o.push(i.node), !i.nextSibling()) return null == r ? o : [];
  }
}
function _I(e, t) {
  for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length - 1, r = e.parent; n >= 0; r = r.parent) {
    if (!r) return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name) return !1;
      n--;
    }
  }
  return !0;
}
var $I = zi(function e(t, n, r, i) {
    Ri(this, e), this.parent = t, this.buffer = n, this.index = r, this.start = i;
  }),
  OI = function () {
    function e(t, n, r) {
      Ri(this, e), this.context = t, this._parent = n, this.index = r, this.type = t.buffer.set.types[t.buffer.buffer[r]];
    }
    return zi(e, [{
      key: "name",
      get: function get() {
        return this.type.name;
      }
    }, {
      key: "from",
      get: function get() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
      }
    }, {
      key: "to",
      get: function get() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
      }
    }, {
      key: "child",
      value: function value(t, n, r) {
        var i = this.context.buffer,
          o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
        return o < 0 ? null : new e(this.context, this, o);
      }
    }, {
      key: "firstChild",
      get: function get() {
        return this.child(1, 0, 4);
      }
    }, {
      key: "lastChild",
      get: function get() {
        return this.child(-1, 0, 4);
      }
    }, {
      key: "childAfter",
      value: function value(e) {
        return this.child(1, e, 2);
      }
    }, {
      key: "childBefore",
      value: function value(e) {
        return this.child(-1, e, -2);
      }
    }, {
      key: "enter",
      value: function value(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        if (r & pI.ExcludeBuffers) return null;
        var i = this.context.buffer,
          o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
        return o < 0 ? null : new e(this.context, this, o);
      }
    }, {
      key: "parent",
      get: function get() {
        return this._parent || this.context.parent.nextSignificantParent();
      }
    }, {
      key: "externalSibling",
      value: function value(e) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + e, e, 0, 4);
      }
    }, {
      key: "nextSibling",
      get: function get() {
        var t = this.context.buffer,
          n = t.buffer[this.index + 3];
        return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new e(this.context, this._parent, n) : this.externalSibling(1);
      }
    }, {
      key: "prevSibling",
      get: function get() {
        var t = this.context.buffer,
          n = this._parent ? this._parent.index + 4 : 0;
        return this.index == n ? this.externalSibling(-1) : new e(this.context, this._parent, t.findChild(n, this.index, -1, 0, 4));
      }
    }, {
      key: "cursor",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
        return new AI(this, e);
      }
    }, {
      key: "tree",
      get: function get() {
        return null;
      }
    }, {
      key: "toTree",
      value: function value() {
        var e = [],
          t = [],
          n = this.context.buffer,
          r = this.index + 4,
          i = n.buffer[this.index + 3];
        if (i > r) {
          var o = n.buffer[this.index + 1],
            a = n.buffer[this.index + 2];
          e.push(n.slice(r, i, o, a)), t.push(0);
        }
        return new yI(this.type, e, t, this.to - this.from);
      }
    }, {
      key: "resolve",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return jI(this, e, t, !1);
      }
    }, {
      key: "resolveInner",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return jI(this, e, t, !0);
      }
    }, {
      key: "enterUnfinishedNodesBefore",
      value: function value(e) {
        return xI(this, e);
      }
    }, {
      key: "toString",
      value: function value() {
        return this.context.buffer.childString(this.index);
      }
    }, {
      key: "getChild",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          r = CI(this, e, t, n);
        return r.length ? r[0] : null;
      }
    }, {
      key: "getChildren",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        return CI(this, e, t, n);
      }
    }, {
      key: "node",
      get: function get() {
        return this;
      }
    }, {
      key: "matchContext",
      value: function value(e) {
        return _I(this, e);
      }
    }]), e;
  }(),
  AI = function () {
    function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      if (Ri(this, e), this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof SI) this.yieldNode(t);else {
        this._tree = t.context.parent, this.buffer = t.context;
        for (var r = t._parent; r; r = r._parent) {
          this.stack.unshift(r.index);
        }
        this.bufferNode = t, this.yieldBuf(t.index);
      }
    }
    return zi(e, [{
      key: "name",
      get: function get() {
        return this.type.name;
      }
    }, {
      key: "yieldNode",
      value: function value(e) {
        return !!e && (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0);
      }
    }, {
      key: "yieldBuf",
      value: function value(e, t) {
        this.index = e;
        var n = this.buffer,
          r = n.start,
          i = n.buffer;
        return this.type = t || i.set.types[i.buffer[e]], this.from = r + i.buffer[e + 1], this.to = r + i.buffer[e + 2], !0;
      }
    }, {
      key: "yield",
      value: function value(e) {
        return !!e && (e instanceof SI ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)));
      }
    }, {
      key: "toString",
      value: function value() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
      }
    }, {
      key: "enterChild",
      value: function value(e, t, n) {
        if (!this.buffer) return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, t, n, this.mode));
        var r = this.buffer.buffer,
          i = r.findChild(this.index + 4, r.buffer[this.index + 3], e, t - this.buffer.start, n);
        return !(i < 0) && (this.stack.push(this.index), this.yieldBuf(i));
      }
    }, {
      key: "firstChild",
      value: function value() {
        return this.enterChild(1, 0, 4);
      }
    }, {
      key: "lastChild",
      value: function value() {
        return this.enterChild(-1, 0, 4);
      }
    }, {
      key: "childAfter",
      value: function value(e) {
        return this.enterChild(1, e, 2);
      }
    }, {
      key: "childBefore",
      value: function value(e) {
        return this.enterChild(-1, e, -2);
      }
    }, {
      key: "enter",
      value: function value(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.mode;
        return this.buffer ? !(n & pI.ExcludeBuffers) && this.enterChild(1, e, t) : this.yield(this._tree.enter(e, t, n));
      }
    }, {
      key: "parent",
      value: function value() {
        if (!this.buffer) return this.yieldNode(this.mode & pI.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        var e = this.mode & pI.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        return this.buffer = null, this.yieldNode(e);
      }
    }, {
      key: "sibling",
      value: function value(e) {
        if (!this.buffer) return !!this._tree._parent && this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode));
        var t = this.buffer.buffer,
          n = this.stack.length - 1;
        if (e < 0) {
          var r = n < 0 ? 0 : this.stack[n] + 4;
          if (this.index != r) return this.yieldBuf(t.findChild(r, this.index, -1, 0, 4));
        } else {
          var i = t.buffer[this.index + 3];
          if (i < (n < 0 ? t.buffer.length : t.buffer[this.stack[n] + 3])) return this.yieldBuf(i);
        }
        return n < 0 && this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode));
      }
    }, {
      key: "nextSibling",
      value: function value() {
        return this.sibling(1);
      }
    }, {
      key: "prevSibling",
      value: function value() {
        return this.sibling(-1);
      }
    }, {
      key: "atLastNode",
      value: function value(e) {
        var t,
          n,
          r = this.buffer;
        if (r) {
          if (e > 0) {
            if (this.index < r.buffer.buffer.length) return !1;
          } else for (var i = 0; i < this.index; i++) {
            if (r.buffer.buffer[i + 3] < this.index) return !1;
          }
          t = r.index, n = r.parent;
        } else {
          var o = this._tree;
          t = o.index, n = o._parent;
        }
        for (; n; t = (a = n).index, n = a._parent, a) {
          var a;
          if (t > -1) for (var s = t + e, u = e < 0 ? -1 : n._tree.children.length; s != u; s += e) {
            var c = n._tree.children[s];
            if (this.mode & pI.IncludeAnonymous || c instanceof kI || !c.type.isAnonymous || EI(c)) return !1;
          }
        }
        return !0;
      }
    }, {
      key: "move",
      value: function value(e, t) {
        if (t && this.enterChild(e, 0, 4)) return !0;
        for (;;) {
          if (this.sibling(e)) return !0;
          if (this.atLastNode(e) || !this.parent()) return !1;
        }
      }
    }, {
      key: "next",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        return this.move(1, e);
      }
    }, {
      key: "prev",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        return this.move(-1, e);
      }
    }, {
      key: "moveTo",
      value: function value(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0; (this.from == this.to || (t < 1 ? this.from >= e : this.from > e) || (t > -1 ? this.to <= e : this.to < e)) && this.parent();) {
          ;
        }
        for (; this.enterChild(1, e, t);) {
          ;
        }
        return this;
      }
    }, {
      key: "node",
      get: function get() {
        if (!this.buffer) return this._tree;
        var e = this.bufferNode,
          t = null,
          n = 0;
        if (e && e.context == this.buffer) e: for (var r = this.index, i = this.stack.length; i >= 0;) {
          for (var o = e; o; o = o._parent) {
            if (o.index == r) {
              if (r == this.index) return o;
              t = o, n = i + 1;
              break e;
            }
          }
          r = this.stack[--i];
        }
        for (var a = n; a < this.stack.length; a++) {
          t = new OI(this.buffer, t, this.stack[a]);
        }
        return this.bufferNode = new OI(this.buffer, t, this.index);
      }
    }, {
      key: "tree",
      get: function get() {
        return this.buffer ? null : this._tree._tree;
      }
    }, {
      key: "iterate",
      value: function value(e, t) {
        for (var n = 0;;) {
          var r = !1;
          if (this.type.isAnonymous || !1 !== e(this)) {
            if (this.firstChild()) {
              n++;
              continue;
            }
            this.type.isAnonymous || (r = !0);
          }
          for (; r && t && t(this), r = this.type.isAnonymous, !this.nextSibling();) {
            if (!n) return;
            this.parent(), n--, r = !0;
          }
        }
      }
    }, {
      key: "matchContext",
      value: function value(e) {
        if (!this.buffer) return _I(this.node, e);
        for (var t = this.buffer.buffer, n = t.set.types, r = e.length - 1, i = this.stack.length - 1; r >= 0; i--) {
          if (i < 0) return _I(this.node, e, r);
          var o = n[t.buffer[this.stack[i]]];
          if (!o.isAnonymous) {
            if (e[r] && e[r] != o.name) return !1;
            r--;
          }
        }
        return !0;
      }
    }]), e;
  }();
function EI(e) {
  return e.children.some(function (e) {
    return e instanceof kI || !e.type.isAnonymous || EI(e);
  });
}
function PI(e) {
  var t,
    n = e.buffer,
    r = e.nodeSet,
    i = e.maxBufferLength,
    o = void 0 === i ? 1024 : i,
    a = e.reused,
    s = void 0 === a ? [] : a,
    u = e.minRepeatType,
    c = void 0 === u ? r.types.length : u,
    l = Array.isArray(n) ? new bI(n, n.length) : n,
    f = r.types,
    h = 0,
    d = 0;
  function v(e, t, n, i, a) {
    for (var u = l.id, y = l.start, b = l.end, k = l.size, w = d; k < 0;) {
      if (l.next(), -1 == k) {
        var x = s[u];
        return n.push(x), void i.push(y - e);
      }
      if (-3 == k) return void (h = u);
      if (-4 == k) return void (d = u);
      throw new RangeError("Unrecognized record size: ".concat(k));
    }
    var j,
      S,
      C = f[u],
      _ = y - e;
    if (b - y <= o && (S = function (e, t) {
      var n = l.fork(),
        r = 0,
        i = 0,
        a = 0,
        s = n.end - o,
        u = {
          size: 0,
          start: 0,
          skip: 0
        };
      e: for (var f = n.pos - e; n.pos > f;) {
        var h = n.size;
        if (n.id == t && h >= 0) u.size = r, u.start = i, u.skip = a, a += 4, r += 4, n.next();else {
          var d = n.pos - h;
          if (h < 0 || d < f || n.start < s) break;
          var v = n.id >= c ? 4 : 0,
            p = n.start;
          for (n.next(); n.pos > d;) {
            if (n.size < 0) {
              if (-3 != n.size) break e;
              v += 4;
            } else n.id >= c && (v += 4);
            n.next();
          }
          i = p, r += h, a += v;
        }
      }
      (t < 0 || r == e) && (u.size = r, u.start = i, u.skip = a);
      return u.size > 4 ? u : void 0;
    }(l.pos - t, a))) {
      for (var $ = new Uint16Array(S.size - S.skip), O = l.pos - S.size, A = $.length; l.pos > O;) {
        A = g(S.start, $, A);
      }
      j = new kI($, b - S.start, r), _ = S.start - e;
    } else {
      var E = l.pos - k;
      l.next();
      for (var P = [], M = [], I = u >= c ? u : -1, T = 0, N = b; l.pos > E;) {
        I >= 0 && l.id == I && l.size >= 0 ? (l.end <= N - o && (p(P, M, y, T, l.end, N, I, w), T = P.length, N = l.end), l.next()) : v(y, E, P, M, I);
      }
      if (I >= 0 && T > 0 && T < P.length && p(P, M, y, T, y, N, I, w), P.reverse(), M.reverse(), I > -1 && T > 0) {
        var R = function (e) {
          return function (t, n, r) {
            var i,
              o,
              a = 0,
              s = t.length - 1;
            if (s >= 0 && (i = t[s]) instanceof yI) {
              if (!s && i.type == e && i.length == r) return i;
              (o = i.prop(hI.lookAhead)) && (a = n[s] + i.length + o);
            }
            return m(e, t, n, r, a);
          };
        }(C);
        j = TI(C, P, M, 0, P.length, 0, b - y, R, R);
      } else j = m(C, P, M, b - y, w - b);
    }
    n.push(j), i.push(_);
  }
  function p(e, t, n, i, o, a, s, u) {
    for (var c = [], l = []; e.length > i;) {
      c.push(e.pop()), l.push(t.pop() + n - o);
    }
    e.push(m(r.types[s], c, l, a - o, u - a)), t.push(o - n);
  }
  function m(e, t, n, r) {
    var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
      o = arguments.length > 5 ? arguments[5] : void 0;
    if (h) {
      var a = [hI.contextHash, h];
      o = o ? [a].concat(o) : [a];
    }
    if (i > 25) {
      var s = [hI.lookAhead, i];
      o = o ? [s].concat(o) : [s];
    }
    return new yI(e, t, n, r, o);
  }
  function g(e, t, n) {
    var r = l.id,
      i = l.start,
      o = l.end,
      a = l.size;
    if (l.next(), a >= 0 && r < c) {
      var s = n;
      if (a > 4) for (var u = l.pos - (a - 4); l.pos > u;) {
        n = g(e, t, n);
      }
      t[--n] = s, t[--n] = o - e, t[--n] = i - e, t[--n] = r;
    } else -3 == a ? h = r : -4 == a && (d = r);
    return n;
  }
  for (var y = [], b = []; l.pos > 0;) {
    v(e.start || 0, e.bufferStart || 0, y, b, -1);
  }
  var k = null !== (t = e.length) && void 0 !== t ? t : y.length ? b[0] + y[0].length : 0;
  return new yI(f[e.topID], y.reverse(), b.reverse(), k);
}
var MI = new WeakMap();
function II(e, t) {
  if (!e.isAnonymous || t instanceof kI || t.type != e) return 1;
  var n = MI.get(t);
  if (null == n) {
    n = 1;
    var r,
      i = bi(t.children);
    try {
      for (i.s(); !(r = i.n()).done;) {
        var o = r.value;
        if (o.type != e || !(o instanceof yI)) {
          n = 1;
          break;
        }
        n += II(e, o);
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
    MI.set(t, n);
  }
  return n;
}
function TI(e, t, n, r, i, o, a, s, u) {
  for (var c = 0, l = r; l < i; l++) {
    c += II(e, t[l]);
  }
  var f = Math.ceil(1.5 * c / 8),
    h = [],
    d = [];
  return function t(n, r, i, a, s) {
    for (var c = i; c < a;) {
      var l = c,
        v = r[c],
        p = II(e, n[c]);
      for (c++; c < a; c++) {
        var m = II(e, n[c]);
        if (p + m >= f) break;
        p += m;
      }
      if (c == l + 1) {
        if (p > f) {
          var g = n[l];
          t(g.children, g.positions, 0, g.children.length, r[l] + s);
          continue;
        }
        h.push(n[l]);
      } else {
        var y = r[c - 1] + n[c - 1].length - v;
        h.push(TI(e, n, r, l, c, v, y, null, u));
      }
      d.push(v + s - o);
    }
  }(t, n, r, i, 0), (s || u)(h, d, a);
}
var NI = function () {
    function e(t, n, r, i) {
      var o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
        a = arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
      Ri(this, e), this.from = t, this.to = n, this.tree = r, this.offset = i, this.open = (o ? 1 : 0) | (a ? 2 : 0);
    }
    return zi(e, [{
      key: "openStart",
      get: function get() {
        return (1 & this.open) > 0;
      }
    }, {
      key: "openEnd",
      get: function get() {
        return (2 & this.open) > 0;
      }
    }], [{
      key: "addTree",
      value: function value(t) {
        var n,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
          i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          o = [new e(0, t.length, t, 0, !1, i)],
          a = bi(r);
        try {
          for (a.s(); !(n = a.n()).done;) {
            var s = n.value;
            s.to > t.length && o.push(s);
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
        return o;
      }
    }, {
      key: "applyChanges",
      value: function value(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 128;
        if (!n.length) return t;
        for (var i = [], o = 1, a = t.length ? t[0] : null, s = 0, u = 0, c = 0;; s++) {
          var l = s < n.length ? n[s] : null,
            f = l ? l.fromA : 1e9;
          if (f - u >= r) for (; a && a.from < f;) {
            var h = a;
            if (u >= h.from || f <= h.to || c) {
              var d = Math.max(h.from, u) - c,
                v = Math.min(h.to, f) - c;
              h = d >= v ? null : new e(d, v, h.tree, h.offset + c, s > 0, !!l);
            }
            if (h && i.push(h), a.to > f) break;
            a = o < t.length ? t[o++] : null;
          }
          if (!l) break;
          u = l.toA, c = l.toA - l.toB;
        }
        return i;
      }
    }]), e;
  }(),
  RI = function () {
    function e() {
      Ri(this, e);
    }
    return zi(e, [{
      key: "startParse",
      value: function value(e, t, n) {
        return "string" == typeof e && (e = new DI(e)), n = n ? n.length ? n.map(function (e) {
          return new fI(e.from, e.to);
        }) : [new fI(0, 0)] : [new fI(0, e.length)], this.createParse(e, t || [], n);
      }
    }, {
      key: "parse",
      value: function value(e, t, n) {
        for (var r = this.startParse(e, t, n);;) {
          var i = r.advance();
          if (i) return i;
        }
      }
    }]), e;
  }(),
  DI = function () {
    function e(t) {
      Ri(this, e), this.string = t;
    }
    return zi(e, [{
      key: "length",
      get: function get() {
        return this.string.length;
      }
    }, {
      key: "chunk",
      value: function value(e) {
        return this.string.slice(e);
      }
    }, {
      key: "lineChunks",
      get: function get() {
        return !1;
      }
    }, {
      key: "read",
      value: function value(e, t) {
        return this.string.slice(e, t);
      }
    }]), e;
  }();
new hI({
  perNode: !0
});
var zI = 0,
  LI = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      Ri(this, e), this.id = zI++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || function () {
        throw new Error("This node type doesn't define a deserialize function");
      };
    }
    return zi(e, [{
      key: "add",
      value: function value(e) {
        var t = this;
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        return "function" != typeof e && (e = qI.match(e)), function (n) {
          var r = e(n);
          return void 0 === r ? null : [t, r];
        };
      }
    }]), e;
  }();
LI.closedBy = new LI({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), LI.openedBy = new LI({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), LI.group = new LI({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), LI.contextHash = new LI({
  perNode: !0
}), LI.lookAhead = new LI({
  perNode: !0
}), LI.mounted = new LI({
  perNode: !0
});
var BI = Object.create(null),
  qI = function () {
    function e(t, n, r) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
      Ri(this, e), this.name = t, this.props = n, this.id = r, this.flags = i;
    }
    return zi(e, [{
      key: "prop",
      value: function value(e) {
        return this.props[e.id];
      }
    }, {
      key: "isTop",
      get: function get() {
        return (1 & this.flags) > 0;
      }
    }, {
      key: "isSkipped",
      get: function get() {
        return (2 & this.flags) > 0;
      }
    }, {
      key: "isError",
      get: function get() {
        return (4 & this.flags) > 0;
      }
    }, {
      key: "isAnonymous",
      get: function get() {
        return (8 & this.flags) > 0;
      }
    }, {
      key: "is",
      value: function value(e) {
        if ("string" == typeof e) {
          if (this.name == e) return !0;
          var t = this.prop(LI.group);
          return !!t && t.indexOf(e) > -1;
        }
        return this.id == e;
      }
    }], [{
      key: "define",
      value: function value(t) {
        var n = t.props && t.props.length ? Object.create(null) : BI,
          r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (null == t.name ? 8 : 0),
          i = new e(t.name || "", n, t.id, r);
        if (t.props) {
          var o,
            a = bi(t.props);
          try {
            for (a.s(); !(o = a.n()).done;) {
              var s = o.value;
              if (Array.isArray(s) || (s = s(i)), s) {
                if (s[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                n[s[0].id] = s[1];
              }
            }
          } catch (e) {
            a.e(e);
          } finally {
            a.f();
          }
        }
        return i;
      }
    }, {
      key: "match",
      value: function value(e) {
        var t = Object.create(null);
        for (var n in e) {
          var r,
            i = bi(n.split(" "));
          try {
            for (i.s(); !(r = i.n()).done;) {
              var o = r.value;
              t[o] = e[n];
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        }
        return function (e) {
          for (var n = e.prop(LI.group), r = -1; r < (n ? n.length : 0); r++) {
            var i = t[r < 0 ? e.name : n[r]];
            if (i) return i;
          }
        };
      }
    }]), e;
  }();
qI.none = new qI("", Object.create(null), 0, 8);
var FI,
  VI = new WeakMap(),
  HI = new WeakMap();
!function (e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
}(FI || (FI = {}));
var WI = function () {
  function e(t, n, r, i, o) {
    if (Ri(this, e), this.type = t, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = Object.create(null);
      var a,
        s = bi(o);
      try {
        for (s.s(); !(a = s.n()).done;) {
          var u = xi(a.value, 2),
            c = u[0],
            l = u[1];
          this.props["number" == typeof c ? c : c.id] = l;
        }
      } catch (e) {
        s.e(e);
      } finally {
        s.f();
      }
    }
  }
  return zi(e, [{
    key: "toString",
    value: function value() {
      var e = this.prop(LI.mounted);
      if (e && !e.overlay) return e.tree.toString();
      var t,
        n = "",
        r = bi(this.children);
      try {
        for (r.s(); !(t = r.n()).done;) {
          var i = t.value.toString();
          i && (n && (n += ","), n += i);
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
      return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
    }
  }, {
    key: "cursor",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      return new nT(this.topNode, e);
    }
  }, {
    key: "cursorAt",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = VI.get(this) || this.topNode,
        r = new nT(n);
      return r.moveTo(e, t), VI.set(this, r._tree), r;
    }
  }, {
    key: "topNode",
    get: function get() {
      return new YI(this, 0, 0, null);
    }
  }, {
    key: "resolve",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = QI(VI.get(this) || this.topNode, e, t, !1);
      return VI.set(this, n), n;
    }
  }, {
    key: "resolveInner",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = QI(HI.get(this) || this.topNode, e, t, !0);
      return HI.set(this, n), n;
    }
  }, {
    key: "iterate",
    value: function value(e) {
      for (var t = e.enter, n = e.leave, r = e.from, i = void 0 === r ? 0 : r, o = e.to, a = void 0 === o ? this.length : o, s = this.cursor((e.mode || 0) | FI.IncludeAnonymous);;) {
        var u = !1;
        if (s.from <= a && s.to >= i && (s.type.isAnonymous || !1 !== t(s))) {
          if (s.firstChild()) continue;
          u = !0;
        }
        for (; u && n && !s.type.isAnonymous && n(s), !s.nextSibling();) {
          if (!s.parent()) return;
          u = !0;
        }
      }
    }
  }, {
    key: "prop",
    value: function value(e) {
      return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
    }
  }, {
    key: "propValues",
    get: function get() {
      var e = [];
      if (this.props) for (var t in this.props) {
        e.push([+t, this.props[t]]);
      }
      return e;
    }
  }, {
    key: "balance",
    value: function value() {
      var t = this,
        n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return this.children.length <= 8 ? this : sT(qI.none, this.children, this.positions, 0, this.children.length, 0, this.length, function (n, r, i) {
        return new e(t.type, n, r, i, t.propValues);
      }, n.makeTree || function (t, n, r) {
        return new e(qI.none, t, n, r);
      });
    }
  }], [{
    key: "build",
    value: function value(e) {
      return iT(e);
    }
  }]), e;
}();
WI.empty = new WI(qI.none, [], [], 0);
var UI = function () {
    function e(t, n) {
      Ri(this, e), this.buffer = t, this.index = n;
    }
    return zi(e, [{
      key: "id",
      get: function get() {
        return this.buffer[this.index - 4];
      }
    }, {
      key: "start",
      get: function get() {
        return this.buffer[this.index - 3];
      }
    }, {
      key: "end",
      get: function get() {
        return this.buffer[this.index - 2];
      }
    }, {
      key: "size",
      get: function get() {
        return this.buffer[this.index - 1];
      }
    }, {
      key: "pos",
      get: function get() {
        return this.index;
      }
    }, {
      key: "next",
      value: function value() {
        this.index -= 4;
      }
    }, {
      key: "fork",
      value: function value() {
        return new e(this.buffer, this.index);
      }
    }]), e;
  }(),
  JI = function () {
    function e(t, n, r) {
      Ri(this, e), this.buffer = t, this.length = n, this.set = r;
    }
    return zi(e, [{
      key: "type",
      get: function get() {
        return qI.none;
      }
    }, {
      key: "toString",
      value: function value() {
        for (var e = [], t = 0; t < this.buffer.length;) {
          e.push(this.childString(t)), t = this.buffer[t + 3];
        }
        return e.join(",");
      }
    }, {
      key: "childString",
      value: function value(e) {
        var t = this.buffer[e],
          n = this.buffer[e + 3],
          r = this.set.types[t],
          i = r.name;
        if (/\W/.test(i) && !r.isError && (i = JSON.stringify(i)), n == (e += 4)) return i;
        for (var o = []; e < n;) {
          o.push(this.childString(e)), e = this.buffer[e + 3];
        }
        return i + "(" + o.join(",") + ")";
      }
    }, {
      key: "findChild",
      value: function value(e, t, n, r, i) {
        for (var o = this.buffer, a = -1, s = e; s != t && !(KI(i, r, o[s + 1], o[s + 2]) && (a = s, n > 0)); s = o[s + 3]) {
          ;
        }
        return a;
      }
    }, {
      key: "slice",
      value: function value(t, n, r, i) {
        for (var o = this.buffer, a = new Uint16Array(n - t), s = t, u = 0; s < n;) {
          a[u++] = o[s++], a[u++] = o[s++] - r, a[u++] = o[s++] - r, a[u++] = o[s++] - t;
        }
        return new e(a, i - r, this.set);
      }
    }]), e;
  }();
function KI(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function GI(e, t) {
  for (var n = e.childBefore(t); n;) {
    var r = n.lastChild;
    if (!r || r.to != n.to) break;
    r.type.isError && r.from == r.to ? (e = n, n = r.prevSibling) : n = r;
  }
  return e;
}
function QI(e, t, n, r) {
  for (var i; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t);) {
    var o = !r && e instanceof YI && e.index < 0 ? null : e.parent;
    if (!o) return e;
    e = o;
  }
  var a = r ? 0 : FI.IgnoreOverlays;
  if (r) for (var s = e, u = s.parent; u; u = (s = u).parent) {
    s instanceof YI && s.index < 0 && (null === (i = u.enter(t, n, a)) || void 0 === i ? void 0 : i.from) != s.from && (e = u);
  }
  for (;;) {
    var c = e.enter(t, n, a);
    if (!c) return e;
    e = c;
  }
}
var YI = function () {
  function e(t, n, r, i) {
    Ri(this, e), this._tree = t, this.from = n, this.index = r, this._parent = i;
  }
  return zi(e, [{
    key: "type",
    get: function get() {
      return this._tree.type;
    }
  }, {
    key: "name",
    get: function get() {
      return this._tree.type.name;
    }
  }, {
    key: "to",
    get: function get() {
      return this.from + this._tree.length;
    }
  }, {
    key: "nextChild",
    value: function value(t, n, r, i) {
      for (var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = this;;) {
        for (var s = a._tree, u = s.children, c = s.positions, l = n > 0 ? u.length : -1; t != l; t += n) {
          var f = u[t],
            h = c[t] + a.from;
          if (KI(i, r, h, h + f.length)) if (f instanceof JI) {
            if (o & FI.ExcludeBuffers) continue;
            var d = f.findChild(0, f.buffer.length, n, r - h, i);
            if (d > -1) return new tT(new eT(a, f, t, h), null, d);
          } else if (o & FI.IncludeAnonymous || !f.type.isAnonymous || rT(f)) {
            var v = void 0;
            if (!(o & FI.IgnoreMounts) && f.props && (v = f.prop(LI.mounted)) && !v.overlay) return new e(v.tree, h, t, a);
            var p = new e(f, h, t, a);
            return o & FI.IncludeAnonymous || !p.type.isAnonymous ? p : p.nextChild(n < 0 ? f.children.length - 1 : 0, n, r, i);
          }
        }
        if (o & FI.IncludeAnonymous || !a.type.isAnonymous) return null;
        if (t = a.index >= 0 ? a.index + n : n < 0 ? -1 : a._parent._tree.children.length, !(a = a._parent)) return null;
      }
    }
  }, {
    key: "firstChild",
    get: function get() {
      return this.nextChild(0, 1, 0, 4);
    }
  }, {
    key: "lastChild",
    get: function get() {
      return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
    }
  }, {
    key: "childAfter",
    value: function value(e) {
      return this.nextChild(0, 1, e, 2);
    }
  }, {
    key: "childBefore",
    value: function value(e) {
      return this.nextChild(this._tree.children.length - 1, -1, e, -2);
    }
  }, {
    key: "enter",
    value: function value(t, n) {
      var r,
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
      if (!(i & FI.IgnoreOverlays) && (r = this._tree.prop(LI.mounted)) && r.overlay) {
        var o,
          a = t - this.from,
          s = bi(r.overlay);
        try {
          for (s.s(); !(o = s.n()).done;) {
            var u = o.value,
              c = u.from,
              l = u.to;
            if ((n > 0 ? c <= a : c < a) && (n < 0 ? l >= a : l > a)) return new e(r.tree, r.overlay[0].from + this.from, -1, this);
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
      }
      return this.nextChild(0, 1, t, n, i);
    }
  }, {
    key: "nextSignificantParent",
    value: function value() {
      for (var e = this; e.type.isAnonymous && e._parent;) {
        e = e._parent;
      }
      return e;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent ? this._parent.nextSignificantParent() : null;
    }
  }, {
    key: "nextSibling",
    get: function get() {
      return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
    }
  }, {
    key: "prevSibling",
    get: function get() {
      return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
    }
  }, {
    key: "cursor",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      return new nT(this, e);
    }
  }, {
    key: "tree",
    get: function get() {
      return this._tree;
    }
  }, {
    key: "toTree",
    value: function value() {
      return this._tree;
    }
  }, {
    key: "resolve",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return QI(this, e, t, !1);
    }
  }, {
    key: "resolveInner",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return QI(this, e, t, !0);
    }
  }, {
    key: "enterUnfinishedNodesBefore",
    value: function value(e) {
      return GI(this, e);
    }
  }, {
    key: "getChild",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
        r = ZI(this, e, t, n);
      return r.length ? r[0] : null;
    }
  }, {
    key: "getChildren",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
      return ZI(this, e, t, n);
    }
  }, {
    key: "toString",
    value: function value() {
      return this._tree.toString();
    }
  }, {
    key: "node",
    get: function get() {
      return this;
    }
  }, {
    key: "matchContext",
    value: function value(e) {
      return XI(this, e);
    }
  }]), e;
}();
function ZI(e, t, n, r) {
  var i = e.cursor(),
    o = [];
  if (!i.firstChild()) return o;
  if (null != n) for (; !i.type.is(n);) {
    if (!i.nextSibling()) return o;
  }
  for (;;) {
    if (null != r && i.type.is(r)) return o;
    if (i.type.is(t) && o.push(i.node), !i.nextSibling()) return null == r ? o : [];
  }
}
function XI(e, t) {
  for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length - 1, r = e.parent; n >= 0; r = r.parent) {
    if (!r) return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name) return !1;
      n--;
    }
  }
  return !0;
}
var eT = zi(function e(t, n, r, i) {
    Ri(this, e), this.parent = t, this.buffer = n, this.index = r, this.start = i;
  }),
  tT = function () {
    function e(t, n, r) {
      Ri(this, e), this.context = t, this._parent = n, this.index = r, this.type = t.buffer.set.types[t.buffer.buffer[r]];
    }
    return zi(e, [{
      key: "name",
      get: function get() {
        return this.type.name;
      }
    }, {
      key: "from",
      get: function get() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
      }
    }, {
      key: "to",
      get: function get() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
      }
    }, {
      key: "child",
      value: function value(t, n, r) {
        var i = this.context.buffer,
          o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
        return o < 0 ? null : new e(this.context, this, o);
      }
    }, {
      key: "firstChild",
      get: function get() {
        return this.child(1, 0, 4);
      }
    }, {
      key: "lastChild",
      get: function get() {
        return this.child(-1, 0, 4);
      }
    }, {
      key: "childAfter",
      value: function value(e) {
        return this.child(1, e, 2);
      }
    }, {
      key: "childBefore",
      value: function value(e) {
        return this.child(-1, e, -2);
      }
    }, {
      key: "enter",
      value: function value(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        if (r & FI.ExcludeBuffers) return null;
        var i = this.context.buffer,
          o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
        return o < 0 ? null : new e(this.context, this, o);
      }
    }, {
      key: "parent",
      get: function get() {
        return this._parent || this.context.parent.nextSignificantParent();
      }
    }, {
      key: "externalSibling",
      value: function value(e) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + e, e, 0, 4);
      }
    }, {
      key: "nextSibling",
      get: function get() {
        var t = this.context.buffer,
          n = t.buffer[this.index + 3];
        return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new e(this.context, this._parent, n) : this.externalSibling(1);
      }
    }, {
      key: "prevSibling",
      get: function get() {
        var t = this.context.buffer,
          n = this._parent ? this._parent.index + 4 : 0;
        return this.index == n ? this.externalSibling(-1) : new e(this.context, this._parent, t.findChild(n, this.index, -1, 0, 4));
      }
    }, {
      key: "cursor",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
        return new nT(this, e);
      }
    }, {
      key: "tree",
      get: function get() {
        return null;
      }
    }, {
      key: "toTree",
      value: function value() {
        var e = [],
          t = [],
          n = this.context.buffer,
          r = this.index + 4,
          i = n.buffer[this.index + 3];
        if (i > r) {
          var o = n.buffer[this.index + 1],
            a = n.buffer[this.index + 2];
          e.push(n.slice(r, i, o, a)), t.push(0);
        }
        return new WI(this.type, e, t, this.to - this.from);
      }
    }, {
      key: "resolve",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return QI(this, e, t, !1);
      }
    }, {
      key: "resolveInner",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return QI(this, e, t, !0);
      }
    }, {
      key: "enterUnfinishedNodesBefore",
      value: function value(e) {
        return GI(this, e);
      }
    }, {
      key: "toString",
      value: function value() {
        return this.context.buffer.childString(this.index);
      }
    }, {
      key: "getChild",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          r = ZI(this, e, t, n);
        return r.length ? r[0] : null;
      }
    }, {
      key: "getChildren",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        return ZI(this, e, t, n);
      }
    }, {
      key: "node",
      get: function get() {
        return this;
      }
    }, {
      key: "matchContext",
      value: function value(e) {
        return XI(this, e);
      }
    }]), e;
  }(),
  nT = function () {
    function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      if (Ri(this, e), this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof YI) this.yieldNode(t);else {
        this._tree = t.context.parent, this.buffer = t.context;
        for (var r = t._parent; r; r = r._parent) {
          this.stack.unshift(r.index);
        }
        this.bufferNode = t, this.yieldBuf(t.index);
      }
    }
    return zi(e, [{
      key: "name",
      get: function get() {
        return this.type.name;
      }
    }, {
      key: "yieldNode",
      value: function value(e) {
        return !!e && (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0);
      }
    }, {
      key: "yieldBuf",
      value: function value(e, t) {
        this.index = e;
        var n = this.buffer,
          r = n.start,
          i = n.buffer;
        return this.type = t || i.set.types[i.buffer[e]], this.from = r + i.buffer[e + 1], this.to = r + i.buffer[e + 2], !0;
      }
    }, {
      key: "yield",
      value: function value(e) {
        return !!e && (e instanceof YI ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)));
      }
    }, {
      key: "toString",
      value: function value() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
      }
    }, {
      key: "enterChild",
      value: function value(e, t, n) {
        if (!this.buffer) return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, t, n, this.mode));
        var r = this.buffer.buffer,
          i = r.findChild(this.index + 4, r.buffer[this.index + 3], e, t - this.buffer.start, n);
        return !(i < 0) && (this.stack.push(this.index), this.yieldBuf(i));
      }
    }, {
      key: "firstChild",
      value: function value() {
        return this.enterChild(1, 0, 4);
      }
    }, {
      key: "lastChild",
      value: function value() {
        return this.enterChild(-1, 0, 4);
      }
    }, {
      key: "childAfter",
      value: function value(e) {
        return this.enterChild(1, e, 2);
      }
    }, {
      key: "childBefore",
      value: function value(e) {
        return this.enterChild(-1, e, -2);
      }
    }, {
      key: "enter",
      value: function value(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.mode;
        return this.buffer ? !(n & FI.ExcludeBuffers) && this.enterChild(1, e, t) : this.yield(this._tree.enter(e, t, n));
      }
    }, {
      key: "parent",
      value: function value() {
        if (!this.buffer) return this.yieldNode(this.mode & FI.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        var e = this.mode & FI.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        return this.buffer = null, this.yieldNode(e);
      }
    }, {
      key: "sibling",
      value: function value(e) {
        if (!this.buffer) return !!this._tree._parent && this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode));
        var t = this.buffer.buffer,
          n = this.stack.length - 1;
        if (e < 0) {
          var r = n < 0 ? 0 : this.stack[n] + 4;
          if (this.index != r) return this.yieldBuf(t.findChild(r, this.index, -1, 0, 4));
        } else {
          var i = t.buffer[this.index + 3];
          if (i < (n < 0 ? t.buffer.length : t.buffer[this.stack[n] + 3])) return this.yieldBuf(i);
        }
        return n < 0 && this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode));
      }
    }, {
      key: "nextSibling",
      value: function value() {
        return this.sibling(1);
      }
    }, {
      key: "prevSibling",
      value: function value() {
        return this.sibling(-1);
      }
    }, {
      key: "atLastNode",
      value: function value(e) {
        var t,
          n,
          r = this.buffer;
        if (r) {
          if (e > 0) {
            if (this.index < r.buffer.buffer.length) return !1;
          } else for (var i = 0; i < this.index; i++) {
            if (r.buffer.buffer[i + 3] < this.index) return !1;
          }
          t = r.index, n = r.parent;
        } else {
          var o = this._tree;
          t = o.index, n = o._parent;
        }
        for (; n; t = (a = n).index, n = a._parent, a) {
          var a;
          if (t > -1) for (var s = t + e, u = e < 0 ? -1 : n._tree.children.length; s != u; s += e) {
            var c = n._tree.children[s];
            if (this.mode & FI.IncludeAnonymous || c instanceof JI || !c.type.isAnonymous || rT(c)) return !1;
          }
        }
        return !0;
      }
    }, {
      key: "move",
      value: function value(e, t) {
        if (t && this.enterChild(e, 0, 4)) return !0;
        for (;;) {
          if (this.sibling(e)) return !0;
          if (this.atLastNode(e) || !this.parent()) return !1;
        }
      }
    }, {
      key: "next",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        return this.move(1, e);
      }
    }, {
      key: "prev",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        return this.move(-1, e);
      }
    }, {
      key: "moveTo",
      value: function value(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0; (this.from == this.to || (t < 1 ? this.from >= e : this.from > e) || (t > -1 ? this.to <= e : this.to < e)) && this.parent();) {
          ;
        }
        for (; this.enterChild(1, e, t);) {
          ;
        }
        return this;
      }
    }, {
      key: "node",
      get: function get() {
        if (!this.buffer) return this._tree;
        var e = this.bufferNode,
          t = null,
          n = 0;
        if (e && e.context == this.buffer) e: for (var r = this.index, i = this.stack.length; i >= 0;) {
          for (var o = e; o; o = o._parent) {
            if (o.index == r) {
              if (r == this.index) return o;
              t = o, n = i + 1;
              break e;
            }
          }
          r = this.stack[--i];
        }
        for (var a = n; a < this.stack.length; a++) {
          t = new tT(this.buffer, t, this.stack[a]);
        }
        return this.bufferNode = new tT(this.buffer, t, this.index);
      }
    }, {
      key: "tree",
      get: function get() {
        return this.buffer ? null : this._tree._tree;
      }
    }, {
      key: "iterate",
      value: function value(e, t) {
        for (var n = 0;;) {
          var r = !1;
          if (this.type.isAnonymous || !1 !== e(this)) {
            if (this.firstChild()) {
              n++;
              continue;
            }
            this.type.isAnonymous || (r = !0);
          }
          for (; r && t && t(this), r = this.type.isAnonymous, !this.nextSibling();) {
            if (!n) return;
            this.parent(), n--, r = !0;
          }
        }
      }
    }, {
      key: "matchContext",
      value: function value(e) {
        if (!this.buffer) return XI(this.node, e);
        for (var t = this.buffer.buffer, n = t.set.types, r = e.length - 1, i = this.stack.length - 1; r >= 0; i--) {
          if (i < 0) return XI(this.node, e, r);
          var o = n[t.buffer[this.stack[i]]];
          if (!o.isAnonymous) {
            if (e[r] && e[r] != o.name) return !1;
            r--;
          }
        }
        return !0;
      }
    }]), e;
  }();
function rT(e) {
  return e.children.some(function (e) {
    return e instanceof JI || !e.type.isAnonymous || rT(e);
  });
}
function iT(e) {
  var t,
    n = e.buffer,
    r = e.nodeSet,
    i = e.maxBufferLength,
    o = void 0 === i ? 1024 : i,
    a = e.reused,
    s = void 0 === a ? [] : a,
    u = e.minRepeatType,
    c = void 0 === u ? r.types.length : u,
    l = Array.isArray(n) ? new UI(n, n.length) : n,
    f = r.types,
    h = 0,
    d = 0;
  function v(e, t, n, i, a) {
    for (var u = l.id, y = l.start, b = l.end, k = l.size, w = d; k < 0;) {
      if (l.next(), -1 == k) {
        var x = s[u];
        return n.push(x), void i.push(y - e);
      }
      if (-3 == k) return void (h = u);
      if (-4 == k) return void (d = u);
      throw new RangeError("Unrecognized record size: ".concat(k));
    }
    var j,
      S,
      C = f[u],
      _ = y - e;
    if (b - y <= o && (S = function (e, t) {
      var n = l.fork(),
        r = 0,
        i = 0,
        a = 0,
        s = n.end - o,
        u = {
          size: 0,
          start: 0,
          skip: 0
        };
      e: for (var f = n.pos - e; n.pos > f;) {
        var h = n.size;
        if (n.id == t && h >= 0) u.size = r, u.start = i, u.skip = a, a += 4, r += 4, n.next();else {
          var d = n.pos - h;
          if (h < 0 || d < f || n.start < s) break;
          var v = n.id >= c ? 4 : 0,
            p = n.start;
          for (n.next(); n.pos > d;) {
            if (n.size < 0) {
              if (-3 != n.size) break e;
              v += 4;
            } else n.id >= c && (v += 4);
            n.next();
          }
          i = p, r += h, a += v;
        }
      }
      (t < 0 || r == e) && (u.size = r, u.start = i, u.skip = a);
      return u.size > 4 ? u : void 0;
    }(l.pos - t, a))) {
      for (var $ = new Uint16Array(S.size - S.skip), O = l.pos - S.size, A = $.length; l.pos > O;) {
        A = g(S.start, $, A);
      }
      j = new JI($, b - S.start, r), _ = S.start - e;
    } else {
      var E = l.pos - k;
      l.next();
      for (var P = [], M = [], I = u >= c ? u : -1, T = 0, N = b; l.pos > E;) {
        I >= 0 && l.id == I && l.size >= 0 ? (l.end <= N - o && (p(P, M, y, T, l.end, N, I, w), T = P.length, N = l.end), l.next()) : v(y, E, P, M, I);
      }
      if (I >= 0 && T > 0 && T < P.length && p(P, M, y, T, y, N, I, w), P.reverse(), M.reverse(), I > -1 && T > 0) {
        var R = function (e) {
          return function (t, n, r) {
            var i,
              o,
              a = 0,
              s = t.length - 1;
            if (s >= 0 && (i = t[s]) instanceof WI) {
              if (!s && i.type == e && i.length == r) return i;
              (o = i.prop(LI.lookAhead)) && (a = n[s] + i.length + o);
            }
            return m(e, t, n, r, a);
          };
        }(C);
        j = sT(C, P, M, 0, P.length, 0, b - y, R, R);
      } else j = m(C, P, M, b - y, w - b);
    }
    n.push(j), i.push(_);
  }
  function p(e, t, n, i, o, a, s, u) {
    for (var c = [], l = []; e.length > i;) {
      c.push(e.pop()), l.push(t.pop() + n - o);
    }
    e.push(m(r.types[s], c, l, a - o, u - a)), t.push(o - n);
  }
  function m(e, t, n, r) {
    var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
      o = arguments.length > 5 ? arguments[5] : void 0;
    if (h) {
      var a = [LI.contextHash, h];
      o = o ? [a].concat(o) : [a];
    }
    if (i > 25) {
      var s = [LI.lookAhead, i];
      o = o ? [s].concat(o) : [s];
    }
    return new WI(e, t, n, r, o);
  }
  function g(e, t, n) {
    var r = l.id,
      i = l.start,
      o = l.end,
      a = l.size;
    if (l.next(), a >= 0 && r < c) {
      var s = n;
      if (a > 4) for (var u = l.pos - (a - 4); l.pos > u;) {
        n = g(e, t, n);
      }
      t[--n] = s, t[--n] = o - e, t[--n] = i - e, t[--n] = r;
    } else -3 == a ? h = r : -4 == a && (d = r);
    return n;
  }
  for (var y = [], b = []; l.pos > 0;) {
    v(e.start || 0, e.bufferStart || 0, y, b, -1);
  }
  var k = null !== (t = e.length) && void 0 !== t ? t : y.length ? b[0] + y[0].length : 0;
  return new WI(f[e.topID], y.reverse(), b.reverse(), k);
}
var oT = new WeakMap();
function aT(e, t) {
  if (!e.isAnonymous || t instanceof JI || t.type != e) return 1;
  var n = oT.get(t);
  if (null == n) {
    n = 1;
    var r,
      i = bi(t.children);
    try {
      for (i.s(); !(r = i.n()).done;) {
        var o = r.value;
        if (o.type != e || !(o instanceof WI)) {
          n = 1;
          break;
        }
        n += aT(e, o);
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
    oT.set(t, n);
  }
  return n;
}
function sT(e, t, n, r, i, o, a, s, u) {
  for (var c = 0, l = r; l < i; l++) {
    c += aT(e, t[l]);
  }
  var f = Math.ceil(1.5 * c / 8),
    h = [],
    d = [];
  return function t(n, r, i, a, s) {
    for (var c = i; c < a;) {
      var l = c,
        v = r[c],
        p = aT(e, n[c]);
      for (c++; c < a; c++) {
        var m = aT(e, n[c]);
        if (p + m >= f) break;
        p += m;
      }
      if (c == l + 1) {
        if (p > f) {
          var g = n[l];
          t(g.children, g.positions, 0, g.children.length, r[l] + s);
          continue;
        }
        h.push(n[l]);
      } else {
        var y = r[c - 1] + n[c - 1].length - v;
        h.push(sT(e, n, r, l, c, v, y, null, u));
      }
      d.push(v + s - o);
    }
  }(t, n, r, i, 0), (s || u)(h, d, a);
}
new LI({
  perNode: !0
});
var uT = 0,
  cT = function () {
    function e(t, n, r) {
      Ri(this, e), this.set = t, this.base = n, this.modified = r, this.id = uT++;
    }
    return zi(e, null, [{
      key: "define",
      value: function value(t) {
        if (null == t ? void 0 : t.base) throw new Error("Can not derive from a modified tag");
        var n = new e([], null, []);
        if (n.set.push(n), t) {
          var r,
            i = bi(t.set);
          try {
            for (i.s(); !(r = i.n()).done;) {
              var o = r.value;
              n.set.push(o);
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        }
        return n;
      }
    }, {
      key: "defineModifier",
      value: function value() {
        var e = new fT();
        return function (t) {
          return t.modified.indexOf(e) > -1 ? t : fT.get(t.base || t, t.modified.concat(e).sort(function (e, t) {
            return e.id - t.id;
          }));
        };
      }
    }]), e;
  }(),
  lT = 0,
  fT = function () {
    function e() {
      Ri(this, e), this.instances = [], this.id = lT++;
    }
    return zi(e, null, [{
      key: "get",
      value: function value(t, n) {
        if (!n.length) return t;
        var r = n[0].instances.find(function (e) {
          return e.base == t && (r = n, i = e.modified, r.length == i.length && r.every(function (e, t) {
            return e == i[t];
          }));
          var r, i;
        });
        if (r) return r;
        var i,
          o = [],
          a = new cT(o, t, n),
          s = bi(n);
        try {
          for (s.s(); !(i = s.n()).done;) {
            i.value.instances.push(a);
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
        var u,
          c = hT(n),
          l = bi(t.set);
        try {
          for (l.s(); !(u = l.n()).done;) {
            var f,
              h = u.value,
              d = bi(c);
            try {
              for (d.s(); !(f = d.n()).done;) {
                var v = f.value;
                o.push(e.get(h, v));
              }
            } catch (e) {
              d.e(e);
            } finally {
              d.f();
            }
          }
        } catch (e) {
          l.e(e);
        } finally {
          l.f();
        }
        return a;
      }
    }]), e;
  }();
function hT(e) {
  for (var t = [e], n = 0; n < e.length; n++) {
    var r,
      i = bi(hT(e.slice(0, n).concat(e.slice(n + 1))));
    try {
      for (i.s(); !(r = i.n()).done;) {
        var o = r.value;
        t.push(o);
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
  }
  return t;
}
function dT(e) {
  var t = Object.create(null);
  for (var n in e) {
    var r = e[n];
    Array.isArray(r) || (r = [r]);
    var i,
      o = bi(n.split(" "));
    try {
      for (o.s(); !(i = o.n()).done;) {
        var a = i.value;
        if (a) {
          for (var s = [], u = 2, c = a, l = 0;;) {
            if ("..." == c && l > 0 && l + 3 == a.length) {
              u = 1;
              break;
            }
            var f = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(c);
            if (!f) throw new RangeError("Invalid path: " + a);
            if (s.push("*" == f[0] ? "" : '"' == f[0][0] ? JSON.parse(f[0]) : f[0]), (l += f[0].length) == a.length) break;
            var h = a[l++];
            if (l == a.length && "!" == h) {
              u = 0;
              break;
            }
            if ("/" != h) throw new RangeError("Invalid path: " + a);
            c = a.slice(l);
          }
          var d = s.length - 1,
            v = s[d];
          if (!v) throw new RangeError("Invalid path: " + a);
          var p = new pT(r, u, d > 0 ? s.slice(0, d) : null);
          t[v] = p.sort(t[v]);
        }
      }
    } catch (e) {
      o.e(e);
    } finally {
      o.f();
    }
  }
  return vT.add(t);
}
var vT = new LI(),
  pT = function () {
    function e(t, n, r, i) {
      Ri(this, e), this.tags = t, this.mode = n, this.context = r, this.next = i;
    }
    return zi(e, [{
      key: "sort",
      value: function value(e) {
        return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
      }
    }, {
      key: "depth",
      get: function get() {
        return this.context ? this.context.length : 0;
      }
    }]), e;
  }();
function mT(e, t) {
  var n,
    r = Object.create(null),
    i = bi(e);
  try {
    for (i.s(); !(n = i.n()).done;) {
      var o = n.value;
      if (Array.isArray(o.tag)) {
        var a,
          s = bi(o.tag);
        try {
          for (s.s(); !(a = s.n()).done;) {
            var u = a.value;
            r[u.id] = o.class;
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
      } else r[o.tag.id] = o.class;
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }
  var c = t || {},
    l = c.scope,
    f = c.all,
    h = void 0 === f ? null : f;
  return {
    style: function style(e) {
      var t,
        n = h,
        i = bi(e);
      try {
        for (i.s(); !(t = i.n()).done;) {
          var o,
            a = bi(t.value.set);
          try {
            for (a.s(); !(o = a.n()).done;) {
              var s = o.value,
                u = r[s.id];
              if (u) {
                n = n ? n + " " + u : u;
                break;
              }
            }
          } catch (e) {
            a.e(e);
          } finally {
            a.f();
          }
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }
      return n;
    },
    scope: l
  };
}
function gT(e, t) {
  var n,
    r = null,
    i = bi(e);
  try {
    for (i.s(); !(n = i.n()).done;) {
      var o = n.value.style(t);
      o && (r = r ? r + " " + o : o);
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }
  return r;
}
function yT(e, t, n) {
  var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
    i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : e.length,
    o = new kT(r, Array.isArray(t) ? t : [t], n);
  o.highlightRange(e.cursor(), r, i, "", o.highlighters), o.flush(i);
}
var bT,
  kT = function () {
    function e(t, n, r) {
      Ri(this, e), this.at = t, this.highlighters = n, this.span = r, this.class = "";
    }
    return zi(e, [{
      key: "startSpan",
      value: function value(e, t) {
        t != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = t);
      }
    }, {
      key: "flush",
      value: function value(e) {
        e > this.at && this.class && this.span(this.at, e, this.class);
      }
    }, {
      key: "highlightRange",
      value: function value(e, t, n, r, i) {
        var o = e.type,
          a = e.from,
          s = e.to;
        if (!(a >= n || s <= t)) {
          o.isTop && (i = this.highlighters.filter(function (e) {
            return !e.scope || e.scope(o);
          }));
          for (var u = r, c = o.prop(vT), l = !1; c;) {
            if (!c.context || e.matchContext(c.context)) {
              var f = gT(i, c.tags);
              f && (u && (u += " "), u += f, 1 == c.mode ? r += (r ? " " : "") + f : 0 == c.mode && (l = !0));
              break;
            }
            c = c.next;
          }
          if (this.startSpan(e.from, u), !l) {
            var h = e.tree && e.tree.prop(LI.mounted);
            if (h && h.overlay) {
              for (var d = e.node.enter(h.overlay[0].from + a, 1), v = this.highlighters.filter(function (e) {
                  return !e.scope || e.scope(h.tree.type);
                }), p = e.firstChild(), m = 0, g = a;; m++) {
                var y = m < h.overlay.length ? h.overlay[m] : null,
                  b = y ? y.from + a : s,
                  k = Math.max(t, g),
                  w = Math.min(n, b);
                if (k < w && p) for (; e.from < w && (this.highlightRange(e, k, w, r, i), this.startSpan(Math.min(n, e.to), u), !(e.to >= b) && e.nextSibling());) {
                  ;
                }
                if (!y || b > n) break;
                (g = y.to + a) > t && (this.highlightRange(d.cursor(), Math.max(t, y.from + a), Math.min(n, g), r, v), this.startSpan(g, u));
              }
              p && e.parent();
            } else if (e.firstChild()) {
              do {
                if (!(e.to <= t)) {
                  if (e.from >= n) break;
                  this.highlightRange(e, t, n, r, i), this.startSpan(Math.min(n, e.to), u);
                }
              } while (e.nextSibling());
              e.parent();
            }
          }
        }
      }
    }]), e;
  }(),
  wT = cT.define,
  xT = wT(),
  jT = wT(),
  ST = wT(jT),
  CT = wT(jT),
  _T = wT(),
  $T = wT(_T),
  OT = wT(_T),
  AT = wT(),
  ET = wT(AT),
  PT = wT(),
  MT = wT(),
  IT = wT(),
  TT = wT(IT),
  NT = wT(),
  RT = {
    comment: xT,
    lineComment: wT(xT),
    blockComment: wT(xT),
    docComment: wT(xT),
    name: jT,
    variableName: wT(jT),
    typeName: ST,
    tagName: wT(ST),
    propertyName: CT,
    attributeName: wT(CT),
    className: wT(jT),
    labelName: wT(jT),
    namespace: wT(jT),
    macroName: wT(jT),
    literal: _T,
    string: $T,
    docString: wT($T),
    character: wT($T),
    attributeValue: wT($T),
    number: OT,
    integer: wT(OT),
    float: wT(OT),
    bool: wT(_T),
    regexp: wT(_T),
    escape: wT(_T),
    color: wT(_T),
    url: wT(_T),
    keyword: PT,
    self: wT(PT),
    null: wT(PT),
    atom: wT(PT),
    unit: wT(PT),
    modifier: wT(PT),
    operatorKeyword: wT(PT),
    controlKeyword: wT(PT),
    definitionKeyword: wT(PT),
    moduleKeyword: wT(PT),
    operator: MT,
    derefOperator: wT(MT),
    arithmeticOperator: wT(MT),
    logicOperator: wT(MT),
    bitwiseOperator: wT(MT),
    compareOperator: wT(MT),
    updateOperator: wT(MT),
    definitionOperator: wT(MT),
    typeOperator: wT(MT),
    controlOperator: wT(MT),
    punctuation: IT,
    separator: wT(IT),
    bracket: TT,
    angleBracket: wT(TT),
    squareBracket: wT(TT),
    paren: wT(TT),
    brace: wT(TT),
    content: AT,
    heading: ET,
    heading1: wT(ET),
    heading2: wT(ET),
    heading3: wT(ET),
    heading4: wT(ET),
    heading5: wT(ET),
    heading6: wT(ET),
    contentSeparator: wT(AT),
    list: wT(AT),
    quote: wT(AT),
    emphasis: wT(AT),
    strong: wT(AT),
    link: wT(AT),
    monospace: wT(AT),
    strikethrough: wT(AT),
    inserted: wT(),
    deleted: wT(),
    changed: wT(),
    invalid: wT(),
    meta: NT,
    documentMeta: wT(NT),
    annotation: wT(NT),
    processingInstruction: wT(NT),
    definition: cT.defineModifier(),
    constant: cT.defineModifier(),
    function: cT.defineModifier(),
    standard: cT.defineModifier(),
    local: cT.defineModifier(),
    special: cT.defineModifier()
  };
mT([{
  tag: RT.link,
  class: "tok-link"
}, {
  tag: RT.heading,
  class: "tok-heading"
}, {
  tag: RT.emphasis,
  class: "tok-emphasis"
}, {
  tag: RT.strong,
  class: "tok-strong"
}, {
  tag: RT.keyword,
  class: "tok-keyword"
}, {
  tag: RT.atom,
  class: "tok-atom"
}, {
  tag: RT.bool,
  class: "tok-bool"
}, {
  tag: RT.url,
  class: "tok-url"
}, {
  tag: RT.labelName,
  class: "tok-labelName"
}, {
  tag: RT.inserted,
  class: "tok-inserted"
}, {
  tag: RT.deleted,
  class: "tok-deleted"
}, {
  tag: RT.literal,
  class: "tok-literal"
}, {
  tag: RT.string,
  class: "tok-string"
}, {
  tag: RT.number,
  class: "tok-number"
}, {
  tag: [RT.regexp, RT.escape, RT.special(RT.string)],
  class: "tok-string2"
}, {
  tag: RT.variableName,
  class: "tok-variableName"
}, {
  tag: RT.local(RT.variableName),
  class: "tok-variableName tok-local"
}, {
  tag: RT.definition(RT.variableName),
  class: "tok-variableName tok-definition"
}, {
  tag: RT.special(RT.variableName),
  class: "tok-variableName2"
}, {
  tag: RT.definition(RT.propertyName),
  class: "tok-propertyName tok-definition"
}, {
  tag: RT.typeName,
  class: "tok-typeName"
}, {
  tag: RT.namespace,
  class: "tok-namespace"
}, {
  tag: RT.className,
  class: "tok-className"
}, {
  tag: RT.macroName,
  class: "tok-macroName"
}, {
  tag: RT.propertyName,
  class: "tok-propertyName"
}, {
  tag: RT.operator,
  class: "tok-operator"
}, {
  tag: RT.comment,
  class: "tok-comment"
}, {
  tag: RT.meta,
  class: "tok-meta"
}, {
  tag: RT.invalid,
  class: "tok-invalid"
}, {
  tag: RT.punctuation,
  class: "tok-punctuation"
}]);
var DT = new hI();
var zT = function () {
  function e(t, n) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
    Ri(this, e), this.data = t, c$.prototype.hasOwnProperty("tree") || Object.defineProperty(c$.prototype, "tree", {
      get: function get() {
        return qT(this);
      }
    }), this.parser = n, this.extension = [QT.of(this), c$.languageData.of(function (e, t, n) {
      return e.facet(LT(e, t, n));
    })].concat(r);
  }
  return zi(e, [{
    key: "isActiveAt",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1;
      return LT(e, t, n) == this.data;
    }
  }, {
    key: "findRegions",
    value: function value(e) {
      var t = this,
        n = e.facet(QT);
      if ((null == n ? void 0 : n.data) == this.data) return [{
        from: 0,
        to: e.doc.length
      }];
      if (!n || !n.allowsNesting) return [];
      var r = [];
      return function e(n, i) {
        if (n.prop(DT) != t.data) {
          var o = n.prop(hI.mounted);
          if (o) {
            if (o.tree.prop(DT) == t.data) {
              if (o.overlay) {
                var a,
                  s = bi(o.overlay);
                try {
                  for (s.s(); !(a = s.n()).done;) {
                    var u = a.value;
                    r.push({
                      from: u.from + i,
                      to: u.to + i
                    });
                  }
                } catch (e) {
                  s.e(e);
                } finally {
                  s.f();
                }
              } else r.push({
                from: i,
                to: i + n.length
              });
              return;
            }
            if (o.overlay) {
              var c = r.length;
              if (e(o.tree, o.overlay[0].from + i), r.length > c) return;
            }
          }
          for (var l = 0; l < n.children.length; l++) {
            var f = n.children[l];
            f instanceof yI && e(f, n.positions[l] + i);
          }
        } else r.push({
          from: i,
          to: i + n.length
        });
      }(qT(e), 0), r;
    }
  }, {
    key: "allowsNesting",
    get: function get() {
      return !0;
    }
  }]), e;
}();
function LT(e, t, n) {
  var r = e.facet(QT);
  if (!r) return null;
  var i = r.data;
  if (r.allowsNesting) for (var o = qT(e).topNode; o; o = o.enter(t, n, pI.ExcludeBuffers)) {
    i = o.type.prop(DT) || i;
  }
  return i;
}
zT.setState = Y_.define();
var BT = function (e) {
  ji(n, zT);
  var t = Ci(n);
  function n(e, r) {
    var i;
    return Ri(this, n), (i = t.call(this, e, r)).parser = r, i;
  }
  return zi(n, [{
    key: "configure",
    value: function value(e) {
      return new n(this.data, this.parser.configure(e));
    }
  }, {
    key: "allowsNesting",
    get: function get() {
      return this.parser.hasWrappers();
    }
  }], [{
    key: "define",
    value: function value(e) {
      var t,
        r = (t = e.languageData, x_.define({
          combine: t ? function (e) {
            return e.concat(t);
          } : void 0
        }));
      return new n(r, e.parser.configure({
        props: [DT.add(function (e) {
          return e.isTop ? r : void 0;
        })]
      }));
    }
  }]), n;
}();
function qT(e) {
  var t = e.field(zT.state, !1);
  return t ? t.tree : yI.empty;
}
var FT = function () {
    function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.length;
      Ri(this, e), this.doc = t, this.length = n, this.cursorPos = 0, this.string = "", this.cursor = t.iter();
    }
    return zi(e, [{
      key: "syncTo",
      value: function value(e) {
        return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
      }
    }, {
      key: "chunk",
      value: function value(e) {
        return this.syncTo(e), this.string;
      }
    }, {
      key: "lineChunks",
      get: function get() {
        return !0;
      }
    }, {
      key: "read",
      value: function value(e, t) {
        var n = this.cursorPos - this.string.length;
        return e < n || t >= this.cursorPos ? this.doc.sliceString(e, t) : this.string.slice(e - n, t - n);
      }
    }]), e;
  }(),
  VT = null,
  HT = function () {
    function e(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
        i = arguments.length > 3 ? arguments[3] : void 0,
        o = arguments.length > 4 ? arguments[4] : void 0,
        a = arguments.length > 5 ? arguments[5] : void 0,
        s = arguments.length > 6 ? arguments[6] : void 0,
        u = arguments.length > 7 ? arguments[7] : void 0;
      Ri(this, e), this.parser = t, this.state = n, this.fragments = r, this.tree = i, this.treeLen = o, this.viewport = a, this.skipped = s, this.scheduleOn = u, this.parse = null, this.tempSkipped = [];
    }
    return zi(e, [{
      key: "startParse",
      value: function value() {
        return this.parser.startParse(new FT(this.state.doc), this.fragments);
      }
    }, {
      key: "work",
      value: function value(e, t) {
        var n = this;
        return null != t && t >= this.state.doc.length && (t = void 0), this.tree != yI.empty && this.isDone(null != t ? t : this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(function () {
          var r;
          if ("number" == typeof e) {
            var i = Date.now() + e;
            e = function e() {
              return Date.now() > i;
            };
          }
          for (n.parse || (n.parse = n.startParse()), null != t && (null == n.parse.stoppedAt || n.parse.stoppedAt > t) && t < n.state.doc.length && n.parse.stopAt(t);;) {
            var o = n.parse.advance();
            if (o) {
              if (n.fragments = n.withoutTempSkipped(NI.addTree(o, n.fragments, null != n.parse.stoppedAt)), n.treeLen = null !== (r = n.parse.stoppedAt) && void 0 !== r ? r : n.state.doc.length, n.tree = o, n.parse = null, !(n.treeLen < (null != t ? t : n.state.doc.length))) return !0;
              n.parse = n.startParse();
            }
            if (e()) return !1;
          }
        });
      }
    }, {
      key: "takeTree",
      value: function value() {
        var e,
          t,
          n = this;
        this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((null == this.parse.stoppedAt || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(function () {
          for (; !(t = n.parse.advance());) {
            ;
          }
        }), this.treeLen = e, this.tree = t, this.fragments = this.withoutTempSkipped(NI.addTree(this.tree, this.fragments, !0)), this.parse = null);
      }
    }, {
      key: "withContext",
      value: function value(e) {
        var t = VT;
        VT = this;
        try {
          return e();
        } finally {
          VT = t;
        }
      }
    }, {
      key: "withoutTempSkipped",
      value: function value(e) {
        for (var t; t = this.tempSkipped.pop();) {
          e = WT(e, t.from, t.to);
        }
        return e;
      }
    }, {
      key: "changes",
      value: function value(t, n) {
        var r = this.fragments,
          i = this.tree,
          o = this.treeLen,
          a = this.viewport,
          s = this.skipped;
        if (this.takeTree(), !t.empty) {
          var u = [];
          if (t.iterChangedRanges(function (e, t, n, r) {
            return u.push({
              fromA: e,
              toA: t,
              fromB: n,
              toB: r
            });
          }), r = NI.applyChanges(r, u), i = yI.empty, o = 0, a = {
            from: t.mapPos(a.from, -1),
            to: t.mapPos(a.to, 1)
          }, this.skipped.length) {
            s = [];
            var c,
              l = bi(this.skipped);
            try {
              for (l.s(); !(c = l.n()).done;) {
                var f = c.value,
                  h = t.mapPos(f.from, 1),
                  d = t.mapPos(f.to, -1);
                h < d && s.push({
                  from: h,
                  to: d
                });
              }
            } catch (e) {
              l.e(e);
            } finally {
              l.f();
            }
          }
        }
        return new e(this.parser, n, r, i, o, a, s, this.scheduleOn);
      }
    }, {
      key: "updateViewport",
      value: function value(e) {
        if (this.viewport.from == e.from && this.viewport.to == e.to) return !1;
        this.viewport = e;
        for (var t = this.skipped.length, n = 0; n < this.skipped.length; n++) {
          var r = this.skipped[n],
            i = r.from,
            o = r.to;
          i < e.to && o > e.from && (this.fragments = WT(this.fragments, i, o), this.skipped.splice(n--, 1));
        }
        return !(this.skipped.length >= t) && (this.reset(), !0);
      }
    }, {
      key: "reset",
      value: function value() {
        this.parse && (this.takeTree(), this.parse = null);
      }
    }, {
      key: "skipUntilInView",
      value: function value(e, t) {
        this.skipped.push({
          from: e,
          to: t
        });
      }
    }, {
      key: "isDone",
      value: function value(e) {
        e = Math.min(e, this.state.doc.length);
        var t = this.fragments;
        return this.treeLen >= e && t.length && 0 == t[0].from && t[0].to >= e;
      }
    }], [{
      key: "create",
      value: function value(t, n, r) {
        return new e(t, n, [], yI.empty, 0, r, [], null);
      }
    }, {
      key: "getSkippingParser",
      value: function value(e) {
        return new (function (t) {
          ji(r, RI);
          var n = Ci(r);
          function r() {
            return Ri(this, r), n.apply(this, arguments);
          }
          return zi(r, [{
            key: "createParse",
            value: function value(t, n, r) {
              var i = r[0].from,
                o = r[r.length - 1].to;
              return {
                parsedPos: i,
                advance: function advance() {
                  var t = VT;
                  if (t) {
                    var n,
                      a = bi(r);
                    try {
                      for (a.s(); !(n = a.n()).done;) {
                        var s = n.value;
                        t.tempSkipped.push(s);
                      }
                    } catch (e) {
                      a.e(e);
                    } finally {
                      a.f();
                    }
                    e && (t.scheduleOn = t.scheduleOn ? Promise.all([t.scheduleOn, e]) : e);
                  }
                  return this.parsedPos = o, new yI(vI.none, [], [], o - i);
                },
                stoppedAt: null,
                stopAt: function stopAt() {}
              };
            }
          }]), r;
        }())();
      }
    }, {
      key: "get",
      value: function value() {
        return VT;
      }
    }]), e;
  }();
function WT(e, t, n) {
  return NI.applyChanges(e, [{
    fromA: t,
    toA: n,
    fromB: t,
    toB: n
  }]);
}
var UT = function () {
  function e(t) {
    Ri(this, e), this.context = t, this.tree = t.tree;
  }
  return zi(e, [{
    key: "apply",
    value: function value(t) {
      if (!t.docChanged && this.tree == this.context.tree) return this;
      var n = this.context.changes(t.changes, t.state),
        r = this.context.treeLen == t.startState.doc.length ? void 0 : Math.max(t.changes.mapPos(this.context.treeLen), n.viewport.to);
      return n.work(20, r) || n.takeTree(), new e(n);
    }
  }], [{
    key: "init",
    value: function value(t) {
      var n = Math.min(3e3, t.doc.length),
        r = HT.create(t.facet(QT).parser, t, {
          from: 0,
          to: n
        });
      return r.work(20, n) || r.takeTree(), new e(r);
    }
  }]), e;
}();
zT.state = O_.define({
  create: UT.init,
  update: function update(e, t) {
    var n,
      r = bi(t.effects);
    try {
      for (r.s(); !(n = r.n()).done;) {
        var i = n.value;
        if (i.is(zT.setState)) return i.value;
      }
    } catch (e) {
      r.e(e);
    } finally {
      r.f();
    }
    return t.startState.facet(QT) != t.state.facet(QT) ? UT.init(t.state) : e.apply(t);
  }
});
var JT = function JT(e) {
  var t = setTimeout(function () {
    return e();
  }, 500);
  return function () {
    return clearTimeout(t);
  };
};
"undefined" != typeof requestIdleCallback && (JT = function JT(e) {
  var t = -1,
    n = setTimeout(function () {
      t = requestIdleCallback(e, {
        timeout: 400
      });
    }, 100);
  return function () {
    return t < 0 ? clearTimeout(n) : cancelIdleCallback(t);
  };
});
var KT = "undefined" != typeof navigator && (null === (bT = navigator.scheduling) || void 0 === bT ? void 0 : bT.isInputPending) ? function () {
    return navigator.scheduling.isInputPending();
  } : null,
  GT = mA.fromClass(function () {
    function e(t) {
      Ri(this, e), this.view = t, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
    }
    return zi(e, [{
      key: "update",
      value: function value(e) {
        var t = this.view.state.field(zT.state).context;
        (t.updateViewport(e.view.viewport) || this.view.viewport.to > t.treeLen) && this.scheduleWork(), e.docChanged && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(t);
      }
    }, {
      key: "scheduleWork",
      value: function value() {
        if (!this.working) {
          var e = this.view.state,
            t = e.field(zT.state);
          t.tree == t.context.tree && t.context.isDone(e.doc.length) || (this.working = JT(this.work));
        }
      }
    }, {
      key: "work",
      value: function value(e) {
        this.working = null;
        var t = Date.now();
        if (this.chunkEnd < t && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = t + 3e4, this.chunkBudget = 3e3), !(this.chunkBudget <= 0)) {
          var n = this.view,
            r = n.state,
            i = n.viewport.to,
            o = r.field(zT.state);
          if (o.tree != o.context.tree || !o.context.isDone(i + 1e5)) {
            var a = Date.now() + Math.min(this.chunkBudget, 100, e && !KT ? Math.max(25, e.timeRemaining() - 5) : 1e9),
              s = o.context.treeLen < i && r.doc.length > i + 1e3,
              u = o.context.work(function () {
                return KT && KT() || Date.now() > a;
              }, i + (s ? 0 : 1e5));
            this.chunkBudget -= Date.now() - t, (u || this.chunkBudget <= 0) && (o.context.takeTree(), this.view.dispatch({
              effects: zT.setState.of(new UT(o.context))
            })), this.chunkBudget > 0 && (!u || s) && this.scheduleWork(), this.checkAsyncSchedule(o.context);
          }
        }
      }
    }, {
      key: "checkAsyncSchedule",
      value: function value(e) {
        var t = this;
        e.scheduleOn && (this.workScheduled++, e.scheduleOn.then(function () {
          return t.scheduleWork();
        }).catch(function (e) {
          return hA(t.view.state, e);
        }).then(function () {
          return t.workScheduled--;
        }), e.scheduleOn = null);
      }
    }, {
      key: "destroy",
      value: function value() {
        this.working && this.working();
      }
    }, {
      key: "isWorking",
      value: function value() {
        return !!(this.working || this.workScheduled > 0);
      }
    }]), e;
  }(), {
    eventHandlers: {
      focus: function focus() {
        this.scheduleWork();
      }
    }
  }),
  QT = x_.define({
    combine: function combine(e) {
      return e.length ? e[0] : null;
    },
    enables: [zT.state, GT]
  }),
  YT = zi(function e(t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
    Ri(this, e), this.language = t, this.support = n, this.extension = [t, n];
  }),
  ZT = x_.define(),
  XT = x_.define({
    combine: function combine(e) {
      if (!e.length) return "  ";
      if (!/^(?: +|\t+)$/.test(e[0])) throw new Error("Invalid indent unit: " + JSON.stringify(e[0]));
      return e[0];
    }
  });
function eN(e) {
  var t = e.facet(XT);
  return 9 == t.charCodeAt(0) ? e.tabSize * t.length : t.length;
}
function tN(e, t) {
  var n = "",
    r = e.tabSize;
  if (9 == e.facet(XT).charCodeAt(0)) for (; t >= r;) {
    n += "\t", t -= r;
  }
  for (var i = 0; i < t; i++) {
    n += " ";
  }
  return n;
}
function nN(e, t) {
  e instanceof c$ && (e = new rN(e));
  var n,
    r = bi(e.state.facet(ZT));
  try {
    for (r.s(); !(n = r.n()).done;) {
      var i = (0, n.value)(e, t);
      if (null != i) return i;
    }
  } catch (e) {
    r.e(e);
  } finally {
    r.f();
  }
  var o = qT(e.state);
  return o ? function (e, t, n) {
    return aN(t.resolveInner(n).enterUnfinishedNodesBefore(n), n, e);
  }(e, o, t) : null;
}
var rN = function () {
    function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      Ri(this, e), this.state = t, this.options = n, this.unit = eN(t);
    }
    return zi(e, [{
      key: "lineAt",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
          n = this.state.doc.lineAt(e),
          r = this.options,
          i = r.simulateBreak,
          o = r.simulateDoubleBreak;
        return null != i && i >= n.from && i <= n.to ? o && i == e ? {
          text: "",
          from: e
        } : (t < 0 ? i < e : i <= e) ? {
          text: n.text.slice(i - n.from),
          from: i
        } : {
          text: n.text.slice(0, i - n.from),
          from: n.from
        } : n;
      }
    }, {
      key: "textAfterPos",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
        if (this.options.simulateDoubleBreak && e == this.options.simulateBreak) return "";
        var n = this.lineAt(e, t),
          r = n.text,
          i = n.from;
        return r.slice(e - i, Math.min(r.length, e + 100 - i));
      }
    }, {
      key: "column",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
          n = this.lineAt(e, t),
          r = n.text,
          i = n.from,
          o = this.countColumn(r, e - i),
          a = this.options.overrideIndentation ? this.options.overrideIndentation(i) : -1;
        return a > -1 && (o += a - this.countColumn(r, r.search(/\S|$/))), o;
      }
    }, {
      key: "countColumn",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.length;
        return O$(e, this.state.tabSize, t);
      }
    }, {
      key: "lineIndent",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
          n = this.lineAt(e, t),
          r = n.text,
          i = n.from,
          o = this.options.overrideIndentation;
        if (o) {
          var a = o(i);
          if (a > -1) return a;
        }
        return this.countColumn(r, r.search(/\S|$/));
      }
    }, {
      key: "simulatedBreak",
      get: function get() {
        return this.options.simulateBreak || null;
      }
    }]), e;
  }(),
  iN = new hI();
function oN(e) {
  var t = e.type.prop(iN);
  if (t) return t;
  var n,
    r = e.firstChild;
  if (r && (n = r.type.prop(hI.closedBy))) {
    var i = e.lastChild,
      o = i && n.indexOf(i.name) > -1;
    return function (e) {
      return function (e, t, n, r, i) {
        var o = e.textAfter,
          a = o.match(/^\s*/)[0].length,
          s = r && o.slice(a, a + r.length) == r || i == e.pos + a,
          u = t ? function (e) {
            var t = e.node,
              n = t.childAfter(t.from),
              r = t.lastChild;
            if (!n) return null;
            for (var i = e.options.simulateBreak, o = e.state.doc.lineAt(n.from), a = null == i || i <= o.from ? o.to : Math.min(o.to, i), s = n.to;;) {
              var u = t.childAfter(s);
              if (!u || u == r) return null;
              if (!u.type.isSkipped) return u.from < a ? n : null;
              s = u.to;
            }
          }(e) : null;
        return u ? s ? e.column(u.from) : e.column(u.to) : e.baseIndent + (s ? 0 : e.unit * n);
      }(e, !0, 1, void 0, o && !function (e) {
        return e.pos == e.options.simulateBreak && e.options.simulateDoubleBreak;
      }(e) ? i.from : void 0);
    };
  }
  return null == e.parent ? sN : null;
}
function aN(e, t, n) {
  for (; e; e = e.parent) {
    var r = oN(e);
    if (r) return r(uN.create(n, t, e));
  }
  return null;
}
function sN() {
  return 0;
}
var uN = function (e) {
  ji(n, rN);
  var t = Ci(n);
  function n(e, r, i) {
    var o;
    return Ri(this, n), (o = t.call(this, e.state, e.options)).base = e, o.pos = r, o.node = i, o;
  }
  return zi(n, [{
    key: "textAfter",
    get: function get() {
      return this.textAfterPos(this.pos);
    }
  }, {
    key: "baseIndent",
    get: function get() {
      for (var e = this.state.doc.lineAt(this.node.from);;) {
        for (var t = this.node.resolve(e.from); t.parent && t.parent.from == t.from;) {
          t = t.parent;
        }
        if (cN(t, this.node)) break;
        e = this.state.doc.lineAt(t.from);
      }
      return this.lineIndent(e.from);
    }
  }, {
    key: "continue",
    value: function value() {
      var e = this.node.parent;
      return e ? aN(e, this.pos, this.base) : 0;
    }
  }], [{
    key: "create",
    value: function value(e, t, r) {
      return new n(e, t, r);
    }
  }]), n;
}();
function cN(e, t) {
  for (var n = t; n; n = n.parent) {
    if (e == n) return !0;
  }
  return !1;
}
function lN() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    t = e.except,
    n = e.units,
    r = void 0 === n ? 1 : n;
  return function (e) {
    var n = t && t.test(e.textAfter);
    return e.baseIndent + (n ? 0 : r * e.unit);
  };
}
function fN() {
  return c$.transactionFilter.of(function (e) {
    if (!e.docChanged || !e.isUserEvent("input.type") && !e.isUserEvent("input.complete")) return e;
    var t = e.startState.languageDataAt("indentOnInput", e.startState.selection.main.head);
    if (!t.length) return e;
    var n = e.newDoc,
      r = e.newSelection.main.head,
      i = n.lineAt(r);
    if (r > i.from + 200) return e;
    var o = n.sliceString(i.from, r);
    if (!t.some(function (e) {
      return e.test(o);
    })) return e;
    var a,
      s = e.state,
      u = -1,
      c = [],
      l = bi(s.selection.ranges);
    try {
      for (l.s(); !(a = l.n()).done;) {
        var f = a.value.head,
          h = s.doc.lineAt(f);
        if (h.from != u) {
          u = h.from;
          var d = nN(s, h.from);
          if (null != d) {
            var v = /^\s*/.exec(h.text)[0],
              p = tN(s, d);
            v != p && c.push({
              from: h.from,
              to: h.from + v.length,
              insert: p
            });
          }
        }
      }
    } catch (e) {
      l.e(e);
    } finally {
      l.f();
    }
    return c.length ? [e, {
      changes: c,
      sequential: !0
    }] : e;
  });
}
var hN = x_.define(),
  dN = new hI();
function vN(e, t, n) {
  var r,
    i = bi(e.facet(hN));
  try {
    for (i.s(); !(r = i.n()).done;) {
      var o = (0, r.value)(e, t, n);
      if (o) return o;
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }
  return function (e, t, n) {
    var r = qT(e);
    if (r.length < n) return null;
    for (var i, o, a = null, s = r.resolveInner(n); s; s = s.parent) {
      if (!(s.to <= n || s.from > n)) {
        if (a && s.from < t) break;
        var u = s.type.prop(dN);
        if (u && (s.to < r.length - 50 || r.length == e.doc.length || (o = void 0, !(o = (i = s).lastChild) || o.to != i.to || !o.type.isError))) {
          var c = u(s, e);
          c && c.from <= n && c.from >= t && c.to > n && (a = c);
        }
      }
    }
    return a;
  }(e, t, n);
}
function pN(e, t) {
  var n = t.mapPos(e.from, 1),
    r = t.mapPos(e.to, -1);
  return n >= r ? void 0 : {
    from: n,
    to: r
  };
}
var mN = Y_.define({
    map: pN
  }),
  gN = Y_.define({
    map: pN
  });
function yN(e) {
  var t,
    n = [],
    r = bi(e.state.selection.ranges);
  try {
    var i = function i() {
      var r = t.value.head;
      if (n.some(function (e) {
        return e.from <= r && e.to >= r;
      })) return "continue";
      n.push(e.lineBlockAt(r));
    };
    for (r.s(); !(t = r.n()).done;) {
      i();
    }
  } catch (e) {
    r.e(e);
  } finally {
    r.f();
  }
  return n;
}
var bN = O_.define({
  create: function create() {
    return UO.none;
  },
  update: function update(e, t) {
    e = e.map(t.changes);
    var n,
      r = bi(t.effects);
    try {
      var i = function i() {
        var t = n.value;
        t.is(mN) && !function (e, t, n) {
          var r = !1;
          return e.between(t, t, function (e, i) {
            e == t && i == n && (r = !0);
          }), r;
        }(e, t.value.from, t.value.to) ? e = e.update({
          add: [$N.range(t.value.from, t.value.to)]
        }) : t.is(gN) && (e = e.update({
          filter: function filter(e, n) {
            return t.value.from != e || t.value.to != n;
          },
          filterFrom: t.value.from,
          filterTo: t.value.to
        }));
      };
      for (r.s(); !(n = r.n()).done;) {
        i();
      }
    } catch (e) {
      r.e(e);
    } finally {
      r.f();
    }
    if (t.selection) {
      var o = !1,
        a = t.selection.main.head;
      e.between(a, a, function (e, t) {
        e < a && t > a && (o = !0);
      }), o && (e = e.update({
        filterFrom: a,
        filterTo: a,
        filter: function filter(e, t) {
          return t <= a || e >= a;
        }
      }));
    }
    return e;
  },
  provide: function provide(e) {
    return CP.decorations.from(e);
  }
});
function kN(e, t, n) {
  var r,
    i = null;
  return null === (r = e.field(bN, !1)) || void 0 === r || r.between(t, n, function (e, t) {
    (!i || i.from > e) && (i = {
      from: e,
      to: t
    });
  }), i;
}
function wN(e, t) {
  return e.field(bN, !1) ? t : t.concat(Y_.appendConfig.of(_N()));
}
function xN(e, t) {
  var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2],
    r = e.state.doc.lineAt(t.from).number,
    i = e.state.doc.lineAt(t.to).number;
  return CP.announce.of("".concat(e.state.phrase(n ? "Folded lines" : "Unfolded lines"), " ").concat(r, " ").concat(e.state.phrase("to"), " ").concat(i, "."));
}
var jN = [{
    key: "Ctrl-Shift-[",
    mac: "Cmd-Alt-[",
    run: function run(e) {
      var t,
        n = bi(yN(e));
      try {
        for (n.s(); !(t = n.n()).done;) {
          var r = t.value,
            i = vN(e.state, r.from, r.to);
          if (i) return e.dispatch({
            effects: wN(e.state, [mN.of(i), xN(e, i)])
          }), !0;
        }
      } catch (e) {
        n.e(e);
      } finally {
        n.f();
      }
      return !1;
    }
  }, {
    key: "Ctrl-Shift-]",
    mac: "Cmd-Alt-]",
    run: function run(e) {
      if (!e.state.field(bN, !1)) return !1;
      var t,
        n = [],
        r = bi(yN(e));
      try {
        for (r.s(); !(t = r.n()).done;) {
          var i = t.value,
            o = kN(e.state, i.from, i.to);
          o && n.push(gN.of(o), xN(e, o, !1));
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
      return n.length && e.dispatch({
        effects: n
      }), n.length > 0;
    }
  }, {
    key: "Ctrl-Alt-[",
    run: function run(e) {
      for (var t = e.state, n = [], r = 0; r < t.doc.length;) {
        var i = e.lineBlockAt(r),
          o = vN(t, i.from, i.to);
        o && n.push(mN.of(o)), r = (o ? e.lineBlockAt(o.to) : i).to + 1;
      }
      return n.length && e.dispatch({
        effects: wN(e.state, n)
      }), !!n.length;
    }
  }, {
    key: "Ctrl-Alt-]",
    run: function run(e) {
      var t = e.state.field(bN, !1);
      if (!t || !t.size) return !1;
      var n = [];
      return t.between(0, e.state.doc.length, function (e, t) {
        n.push(gN.of({
          from: e,
          to: t
        }));
      }), e.dispatch({
        effects: n
      }), !0;
    }
  }],
  SN = {
    placeholderDOM: null,
    placeholderText: "…"
  },
  CN = x_.define({
    combine: function combine(e) {
      return l$(e, SN);
    }
  });
function _N(e) {
  var t = [bN, PN];
  return e && t.push(CN.of(e)), t;
}
var $N = UO.replace({
    widget: new (function (e) {
      ji(n, HO);
      var t = Ci(n);
      function n() {
        return Ri(this, n), t.apply(this, arguments);
      }
      return zi(n, [{
        key: "toDOM",
        value: function value(e) {
          var t = e.state,
            n = t.facet(CN),
            r = function r(t) {
              var n = e.lineBlockAt(e.posAtDOM(t.target)),
                r = kN(e.state, n.from, n.to);
              r && e.dispatch({
                effects: gN.of(r)
              }), t.preventDefault();
            };
          if (n.placeholderDOM) return n.placeholderDOM(e, r);
          var i = document.createElement("span");
          return i.textContent = n.placeholderText, i.setAttribute("aria-label", t.phrase("folded code")), i.title = t.phrase("unfold"), i.className = "cm-foldPlaceholder", i.onclick = r, i;
        }
      }]), n;
    }())()
  }),
  ON = {
    openText: "⌄",
    closedText: "›",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: function foldingChanged() {
      return !1;
    }
  },
  AN = function (e) {
    ji(n, qM);
    var t = Ci(n);
    function n(e, r) {
      var i;
      return Ri(this, n), (i = t.call(this)).config = e, i.open = r, i;
    }
    return zi(n, [{
      key: "eq",
      value: function value(e) {
        return this.config == e.config && this.open == e.open;
      }
    }, {
      key: "toDOM",
      value: function value(e) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        var t = document.createElement("span");
        return t.textContent = this.open ? this.config.openText : this.config.closedText, t.title = e.state.phrase(this.open ? "Fold line" : "Unfold line"), t;
      }
    }]), n;
  }();
function EN() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    t = Object.assign(Object.assign({}, ON), e),
    n = new AN(t, !0),
    r = new AN(t, !1),
    i = mA.fromClass(function () {
      function e(t) {
        Ri(this, e), this.from = t.viewport.from, this.markers = this.buildMarkers(t);
      }
      return zi(e, [{
        key: "update",
        value: function value(e) {
          (e.docChanged || e.viewportChanged || e.startState.facet(QT) != e.state.facet(QT) || e.startState.field(bN, !1) != e.state.field(bN, !1) || qT(e.startState) != qT(e.state) || t.foldingChanged(e)) && (this.markers = this.buildMarkers(e.view));
        }
      }, {
        key: "buildMarkers",
        value: function value(e) {
          var t,
            i = new g$(),
            o = bi(e.viewportLineBlocks);
          try {
            for (o.s(); !(t = o.n()).done;) {
              var a = t.value,
                s = kN(e.state, a.from, a.to) ? r : vN(e.state, a.from, a.to) ? n : null;
              s && i.add(a.from, a.from, s);
            }
          } catch (e) {
            o.e(e);
          } finally {
            o.f();
          }
          return i.finish();
        }
      }]), e;
    }()),
    o = t.domEventHandlers;
  return [i, WM({
    class: "cm-foldGutter",
    markers: function markers(e) {
      var t;
      return (null === (t = e.plugin(i)) || void 0 === t ? void 0 : t.markers) || p$.empty;
    },
    initialSpacer: function initialSpacer() {
      return new AN(t, !1);
    },
    domEventHandlers: Object.assign(Object.assign({}, o), {
      click: function click(e, t, n) {
        if (o.click && o.click(e, t, n)) return !0;
        var r = kN(e.state, t.from, t.to);
        if (r) return e.dispatch({
          effects: gN.of(r)
        }), !0;
        var i = vN(e.state, t.from, t.to);
        return !!i && (e.dispatch({
          effects: mN.of(i)
        }), !0);
      }
    })
  }), _N()];
}
var PN = CP.baseTheme({
    ".cm-foldPlaceholder": {
      backgroundColor: "#eee",
      border: "1px solid #ddd",
      color: "#888",
      borderRadius: ".2em",
      margin: "0 1px",
      padding: "0 1px",
      cursor: "pointer"
    },
    ".cm-foldGutter span": {
      padding: "0 1px",
      cursor: "pointer"
    }
  }),
  MN = function () {
    function e(t, n) {
      var r;
      function i(e) {
        var t = I$.newName();
        return (r || (r = Object.create(null)))["." + t] = e, t;
      }
      Ri(this, e);
      var o = "string" == typeof n.all ? n.all : n.all ? i(n.all) : void 0,
        a = n.scope;
      this.scope = a instanceof zT ? function (e) {
        return e.prop(DT) == a.data;
      } : a ? function (e) {
        return e == a;
      } : void 0, this.style = mT(t.map(function (e) {
        return {
          tag: e.tag,
          class: e.class || i(Object.assign({}, e, {
            tag: null
          }))
        };
      }), {
        all: o
      }).style, this.module = r ? new I$(r) : null, this.themeType = n.themeType;
    }
    return zi(e, null, [{
      key: "define",
      value: function value(t, n) {
        return new e(t, n || {});
      }
    }]), e;
  }(),
  IN = x_.define(),
  TN = x_.define({
    combine: function combine(e) {
      return e.length ? [e[0]] : null;
    }
  });
function NN(e) {
  var t = e.facet(IN);
  return t.length ? t : e.facet(TN);
}
function RN(e, t) {
  var n,
    r = [zN];
  return e instanceof MN && (e.module && r.push(CP.styleModule.of(e.module)), n = e.themeType), (null == t ? void 0 : t.fallback) ? r.push(TN.of(e)) : n ? r.push(IN.computeN([CP.darkTheme], function (t) {
    return t.facet(CP.darkTheme) == ("dark" == n) ? [e] : [];
  })) : r.push(IN.of(e)), r;
}
var DN = function () {
    function e(t) {
      Ri(this, e), this.markCache = Object.create(null), this.tree = qT(t.state), this.decorations = this.buildDeco(t, NN(t.state));
    }
    return zi(e, [{
      key: "update",
      value: function value(e) {
        var t = qT(e.state),
          n = NN(e.state),
          r = n != NN(e.startState);
        t.length < e.view.viewport.to && !r && t.type == this.tree.type ? this.decorations = this.decorations.map(e.changes) : (t != this.tree || e.viewportChanged || r) && (this.tree = t, this.decorations = this.buildDeco(e.view, n));
      }
    }, {
      key: "buildDeco",
      value: function value(e, t) {
        var n = this;
        if (!t || !this.tree.length) return UO.none;
        var r,
          i = new g$(),
          o = bi(e.visibleRanges);
        try {
          for (o.s(); !(r = o.n()).done;) {
            var a = r.value,
              s = a.from,
              u = a.to;
            yT(this.tree, t, function (e, t, r) {
              i.add(e, t, n.markCache[r] || (n.markCache[r] = UO.mark({
                class: r
              })));
            }, s, u);
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        return i.finish();
      }
    }]), e;
  }(),
  zN = T_.high(mA.fromClass(DN, {
    decorations: function decorations(e) {
      return e.decorations;
    }
  })),
  LN = MN.define([{
    tag: RT.meta,
    color: "#7a757a"
  }, {
    tag: RT.link,
    textDecoration: "underline"
  }, {
    tag: RT.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  }, {
    tag: RT.emphasis,
    fontStyle: "italic"
  }, {
    tag: RT.strong,
    fontWeight: "bold"
  }, {
    tag: RT.strikethrough,
    textDecoration: "line-through"
  }, {
    tag: RT.keyword,
    color: "#708"
  }, {
    tag: [RT.atom, RT.bool, RT.url, RT.contentSeparator, RT.labelName],
    color: "#219"
  }, {
    tag: [RT.literal, RT.inserted],
    color: "#164"
  }, {
    tag: [RT.string, RT.deleted],
    color: "#a11"
  }, {
    tag: [RT.regexp, RT.escape, RT.special(RT.string)],
    color: "#e40"
  }, {
    tag: RT.definition(RT.variableName),
    color: "#00f"
  }, {
    tag: RT.local(RT.variableName),
    color: "#30a"
  }, {
    tag: [RT.typeName, RT.namespace],
    color: "#085"
  }, {
    tag: RT.className,
    color: "#167"
  }, {
    tag: [RT.special(RT.variableName), RT.macroName],
    color: "#256"
  }, {
    tag: RT.definition(RT.propertyName),
    color: "#00c"
  }, {
    tag: RT.comment,
    color: "#940"
  }, {
    tag: RT.invalid,
    color: "#f00"
  }]),
  BN = CP.baseTheme({
    "&.cm-focused .cm-matchingBracket": {
      backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
      backgroundColor: "#bb555544"
    }
  }),
  qN = x_.define({
    combine: function combine(e) {
      return l$(e, {
        afterCursor: !0,
        brackets: "()[]{}",
        maxScanDistance: 1e4,
        renderMatch: HN
      });
    }
  }),
  FN = UO.mark({
    class: "cm-matchingBracket"
  }),
  VN = UO.mark({
    class: "cm-nonmatchingBracket"
  });
function HN(e) {
  var t = [],
    n = e.matched ? FN : VN;
  return t.push(n.range(e.start.from, e.start.to)), e.end && t.push(n.range(e.end.from, e.end.to)), t;
}
var WN = [O_.define({
  create: function create() {
    return UO.none;
  },
  update: function update(e, t) {
    if (!t.docChanged && !t.selection) return e;
    var n,
      r = [],
      i = t.state.facet(qN),
      o = bi(t.state.selection.ranges);
    try {
      for (o.s(); !(n = o.n()).done;) {
        var a = n.value;
        if (a.empty) {
          var s = KN(t.state, a.head, -1, i) || a.head > 0 && KN(t.state, a.head - 1, 1, i) || i.afterCursor && (KN(t.state, a.head, 1, i) || a.head < t.state.doc.length && KN(t.state, a.head + 1, -1, i));
          s && (r = r.concat(i.renderMatch(s, t.state)));
        }
      }
    } catch (e) {
      o.e(e);
    } finally {
      o.f();
    }
    return UO.set(r, !0);
  },
  provide: function provide(e) {
    return CP.decorations.from(e);
  }
}), BN];
function UN() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return [qN.of(e), WN];
}
function JN(e, t, n) {
  var r = e.prop(t < 0 ? hI.openedBy : hI.closedBy);
  if (r) return r;
  if (1 == e.name.length) {
    var i = n.indexOf(e.name);
    if (i > -1 && i % 2 == (t < 0 ? 1 : 0)) return [n[i + t]];
  }
  return null;
}
function KN(e, t, n) {
  for (var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, i = r.maxScanDistance || 1e4, o = r.brackets || "()[]{}", a = qT(e), s = a.resolveInner(t, n), u = s; u; u = u.parent) {
    var c = JN(u.type, n, o);
    if (c && u.from < u.to) return GN(e, t, n, u, c, o);
  }
  return QN(e, t, n, a, s.type, i, o);
}
function GN(e, t, n, r, i, o) {
  var a = r.parent,
    s = {
      from: r.from,
      to: r.to
    },
    u = 0,
    c = null == a ? void 0 : a.cursor();
  if (c && (n < 0 ? c.childBefore(r.from) : c.childAfter(r.to))) do {
    if (n < 0 ? c.to <= r.from : c.from >= r.to) {
      if (0 == u && i.indexOf(c.type.name) > -1 && c.from < c.to) return {
        start: s,
        end: {
          from: c.from,
          to: c.to
        },
        matched: !0
      };
      if (JN(c.type, n, o)) u++;else if (JN(c.type, -n, o) && 0 == --u) return {
        start: s,
        end: c.from == c.to ? void 0 : {
          from: c.from,
          to: c.to
        },
        matched: !1
      };
    }
  } while (n < 0 ? c.prevSibling() : c.nextSibling());
  return {
    start: s,
    matched: !1
  };
}
function QN(e, t, n, r, i, o, a) {
  var s = n < 0 ? e.sliceDoc(t - 1, t) : e.sliceDoc(t, t + 1),
    u = a.indexOf(s);
  if (u < 0 || u % 2 == 0 != n > 0) return null;
  for (var c = {
      from: n < 0 ? t - 1 : t,
      to: n > 0 ? t + 1 : t
    }, l = e.doc.iterRange(t, n > 0 ? e.doc.length : 0), f = 0, h = 0; !l.next().done && h <= o;) {
    var d = l.value;
    n < 0 && (h += d.length);
    for (var v = t + h * n, p = n > 0 ? 0 : d.length - 1, m = n > 0 ? d.length : -1; p != m; p += n) {
      var g = a.indexOf(d[p]);
      if (!(g < 0 || r.resolve(v + p, 1).type != i)) if (g % 2 == 0 == n > 0) f++;else {
        if (1 == f) return {
          start: c,
          end: {
            from: v + p,
            to: v + p + 1
          },
          matched: g >> 1 == u >> 1
        };
        f--;
      }
    }
    n > 0 && (h += d.length);
  }
  return l.done ? {
    start: c,
    matched: !1
  } : null;
}
for (var YN = Object.create(null), ZN = [vI.none], XN = [], eR = Object.create(null), tR = 0, nR = [["variable", "variableName"], ["variable-2", "variableName.special"], ["string-2", "string.special"], ["def", "variableName.definition"], ["tag", "typeName"], ["attribute", "propertyName"], ["type", "typeName"], ["builtin", "variableName.standard"], ["qualifier", "modifier"], ["error", "invalid"], ["header", "heading"], ["property", "propertyName"]]; tR < nR.length; tR++) {
  var rR = xi(nR[tR], 2),
    iR = rR[0],
    oR = rR[1];
  eR[iR] = sR(YN, oR);
}
function aR(e, t) {
  XN.indexOf(e) > -1 || (XN.push(e), console.warn(t));
}
function sR(e, t) {
  var n,
    r = null,
    i = bi(t.split("."));
  try {
    for (i.s(); !(n = i.n()).done;) {
      var o = n.value,
        a = e[o] || RT[o];
      a ? "function" == typeof a ? r ? r = a(r) : aR(o, "Modifier ".concat(o, " used at start of tag")) : r ? aR(o, "Tag ".concat(o, " used as modifier")) : r = a : aR(o, "Unknown highlighting tag ".concat(o));
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }
  if (!r) return 0;
  var s = t.replace(/ /g, "_"),
    u = vI.define({
      id: ZN.length,
      name: s,
      props: [dT(Mi({}, s, r))]
    });
  return ZN.push(u), u.id;
}
var uR = 0,
  cR = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      Ri(this, e), this.id = uR++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || function () {
        throw new Error("This node type doesn't define a deserialize function");
      };
    }
    return zi(e, [{
      key: "add",
      value: function value(e) {
        var t = this;
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        return "function" != typeof e && (e = fR.match(e)), function (n) {
          var r = e(n);
          return void 0 === r ? null : [t, r];
        };
      }
    }]), e;
  }();
cR.closedBy = new cR({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), cR.openedBy = new cR({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), cR.group = new cR({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), cR.contextHash = new cR({
  perNode: !0
}), cR.lookAhead = new cR({
  perNode: !0
}), cR.mounted = new cR({
  perNode: !0
});
var lR = Object.create(null),
  fR = function () {
    function e(t, n, r) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
      Ri(this, e), this.name = t, this.props = n, this.id = r, this.flags = i;
    }
    return zi(e, [{
      key: "prop",
      value: function value(e) {
        return this.props[e.id];
      }
    }, {
      key: "isTop",
      get: function get() {
        return (1 & this.flags) > 0;
      }
    }, {
      key: "isSkipped",
      get: function get() {
        return (2 & this.flags) > 0;
      }
    }, {
      key: "isError",
      get: function get() {
        return (4 & this.flags) > 0;
      }
    }, {
      key: "isAnonymous",
      get: function get() {
        return (8 & this.flags) > 0;
      }
    }, {
      key: "is",
      value: function value(e) {
        if ("string" == typeof e) {
          if (this.name == e) return !0;
          var t = this.prop(cR.group);
          return !!t && t.indexOf(e) > -1;
        }
        return this.id == e;
      }
    }], [{
      key: "define",
      value: function value(t) {
        var n = t.props && t.props.length ? Object.create(null) : lR,
          r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (null == t.name ? 8 : 0),
          i = new e(t.name || "", n, t.id, r);
        if (t.props) {
          var o,
            a = bi(t.props);
          try {
            for (a.s(); !(o = a.n()).done;) {
              var s = o.value;
              if (Array.isArray(s) || (s = s(i)), s) {
                if (s[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                n[s[0].id] = s[1];
              }
            }
          } catch (e) {
            a.e(e);
          } finally {
            a.f();
          }
        }
        return i;
      }
    }, {
      key: "match",
      value: function value(e) {
        var t = Object.create(null);
        for (var n in e) {
          var r,
            i = bi(n.split(" "));
          try {
            for (i.s(); !(r = i.n()).done;) {
              var o = r.value;
              t[o] = e[n];
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        }
        return function (e) {
          for (var n = e.prop(cR.group), r = -1; r < (n ? n.length : 0); r++) {
            var i = t[r < 0 ? e.name : n[r]];
            if (i) return i;
          }
        };
      }
    }]), e;
  }();
fR.none = new fR("", Object.create(null), 0, 8);
var hR,
  dR = new WeakMap(),
  vR = new WeakMap();
!function (e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
}(hR || (hR = {}));
var pR = function () {
  function e(t, n, r, i, o) {
    if (Ri(this, e), this.type = t, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = Object.create(null);
      var a,
        s = bi(o);
      try {
        for (s.s(); !(a = s.n()).done;) {
          var u = xi(a.value, 2),
            c = u[0],
            l = u[1];
          this.props["number" == typeof c ? c : c.id] = l;
        }
      } catch (e) {
        s.e(e);
      } finally {
        s.f();
      }
    }
  }
  return zi(e, [{
    key: "toString",
    value: function value() {
      var e = this.prop(cR.mounted);
      if (e && !e.overlay) return e.tree.toString();
      var t,
        n = "",
        r = bi(this.children);
      try {
        for (r.s(); !(t = r.n()).done;) {
          var i = t.value.toString();
          i && (n && (n += ","), n += i);
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
      return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
    }
  }, {
    key: "cursor",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      return new _R(this.topNode, e);
    }
  }, {
    key: "cursorAt",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = dR.get(this) || this.topNode,
        r = new _R(n);
      return r.moveTo(e, t), dR.set(this, r._tree), r;
    }
  }, {
    key: "topNode",
    get: function get() {
      return new wR(this, 0, 0, null);
    }
  }, {
    key: "resolve",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = kR(dR.get(this) || this.topNode, e, t, !1);
      return dR.set(this, n), n;
    }
  }, {
    key: "resolveInner",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = kR(vR.get(this) || this.topNode, e, t, !0);
      return vR.set(this, n), n;
    }
  }, {
    key: "iterate",
    value: function value(e) {
      for (var t = e.enter, n = e.leave, r = e.from, i = void 0 === r ? 0 : r, o = e.to, a = void 0 === o ? this.length : o, s = this.cursor((e.mode || 0) | hR.IncludeAnonymous);;) {
        var u = !1;
        if (s.from <= a && s.to >= i && (s.type.isAnonymous || !1 !== t(s))) {
          if (s.firstChild()) continue;
          u = !0;
        }
        for (; u && n && !s.type.isAnonymous && n(s), !s.nextSibling();) {
          if (!s.parent()) return;
          u = !0;
        }
      }
    }
  }, {
    key: "prop",
    value: function value(e) {
      return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
    }
  }, {
    key: "propValues",
    get: function get() {
      var e = [];
      if (this.props) for (var t in this.props) {
        e.push([+t, this.props[t]]);
      }
      return e;
    }
  }, {
    key: "balance",
    value: function value() {
      var t = this,
        n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return this.children.length <= 8 ? this : PR(fR.none, this.children, this.positions, 0, this.children.length, 0, this.length, function (n, r, i) {
        return new e(t.type, n, r, i, t.propValues);
      }, n.makeTree || function (t, n, r) {
        return new e(fR.none, t, n, r);
      });
    }
  }], [{
    key: "build",
    value: function value(e) {
      return OR(e);
    }
  }]), e;
}();
pR.empty = new pR(fR.none, [], [], 0);
var mR = function () {
    function e(t, n) {
      Ri(this, e), this.buffer = t, this.index = n;
    }
    return zi(e, [{
      key: "id",
      get: function get() {
        return this.buffer[this.index - 4];
      }
    }, {
      key: "start",
      get: function get() {
        return this.buffer[this.index - 3];
      }
    }, {
      key: "end",
      get: function get() {
        return this.buffer[this.index - 2];
      }
    }, {
      key: "size",
      get: function get() {
        return this.buffer[this.index - 1];
      }
    }, {
      key: "pos",
      get: function get() {
        return this.index;
      }
    }, {
      key: "next",
      value: function value() {
        this.index -= 4;
      }
    }, {
      key: "fork",
      value: function value() {
        return new e(this.buffer, this.index);
      }
    }]), e;
  }(),
  gR = function () {
    function e(t, n, r) {
      Ri(this, e), this.buffer = t, this.length = n, this.set = r;
    }
    return zi(e, [{
      key: "type",
      get: function get() {
        return fR.none;
      }
    }, {
      key: "toString",
      value: function value() {
        for (var e = [], t = 0; t < this.buffer.length;) {
          e.push(this.childString(t)), t = this.buffer[t + 3];
        }
        return e.join(",");
      }
    }, {
      key: "childString",
      value: function value(e) {
        var t = this.buffer[e],
          n = this.buffer[e + 3],
          r = this.set.types[t],
          i = r.name;
        if (/\W/.test(i) && !r.isError && (i = JSON.stringify(i)), n == (e += 4)) return i;
        for (var o = []; e < n;) {
          o.push(this.childString(e)), e = this.buffer[e + 3];
        }
        return i + "(" + o.join(",") + ")";
      }
    }, {
      key: "findChild",
      value: function value(e, t, n, r, i) {
        for (var o = this.buffer, a = -1, s = e; s != t && !(yR(i, r, o[s + 1], o[s + 2]) && (a = s, n > 0)); s = o[s + 3]) {
          ;
        }
        return a;
      }
    }, {
      key: "slice",
      value: function value(t, n, r, i) {
        for (var o = this.buffer, a = new Uint16Array(n - t), s = t, u = 0; s < n;) {
          a[u++] = o[s++], a[u++] = o[s++] - r, a[u++] = o[s++] - r, a[u++] = o[s++] - t;
        }
        return new e(a, i - r, this.set);
      }
    }]), e;
  }();
function yR(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function bR(e, t) {
  for (var n = e.childBefore(t); n;) {
    var r = n.lastChild;
    if (!r || r.to != n.to) break;
    r.type.isError && r.from == r.to ? (e = n, n = r.prevSibling) : n = r;
  }
  return e;
}
function kR(e, t, n, r) {
  for (var i; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t);) {
    var o = !r && e instanceof wR && e.index < 0 ? null : e.parent;
    if (!o) return e;
    e = o;
  }
  var a = r ? 0 : hR.IgnoreOverlays;
  if (r) for (var s = e, u = s.parent; u; u = (s = u).parent) {
    s instanceof wR && s.index < 0 && (null === (i = u.enter(t, n, a)) || void 0 === i ? void 0 : i.from) != s.from && (e = u);
  }
  for (;;) {
    var c = e.enter(t, n, a);
    if (!c) return e;
    e = c;
  }
}
var wR = function () {
  function e(t, n, r, i) {
    Ri(this, e), this._tree = t, this.from = n, this.index = r, this._parent = i;
  }
  return zi(e, [{
    key: "type",
    get: function get() {
      return this._tree.type;
    }
  }, {
    key: "name",
    get: function get() {
      return this._tree.type.name;
    }
  }, {
    key: "to",
    get: function get() {
      return this.from + this._tree.length;
    }
  }, {
    key: "nextChild",
    value: function value(t, n, r, i) {
      for (var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = this;;) {
        for (var s = a._tree, u = s.children, c = s.positions, l = n > 0 ? u.length : -1; t != l; t += n) {
          var f = u[t],
            h = c[t] + a.from;
          if (yR(i, r, h, h + f.length)) if (f instanceof gR) {
            if (o & hR.ExcludeBuffers) continue;
            var d = f.findChild(0, f.buffer.length, n, r - h, i);
            if (d > -1) return new CR(new SR(a, f, t, h), null, d);
          } else if (o & hR.IncludeAnonymous || !f.type.isAnonymous || $R(f)) {
            var v = void 0;
            if (!(o & hR.IgnoreMounts) && f.props && (v = f.prop(cR.mounted)) && !v.overlay) return new e(v.tree, h, t, a);
            var p = new e(f, h, t, a);
            return o & hR.IncludeAnonymous || !p.type.isAnonymous ? p : p.nextChild(n < 0 ? f.children.length - 1 : 0, n, r, i);
          }
        }
        if (o & hR.IncludeAnonymous || !a.type.isAnonymous) return null;
        if (t = a.index >= 0 ? a.index + n : n < 0 ? -1 : a._parent._tree.children.length, !(a = a._parent)) return null;
      }
    }
  }, {
    key: "firstChild",
    get: function get() {
      return this.nextChild(0, 1, 0, 4);
    }
  }, {
    key: "lastChild",
    get: function get() {
      return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
    }
  }, {
    key: "childAfter",
    value: function value(e) {
      return this.nextChild(0, 1, e, 2);
    }
  }, {
    key: "childBefore",
    value: function value(e) {
      return this.nextChild(this._tree.children.length - 1, -1, e, -2);
    }
  }, {
    key: "enter",
    value: function value(t, n) {
      var r,
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
      if (!(i & hR.IgnoreOverlays) && (r = this._tree.prop(cR.mounted)) && r.overlay) {
        var o,
          a = t - this.from,
          s = bi(r.overlay);
        try {
          for (s.s(); !(o = s.n()).done;) {
            var u = o.value,
              c = u.from,
              l = u.to;
            if ((n > 0 ? c <= a : c < a) && (n < 0 ? l >= a : l > a)) return new e(r.tree, r.overlay[0].from + this.from, -1, this);
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
      }
      return this.nextChild(0, 1, t, n, i);
    }
  }, {
    key: "nextSignificantParent",
    value: function value() {
      for (var e = this; e.type.isAnonymous && e._parent;) {
        e = e._parent;
      }
      return e;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent ? this._parent.nextSignificantParent() : null;
    }
  }, {
    key: "nextSibling",
    get: function get() {
      return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
    }
  }, {
    key: "prevSibling",
    get: function get() {
      return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
    }
  }, {
    key: "cursor",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      return new _R(this, e);
    }
  }, {
    key: "tree",
    get: function get() {
      return this._tree;
    }
  }, {
    key: "toTree",
    value: function value() {
      return this._tree;
    }
  }, {
    key: "resolve",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return kR(this, e, t, !1);
    }
  }, {
    key: "resolveInner",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return kR(this, e, t, !0);
    }
  }, {
    key: "enterUnfinishedNodesBefore",
    value: function value(e) {
      return bR(this, e);
    }
  }, {
    key: "getChild",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
        r = xR(this, e, t, n);
      return r.length ? r[0] : null;
    }
  }, {
    key: "getChildren",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
      return xR(this, e, t, n);
    }
  }, {
    key: "toString",
    value: function value() {
      return this._tree.toString();
    }
  }, {
    key: "node",
    get: function get() {
      return this;
    }
  }, {
    key: "matchContext",
    value: function value(e) {
      return jR(this, e);
    }
  }]), e;
}();
function xR(e, t, n, r) {
  var i = e.cursor(),
    o = [];
  if (!i.firstChild()) return o;
  if (null != n) for (; !i.type.is(n);) {
    if (!i.nextSibling()) return o;
  }
  for (;;) {
    if (null != r && i.type.is(r)) return o;
    if (i.type.is(t) && o.push(i.node), !i.nextSibling()) return null == r ? o : [];
  }
}
function jR(e, t) {
  for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length - 1, r = e.parent; n >= 0; r = r.parent) {
    if (!r) return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name) return !1;
      n--;
    }
  }
  return !0;
}
var SR = zi(function e(t, n, r, i) {
    Ri(this, e), this.parent = t, this.buffer = n, this.index = r, this.start = i;
  }),
  CR = function () {
    function e(t, n, r) {
      Ri(this, e), this.context = t, this._parent = n, this.index = r, this.type = t.buffer.set.types[t.buffer.buffer[r]];
    }
    return zi(e, [{
      key: "name",
      get: function get() {
        return this.type.name;
      }
    }, {
      key: "from",
      get: function get() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
      }
    }, {
      key: "to",
      get: function get() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
      }
    }, {
      key: "child",
      value: function value(t, n, r) {
        var i = this.context.buffer,
          o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
        return o < 0 ? null : new e(this.context, this, o);
      }
    }, {
      key: "firstChild",
      get: function get() {
        return this.child(1, 0, 4);
      }
    }, {
      key: "lastChild",
      get: function get() {
        return this.child(-1, 0, 4);
      }
    }, {
      key: "childAfter",
      value: function value(e) {
        return this.child(1, e, 2);
      }
    }, {
      key: "childBefore",
      value: function value(e) {
        return this.child(-1, e, -2);
      }
    }, {
      key: "enter",
      value: function value(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        if (r & hR.ExcludeBuffers) return null;
        var i = this.context.buffer,
          o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
        return o < 0 ? null : new e(this.context, this, o);
      }
    }, {
      key: "parent",
      get: function get() {
        return this._parent || this.context.parent.nextSignificantParent();
      }
    }, {
      key: "externalSibling",
      value: function value(e) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + e, e, 0, 4);
      }
    }, {
      key: "nextSibling",
      get: function get() {
        var t = this.context.buffer,
          n = t.buffer[this.index + 3];
        return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new e(this.context, this._parent, n) : this.externalSibling(1);
      }
    }, {
      key: "prevSibling",
      get: function get() {
        var t = this.context.buffer,
          n = this._parent ? this._parent.index + 4 : 0;
        return this.index == n ? this.externalSibling(-1) : new e(this.context, this._parent, t.findChild(n, this.index, -1, 0, 4));
      }
    }, {
      key: "cursor",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
        return new _R(this, e);
      }
    }, {
      key: "tree",
      get: function get() {
        return null;
      }
    }, {
      key: "toTree",
      value: function value() {
        var e = [],
          t = [],
          n = this.context.buffer,
          r = this.index + 4,
          i = n.buffer[this.index + 3];
        if (i > r) {
          var o = n.buffer[this.index + 1],
            a = n.buffer[this.index + 2];
          e.push(n.slice(r, i, o, a)), t.push(0);
        }
        return new pR(this.type, e, t, this.to - this.from);
      }
    }, {
      key: "resolve",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return kR(this, e, t, !1);
      }
    }, {
      key: "resolveInner",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return kR(this, e, t, !0);
      }
    }, {
      key: "enterUnfinishedNodesBefore",
      value: function value(e) {
        return bR(this, e);
      }
    }, {
      key: "toString",
      value: function value() {
        return this.context.buffer.childString(this.index);
      }
    }, {
      key: "getChild",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          r = xR(this, e, t, n);
        return r.length ? r[0] : null;
      }
    }, {
      key: "getChildren",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        return xR(this, e, t, n);
      }
    }, {
      key: "node",
      get: function get() {
        return this;
      }
    }, {
      key: "matchContext",
      value: function value(e) {
        return jR(this, e);
      }
    }]), e;
  }(),
  _R = function () {
    function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      if (Ri(this, e), this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof wR) this.yieldNode(t);else {
        this._tree = t.context.parent, this.buffer = t.context;
        for (var r = t._parent; r; r = r._parent) {
          this.stack.unshift(r.index);
        }
        this.bufferNode = t, this.yieldBuf(t.index);
      }
    }
    return zi(e, [{
      key: "name",
      get: function get() {
        return this.type.name;
      }
    }, {
      key: "yieldNode",
      value: function value(e) {
        return !!e && (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0);
      }
    }, {
      key: "yieldBuf",
      value: function value(e, t) {
        this.index = e;
        var n = this.buffer,
          r = n.start,
          i = n.buffer;
        return this.type = t || i.set.types[i.buffer[e]], this.from = r + i.buffer[e + 1], this.to = r + i.buffer[e + 2], !0;
      }
    }, {
      key: "yield",
      value: function value(e) {
        return !!e && (e instanceof wR ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)));
      }
    }, {
      key: "toString",
      value: function value() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
      }
    }, {
      key: "enterChild",
      value: function value(e, t, n) {
        if (!this.buffer) return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, t, n, this.mode));
        var r = this.buffer.buffer,
          i = r.findChild(this.index + 4, r.buffer[this.index + 3], e, t - this.buffer.start, n);
        return !(i < 0) && (this.stack.push(this.index), this.yieldBuf(i));
      }
    }, {
      key: "firstChild",
      value: function value() {
        return this.enterChild(1, 0, 4);
      }
    }, {
      key: "lastChild",
      value: function value() {
        return this.enterChild(-1, 0, 4);
      }
    }, {
      key: "childAfter",
      value: function value(e) {
        return this.enterChild(1, e, 2);
      }
    }, {
      key: "childBefore",
      value: function value(e) {
        return this.enterChild(-1, e, -2);
      }
    }, {
      key: "enter",
      value: function value(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.mode;
        return this.buffer ? !(n & hR.ExcludeBuffers) && this.enterChild(1, e, t) : this.yield(this._tree.enter(e, t, n));
      }
    }, {
      key: "parent",
      value: function value() {
        if (!this.buffer) return this.yieldNode(this.mode & hR.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        var e = this.mode & hR.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        return this.buffer = null, this.yieldNode(e);
      }
    }, {
      key: "sibling",
      value: function value(e) {
        if (!this.buffer) return !!this._tree._parent && this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode));
        var t = this.buffer.buffer,
          n = this.stack.length - 1;
        if (e < 0) {
          var r = n < 0 ? 0 : this.stack[n] + 4;
          if (this.index != r) return this.yieldBuf(t.findChild(r, this.index, -1, 0, 4));
        } else {
          var i = t.buffer[this.index + 3];
          if (i < (n < 0 ? t.buffer.length : t.buffer[this.stack[n] + 3])) return this.yieldBuf(i);
        }
        return n < 0 && this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode));
      }
    }, {
      key: "nextSibling",
      value: function value() {
        return this.sibling(1);
      }
    }, {
      key: "prevSibling",
      value: function value() {
        return this.sibling(-1);
      }
    }, {
      key: "atLastNode",
      value: function value(e) {
        var t,
          n,
          r = this.buffer;
        if (r) {
          if (e > 0) {
            if (this.index < r.buffer.buffer.length) return !1;
          } else for (var i = 0; i < this.index; i++) {
            if (r.buffer.buffer[i + 3] < this.index) return !1;
          }
          t = r.index, n = r.parent;
        } else {
          var o = this._tree;
          t = o.index, n = o._parent;
        }
        for (; n; t = (a = n).index, n = a._parent, a) {
          var a;
          if (t > -1) for (var s = t + e, u = e < 0 ? -1 : n._tree.children.length; s != u; s += e) {
            var c = n._tree.children[s];
            if (this.mode & hR.IncludeAnonymous || c instanceof gR || !c.type.isAnonymous || $R(c)) return !1;
          }
        }
        return !0;
      }
    }, {
      key: "move",
      value: function value(e, t) {
        if (t && this.enterChild(e, 0, 4)) return !0;
        for (;;) {
          if (this.sibling(e)) return !0;
          if (this.atLastNode(e) || !this.parent()) return !1;
        }
      }
    }, {
      key: "next",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        return this.move(1, e);
      }
    }, {
      key: "prev",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        return this.move(-1, e);
      }
    }, {
      key: "moveTo",
      value: function value(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0; (this.from == this.to || (t < 1 ? this.from >= e : this.from > e) || (t > -1 ? this.to <= e : this.to < e)) && this.parent();) {
          ;
        }
        for (; this.enterChild(1, e, t);) {
          ;
        }
        return this;
      }
    }, {
      key: "node",
      get: function get() {
        if (!this.buffer) return this._tree;
        var e = this.bufferNode,
          t = null,
          n = 0;
        if (e && e.context == this.buffer) e: for (var r = this.index, i = this.stack.length; i >= 0;) {
          for (var o = e; o; o = o._parent) {
            if (o.index == r) {
              if (r == this.index) return o;
              t = o, n = i + 1;
              break e;
            }
          }
          r = this.stack[--i];
        }
        for (var a = n; a < this.stack.length; a++) {
          t = new CR(this.buffer, t, this.stack[a]);
        }
        return this.bufferNode = new CR(this.buffer, t, this.index);
      }
    }, {
      key: "tree",
      get: function get() {
        return this.buffer ? null : this._tree._tree;
      }
    }, {
      key: "iterate",
      value: function value(e, t) {
        for (var n = 0;;) {
          var r = !1;
          if (this.type.isAnonymous || !1 !== e(this)) {
            if (this.firstChild()) {
              n++;
              continue;
            }
            this.type.isAnonymous || (r = !0);
          }
          for (; r && t && t(this), r = this.type.isAnonymous, !this.nextSibling();) {
            if (!n) return;
            this.parent(), n--, r = !0;
          }
        }
      }
    }, {
      key: "matchContext",
      value: function value(e) {
        if (!this.buffer) return jR(this.node, e);
        for (var t = this.buffer.buffer, n = t.set.types, r = e.length - 1, i = this.stack.length - 1; r >= 0; i--) {
          if (i < 0) return jR(this.node, e, r);
          var o = n[t.buffer[this.stack[i]]];
          if (!o.isAnonymous) {
            if (e[r] && e[r] != o.name) return !1;
            r--;
          }
        }
        return !0;
      }
    }]), e;
  }();
function $R(e) {
  return e.children.some(function (e) {
    return e instanceof gR || !e.type.isAnonymous || $R(e);
  });
}
function OR(e) {
  var t,
    n = e.buffer,
    r = e.nodeSet,
    i = e.maxBufferLength,
    o = void 0 === i ? 1024 : i,
    a = e.reused,
    s = void 0 === a ? [] : a,
    u = e.minRepeatType,
    c = void 0 === u ? r.types.length : u,
    l = Array.isArray(n) ? new mR(n, n.length) : n,
    f = r.types,
    h = 0,
    d = 0;
  function v(e, t, n, i, a) {
    for (var u = l.id, y = l.start, b = l.end, k = l.size, w = d; k < 0;) {
      if (l.next(), -1 == k) {
        var x = s[u];
        return n.push(x), void i.push(y - e);
      }
      if (-3 == k) return void (h = u);
      if (-4 == k) return void (d = u);
      throw new RangeError("Unrecognized record size: ".concat(k));
    }
    var j,
      S,
      C = f[u],
      _ = y - e;
    if (b - y <= o && (S = function (e, t) {
      var n = l.fork(),
        r = 0,
        i = 0,
        a = 0,
        s = n.end - o,
        u = {
          size: 0,
          start: 0,
          skip: 0
        };
      e: for (var f = n.pos - e; n.pos > f;) {
        var h = n.size;
        if (n.id == t && h >= 0) u.size = r, u.start = i, u.skip = a, a += 4, r += 4, n.next();else {
          var d = n.pos - h;
          if (h < 0 || d < f || n.start < s) break;
          var v = n.id >= c ? 4 : 0,
            p = n.start;
          for (n.next(); n.pos > d;) {
            if (n.size < 0) {
              if (-3 != n.size) break e;
              v += 4;
            } else n.id >= c && (v += 4);
            n.next();
          }
          i = p, r += h, a += v;
        }
      }
      (t < 0 || r == e) && (u.size = r, u.start = i, u.skip = a);
      return u.size > 4 ? u : void 0;
    }(l.pos - t, a))) {
      for (var $ = new Uint16Array(S.size - S.skip), O = l.pos - S.size, A = $.length; l.pos > O;) {
        A = g(S.start, $, A);
      }
      j = new gR($, b - S.start, r), _ = S.start - e;
    } else {
      var E = l.pos - k;
      l.next();
      for (var P = [], M = [], I = u >= c ? u : -1, T = 0, N = b; l.pos > E;) {
        I >= 0 && l.id == I && l.size >= 0 ? (l.end <= N - o && (p(P, M, y, T, l.end, N, I, w), T = P.length, N = l.end), l.next()) : v(y, E, P, M, I);
      }
      if (I >= 0 && T > 0 && T < P.length && p(P, M, y, T, y, N, I, w), P.reverse(), M.reverse(), I > -1 && T > 0) {
        var R = function (e) {
          return function (t, n, r) {
            var i,
              o,
              a = 0,
              s = t.length - 1;
            if (s >= 0 && (i = t[s]) instanceof pR) {
              if (!s && i.type == e && i.length == r) return i;
              (o = i.prop(cR.lookAhead)) && (a = n[s] + i.length + o);
            }
            return m(e, t, n, r, a);
          };
        }(C);
        j = PR(C, P, M, 0, P.length, 0, b - y, R, R);
      } else j = m(C, P, M, b - y, w - b);
    }
    n.push(j), i.push(_);
  }
  function p(e, t, n, i, o, a, s, u) {
    for (var c = [], l = []; e.length > i;) {
      c.push(e.pop()), l.push(t.pop() + n - o);
    }
    e.push(m(r.types[s], c, l, a - o, u - a)), t.push(o - n);
  }
  function m(e, t, n, r) {
    var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
      o = arguments.length > 5 ? arguments[5] : void 0;
    if (h) {
      var a = [cR.contextHash, h];
      o = o ? [a].concat(o) : [a];
    }
    if (i > 25) {
      var s = [cR.lookAhead, i];
      o = o ? [s].concat(o) : [s];
    }
    return new pR(e, t, n, r, o);
  }
  function g(e, t, n) {
    var r = l.id,
      i = l.start,
      o = l.end,
      a = l.size;
    if (l.next(), a >= 0 && r < c) {
      var s = n;
      if (a > 4) for (var u = l.pos - (a - 4); l.pos > u;) {
        n = g(e, t, n);
      }
      t[--n] = s, t[--n] = o - e, t[--n] = i - e, t[--n] = r;
    } else -3 == a ? h = r : -4 == a && (d = r);
    return n;
  }
  for (var y = [], b = []; l.pos > 0;) {
    v(e.start || 0, e.bufferStart || 0, y, b, -1);
  }
  var k = null !== (t = e.length) && void 0 !== t ? t : y.length ? b[0] + y[0].length : 0;
  return new pR(f[e.topID], y.reverse(), b.reverse(), k);
}
var AR = new WeakMap();
function ER(e, t) {
  if (!e.isAnonymous || t instanceof gR || t.type != e) return 1;
  var n = AR.get(t);
  if (null == n) {
    n = 1;
    var r,
      i = bi(t.children);
    try {
      for (i.s(); !(r = i.n()).done;) {
        var o = r.value;
        if (o.type != e || !(o instanceof pR)) {
          n = 1;
          break;
        }
        n += ER(e, o);
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
    AR.set(t, n);
  }
  return n;
}
function PR(e, t, n, r, i, o, a, s, u) {
  for (var c = 0, l = r; l < i; l++) {
    c += ER(e, t[l]);
  }
  var f = Math.ceil(1.5 * c / 8),
    h = [],
    d = [];
  return function t(n, r, i, a, s) {
    for (var c = i; c < a;) {
      var l = c,
        v = r[c],
        p = ER(e, n[c]);
      for (c++; c < a; c++) {
        var m = ER(e, n[c]);
        if (p + m >= f) break;
        p += m;
      }
      if (c == l + 1) {
        if (p > f) {
          var g = n[l];
          t(g.children, g.positions, 0, g.children.length, r[l] + s);
          continue;
        }
        h.push(n[l]);
      } else {
        var y = r[c - 1] + n[c - 1].length - v;
        h.push(PR(e, n, r, l, c, v, y, null, u));
      }
      d.push(v + s - o);
    }
  }(t, n, r, i, 0), (s || u)(h, d, a);
}
new cR({
  perNode: !0
});
function MR(e, t) {
  return function (n) {
    var r = n.state,
      i = n.dispatch;
    if (r.readOnly) return !1;
    var o = e(t, r);
    return !!o && (i(r.update(o)), !0);
  };
}
var IR = MR(LR, 0),
  TR = MR(zR, 0),
  NR = MR(function (e, t) {
    return zR(e, t, function (e) {
      var t,
        n = [],
        r = bi(e.selection.ranges);
      try {
        for (r.s(); !(t = r.n()).done;) {
          var i = t.value,
            o = e.doc.lineAt(i.from),
            a = i.to <= o.to ? o : e.doc.lineAt(i.to),
            s = n.length - 1;
          s >= 0 && n[s].to > o.from ? n[s].to = a.to : n.push({
            from: o.from,
            to: a.to
          });
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
      return n;
    }(t));
  }, 0);
function RR(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.selection.main.head,
    n = e.languageDataAt("commentTokens", t);
  return n.length ? n[0] : {};
}
function DR(e, t, n, r) {
  var i,
    o,
    a = t.open,
    s = t.close,
    u = e.sliceDoc(n - 50, n),
    c = e.sliceDoc(r, r + 50),
    l = /\s*$/.exec(u)[0].length,
    f = /^\s*/.exec(c)[0].length,
    h = u.length - l;
  if (u.slice(h - a.length, h) == a && c.slice(f, f + s.length) == s) return {
    open: {
      pos: n - l,
      margin: l && 1
    },
    close: {
      pos: r + f,
      margin: f && 1
    }
  };
  r - n <= 100 ? i = o = e.sliceDoc(n, r) : (i = e.sliceDoc(n, n + 50), o = e.sliceDoc(r - 50, r));
  var d = /^\s*/.exec(i)[0].length,
    v = /\s*$/.exec(o)[0].length,
    p = o.length - v - s.length;
  return i.slice(d, d + a.length) == a && o.slice(p, p + s.length) == s ? {
    open: {
      pos: n + d + a.length,
      margin: /\s/.test(i.charAt(d + a.length)) ? 1 : 0
    },
    close: {
      pos: r - v - s.length,
      margin: /\s/.test(o.charAt(p - 1)) ? 1 : 0
    }
  } : null;
}
function zR(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.selection.ranges,
    r = n.map(function (e) {
      return RR(t, e.from).block;
    });
  if (!r.every(function (e) {
    return e;
  })) return null;
  var i = n.map(function (e, n) {
    return DR(t, r[n], e.from, e.to);
  });
  if (2 != e && !i.every(function (e) {
    return e;
  })) return {
    changes: t.changes(n.map(function (e, t) {
      return i[t] ? [] : [{
        from: e.from,
        insert: r[t].open + " "
      }, {
        from: e.to,
        insert: " " + r[t].close
      }];
    }))
  };
  if (1 != e && i.some(function (e) {
    return e;
  })) {
    for (var o, a = [], s = 0; s < i.length; s++) {
      if (o = i[s]) {
        var u = r[s],
          c = o,
          l = c.open,
          f = c.close;
        a.push({
          from: l.pos - u.open.length,
          to: l.pos + l.margin
        }, {
          from: f.pos - f.margin,
          to: f.pos + u.close.length
        });
      }
    }
    return {
      changes: a
    };
  }
  return null;
}
function LR(e, t) {
  var n,
    r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.selection.ranges,
    i = [],
    o = -1,
    a = bi(r);
  try {
    for (a.s(); !(n = a.n()).done;) {
      for (var s = n.value, u = s.from, c = s.to, l = i.length, f = 1e9, h = u; h <= c;) {
        var d = t.doc.lineAt(h);
        if (d.from > o && (u == c || c > d.from)) {
          o = d.from;
          var v = RR(t, h).line;
          if (!v) continue;
          var p = /^\s*/.exec(d.text)[0].length,
            m = p == d.length,
            g = d.text.slice(p, p + v.length) == v ? p : -1;
          p < d.text.length && p < f && (f = p), i.push({
            line: d,
            comment: g,
            token: v,
            indent: p,
            empty: m,
            single: !1
          });
        }
        h = d.to + 1;
      }
      if (f < 1e9) for (var y = l; y < i.length; y++) {
        i[y].indent < i[y].line.text.length && (i[y].indent = f);
      }
      i.length == l + 1 && (i[l].single = !0);
    }
  } catch (e) {
    a.e(e);
  } finally {
    a.f();
  }
  if (2 != e && i.some(function (e) {
    return e.comment < 0 && (!e.empty || e.single);
  })) {
    var b,
      k = [],
      w = bi(i);
    try {
      for (w.s(); !(b = w.n()).done;) {
        var x = b.value,
          j = x.line,
          S = x.token,
          C = x.indent,
          _ = x.empty,
          $ = x.single;
        !$ && _ || k.push({
          from: j.from + C,
          insert: S + " "
        });
      }
    } catch (e) {
      w.e(e);
    } finally {
      w.f();
    }
    var O = t.changes(k);
    return {
      changes: O,
      selection: t.selection.map(O, 1)
    };
  }
  if (1 != e && i.some(function (e) {
    return e.comment >= 0;
  })) {
    var A,
      E = [],
      P = bi(i);
    try {
      for (P.s(); !(A = P.n()).done;) {
        var M = A.value,
          I = M.line,
          T = M.comment,
          N = M.token;
        if (T >= 0) {
          var R = I.from + T,
            D = R + N.length;
          " " == I.text[D - I.from] && D++, E.push({
            from: R,
            to: D
          });
        }
      }
    } catch (e) {
      P.e(e);
    } finally {
      P.f();
    }
    return {
      changes: E
    };
  }
  return null;
}
var BR = K_.define(),
  qR = K_.define(),
  FR = x_.define(),
  VR = x_.define({
    combine: function combine(e) {
      return l$(e, {
        minDepth: 100,
        newGroupDelay: 500
      }, {
        minDepth: Math.max,
        newGroupDelay: Math.min
      });
    }
  });
var HR = O_.define({
  create: function create() {
    return cD.empty;
  },
  update: function update(e, t) {
    var n,
      r,
      i = t.state.facet(VR),
      o = t.annotation(BR);
    if (o) {
      var a = t.docChanged ? b_.single((n = t.changes, r = 0, n.iterChangedRanges(function (e, t) {
          return r = t;
        }), r)) : void 0,
        s = eD.fromTransaction(t, a),
        u = o.side,
        c = 0 == u ? e.undone : e.done;
      return c = s ? tD(c, c.length, i.minDepth, s) : iD(c, t.startState.selection), new cD(0 == u ? o.rest : c, 0 == u ? c : o.rest);
    }
    var l = t.annotation(qR);
    if ("full" != l && "before" != l || (e = e.isolate()), !1 === t.annotation(Z_.addToHistory)) return t.changes.empty ? e : e.addMapping(t.changes.desc);
    var f = eD.fromTransaction(t),
      h = t.annotation(Z_.time),
      d = t.annotation(Z_.userEvent);
    return f ? e = e.addChanges(f, h, d, i.newGroupDelay, i.minDepth) : t.selection && (e = e.addSelection(t.startState.selection, h, d, i.newGroupDelay)), "full" != l && "after" != l || (e = e.isolate()), e;
  },
  toJSON: function toJSON(e) {
    return {
      done: e.done.map(function (e) {
        return e.toJSON();
      }),
      undone: e.undone.map(function (e) {
        return e.toJSON();
      })
    };
  },
  fromJSON: function fromJSON(e) {
    return new cD(e.done.map(eD.fromJSON), e.undone.map(eD.fromJSON));
  }
});
function WR() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return [HR, VR.of(e), CP.domEventHandlers({
    beforeinput: function beforeinput(e, t) {
      var n = "historyUndo" == e.inputType ? JR : "historyRedo" == e.inputType ? KR : null;
      return !!n && (e.preventDefault(), n(t));
    }
  })];
}
function UR(e, t) {
  return function (n) {
    var r = n.state,
      i = n.dispatch;
    if (!t && r.readOnly) return !1;
    var o = r.field(HR, !1);
    if (!o) return !1;
    var a = o.pop(e, r, t);
    return !!a && (i(a), !0);
  };
}
var JR = UR(0, !1),
  KR = UR(1, !1),
  GR = UR(0, !0),
  QR = UR(1, !0);
function YR(e) {
  return function (t) {
    var n = t.field(HR, !1);
    if (!n) return 0;
    var r = 0 == e ? n.done : n.undone;
    return r.length - (r.length && !r[0].changes ? 1 : 0);
  };
}
var ZR = YR(0),
  XR = YR(1),
  eD = function () {
    function e(t, n, r, i, o) {
      Ri(this, e), this.changes = t, this.effects = n, this.mapped = r, this.startSelection = i, this.selectionsAfter = o;
    }
    return zi(e, [{
      key: "setSelAfter",
      value: function value(t) {
        return new e(this.changes, this.effects, this.mapped, this.startSelection, t);
      }
    }, {
      key: "toJSON",
      value: function value() {
        var e, t, n;
        return {
          changes: null === (e = this.changes) || void 0 === e ? void 0 : e.toJSON(),
          mapped: null === (t = this.mapped) || void 0 === t ? void 0 : t.toJSON(),
          startSelection: null === (n = this.startSelection) || void 0 === n ? void 0 : n.toJSON(),
          selectionsAfter: this.selectionsAfter.map(function (e) {
            return e.toJSON();
          })
        };
      }
    }], [{
      key: "fromJSON",
      value: function value(t) {
        return new e(t.changes && f_.fromJSON(t.changes), [], t.mapped && l_.fromJSON(t.mapped), t.startSelection && b_.fromJSON(t.startSelection), t.selectionsAfter.map(b_.fromJSON));
      }
    }, {
      key: "fromTransaction",
      value: function value(t, n) {
        var r,
          i = rD,
          o = bi(t.startState.facet(FR));
        try {
          for (o.s(); !(r = o.n()).done;) {
            var a = (0, r.value)(t);
            a.length && (i = i.concat(a));
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        return !i.length && t.changes.empty ? null : new e(t.changes.invert(t.startState.doc), i, void 0, n || t.startState.selection, rD);
      }
    }, {
      key: "selection",
      value: function value(t) {
        return new e(void 0, rD, void 0, void 0, t);
      }
    }]), e;
  }();
function tD(e, t, n, r) {
  var i = t + 1 > n + 20 ? t - n - 1 : 0,
    o = e.slice(i, t);
  return o.push(r), o;
}
function nD(e, t) {
  return e.length ? t.length ? e.concat(t) : e : t;
}
var rD = [];
function iD(e, t) {
  if (e.length) {
    var n = e[e.length - 1],
      r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - 200));
    return r.length && r[r.length - 1].eq(t) ? e : (r.push(t), tD(e, e.length - 1, 1e9, n.setSelAfter(r)));
  }
  return [eD.selection([t])];
}
function oD(e) {
  var t = e[e.length - 1],
    n = e.slice();
  return n[e.length - 1] = t.setSelAfter(t.selectionsAfter.slice(0, t.selectionsAfter.length - 1)), n;
}
function aD(e, t) {
  if (!e.length) return e;
  for (var n = e.length, r = rD; n;) {
    var i = sD(e[n - 1], t, r);
    if (i.changes && !i.changes.empty || i.effects.length) {
      var o = e.slice(0, n);
      return o[n - 1] = i, o;
    }
    t = i.mapped, n--, r = i.selectionsAfter;
  }
  return r.length ? [eD.selection(r)] : rD;
}
function sD(e, t, n) {
  var r = nD(e.selectionsAfter.length ? e.selectionsAfter.map(function (e) {
    return e.map(t);
  }) : rD, n);
  if (!e.changes) return eD.selection(r);
  var i = e.changes.map(t),
    o = t.mapDesc(e.changes, !0),
    a = e.mapped ? e.mapped.composeDesc(o) : o;
  return new eD(i, Y_.mapEffects(e.effects, t), a, e.startSelection.map(o), r);
}
var uD = /^(input\.type|delete)($|\.)/,
  cD = function () {
    function e(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : void 0;
      Ri(this, e), this.done = t, this.undone = n, this.prevTime = r, this.prevUserEvent = i;
    }
    return zi(e, [{
      key: "isolate",
      value: function value() {
        return this.prevTime ? new e(this.done, this.undone) : this;
      }
    }, {
      key: "addChanges",
      value: function value(t, n, r, i, o) {
        var a = this.done,
          s = a[a.length - 1];
        return new e(a = s && s.changes && !s.changes.empty && t.changes && (!r || uD.test(r)) && (!s.selectionsAfter.length && n - this.prevTime < i && function (e, t) {
          var n = [],
            r = !1;
          return e.iterChangedRanges(function (e, t) {
            return n.push(e, t);
          }), t.iterChangedRanges(function (e, t, i, o) {
            for (var a = 0; a < n.length;) {
              var s = n[a++],
                u = n[a++];
              o >= s && i <= u && (r = !0);
            }
          }), r;
        }(s.changes, t.changes) || "input.type.compose" == r) ? tD(a, a.length - 1, o, new eD(t.changes.compose(s.changes), nD(t.effects, s.effects), s.mapped, s.startSelection, rD)) : tD(a, a.length, o, t), rD, n, r);
      }
    }, {
      key: "addSelection",
      value: function value(t, n, r, i) {
        var o,
          a,
          s = this.done.length ? this.done[this.done.length - 1].selectionsAfter : rD;
        return s.length > 0 && n - this.prevTime < i && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && (o = s[s.length - 1], a = t, o.ranges.length == a.ranges.length && 0 === o.ranges.filter(function (e, t) {
          return e.empty != a.ranges[t].empty;
        }).length) ? this : new e(iD(this.done, t), this.undone, n, r);
      }
    }, {
      key: "addMapping",
      value: function value(t) {
        return new e(aD(this.done, t), aD(this.undone, t), this.prevTime, this.prevUserEvent);
      }
    }, {
      key: "pop",
      value: function value(e, t, n) {
        var r = 0 == e ? this.done : this.undone;
        if (0 == r.length) return null;
        var i = r[r.length - 1];
        if (n && i.selectionsAfter.length) return t.update({
          selection: i.selectionsAfter[i.selectionsAfter.length - 1],
          annotations: BR.of({
            side: e,
            rest: oD(r)
          }),
          userEvent: 0 == e ? "select.undo" : "select.redo",
          scrollIntoView: !0
        });
        if (i.changes) {
          var o = 1 == r.length ? rD : r.slice(0, r.length - 1);
          return i.mapped && (o = aD(o, i.mapped)), t.update({
            changes: i.changes,
            selection: i.startSelection,
            effects: i.effects,
            annotations: BR.of({
              side: e,
              rest: o
            }),
            filter: !1,
            userEvent: 0 == e ? "undo" : "redo",
            scrollIntoView: !0
          });
        }
        return null;
      }
    }]), e;
  }();
cD.empty = new cD(rD, rD);
var lD = [{
  key: "Mod-z",
  run: JR,
  preventDefault: !0
}, {
  key: "Mod-y",
  mac: "Mod-Shift-z",
  run: KR,
  preventDefault: !0
}, {
  key: "Mod-u",
  run: GR,
  preventDefault: !0
}, {
  key: "Alt-u",
  mac: "Mod-Shift-u",
  run: QR,
  preventDefault: !0
}];
function fD(e, t) {
  return b_.create(e.ranges.map(t), e.mainIndex);
}
function hD(e, t) {
  return e.update({
    selection: t,
    scrollIntoView: !0,
    userEvent: "select"
  });
}
function dD(e, t) {
  var n = e.state,
    r = e.dispatch,
    i = fD(n.selection, t);
  return !i.eq(n.selection) && (r(hD(n, i)), !0);
}
function vD(e, t) {
  return b_.cursor(t ? e.to : e.from);
}
function pD(e, t) {
  return dD(e, function (n) {
    return n.empty ? e.moveByChar(n, t) : vD(n, t);
  });
}
function mD(e) {
  return e.textDirectionAt(e.state.selection.main.head) == _A.LTR;
}
var gD = function gD(e) {
    return pD(e, !mD(e));
  },
  yD = function yD(e) {
    return pD(e, mD(e));
  };
function bD(e, t) {
  return dD(e, function (n) {
    return n.empty ? e.moveByGroup(n, t) : vD(n, t);
  });
}
function kD(e, t, n) {
  if (t.type.prop(n)) return !0;
  var r = t.to - t.from;
  return r && (r > 2 || /[^\s,.;:]/.test(e.sliceDoc(t.from, t.to))) || t.firstChild;
}
function wD(e, t, n) {
  for (var r = qT(e).resolveInner(t.head), i = n ? cR.closedBy : cR.openedBy, o = t.head;;) {
    var a = n ? r.childAfter(o) : r.childBefore(o);
    if (!a) break;
    kD(e, a, i) ? r = a : o = n ? a.to : a.from;
  }
  var s, u;
  return u = r.type.prop(i) && (s = n ? KN(e, r.from, 1) : KN(e, r.to, -1)) && s.matched ? n ? s.end.to : s.end.from : n ? r.to : r.from, b_.cursor(u, n ? -1 : 1);
}
function xD(e, t) {
  return dD(e, function (n) {
    if (!n.empty) return vD(n, t);
    var r = e.moveVertically(n, t);
    return r.head != n.head ? r : e.moveToLineBoundary(n, t);
  });
}
var jD = function jD(e) {
    return xD(e, !1);
  },
  SD = function SD(e) {
    return xD(e, !0);
  };
function CD(e) {
  return Math.max(e.defaultLineHeight, Math.min(e.dom.clientHeight, innerHeight) - 5);
}
function _D(e, t) {
  var n = e.state,
    r = fD(n.selection, function (n) {
      return n.empty ? e.moveVertically(n, t, CD(e)) : vD(n, t);
    });
  if (r.eq(n.selection)) return !1;
  var i,
    o = e.coordsAtPos(n.selection.main.head),
    a = e.scrollDOM.getBoundingClientRect();
  return o && o.top > a.top && o.bottom < a.bottom && o.top - a.top <= e.scrollDOM.scrollHeight - e.scrollDOM.scrollTop - e.scrollDOM.clientHeight && (i = CP.scrollIntoView(r.main.head, {
    y: "start",
    yMargin: o.top - a.top
  })), e.dispatch(hD(n, r), {
    effects: i
  }), !0;
}
var $D = function $D(e) {
    return _D(e, !1);
  },
  OD = function OD(e) {
    return _D(e, !0);
  };
function AD(e, t, n) {
  var r = e.lineBlockAt(t.head),
    i = e.moveToLineBoundary(t, n);
  if (i.head == t.head && i.head != (n ? r.to : r.from) && (i = e.moveToLineBoundary(t, n, !1)), !n && i.head == r.from && r.length) {
    var o = /^\s*/.exec(e.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    o && t.head != r.from + o && (i = b_.cursor(r.from + o));
  }
  return i;
}
var ED = function ED(e) {
    return dD(e, function (t) {
      return AD(e, t, !0);
    });
  },
  PD = function PD(e) {
    return dD(e, function (t) {
      return AD(e, t, !1);
    });
  };
function MD(e, t) {
  var n = fD(e.state.selection, function (e) {
    var n = t(e);
    return b_.range(e.anchor, n.head, n.goalColumn);
  });
  return !n.eq(e.state.selection) && (e.dispatch(hD(e.state, n)), !0);
}
function ID(e, t) {
  return MD(e, function (n) {
    return e.moveByChar(n, t);
  });
}
var TD = function TD(e) {
    return ID(e, !mD(e));
  },
  ND = function ND(e) {
    return ID(e, mD(e));
  };
function RD(e, t) {
  return MD(e, function (n) {
    return e.moveByGroup(n, t);
  });
}
function DD(e, t) {
  return MD(e, function (n) {
    return e.moveVertically(n, t);
  });
}
var zD = function zD(e) {
    return DD(e, !1);
  },
  LD = function LD(e) {
    return DD(e, !0);
  };
function BD(e, t) {
  return MD(e, function (n) {
    return e.moveVertically(n, t, CD(e));
  });
}
var qD = function qD(e) {
    return BD(e, !1);
  },
  FD = function FD(e) {
    return BD(e, !0);
  },
  VD = function VD(e) {
    return MD(e, function (t) {
      return AD(e, t, !0);
    });
  },
  HD = function HD(e) {
    return MD(e, function (t) {
      return AD(e, t, !1);
    });
  },
  WD = function WD(e) {
    var t = e.state;
    return (0, e.dispatch)(hD(t, {
      anchor: 0
    })), !0;
  },
  UD = function UD(e) {
    var t = e.state;
    return (0, e.dispatch)(hD(t, {
      anchor: t.doc.length
    })), !0;
  },
  JD = function JD(e) {
    var t = e.state;
    return (0, e.dispatch)(hD(t, {
      anchor: t.selection.main.anchor,
      head: 0
    })), !0;
  },
  KD = function KD(e) {
    var t = e.state;
    return (0, e.dispatch)(hD(t, {
      anchor: t.selection.main.anchor,
      head: t.doc.length
    })), !0;
  };
function GD(e, t) {
  var n = e.state,
    r = e.dispatch;
  if (n.readOnly) return !1;
  var i = "delete.selection",
    o = n.changeByRange(function (e) {
      var n = e.from,
        r = e.to;
      if (n == r) {
        var o = t(n);
        o < n ? i = "delete.backward" : o > n && (i = "delete.forward"), n = Math.min(n, o), r = Math.max(r, o);
      }
      return n == r ? {
        range: e
      } : {
        changes: {
          from: n,
          to: r
        },
        range: b_.cursor(n)
      };
    });
  return !o.changes.empty && (r(n.update(o, {
    scrollIntoView: !0,
    userEvent: i
  })), !0);
}
function QD(e, t, n) {
  if (e instanceof CP) {
    var r,
      i = bi(e.state.facet(CP.atomicRanges).map(function (t) {
        return t(e);
      }));
    try {
      for (i.s(); !(r = i.n()).done;) {
        r.value.between(t, t, function (e, r) {
          e < t && r > t && (t = n ? r : e);
        });
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
  }
  return t;
}
var YD = function YD(e, t) {
    return GD(e, function (n) {
      var r,
        i,
        o = e.state,
        a = o.doc.lineAt(n);
      if (!t && n > a.from && n < a.from + 200 && !/[^ \t]/.test(r = a.text.slice(0, n - a.from))) {
        if ("\t" == r[r.length - 1]) return n - 1;
        for (var s = O$(r, o.tabSize) % eN(o) || eN(o), u = 0; u < s && " " == r[r.length - 1 - u]; u++) {
          n--;
        }
        i = n;
      } else (i = e_(a.text, n - a.from, t, t) + a.from) == n && a.number != (t ? o.doc.lines : 1) && (i += t ? 1 : -1);
      return QD(e, i, t);
    });
  },
  ZD = function ZD(e) {
    return YD(e, !1);
  },
  XD = function XD(e) {
    return YD(e, !0);
  },
  ez = function ez(e, t) {
    return GD(e, function (n) {
      for (var r = n, i = e.state, o = i.doc.lineAt(r), a = i.charCategorizer(r), s = null;;) {
        if (r == (t ? o.to : o.from)) {
          r == n && o.number != (t ? i.doc.lines : 1) && (r += t ? 1 : -1);
          break;
        }
        var u = e_(o.text, r - o.from, t) + o.from,
          c = o.text.slice(Math.min(r, u) - o.from, Math.max(r, u) - o.from),
          l = a(c);
        if (null != s && l != s) break;
        " " == c && r == n || (s = l), r = u;
      }
      return QD(e, r, t);
    });
  },
  tz = function tz(e) {
    return ez(e, !1);
  },
  nz = function nz(e) {
    return GD(e, function (t) {
      var n = e.lineBlockAt(t).to;
      return QD(e, t < n ? n : Math.min(e.state.doc.length, t + 1), !0);
    });
  };
function rz(e) {
  var t,
    n = [],
    r = -1,
    i = bi(e.selection.ranges);
  try {
    for (i.s(); !(t = i.n()).done;) {
      var o = t.value,
        a = e.doc.lineAt(o.from),
        s = e.doc.lineAt(o.to);
      if (o.empty || o.to != s.from || (s = e.doc.lineAt(o.to - 1)), r >= a.number) {
        var u = n[n.length - 1];
        u.to = s.to, u.ranges.push(o);
      } else n.push({
        from: a.from,
        to: s.to,
        ranges: [o]
      });
      r = s.number + 1;
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }
  return n;
}
function iz(e, t, n) {
  if (e.readOnly) return !1;
  var r,
    i = [],
    o = [],
    a = bi(rz(e));
  try {
    for (a.s(); !(r = a.n()).done;) {
      var s = r.value;
      if (n ? s.to != e.doc.length : 0 != s.from) {
        var u = e.doc.lineAt(n ? s.to + 1 : s.from - 1),
          c = u.length + 1;
        if (n) {
          i.push({
            from: s.to,
            to: u.to
          }, {
            from: s.from,
            insert: u.text + e.lineBreak
          });
          var l,
            f = bi(s.ranges);
          try {
            for (f.s(); !(l = f.n()).done;) {
              var h = l.value;
              o.push(b_.range(Math.min(e.doc.length, h.anchor + c), Math.min(e.doc.length, h.head + c)));
            }
          } catch (e) {
            f.e(e);
          } finally {
            f.f();
          }
        } else {
          i.push({
            from: u.from,
            to: s.from
          }, {
            from: s.to,
            insert: e.lineBreak + u.text
          });
          var d,
            v = bi(s.ranges);
          try {
            for (v.s(); !(d = v.n()).done;) {
              var p = d.value;
              o.push(b_.range(p.anchor - c, p.head - c));
            }
          } catch (e) {
            v.e(e);
          } finally {
            v.f();
          }
        }
      }
    }
  } catch (e) {
    a.e(e);
  } finally {
    a.f();
  }
  return !!i.length && (t(e.update({
    changes: i,
    scrollIntoView: !0,
    selection: b_.create(o, e.selection.mainIndex),
    userEvent: "move.line"
  })), !0);
}
function oz(e, t, n) {
  if (e.readOnly) return !1;
  var r,
    i = [],
    o = bi(rz(e));
  try {
    for (o.s(); !(r = o.n()).done;) {
      var a = r.value;
      n ? i.push({
        from: a.from,
        insert: e.doc.slice(a.from, a.to) + e.lineBreak
      }) : i.push({
        from: a.to,
        insert: e.lineBreak + e.doc.slice(a.from, a.to)
      });
    }
  } catch (e) {
    o.e(e);
  } finally {
    o.f();
  }
  return t(e.update({
    changes: i,
    scrollIntoView: !0,
    userEvent: "input.copyline"
  })), !0;
}
var az = sz(!1);
function sz(e) {
  return function (t) {
    var n = t.state,
      r = t.dispatch;
    if (n.readOnly) return !1;
    var i = n.changeByRange(function (t) {
      var r = t.from,
        i = t.to,
        o = n.doc.lineAt(r),
        a = !e && r == i && function (e, t) {
          if (/\(\)|\[\]|\{\}/.test(e.sliceDoc(t - 1, t + 1))) return {
            from: t,
            to: t
          };
          var n,
            r = qT(e).resolveInner(t),
            i = r.childBefore(t),
            o = r.childAfter(t);
          return i && o && i.to <= t && o.from >= t && (n = i.type.prop(cR.closedBy)) && n.indexOf(o.name) > -1 && e.doc.lineAt(i.to).from == e.doc.lineAt(o.from).from ? {
            from: i.to,
            to: o.from
          } : null;
        }(n, r);
      e && (r = i = (i <= o.to ? o : n.doc.lineAt(i)).to);
      var s = new rN(n, {
          simulateBreak: r,
          simulateDoubleBreak: !!a
        }),
        u = nN(s, r);
      for (null == u && (u = /^\s*/.exec(n.doc.lineAt(r).text)[0].length); i < o.to && /\s/.test(o.text[i - o.from]);) {
        i++;
      }
      a ? (r = a.from, i = a.to) : r > o.from && r < o.from + 100 && !/\S/.test(o.text.slice(0, r)) && (r = o.from);
      var c = ["", tN(n, u)];
      return a && c.push(tN(n, s.lineIndent(o.from, -1))), {
        changes: {
          from: r,
          to: i,
          insert: BC.of(c)
        },
        range: b_.cursor(r + 1 + c[1].length)
      };
    });
    return r(n.update(i, {
      scrollIntoView: !0,
      userEvent: "input"
    })), !0;
  };
}
function uz(e, t) {
  var n = -1;
  return e.changeByRange(function (r) {
    for (var i = [], o = r.from; o <= r.to;) {
      var a = e.doc.lineAt(o);
      a.number > n && (r.empty || r.to > a.from) && (t(a, i, r), n = a.number), o = a.to + 1;
    }
    var s = e.changes(i);
    return {
      changes: i,
      range: b_.range(s.mapPos(r.anchor, 1), s.mapPos(r.head, 1))
    };
  });
}
var cz = function cz(e) {
    var t = e.state,
      n = e.dispatch;
    return !t.readOnly && (n(t.update(uz(t, function (e, n) {
      n.push({
        from: e.from,
        insert: t.facet(XT)
      });
    }), {
      userEvent: "input.indent"
    })), !0);
  },
  lz = function lz(e) {
    var t = e.state,
      n = e.dispatch;
    return !t.readOnly && (n(t.update(uz(t, function (e, n) {
      var r = /^\s*/.exec(e.text)[0];
      if (r) {
        for (var i = O$(r, t.tabSize), o = 0, a = tN(t, Math.max(0, i - eN(t))); o < r.length && o < a.length && r.charCodeAt(o) == a.charCodeAt(o);) {
          o++;
        }
        n.push({
          from: e.from + o,
          to: e.from + r.length,
          insert: a.slice(o)
        });
      }
    }), {
      userEvent: "delete.dedent"
    })), !0);
  },
  fz = [{
    key: "Alt-ArrowLeft",
    mac: "Ctrl-ArrowLeft",
    run: function run(e) {
      return dD(e, function (t) {
        return wD(e.state, t, !mD(e));
      });
    },
    shift: function shift(e) {
      return MD(e, function (t) {
        return wD(e.state, t, !mD(e));
      });
    }
  }, {
    key: "Alt-ArrowRight",
    mac: "Ctrl-ArrowRight",
    run: function run(e) {
      return dD(e, function (t) {
        return wD(e.state, t, mD(e));
      });
    },
    shift: function shift(e) {
      return MD(e, function (t) {
        return wD(e.state, t, mD(e));
      });
    }
  }, {
    key: "Alt-ArrowUp",
    run: function run(e) {
      return iz(e.state, e.dispatch, !1);
    }
  }, {
    key: "Shift-Alt-ArrowUp",
    run: function run(e) {
      return oz(e.state, e.dispatch, !1);
    }
  }, {
    key: "Alt-ArrowDown",
    run: function run(e) {
      return iz(e.state, e.dispatch, !0);
    }
  }, {
    key: "Shift-Alt-ArrowDown",
    run: function run(e) {
      return oz(e.state, e.dispatch, !0);
    }
  }, {
    key: "Escape",
    run: function run(e) {
      var t = e.state,
        n = e.dispatch,
        r = t.selection,
        i = null;
      return r.ranges.length > 1 ? i = b_.create([r.main]) : r.main.empty || (i = b_.create([b_.cursor(r.main.head)])), !!i && (n(hD(t, i)), !0);
    }
  }, {
    key: "Mod-Enter",
    run: sz(!0)
  }, {
    key: "Alt-l",
    mac: "Ctrl-l",
    run: function run(e) {
      var t = e.state,
        n = e.dispatch,
        r = rz(t).map(function (e) {
          var n = e.from,
            r = e.to;
          return b_.range(n, Math.min(r + 1, t.doc.length));
        });
      return n(t.update({
        selection: b_.create(r),
        userEvent: "select"
      })), !0;
    }
  }, {
    key: "Mod-i",
    run: function run(e) {
      var t = e.state,
        n = e.dispatch,
        r = fD(t.selection, function (e) {
          for (var n, r = qT(t).resolveInner(e.head, 1); !(r.from < e.from && r.to >= e.to || r.to > e.to && r.from <= e.from) && (null === (n = r.parent) || void 0 === n ? void 0 : n.parent);) {
            r = r.parent;
          }
          return b_.range(r.to, r.from);
        });
      return n(hD(t, r)), !0;
    },
    preventDefault: !0
  }, {
    key: "Mod-[",
    run: lz
  }, {
    key: "Mod-]",
    run: cz
  }, {
    key: "Mod-Alt-\\",
    run: function run(e) {
      var t = e.state,
        n = e.dispatch;
      if (t.readOnly) return !1;
      var r = Object.create(null),
        i = new rN(t, {
          overrideIndentation: function overrideIndentation(e) {
            var t = r[e];
            return null == t ? -1 : t;
          }
        }),
        o = uz(t, function (e, n, o) {
          var a = nN(i, e.from);
          if (null != a) {
            /\S/.test(e.text) || (a = 0);
            var s = /^\s*/.exec(e.text)[0],
              u = tN(t, a);
            (s != u || o.from < e.from + s.length) && (r[e.from] = a, n.push({
              from: e.from,
              to: e.from + s.length,
              insert: u
            }));
          }
        });
      return o.changes.empty || n(t.update(o, {
        userEvent: "indent"
      })), !0;
    }
  }, {
    key: "Shift-Mod-k",
    run: function run(e) {
      if (e.state.readOnly) return !1;
      var t = e.state,
        n = t.changes(rz(t).map(function (e) {
          var n = e.from,
            r = e.to;
          return n > 0 ? n-- : r < t.doc.length && r++, {
            from: n,
            to: r
          };
        })),
        r = fD(t.selection, function (t) {
          return e.moveVertically(t, !0);
        }).map(n);
      return e.dispatch({
        changes: n,
        selection: r,
        scrollIntoView: !0,
        userEvent: "delete.line"
      }), !0;
    }
  }, {
    key: "Shift-Mod-\\",
    run: function run(e) {
      return function (e, t, n) {
        var r = !1,
          i = fD(e.selection, function (t) {
            var i = KN(e, t.head, -1) || KN(e, t.head, 1) || t.head > 0 && KN(e, t.head - 1, 1) || t.head < e.doc.length && KN(e, t.head + 1, -1);
            if (!i || !i.end) return t;
            r = !0;
            var o = i.start.from == t.head ? i.end.to : i.end.from;
            return n ? b_.range(t.anchor, o) : b_.cursor(o);
          });
        return !!r && (t(hD(e, i)), !0);
      }(e.state, e.dispatch, !1);
    }
  }, {
    key: "Mod-/",
    run: function run(e) {
      var t = RR(e.state);
      return t.line ? IR(e) : !!t.block && NR(e);
    }
  }, {
    key: "Alt-A",
    run: TR
  }].concat([{
    key: "ArrowLeft",
    run: gD,
    shift: TD,
    preventDefault: !0
  }, {
    key: "Mod-ArrowLeft",
    mac: "Alt-ArrowLeft",
    run: function run(e) {
      return bD(e, !mD(e));
    },
    shift: function shift(e) {
      return RD(e, !mD(e));
    }
  }, {
    mac: "Cmd-ArrowLeft",
    run: PD,
    shift: HD
  }, {
    key: "ArrowRight",
    run: yD,
    shift: ND,
    preventDefault: !0
  }, {
    key: "Mod-ArrowRight",
    mac: "Alt-ArrowRight",
    run: function run(e) {
      return bD(e, mD(e));
    },
    shift: function shift(e) {
      return RD(e, mD(e));
    }
  }, {
    mac: "Cmd-ArrowRight",
    run: ED,
    shift: VD
  }, {
    key: "ArrowUp",
    run: jD,
    shift: zD,
    preventDefault: !0
  }, {
    mac: "Cmd-ArrowUp",
    run: WD,
    shift: JD
  }, {
    mac: "Ctrl-ArrowUp",
    run: $D,
    shift: qD
  }, {
    key: "ArrowDown",
    run: SD,
    shift: LD,
    preventDefault: !0
  }, {
    mac: "Cmd-ArrowDown",
    run: UD,
    shift: KD
  }, {
    mac: "Ctrl-ArrowDown",
    run: OD,
    shift: FD
  }, {
    key: "PageUp",
    run: $D,
    shift: qD
  }, {
    key: "PageDown",
    run: OD,
    shift: FD
  }, {
    key: "Home",
    run: PD,
    shift: HD,
    preventDefault: !0
  }, {
    key: "Mod-Home",
    run: WD,
    shift: JD
  }, {
    key: "End",
    run: ED,
    shift: VD,
    preventDefault: !0
  }, {
    key: "Mod-End",
    run: UD,
    shift: KD
  }, {
    key: "Enter",
    run: az
  }, {
    key: "Mod-a",
    run: function run(e) {
      var t = e.state;
      return (0, e.dispatch)(t.update({
        selection: {
          anchor: 0,
          head: t.doc.length
        },
        userEvent: "select"
      })), !0;
    }
  }, {
    key: "Backspace",
    run: ZD,
    shift: ZD
  }, {
    key: "Delete",
    run: XD
  }, {
    key: "Mod-Backspace",
    mac: "Alt-Backspace",
    run: tz
  }, {
    key: "Mod-Delete",
    mac: "Alt-Delete",
    run: function run(e) {
      return ez(e, !0);
    }
  }, {
    mac: "Mod-Backspace",
    run: function run(e) {
      return GD(e, function (t) {
        var n = e.lineBlockAt(t).from;
        return QD(e, t > n ? n : Math.max(0, t - 1), !1);
      });
    }
  }, {
    mac: "Mod-Delete",
    run: nz
  }].concat([{
    key: "Ctrl-b",
    run: gD,
    shift: TD,
    preventDefault: !0
  }, {
    key: "Ctrl-f",
    run: yD,
    shift: ND
  }, {
    key: "Ctrl-p",
    run: jD,
    shift: zD
  }, {
    key: "Ctrl-n",
    run: SD,
    shift: LD
  }, {
    key: "Ctrl-a",
    run: function run(e) {
      return dD(e, function (t) {
        return b_.cursor(e.lineBlockAt(t.head).from, 1);
      });
    },
    shift: function shift(e) {
      return MD(e, function (t) {
        return b_.cursor(e.lineBlockAt(t.head).from);
      });
    }
  }, {
    key: "Ctrl-e",
    run: function run(e) {
      return dD(e, function (t) {
        return b_.cursor(e.lineBlockAt(t.head).to, -1);
      });
    },
    shift: function shift(e) {
      return MD(e, function (t) {
        return b_.cursor(e.lineBlockAt(t.head).to);
      });
    }
  }, {
    key: "Ctrl-d",
    run: XD
  }, {
    key: "Ctrl-h",
    run: ZD
  }, {
    key: "Ctrl-k",
    run: nz
  }, {
    key: "Ctrl-Alt-h",
    run: tz
  }, {
    key: "Ctrl-o",
    run: function run(e) {
      var t = e.state,
        n = e.dispatch;
      if (t.readOnly) return !1;
      var r = t.changeByRange(function (e) {
        return {
          changes: {
            from: e.from,
            to: e.to,
            insert: BC.of(["", ""])
          },
          range: b_.cursor(e.from)
        };
      });
      return n(t.update(r, {
        scrollIntoView: !0,
        userEvent: "input"
      })), !0;
    }
  }, {
    key: "Ctrl-t",
    run: function run(e) {
      var t = e.state,
        n = e.dispatch;
      if (t.readOnly) return !1;
      var r = t.changeByRange(function (e) {
        if (!e.empty || 0 == e.from || e.from == t.doc.length) return {
          range: e
        };
        var n = e.from,
          r = t.doc.lineAt(n),
          i = n == r.from ? n - 1 : e_(r.text, n - r.from, !1) + r.from,
          o = n == r.to ? n + 1 : e_(r.text, n - r.from, !0) + r.from;
        return {
          changes: {
            from: i,
            to: o,
            insert: t.doc.slice(n, o).append(t.doc.slice(i, n))
          },
          range: b_.cursor(o)
        };
      });
      return !r.changes.empty && (n(t.update(r, {
        scrollIntoView: !0,
        userEvent: "move.character"
      })), !0);
    }
  }, {
    key: "Ctrl-v",
    run: OD
  }].map(function (e) {
    return {
      mac: e.key,
      run: e.run,
      shift: e.shift
    };
  }))),
  hz = {
    key: "Tab",
    run: cz,
    shift: lz
  };
function dz() {
  var e = arguments[0];
  "string" == typeof e && (e = document.createElement(e));
  var t = 1,
    n = arguments[1];
  if (n && "object" == Li(n) && null == n.nodeType && !Array.isArray(n)) {
    for (var r in n) {
      if (Object.prototype.hasOwnProperty.call(n, r)) {
        var i = n[r];
        "string" == typeof i ? e.setAttribute(r, i) : null != i && (e[r] = i);
      }
    }
    t++;
  }
  for (; t < arguments.length; t++) {
    vz(e, arguments[t]);
  }
  return e;
}
function vz(e, t) {
  if ("string" == typeof t) e.appendChild(document.createTextNode(t));else if (null == t) ;else if (null != t.nodeType) e.appendChild(t);else {
    if (!Array.isArray(t)) throw new RangeError("Unsupported child node: " + t);
    for (var n = 0; n < t.length; n++) {
      vz(e, t[n]);
    }
  }
}
var pz = "function" == typeof String.prototype.normalize ? function (e) {
    return e.normalize("NFKD");
  } : function (e) {
    return e;
  },
  mz = function () {
    function e(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.length,
        o = arguments.length > 4 ? arguments[4] : void 0;
      Ri(this, e), this.value = {
        from: 0,
        to: 0
      }, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = t.iterRange(r, i), this.bufferStart = r, this.normalize = o ? function (e) {
        return o(pz(e));
      } : pz, this.query = this.normalize(n);
    }
    return zi(e, [{
      key: "peek",
      value: function value() {
        if (this.bufferPos == this.buffer.length) {
          if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done) return -1;
          this.bufferPos = 0, this.buffer = this.iter.value;
        }
        return o_(this.buffer, this.bufferPos);
      }
    }, {
      key: "next",
      value: function value() {
        for (; this.matches.length;) {
          this.matches.pop();
        }
        return this.nextOverlapping();
      }
    }, {
      key: "nextOverlapping",
      value: function value() {
        for (;;) {
          var e = this.peek();
          if (e < 0) return this.done = !0, this;
          var t = a_(e),
            n = this.bufferStart + this.bufferPos;
          this.bufferPos += s_(e);
          for (var r = this.normalize(t), i = 0, o = n;; i++) {
            var a = r.charCodeAt(i),
              s = this.match(a, o);
            if (s) return this.value = s, this;
            if (i == r.length - 1) break;
            o == n && i < t.length && t.charCodeAt(i) == a && o++;
          }
        }
      }
    }, {
      key: "match",
      value: function value(e, t) {
        for (var n = null, r = 0; r < this.matches.length; r += 2) {
          var i = this.matches[r],
            o = !1;
          this.query.charCodeAt(i) == e && (i == this.query.length - 1 ? n = {
            from: this.matches[r + 1],
            to: t + 1
          } : (this.matches[r]++, o = !0)), o || (this.matches.splice(r, 2), r -= 2);
        }
        return this.query.charCodeAt(0) == e && (1 == this.query.length ? n = {
          from: t,
          to: t + 1
        } : this.matches.push(1, t)), n;
      }
    }]), e;
  }();
"undefined" != typeof Symbol && (mz.prototype[Symbol.iterator] = function () {
  return this;
});
var gz = {
    from: -1,
    to: -1,
    match: /.*/.exec("")
  },
  yz = "gm" + (null == /x/.unicode ? "" : "u"),
  bz = function () {
    function e(t, n, r) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
        o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : t.length;
      if (Ri(this, e), this.to = o, this.curLine = "", this.done = !1, this.value = gz, /\\[sWDnr]|\n|\r|\[\^/.test(n)) return new xz(t, n, r, i, o);
      this.re = new RegExp(n, yz + ((null == r ? void 0 : r.ignoreCase) ? "i" : "")), this.iter = t.iter();
      var a = t.lineAt(i);
      this.curLineStart = a.from, this.matchPos = i, this.getLine(this.curLineStart);
    }
    return zi(e, [{
      key: "getLine",
      value: function value(e) {
        this.iter.next(e), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
      }
    }, {
      key: "nextLine",
      value: function value() {
        this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
      }
    }, {
      key: "next",
      value: function value() {
        for (var e = this.matchPos - this.curLineStart;;) {
          this.re.lastIndex = e;
          var t = this.matchPos <= this.to && this.re.exec(this.curLine);
          if (t) {
            var n = this.curLineStart + t.index,
              r = n + t[0].length;
            if (this.matchPos = r + (n == r ? 1 : 0), n == this.curLine.length && this.nextLine(), n < r || n > this.value.to) return this.value = {
              from: n,
              to: r,
              match: t
            }, this;
            e = this.matchPos - this.curLineStart;
          } else {
            if (!(this.curLineStart + this.curLine.length < this.to)) return this.done = !0, this;
            this.nextLine(), e = 0;
          }
        }
      }
    }]), e;
  }(),
  kz = new WeakMap(),
  wz = function () {
    function e(t, n) {
      Ri(this, e), this.from = t, this.text = n;
    }
    return zi(e, [{
      key: "to",
      get: function get() {
        return this.from + this.text.length;
      }
    }], [{
      key: "get",
      value: function value(t, n, r) {
        var i = kz.get(t);
        if (!i || i.from >= r || i.to <= n) {
          var o = new e(n, t.sliceString(n, r));
          return kz.set(t, o), o;
        }
        if (i.from == n && i.to == r) return i;
        var a = i.text,
          s = i.from;
        return s > n && (a = t.sliceString(n, s) + a, s = n), i.to < r && (a += t.sliceString(i.to, r)), kz.set(t, new e(s, a)), new e(n, a.slice(n - s, r - s));
      }
    }]), e;
  }(),
  xz = function () {
    function e(t, n, r, i, o) {
      Ri(this, e), this.text = t, this.to = o, this.done = !1, this.value = gz, this.matchPos = i, this.re = new RegExp(n, yz + ((null == r ? void 0 : r.ignoreCase) ? "i" : "")), this.flat = wz.get(t, i, this.chunkEnd(i + 5e3));
    }
    return zi(e, [{
      key: "chunkEnd",
      value: function value(e) {
        return e >= this.to ? this.to : this.text.lineAt(e).to;
      }
    }, {
      key: "next",
      value: function value() {
        for (;;) {
          var e = this.re.lastIndex = this.matchPos - this.flat.from,
            t = this.re.exec(this.flat.text);
          if (t && !t[0] && t.index == e && (this.re.lastIndex = e + 1, t = this.re.exec(this.flat.text)), t && this.flat.to < this.to && t.index + t[0].length > this.flat.text.length - 10 && (t = null), t) {
            var n = this.flat.from + t.index,
              r = n + t[0].length;
            return this.value = {
              from: n,
              to: r,
              match: t
            }, this.matchPos = r + (n == r ? 1 : 0), this;
          }
          if (this.flat.to == this.to) return this.done = !0, this;
          this.flat = wz.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + 2 * this.flat.text.length));
        }
      }
    }]), e;
  }();
function jz(e) {
  var t = dz("input", {
    class: "cm-textfield",
    name: "line"
  });
  function n() {
    var n = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(t.value);
    if (n) {
      var r = e.state,
        i = r.doc.lineAt(r.selection.main.head),
        o = xi(n, 5),
        a = o[1],
        s = o[2],
        u = o[3],
        c = o[4],
        l = u ? +u.slice(1) : 0,
        f = s ? +s : i.number;
      if (s && c) {
        var h = f / 100;
        a && (h = h * ("-" == a ? -1 : 1) + i.number / r.doc.lines), f = Math.round(r.doc.lines * h);
      } else s && a && (f = f * ("-" == a ? -1 : 1) + i.number);
      var d = r.doc.line(Math.max(1, Math.min(r.doc.lines, f)));
      e.dispatch({
        effects: Sz.of(!1),
        selection: b_.cursor(d.from + Math.max(0, Math.min(l, d.length))),
        scrollIntoView: !0
      }), e.focus();
    }
  }
  return {
    dom: dz("form", {
      class: "cm-gotoLine",
      onkeydown: function onkeydown(t) {
        27 == t.keyCode ? (t.preventDefault(), e.dispatch({
          effects: Sz.of(!1)
        }), e.focus()) : 13 == t.keyCode && (t.preventDefault(), n());
      },
      onsubmit: function onsubmit(e) {
        e.preventDefault(), n();
      }
    }, dz("label", e.state.phrase("Go to line"), ": ", t), " ", dz("button", {
      class: "cm-button",
      type: "submit"
    }, e.state.phrase("go")))
  };
}
"undefined" != typeof Symbol && (bz.prototype[Symbol.iterator] = xz.prototype[Symbol.iterator] = function () {
  return this;
});
var Sz = Y_.define(),
  Cz = O_.define({
    create: function create() {
      return !0;
    },
    update: function update(e, t) {
      var n,
        r = bi(t.effects);
      try {
        for (r.s(); !(n = r.n()).done;) {
          var i = n.value;
          i.is(Sz) && (e = i.value);
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
      return e;
    },
    provide: function provide(e) {
      return BM.from(e, function (e) {
        return e ? jz : null;
      });
    }
  }),
  _z = CP.baseTheme({
    ".cm-panel.cm-gotoLine": {
      padding: "2px 6px 4px",
      "& label": {
        fontSize: "80%"
      }
    }
  }),
  $z = {
    highlightWordAroundCursor: !1,
    minSelectionLength: 1,
    maxMatches: 100,
    wholeWords: !1
  },
  Oz = x_.define({
    combine: function combine(e) {
      return l$(e, $z, {
        highlightWordAroundCursor: function highlightWordAroundCursor(e, t) {
          return e || t;
        },
        minSelectionLength: Math.min,
        maxMatches: Math.min
      });
    }
  });
function Az(e) {
  var t = [Tz, Iz];
  return e && t.push(Oz.of(e)), t;
}
var Ez = UO.mark({
    class: "cm-selectionMatch"
  }),
  Pz = UO.mark({
    class: "cm-selectionMatch cm-selectionMatch-main"
  });
function Mz(e, t, n, r) {
  return !(0 != n && e(t.sliceDoc(n - 1, n)) == a$.Word || r != t.doc.length && e(t.sliceDoc(r, r + 1)) == a$.Word);
}
var Iz = mA.fromClass(function () {
    function e(t) {
      Ri(this, e), this.decorations = this.getDeco(t);
    }
    return zi(e, [{
      key: "update",
      value: function value(e) {
        (e.selectionSet || e.docChanged || e.viewportChanged) && (this.decorations = this.getDeco(e.view));
      }
    }, {
      key: "getDeco",
      value: function value(e) {
        var t = e.state.facet(Oz),
          n = e.state,
          r = n.selection;
        if (r.ranges.length > 1) return UO.none;
        var i,
          o = r.main,
          a = null;
        if (o.empty) {
          if (!t.highlightWordAroundCursor) return UO.none;
          var s = n.wordAt(o.head);
          if (!s) return UO.none;
          a = n.charCategorizer(o.head), i = n.sliceDoc(s.from, s.to);
        } else {
          var u = o.to - o.from;
          if (u < t.minSelectionLength || u > 200) return UO.none;
          if (t.wholeWords) {
            if (i = n.sliceDoc(o.from, o.to), !Mz(a = n.charCategorizer(o.head), n, o.from, o.to) || !function (e, t, n, r) {
              return e(t.sliceDoc(n, n + 1)) == a$.Word && e(t.sliceDoc(r - 1, r)) == a$.Word;
            }(a, n, o.from, o.to)) return UO.none;
          } else if (!(i = n.sliceDoc(o.from, o.to).trim())) return UO.none;
        }
        var c,
          l = [],
          f = bi(e.visibleRanges);
        try {
          for (f.s(); !(c = f.n()).done;) {
            for (var h = c.value, d = new mz(n.doc, i, h.from, h.to); !d.next().done;) {
              var v = d.value,
                p = v.from,
                m = v.to;
              if ((!a || Mz(a, n, p, m)) && (o.empty && p <= o.from && m >= o.to ? l.push(Pz.range(p, m)) : (p >= o.to || m <= o.from) && l.push(Ez.range(p, m)), l.length > t.maxMatches)) return UO.none;
            }
          }
        } catch (e) {
          f.e(e);
        } finally {
          f.f();
        }
        return UO.set(l);
      }
    }]), e;
  }(), {
    decorations: function decorations(e) {
      return e.decorations;
    }
  }),
  Tz = CP.baseTheme({
    ".cm-selectionMatch": {
      backgroundColor: "#99ff7780"
    },
    ".cm-searchMatch .cm-selectionMatch": {
      backgroundColor: "transparent"
    }
  });
var Nz = x_.define({
  combine: function combine(e) {
    var t;
    return {
      top: e.reduce(function (e, t) {
        return null != e ? e : t.top;
      }, void 0) || !1,
      caseSensitive: e.reduce(function (e, t) {
        return null != e ? e : t.caseSensitive;
      }, void 0) || !1,
      createPanel: (null === (t = e.find(function (e) {
        return e.createPanel;
      })) || void 0 === t ? void 0 : t.createPanel) || function (e) {
        return new sL(e);
      }
    };
  }
});
function Rz(e) {
  return e ? [Nz.of(e), hL] : hL;
}
var Dz = function () {
    function e(t) {
      Ri(this, e), this.search = t.search, this.caseSensitive = !!t.caseSensitive, this.regexp = !!t.regexp, this.replace = t.replace || "", this.valid = !!this.search && (!this.regexp || function (e) {
        try {
          return new RegExp(e, yz), !0;
        } catch (e) {
          return !1;
        }
      }(this.search)), this.unquoted = t.literal ? this.search : this.search.replace(/\\([nrt\\])/g, function (e, t) {
        return "n" == t ? "\n" : "r" == t ? "\r" : "t" == t ? "\t" : "\\";
      });
    }
    return zi(e, [{
      key: "eq",
      value: function value(e) {
        return this.search == e.search && this.replace == e.replace && this.caseSensitive == e.caseSensitive && this.regexp == e.regexp;
      }
    }, {
      key: "create",
      value: function value() {
        return this.regexp ? new Fz(this) : new Bz(this);
      }
    }, {
      key: "getCursor",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.length;
        return this.regexp ? qz(this, e, t, n) : Lz(this, e, t, n);
      }
    }]), e;
  }(),
  zz = zi(function e(t) {
    Ri(this, e), this.spec = t;
  });
function Lz(e, t, n, r) {
  return new mz(t, e.unquoted, n, r, e.caseSensitive ? void 0 : function (e) {
    return e.toLowerCase();
  });
}
var Bz = function (e) {
  ji(n, zz);
  var t = Ci(n);
  function n(e) {
    return Ri(this, n), t.call(this, e);
  }
  return zi(n, [{
    key: "nextMatch",
    value: function value(e, t, n) {
      var r = Lz(this.spec, e, n, e.length).nextOverlapping();
      return r.done && (r = Lz(this.spec, e, 0, t).nextOverlapping()), r.done ? null : r.value;
    }
  }, {
    key: "prevMatchInRange",
    value: function value(e, t, n) {
      for (var r = n;;) {
        for (var i = Math.max(t, r - 1e4 - this.spec.unquoted.length), o = Lz(this.spec, e, i, r), a = null; !o.nextOverlapping().done;) {
          a = o.value;
        }
        if (a) return a;
        if (i == t) return null;
        r -= 1e4;
      }
    }
  }, {
    key: "prevMatch",
    value: function value(e, t, n) {
      return this.prevMatchInRange(e, 0, t) || this.prevMatchInRange(e, n, e.length);
    }
  }, {
    key: "getReplacement",
    value: function value(e) {
      return this.spec.replace;
    }
  }, {
    key: "matchAll",
    value: function value(e, t) {
      for (var n = Lz(this.spec, e, 0, e.length), r = []; !n.next().done;) {
        if (r.length >= t) return null;
        r.push(n.value);
      }
      return r;
    }
  }, {
    key: "highlight",
    value: function value(e, t, n, r) {
      for (var i = Lz(this.spec, e, Math.max(0, t - this.spec.unquoted.length), Math.min(n + this.spec.unquoted.length, e.length)); !i.next().done;) {
        r(i.value.from, i.value.to);
      }
    }
  }]), n;
}();
function qz(e, t, n, r) {
  return new bz(t, e.search, e.caseSensitive ? void 0 : {
    ignoreCase: !0
  }, n, r);
}
var Fz = function (e) {
    ji(n, zz);
    var t = Ci(n);
    function n() {
      return Ri(this, n), t.apply(this, arguments);
    }
    return zi(n, [{
      key: "nextMatch",
      value: function value(e, t, n) {
        var r = qz(this.spec, e, n, e.length).next();
        return r.done && (r = qz(this.spec, e, 0, t).next()), r.done ? null : r.value;
      }
    }, {
      key: "prevMatchInRange",
      value: function value(e, t, n) {
        for (var r = 1;; r++) {
          for (var i = Math.max(t, n - 1e4 * r), o = qz(this.spec, e, i, n), a = null; !o.next().done;) {
            a = o.value;
          }
          if (a && (i == t || a.from > i + 10)) return a;
          if (i == t) return null;
        }
      }
    }, {
      key: "prevMatch",
      value: function value(e, t, n) {
        return this.prevMatchInRange(e, 0, t) || this.prevMatchInRange(e, n, e.length);
      }
    }, {
      key: "getReplacement",
      value: function value(e) {
        return this.spec.replace.replace(/\$([$&\d+])/g, function (t, n) {
          return "$" == n ? "$" : "&" == n ? e.match[0] : "0" != n && +n < e.match.length ? e.match[n] : t;
        });
      }
    }, {
      key: "matchAll",
      value: function value(e, t) {
        for (var n = qz(this.spec, e, 0, e.length), r = []; !n.next().done;) {
          if (r.length >= t) return null;
          r.push(n.value);
        }
        return r;
      }
    }, {
      key: "highlight",
      value: function value(e, t, n, r) {
        for (var i = qz(this.spec, e, Math.max(0, t - 250), Math.min(n + 250, e.length)); !i.next().done;) {
          r(i.value.from, i.value.to);
        }
      }
    }]), n;
  }(),
  Vz = Y_.define(),
  Hz = Y_.define(),
  Wz = O_.define({
    create: function create(e) {
      return new Uz(rL(e).create(), null);
    },
    update: function update(e, t) {
      var n,
        r = bi(t.effects);
      try {
        for (r.s(); !(n = r.n()).done;) {
          var i = n.value;
          i.is(Vz) ? e = new Uz(i.value.create(), e.panel) : i.is(Hz) && (e = new Uz(e.query, i.value ? nL : null));
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
      return e;
    },
    provide: function provide(e) {
      return BM.from(e, function (e) {
        return e.panel;
      });
    }
  }),
  Uz = zi(function e(t, n) {
    Ri(this, e), this.query = t, this.panel = n;
  }),
  Jz = UO.mark({
    class: "cm-searchMatch"
  }),
  Kz = UO.mark({
    class: "cm-searchMatch cm-searchMatch-selected"
  }),
  Gz = mA.fromClass(function () {
    function e(t) {
      Ri(this, e), this.view = t, this.decorations = this.highlight(t.state.field(Wz));
    }
    return zi(e, [{
      key: "update",
      value: function value(e) {
        var t = e.state.field(Wz);
        (t != e.startState.field(Wz) || e.docChanged || e.selectionSet || e.viewportChanged) && (this.decorations = this.highlight(t));
      }
    }, {
      key: "highlight",
      value: function value(e) {
        var t = e.query;
        if (!e.panel || !t.spec.valid) return UO.none;
        for (var n = this.view, r = new g$(), i = 0, o = n.visibleRanges, a = o.length; i < a; i++) {
          for (var s = o[i], u = s.from, c = s.to; i < a - 1 && c > o[i + 1].from - 500;) {
            c = o[++i].to;
          }
          t.highlight(n.state.doc, u, c, function (e, t) {
            var i = n.state.selection.ranges.some(function (n) {
              return n.from == e && n.to == t;
            });
            r.add(e, t, i ? Kz : Jz);
          });
        }
        return r.finish();
      }
    }]), e;
  }(), {
    decorations: function decorations(e) {
      return e.decorations;
    }
  });
function Qz(e) {
  return function (t) {
    var n = t.state.field(Wz, !1);
    return n && n.query.spec.valid ? e(t, n) : iL(t);
  };
}
var Yz = Qz(function (e, t) {
    var n = t.query,
      r = e.state.selection.main,
      i = r.from,
      o = r.to,
      a = n.nextMatch(e.state.doc, i, o);
    return !(!a || a.from == i && a.to == o) && (e.dispatch({
      selection: {
        anchor: a.from,
        head: a.to
      },
      scrollIntoView: !0,
      effects: lL(e, a),
      userEvent: "select.search"
    }), !0);
  }),
  Zz = Qz(function (e, t) {
    var n = t.query,
      r = e.state,
      i = r.selection.main,
      o = i.from,
      a = i.to,
      s = n.prevMatch(r.doc, o, a);
    return !!s && (e.dispatch({
      selection: {
        anchor: s.from,
        head: s.to
      },
      scrollIntoView: !0,
      effects: lL(e, s),
      userEvent: "select.search"
    }), !0);
  }),
  Xz = Qz(function (e, t) {
    var n = t.query.matchAll(e.state.doc, 1e3);
    return !(!n || !n.length) && (e.dispatch({
      selection: b_.create(n.map(function (e) {
        return b_.range(e.from, e.to);
      })),
      userEvent: "select.search.matches"
    }), !0);
  }),
  eL = Qz(function (e, t) {
    var n = t.query,
      r = e.state,
      i = r.selection.main,
      o = i.from,
      a = i.to;
    if (r.readOnly) return !1;
    var s = n.nextMatch(r.doc, o, o);
    if (!s) return !1;
    var u,
      c,
      l = [],
      f = [];
    if (s.from == o && s.to == a && (c = r.toText(n.getReplacement(s)), l.push({
      from: s.from,
      to: s.to,
      insert: c
    }), s = n.nextMatch(r.doc, s.from, s.to), f.push(CP.announce.of(r.phrase("replaced match on line $", r.doc.lineAt(o).number) + "."))), s) {
      var h = 0 == l.length || l[0].from >= s.to ? 0 : s.to - s.from - c.length;
      u = {
        anchor: s.from - h,
        head: s.to - h
      }, f.push(lL(e, s));
    }
    return e.dispatch({
      changes: l,
      selection: u,
      scrollIntoView: !!u,
      effects: f,
      userEvent: "input.replace"
    }), !0;
  }),
  tL = Qz(function (e, t) {
    var n = t.query;
    if (e.state.readOnly) return !1;
    var r = n.matchAll(e.state.doc, 1e9).map(function (e) {
      return {
        from: e.from,
        to: e.to,
        insert: n.getReplacement(e)
      };
    });
    if (!r.length) return !1;
    var i = e.state.phrase("replaced $ matches", r.length) + ".";
    return e.dispatch({
      changes: r,
      effects: CP.announce.of(i),
      userEvent: "input.replace.all"
    }), !0;
  });
function nL(e) {
  return e.state.facet(Nz).createPanel(e);
}
function rL(e, t) {
  var n,
    r = e.selection.main,
    i = r.empty || r.to > r.from + 100 ? "" : e.sliceDoc(r.from, r.to),
    o = null !== (n = null == t ? void 0 : t.caseSensitive) && void 0 !== n ? n : e.facet(Nz).caseSensitive;
  return t && !i ? t : new Dz({
    search: i.replace(/\n/g, "\\n"),
    caseSensitive: o
  });
}
var iL = function iL(e) {
    var t = e.state.field(Wz, !1);
    if (t && t.panel) {
      var n = RM(e, nL);
      if (!n) return !1;
      var r = n.dom.querySelector("[main-field]");
      if (r && r != e.root.activeElement) {
        var i = rL(e.state, t.query.spec);
        i.valid && e.dispatch({
          effects: Vz.of(i)
        }), r.focus(), r.select();
      }
    } else e.dispatch({
      effects: [Hz.of(!0), t ? Vz.of(rL(e.state, t.query.spec)) : Y_.appendConfig.of(hL)]
    });
    return !0;
  },
  oL = function oL(e) {
    var t = e.state.field(Wz, !1);
    if (!t || !t.panel) return !1;
    var n = RM(e, nL);
    return n && n.dom.contains(e.root.activeElement) && e.focus(), e.dispatch({
      effects: Hz.of(!1)
    }), !0;
  },
  aL = [{
    key: "Mod-f",
    run: iL,
    scope: "editor search-panel"
  }, {
    key: "F3",
    run: Yz,
    shift: Zz,
    scope: "editor search-panel",
    preventDefault: !0
  }, {
    key: "Mod-g",
    run: Yz,
    shift: Zz,
    scope: "editor search-panel",
    preventDefault: !0
  }, {
    key: "Escape",
    run: oL,
    scope: "editor search-panel"
  }, {
    key: "Mod-Shift-l",
    run: function run(e) {
      var t = e.state,
        n = e.dispatch,
        r = t.selection;
      if (r.ranges.length > 1 || r.main.empty) return !1;
      for (var i = r.main, o = i.from, a = i.to, s = [], u = 0, c = new mz(t.doc, t.sliceDoc(o, a)); !c.next().done;) {
        if (s.length > 1e3) return !1;
        c.value.from == o && (u = s.length), s.push(b_.range(c.value.from, c.value.to));
      }
      return n(t.update({
        selection: b_.create(s, u),
        userEvent: "select.search.matches"
      })), !0;
    }
  }, {
    key: "Alt-g",
    run: function run(e) {
      var t = RM(e, jz);
      if (!t) {
        var n = [Sz.of(!0)];
        null == e.state.field(Cz, !1) && n.push(Y_.appendConfig.of([Cz, _z])), e.dispatch({
          effects: n
        }), t = RM(e, jz);
      }
      return t && t.dom.querySelector("input").focus(), !0;
    }
  }, {
    key: "Mod-d",
    run: function run(e) {
      var t = e.state,
        n = e.dispatch,
        r = t.selection.ranges;
      if (r.some(function (e) {
        return e.from === e.to;
      })) return function (e) {
        var t = e.state,
          n = e.dispatch,
          r = t.selection,
          i = b_.create(r.ranges.map(function (e) {
            return t.wordAt(e.head) || b_.cursor(e.head);
          }), r.mainIndex);
        return !i.eq(r) && (n(t.update({
          selection: i
        })), !0);
      }({
        state: t,
        dispatch: n
      });
      var i = t.sliceDoc(r[0].from, r[0].to);
      if (t.selection.ranges.some(function (e) {
        return t.sliceDoc(e.from, e.to) != i;
      })) return !1;
      var o = function (e, t) {
        for (var n = e.selection, r = n.main, i = n.ranges, o = e.wordAt(r.head), a = o && o.from == r.from && o.to == r.to, s = function s(n, r) {
            if (r.next(), !r.done) {
              if (n && i.some(function (e) {
                return e.from == r.value.from;
              })) return c = r, u = n, "continue";
              if (a) {
                var o = e.wordAt(r.value.from);
                if (!o || o.from != r.value.from || o.to != r.value.to) return c = r, u = n, "continue";
              }
              return u = n, c = r, {
                v: r.value
              };
            }
            if (n) return c = r, u = n, {
              v: null
            };
            r = new mz(e.doc, t, 0, Math.max(0, i[i.length - 1].from - 1)), u = n = !0, c = r;
          }, u = !1, c = new mz(e.doc, t, i[i.length - 1].to);;) {
          var l = s(u, c);
          if ("continue" !== l && "object" === Li(l)) return l.v;
        }
      }(t, i);
      return !!o && (n(t.update({
        selection: t.selection.addRange(b_.range(o.from, o.to), !1),
        effects: CP.scrollIntoView(o.to)
      })), !0);
    },
    preventDefault: !0
  }],
  sL = function () {
    function e(t) {
      var n = this;
      Ri(this, e), this.view = t;
      var r = this.query = t.state.field(Wz).query.spec;
      function i(e, t, n) {
        return dz("button", {
          class: "cm-button",
          name: e,
          onclick: t,
          type: "button"
        }, n);
      }
      this.commit = this.commit.bind(this), this.searchField = dz("input", {
        value: r.search,
        placeholder: uL(t, "Find"),
        "aria-label": uL(t, "Find"),
        class: "cm-textfield",
        name: "search",
        "main-field": "true",
        onchange: this.commit,
        onkeyup: this.commit
      }), this.replaceField = dz("input", {
        value: r.replace,
        placeholder: uL(t, "Replace"),
        "aria-label": uL(t, "Replace"),
        class: "cm-textfield",
        name: "replace",
        onchange: this.commit,
        onkeyup: this.commit
      }), this.caseField = dz("input", {
        type: "checkbox",
        name: "case",
        checked: r.caseSensitive,
        onchange: this.commit
      }), this.reField = dz("input", {
        type: "checkbox",
        name: "re",
        checked: r.regexp,
        onchange: this.commit
      }), this.dom = dz("div", {
        onkeydown: function onkeydown(e) {
          return n.keydown(e);
        },
        class: "cm-search"
      }, [this.searchField, i("next", function () {
        return Yz(t);
      }, [uL(t, "next")]), i("prev", function () {
        return Zz(t);
      }, [uL(t, "previous")]), i("select", function () {
        return Xz(t);
      }, [uL(t, "all")]), dz("label", null, [this.caseField, uL(t, "match case")]), dz("label", null, [this.reField, uL(t, "regexp")])].concat(Ii(t.state.readOnly ? [] : [dz("br"), this.replaceField, i("replace", function () {
        return eL(t);
      }, [uL(t, "replace")]), i("replaceAll", function () {
        return tL(t);
      }, [uL(t, "replace all")]), dz("button", {
        name: "close",
        onclick: function onclick() {
          return oL(t);
        },
        "aria-label": uL(t, "close"),
        type: "button"
      }, ["×"])])));
    }
    return zi(e, [{
      key: "commit",
      value: function value() {
        var e = new Dz({
          search: this.searchField.value,
          caseSensitive: this.caseField.checked,
          regexp: this.reField.checked,
          replace: this.replaceField.value
        });
        e.eq(this.query) || (this.query = e, this.view.dispatch({
          effects: Vz.of(e)
        }));
      }
    }, {
      key: "keydown",
      value: function value(e) {
        var t, n, r;
        t = this.view, n = e, r = "search-panel", zP(RP(t.state), n, t, r) ? e.preventDefault() : 13 == e.keyCode && e.target == this.searchField ? (e.preventDefault(), (e.shiftKey ? Zz : Yz)(this.view)) : 13 == e.keyCode && e.target == this.replaceField && (e.preventDefault(), eL(this.view));
      }
    }, {
      key: "update",
      value: function value(e) {
        var t,
          n = bi(e.transactions);
        try {
          for (n.s(); !(t = n.n()).done;) {
            var r,
              i = bi(t.value.effects);
            try {
              for (i.s(); !(r = i.n()).done;) {
                var o = r.value;
                o.is(Vz) && !o.value.eq(this.query) && this.setQuery(o.value);
              }
            } catch (e) {
              i.e(e);
            } finally {
              i.f();
            }
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
      }
    }, {
      key: "setQuery",
      value: function value(e) {
        this.query = e, this.searchField.value = e.search, this.replaceField.value = e.replace, this.caseField.checked = e.caseSensitive, this.reField.checked = e.regexp;
      }
    }, {
      key: "mount",
      value: function value() {
        this.searchField.select();
      }
    }, {
      key: "pos",
      get: function get() {
        return 80;
      }
    }, {
      key: "top",
      get: function get() {
        return this.view.state.facet(Nz).top;
      }
    }]), e;
  }();
function uL(e, t) {
  return e.state.phrase(t);
}
var cL = /[\s\.,:;?!]/;
function lL(e, t) {
  var n = t.from,
    r = t.to,
    i = e.state.doc.lineAt(n),
    o = e.state.doc.lineAt(r).to,
    a = Math.max(i.from, n - 30),
    s = Math.min(o, r + 30),
    u = e.state.sliceDoc(a, s);
  if (a != i.from) for (var c = 0; c < 30; c++) {
    if (!cL.test(u[c + 1]) && cL.test(u[c])) {
      u = u.slice(c);
      break;
    }
  }
  if (s != o) for (var l = u.length - 1; l > u.length - 30; l--) {
    if (!cL.test(u[l - 1]) && cL.test(u[l])) {
      u = u.slice(0, l);
      break;
    }
  }
  return CP.announce.of("".concat(e.state.phrase("current match"), ". ").concat(u, " ").concat(e.state.phrase("on line"), " ").concat(i.number, "."));
}
var fL = CP.baseTheme({
    ".cm-panel.cm-search": {
      padding: "2px 6px 4px",
      position: "relative",
      "& [name=close]": {
        position: "absolute",
        top: "0",
        right: "4px",
        backgroundColor: "inherit",
        border: "none",
        font: "inherit",
        padding: 0,
        margin: 0
      },
      "& input, & button, & label": {
        margin: ".2em .6em .2em 0"
      },
      "& input[type=checkbox]": {
        marginRight: ".2em"
      },
      "& label": {
        fontSize: "80%",
        whiteSpace: "pre"
      }
    },
    "&light .cm-searchMatch": {
      backgroundColor: "#ffff0054"
    },
    "&dark .cm-searchMatch": {
      backgroundColor: "#00ffff8a"
    },
    "&light .cm-searchMatch-selected": {
      backgroundColor: "#ff6a0054"
    },
    "&dark .cm-searchMatch-selected": {
      backgroundColor: "#ff00ff8a"
    }
  }),
  hL = [Wz, T_.lowest(Gz), fL],
  dL = function () {
    function e(t, n, r) {
      Ri(this, e), this.state = t, this.pos = n, this.explicit = r, this.abortListeners = [];
    }
    return zi(e, [{
      key: "tokenBefore",
      value: function value(e) {
        for (var t = qT(this.state).resolveInner(this.pos, -1); t && e.indexOf(t.name) < 0;) {
          t = t.parent;
        }
        return t ? {
          from: t.from,
          to: this.pos,
          text: this.state.sliceDoc(t.from, this.pos),
          type: t.type
        } : null;
      }
    }, {
      key: "matchBefore",
      value: function value(e) {
        var t = this.state.doc.lineAt(this.pos),
          n = Math.max(t.from, this.pos - 250),
          r = t.text.slice(n - t.from, this.pos - t.from),
          i = r.search(yL(e, !1));
        return i < 0 ? null : {
          from: n + i,
          to: this.pos,
          text: r.slice(i)
        };
      }
    }, {
      key: "aborted",
      get: function get() {
        return null == this.abortListeners;
      }
    }, {
      key: "addEventListener",
      value: function value(e, t) {
        "abort" == e && this.abortListeners && this.abortListeners.push(t);
      }
    }]), e;
  }();
function vL(e) {
  var t = Object.keys(e).join(""),
    n = /\w/.test(t);
  return n && (t = t.replace(/\w/g, "")), "[".concat(n ? "\\w" : "").concat(t.replace(/[^\w\s]/g, "\\$&"), "]");
}
function pL(e) {
  var t = e.map(function (e) {
      return "string" == typeof e ? {
        label: e
      } : e;
    }),
    n = xi(t.every(function (e) {
      return /^\w+$/.test(e.label);
    }) ? [/\w*$/, /\w+$/] : function (e) {
      var t,
        n = Object.create(null),
        r = Object.create(null),
        i = bi(e);
      try {
        for (i.s(); !(t = i.n()).done;) {
          var o = t.value.label;
          n[o[0]] = !0;
          for (var a = 1; a < o.length; a++) {
            r[o[a]] = !0;
          }
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }
      var s = vL(n) + vL(r) + "*$";
      return [new RegExp("^" + s), new RegExp(s)];
    }(t), 2),
    r = n[0],
    i = n[1];
  return function (e) {
    var n = e.matchBefore(i);
    return n || e.explicit ? {
      from: n ? n.from : e.pos,
      options: t,
      validFor: r
    } : null;
  };
}
var mL = zi(function e(t, n, r) {
  Ri(this, e), this.completion = t, this.source = n, this.match = r;
});
function gL(e) {
  return e.selection.main.head;
}
function yL(e, t) {
  var n,
    r = e.source,
    i = t && "^" != r[0],
    o = "$" != r[r.length - 1];
  return i || o ? new RegExp("".concat(i ? "^" : "", "(?:").concat(r, ")").concat(o ? "$" : ""), null !== (n = e.flags) && void 0 !== n ? n : e.ignoreCase ? "i" : "") : e;
}
function bL(e, t) {
  var n = t.completion.apply || t.completion.label,
    r = t.source;
  "string" == typeof n ? e.dispatch(function (e, t, n, r) {
    return Object.assign(Object.assign({}, e.changeByRange(function (i) {
      if (i == e.selection.main) return {
        changes: {
          from: n,
          to: r,
          insert: t
        },
        range: b_.cursor(n + t.length)
      };
      var o = r - n;
      return !i.empty || o && e.sliceDoc(i.from - o, i.from) != e.sliceDoc(n, r) ? {
        range: i
      } : {
        changes: {
          from: i.from - o,
          to: i.from,
          insert: t
        },
        range: b_.cursor(i.from - o + t.length)
      };
    })), {
      userEvent: "input.complete"
    });
  }(e.state, n, r.from, r.to)) : n(e, t.completion, r.from, r.to);
}
var kL = new WeakMap();
function wL(e) {
  if (!Array.isArray(e)) return e;
  var t = kL.get(e);
  return t || kL.set(e, t = pL(e)), t;
}
var xL = function () {
    function e(t) {
      Ri(this, e), this.pattern = t, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [];
      for (var n = 0; n < t.length;) {
        var r = o_(t, n),
          i = s_(r);
        this.chars.push(r);
        var o = t.slice(n, n + i),
          a = o.toUpperCase();
        this.folded.push(o_(a == o ? o.toLowerCase() : a, 0)), n += i;
      }
      this.astral = t.length != this.chars.length;
    }
    return zi(e, [{
      key: "match",
      value: function value(e) {
        if (0 == this.pattern.length) return [0];
        if (e.length < this.pattern.length) return null;
        var t = this.chars,
          n = this.folded,
          r = this.any,
          i = this.precise,
          o = this.byWord;
        if (1 == t.length) {
          var a = o_(e, 0);
          return a == t[0] ? [0, 0, s_(a)] : a == n[0] ? [-200, 0, s_(a)] : null;
        }
        var s = e.indexOf(this.pattern);
        if (0 == s) return [0, 0, this.pattern.length];
        var u = t.length,
          c = 0;
        if (s < 0) {
          for (var l = 0, f = Math.min(e.length, 200); l < f && c < u;) {
            var h = o_(e, l);
            h != t[c] && h != n[c] || (r[c++] = l), l += s_(h);
          }
          if (c < u) return null;
        }
        for (var d = 0, v = 0, p = !1, m = 0, g = -1, y = -1, b = /[a-z]/.test(e), k = !0, w = 0, x = Math.min(e.length, 200), j = 0; w < x && v < u;) {
          var S = o_(e, w);
          s < 0 && (d < u && S == t[d] && (i[d++] = w), m < u && (S == t[m] || S == n[m] ? (0 == m && (g = w), y = w + 1, m++) : m = 0));
          var C = void 0,
            _ = S < 255 ? S >= 48 && S <= 57 || S >= 97 && S <= 122 ? 2 : S >= 65 && S <= 90 ? 1 : 0 : (C = a_(S)) != C.toLowerCase() ? 1 : C != C.toUpperCase() ? 2 : 0;
          (!w || 1 == _ && b || 0 == j && 0 != _) && (t[v] == S || n[v] == S && (p = !0) ? o[v++] = w : o.length && (k = !1)), j = _, w += s_(S);
        }
        return v == u && 0 == o[0] && k ? this.result((p ? -200 : 0) - 100, o, e) : m == u && 0 == g ? [-200 - e.length, 0, y] : s > -1 ? [-700 - e.length, s, s + this.pattern.length] : m == u ? [-900 - e.length, g, y] : v == u ? this.result((p ? -200 : 0) - 100 - 700 + (k ? 0 : -1100), o, e) : 2 == t.length ? null : this.result((r[0] ? -700 : 0) - 200 - 1100, r, e);
      }
    }, {
      key: "result",
      value: function value(e, t, n) {
        var r,
          i = [e - n.length],
          o = 1,
          a = bi(t);
        try {
          for (a.s(); !(r = a.n()).done;) {
            var s = r.value,
              u = s + (this.astral ? s_(o_(n, s)) : 1);
            o > 1 && i[o - 1] == s ? i[o - 1] = u : (i[o++] = s, i[o++] = u);
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
        return i;
      }
    }]), e;
  }(),
  jL = x_.define({
    combine: function combine(e) {
      return l$(e, {
        activateOnTyping: !0,
        override: null,
        closeOnBlur: !0,
        maxRenderedOptions: 100,
        defaultKeymap: !0,
        optionClass: function optionClass() {
          return "";
        },
        aboveCursor: !1,
        icons: !0,
        addToOptions: []
      }, {
        defaultKeymap: function defaultKeymap(e, t) {
          return e && t;
        },
        closeOnBlur: function closeOnBlur(e, t) {
          return e && t;
        },
        icons: function icons(e, t) {
          return e && t;
        },
        optionClass: function optionClass(e, t) {
          return function (n) {
            return function (e, t) {
              return e ? t ? e + " " + t : e : t;
            }(e(n), t(n));
          };
        },
        addToOptions: function addToOptions(e, t) {
          return e.concat(t);
        }
      });
    }
  });
function SL(e, t, n) {
  if (e <= n) return {
    from: 0,
    to: e
  };
  if (t <= e >> 1) {
    var r = Math.floor(t / n);
    return {
      from: r * n,
      to: (r + 1) * n
    };
  }
  var i = Math.floor((e - t) / n);
  return {
    from: e - (i + 1) * n,
    to: e - i * n
  };
}
var CL = function () {
  function e(t, n) {
    var r = this;
    Ri(this, e), this.view = t, this.stateField = n, this.info = null, this.placeInfo = {
      read: function read() {
        return r.measureInfo();
      },
      write: function write(e) {
        return r.positionInfo(e);
      },
      key: this
    };
    var i = t.state.field(n),
      o = i.open,
      a = o.options,
      s = o.selected,
      u = t.state.facet(jL);
    this.optionContent = function (e) {
      var t = e.addToOptions.slice();
      return e.icons && t.push({
        render: function render(e) {
          var t,
            n = document.createElement("div");
          return n.classList.add("cm-completionIcon"), e.type && (t = n.classList).add.apply(t, Ii(e.type.split(/\s+/g).map(function (e) {
            return "cm-completionIcon-" + e;
          }))), n.setAttribute("aria-hidden", "true"), n;
        },
        position: 20
      }), t.push({
        render: function render(e, t, n) {
          var r = document.createElement("span");
          r.className = "cm-completionLabel";
          for (var i = e.label, o = 0, a = 1; a < n.length;) {
            var s = n[a++],
              u = n[a++];
            s > o && r.appendChild(document.createTextNode(i.slice(o, s)));
            var c = r.appendChild(document.createElement("span"));
            c.appendChild(document.createTextNode(i.slice(s, u))), c.className = "cm-completionMatchedText", o = u;
          }
          return o < i.length && r.appendChild(document.createTextNode(i.slice(o))), r;
        },
        position: 50
      }, {
        render: function render(e) {
          if (!e.detail) return null;
          var t = document.createElement("span");
          return t.className = "cm-completionDetail", t.textContent = e.detail, t;
        },
        position: 80
      }), t.sort(function (e, t) {
        return e.position - t.position;
      }).map(function (e) {
        return e.render;
      });
    }(u), this.optionClass = u.optionClass, this.range = SL(a.length, s, u.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.dom.addEventListener("mousedown", function (e) {
      for (var n, i = e.target; i && i != r.dom; i = i.parentNode) {
        if ("LI" == i.nodeName && (n = /-(\d+)$/.exec(i.id)) && +n[1] < a.length) return bL(t, a[+n[1]]), void e.preventDefault();
      }
    }), this.list = this.dom.appendChild(this.createListBox(a, i.id, this.range)), this.list.addEventListener("scroll", function () {
      r.info && r.view.requestMeasure(r.placeInfo);
    });
  }
  return zi(e, [{
    key: "mount",
    value: function value() {
      this.updateSel();
    }
  }, {
    key: "update",
    value: function value(e) {
      e.state.field(this.stateField) != e.startState.field(this.stateField) && this.updateSel();
    }
  }, {
    key: "positioned",
    value: function value() {
      this.info && this.view.requestMeasure(this.placeInfo);
    }
  }, {
    key: "updateSel",
    value: function value() {
      var e = this,
        t = this.view.state.field(this.stateField),
        n = t.open;
      if ((n.selected < this.range.from || n.selected >= this.range.to) && (this.range = SL(n.options.length, n.selected, this.view.state.facet(jL).maxRenderedOptions), this.list.remove(), this.list = this.dom.appendChild(this.createListBox(n.options, t.id, this.range)), this.list.addEventListener("scroll", function () {
        e.info && e.view.requestMeasure(e.placeInfo);
      })), this.updateSelectedOption(n.selected)) {
        this.info && (this.info.remove(), this.info = null);
        var r = n.options[n.selected].completion,
          i = r.info;
        if (!i) return;
        var o = "string" == typeof i ? document.createTextNode(i) : i(r);
        if (!o) return;
        "then" in o ? o.then(function (n) {
          n && e.view.state.field(e.stateField, !1) == t && e.addInfoPane(n);
        }).catch(function (t) {
          return hA(e.view.state, t, "completion info");
        }) : this.addInfoPane(o);
      }
    }
  }, {
    key: "addInfoPane",
    value: function value(e) {
      var t = this.info = document.createElement("div");
      t.className = "cm-tooltip cm-completionInfo", t.appendChild(e), this.dom.appendChild(t), this.view.requestMeasure(this.placeInfo);
    }
  }, {
    key: "updateSelectedOption",
    value: function value(e) {
      for (var t = null, n = this.list.firstChild, r = this.range.from; n; n = n.nextSibling, r++) {
        r == e ? n.hasAttribute("aria-selected") || (n.setAttribute("aria-selected", "true"), t = n) : n.hasAttribute("aria-selected") && n.removeAttribute("aria-selected");
      }
      return t && function (e, t) {
        var n = e.getBoundingClientRect(),
          r = t.getBoundingClientRect();
        r.top < n.top ? e.scrollTop -= n.top - r.top : r.bottom > n.bottom && (e.scrollTop += r.bottom - n.bottom);
      }(this.list, t), t;
    }
  }, {
    key: "measureInfo",
    value: function value() {
      var e = this.dom.querySelector("[aria-selected]");
      if (!e || !this.info) return null;
      var t = this.dom.getBoundingClientRect(),
        n = this.info.getBoundingClientRect(),
        r = e.getBoundingClientRect();
      if (r.top > Math.min(innerHeight, t.bottom) - 10 || r.bottom < Math.max(0, t.top) + 10) return null;
      var i = Math.max(0, Math.min(r.top, innerHeight - n.height)) - t.top,
        o = this.view.textDirection == _A.RTL,
        a = t.left,
        s = innerWidth - t.right;
      return o && a < Math.min(n.width, s) ? o = !1 : !o && s < Math.min(n.width, a) && (o = !0), {
        top: i,
        left: o
      };
    }
  }, {
    key: "positionInfo",
    value: function value(e) {
      this.info && (this.info.style.top = (e ? e.top : -1e6) + "px", e && (this.info.classList.toggle("cm-completionInfo-left", e.left), this.info.classList.toggle("cm-completionInfo-right", !e.left)));
    }
  }, {
    key: "createListBox",
    value: function value(e, t, n) {
      var r = document.createElement("ul");
      r.id = t, r.setAttribute("role", "listbox"), r.setAttribute("aria-expanded", "true"), r.setAttribute("aria-label", this.view.state.phrase("Completions"));
      for (var i = n.from; i < n.to; i++) {
        var o = e[i],
          a = o.completion,
          s = o.match,
          u = r.appendChild(document.createElement("li"));
        u.id = t + "-" + i, u.setAttribute("role", "option");
        var c = this.optionClass(a);
        c && (u.className = c);
        var l,
          f = bi(this.optionContent);
        try {
          for (f.s(); !(l = f.n()).done;) {
            var h = (0, l.value)(a, this.view.state, s);
            h && u.appendChild(h);
          }
        } catch (e) {
          f.e(e);
        } finally {
          f.f();
        }
      }
      return n.from && r.classList.add("cm-completionListIncompleteTop"), n.to < e.length && r.classList.add("cm-completionListIncompleteBottom"), r;
    }
  }]), e;
}();
function _L(e) {
  return 100 * (e.boost || 0) + (e.apply ? 10 : 0) + (e.info ? 5 : 0) + (e.type ? 1 : 0);
}
var $L = function () {
    function e(t, n, r, i, o) {
      Ri(this, e), this.options = t, this.attrs = n, this.tooltip = r, this.timestamp = i, this.selected = o;
    }
    return zi(e, [{
      key: "setSelected",
      value: function value(t, n) {
        return t == this.selected || t >= this.options.length ? this : new e(this.options, EL(n, t), this.tooltip, this.timestamp, t);
      }
    }, {
      key: "map",
      value: function value(t) {
        return new e(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), {
          pos: t.mapPos(this.tooltip.pos)
        }), this.timestamp, this.selected);
      }
    }], [{
      key: "build",
      value: function value(t, n, r, i, o) {
        var a = function (e, t) {
          var n,
            r = [],
            i = 0,
            o = bi(e);
          try {
            for (o.s(); !(n = o.n()).done;) {
              var a = n.value;
              if (a.hasResult()) if (!1 === a.result.filter) {
                var s,
                  u = a.result.getMatch,
                  c = bi(a.result.options);
                try {
                  for (c.s(); !(s = c.n()).done;) {
                    var l = s.value,
                      f = [1e9 - i++];
                    if (u) {
                      var h,
                        d = bi(u(l));
                      try {
                        for (d.s(); !(h = d.n()).done;) {
                          var v = h.value;
                          f.push(v);
                        }
                      } catch (e) {
                        d.e(e);
                      } finally {
                        d.f();
                      }
                    }
                    r.push(new mL(l, a, f));
                  }
                } catch (e) {
                  c.e(e);
                } finally {
                  c.f();
                }
              } else {
                var p,
                  m = new xL(t.sliceDoc(a.from, a.to)),
                  g = void 0,
                  y = bi(a.result.options);
                try {
                  for (y.s(); !(p = y.n()).done;) {
                    var b = p.value;
                    (g = m.match(b.label)) && (null != b.boost && (g[0] += b.boost), r.push(new mL(b, a, g)));
                  }
                } catch (e) {
                  y.e(e);
                } finally {
                  y.f();
                }
              }
            }
          } catch (e) {
            o.e(e);
          } finally {
            o.f();
          }
          var k,
            w = [],
            x = null,
            j = bi(r.sort(ML));
          try {
            for (j.s(); !(k = j.n()).done;) {
              var S = k.value;
              !x || x.label != S.completion.label || x.detail != S.completion.detail || null != x.type && null != S.completion.type && x.type != S.completion.type || x.apply != S.completion.apply ? w.push(S) : _L(S.completion) > _L(x) && (w[w.length - 1] = S), x = S.completion;
            }
          } catch (e) {
            j.e(e);
          } finally {
            j.f();
          }
          return w;
        }(t, n);
        if (!a.length) return null;
        var s,
          u = 0;
        if (i && i.selected) for (var c = i.options[i.selected].completion, l = 0; l < a.length; l++) {
          if (a[l].completion == c) {
            u = l;
            break;
          }
        }
        return new e(a, EL(r, u), {
          pos: t.reduce(function (e, t) {
            return t.hasResult() ? Math.min(e, t.from) : e;
          }, 1e8),
          create: (s = BL, function (e) {
            return new CL(e, s);
          }),
          above: o.aboveCursor
        }, i ? i.timestamp : Date.now(), u);
      }
    }]), e;
  }(),
  OL = function () {
    function e(t, n, r) {
      Ri(this, e), this.active = t, this.id = n, this.open = r;
    }
    return zi(e, [{
      key: "update",
      value: function value(t) {
        var n = this,
          r = t.state,
          i = r.facet(jL),
          o = (i.override || r.languageDataAt("autocomplete", gL(r)).map(wL)).map(function (e) {
            return (n.active.find(function (t) {
              return t.source == e;
            }) || new TL(e, n.active.some(function (e) {
              return 0 != e.state;
            }) ? 1 : 0)).update(t, i);
          });
        o.length == this.active.length && o.every(function (e, t) {
          return e == n.active[t];
        }) && (o = this.active);
        var a = t.selection || o.some(function (e) {
          return e.hasResult() && t.changes.touchesRange(e.from, e.to);
        }) || !function (e, t) {
          if (e == t) return !0;
          for (var n = 0, r = 0;;) {
            for (; n < e.length && !e[n].hasResult;) {
              n++;
            }
            for (; r < t.length && !t[r].hasResult;) {
              r++;
            }
            var i = n == e.length,
              o = r == t.length;
            if (i || o) return i == o;
            if (e[n++].result != t[r++].result) return !1;
          }
        }(o, this.active) ? $L.build(o, r, this.id, this.open, i) : this.open && t.docChanged ? this.open.map(t.changes) : this.open;
        !a && o.every(function (e) {
          return 1 != e.state;
        }) && o.some(function (e) {
          return e.hasResult();
        }) && (o = o.map(function (e) {
          return e.hasResult() ? new TL(e.source, 0) : e;
        }));
        var s,
          u = bi(t.effects);
        try {
          for (u.s(); !(s = u.n()).done;) {
            var c = s.value;
            c.is(LL) && (a = a && a.setSelected(c.value, this.id));
          }
        } catch (e) {
          u.e(e);
        } finally {
          u.f();
        }
        return o == this.active && a == this.open ? this : new e(o, this.id, a);
      }
    }, {
      key: "tooltip",
      get: function get() {
        return this.open ? this.open.tooltip : null;
      }
    }, {
      key: "attrs",
      get: function get() {
        return this.open ? this.open.attrs : AL;
      }
    }], [{
      key: "start",
      value: function value() {
        return new e(PL, "cm-ac-" + Math.floor(2e6 * Math.random()).toString(36), null);
      }
    }]), e;
  }();
var AL = {
  "aria-autocomplete": "list"
};
function EL(e, t) {
  return {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-activedescendant": e + "-" + t,
    "aria-controls": e
  };
}
var PL = [];
function ML(e, t) {
  var n = t.match[0] - e.match[0];
  return n || e.completion.label.localeCompare(t.completion.label);
}
function IL(e) {
  return e.isUserEvent("input.type") ? "input" : e.isUserEvent("delete.backward") ? "delete" : null;
}
var TL = function () {
    function e(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1;
      Ri(this, e), this.source = t, this.state = n, this.explicitPos = r;
    }
    return zi(e, [{
      key: "hasResult",
      value: function value() {
        return !1;
      }
    }, {
      key: "update",
      value: function value(t, n) {
        var r = IL(t),
          i = this;
        r ? i = i.handleUserEvent(t, r, n) : t.docChanged ? i = i.handleChange(t) : t.selection && 0 != i.state && (i = new e(i.source, 0));
        var o,
          a = bi(t.effects);
        try {
          for (a.s(); !(o = a.n()).done;) {
            var s = o.value;
            if (s.is(RL)) i = new e(i.source, 1, s.value ? gL(t.state) : -1);else if (s.is(DL)) i = new e(i.source, 0);else if (s.is(zL)) {
              var u,
                c = bi(s.value);
              try {
                for (c.s(); !(u = c.n()).done;) {
                  var l = u.value;
                  l.source == i.source && (i = l);
                }
              } catch (e) {
                c.e(e);
              } finally {
                c.f();
              }
            }
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
        return i;
      }
    }, {
      key: "handleUserEvent",
      value: function value(t, n, r) {
        return "delete" != n && r.activateOnTyping ? new e(this.source, 1) : this.map(t.changes);
      }
    }, {
      key: "handleChange",
      value: function value(t) {
        return t.changes.touchesRange(gL(t.startState)) ? new e(this.source, 0) : this.map(t.changes);
      }
    }, {
      key: "map",
      value: function value(t) {
        return t.empty || this.explicitPos < 0 ? this : new e(this.source, this.state, t.mapPos(this.explicitPos));
      }
    }]), e;
  }(),
  NL = function (e) {
    ji(n, TL);
    var t = Ci(n);
    function n(e, r, i, o, a) {
      var s;
      return Ri(this, n), (s = t.call(this, e, 2, r)).result = i, s.from = o, s.to = a, s;
    }
    return zi(n, [{
      key: "hasResult",
      value: function value() {
        return !0;
      }
    }, {
      key: "handleUserEvent",
      value: function value(e, t, r) {
        var i,
          o = e.changes.mapPos(this.from),
          a = e.changes.mapPos(this.to, 1),
          s = gL(e.state);
        if ((this.explicitPos < 0 ? s <= o : s < this.from) || s > a || "delete" == t && gL(e.startState) == this.from) return new TL(this.source, "input" == t && r.activateOnTyping ? 1 : 0);
        var u,
          c = this.explicitPos < 0 ? -1 : e.changes.mapPos(this.explicitPos);
        return function (e, t, n, r) {
          if (!e) return !1;
          var i = t.sliceDoc(n, r);
          return "function" == typeof e ? e(i, n, r, t) : yL(e, !0).test(i);
        }(this.result.validFor, e.state, o, a) ? new n(this.source, c, this.result, o, a) : this.result.update && (u = this.result.update(this.result, o, a, new dL(e.state, s, c >= 0))) ? new n(this.source, c, u, u.from, null !== (i = u.to) && void 0 !== i ? i : gL(e.state)) : new TL(this.source, 1, c);
      }
    }, {
      key: "handleChange",
      value: function value(e) {
        return e.changes.touchesRange(this.from, this.to) ? new TL(this.source, 0) : this.map(e.changes);
      }
    }, {
      key: "map",
      value: function value(e) {
        return e.empty ? this : new n(this.source, this.explicitPos < 0 ? -1 : e.mapPos(this.explicitPos), this.result, e.mapPos(this.from), e.mapPos(this.to, 1));
      }
    }]), n;
  }();
var RL = Y_.define(),
  DL = Y_.define(),
  zL = Y_.define({
    map: function map(e, t) {
      return e.map(function (e) {
        return e.map(t);
      });
    }
  }),
  LL = Y_.define(),
  BL = O_.define({
    create: function create() {
      return OL.start();
    },
    update: function update(e, t) {
      return e.update(t);
    },
    provide: function provide(e) {
      return [$M.from(e, function (e) {
        return e.tooltip;
      }), CP.contentAttributes.from(e, function (e) {
        return e.attrs;
      })];
    }
  });
function qL(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "option";
  return function (n) {
    var r = n.state.field(BL, !1);
    if (!r || !r.open || Date.now() - r.open.timestamp < 75) return !1;
    var i,
      o = 1;
    "page" == t && (i = IM(n, r.open.tooltip)) && (o = Math.max(2, Math.floor(i.dom.offsetHeight / i.dom.querySelector("li").offsetHeight) - 1));
    var a = r.open.selected + o * (e ? 1 : -1),
      s = r.open.options.length;
    return a < 0 ? a = "page" == t ? 0 : s - 1 : a >= s && (a = "page" == t ? s - 1 : 0), n.dispatch({
      effects: LL.of(a)
    }), !0;
  };
}
var FL = zi(function e(t, n) {
    Ri(this, e), this.active = t, this.context = n, this.time = Date.now(), this.updates = [], this.done = void 0;
  }),
  VL = mA.fromClass(function () {
    function e(t) {
      Ri(this, e), this.view = t, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.composing = 0;
      var n,
        r = bi(t.state.field(BL).active);
      try {
        for (r.s(); !(n = r.n()).done;) {
          var i = n.value;
          1 == i.state && this.startQuery(i);
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
    }
    return zi(e, [{
      key: "update",
      value: function value(e) {
        var t = this,
          n = e.state.field(BL);
        if (e.selectionSet || e.docChanged || e.startState.field(BL) != n) {
          for (var r = e.transactions.some(function (e) {
              return (e.selection || e.docChanged) && !IL(e);
            }), i = 0; i < this.running.length; i++) {
            var o = this.running[i];
            if (r || o.updates.length + e.transactions.length > 50 && Date.now() - o.time > 1e3) {
              var a,
                s = bi(o.context.abortListeners);
              try {
                for (s.s(); !(a = s.n()).done;) {
                  var u = a.value;
                  try {
                    u();
                  } catch (e) {
                    hA(this.view.state, e);
                  }
                }
              } catch (e) {
                s.e(e);
              } finally {
                s.f();
              }
              o.context.abortListeners = null, this.running.splice(i--, 1);
            } else {
              var c;
              (c = o.updates).push.apply(c, Ii(e.transactions));
            }
          }
          if (this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), this.debounceUpdate = n.active.some(function (e) {
            return 1 == e.state && !t.running.some(function (t) {
              return t.active.source == e.source;
            });
          }) ? setTimeout(function () {
            return t.startUpdate();
          }, 50) : -1, 0 != this.composing) {
            var l,
              f = bi(e.transactions);
            try {
              for (f.s(); !(l = f.n()).done;) {
                var h = l.value;
                "input" == IL(h) ? this.composing = 2 : 2 == this.composing && h.selection && (this.composing = 3);
              }
            } catch (e) {
              f.e(e);
            } finally {
              f.f();
            }
          }
        }
      }
    }, {
      key: "startUpdate",
      value: function value() {
        var e = this;
        this.debounceUpdate = -1;
        var t,
          n = bi(this.view.state.field(BL).active);
        try {
          var r = function r() {
            var n = t.value;
            1 != n.state || e.running.some(function (e) {
              return e.active.source == n.source;
            }) || e.startQuery(n);
          };
          for (n.s(); !(t = n.n()).done;) {
            r();
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
      }
    }, {
      key: "startQuery",
      value: function value(e) {
        var t = this,
          n = this.view.state,
          r = gL(n),
          i = new dL(n, r, e.explicitPos == r),
          o = new FL(e, i);
        this.running.push(o), Promise.resolve(e.source(i)).then(function (e) {
          o.context.aborted || (o.done = e || null, t.scheduleAccept());
        }, function (e) {
          t.view.dispatch({
            effects: DL.of(null)
          }), hA(t.view.state, e);
        });
      }
    }, {
      key: "scheduleAccept",
      value: function value() {
        var e = this;
        this.running.every(function (e) {
          return void 0 !== e.done;
        }) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(function () {
          return e.accept();
        }, 50));
      }
    }, {
      key: "accept",
      value: function value() {
        var e,
          t = this;
        this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
        for (var n = [], r = this.view.state.facet(jL), i = function i(_i13) {
            var a = t.running[_i13];
            if (void 0 === a.done) return o = _i13, "continue";
            if (t.running.splice(_i13--, 1), a.done) {
              var s,
                u = new NL(a.active.source, a.active.explicitPos, a.done, a.done.from, null !== (e = a.done.to) && void 0 !== e ? e : gL(a.updates.length ? a.updates[0].startState : t.view.state)),
                c = bi(a.updates);
              try {
                for (c.s(); !(s = c.n()).done;) {
                  var l = s.value;
                  u = u.update(l, r);
                }
              } catch (e) {
                c.e(e);
              } finally {
                c.f();
              }
              if (u.hasResult()) return n.push(u), o = _i13, "continue";
            }
            var f = t.view.state.field(BL).active.find(function (e) {
              return e.source == a.active.source;
            });
            if (f && 1 == f.state) if (null == a.done) {
              var h,
                d = new TL(a.active.source, 0),
                v = bi(a.updates);
              try {
                for (v.s(); !(h = v.n()).done;) {
                  var p = h.value;
                  d = d.update(p, r);
                }
              } catch (e) {
                v.e(e);
              } finally {
                v.f();
              }
              1 != d.state && n.push(d);
            } else t.startQuery(f);
            o = _i13;
          }, o = 0; o < this.running.length; o++) {
          i(o);
        }
        n.length && this.view.dispatch({
          effects: zL.of(n)
        });
      }
    }]), e;
  }(), {
    eventHandlers: {
      blur: function blur() {
        var e = this.view.state.field(BL, !1);
        e && e.tooltip && this.view.state.facet(jL).closeOnBlur && this.view.dispatch({
          effects: DL.of(null)
        });
      },
      compositionstart: function compositionstart() {
        this.composing = 1;
      },
      compositionend: function compositionend() {
        var e = this;
        3 == this.composing && setTimeout(function () {
          return e.view.dispatch({
            effects: RL.of(!1)
          });
        }, 20), this.composing = 0;
      }
    }
  }),
  HL = CP.baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
      "& > ul": {
        fontFamily: "monospace",
        whiteSpace: "nowrap",
        overflow: "hidden auto",
        maxWidth_fallback: "700px",
        maxWidth: "min(700px, 95vw)",
        minWidth: "250px",
        maxHeight: "10em",
        listStyle: "none",
        margin: 0,
        padding: 0,
        "& > li": {
          overflowX: "hidden",
          textOverflow: "ellipsis",
          cursor: "pointer",
          padding: "1px 3px",
          lineHeight: 1.2
        }
      }
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
      background: "#17c",
      color: "white"
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
      background: "#347",
      color: "white"
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
      content: '"···"',
      opacity: .5,
      display: "block",
      textAlign: "center"
    },
    ".cm-tooltip.cm-completionInfo": {
      position: "absolute",
      padding: "3px 9px",
      width: "max-content",
      maxWidth: "300px"
    },
    ".cm-completionInfo.cm-completionInfo-left": {
      right: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-right": {
      left: "100%"
    },
    "&light .cm-snippetField": {
      backgroundColor: "#00000022"
    },
    "&dark .cm-snippetField": {
      backgroundColor: "#ffffff22"
    },
    ".cm-snippetFieldPosition": {
      verticalAlign: "text-top",
      width: 0,
      height: "1.15em",
      margin: "0 -0.7px -.7em",
      borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": {
      textDecoration: "underline"
    },
    ".cm-completionDetail": {
      marginLeft: "0.5em",
      fontStyle: "italic"
    },
    ".cm-completionIcon": {
      fontSize: "90%",
      width: ".8em",
      display: "inline-block",
      textAlign: "center",
      paddingRight: ".6em",
      opacity: "0.6"
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
      "&:after": {
        content: "'ƒ'"
      }
    },
    ".cm-completionIcon-class": {
      "&:after": {
        content: "'○'"
      }
    },
    ".cm-completionIcon-interface": {
      "&:after": {
        content: "'◌'"
      }
    },
    ".cm-completionIcon-variable": {
      "&:after": {
        content: "'𝑥'"
      }
    },
    ".cm-completionIcon-constant": {
      "&:after": {
        content: "'𝐶'"
      }
    },
    ".cm-completionIcon-type": {
      "&:after": {
        content: "'𝑡'"
      }
    },
    ".cm-completionIcon-enum": {
      "&:after": {
        content: "'∪'"
      }
    },
    ".cm-completionIcon-property": {
      "&:after": {
        content: "'□'"
      }
    },
    ".cm-completionIcon-keyword": {
      "&:after": {
        content: "'🔑︎'"
      }
    },
    ".cm-completionIcon-namespace": {
      "&:after": {
        content: "'▢'"
      }
    },
    ".cm-completionIcon-text": {
      "&:after": {
        content: "'abc'",
        fontSize: "50%",
        verticalAlign: "middle"
      }
    }
  }),
  WL = {
    brackets: ["(", "[", "{", "'", '"'],
    before: ")]}:;>"
  },
  UL = Y_.define({
    map: function map(e, t) {
      var n = t.mapPos(e, -1, c_.TrackAfter);
      return null == n ? void 0 : n;
    }
  }),
  JL = Y_.define({
    map: function map(e, t) {
      return t.mapPos(e);
    }
  }),
  KL = new (function (e) {
    ji(n, f$);
    var t = Ci(n);
    function n() {
      return Ri(this, n), t.apply(this, arguments);
    }
    return zi(n);
  }())();
KL.startSide = 1, KL.endSide = -1;
var GL = O_.define({
  create: function create() {
    return p$.empty;
  },
  update: function update(e, t) {
    if (t.selection) {
      var n = t.state.doc.lineAt(t.selection.main.head).from,
        r = t.startState.doc.lineAt(t.startState.selection.main.head).from;
      n != t.changes.mapPos(r, -1) && (e = p$.empty);
    }
    e = e.map(t.changes);
    var i,
      o = bi(t.effects);
    try {
      var a = function a() {
        var t = i.value;
        t.is(UL) ? e = e.update({
          add: [KL.range(t.value, t.value + 1)]
        }) : t.is(JL) && (e = e.update({
          filter: function filter(e) {
            return e != t.value;
          }
        }));
      };
      for (o.s(); !(i = o.n()).done;) {
        a();
      }
    } catch (e) {
      o.e(e);
    } finally {
      o.f();
    }
    return e;
  }
});
function QL() {
  return [eB, GL];
}
function YL(e) {
  for (var t = 0; t < "()[]{}<>".length; t += 2) {
    if ("()[]{}<>".charCodeAt(t) == e) return "()[]{}<>".charAt(t + 1);
  }
  return a_(e < 128 ? e : e + 1);
}
function ZL(e, t) {
  return e.languageDataAt("closeBrackets", t)[0] || WL;
}
var XL = "object" == ("undefined" == typeof navigator ? "undefined" : Li(navigator)) && /Android\b/.test(navigator.userAgent),
  eB = CP.inputHandler.of(function (e, t, n, r) {
    if ((XL ? e.composing : e.compositionStarted) || e.state.readOnly) return !1;
    var i = e.state.selection.main;
    if (r.length > 2 || 2 == r.length && 1 == s_(o_(r, 0)) || t != i.from || n != i.to) return !1;
    var o = function (e, t) {
      var n,
        r = ZL(e, e.selection.main.head),
        i = r.brackets || WL.brackets,
        o = bi(i);
      try {
        for (o.s(); !(n = o.n()).done;) {
          var a = n.value,
            s = YL(o_(a, 0));
          if (t == a) return s == a ? aB(e, a, i.indexOf(a + a + a) > -1) : iB(e, a, s, r.before || WL.before);
          if (t == s && nB(e, e.selection.main.from)) return oB(e, a, s);
        }
      } catch (e) {
        o.e(e);
      } finally {
        o.f();
      }
      return null;
    }(e.state, r);
    return !!o && (e.dispatch(o), !0);
  }),
  tB = [{
    key: "Backspace",
    run: function run(e) {
      var t = e.state,
        n = e.dispatch;
      if (t.readOnly) return !1;
      var r = ZL(t, t.selection.main.head).brackets || WL.brackets,
        i = null,
        o = t.changeByRange(function (e) {
          if (e.empty) {
            var n,
              o = function (e, t) {
                var n = e.sliceString(t - 2, t);
                return s_(o_(n, 0)) == n.length ? n : n.slice(1);
              }(t.doc, e.head),
              a = bi(r);
            try {
              for (a.s(); !(n = a.n()).done;) {
                var s = n.value;
                if (s == o && rB(t.doc, e.head) == YL(o_(s, 0))) return {
                  changes: {
                    from: e.head - s.length,
                    to: e.head + s.length
                  },
                  range: b_.cursor(e.head - s.length),
                  userEvent: "delete.backward"
                };
              }
            } catch (e) {
              a.e(e);
            } finally {
              a.f();
            }
          }
          return {
            range: i = e
          };
        });
      return i || n(t.update(o, {
        scrollIntoView: !0
      })), !i;
    }
  }];
function nB(e, t) {
  var n = !1;
  return e.field(GL).between(0, e.doc.length, function (e) {
    e == t && (n = !0);
  }), n;
}
function rB(e, t) {
  var n = e.sliceString(t, t + 2);
  return n.slice(0, s_(o_(n, 0)));
}
function iB(e, t, n, r) {
  var i = null,
    o = e.changeByRange(function (o) {
      if (!o.empty) return {
        changes: [{
          insert: t,
          from: o.from
        }, {
          insert: n,
          from: o.to
        }],
        effects: UL.of(o.to + t.length),
        range: b_.range(o.anchor + t.length, o.head + t.length)
      };
      var a = rB(e.doc, o.head);
      return !a || /\s/.test(a) || r.indexOf(a) > -1 ? {
        changes: {
          insert: t + n,
          from: o.head
        },
        effects: UL.of(o.head + t.length),
        range: b_.cursor(o.head + t.length)
      } : {
        range: i = o
      };
    });
  return i ? null : e.update(o, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function oB(e, t, n) {
  var r = null,
    i = e.selection.ranges.map(function (t) {
      return t.empty && rB(e.doc, t.head) == n ? b_.cursor(t.head + n.length) : r = t;
    });
  return r ? null : e.update({
    selection: b_.create(i, e.selection.mainIndex),
    scrollIntoView: !0,
    effects: e.selection.ranges.map(function (e) {
      var t = e.from;
      return JL.of(t);
    })
  });
}
function aB(e, t, n) {
  var r = null,
    i = e.changeByRange(function (i) {
      if (!i.empty) return {
        changes: [{
          insert: t,
          from: i.from
        }, {
          insert: t,
          from: i.to
        }],
        effects: UL.of(i.to + t.length),
        range: b_.range(i.anchor + t.length, i.head + t.length)
      };
      var o = i.head,
        a = rB(e.doc, o);
      if (a == t) {
        if (sB(e, o)) return {
          changes: {
            insert: t + t,
            from: o
          },
          effects: UL.of(o + t.length),
          range: b_.cursor(o + t.length)
        };
        if (nB(e, o)) {
          var s = n && e.sliceDoc(o, o + 3 * t.length) == t + t + t;
          return {
            range: b_.cursor(o + t.length * (s ? 3 : 1)),
            effects: JL.of(o)
          };
        }
      } else {
        if (n && e.sliceDoc(o - 2 * t.length, o) == t + t && sB(e, o - 2 * t.length)) return {
          changes: {
            insert: t + t + t + t,
            from: o
          },
          effects: UL.of(o + t.length),
          range: b_.cursor(o + t.length)
        };
        if (e.charCategorizer(o)(a) != a$.Word) {
          var u = e.sliceDoc(o - 1, o);
          if (u != t && e.charCategorizer(o)(u) != a$.Word && !function (e, t, n) {
            for (var r = qT(e).resolveInner(t, -1), i = 0; i < 5; i++) {
              if (e.sliceDoc(r.from, r.from + n.length) == n) return !0;
              var o = r.to == t && r.parent;
              if (!o) break;
              r = o;
            }
            return !1;
          }(e, o, t)) return {
            changes: {
              insert: t + t,
              from: o
            },
            effects: UL.of(o + t.length),
            range: b_.cursor(o + t.length)
          };
        }
      }
      return {
        range: r = i
      };
    });
  return r ? null : e.update(i, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function sB(e, t) {
  var n = qT(e).resolveInner(t + 1);
  return n.parent && n.from == t;
}
function uB() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return [BL, jL.of(e), VL, lB, HL];
}
var cB = [{
    key: "Ctrl-Space",
    run: function run(e) {
      return !!e.state.field(BL, !1) && (e.dispatch({
        effects: RL.of(!0)
      }), !0);
    }
  }, {
    key: "Escape",
    run: function run(e) {
      var t = e.state.field(BL, !1);
      return !(!t || !t.active.some(function (e) {
        return 0 != e.state;
      })) && (e.dispatch({
        effects: DL.of(null)
      }), !0);
    }
  }, {
    key: "ArrowDown",
    run: qL(!0)
  }, {
    key: "ArrowUp",
    run: qL(!1)
  }, {
    key: "PageDown",
    run: qL(!0, "page")
  }, {
    key: "PageUp",
    run: qL(!1, "page")
  }, {
    key: "Enter",
    run: function run(e) {
      var t = e.state.field(BL, !1);
      return !(e.state.readOnly || !t || !t.open || Date.now() - t.open.timestamp < 75) && (bL(e, t.open.options[t.open.selected]), !0);
    }
  }],
  lB = T_.highest(TP.computeN([jL], function (e) {
    return e.facet(jL).defaultKeymap ? [cB] : [];
  })),
  fB = zi(function e(t, n, r) {
    Ri(this, e), this.from = t, this.to = n, this.diagnostic = r;
  }),
  hB = function () {
    function e(t, n, r) {
      Ri(this, e), this.diagnostics = t, this.panel = n, this.selected = r;
    }
    return zi(e, null, [{
      key: "init",
      value: function value(t, n, r) {
        var i = t,
          o = r.facet(_B).markerFilter;
        o && (i = o(i));
        var a = UO.set(i.map(function (e) {
          return e.from == e.to || e.from == e.to - 1 && r.doc.lineAt(e.from).to == e.from ? UO.widget({
            widget: new EB(e),
            diagnostic: e
          }).range(e.from) : UO.mark({
            attributes: {
              class: "cm-lintRange cm-lintRange-" + e.severity
            },
            diagnostic: e
          }).range(e.from, e.to);
        }), !0);
        return new e(a, n, dB(a));
      }
    }]), e;
  }();
function dB(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
    r = null;
  return e.between(n, 1e9, function (e, n, i) {
    var o = i.spec;
    if (!t || o.diagnostic == t) return r = new fB(e, n, o.diagnostic), !1;
  }), r;
}
function vB(e, t) {
  return !(!e.effects.some(function (e) {
    return e.is(mB);
  }) && !e.changes.touchesRange(t.pos));
}
function pB(e, t) {
  return e.field(bB, !1) ? t : t.concat(Y_.appendConfig.of([bB, CP.decorations.compute([bB], function (e) {
    var t = e.field(bB),
      n = t.selected,
      r = t.panel;
    return n && r && n.from != n.to ? UO.set([kB.range(n.from, n.to)]) : UO.none;
  }), MM(wB, {
    hideOn: vB
  }), NB]));
}
var mB = Y_.define(),
  gB = Y_.define(),
  yB = Y_.define(),
  bB = O_.define({
    create: function create() {
      return new hB(UO.none, null, null);
    },
    update: function update(e, t) {
      if (t.docChanged) {
        var n = e.diagnostics.map(t.changes),
          r = null;
        if (e.selected) {
          var i = t.changes.mapPos(e.selected.from, 1);
          r = dB(n, e.selected.diagnostic, i) || dB(n, null, i);
        }
        e = new hB(n, e.panel, r);
      }
      var o,
        a = bi(t.effects);
      try {
        for (a.s(); !(o = a.n()).done;) {
          var s = o.value;
          s.is(mB) ? e = hB.init(s.value, e.panel, t.state) : s.is(gB) ? e = new hB(e.diagnostics, s.value ? MB.open : null, e.selected) : s.is(yB) && (e = new hB(e.diagnostics, e.panel, s.value));
        }
      } catch (e) {
        a.e(e);
      } finally {
        a.f();
      }
      return e;
    },
    provide: function provide(e) {
      return [BM.from(e, function (e) {
        return e.panel;
      }), CP.decorations.from(e, function (e) {
        return e.diagnostics;
      })];
    }
  }),
  kB = UO.mark({
    class: "cm-lintRange cm-lintRange-active"
  });
function wB(e, t, n) {
  var r = e.state.field(bB).diagnostics,
    i = [],
    o = 2e8,
    a = 0;
  r.between(t - (n < 0 ? 1 : 0), t + (n > 0 ? 1 : 0), function (e, r, s) {
    var u = s.spec;
    t >= e && t <= r && (e == r || (t > e || n > 0) && (t < r || n < 0)) && (i.push(u.diagnostic), o = Math.min(e, o), a = Math.max(r, a));
  });
  var s = e.state.facet(_B).tooltipFilter;
  return s && (i = s(i)), i.length ? {
    pos: o,
    end: a,
    above: e.state.doc.lineAt(o).to < a,
    create: function create() {
      return {
        dom: xB(e, i)
      };
    }
  } : null;
}
function xB(e, t) {
  return dz("ul", {
    class: "cm-tooltip-lint"
  }, t.map(function (t) {
    return AB(e, t, !1);
  }));
}
var jB = function jB(e) {
    var t = e.state.field(bB, !1);
    return !(!t || !t.panel) && (e.dispatch({
      effects: gB.of(!1)
    }), !0);
  },
  SB = [{
    key: "Mod-Shift-m",
    run: function run(e) {
      var t = e.state.field(bB, !1);
      t && t.panel || e.dispatch({
        effects: pB(e.state, [gB.of(!0)])
      });
      var n = RM(e, MB.open);
      return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
    }
  }, {
    key: "F8",
    run: function run(e) {
      var t = e.state.field(bB, !1);
      if (!t) return !1;
      var n = e.state.selection.main,
        r = t.diagnostics.iter(n.to + 1);
      return !(!r.value && (!(r = t.diagnostics.iter(0)).value || r.from == n.from && r.to == n.to)) && (e.dispatch({
        selection: {
          anchor: r.from,
          head: r.to
        },
        scrollIntoView: !0
      }), !0);
    }
  }],
  CB = mA.fromClass(function () {
    function e(t) {
      Ri(this, e), this.view = t, this.timeout = -1, this.set = !0;
      var n = t.state.facet(_B).delay;
      this.lintTime = Date.now() + n, this.run = this.run.bind(this), this.timeout = setTimeout(this.run, n);
    }
    return zi(e, [{
      key: "run",
      value: function value() {
        var e = this,
          t = Date.now();
        if (t < this.lintTime - 10) setTimeout(this.run, this.lintTime - t);else {
          this.set = !1;
          var n = this.view.state,
            r = n.facet(_B).sources;
          Promise.all(r.map(function (t) {
            return Promise.resolve(t(e.view));
          })).then(function (t) {
            var r = t.reduce(function (e, t) {
              return e.concat(t);
            });
            e.view.state.doc == n.doc && e.view.dispatch(function (e, t) {
              return {
                effects: pB(e, [mB.of(t)])
              };
            }(e.view.state, r));
          }, function (t) {
            hA(e.view.state, t);
          });
        }
      }
    }, {
      key: "update",
      value: function value(e) {
        var t = e.state.facet(_B);
        (e.docChanged || t != e.startState.facet(_B)) && (this.lintTime = Date.now() + t.delay, this.set || (this.set = !0, this.timeout = setTimeout(this.run, t.delay)));
      }
    }, {
      key: "force",
      value: function value() {
        this.set && (this.lintTime = Date.now(), this.run());
      }
    }, {
      key: "destroy",
      value: function value() {
        clearTimeout(this.timeout);
      }
    }]), e;
  }()),
  _B = x_.define({
    combine: function combine(e) {
      return Object.assign({
        sources: e.map(function (e) {
          return e.source;
        })
      }, l$(e.map(function (e) {
        return e.config;
      }), {
        delay: 750,
        markerFilter: null,
        tooltipFilter: null
      }));
    },
    enables: CB
  });
function $B(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return _B.of({
    source: e,
    config: t
  });
}
function OB(e) {
  var t = [];
  if (e) {
    var n,
      r = bi(e);
    try {
      e: for (r.s(); !(n = r.n()).done;) {
        for (var i = n.value.name, o = function o(e) {
            var n = i[e];
            if (/[a-zA-Z]/.test(n) && !t.some(function (e) {
              return e.toLowerCase() == n.toLowerCase();
            })) return t.push(n), "continue|actions";
          }, a = 0; a < i.length; a++) {
          if ("continue|actions" === o(a)) continue e;
        }
        t.push("");
      }
    } catch (e) {
      r.e(e);
    } finally {
      r.f();
    }
  }
  return t;
}
function AB(e, t, n) {
  var r,
    i = n ? OB(t.actions) : [];
  return dz("li", {
    class: "cm-diagnostic cm-diagnostic-" + t.severity
  }, dz("span", {
    class: "cm-diagnosticText"
  }, t.renderMessage ? t.renderMessage() : t.message), null === (r = t.actions) || void 0 === r ? void 0 : r.map(function (n, r) {
    var o = function o(r) {
        r.preventDefault();
        var i = dB(e.state.field(bB).diagnostics, t);
        i && n.apply(e, i.from, i.to);
      },
      a = n.name,
      s = i[r] ? a.indexOf(i[r]) : -1,
      u = s < 0 ? a : [a.slice(0, s), dz("u", a.slice(s, s + 1)), a.slice(s + 1)];
    return dz("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: o,
      onmousedown: o,
      "aria-label": " Action: ".concat(a).concat(s < 0 ? "" : ' (access key "'.concat(i[r], ')"'), ".")
    }, u);
  }), t.source && dz("div", {
    class: "cm-diagnosticSource"
  }, t.source));
}
var EB = function (e) {
    ji(n, HO);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), (r = t.call(this)).diagnostic = e, r;
    }
    return zi(n, [{
      key: "eq",
      value: function value(e) {
        return e.diagnostic == this.diagnostic;
      }
    }, {
      key: "toDOM",
      value: function value() {
        return dz("span", {
          class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity
        });
      }
    }]), n;
  }(),
  PB = zi(function e(t, n) {
    Ri(this, e), this.diagnostic = n, this.id = "item_" + Math.floor(4294967295 * Math.random()).toString(16), this.dom = AB(t, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }),
  MB = function () {
    function e(t) {
      var n = this;
      Ri(this, e), this.view = t, this.items = [];
      this.list = dz("ul", {
        tabIndex: 0,
        role: "listbox",
        "aria-label": this.view.state.phrase("Diagnostics"),
        onkeydown: function onkeydown(e) {
          if (27 == e.keyCode) jB(n.view), n.view.focus();else if (38 == e.keyCode || 33 == e.keyCode) n.moveSelection((n.selectedIndex - 1 + n.items.length) % n.items.length);else if (40 == e.keyCode || 34 == e.keyCode) n.moveSelection((n.selectedIndex + 1) % n.items.length);else if (36 == e.keyCode) n.moveSelection(0);else if (35 == e.keyCode) n.moveSelection(n.items.length - 1);else if (13 == e.keyCode) n.view.focus();else {
            if (!(e.keyCode >= 65 && e.keyCode <= 90 && n.selectedIndex >= 0)) return;
            for (var r = n.items[n.selectedIndex].diagnostic, i = OB(r.actions), o = 0; o < i.length; o++) {
              if (i[o].toUpperCase().charCodeAt(0) == e.keyCode) {
                var a = dB(n.view.state.field(bB).diagnostics, r);
                a && r.actions[o].apply(t, a.from, a.to);
              }
            }
          }
          e.preventDefault();
        },
        onclick: function onclick(e) {
          for (var t = 0; t < n.items.length; t++) {
            n.items[t].dom.contains(e.target) && n.moveSelection(t);
          }
        }
      }), this.dom = dz("div", {
        class: "cm-panel-lint"
      }, this.list, dz("button", {
        type: "button",
        name: "close",
        "aria-label": this.view.state.phrase("close"),
        onclick: function onclick() {
          return jB(n.view);
        }
      }, "×")), this.update();
    }
    return zi(e, [{
      key: "selectedIndex",
      get: function get() {
        var e = this.view.state.field(bB).selected;
        if (!e) return -1;
        for (var t = 0; t < this.items.length; t++) {
          if (this.items[t].diagnostic == e.diagnostic) return t;
        }
        return -1;
      }
    }, {
      key: "update",
      value: function value() {
        var e = this,
          t = this.view.state.field(bB),
          n = t.diagnostics,
          r = t.selected,
          i = 0,
          o = !1,
          a = null;
        for (n.between(0, this.view.state.doc.length, function (t, n, s) {
          for (var u, c = s.spec, l = -1, f = i; f < e.items.length; f++) {
            if (e.items[f].diagnostic == c.diagnostic) {
              l = f;
              break;
            }
          }
          l < 0 ? (u = new PB(e.view, c.diagnostic), e.items.splice(i, 0, u), o = !0) : (u = e.items[l], l > i && (e.items.splice(i, l - i), o = !0)), r && u.diagnostic == r.diagnostic ? u.dom.hasAttribute("aria-selected") || (u.dom.setAttribute("aria-selected", "true"), a = u) : u.dom.hasAttribute("aria-selected") && u.dom.removeAttribute("aria-selected"), i++;
        }); i < this.items.length && !(1 == this.items.length && this.items[0].diagnostic.from < 0);) {
          o = !0, this.items.pop();
        }
        0 == this.items.length && (this.items.push(new PB(this.view, {
          from: -1,
          to: -1,
          severity: "info",
          message: this.view.state.phrase("No diagnostics")
        })), o = !0), a ? (this.list.setAttribute("aria-activedescendant", a.id), this.view.requestMeasure({
          key: this,
          read: function read() {
            return {
              sel: a.dom.getBoundingClientRect(),
              panel: e.list.getBoundingClientRect()
            };
          },
          write: function write(t) {
            var n = t.sel,
              r = t.panel;
            n.top < r.top ? e.list.scrollTop -= r.top - n.top : n.bottom > r.bottom && (e.list.scrollTop += n.bottom - r.bottom);
          }
        })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), o && this.sync();
      }
    }, {
      key: "sync",
      value: function value() {
        var e = this.list.firstChild;
        function t() {
          var t = e;
          e = t.nextSibling, t.remove();
        }
        var n,
          r = bi(this.items);
        try {
          for (r.s(); !(n = r.n()).done;) {
            var i = n.value;
            if (i.dom.parentNode == this.list) {
              for (; e != i.dom;) {
                t();
              }
              e = i.dom.nextSibling;
            } else this.list.insertBefore(i.dom, e);
          }
        } catch (e) {
          r.e(e);
        } finally {
          r.f();
        }
        for (; e;) {
          t();
        }
      }
    }, {
      key: "moveSelection",
      value: function value(e) {
        if (!(this.selectedIndex < 0)) {
          var t = dB(this.view.state.field(bB).diagnostics, this.items[e].diagnostic);
          t && this.view.dispatch({
            selection: {
              anchor: t.from,
              head: t.to
            },
            scrollIntoView: !0,
            effects: yB.of(t)
          });
        }
      }
    }], [{
      key: "open",
      value: function value(t) {
        return new e(t);
      }
    }]), e;
  }();
function IB(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'viewBox="0 0 40 40"';
  return 'url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" '.concat(t, ">").concat(encodeURIComponent(e), "</svg>')");
}
function TB(e) {
  return IB('<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="'.concat(e, '" fill="none" stroke-width=".7"/>'), 'width="6" height="3"');
}
var NB = CP.baseTheme({
    ".cm-diagnostic": {
      padding: "3px 6px 3px 8px",
      marginLeft: "-1px",
      display: "block",
      whiteSpace: "pre-wrap"
    },
    ".cm-diagnostic-error": {
      borderLeft: "5px solid #d11"
    },
    ".cm-diagnostic-warning": {
      borderLeft: "5px solid orange"
    },
    ".cm-diagnostic-info": {
      borderLeft: "5px solid #999"
    },
    ".cm-diagnosticAction": {
      font: "inherit",
      border: "none",
      padding: "2px 4px",
      backgroundColor: "#444",
      color: "white",
      borderRadius: "3px",
      marginLeft: "8px"
    },
    ".cm-diagnosticSource": {
      fontSize: "70%",
      opacity: .7
    },
    ".cm-lintRange": {
      backgroundPosition: "left bottom",
      backgroundRepeat: "repeat-x",
      paddingBottom: "0.7px"
    },
    ".cm-lintRange-error": {
      backgroundImage: TB("#d11")
    },
    ".cm-lintRange-warning": {
      backgroundImage: TB("orange")
    },
    ".cm-lintRange-info": {
      backgroundImage: TB("#999")
    },
    ".cm-lintRange-active": {
      backgroundColor: "#ffdd9980"
    },
    ".cm-tooltip-lint": {
      padding: 0,
      margin: 0
    },
    ".cm-lintPoint": {
      position: "relative",
      "&:after": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: "-2px",
        borderLeft: "3px solid transparent",
        borderRight: "3px solid transparent",
        borderBottom: "4px solid #d11"
      }
    },
    ".cm-lintPoint-warning": {
      "&:after": {
        borderBottomColor: "orange"
      }
    },
    ".cm-lintPoint-info": {
      "&:after": {
        borderBottomColor: "#999"
      }
    },
    ".cm-panel.cm-panel-lint": {
      position: "relative",
      "& ul": {
        maxHeight: "100px",
        overflowY: "auto",
        "& [aria-selected]": {
          backgroundColor: "#ddd",
          "& u": {
            textDecoration: "underline"
          }
        },
        "&:focus [aria-selected]": {
          background_fallback: "#bdf",
          backgroundColor: "Highlight",
          color_fallback: "white",
          color: "HighlightText"
        },
        "& u": {
          textDecoration: "none"
        },
        padding: 0,
        margin: 0
      },
      "& [name=close]": {
        position: "absolute",
        top: "0",
        right: "2px",
        background: "inherit",
        border: "none",
        font: "inherit",
        padding: 0,
        margin: 0
      }
    }
  }),
  RB = function (e) {
    ji(n, qM);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), (r = t.call(this)).diagnostics = e, r.severity = e.reduce(function (e, t) {
        var n = t.severity;
        return "error" == n || "warning" == n && "info" == e ? n : e;
      }, "info"), r;
    }
    return zi(n, [{
      key: "toDOM",
      value: function value(e) {
        var t = document.createElement("div");
        t.className = "cm-lint-marker cm-lint-marker-" + this.severity;
        var n = this.diagnostics,
          r = e.state.facet(VB).tooltipFilter;
        return r && (n = r(n)), n.length && (t.onmouseover = function () {
          return function (e, t, n) {
            function r() {
              var r = e.elementAtHeight(t.getBoundingClientRect().top + 5 - e.documentTop);
              e.coordsAtPos(r.from) && e.dispatch({
                effects: BB.of({
                  pos: r.from,
                  above: !1,
                  create: function create() {
                    return {
                      dom: xB(e, n),
                      getCoords: function getCoords() {
                        return t.getBoundingClientRect();
                      }
                    };
                  }
                })
              }), t.onmouseout = t.onmousemove = null, function (e, t) {
                var n = function n(r) {
                  var i = t.getBoundingClientRect();
                  if (!(r.clientX > i.left - 10 && r.clientX < i.right + 10 && r.clientY > i.top - 10 && r.clientY < i.bottom + 10)) {
                    for (var o = r.target; o; o = o.parentNode) {
                      if (1 == o.nodeType && o.classList.contains("cm-tooltip-lint")) return;
                    }
                    window.removeEventListener("mousemove", n), e.state.field(qB) && e.dispatch({
                      effects: BB.of(null)
                    });
                  }
                };
                window.addEventListener("mousemove", n);
              }(e, t);
            }
            var i = e.state.facet(VB).hoverTime,
              o = setTimeout(r, i);
            t.onmouseout = function () {
              clearTimeout(o), t.onmouseout = t.onmousemove = null;
            }, t.onmousemove = function () {
              clearTimeout(o), o = setTimeout(r, i);
            };
          }(e, t, n);
        }), t;
      }
    }]), n;
  }();
function DB(e, t) {
  var n,
    r = Object.create(null),
    i = bi(t);
  try {
    for (i.s(); !(n = i.n()).done;) {
      var o = n.value,
        a = e.lineAt(o.from);
      (r[a.from] || (r[a.from] = [])).push(o);
    }
  } catch (e) {
    i.e(e);
  } finally {
    i.f();
  }
  var s = [];
  for (var u in r) {
    s.push(new RB(r[u]).range(+u));
  }
  return p$.of(s, !0);
}
var zB = WM({
    class: "cm-gutter-lint",
    markers: function markers(e) {
      return e.state.field(LB);
    }
  }),
  LB = O_.define({
    create: function create() {
      return p$.empty;
    },
    update: function update(e, t) {
      e = e.map(t.changes);
      var n,
        r = t.state.facet(VB).markerFilter,
        i = bi(t.effects);
      try {
        for (i.s(); !(n = i.n()).done;) {
          var o = n.value;
          if (o.is(mB)) {
            var a = o.value;
            r && (a = r(a || [])), e = DB(t.state.doc, a.slice(0));
          }
        }
      } catch (e) {
        i.e(e);
      } finally {
        i.f();
      }
      return e;
    }
  }),
  BB = Y_.define(),
  qB = O_.define({
    create: function create() {
      return null;
    },
    update: function update(e, t) {
      return e && t.docChanged && (e = vB(t, e) ? null : Object.assign(Object.assign({}, e), {
        pos: t.changes.mapPos(e.pos)
      })), t.effects.reduce(function (e, t) {
        return t.is(BB) ? t.value : e;
      }, e);
    },
    provide: function provide(e) {
      return $M.from(e);
    }
  }),
  FB = CP.baseTheme({
    ".cm-gutter-lint": {
      width: "1.4em",
      "& .cm-gutterElement": {
        padding: ".2em"
      }
    },
    ".cm-lint-marker": {
      width: "1em",
      height: "1em"
    },
    ".cm-lint-marker-info": {
      content: IB('<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>')
    },
    ".cm-lint-marker-warning": {
      content: IB('<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>')
    },
    ".cm-lint-marker-error:before": {
      content: IB('<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>')
    }
  }),
  VB = x_.define({
    combine: function combine(e) {
      return l$(e, {
        hoverTime: 300,
        markerFilter: null,
        tooltipFilter: null
      });
    }
  });
function HB() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return [VB.of(e), LB, zB, FB, qB];
}
var WB = [oI(), cI(), sM(), WR(), EN(), qP(), XP(), c$.allowMultipleSelections.of(!0), fN(), RN(LN, {
    fallback: !0
  }), UN(), QL(), uB(), gM(), kM(), hM(), Az(), TP.of([].concat(tB, Ii(fz), aL, lD, jN, cB, SB))],
  UB = 0,
  JB = zi(function e(t, n) {
    Ri(this, e), this.from = t, this.to = n;
  }),
  KB = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      Ri(this, e), this.id = UB++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || function () {
        throw new Error("This node type doesn't define a deserialize function");
      };
    }
    return zi(e, [{
      key: "add",
      value: function value(e) {
        var t = this;
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        return "function" != typeof e && (e = QB.match(e)), function (n) {
          var r = e(n);
          return void 0 === r ? null : [t, r];
        };
      }
    }]), e;
  }();
KB.closedBy = new KB({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), KB.openedBy = new KB({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), KB.group = new KB({
  deserialize: function deserialize(e) {
    return e.split(" ");
  }
}), KB.contextHash = new KB({
  perNode: !0
}), KB.lookAhead = new KB({
  perNode: !0
}), KB.mounted = new KB({
  perNode: !0
});
var GB = Object.create(null),
  QB = function () {
    function e(t, n, r) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
      Ri(this, e), this.name = t, this.props = n, this.id = r, this.flags = i;
    }
    return zi(e, [{
      key: "prop",
      value: function value(e) {
        return this.props[e.id];
      }
    }, {
      key: "isTop",
      get: function get() {
        return (1 & this.flags) > 0;
      }
    }, {
      key: "isSkipped",
      get: function get() {
        return (2 & this.flags) > 0;
      }
    }, {
      key: "isError",
      get: function get() {
        return (4 & this.flags) > 0;
      }
    }, {
      key: "isAnonymous",
      get: function get() {
        return (8 & this.flags) > 0;
      }
    }, {
      key: "is",
      value: function value(e) {
        if ("string" == typeof e) {
          if (this.name == e) return !0;
          var t = this.prop(KB.group);
          return !!t && t.indexOf(e) > -1;
        }
        return this.id == e;
      }
    }], [{
      key: "define",
      value: function value(t) {
        var n = t.props && t.props.length ? Object.create(null) : GB,
          r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (null == t.name ? 8 : 0),
          i = new e(t.name || "", n, t.id, r);
        if (t.props) {
          var o,
            a = bi(t.props);
          try {
            for (a.s(); !(o = a.n()).done;) {
              var s = o.value;
              if (Array.isArray(s) || (s = s(i)), s) {
                if (s[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                n[s[0].id] = s[1];
              }
            }
          } catch (e) {
            a.e(e);
          } finally {
            a.f();
          }
        }
        return i;
      }
    }, {
      key: "match",
      value: function value(e) {
        var t = Object.create(null);
        for (var n in e) {
          var r,
            i = bi(n.split(" "));
          try {
            for (i.s(); !(r = i.n()).done;) {
              var o = r.value;
              t[o] = e[n];
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        }
        return function (e) {
          for (var n = e.prop(KB.group), r = -1; r < (n ? n.length : 0); r++) {
            var i = t[r < 0 ? e.name : n[r]];
            if (i) return i;
          }
        };
      }
    }]), e;
  }();
QB.none = new QB("", Object.create(null), 0, 8);
var YB,
  ZB = function () {
    function e(t) {
      Ri(this, e), this.types = t;
      for (var n = 0; n < t.length; n++) {
        if (t[n].id != n) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
      }
    }
    return zi(e, [{
      key: "extend",
      value: function value() {
        for (var t = [], n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }
        var o,
          a = bi(this.types);
        try {
          for (a.s(); !(o = a.n()).done;) {
            var s,
              u = o.value,
              c = null,
              l = bi(r);
            try {
              for (l.s(); !(s = l.n()).done;) {
                var f = s.value,
                  h = f(u);
                h && (c || (c = Object.assign({}, u.props)), c[h[0].id] = h[1]);
              }
            } catch (e) {
              l.e(e);
            } finally {
              l.f();
            }
            t.push(c ? new QB(u.name, c, u.id, u.flags) : u);
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
        return new e(t);
      }
    }]), e;
  }(),
  XB = new WeakMap(),
  eq = new WeakMap();
!function (e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
}(YB || (YB = {}));
var tq = function () {
  function e(t, n, r, i, o) {
    if (Ri(this, e), this.type = t, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = Object.create(null);
      var a,
        s = bi(o);
      try {
        for (s.s(); !(a = s.n()).done;) {
          var u = xi(a.value, 2),
            c = u[0],
            l = u[1];
          this.props["number" == typeof c ? c : c.id] = l;
        }
      } catch (e) {
        s.e(e);
      } finally {
        s.f();
      }
    }
  }
  return zi(e, [{
    key: "toString",
    value: function value() {
      var e = this.prop(KB.mounted);
      if (e && !e.overlay) return e.tree.toString();
      var t,
        n = "",
        r = bi(this.children);
      try {
        for (r.s(); !(t = r.n()).done;) {
          var i = t.value.toString();
          i && (n && (n += ","), n += i);
        }
      } catch (e) {
        r.e(e);
      } finally {
        r.f();
      }
      return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
    }
  }, {
    key: "cursor",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      return new hq(this.topNode, e);
    }
  }, {
    key: "cursorAt",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = XB.get(this) || this.topNode,
        r = new hq(n);
      return r.moveTo(e, t), XB.set(this, r._tree), r;
    }
  }, {
    key: "topNode",
    get: function get() {
      return new sq(this, 0, 0, null);
    }
  }, {
    key: "resolve",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = aq(XB.get(this) || this.topNode, e, t, !1);
      return XB.set(this, n), n;
    }
  }, {
    key: "resolveInner",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = aq(eq.get(this) || this.topNode, e, t, !0);
      return eq.set(this, n), n;
    }
  }, {
    key: "iterate",
    value: function value(e) {
      for (var t = e.enter, n = e.leave, r = e.from, i = void 0 === r ? 0 : r, o = e.to, a = void 0 === o ? this.length : o, s = this.cursor((e.mode || 0) | YB.IncludeAnonymous);;) {
        var u = !1;
        if (s.from <= a && s.to >= i && (s.type.isAnonymous || !1 !== t(s))) {
          if (s.firstChild()) continue;
          u = !0;
        }
        for (; u && n && !s.type.isAnonymous && n(s), !s.nextSibling();) {
          if (!s.parent()) return;
          u = !0;
        }
      }
    }
  }, {
    key: "prop",
    value: function value(e) {
      return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
    }
  }, {
    key: "propValues",
    get: function get() {
      var e = [];
      if (this.props) for (var t in this.props) {
        e.push([+t, this.props[t]]);
      }
      return e;
    }
  }, {
    key: "balance",
    value: function value() {
      var t = this,
        n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return this.children.length <= 8 ? this : gq(QB.none, this.children, this.positions, 0, this.children.length, 0, this.length, function (n, r, i) {
        return new e(t.type, n, r, i, t.propValues);
      }, n.makeTree || function (t, n, r) {
        return new e(QB.none, t, n, r);
      });
    }
  }], [{
    key: "build",
    value: function value(e) {
      return vq(e);
    }
  }]), e;
}();
tq.empty = new tq(QB.none, [], [], 0);
var nq = function () {
    function e(t, n) {
      Ri(this, e), this.buffer = t, this.index = n;
    }
    return zi(e, [{
      key: "id",
      get: function get() {
        return this.buffer[this.index - 4];
      }
    }, {
      key: "start",
      get: function get() {
        return this.buffer[this.index - 3];
      }
    }, {
      key: "end",
      get: function get() {
        return this.buffer[this.index - 2];
      }
    }, {
      key: "size",
      get: function get() {
        return this.buffer[this.index - 1];
      }
    }, {
      key: "pos",
      get: function get() {
        return this.index;
      }
    }, {
      key: "next",
      value: function value() {
        this.index -= 4;
      }
    }, {
      key: "fork",
      value: function value() {
        return new e(this.buffer, this.index);
      }
    }]), e;
  }(),
  rq = function () {
    function e(t, n, r) {
      Ri(this, e), this.buffer = t, this.length = n, this.set = r;
    }
    return zi(e, [{
      key: "type",
      get: function get() {
        return QB.none;
      }
    }, {
      key: "toString",
      value: function value() {
        for (var e = [], t = 0; t < this.buffer.length;) {
          e.push(this.childString(t)), t = this.buffer[t + 3];
        }
        return e.join(",");
      }
    }, {
      key: "childString",
      value: function value(e) {
        var t = this.buffer[e],
          n = this.buffer[e + 3],
          r = this.set.types[t],
          i = r.name;
        if (/\W/.test(i) && !r.isError && (i = JSON.stringify(i)), n == (e += 4)) return i;
        for (var o = []; e < n;) {
          o.push(this.childString(e)), e = this.buffer[e + 3];
        }
        return i + "(" + o.join(",") + ")";
      }
    }, {
      key: "findChild",
      value: function value(e, t, n, r, i) {
        for (var o = this.buffer, a = -1, s = e; s != t && !(iq(i, r, o[s + 1], o[s + 2]) && (a = s, n > 0)); s = o[s + 3]) {
          ;
        }
        return a;
      }
    }, {
      key: "slice",
      value: function value(t, n, r, i) {
        for (var o = this.buffer, a = new Uint16Array(n - t), s = t, u = 0; s < n;) {
          a[u++] = o[s++], a[u++] = o[s++] - r, a[u++] = o[s++] - r, a[u++] = o[s++] - t;
        }
        return new e(a, i - r, this.set);
      }
    }]), e;
  }();
function iq(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function oq(e, t) {
  for (var n = e.childBefore(t); n;) {
    var r = n.lastChild;
    if (!r || r.to != n.to) break;
    r.type.isError && r.from == r.to ? (e = n, n = r.prevSibling) : n = r;
  }
  return e;
}
function aq(e, t, n, r) {
  for (var i; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t);) {
    var o = !r && e instanceof sq && e.index < 0 ? null : e.parent;
    if (!o) return e;
    e = o;
  }
  var a = r ? 0 : YB.IgnoreOverlays;
  if (r) for (var s = e, u = s.parent; u; u = (s = u).parent) {
    s instanceof sq && s.index < 0 && (null === (i = u.enter(t, n, a)) || void 0 === i ? void 0 : i.from) != s.from && (e = u);
  }
  for (;;) {
    var c = e.enter(t, n, a);
    if (!c) return e;
    e = c;
  }
}
var sq = function () {
  function e(t, n, r, i) {
    Ri(this, e), this._tree = t, this.from = n, this.index = r, this._parent = i;
  }
  return zi(e, [{
    key: "type",
    get: function get() {
      return this._tree.type;
    }
  }, {
    key: "name",
    get: function get() {
      return this._tree.type.name;
    }
  }, {
    key: "to",
    get: function get() {
      return this.from + this._tree.length;
    }
  }, {
    key: "nextChild",
    value: function value(t, n, r, i) {
      for (var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = this;;) {
        for (var s = a._tree, u = s.children, c = s.positions, l = n > 0 ? u.length : -1; t != l; t += n) {
          var f = u[t],
            h = c[t] + a.from;
          if (iq(i, r, h, h + f.length)) if (f instanceof rq) {
            if (o & YB.ExcludeBuffers) continue;
            var d = f.findChild(0, f.buffer.length, n, r - h, i);
            if (d > -1) return new fq(new lq(a, f, t, h), null, d);
          } else if (o & YB.IncludeAnonymous || !f.type.isAnonymous || dq(f)) {
            var v = void 0;
            if (!(o & YB.IgnoreMounts) && f.props && (v = f.prop(KB.mounted)) && !v.overlay) return new e(v.tree, h, t, a);
            var p = new e(f, h, t, a);
            return o & YB.IncludeAnonymous || !p.type.isAnonymous ? p : p.nextChild(n < 0 ? f.children.length - 1 : 0, n, r, i);
          }
        }
        if (o & YB.IncludeAnonymous || !a.type.isAnonymous) return null;
        if (t = a.index >= 0 ? a.index + n : n < 0 ? -1 : a._parent._tree.children.length, !(a = a._parent)) return null;
      }
    }
  }, {
    key: "firstChild",
    get: function get() {
      return this.nextChild(0, 1, 0, 4);
    }
  }, {
    key: "lastChild",
    get: function get() {
      return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
    }
  }, {
    key: "childAfter",
    value: function value(e) {
      return this.nextChild(0, 1, e, 2);
    }
  }, {
    key: "childBefore",
    value: function value(e) {
      return this.nextChild(this._tree.children.length - 1, -1, e, -2);
    }
  }, {
    key: "enter",
    value: function value(t, n) {
      var r,
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
      if (!(i & YB.IgnoreOverlays) && (r = this._tree.prop(KB.mounted)) && r.overlay) {
        var o,
          a = t - this.from,
          s = bi(r.overlay);
        try {
          for (s.s(); !(o = s.n()).done;) {
            var u = o.value,
              c = u.from,
              l = u.to;
            if ((n > 0 ? c <= a : c < a) && (n < 0 ? l >= a : l > a)) return new e(r.tree, r.overlay[0].from + this.from, -1, this);
          }
        } catch (e) {
          s.e(e);
        } finally {
          s.f();
        }
      }
      return this.nextChild(0, 1, t, n, i);
    }
  }, {
    key: "nextSignificantParent",
    value: function value() {
      for (var e = this; e.type.isAnonymous && e._parent;) {
        e = e._parent;
      }
      return e;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent ? this._parent.nextSignificantParent() : null;
    }
  }, {
    key: "nextSibling",
    get: function get() {
      return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
    }
  }, {
    key: "prevSibling",
    get: function get() {
      return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
    }
  }, {
    key: "cursor",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      return new hq(this, e);
    }
  }, {
    key: "tree",
    get: function get() {
      return this._tree;
    }
  }, {
    key: "toTree",
    value: function value() {
      return this._tree;
    }
  }, {
    key: "resolve",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return aq(this, e, t, !1);
    }
  }, {
    key: "resolveInner",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return aq(this, e, t, !0);
    }
  }, {
    key: "enterUnfinishedNodesBefore",
    value: function value(e) {
      return oq(this, e);
    }
  }, {
    key: "getChild",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
        r = uq(this, e, t, n);
      return r.length ? r[0] : null;
    }
  }, {
    key: "getChildren",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
      return uq(this, e, t, n);
    }
  }, {
    key: "toString",
    value: function value() {
      return this._tree.toString();
    }
  }, {
    key: "node",
    get: function get() {
      return this;
    }
  }, {
    key: "matchContext",
    value: function value(e) {
      return cq(this, e);
    }
  }]), e;
}();
function uq(e, t, n, r) {
  var i = e.cursor(),
    o = [];
  if (!i.firstChild()) return o;
  if (null != n) for (; !i.type.is(n);) {
    if (!i.nextSibling()) return o;
  }
  for (;;) {
    if (null != r && i.type.is(r)) return o;
    if (i.type.is(t) && o.push(i.node), !i.nextSibling()) return null == r ? o : [];
  }
}
function cq(e, t) {
  for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length - 1, r = e.parent; n >= 0; r = r.parent) {
    if (!r) return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name) return !1;
      n--;
    }
  }
  return !0;
}
var lq = zi(function e(t, n, r, i) {
    Ri(this, e), this.parent = t, this.buffer = n, this.index = r, this.start = i;
  }),
  fq = function () {
    function e(t, n, r) {
      Ri(this, e), this.context = t, this._parent = n, this.index = r, this.type = t.buffer.set.types[t.buffer.buffer[r]];
    }
    return zi(e, [{
      key: "name",
      get: function get() {
        return this.type.name;
      }
    }, {
      key: "from",
      get: function get() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
      }
    }, {
      key: "to",
      get: function get() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
      }
    }, {
      key: "child",
      value: function value(t, n, r) {
        var i = this.context.buffer,
          o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
        return o < 0 ? null : new e(this.context, this, o);
      }
    }, {
      key: "firstChild",
      get: function get() {
        return this.child(1, 0, 4);
      }
    }, {
      key: "lastChild",
      get: function get() {
        return this.child(-1, 0, 4);
      }
    }, {
      key: "childAfter",
      value: function value(e) {
        return this.child(1, e, 2);
      }
    }, {
      key: "childBefore",
      value: function value(e) {
        return this.child(-1, e, -2);
      }
    }, {
      key: "enter",
      value: function value(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
        if (r & YB.ExcludeBuffers) return null;
        var i = this.context.buffer,
          o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
        return o < 0 ? null : new e(this.context, this, o);
      }
    }, {
      key: "parent",
      get: function get() {
        return this._parent || this.context.parent.nextSignificantParent();
      }
    }, {
      key: "externalSibling",
      value: function value(e) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + e, e, 0, 4);
      }
    }, {
      key: "nextSibling",
      get: function get() {
        var t = this.context.buffer,
          n = t.buffer[this.index + 3];
        return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new e(this.context, this._parent, n) : this.externalSibling(1);
      }
    }, {
      key: "prevSibling",
      get: function get() {
        var t = this.context.buffer,
          n = this._parent ? this._parent.index + 4 : 0;
        return this.index == n ? this.externalSibling(-1) : new e(this.context, this._parent, t.findChild(n, this.index, -1, 0, 4));
      }
    }, {
      key: "cursor",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
        return new hq(this, e);
      }
    }, {
      key: "tree",
      get: function get() {
        return null;
      }
    }, {
      key: "toTree",
      value: function value() {
        var e = [],
          t = [],
          n = this.context.buffer,
          r = this.index + 4,
          i = n.buffer[this.index + 3];
        if (i > r) {
          var o = n.buffer[this.index + 1],
            a = n.buffer[this.index + 2];
          e.push(n.slice(r, i, o, a)), t.push(0);
        }
        return new tq(this.type, e, t, this.to - this.from);
      }
    }, {
      key: "resolve",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return aq(this, e, t, !1);
      }
    }, {
      key: "resolveInner",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return aq(this, e, t, !0);
      }
    }, {
      key: "enterUnfinishedNodesBefore",
      value: function value(e) {
        return oq(this, e);
      }
    }, {
      key: "toString",
      value: function value() {
        return this.context.buffer.childString(this.index);
      }
    }, {
      key: "getChild",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          r = uq(this, e, t, n);
        return r.length ? r[0] : null;
      }
    }, {
      key: "getChildren",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        return uq(this, e, t, n);
      }
    }, {
      key: "node",
      get: function get() {
        return this;
      }
    }, {
      key: "matchContext",
      value: function value(e) {
        return cq(this, e);
      }
    }]), e;
  }(),
  hq = function () {
    function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      if (Ri(this, e), this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof sq) this.yieldNode(t);else {
        this._tree = t.context.parent, this.buffer = t.context;
        for (var r = t._parent; r; r = r._parent) {
          this.stack.unshift(r.index);
        }
        this.bufferNode = t, this.yieldBuf(t.index);
      }
    }
    return zi(e, [{
      key: "name",
      get: function get() {
        return this.type.name;
      }
    }, {
      key: "yieldNode",
      value: function value(e) {
        return !!e && (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0);
      }
    }, {
      key: "yieldBuf",
      value: function value(e, t) {
        this.index = e;
        var n = this.buffer,
          r = n.start,
          i = n.buffer;
        return this.type = t || i.set.types[i.buffer[e]], this.from = r + i.buffer[e + 1], this.to = r + i.buffer[e + 2], !0;
      }
    }, {
      key: "yield",
      value: function value(e) {
        return !!e && (e instanceof sq ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)));
      }
    }, {
      key: "toString",
      value: function value() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
      }
    }, {
      key: "enterChild",
      value: function value(e, t, n) {
        if (!this.buffer) return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, t, n, this.mode));
        var r = this.buffer.buffer,
          i = r.findChild(this.index + 4, r.buffer[this.index + 3], e, t - this.buffer.start, n);
        return !(i < 0) && (this.stack.push(this.index), this.yieldBuf(i));
      }
    }, {
      key: "firstChild",
      value: function value() {
        return this.enterChild(1, 0, 4);
      }
    }, {
      key: "lastChild",
      value: function value() {
        return this.enterChild(-1, 0, 4);
      }
    }, {
      key: "childAfter",
      value: function value(e) {
        return this.enterChild(1, e, 2);
      }
    }, {
      key: "childBefore",
      value: function value(e) {
        return this.enterChild(-1, e, -2);
      }
    }, {
      key: "enter",
      value: function value(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.mode;
        return this.buffer ? !(n & YB.ExcludeBuffers) && this.enterChild(1, e, t) : this.yield(this._tree.enter(e, t, n));
      }
    }, {
      key: "parent",
      value: function value() {
        if (!this.buffer) return this.yieldNode(this.mode & YB.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        var e = this.mode & YB.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        return this.buffer = null, this.yieldNode(e);
      }
    }, {
      key: "sibling",
      value: function value(e) {
        if (!this.buffer) return !!this._tree._parent && this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode));
        var t = this.buffer.buffer,
          n = this.stack.length - 1;
        if (e < 0) {
          var r = n < 0 ? 0 : this.stack[n] + 4;
          if (this.index != r) return this.yieldBuf(t.findChild(r, this.index, -1, 0, 4));
        } else {
          var i = t.buffer[this.index + 3];
          if (i < (n < 0 ? t.buffer.length : t.buffer[this.stack[n] + 3])) return this.yieldBuf(i);
        }
        return n < 0 && this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode));
      }
    }, {
      key: "nextSibling",
      value: function value() {
        return this.sibling(1);
      }
    }, {
      key: "prevSibling",
      value: function value() {
        return this.sibling(-1);
      }
    }, {
      key: "atLastNode",
      value: function value(e) {
        var t,
          n,
          r = this.buffer;
        if (r) {
          if (e > 0) {
            if (this.index < r.buffer.buffer.length) return !1;
          } else for (var i = 0; i < this.index; i++) {
            if (r.buffer.buffer[i + 3] < this.index) return !1;
          }
          t = r.index, n = r.parent;
        } else {
          var o = this._tree;
          t = o.index, n = o._parent;
        }
        for (; n; t = (a = n).index, n = a._parent, a) {
          var a;
          if (t > -1) for (var s = t + e, u = e < 0 ? -1 : n._tree.children.length; s != u; s += e) {
            var c = n._tree.children[s];
            if (this.mode & YB.IncludeAnonymous || c instanceof rq || !c.type.isAnonymous || dq(c)) return !1;
          }
        }
        return !0;
      }
    }, {
      key: "move",
      value: function value(e, t) {
        if (t && this.enterChild(e, 0, 4)) return !0;
        for (;;) {
          if (this.sibling(e)) return !0;
          if (this.atLastNode(e) || !this.parent()) return !1;
        }
      }
    }, {
      key: "next",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        return this.move(1, e);
      }
    }, {
      key: "prev",
      value: function value() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        return this.move(-1, e);
      }
    }, {
      key: "moveTo",
      value: function value(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0; (this.from == this.to || (t < 1 ? this.from >= e : this.from > e) || (t > -1 ? this.to <= e : this.to < e)) && this.parent();) {
          ;
        }
        for (; this.enterChild(1, e, t);) {
          ;
        }
        return this;
      }
    }, {
      key: "node",
      get: function get() {
        if (!this.buffer) return this._tree;
        var e = this.bufferNode,
          t = null,
          n = 0;
        if (e && e.context == this.buffer) e: for (var r = this.index, i = this.stack.length; i >= 0;) {
          for (var o = e; o; o = o._parent) {
            if (o.index == r) {
              if (r == this.index) return o;
              t = o, n = i + 1;
              break e;
            }
          }
          r = this.stack[--i];
        }
        for (var a = n; a < this.stack.length; a++) {
          t = new fq(this.buffer, t, this.stack[a]);
        }
        return this.bufferNode = new fq(this.buffer, t, this.index);
      }
    }, {
      key: "tree",
      get: function get() {
        return this.buffer ? null : this._tree._tree;
      }
    }, {
      key: "iterate",
      value: function value(e, t) {
        for (var n = 0;;) {
          var r = !1;
          if (this.type.isAnonymous || !1 !== e(this)) {
            if (this.firstChild()) {
              n++;
              continue;
            }
            this.type.isAnonymous || (r = !0);
          }
          for (; r && t && t(this), r = this.type.isAnonymous, !this.nextSibling();) {
            if (!n) return;
            this.parent(), n--, r = !0;
          }
        }
      }
    }, {
      key: "matchContext",
      value: function value(e) {
        if (!this.buffer) return cq(this.node, e);
        for (var t = this.buffer.buffer, n = t.set.types, r = e.length - 1, i = this.stack.length - 1; r >= 0; i--) {
          if (i < 0) return cq(this.node, e, r);
          var o = n[t.buffer[this.stack[i]]];
          if (!o.isAnonymous) {
            if (e[r] && e[r] != o.name) return !1;
            r--;
          }
        }
        return !0;
      }
    }]), e;
  }();
function dq(e) {
  return e.children.some(function (e) {
    return e instanceof rq || !e.type.isAnonymous || dq(e);
  });
}
function vq(e) {
  var t,
    n = e.buffer,
    r = e.nodeSet,
    i = e.maxBufferLength,
    o = void 0 === i ? 1024 : i,
    a = e.reused,
    s = void 0 === a ? [] : a,
    u = e.minRepeatType,
    c = void 0 === u ? r.types.length : u,
    l = Array.isArray(n) ? new nq(n, n.length) : n,
    f = r.types,
    h = 0,
    d = 0;
  function v(e, t, n, i, a) {
    for (var u = l.id, y = l.start, b = l.end, k = l.size, w = d; k < 0;) {
      if (l.next(), -1 == k) {
        var x = s[u];
        return n.push(x), void i.push(y - e);
      }
      if (-3 == k) return void (h = u);
      if (-4 == k) return void (d = u);
      throw new RangeError("Unrecognized record size: ".concat(k));
    }
    var j,
      S,
      C = f[u],
      _ = y - e;
    if (b - y <= o && (S = function (e, t) {
      var n = l.fork(),
        r = 0,
        i = 0,
        a = 0,
        s = n.end - o,
        u = {
          size: 0,
          start: 0,
          skip: 0
        };
      e: for (var f = n.pos - e; n.pos > f;) {
        var h = n.size;
        if (n.id == t && h >= 0) u.size = r, u.start = i, u.skip = a, a += 4, r += 4, n.next();else {
          var d = n.pos - h;
          if (h < 0 || d < f || n.start < s) break;
          var v = n.id >= c ? 4 : 0,
            p = n.start;
          for (n.next(); n.pos > d;) {
            if (n.size < 0) {
              if (-3 != n.size) break e;
              v += 4;
            } else n.id >= c && (v += 4);
            n.next();
          }
          i = p, r += h, a += v;
        }
      }
      (t < 0 || r == e) && (u.size = r, u.start = i, u.skip = a);
      return u.size > 4 ? u : void 0;
    }(l.pos - t, a))) {
      for (var $ = new Uint16Array(S.size - S.skip), O = l.pos - S.size, A = $.length; l.pos > O;) {
        A = g(S.start, $, A);
      }
      j = new rq($, b - S.start, r), _ = S.start - e;
    } else {
      var E = l.pos - k;
      l.next();
      for (var P = [], M = [], I = u >= c ? u : -1, T = 0, N = b; l.pos > E;) {
        I >= 0 && l.id == I && l.size >= 0 ? (l.end <= N - o && (p(P, M, y, T, l.end, N, I, w), T = P.length, N = l.end), l.next()) : v(y, E, P, M, I);
      }
      if (I >= 0 && T > 0 && T < P.length && p(P, M, y, T, y, N, I, w), P.reverse(), M.reverse(), I > -1 && T > 0) {
        var R = function (e) {
          return function (t, n, r) {
            var i,
              o,
              a = 0,
              s = t.length - 1;
            if (s >= 0 && (i = t[s]) instanceof tq) {
              if (!s && i.type == e && i.length == r) return i;
              (o = i.prop(KB.lookAhead)) && (a = n[s] + i.length + o);
            }
            return m(e, t, n, r, a);
          };
        }(C);
        j = gq(C, P, M, 0, P.length, 0, b - y, R, R);
      } else j = m(C, P, M, b - y, w - b);
    }
    n.push(j), i.push(_);
  }
  function p(e, t, n, i, o, a, s, u) {
    for (var c = [], l = []; e.length > i;) {
      c.push(e.pop()), l.push(t.pop() + n - o);
    }
    e.push(m(r.types[s], c, l, a - o, u - a)), t.push(o - n);
  }
  function m(e, t, n, r) {
    var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
      o = arguments.length > 5 ? arguments[5] : void 0;
    if (h) {
      var a = [KB.contextHash, h];
      o = o ? [a].concat(o) : [a];
    }
    if (i > 25) {
      var s = [KB.lookAhead, i];
      o = o ? [s].concat(o) : [s];
    }
    return new tq(e, t, n, r, o);
  }
  function g(e, t, n) {
    var r = l.id,
      i = l.start,
      o = l.end,
      a = l.size;
    if (l.next(), a >= 0 && r < c) {
      var s = n;
      if (a > 4) for (var u = l.pos - (a - 4); l.pos > u;) {
        n = g(e, t, n);
      }
      t[--n] = s, t[--n] = o - e, t[--n] = i - e, t[--n] = r;
    } else -3 == a ? h = r : -4 == a && (d = r);
    return n;
  }
  for (var y = [], b = []; l.pos > 0;) {
    v(e.start || 0, e.bufferStart || 0, y, b, -1);
  }
  var k = null !== (t = e.length) && void 0 !== t ? t : y.length ? b[0] + y[0].length : 0;
  return new tq(f[e.topID], y.reverse(), b.reverse(), k);
}
var pq = new WeakMap();
function mq(e, t) {
  if (!e.isAnonymous || t instanceof rq || t.type != e) return 1;
  var n = pq.get(t);
  if (null == n) {
    n = 1;
    var r,
      i = bi(t.children);
    try {
      for (i.s(); !(r = i.n()).done;) {
        var o = r.value;
        if (o.type != e || !(o instanceof tq)) {
          n = 1;
          break;
        }
        n += mq(e, o);
      }
    } catch (e) {
      i.e(e);
    } finally {
      i.f();
    }
    pq.set(t, n);
  }
  return n;
}
function gq(e, t, n, r, i, o, a, s, u) {
  for (var c = 0, l = r; l < i; l++) {
    c += mq(e, t[l]);
  }
  var f = Math.ceil(1.5 * c / 8),
    h = [],
    d = [];
  return function t(n, r, i, a, s) {
    for (var c = i; c < a;) {
      var l = c,
        v = r[c],
        p = mq(e, n[c]);
      for (c++; c < a; c++) {
        var m = mq(e, n[c]);
        if (p + m >= f) break;
        p += m;
      }
      if (c == l + 1) {
        if (p > f) {
          var g = n[l];
          t(g.children, g.positions, 0, g.children.length, r[l] + s);
          continue;
        }
        h.push(n[l]);
      } else {
        var y = r[c - 1] + n[c - 1].length - v;
        h.push(gq(e, n, r, l, c, v, y, null, u));
      }
      d.push(v + s - o);
    }
  }(t, n, r, i, 0), (s || u)(h, d, a);
}
var yq = function () {
    function e() {
      Ri(this, e);
    }
    return zi(e, [{
      key: "startParse",
      value: function value(e, t, n) {
        return "string" == typeof e && (e = new bq(e)), n = n ? n.length ? n.map(function (e) {
          return new JB(e.from, e.to);
        }) : [new JB(0, 0)] : [new JB(0, e.length)], this.createParse(e, t || [], n);
      }
    }, {
      key: "parse",
      value: function value(e, t, n) {
        for (var r = this.startParse(e, t, n);;) {
          var i = r.advance();
          if (i) return i;
        }
      }
    }]), e;
  }(),
  bq = function () {
    function e(t) {
      Ri(this, e), this.string = t;
    }
    return zi(e, [{
      key: "length",
      get: function get() {
        return this.string.length;
      }
    }, {
      key: "chunk",
      value: function value(e) {
        return this.string.slice(e);
      }
    }, {
      key: "lineChunks",
      get: function get() {
        return !1;
      }
    }, {
      key: "read",
      value: function value(e, t) {
        return this.string.slice(e, t);
      }
    }]), e;
  }();
new KB({
  perNode: !0
});
var kq,
  wq = function () {
    function e(t, n, r, i, o, a, s, u, c) {
      var l = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0,
        f = arguments.length > 10 ? arguments[10] : void 0;
      Ri(this, e), this.p = t, this.stack = n, this.state = r, this.reducePos = i, this.pos = o, this.score = a, this.buffer = s, this.bufferBase = u, this.curContext = c, this.lookAhead = l, this.parent = f;
    }
    return zi(e, [{
      key: "toString",
      value: function value() {
        return "[".concat(this.stack.filter(function (e, t) {
          return t % 3 == 0;
        }).concat(this.state), "]@").concat(this.pos).concat(this.score ? "!" + this.score : "");
      }
    }, {
      key: "context",
      get: function get() {
        return this.curContext ? this.curContext.context : null;
      }
    }, {
      key: "pushState",
      value: function value(e, t) {
        this.stack.push(this.state, t, this.bufferBase + this.buffer.length), this.state = e;
      }
    }, {
      key: "reduce",
      value: function value(e) {
        var t = e >> 19,
          n = 65535 & e,
          r = this.p.parser,
          i = r.dynamicPrecedence(n);
        if (i && (this.score += i), 0 == t) return this.pushState(r.getGoto(this.state, n, !0), this.reducePos), n < r.minRepeatTerm && this.storeNode(n, this.reducePos, this.reducePos, 4, !0), void this.reduceContext(n, this.reducePos);
        var o = this.stack.length - 3 * (t - 1) - (262144 & e ? 6 : 0),
          a = this.stack[o - 2],
          s = this.stack[o - 1],
          u = this.bufferBase + this.buffer.length - s;
        if (n < r.minRepeatTerm || 131072 & e) {
          var c = r.stateFlag(this.state, 1) ? this.pos : this.reducePos;
          this.storeNode(n, a, c, u + 4, !0);
        }
        if (262144 & e) this.state = this.stack[o];else {
          var l = this.stack[o - 3];
          this.state = r.getGoto(l, n, !0);
        }
        for (; this.stack.length > o;) {
          this.stack.pop();
        }
        this.reduceContext(n, a);
      }
    }, {
      key: "storeNode",
      value: function value(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 4,
          i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
        if (0 == e && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
          var o = this,
            a = this.buffer.length;
          if (0 == a && o.parent && (a = o.bufferBase - o.parent.bufferBase, o = o.parent), a > 0 && 0 == o.buffer[a - 4] && o.buffer[a - 1] > -1) {
            if (t == n) return;
            if (o.buffer[a - 2] >= t) return void (o.buffer[a - 2] = n);
          }
        }
        if (i && this.pos != n) {
          var s = this.buffer.length;
          if (s > 0 && 0 != this.buffer[s - 4]) for (; s > 0 && this.buffer[s - 2] > n;) {
            this.buffer[s] = this.buffer[s - 4], this.buffer[s + 1] = this.buffer[s - 3], this.buffer[s + 2] = this.buffer[s - 2], this.buffer[s + 3] = this.buffer[s - 1], s -= 4, r > 4 && (r -= 4);
          }
          this.buffer[s] = e, this.buffer[s + 1] = t, this.buffer[s + 2] = n, this.buffer[s + 3] = r;
        } else this.buffer.push(e, t, n, r);
      }
    }, {
      key: "shift",
      value: function value(e, t, n) {
        var r = this.pos;
        if (131072 & e) this.pushState(65535 & e, this.pos);else if (0 == (262144 & e)) {
          var i = e,
            o = this.p.parser;
          (n > this.pos || t <= o.maxNode) && (this.pos = n, o.stateFlag(i, 1) || (this.reducePos = n)), this.pushState(i, r), this.shiftContext(t, r), t <= o.maxNode && this.buffer.push(t, r, n, 4);
        } else this.pos = n, this.shiftContext(t, r), t <= this.p.parser.maxNode && this.buffer.push(t, r, n, 4);
      }
    }, {
      key: "apply",
      value: function value(e, t, n) {
        65536 & e ? this.reduce(e) : this.shift(e, t, n);
      }
    }, {
      key: "useNode",
      value: function value(e, t) {
        var n = this.p.reused.length - 1;
        (n < 0 || this.p.reused[n] != e) && (this.p.reused.push(e), n++);
        var r = this.pos;
        this.reducePos = this.pos = r + e.length, this.pushState(t, r), this.buffer.push(n, r, this.reducePos, -1), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, e, this, this.p.stream.reset(this.pos - e.length)));
      }
    }, {
      key: "split",
      value: function value() {
        for (var t = this, n = t.buffer.length; n > 0 && t.buffer[n - 2] > t.reducePos;) {
          n -= 4;
        }
        for (var r = t.buffer.slice(n), i = t.bufferBase + n; t && i == t.bufferBase;) {
          t = t.parent;
        }
        return new e(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, i, this.curContext, this.lookAhead, t);
      }
    }, {
      key: "recoverByDelete",
      value: function value(e, t) {
        var n = e <= this.p.parser.maxNode;
        n && this.storeNode(e, this.pos, t, 4), this.storeNode(0, this.pos, t, n ? 8 : 4), this.pos = this.reducePos = t, this.score -= 190;
      }
    }, {
      key: "canShift",
      value: function value(e) {
        for (var t = new jq(this);;) {
          var n = this.p.parser.stateSlot(t.state, 4) || this.p.parser.hasAction(t.state, e);
          if (0 == (65536 & n)) return !0;
          if (0 == n) return !1;
          t.reduce(n);
        }
      }
    }, {
      key: "recoverByInsert",
      value: function value(e) {
        if (this.stack.length >= 300) return [];
        var t = this.p.parser.nextStates(this.state);
        if (t.length > 8 || this.stack.length >= 120) {
          for (var n, r = [], i = 0; i < t.length; i += 2) {
            (n = t[i + 1]) != this.state && this.p.parser.hasAction(n, e) && r.push(t[i], n);
          }
          if (this.stack.length < 120) for (var o = function o(e) {
              var n = t[e + 1];
              r.some(function (e, t) {
                return 1 & t && e == n;
              }) || r.push(t[e], n);
            }, a = 0; r.length < 8 && a < t.length; a += 2) {
            o(a);
          }
          t = r;
        }
        for (var s = [], u = 0; u < t.length && s.length < 4; u += 2) {
          var c = t[u + 1];
          if (c != this.state) {
            var l = this.split();
            l.pushState(c, this.pos), l.storeNode(0, l.pos, l.pos, 4, !0), l.shiftContext(t[u], this.pos), l.score -= 200, s.push(l);
          }
        }
        return s;
      }
    }, {
      key: "forceReduce",
      value: function value() {
        var e = this.p.parser.stateSlot(this.state, 5);
        if (0 == (65536 & e)) return !1;
        var t = this.p.parser;
        if (!t.validAction(this.state, e)) {
          var n = e >> 19,
            r = 65535 & e,
            i = this.stack.length - 3 * n;
          if (i < 0 || t.getGoto(this.stack[i], r, !1) < 0) return !1;
          this.storeNode(0, this.reducePos, this.reducePos, 4, !0), this.score -= 100;
        }
        return this.reducePos = this.pos, this.reduce(e), !0;
      }
    }, {
      key: "forceAll",
      value: function value() {
        for (; !this.p.parser.stateFlag(this.state, 2);) {
          if (!this.forceReduce()) {
            this.storeNode(0, this.pos, this.pos, 4, !0);
            break;
          }
        }
        return this;
      }
    }, {
      key: "deadEnd",
      get: function get() {
        if (3 != this.stack.length) return !1;
        var e = this.p.parser;
        return 65535 == e.data[e.stateSlot(this.state, 1)] && !e.stateSlot(this.state, 4);
      }
    }, {
      key: "restart",
      value: function value() {
        this.state = this.stack[0], this.stack.length = 0;
      }
    }, {
      key: "sameState",
      value: function value(e) {
        if (this.state != e.state || this.stack.length != e.stack.length) return !1;
        for (var t = 0; t < this.stack.length; t += 3) {
          if (this.stack[t] != e.stack[t]) return !1;
        }
        return !0;
      }
    }, {
      key: "parser",
      get: function get() {
        return this.p.parser;
      }
    }, {
      key: "dialectEnabled",
      value: function value(e) {
        return this.p.parser.dialect.flags[e];
      }
    }, {
      key: "shiftContext",
      value: function value(e, t) {
        this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(t)));
      }
    }, {
      key: "reduceContext",
      value: function value(e, t) {
        this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(t)));
      }
    }, {
      key: "emitContext",
      value: function value() {
        var e = this.buffer.length - 1;
        (e < 0 || -3 != this.buffer[e]) && this.buffer.push(this.curContext.hash, this.reducePos, this.reducePos, -3);
      }
    }, {
      key: "emitLookAhead",
      value: function value() {
        var e = this.buffer.length - 1;
        (e < 0 || -4 != this.buffer[e]) && this.buffer.push(this.lookAhead, this.reducePos, this.reducePos, -4);
      }
    }, {
      key: "updateContext",
      value: function value(e) {
        if (e != this.curContext.context) {
          var t = new xq(this.curContext.tracker, e);
          t.hash != this.curContext.hash && this.emitContext(), this.curContext = t;
        }
      }
    }, {
      key: "setLookAhead",
      value: function value(e) {
        e > this.lookAhead && (this.emitLookAhead(), this.lookAhead = e);
      }
    }, {
      key: "close",
      value: function value() {
        this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
      }
    }], [{
      key: "start",
      value: function value(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
          i = t.parser.context;
        return new e(t, [], n, r, r, 0, [], 0, i ? new xq(i, i.start) : null, 0, null);
      }
    }]), e;
  }(),
  xq = zi(function e(t, n) {
    Ri(this, e), this.tracker = t, this.context = n, this.hash = t.strict ? t.hash(n) : 0;
  });
!function (e) {
  e[e.Insert = 200] = "Insert", e[e.Delete = 190] = "Delete", e[e.Reduce = 100] = "Reduce", e[e.MaxNext = 4] = "MaxNext", e[e.MaxInsertStackDepth = 300] = "MaxInsertStackDepth", e[e.DampenInsertStackDepth = 120] = "DampenInsertStackDepth";
}(kq || (kq = {}));
var jq = function () {
    function e(t) {
      Ri(this, e), this.start = t, this.state = t.state, this.stack = t.stack, this.base = this.stack.length;
    }
    return zi(e, [{
      key: "reduce",
      value: function value(e) {
        var t = 65535 & e,
          n = e >> 19;
        0 == n ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= 3 * (n - 1);
        var r = this.start.p.parser.getGoto(this.stack[this.base - 3], t, !0);
        this.state = r;
      }
    }]), e;
  }(),
  Sq = function () {
    function e(t, n, r) {
      Ri(this, e), this.stack = t, this.pos = n, this.index = r, this.buffer = t.buffer, 0 == this.index && this.maybeNext();
    }
    return zi(e, [{
      key: "maybeNext",
      value: function value() {
        var e = this.stack.parent;
        null != e && (this.index = this.stack.bufferBase - e.bufferBase, this.stack = e, this.buffer = e.buffer);
      }
    }, {
      key: "id",
      get: function get() {
        return this.buffer[this.index - 4];
      }
    }, {
      key: "start",
      get: function get() {
        return this.buffer[this.index - 3];
      }
    }, {
      key: "end",
      get: function get() {
        return this.buffer[this.index - 2];
      }
    }, {
      key: "size",
      get: function get() {
        return this.buffer[this.index - 1];
      }
    }, {
      key: "next",
      value: function value() {
        this.index -= 4, this.pos -= 4, 0 == this.index && this.maybeNext();
      }
    }, {
      key: "fork",
      value: function value() {
        return new e(this.stack, this.pos, this.index);
      }
    }], [{
      key: "create",
      value: function value(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.bufferBase + t.buffer.length;
        return new e(t, n, n - t.bufferBase);
      }
    }]), e;
  }(),
  Cq = zi(function e() {
    Ri(this, e), this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }),
  _q = new Cq(),
  $q = function () {
    function e(t, n) {
      Ri(this, e), this.input = t, this.ranges = n, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = _q, this.rangeIndex = 0, this.pos = this.chunkPos = n[0].from, this.range = n[0], this.end = n[n.length - 1].to, this.readNext();
    }
    return zi(e, [{
      key: "resolveOffset",
      value: function value(e, t) {
        for (var n = this.range, r = this.rangeIndex, i = this.pos + e; i < n.from;) {
          if (!r) return null;
          var o = this.ranges[--r];
          i -= n.from - o.to, n = o;
        }
        for (; t < 0 ? i > n.to : i >= n.to;) {
          if (r == this.ranges.length - 1) return null;
          var a = this.ranges[++r];
          i += a.from - n.to, n = a;
        }
        return i;
      }
    }, {
      key: "peek",
      value: function value(e) {
        var t,
          n,
          r = this.chunkOff + e;
        if (r >= 0 && r < this.chunk.length) t = this.pos + e, n = this.chunk.charCodeAt(r);else {
          var i = this.resolveOffset(e, 1);
          if (null == i) return -1;
          if ((t = i) >= this.chunk2Pos && t < this.chunk2Pos + this.chunk2.length) n = this.chunk2.charCodeAt(t - this.chunk2Pos);else {
            for (var o = this.rangeIndex, a = this.range; a.to <= t;) {
              a = this.ranges[++o];
            }
            this.chunk2 = this.input.chunk(this.chunk2Pos = t), t + this.chunk2.length > a.to && (this.chunk2 = this.chunk2.slice(0, a.to - t)), n = this.chunk2.charCodeAt(0);
          }
        }
        return t >= this.token.lookAhead && (this.token.lookAhead = t + 1), n;
      }
    }, {
      key: "acceptToken",
      value: function value(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = t ? this.resolveOffset(t, -1) : this.pos;
        if (null == n || n < this.token.start) throw new RangeError("Token end out of bounds");
        this.token.value = e, this.token.end = n;
      }
    }, {
      key: "getChunk",
      value: function value() {
        if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
          var e = this.chunk,
            t = this.chunkPos;
          this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = e, this.chunk2Pos = t, this.chunkOff = this.pos - this.chunkPos;
        } else {
          this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
          var n = this.input.chunk(this.pos),
            r = this.pos + n.length;
          this.chunk = r > this.range.to ? n.slice(0, this.range.to - this.pos) : n, this.chunkPos = this.pos, this.chunkOff = 0;
        }
      }
    }, {
      key: "readNext",
      value: function value() {
        return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
      }
    }, {
      key: "advance",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        for (this.chunkOff += e; this.pos + e >= this.range.to;) {
          if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
          e -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
        }
        return this.pos += e, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
      }
    }, {
      key: "setDone",
      value: function value() {
        return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
      }
    }, {
      key: "reset",
      value: function value(e, t) {
        if (t ? (this.token = t, t.start = e, t.lookAhead = e + 1, t.value = t.extended = -1) : this.token = _q, this.pos != e) {
          if (this.pos = e, e == this.end) return this.setDone(), this;
          for (; e < this.range.from;) {
            this.range = this.ranges[--this.rangeIndex];
          }
          for (; e >= this.range.to;) {
            this.range = this.ranges[++this.rangeIndex];
          }
          e >= this.chunkPos && e < this.chunkPos + this.chunk.length ? this.chunkOff = e - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
        }
        return this;
      }
    }, {
      key: "read",
      value: function value(e, t) {
        if (e >= this.chunkPos && t <= this.chunkPos + this.chunk.length) return this.chunk.slice(e - this.chunkPos, t - this.chunkPos);
        if (e >= this.chunk2Pos && t <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(e - this.chunk2Pos, t - this.chunk2Pos);
        if (e >= this.range.from && t <= this.range.to) return this.input.read(e, t);
        var n,
          r = "",
          i = bi(this.ranges);
        try {
          for (i.s(); !(n = i.n()).done;) {
            var o = n.value;
            if (o.from >= t) break;
            o.to > e && (r += this.input.read(Math.max(o.from, e), Math.min(o.to, t)));
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        return r;
      }
    }]), e;
  }(),
  Oq = function () {
    function e(t, n) {
      Ri(this, e), this.data = t, this.id = n;
    }
    return zi(e, [{
      key: "token",
      value: function value(e, t) {
        !function (e, t, n, r) {
          var i = 0,
            o = 1 << r,
            a = n.p.parser,
            s = a.dialect;
          e: for (; 0 != (o & e[i]);) {
            for (var u = e[i + 1], c = i + 3; c < u; c += 2) {
              if ((e[c + 1] & o) > 0) {
                var l = e[c];
                if (s.allows(l) && (-1 == t.token.value || t.token.value == l || a.overrides(l, t.token.value))) {
                  t.acceptToken(l);
                  break;
                }
              }
            }
            for (var f = t.next, h = 0, d = e[i + 2]; h < d;) {
              var v = h + d >> 1,
                p = u + v + (v << 1),
                m = e[p],
                g = e[p + 1];
              if (f < m) d = v;else {
                if (!(f >= g)) {
                  i = e[p + 2], t.advance();
                  continue e;
                }
                h = v + 1;
              }
            }
            break;
          }
        }(this.data, e, t, this.id);
      }
    }]), e;
  }();
function Aq(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Uint16Array;
  if ("string" != typeof e) return e;
  for (var n = null, r = 0, i = 0; r < e.length;) {
    for (var o = 0;;) {
      var a = e.charCodeAt(r++),
        s = !1;
      if (126 == a) {
        o = 65535;
        break;
      }
      a >= 92 && a--, a >= 34 && a--;
      var u = a - 32;
      if (u >= 46 && (u -= 46, s = !0), o += u, s) break;
      o *= 46;
    }
    n ? n[i++] = o : n = new t(o);
  }
  return n;
}
Oq.prototype.contextual = Oq.prototype.fallback = Oq.prototype.extend = !1;
var Eq,
  Pq = "undefined" != typeof process && process.env && /\bparse\b/.test(process.env.LOG),
  Mq = null;
function Iq(e, t, n) {
  var r = e.cursor(YB.IncludeAnonymous);
  for (r.moveTo(t);;) {
    if (!(n < 0 ? r.childBefore(t) : r.childAfter(t))) for (;;) {
      if ((n < 0 ? r.to < t : r.from > t) && !r.type.isError) return n < 0 ? Math.max(0, Math.min(r.to - 1, t - 25)) : Math.min(e.length, Math.max(r.from + 1, t + 25));
      if (n < 0 ? r.prevSibling() : r.nextSibling()) break;
      if (!r.parent()) return n < 0 ? 0 : e.length;
    }
  }
}
!function (e) {
  e[e.Margin = 25] = "Margin";
}(Eq || (Eq = {}));
var Tq,
  Nq = function () {
    function e(t, n) {
      Ri(this, e), this.fragments = t, this.nodeSet = n, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
    }
    return zi(e, [{
      key: "nextFragment",
      value: function value() {
        var e = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
        if (e) {
          for (this.safeFrom = e.openStart ? Iq(e.tree, e.from + e.offset, 1) - e.offset : e.from, this.safeTo = e.openEnd ? Iq(e.tree, e.to + e.offset, -1) - e.offset : e.to; this.trees.length;) {
            this.trees.pop(), this.start.pop(), this.index.pop();
          }
          this.trees.push(e.tree), this.start.push(-e.offset), this.index.push(0), this.nextStart = this.safeFrom;
        } else this.nextStart = 1e9;
      }
    }, {
      key: "nodeAt",
      value: function value(e) {
        if (e < this.nextStart) return null;
        for (; this.fragment && this.safeTo <= e;) {
          this.nextFragment();
        }
        if (!this.fragment) return null;
        for (;;) {
          var t = this.trees.length - 1;
          if (t < 0) return this.nextFragment(), null;
          var n = this.trees[t],
            r = this.index[t];
          if (r != n.children.length) {
            var i = n.children[r],
              o = this.start[t] + n.positions[r];
            if (o > e) return this.nextStart = o, null;
            if (i instanceof tq) {
              if (o == e) {
                if (o < this.safeFrom) return null;
                var a = o + i.length;
                if (a <= this.safeTo) {
                  var s = i.prop(KB.lookAhead);
                  if (!s || a + s < this.fragment.to) return i;
                }
              }
              this.index[t]++, o + i.length >= Math.max(this.safeFrom, e) && (this.trees.push(i), this.start.push(o), this.index.push(0));
            } else this.index[t]++, this.nextStart = o + i.length;
          } else this.trees.pop(), this.start.pop(), this.index.pop();
        }
      }
    }]), e;
  }(),
  Rq = function () {
    function e(t, n) {
      Ri(this, e), this.stream = n, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = t.tokenizers.map(function (e) {
        return new Cq();
      });
    }
    return zi(e, [{
      key: "getActions",
      value: function value(e) {
        for (var t = 0, n = null, r = e.p.parser, i = r.tokenizers, o = r.stateSlot(e.state, 3), a = e.curContext ? e.curContext.hash : 0, s = 0, u = 0; u < i.length; u++) {
          if (0 != (1 << u & o)) {
            var c = i[u],
              l = this.tokens[u];
            if ((!n || c.fallback) && ((c.contextual || l.start != e.pos || l.mask != o || l.context != a) && (this.updateCachedToken(l, c, e), l.mask = o, l.context = a), l.lookAhead > l.end + 25 && (s = Math.max(l.lookAhead, s)), 0 != l.value)) {
              var f = t;
              if (l.extended > -1 && (t = this.addActions(e, l.extended, l.end, t)), t = this.addActions(e, l.value, l.end, t), !c.extend && (n = l, t > f)) break;
            }
          }
        }
        for (; this.actions.length > t;) {
          this.actions.pop();
        }
        return s && e.setLookAhead(s), n || e.pos != this.stream.end || ((n = new Cq()).value = e.p.parser.eofTerm, n.start = n.end = e.pos, t = this.addActions(e, n.value, n.end, t)), this.mainToken = n, this.actions;
      }
    }, {
      key: "getMainToken",
      value: function value(e) {
        if (this.mainToken) return this.mainToken;
        var t = new Cq(),
          n = e.pos,
          r = e.p;
        return t.start = n, t.end = Math.min(n + 1, r.stream.end), t.value = n == r.stream.end ? r.parser.eofTerm : 0, t;
      }
    }, {
      key: "updateCachedToken",
      value: function value(e, t, n) {
        if (t.token(this.stream.reset(n.pos, e), n), e.value > -1) {
          for (var r = n.p.parser, i = 0; i < r.specialized.length; i++) {
            if (r.specialized[i] == e.value) {
              var o = r.specializers[i](this.stream.read(e.start, e.end), n);
              if (o >= 0 && n.p.parser.dialect.allows(o >> 1)) {
                0 == (1 & o) ? e.value = o >> 1 : e.extended = o >> 1;
                break;
              }
            }
          }
        } else e.value = 0, e.end = Math.min(n.p.stream.end, n.pos + 1);
      }
    }, {
      key: "putAction",
      value: function value(e, t, n, r) {
        for (var i = 0; i < r; i += 3) {
          if (this.actions[i] == e) return r;
        }
        return this.actions[r++] = e, this.actions[r++] = t, this.actions[r++] = n, r;
      }
    }, {
      key: "addActions",
      value: function value(e, t, n, r) {
        for (var i = e.state, o = e.p.parser, a = o.data, s = 0; s < 2; s++) {
          for (var u = o.stateSlot(i, s ? 2 : 1);; u += 3) {
            if (65535 == a[u]) {
              if (1 != a[u + 1]) {
                0 == r && 2 == a[u + 1] && (r = this.putAction(qq(a, u + 2), t, n, r));
                break;
              }
              u = qq(a, u + 2);
            }
            a[u] == t && (r = this.putAction(qq(a, u + 1), t, n, r));
          }
        }
        return r;
      }
    }]), e;
  }();
!function (e) {
  e[e.Distance = 5] = "Distance", e[e.MaxRemainingPerStep = 3] = "MaxRemainingPerStep", e[e.MinBufferLengthPrune = 500] = "MinBufferLengthPrune", e[e.ForceReduceLimit = 10] = "ForceReduceLimit", e[e.CutDepth = 15e3] = "CutDepth", e[e.CutTo = 9e3] = "CutTo";
}(Tq || (Tq = {}));
var Dq = function () {
  function e(t, n, r, i) {
    Ri(this, e), this.parser = t, this.input = n, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.stream = new $q(n, i), this.tokens = new Rq(t, this.stream), this.topTerm = t.top[1];
    var o = i[0].from;
    this.stacks = [wq.start(this, t.top[0], o)], this.fragments = r.length && this.stream.end - o > 4 * t.bufferLength ? new Nq(r, t.nodeSet) : null;
  }
  return zi(e, [{
    key: "parsedPos",
    get: function get() {
      return this.minStackPos;
    }
  }, {
    key: "advance",
    value: function value() {
      for (var e, t, n = this.stacks, r = this.minStackPos, i = this.stacks = [], o = 0; o < n.length; o++) {
        for (var a = n[o];;) {
          if (this.tokens.mainToken = null, a.pos > r) i.push(a);else {
            if (this.advanceStack(a, i, n)) continue;
            e || (e = [], t = []), e.push(a);
            var s = this.tokens.getMainToken(a);
            t.push(s.value, s.end);
          }
          break;
        }
      }
      if (!i.length) {
        var u = e && function (e) {
          var t,
            n = null,
            r = bi(e);
          try {
            for (r.s(); !(t = r.n()).done;) {
              var i = t.value,
                o = i.p.stoppedAt;
              (i.pos == i.p.stream.end || null != o && i.pos > o) && i.p.parser.stateFlag(i.state, 2) && (!n || n.score < i.score) && (n = i);
            }
          } catch (e) {
            r.e(e);
          } finally {
            r.f();
          }
          return n;
        }(e);
        if (u) return this.stackToTree(u);
        if (this.parser.strict) throw Pq && e && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + r);
        this.recovering || (this.recovering = 5);
      }
      if (this.recovering && e) {
        var c = null != this.stoppedAt && e[0].pos > this.stoppedAt ? e[0] : this.runRecovery(e, t, i);
        if (c) return this.stackToTree(c.forceAll());
      }
      if (this.recovering) {
        var l = 1 == this.recovering ? 1 : 3 * this.recovering;
        if (i.length > l) for (i.sort(function (e, t) {
          return t.score - e.score;
        }); i.length > l;) {
          i.pop();
        }
        i.some(function (e) {
          return e.reducePos > r;
        }) && this.recovering--;
      } else if (i.length > 1) e: for (var f = 0; f < i.length - 1; f++) {
        for (var h = i[f], d = f + 1; d < i.length; d++) {
          var v = i[d];
          if (h.sameState(v) || h.buffer.length > 500 && v.buffer.length > 500) {
            if (!((h.score - v.score || h.buffer.length - v.buffer.length) > 0)) {
              i.splice(f--, 1);
              continue e;
            }
            i.splice(d--, 1);
          }
        }
      }
      this.minStackPos = i[0].pos;
      for (var p = 1; p < i.length; p++) {
        i[p].pos < this.minStackPos && (this.minStackPos = i[p].pos);
      }
      return null;
    }
  }, {
    key: "stopAt",
    value: function value(e) {
      if (null != this.stoppedAt && this.stoppedAt < e) throw new RangeError("Can't move stoppedAt forward");
      this.stoppedAt = e;
    }
  }, {
    key: "advanceStack",
    value: function value(e, t, n) {
      var r = e.pos,
        i = this.parser,
        o = Pq ? this.stackID(e) + " -> " : "";
      if (null != this.stoppedAt && r > this.stoppedAt) return e.forceReduce() ? e : null;
      if (this.fragments) for (var a = e.curContext && e.curContext.tracker.strict, s = a ? e.curContext.hash : 0, u = this.fragments.nodeAt(r); u;) {
        var c = this.parser.nodeSet.types[u.type.id] == u.type ? i.getGoto(e.state, u.type.id) : -1;
        if (c > -1 && u.length && (!a || (u.prop(KB.contextHash) || 0) == s)) return e.useNode(u, c), Pq && console.log(o + this.stackID(e) + " (via reuse of ".concat(i.getName(u.type.id), ")")), !0;
        if (!(u instanceof tq) || 0 == u.children.length || u.positions[0] > 0) break;
        var l = u.children[0];
        if (!(l instanceof tq && 0 == u.positions[0])) break;
        u = l;
      }
      var f = i.stateSlot(e.state, 4);
      if (f > 0) return e.reduce(f), Pq && console.log(o + this.stackID(e) + " (via always-reduce ".concat(i.getName(65535 & f), ")")), !0;
      if (e.stack.length >= 15e3) for (; e.stack.length > 9e3 && e.forceReduce();) {
        ;
      }
      for (var h = this.tokens.getActions(e), d = 0; d < h.length;) {
        var v = h[d++],
          p = h[d++],
          m = h[d++],
          g = d == h.length || !n,
          y = g ? e : e.split();
        if (y.apply(v, p, m), Pq && console.log(o + this.stackID(y) + " (via ".concat(0 == (65536 & v) ? "shift" : "reduce of ".concat(i.getName(65535 & v)), " for ").concat(i.getName(p), " @ ").concat(r).concat(y == e ? "" : ", split", ")")), g) return !0;
        y.pos > r ? t.push(y) : n.push(y);
      }
      return !1;
    }
  }, {
    key: "advanceFully",
    value: function value(e, t) {
      for (var n = e.pos;;) {
        if (!this.advanceStack(e, null, null)) return !1;
        if (e.pos > n) return zq(e, t), !0;
      }
    }
  }, {
    key: "runRecovery",
    value: function value(e, t, n) {
      for (var r = null, i = !1, o = 0; o < e.length; o++) {
        var a = e[o],
          s = t[o << 1],
          u = t[1 + (o << 1)],
          c = Pq ? this.stackID(a) + " -> " : "";
        if (a.deadEnd) {
          if (i) continue;
          if (i = !0, a.restart(), Pq && console.log(c + this.stackID(a) + " (restarted)"), this.advanceFully(a, n)) continue;
        }
        for (var l = a.split(), f = c, h = 0; l.forceReduce() && h < 10; h++) {
          if (Pq && console.log(f + this.stackID(l) + " (via force-reduce)"), this.advanceFully(l, n)) break;
          Pq && (f = this.stackID(l) + " -> ");
        }
        var d,
          v = bi(a.recoverByInsert(s));
        try {
          for (v.s(); !(d = v.n()).done;) {
            var p = d.value;
            Pq && console.log(c + this.stackID(p) + " (via recover-insert)"), this.advanceFully(p, n);
          }
        } catch (e) {
          v.e(e);
        } finally {
          v.f();
        }
        this.stream.end > a.pos ? (u == a.pos && (u++, s = 0), a.recoverByDelete(s, u), Pq && console.log(c + this.stackID(a) + " (via recover-delete ".concat(this.parser.getName(s), ")")), zq(a, n)) : (!r || r.score < a.score) && (r = a);
      }
      return r;
    }
  }, {
    key: "stackToTree",
    value: function value(e) {
      return e.close(), tq.build({
        buffer: Sq.create(e),
        nodeSet: this.parser.nodeSet,
        topID: this.topTerm,
        maxBufferLength: this.parser.bufferLength,
        reused: this.reused,
        start: this.ranges[0].from,
        length: e.pos - this.ranges[0].from,
        minRepeatType: this.parser.minRepeatTerm
      });
    }
  }, {
    key: "stackID",
    value: function value(e) {
      var t = (Mq || (Mq = new WeakMap())).get(e);
      return t || Mq.set(e, t = String.fromCodePoint(this.nextStackID++)), t + e;
    }
  }]), e;
}();
function zq(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    if (r.pos == e.pos && r.sameState(e)) return void (t[n].score < e.score && (t[n] = e));
  }
  t.push(e);
}
var Lq = function () {
    function e(t, n, r) {
      Ri(this, e), this.source = t, this.flags = n, this.disabled = r;
    }
    return zi(e, [{
      key: "allows",
      value: function value(e) {
        return !this.disabled || 0 == this.disabled[e];
      }
    }]), e;
  }(),
  Bq = function (e) {
    ji(n, yq);
    var t = Ci(n);
    function n(e) {
      var r, i;
      if (Ri(this, n), (i = t.call(this)).wrappers = [], 14 != e.version) throw new RangeError("Parser version (".concat(e.version, ") doesn't match runtime version (", 14, ")"));
      var o = e.nodeNames.split(" ");
      i.minRepeatTerm = o.length;
      for (var a = 0; a < e.repeatNodeCount; a++) {
        o.push("");
      }
      for (var s = Object.keys(e.topRules).map(function (t) {
          return e.topRules[t][1];
        }), u = [], c = 0; c < o.length; c++) {
        u.push([]);
      }
      function l(e, t, n) {
        u[e].push([t, t.deserialize(String(n))]);
      }
      if (e.nodeProps) {
        var f,
          h = bi(e.nodeProps);
        try {
          for (h.s(); !(f = h.n()).done;) {
            var d = f.value,
              v = d[0];
            "string" == typeof v && (v = KB[v]);
            for (var p = 1; p < d.length;) {
              var m = d[p++];
              if (m >= 0) l(m, v, d[p++]);else {
                for (var g = d[p + -m], y = -m; y > 0; y--) {
                  l(d[p++], v, g);
                }
                p++;
              }
            }
          }
        } catch (e) {
          h.e(e);
        } finally {
          h.f();
        }
      }
      i.nodeSet = new ZB(o.map(function (t, n) {
        return QB.define({
          name: n >= i.minRepeatTerm ? void 0 : t,
          id: n,
          props: u[n],
          top: s.indexOf(n) > -1,
          error: 0 == n,
          skipped: e.skippedNodes && e.skippedNodes.indexOf(n) > -1
        });
      })), e.propSources && (i.nodeSet = (r = i.nodeSet).extend.apply(r, Ii(e.propSources))), i.strict = !1, i.bufferLength = 1024;
      var b = Aq(e.tokenData);
      if (i.context = e.context, i.specialized = new Uint16Array(e.specialized ? e.specialized.length : 0), i.specializers = [], e.specialized) for (var k = 0; k < e.specialized.length; k++) {
        i.specialized[k] = e.specialized[k].term, i.specializers[k] = e.specialized[k].get;
      }
      return i.states = Aq(e.states, Uint32Array), i.data = Aq(e.stateData), i.goto = Aq(e.goto), i.maxTerm = e.maxTerm, i.tokenizers = e.tokenizers.map(function (e) {
        return "number" == typeof e ? new Oq(b, e) : e;
      }), i.topRules = e.topRules, i.dialects = e.dialects || {}, i.dynamicPrecedences = e.dynamicPrecedences || null, i.tokenPrecTable = e.tokenPrec, i.termNames = e.termNames || null, i.maxNode = i.nodeSet.types.length - 1, i.dialect = i.parseDialect(), i.top = i.topRules[Object.keys(i.topRules)[0]], i;
    }
    return zi(n, [{
      key: "createParse",
      value: function value(e, t, n) {
        var r,
          i = new Dq(this, e, t, n),
          o = bi(this.wrappers);
        try {
          for (o.s(); !(r = o.n()).done;) {
            i = (0, r.value)(i, e, t, n);
          }
        } catch (e) {
          o.e(e);
        } finally {
          o.f();
        }
        return i;
      }
    }, {
      key: "getGoto",
      value: function value(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          r = this.goto;
        if (t >= r[0]) return -1;
        for (var i = r[t + 1];;) {
          var o = r[i++],
            a = 1 & o,
            s = r[i++];
          if (a && n) return s;
          for (var u = i + (o >> 1); i < u; i++) {
            if (r[i] == e) return s;
          }
          if (a) return -1;
        }
      }
    }, {
      key: "hasAction",
      value: function value(e, t) {
        for (var n = this.data, r = 0; r < 2; r++) {
          for (var i, o = this.stateSlot(e, r ? 2 : 1);; o += 3) {
            if (65535 == (i = n[o])) {
              if (1 != n[o + 1]) {
                if (2 == n[o + 1]) return qq(n, o + 2);
                break;
              }
              i = n[o = qq(n, o + 2)];
            }
            if (i == t || 0 == i) return qq(n, o + 1);
          }
        }
        return 0;
      }
    }, {
      key: "stateSlot",
      value: function value(e, t) {
        return this.states[6 * e + t];
      }
    }, {
      key: "stateFlag",
      value: function value(e, t) {
        return (this.stateSlot(e, 0) & t) > 0;
      }
    }, {
      key: "validAction",
      value: function value(e, t) {
        if (t == this.stateSlot(e, 4)) return !0;
        for (var n = this.stateSlot(e, 1);; n += 3) {
          if (65535 == this.data[n]) {
            if (1 != this.data[n + 1]) return !1;
            n = qq(this.data, n + 2);
          }
          if (t == qq(this.data, n + 1)) return !0;
        }
      }
    }, {
      key: "nextStates",
      value: function value(e) {
        for (var t = this, n = [], r = this.stateSlot(e, 1);; r += 3) {
          if (65535 == this.data[r]) {
            if (1 != this.data[r + 1]) break;
            r = qq(this.data, r + 2);
          }
          0 == (1 & this.data[r + 2]) && function () {
            var e = t.data[r + 1];
            n.some(function (t, n) {
              return 1 & n && t == e;
            }) || n.push(t.data[r], e);
          }();
        }
        return n;
      }
    }, {
      key: "overrides",
      value: function value(e, t) {
        var n = Fq(this.data, this.tokenPrecTable, t);
        return n < 0 || Fq(this.data, this.tokenPrecTable, e) < n;
      }
    }, {
      key: "configure",
      value: function value(e) {
        var t,
          r = Object.assign(Object.create(n.prototype), this);
        if (e.props && (r.nodeSet = (t = this.nodeSet).extend.apply(t, Ii(e.props))), e.top) {
          var i = this.topRules[e.top];
          if (!i) throw new RangeError("Invalid top rule name ".concat(e.top));
          r.top = i;
        }
        return e.tokenizers && (r.tokenizers = this.tokenizers.map(function (t) {
          var n = e.tokenizers.find(function (e) {
            return e.from == t;
          });
          return n ? n.to : t;
        })), e.contextTracker && (r.context = e.contextTracker), e.dialect && (r.dialect = this.parseDialect(e.dialect)), null != e.strict && (r.strict = e.strict), e.wrap && (r.wrappers = r.wrappers.concat(e.wrap)), null != e.bufferLength && (r.bufferLength = e.bufferLength), r;
      }
    }, {
      key: "hasWrappers",
      value: function value() {
        return this.wrappers.length > 0;
      }
    }, {
      key: "getName",
      value: function value(e) {
        return this.termNames ? this.termNames[e] : String(e <= this.maxNode && this.nodeSet.types[e].name || e);
      }
    }, {
      key: "eofTerm",
      get: function get() {
        return this.maxNode + 1;
      }
    }, {
      key: "topNode",
      get: function get() {
        return this.nodeSet.types[this.top[1]];
      }
    }, {
      key: "dynamicPrecedence",
      value: function value(e) {
        var t = this.dynamicPrecedences;
        return null == t ? 0 : t[e] || 0;
      }
    }, {
      key: "parseDialect",
      value: function value(e) {
        var t = Object.keys(this.dialects),
          n = t.map(function () {
            return !1;
          });
        if (e) {
          var r,
            i = bi(e.split(" "));
          try {
            for (i.s(); !(r = i.n()).done;) {
              var o = r.value,
                a = t.indexOf(o);
              a >= 0 && (n[a] = !0);
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        }
        for (var s = null, u = 0; u < t.length; u++) {
          if (!n[u]) for (var c, l = this.dialects[t[u]]; 65535 != (c = this.data[l++]);) {
            (s || (s = new Uint8Array(this.maxTerm + 1)))[c] = 1;
          }
        }
        return new Lq(e, n, s);
      }
    }], [{
      key: "deserialize",
      value: function value(e) {
        return new n(e);
      }
    }]), n;
  }();
function qq(e, t) {
  return e[t] | e[t + 1] << 16;
}
function Fq(e, t, n) {
  for (var r, i = t; 65535 != (r = e[i]); i++) {
    if (r == n) return i - t;
  }
  return -1;
}
var Vq = dT({
    String: RT.string,
    Number: RT.number,
    "True False": RT.bool,
    PropertyName: RT.propertyName,
    Null: RT.null,
    ",": RT.separator,
    "[ ]": RT.squareBracket,
    "{ }": RT.brace
  }),
  Hq = Bq.deserialize({
    version: 14,
    states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#CjOOQO'#Cp'#CpQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CrOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59U,59UO!iQPO,59UOVQPO,59QOqQPO'#CkO!nQPO,59^OOQO1G.k1G.kOVQPO'#ClO!vQPO,59aOOQO1G.p1G.pOOQO1G.l1G.lOOQO,59V,59VOOQO-E6i-E6iOOQO,59W,59WOOQO-E6j-E6j",
    stateData: "#O~OcOS~OQSORSOSSOTSOWQO]ROePO~OVXOeUO~O[[O~PVOg^O~Oh_OVfX~OVaO~OhbO[iX~O[dO~Oh_OVfa~OhbO[ia~O",
    goto: "!kjPPPPPPkPPkqwPPk{!RPPP!XP!ePP!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
    nodeNames: "⚠ JsonText True False Null Number String } { Object Property PropertyName ] [ Array",
    maxTerm: 25,
    nodeProps: [["openedBy", 7, "{", 12, "["], ["closedBy", 8, "}", 13, "]"]],
    propSources: [Vq],
    skippedNodes: [0],
    repeatNodeCount: 2,
    tokenData: "(p~RaXY!WYZ!W]^!Wpq!Wrs!]|}$i}!O$n!Q!R$w!R![&V![!]&h!}#O&m#P#Q&r#Y#Z&w#b#c'f#h#i'}#o#p(f#q#r(k~!]Oc~~!`Upq!]qr!]rs!rs#O!]#O#P!w#P~!]~!wOe~~!zXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#g~#jR!Q![#s!c!i#s#T#Z#s~#vR!Q![$P!c!i$P#T#Z$P~$SR!Q![$]!c!i$]#T#Z$]~$`R!Q![!]!c!i!]#T#Z!]~$nOh~~$qQ!Q!R$w!R![&V~$|RT~!O!P%V!g!h%k#X#Y%k~%YP!Q![%]~%bRT~!Q![%]!g!h%k#X#Y%k~%nR{|%w}!O%w!Q![%}~%zP!Q![%}~&SPT~!Q![%}~&[ST~!O!P%V!Q![&V!g!h%k#X#Y%k~&mOg~~&rO]~~&wO[~~&zP#T#U&}~'QP#`#a'T~'WP#g#h'Z~'^P#X#Y'a~'fOR~~'iP#i#j'l~'oP#`#a'r~'uP#`#a'x~'}OS~~(QP#f#g(T~(WP#i#j(Z~(^P#X#Y(a~(fOQ~~(kOW~~(pOV~",
    tokenizers: [0],
    topRules: {
      JsonText: [0, 1]
    },
    tokenPrec: 0
  }),
  Wq = BT.define({
    parser: Hq.configure({
      props: [iN.add({
        Object: lN({
          except: /^\s*\}/
        }),
        Array: lN({
          except: /^\s*\]/
        })
      }), dN.add({
        "Object Array": function ObjectArray(e) {
          var t = e.firstChild,
            n = e.lastChild;
          return t && t.to < n.from ? {
            from: t.to,
            to: n.type.isError ? e.to : n.from
          } : null;
        }
      })]
    }),
    languageData: {
      closeBrackets: {
        brackets: ["[", "{", '"']
      },
      indentOnInput: /^\s*[\}\]]$/
    }
  });
function Uq(e, t) {
  var n = Date.now(),
    r = e();
  return t(Date.now() - n), r;
}
function Jq(e) {
  co(e, "svelte-1oo7hnc", ".jse-status-bar.svelte-1oo7hnc.svelte-1oo7hnc{background:var(--jse-panel-background);color:var(--jse-panel-color-readonly);font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);margin:0;border-top:var(--jse-panel-border);border-left:var(--jse-main-border);border-right:var(--jse-main-border);display:flex;gap:var(--jse-padding)}.jse-status-bar.svelte-1oo7hnc.svelte-1oo7hnc:last-child{border-bottom:var(--jse-main-border)}.jse-status-bar.svelte-1oo7hnc .jse-status-bar-info.svelte-1oo7hnc{padding:2px}");
}
function Kq(e) {
  var t, n, r;
  return {
    c: function c() {
      t = go("div"), n = bo("Line: "), r = bo(e[0]), So(t, "class", "jse-status-bar-info svelte-1oo7hnc");
    },
    m: function m(e, i) {
      vo(e, t, i), uo(t, n), uo(t, r);
    },
    p: function p(e, t) {
      1 & t && Ao(r, e[0]);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function Gq(e) {
  var t, n, r;
  return {
    c: function c() {
      t = go("div"), n = bo("Column: "), r = bo(e[1]), So(t, "class", "jse-status-bar-info svelte-1oo7hnc");
    },
    m: function m(e, i) {
      vo(e, t, i), uo(t, n), uo(t, r);
    },
    p: function p(e, t) {
      2 & t && Ao(r, e[1]);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function Qq(e) {
  var t, n, r, i;
  return {
    c: function c() {
      t = go("div"), n = bo("Selection: "), r = bo(e[2]), i = bo(" characters"), So(t, "class", "jse-status-bar-info svelte-1oo7hnc");
    },
    m: function m(e, o) {
      vo(e, t, o), uo(t, n), uo(t, r), uo(t, i);
    },
    p: function p(e, t) {
      4 & t && Ao(r, e[2]);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function Yq(e) {
  var t,
    n,
    r,
    i = void 0 !== e[0] && Kq(e),
    o = void 0 !== e[1] && Gq(e),
    a = void 0 !== e[2] && e[2] > 0 && Qq(e);
  return {
    c: function c() {
      t = go("div"), i && i.c(), n = ko(), o && o.c(), r = ko(), a && a.c(), So(t, "class", "jse-status-bar svelte-1oo7hnc");
    },
    m: function m(e, s) {
      vo(e, t, s), i && i.m(t, null), uo(t, n), o && o.m(t, null), uo(t, r), a && a.m(t, null);
    },
    p: function p(e, s) {
      var u = xi(s, 1)[0];
      void 0 !== e[0] ? i ? i.p(e, u) : ((i = Kq(e)).c(), i.m(t, n)) : i && (i.d(1), i = null), void 0 !== e[1] ? o ? o.p(e, u) : ((o = Gq(e)).c(), o.m(t, r)) : o && (o.d(1), o = null), void 0 !== e[2] && e[2] > 0 ? a ? a.p(e, u) : ((a = Qq(e)).c(), a.m(t, null)) : a && (a.d(1), a = null);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t), i && i.d(), o && o.d(), a && a.d();
    }
  };
}
function Zq(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f,
    h,
    d = t.editorState;
  return e.$$set = function (e) {
    "editorState" in e && n(3, d = e.editorState);
  }, e.$$.update = function () {
    56 & e.$$.dirty && n(9, u = null === n(5, i = null === n(4, r = null == d ? void 0 : d.selection) || void 0 === r ? void 0 : r.main) || void 0 === i ? void 0 : i.head), 584 & e.$$.dirty && n(10, c = null === n(6, o = null == d ? void 0 : d.doc) || void 0 === o ? void 0 : o.lineAt(u)), 1024 & e.$$.dirty && n(0, l = c ? c.number : void 0), 1536 & e.$$.dirty && n(1, f = c ? u - c.from + 1 : void 0), 392 & e.$$.dirty && n(2, h = null === n(8, s = null === n(7, a = null == d ? void 0 : d.selection) || void 0 === a ? void 0 : a.ranges) || void 0 === s ? void 0 : s.reduce(function (e, t) {
      return e + t.to - t.from;
    }, 0));
  }, [l, f, h, d, r, i, o, a, s, u, c];
}
var Xq = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, Zq, Yq, Ji, {
        editorState: 3
      }, Jq), r;
    }
    return zi(n);
  }(),
  eF = MN.define([{
    tag: RT.propertyName,
    color: "var(--jse-key-color)"
  }, {
    tag: RT.number,
    color: "var(--jse-value-color-number)"
  }, {
    tag: RT.bool,
    color: "var(--jse-value-color-boolean)"
  }, {
    tag: RT.string,
    color: "var(--jse-value-color-string)"
  }, {
    tag: RT.keyword,
    color: "var(--jse-value-color-null)"
  }]),
  tF = RN(eF),
  nF = eF.style;
function rF(e) {
  co(e, "svelte-1ol5grl", '.jse-code-mode.svelte-1ol5grl.svelte-1ol5grl{flex:1;box-sizing:border-box;display:flex;flex-direction:column;background:var(--jse-background-color)}.jse-code-mode.no-main-menu.svelte-1ol5grl.svelte-1ol5grl{border-top:var(--jse-main-border)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl{flex:1;display:flex;flex-direction:column;overflow:hidden;min-width:0;min-height:0;border-left:var(--jse-main-border);border-right:var(--jse-main-border)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl:last-child{border-bottom:var(--jse-main-border)}.jse-code-mode.svelte-1ol5grl .jse-contents.jse-hidden.svelte-1ol5grl{visibility:hidden}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor{flex:1;overflow:hidden}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-scroller{font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);line-height:var(--jse-line-height);color:var(--jse-delimiter-color)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-gutters{background:var(--jse-panel-background);color:var(--jse-panel-color-readonly);border-right:var(--jse-panel-border)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-activeLine,.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-activeLineGutter{background:var(--jse-hover-background-color)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-selectionBackground{background:var(--jse-selection-background-color)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-searchMatch{background-color:var(--jse-search-match-color);outline:var(--jse-search-match-outline)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-searchMatch.cm-searchMatch-selected{background-color:var(--jse-search-match-active-color);outline:var(--jse-search-match-active-outline)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-foldPlaceholder{background:var(--jse-tag-background);color:var(--jse-tag-color);border:none;padding:0 var(--jse-padding)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-diagnostic{font-size:var(--jse-font-size);font-family:var(--jse-font-family)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-panels{border-bottom:var(--jse-panel-border)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-search{background:var(--jse-panel-background);color:var(--jse-panel-color);font-family:var(--jse-font-family);font-size:var(--jse-font-size)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-search input{font-family:var(--jse-font-family);font-size:var(--jse-font-size-code-mode-search);color:var(--jse-input-color);border:var(--jse-input-border);background:var(--jse-input-background);margin-right:2px}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-search button{font-family:var(--jse-font-family);font-size:var(--jse-font-size-code-mode-search);color:var(--jse-panel-button-color);background:var(--jse-panel-button-background);border:none;cursor:pointer;text-transform:capitalize;padding:calc(0.5 * var(--jse-padding)) var(--jse-padding);margin:0}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-search button:hover{color:var(--jse-panel-button-color-highlight);background:var(--jse-panel-button-background-highlight)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-search label{font-family:var(--jse-font-family);font-size:var(--jse-font-size-code-mode-search);padding-left:var(--jse-padding)}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-search label input{margin-right:2px}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-search button[name="close"]{width:32px;height:32px;font-size:24px;line-height:24px;padding:0;right:0;top:-4px}.jse-code-mode.svelte-1ol5grl .jse-contents.svelte-1ol5grl .cm-editor .cm-cursor-primary{border-color:var(--jse-text-color)}.jse-code-mode.svelte-1ol5grl .jse-contents .jse-loading-space.svelte-1ol5grl{flex:1}.jse-code-mode.svelte-1ol5grl .jse-contents .jse-loading.svelte-1ol5grl{flex:2;text-align:center;color:var(--jse-panel-color-readonly);box-sizing:border-box;font-family:var(--jse-font-family);font-size:var(--jse-font-size)}');
}
function iF(e) {
  var t, n;
  return t = new LC({
    props: {
      readOnly: e[1],
      onFormat: e[17],
      onCompact: e[18],
      onSort: e[19],
      onTransform: e[20],
      onToggleSearch: e[21],
      onUndo: e[22],
      onRedo: e[23],
      canFormat: !e[15],
      canCompact: !e[15],
      canSort: !e[15],
      canTransform: !e[15],
      canUndo: e[10],
      canRedo: e[11],
      onRenderMenu: e[5]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      2 & n[0] && (r.readOnly = e[1]), 32768 & n[0] && (r.canFormat = !e[15]), 32768 & n[0] && (r.canCompact = !e[15]), 32768 & n[0] && (r.canSort = !e[15]), 32768 & n[0] && (r.canTransform = !e[15]), 1024 & n[0] && (r.canUndo = e[10]), 2048 & n[0] && (r.canRedo = e[11]), 32 & n[0] && (r.onRenderMenu = e[5]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function oF(e) {
  var t;
  return {
    c: function c() {
      (t = go("div")).innerHTML = '<div class="jse-loading-space svelte-1ol5grl"></div> \n      <div class="jse-loading svelte-1ol5grl">loading...</div>', So(t, "class", "jse-contents svelte-1ol5grl");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: Bi,
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function aF(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u = e[14] && sF(e),
    _c6 = e[3] && uF(e),
    l = e[12] && cF(e);
  return a = new pC({
    props: {
      validationErrors: e[9],
      selectError: e[26]
    }
  }), {
    c: function c() {
      u && u.c(), t = ko(), n = go("div"), r = ko(), _c6 && _c6.c(), i = ko(), l && l.c(), o = ko(), Aa(a.$$.fragment), So(n, "class", "jse-contents svelte-1ol5grl"), To(n, "jse-hidden", e[14]);
    },
    m: function m(f, h) {
      u && u.m(f, h), vo(f, t, h), vo(f, n, h), e[46](n), vo(f, r, h), _c6 && _c6.m(f, h), vo(f, i, h), l && l.m(f, h), vo(f, o, h), Ea(a, f, h), s = !0;
    },
    p: function p(e, r) {
      e[14] ? u ? (u.p(e, r), 16384 & r[0] && ya(u, 1)) : ((u = sF(e)).c(), ya(u, 1), u.m(t.parentNode, t)) : u && (ma(), ba(u, 1, 1, function () {
        u = null;
      }), ga()), 16384 & r[0] && To(n, "jse-hidden", e[14]), e[3] ? _c6 ? (_c6.p(e, r), 8 & r[0] && ya(_c6, 1)) : ((_c6 = uF(e)).c(), ya(_c6, 1), _c6.m(i.parentNode, i)) : _c6 && (ma(), ba(_c6, 1, 1, function () {
        _c6 = null;
      }), ga()), e[12] ? l ? (l.p(e, r), 4096 & r[0] && ya(l, 1)) : ((l = cF(e)).c(), ya(l, 1), l.m(o.parentNode, o)) : l && (ma(), ba(l, 1, 1, function () {
        l = null;
      }), ga());
      var s = {};
      512 & r[0] && (s.validationErrors = e[9]), a.$set(s);
    },
    i: function i(e) {
      s || (ya(u), ya(_c6), ya(l), ya(a.$$.fragment, e), s = !0);
    },
    o: function o(e) {
      ba(u), ba(_c6), ba(l), ba(a.$$.fragment, e), s = !1;
    },
    d: function d(s) {
      u && u.d(s), s && po(t), s && po(n), e[46](null), s && po(r), _c6 && _c6.d(s), s && po(i), l && l.d(s), s && po(o), Pa(a, s);
    }
  };
}
function sF(e) {
  var t, n;
  return t = new nC({
    props: {
      icon: yS,
      type: "error",
      message: "The JSON document is larger than ".concat(wS(10485760, 1024), ", ") + "and may crash your browser when loading it in code mode. Actual size: ".concat(wS(e[0].length, 1024), "."),
      actions: [{
        text: "Open anyway",
        title: "Open the document in code mode. This may freeze or crash your browser.",
        onClick: e[24]
      }, {
        text: "Open in tree mode",
        title: "Open the document in tree mode. Tree mode can handle large documents.",
        onClick: e[4]
      }, {
        text: "Cancel",
        title: "Cancel opening this large document.",
        onClick: e[25]
      }]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      1 & n[0] && (r.message = "The JSON document is larger than ".concat(wS(10485760, 1024), ", ") + "and may crash your browser when loading it in code mode. Actual size: ".concat(wS(e[0].length, 1024), ".")), 16 & n[0] && (r.actions = [{
        text: "Open anyway",
        title: "Open the document in code mode. This may freeze or crash your browser.",
        onClick: e[24]
      }, {
        text: "Open in tree mode",
        title: "Open the document in tree mode. Tree mode can handle large documents.",
        onClick: e[4]
      }, {
        text: "Cancel",
        title: "Cancel opening this large document.",
        onClick: e[25]
      }]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function uF(e) {
  var t, n;
  return t = new Xq({
    props: {
      editorState: e[8]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      256 & n[0] && (r.editorState = e[8]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function cF(e) {
  var t, n;
  return t = new nC({
    props: {
      type: "error",
      icon: yS,
      message: e[12].message,
      actions: e[13],
      onClick: e[47]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      4096 & n[0] && (r.message = e[12].message), 8192 & n[0] && (r.actions = e[13]), 4096 & n[0] && (r.onClick = e[47]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function lF(e) {
  var t,
    n,
    r,
    _i14,
    _o8,
    a = e[2] && iF(e),
    s = [aF, oF],
    u = [];
  return r = function (e, t) {
    return e[16] ? 1 : 0;
  }(e), _i14 = u[r] = s[r](e), {
    c: function c() {
      t = go("div"), a && a.c(), n = ko(), _i14.c(), So(t, "class", "jse-code-mode svelte-1ol5grl"), To(t, "no-main-menu", !e[2]);
    },
    m: function m(i, s) {
      vo(i, t, s), a && a.m(t, null), uo(t, n), u[r].m(t, null), e[48](t), _o8 = !0;
    },
    p: function p(e, r) {
      e[2] ? a ? (a.p(e, r), 4 & r[0] && ya(a, 1)) : ((a = iF(e)).c(), ya(a, 1), a.m(t, n)) : a && (ma(), ba(a, 1, 1, function () {
        a = null;
      }), ga()), _i14.p(e, r), 4 & r[0] && To(t, "no-main-menu", !e[2]);
    },
    i: function i(e) {
      _o8 || (ya(a), ya(_i14), _o8 = !0);
    },
    o: function o(e) {
      ba(a), ba(_i14), _o8 = !1;
    },
    d: function d(n) {
      n && po(t), a && a.d(), u[r].d(), e[48](null);
    }
  };
}
function fF(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f,
    h,
    d = t.readOnly,
    v = void 0 !== d && d,
    p = t.mainMenuBar,
    m = void 0 === p || p,
    g = t.statusBar,
    y = void 0 === g || g,
    b = t.text,
    k = void 0 === b ? "" : b,
    w = t.indentation,
    x = void 0 === w ? 2 : w,
    j = t.tabSize,
    S = void 0 === j ? 4 : j,
    C = t.escapeUnicodeCharacters,
    _ = void 0 !== C && C,
    $ = t.validator,
    O = void 0 === $ ? null : $,
    A = t.onChange,
    E = void 0 === A ? null : A,
    P = t.onSwitchToTreeMode,
    M = void 0 === P ? kc : P,
    I = t.onError,
    T = t.onFocus,
    N = void 0 === T ? kc : T,
    R = t.onBlur,
    D = void 0 === R ? kc : R,
    z = t.onRenderMenu,
    L = void 0 === z ? kc : z,
    B = t.onSortModal,
    q = t.onTransformModal,
    F = Na("jsoneditor:CodeMode"),
    V = {
      key: "Mod-i",
      run: ie,
      shift: oe,
      preventDefault: !0
    },
    H = "undefined" == typeof window;
  F("isSSR:", H);
  var W = !1,
    U = [],
    J = new R_(),
    K = new R_(),
    G = new R_(),
    Q = _;
  Jo(yi(mi().mark(function e() {
    return mi().wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (!H) {
              e.next = 2;
              break;
            }
            return e.abrupt("return");
          case 2:
            try {
              c = fe({
                target: u,
                initialText: o ? "" : k,
                readOnly: v,
                indentation: x
              }), te();
            } catch (e) {
              console.error(e);
            }
          case 3:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))), Ko(function () {
    c && (F("Destroy CodeMirror editor"), c.destroy());
  });
  var Y = !1,
    Z = !1,
    X = ww(),
    ee = ww();
  function te() {
    c && (F("focus"), c.focus());
  }
  var ne = !1;
  function re(e) {
    F("patch", e);
    var t = k,
      r = JSON.parse(k),
      i = ks.exports.immutableJSONPatch(r, e),
      o = ks.exports.revertJSONPatch(r, e);
    return n(0, k = JSON.stringify(i, null, x)), k !== t && ke(k, t), {
      json: i,
      previousJson: r,
      undo: o,
      redo: e
    };
  }
  function ie() {
    if (F("format"), !v) try {
      var e = k,
        t = JSON.parse(k);
      n(0, k = JSON.stringify(t, null, x)), k !== e && ke(k, e);
    } catch (e) {
      I(e);
    }
  }
  function oe() {
    if (F("compact"), !v) try {
      var e = k,
        t = JSON.parse(k);
      n(0, k = JSON.stringify(t)), k !== e && ke(k, e);
    } catch (e) {
      I(e);
    }
  }
  function ae() {
    if (F("repair"), !v) try {
      var e = k;
      n(0, k = Ds(k)), n(44, we = "valid"), n(12, xe = void 0), k !== e && ke(k, e);
    } catch (e) {
      I(e);
    }
  }
  function se(e) {
    var t = e.id,
      n = e.selectedPath,
      r = e.onTransform,
      i = e.onClose;
    try {
      var o = JSON.parse(k);
      ne = !0, q({
        id: t || ee,
        json: o,
        selectedPath: n,
        onTransform: r ? function (e) {
          r({
            operations: e,
            json: o,
            transformedJson: ks.exports.immutableJSONPatch(o, e)
          });
        } : function (e) {
          F("onTransform", e), re(e);
        },
        onClose: function onClose() {
          ne = !1, te(), i && i();
        }
      });
    } catch (e) {
      I(e);
    }
  }
  function ue(e) {
    F("select parse error", e);
    var t = de(e);
    ce(t.from, t.to), te();
  }
  function ce(e, t) {
    F("setSelection", {
      anchor: e,
      head: t
    }), c && c.dispatch(c.state.update({
      selection: {
        anchor: e,
        head: t
      },
      scrollIntoView: !0
    }));
  }
  function le(e, t) {
    if (1 === t.state.selection.ranges.length) {
      var n = t.state.selection.ranges[0],
        r = k.slice(n.from, n.to);
      if ("{" === r || "[" === r) {
        var i = ws.parse(k),
          o = Object.keys(i.pointers).find(function (e) {
            var t;
            return (null === (t = i.pointers[e].value) || void 0 === t ? void 0 : t.pos) === n.from;
          }),
          a = i.pointers[o];
        if (o && a && a.value && a.valueEnd) F("pointer found, selecting inner contents of path:", o, a), ce(a.value.pos + 1, a.valueEnd.pos - 1);
      }
    }
  }
  function fe(e) {
    var t = e.target,
      r = e.initialText,
      i = e.readOnly,
      o = e.indentation;
    F("Create CodeMirror editor", {
      readOnly: i,
      indentation: o
    });
    var a = c$.create({
      doc: r,
      extensions: [TP.of([hz, V]), $B(function () {
        return be.flush(), function () {
          if (F("validate"), n(44, we = "valid"), n(12, xe = null), n(9, U = []), k.length > 104857600) return [{
            from: 0,
            to: 0,
            message: "Validation turned off: the document is too large",
            severity: "info"
          }];
          if (0 === k.length) return [];
          try {
            var e = Uq(function () {
              return JSON.parse(k);
            }, function (e) {
              return F("validate: parsed json in ".concat(e, " ms"));
            });
            return O ? (n(9, U = Uq(function () {
              return O(e);
            }, function (e) {
              return F("validate: validated json in ".concat(e, " ms"));
            })), U.map(he)) : [];
          } catch (e) {
            var t = Uq(function () {
              return function (e) {
                if (e.length > 1048576) return !1;
                try {
                  return JSON.parse(Ds(e)), !0;
                } catch (e) {
                  return !1;
                }
              }(k);
            }, function (e) {
              return F("validate: checked whether repairable in ".concat(e, " ms"));
            });
            return n(12, xe = ru(k, e.message || e.toString())), n(44, we = t ? "repairable" : "invalid"), [de(xe, t)];
          }
        }();
      }, {
        delay: 300
      }), HB(), WB, tF, CP.domEventHandlers({
        dblclick: le
      }), CP.updateListener.of(function (e) {
        n(8, h = e.state), e.docChanged && be();
      }), new YT(Wq), Rz({
        top: !0
      }), J.of(c$.readOnly.of(i)), G.of(c$.tabSize.of(S)), K.of(ge(o)), CP.lineWrapping]
    });
    return c = new CP({
      state: a,
      parent: t
    });
  }
  function he(e) {
    var t = e.path,
      n = e.message,
      r = e.isChildError,
      i = function (e, t) {
        try {
          var n = ws.parse(e),
            r = ks.exports.compileJSONPointer(t),
            i = n.pointers[r];
          if (i) return {
            path: t,
            line: i.key ? i.key.line : i.value ? i.value.line : 0,
            column: i.key ? i.key.column : i.value ? i.value.column : 0,
            from: i.key ? i.key.pos : i.value ? i.value.pos : 0,
            to: i.keyEnd ? i.keyEnd.pos : i.valueEnd ? i.valueEnd.pos : 0
          };
        } catch (e) {
          console.error(e);
        }
        return null;
      }(k, t);
    return {
      path: t,
      isChildError: r,
      line: i.line,
      column: i.column,
      from: i.from,
      to: i.to,
      message: n,
      severity: "warning",
      actions: []
    };
  }
  function de(e, t) {
    var n = e.line,
      r = e.column,
      i = e.position;
    return {
      path: null,
      line: n,
      column: r,
      from: i || 0,
      to: i || 0,
      severity: "error",
      message: e.message,
      actions: t && !v ? [{
        name: "Auto repair",
        apply: function apply() {
          return ae();
        }
      }] : null
    };
  }
  function ve(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    !o || t ? c && e !== l && (F("setCodeMirrorValue length=", e.length), l = e, c.dispatch({
      changes: {
        from: 0,
        to: c.state.doc.length,
        insert: a.escapeValue(e)
      }
    }), ye()) : F("not applying text: editor is disabled");
  }
  function pe() {
    F("forceUpdateText", {
      escapeUnicodeCharacters: _
    }), c && c.dispatch({
      changes: {
        from: 0,
        to: c.state.doc.length,
        insert: a.escapeValue(k)
      }
    });
  }
  function me() {
    if (c && (l = c ? a.unescapeValue(c.state.doc.toString()) : "") !== k) {
      var e = l;
      F("text changed"), n(0, k = l), ye(), ke(k, e);
    }
  }
  function ge(e) {
    return XT.of("number" == typeof e ? " ".repeat(e) : e);
  }
  function ye() {
    n(10, Y = ZR(c.state) > 0), n(11, Z = XR(c.state) > 0), F({
      canUndo: Y,
      canRedo: Z
    });
  }
  jS({
    onMount: Jo,
    onDestroy: Ko,
    getWindow: function getWindow() {
      return Aj(f);
    },
    hasFocus: function hasFocus() {
      return ne && document.hasFocus() || Ej(f);
    },
    onFocus: N,
    onBlur: D
  });
  var be = Ev(me, 300);
  function ke(e, t) {
    E && E(e, t);
  }
  var we = "valid",
    xe = null;
  return e.$$set = function (e) {
    "readOnly" in e && n(1, v = e.readOnly), "mainMenuBar" in e && n(2, m = e.mainMenuBar), "statusBar" in e && n(3, y = e.statusBar), "text" in e && n(0, k = e.text), "indentation" in e && n(28, x = e.indentation), "tabSize" in e && n(29, S = e.tabSize), "escapeUnicodeCharacters" in e && n(30, _ = e.escapeUnicodeCharacters), "validator" in e && n(31, O = e.validator), "onChange" in e && n(32, E = e.onChange), "onSwitchToTreeMode" in e && n(4, M = e.onSwitchToTreeMode), "onError" in e && n(33, I = e.onError), "onFocus" in e && n(34, N = e.onFocus), "onBlur" in e && n(35, D = e.onBlur), "onRenderMenu" in e && n(5, L = e.onRenderMenu), "onSortModal" in e && n(36, B = e.onSortModal), "onTransformModal" in e && n(37, q = e.onTransformModal);
  }, e.$$.update = function () {
    1 & e.$$.dirty[0] && n(15, r = 0 === k.length), 1 & e.$$.dirty[0] && n(45, i = k && k.length > 10485760), 18432 & e.$$.dirty[1] && n(14, o = i && !W), 1073741824 & e.$$.dirty[0] && (a = hj({
      escapeControlCharacters: !1,
      escapeUnicodeCharacters: _
    })), 1 & e.$$.dirty[0] && ve(k), 268435456 & e.$$.dirty[0] && function (e) {
      c && (F("updateIndentation", e), c.dispatch({
        effects: K.reconfigure(ge(e))
      }));
    }(x), 536870912 & e.$$.dirty[0] && function (e) {
      c && (F("updateTabSize", e), c.dispatch({
        effects: G.reconfigure(c$.tabSize.of(e))
      }));
    }(S), 2 & e.$$.dirty[0] && function (e) {
      c && (F("updateReadOnly", e), c.dispatch({
        effects: J.reconfigure(c$.readOnly.of(e))
      }));
    }(v), 1073741824 & e.$$.dirty[0] | 4096 & e.$$.dirty[1] && Q !== _ && (n(43, Q = _), pe()), 2 & e.$$.dirty[0] | 1 & e.$$.dirty[1] && pe(), 2 & e.$$.dirty[0] | 8192 & e.$$.dirty[1] && n(13, s = "repairable" !== we || v ? [] : [{
      icon: bS,
      text: "Auto repair",
      title: "Automatically repair JSON",
      onClick: ae
    }]);
  }, [k, v, m, y, M, L, u, f, h, U, Y, Z, xe, s, o, r, H, ie, oe, function () {
    var e;
    if (!v) try {
      var t = JSON.parse(k);
      ne = !0, B({
        id: X,
        json: t,
        selectedPath: [],
        onSort: (e = yi(mi().mark(function e(t) {
          return mi().wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  F("onSort", t), re(t);
                case 2:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        })), function (t) {
          return e.apply(this, arguments);
        }),
        onClose: function onClose() {
          ne = !1, te();
        }
      });
    } catch (e) {
      I(e);
    }
  }, function () {
    v || se({
      selectedPath: []
    });
  }, function () {
    c && (u && u.querySelector(".cm-search") ? oL(c) : iL(c));
  }, function () {
    v || c && (JR(c), te());
  }, function () {
    v || c && (KR(c), te());
  }, function () {
    n(42, W = !0), ve(k, !0);
  }, function () {
    me();
  }, function (e) {
    F("select validation error", e);
    var t = he(e);
    ce(t.from, t.to), te();
  }, ue, x, S, _, O, E, I, N, D, B, q, te, re, se, function () {
    F("refresh");
    var e = c.state.doc.length;
    c.dispatch({
      changes: {
        from: e,
        to: e,
        insert: " "
      }
    }), c.dispatch({
      changes: {
        from: e,
        to: e + 1,
        insert: ""
      }
    });
  }, W, Q, we, i, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(6, u = e);
    });
  }, function () {
    return ue(xe);
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(7, f = e);
    });
  }];
}
eF.style = function (e) {
  return nF(e || []);
};
var hF = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, fF, lF, Ki, {
        readOnly: 1,
        mainMenuBar: 2,
        statusBar: 3,
        text: 0,
        indentation: 28,
        tabSize: 29,
        escapeUnicodeCharacters: 30,
        validator: 31,
        onChange: 32,
        onSwitchToTreeMode: 4,
        onError: 33,
        onFocus: 34,
        onBlur: 35,
        onRenderMenu: 5,
        onSortModal: 36,
        onTransformModal: 37,
        focus: 38,
        patch: 39,
        openTransformModal: 40,
        refresh: 41
      }, rF, [-1, -1, -1]), r;
    }
    return zi(n, [{
      key: "focus",
      get: function get() {
        return this.$$.ctx[38];
      }
    }, {
      key: "patch",
      get: function get() {
        return this.$$.ctx[39];
      }
    }, {
      key: "openTransformModal",
      get: function get() {
        return this.$$.ctx[40];
      }
    }, {
      key: "refresh",
      get: function get() {
        return this.$$.ctx[41];
      }
    }]), n;
  }(),
  dF = Na("jsoneditor:AutoScrollHandler");
function vF(e) {
  var t, n;
  function r(e) {
    return e < 20 ? 200 : e < 50 ? 400 : 1200;
  }
  function i() {
    if (e) {
      var n = .05 * t;
      e.scrollTop += n;
    }
  }
  function o(e) {
    n && e === t || (a(), dF("startAutoScroll", e), t = e, n = setInterval(i, 50));
  }
  function a() {
    n && (dF("stopAutoScroll"), clearInterval(n), n = void 0, t = void 0);
  }
  return dF("createAutoScrollHandler", e), {
    onDrag: function onDrag(t) {
      if (e) {
        var n = t.clientY,
          i = e.getBoundingClientRect(),
          s = i.top,
          u = i.bottom;
        if (n < s) o(-r(s - n));else if (n > u) {
          o(r(n - u));
        } else a();
      }
    },
    onDragEnd: function onDragEnd() {
      a();
    }
  };
}
var pF = function pF(e, t, n, r) {
    return (e /= r / 2) < 1 ? n / 2 * e * e + t : -n / 2 * (--e * (e - 2) - 1) + t;
  },
  mF = function mF() {
    var e, t, n, r, i, o, a, s, u, c, l, f, h;
    function d() {
      return e.scrollY || e.pageYOffset || e.scrollTop;
    }
    function v(t) {
      return t.getBoundingClientRect().top - (e.getBoundingClientRect ? e.getBoundingClientRect().top : 0) + n;
    }
    function p(t) {
      e.scrollTo ? e.scrollTo(0, t) : e.scrollTop = t;
    }
    function m(e) {
      c || (c = e), p(o(l = e - c, n, s, u)), h = !0, l < u ? requestAnimationFrame(m) : function () {
        p(n + s), t && a && (t.setAttribute("tabindex", "-1"), t.focus());
        "function" == typeof f && f();
        c = !1, h = !1;
      }();
    }
    return function (l) {
      var p = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      switch (u = p.duration || 1e3, i = p.offset || 0, f = p.callback, o = p.easing || pF, a = p.a11y || !1, Li(p.container)) {
        case "object":
          e = p.container;
          break;
        case "string":
          e = document.querySelector(p.container);
          break;
        default:
          e = window;
      }
      switch (n = d(), Li(l)) {
        case "number":
          t = void 0, a = !1, r = n + l;
          break;
        case "object":
          r = v(t = l);
          break;
        case "string":
          t = document.querySelector(l), r = v(t);
      }
      switch (s = r - n + i, Li(p.duration)) {
        case "number":
          u = p.duration;
          break;
        case "function":
          u = p.duration(s);
      }
      h ? c = !1 : requestAnimationFrame(m);
    };
  };
function gF(e, t) {
  for (var n = new Set(t), r = e.replace(/ \(copy( \d+)?\)$/, ""), i = e, o = 1; n.has(i);) {
    var a = "copy" + (o > 1 ? " " + o : "");
    i = "".concat(r, " (").concat(a, ")"), o++;
  }
  return i;
}
function yF(e, t) {
  var n = t - "...".length;
  return e.length > t ? e.substr(0, n) + "..." : e;
}
function bF(e) {
  if ("" === e) return "";
  var t = e.toLowerCase();
  if ("null" === t) return null;
  if ("true" === t) return !0;
  if ("false" === t) return !1;
  if ("undefined" !== t) {
    var n = Number(e),
      r = parseFloat(e);
    return isNaN(n) || isNaN(r) ? e : n;
  }
}
function kF(e, t, n, r) {
  var i = _m(n),
    o = ks.exports.getIn(e, i);
  if (Array.isArray(o)) {
    var a = parseInt(Gv(n), 10);
    return r.map(function (e, t) {
      return {
        op: "add",
        path: ks.exports.compileJSONPointer(i.concat(a + t)),
        value: e.value
      };
    });
  }
  var s = Gv(n),
    u = Ex(t, i),
    c = Ix(u, s, !0);
  return [].concat(Ii(r.map(function (e) {
    var t = gF(e.key, u);
    return {
      op: "add",
      path: ks.exports.compileJSONPointer(i.concat(t)),
      value: e.value
    };
  })), Ii(c.map(function (e) {
    return CF(i, e);
  })));
}
function wF(e, t, n) {
  var r = ks.exports.getIn(e, t);
  if (Array.isArray(r)) {
    var i = r.length;
    return n.map(function (e, n) {
      return {
        op: "add",
        path: ks.exports.compileJSONPointer(t.concat(i + n)),
        value: e.value
      };
    });
  }
  return n.map(function (e) {
    var n = gF(e.key, Object.keys(r));
    return {
      op: "add",
      path: ks.exports.compileJSONPointer(t.concat(n)),
      value: e.value
    };
  });
}
function xF(e, t, n, r) {
  var i = gF(r, t.filter(function (e) {
      return e !== n;
    })),
    o = Ix(t, n, !1);
  return [{
    op: "move",
    from: ks.exports.compileJSONPointer(e.concat(n)),
    path: ks.exports.compileJSONPointer(e.concat(i))
  }].concat(Ii(o.map(function (t) {
    return CF(e, t);
  })));
}
function jF(e, t, n, r) {
  if (n.type === Hx) {
    var i = Xs(r),
      o = _m(n.focusPath);
    return xF(o, Ex(t, o), Gv(n.focusPath), "string" == typeof i ? i : r);
  }
  if (n.type === Wx || n.type === Ux && Ym(n.focusPath)) try {
    return [{
      op: "replace",
      path: ks.exports.compileJSONPointer(n.focusPath),
      value: eu(r, Zs)
    }];
  } catch (e) {
    return [{
      op: "replace",
      path: ks.exports.compileJSONPointer(n.focusPath),
      value: r
    }];
  }
  if (n.type === Ux) {
    var a = _F(r);
    return function (e, t, n, r) {
      var i = _m(Bp(n)),
        o = ks.exports.getIn(e, i);
      if (Array.isArray(o)) {
        var a = Bp(n),
          s = a ? parseInt(Gv(a), 10) : 0;
        return [].concat(Ii(SF(n)), Ii(r.map(function (e, t) {
          return {
            op: "add",
            path: ks.exports.compileJSONPointer(i.concat(t + s)),
            value: e.value
          };
        })));
      }
      var u = Gv(n),
        c = _m(u),
        l = Gv(u),
        f = Ex(t, c),
        h = Ix(f, l, !1),
        d = new Set(n.map(function (e) {
          return Gv(e);
        })),
        v = f.filter(function (e) {
          return !d.has(e);
        });
      return [].concat(Ii(SF(n)), Ii(r.map(function (e) {
        var t = gF(e.key, v);
        return {
          op: "add",
          path: ks.exports.compileJSONPointer(c.concat(t)),
          value: e.value
        };
      })), Ii(h.map(function (e) {
        return CF(c, e);
      })));
    }(e, t, n.paths, a);
  }
  if (n.type === Fx) {
    var s = _F(r),
      u = n.focusPath,
      c = _m(u),
      l = ks.exports.getIn(e, c);
    if (Array.isArray(l)) {
      var f = Gv(u);
      return kF(e, t, c.concat([f + 1]), s);
    }
    var h = Gv(u),
      d = Ex(t, c);
    if (Ym(d) || Gv(d) === h) return wF(e, c, s);
    var v = d.indexOf(h),
      p = d[v + 1];
    return kF(e, t, c.concat([p]), s);
  }
  if (n.type === Vx) {
    var m = _F(r),
      g = n.focusPath,
      y = ks.exports.getIn(e, g);
    if (Array.isArray(y)) return kF(e, t, g.concat([0]), m);
    var b = Ex(t, g);
    if (Ym(b)) return wF(e, g, m);
    var k = Bp(b);
    return kF(e, t, g.concat([k]), m);
  }
  throw new Error("Cannot insert: unsupported type of selection " + JSON.stringify(n));
}
function SF(e) {
  return e.map(function (e) {
    return {
      op: "remove",
      path: ks.exports.compileJSONPointer(e)
    };
  }).reverse();
}
function CF(e, t) {
  return {
    op: "move",
    from: ks.exports.compileJSONPointer(e.concat(t)),
    path: ks.exports.compileJSONPointer(e.concat(t))
  };
}
function _F(e) {
  var t = /^\s*{/.test(e),
    n = /^\s*\[/.test(e),
    r = Xs(e),
    i = void 0 !== r ? r : eu(e, Zs);
  return t && zs(i) || n && Array.isArray(i) ? [{
    key: "New item",
    value: i
  }] : Array.isArray(i) ? i.map(function (e, t) {
    return {
      key: "New item " + t,
      value: e
    };
  }) : zs(i) ? Object.keys(i).map(function (e) {
    return {
      key: e,
      value: i[e]
    };
  }) : [{
    key: "New item",
    value: i
  }];
}
function $F(e, t, n) {
  if (n.type === Hx) {
    var r = _m(n.focusPath),
      i = xF(r, Ex(t, r), Gv(n.focusPath), "");
    return {
      operations: i,
      newSelection: tj(e, 0, i)
    };
  }
  if (n.type === Wx) return {
    operations: [{
      op: "replace",
      path: ks.exports.compileJSONPointer(n.focusPath),
      value: ""
    }],
    newSelection: n
  };
  if (n.type === Ux) {
    var o = SF(n.paths),
      a = Gv(n.paths);
    if (Ym(a)) {
      return {
        operations: [{
          op: "replace",
          path: "",
          value: ""
        }],
        newSelection: sj(e, t, {
          type: Wx,
          path: []
        })
      };
    }
    var s = _m(a),
      u = ks.exports.getIn(e, s);
    if (Array.isArray(u)) {
      var c = Gv(Bp(n.paths));
      return {
        operations: o,
        newSelection: sj(e, t, 0 === c ? {
          type: Vx,
          path: s
        } : {
          type: Fx,
          path: s.concat([c - 1])
        })
      };
    }
    var l = Ex(t, s),
      f = Gv(Bp(n.paths)),
      h = l.indexOf(f),
      d = l[h - 1];
    return {
      operations: o,
      newSelection: sj(e, t, 0 === h ? {
        type: Vx,
        path: s
      } : {
        type: Fx,
        path: s.concat([d])
      })
    };
  }
  throw new Error("Cannot remove: unsupported type of selection " + JSON.stringify(n));
}
function OF(e, t, n) {
  var r = t,
    i = function (e, t) {
      var n = {};
      return t.forEach(function (t) {
        var r = t.path;
        if (!ks.exports.existsIn(n, r)) {
          var i = ks.exports.getIn(e, r);
          n = ks.exports.setIn(n, r, Array.isArray(i) ? [] : {}, !0);
        }
        n = ks.exports.setIn(n, zF(t), t, !0);
      }), n;
    }(e, r),
    o = n && n.activeItem ? zF(n.activeItem) : void 0,
    a = o && ks.exports.existsIn(i, o) ? ks.exports.getIn(i, o) : r[0],
    s = r.findIndex(function (e) {
      return n = a, (t = e).start === n.start && t.field === n.field && Zm(t.path, n.path);
      var t, n;
    });
  return {
    items: i,
    itemsWithActive: i && a && -1 !== s ? ks.exports.setIn(i, DF(a), !0) : i,
    flatItems: r,
    count: r.length,
    activeItem: a,
    activeIndex: s
  };
}
function AF(e) {
  var t = e.activeIndex < e.flatItems.length - 1 ? e.activeIndex + 1 : e.flatItems.length > 0 ? 0 : -1,
    n = e.flatItems[t],
    r = n ? ks.exports.setIn(e.items, DF(n), !0, !0) : e.items;
  return Pi(Pi({}, e), {}, {
    itemsWithActive: r,
    activeItem: n,
    activeIndex: t
  });
}
function EF(e) {
  var t = e.activeIndex > 0 ? e.activeIndex - 1 : e.flatItems.length - 1,
    n = e.flatItems[t],
    r = n ? ks.exports.setIn(e.items, DF(n), !0, !0) : e.items;
  return Pi(Pi({}, e), {}, {
    itemsWithActive: r,
    activeItem: n,
    activeIndex: t
  });
}
function PF(e, t, n) {
  var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1 / 0,
    i = [],
    o = [];
  function a(e) {
    i.length < r && i.push(e);
  }
  function s(e, t, n) {
    if (Array.isArray(t)) {
      var u = o.length;
      o.push(0);
      for (var c = 0; c < t.length; c++) {
        if (o[u] = c, s(e, t[c], n ? n[c] : void 0), i.length >= r) return;
      }
      o.pop();
    } else if (null !== t && "object" === Li(t)) {
      var l = o.length;
      o.push(0);
      var f,
        h = bi(n ? n[ns] : Object.keys(t));
      try {
        for (h.s(); !(f = h.n()).done;) {
          var d = f.value;
          if (o[l] = d, MF(d, e, o, rs, a), s(e, t[d], n ? n[d] : void 0), i.length >= r) return;
        }
      } catch (e) {
        h.e(e);
      } finally {
        h.f();
      }
      o.pop();
    } else MF(t, e, o, is, a);
  }
  if ("string" == typeof e && "" !== e) {
    var u = e.toLowerCase();
    s(u, t, n);
  }
  return i;
}
function MF(e, t, n, r, i) {
  var o = String(e).toLowerCase(),
    a = 0,
    s = -1,
    u = -1;
  do {
    -1 !== (u = o.indexOf(t, s)) && (s = u + t.length, i({
      path: n.slice(0),
      field: r,
      fieldIndex: a,
      start: u,
      end: s,
      active: !1
    }), a++);
  } while (-1 !== u);
}
function IF(e, t, n, r) {
  return e.substring(0, n) + t + e.substring(r);
}
function TF(e, t, n) {
  var r = e;
  return lp(n, function (e) {
    r = IF(r, t, e.start, e.end);
  }), r;
}
function NF(e, t, n, r) {
  var i = r.field,
    o = r.path,
    a = r.start,
    s = r.end;
  if (i === rs) {
    var u = _m(o),
      c = Gv(o),
      l = xF(u, Ex(t, u), c, IF(c, n, a, s));
    return {
      newSelection: tj(e, 0, l),
      operations: l
    };
  }
  if (i === is) {
    var f = ks.exports.getIn(e, o);
    if (void 0 === f) throw new Error("Cannot replace: path not found ".concat(ks.exports.compileJSONPointer(o)));
    var h = "string" == typeof f ? f : String(f),
      d = ks.exports.getIn(t, o.concat([os])) || !1,
      v = IF(h, n, a, s),
      p = [{
        op: "replace",
        path: ks.exports.compileJSONPointer(o),
        value: d ? v : Hs(v)
      }];
    return {
      newSelection: tj(e, 0, p),
      operations: p
    };
  }
  throw new Error("Cannot replace: unknown type of search result field ".concat(i));
}
function RF(e, t, n, r) {
  for (var i = PF(n, e, t, 1 / 0), o = [], a = 0; a < i.length; a++) {
    var s = i[a - 1],
      u = i[a];
    0 !== a && u.field === s.field && Zm(u.path, s.path) ? Gv(o).items.push(u) : o.push({
      path: u.path,
      field: u.field,
      items: [u]
    });
  }
  o.sort(function (e, t) {
    return e.field !== t.field ? e.field === rs ? 1 : -1 : t.path.length - e.path.length;
  });
  var c = [],
    l = void 0;
  return o.forEach(function (n) {
    var i = n.field,
      o = n.path,
      a = n.items;
    if (i === rs) {
      var s = _m(o),
        u = Gv(o),
        f = xF(s, Ex(t, s), u, TF(u, r, a));
      c = c.concat(f), l = tj(e, 0, f);
    } else {
      if (i !== is) throw new Error("Cannot replace: unknown type of search result field ".concat(i));
      var h = ks.exports.getIn(e, o);
      if (void 0 === h) throw new Error("Cannot replace: path not found ".concat(ks.exports.compileJSONPointer(o)));
      var d = "string" == typeof h ? h : String(h),
        v = ks.exports.getIn(t, o.concat([os])) || !1,
        p = TF(d, r, a),
        m = [{
          op: "replace",
          path: ks.exports.compileJSONPointer(o),
          value: v ? p : Hs(p)
        }];
      c = c.concat(m), l = tj(e, 0, m);
    }
  }), {
    operations: c,
    newSelection: l
  };
}
function DF(e) {
  return e.path.concat(e.field, e.fieldIndex, "active");
}
function zF(e) {
  return e.path.concat(e.field, e.fieldIndex);
}
function LF(e) {
  co(e, "svelte-d01h2s", ".jse-header.svelte-d01h2s.svelte-d01h2s{display:flex;background:var(--jse-theme-color);color:var(--jse-menu-color)}.jse-header.svelte-d01h2s .jse-title.svelte-d01h2s{flex:1;padding:5px;vertical-align:middle}.jse-header.svelte-d01h2s button.svelte-d01h2s{border:none;background:transparent;min-width:32px;color:inherit;cursor:pointer}.jse-header.svelte-d01h2s button.svelte-d01h2s:hover{background:rgba(255, 255, 255, 0.1)}");
}
function BF(e) {
  var t, n, r, i, o, a, s, u, c;
  return a = new KS({
    props: {
      data: kS
    }
  }), {
    c: function c() {
      t = go("div"), n = go("div"), r = bo(e[0]), i = ko(), o = go("button"), Aa(a.$$.fragment), So(n, "class", "jse-title svelte-d01h2s"), So(o, "type", "button"), So(o, "class", "jse-close svelte-d01h2s"), So(t, "class", "jse-header svelte-d01h2s");
    },
    m: function m(l, f) {
      vo(l, t, f), uo(t, n), uo(n, r), uo(t, i), uo(t, o), Ea(a, o, null), s = !0, u || (c = xo(o, "click", e[1]), u = !0);
    },
    p: function p(e, t) {
      var n = xi(t, 1)[0];
      (!s || 1 & n) && Ao(r, e[0]);
    },
    i: function i(e) {
      s || (ya(a.$$.fragment, e), s = !0);
    },
    o: function o(e) {
      ba(a.$$.fragment, e), s = !1;
    },
    d: function d(e) {
      e && po(t), Pa(a), u = !1, c();
    }
  };
}
function qF(e, t, n) {
  var r = t.title,
    i = void 0 === r ? "Modal" : r,
    o = Yo("simple-modal").close;
  return e.$$set = function (e) {
    "title" in e && n(0, i = e.title);
  }, [i, o];
}
var FF = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, qF, BF, Ki, {
      title: 0
    }, LF), r;
  }
  return zi(n);
}();
function VF(e) {
  co(e, "svelte-t45ah0", ".jse-modal.svelte-t45ah0.svelte-t45ah0{--height:36px;--multiItemHeight:28px;--multiItemMargin:2px;--multiItemPadding:2px 8px;--multiClearTop:5px;--multiItemBorderRadius:6px;--clearSelectTop:2px;--clearSelectBottom:2px;--indicatorTop:8px;flex:1;display:flex;flex-direction:column;font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;background:var(--jse-modal-background);color:var(--jse-text-color)}.jse-modal.svelte-t45ah0 .jse-contents.svelte-t45ah0{padding:20px;overflow:auto}.jse-modal.svelte-t45ah0 .jse-contents .jse-actions.svelte-t45ah0{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding)}.jse-modal.svelte-t45ah0 .jse-contents .jse-actions button.svelte-t45ah0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;background:var(--jse-button-primary-background);color:var(--jse-button-primary-color);padding:var(--jse-padding) calc(2 * var(--jse-padding));border-radius:3px}.jse-modal.svelte-t45ah0 .jse-contents .jse-actions button.svelte-t45ah0:hover{background:var(--jse-button-primary-background-highlight)}.jse-modal.svelte-t45ah0 .jse-contents .jse-actions button.svelte-t45ah0:disabled{background:var(--jse-button-primary-background-disabled)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-modal-overlay-background)}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-content{flex:1;display:flex;max-height:calc(100vh - 6rem);padding:0}.jse-modal.jse-copy-paste.svelte-t45ah0 .jse-shortcuts.svelte-t45ah0{display:flex;flex-wrap:wrap;justify-content:space-around;margin:calc(2 * var(--jse-padding)) 0}.jse-modal.jse-copy-paste.svelte-t45ah0 .jse-shortcuts .jse-shortcut .jse-key.svelte-t45ah0{font-size:200%;color:var(--jse-theme-color)}");
}
function HF(e) {
  var t, n, r, i, o, a, s, u, _c7, l, f, h, d, v, p, _m5, g, y, b, k, w, x, j, S;
  return n = new FF({
    props: {
      title: "Copying and pasting"
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), r = ko(), i = go("div"), (o = go("div")).textContent = "These actions are unavailable via the menu. Please use:", a = ko(), s = go("div"), u = go("div"), (_c7 = go("div")).textContent = "".concat(e[1], "+C"), l = bo("\n        for copy"), f = ko(), h = go("div"), (d = go("div")).textContent = "".concat(e[1], "+X"), v = bo("\n        for cut"), p = ko(), _m5 = go("div"), (g = go("div")).textContent = "".concat(e[1], "+V"), y = bo("\n        for paste"), b = ko(), k = go("div"), (w = go("button")).textContent = "Close", So(_c7, "class", "jse-key svelte-t45ah0"), So(u, "class", "jse-shortcut"), So(d, "class", "jse-key svelte-t45ah0"), So(h, "class", "jse-shortcut"), So(g, "class", "jse-key svelte-t45ah0"), So(_m5, "class", "jse-shortcut"), So(s, "class", "jse-shortcuts svelte-t45ah0"), So(w, "type", "button"), So(w, "class", "jse-primary svelte-t45ah0"), So(k, "class", "jse-actions svelte-t45ah0"), So(i, "class", "jse-contents svelte-t45ah0"), So(t, "class", "jse-modal jse-copy-paste svelte-t45ah0");
    },
    m: function m(C, _) {
      vo(C, t, _), Ea(n, t, null), uo(t, r), uo(t, i), uo(i, o), uo(i, a), uo(i, s), uo(s, u), uo(u, _c7), uo(u, l), uo(s, f), uo(s, h), uo(h, d), uo(h, v), uo(s, p), uo(s, _m5), uo(_m5, g), uo(_m5, y), uo(i, b), uo(i, k), uo(k, w), x = !0, j || (S = xo(w, "click", e[0]), j = !0);
    },
    p: Bi,
    i: function i(e) {
      x || (ya(n.$$.fragment, e), x = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), x = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), j = !1, S();
    }
  };
}
function WF(e) {
  return [Yo("simple-modal").close, Rj ? "⌘" : "Ctrl"];
}
var UF = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, WF, HF, Ki, {}, VF), r;
  }
  return zi(n);
}();
function JF(e) {
  co(e, "svelte-gz09vf", ".jse-json-repair-component.svelte-gz09vf.svelte-gz09vf{flex:1;display:flex;flex-direction:column;background:var(--jse-background-color);color:var(--jse-text-color)}.jse-json-repair-component.svelte-gz09vf .jse-menu .jse-info.svelte-gz09vf{padding:0 var(--jse-padding)}.jse-json-repair-component.svelte-gz09vf .jse-json-text.svelte-gz09vf{flex:1;border:none;padding:2px;font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);background:var(--jse-background-color);color:var(--jse-text-color);resize:none;outline:none}");
}
function KF(e) {
  var t;
  return {
    c: function c() {
      (t = go("div")).textContent = "Repair invalid JSON, then click apply", So(t, "slot", "left"), So(t, "class", "jse-info svelte-gz09vf");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function GF(e) {
  var t, n;
  return t = new nC({
    props: {
      type: "success",
      message: "JSON is valid now and can be parsed.",
      actions: e[5]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      32 & n && (r.actions = e[5]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function QF(e) {
  var t, n;
  return t = new nC({
    props: {
      type: "error",
      icon: yS,
      message: "Cannot parse JSON: ".concat(e[2].message),
      actions: e[6]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      4 & n && (r.message = "Cannot parse JSON: ".concat(e[2].message)), 64 & n && (r.actions = e[6]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function YF(e) {
  var t, n, r, i, _o9, a, s, u, c, l;
  n = new TC({
    props: {
      items: e[7],
      $$slots: {
        left: [KF]
      },
      $$scope: {
        ctx: e
      }
    }
  });
  var f = [QF, GF],
    h = [];
  function d(e, t) {
    return e[2] ? 0 : 1;
  }
  return i = d(e), _o9 = h[i] = f[i](e), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), r = ko(), _o9.c(), a = ko(), (s = go("textarea")).value = e[0], s.readOnly = e[1], So(s, "class", "jse-json-text svelte-gz09vf"), So(s, "autocomplete", "off"), So(s, "autocapitalize", "off"), So(s, "spellcheck", "false"), So(t, "class", "jse-json-repair-component svelte-gz09vf");
    },
    m: function m(o, f) {
      vo(o, t, f), Ea(n, t, null), uo(t, r), h[i].m(t, null), uo(t, a), uo(t, s), e[21](s), e[22](t), u = !0, c || (l = xo(s, "input", e[8]), c = !0);
    },
    p: function p(e, r) {
      var c = xi(r, 1)[0],
        l = {};
      128 & c && (l.items = e[7]), 536870912 & c && (l.$$scope = {
        dirty: c,
        ctx: e
      }), n.$set(l);
      var v = i;
      (i = d(e)) === v ? h[i].p(e, c) : (ma(), ba(h[v], 1, 1, function () {
        h[v] = null;
      }), ga(), (_o9 = h[i]) ? _o9.p(e, c) : (_o9 = h[i] = f[i](e)).c(), ya(_o9, 1), _o9.m(t, a)), (!u || 1 & c) && (s.value = e[0]), (!u || 2 & c) && (s.readOnly = e[1]);
    },
    i: function i(e) {
      u || (ya(n.$$.fragment, e), ya(_o9), u = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), ba(_o9), u = !1;
    },
    d: function d(r) {
      r && po(t), Pa(n), h[i].d(), e[21](null), e[22](null), c = !1, l();
    }
  };
}
function ZF(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f,
    h,
    d = t.text,
    v = void 0 === d ? "" : d,
    p = t.readOnly,
    m = void 0 !== p && p,
    g = t.onParse,
    y = t.onRepair,
    b = t.onChange,
    k = void 0 === b ? null : b,
    w = t.onApply,
    x = t.onCancel,
    j = t.onFocus,
    S = t.onBlur,
    C = t.onRenderMenu,
    _ = void 0 === C ? kc : C,
    $ = Na("jsoneditor:JSONRepair");
  function O() {
    w(v);
  }
  return jS({
    onMount: Jo,
    onDestroy: Ko,
    getWindow: function getWindow() {
      return Aj(f);
    },
    hasFocus: function hasFocus() {
      return Ej(f);
    },
    onFocus: function onFocus() {
      j && j();
    },
    onBlur: function onBlur() {
      S && S();
    }
  }), e.$$set = function (e) {
    "text" in e && n(0, v = e.text), "readOnly" in e && n(1, m = e.readOnly), "onParse" in e && n(9, g = e.onParse), "onRepair" in e && n(10, y = e.onRepair), "onChange" in e && n(11, k = e.onChange), "onApply" in e && n(12, w = e.onApply), "onCancel" in e && n(13, x = e.onCancel), "onFocus" in e && n(14, j = e.onFocus), "onBlur" in e && n(15, S = e.onBlur), "onRenderMenu" in e && n(16, _ = e.onRenderMenu);
  }, e.$$.update = function () {
    1 & e.$$.dirty && n(2, r = function (e) {
      try {
        return g(e), null;
      } catch (t) {
        return ru(e, t.message);
      }
    }(v)), 1 & e.$$.dirty && n(19, i = function (e) {
      try {
        return y(e), !0;
      } catch (e) {
        return !1;
      }
    }(v)), 4 & e.$$.dirty && $("error", r), 8192 & e.$$.dirty && n(20, o = [{
      space: !0
    }, {
      icon: kS,
      title: "Cancel repair",
      className: "jse-cancel",
      onClick: x
    }]), 1114112 & e.$$.dirty && n(7, a = _("repair", o) || o), 917504 & e.$$.dirty && n(6, c = i ? [s, u] : [s]), 2 & e.$$.dirty && n(5, l = [{
      icon: tS,
      text: "Apply",
      title: "Apply fixed JSON",
      disabled: m,
      onClick: O
    }]);
  }, n(17, s = {
    icon: Gj,
    text: "Show me",
    title: "Scroll to the error location",
    onClick: function onClick() {
      h && r && null != r.position && (h.setSelectionRange(r.position, r.position), setTimeout(function () {
        h.focus();
      }));
    }
  }), n(18, u = {
    icon: bS,
    text: "Auto repair",
    title: "Automatically repair JSON",
    onClick: function onClick() {
      try {
        n(0, v = y(v)), k && k(v);
      } catch (e) {}
    }
  }), [v, m, r, f, h, l, c, a, function (e) {
    $("handleChange");
    var t = e.target.value;
    v !== t && (n(0, v = t), k && k(v));
  }, g, y, k, w, x, j, S, _, s, u, i, o, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(4, h = e);
    });
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(3, f = e);
    });
  }];
}
var XF = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, ZF, YF, Ki, {
      text: 0,
      readOnly: 1,
      onParse: 9,
      onRepair: 10,
      onChange: 11,
      onApply: 12,
      onCancel: 13,
      onFocus: 14,
      onBlur: 15,
      onRenderMenu: 16
    }, JF), r;
  }
  return zi(n);
}();
function eV(e) {
  co(e, "svelte-1ffm3pm", ".jse-modal.jse-repair.svelte-1ffm3pm{flex:1;display:flex;flex-direction:column;font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;background:var(--jse-background-color);color:var(--jse-text-color)}");
}
function tV(e) {
  var t, n, r, _i15;
  function o(t) {
    e[9](t);
  }
  var a = {
    onParse: e[1],
    onRepair: e[2],
    onApply: e[6],
    onCancel: e[7],
    onFocus: e[3],
    onBlur: e[4],
    onRenderMenu: e[5]
  };
  return void 0 !== e[0] && (a.text = e[0]), n = new XF({
    props: a
  }), Xo.push(function () {
    return Oa(n, "text", o);
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), So(t, "class", "jse-modal jse-repair svelte-1ffm3pm");
    },
    m: function m(e, r) {
      vo(e, t, r), Ea(n, t, null), _i15 = !0;
    },
    p: function p(e, t) {
      var i = xi(t, 1)[0],
        o = {};
      2 & i && (o.onParse = e[1]), 4 & i && (o.onRepair = e[2]), 8 & i && (o.onFocus = e[3]), 16 & i && (o.onBlur = e[4]), 32 & i && (o.onRenderMenu = e[5]), !r && 1 & i && (r = !0, o.text = e[0], sa(function () {
        return r = !1;
      })), n.$set(o);
    },
    i: function i(e) {
      _i15 || (ya(n.$$.fragment, e), _i15 = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), _i15 = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n);
    }
  };
}
function nV(e, t, n) {
  var r = t.text,
    i = t.onParse,
    o = t.onRepair,
    a = t.onApply,
    s = t.onFocus,
    u = t.onBlur,
    c = t.onRenderMenu,
    l = Yo("simple-modal").close;
  return e.$$set = function (e) {
    "text" in e && n(0, r = e.text), "onParse" in e && n(1, i = e.onParse), "onRepair" in e && n(2, o = e.onRepair), "onApply" in e && n(8, a = e.onApply), "onFocus" in e && n(3, s = e.onFocus), "onBlur" in e && n(4, u = e.onBlur), "onRenderMenu" in e && n(5, c = e.onRenderMenu);
  }, [r, i, o, s, u, c, function (e) {
    l(), a(e);
  }, function () {
    l();
  }, a, function (e) {
    n(0, r = e);
  }];
}
var rV = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, nV, tV, Ki, {
      text: 0,
      onParse: 1,
      onRepair: 2,
      onApply: 8,
      onFocus: 3,
      onBlur: 4,
      onRenderMenu: 5
    }, eV), r;
  }
  return zi(n);
}();
function iV(e) {
  co(e, "svelte-mojfmz", ".jse-dropdown-button.svelte-mojfmz.svelte-mojfmz{flex:1;line-height:normal;border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;position:relative;padding:0;display:flex}.jse-dropdown-button.svelte-mojfmz ul.svelte-mojfmz{margin:0;padding:0}.jse-dropdown-button.svelte-mojfmz ul li.svelte-mojfmz{margin:0;padding:0;list-style-type:none}.jse-dropdown-button.svelte-mojfmz button.jse-open-dropdown.svelte-mojfmz{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;width:2em;background:var(--jse-context-menu-background);color:var(--jse-context-menu-color);border-radius:0}.jse-dropdown-button.svelte-mojfmz button.jse-open-dropdown.jse-visible.svelte-mojfmz{background:var(--jse-context-menu-background)}.jse-dropdown-button.svelte-mojfmz button.jse-open-dropdown.svelte-mojfmz:hover{background:var(--jse-context-menu-background-highlight)}.jse-dropdown-button.svelte-mojfmz button.jse-open-dropdown.svelte-mojfmz:disabled{color:var(--jse-context-menu-color-disabled);background:unset}.jse-dropdown-button.svelte-mojfmz .jse-dropdown-items.svelte-mojfmz{display:none;position:absolute;top:100%;left:0;z-index:1;background:var(--jse-context-menu-background);color:var(--jse-context-menu-color);box-shadow:var(--jse-controls-box-shadow)}.jse-dropdown-button.svelte-mojfmz .jse-dropdown-items.jse-visible.svelte-mojfmz{display:block}.jse-dropdown-button.svelte-mojfmz .jse-dropdown-items button.svelte-mojfmz{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;width:100%;text-align:left;padding:var(--jse-padding);margin:0}.jse-dropdown-button.svelte-mojfmz .jse-dropdown-items button.svelte-mojfmz:hover{background:var(--jse-context-menu-background-highlight)}.jse-dropdown-button.svelte-mojfmz .jse-dropdown-items button.svelte-mojfmz:disabled{color:var(--jse-context-menu-color-disabled);background:unset}");
}
function oV(e, t, n) {
  var r = e.slice();
  return r[10] = t[n], r;
}
var aV = function aV(e) {
    return {};
  },
  sV = function sV(e) {
    return {};
  };
function uV(e) {
  var t, n;
  return t = new KS({
    props: {
      data: e[10].icon
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      1 & n && (r.data = e[10].icon), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function cV(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f = e[10].text + "",
    h = e[10].icon && uV(e);
  function d() {
    return e[8](e[10]);
  }
  return {
    c: function c() {
      t = go("li"), n = go("button"), h && h.c(), r = ko(), i = bo(f), s = ko(), So(n, "type", "button"), So(n, "title", o = e[10].title), n.disabled = a = e[10].disabled, So(n, "class", "svelte-mojfmz"), So(t, "class", "svelte-mojfmz");
    },
    m: function m(e, o) {
      vo(e, t, o), uo(t, n), h && h.m(n, null), uo(n, r), uo(n, i), uo(t, s), u = !0, c || (l = xo(n, "click", d), c = !0);
    },
    p: function p(t, s) {
      (e = t)[10].icon ? h ? (h.p(e, s), 1 & s && ya(h, 1)) : ((h = uV(e)).c(), ya(h, 1), h.m(n, r)) : h && (ma(), ba(h, 1, 1, function () {
        h = null;
      }), ga()), (!u || 1 & s) && f !== (f = e[10].text + "") && Ao(i, f), (!u || 1 & s && o !== (o = e[10].title)) && So(n, "title", o), (!u || 1 & s && a !== (a = e[10].disabled)) && (n.disabled = a);
    },
    i: function i(e) {
      u || (ya(h), u = !0);
    },
    o: function o(e) {
      ba(h), u = !1;
    },
    d: function d(e) {
      e && po(t), h && h.d(), c = !1, l();
    }
  };
}
function lV(e) {
  var t,
    n,
    r,
    _i16,
    o,
    a,
    s,
    u,
    c,
    l,
    f = e[7].defaultItem,
    h = Gi(f, e, e[6], sV);
  _i16 = new KS({
    props: {
      data: Xj
    }
  });
  for (var d = e[0], v = [], p = 0; p < d.length; p += 1) {
    v[p] = cV(oV(e, d, p));
  }
  var m = function m(e) {
    return ba(v[e], 1, 1, function () {
      v[e] = null;
    });
  };
  return {
    c: function c() {
      t = go("div"), h && h.c(), n = ko(), r = go("button"), Aa(_i16.$$.fragment), o = ko(), a = go("div"), s = go("ul");
      for (var u = 0; u < v.length; u += 1) {
        v[u].c();
      }
      So(r, "type", "button"), So(r, "class", "jse-open-dropdown svelte-mojfmz"), So(r, "data-type", "jse-open-dropdown"), To(r, "jse-visible", e[3]), So(s, "class", "svelte-mojfmz"), So(a, "class", "jse-dropdown-items svelte-mojfmz"), Po(a, "width", e[2]), To(a, "jse-visible", e[3]), So(t, "class", "jse-dropdown-button svelte-mojfmz"), So(t, "title", e[1]);
    },
    m: function m(f, d) {
      vo(f, t, d), h && h.m(t, null), uo(t, n), uo(t, r), Ea(_i16, r, null), uo(t, o), uo(t, a), uo(a, s);
      for (var p = 0; p < v.length; p += 1) {
        v[p].m(s, null);
      }
      u = !0, c || (l = [xo(r, "click", e[4]), xo(t, "click", e[5])], c = !0);
    },
    p: function p(e, n) {
      var i = xi(n, 1)[0];
      if (h && h.p && (!u || 64 & i) && Zi(h, f, e, e[6], u ? Yi(f, e[6], i, aV) : Xi(e[6]), sV), 8 & i && To(r, "jse-visible", e[3]), 1 & i) {
        var o;
        for (d = e[0], o = 0; o < d.length; o += 1) {
          var c = oV(e, d, o);
          v[o] ? (v[o].p(c, i), ya(v[o], 1)) : (v[o] = cV(c), v[o].c(), ya(v[o], 1), v[o].m(s, null));
        }
        for (ma(), o = d.length; o < v.length; o += 1) {
          m(o);
        }
        ga();
      }
      (!u || 4 & i) && Po(a, "width", e[2]), 8 & i && To(a, "jse-visible", e[3]), (!u || 2 & i) && So(t, "title", e[1]);
    },
    i: function i(e) {
      if (!u) {
        ya(h, e), ya(_i16.$$.fragment, e);
        for (var t = 0; t < d.length; t += 1) {
          ya(v[t]);
        }
        u = !0;
      }
    },
    o: function o(e) {
      ba(h, e), ba(_i16.$$.fragment, e), v = v.filter(Boolean);
      for (var t = 0; t < v.length; t += 1) {
        ba(v[t]);
      }
      u = !1;
    },
    d: function d(e) {
      e && po(t), h && h.d(e), Pa(_i16), mo(v, e), c = !1, Wi(l);
    }
  };
}
function fV(e, t, n) {
  var r = t.$$slots,
    i = void 0 === r ? {} : r,
    o = t.$$scope,
    a = t.items,
    s = void 0 === a ? [] : a,
    u = t.title,
    c = void 0 === u ? void 0 : u,
    l = t.width,
    f = void 0 === l ? "120px" : l,
    h = !1;
  function d() {
    n(3, h = !1);
  }
  function v(e) {
    "Escape" === Dj(e) && (e.preventDefault(), n(3, h = !1));
  }
  Jo(function () {
    document.addEventListener("click", d), document.addEventListener("keydown", v);
  }), Ko(function () {
    document.removeEventListener("click", d), document.removeEventListener("keydown", v);
  });
  return e.$$set = function (e) {
    "items" in e && n(0, s = e.items), "title" in e && n(1, c = e.title), "width" in e && n(2, f = e.width), "$$scope" in e && n(6, o = e.$$scope);
  }, [s, c, f, h, function () {
    var e = h;
    setTimeout(function () {
      return n(3, h = !e);
    });
  }, d, o, i, function (e) {
    return e.onClick();
  }];
}
var hV = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, fV, lV, Ki, {
        items: 0,
        title: 1,
        width: 2
      }, iV), r;
    }
    return zi(n);
  }(),
  dV = {
    prefix: "far",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", "M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z"]
  },
  vV = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [384, 512, [128161], "f0eb", "M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM192 0C90.02 .3203 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.8 289.2 .0039 192 0zM288.4 260.1c-15.66 17.85-35.04 46.3-49.05 75.89h-94.61c-14.01-29.59-33.39-58.04-49.04-75.88C75.24 236.8 64 206.1 64 175.1C64 113.3 112.1 48.25 191.1 48C262.6 48 320 105.4 320 175.1C320 206.1 308.8 236.8 288.4 260.1zM176 80C131.9 80 96 115.9 96 160c0 8.844 7.156 16 16 16S128 168.8 128 160c0-26.47 21.53-48 48-48c8.844 0 16-7.148 16-15.99S184.8 80 176 80z"]
  },
  pV = {
    prefix: "far",
    iconName: "square",
    icon: [448, 512, [9723, 9724, 61590, 9632], "f0c8", "M384 32C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H384zM384 80H64C55.16 80 48 87.16 48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80z"]
  },
  mV = {
    prefix: "far",
    iconName: "square-check",
    icon: [448, 512, [9989, 61510, 9745, "check-square"], "f14a", "M211.8 339.8C200.9 350.7 183.1 350.7 172.2 339.8L108.2 275.8C97.27 264.9 97.27 247.1 108.2 236.2C119.1 225.3 136.9 225.3 147.8 236.2L192 280.4L300.2 172.2C311.1 161.3 328.9 161.3 339.8 172.2C350.7 183.1 350.7 200.9 339.8 211.8L211.8 339.8zM0 96C0 60.65 28.65 32 64 32H384C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96zM48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80H64C55.16 80 48 87.16 48 96z"]
  };
/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function gV(e) {
  co(e, "svelte-1yai37q", ".jse-contextmenu.svelte-1yai37q.svelte-1yai37q{box-shadow:var(--jse-controls-box-shadow);font-family:var(--jse-font-family);font-size:var(--jse-font-size);background:var(--jse-context-menu-background);color:var(--jse-context-menu-color)}.jse-contextmenu.svelte-1yai37q button.svelte-1yai37q{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0}.jse-contextmenu.svelte-1yai37q button.svelte-1yai37q:focus{background:var(--jse-context-menu-background-highlight)}.jse-contextmenu.svelte-1yai37q .jse-row.svelte-1yai37q{display:flex;flex-direction:row;align-items:flex-start;justify-content:stretch}.jse-contextmenu.svelte-1yai37q .jse-row div.jse-label.svelte-1yai37q{flex:1;white-space:nowrap;padding:var(--jse-padding);color:var(--jse-context-menu-color-disabled);line-height:normal}.jse-contextmenu.svelte-1yai37q .jse-row div.jse-tip.svelte-1yai37q{flex:1;background:var(--jse-context-menu-tip-background);color:var(--jse-context-menu-tip-color);margin:calc(0.5 * var(--jse-padding));padding:calc(0.5 * var(--jse-padding)) var(--jse-padding);font-size:80%;line-height:1.3em;display:flex;flex-direction:row;align-items:center;gap:var(--jse-padding);border-radius:3px}.jse-contextmenu.svelte-1yai37q .jse-row div.jse-tip div.svelte-1yai37q{vertical-align:middle}.jse-contextmenu.svelte-1yai37q .jse-row button.svelte-1yai37q{flex:1;white-space:nowrap;padding:var(--jse-padding);color:inherit}.jse-contextmenu.svelte-1yai37q .jse-row button.svelte-1yai37q:hover{background:var(--jse-context-menu-background-highlight)}.jse-contextmenu.svelte-1yai37q .jse-row button.svelte-1yai37q:disabled{color:var(--jse-context-menu-color-disabled);background:unset}.jse-contextmenu.svelte-1yai37q .jse-row button .jse-insert.svelte-1yai37q{display:inline-block;position:relative;width:18px;height:18px;font-family:var(--jse-font-family-mono);font-weight:bold;font-size:16px}.jse-contextmenu.svelte-1yai37q .jse-row button .jse-insert .jse-quote.svelte-1yai37q,.jse-contextmenu.svelte-1yai37q .jse-row button .jse-insert .jse-plus.svelte-1yai37q{position:absolute;top:-4px;left:2px;font-size:24px}.jse-contextmenu.svelte-1yai37q .jse-column.svelte-1yai37q{flex:1;display:flex;flex-direction:column;align-items:stretch}.jse-contextmenu.svelte-1yai37q .jse-column.svelte-1yai37q:not(:last-child){border-right:1px solid var(--jse-context-menu-separator-color)}.jse-contextmenu.svelte-1yai37q .jse-column button.svelte-1yai37q{text-align:left;min-width:130px}.jse-contextmenu.svelte-1yai37q .jse-separator.svelte-1yai37q{width:100%;height:1px;background:var(--jse-context-menu-separator-color)}");
}
function yV(e) {
  var t, n, r, i, _o10, a, s;
  return n = new KS({
    props: {
      data: vS
    }
  }), {
    c: function c() {
      t = go("button"), Aa(n.$$.fragment), r = bo(" Edit value"), So(t, "type", "button"), So(t, "slot", "defaultItem"), So(t, "title", "Edit the value (Double-click on the value)"), t.disabled = i = !e[2], So(t, "class", "svelte-1yai37q");
    },
    m: function m(i, u) {
      vo(i, t, u), Ea(n, t, null), uo(t, r), _o10 = !0, a || (s = xo(t, "click", e[18]), a = !0);
    },
    p: function p(e, n) {
      (!_o10 || 4 & n[0] && i !== (i = !e[2])) && (t.disabled = i);
    },
    i: function i(e) {
      _o10 || (ya(n.$$.fragment, e), _o10 = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), _o10 = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), a = !1, s();
    }
  };
}
function bV(e) {
  var t, n, r, i, _o11, a, s;
  return n = new KS({
    props: {
      data: pS
    }
  }), {
    c: function c() {
      t = go("button"), Aa(n.$$.fragment), r = bo(" Cut"), So(t, "type", "button"), So(t, "slot", "defaultItem"), So(t, "title", "Cut selected contents, formatted with indentation (Ctrl+X)"), t.disabled = i = !e[1], So(t, "class", "svelte-1yai37q");
    },
    m: function m(i, u) {
      vo(i, t, u), Ea(n, t, null), uo(t, r), _o11 = !0, a || (s = xo(t, "click", e[19]), a = !0);
    },
    p: function p(e, n) {
      (!_o11 || 2 & n[0] && i !== (i = !e[1])) && (t.disabled = i);
    },
    i: function i(e) {
      _o11 || (ya(n.$$.fragment, e), _o11 = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), _o11 = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), a = !1, s();
    }
  };
}
function kV(e) {
  var t, n, r, i, _o12, a, s;
  return n = new KS({
    props: {
      data: sS
    }
  }), {
    c: function c() {
      t = go("button"), Aa(n.$$.fragment), r = bo(" Copy"), So(t, "type", "button"), So(t, "slot", "defaultItem"), So(t, "title", "Copy selected contents, formatted with indentation (Ctrl+C)"), t.disabled = i = !e[1], So(t, "class", "svelte-1yai37q");
    },
    m: function m(i, u) {
      vo(i, t, u), Ea(n, t, null), uo(t, r), _o12 = !0, a || (s = xo(t, "click", e[20]), a = !0);
    },
    p: function p(e, n) {
      (!_o12 || 2 & n[0] && i !== (i = !e[1])) && (t.disabled = i);
    },
    i: function i(e) {
      _o12 || (ya(n.$$.fragment, e), _o12 = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), _o12 = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), a = !1, s();
    }
  };
}
function wV(e) {
  var t, n, r, _i17, o, a, s;
  return _i17 = new KS({
    props: {
      data: vV
    }
  }), {
    c: function c() {
      t = go("div"), n = go("div"), r = go("div"), Aa(_i17.$$.fragment), o = ko(), (a = go("div")).textContent = "Tip: you can open this context menu via right-click or with Ctrl+Q", So(r, "class", "svelte-1yai37q"), So(a, "class", "svelte-1yai37q"), So(n, "class", "jse-tip svelte-1yai37q"), So(t, "class", "jse-row svelte-1yai37q");
    },
    m: function m(e, u) {
      vo(e, t, u), uo(t, n), uo(n, r), Ea(_i17, r, null), uo(n, o), uo(n, a), s = !0;
    },
    p: Bi,
    i: function i(e) {
      s || (ya(_i17.$$.fragment, e), s = !0);
    },
    o: function o(e) {
      ba(_i17.$$.fragment, e), s = !1;
    },
    d: function d(e) {
      e && po(t), Pa(_i17);
    }
  };
}
function xV(e) {
  var t, n, r, _i18, o, a, s, u, _c8, l, f, h, _d4, v, _p5, _m6, g, y, b, k, w, x, j, S, C, _, $, O, A, E, P, M, I, T, N, R, D, z, L, B, q, F, V, H, W, U, J, K, G, Q, Y, Z, X, ee, te, ne, re, ie, oe, ae, se, ue, ce, le, fe, he, de, ve, pe, me, ge, ye, be, ke, we, xe, je, Se, Ce, _e, $e, Oe, Ae, Ee, Pe, Me, Ie, Te, Ne, Re, De, ze, Le, Be, qe, Fe;
  _i18 = new KS({
    props: {
      data: vS
    }
  }), u = new hV({
    props: {
      width: "11em",
      items: e[8],
      $$slots: {
        defaultItem: [yV]
      },
      $$scope: {
        ctx: e
      }
    }
  }), _d4 = new hV({
    props: {
      width: "10em",
      items: e[7],
      $$slots: {
        defaultItem: [bV]
      },
      $$scope: {
        ctx: e
      }
    }
  }), _p5 = new hV({
    props: {
      width: "12em",
      items: e[6],
      $$slots: {
        defaultItem: [kV]
      },
      $$scope: {
        ctx: e
      }
    }
  }), y = new KS({
    props: {
      data: dS
    }
  }), $ = new KS({
    props: {
      data: kS
    }
  }), M = new KS({
    props: {
      data: oS
    }
  }), D = new KS({
    props: {
      data: uS
    }
  }), F = new KS({
    props: {
      data: Qj
    }
  }), J = new KS({
    props: {
      data: lS
    }
  }), Pe = new KS({
    props: {
      data: gS
    }
  }), Re = new KS({
    props: {
      data: mS
    }
  });
  var Ve = e[0] && wV();
  return {
    c: function c() {
      t = go("div"), n = go("div"), r = go("button"), Aa(_i18.$$.fragment), o = bo(" Edit key"), s = ko(), Aa(u.$$.fragment), _c8 = ko(), l = go("div"), f = ko(), h = go("div"), Aa(_d4.$$.fragment), v = ko(), Aa(_p5.$$.fragment), _m6 = ko(), g = go("button"), Aa(y.$$.fragment), b = bo(" Paste"), w = ko(), x = go("div"), j = ko(), S = go("div"), C = go("div"), _ = go("button"), Aa($.$$.fragment), O = bo(" Remove"), E = ko(), P = go("button"), Aa(M.$$.fragment), I = bo(" Duplicate"), N = ko(), R = go("button"), Aa(D.$$.fragment), z = bo(" Extract"), B = ko(), q = go("button"), Aa(F.$$.fragment), V = bo(" Sort"), W = ko(), U = go("button"), Aa(J.$$.fragment), K = bo(" Transform"), Q = ko(), Y = go("div"), Z = go("div"), X = bo(e[13]), ee = bo(":"), te = ko(), ne = go("button"), re = go("span"), (ie = go("span")).textContent = "+", oe = bo(" Structure"), ue = ko(), ce = go("button"), (le = go("span")).textContent = "{}", fe = bo(" Object"), ve = ko(), pe = go("button"), (me = go("span")).textContent = "[]", ge = bo(" Array"), ke = ko(), we = go("button"), (xe = go("span")).innerHTML = '<span class="jse-quote svelte-1yai37q">&quot;</span>', je = bo(" Value"), _e = ko(), $e = go("div"), Oe = ko(), Ae = go("div"), Ee = go("button"), Aa(Pe.$$.fragment), Me = bo(" Insert before"), Te = ko(), Ne = go("button"), Aa(Re.$$.fragment), De = bo(" Insert after"), Le = ko(), Ve && Ve.c(), So(r, "type", "button"), So(r, "title", "Edit the key (Double-click on the key)"), r.disabled = a = !e[14], So(r, "class", "svelte-1yai37q"), So(n, "class", "jse-row svelte-1yai37q"), So(l, "class", "jse-separator svelte-1yai37q"), So(g, "type", "button"), So(g, "title", "Paste clipboard contents (Ctrl+V)"), g.disabled = k = !e[3], So(g, "class", "svelte-1yai37q"), So(h, "class", "jse-row svelte-1yai37q"), So(x, "class", "jse-separator svelte-1yai37q"), So(_, "type", "button"), So(_, "title", "Remove selected contents (Delete)"), _.disabled = A = !e[1], So(_, "class", "svelte-1yai37q"), So(P, "type", "button"), So(P, "title", "Duplicate selected contents (Ctrl+D)"), P.disabled = T = !e[16], So(P, "class", "svelte-1yai37q"), So(R, "type", "button"), So(R, "title", "Extract selected contents"), R.disabled = L = !e[15], So(R, "class", "svelte-1yai37q"), So(q, "type", "button"), So(q, "title", "Sort array or object contents"), q.disabled = H = !e[1], So(q, "class", "svelte-1yai37q"), So(U, "type", "button"), So(U, "title", "Transform array or object contents (filter, sort, project)"), U.disabled = G = !e[1], So(U, "class", "svelte-1yai37q"), So(C, "class", "jse-column svelte-1yai37q"), So(Z, "class", "jse-label svelte-1yai37q"), So(ie, "class", "jse-plus svelte-1yai37q"), So(re, "class", "jse-insert svelte-1yai37q"), So(ne, "type", "button"), So(ne, "title", ae = e[13] + " structure"), ne.disabled = se = !e[12], So(ne, "class", "svelte-1yai37q"), So(le, "class", "jse-insert svelte-1yai37q"), So(ce, "type", "button"), So(ce, "title", he = e[13] + " object"), ce.disabled = de = !e[11], So(ce, "class", "svelte-1yai37q"), So(me, "class", "jse-insert svelte-1yai37q"), So(pe, "type", "button"), So(pe, "title", ye = e[13] + " array"), pe.disabled = be = !e[10], So(pe, "class", "svelte-1yai37q"), So(xe, "class", "jse-insert svelte-1yai37q"), So(we, "type", "button"), So(we, "title", Se = e[13] + " value"), we.disabled = Ce = !e[9], So(we, "class", "svelte-1yai37q"), So(Y, "class", "jse-column svelte-1yai37q"), So(S, "class", "jse-row svelte-1yai37q"), So($e, "class", "jse-separator svelte-1yai37q"), So(Ee, "type", "button"), So(Ee, "title", "Select area before current entry to insert or paste contents"), Ee.disabled = Ie = !e[1] || e[4], So(Ee, "class", "svelte-1yai37q"), So(Ne, "type", "button"), So(Ne, "title", "Select area after current entry to insert or paste contents"), Ne.disabled = ze = !e[1] || e[4], So(Ne, "class", "svelte-1yai37q"), So(Ae, "class", "jse-row svelte-1yai37q"), So(t, "class", "jse-contextmenu svelte-1yai37q");
    },
    m: function m(a, k) {
      vo(a, t, k), uo(t, n), uo(n, r), Ea(_i18, r, null), uo(r, o), uo(n, s), Ea(u, n, null), uo(t, _c8), uo(t, l), uo(t, f), uo(t, h), Ea(_d4, h, null), uo(h, v), Ea(_p5, h, null), uo(h, _m6), uo(h, g), Ea(y, g, null), uo(g, b), uo(t, w), uo(t, x), uo(t, j), uo(t, S), uo(S, C), uo(C, _), Ea($, _, null), uo(_, O), uo(C, E), uo(C, P), Ea(M, P, null), uo(P, I), uo(C, N), uo(C, R), Ea(D, R, null), uo(R, z), uo(C, B), uo(C, q), Ea(F, q, null), uo(q, V), uo(C, W), uo(C, U), Ea(J, U, null), uo(U, K), uo(S, Q), uo(S, Y), uo(Y, Z), uo(Z, X), uo(Z, ee), uo(Y, te), uo(Y, ne), uo(ne, re), uo(re, ie), uo(ne, oe), uo(Y, ue), uo(Y, ce), uo(ce, le), uo(ce, fe), uo(Y, ve), uo(Y, pe), uo(pe, me), uo(pe, ge), uo(Y, ke), uo(Y, we), uo(we, xe), uo(we, je), uo(t, _e), uo(t, $e), uo(t, Oe), uo(t, Ae), uo(Ae, Ee), Ea(Pe, Ee, null), uo(Ee, Me), uo(Ae, Te), uo(Ae, Ne), Ea(Re, Ne, null), uo(Ne, De), uo(t, Le), Ve && Ve.m(t, null), e[58](t), Be = !0, qe || (Fe = [xo(r, "click", e[17]), xo(g, "click", e[21]), xo(_, "click", e[22]), xo(P, "click", e[23]), xo(R, "click", e[24]), xo(q, "click", e[26]), xo(U, "click", e[27]), xo(ne, "click", e[54]), xo(ce, "click", e[55]), xo(pe, "click", e[56]), xo(we, "click", e[57]), xo(Ee, "click", e[28]), xo(Ne, "click", e[29]), xo(t, "keydown", e[30])], qe = !0);
    },
    p: function p(e, n) {
      (!Be || 16384 & n[0] && a !== (a = !e[14])) && (r.disabled = a);
      var i = {};
      256 & n[0] && (i.items = e[8]), 4 & n[0] | 1 & n[2] && (i.$$scope = {
        dirty: n,
        ctx: e
      }), u.$set(i);
      var o = {};
      128 & n[0] && (o.items = e[7]), 2 & n[0] | 1 & n[2] && (o.$$scope = {
        dirty: n,
        ctx: e
      }), _d4.$set(o);
      var s = {};
      64 & n[0] && (s.items = e[6]), 2 & n[0] | 1 & n[2] && (s.$$scope = {
        dirty: n,
        ctx: e
      }), _p5.$set(s), (!Be || 8 & n[0] && k !== (k = !e[3])) && (g.disabled = k), (!Be || 2 & n[0] && A !== (A = !e[1])) && (_.disabled = A), (!Be || 65536 & n[0] && T !== (T = !e[16])) && (P.disabled = T), (!Be || 32768 & n[0] && L !== (L = !e[15])) && (R.disabled = L), (!Be || 2 & n[0] && H !== (H = !e[1])) && (q.disabled = H), (!Be || 2 & n[0] && G !== (G = !e[1])) && (U.disabled = G), (!Be || 8192 & n[0]) && Ao(X, e[13]), (!Be || 8192 & n[0] && ae !== (ae = e[13] + " structure")) && So(ne, "title", ae), (!Be || 4096 & n[0] && se !== (se = !e[12])) && (ne.disabled = se), (!Be || 8192 & n[0] && he !== (he = e[13] + " object")) && So(ce, "title", he), (!Be || 2048 & n[0] && de !== (de = !e[11])) && (ce.disabled = de), (!Be || 8192 & n[0] && ye !== (ye = e[13] + " array")) && So(pe, "title", ye), (!Be || 1024 & n[0] && be !== (be = !e[10])) && (pe.disabled = be), (!Be || 8192 & n[0] && Se !== (Se = e[13] + " value")) && So(we, "title", Se), (!Be || 512 & n[0] && Ce !== (Ce = !e[9])) && (we.disabled = Ce), (!Be || 18 & n[0] && Ie !== (Ie = !e[1] || e[4])) && (Ee.disabled = Ie), (!Be || 18 & n[0] && ze !== (ze = !e[1] || e[4])) && (Ne.disabled = ze), e[0] ? Ve ? (Ve.p(e, n), 1 & n[0] && ya(Ve, 1)) : ((Ve = wV()).c(), ya(Ve, 1), Ve.m(t, null)) : Ve && (ma(), ba(Ve, 1, 1, function () {
        Ve = null;
      }), ga());
    },
    i: function i(e) {
      Be || (ya(_i18.$$.fragment, e), ya(u.$$.fragment, e), ya(_d4.$$.fragment, e), ya(_p5.$$.fragment, e), ya(y.$$.fragment, e), ya($.$$.fragment, e), ya(M.$$.fragment, e), ya(D.$$.fragment, e), ya(F.$$.fragment, e), ya(J.$$.fragment, e), ya(Pe.$$.fragment, e), ya(Re.$$.fragment, e), ya(Ve), Be = !0);
    },
    o: function o(e) {
      ba(_i18.$$.fragment, e), ba(u.$$.fragment, e), ba(_d4.$$.fragment, e), ba(_p5.$$.fragment, e), ba(y.$$.fragment, e), ba($.$$.fragment, e), ba(M.$$.fragment, e), ba(D.$$.fragment, e), ba(F.$$.fragment, e), ba(J.$$.fragment, e), ba(Pe.$$.fragment, e), ba(Re.$$.fragment, e), ba(Ve), Be = !1;
    },
    d: function d(n) {
      n && po(t), Pa(_i18), Pa(u), Pa(_d4), Pa(_p5), Pa(y), Pa($), Pa(M), Pa(D), Pa(F), Pa(J), Pa(Pe), Pa(Re), Ve && Ve.d(), e[58](null), qe = !1, Wi(Fe);
    }
  };
}
function jV(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f,
    h,
    d,
    v,
    p,
    m,
    g,
    y,
    b,
    k,
    w,
    x,
    j = t.json,
    S = t.state,
    C = t.selection,
    _ = t.showTip,
    $ = t.onCloseContextMenu,
    O = t.onEditKey,
    A = t.onEditValue,
    E = t.onToggleEnforceString,
    P = t.onCut,
    M = t.onCopy,
    I = t.onPaste,
    T = t.onRemove,
    N = t.onDuplicate,
    R = t.onExtract,
    D = t.onInsertBefore,
    z = t.onInsert,
    L = t.onConvert,
    B = t.onInsertAfter,
    q = t.onSort,
    F = t.onTransform;
  function V() {
    $(), A();
  }
  function H() {
    $(), E();
  }
  function W() {
    $(), P(!0);
  }
  function U() {
    $(), P(!1);
  }
  function J() {
    $(), M(!0);
  }
  function K() {
    $(), M(!1);
  }
  function G(e) {
    $(), s ? L(e) : z(e);
  }
  Jo(function () {
    setTimeout(function () {
      var e = Ii(x.querySelectorAll("button")).find(function (e) {
        return !e.disabled;
      });
      e && e.focus();
    });
  });
  return e.$$set = function (e) {
    "json" in e && n(31, j = e.json), "state" in e && n(32, S = e.state), "selection" in e && n(33, C = e.selection), "showTip" in e && n(0, _ = e.showTip), "onCloseContextMenu" in e && n(34, $ = e.onCloseContextMenu), "onEditKey" in e && n(35, O = e.onEditKey), "onEditValue" in e && n(36, A = e.onEditValue), "onToggleEnforceString" in e && n(37, E = e.onToggleEnforceString), "onCut" in e && n(38, P = e.onCut), "onCopy" in e && n(39, M = e.onCopy), "onPaste" in e && n(40, I = e.onPaste), "onRemove" in e && n(41, T = e.onRemove), "onDuplicate" in e && n(42, N = e.onDuplicate), "onExtract" in e && n(43, R = e.onExtract), "onInsertBefore" in e && n(44, D = e.onInsertBefore), "onInsert" in e && n(45, z = e.onInsert), "onConvert" in e && n(46, L = e.onConvert), "onInsertAfter" in e && n(47, B = e.onInsertAfter), "onSort" in e && n(48, q = e.onSort), "onTransform" in e && n(49, F = e.onTransform);
  }, e.$$.update = function () {
    1 & e.$$.dirty[1] && n(53, r = void 0 !== j), 4 & e.$$.dirty[1] && n(3, i = null != C), 8 & e.$$.dirty[0] | 4 & e.$$.dirty[1] && n(4, o = i && Ym(C.focusPath)), 8 & e.$$.dirty[0] | 5 & e.$$.dirty[1] && n(51, a = i ? ks.exports.getIn(j, C.focusPath) : void 0), 4194308 & e.$$.dirty[1] && n(1, s = r && null != C && (C.type === Ux || C.type === Hx || C.type === Wx)), 18 & e.$$.dirty[0] | 4194304 & e.$$.dirty[1] && n(16, u = r && s && !o), 16 & e.$$.dirty[0] | 4194308 & e.$$.dirty[1] && n(15, c = r && null != C && (C.type === Ux || C.type === Wx) && !o), 16 & e.$$.dirty[0] | 4194309 & e.$$.dirty[1] && n(14, l = r && null != C && rj(C) && !o && !Array.isArray(ks.exports.getIn(j, _m(C.focusPath)))), 5242884 & e.$$.dirty[1] && n(2, f = r && null != C && rj(C) && !Ls(a)), 2 & e.$$.dirty[0] && n(52, h = s), 2097152 & e.$$.dirty[1] && n(13, d = h ? "Convert to" : "Insert"), 8 & e.$$.dirty[0] | 2097152 & e.$$.dirty[1] && n(12, v = !h && i), 8 & e.$$.dirty[0] | 3145732 & e.$$.dirty[1] && n(11, p = h ? lj(C) && !zs(a) : i), 8 & e.$$.dirty[0] | 3145732 & e.$$.dirty[1] && n(10, m = h ? lj(C) && !Array.isArray(a) : i), 8 & e.$$.dirty[0] | 3145732 & e.$$.dirty[1] && n(9, g = h ? lj(C) && Ls(a) : i), 6 & e.$$.dirty[1] && n(50, y = null != C && !0 === ks.exports.getIn(S, C.focusPath.concat(os))), 4 & e.$$.dirty[0] | 524288 & e.$$.dirty[1] && n(8, b = [{
      icon: vS,
      text: "Edit value",
      title: "Edit the value (Double-click on the value)",
      onClick: V,
      disabled: !f
    }, {
      icon: y ? mV : pV,
      text: "Enforce string",
      title: "Enforce keeping the value as string when it contains a numeric value",
      onClick: H,
      disabled: !f
    }]), 2 & e.$$.dirty[0] && n(7, k = [{
      icon: pS,
      text: "Cut formatted",
      title: "Cut selected contents, formatted with indentation (Ctrl+X)",
      onClick: W,
      disabled: !s
    }, {
      icon: pS,
      text: "Cut compacted",
      title: "Cut selected contents, without indentation (Ctrl+Shift+X)",
      onClick: U,
      disabled: !s
    }]), 2 & e.$$.dirty[0] && n(6, w = [{
      icon: sS,
      text: "Copy formatted",
      title: "Copy selected contents, formatted with indentation (Ctrl+C)",
      onClick: J,
      disabled: !s
    }, {
      icon: sS,
      text: "Copy compacted",
      title: "Copy selected contents, without indentation (Ctrl+Shift+C)",
      onClick: K,
      disabled: !s
    }]);
  }, [_, s, f, i, o, x, w, k, b, g, m, p, v, d, l, c, u, function () {
    $(), O();
  }, V, W, J, function () {
    $(), I();
  }, function () {
    $(), T();
  }, function () {
    $(), N();
  }, function () {
    $(), R();
  }, G, function () {
    $(), q();
  }, function () {
    $(), F();
  }, function () {
    $(), D();
  }, function () {
    $(), B();
  }, function (e) {
    var t = Dj(e).replace(/^Command\+/, "Ctrl+");
    if ("Up" === t || "Down" === t || "Left" === t || "Right" === t) {
      e.preventDefault();
      var n = Nj({
        allElements: Array.from(x.querySelectorAll("button:not([disabled])")),
        currentElement: e.target,
        direction: t,
        hasPrio: function hasPrio(e) {
          return "jse-open-dropdown" !== e.getAttribute("data-type");
        }
      });
      n && n.focus();
    }
  }, j, S, C, $, O, A, E, P, M, I, T, N, R, D, z, L, B, q, F, y, a, h, r, function () {
    return G("structure");
  }, function () {
    return G("object");
  }, function () {
    return G("array");
  }, function () {
    return G("value");
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(5, x = e);
    });
  }];
}
var SV = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, jV, xV, Ki, {
        json: 31,
        state: 32,
        selection: 33,
        showTip: 0,
        onCloseContextMenu: 34,
        onEditKey: 35,
        onEditValue: 36,
        onToggleEnforceString: 37,
        onCut: 38,
        onCopy: 39,
        onPaste: 40,
        onRemove: 41,
        onDuplicate: 42,
        onExtract: 43,
        onInsertBefore: 44,
        onInsert: 45,
        onConvert: 46,
        onInsertAfter: 47,
        onSort: 48,
        onTransform: 49
      }, gV, [-1, -1, -1]), r;
    }
    return zi(n);
  }(),
  CV = {
    exports: {}
  };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
!function (e) {
  !function () {
    var t = {}.hasOwnProperty;
    function n() {
      for (var e = [], r = 0; r < arguments.length; r++) {
        var i = arguments[r];
        if (i) {
          var o = Li(i);
          if ("string" === o || "number" === o) e.push(i);else if (Array.isArray(i)) {
            if (i.length) {
              var a = n.apply(null, i);
              a && e.push(a);
            }
          } else if ("object" === o) if (i.toString === Object.prototype.toString) for (var s in i) {
            t.call(i, s) && i[s] && e.push(s);
          } else e.push(i.toString());
        }
      }
      return e.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  }();
}(CV);
var _V = CV.exports;
function $V(e) {
  co(e, "svelte-1knbf5w", "div.jse-collapsed-items.svelte-1knbf5w.svelte-1knbf5w{font-family:var(--jse-font-family);font-size:var(--jse-font-size);color:var(--jse-collapsed-items-link-color);padding:calc(0.5 * var(--jse-padding));border:8px solid transparent;border-width:8px 0;background-color:transparent;background-image:linear-gradient(var(--jse-collapsed-items-background-color), var(--jse-collapsed-items-background-color)), linear-gradient(to bottom right, transparent 50.5%, var(--jse-collapsed-items-background-color) 50.5%), linear-gradient(to bottom left, transparent 50.5%, var(--jse-collapsed-items-background-color) 50.5%), linear-gradient(to top right, transparent 50.5%, var(--jse-collapsed-items-background-color) 50.5%), linear-gradient(to top left, transparent 50.5%, var(--jse-collapsed-items-background-color) 50.5%);background-repeat:repeat, repeat-x, repeat-x, repeat-x, repeat-x;background-position:0 0, 8px 0, 8px 0, 8px 100%, 8px 100%;background-size:auto auto, 16px 16px, 16px 16px, 16px 16px, 16px 16px;background-clip:padding-box, border-box, border-box, border-box, border-box;background-origin:padding-box, border-box, border-box, border-box, border-box;display:flex}div.jse-collapsed-items.svelte-1knbf5w div.jse-text.svelte-1knbf5w,div.jse-collapsed-items.svelte-1knbf5w button.jse-expand-items.svelte-1knbf5w{margin:0 calc(0.5 * var(--jse-padding))}div.jse-collapsed-items.svelte-1knbf5w div.jse-text.svelte-1knbf5w{display:inline}div.jse-collapsed-items.svelte-1knbf5w button.jse-expand-items.svelte-1knbf5w{font-family:inherit;font-size:inherit;color:var(--jse-collapsed-items-link-color);background:none;border:none;padding:0;text-decoration:underline;cursor:pointer}div.jse-collapsed-items.svelte-1knbf5w button.jse-expand-items.svelte-1knbf5w:hover,div.jse-collapsed-items.svelte-1knbf5w button.jse-expand-items.svelte-1knbf5w:focus{color:var(--jse-collapsed-items-link-color-highlight)}");
}
function OV(e, t, n) {
  var r = e.slice();
  return r[12] = t[n], r;
}
function AV(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    _c9 = e[12].start + "",
    l = e[12].end + "";
  function f() {
    return e[11](e[12]);
  }
  return {
    c: function c() {
      t = go("button"), n = bo("show "), r = bo(_c9), i = bo("-"), o = bo(l), a = ko(), So(t, "type", "button"), So(t, "class", "jse-expand-items svelte-1knbf5w");
    },
    m: function m(e, c) {
      vo(e, t, c), uo(t, n), uo(t, r), uo(t, i), uo(t, o), uo(t, a), s || (u = xo(t, "click", f), s = !0);
    },
    p: function p(t, n) {
      e = t, 16 & n && _c9 !== (_c9 = e[12].start + "") && Ao(r, _c9), 16 & n && l !== (l = e[12].end + "") && Ao(o, l);
    },
    d: function d(e) {
      e && po(t), s = !1, u();
    }
  };
}
function EV(e) {
  for (var t, n, r, i, o, a, s, u, _c10, l, f, h = e[4], _d5 = [], v = 0; v < h.length; v += 1) {
    _d5[v] = AV(OV(e, h, v));
  }
  return {
    c: function c() {
      t = go("div"), n = go("div"), r = go("div"), i = bo("Items "), o = bo(e[3]), a = bo("-"), s = bo(e[2]), u = ko();
      for (var l = 0; l < _d5.length; l += 1) {
        _d5[l].c();
      }
      So(r, "class", "jse-text svelte-1knbf5w"), So(t, "class", "jse-collapsed-items svelte-1knbf5w"), So(t, "style", _c10 = PV(e[0].length + 2)), To(t, "jse-selected", e[5]);
    },
    m: function m(e, c) {
      vo(e, t, c), uo(t, n), uo(n, r), uo(r, i), uo(r, o), uo(r, a), uo(r, s), uo(n, u);
      for (var h = 0; h < _d5.length; h += 1) {
        _d5[h].m(n, null);
      }
      l || (f = xo(t, "mousemove", MV), l = !0);
    },
    p: function p(e, r) {
      var i = xi(r, 1)[0];
      if (8 & i && Ao(o, e[3]), 4 & i && Ao(s, e[2]), 19 & i) {
        var a;
        for (h = e[4], a = 0; a < h.length; a += 1) {
          var u = OV(e, h, a);
          _d5[a] ? _d5[a].p(u, i) : (_d5[a] = AV(u), _d5[a].c(), _d5[a].m(n, null));
        }
        for (; a < _d5.length; a += 1) {
          _d5[a].d(1);
        }
        _d5.length = h.length;
      }
      1 & i && _c10 !== (_c10 = PV(e[0].length + 2)) && So(t, "style", _c10), 32 & i && To(t, "jse-selected", e[5]);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t), mo(_d5, e), l = !1, f();
    }
  };
}
function PV(e) {
  return "margin-left: calc(".concat(e, " * var(--jse-indent-size))");
}
function MV(e) {
  e.stopPropagation();
}
function IV(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u = t.visibleSections,
    c = t.sectionIndex,
    l = t.total,
    f = t.path,
    h = t.selection,
    d = t.onExpandSection;
  return e.$$set = function (e) {
    "visibleSections" in e && n(6, u = e.visibleSections), "sectionIndex" in e && n(7, c = e.sectionIndex), "total" in e && n(8, l = e.total), "path" in e && n(0, f = e.path), "selection" in e && n(9, h = e.selection), "onExpandSection" in e && n(1, d = e.onExpandSection);
  }, e.$$.update = function () {
    192 & e.$$.dirty && n(10, r = u[c]), 1024 & e.$$.dirty && n(3, i = r.end), 448 & e.$$.dirty && n(2, o = u[c + 1] ? u[c + 1].start : l), 521 & e.$$.dirty && n(5, a = !(!h || !h.pathsMap) && !0 === h.pathsMap[ks.exports.compileJSONPointer(f.concat(i))]), 12 & e.$$.dirty && n(4, s = function (e, t) {
      var n = {
          start: e,
          end: Math.min(yx(e), t)
        },
        r = Math.max(bx((e + t) / 2), e),
        i = {
          start: r,
          end: Math.min(yx(r), t)
        },
        o = bx(t),
        a = o === t ? o - 100 : o,
        s = {
          start: Math.max(a, e),
          end: t
        },
        u = [n],
        c = i.start >= n.end && i.end <= s.start;
      return c && u.push(i), s.start >= (c ? i.end : n.end) && u.push(s), u;
    }(i, o));
  }, [f, d, o, i, s, a, u, c, l, h, r, function (e) {
    return d(f, e);
  }];
}
var TV = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, IV, EV, Ki, {
      visibleSections: 6,
      sectionIndex: 7,
      total: 8,
      path: 0,
      selection: 9,
      onExpandSection: 1
    }, $V), r;
  }
  return zi(n);
}();
function NV(e) {
  co(e, "svelte-dol684", ".jse-context-menu-button.svelte-dol684{position:absolute;top:calc(-0.5 * var(--jse-context-menu-button-size));right:calc(-0.5 * var(--jse-context-menu-button-size));width:var(--jse-context-menu-button-size);height:var(--jse-context-menu-button-size);padding:0;margin:0;z-index:2;cursor:pointer;background:transparent;border-radius:2px;background:var(--jse-context-menu-button-background);color:var(--jse-context-menu-button-color);border:none;box-shadow:var(--jse-controls-box-shadow)}.jse-context-menu-button.svelte-dol684:hover{background:var(--jse-context-menu-button-background-highlight)}");
}
function RV(e) {
  var t, n, r, i, o;
  return n = new KS({
    props: {
      data: Xj
    }
  }), {
    c: function c() {
      t = go("button"), Aa(n.$$.fragment), So(t, "type", "button"), So(t, "class", "jse-context-menu-button svelte-dol684"), So(t, "title", ds), To(t, "jse-selected", e[0]);
    },
    m: function m(a, s) {
      vo(a, t, s), Ea(n, t, null), r = !0, i || (o = xo(t, "click", e[1]), i = !0);
    },
    p: function p(e, n) {
      1 & xi(n, 1)[0] && To(t, "jse-selected", e[0]);
    },
    i: function i(e) {
      r || (ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), i = !1, o();
    }
  };
}
function DV(e, t, n) {
  var r = t.selected,
    i = t.onContextMenu;
  return e.$$set = function (e) {
    "selected" in e && n(0, r = e.selected), "onContextMenu" in e && n(2, i = e.onContextMenu);
  }, [r, function (e) {
    for (var t = e.target; t && "BUTTON" !== t.nodeName;) {
      t = t.parentNode;
    }
    t && i({
      anchor: t,
      left: 0,
      top: 0,
      width: 260,
      height: 336,
      offsetTop: 2,
      offsetLeft: 0,
      showTip: !0
    });
  }, i];
}
var zV = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, DV, RV, Ki, {
      selected: 0,
      onContextMenu: 2
    }, NV), r;
  }
  return zi(n);
}();
function LV(e) {
  co(e, "svelte-s6kbew", ".jse-highlight.svelte-s6kbew{background-color:var(--jse-search-match-color);outline:var(--jse-search-match-outline)}.jse-highlight.jse-active.svelte-s6kbew{background-color:var(--jse-search-match-active-color);outline:var(--jse-search-match-active-outline)}");
}
function BV(e, t, n) {
  var r = e.slice();
  return r[3] = t[n], r;
}
function qV(e) {
  var t,
    n,
    r = jj(e[3].text) + "";
  return {
    c: function c() {
      t = go("span"), n = bo(r), So(t, "class", "jse-highlight svelte-s6kbew"), To(t, "jse-active", e[3].active);
    },
    m: function m(e, r) {
      vo(e, t, r), uo(t, n);
    },
    p: function p(e, i) {
      1 & i && r !== (r = jj(e[3].text) + "") && Ao(n, r), 1 & i && To(t, "jse-active", e[3].active);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function FV(e) {
  var t,
    n = e[3].text + "";
  return {
    c: function c() {
      t = bo(n);
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: function p(e, r) {
      1 & r && n !== (n = e[3].text + "") && Ao(t, n);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function VV(e) {
  var t;
  function n(e, t) {
    return "normal" === e[3].type ? FV : qV;
  }
  var r = n(e),
    i = r(e);
  return {
    c: function c() {
      i.c(), t = wo();
    },
    m: function m(e, n) {
      i.m(e, n), vo(e, t, n);
    },
    p: function p(e, o) {
      r === (r = n(e)) && i ? i.p(e, o) : (i.d(1), (i = r(e)) && (i.c(), i.m(t.parentNode, t)));
    },
    d: function d(e) {
      i.d(e), e && po(t);
    }
  };
}
function HV(e) {
  for (var t, n = e[0], r = [], i = 0; i < n.length; i += 1) {
    r[i] = VV(BV(e, n, i));
  }
  return {
    c: function c() {
      for (var e = 0; e < r.length; e += 1) {
        r[e].c();
      }
      t = wo();
    },
    m: function m(e, n) {
      for (var i = 0; i < r.length; i += 1) {
        r[i].m(e, n);
      }
      vo(e, t, n);
    },
    p: function p(e, i) {
      var o = xi(i, 1)[0];
      if (1 & o) {
        var a;
        for (n = e[0], a = 0; a < n.length; a += 1) {
          var s = BV(e, n, a);
          r[a] ? r[a].p(s, o) : (r[a] = VV(s), r[a].c(), r[a].m(t.parentNode, t));
        }
        for (; a < r.length; a += 1) {
          r[a].d(1);
        }
        r.length = n.length;
      }
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      mo(r, e), e && po(t);
    }
  };
}
function WV(e, t, n) {
  var r,
    i = t.text,
    o = t.searchResult;
  return e.$$set = function (e) {
    "text" in e && n(1, i = e.text), "searchResult" in e && n(2, o = e.searchResult);
  }, e.$$.update = function () {
    6 & e.$$.dirty && n(0, r = function (e, t) {
      var n,
        r = [],
        i = 0,
        o = bi(t);
      try {
        for (o.s(); !(n = o.n()).done;) {
          var a = n.value,
            s = e.slice(i, a.start);
          "" !== s && r.push({
            type: "normal",
            text: s,
            active: !1
          });
          var u = e.slice(a.start, a.end);
          r.push({
            type: "highlight",
            text: u,
            active: a.active
          }), i = a.end;
        }
      } catch (e) {
        o.e(e);
      } finally {
        o.f();
      }
      var c = Gv(t);
      return c.end < e.length && r.push({
        type: "normal",
        text: e.slice(c.end),
        active: !1
      }), r;
    }(String(i), o));
  }, [r, i, o];
}
var UV = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, WV, HV, Ji, {
      text: 1,
      searchResult: 2
    }, LV), r;
  }
  return zi(n);
}();
function JV(e) {
  co(e, "svelte-rw77oa", ".jse-value.jse-string.svelte-rw77oa{color:var(--jse-value-color-string)}.jse-value.jse-object.svelte-rw77oa,.jse-value.jse-array.svelte-rw77oa{min-width:16px;color:var(--jse-delimiter-color)}.jse-value.jse-number.svelte-rw77oa{color:var(--jse-value-color-number)}.jse-value.jse-boolean.svelte-rw77oa{color:var(--jse-value-color-boolean)}.jse-value.jse-null.svelte-rw77oa{color:var(--jse-value-color-null)}.jse-value.jse-invalid.svelte-rw77oa{color:var(--jse-text-color)}.jse-value.jse-url.svelte-rw77oa{color:var(--jse-value-color-url);text-decoration:underline}div.jse-editable-div.svelte-rw77oa{min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;word-break:normal;white-space:pre-wrap;overflow-wrap:anywhere}div.jse-editable-div.jse-short-text.svelte-rw77oa{overflow-wrap:normal}div.jse-editable-div[contenteditable=true].svelte-rw77oa{outline:var(--jse-edit-outline);background:inherit !important;position:relative;border-radius:0;z-index:3}div.jse-editable-div.jse-empty.svelte-rw77oa:not(:focus){outline:1px dotted var(--jse-tag-background);-moz-outline-radius:2px}div.jse-editable-div.jse-empty.svelte-rw77oa::after{pointer-events:none;color:var(--jse-tag-background)}");
}
function KV(e) {
  var t, n, r, i;
  return {
    c: function c() {
      So(t = go("div"), "class", n = eo(_V("jse-editable-div", e[2], {
        "jse-short-text": e[0]
      })) + " svelte-rw77oa"), So(t, "contenteditable", "true"), So(t, "spellcheck", "false");
    },
    m: function m(n, o) {
      vo(n, t, o), e[13](t), r || (i = [xo(t, "input", e[3]), xo(t, "keydown", e[4]), xo(t, "paste", e[5]), xo(t, "blur", e[6])], r = !0);
    },
    p: function p(e, r) {
      5 & xi(r, 1)[0] && n !== (n = eo(_V("jse-editable-div", e[2], {
        "jse-short-text": e[0]
      })) + " svelte-rw77oa") && So(t, "class", n);
    },
    i: Bi,
    o: Bi,
    d: function d(n) {
      n && po(t), e[13](null), r = !1, Wi(i);
    }
  };
}
function GV(e, t, n) {
  var r,
    i = Na("jsoneditor:EditableDiv"),
    o = t.value,
    a = t.shortText,
    s = void 0 !== a && a,
    u = t.onChange,
    c = t.onCancel,
    l = t.onFind,
    f = t.onPaste,
    h = void 0 === f ? kc : f,
    d = t.onValueClass,
    v = void 0 === d ? function () {
      return "";
    } : d,
    p = v(o),
    m = !1;
  function g() {
    return function (e) {
      return e.replace(/\n$/, "");
    }(r.innerText);
  }
  function y(e) {
    n(1, r.innerText = jj(e), r);
  }
  return Jo(function () {
    i("onMount", {
      value: o
    }), y(o), setTimeout(function () {
      return Oj(r);
    });
  }), Ko(function () {
    var e = g();
    i("onDestroy", {
      closed: m,
      value: o,
      newValue: e
    }), m || e === o || u(e, vs);
  }), e.$$set = function (e) {
    "value" in e && n(7, o = e.value), "shortText" in e && n(0, s = e.shortText), "onChange" in e && n(8, u = e.onChange), "onCancel" in e && n(9, c = e.onCancel), "onFind" in e && n(10, l = e.onFind), "onPaste" in e && n(11, h = e.onPaste), "onValueClass" in e && n(12, v = e.onValueClass);
  }, [s, r, p, function () {
    var e = g();
    "" === e && y(""), n(2, p = v(e));
  }, function (e) {
    e.stopPropagation();
    var t = Dj(e).replace(/^Command\+/, "Ctrl+");
    if ("Escape" === t && (m = !0, c()), "Enter" === t || "Tab" === t) {
      m = !0;
      var n = g();
      u(n, ms);
    }
    "Ctrl+F" === t && (e.preventDefault(), l(!1)), "Ctrl+H" === t && (e.preventDefault(), l(!0));
  }, function (e) {
    if (h) {
      var t = e.clipboardData.getData("text/plain");
      h(t);
    }
  }, function () {
    var e = document.hasFocus(),
      t = g();
    i("handleBlur", {
      hasFocus: e,
      closed: m,
      value: o,
      newValue: t
    }), document.hasFocus() && !m && (m = !0, t !== o ? u(t, ps) : c());
  }, o, u, c, l, h, v, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(1, r = e);
    });
  }];
}
var QV = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, GV, KV, Ki, {
      value: 7,
      shortText: 0,
      onChange: 8,
      onCancel: 9,
      onFind: 10,
      onPaste: 11,
      onValueClass: 12
    }, JV), r;
  }
  return zi(n);
}();
function YV(e) {
  co(e, "svelte-566egb", '.jse-key.svelte-566egb{display:inline-block;min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;color:var(--jse-key-color);word-break:normal;overflow-wrap:normal;white-space:pre-wrap}.jse-key.svelte-566egb:hover{background:var(--jse-hover-background-color)}.jse-key.svelte-566egb:hover{background:var(--jse-hover-background-color)}.jse-key.jse-empty.svelte-566egb{min-width:3em;outline:1px dotted var(--jse-tag-background);-moz-outline-radius:2px}.jse-key.jse-empty.svelte-566egb::after{pointer-events:none;color:var(--jse-tag-background);content:"key"}');
}
function ZV(e) {
  var t,
    n,
    r,
    i,
    _o13,
    a,
    s,
    u = [tH, eH],
    c = [];
  function l(e, t) {
    return e[1] ? 0 : 1;
  }
  return n = l(e), r = c[n] = u[n](e), {
    c: function c() {
      t = go("div"), r.c(), So(t, "data-type", "selectable-key"), So(t, "class", i = eo(e[5](e[0])) + " svelte-566egb");
    },
    m: function m(r, i) {
      vo(r, t, i), c[n].m(t, null), _o13 = !0, a || (s = xo(t, "dblclick", e[4]), a = !0);
    },
    p: function p(e, a) {
      var s = n;
      (n = l(e)) === s ? c[n].p(e, a) : (ma(), ba(c[s], 1, 1, function () {
        c[s] = null;
      }), ga(), (r = c[n]) ? r.p(e, a) : (r = c[n] = u[n](e)).c(), ya(r, 1), r.m(t, null)), (!_o13 || 1 & a && i !== (i = eo(e[5](e[0])) + " svelte-566egb")) && So(t, "class", i);
    },
    i: function i(e) {
      _o13 || (ya(r), _o13 = !0);
    },
    o: function o(e) {
      ba(r), _o13 = !1;
    },
    d: function d(e) {
      e && po(t), c[n].d(), a = !1, s();
    }
  };
}
function XV(e) {
  var t, n;
  return t = new QV({
    props: {
      value: e[2].normalization.escapeValue(e[0]),
      shortText: !0,
      onChange: e[6],
      onCancel: e[7],
      onFind: e[2].onFind
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      5 & n && (r.value = e[2].normalization.escapeValue(e[0])), 4 & n && (r.onFind = e[2].onFind), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function eH(e) {
  var t,
    n = jj(e[2].normalization.escapeValue(e[0])) + "";
  return {
    c: function c() {
      t = bo(n);
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: function p(e, r) {
      5 & r && n !== (n = jj(e[2].normalization.escapeValue(e[0])) + "") && Ao(t, n);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function tH(e) {
  var t, n;
  return t = new UV({
    props: {
      text: e[2].normalization.escapeValue(e[0]),
      searchResult: e[1]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      5 & n && (r.text = e[2].normalization.escapeValue(e[0])), 2 & n && (r.searchResult = e[1]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function nH(e) {
  var t,
    n,
    r,
    _i19,
    o = [XV, ZV],
    a = [];
  function s(e, t) {
    return e[3] ? 0 : 1;
  }
  return t = s(e), n = a[t] = o[t](e), {
    c: function c() {
      n.c(), r = wo();
    },
    m: function m(e, n) {
      a[t].m(e, n), vo(e, r, n), _i19 = !0;
    },
    p: function p(e, i) {
      var u = xi(i, 1)[0],
        c = t;
      (t = s(e)) === c ? a[t].p(e, u) : (ma(), ba(a[c], 1, 1, function () {
        a[c] = null;
      }), ga(), (n = a[t]) ? n.p(e, u) : (n = a[t] = o[t](e)).c(), ya(n, 1), n.m(r.parentNode, r));
    },
    i: function i(e) {
      _i19 || (ya(n), _i19 = !0);
    },
    o: function o(e) {
      ba(n), _i19 = !1;
    },
    d: function d(e) {
      a[t].d(e), e && po(r);
    }
  };
}
function rH(e, t, n) {
  var r,
    i,
    o = t.path,
    a = t.key,
    s = t.onUpdateKey,
    u = t.selection,
    c = t.searchResult,
    l = t.context;
  return e.$$set = function (e) {
    "path" in e && n(8, o = e.path), "key" in e && n(0, a = e.key), "onUpdateKey" in e && n(9, s = e.onUpdateKey), "selection" in e && n(10, u = e.selection), "searchResult" in e && n(1, c = e.searchResult), "context" in e && n(2, l = e.context);
  }, e.$$.update = function () {
    1024 & e.$$.dirty && n(11, r = u && u.type === Hx), 3076 & e.$$.dirty && n(3, i = !l.readOnly && r && u && !0 === u.edit);
  }, [a, c, l, i, function (e) {
    i || l.readOnly || (e.preventDefault(), l.onSelect({
      type: Hx,
      path: o,
      edit: !0
    }));
  }, function (e) {
    return _V("jse-key", {
      "jse-empty": "" === e
    });
  }, function (e, t) {
    var n = s(a, l.normalization.unescapeValue(e)),
      r = _m(o).concat(n);
    t === ms && l.onSelect({
      type: Hx,
      path: r,
      next: !0
    }), t === ps && l.onSelect({
      type: Hx,
      path: r
    }, {
      ensureFocus: !1
    });
  }, function () {
    l.onSelect({
      type: Hx,
      path: o
    });
  }, o, s, u, r];
}
var iH = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, rH, nH, Ki, {
      path: 8,
      key: 0,
      onUpdateKey: 9,
      selection: 10,
      searchResult: 1,
      context: 2
    }, YV), r;
  }
  return zi(n);
}();
function oH(e, t, n) {
  var r = e.slice();
  return r[9] = t[n], r;
}
function aH(e) {
  var t,
    n,
    r,
    i = [e[9].props],
    o = e[9].component;
  function a(e) {
    for (var t = {}, n = 0; n < i.length; n += 1) {
      t = Fi(t, i[n]);
    }
    return {
      props: t
    };
  }
  return o && (t = new o(a())), {
    c: function c() {
      t && Aa(t.$$.fragment), n = wo();
    },
    m: function m(e, i) {
      t && Ea(t, e, i), vo(e, n, i), r = !0;
    },
    p: function p(e, r) {
      var s = 1 & r ? _a(i, [$a(e[9].props)]) : {};
      if (o !== (o = e[9].component)) {
        if (t) {
          ma();
          var u = t;
          ba(u.$$.fragment, 1, 0, function () {
            Pa(u, 1);
          }), ga();
        }
        o ? (Aa((t = new o(a())).$$.fragment), ya(t.$$.fragment, 1), Ea(t, n.parentNode, n)) : t = null;
      } else o && t.$set(s);
    },
    i: function i(e) {
      r || (t && ya(t.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      t && ba(t.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(n), t && Pa(t, e);
    }
  };
}
function sH(e) {
  for (var t, n, r = e[0], _i20 = [], o = 0; o < r.length; o += 1) {
    _i20[o] = aH(oH(e, r, o));
  }
  var a = function a(e) {
    return ba(_i20[e], 1, 1, function () {
      _i20[e] = null;
    });
  };
  return {
    c: function c() {
      for (var e = 0; e < _i20.length; e += 1) {
        _i20[e].c();
      }
      t = wo();
    },
    m: function m(e, r) {
      for (var o = 0; o < _i20.length; o += 1) {
        _i20[o].m(e, r);
      }
      vo(e, t, r), n = !0;
    },
    p: function p(e, n) {
      var o = xi(n, 1)[0];
      if (1 & o) {
        var s;
        for (r = e[0], s = 0; s < r.length; s += 1) {
          var u = oH(e, r, s);
          _i20[s] ? (_i20[s].p(u, o), ya(_i20[s], 1)) : (_i20[s] = aH(u), _i20[s].c(), ya(_i20[s], 1), _i20[s].m(t.parentNode, t));
        }
        for (ma(), s = r.length; s < _i20.length; s += 1) {
          a(s);
        }
        ga();
      }
    },
    i: function i(e) {
      if (!n) {
        for (var t = 0; t < r.length; t += 1) {
          ya(_i20[t]);
        }
        n = !0;
      }
    },
    o: function o(e) {
      _i20 = _i20.filter(Boolean);
      for (var t = 0; t < _i20.length; t += 1) {
        ba(_i20[t]);
      }
      n = !1;
    },
    d: function d(e) {
      mo(_i20, e), e && po(t);
    }
  };
}
function uH(e, t, n) {
  var r,
    i,
    o,
    a = t.path,
    s = t.value,
    u = t.context,
    c = t.enforceString,
    l = t.selection,
    f = t.searchResult;
  return e.$$set = function (e) {
    "path" in e && n(1, a = e.path), "value" in e && n(2, s = e.value), "context" in e && n(3, u = e.context), "enforceString" in e && n(4, c = e.enforceString), "selection" in e && n(5, l = e.selection), "searchResult" in e && n(6, f = e.searchResult);
  }, e.$$.update = function () {
    34 & e.$$.dirty && n(8, r = !(!l || l.type !== Wx) && Zm(l.focusPath, a)), 296 & e.$$.dirty && n(7, i = !u.readOnly && r && l && !0 === l.edit), 510 & e.$$.dirty && n(0, o = u.onRenderValue({
      path: a,
      value: s,
      readOnly: u.readOnly,
      enforceString: c,
      isSelected: r,
      isEditing: i,
      normalization: u.normalization,
      selection: l,
      searchResult: f,
      onPatch: u.onPatch,
      onPasteJson: u.onPasteJson,
      onSelect: u.onSelect,
      onFind: u.onFind
    }));
  }, [o, a, s, u, c, l, f, i, r];
}
var cH = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, uH, sH, Ki, {
        path: 1,
        value: 2,
        context: 3,
        enforceString: 4,
        selection: 5,
        searchResult: 6
      }), r;
    }
    return zi(n);
  }(),
  lH = {
    selecting: !1,
    selectionAnchor: null,
    selectionAnchorType: null,
    selectionFocus: null,
    dragging: !1
  };
function fH(e) {
  co(e, "svelte-r4omvg", ".jse-tooltip.svelte-r4omvg{font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;padding:calc(0.5 * var(--jse-padding)) var(--jse-padding);border-radius:3px;background:var(--jse-context-menu-background);color:var(--jse-context-menu-color);white-space:nowrap;box-shadow:var(--jse-controls-box-shadow)}");
}
function hH(e) {
  var t, n;
  return {
    c: function c() {
      t = go("div"), n = bo(e[0]), So(t, "class", "jse-tooltip svelte-r4omvg");
    },
    m: function m(e, r) {
      vo(e, t, r), uo(t, n);
    },
    p: function p(e, t) {
      1 & xi(t, 1)[0] && Ao(n, e[0]);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function dH(e, t, n) {
  var r = t.text;
  return e.$$set = function (e) {
    "text" in e && n(0, r = e.text);
  }, [r];
}
var vH = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, dH, hH, Ji, {
      text: 0
    }, fH), r;
  }
  return zi(n);
}();
function pH(e, t) {
  var n = t.text,
    r = t.openAbsolutePopup,
    i = t.closeAbsolutePopup;
  function o() {
    r(vH, {
      text: n
    }, {
      position: "top",
      width: 10 * n.length,
      offsetTop: 3,
      anchor: e,
      closeOnOuterClick: !0
    });
  }
  function a() {
    i();
  }
  return e.addEventListener("mouseover", o), e.addEventListener("mouseout", a), {
    destroy: function destroy() {
      e.removeEventListener("mouseover", o), e.removeEventListener("mouseout", a);
    }
  };
}
function mH(e) {
  co(e, "svelte-1q62mys", "button.jse-validation-error.svelte-1q62mys{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;color:var(--jse-warning-color);padding:0 5px;margin:0;font-size:var(--jse-font-size-mono);height:var(--jse-line-height);overflow:hidden}");
}
function gH(e) {
  var t, n, r, _i21, o, a;
  return n = new KS({
    props: {
      data: yS
    }
  }), {
    c: function c() {
      t = go("button"), Aa(n.$$.fragment), So(t, "type", "button"), So(t, "class", "jse-validation-error svelte-1q62mys");
    },
    m: function m(s, u) {
      vo(s, t, u), Ea(n, t, null), _i21 = !0, o || (a = [xo(t, "click", function () {
        Ui(e[0]) && e[0].apply(this, arguments);
      }), to(r = pH.call(null, t, Pi({
        text: e[1]
      }, e[2])))], o = !0);
    },
    p: function p(t, n) {
      var i = xi(n, 1)[0];
      e = t, r && Ui(r.update) && 2 & i && r.update.call(null, Pi({
        text: e[1]
      }, e[2]));
    },
    i: function i(e) {
      _i21 || (ya(n.$$.fragment, e), _i21 = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), _i21 = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), o = !1, Wi(a);
    }
  };
}
function yH(e, t, n) {
  var r,
    i = Yo("absolute-popup"),
    o = t.validationError,
    a = t.onExpand;
  return e.$$set = function (e) {
    "validationError" in e && n(3, o = e.validationError), "onExpand" in e && n(0, a = e.onExpand);
  }, e.$$.update = function () {
    8 & e.$$.dirty && n(1, r = o.isChildError ? "Contains invalid data" : o.message);
  }, [a, r, i, o];
}
var bH = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, yH, gH, Ji, {
      validationError: 3,
      onExpand: 0
    }, mH), r;
  }
  return zi(n);
}();
function kH(e) {
  var t = e.fullJson,
    n = e.fullState,
    r = e.fullSelection,
    i = e.deltaY,
    o = e.items,
    a = i < 0 ? function (e) {
      var t = e.items,
        n = e.fullSelection,
        r = e.deltaY,
        i = Kx(n),
        o = t.findIndex(function (e) {
          return Zm(e.path, i);
        }),
        a = function a() {
          var e;
          return null === (e = t[s - 1]) || void 0 === e ? void 0 : e.height;
        },
        s = o,
        u = 0;
      for (; void 0 !== a() && Math.abs(r) > u + a() / 2;) {
        u += a(), s -= 1;
      }
      var c = t[s].path,
        l = s - o;
      return s !== o && void 0 !== t[s] ? {
        beforePath: c,
        indexOffset: l
      } : void 0;
    }({
      fullSelection: r,
      deltaY: i,
      items: o
    }) : function (e) {
      var t,
        n = e.items,
        r = e.fullSelection,
        i = e.deltaY,
        o = Gx(r),
        a = n.findIndex(function (e) {
          return Zm(e.path, o);
        }),
        s = function s() {
          var e;
          return null === (e = n[c + 1]) || void 0 === e ? void 0 : e.height;
        },
        u = 0,
        c = a;
      for (; void 0 !== s() && Math.abs(i) > u + s() / 2;) {
        u += s(), c += 1;
      }
      var l = "number" == typeof Gv(o),
        f = null === (t = n[l ? c : c + 1]) || void 0 === t ? void 0 : t.path,
        h = c - a;
      return f ? {
        beforePath: f,
        indexOffset: h
      } : {
        append: !0,
        indexOffset: h
      };
    }({
      fullSelection: r,
      deltaY: i,
      items: o
    });
  if (!a || 0 === a.indexOffset) return {
    operations: void 0,
    updatedValue: void 0,
    updatedState: void 0,
    updatedSelection: void 0,
    updatedFullSelection: void 0,
    indexOffset: 0
  };
  var s = function (e, t, n, r) {
      var i = r.beforePath,
        o = r.append,
        a = _m(n.focusPath),
        s = ks.exports.getIn(e, a);
      if (o || i && oj(i, a) && i.length > a.length) {
        var u = n.paths ? Bp(n.paths) : n.focusPath,
          c = n.paths ? Gv(n.paths) : n.focusPath,
          l = Gv(u),
          f = Gv(c),
          h = i ? i[a.length] : void 0;
        if (!zs(s)) {
          var d = l,
            v = h;
          return Hk(f - d + 1, v < d ? function (e) {
            return {
              op: "move",
              from: ks.exports.compileJSONPointer(a.concat(d + e)),
              path: ks.exports.compileJSONPointer(a.concat(v + e))
            };
          } : function () {
            return {
              op: "move",
              from: ks.exports.compileJSONPointer(a.concat(d)),
              path: ks.exports.compileJSONPointer(a.concat(v))
            };
          });
        }
        var p = ks.exports.getIn(t, a.concat(ns)),
          m = p.indexOf(l),
          g = p.indexOf(f),
          y = o ? p.length : p.indexOf(h);
        if (-1 !== m && -1 !== g && -1 !== y) return y > m ? [].concat(Ii(p.slice(m, g + 1)), Ii(p.slice(y, p.length))).map(function (e) {
          return CF(a, e);
        }) : [].concat(Ii(p.slice(y, m)), Ii(p.slice(g + 1, p.length))).map(function (e) {
          return CF(a, e);
        });
      }
    }(t, n, r, a),
    u = Ox(t, n, s),
    c = _m(Kx(r)),
    l = ks.exports.getIn(t, c);
  if (Array.isArray(l)) {
    var f = function (e) {
        var t,
          n,
          r = e.items,
          i = e.fullJson,
          o = e.fullState,
          a = e.fullSelection,
          s = e.indexOffset,
          u = Kx(a),
          c = Gx(a),
          l = r.findIndex(function (e) {
            return Zm(e.path, u);
          }),
          f = r.findIndex(function (e) {
            return Zm(e.path, c);
          }),
          h = null === (t = r[l + s]) || void 0 === t ? void 0 : t.path,
          d = null === (n = r[f + s]) || void 0 === n ? void 0 : n.path;
        return sj(i, o, {
          type: Ux,
          anchorPath: h,
          focusPath: d
        });
      }({
        items: o,
        fullJson: t,
        fullState: n,
        fullSelection: r,
        indexOffset: a.indexOffset
      }),
      h = cj(t, f),
      d = ks.exports.getIn(h, c);
    return {
      operations: s,
      updatedValue: ks.exports.getIn(u.json, c),
      updatedState: ks.exports.getIn(u.state, c),
      updatedSelection: d,
      updatedFullSelection: f,
      indexOffset: a.indexOffset
    };
  }
  return {
    operations: s,
    updatedValue: ks.exports.getIn(u.json, c),
    updatedState: ks.exports.getIn(u.state, c),
    updatedSelection: void 0,
    updatedFullSelection: void 0,
    indexOffset: a.indexOffset
  };
}
function wH(e) {
  co(e, "svelte-uj4yd7", ".jse-json-node.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{position:relative;color:var(--jse-text-color)}.jse-json-node.jse-root.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{min-height:100%;padding-bottom:2px;box-sizing:border-box}.jse-json-node.jse-root.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7 .jse-context-menu-button,.jse-json-node.jse-root.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7 .jse-context-menu-button{top:0;right:calc(-2px - var(--jse-context-menu-button-size))}.jse-json-node.jse-root.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7.svelte-uj4yd7{padding-left:0}.jse-json-node.jse-hovered.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7,.jse-json-node.jse-hovered.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-hovered.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-hovered.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-hovered.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-hovered.svelte-uj4yd7 .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{background:var(--jse-hover-background-color)}.jse-json-node.svelte-uj4yd7 .jse-props.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.svelte-uj4yd7 .jse-items.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{position:relative}.jse-json-node.svelte-uj4yd7 .jse-header-outer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.svelte-uj4yd7 .jse-footer-outer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:flex}.jse-json-node.svelte-uj4yd7 .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{position:relative}.jse-json-node.svelte-uj4yd7 .jse-header .jse-meta.svelte-uj4yd7>.jse-meta-inner.svelte-uj4yd7.svelte-uj4yd7{display:flex;justify-content:center}.jse-json-node.svelte-uj4yd7 .jse-contents-outer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:flex}.jse-json-node.svelte-uj4yd7 .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.svelte-uj4yd7 .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:flex;flex-direction:row}.jse-json-node.svelte-uj4yd7 .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{padding-left:var(--jse-indent-size)}.jse-json-node.svelte-uj4yd7 .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:inline-flex;padding-left:calc(var(--jse-indent-size) + 5px)}.jse-json-node.svelte-uj4yd7 .jse-insert-selection-area.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{visibility:hidden;padding:0 calc(0.5 * var(--jse-padding));flex:1}.jse-json-node.svelte-uj4yd7 .jse-insert-selection-area.jse-inside.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:inline-flex;align-items:center}.jse-json-node.svelte-uj4yd7 .jse-insert-selection-area.jse-after.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:flex;align-items:flex-end}.jse-json-node.svelte-uj4yd7:hover>.jse-contents-outer .jse-insert-selection-area.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7:not(.jse-selected),.jse-json-node.svelte-uj4yd7 .jse-header-outer.svelte-uj4yd7:hover>.jse-insert-selection-area.svelte-uj4yd7.svelte-uj4yd7:not(.jse-selected),.jse-json-node.svelte-uj4yd7 .jse-footer-outer:hover .jse-insert-selection-area.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7:not(.jse-selected){visibility:visible;z-index:1}.jse-json-node.svelte-uj4yd7 .jse-context-menu-button-anchor.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{position:relative}.jse-json-node.svelte-uj4yd7 .jse-insert-area.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{display:flex;position:relative;max-width:250px;min-width:100px;height:0;margin-right:calc(0.5 * var(--jse-padding));outline:1px solid}.jse-json-node.svelte-uj4yd7 .jse-insert-area.svelte-uj4yd7 .jse-context-menu-button{right:-1px;background:var(--jse-selection-background-color)}.jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-hovered.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{outline-color:var(--jse-selection-background-color)}.jse-json-node.jse-selected.svelte-uj4yd7 .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-meta.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-value{background:var(--jse-selection-background-color) !important;cursor:grab}.jse-json-node.jse-selected.svelte-uj4yd7 .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{cursor:pointer}.jse-json-node.jse-selected-key.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7>.jse-identifier>.jse-key,.jse-json-node.jse-selected-key.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-identifier>.jse-key{background:var(--jse-selection-background-color);cursor:grab}.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7>.jse-value{background:var(--jse-selection-background-color);cursor:grab}.jse-json-node.svelte-uj4yd7 .jse-collapsed-items.jse-selected,.jse-json-node.jse-selected.svelte-uj4yd7 .jse-collapsed-items,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-collapsed-items{background-color:var(--jse-selection-background-color);cursor:grab;background-image:linear-gradient(var(--jse-collapsed-items-selected-background-color), var(--jse-collapsed-items-selected-background-color)), linear-gradient(to bottom right, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to bottom left, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to top right, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to top left, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%)}.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{background:var(--jse-selection-background-color) !important}.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7 .jse-value,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7 .jse-key,.jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7 .jse-value{background:var(--jse-selection-background-color);cursor:grab}.jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{z-index:2;outline-color:var(--jse-context-menu-button-background)}.jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7 .jse-context-menu-button{background:var(--jse-context-menu-button-background)}.jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7 .jse-context-menu-button:hover{background:var(--jse-context-menu-button-background-highlight)}.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-meta.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-value{background:var(--jse-selection-background-light-color) !important;cursor:grab}.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{cursor:pointer}.jse-main:not(.jse-focus) .jse-json-node.jse-selected-key.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7>.jse-identifier>.jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-key.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-identifier>.jse-key{background:var(--jse-selection-background-light-color);cursor:grab}.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-contents-outer.svelte-uj4yd7>.jse-contents.svelte-uj4yd7>.jse-value{background:var(--jse-selection-background-light-color);cursor:grab}.jse-main:not(.jse-focus) .jse-json-node.svelte-uj4yd7 .jse-collapsed-items.jse-selected,.jse-main:not(.jse-focus) .jse-json-node.jse-selected.svelte-uj4yd7 .jse-collapsed-items,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-collapsed-items{background-color:var(--jse-selection-background-light-color);cursor:grab;background-image:linear-gradient(var(--jse-collapsed-items-selected-background-color), var(--jse-collapsed-items-selected-background-color)), linear-gradient(to bottom right, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to bottom left, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to top right, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%), linear-gradient(to top left, transparent 50.5%, var(--jse-collapsed-items-selected-background-color) 50.5%)}.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{background:var(--jse-selection-background-light-color) !important}.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-meta.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-header-outer.svelte-uj4yd7>.jse-header.svelte-uj4yd7>.jse-meta.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7>.jse-footer-outer.svelte-uj4yd7>.jse-footer.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-contents.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-header.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-footer.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-props .jse-expand.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-contents.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-header.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-footer.svelte-uj4yd7 .jse-value,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7 .jse-key,.jse-main:not(.jse-focus) .jse-json-node.jse-selected-value.svelte-uj4yd7 .jse-items .jse-expand.svelte-uj4yd7 .jse-value{background:var(--jse-selection-background-light-color);cursor:grab}.jse-main:not(.jse-focus) .jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{z-index:2;outline-color:var(--jse-selection-background-color)}.jse-main:not(.jse-focus) .jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7 .jse-context-menu-button{background:var(--jse-selection-background-color)}.jse-main:not(.jse-focus) .jse-json-node.svelte-uj4yd7 .jse-insert-area.jse-selected.svelte-uj4yd7 .jse-context-menu-button:hover{background:var(--jse-selection-background-color)}.jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{width:var(--jse-indent-size);padding:0;margin:0;border:none;cursor:pointer;background:transparent;color:var(--jse-delimiter-color);font-size:var(--jse-font-size-mono);height:var(--jse-line-height)}.jse-expand.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7:hover{opacity:0.8}.jse-meta.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-separator.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-index.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7,.jse-bracket.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{vertical-align:top;color:var(--jse-delimiter-color)}.jse-index.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{padding:0 calc(0.5 * var(--jse-padding))}.jse-bracket.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{padding:0 2px}.jse-bracket.jse-expanded.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{padding-right:var(--jse-padding)}.jse-tag.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{border:none;font-size:80%;font-family:var(--jse-font-family);color:var(--jse-tag-color);background:var(--jse-tag-background);border-radius:2px;cursor:pointer;position:relative;display:inline-block;padding:0 4px;line-height:normal;margin:1px 0}.jse-tag.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7:hover{opacity:0.8}.jse-tag.jse-expanded.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{opacity:0.7;cursor:inherit}.jse-identifier.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7.svelte-uj4yd7{vertical-align:top;position:relative}");
}
var xH = function xH(e) {
    return {};
  },
  jH = function jH(e) {
    return {};
  };
function SH(e, t, n) {
  var r = e.slice();
  return r[57] = t[n], r;
}
var CH = function CH(e) {
    return {};
  },
  _H = function _H(e) {
    return {};
  };
function $H(e, t, n) {
  var r = e.slice();
  return r[51] = t[n], r[53] = n, r;
}
function OH(e, t, n) {
  var r = e.slice();
  return r[54] = t[n], r[56] = n, r;
}
var AH = function AH(e) {
    return {};
  },
  EH = function EH(e) {
    return {};
  };
function PH(e) {
  var t,
    n,
    r,
    i,
    _o14,
    a,
    s,
    u,
    c,
    l = !e[4].readOnly && e[7] && (e[7].type === Wx || e[7].type === Ux) && !e[7].edit && Zm(e[7].focusPath, e[1]),
    f = e[39].identifier,
    h = Gi(f, e, e[40], jH),
    _d6 = !e[10] && TH();
  _o14 = new cH({
    props: {
      path: e[1],
      value: e[0],
      enforceString: e[5] ? e[5][os] : void 0,
      selection: e[7],
      searchResult: e[2] ? e[2][is] : void 0,
      context: e[4]
    }
  });
  var v = l && NH(e),
    _p6 = e[15] && RH(e),
    _m7 = !e[10] && DH(e);
  return {
    c: function c() {
      t = go("div"), n = go("div"), h && h.c(), r = ko(), _d6 && _d6.c(), i = ko(), Aa(_o14.$$.fragment), a = ko(), v && v.c(), s = ko(), _p6 && _p6.c(), u = ko(), _m7 && _m7.c(), So(n, "class", "jse-contents svelte-uj4yd7"), So(t, "class", "jse-contents-outer svelte-uj4yd7"), So(t, "style", e[13]);
    },
    m: function m(e, l) {
      vo(e, t, l), uo(t, n), h && h.m(n, null), uo(n, r), _d6 && _d6.m(n, null), uo(n, i), Ea(_o14, n, null), uo(n, a), v && v.m(n, null), uo(t, s), _p6 && _p6.m(t, null), uo(t, u), _m7 && _m7.m(t, null), c = !0;
    },
    p: function p(e, r) {
      h && h.p && (!c || 512 & r[1]) && Zi(h, f, e, e[40], c ? Yi(f, e[40], r, xH) : Xi(e[40]), jH), e[10] ? _d6 && (_d6.d(1), _d6 = null) : _d6 || ((_d6 = TH()).c(), _d6.m(n, i));
      var a = {};
      2 & r[0] && (a.path = e[1]), 1 & r[0] && (a.value = e[0]), 32 & r[0] && (a.enforceString = e[5] ? e[5][os] : void 0), 128 & r[0] && (a.selection = e[7]), 4 & r[0] && (a.searchResult = e[2] ? e[2][is] : void 0), 16 & r[0] && (a.context = e[4]), _o14.$set(a), 146 & r[0] && (l = !e[4].readOnly && e[7] && (e[7].type === Wx || e[7].type === Ux) && !e[7].edit && Zm(e[7].focusPath, e[1])), l ? v ? (v.p(e, r), 146 & r[0] && ya(v, 1)) : ((v = NH(e)).c(), ya(v, 1), v.m(n, null)) : v && (ma(), ba(v, 1, 1, function () {
        v = null;
      }), ga()), e[15] ? _p6 ? (_p6.p(e, r), 32768 & r[0] && ya(_p6, 1)) : ((_p6 = RH(e)).c(), ya(_p6, 1), _p6.m(t, u)) : _p6 && (ma(), ba(_p6, 1, 1, function () {
        _p6 = null;
      }), ga()), e[10] ? _m7 && (_m7.d(1), _m7 = null) : _m7 ? _m7.p(e, r) : ((_m7 = DH(e)).c(), _m7.m(t, null)), (!c || 8192 & r[0]) && So(t, "style", e[13]);
    },
    i: function i(e) {
      c || (ya(h, e), ya(_o14.$$.fragment, e), ya(v), ya(_p6), c = !0);
    },
    o: function o(e) {
      ba(h, e), ba(_o14.$$.fragment, e), ba(v), ba(_p6), c = !1;
    },
    d: function d(e) {
      e && po(t), h && h.d(e), _d6 && _d6.d(), Pa(_o14), v && v.d(), _p6 && _p6.d(), _m7 && _m7.d();
    }
  };
}
function MH(e) {
  var t,
    n,
    r,
    i,
    _o15,
    a,
    s,
    u,
    _c11,
    l,
    f,
    h,
    d,
    v,
    _p7,
    _m8,
    g,
    y,
    b = !e[4].readOnly && e[7] && (e[7].type === Wx || e[7].type === Ux) && !e[7].edit && Zm(e[7].focusPath, e[1]),
    k = [LH, zH],
    w = [];
  function x(e, t) {
    return e[12] ? 0 : 1;
  }
  i = x(e), _o15 = w[i] = k[i](e);
  var j = e[39].identifier,
    S = Gi(j, e, e[40], _H),
    C = !e[10] && BH();
  function _(e, t) {
    return e[12] ? FH : qH;
  }
  var $ = _(e),
    O = $(e),
    A = b && VH(e),
    E = e[15] && (!e[12] || !e[15].isChildError) && HH(e);
  function P(e, t) {
    return e[12] ? UH : e[10] ? void 0 : WH;
  }
  var M = P(e),
    I = M && M(e),
    T = e[12] && JH(e);
  return {
    c: function c() {
      t = go("div"), n = go("div"), r = go("button"), _o15.c(), a = ko(), S && S.c(), s = ko(), C && C.c(), u = ko(), _c11 = go("div"), l = go("div"), O.c(), f = ko(), A && A.c(), h = ko(), E && E.c(), d = ko(), I && I.c(), v = ko(), T && T.c(), _p7 = wo(), So(r, "type", "button"), So(r, "class", "jse-expand svelte-uj4yd7"), So(r, "title", "Expand or collapse this object (Ctrl+Click to expand/collapse recursively)"), So(l, "class", "jse-meta-inner svelte-uj4yd7"), So(_c11, "class", "jse-meta svelte-uj4yd7"), So(_c11, "data-type", "selectable-value"), So(n, "class", "jse-header svelte-uj4yd7"), So(t, "class", "jse-header-outer svelte-uj4yd7"), So(t, "style", e[13]);
    },
    m: function m(o, b) {
      vo(o, t, b), uo(t, n), uo(n, r), w[i].m(r, null), uo(n, a), S && S.m(n, null), uo(n, s), C && C.m(n, null), uo(n, u), uo(n, _c11), uo(_c11, l), O.m(l, null), uo(n, f), A && A.m(n, null), uo(t, h), E && E.m(t, null), uo(t, d), I && I.m(t, null), vo(o, v, b), T && T.m(o, b), vo(o, _p7, b), _m8 = !0, g || (y = xo(r, "click", e[23]), g = !0);
    },
    p: function p(e, a) {
      var s = i;
      (i = x(e)) === s ? w[i].p(e, a) : (ma(), ba(w[s], 1, 1, function () {
        w[s] = null;
      }), ga(), (_o15 = w[i]) ? _o15.p(e, a) : (_o15 = w[i] = k[i](e)).c(), ya(_o15, 1), _o15.m(r, null)), S && S.p && (!_m8 || 512 & a[1]) && Zi(S, j, e, e[40], _m8 ? Yi(j, e[40], a, CH) : Xi(e[40]), _H), e[10] ? C && (C.d(1), C = null) : C || ((C = BH()).c(), C.m(n, u)), $ === ($ = _(e)) && O ? O.p(e, a) : (O.d(1), (O = $(e)) && (O.c(), O.m(l, null))), 146 & a[0] && (b = !e[4].readOnly && e[7] && (e[7].type === Wx || e[7].type === Ux) && !e[7].edit && Zm(e[7].focusPath, e[1])), b ? A ? (A.p(e, a), 146 & a[0] && ya(A, 1)) : ((A = VH(e)).c(), ya(A, 1), A.m(n, null)) : A && (ma(), ba(A, 1, 1, function () {
        A = null;
      }), ga()), !e[15] || e[12] && e[15].isChildError ? E && (ma(), ba(E, 1, 1, function () {
        E = null;
      }), ga()) : E ? (E.p(e, a), 36864 & a[0] && ya(E, 1)) : ((E = HH(e)).c(), ya(E, 1), E.m(t, d)), M === (M = P(e)) && I ? I.p(e, a) : (I && I.d(1), (I = M && M(e)) && (I.c(), I.m(t, null))), (!_m8 || 8192 & a[0]) && So(t, "style", e[13]), e[12] ? T ? (T.p(e, a), 4096 & a[0] && ya(T, 1)) : ((T = JH(e)).c(), ya(T, 1), T.m(_p7.parentNode, _p7)) : T && (ma(), ba(T, 1, 1, function () {
        T = null;
      }), ga());
    },
    i: function i(e) {
      _m8 || (ya(_o15), ya(S, e), ya(A), ya(E), ya(T), _m8 = !0);
    },
    o: function o(e) {
      ba(_o15), ba(S, e), ba(A), ba(E), ba(T), _m8 = !1;
    },
    d: function d(e) {
      e && po(t), w[i].d(), S && S.d(e), C && C.d(), O.d(), A && A.d(), E && E.d(), I && I.d(), e && po(v), T && T.d(e), e && po(_p7), g = !1, y();
    }
  };
}
function IH(e) {
  var t,
    n,
    r,
    i,
    _o16,
    a,
    s,
    u,
    _c12,
    l,
    f,
    h,
    d,
    v,
    _p8,
    _m9,
    g,
    y,
    b = !e[4].readOnly && e[7] && (e[7].type === Wx || e[7].type === Ux) && !e[7].edit && Zm(e[7].focusPath, e[1]),
    k = [eW, XH],
    w = [];
  function x(e, t) {
    return e[12] ? 0 : 1;
  }
  i = x(e), _o16 = w[i] = k[i](e);
  var j = e[39].identifier,
    S = Gi(j, e, e[40], EH),
    C = !e[10] && tW();
  function _(e, t) {
    return e[12] ? rW : nW;
  }
  var $ = _(e),
    O = $(e),
    A = b && iW(e),
    E = e[15] && (!e[12] || !e[15].isChildError) && oW(e);
  function P(e, t) {
    return e[12] ? sW : aW;
  }
  var M = P(e),
    I = M(e),
    T = e[12] && uW(e);
  return {
    c: function c() {
      t = go("div"), n = go("div"), r = go("button"), _o16.c(), a = ko(), S && S.c(), s = ko(), C && C.c(), u = ko(), _c12 = go("div"), l = go("div"), O.c(), f = ko(), A && A.c(), h = ko(), E && E.c(), d = ko(), I.c(), v = ko(), T && T.c(), _p8 = wo(), So(r, "type", "button"), So(r, "class", "jse-expand svelte-uj4yd7"), So(r, "title", "Expand or collapse this array (Ctrl+Click to expand/collapse recursively)"), So(l, "class", "jse-meta-inner svelte-uj4yd7"), So(l, "data-type", "selectable-value"), So(_c12, "class", "jse-meta svelte-uj4yd7"), So(n, "class", "jse-header svelte-uj4yd7"), So(t, "class", "jse-header-outer svelte-uj4yd7"), So(t, "style", e[13]);
    },
    m: function m(o, b) {
      vo(o, t, b), uo(t, n), uo(n, r), w[i].m(r, null), uo(n, a), S && S.m(n, null), uo(n, s), C && C.m(n, null), uo(n, u), uo(n, _c12), uo(_c12, l), O.m(l, null), uo(n, f), A && A.m(n, null), uo(t, h), E && E.m(t, null), uo(t, d), I.m(t, null), vo(o, v, b), T && T.m(o, b), vo(o, _p8, b), _m9 = !0, g || (y = xo(r, "click", e[23]), g = !0);
    },
    p: function p(e, a) {
      var s = i;
      (i = x(e)) === s ? w[i].p(e, a) : (ma(), ba(w[s], 1, 1, function () {
        w[s] = null;
      }), ga(), (_o16 = w[i]) ? _o16.p(e, a) : (_o16 = w[i] = k[i](e)).c(), ya(_o16, 1), _o16.m(r, null)), S && S.p && (!_m9 || 512 & a[1]) && Zi(S, j, e, e[40], _m9 ? Yi(j, e[40], a, AH) : Xi(e[40]), EH), e[10] ? C && (C.d(1), C = null) : C || ((C = tW()).c(), C.m(n, u)), $ === ($ = _(e)) && O ? O.p(e, a) : (O.d(1), (O = $(e)) && (O.c(), O.m(l, null))), 146 & a[0] && (b = !e[4].readOnly && e[7] && (e[7].type === Wx || e[7].type === Ux) && !e[7].edit && Zm(e[7].focusPath, e[1])), b ? A ? (A.p(e, a), 146 & a[0] && ya(A, 1)) : ((A = iW(e)).c(), ya(A, 1), A.m(n, null)) : A && (ma(), ba(A, 1, 1, function () {
        A = null;
      }), ga()), !e[15] || e[12] && e[15].isChildError ? E && (ma(), ba(E, 1, 1, function () {
        E = null;
      }), ga()) : E ? (E.p(e, a), 36864 & a[0] && ya(E, 1)) : ((E = oW(e)).c(), ya(E, 1), E.m(t, d)), M === (M = P(e)) && I ? I.p(e, a) : (I.d(1), (I = M(e)) && (I.c(), I.m(t, null))), (!_m9 || 8192 & a[0]) && So(t, "style", e[13]), e[12] ? T ? (T.p(e, a), 4096 & a[0] && ya(T, 1)) : ((T = uW(e)).c(), ya(T, 1), T.m(_p8.parentNode, _p8)) : T && (ma(), ba(T, 1, 1, function () {
        T = null;
      }), ga());
    },
    i: function i(e) {
      _m9 || (ya(_o16), ya(S, e), ya(A), ya(E), ya(T), _m9 = !0);
    },
    o: function o(e) {
      ba(_o16), ba(S, e), ba(A), ba(E), ba(T), _m9 = !1;
    },
    d: function d(e) {
      e && po(t), w[i].d(), S && S.d(e), C && C.d(), O.d(), A && A.d(), E && E.d(), I.d(), e && po(v), T && T.d(e), e && po(_p8), g = !1, y();
    }
  };
}
function TH(e) {
  var t;
  return {
    c: function c() {
      (t = go("div")).textContent = ":", So(t, "class", "jse-separator svelte-uj4yd7");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function NH(e) {
  var t, n, r;
  return n = new zV({
    props: {
      selected: !0,
      onContextMenu: e[4].onContextMenu
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), So(t, "class", "jse-context-menu-button-anchor svelte-uj4yd7");
    },
    m: function m(e, i) {
      vo(e, t, i), Ea(n, t, null), r = !0;
    },
    p: function p(e, t) {
      var r = {};
      16 & t[0] && (r.onContextMenu = e[4].onContextMenu), n.$set(r);
    },
    i: function i(e) {
      r || (ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n);
    }
  };
}
function RH(e) {
  var t, n;
  return t = new bH({
    props: {
      validationError: e[15],
      onExpand: e[24]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      32768 & n[0] && (r.validationError = e[15]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function DH(e) {
  var t, n, r;
  return {
    c: function c() {
      So(t = go("div"), "class", "jse-insert-selection-area jse-after svelte-uj4yd7"), So(t, "data-type", "insert-selection-area-after");
    },
    m: function m(i, o) {
      vo(i, t, o), n || (r = xo(t, "click", e[32]), n = !0);
    },
    p: Bi,
    d: function d(e) {
      e && po(t), n = !1, r();
    }
  };
}
function zH(e) {
  var t, n;
  return t = new KS({
    props: {
      data: eS
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: Bi,
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function LH(e) {
  var t, n;
  return t = new KS({
    props: {
      data: Xj
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: Bi,
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function BH(e) {
  var t;
  return {
    c: function c() {
      (t = go("div")).textContent = ":", So(t, "class", "jse-separator svelte-uj4yd7");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function qH(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f = Object.keys(e[6]).length + "",
    h = 1 === Object.keys(e[6]).length ? "prop" : "props";
  return {
    c: function c() {
      (t = go("div")).textContent = "{", n = ko(), r = go("button"), i = bo(f), o = ko(), a = bo(h), s = ko(), (u = go("div")).textContent = "}", So(t, "class", "jse-bracket svelte-uj4yd7"), So(r, "type", "button"), So(r, "class", "jse-tag svelte-uj4yd7"), So(u, "class", "jse-bracket svelte-uj4yd7");
    },
    m: function m(f, h) {
      vo(f, t, h), vo(f, n, h), vo(f, r, h), uo(r, i), uo(r, o), uo(r, a), vo(f, s, h), vo(f, u, h), c || (l = xo(r, "click", e[24]), c = !0);
    },
    p: function p(e, t) {
      64 & t[0] && f !== (f = Object.keys(e[6]).length + "") && Ao(i, f), 64 & t[0] && h !== (h = 1 === Object.keys(e[6]).length ? "prop" : "props") && Ao(a, h);
    },
    d: function d(e) {
      e && po(t), e && po(n), e && po(r), e && po(s), e && po(u), c = !1, l();
    }
  };
}
function FH(e) {
  var t;
  return {
    c: function c() {
      (t = go("div")).textContent = "{", So(t, "class", "jse-bracket jse-expanded svelte-uj4yd7");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function VH(e) {
  var t, n, r;
  return n = new zV({
    props: {
      selected: !0,
      onContextMenu: e[4].onContextMenu
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), So(t, "class", "jse-context-menu-button-anchor svelte-uj4yd7");
    },
    m: function m(e, i) {
      vo(e, t, i), Ea(n, t, null), r = !0;
    },
    p: function p(e, t) {
      var r = {};
      16 & t[0] && (r.onContextMenu = e[4].onContextMenu), n.$set(r);
    },
    i: function i(e) {
      r || (ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n);
    }
  };
}
function HH(e) {
  var t, n;
  return t = new bH({
    props: {
      validationError: e[15],
      onExpand: e[24]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      32768 & n[0] && (r.validationError = e[15]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function WH(e) {
  var t, n, r;
  return {
    c: function c() {
      So(t = go("div"), "class", "jse-insert-selection-area jse-after svelte-uj4yd7"), So(t, "data-type", "insert-selection-area-after");
    },
    m: function m(i, o) {
      vo(i, t, o), n || (r = xo(t, "click", e[32]), n = !0);
    },
    p: Bi,
    d: function d(e) {
      e && po(t), n = !1, r();
    }
  };
}
function UH(e) {
  var t, n, r;
  return {
    c: function c() {
      So(t = go("div"), "class", "jse-insert-selection-area jse-inside svelte-uj4yd7"), So(t, "data-type", "insert-selection-area-inside");
    },
    m: function m(i, o) {
      vo(i, t, o), n || (r = xo(t, "click", e[31]), n = !0);
    },
    p: Bi,
    d: function d(e) {
      e && po(t), n = !1, r();
    }
  };
}
function JH(e) {
  for (var t, n, r, i, o, a, s, u = [], c = new Map(), l = !e[4].readOnly && ("hover-insert-inside" === e[9] || e[19]) && KH(e), f = e[11], h = function h(e) {
      return e[5][e[57]][Xa];
    }, d = 0; d < f.length; d += 1) {
    var v = SH(e, f, d),
      p = h(v);
    c.set(p, u[d] = YH(p, v));
  }
  var _m10 = !e[10] && ZH(e);
  return {
    c: function c() {
      t = go("div"), l && l.c(), n = ko();
      for (var s = 0; s < u.length; s += 1) {
        u[s].c();
      }
      r = ko(), i = go("div"), (o = go("div")).innerHTML = '<div class="jse-bracket svelte-uj4yd7">}</div>', a = ko(), _m10 && _m10.c(), So(t, "class", "jse-props svelte-uj4yd7"), So(o, "data-type", "selectable-value"), So(o, "class", "jse-footer svelte-uj4yd7"), So(i, "class", "jse-footer-outer svelte-uj4yd7"), So(i, "style", e[13]);
    },
    m: function m(e, c) {
      vo(e, t, c), l && l.m(t, null), uo(t, n);
      for (var f = 0; f < u.length; f += 1) {
        u[f].m(t, null);
      }
      vo(e, r, c), vo(e, i, c), uo(i, o), uo(i, a), _m10 && _m10.m(i, null), s = !0;
    },
    p: function p(e, r) {
      e[4].readOnly || "hover-insert-inside" !== e[9] && !e[19] ? l && (ma(), ba(l, 1, 1, function () {
        l = null;
      }), ga()) : l ? (l.p(e, r), 524816 & r[0] && ya(l, 1)) : ((l = KH(e)).c(), ya(l, 1), l.m(t, n)), 306186622 & r[0] && (f = e[11], ma(), u = Ca(u, r, h, 1, e, f, c, t, Sa, YH, null, SH), ga()), e[10] ? _m10 && (_m10.d(1), _m10 = null) : _m10 ? _m10.p(e, r) : ((_m10 = ZH(e)).c(), _m10.m(i, null)), (!s || 8192 & r[0]) && So(i, "style", e[13]);
    },
    i: function i(e) {
      if (!s) {
        ya(l);
        for (var t = 0; t < f.length; t += 1) {
          ya(u[t]);
        }
        s = !0;
      }
    },
    o: function o(e) {
      ba(l);
      for (var t = 0; t < u.length; t += 1) {
        ba(u[t]);
      }
      s = !1;
    },
    d: function d(e) {
      e && po(t), l && l.d();
      for (var n = 0; n < u.length; n += 1) {
        u[n].d();
      }
      e && po(r), e && po(i), _m10 && _m10.d();
    }
  };
}
function KH(e) {
  var t, n, r, _i22;
  return n = new zV({
    props: {
      selected: e[19],
      onContextMenu: e[33]
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), So(t, "class", "jse-insert-area jse-inside svelte-uj4yd7"), So(t, "data-type", "insert-selection-area-inside"), So(t, "style", r = gW(e[1].length + 1)), So(t, "title", hs), To(t, "jse-hovered", "hover-insert-inside" === e[9]), To(t, "jse-selected", e[19]);
    },
    m: function m(e, r) {
      vo(e, t, r), Ea(n, t, null), _i22 = !0;
    },
    p: function p(e, o) {
      var a = {};
      524288 & o[0] && (a.selected = e[19]), n.$set(a), (!_i22 || 2 & o[0] && r !== (r = gW(e[1].length + 1))) && So(t, "style", r), 512 & o[0] && To(t, "jse-hovered", "hover-insert-inside" === e[9]), 524288 & o[0] && To(t, "jse-selected", e[19]);
    },
    i: function i(e) {
      _i22 || (ya(n.$$.fragment, e), _i22 = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), _i22 = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n);
    }
  };
}
function GH(e) {
  var t, n;
  return t = new zV({
    props: {
      selected: !0,
      onContextMenu: e[4].onContextMenu
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      16 & n[0] && (r.onContextMenu = e[4].onContextMenu), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function QH(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    c,
    l = !e[4].readOnly && fj(e[1], e[57], e[8]);
  a = new iH({
    props: {
      path: e[22](e[1].concat(e[57])),
      key: e[57],
      context: e[4],
      selection: null === (t = e[8]) || void 0 === t || null === (n = t[e[57]]) || void 0 === n ? void 0 : n[as],
      searchResult: null === (r = e[2]) || void 0 === r || null === (i = r[e[57]]) || void 0 === i ? void 0 : i[rs],
      onUpdateKey: e[25]
    }
  });
  var f = l && GH(e);
  return {
    c: function c() {
      o = go("div"), Aa(a.$$.fragment), s = ko(), f && f.c(), u = ko(), So(o, "slot", "identifier"), So(o, "class", "jse-identifier svelte-uj4yd7");
    },
    m: function m(e, t) {
      vo(e, o, t), Ea(a, o, null), uo(o, s), f && f.m(o, null), uo(o, u), c = !0;
    },
    p: function p(e, t) {
      var n,
        r,
        i,
        s,
        c = {};
      2050 & t[0] && (c.path = e[22](e[1].concat(e[57]))), 2048 & t[0] && (c.key = e[57]), 16 & t[0] && (c.context = e[4]), 2304 & t[0] && (c.selection = null === (n = e[8]) || void 0 === n || null === (r = n[e[57]]) || void 0 === r ? void 0 : r[as]), 2052 & t[0] && (c.searchResult = null === (i = e[2]) || void 0 === i || null === (s = i[e[57]]) || void 0 === s ? void 0 : s[rs]), a.$set(c), 2322 & t[0] && (l = !e[4].readOnly && fj(e[1], e[57], e[8])), l ? f ? (f.p(e, t), 2322 & t[0] && ya(f, 1)) : ((f = GH(e)).c(), ya(f, 1), f.m(o, u)) : f && (ma(), ba(f, 1, 1, function () {
        f = null;
      }), ga());
    },
    i: function i(e) {
      c || (ya(a.$$.fragment, e), ya(f), c = !0);
    },
    o: function o(e) {
      ba(a.$$.fragment, e), ba(f), c = !1;
    },
    d: function d(e) {
      e && po(o), Pa(a), f && f.d();
    }
  };
}
function YH(e, t) {
  var n, r, _i23;
  return r = new bW({
    props: {
      value: t[6][t[57]],
      path: t[22](t[1].concat(t[57])),
      state: t[5][t[57]],
      selection: t[8] ? t[8][t[57]] : void 0,
      searchResult: t[2] ? t[2][t[57]] : void 0,
      validationErrors: t[3] ? t[3][t[57]] : void 0,
      context: t[4],
      onDragSelectionStart: t[28],
      $$slots: {
        identifier: [QH]
      },
      $$scope: {
        ctx: t
      }
    }
  }), {
    key: e,
    first: null,
    c: function c() {
      n = wo(), Aa(r.$$.fragment), this.first = n;
    },
    m: function m(e, t) {
      vo(e, n, t), Ea(r, e, t), _i23 = !0;
    },
    p: function p(e, n) {
      t = e;
      var i = {};
      2112 & n[0] && (i.value = t[6][t[57]]), 2050 & n[0] && (i.path = t[22](t[1].concat(t[57]))), 2080 & n[0] && (i.state = t[5][t[57]]), 2304 & n[0] && (i.selection = t[8] ? t[8][t[57]] : void 0), 2052 & n[0] && (i.searchResult = t[2] ? t[2][t[57]] : void 0), 2056 & n[0] && (i.validationErrors = t[3] ? t[3][t[57]] : void 0), 16 & n[0] && (i.context = t[4]), 2326 & n[0] | 512 & n[1] && (i.$$scope = {
        dirty: n,
        ctx: t
      }), r.$set(i);
    },
    i: function i(e) {
      _i23 || (ya(r.$$.fragment, e), _i23 = !0);
    },
    o: function o(e) {
      ba(r.$$.fragment, e), _i23 = !1;
    },
    d: function d(e) {
      e && po(n), Pa(r, e);
    }
  };
}
function ZH(e) {
  var t, n, r;
  return {
    c: function c() {
      So(t = go("div"), "class", "jse-insert-selection-area jse-after svelte-uj4yd7"), So(t, "data-type", "insert-selection-area-after");
    },
    m: function m(i, o) {
      vo(i, t, o), n || (r = xo(t, "click", e[32]), n = !0);
    },
    p: Bi,
    d: function d(e) {
      e && po(t), n = !1, r();
    }
  };
}
function XH(e) {
  var t, n;
  return t = new KS({
    props: {
      data: eS
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: Bi,
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function eW(e) {
  var t, n;
  return t = new KS({
    props: {
      data: Xj
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: Bi,
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function tW(e) {
  var t;
  return {
    c: function c() {
      (t = go("div")).textContent = ":", So(t, "class", "jse-separator svelte-uj4yd7");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function nW(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f = e[6].length + "",
    h = 1 === e[6].length ? "item" : "items";
  return {
    c: function c() {
      (t = go("div")).textContent = "[", n = ko(), r = go("button"), i = bo(f), o = ko(), a = bo(h), s = ko(), (u = go("div")).textContent = "]", So(t, "class", "jse-bracket svelte-uj4yd7"), So(r, "type", "button"), So(r, "class", "jse-tag svelte-uj4yd7"), So(u, "class", "jse-bracket svelte-uj4yd7");
    },
    m: function m(f, h) {
      vo(f, t, h), vo(f, n, h), vo(f, r, h), uo(r, i), uo(r, o), uo(r, a), vo(f, s, h), vo(f, u, h), c || (l = xo(r, "click", e[24]), c = !0);
    },
    p: function p(e, t) {
      64 & t[0] && f !== (f = e[6].length + "") && Ao(i, f), 64 & t[0] && h !== (h = 1 === e[6].length ? "item" : "items") && Ao(a, h);
    },
    d: function d(e) {
      e && po(t), e && po(n), e && po(r), e && po(s), e && po(u), c = !1, l();
    }
  };
}
function rW(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s = e[6].length + "",
    u = 1 === e[6].length ? "item" : "items";
  return {
    c: function c() {
      (t = go("div")).textContent = "[", n = ko(), r = go("span"), i = bo(s), o = ko(), a = bo(u), So(t, "class", "jse-bracket svelte-uj4yd7"), So(r, "class", "jse-tag jse-expanded svelte-uj4yd7");
    },
    m: function m(e, s) {
      vo(e, t, s), vo(e, n, s), vo(e, r, s), uo(r, i), uo(r, o), uo(r, a);
    },
    p: function p(e, t) {
      64 & t[0] && s !== (s = e[6].length + "") && Ao(i, s), 64 & t[0] && u !== (u = 1 === e[6].length ? "item" : "items") && Ao(a, u);
    },
    d: function d(e) {
      e && po(t), e && po(n), e && po(r);
    }
  };
}
function iW(e) {
  var t, n, r;
  return n = new zV({
    props: {
      selected: !0,
      onContextMenu: e[4].onContextMenu
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), So(t, "class", "jse-context-menu-button-anchor svelte-uj4yd7");
    },
    m: function m(e, i) {
      vo(e, t, i), Ea(n, t, null), r = !0;
    },
    p: function p(e, t) {
      var r = {};
      16 & t[0] && (r.onContextMenu = e[4].onContextMenu), n.$set(r);
    },
    i: function i(e) {
      r || (ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n);
    }
  };
}
function oW(e) {
  var t, n;
  return t = new bH({
    props: {
      validationError: e[15],
      onExpand: e[24]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      32768 & n[0] && (r.validationError = e[15]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function aW(e) {
  var t, n, r;
  return {
    c: function c() {
      So(t = go("div"), "class", "jse-insert-selection-area jse-after svelte-uj4yd7"), So(t, "data-type", "insert-selection-area-after");
    },
    m: function m(i, o) {
      vo(i, t, o), n || (r = xo(t, "click", e[32]), n = !0);
    },
    p: Bi,
    d: function d(e) {
      e && po(t), n = !1, r();
    }
  };
}
function sW(e) {
  var t, n, r;
  return {
    c: function c() {
      So(t = go("div"), "class", "jse-insert-selection-area jse-inside svelte-uj4yd7"), So(t, "data-type", "insert-selection-area-inside");
    },
    m: function m(i, o) {
      vo(i, t, o), n || (r = xo(t, "click", e[31]), n = !0);
    },
    p: Bi,
    d: function d(e) {
      e && po(t), n = !1, r();
    }
  };
}
function uW(e) {
  for (var t, n, r, i, o, a, s, u = [], c = new Map(), l = !e[4].readOnly && ("hover-insert-inside" === e[9] || e[19]) && cW(e), f = e[16], h = function h(e) {
      return e[53];
    }, d = 0; d < f.length; d += 1) {
    var v = $H(e, f, d),
      p = h(v);
    c.set(p, u[d] = dW(p, v));
  }
  var _m11 = !e[10] && vW(e);
  return {
    c: function c() {
      t = go("div"), l && l.c(), n = ko();
      for (var s = 0; s < u.length; s += 1) {
        u[s].c();
      }
      r = ko(), i = go("div"), (o = go("div")).innerHTML = '<span class="jse-bracket svelte-uj4yd7">]</span>', a = ko(), _m11 && _m11.c(), So(t, "class", "jse-items svelte-uj4yd7"), So(o, "data-type", "selectable-value"), So(o, "class", "jse-footer svelte-uj4yd7"), So(i, "class", "jse-footer-outer svelte-uj4yd7"), So(i, "style", e[13]);
    },
    m: function m(e, c) {
      vo(e, t, c), l && l.m(t, null), uo(t, n);
      for (var f = 0; f < u.length; f += 1) {
        u[f].m(t, null);
      }
      vo(e, r, c), vo(e, i, c), uo(i, o), uo(i, a), _m11 && _m11.m(i, null), s = !0;
    },
    p: function p(e, r) {
      e[4].readOnly || "hover-insert-inside" !== e[9] && !e[19] ? l && (ma(), ba(l, 1, 1, function () {
        l = null;
      }), ga()) : l ? (l.p(e, r), 524816 & r[0] && ya(l, 1)) : ((l = cW(e)).c(), ya(l, 1), l.m(t, n)), 272695806 & r[0] && (f = e[16], ma(), u = Ca(u, r, h, 1, e, f, c, t, Sa, dW, null, $H), ga()), e[10] ? _m11 && (_m11.d(1), _m11 = null) : _m11 ? _m11.p(e, r) : ((_m11 = vW(e)).c(), _m11.m(i, null)), (!s || 8192 & r[0]) && So(i, "style", e[13]);
    },
    i: function i(e) {
      if (!s) {
        ya(l);
        for (var t = 0; t < f.length; t += 1) {
          ya(u[t]);
        }
        s = !0;
      }
    },
    o: function o(e) {
      ba(l);
      for (var t = 0; t < u.length; t += 1) {
        ba(u[t]);
      }
      s = !1;
    },
    d: function d(e) {
      e && po(t), l && l.d();
      for (var n = 0; n < u.length; n += 1) {
        u[n].d();
      }
      e && po(r), e && po(i), _m11 && _m11.d();
    }
  };
}
function cW(e) {
  var t, n, r, _i24;
  return n = new zV({
    props: {
      selected: e[19],
      onContextMenu: e[33]
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), So(t, "class", "jse-insert-area jse-inside svelte-uj4yd7"), So(t, "data-type", "insert-selection-area-inside"), So(t, "style", r = gW(e[1].length + 1)), So(t, "title", hs), To(t, "jse-hovered", "hover-insert-inside" === e[9]), To(t, "jse-selected", e[19]);
    },
    m: function m(e, r) {
      vo(e, t, r), Ea(n, t, null), _i24 = !0;
    },
    p: function p(e, o) {
      var a = {};
      524288 & o[0] && (a.selected = e[19]), n.$set(a), (!_i24 || 2 & o[0] && r !== (r = gW(e[1].length + 1))) && So(t, "style", r), 512 & o[0] && To(t, "jse-hovered", "hover-insert-inside" === e[9]), 524288 & o[0] && To(t, "jse-selected", e[19]);
    },
    i: function i(e) {
      _i24 || (ya(n.$$.fragment, e), _i24 = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), _i24 = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n);
    }
  };
}
function lW(e) {
  var t,
    n,
    r,
    i = e[51].start + e[56] + "";
  return {
    c: function c() {
      t = go("div"), n = go("div"), r = bo(i), So(n, "class", "jse-index svelte-uj4yd7"), So(t, "slot", "identifier"), So(t, "class", "jse-identifier svelte-uj4yd7");
    },
    m: function m(e, i) {
      vo(e, t, i), uo(t, n), uo(n, r);
    },
    p: function p(e, t) {
      65600 & t[0] && i !== (i = e[51].start + e[56] + "") && Ao(r, i);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function fW(e, t) {
  var n, r, _i25;
  return r = new bW({
    props: {
      value: t[54],
      path: t[22](t[1].concat(t[51].start + t[56])),
      state: t[5][t[51].start + t[56]],
      selection: t[8] ? t[8][t[51].start + t[56]] : void 0,
      searchResult: t[2] ? t[2][t[51].start + t[56]] : void 0,
      validationErrors: t[3] ? t[3][t[51].start + t[56]] : void 0,
      context: t[4],
      onDragSelectionStart: t[28],
      $$slots: {
        identifier: [lW]
      },
      $$scope: {
        ctx: t
      }
    }
  }), {
    key: e,
    first: null,
    c: function c() {
      n = wo(), Aa(r.$$.fragment), this.first = n;
    },
    m: function m(e, t) {
      vo(e, n, t), Ea(r, e, t), _i25 = !0;
    },
    p: function p(e, n) {
      t = e;
      var i = {};
      65600 & n[0] && (i.value = t[54]), 65602 & n[0] && (i.path = t[22](t[1].concat(t[51].start + t[56]))), 65632 & n[0] && (i.state = t[5][t[51].start + t[56]]), 65856 & n[0] && (i.selection = t[8] ? t[8][t[51].start + t[56]] : void 0), 65604 & n[0] && (i.searchResult = t[2] ? t[2][t[51].start + t[56]] : void 0), 65608 & n[0] && (i.validationErrors = t[3] ? t[3][t[51].start + t[56]] : void 0), 16 & n[0] && (i.context = t[4]), 65600 & n[0] | 512 & n[1] && (i.$$scope = {
        dirty: n,
        ctx: t
      }), r.$set(i);
    },
    i: function i(e) {
      _i25 || (ya(r.$$.fragment, e), _i25 = !0);
    },
    o: function o(e) {
      ba(r.$$.fragment, e), _i25 = !1;
    },
    d: function d(e) {
      e && po(n), Pa(r, e);
    }
  };
}
function hW(e) {
  var t, n;
  return t = new TV({
    props: {
      visibleSections: e[16],
      sectionIndex: e[53],
      total: e[6].length,
      path: e[1],
      onExpandSection: e[4].onExpandSection,
      selection: e[7]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      65536 & n[0] && (r.visibleSections = e[16]), 65536 & n[0] && (r.sectionIndex = e[53]), 64 & n[0] && (r.total = e[6].length), 2 & n[0] && (r.path = e[1]), 16 & n[0] && (r.onExpandSection = e[4].onExpandSection), 128 & n[0] && (r.selection = e[7]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function dW(e, t) {
  for (var n, r, i, _o17, a = [], s = new Map(), u = t[6].slice(t[51].start, Math.min(t[51].end, t[6].length)), c = function c(e) {
      return e[56];
    }, l = 0; l < u.length; l += 1) {
    var f = OH(t, u, l),
      h = c(f);
    s.set(h, a[l] = fW(h, f));
  }
  var _d7 = t[51].end < t[6].length && hW(t);
  return {
    key: e,
    first: null,
    c: function c() {
      n = wo();
      for (var e = 0; e < a.length; e += 1) {
        a[e].c();
      }
      r = ko(), _d7 && _d7.c(), i = wo(), this.first = n;
    },
    m: function m(e, t) {
      vo(e, n, t);
      for (var s = 0; s < a.length; s += 1) {
        a[s].m(e, t);
      }
      vo(e, r, t), _d7 && _d7.m(e, t), vo(e, i, t), _o17 = !0;
    },
    p: function p(e, n) {
      t = e, 272695678 & n[0] && (u = t[6].slice(t[51].start, Math.min(t[51].end, t[6].length)), ma(), a = Ca(a, n, c, 1, t, u, s, r.parentNode, Sa, fW, r, OH), ga()), t[51].end < t[6].length ? _d7 ? (_d7.p(t, n), 65600 & n[0] && ya(_d7, 1)) : ((_d7 = hW(t)).c(), ya(_d7, 1), _d7.m(i.parentNode, i)) : _d7 && (ma(), ba(_d7, 1, 1, function () {
        _d7 = null;
      }), ga());
    },
    i: function i(e) {
      if (!_o17) {
        for (var t = 0; t < u.length; t += 1) {
          ya(a[t]);
        }
        ya(_d7), _o17 = !0;
      }
    },
    o: function o(e) {
      for (var t = 0; t < a.length; t += 1) {
        ba(a[t]);
      }
      ba(_d7), _o17 = !1;
    },
    d: function d(e) {
      e && po(n);
      for (var t = 0; t < a.length; t += 1) {
        a[t].d(e);
      }
      e && po(r), _d7 && _d7.d(e), e && po(i);
    }
  };
}
function vW(e) {
  var t, n, r;
  return {
    c: function c() {
      So(t = go("div"), "class", "jse-insert-selection-area jse-after svelte-uj4yd7"), So(t, "data-type", "insert-selection-area-after");
    },
    m: function m(i, o) {
      vo(i, t, o), n || (r = xo(t, "click", e[32]), n = !0);
    },
    p: Bi,
    d: function d(e) {
      e && po(t), n = !1, r();
    }
  };
}
function pW(e) {
  var t, n, r;
  return n = new zV({
    props: {
      selected: e[20],
      onContextMenu: e[34]
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), So(t, "class", "jse-insert-area jse-after svelte-uj4yd7"), So(t, "data-type", "insert-selection-area-after"), So(t, "style", e[13]), So(t, "title", hs), To(t, "jse-hovered", "hover-insert-after" === e[9]), To(t, "jse-selected", e[20]);
    },
    m: function m(e, i) {
      vo(e, t, i), Ea(n, t, null), r = !0;
    },
    p: function p(e, i) {
      var o = {};
      1048576 & i[0] && (o.selected = e[20]), n.$set(o), (!r || 8192 & i[0]) && So(t, "style", e[13]), 512 & i[0] && To(t, "jse-hovered", "hover-insert-after" === e[9]), 1048576 & i[0] && To(t, "jse-selected", e[20]);
    },
    i: function i(e) {
      r || (ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n);
    }
  };
}
function mW(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    c,
    l = [IH, MH, PH],
    f = [];
  function h(e, t) {
    return "array" === e[14] ? 0 : "object" === e[14] ? 1 : 2;
  }
  n = h(e), r = f[n] = l[n](e);
  var _d8 = !e[4].readOnly && ("hover-insert-after" === e[9] || e[20]) && pW(e);
  return {
    c: function c() {
      t = go("div"), r.c(), i = ko(), _d8 && _d8.c(), So(t, "class", o = eo(_V("jse-json-node", {
        "jse-expanded": e[12]
      }, e[4].onClassName(e[1], e[6]))) + " svelte-uj4yd7"), So(t, "data-path", a = Ij(e[1])), To(t, "jse-root", e[10]), To(t, "jse-selected", e[21]), To(t, "jse-selected-key", e[18]), To(t, "jse-selected-value", e[17]), To(t, "jse-hovered", "hover-collection" === e[9]);
    },
    m: function m(r, o) {
      vo(r, t, o), f[n].m(t, null), uo(t, i), _d8 && _d8.m(t, null), s = !0, u || (c = [xo(t, "mousedown", e[26]), xo(t, "mousemove", e[27]), xo(t, "mouseover", e[29]), xo(t, "mouseout", e[30]), xo(t, "focus", void 0), xo(t, "blur", void 0)], u = !0);
    },
    p: function p(e, u) {
      var c = n;
      (n = h(e)) === c ? f[n].p(e, u) : (ma(), ba(f[c], 1, 1, function () {
        f[c] = null;
      }), ga(), (r = f[n]) ? r.p(e, u) : (r = f[n] = l[n](e)).c(), ya(r, 1), r.m(t, i)), e[4].readOnly || "hover-insert-after" !== e[9] && !e[20] ? _d8 && (ma(), ba(_d8, 1, 1, function () {
        _d8 = null;
      }), ga()) : _d8 ? (_d8.p(e, u), 1049104 & u[0] && ya(_d8, 1)) : ((_d8 = pW(e)).c(), ya(_d8, 1), _d8.m(t, null)), (!s || 4178 & u[0] && o !== (o = eo(_V("jse-json-node", {
        "jse-expanded": e[12]
      }, e[4].onClassName(e[1], e[6]))) + " svelte-uj4yd7")) && So(t, "class", o), (!s || 2 & u[0] && a !== (a = Ij(e[1]))) && So(t, "data-path", a), 5202 & u[0] && To(t, "jse-root", e[10]), 2101330 & u[0] && To(t, "jse-selected", e[21]), 266322 & u[0] && To(t, "jse-selected-key", e[18]), 135250 & u[0] && To(t, "jse-selected-value", e[17]), 4690 & u[0] && To(t, "jse-hovered", "hover-collection" === e[9]);
    },
    i: function i(e) {
      s || (ya(r), ya(_d8), s = !0);
    },
    o: function o(e) {
      ba(r), ba(_d8), s = !1;
    },
    d: function d(e) {
      e && po(t), f[n].d(), _d8 && _d8.d(), u = !1, Wi(c);
    }
  };
}
function gW(e) {
  return "margin-left: calc(".concat(e, " * var(--jse-indent-size))");
}
function yW(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f,
    h,
    d,
    v,
    p,
    m,
    g,
    y,
    b = t.$$slots,
    k = void 0 === b ? {} : b,
    w = t.$$scope,
    x = t.value,
    j = t.path,
    S = t.state,
    C = t.selection,
    _ = t.searchResult,
    $ = t.validationErrors,
    O = t.context,
    A = t.onDragSelectionStart,
    E = Na("jsoneditor:JSONNode"),
    P = void 0,
    M = void 0,
    I = void 0,
    T = df(function (e) {
      return e;
    }, rC);
  function N(e) {
    O.onDrag(e);
  }
  function R(e) {
    lH.selecting && (lH.selecting = !1, e.stopPropagation()), O.onDragEnd(), document.removeEventListener("mousemove", N, !0), document.removeEventListener("mouseup", R);
  }
  function D() {
    var e, t;
    return (null === (t = null === (e = O.findElement([])) || void 0 === e ? void 0 : e.getBoundingClientRect()) || void 0 === t ? void 0 : t.top) || 0;
  }
  function z(e, t) {
    var n = D() - e.initialContentTop;
    return t.clientY - e.initialClientY - n;
  }
  function L(e) {
    if (I) {
      var t = z(I, e),
        r = kH({
          fullJson: O.getFullJson(),
          fullState: O.getFullState(),
          fullSelection: O.getFullSelection(),
          deltaY: t,
          items: I.items
        }),
        i = r.updatedValue,
        o = r.updatedState,
        a = r.updatedSelection,
        s = r.indexOffset;
      s !== I.indexOffset && (E("drag selection", s, t, a), n(38, I = Pi(Pi({}, I), {}, {
        updatedValue: i,
        updatedState: o,
        updatedSelection: a,
        indexOffset: s,
        didMoveItems: !0
      })));
    }
  }
  function B(e) {
    if (I) {
      var t = z(I, e),
        r = kH({
          fullJson: O.getFullJson(),
          fullState: O.getFullState(),
          fullSelection: O.getFullSelection(),
          deltaY: t,
          items: I.items
        }),
        i = r.operations,
        o = r.updatedFullSelection;
      i ? O.onPatch(i, function () {
        return {
          selection: o || O.getFullSelection()
        };
      }) : e.target !== I.initialTarget || I.didMoveItems || O.onSelect({
        type: Mj(e.target),
        path: Tj(e.target)
      }), n(38, I = void 0), lH.dragging = !1, document.removeEventListener("mousemove", L, !0), document.removeEventListener("mouseup", B);
    }
  }
  return e.$$set = function (e) {
    "value" in e && n(0, x = e.value), "path" in e && n(1, j = e.path), "state" in e && n(35, S = e.state), "selection" in e && n(36, C = e.selection), "searchResult" in e && n(2, _ = e.searchResult), "validationErrors" in e && n(3, $ = e.validationErrors), "context" in e && n(4, O = e.context), "onDragSelectionStart" in e && n(37, A = e.onDragSelectionStart), "$$scope" in e && n(40, w = e.$$scope);
  }, e.$$.update = function () {
    1 & e.$$.dirty[0] | 128 & e.$$.dirty[1] && n(6, r = void 0 !== (null == I ? void 0 : I.updatedValue) ? I.updatedValue : x), 144 & e.$$.dirty[1] && n(5, i = void 0 !== (null == I ? void 0 : I.updatedState) ? I.updatedState : S), 160 & e.$$.dirty[1] && n(8, o = null != (null == I ? void 0 : I.updatedSelection) ? I.updatedSelection : C), 256 & e.$$.dirty[0] && n(7, a = o && o[as]), 128 & e.$$.dirty[0] && n(21, s = !(!a || !a.pathsMap)), 128 & e.$$.dirty[0] && n(20, u = !(!a || a.type !== Fx)), 128 & e.$$.dirty[0] && n(19, c = !(!a || a.type !== Vx)), 128 & e.$$.dirty[0] && n(18, l = !(!a || a.type !== Hx)), 128 & e.$$.dirty[0] && n(17, f = !(!a || a.type !== Wx)), 32 & e.$$.dirty[0] && n(12, h = i[es]), 32 & e.$$.dirty[0] && n(16, d = i[ts]), 32 & e.$$.dirty[0] && n(11, v = i[ns]), 8 & e.$$.dirty[0] && n(15, p = $ && $[ss]), 2 & e.$$.dirty[0] && n(10, m = 0 === j.length), 64 & e.$$.dirty[0] && n(14, g = qs(r)), 2 & e.$$.dirty[0] && n(13, y = gW(j.length));
  }, [x, j, _, $, O, i, r, a, o, P, m, v, h, y, g, p, d, f, l, c, u, s, T, function (e) {
    e.stopPropagation();
    var t = e.ctrlKey;
    O.onExpand(j, !h, t);
  }, function (e) {
    e.stopPropagation(), O.onExpand(j, !0);
  }, function (e, t) {
    var n = xF(j, v, e, t);
    return O.onPatch(n), Gv(ks.exports.parseJSONPointer(n[0].path));
  }, function (e) {
    if (!(function (e) {
      return "DIV" === e.nodeName && "true" === e.contentEditable;
    }(e.target) || 1 === e.which && Sj(e.target, "BUTTON"))) {
      e.stopPropagation(), e.preventDefault(), document.addEventListener("mousemove", N, !0), document.addEventListener("mouseup", R);
      var t = Mj(e.target);
      if (function (e, t, n) {
        if (!e) return !1;
        var r = t.slice(0);
        if (e.type === Ux) for (; r.length > 0;) {
          if (!0 === e.pathsMap[ks.exports.compileJSONPointer(r)]) return !0;
          r.pop();
        }
        if (e.type === Hx) return n === Hx && Zm(e.focusPath, t);
        if (e.type === Wx) {
          if (n === Wx && Zm(e.focusPath, t)) return !0;
          if (oj(t, e.focusPath) && t.length > e.focusPath.length && (n === Hx || n === Wx || n === Ux)) return !0;
        }
        return !1;
      }(O.getFullSelection(), j, t)) 0 === e.button && (O.focus(), A(e));else if (lH.selecting = !0, lH.selectionAnchor = j, lH.selectionAnchorType = t, lH.selectionFocus = j, e.shiftKey) {
        var n = O.getFullSelection();
        n && O.onSelect({
          type: Ux,
          anchorPath: n.anchorPath,
          focusPath: j
        });
      } else switch (t) {
        case Hx:
        case Wx:
        case Fx:
        case Vx:
          O.onSelect({
            type: t,
            path: j
          });
          break;
        case Ux:
          if (m && e.target.hasAttribute("data-path")) {
            var o = Gv(Lx(r, i));
            O.onSelect(o);
          } else O.onSelect({
            type: Ux,
            anchorPath: j,
            focusPath: j
          });
      }
    }
  }, function (e) {
    if (lH.selecting) {
      e.preventDefault(), e.stopPropagation(), null == lH.selectionFocus && window.getSelection && window.getSelection().empty();
      var t = Mj(e.target);
      Zm(j, lH.selectionFocus) && t === lH.selectionAnchorType || (lH.selectionFocus = j, O.onSelect({
        anchorPath: lH.selectionAnchor,
        focusPath: lH.selectionFocus
      }));
    }
  }, function (e) {
    if (!O.readOnly) {
      var t = O.getFullSelection(),
        r = _m(t.focusPath);
      if (Zm(j, r)) {
        var i = function (e) {
          var t = [];
          function n(e) {
            var n = j.concat(e),
              r = O.findElement(n);
            null != r && t.push({
              path: n,
              height: r.clientHeight
            });
          }
          if (Array.isArray(x)) {
            var r = Bp(e.paths) || e.focusPath,
              i = Gv(e.paths) || e.focusPath,
              o = Gv(r),
              a = Gv(i),
              s = S[ts].find(function (e) {
                return o >= e.start && a <= e.end;
              });
            if (!s) return null;
            var u = s.start,
              c = s.end;
            Ks(u, Math.min(x.length, c), n);
          } else jx(S, n);
          return t;
        }(t);
        E("dragSelectionStart", {
          fullSelection: t,
          items: i
        }), i ? (n(38, I = {
          initialTarget: e.target,
          initialClientY: e.clientY,
          initialContentTop: D(),
          updatedValue: void 0,
          updatedState: void 0,
          updatedSelection: void 0,
          items: i,
          indexOffset: 0,
          didMoveItems: !1
        }), lH.dragging = !0, document.addEventListener("mousemove", L, !0), document.addEventListener("mouseup", B)) : E("Cannot drag the current selection (probably spread over multiple sections)");
      } else A(e);
    }
  }, function (e) {
    lH.selecting || lH.dragging || (e.stopPropagation(), Cj(e.target, "data-type", "selectable-value") ? n(9, P = "hover-collection") : Cj(e.target, "data-type", "insert-selection-area-inside") ? n(9, P = "hover-insert-inside") : Cj(e.target, "data-type", "insert-selection-area-after") && n(9, P = "hover-insert-after"), clearTimeout(M));
  }, function (e) {
    e.stopPropagation(), M = setTimeout(function () {
      return n(9, P = void 0);
    });
  }, function (e) {
    e.shiftKey || (e.stopPropagation(), e.preventDefault(), O.onSelect({
      type: Vx,
      path: j
    }));
  }, function (e) {
    e.shiftKey || (e.stopPropagation(), e.preventDefault(), O.onSelect({
      type: Fx,
      path: j
    }));
  }, function (e) {
    O.onSelect({
      type: Vx,
      path: j
    }), O.onContextMenu(e);
  }, function (e) {
    O.onSelect({
      type: Fx,
      path: j
    }), O.onContextMenu(e);
  }, S, C, A, I, k, w];
}
var bW = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, yW, mW, Ki, {
      value: 0,
      path: 1,
      state: 35,
      selection: 36,
      searchResult: 2,
      validationErrors: 3,
      context: 4,
      onDragSelectionStart: 37
    }, wH, [-1, -1]), r;
  }
  return zi(n);
}();
function kW(e) {
  var t, n;
  return t = new TC({
    props: {
      items: e[0]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      1 & xi(n, 1)[0] && (r.items = e[0]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function wW(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c,
    l = t.json,
    f = t.selection,
    h = t.readOnly,
    d = t.showSearch,
    v = void 0 !== d && d,
    p = t.historyState,
    m = t.onExpandAll,
    g = t.onCollapseAll,
    y = t.onUndo,
    b = t.onRedo,
    k = t.onSort,
    w = t.onTransform,
    x = t.onContextMenu,
    j = t.onCopy,
    S = t.onRenderMenu,
    C = void 0 === S ? kc : S;
  function _() {
    n(1, v = !v);
  }
  return e.$$set = function (e) {
    "json" in e && n(2, l = e.json), "selection" in e && n(3, f = e.selection), "readOnly" in e && n(4, h = e.readOnly), "showSearch" in e && n(1, v = e.showSearch), "historyState" in e && n(5, p = e.historyState), "onExpandAll" in e && n(6, m = e.onExpandAll), "onCollapseAll" in e && n(7, g = e.onCollapseAll), "onUndo" in e && n(8, y = e.onUndo), "onRedo" in e && n(9, b = e.onRedo), "onSort" in e && n(10, k = e.onSort), "onTransform" in e && n(11, w = e.onTransform), "onContextMenu" in e && n(12, x = e.onContextMenu), "onCopy" in e && n(13, j = e.onCopy), "onRenderMenu" in e && n(14, C = e.onRenderMenu);
  }, e.$$.update = function () {
    4 & e.$$.dirty && n(20, r = void 0 !== l), e.$$.dirty, 1048584 & e.$$.dirty && n(17, i = r && null != f && (f.type === Ux || f.type === Hx || f.type === Wx)), 68 & e.$$.dirty && n(19, o = {
      icon: mC,
      title: "Expand all",
      className: "jse-expand-all",
      onClick: m,
      disabled: !Ls(l)
    }), 132 & e.$$.dirty && n(18, a = {
      icon: gC,
      title: "Collapse all",
      className: "jse-collapse-all",
      onClick: g,
      disabled: !Ls(l)
    }), 4 & e.$$.dirty && n(16, s = {
      icon: hS,
      title: "Search (Ctrl+F)",
      className: "jse-search",
      onClick: _,
      disabled: void 0 === l
    }), 999220 & e.$$.dirty && n(15, u = h ? [o, a, {
      separator: !0
    }, {
      icon: sS,
      title: "Copy (Ctrl+C)",
      className: "jse-copy",
      onClick: j,
      disabled: !i
    }, {
      separator: !0
    }, s, {
      space: !0
    }] : [o, a, {
      separator: !0
    }, {
      icon: Qj,
      title: "Sort",
      className: "jse-sort",
      onClick: k,
      disabled: h || void 0 === l
    }, {
      icon: lS,
      title: "Transform contents (filter, sort, project)",
      className: "jse-transform",
      onClick: w,
      disabled: h || void 0 === l
    }, s, {
      icon: cS,
      title: ds,
      className: "jse-contextmenu",
      onClick: x
    }, {
      separator: !0
    }, {
      icon: Yj,
      title: "Undo (Ctrl+Z)",
      className: "jse-undo",
      onClick: y,
      disabled: !p.canUndo
    }, {
      icon: Zj,
      title: "Redo (Ctrl+Shift+Z)",
      className: "jse-redo",
      onClick: b,
      disabled: !p.canRedo
    }, {
      space: !0
    }]), 49152 & e.$$.dirty && n(0, c = C("tree", u) || u);
  }, [c, v, l, f, h, p, m, g, y, b, k, w, x, j, C, u, s, i, a, o, r];
}
var xW = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, wW, kW, Ki, {
      json: 2,
      selection: 3,
      readOnly: 4,
      showSearch: 1,
      historyState: 5,
      onExpandAll: 6,
      onCollapseAll: 7,
      onUndo: 8,
      onRedo: 9,
      onSort: 10,
      onTransform: 11,
      onContextMenu: 12,
      onCopy: 13,
      onRenderMenu: 14
    }), r;
  }
  return zi(n);
}();
function jW(e) {
  co(e, "svelte-1q2qkk2", '@charset "UTF-8";.jse-welcome.svelte-1q2qkk2.svelte-1q2qkk2{flex:1;overflow:auto;font-family:var(--jse-font-family);font-size:var(--jse-font-size);display:flex;flex-direction:column;align-items:center;border-left:var(--jse-main-border);border-right:var(--jse-main-border)}.jse-welcome.svelte-1q2qkk2.svelte-1q2qkk2:last-child{border-bottom:var(--jse-main-border)}.jse-welcome.svelte-1q2qkk2 .jse-space.jse-before.svelte-1q2qkk2{flex:1}.jse-welcome.svelte-1q2qkk2 .jse-space.jse-after.svelte-1q2qkk2{flex:2}.jse-welcome.svelte-1q2qkk2 .jse-contents.svelte-1q2qkk2{margin:2em var(--jse-padding) 0;color:var(--jse-panel-color-readonly)}.jse-welcome.svelte-1q2qkk2 .jse-contents ul.svelte-1q2qkk2{list-style:"●";list-style-position:outside;padding-left:20px}.jse-welcome.svelte-1q2qkk2 .jse-contents ul li.svelte-1q2qkk2{padding-left:10px}.jse-welcome.svelte-1q2qkk2 .jse-contents ul li span.jse-bold.svelte-1q2qkk2{font-family:var(--jse-font-family-mono);font-weight:bold}');
}
function SW(e) {
  var t;
  return {
    c: function c() {
      (t = go("ul")).innerHTML = '<li class="svelte-1q2qkk2">Click inside the editor</li> \n        <li class="svelte-1q2qkk2">Paste clipboard data using <span class="jse-bold svelte-1q2qkk2">Ctrl+V</span></li> \n        <li class="svelte-1q2qkk2">Create a new object by typing <span class="jse-bold svelte-1q2qkk2">{</span></li> \n        <li class="svelte-1q2qkk2">Create a new array by typing <span class="jse-bold svelte-1q2qkk2">[</span></li>', So(t, "class", "svelte-1q2qkk2");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function CW(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u = !e[0] && SW();
  return {
    c: function c() {
      t = go("div"), n = go("div"), r = ko(), i = go("div"), o = bo("Empty document\n    "), u && u.c(), a = ko(), s = go("div"), So(n, "class", "jse-space jse-before svelte-1q2qkk2"), So(i, "class", "jse-contents svelte-1q2qkk2"), So(s, "class", "jse-space jse-after svelte-1q2qkk2"), So(t, "class", "jse-welcome svelte-1q2qkk2");
    },
    m: function m(e, c) {
      vo(e, t, c), uo(t, n), uo(t, r), uo(t, i), uo(i, o), u && u.m(i, null), uo(t, a), uo(t, s);
    },
    p: function p(e, t) {
      xi(t, 1)[0];
      e[0] ? u && (u.d(1), u = null) : u || ((u = SW()).c(), u.m(i, null));
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t), u && u.d();
    }
  };
}
function _W(e, t, n) {
  var r = t.readOnly;
  return e.$$set = function (e) {
    "readOnly" in e && n(0, r = e.readOnly);
  }, [r];
}
var $W = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, _W, CW, Ki, {
      readOnly: 0
    }, jW), r;
  }
  return zi(n);
}();
function OW(e) {
  co(e, "svelte-6hb2gf", ".jse-navigation-bar-dropdown.svelte-6hb2gf.svelte-6hb2gf{position:absolute;top:100%;left:0;z-index:3;background:var(--jse-navigation-bar-background);color:var(--jse-navigation-bar-dropdown-color);box-shadow:var(--jse-controls-box-shadow);display:flex;flex-direction:column;max-height:300px;overflow:auto;min-width:80px}.jse-navigation-bar-dropdown.svelte-6hb2gf button.jse-navigation-bar-dropdown-item.svelte-6hb2gf{font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);border:none;background:transparent;color:inherit;cursor:pointer;outline:none;text-align:left;white-space:nowrap;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding)) 36px}.jse-navigation-bar-dropdown.svelte-6hb2gf button.jse-navigation-bar-dropdown-item.svelte-6hb2gf:focus,.jse-navigation-bar-dropdown.svelte-6hb2gf button.jse-navigation-bar-dropdown-item.svelte-6hb2gf:hover{background:var(--jse-navigation-bar-background-highlight)}.jse-navigation-bar-dropdown.svelte-6hb2gf button.jse-navigation-bar-dropdown-item.jse-selected.svelte-6hb2gf{background:var(--jse-navigation-bar-dropdown-color);color:var(--jse-navigation-bar-background)}");
}
function AW(e, t, n) {
  var r = e.slice();
  return r[4] = t[n], r;
}
function EW(e, t) {
  var n,
    r,
    i,
    o,
    a,
    s = yF(t[4], TW) + "";
  function u() {
    return t[3](t[4]);
  }
  return {
    key: e,
    first: null,
    c: function c() {
      n = go("button"), r = bo(s), So(n, "type", "button"), So(n, "class", "jse-navigation-bar-dropdown-item svelte-6hb2gf"), So(n, "title", i = t[4]), To(n, "jse-selected", t[4] === t[1]), this.first = n;
    },
    m: function m(e, t) {
      vo(e, n, t), uo(n, r), o || (a = xo(n, "click", jo(u)), o = !0);
    },
    p: function p(e, o) {
      t = e, 1 & o && s !== (s = yF(t[4], TW) + "") && Ao(r, s), 1 & o && i !== (i = t[4]) && So(n, "title", i), 3 & o && To(n, "jse-selected", t[4] === t[1]);
    },
    d: function d(e) {
      e && po(n), o = !1, a();
    }
  };
}
function PW(e) {
  var t, n;
  return {
    c: function c() {
      t = go("button"), n = bo("..."), So(t, "type", "button"), So(t, "class", "jse-navigation-bar-dropdown-item svelte-6hb2gf"), So(t, "title", "Limited to " + IW + " items");
    },
    m: function m(e, r) {
      vo(e, t, r), uo(t, n);
    },
    p: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function MW(e) {
  for (var t, n, r = [], i = new Map(), o = Gs(e[0], IW), a = function a(e) {
      return e[4];
    }, s = 0; s < o.length; s += 1) {
    var u = AW(e, o, s),
      c = a(u);
    i.set(c, r[s] = EW(c, u));
  }
  var l = e[0].length > IW && PW();
  return {
    c: function c() {
      t = go("div");
      for (var e = 0; e < r.length; e += 1) {
        r[e].c();
      }
      n = ko(), l && l.c(), So(t, "class", "jse-navigation-bar-dropdown svelte-6hb2gf");
    },
    m: function m(e, i) {
      vo(e, t, i);
      for (var o = 0; o < r.length; o += 1) {
        r[o].m(t, null);
      }
      uo(t, n), l && l.m(t, null);
    },
    p: function p(e, s) {
      var u = xi(s, 1)[0];
      7 & u && (o = Gs(e[0], IW), r = Ca(r, u, a, 1, e, o, i, t, ja, EW, n, AW)), e[0].length > IW ? l ? l.p(e, u) : ((l = PW()).c(), l.m(t, null)) : l && (l.d(1), l = null);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
      for (var n = 0; n < r.length; n += 1) {
        r[n].d();
      }
      l && l.d();
    }
  };
}
var IW = 100,
  TW = 30;
function NW(e, t, n) {
  var r = t.items,
    i = t.selectedItem,
    o = t.onSelect;
  return e.$$set = function (e) {
    "items" in e && n(0, r = e.items), "selectedItem" in e && n(1, i = e.selectedItem), "onSelect" in e && n(2, o = e.onSelect);
  }, [r, i, o, function (e) {
    return o(e);
  }];
}
var RW = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, NW, MW, Ki, {
      items: 0,
      selectedItem: 1,
      onSelect: 2
    }, OW), r;
  }
  return zi(n);
}();
function DW(e) {
  co(e, "svelte-1r1k9th", ".jse-navigation-bar-item.svelte-1r1k9th.svelte-1r1k9th{position:relative;display:flex}.jse-navigation-bar-item.svelte-1r1k9th button.jse-navigation-bar-button.svelte-1r1k9th{font-family:inherit;font-size:inherit;padding:calc(0.5 * var(--jse-padding)) 2px;border:none;background:transparent;color:inherit;cursor:pointer;outline:none;min-width:2em;white-space:nowrap}.jse-navigation-bar-item.svelte-1r1k9th button.jse-navigation-bar-button.svelte-1r1k9th:focus,.jse-navigation-bar-item.svelte-1r1k9th button.jse-navigation-bar-button.svelte-1r1k9th:hover{background:var(--jse-panel-button-background-highlight);color:var(--jse-panel-button-color-highlight)}.jse-navigation-bar-item.svelte-1r1k9th button.jse-navigation-bar-button.jse-navigation-bar-arrow.svelte-1r1k9th{padding:2px var(--jse-padding) 0}.jse-navigation-bar-item.svelte-1r1k9th button.jse-navigation-bar-button.jse-navigation-bar-arrow.jse-open.svelte-1r1k9th{background:var(--jse-navigation-bar-background);color:var(--jse-navigation-bar-dropdown-color)}.jse-navigation-bar-item.svelte-1r1k9th.svelte-1r1k9th:last-child{padding-right:var(--jse-padding)}");
}
function zW(e) {
  var t, n, r, i;
  return {
    c: function c() {
      t = go("button"), n = bo(e[2]), So(t, "type", "button"), So(t, "class", "jse-navigation-bar-button svelte-1r1k9th");
    },
    m: function m(o, a) {
      vo(o, t, a), uo(t, n), r || (i = xo(t, "click", e[9]), r = !0);
    },
    p: function p(e, t) {
      4 & t && Ao(n, e[2]);
    },
    d: function d(e) {
      e && po(t), r = !1, i();
    }
  };
}
function LW(e) {
  var t, n, r, i, _o18, a, s;
  r = new KS({
    props: {
      data: Kj
    }
  });
  var u = void 0 !== e[2] && zW(e);
  return {
    c: function c() {
      t = go("div"), n = go("button"), Aa(r.$$.fragment), i = ko(), u && u.c(), So(n, "type", "button"), So(n, "class", "jse-navigation-bar-button jse-navigation-bar-arrow svelte-1r1k9th"), To(n, "jse-open", e[1]), So(t, "class", "jse-navigation-bar-item svelte-1r1k9th");
    },
    m: function m(c, l) {
      vo(c, t, l), uo(t, n), Ea(r, n, null), uo(t, i), u && u.m(t, null), e[10](t), _o18 = !0, a || (s = xo(n, "click", e[4]), a = !0);
    },
    p: function p(e, r) {
      var i = xi(r, 1)[0];
      2 & i && To(n, "jse-open", e[1]), void 0 !== e[2] ? u ? u.p(e, i) : ((u = zW(e)).c(), u.m(t, null)) : u && (u.d(1), u = null);
    },
    i: function i(e) {
      _o18 || (ya(r.$$.fragment, e), _o18 = !0);
    },
    o: function o(e) {
      ba(r.$$.fragment, e), _o18 = !1;
    },
    d: function d(n) {
      n && po(t), Pa(r), u && u.d(), e[10](null), a = !1, s();
    }
  };
}
function BW(e, t, n) {
  var r,
    i,
    o,
    a = Yo("absolute-popup"),
    s = a.openAbsolutePopup,
    u = a.closeAbsolutePopup,
    c = t.path,
    l = t.index,
    f = t.onSelect,
    h = t.getItems,
    d = !1;
  function v(e) {
    u(), f(r.concat(e));
  }
  return e.$$set = function (e) {
    "path" in e && n(5, c = e.path), "index" in e && n(6, l = e.index), "onSelect" in e && n(7, f = e.onSelect), "getItems" in e && n(8, h = e.getItems);
  }, e.$$.update = function () {
    96 & e.$$.dirty && (r = c.slice(0, l)), 96 & e.$$.dirty && n(2, i = c[l]);
  }, [o, d, i, v, function () {
    if (o) {
      n(1, d = !0);
      var e = {
        items: h(r),
        selectedItem: i,
        onSelect: v
      };
      s(RW, e, {
        anchor: o,
        closeOnOuterClick: !0,
        onClose: function onClose() {
          n(1, d = !1);
        }
      });
    }
  }, c, l, f, h, function () {
    return v(i);
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(0, o = e);
    });
  }];
}
var qW = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, BW, LW, Ki, {
        path: 5,
        index: 6,
        onSelect: 7,
        getItems: 8
      }, DW), r;
    }
    return zi(n);
  }(),
  FW = {
    exports: {}
  },
  VW = function VW(e, t) {
    var n,
      r,
      i = 1,
      o = 0,
      a = 0,
      s = String.alphabet;
    function u(e, t, r) {
      if (r) {
        for (n = t; (r = u(e, n)) < 76 && r > 65;) {
          ++n;
        }
        return +e.slice(t - 1, n);
      }
      return (r = s && s.indexOf(e.charAt(t))) > -1 ? r + 76 : (r = e.charCodeAt(t) || 0) < 45 || r > 127 ? r : r < 46 ? 65 : r < 48 ? r - 1 : r < 58 ? r + 18 : r < 65 ? r - 11 : r < 91 ? r + 11 : r < 97 ? r - 37 : r < 123 ? r + 5 : r - 63;
    }
    if ((e += "") != (t += "")) for (; i;) {
      if (r = u(e, o++), i = u(t, a++), r < 76 && i < 76 && r > 66 && i > 66 && (r = u(e, o, o), i = u(t, a, o = n), a = n), r != i) return r < i ? -1 : 1;
    }
    return 0;
  };
try {
  FW.exports = VW;
} catch (e) {
  String.naturalCompare = VW;
}
function HW(e, t) {
  var n = "string" == typeof e ? e.toLowerCase() : e,
    r = "string" == typeof t ? t.toLowerCase() : t;
  return FW.exports(n, r);
}
function WW(e, t) {
  return function (n, r) {
    var i = ks.exports.getIn(n, e),
      o = ks.exports.getIn(r, e);
    return void 0 === i ? t : void 0 === o ? -t : "string" != typeof i && "string" != typeof o ? i > o ? t : i < o ? -t : 0 : t * HW(i, o);
  };
}
function UW(e) {
  co(e, "svelte-5lwyke", ".jse-navigation-bar.svelte-5lwyke.svelte-5lwyke{font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);background:var(--jse-panel-background);color:var(--jse-panel-button-color);padding:0;margin:0;display:flex;overflow:auto;border-left:var(--jse-main-border);border-right:var(--jse-main-border)}.jse-navigation-bar.svelte-5lwyke .jse-navigation-bar-space.svelte-5lwyke{padding:calc(0.5 * var(--jse-padding)) var(--jse-padding);color:var(--jse-navigation-bar-color)}");
}
function JW(e, t, n) {
  var r = e.slice();
  return r[12] = t[n], r[14] = n, r;
}
function KW(e, t) {
  var n, r, _i26;
  return r = new qW({
    props: {
      getItems: t[4],
      path: t[1],
      index: t[14],
      onSelect: t[5]
    }
  }), {
    key: e,
    first: null,
    c: function c() {
      n = wo(), Aa(r.$$.fragment), this.first = n;
    },
    m: function m(e, t) {
      vo(e, n, t), Ea(r, e, t), _i26 = !0;
    },
    p: function p(e, n) {
      t = e;
      var i = {};
      2 & n && (i.path = t[1]), 2 & n && (i.index = t[14]), r.$set(i);
    },
    i: function i(e) {
      _i26 || (ya(r.$$.fragment, e), _i26 = !0);
    },
    o: function o(e) {
      ba(r.$$.fragment, e), _i26 = !1;
    },
    d: function d(e) {
      e && po(n), Pa(r, e);
    }
  };
}
function GW(e) {
  var t, n;
  return t = new qW({
    props: {
      getItems: e[4],
      path: e[1],
      index: void 0,
      onSelect: e[5]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      2 & n && (r.path = e[1]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function QW(e) {
  for (var t, n, r, i, o, a, s = [], u = new Map(), _c13 = Ls(e[0]) ? " " : "Navigation bar", l = e[1], f = function f(e) {
      return e[14];
    }, h = 0; h < l.length; h += 1) {
    var d = JW(e, l, h),
      v = f(d);
    u.set(v, s[h] = KW(v, d));
  }
  var _p9 = e[3] && GW(e);
  return {
    c: function c() {
      t = go("div");
      for (var e = 0; e < s.length; e += 1) {
        s[e].c();
      }
      n = ko(), _p9 && _p9.c(), r = ko(), i = go("div"), o = bo(_c13), So(i, "class", "jse-navigation-bar-space svelte-5lwyke"), So(t, "class", "jse-navigation-bar svelte-5lwyke");
    },
    m: function m(u, c) {
      vo(u, t, c);
      for (var l = 0; l < s.length; l += 1) {
        s[l].m(t, null);
      }
      uo(t, n), _p9 && _p9.m(t, null), uo(t, r), uo(t, i), uo(i, o), e[9](t), a = !0;
    },
    p: function p(e, i) {
      var h = xi(i, 1)[0];
      50 & h && (l = e[1], ma(), s = Ca(s, h, f, 1, e, l, u, t, Sa, KW, n, JW), ga()), e[3] ? _p9 ? (_p9.p(e, h), 8 & h && ya(_p9, 1)) : ((_p9 = GW(e)).c(), ya(_p9, 1), _p9.m(t, r)) : _p9 && (ma(), ba(_p9, 1, 1, function () {
        _p9 = null;
      }), ga()), (!a || 1 & h) && _c13 !== (_c13 = Ls(e[0]) ? " " : "Navigation bar") && Ao(o, _c13);
    },
    i: function i(e) {
      if (!a) {
        for (var t = 0; t < l.length; t += 1) {
          ya(s[t]);
        }
        ya(_p9), a = !0;
      }
    },
    o: function o(e) {
      for (var t = 0; t < s.length; t += 1) {
        ba(s[t]);
      }
      ba(_p9), a = !1;
    },
    d: function d(n) {
      n && po(t);
      for (var r = 0; r < s.length; r += 1) {
        s[r].d();
      }
      _p9 && _p9.d(), e[9](null);
    }
  };
}
function YW(e, t, n) {
  var r,
    i,
    o,
    a = Na("jsoneditor:NavigationBar"),
    s = t.json,
    u = t.state,
    c = t.selection,
    l = t.onSelect;
  return e.$$set = function (e) {
    "json" in e && n(0, s = e.json), "state" in e && n(6, u = e.state), "selection" in e && n(7, c = e.selection), "onSelect" in e && n(8, l = e.onSelect);
  }, e.$$.update = function () {
    128 & e.$$.dirty && n(1, r = c ? c.focusPath : []), 3 & e.$$.dirty && n(3, i = Ls(ks.exports.getIn(s, r))), 2 & e.$$.dirty && setTimeout(function () {
      if (o && o.scrollTo) {
        var e = o.scrollWidth - o.clientWidth;
        e > 0 && (a("scrollTo ", e), o.scrollTo({
          left: e,
          behavior: "smooth"
        }));
      }
    });
  }, [s, r, o, i, function (e) {
    a("get items for path", e);
    var t = ks.exports.getIn(s, e);
    if (Array.isArray(t)) return pb(0, t.length);
    if (zs(t)) {
      var n = (ks.exports.getIn(u, e.concat(ns)) || Object.keys(t)).slice(0);
      return n.sort(HW), n;
    }
    return [];
  }, function (e) {
    a("select path", JSON.stringify(e));
    var t = sj(s, u, {
      type: Ux,
      anchorPath: e,
      focusPath: e
    });
    l(t);
  }, u, c, l, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(2, o = e);
    });
  }];
}
var ZW = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, YW, QW, Ki, {
      json: 0,
      state: 6,
      selection: 7,
      onSelect: 8
    }, UW), r;
  }
  return zi(n);
}();
function XW(e) {
  co(e, "svelte-18vllqh", ".jse-search-box.svelte-18vllqh.svelte-18vllqh{border:var(--jse-panel-border);border-radius:3px;font-family:var(--jse-font-family);font-size:var(--jse-font-size);background:var(--jse-panel-background);color:var(--jse-panel-color-readonly);box-shadow:var(--jse-controls-box-shadow);display:inline-block;width:400px;max-width:100%;overflow:auto}.jse-search-box.svelte-18vllqh .jse-search-form.svelte-18vllqh{display:flex;align-items:stretch}.jse-search-box.svelte-18vllqh .jse-search-form button.svelte-18vllqh,.jse-search-box.svelte-18vllqh .jse-search-form input.svelte-18vllqh{font-family:inherit;font-size:inherit}.jse-search-box.svelte-18vllqh .jse-search-form button.svelte-18vllqh{display:block;text-align:center;border:none;padding:0 5px;margin:0;cursor:pointer;color:var(--jse-panel-button-color);background:var(--jse-panel-button-background)}.jse-search-box.svelte-18vllqh .jse-search-form button.svelte-18vllqh:hover{color:var(--jse-panel-button-color-highlight);background:var(--jse-panel-button-background-highlight)}.jse-search-box.svelte-18vllqh .jse-search-form input.svelte-18vllqh{color:var(--jse-panel-color);border:var(--jse-input-border);border-radius:3px;background:var(--jse-input-background);height:28px;padding:0 5px;margin:0;flex:1;outline:none}.jse-search-box.svelte-18vllqh .jse-search-form .jse-replace-toggle.svelte-18vllqh{padding:var(--jse-padding) calc(0.5 * var(--jse-padding));min-width:20px;background:var(--jse-panel-button-background-highlight)}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents.svelte-18vllqh{flex:1;display:flex;flex-direction:column;padding:calc(0.5 * var(--jse-padding));gap:calc(0.5 * var(--jse-padding))}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-search-section.svelte-18vllqh{flex:1;display:flex;align-items:center;position:relative;padding-left:32px}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-search-section .jse-search-icon.svelte-18vllqh{color:inherit;cursor:inherit;background:inherit;position:absolute;top:calc(0.5 * var(--jse-padding));left:calc(0.5 * var(--jse-padding))}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-search-section label.jse-search-input-label.svelte-18vllqh{flex:1;display:flex}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-search-section .jse-search-count.svelte-18vllqh{color:inherit;font-size:80%;visibility:hidden;padding:0 5px;min-width:36px;text-align:center}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-search-section .jse-search-count.jse-visible.svelte-18vllqh{visibility:visible}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-replace-section.svelte-18vllqh{padding-left:32px;flex:1;display:flex}.jse-search-box.svelte-18vllqh .jse-search-form .jse-search-contents .jse-replace-section button.svelte-18vllqh{width:auto}");
}
function eU(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    _c14,
    l,
    f,
    h,
    d,
    v,
    _p10,
    _m12,
    g,
    y,
    b,
    k,
    w,
    x,
    j,
    S,
    C,
    _,
    $,
    O,
    A = (-1 !== e[3] ? "".concat(e[3] + 1, "/") : "") + "",
    E = !e[4] && tU(e),
    P = [rU, nU],
    M = [];
  function I(e, t) {
    return e[2] ? 0 : 1;
  }
  s = I(e), u = M[s] = P[s](e), y = new KS({
    props: {
      data: nS
    }
  }), w = new KS({
    props: {
      data: rS
    }
  }), S = new KS({
    props: {
      data: kS
    }
  });
  var T = e[0] && !e[4] && iU(e);
  return {
    c: function c() {
      t = go("div"), n = go("form"), E && E.c(), r = ko(), i = go("div"), o = go("div"), a = go("div"), u.c(), _c14 = ko(), l = go("label"), f = go("input"), h = ko(), d = go("div"), v = bo(A), _p10 = bo(e[10]), _m12 = ko(), g = go("button"), Aa(y.$$.fragment), b = ko(), k = go("button"), Aa(w.$$.fragment), x = ko(), j = go("button"), Aa(S.$$.fragment), C = ko(), T && T.c(), So(a, "class", "jse-search-icon svelte-18vllqh"), So(f, "class", "jse-search-input svelte-18vllqh"), So(f, "title", "Enter text to search"), So(f, "type", "text"), So(f, "placeholder", "Find"), So(l, "class", "jse-search-input-label svelte-18vllqh"), So(l, "about", "jse-search input"), So(d, "class", "jse-search-count svelte-18vllqh"), To(d, "jse-visible", "" !== e[8]), So(g, "type", "button"), So(g, "class", "jse-search-next svelte-18vllqh"), So(g, "title", "Go to next search result (Enter)"), So(k, "type", "button"), So(k, "class", "jse-search-previous svelte-18vllqh"), So(k, "title", "Go to previous search result (Shift+Enter)"), So(j, "type", "button"), So(j, "class", "jse-search-clear svelte-18vllqh"), So(j, "title", "Close search box (Esc)"), So(o, "class", "jse-search-section svelte-18vllqh"), So(i, "class", "jse-search-contents svelte-18vllqh"), So(n, "class", "jse-search-form svelte-18vllqh"), So(t, "class", "jse-search-box svelte-18vllqh");
    },
    m: function m(u, A) {
      vo(u, t, A), uo(t, n), E && E.m(n, null), uo(n, r), uo(n, i), uo(i, o), uo(o, a), M[s].m(a, null), uo(o, _c14), uo(o, l), uo(l, f), Eo(f, e[8]), uo(o, h), uo(o, d), uo(d, v), uo(d, _p10), uo(o, _m12), uo(o, g), Ea(y, g, null), uo(o, b), uo(o, k), Ea(w, k, null), uo(o, x), uo(o, j), Ea(S, j, null), uo(i, C), T && T.m(i, null), _ = !0, $ || (O = [xo(f, "input", e[21]), to(aU.call(null, f)), xo(g, "click", e[22]), xo(k, "click", e[23]), xo(j, "click", e[24]), xo(n, "submit", e[12]), xo(n, "keydown", e[13])], $ = !0);
    },
    p: function p(e, t) {
      e[4] ? E && (ma(), ba(E, 1, 1, function () {
        E = null;
      }), ga()) : E ? (E.p(e, t), 16 & t && ya(E, 1)) : ((E = tU(e)).c(), ya(E, 1), E.m(n, r));
      var o = s;
      (s = I(e)) === o ? M[s].p(e, t) : (ma(), ba(M[o], 1, 1, function () {
        M[o] = null;
      }), ga(), (u = M[s]) ? u.p(e, t) : (u = M[s] = P[s](e)).c(), ya(u, 1), u.m(a, null)), 256 & t && f.value !== e[8] && Eo(f, e[8]), (!_ || 8 & t) && A !== (A = (-1 !== e[3] ? "".concat(e[3] + 1, "/") : "") + "") && Ao(v, A), (!_ || 1024 & t) && Ao(_p10, e[10]), 256 & t && To(d, "jse-visible", "" !== e[8]), e[0] && !e[4] ? T ? T.p(e, t) : ((T = iU(e)).c(), T.m(i, null)) : T && (T.d(1), T = null);
    },
    i: function i(e) {
      _ || (ya(E), ya(u), ya(y.$$.fragment, e), ya(w.$$.fragment, e), ya(S.$$.fragment, e), _ = !0);
    },
    o: function o(e) {
      ba(E), ba(u), ba(y.$$.fragment, e), ba(w.$$.fragment, e), ba(S.$$.fragment, e), _ = !1;
    },
    d: function d(e) {
      e && po(t), E && E.d(), M[s].d(), Pa(y), Pa(w), Pa(S), T && T.d(), $ = !1, Wi(O);
    }
  };
}
function tU(e) {
  var t, n, r, i, o;
  return n = new KS({
    props: {
      data: e[0] ? Xj : eS
    }
  }), {
    c: function c() {
      t = go("button"), Aa(n.$$.fragment), So(t, "type", "button"), So(t, "class", "jse-replace-toggle svelte-18vllqh"), So(t, "title", "Toggle visibility of replace options (Ctrl+H)");
    },
    m: function m(a, s) {
      vo(a, t, s), Ea(n, t, null), r = !0, i || (o = xo(t, "click", e[11]), i = !0);
    },
    p: function p(e, t) {
      var r = {};
      1 & t && (r.data = e[0] ? Xj : eS), n.$set(r);
    },
    i: function i(e) {
      r || (ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), i = !1, o();
    }
  };
}
function nU(e) {
  var t, n;
  return t = new KS({
    props: {
      data: hS
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: Bi,
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function rU(e) {
  var t, n;
  return t = new KS({
    props: {
      data: iS,
      spin: !0
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: Bi,
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function iU(e) {
  var t, n, r, i, o, a, s, u;
  return {
    c: function c() {
      t = go("div"), n = go("input"), r = ko(), (i = go("button")).textContent = "Replace", o = ko(), (a = go("button")).textContent = "All", So(n, "class", "jse-replace-input svelte-18vllqh"), So(n, "title", "Enter replacement text"), So(n, "type", "text"), So(n, "placeholder", "Replace"), So(i, "type", "button"), So(i, "title", "Replace current occurrence (Ctrl+Enter)"), So(i, "class", "svelte-18vllqh"), So(a, "type", "button"), So(a, "title", "Replace all occurrences"), So(a, "class", "svelte-18vllqh"), So(t, "class", "jse-replace-section svelte-18vllqh");
    },
    m: function m(c, l) {
      vo(c, t, l), uo(t, n), Eo(n, e[9]), uo(t, r), uo(t, i), uo(t, o), uo(t, a), s || (u = [xo(n, "input", e[25]), xo(i, "click", e[14]), xo(a, "click", e[15])], s = !0);
    },
    p: function p(e, t) {
      512 & t && n.value !== e[9] && Eo(n, e[9]);
    },
    d: function d(e) {
      e && po(t), s = !1, Wi(u);
    }
  };
}
function oU(e) {
  var t,
    n,
    r = e[1] && eU(e);
  return {
    c: function c() {
      r && r.c(), t = wo();
    },
    m: function m(e, i) {
      r && r.m(e, i), vo(e, t, i), n = !0;
    },
    p: function p(e, n) {
      var i = xi(n, 1)[0];
      e[1] ? r ? (r.p(e, i), 2 & i && ya(r, 1)) : ((r = eU(e)).c(), ya(r, 1), r.m(t.parentNode, t)) : r && (ma(), ba(r, 1, 1, function () {
        r = null;
      }), ga());
    },
    i: function i(e) {
      n || (ya(r), n = !0);
    },
    o: function o(e) {
      ba(r), n = !1;
    },
    d: function d(e) {
      r && r.d(e), e && po(t);
    }
  };
}
function aU(e) {
  e.select();
}
function sU(e, t, n) {
  var r,
    i,
    o = t.show,
    a = void 0 !== o && o,
    s = t.searching,
    u = t.resultCount,
    c = void 0 === u ? 0 : u,
    l = t.activeIndex,
    f = void 0 === l ? 0 : l,
    h = t.showReplace,
    d = void 0 !== h && h,
    v = t.readOnly,
    p = void 0 !== v && v,
    m = t.onChange,
    g = void 0 === m ? kc : m,
    y = t.onPrevious,
    b = void 0 === y ? kc : y,
    k = t.onNext,
    w = void 0 === k ? kc : k,
    x = t.onReplace,
    j = void 0 === x ? kc : x,
    S = t.onReplaceAll,
    C = void 0 === S ? kc : S,
    _ = t.onClose,
    $ = void 0 === _ ? kc : _,
    O = "",
    A = "",
    E = "";
  function P() {
    n(0, d = !d && !p);
  }
  function M() {
    p || j(O, E);
  }
  return e.$$set = function (e) {
    "show" in e && n(1, a = e.show), "searching" in e && n(2, s = e.searching), "resultCount" in e && n(16, c = e.resultCount), "activeIndex" in e && n(3, f = e.activeIndex), "showReplace" in e && n(0, d = e.showReplace), "readOnly" in e && n(4, p = e.readOnly), "onChange" in e && n(17, g = e.onChange), "onPrevious" in e && n(5, b = e.onPrevious), "onNext" in e && n(6, w = e.onNext), "onReplace" in e && n(18, j = e.onReplace), "onReplaceAll" in e && n(19, C = e.onReplaceAll), "onClose" in e && n(7, $ = e.onClose);
  }, e.$$.update = function () {
    65536 & e.$$.dirty && n(10, r = c >= 1e3 ? "".concat(999, "+") : String(c)), 131072 & e.$$.dirty && n(20, i = Ev(g, 300)), 1048832 & e.$$.dirty && i(O), 2 & e.$$.dirty && a && "" !== O && g(O);
  }, [d, a, s, f, p, b, w, $, O, E, r, P, function (e) {
    e.preventDefault(), O !== A ? (A = O, i.cancel(), g(O)) : w();
  }, function (e) {
    e.stopPropagation();
    var t = Dj(e);
    "Enter" === t && (e.preventDefault(), w()), "Shift+Enter" === t && (e.preventDefault(), b()), "Ctrl+Enter" !== t && "Command+Enter" !== t || (e.preventDefault(), d ? M() : w()), "Ctrl+H" === t && (e.preventDefault(), P()), "Escape" === t && (e.preventDefault(), $());
  }, M, function () {
    p || C(O, E);
  }, c, g, j, C, i, function () {
    O = this.value, n(8, O);
  }, function () {
    return w();
  }, function () {
    return b();
  }, function () {
    return $();
  }, function () {
    E = this.value, n(9, E);
  }];
}
var uU = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, sU, oU, Ki, {
        show: 1,
        searching: 2,
        resultCount: 16,
        activeIndex: 3,
        showReplace: 0,
        readOnly: 4,
        onChange: 17,
        onPrevious: 5,
        onNext: 6,
        onReplace: 18,
        onReplaceAll: 19,
        onClose: 7
      }, XW), r;
    }
    return zi(n);
  }(),
  cU = xa.window;
function lU(e) {
  co(e, "svelte-1wno2xw", ".jse-tree-mode.svelte-1wno2xw.svelte-1wno2xw{flex:1;display:flex;flex-direction:column;position:relative;background:var(--jse-background-color);min-width:0;min-height:0;font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);color:var(--jse-text-color);line-height:var(--jse-line-height)}.jse-tree-mode.svelte-1wno2xw .jse-hidden-input-label.svelte-1wno2xw{position:absolute;right:0;top:0;width:0;height:0}.jse-tree-mode.svelte-1wno2xw .jse-hidden-input-label .jse-hidden-input.svelte-1wno2xw{width:0;height:0;padding:0;border:0;outline:none}.jse-tree-mode.svelte-1wno2xw .jse-search-box-container.svelte-1wno2xw{position:relative;height:0;top:var(--jse-padding);margin-right:calc(var(--jse-padding) + 20px);margin-left:var(--jse-padding);text-align:right;z-index:3}.jse-tree-mode.no-main-menu.svelte-1wno2xw.svelte-1wno2xw{border-top:var(--jse-main-border)}.jse-tree-mode.svelte-1wno2xw .jse-contents.svelte-1wno2xw{border-left:var(--jse-main-border);border-right:var(--jse-main-border);flex:1;overflow:auto;position:relative;padding:2px;display:flex;flex-direction:column}.jse-tree-mode.svelte-1wno2xw .jse-contents.svelte-1wno2xw:last-child{border-bottom:var(--jse-main-border)}.jse-tree-mode.svelte-1wno2xw .jse-contents .jse-loading-space.svelte-1wno2xw{flex:1}.jse-tree-mode.svelte-1wno2xw .jse-contents .jse-loading.svelte-1wno2xw{flex:2;text-align:center;color:var(--jse-panel-color-readonly);box-sizing:border-box;font-family:var(--jse-font-family);font-size:var(--jse-font-size)}.jse-tree-mode.svelte-1wno2xw .jse-preview.svelte-1wno2xw{flex:1;color:var(--jse-panel-color-readonly);overflow:auto;white-space:pre-wrap;padding:2px}");
}
function fU(e) {
  var t, n, r;
  function i(t) {
    e[72](t);
  }
  var o = {
    json: e[7],
    selection: e[9],
    readOnly: e[0],
    historyState: e[20],
    onExpandAll: e[39],
    onCollapseAll: e[40],
    onUndo: e[35],
    onRedo: e[36],
    onSort: e[37],
    onTransform: e[38],
    onContextMenu: e[44],
    onCopy: e[33],
    onRenderMenu: e[4]
  };
  return void 0 !== e[16] && (o.showSearch = e[16]), t = new xW({
    props: o
  }), Xo.push(function () {
    return Oa(t, "showSearch", i);
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, n) {
      Ea(t, e, n), r = !0;
    },
    p: function p(e, r) {
      var i = {};
      128 & r[0] && (i.json = e[7]), 512 & r[0] && (i.selection = e[9]), 1 & r[0] && (i.readOnly = e[0]), 1048576 & r[0] && (i.historyState = e[20]), 16 & r[0] && (i.onRenderMenu = e[4]), !n && 65536 & r[0] && (n = !0, i.showSearch = e[16], sa(function () {
        return n = !1;
      })), t.$set(i);
    },
    i: function i(e) {
      r || (ya(t.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function hU(e) {
  var t, n;
  return t = new ZW({
    props: {
      json: e[7],
      state: e[14],
      selection: e[9],
      onSelect: e[47]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      128 & n[0] && (r.json = e[7]), 16384 & n[0] && (r.state = e[14]), 512 & n[0] && (r.selection = e[9]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function dU(e) {
  var t;
  return {
    c: function c() {
      (t = go("div")).innerHTML = '<div class="jse-loading-space svelte-1wno2xw"></div> \n      <div class="jse-loading svelte-1wno2xw">loading...</div>', So(t, "class", "jse-contents svelte-1wno2xw");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: Bi,
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function vU(e) {
  var t,
    n,
    r,
    i,
    _o19,
    a,
    s,
    u,
    c,
    l = [mU, pU],
    f = [];
  function h(e, t) {
    return void 0 === e[7] ? 0 : 1;
  }
  return i = h(e), _o19 = f[i] = l[i](e), {
    c: function c() {
      t = go("label"), n = go("input"), r = ko(), _o19.c(), a = wo(), So(n, "class", "jse-hidden-input svelte-1wno2xw"), So(n, "tabindex", "-1"), So(t, "class", "jse-hidden-input-label svelte-1wno2xw");
    },
    m: function m(o, l) {
      vo(o, t, l), uo(t, n), e[73](n), vo(o, r, l), f[i].m(o, l), vo(o, a, l), s = !0, u || (c = xo(n, "paste", e[34]), u = !0);
    },
    p: function p(e, t) {
      var n = i;
      (i = h(e)) === n ? f[i].p(e, t) : (ma(), ba(f[n], 1, 1, function () {
        f[n] = null;
      }), ga(), (_o19 = f[i]) ? _o19.p(e, t) : (_o19 = f[i] = l[i](e)).c(), ya(_o19, 1), _o19.m(a.parentNode, a));
    },
    i: function i(e) {
      s || (ya(_o19), s = !0);
    },
    o: function o(e) {
      ba(_o19), s = !1;
    },
    d: function d(n) {
      n && po(t), e[73](null), n && po(r), f[i].d(n), n && po(a), u = !1, c();
    }
  };
}
function pU(e) {
  var t, n, r, i, _o20, a, s, u, _c15, l;
  n = new uU({
    props: {
      show: e[16],
      resultCount: e[19] ? e[19].count : 0,
      activeIndex: e[19] ? e[19].activeIndex : 0,
      showReplace: e[17],
      searching: e[18],
      readOnly: e[0],
      onChange: e[26],
      onNext: e[27],
      onPrevious: e[28],
      onReplace: e[29],
      onReplaceAll: e[30],
      onClose: e[31]
    }
  }), _o20 = new bW({
    props: {
      value: e[7],
      path: e[25],
      state: e[14],
      selection: e[23],
      searchResult: e[19] && e[19].itemsWithActive,
      validationErrors: e[22],
      context: e[10],
      onDragSelectionStart: kc
    }
  });
  var f = e[15] && gU(e),
    h = e[21] && yU(e);
  return _c15 = new pC({
    props: {
      validationErrors: e[11],
      selectError: e[32]
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), r = ko(), i = go("div"), Aa(_o20.$$.fragment), a = ko(), f && f.c(), s = ko(), h && h.c(), u = ko(), Aa(_c15.$$.fragment), So(t, "class", "jse-search-box-container svelte-1wno2xw"), So(i, "class", "jse-contents svelte-1wno2xw"), So(i, "data-jsoneditor-scrollable-contents", !0);
    },
    m: function m(d, v) {
      vo(d, t, v), Ea(n, t, null), vo(d, r, v), vo(d, i, v), Ea(_o20, i, null), e[74](i), vo(d, a, v), f && f.m(d, v), vo(d, s, v), h && h.m(d, v), vo(d, u, v), Ea(_c15, d, v), l = !0;
    },
    p: function p(e, t) {
      var r = {};
      65536 & t[0] && (r.show = e[16]), 524288 & t[0] && (r.resultCount = e[19] ? e[19].count : 0), 524288 & t[0] && (r.activeIndex = e[19] ? e[19].activeIndex : 0), 131072 & t[0] && (r.showReplace = e[17]), 262144 & t[0] && (r.searching = e[18]), 1 & t[0] && (r.readOnly = e[0]), n.$set(r);
      var i = {};
      128 & t[0] && (i.value = e[7]), 16384 & t[0] && (i.state = e[14]), 8388608 & t[0] && (i.selection = e[23]), 524288 & t[0] && (i.searchResult = e[19] && e[19].itemsWithActive), 4194304 & t[0] && (i.validationErrors = e[22]), 1024 & t[0] && (i.context = e[10]), _o20.$set(i), e[15] ? f ? (f.p(e, t), 32768 & t[0] && ya(f, 1)) : ((f = gU(e)).c(), ya(f, 1), f.m(s.parentNode, s)) : f && (ma(), ba(f, 1, 1, function () {
        f = null;
      }), ga()), e[21] ? h ? (h.p(e, t), 2097152 & t[0] && ya(h, 1)) : ((h = yU(e)).c(), ya(h, 1), h.m(u.parentNode, u)) : h && (ma(), ba(h, 1, 1, function () {
        h = null;
      }), ga());
      var a = {};
      2048 & t[0] && (a.validationErrors = e[11]), _c15.$set(a);
    },
    i: function i(e) {
      l || (ya(n.$$.fragment, e), ya(_o20.$$.fragment, e), ya(f), ya(h), ya(_c15.$$.fragment, e), l = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), ba(_o20.$$.fragment, e), ba(f), ba(h), ba(_c15.$$.fragment, e), l = !1;
    },
    d: function d(l) {
      l && po(t), Pa(n), l && po(r), l && po(i), Pa(_o20), e[74](null), l && po(a), f && f.d(l), l && po(s), h && h.d(l), l && po(u), Pa(_c15, l);
    }
  };
}
function mU(e) {
  var t,
    n,
    r,
    _i27,
    o = [kU, bU],
    a = [];
  function s(e, t) {
    return "" === e[8] || void 0 === e[8] ? 0 : 1;
  }
  return t = s(e), n = a[t] = o[t](e), {
    c: function c() {
      n.c(), r = wo();
    },
    m: function m(e, n) {
      a[t].m(e, n), vo(e, r, n), _i27 = !0;
    },
    p: function p(e, i) {
      var u = t;
      (t = s(e)) === u ? a[t].p(e, i) : (ma(), ba(a[u], 1, 1, function () {
        a[u] = null;
      }), ga(), (n = a[t]) ? n.p(e, i) : (n = a[t] = o[t](e)).c(), ya(n, 1), n.m(r.parentNode, r));
    },
    i: function i(e) {
      _i27 || (ya(n), _i27 = !0);
    },
    o: function o(e) {
      ba(n), _i27 = !1;
    },
    d: function d(e) {
      a[t].d(e), e && po(r);
    }
  };
}
function gU(e) {
  var t, n;
  return t = new nC({
    props: {
      type: "info",
      message: "You pasted a JSON ".concat(Array.isArray(e[15].contents) ? "array" : "object", " as text"),
      actions: [{
        icon: bS,
        text: "Paste as JSON instead",
        onMouseDown: e[45]
      }, {
        text: "Leave as is",
        onClick: e[46]
      }]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      32768 & n[0] && (r.message = "You pasted a JSON ".concat(Array.isArray(e[15].contents) ? "array" : "object", " as text")), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function yU(e) {
  var t, n;
  return t = new nC({
    props: {
      type: "success",
      message: "The loaded JSON document was invalid but is successfully repaired.",
      actions: e[0] ? [] : [{
        icon: tS,
        text: "Ok",
        onClick: e[5]
      }, {
        icon: aS,
        text: "Repair manually instead",
        onClick: e[3]
      }]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      9 & n[0] && (r.actions = e[0] ? [] : [{
        icon: tS,
        text: "Ok",
        onClick: e[5]
      }, {
        icon: aS,
        text: "Repair manually instead",
        onClick: e[3]
      }]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function bU(e) {
  var t, n, r, i, _o21;
  return t = new nC({
    props: {
      type: "error",
      message: "The loaded JSON document is invalid and could not be repaired automatically.",
      actions: e[0] ? [] : [{
        icon: aS,
        text: "Repair manually",
        onClick: e[3]
      }]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment), n = ko(), r = go("div"), i = bo(e[8]), So(r, "class", "jse-preview svelte-1wno2xw");
    },
    m: function m(e, a) {
      Ea(t, e, a), vo(e, n, a), vo(e, r, a), uo(r, i), _o21 = !0;
    },
    p: function p(e, n) {
      var r = {};
      9 & n[0] && (r.actions = e[0] ? [] : [{
        icon: aS,
        text: "Repair manually",
        onClick: e[3]
      }]), t.$set(r), (!_o21 || 256 & n[0]) && Ao(i, e[8]);
    },
    i: function i(e) {
      _o21 || (ya(t.$$.fragment, e), _o21 = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), _o21 = !1;
    },
    d: function d(e) {
      Pa(t, e), e && po(n), e && po(r);
    }
  };
}
function kU(e) {
  var t, n;
  return t = new $W({
    props: {
      readOnly: e[0]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      1 & n[0] && (r.readOnly = e[0]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function wU(e) {
  var t,
    n,
    r,
    i,
    _o22,
    a,
    s,
    u,
    _c16 = e[1] && fU(e),
    l = e[2] && hU(e),
    f = [vU, dU],
    h = [];
  return i = function (e, t) {
    return e[24] ? 1 : 0;
  }(e), _o22 = h[i] = f[i](e), {
    c: function c() {
      t = go("div"), _c16 && _c16.c(), n = ko(), l && l.c(), r = ko(), _o22.c(), So(t, "class", "jse-tree-mode svelte-1wno2xw"), To(t, "no-main-menu", !e[1]);
    },
    m: function m(o, f) {
      vo(o, t, f), _c16 && _c16.m(t, null), uo(t, n), l && l.m(t, null), uo(t, r), h[i].m(t, null), e[75](t), a = !0, s || (u = [xo(cU, "mousedown", e[48]), xo(t, "keydown", e[41]), xo(t, "mousedown", e[42]), xo(t, "contextmenu", e[43])], s = !0);
    },
    p: function p(e, i) {
      e[1] ? _c16 ? (_c16.p(e, i), 2 & i[0] && ya(_c16, 1)) : ((_c16 = fU(e)).c(), ya(_c16, 1), _c16.m(t, n)) : _c16 && (ma(), ba(_c16, 1, 1, function () {
        _c16 = null;
      }), ga()), e[2] ? l ? (l.p(e, i), 4 & i[0] && ya(l, 1)) : ((l = hU(e)).c(), ya(l, 1), l.m(t, r)) : l && (ma(), ba(l, 1, 1, function () {
        l = null;
      }), ga()), _o22.p(e, i), 2 & i[0] && To(t, "no-main-menu", !e[1]);
    },
    i: function i(e) {
      a || (ya(_c16), ya(l), ya(_o22), a = !0);
    },
    o: function o(e) {
      ba(_c16), ba(l), ba(_o22), a = !1;
    },
    d: function d(n) {
      n && po(t), _c16 && _c16.d(), l && l.d(), h[i].d(), e[75](null), s = !1, Wi(u);
    }
  };
}
function xU(e) {
  return e.length < 1 || 1 === e.length && 0 === e[0];
}
function jU() {
  return !0;
}
function SU(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c = Na("jsoneditor:TreeMode"),
    l = "undefined" == typeof window;
  c("isSSR:", l);
  var f,
    h,
    d,
    v,
    p,
    m = Yo("simple-modal").open,
    g = ww(),
    y = ww(),
    b = Yo("absolute-popup"),
    k = b.openAbsolutePopup,
    w = b.closeAbsolutePopup,
    x = !1,
    j = mF(),
    S = t.readOnly,
    C = void 0 !== S && S,
    _ = t.externalContent,
    $ = t.mainMenuBar,
    O = void 0 === $ || $,
    A = t.navigationBar,
    E = void 0 === A || A,
    P = t.escapeControlCharacters,
    M = void 0 !== P && P,
    I = t.escapeUnicodeCharacters,
    T = void 0 !== I && I,
    N = t.validator,
    R = void 0 === N ? null : N,
    D = t.indentation,
    z = void 0 === D ? 2 : D,
    L = t.onError,
    B = t.onChange,
    q = t.onRenderValue,
    F = t.onRequestRepair,
    V = void 0 === F ? kc : F,
    H = t.onRenderMenu,
    W = void 0 === H ? kc : H,
    U = t.onClassName,
    J = t.onFocus,
    K = t.onBlur,
    G = t.onSortModal,
    Q = t.onTransformModal,
    Y = !1;
  jS({
    onMount: Jo,
    onDestroy: Ko,
    getWindow: function getWindow() {
      return Aj(d);
    },
    hasFocus: function hasFocus() {
      return Y && document.hasFocus() || Ej(d);
    },
    onFocus: function onFocus() {
      x = !0, J && J();
    },
    onBlur: function onBlur() {
      x = !1, K && K();
    }
  });
  var Z,
    X = kx({}, void 0, [], xU),
    ee = null;
  function te(e) {
    return au({
      json: e
    }, 10240) ? xU : jU;
  }
  var ne,
    re = !1,
    ie = !1,
    oe = !1,
    ae = "";
  function se(e) {
    return ue.apply(this, arguments);
  }
  function ue() {
    return (ue = yi(mi().mark(function e(t) {
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return c("search text updated", t), n(69, ae = t), e.next = 4, oa();
            case 4:
              return e.next = 6, de(ne && ne.activeItem);
            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function ce() {
    return (ce = yi(mi().mark(function e() {
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n(19, ne = ne ? AF(ne) : ne), e.next = 3, de(ne && ne.activeItem);
            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function le() {
    return (le = yi(mi().mark(function e() {
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n(19, ne = ne ? EF(ne) : ne), e.next = 3, de(ne && ne.activeItem);
            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function fe() {
    return (fe = yi(mi().mark(function e(t, n) {
      var r, i, o, a;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r = ne.activeItem, c("handleReplace", {
                replacementText: n,
                activeItem: r
              }), ne && r) {
                e.next = 4;
                break;
              }
              return e.abrupt("return");
            case 4:
              return i = NF(v, X, n, r), o = i.operations, a = i.newSelection, it(o, function () {
                return {
                  selection: a
                };
              }), e.next = 8, oa();
            case 8:
              return e.next = 10, de(ne && ne.activeItem);
            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function he() {
    return (he = yi(mi().mark(function e(t, n) {
      var r, i, o;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return c("handleReplaceAll", {
                text: t,
                replacementText: n
              }), r = RF(v, X, t, n), i = r.operations, o = r.newSelection, it(i, function () {
                return {
                  selection: o
                };
              }), e.next = 5, oa();
            case 5:
              return e.next = 7, de(ne && ne.activeItem);
            case 7:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function de(e) {
    return ve.apply(this, arguments);
  }
  function ve() {
    return (ve = yi(mi().mark(function e(t) {
      var r;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!t) {
                e.next = 8;
                break;
              }
              return r = t.path, n(14, X = Sx(v, X, r)), n(9, ee = null), e.next = 6, oa();
            case 6:
              return e.next = 8, Xe(r);
            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  var pe = qk(function () {
    "" !== ae ? (n(18, oe = !0), setTimeout(function () {
      c("searching...", ae);
      var e = PF(ae, v, X, 1e3);
      n(19, ne = OF(v, e, ne)), n(18, oe = !1);
    })) : n(19, ne = void 0);
  }, 300);
  var me = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.maxItems || 1e3,
        n = [],
        r = 0;
      function i() {
        return r < n.length;
      }
      function o() {
        return r > 0;
      }
      function a() {
        return {
          canUndo: i(),
          canRedo: o(),
          length: n.length
        };
      }
      function s() {
        e.onChange && e.onChange(a());
      }
      function u(e) {
        n = [e].concat(n.slice(r)).slice(0, t), r = 0, s();
      }
      function c() {
        n = [], r = 0, s();
      }
      function l() {
        if (i()) {
          var e = n[r];
          return r += 1, s(), e;
        }
      }
      function f() {
        if (o()) return r -= 1, s(), n[r];
      }
      return {
        add: u,
        clear: c,
        getState: a,
        undo: l,
        redo: f
      };
    }({
      onChange: function onChange(e) {
        n(20, ge = e);
      }
    }),
    ge = me.getState();
  var ye = !1;
  function be(e) {
    void 0 !== e.json && function (e) {
      if (void 0 === e) return;
      var t = !Zm(v, e),
        r = void 0 === v;
      if (c("update external json", {
        isChanged: t,
        isText: r
      }), !t) return;
      var i = X,
        o = v,
        a = p,
        s = ye,
        u = ee;
      n(7, v = e), n(14, X = kx(v, i, [], te(v), !1)), n(8, p = void 0), n(21, ye = !1), n(9, ee = ke(ee, v)), we({
        previousJson: o,
        previousState: i,
        previousText: a,
        previousTextIsRepaired: s,
        previousSelection: u
      }), pe();
    }(e.json), void 0 !== e.text && function (e) {
      if (void 0 === e || void 0 !== _.json) return;
      if (e === p) return;
      c("update external text");
      var t = v,
        r = X,
        i = p,
        o = ye,
        a = ee;
      try {
        n(7, v = JSON.parse(e)), n(14, X = kx(v, r, [], te(v), !1)), n(8, p = e), n(21, ye = !1), n(9, ee = ke(ee, v));
      } catch (t) {
        try {
          n(7, v = JSON.parse(Ds(e))), n(14, X = kx(v, r, [], te(v), !1)), n(8, p = e), n(21, ye = !0), n(9, ee = ke(ee, v));
        } catch (e) {
          n(7, v = void 0), n(14, X = void 0), n(8, p = _.text), n(21, ye = !1), n(9, ee = ke(ee, v));
        }
      }
      ee || void 0 !== v || "" !== p && void 0 !== p || n(9, ee = xe());
      we({
        previousJson: t,
        previousState: r,
        previousText: i,
        previousTextIsRepaired: o,
        previousSelection: a
      }), pe();
    }(e.text);
  }
  function ke(e, t) {
    return e && ks.exports.existsIn(t, e.anchorPath) && ks.exports.existsIn(t, e.focusPath) ? e : (c("clearing selection: path does not exist anymore"), null);
  }
  function we(e) {
    var t = e.previousJson,
      n = e.previousState,
      r = e.previousText,
      i = e.previousTextIsRepaired,
      o = e.previousSelection;
    void 0 === t && void 0 === r || (void 0 !== v ? void 0 !== t ? me.add({
      undo: {
        patch: [{
          op: "replace",
          path: "",
          value: t
        }],
        state: n,
        text: r,
        textIsRepaired: i,
        selection: aj(o)
      },
      redo: {
        patch: [{
          op: "replace",
          path: "",
          value: v
        }],
        state: X,
        text: p,
        textIsRepaired: ye,
        selection: aj(ee)
      }
    }) : me.add({
      undo: {
        state: n,
        text: r,
        textIsRepaired: i,
        selection: aj(o)
      },
      redo: {
        json: v,
        state: X,
        text: p,
        textIsRepaired: ye,
        selection: aj(ee)
      }
    }) : void 0 !== t && me.add({
      undo: {
        json: t,
        state: n,
        text: r,
        textIsRepaired: i,
        selection: aj(o)
      },
      redo: {
        text: p,
        textIsRepaired: ye,
        state: X,
        selection: aj(ee)
      }
    }));
  }
  function xe() {
    return sj(v || {}, X, {
      type: Ux,
      anchorPath: [],
      focusPath: []
    });
  }
  function je(e, t) {
    if (void 0 === v) throw new Error("Cannot apply patch: no JSON");
    var r = v,
      i = X,
      o = p,
      a = ye,
      s = ee;
    c("patch", e, t);
    var u = ks.exports.revertJSONPatch(v, e),
      l = Ox(v, X, e),
      f = "function" == typeof t ? t(l.json, l.state, ee) : void 0;
    return n(7, v = f && void 0 !== f.json ? f.json : l.json), n(14, X = f && void 0 !== f.state ? f.state : l.state), n(8, p = void 0), n(21, ye = !1), n(9, ee = f && f.selection ? f.selection : tj(r, 0, e)), n(9, ee = ke(ee, v)), me.add({
      undo: {
        patch: u,
        state: i,
        text: o,
        textIsRepaired: a,
        selection: aj(s)
      },
      redo: {
        patch: e,
        state: X,
        text: p,
        textIsRepaired: ye,
        selection: aj(ee)
      }
    }), {
      json: v,
      previousJson: r,
      undo: u,
      redo: e
    };
  }
  function Se() {
    return ee && (ee.type === Ux || ee.type === Hx || ee.type === Wx);
  }
  function Ce() {
    !C && ee && n(9, ee = sj(v, X, {
      type: Hx,
      path: ee.focusPath,
      edit: !0
    }));
  }
  function _e() {
    !C && ee && n(9, ee = sj(v, X, {
      type: Wx,
      path: ee.focusPath,
      edit: !0
    }));
  }
  function $e() {
    if (!C && ee && ee.type === Wx) {
      var e = ee.focusPath,
        t = e.concat(os),
        r = !ks.exports.getIn(X, t);
      n(14, X = ks.exports.setIn(X, t, r, !0));
      var i = ks.exports.getIn(v, e),
        o = r ? String(i) : Hs(i);
      o !== i && it([{
        op: "replace",
        path: ks.exports.compileJSONPointer(e),
        value: o
      }]);
    }
  }
  function Oe() {
    return Ae.apply(this, arguments);
  }
  function Ae() {
    return (Ae = yi(mi().mark(function e() {
      var t,
        n,
        r,
        i,
        o,
        a = arguments;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t = !(a.length > 0 && void 0 !== a[0]) || a[0], !C && Se()) {
                e.next = 3;
                break;
              }
              return e.abrupt("return");
            case 3:
              if (null != (n = uj(v, ee, t ? z : null))) {
                e.next = 7;
                break;
              }
              return e.abrupt("return");
            case 7:
              return c("cut", {
                selection: ee,
                clipboard: n,
                indent: t
              }), e.prev = 8, e.next = 11, navigator.clipboard.writeText(n);
            case 11:
              e.next = 16;
              break;
            case 13:
              e.prev = 13, e.t0 = e.catch(8), L(e.t0);
            case 16:
              r = $F(v, X, ee), i = r.operations, o = r.newSelection, it(i, function () {
                return {
                  selection: o
                };
              });
            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[8, 13]]);
    }))).apply(this, arguments);
  }
  function Ee() {
    return Pe.apply(this, arguments);
  }
  function Pe() {
    return (Pe = yi(mi().mark(function e() {
      var t,
        n,
        r = arguments;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t = !(r.length > 0 && void 0 !== r[0]) || r[0], null != (n = uj(v, ee, t ? z : null))) {
                e.next = 5;
                break;
              }
              return e.abrupt("return");
            case 5:
              return c("copy", {
                clipboard: n,
                indent: t
              }), e.prev = 6, e.next = 9, navigator.clipboard.writeText(n);
            case 9:
              e.next = 14;
              break;
            case 11:
              e.prev = 11, e.t0 = e.catch(6), L(e.t0);
            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[6, 11]]);
    }))).apply(this, arguments);
  }
  function Me() {
    m(UF, {}, Pi(Pi({}, cs), {}, {
      styleWindow: Pi(Pi({}, cs.styleWindow), {}, {
        width: "450px"
      })
    }), {
      onClose: function onClose() {
        return setTimeout(J);
      }
    });
  }
  function Ie(e) {
    if (void 0 !== v) {
      var t = ee || xe(),
        r = jF(v, X, t, e);
      c("paste", {
        clipboardText: e,
        operations: r,
        selectionOrDefault: t
      }), it(r, function (e, t) {
        var n = t;
        return r.filter(function (e) {
          return Ls(e.value);
        }).forEach(function (t) {
          var r = px(v, t.path);
          n = at(e, n, r);
        }), {
          state: n
        };
      });
    } else c("paste text", {
      clipboardText: e
    }), function (e, t) {
      var r = X,
        i = v,
        o = p,
        a = {
          json: v,
          text: p
        },
        s = ye,
        u = ee;
      try {
        n(7, v = JSON.parse(e)), n(14, X = kx(v, r, [], xU)), n(8, p = void 0), n(21, ye = !1);
      } catch (t) {
        try {
          n(7, v = JSON.parse(Ds(e))), n(14, X = kx(v, r, [], xU)), n(8, p = e), n(21, ye = !0);
        } catch (t) {
          n(7, v = void 0), n(14, X = kx(v, wx(v), [], xU)), n(8, p = e), n(21, ye = !1);
        }
      }
      if ("function" == typeof t) {
        var c = t(v, X, ee);
        n(7, v = c && c.json ? c.json : v), n(14, X = c && c.state ? c.state : X), n(9, ee = c && c.selection ? c.selection : ee);
      }
      n(9, ee = ke(ee, v)), we({
        previousJson: i,
        previousState: r,
        previousText: o,
        previousTextIsRepaired: s,
        previousSelection: u
      }), rt(a, null);
    }(e, function (e, t) {
      if (e) {
        return {
          state: at(e, t, [])
        };
      }
    });
  }
  function Te() {
    if (!C && ee) {
      var e = ee.type === Hx || ee.type === Wx ? sj(v, X, {
        type: Ux,
        anchorPath: ee.anchorPath,
        focusPath: ee.focusPath
      }) : ee;
      if (Ym(ee.focusPath)) {
        c("remove root", {
          selection: ee
        });
        B({
          text: "",
          json: void 0
        }, {
          text: p,
          json: v
        }, null);
      } else {
        var t = $F(v, X, e),
          n = t.operations,
          r = t.newSelection;
        c("remove", {
          operations: n,
          selection: ee,
          newSelection: r
        }), it(n, function () {
          return {
            selection: r
          };
        });
      }
    }
  }
  function Ne() {
    C || !Se() || Ym(ee.focusPath) || (c("duplicate", {
      selection: ee
    }), it(function (e, t, n) {
      var r = Gv(n);
      if (Ym(r)) throw new Error("Cannot duplicate root object");
      var i = _m(r),
        o = Gv(r),
        a = ks.exports.getIn(e, i);
      if (Array.isArray(a)) {
        var s = Gv(n),
          u = s ? parseInt(Gv(s), 10) + 1 : 0;
        return Ii(n.map(function (e, t) {
          return {
            op: "copy",
            from: ks.exports.compileJSONPointer(e),
            path: ks.exports.compileJSONPointer(i.concat(t + u))
          };
        }));
      }
      var c = Ex(t, i),
        l = Ix(c, o, !1);
      return [].concat(Ii(n.map(function (e) {
        var t = gF(Gv(e), c);
        return {
          op: "copy",
          from: ks.exports.compileJSONPointer(e),
          path: ks.exports.compileJSONPointer(i.concat(t))
        };
      })), Ii(l.map(function (e) {
        return CF(i, e);
      })));
    }(v, X, ee.paths || [ee.focusPath])));
  }
  function Re() {
    C || !ee || ee.type !== Ux && ee.type !== Wx || Ym(ee.focusPath) || (c("extract", {
      selection: ee
    }), it(function (e, t, n) {
      if (n.type === Wx) return [{
        op: "move",
        from: ks.exports.compileJSONPointer(n.focusPath),
        path: ""
      }];
      if (n.type === Ux) {
        var r = _m(n.focusPath),
          i = ks.exports.getIn(e, r);
        if (Array.isArray(i)) return [{
          op: "replace",
          path: "",
          value: n.paths.map(function (e) {
            var t = Gv(e);
            return i[t];
          })
        }];
        var o = {};
        return n.paths.forEach(function (e) {
          var t = Gv(e);
          o[t] = i[t];
        }), [{
          op: "replace",
          path: "",
          value: o
        }];
      }
      throw new Error("Cannot extract: unsupported type of selection " + JSON.stringify(n));
    }(v, 0, ee), function (e, t) {
      if (Ls(e)) {
        return {
          state: at(e, t, [])
        };
      }
    }), pt());
  }
  function De(e) {
    if (!C && ee) {
      var t = function (e, t, n) {
        if ("object" === n) return {};
        if ("array" === n) return [];
        if ("structure" === n) {
          var r = Jx(t),
            i = ks.exports.getIn(e, r);
          if (Array.isArray(i) && !Ym(i)) {
            var o = Bp(i);
            return Ls(o) ? Td(o, function (e) {
              return Array.isArray(e) ? [] : zs(e) ? void 0 : "";
            }) : "";
          }
        }
        return "";
      }(v, ee, e);
      if (void 0 !== v) {
        var n = JSON.stringify(t),
          r = jF(v, X, ee, n);
        c("handleInsert", {
          type: e,
          operations: r,
          newValue: t,
          data: n
        });
        var i = Gv(r.filter(function (e) {
          return "add" === e.op || "replace" === e.op;
        }));
        it(r, function (e, n) {
          if (i) {
            var r = px(e, i.path);
            return Ls(t) ? {
              state: Cx(e, n, r, jU),
              selection: sj(e || {}, n, {
                type: Vx,
                path: r
              })
            } : "" === t ? {
              selection: sj(e, n, {
                type: zs(Ym(r) ? null : ks.exports.getIn(e, _m(r))) ? Hx : Wx,
                path: r,
                edit: !0
              })
            } : void 0;
          }
        }), i && (pt(), "" === t && oa().then(function () {
          setTimeout(function () {
            return Fe("", !0);
          });
        }));
      } else {
        c("handleInsert", {
          type: e,
          newValue: t
        });
        var o = [];
        ot(t, function (e, t) {
          return {
            state: at(e, t, o),
            selection: sj(e, t, {
              type: Vx,
              path: o
            })
          };
        }), pt();
      }
    }
  }
  function ze(e) {
    ee.type === Hx && n(9, ee = sj(v, X, {
      type: Wx,
      path: ee.focusPath
    })), De(e);
  }
  function Le(e) {
    if (!C && ee) if (lj(ee)) try {
      var t = ee.anchorPath,
        n = ks.exports.getIn(v, t),
        r = function (e, t) {
          if ("array" === t) {
            if (Array.isArray(e)) return e;
            if (zs(e)) return Ys(e);
            if ("string" == typeof e) {
              var n = JSON.parse(e);
              if (Array.isArray(n)) return n;
              if (zs(n)) return Ys(n);
            }
          }
          if ("object" === t) {
            if (Array.isArray(e)) return Qs(e);
            if (zs(e)) return e;
            if ("string" == typeof e) {
              var r = JSON.parse(e);
              if (zs(r)) return r;
              if (Array.isArray(r)) return Qs(r);
            }
          }
          if ("value" === t) return Ls(e) ? JSON.stringify(e) : e;
          throw new Error("Cannot convert ".concat(qs(e), " to ").concat(t));
        }(n, e);
      if (r === n) return;
      var i = [{
        op: "replace",
        path: ks.exports.compileJSONPointer(t),
        value: r
      }];
      c("handleConvert", {
        selection: ee,
        path: t,
        type: e,
        operations: i
      }), it(i, function (e, t) {
        return {
          state: at(e, t, ee.focusPath)
        };
      }), pt();
    } catch (e) {
      L(e);
    } else L(new Error("Cannot convert current selection to ".concat(e)));
  }
  function Be() {
    var e = Yx(v, X, ee, !1),
      t = _m(ee.focusPath);
    !Ym(e.focusPath) && Zm(t, _m(e.focusPath)) ? n(9, ee = sj(v, X, {
      type: Fx,
      path: e.focusPath
    })) : n(9, ee = sj(v, X, {
      type: Vx,
      path: t
    })), c("insert before", {
      selection: ee,
      selectionBefore: e,
      parentPath: t
    }), oa().then(dt);
  }
  function qe() {
    var e = ee.paths ? Gv(ee.paths) : ee.focusPath;
    c("insert after", e), n(9, ee = sj(v, X, {
      type: Fx,
      path: e
    })), oa().then(dt);
  }
  function Fe(e, t) {
    var n = Aj(d).document.activeElement;
    n.isContentEditable && (n.textContent = t ? e : n.textContent + e, Oj(n));
  }
  function Ve(e) {
    return He.apply(this, arguments);
  }
  function He() {
    return (He = yi(mi().mark(function e(t) {
      var r, i;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!C && ee) {
                e.next = 2;
                break;
              }
              return e.abrupt("return");
            case 2:
              if (ee.type !== Hx) {
                e.next = 9;
                break;
              }
              return r = !ee.edit, n(9, ee = Pi(Pi({}, ee), {}, {
                edit: !0
              })), e.next = 7, oa();
            case 7:
              return setTimeout(function () {
                return Fe(t, r);
              }), e.abrupt("return");
            case 9:
              if ("{" !== t) {
                e.next = 13;
                break;
              }
              De("object"), e.next = 28;
              break;
            case 13:
              if ("[" !== t) {
                e.next = 17;
                break;
              }
              De("array"), e.next = 28;
              break;
            case 17:
              if (ee.type !== Wx) {
                e.next = 26;
                break;
              }
              if (Ls(ks.exports.getIn(v, ee.focusPath))) {
                e.next = 24;
                break;
              }
              return i = !ee.edit, n(9, ee = Pi(Pi({}, ee), {}, {
                edit: !0
              })), e.next = 23, oa();
            case 23:
              setTimeout(function () {
                return Fe(t, i);
              });
            case 24:
              e.next = 28;
              break;
            case 26:
              return e.next = 28, We(t);
            case 28:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function We(e) {
    return Ue.apply(this, arguments);
  }
  function Ue() {
    return (Ue = yi(mi().mark(function e(t) {
      var r, i, o;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!C && ee) {
                e.next = 2;
                break;
              }
              return e.abrupt("return");
            case 2:
              return De("value"), r = !ee.edit, i = ee.focusPath, o = ks.exports.getIn(v, _m(i)), n(9, ee = sj(v, X, {
                type: Array.isArray(o) || !o || ee.type === Wx ? Wx : Hx,
                path: i,
                edit: !0
              })), e.next = 9, oa();
            case 9:
              setTimeout(function () {
                return Fe(t, r);
              });
            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function Je() {
    if (!C && me.getState().canUndo) {
      var e = me.undo();
      if (e) {
        var t = {
          json: v,
          text: p
        };
        n(9, ee = e.undo.selection), n(7, v = e.undo.patch ? ks.exports.immutableJSONPatch(v, e.undo.patch) : e.undo.json), n(14, X = e.undo.state), n(8, p = e.undo.text), n(21, ye = e.undo.textIsRepaired), c("undo", {
          item: e,
          json: v,
          state: X,
          selection: ee
        }), rt(t, {
          json: v,
          previousJson: t.json,
          redo: e.undo.patch,
          undo: e.redo.patch
        }), pt(), ee && Xe(ee.focusPath);
      }
    }
  }
  function Ke() {
    if (!C && me.getState().canRedo) {
      var e = me.redo();
      if (e) {
        var t = {
          json: v,
          text: p
        };
        n(9, ee = e.redo.selection), n(7, v = e.redo.patch ? ks.exports.immutableJSONPatch(v, e.redo.patch) : e.redo.json), n(14, X = e.redo.state), n(8, p = e.redo.text), n(21, ye = e.redo.textIsRepaired), c("redo", {
          item: e,
          json: v,
          state: X,
          selection: ee
        }), rt(t, {
          json: v,
          previousJson: t.json,
          redo: e.redo.patch,
          undo: e.undo.patch
        }), pt(), ee && Xe(ee.focusPath);
      }
    }
  }
  function Ge(e) {
    var t;
    C || (Y = !0, G({
      id: g,
      json: v,
      selectedPath: e,
      onSort: (t = yi(mi().mark(function t(n) {
        return mi().wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                c("onSort", e, n), it(n, function (t, n) {
                  return {
                    state: at(t, n, e),
                    selection: sj(t, n, {
                      type: Wx,
                      path: e
                    })
                  };
                });
              case 2:
              case "end":
                return t.stop();
            }
          }
        }, t);
      })), function (e) {
        return t.apply(this, arguments);
      }),
      onClose: function onClose() {
        Y = !1, pt();
      }
    }));
  }
  function Qe() {
    ee && Ge(ij(v, ee));
  }
  function Ye(e) {
    var t = e.id,
      n = e.selectedPath,
      r = e.onTransform,
      i = e.onClose;
    Y = !0, Q({
      id: t || y,
      json: v,
      selectedPath: n,
      onTransform: r ? function (e) {
        r({
          operations: e,
          json: v,
          transformedJson: ks.exports.immutableJSONPatch(v, e)
        });
      } : function (e) {
        c("onTransform", n, e), it(e, function (e, t) {
          return {
            state: at(e, t, n),
            selection: sj(e, t, {
              type: Wx,
              path: n
            })
          };
        });
      },
      onClose: function onClose() {
        Y = !1, pt(), i && i();
      }
    });
  }
  function Ze() {
    ee && Ye({
      selectedPath: ij(v, ee)
    });
  }
  function Xe(e) {
    return et.apply(this, arguments);
  }
  function et() {
    return (et = yi(mi().mark(function e(t) {
      var r, i;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n(14, X = Sx(v, X, t)), e.next = 3, oa();
            case 3:
              (r = tt(t)) && (c("scrollTo", {
                path: t,
                elem: r,
                refContents: f
              }), i = -f.getBoundingClientRect().height / 4, j(r, {
                container: f,
                offset: i,
                duration: 300
              }));
            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function tt(e) {
    return f ? f.querySelector('div[data-path="'.concat(Ij(e), '"]')) : null;
  }
  function nt(e) {
    var t = tt(e);
    if (t && f) {
      var n = f.getBoundingClientRect(),
        r = t.getBoundingClientRect(),
        i = Ls(ks.exports.getIn(v, e)) ? 20 : r.height;
      r.top < n.top + 20 ? j(t, {
        container: f,
        offset: -20,
        duration: 0
      }) : r.top + i > n.bottom - 20 && j(t, {
        container: f,
        offset: -(n.height - i - 20),
        duration: 0
      });
    }
  }
  function rt(e, t) {
    void 0 !== p ? B({
      text: p,
      json: void 0
    }, e, t) : void 0 !== v && B({
      text: void 0,
      json: v
    }, e, t);
  }
  function it(e, t) {
    if (!C) {
      c("handlePatch", e, t);
      var r = {
          json: v,
          text: p
        },
        i = je(e, t);
      return n(15, Z = void 0), rt(r, i), i;
    }
  }
  function ot(e, t) {
    var r = X,
      i = v,
      o = p,
      a = {
        json: v,
        text: p
      },
      s = ye,
      u = ee,
      c = kx(e, r, [], xU),
      l = "function" == typeof t ? t(e, c, ee) : void 0;
    n(7, v = l && void 0 !== l.json ? l.json : e), n(14, X = l && void 0 !== l.state ? l.state : c), n(8, p = void 0), n(21, ye = !1), n(9, ee = l && l.selection ? l.selection : ee), n(9, ee = ke(ee, v)), we({
      previousJson: i,
      previousState: r,
      previousText: o,
      previousTextIsRepaired: s,
      previousSelection: u
    });
    rt(a, null);
  }
  function at(e, t, n) {
    return Cx(e, t, n, !au({
      json: ks.exports.getIn(e, n)
    }, 10240) ? jU : xU);
  }
  function st(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
    n(14, X = t ? Cx(v, X, e, r ? jU : xU) : _x(v, X, e)), ee && !t && Qx(ee, e) && n(9, ee = null), setTimeout(function () {
      Ej(d) || pt();
    });
  }
  function ut(e, t) {
    n(9, ee = e ? sj(v, X, e) : null), !1 !== (null == t ? void 0 : t.ensureFocus) && setTimeout(function () {
      return pt();
    });
  }
  function ct(e) {
    c("openFind", {
      findAndReplace: e
    }), n(16, re = !1), n(17, ie = !1), oa().then(function () {
      n(16, re = !0), n(17, ie = e);
    });
  }
  function lt(e, t) {
    c("handleExpandSection", e, t), n(14, X = function (e, t, n, r) {
      return kx(e, ks.exports.updateIn(t, n.concat(ts), function (e) {
        return gx(e.concat(r));
      }), n, function () {
        return !1;
      });
    }(v, X, e, t));
  }
  function ft(e) {
    c("pasted json as text", e), n(15, Z = e);
  }
  function ht(e) {
    var t = e.anchor,
      n = e.left,
      r = e.top,
      i = e.width,
      o = e.height,
      a = e.offsetTop,
      s = e.offsetLeft,
      u = e.showTip;
    Y = !0, k(SV, {
      json: v,
      state: X,
      selection: ee,
      showTip: u,
      onEditKey: Ce,
      onEditValue: _e,
      onToggleEnforceString: $e,
      onCut: Oe,
      onCopy: Ee,
      onPaste: Me,
      onRemove: Te,
      onDuplicate: Ne,
      onExtract: Re,
      onInsertBefore: Be,
      onInsert: ze,
      onConvert: Le,
      onInsertAfter: qe,
      onSort: Qe,
      onTransform: Ze,
      onCloseContextMenu: function onCloseContextMenu() {
        w(), pt();
      }
    }, {
      left: n,
      top: r,
      offsetTop: a,
      offsetLeft: s,
      width: i,
      height: o,
      anchor: t,
      closeOnOuterClick: !0,
      onClose: function onClose() {
        Y = !1, pt();
      }
    });
  }
  function dt(e) {
    if (!C && !(null == ee ? void 0 : ee.edit)) {
      if (e && (e.stopPropagation(), e.preventDefault()), e && "contextmenu" === e.type && e.target !== h) ht({
        left: e.clientX,
        top: e.clientY,
        width: 260,
        height: 336,
        showTip: !1
      });else {
        var t = null == f ? void 0 : f.querySelector(".jse-context-menu-button.jse-selected");
        if (t) ht({
          anchor: t,
          offsetTop: 2,
          width: 260,
          height: 336,
          showTip: !1
        });else {
          var n = null == f ? void 0 : f.getBoundingClientRect();
          n && ht({
            top: n.top + 2,
            left: n.left + 2,
            width: 260,
            height: 336,
            showTip: !1
          });
        }
      }
      return !1;
    }
  }
  function vt() {
    return (vt = yi(mi().mark(function e() {
      var t, r, i;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return c("apply pasted json", Z), r = (t = Z).path, i = t.contents, n(9, ee = sj(v, X, {
                type: Wx,
                path: r
              })), e.next = 5, oa();
            case 5:
              it([{
                op: "replace",
                path: ks.exports.compileJSONPointer(r),
                value: i
              }], function (e, t) {
                return {
                  state: at(e, t, r)
                };
              });
            case 7:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function pt() {
    h && (h.focus(), h.select());
  }
  function mt() {
    return v;
  }
  function gt() {
    return X;
  }
  function yt() {
    return ee;
  }
  return e.$$set = function (e) {
    "readOnly" in e && n(0, C = e.readOnly), "externalContent" in e && n(49, _ = e.externalContent), "mainMenuBar" in e && n(1, O = e.mainMenuBar), "navigationBar" in e && n(2, E = e.navigationBar), "escapeControlCharacters" in e && n(50, M = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && n(51, T = e.escapeUnicodeCharacters), "validator" in e && n(52, R = e.validator), "indentation" in e && n(53, z = e.indentation), "onError" in e && n(54, L = e.onError), "onChange" in e && n(55, B = e.onChange), "onRenderValue" in e && n(56, q = e.onRenderValue), "onRequestRepair" in e && n(3, V = e.onRequestRepair), "onRenderMenu" in e && n(4, W = e.onRenderMenu), "onClassName" in e && n(57, U = e.onClassName), "onFocus" in e && n(58, J = e.onFocus), "onBlur" in e && n(59, K = e.onBlur), "onSortModal" in e && n(60, G = e.onSortModal), "onTransformModal" in e && n(61, Q = e.onTransformModal);
  }, e.$$.update = function () {
    1572864 & e.$$.dirty[1] && n(71, r = hj({
      escapeControlCharacters: M,
      escapeUnicodeCharacters: T
    })), 640 & e.$$.dirty[0] && n(23, i = cj(v, ee)), 128 & e.$$.dirty[0] | 128 & e.$$.dirty[2] && pe(ae, v), 262144 & e.$$.dirty[1] && be(_), e.$$.dirty[0], 128 & e.$$.dirty[0] | 2097152 & e.$$.dirty[1] && n(11, o = R ? R(v) : []), 2048 & e.$$.dirty[0] && n(22, a = function (e) {
      var t;
      return e.forEach(function (e) {
        var n = e.path.concat([ss]);
        t = ks.exports.setIn(t, n, e, !0);
      }), e.forEach(function (e) {
        for (var n = e.path; n.length > 0;) {
          var r = (n = _m(n)).concat([ss]);
          if (!ks.exports.existsIn(t, r)) {
            var i = {
              isChildError: !0,
              path: n,
              message: "Contains invalid data"
            };
            t = ks.exports.setIn(t, r, i, !0);
          }
        }
      }), t;
    }(o)), 64 & e.$$.dirty[0] && n(70, u = vF(f)), 1 & e.$$.dirty[0] | 100663296 & e.$$.dirty[1] | 768 & e.$$.dirty[2] && n(10, s = {
      readOnly: C,
      normalization: r,
      getFullJson: mt,
      getFullState: gt,
      getFullSelection: yt,
      findElement: tt,
      focus: pt,
      onPatch: it,
      onInsert: De,
      onExpand: st,
      onSelect: ut,
      onFind: ct,
      onPasteJson: ft,
      onExpandSection: lt,
      onRenderValue: q,
      onContextMenu: ht,
      onClassName: U || kc,
      onDrag: u.onDrag,
      onDragEnd: u.onDragEnd
    }), 1024 & e.$$.dirty[0] && c("context changed", s);
  }, [C, O, E, V, W, function () {
    return ye && void 0 !== v && ot(v), {
      json: v,
      text: p
    };
  }, f, v, p, ee, s, o, h, d, X, Z, re, ie, oe, ne, ge, ye, a, i, l, [], se, function () {
    return ce.apply(this, arguments);
  }, function () {
    return le.apply(this, arguments);
  }, function (e, t) {
    return fe.apply(this, arguments);
  }, function (e, t) {
    return he.apply(this, arguments);
  }, function () {
    n(16, re = !1), n(17, ie = !1), se(""), pt();
  }, function (e) {
    c("select validation error", e), n(9, ee = sj(v, X, {
      type: Wx,
      path: e.path
    })), Xe(e.path), pt();
  }, Ee, function (e) {
    if (e.preventDefault(), !C) {
      var t = e.clipboardData.getData("text/plain");
      try {
        Ie(t);
      } catch (e) {
        !function (e, t) {
          m(rV, {
            text: e,
            onParse: eu,
            onRepair: tu,
            onApply: t,
            onRenderMenu: W,
            onFocus: J,
            onBlur: K
          }, Pi(Pi({}, cs), {}, {
            styleWindow: Pi(Pi({}, cs.styleWindow), {}, {
              width: "600px",
              height: "500px"
            }),
            styleContent: {
              padding: 0,
              height: "100%"
            }
          }), {
            onClose: function onClose() {
              return pt();
            }
          });
        }(t, function (e) {
          c("repaired pasted text: ", e), Ie(e);
        });
      }
    }
  }, Je, Ke, function () {
    Ge([]);
  }, function () {
    Ye({
      selectedPath: []
    });
  }, function () {
    st([], !0, !0);
  }, function () {
    st([], !1, !0);
  }, function (e) {
    var t = Dj(e).replace(/^Command\+/, "Ctrl+"),
      r = e.shiftKey;
    if ("Ctrl+X" === t && (e.preventDefault(), Oe(!0)), "Ctrl+Shift+X" === t && (e.preventDefault(), Oe(!1)), "Ctrl+C" === t && (e.preventDefault(), Ee(!0)), "Ctrl+Shift+C" === t && (e.preventDefault(), Ee(!1)), "Ctrl+D" === t && (e.preventDefault(), Ne()), "Delete" !== t && "Backspace" !== t || (e.preventDefault(), Te()), "Insert" === t && (e.preventDefault(), De("structure")), "Ctrl+A" === t && (e.preventDefault(), n(9, ee = {
      type: Wx,
      anchorPath: [],
      focusPath: []
    })), "Ctrl+Q" === t && dt(e), "Up" !== t && "Shift+Up" !== t || (e.preventDefault(), n(9, ee = ee ? Yx(v, X, ee, r, !0) || ee : ej(v, X)), nt(ee.focusPath)), "Down" !== t && "Shift+Down" !== t || (e.preventDefault(), n(9, ee = ee ? Zx(v, X, ee, r, !0) || ee : ej(v, X)), nt(ee.focusPath)), "Left" !== t && "Shift+Left" !== t || (e.preventDefault(), n(9, ee = ee ? function (e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
        i = Xx(e, t, n, !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4]),
        o = i.caret,
        a = i.previous;
      if (r) return n.type !== Ux ? sj(e, t, {
        type: Ux,
        anchorPath: n.anchorPath,
        focusPath: n.focusPath
      }) : null;
      if (o && a) return sj(e, t, {
        type: a.type,
        path: a.path
      });
      var s = _m(n.focusPath),
        u = ks.exports.getIn(e, s);
      return n.type === Wx && Array.isArray(u) ? sj(e, t, {
        type: Ux,
        anchorPath: n.focusPath,
        focusPath: n.focusPath
      }) : n.type !== Ux || Array.isArray(u) ? null : sj(e, t, {
        type: Hx,
        path: n.focusPath
      });
    }(v, X, ee, r, !C) || ee : ej(v, X)), nt(ee.focusPath)), "Right" !== t && "Shift+Right" !== t || (e.preventDefault(), n(9, ee = ee ? function (e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
        i = Xx(e, t, n, !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4]),
        o = i.caret,
        a = i.next;
      return r ? n.type !== Ux ? sj(e, t, {
        type: Ux,
        anchorPath: n.anchorPath,
        focusPath: n.focusPath
      }) : null : o && a ? sj(e, t, {
        type: a.type,
        path: a.path
      }) : n.type === Ux ? sj(e, t, {
        type: Wx,
        path: n.focusPath
      }) : null;
    }(v, X, ee, r, !C) || ee : ej(v, X)), nt(ee.focusPath)), "Enter" === t && ee) {
      if (!C && ee.type === Ux && 1 === ee.paths.length) {
        var i = ee.focusPath,
          o = ks.exports.getIn(v, _m(i));
        Array.isArray(o) && n(9, ee = sj(v, X, {
          type: Wx,
          path: i
        }));
      }
      if (C || ee.type !== Hx || (e.preventDefault(), n(9, ee = Pi(Pi({}, ee), {}, {
        edit: !0
      }))), ee.type === Wx) e.preventDefault(), Ls(ks.exports.getIn(v, ee.focusPath)) ? st(ee.focusPath, !0) : C || n(9, ee = Pi(Pi({}, ee), {}, {
        edit: !0
      }));
    }
    if (t.length === (t.startsWith("Shift+") ? 7 : 1) && ee) return e.preventDefault(), void Ve(e.key);
    if ("Enter" === t && (ee.type === Fx || ee.type === Vx)) return e.preventDefault(), void Ve("");
    if ("Ctrl+Enter" === t && ee && ee.type === Wx) {
      var a = ks.exports.getIn(v, ee.focusPath);
      Vs(a) && window.open(a, "_blank");
    }
    if ("Escape" === t && ee && (e.preventDefault(), n(9, ee = null)), "Ctrl+F" === t && (e.preventDefault(), ct(!1)), "Ctrl+H" === t && (e.preventDefault(), ct(!0)), "Ctrl+Z" === t) {
      e.preventDefault();
      var s = document.activeElement;
      s && s.blur && s.focus ? (s.blur(), setTimeout(function () {
        Je(), setTimeout(function () {
          return s.select();
        });
      })) : Je();
    }
    if ("Ctrl+Shift+Z" === t) {
      e.preventDefault();
      var u = document.activeElement;
      u && u.blur && u.focus ? (u.blur(), setTimeout(function () {
        Ke(), setTimeout(function () {
          return u.select();
        });
      })) : Ke();
    }
  }, function (e) {
    c("handleMouseDown", e), setTimeout(function () {
      setTimeout(function () {
        x || Sj(e.target, "BUTTON") || (pt(), ee || void 0 !== v || "" !== p && void 0 !== p || n(9, ee = xe()));
      });
    });
  }, dt, function (e) {
    C || ht({
      anchor: Pj(e.target, "BUTTON"),
      offsetTop: 0,
      width: 260,
      height: 336,
      showTip: !0
    });
  }, function () {
    return vt.apply(this, arguments);
  }, function () {
    c("clear pasted json"), n(15, Z = void 0);
  }, function (e) {
    n(9, ee = e), pt(), Xe(e.focusPath);
  }, function (e) {
    !_j(e.target, function (e) {
      return e === d;
    }) && ee && ee.edit && (c("click outside the editor, stop edit mode"), n(9, ee = Pi(Pi({}, ee), {}, {
      edit: !1
    })), x && h && (h.focus(), h.blur()), oa().then(function () {
      setTimeout(function () {
        h && h.blur();
      });
    }));
  }, _, M, T, R, z, L, B, q, U, J, K, G, Q, function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function () {
      return !0;
    };
    n(14, X = kx(v, X, [], e, !0));
  }, function () {
    return v;
  }, je, Ye, Xe, tt, pt, ae, u, r, function (e) {
    n(16, re = e);
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(12, h = e);
    });
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(6, f = e);
    });
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(13, d = e);
    });
  }];
}
var CU = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, SU, wU, Ki, {
        readOnly: 0,
        externalContent: 49,
        mainMenuBar: 1,
        navigationBar: 2,
        escapeControlCharacters: 50,
        escapeUnicodeCharacters: 51,
        validator: 52,
        indentation: 53,
        onError: 54,
        onChange: 55,
        onRenderValue: 56,
        onRequestRepair: 3,
        onRenderMenu: 4,
        onClassName: 57,
        onFocus: 58,
        onBlur: 59,
        onSortModal: 60,
        onTransformModal: 61,
        expand: 62,
        get: 63,
        patch: 64,
        acceptAutoRepair: 5,
        openTransformModal: 65,
        scrollTo: 66,
        findElement: 67,
        focus: 68
      }, lU, [-1, -1, -1, -1, -1]), r;
    }
    return zi(n, [{
      key: "expand",
      get: function get() {
        return this.$$.ctx[62];
      }
    }, {
      key: "get",
      get: function get() {
        return this.$$.ctx[63];
      }
    }, {
      key: "patch",
      get: function get() {
        return this.$$.ctx[64];
      }
    }, {
      key: "acceptAutoRepair",
      get: function get() {
        return this.$$.ctx[5];
      }
    }, {
      key: "openTransformModal",
      get: function get() {
        return this.$$.ctx[65];
      }
    }, {
      key: "scrollTo",
      get: function get() {
        return this.$$.ctx[66];
      }
    }, {
      key: "findElement",
      get: function get() {
        return this.$$.ctx[67];
      }
    }, {
      key: "focus",
      get: function get() {
        return this.$$.ctx[68];
      }
    }]), n;
  }(),
  _U = {
    id: "javascript",
    name: "JavaScript",
    description: "\n<p>\n  Enter a JavaScript function to filter, sort, or transform the data.\n</p>\n",
    createQuery: function createQuery(e, t) {
      var n = t.filter,
        r = t.sort,
        i = t.projection,
        o = [];
      if (n && n.path && n.relation && n.value) {
        var a = "item => item".concat(iC(n.path)),
          s = "string" == typeof bF(n.value) ? "'".concat(n.value, "'") : n.value;
        o.push("  data = data.filter(".concat(a, " ").concat(n.relation, " ").concat(s, ")\n"));
      }
      r && r.path && r.direction && ("desc" === r.direction ? o.push("  data = data.slice().sort((a, b) => {\n    // sort descending\n" + "    const valueA = a".concat(iC(r.path), "\n") + "    const valueB = b".concat(iC(r.path), "\n") + "    return valueA > valueB ? -1 : valueA < valueB ? 1 : 0\n  })\n") : o.push("  data = data.slice().sort((a, b) => {\n    // sort ascending\n" + "    const valueA = a".concat(iC(r.path), "\n") + "    const valueB = b".concat(iC(r.path), "\n") + "    return valueA > valueB ? 1 : valueA < valueB ? -1 : 0\n  })\n"));
      if (i && i.paths) if (i.paths.length > 1) {
        var u = i.paths.map(function (e) {
          var t = e[e.length - 1] || "item",
            n = "item".concat(iC(e));
          return "    ".concat(JSON.stringify(t), ": ").concat(n);
        });
        o.push("  data = data.map(item => ({\n".concat(u.join(",\n"), "})\n  )\n"));
      } else {
        var c = "item".concat(iC(i.paths[0]));
        o.push("  data = data.map(item => ".concat(c, ")\n"));
      }
      return o.push("  return data\n"), "function query (data) {\n".concat(o.join(""), "}");
    },
    executeQuery: function executeQuery(e, t) {
      var n = new Function('"use strict";\n\n' + t + '\n\nif (typeof query !== "function") {\n  throw new Error("Cannot execute query: expecting a function named \'query\' but is undefined")\n}\n\nreturn query;\n')()(e);
      return void 0 !== n ? n : null;
    }
  };
function $U(e) {
  co(e, "svelte-zs5o25", ".jse-boolean-toggle.svelte-zs5o25{color:var(--jse-value-color-boolean);position:relative;padding-left:calc(0.5 * var(--jse-padding));padding-top:1px;height:var(--jse-line-height)}");
}
function OU(e) {
  var t, n, r, _i28, o, a;
  return n = new KS({
    props: {
      data: !0 === e[0] ? mV : pV
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), So(t, "class", "jse-boolean-toggle svelte-zs5o25"), So(t, "title", r = e[1] ? "Boolean value ".concat(e[0]) : "Click to toggle this boolean value");
    },
    m: function m(r, s) {
      vo(r, t, s), Ea(n, t, null), _i28 = !0, o || (a = xo(t, "mousedown", e[2]), o = !0);
    },
    p: function p(e, o) {
      var a = xi(o, 1)[0],
        s = {};
      1 & a && (s.data = !0 === e[0] ? mV : pV), n.$set(s), (!_i28 || 3 & a && r !== (r = e[1] ? "Boolean value ".concat(e[0]) : "Click to toggle this boolean value")) && So(t, "title", r);
    },
    i: function i(e) {
      _i28 || (ya(n.$$.fragment, e), _i28 = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), _i28 = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), o = !1, a();
    }
  };
}
function AU(e, t, n) {
  var r = t.path,
    i = t.value,
    o = t.readOnly,
    a = t.onPatch,
    s = t.onSelect;
  return e.$$set = function (e) {
    "path" in e && n(3, r = e.path), "value" in e && n(0, i = e.value), "readOnly" in e && n(1, o = e.readOnly), "onPatch" in e && n(4, a = e.onPatch), "onSelect" in e && n(5, s = e.onSelect);
  }, [i, o, function (e) {
    e.stopPropagation(), o || (a([{
      op: "replace",
      path: ks.exports.compileJSONPointer(r),
      value: !i
    }]), s({
      type: Wx,
      path: r
    }));
  }, r, a, s];
}
var EU = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, AU, OU, Ki, {
      path: 3,
      value: 0,
      readOnly: 1,
      onPatch: 4,
      onSelect: 5
    }, $U), r;
  }
  return zi(n);
}();
function PU(e) {
  co(e, "svelte-1gn8yt9", ".jse-color-picker-popup.svelte-1gn8yt9 .picker_wrapper.popup,.jse-color-picker-popup.svelte-1gn8yt9 .picker_wrapper.popup .picker_arrow::before,.jse-color-picker-popup.svelte-1gn8yt9 .picker_wrapper.popup .picker_arrow::after{background:var(--jse-color-picker-background);line-height:normal}.jse-color-picker-popup.svelte-1gn8yt9 .picker_slider,.jse-color-picker-popup.svelte-1gn8yt9 .picker_sl,.jse-color-picker-popup.svelte-1gn8yt9 .picker_editor input,.jse-color-picker-popup.svelte-1gn8yt9 .picker_sample,.jse-color-picker-popup.svelte-1gn8yt9 .picker_done button{box-shadow:var(--jse-color-picker-border-box-shadow)}.jse-color-picker-popup.svelte-1gn8yt9 .picker_editor input{background:var(--jse-background-color);color:var(--jse-text-color)}.jse-color-picker-popup.svelte-1gn8yt9 .picker_done button{background:var(--jse-button-background);color:var(--jse-button-color)}.jse-color-picker-popup.svelte-1gn8yt9 .picker_done button:hover{background:var(--jse-button-background-highlight)}");
}
function MU(e) {
  var t;
  return {
    c: function c() {
      So(t = go("div"), "class", "jse-color-picker-popup svelte-1gn8yt9");
    },
    m: function m(n, r) {
      vo(n, t, r), e[4](t);
    },
    p: Bi,
    i: Bi,
    o: Bi,
    d: function d(n) {
      n && po(t), e[4](null);
    }
  };
}
function IU(e, t, n) {
  var r,
    i,
    o = t.color,
    a = t.onChange,
    s = t.showOnTop;
  return Jo(yi(mi().mark(function e() {
    var t;
    return mi().wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.next = 2, Promise.resolve().then(function () {
              return zG;
            });
          case 2:
            t = e.sent.default, (i = new t({
              parent: r,
              color: o,
              popup: s ? "top" : "bottom",
              onDone: function onDone(e) {
                var t = 1 === e.rgba[3] ? e.hex.substring(0, 7) : e.hex;
                a(t);
              }
            })).show();
          case 5:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))), Ko(function () {
    i && i.destroy();
  }), e.$$set = function (e) {
    "color" in e && n(1, o = e.color), "onChange" in e && n(2, a = e.onChange), "showOnTop" in e && n(3, s = e.showOnTop);
  }, [r, o, a, s, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(0, r = e);
    });
  }];
}
var TU = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, IU, MU, Ji, {
      color: 1,
      onChange: 2,
      showOnTop: 3
    }, PU), r;
  }
  return zi(n);
}();
function NU(e) {
  co(e, "svelte-fk1u9y", ".jse-color-picker-button.svelte-fk1u9y{font-size:var(--jse-font-size-mono);width:var(--jse-color-picker-button-size);height:var(--jse-color-picker-button-size);box-sizing:border-box;padding:0;margin:2px;border:1px solid var(--jse-text-color);border-radius:2px;background:inherit;outline:none;cursor:pointer}");
}
function RU(e) {
  var t, n, r, i;
  return {
    c: function c() {
      So(t = go("button"), "class", "jse-color-picker-button svelte-fk1u9y"), Po(t, "background", e[2]), So(t, "title", n = e[1] ? "Color ".concat(e[0]) : "Click to open a color picker");
    },
    m: function m(n, o) {
      vo(n, t, o), r || (i = xo(t, "click", e[3]), r = !0);
    },
    p: function p(e, r) {
      var i = xi(r, 1)[0];
      4 & i && Po(t, "background", e[2]), 3 & i && n !== (n = e[1] ? "Color ".concat(e[0]) : "Click to open a color picker") && So(t, "title", n);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t), r = !1, i();
    }
  };
}
function DU(e, t, n) {
  var r,
    i = Yo("absolute-popup").openAbsolutePopup,
    o = t.path,
    a = t.value,
    s = t.readOnly,
    u = t.onPatch,
    c = t.onSelect;
  function l(e) {
    u([{
      op: "replace",
      path: ks.exports.compileJSONPointer(o),
      value: e
    }]), f();
  }
  function f() {
    c({
      type: Wx,
      path: o
    });
  }
  return e.$$set = function (e) {
    "path" in e && n(4, o = e.path), "value" in e && n(0, a = e.value), "readOnly" in e && n(1, s = e.readOnly), "onPatch" in e && n(5, u = e.onPatch), "onSelect" in e && n(6, c = e.onSelect);
  }, e.$$.update = function () {
    1 & e.$$.dirty && n(2, r = Bs(a));
  }, [a, s, r, function (e) {
    if (!s) {
      var t = e.target.getBoundingClientRect().top,
        n = Aj(e.target).innerHeight;
      i(TU, {
        color: a,
        onChange: l,
        showOnTop: n - t < 300 && t > 300
      }, {
        anchor: e.target,
        closeOnOuterClick: !0,
        onClose: f,
        offsetTop: 18,
        offsetLeft: -8,
        height: 300
      });
    }
  }, o, u, c];
}
var zU = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, DU, RU, Ki, {
      path: 4,
      value: 0,
      readOnly: 1,
      onPatch: 5,
      onSelect: 6
    }, NU), r;
  }
  return zi(n);
}();
function LU(e) {
  var t = qs(e);
  return _V("jse-value", "jse-" + t, {
    "jse-url": Vs(e),
    "jse-empty": "string" == typeof e && 0 === e.length
  });
}
function BU(e) {
  var t, n;
  return t = new QV({
    props: {
      value: e[1].escapeValue(e[0]),
      onChange: e[3],
      onCancel: e[4],
      onPaste: e[5],
      onFind: e[2],
      onValueClass: e[6]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = xi(n, 1)[0],
        i = {};
      3 & r && (i.value = e[1].escapeValue(e[0])), 4 & r && (i.onFind = e[2]), t.$set(i);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function qU(e, t, n) {
  var r = t.path,
    i = t.value,
    o = t.normalization,
    a = t.enforceString,
    s = t.onPatch,
    u = t.onPasteJson,
    c = t.onSelect,
    l = t.onFind;
  function f(e) {
    return a ? e : Hs(e);
  }
  return e.$$set = function (e) {
    "path" in e && n(7, r = e.path), "value" in e && n(0, i = e.value), "normalization" in e && n(1, o = e.normalization), "enforceString" in e && n(8, a = e.enforceString), "onPatch" in e && n(9, s = e.onPatch), "onPasteJson" in e && n(10, u = e.onPasteJson), "onSelect" in e && n(11, c = e.onSelect), "onFind" in e && n(2, l = e.onFind);
  }, [i, o, l, function (e, t) {
    s([{
      op: "replace",
      path: ks.exports.compileJSONPointer(r),
      value: f(o.unescapeValue(e))
    }]), t === ms && c({
      type: Wx,
      path: r,
      nextInside: !0
    }), t === ps && c({
      type: Wx,
      path: r
    }, {
      ensureFocus: !1
    });
  }, function () {
    c({
      type: Wx,
      path: r
    });
  }, function (e) {
    try {
      var t = JSON.parse(e);
      Ls(t) && u({
        path: r,
        contents: t
      });
    } catch (e) {}
  }, function (e) {
    return LU(f(o.unescapeValue(e)));
  }, r, a, s, u, c];
}
var FU = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, qU, BU, Ki, {
      path: 7,
      value: 0,
      normalization: 1,
      enforceString: 8,
      onPatch: 9,
      onPasteJson: 10,
      onSelect: 11,
      onFind: 2
    }), r;
  }
  return zi(n);
}();
function VU(e) {
  co(e, "svelte-6ci2p7", '.jse-value.jse-string.svelte-6ci2p7{color:var(--jse-value-color-string)}.jse-value.jse-object.svelte-6ci2p7,.jse-value.jse-array.svelte-6ci2p7{min-width:16px;color:var(--jse-delimiter-color)}.jse-value.jse-number.svelte-6ci2p7{color:var(--jse-value-color-number)}.jse-value.jse-boolean.svelte-6ci2p7{color:var(--jse-value-color-boolean)}.jse-value.jse-null.svelte-6ci2p7{color:var(--jse-value-color-null)}.jse-value.jse-invalid.svelte-6ci2p7{color:var(--jse-text-color)}.jse-value.jse-url.svelte-6ci2p7{color:var(--jse-value-color-url);text-decoration:underline}.jse-value.svelte-6ci2p7{min-width:2em;padding:0 5px;box-sizing:border-box;outline:none;border-radius:1px;vertical-align:top;word-break:normal;overflow-wrap:anywhere;white-space:pre-wrap}.jse-value.svelte-6ci2p7:hover{background:var(--jse-hover-background-color)}.jse-value.jse-empty.svelte-6ci2p7{min-width:4em;outline:1px dotted var(--jse-tag-background);-moz-outline-radius:2px}.jse-value.jse-empty.svelte-6ci2p7::after{pointer-events:none;color:var(--jse-tag-background);content:"value"}');
}
function HU(e) {
  var t,
    n = jj(e[1].escapeValue(e[0])) + "";
  return {
    c: function c() {
      t = bo(n);
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: function p(e, r) {
      3 & r && n !== (n = jj(e[1].escapeValue(e[0])) + "") && Ao(t, n);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function WU(e) {
  var t, n;
  return t = new UV({
    props: {
      text: e[1].escapeValue(e[0]),
      searchResult: e[2]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      3 & n && (r.text = e[1].escapeValue(e[0])), 4 & n && (r.searchResult = e[2]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function UU(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    c = [WU, HU],
    l = [];
  function f(e, t) {
    return e[2] ? 0 : 1;
  }
  return n = f(e), r = l[n] = c[n](e), {
    c: function c() {
      t = go("div"), r.c(), So(t, "data-type", "selectable-value"), So(t, "class", i = eo(LU(e[0])) + " svelte-6ci2p7"), So(t, "title", o = e[3] ? "Ctrl+Click or Ctrl+Enter to open url in new window" : null);
    },
    m: function m(r, i) {
      vo(r, t, i), l[n].m(t, null), a = !0, s || (u = [xo(t, "click", e[4]), xo(t, "dblclick", e[5])], s = !0);
    },
    p: function p(e, s) {
      var u = xi(s, 1)[0],
        h = n;
      (n = f(e)) === h ? l[n].p(e, u) : (ma(), ba(l[h], 1, 1, function () {
        l[h] = null;
      }), ga(), (r = l[n]) ? r.p(e, u) : (r = l[n] = c[n](e)).c(), ya(r, 1), r.m(t, null)), (!a || 1 & u && i !== (i = eo(LU(e[0])) + " svelte-6ci2p7")) && So(t, "class", i), (!a || 8 & u && o !== (o = e[3] ? "Ctrl+Click or Ctrl+Enter to open url in new window" : null)) && So(t, "title", o);
    },
    i: function i(e) {
      a || (ya(r), a = !0);
    },
    o: function o(e) {
      ba(r), a = !1;
    },
    d: function d(e) {
      e && po(t), l[n].d(), s = !1, Wi(u);
    }
  };
}
function JU(e, t, n) {
  var r,
    i = t.path,
    o = t.value,
    a = t.readOnly,
    s = t.normalization,
    u = t.onSelect,
    c = t.searchResult;
  return e.$$set = function (e) {
    "path" in e && n(6, i = e.path), "value" in e && n(0, o = e.value), "readOnly" in e && n(7, a = e.readOnly), "normalization" in e && n(1, s = e.normalization), "onSelect" in e && n(8, u = e.onSelect), "searchResult" in e && n(2, c = e.searchResult);
  }, e.$$.update = function () {
    1 & e.$$.dirty && n(3, r = Vs(o));
  }, [o, s, c, r, function (e) {
    "string" == typeof o && r && e.ctrlKey && (e.preventDefault(), e.stopPropagation(), window.open(o, "_blank"));
  }, function (e) {
    a || (e.preventDefault(), u({
      type: Wx,
      path: i,
      edit: !0
    }));
  }, i, a, u];
}
var KU = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, JU, UU, Ki, {
      path: 6,
      value: 0,
      readOnly: 7,
      normalization: 1,
      onSelect: 8,
      searchResult: 2
    }, VU), r;
  }
  return zi(n);
}();
function GU(e) {
  co(e, "svelte-1u00zub", ".jse-timestamp.svelte-1u00zub{padding:0;margin:0;height:var(--jse-line-height);color:var(--jse-value-color-number);border-radius:3px}");
}
function QU(e) {
  var t, n, r, _i29, o, a;
  return n = new KS({
    props: {
      data: dV
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), So(t, "class", "jse-timestamp svelte-1u00zub");
    },
    m: function m(s, u) {
      vo(s, t, u), Ea(n, t, null), _i29 = !0, o || (a = to(r = pH.call(null, t, Pi({
        text: e[0]
      }, e[1]))), o = !0);
    },
    p: function p(e, t) {
      var n = xi(t, 1)[0];
      r && Ui(r.update) && 1 & n && r.update.call(null, Pi({
        text: e[0]
      }, e[1]));
    },
    i: function i(e) {
      _i29 || (ya(n.$$.fragment, e), _i29 = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), _i29 = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), o = !1, a();
    }
  };
}
function YU(e, t, n) {
  var r,
    i = Yo("absolute-popup"),
    o = t.value;
  return e.$$set = function (e) {
    "value" in e && n(2, o = e.value);
  }, e.$$.update = function () {
    4 & e.$$.dirty && n(0, r = "Time: ".concat(new Date(o).toString()));
  }, [r, i, o];
}
var ZU = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, YU, QU, Ki, {
      value: 2
    }, GU), r;
  }
  return zi(n);
}();
function XU(e) {
  var t = e.path,
    n = e.value,
    r = e.readOnly,
    i = e.enforceString,
    o = e.searchResult,
    a = e.isEditing,
    s = e.normalization,
    u = e.onPatch,
    c = e.onPasteJson,
    l = e.onSelect,
    f = e.onFind,
    h = [];
  return !a && function (e) {
    return !0 === e || !1 === e;
  }(n) && h.push({
    component: EU,
    props: {
      path: t,
      value: n,
      readOnly: r,
      onPatch: u,
      onSelect: l
    }
  }), !a && function (e) {
    return "string" == typeof e && !!Bs(e);
  }(n) && h.push({
    component: zU,
    props: {
      path: t,
      value: n,
      readOnly: r,
      onPatch: u,
      onSelect: l
    }
  }), a && h.push({
    component: FU,
    props: {
      path: t,
      value: n,
      enforceString: i,
      normalization: s,
      onPatch: u,
      onPasteJson: c,
      onSelect: l,
      onFind: f
    }
  }), a || h.push({
    component: KU,
    props: {
      path: t,
      value: n,
      readOnly: r,
      normalization: s,
      searchResult: o,
      onSelect: l
    }
  }), !a && function (e) {
    return "number" == typeof e && e > 9466848e5 && isFinite(e) && Math.floor(e) === e && !isNaN(new Date(e).valueOf());
  }(n) && h.push({
    component: ZU,
    props: {
      value: n
    }
  }), h;
}
var eJ = {};
function tJ(e) {
  co(e, "svelte-3e0qet", ".item.svelte-3e0qet{cursor:default;height:var(--height, 42px);line-height:var(--height, 42px);padding:var(--itemPadding, 0 20px);color:var(--itemColor, inherit);text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.groupHeader.svelte-3e0qet{text-transform:var(--groupTitleTextTransform, uppercase)}.groupItem.svelte-3e0qet{padding-left:var(--groupItemPaddingLeft, 40px)}.item.svelte-3e0qet:active{background:var(--itemActiveBackground, #b9daff)}.item.active.svelte-3e0qet{background:var(--itemIsActiveBG, #007aff);color:var(--itemIsActiveColor, #fff)}.item.notSelectable.svelte-3e0qet{color:var(--itemIsNotSelectableColor, #999)}.item.first.svelte-3e0qet{border-radius:var(--itemFirstBorderRadius, 4px 4px 0 0)}.item.hover.svelte-3e0qet:not(.active){background:var(--itemHoverBG, #e7f2ff);color:var(--itemHoverColor, inherit)}");
}
function nJ(e) {
  var t,
    n,
    r = e[0](e[1], e[2]) + "";
  return {
    c: function c() {
      So(t = go("div"), "class", n = "item " + e[3] + " svelte-3e0qet");
    },
    m: function m(e, n) {
      vo(e, t, n), t.innerHTML = r;
    },
    p: function p(e, i) {
      var o = xi(i, 1)[0];
      7 & o && r !== (r = e[0](e[1], e[2]) + "") && (t.innerHTML = r), 8 & o && n !== (n = "item " + e[3] + " svelte-3e0qet") && So(t, "class", n);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function rJ(e, t, n) {
  var r = t.isActive,
    i = void 0 !== r && r,
    o = t.isFirst,
    a = void 0 !== o && o,
    s = t.isHover,
    u = void 0 !== s && s,
    c = t.isSelectable,
    l = void 0 !== c && c,
    f = t.getOptionLabel,
    h = void 0 === f ? void 0 : f,
    d = t.item,
    v = void 0 === d ? void 0 : d,
    p = t.filterText,
    m = void 0 === p ? "" : p,
    g = "";
  return e.$$set = function (e) {
    "isActive" in e && n(4, i = e.isActive), "isFirst" in e && n(5, a = e.isFirst), "isHover" in e && n(6, u = e.isHover), "isSelectable" in e && n(7, l = e.isSelectable), "getOptionLabel" in e && n(0, h = e.getOptionLabel), "item" in e && n(1, v = e.item), "filterText" in e && n(2, m = e.filterText);
  }, e.$$.update = function () {
    if (242 & e.$$.dirty) {
      var t = [];
      i && t.push("active"), a && t.push("first"), u && t.push("hover"), v.isGroupHeader && t.push("groupHeader"), v.isGroupItem && t.push("groupItem"), l || t.push("notSelectable"), n(3, g = t.join(" "));
    }
  }, [h, v, m, g, i, a, u, l];
}
var iJ = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, rJ, nJ, Ji, {
      isActive: 4,
      isFirst: 5,
      isHover: 6,
      isSelectable: 7,
      getOptionLabel: 0,
      item: 1,
      filterText: 2
    }, tJ), r;
  }
  return zi(n);
}();
function oJ(e) {
  co(e, "svelte-1uyqfml", ".listContainer.svelte-1uyqfml{box-shadow:var(--listShadow, 0 2px 3px 0 rgba(44, 62, 80, 0.24));border-radius:var(--listBorderRadius, 4px);max-height:var(--listMaxHeight, 250px);overflow-y:auto;background:var(--listBackground, #fff);border:var(--listBorder, none);position:var(--listPosition, absolute);z-index:var(--listZIndex, 2);width:100%;left:var(--listLeft, 0);right:var(--listRight, 0)}.virtualList.svelte-1uyqfml{height:var(--virtualListHeight, 200px)}.listGroupTitle.svelte-1uyqfml{color:var(--groupTitleColor, #8f8f8f);cursor:default;font-size:var(--groupTitleFontSize, 12px);font-weight:var(--groupTitleFontWeight, 600);height:var(--height, 42px);line-height:var(--height, 42px);padding:var(--groupTitlePadding, 0 20px);text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap;text-transform:var(--groupTitleTextTransform, uppercase)}.empty.svelte-1uyqfml{text-align:var(--listEmptyTextAlign, center);padding:var(--listEmptyPadding, 20px 0);color:var(--listEmptyColor, #78848f)}");
}
function aJ(e, t, n) {
  var r = e.slice();
  return r[41] = t[n], r[42] = n, r;
}
function sJ(e) {
  for (var t, n, r = e[1], _i30 = [], o = 0; o < r.length; o += 1) {
    _i30[o] = dJ(aJ(e, r, o));
  }
  var a = function a(e) {
      return ba(_i30[e], 1, 1, function () {
        _i30[e] = null;
      });
    },
    s = null;
  return r.length || (s = cJ(e)), {
    c: function c() {
      for (var e = 0; e < _i30.length; e += 1) {
        _i30[e].c();
      }
      t = wo(), s && s.c();
    },
    m: function m(e, r) {
      for (var o = 0; o < _i30.length; o += 1) {
        _i30[o].m(e, r);
      }
      vo(e, t, r), s && s.m(e, r), n = !0;
    },
    p: function p(e, n) {
      if (114390 & n[0]) {
        var o;
        for (r = e[1], o = 0; o < r.length; o += 1) {
          var u = aJ(e, r, o);
          _i30[o] ? (_i30[o].p(u, n), ya(_i30[o], 1)) : (_i30[o] = dJ(u), _i30[o].c(), ya(_i30[o], 1), _i30[o].m(t.parentNode, t));
        }
        for (ma(), o = r.length; o < _i30.length; o += 1) {
          a(o);
        }
        ga(), !r.length && s ? s.p(e, n) : r.length ? s && (s.d(1), s = null) : ((s = cJ(e)).c(), s.m(t.parentNode, t));
      }
    },
    i: function i(e) {
      if (!n) {
        for (var t = 0; t < r.length; t += 1) {
          ya(_i30[t]);
        }
        n = !0;
      }
    },
    o: function o(e) {
      _i30 = _i30.filter(Boolean);
      for (var t = 0; t < _i30.length; t += 1) {
        ba(_i30[t]);
      }
      n = !1;
    },
    d: function d(e) {
      mo(_i30, e), e && po(t), s && s.d(e);
    }
  };
}
function uJ(e) {
  var t,
    n,
    r,
    i = e[3];
  function o(e) {
    return {
      props: {
        items: e[1],
        itemHeight: e[8],
        $$slots: {
          default: [vJ, function (e) {
            return {
              41: e.item,
              42: e.i
            };
          }, function (e) {
            return [0, (e.item ? 1024 : 0) | (e.i ? 2048 : 0)];
          }]
        },
        $$scope: {
          ctx: e
        }
      }
    };
  }
  return i && (t = new i(o(e))), {
    c: function c() {
      t && Aa(t.$$.fragment), n = wo();
    },
    m: function m(e, i) {
      t && Ea(t, e, i), vo(e, n, i), r = !0;
    },
    p: function p(e, r) {
      var a = {};
      if (2 & r[0] && (a.items = e[1]), 256 & r[0] && (a.itemHeight = e[8]), 9814 & r[0] | 11264 & r[1] && (a.$$scope = {
        dirty: r,
        ctx: e
      }), i !== (i = e[3])) {
        if (t) {
          ma();
          var s = t;
          ba(s.$$.fragment, 1, 0, function () {
            Pa(s, 1);
          }), ga();
        }
        i ? (Aa((t = new i(o(e))).$$.fragment), ya(t.$$.fragment, 1), Ea(t, n.parentNode, n)) : t = null;
      } else i && t.$set(a);
    },
    i: function i(e) {
      r || (t && ya(t.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      t && ba(t.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(n), t && Pa(t, e);
    }
  };
}
function cJ(e) {
  var t,
    n = !e[11] && lJ(e);
  return {
    c: function c() {
      n && n.c(), t = wo();
    },
    m: function m(e, r) {
      n && n.m(e, r), vo(e, t, r);
    },
    p: function p(e, r) {
      e[11] ? n && (n.d(1), n = null) : n ? n.p(e, r) : ((n = lJ(e)).c(), n.m(t.parentNode, t));
    },
    d: function d(e) {
      n && n.d(e), e && po(t);
    }
  };
}
function lJ(e) {
  var t, n;
  return {
    c: function c() {
      t = go("div"), n = bo(e[12]), So(t, "class", "empty svelte-1uyqfml");
    },
    m: function m(e, r) {
      vo(e, t, r), uo(t, n);
    },
    p: function p(e, t) {
      4096 & t[0] && Ao(n, e[12]);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function fJ(e) {
  var t,
    n,
    r,
    _i31,
    o,
    a,
    s = e[4];
  function u(e) {
    return {
      props: {
        item: e[41],
        filterText: e[13],
        getOptionLabel: e[6],
        isFirst: gJ(e[42]),
        isActive: mJ(e[41], e[9], e[10]),
        isHover: yJ(e[2], e[41], e[42], e[1]),
        isSelectable: bJ(e[41])
      }
    };
  }
  function c() {
    return e[29](e[42]);
  }
  function l() {
    return e[30](e[42]);
  }
  function f() {
    for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
      r[i] = arguments[i];
    }
    return (t = e)[31].apply(t, [e[41], e[42]].concat(r));
  }
  return s && (n = new s(u(e))), {
    c: function c() {
      t = go("div"), n && Aa(n.$$.fragment), r = ko(), So(t, "class", "listItem"), So(t, "tabindex", "-1");
    },
    m: function m(e, s) {
      vo(e, t, s), n && Ea(n, t, null), uo(t, r), _i31 = !0, o || (a = [xo(t, "mouseover", c), xo(t, "focus", l), xo(t, "click", f)], o = !0);
    },
    p: function p(i, o) {
      e = i;
      var a = {};
      if (2 & o[0] && (a.item = e[41]), 8192 & o[0] && (a.filterText = e[13]), 64 & o[0] && (a.getOptionLabel = e[6]), 1538 & o[0] && (a.isActive = mJ(e[41], e[9], e[10])), 6 & o[0] && (a.isHover = yJ(e[2], e[41], e[42], e[1])), 2 & o[0] && (a.isSelectable = bJ(e[41])), s !== (s = e[4])) {
        if (n) {
          ma();
          var c = n;
          ba(c.$$.fragment, 1, 0, function () {
            Pa(c, 1);
          }), ga();
        }
        s ? (Aa((n = new s(u(e))).$$.fragment), ya(n.$$.fragment, 1), Ea(n, t, r)) : n = null;
      } else s && n.$set(a);
    },
    i: function i(e) {
      _i31 || (n && ya(n.$$.fragment, e), _i31 = !0);
    },
    o: function o(e) {
      n && ba(n.$$.fragment, e), _i31 = !1;
    },
    d: function d(e) {
      e && po(t), n && Pa(n), o = !1, Wi(a);
    }
  };
}
function hJ(e) {
  var t,
    n,
    r = e[7](e[41]) + "";
  return {
    c: function c() {
      t = go("div"), n = bo(r), So(t, "class", "listGroupTitle svelte-1uyqfml");
    },
    m: function m(e, r) {
      vo(e, t, r), uo(t, n);
    },
    p: function p(e, t) {
      130 & t[0] && r !== (r = e[7](e[41]) + "") && Ao(n, r);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function dJ(e) {
  var t,
    n,
    r,
    _i32,
    o = [hJ, fJ],
    a = [];
  function s(e, t) {
    return e[41].isGroupHeader && !e[41].isSelectable ? 0 : 1;
  }
  return t = s(e), n = a[t] = o[t](e), {
    c: function c() {
      n.c(), r = wo();
    },
    m: function m(e, n) {
      a[t].m(e, n), vo(e, r, n), _i32 = !0;
    },
    p: function p(e, i) {
      var u = t;
      (t = s(e)) === u ? a[t].p(e, i) : (ma(), ba(a[u], 1, 1, function () {
        a[u] = null;
      }), ga(), (n = a[t]) ? n.p(e, i) : (n = a[t] = o[t](e)).c(), ya(n, 1), n.m(r.parentNode, r));
    },
    i: function i(e) {
      _i32 || (ya(n), _i32 = !0);
    },
    o: function o(e) {
      ba(n), _i32 = !1;
    },
    d: function d(e) {
      a[t].d(e), e && po(r);
    }
  };
}
function vJ(e) {
  var t,
    n,
    r,
    i,
    o,
    a = e[4];
  function s(e) {
    return {
      props: {
        item: e[41],
        filterText: e[13],
        getOptionLabel: e[6],
        isFirst: gJ(e[42]),
        isActive: mJ(e[41], e[9], e[10]),
        isHover: yJ(e[2], e[41], e[42], e[1]),
        isSelectable: bJ(e[41])
      }
    };
  }
  function u() {
    return e[26](e[42]);
  }
  function c() {
    return e[27](e[42]);
  }
  function l() {
    for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
      r[i] = arguments[i];
    }
    return (t = e)[28].apply(t, [e[41], e[42]].concat(r));
  }
  return a && (n = new a(s(e))), {
    c: function c() {
      t = go("div"), n && Aa(n.$$.fragment), So(t, "class", "listItem");
    },
    m: function m(e, a) {
      vo(e, t, a), n && Ea(n, t, null), r = !0, i || (o = [xo(t, "mouseover", u), xo(t, "focus", c), xo(t, "click", l)], i = !0);
    },
    p: function p(r, i) {
      e = r;
      var o = {};
      if (1024 & i[1] && (o.item = e[41]), 8192 & i[0] && (o.filterText = e[13]), 64 & i[0] && (o.getOptionLabel = e[6]), 2048 & i[1] && (o.isFirst = gJ(e[42])), 1536 & i[0] | 1024 & i[1] && (o.isActive = mJ(e[41], e[9], e[10])), 6 & i[0] | 3072 & i[1] && (o.isHover = yJ(e[2], e[41], e[42], e[1])), 1024 & i[1] && (o.isSelectable = bJ(e[41])), a !== (a = e[4])) {
        if (n) {
          ma();
          var u = n;
          ba(u.$$.fragment, 1, 0, function () {
            Pa(u, 1);
          }), ga();
        }
        a ? (Aa((n = new a(s(e))).$$.fragment), ya(n.$$.fragment, 1), Ea(n, t, null)) : n = null;
      } else a && n.$set(o);
    },
    i: function i(e) {
      r || (n && ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      n && ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), n && Pa(n), i = !1, Wi(o);
    }
  };
}
function pJ(e) {
  var t,
    n,
    r,
    _i33,
    o,
    a,
    s = [uJ, sJ],
    u = [];
  function c(e, t) {
    return e[5] ? 0 : 1;
  }
  return n = c(e), r = u[n] = s[n](e), {
    c: function c() {
      t = go("div"), r.c(), So(t, "class", "listContainer svelte-1uyqfml"), So(t, "style", e[14]), To(t, "virtualList", e[5]);
    },
    m: function m(r, s) {
      vo(r, t, s), u[n].m(t, null), e[32](t), _i33 = !0, o || (a = [xo(window, "keydown", e[17]), xo(window, "resize", e[18])], o = !0);
    },
    p: function p(e, o) {
      var a = n;
      (n = c(e)) === a ? u[n].p(e, o) : (ma(), ba(u[a], 1, 1, function () {
        u[a] = null;
      }), ga(), (r = u[n]) ? r.p(e, o) : (r = u[n] = s[n](e)).c(), ya(r, 1), r.m(t, null)), (!_i33 || 16384 & o[0]) && So(t, "style", e[14]), 32 & o[0] && To(t, "virtualList", e[5]);
    },
    i: function i(e) {
      _i33 || (ya(r), _i33 = !0);
    },
    o: function o(e) {
      ba(r), _i33 = !1;
    },
    d: function d(r) {
      r && po(t), u[n].d(), e[32](null), o = !1, Wi(a);
    }
  };
}
function mJ(e, t, n) {
  return t && t[n] === e[n];
}
function gJ(e) {
  return 0 === e;
}
function yJ(e, t, n, r) {
  return bJ(t) && (e === n || 1 === r.length);
}
function bJ(e) {
  return e.isGroupHeader && e.isSelectable || e.selectable || !e.hasOwnProperty("selectable");
}
function kJ(e, t, n) {
  var r,
    i,
    o = Go(),
    a = t.container,
    s = void 0 === a ? void 0 : a,
    u = t.VirtualList,
    c = void 0 === u ? null : u,
    l = t.Item,
    f = void 0 === l ? iJ : l,
    h = t.isVirtualList,
    d = void 0 !== h && h,
    v = t.items,
    p = void 0 === v ? [] : v,
    m = t.labelIdentifier,
    g = void 0 === m ? "label" : m,
    y = t.getOptionLabel,
    b = void 0 === y ? function (e, t) {
      if (e) return e.isCreator ? 'Create "'.concat(t, '"') : e[g];
    } : y,
    k = t.getGroupHeaderLabel,
    w = void 0 === k ? null : k,
    x = t.itemHeight,
    j = void 0 === x ? 40 : x,
    S = t.hoverItemIndex,
    C = void 0 === S ? 0 : S,
    _ = t.value,
    $ = void 0 === _ ? void 0 : _,
    O = t.optionIdentifier,
    A = void 0 === O ? "value" : O,
    E = t.hideEmptyState,
    P = void 0 !== E && E,
    M = t.noOptionsMessage,
    I = void 0 === M ? "No options" : M,
    T = t.isMulti,
    N = void 0 !== T && T,
    R = t.activeItemIndex,
    D = void 0 === R ? 0 : R,
    z = t.filterText,
    L = void 0 === z ? "" : z,
    B = t.parent,
    q = void 0 === B ? null : B,
    F = t.listPlacement,
    V = void 0 === F ? null : F,
    H = t.listAutoWidth,
    W = void 0 === H ? null : H,
    U = t.listOffset,
    J = void 0 === U ? 5 : U,
    K = 0,
    G = !1;
  function Q(e) {
    e.isCreator || o("itemSelected", e);
  }
  function Y(e) {
    G || n(2, C = e);
  }
  function Z(e) {
    var t = e.item,
      r = e.i;
    if (e.event.stopPropagation(), $ && !N && $[A] === t[A]) return X();
    t.isCreator ? o("itemCreated", L) : bJ(t) && (n(19, D = r), n(2, C = r), Q(t));
  }
  function X() {
    o("closeList");
  }
  function ee(e) {
    return te.apply(this, arguments);
  }
  function te() {
    return (te = yi(mi().mark(function e(t) {
      var r;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!d) {
                e.next = 2;
                break;
              }
              return e.abrupt("return");
            case 2:
              for (r = !0; r;) {
                t > 0 && C === p.length - 1 ? n(2, C = 0) : n(2, t < 0 && 0 === C ? C = p.length - 1 : C += t), r = !bJ(p[C]);
              }
              return e.next = 6, oa();
            case 6:
              ne("hover");
            case 7:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function ne(e) {
    if (!d && s) {
      var t,
        r = s.querySelector(".listItem .".concat(e));
      r && (t = s.getBoundingClientRect().bottom - r.getBoundingClientRect().bottom), n(0, s.scrollTop -= t, s);
    }
  }
  function re() {
    var e = q.getBoundingClientRect(),
      t = e.height,
      r = e.width;
    n(14, i = ""), n(14, i += "min-width:".concat(r, "px;width:").concat(W ? "auto" : "100%", ";")), "top" === V || "auto" === V && function (e, t) {
      var n = e.getBoundingClientRect(),
        r = t.getBoundingClientRect(),
        i = {};
      return i.top = n.top < 0, i.left = n.left < 0, i.bottom = n.bottom + r.height > (window.innerHeight || document.documentElement.clientHeight), i.right = n.right > (window.innerWidth || document.documentElement.clientWidth), i.any = i.top || i.left || i.bottom || i.right, i;
    }(q, s).bottom ? n(14, i += "bottom:".concat(t + J, "px;")) : n(14, i += "top:".concat(t + J, "px;"));
  }
  Jo(function () {
    if (p.length > 0 && !N && $) {
      var e = p.findIndex(function (e) {
        return e[A] === $[A];
      });
      e && n(2, C = e);
    }
    ne("active"), s.addEventListener("scroll", function () {
      clearTimeout(K), K = setTimeout(function () {
        G = !1;
      }, 100);
    }, !1);
  }), Uo(function () {
    p || n(1, p = []), p !== r && p.length > 0 && n(2, C = 0), r = p;
  });
  return e.$$set = function (e) {
    "container" in e && n(0, s = e.container), "VirtualList" in e && n(3, c = e.VirtualList), "Item" in e && n(4, f = e.Item), "isVirtualList" in e && n(5, d = e.isVirtualList), "items" in e && n(1, p = e.items), "labelIdentifier" in e && n(20, g = e.labelIdentifier), "getOptionLabel" in e && n(6, b = e.getOptionLabel), "getGroupHeaderLabel" in e && n(7, w = e.getGroupHeaderLabel), "itemHeight" in e && n(8, j = e.itemHeight), "hoverItemIndex" in e && n(2, C = e.hoverItemIndex), "value" in e && n(9, $ = e.value), "optionIdentifier" in e && n(10, A = e.optionIdentifier), "hideEmptyState" in e && n(11, P = e.hideEmptyState), "noOptionsMessage" in e && n(12, I = e.noOptionsMessage), "isMulti" in e && n(21, N = e.isMulti), "activeItemIndex" in e && n(19, D = e.activeItemIndex), "filterText" in e && n(13, L = e.filterText), "parent" in e && n(22, q = e.parent), "listPlacement" in e && n(23, V = e.listPlacement), "listAutoWidth" in e && n(24, W = e.listAutoWidth), "listOffset" in e && n(25, J = e.listOffset);
  }, e.$$.update = function () {
    4194305 & e.$$.dirty[0] && q && s && re();
  }, [s, p, C, c, f, d, b, w, j, $, A, P, I, L, i, Y, Z, function (e) {
    switch (e.key) {
      case "Escape":
        e.preventDefault(), X();
        break;
      case "ArrowDown":
        e.preventDefault(), p.length && ee(1);
        break;
      case "ArrowUp":
        e.preventDefault(), p.length && ee(-1);
        break;
      case "Enter":
        if (e.preventDefault(), 0 === p.length) break;
        var t = p[C];
        if ($ && !N && $[A] === t[A]) {
          X();
          break;
        }
        t.isCreator ? o("itemCreated", L) : (n(19, D = C), Q(p[C]));
        break;
      case "Tab":
        if (e.preventDefault(), 0 === p.length) return X();
        if ($ && $[A] === p[C][A]) return X();
        n(19, D = C), Q(p[C]);
    }
  }, re, D, g, N, q, V, W, J, function (e) {
    return Y(e);
  }, function (e) {
    return Y(e);
  }, function (e, t, n) {
    return Z({
      item: e,
      i: t,
      event: n
    });
  }, function (e) {
    return Y(e);
  }, function (e) {
    return Y(e);
  }, function (e, t, n) {
    return Z({
      item: e,
      i: t,
      event: n
    });
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(0, s = e);
    });
  }];
}
var wJ = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, kJ, pJ, Ji, {
      container: 0,
      VirtualList: 3,
      Item: 4,
      isVirtualList: 5,
      items: 1,
      labelIdentifier: 20,
      getOptionLabel: 6,
      getGroupHeaderLabel: 7,
      itemHeight: 8,
      hoverItemIndex: 2,
      value: 9,
      optionIdentifier: 10,
      hideEmptyState: 11,
      noOptionsMessage: 12,
      isMulti: 21,
      activeItemIndex: 19,
      filterText: 13,
      parent: 22,
      listPlacement: 23,
      listAutoWidth: 24,
      listOffset: 25
    }, oJ, [-1, -1]), r;
  }
  return zi(n);
}();
function xJ(e) {
  co(e, "svelte-pu1q1n", ".selection.svelte-pu1q1n{text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap}");
}
function jJ(e) {
  var t,
    n = e[0](e[1]) + "";
  return {
    c: function c() {
      So(t = go("div"), "class", "selection svelte-pu1q1n");
    },
    m: function m(e, r) {
      vo(e, t, r), t.innerHTML = n;
    },
    p: function p(e, r) {
      3 & xi(r, 1)[0] && n !== (n = e[0](e[1]) + "") && (t.innerHTML = n);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function SJ(e, t, n) {
  var r = t.getSelectionLabel,
    i = void 0 === r ? void 0 : r,
    o = t.item,
    a = void 0 === o ? void 0 : o;
  return e.$$set = function (e) {
    "getSelectionLabel" in e && n(0, i = e.getSelectionLabel), "item" in e && n(1, a = e.item);
  }, [i, a];
}
var CJ = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, SJ, jJ, Ji, {
      getSelectionLabel: 0,
      item: 1
    }, xJ), r;
  }
  return zi(n);
}();
function _J(e) {
  co(e, "svelte-liu9pa", ".multiSelectItem.svelte-liu9pa.svelte-liu9pa{background:var(--multiItemBG, #ebedef);margin:var(--multiItemMargin, 5px 5px 0 0);border-radius:var(--multiItemBorderRadius, 16px);height:var(--multiItemHeight, 32px);line-height:var(--multiItemHeight, 32px);display:flex;cursor:default;padding:var(--multiItemPadding, 0 10px 0 15px);max-width:100%}.multiSelectItem_label.svelte-liu9pa.svelte-liu9pa{margin:var(--multiLabelMargin, 0 5px 0 0);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.multiSelectItem.svelte-liu9pa.svelte-liu9pa:hover,.multiSelectItem.active.svelte-liu9pa.svelte-liu9pa{background-color:var(--multiItemActiveBG, #006fff);color:var(--multiItemActiveColor, #fff)}.multiSelectItem.disabled.svelte-liu9pa.svelte-liu9pa:hover{background:var(--multiItemDisabledHoverBg, #ebedef);color:var(--multiItemDisabledHoverColor, #c1c6cc)}.multiSelectItem_clear.svelte-liu9pa.svelte-liu9pa{border-radius:var(--multiClearRadius, 50%);background:var(--multiClearBG, #52616f);min-width:var(--multiClearWidth, 16px);max-width:var(--multiClearWidth, 16px);height:var(--multiClearHeight, 16px);position:relative;top:var(--multiClearTop, 8px);text-align:var(--multiClearTextAlign, center);padding:var(--multiClearPadding, 1px)}.multiSelectItem_clear.svelte-liu9pa.svelte-liu9pa:hover,.active.svelte-liu9pa .multiSelectItem_clear.svelte-liu9pa{background:var(--multiClearHoverBG, #fff)}.multiSelectItem_clear.svelte-liu9pa:hover svg.svelte-liu9pa,.active.svelte-liu9pa .multiSelectItem_clear svg.svelte-liu9pa{fill:var(--multiClearHoverFill, #006fff)}.multiSelectItem_clear.svelte-liu9pa svg.svelte-liu9pa{fill:var(--multiClearFill, #ebedef);vertical-align:top}");
}
function $J(e, t, n) {
  var r = e.slice();
  return r[9] = t[n], r[11] = n, r;
}
function OJ(e) {
  var t, n, r;
  function i() {
    for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
      r[i] = arguments[i];
    }
    return (t = e)[6].apply(t, [e[11]].concat(r));
  }
  return {
    c: function c() {
      (t = go("div")).innerHTML = '<svg width="100%" height="100%" viewBox="-2 -2 50 50" focusable="false" aria-hidden="true" role="presentation" class="svelte-liu9pa"><path d="M34.923,37.251L24,26.328L13.077,37.251L9.436,33.61l10.923-10.923L9.436,11.765l3.641-3.641L24,19.047L34.923,8.124 l3.641,3.641L27.641,22.688L38.564,33.61L34.923,37.251z"></path></svg>', So(t, "class", "multiSelectItem_clear svelte-liu9pa");
    },
    m: function m(e, o) {
      vo(e, t, o), n || (r = xo(t, "click", i), n = !0);
    },
    p: function p(t, n) {
      e = t;
    },
    d: function d(e) {
      e && po(t), n = !1, r();
    }
  };
}
function AJ(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u = e[4](e[9]) + "",
    _c17 = !e[2] && !e[3] && OJ(e);
  function l() {
    for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
      r[i] = arguments[i];
    }
    return (t = e)[7].apply(t, [e[11]].concat(r));
  }
  return {
    c: function c() {
      t = go("div"), n = go("div"), r = ko(), _c17 && _c17.c(), i = ko(), So(n, "class", "multiSelectItem_label svelte-liu9pa"), So(t, "class", o = "multiSelectItem " + (e[1] === e[11] ? "active" : "") + " " + (e[2] ? "disabled" : "") + " svelte-liu9pa");
    },
    m: function m(e, o) {
      vo(e, t, o), uo(t, n), n.innerHTML = u, uo(t, r), _c17 && _c17.m(t, null), uo(t, i), a || (s = xo(t, "click", l), a = !0);
    },
    p: function p(r, a) {
      e = r, 17 & a && u !== (u = e[4](e[9]) + "") && (n.innerHTML = u), e[2] || e[3] ? _c17 && (_c17.d(1), _c17 = null) : _c17 ? _c17.p(e, a) : ((_c17 = OJ(e)).c(), _c17.m(t, i)), 6 & a && o !== (o = "multiSelectItem " + (e[1] === e[11] ? "active" : "") + " " + (e[2] ? "disabled" : "") + " svelte-liu9pa") && So(t, "class", o);
    },
    d: function d(e) {
      e && po(t), _c17 && _c17.d(), a = !1, s();
    }
  };
}
function EJ(e) {
  for (var t, n = e[0], r = [], i = 0; i < n.length; i += 1) {
    r[i] = AJ($J(e, n, i));
  }
  return {
    c: function c() {
      for (var e = 0; e < r.length; e += 1) {
        r[e].c();
      }
      t = wo();
    },
    m: function m(e, n) {
      for (var i = 0; i < r.length; i += 1) {
        r[i].m(e, n);
      }
      vo(e, t, n);
    },
    p: function p(e, i) {
      var o = xi(i, 1)[0];
      if (63 & o) {
        var a;
        for (n = e[0], a = 0; a < n.length; a += 1) {
          var s = $J(e, n, a);
          r[a] ? r[a].p(s, o) : (r[a] = AJ(s), r[a].c(), r[a].m(t.parentNode, t));
        }
        for (; a < r.length; a += 1) {
          r[a].d(1);
        }
        r.length = n.length;
      }
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      mo(r, e), e && po(t);
    }
  };
}
function PJ(e, t, n) {
  var r = Go(),
    i = t.value,
    o = void 0 === i ? [] : i,
    a = t.activeValue,
    s = void 0 === a ? void 0 : a,
    u = t.isDisabled,
    c = void 0 !== u && u,
    l = t.multiFullItemClearable,
    f = void 0 !== l && l,
    h = t.getSelectionLabel,
    d = void 0 === h ? void 0 : h;
  function v(e, t) {
    t.stopPropagation(), r("multiItemClear", {
      i: e
    });
  }
  return e.$$set = function (e) {
    "value" in e && n(0, o = e.value), "activeValue" in e && n(1, s = e.activeValue), "isDisabled" in e && n(2, c = e.isDisabled), "multiFullItemClearable" in e && n(3, f = e.multiFullItemClearable), "getSelectionLabel" in e && n(4, d = e.getSelectionLabel);
  }, [o, s, c, f, d, v, function (e, t) {
    return v(e, t);
  }, function (e, t) {
    return f ? v(e, t) : {};
  }];
}
var MJ = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, PJ, EJ, Ji, {
      value: 0,
      activeValue: 1,
      isDisabled: 2,
      multiFullItemClearable: 3,
      getSelectionLabel: 4
    }, _J), r;
  }
  return zi(n);
}();
function IJ(e) {
  co(e, "svelte-g2cagw", "svelte-virtual-list-viewport.svelte-g2cagw{position:relative;overflow-y:auto;-webkit-overflow-scrolling:touch;display:block}svelte-virtual-list-contents.svelte-g2cagw,svelte-virtual-list-row.svelte-g2cagw{display:block}svelte-virtual-list-row.svelte-g2cagw{overflow:hidden}");
}
function TJ(e, t, n) {
  var r = e.slice();
  return r[23] = t[n], r;
}
var NJ = function NJ(e) {
    return {
      item: 32 & e,
      i: 32 & e,
      hoverItemIndex: 2 & e
    };
  },
  RJ = function RJ(e) {
    return {
      item: e[23].data,
      i: e[23].index,
      hoverItemIndex: e[1]
    };
  };
function DJ(e, t) {
  var n,
    r,
    _i34,
    o = t[15].default,
    a = Gi(o, t, t[14], RJ),
    s = a || function (e) {
      var t;
      return {
        c: function c() {
          t = bo("Missing template");
        },
        m: function m(e, n) {
          vo(e, t, n);
        },
        d: function d(e) {
          e && po(t);
        }
      };
    }();
  return {
    key: e,
    first: null,
    c: function c() {
      n = go("svelte-virtual-list-row"), s && s.c(), r = ko(), $o(n, "class", "svelte-g2cagw"), this.first = n;
    },
    m: function m(e, t) {
      vo(e, n, t), s && s.m(n, null), uo(n, r), _i34 = !0;
    },
    p: function p(e, n) {
      t = e, a && a.p && (!_i34 || 16418 & n) && Zi(a, o, t, t[14], _i34 ? Yi(o, t[14], n, NJ) : Xi(t[14]), RJ);
    },
    i: function i(e) {
      _i34 || (ya(s, e), _i34 = !0);
    },
    o: function o(e) {
      ba(s, e), _i34 = !1;
    },
    d: function d(e) {
      e && po(n), s && s.d(e);
    }
  };
}
function zJ(e) {
  for (var t, n, r, _i35, o, a, s = [], u = new Map(), c = e[5], l = function l(e) {
      return e[23].index;
    }, f = 0; f < c.length; f += 1) {
    var h = TJ(e, c, f),
      d = l(h);
    u.set(d, s[f] = DJ(d, h));
  }
  return {
    c: function c() {
      t = go("svelte-virtual-list-viewport"), n = go("svelte-virtual-list-contents");
      for (var r = 0; r < s.length; r += 1) {
        s[r].c();
      }
      Po(n, "padding-top", e[6] + "px"), Po(n, "padding-bottom", e[7] + "px"), $o(n, "class", "svelte-g2cagw"), Po(t, "height", e[0]), $o(t, "class", "svelte-g2cagw"), aa(function () {
        return e[18].call(t);
      });
    },
    m: function m(u, c) {
      vo(u, t, c), uo(t, n);
      for (var l = 0; l < s.length; l += 1) {
        s[l].m(n, null);
      }
      e[16](n), e[17](t), r = function (e, t) {
        "static" === getComputedStyle(e).position && (e.style.position = "relative");
        var n = go("iframe");
        n.setAttribute("style", "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; border: 0; opacity: 0; pointer-events: none; z-index: -1;"), n.setAttribute("aria-hidden", "true"), n.tabIndex = -1;
        var r,
          i = Io();
        return i ? (n.src = "data:text/html,<script>onresize=function(){parent.postMessage(0,'*')}<\/script>", r = xo(window, "message", function (e) {
          e.source === n.contentWindow && t();
        })) : (n.src = "about:blank", n.onload = function () {
          r = xo(n.contentWindow, "resize", t);
        }), uo(e, n), function () {
          (i || r && n.contentWindow) && r(), po(n);
        };
      }(t, e[18].bind(t)), _i35 = !0, o || (a = xo(t, "scroll", e[8]), o = !0);
    },
    p: function p(e, r) {
      var o = xi(r, 1)[0];
      16418 & o && (c = e[5], ma(), s = Ca(s, o, l, 1, e, c, u, n, Sa, DJ, null, TJ), ga()), (!_i35 || 64 & o) && Po(n, "padding-top", e[6] + "px"), (!_i35 || 128 & o) && Po(n, "padding-bottom", e[7] + "px"), (!_i35 || 1 & o) && Po(t, "height", e[0]);
    },
    i: function i(e) {
      if (!_i35) {
        for (var t = 0; t < c.length; t += 1) {
          ya(s[t]);
        }
        _i35 = !0;
      }
    },
    o: function o(e) {
      for (var t = 0; t < s.length; t += 1) {
        ba(s[t]);
      }
      _i35 = !1;
    },
    d: function d(n) {
      n && po(t);
      for (var i = 0; i < s.length; i += 1) {
        s[i].d();
      }
      e[16](null), e[17](null), r(), o = !1, a();
    }
  };
}
function LJ(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c = t.$$slots,
    l = void 0 === c ? {} : c,
    f = t.$$scope,
    h = t.items,
    d = void 0 === h ? void 0 : h,
    v = t.height,
    p = void 0 === v ? "100%" : v,
    m = t.itemHeight,
    g = void 0 === m ? 40 : m,
    y = t.hoverItemIndex,
    b = void 0 === y ? 0 : y,
    k = t.start,
    w = void 0 === k ? 0 : k,
    x = t.end,
    j = void 0 === x ? 0 : x,
    S = [],
    C = 0,
    _ = 0,
    $ = 0;
  function O() {
    return (O = yi(mi().mark(function e(t, o, a) {
      var s, c, l, f, h, d;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return s = i.scrollTop, e.next = 3, oa();
            case 3:
              c = _ - s, l = w;
            case 5:
              if (!(c < o && l < t.length)) {
                e.next = 17;
                break;
              }
              if (f = r[l - w]) {
                e.next = 12;
                break;
              }
              return n(10, j = l + 1), e.next = 11, oa();
            case 11:
              f = r[l - w];
            case 12:
              h = S[l] = a || f.offsetHeight, c += h, l += 1, e.next = 5;
              break;
            case 17:
              n(10, j = l), d = t.length - j, n(7, $ = d * (u = (_ + c) / j)), S.length = t.length, i && n(3, i.scrollTop = 0, i);
            case 23:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function A() {
    return (A = yi(mi().mark(function e() {
      var t, o, a, s, c, l, f, h, v, p, m;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              for (t = i.scrollTop, o = w, a = 0; a < r.length; a += 1) {
                S[w + a] = g || r[a].offsetHeight;
              }
              s = 0, c = 0;
            case 5:
              if (!(s < d.length)) {
                e.next = 15;
                break;
              }
              if (l = S[s] || u, !(c + l > t)) {
                e.next = 11;
                break;
              }
              return n(9, w = s), n(6, _ = c), e.abrupt("break", 15);
            case 11:
              c += l, s += 1, e.next = 5;
              break;
            case 15:
              if (!(s < d.length)) {
                e.next = 22;
                break;
              }
              if (c += S[s] || u, s += 1, !(c > t + C)) {
                e.next = 20;
                break;
              }
              return e.abrupt("break", 22);
            case 20:
              e.next = 15;
              break;
            case 22:
              for (n(10, j = s), f = d.length - j, u = c / j; s < d.length;) {
                S[s++] = u;
              }
              if (n(7, $ = f * u), !(w < o)) {
                e.next = 35;
                break;
              }
              return e.next = 30, oa();
            case 30:
              for (h = 0, v = 0, p = w; p < o; p += 1) {
                r[p - w] && (h += S[p], v += g || r[p - w].offsetHeight);
              }
              m = v - h, i.scrollTo(0, t + m);
            case 35:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  return Jo(function () {
    r = o.getElementsByTagName("svelte-virtual-list-row"), n(13, s = !0);
  }), e.$$set = function (e) {
    "items" in e && n(11, d = e.items), "height" in e && n(0, p = e.height), "itemHeight" in e && n(12, g = e.itemHeight), "hoverItemIndex" in e && n(1, b = e.hoverItemIndex), "start" in e && n(9, w = e.start), "end" in e && n(10, j = e.end), "$$scope" in e && n(14, f = e.$$scope);
  }, e.$$.update = function () {
    3584 & e.$$.dirty && n(5, a = d.slice(w, j).map(function (e, t) {
      return {
        index: t + w,
        data: e
      };
    })), 14340 & e.$$.dirty && s && function (e, t, n) {
      O.apply(this, arguments);
    }(d, C, g);
  }, [p, b, C, i, o, a, _, $, function () {
    return A.apply(this, arguments);
  }, w, j, d, g, s, f, l, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(4, o = e);
    });
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(3, i = e);
    });
  }, function () {
    C = this.offsetHeight, n(2, C);
  }];
}
var BJ = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, LJ, zJ, Ji, {
      items: 11,
      height: 0,
      itemHeight: 12,
      hoverItemIndex: 1,
      start: 9,
      end: 10
    }, IJ), r;
  }
  return zi(n);
}();
function qJ(e) {
  var t, n;
  return {
    c: function c() {
      t = yo("svg"), So(n = yo("path"), "fill", "currentColor"), So(n, "d", "M34.923,37.251L24,26.328L13.077,37.251L9.436,33.61l10.923-10.923L9.436,11.765l3.641-3.641L24,19.047L34.923,8.124\n    l3.641,3.641L27.641,22.688L38.564,33.61L34.923,37.251z"), So(t, "width", "100%"), So(t, "height", "100%"), So(t, "viewBox", "-2 -2 50 50"), So(t, "focusable", "false"), So(t, "aria-hidden", "true"), So(t, "role", "presentation");
    },
    m: function m(e, r) {
      vo(e, t, r), uo(t, n);
    },
    p: Bi,
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
var FJ = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, null, qJ, Ji, {}), r;
  }
  return zi(n);
}();
function VJ(e) {
  co(e, "svelte-17l1npl", ".selectContainer.svelte-17l1npl.svelte-17l1npl{--internalPadding:0 16px;border:var(--border, 1px solid #d8dbdf);border-radius:var(--borderRadius, 3px);box-sizing:border-box;height:var(--height, 42px);position:relative;display:flex;align-items:center;padding:var(--padding, var(--internalPadding));background:var(--background, #fff);margin:var(--margin, 0)}.selectContainer.svelte-17l1npl input.svelte-17l1npl{cursor:default;border:none;color:var(--inputColor, #3f4f5f);height:var(--height, 42px);line-height:var(--height, 42px);padding:var(--inputPadding, var(--padding, var(--internalPadding)));width:100%;background:transparent;font-size:var(--inputFontSize, 14px);letter-spacing:var(--inputLetterSpacing, -0.08px);position:absolute;left:var(--inputLeft, 0);margin:var(--inputMargin, 0)}.selectContainer.svelte-17l1npl input.svelte-17l1npl::placeholder{color:var(--placeholderColor, #78848f);opacity:var(--placeholderOpacity, 1)}.selectContainer.svelte-17l1npl input.svelte-17l1npl:focus{outline:none}.selectContainer.svelte-17l1npl.svelte-17l1npl:hover{border-color:var(--borderHoverColor, #b2b8bf)}.selectContainer.focused.svelte-17l1npl.svelte-17l1npl{border-color:var(--borderFocusColor, #006fe8)}.selectContainer.disabled.svelte-17l1npl.svelte-17l1npl{background:var(--disabledBackground, #ebedef);border-color:var(--disabledBorderColor, #ebedef);color:var(--disabledColor, #c1c6cc)}.selectContainer.disabled.svelte-17l1npl input.svelte-17l1npl::placeholder{color:var(--disabledPlaceholderColor, #c1c6cc);opacity:var(--disabledPlaceholderOpacity, 1)}.selectedItem.svelte-17l1npl.svelte-17l1npl{line-height:var(--height, 42px);height:var(--height, 42px);overflow-x:hidden;padding:var(--selectedItemPadding, 0 20px 0 0)}.selectedItem.svelte-17l1npl.svelte-17l1npl:focus{outline:none}.clearSelect.svelte-17l1npl.svelte-17l1npl{position:absolute;right:var(--clearSelectRight, 10px);top:var(--clearSelectTop, 11px);bottom:var(--clearSelectBottom, 11px);width:var(--clearSelectWidth, 20px);color:var(--clearSelectColor, #c5cacf);flex:none !important}.clearSelect.svelte-17l1npl.svelte-17l1npl:hover{color:var(--clearSelectHoverColor, #2c3e50)}.selectContainer.focused.svelte-17l1npl .clearSelect.svelte-17l1npl{color:var(--clearSelectFocusColor, #3f4f5f)}.indicator.svelte-17l1npl.svelte-17l1npl{position:absolute;right:var(--indicatorRight, 10px);top:var(--indicatorTop, 11px);width:var(--indicatorWidth, 20px);height:var(--indicatorHeight, 20px);color:var(--indicatorColor, #c5cacf)}.indicator.svelte-17l1npl svg.svelte-17l1npl{display:inline-block;fill:var(--indicatorFill, currentcolor);line-height:1;stroke:var(--indicatorStroke, currentcolor);stroke-width:0}.spinner.svelte-17l1npl.svelte-17l1npl{position:absolute;right:var(--spinnerRight, 10px);top:var(--spinnerLeft, 11px);width:var(--spinnerWidth, 20px);height:var(--spinnerHeight, 20px);color:var(--spinnerColor, #51ce6c);animation:svelte-17l1npl-rotate 0.75s linear infinite}.spinner_icon.svelte-17l1npl.svelte-17l1npl{display:block;height:100%;transform-origin:center center;width:100%;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;-webkit-transform:none}.spinner_path.svelte-17l1npl.svelte-17l1npl{stroke-dasharray:90;stroke-linecap:round}.multiSelect.svelte-17l1npl.svelte-17l1npl{display:flex;padding:var(--multiSelectPadding, 0 35px 0 16px);height:auto;flex-wrap:wrap;align-items:stretch}.multiSelect.svelte-17l1npl>.svelte-17l1npl{flex:1 1 50px}.selectContainer.multiSelect.svelte-17l1npl input.svelte-17l1npl{padding:var(--multiSelectInputPadding, 0);position:relative;margin:var(--multiSelectInputMargin, 0)}.hasError.svelte-17l1npl.svelte-17l1npl{border:var(--errorBorder, 1px solid #ff2d55);background:var(--errorBackground, #fff)}.a11yText.svelte-17l1npl.svelte-17l1npl{z-index:9999;border:0px;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0px;white-space:nowrap}@keyframes svelte-17l1npl-rotate{100%{transform:rotate(360deg)}}");
}
function HJ(e, t, n) {
  var r = e.slice();
  return r[103] = t[n], r;
}
function WJ(e) {
  var t, n, r, i, o;
  return {
    c: function c() {
      t = go("span"), n = bo(e[33]), r = ko(), i = go("span"), o = bo(e[32]), So(t, "id", "aria-selection"), So(i, "id", "aria-context");
    },
    m: function m(e, a) {
      vo(e, t, a), uo(t, n), vo(e, r, a), vo(e, i, a), uo(i, o);
    },
    p: function p(e, t) {
      4 & t[1] && Ao(n, e[33]), 2 & t[1] && Ao(o, e[32]);
    },
    d: function d(e) {
      e && po(t), e && po(r), e && po(i);
    }
  };
}
function UJ(e) {
  var t,
    n,
    r,
    i = [e[18]],
    o = e[17];
  function a(e) {
    for (var t = {}, n = 0; n < i.length; n += 1) {
      t = Fi(t, i[n]);
    }
    return {
      props: t
    };
  }
  return o && (t = new o(a())), {
    c: function c() {
      t && Aa(t.$$.fragment), n = wo();
    },
    m: function m(e, i) {
      t && Ea(t, e, i), vo(e, n, i), r = !0;
    },
    p: function p(e, r) {
      var s = 262144 & r[0] ? _a(i, [$a(e[18])]) : {};
      if (o !== (o = e[17])) {
        if (t) {
          ma();
          var u = t;
          ba(u.$$.fragment, 1, 0, function () {
            Pa(u, 1);
          }), ga();
        }
        o ? (Aa((t = new o(a())).$$.fragment), ya(t.$$.fragment, 1), Ea(t, n.parentNode, n)) : t = null;
      } else o && t.$set(s);
    },
    i: function i(e) {
      r || (t && ya(t.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      t && ba(t.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(n), t && Pa(t, e);
    }
  };
}
function JJ(e) {
  var t,
    n,
    r,
    i = e[26];
  function o(e) {
    return {
      props: {
        value: e[2],
        getSelectionLabel: e[12],
        activeValue: e[30],
        isDisabled: e[9],
        multiFullItemClearable: e[8]
      }
    };
  }
  return i && ((t = new i(o(e))).$on("multiItemClear", e[38]), t.$on("focus", e[40])), {
    c: function c() {
      t && Aa(t.$$.fragment), n = wo();
    },
    m: function m(e, i) {
      t && Ea(t, e, i), vo(e, n, i), r = !0;
    },
    p: function p(e, r) {
      var a = {};
      if (4 & r[0] && (a.value = e[2]), 4096 & r[0] && (a.getSelectionLabel = e[12]), 1073741824 & r[0] && (a.activeValue = e[30]), 512 & r[0] && (a.isDisabled = e[9]), 256 & r[0] && (a.multiFullItemClearable = e[8]), i !== (i = e[26])) {
        if (t) {
          ma();
          var s = t;
          ba(s.$$.fragment, 1, 0, function () {
            Pa(s, 1);
          }), ga();
        }
        i ? ((t = new i(o(e))).$on("multiItemClear", e[38]), t.$on("focus", e[40]), Aa(t.$$.fragment), ya(t.$$.fragment, 1), Ea(t, n.parentNode, n)) : t = null;
      } else i && t.$set(a);
    },
    i: function i(e) {
      r || (t && ya(t.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      t && ba(t.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(n), t && Pa(t, e);
    }
  };
}
function KJ(e) {
  var t,
    n,
    r,
    i,
    o,
    a = e[25];
  function s(e) {
    return {
      props: {
        item: e[2],
        getSelectionLabel: e[12]
      }
    };
  }
  return a && (n = new a(s(e))), {
    c: function c() {
      t = go("div"), n && Aa(n.$$.fragment), So(t, "class", "selectedItem svelte-17l1npl");
    },
    m: function m(a, s) {
      vo(a, t, s), n && Ea(n, t, null), r = !0, i || (o = xo(t, "focus", e[40]), i = !0);
    },
    p: function p(e, r) {
      var i = {};
      if (4 & r[0] && (i.item = e[2]), 4096 & r[0] && (i.getSelectionLabel = e[12]), a !== (a = e[25])) {
        if (n) {
          ma();
          var o = n;
          ba(o.$$.fragment, 1, 0, function () {
            Pa(o, 1);
          }), ga();
        }
        a ? (Aa((n = new a(s(e))).$$.fragment), ya(n.$$.fragment, 1), Ea(n, t, null)) : n = null;
      } else a && n.$set(i);
    },
    i: function i(e) {
      r || (n && ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      n && ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), n && Pa(n), i = !1, o();
    }
  };
}
function GJ(e) {
  var t,
    n,
    r,
    i,
    o,
    a = e[23];
  return a && (n = new a({})), {
    c: function c() {
      t = go("div"), n && Aa(n.$$.fragment), So(t, "class", "clearSelect svelte-17l1npl"), So(t, "aria-hidden", "true");
    },
    m: function m(a, s) {
      var u;
      vo(a, t, s), n && Ea(n, t, null), r = !0, i || (o = xo(t, "click", (u = e[27], function (e) {
        return e.preventDefault(), u.call(this, e);
      })), i = !0);
    },
    p: function p(e, r) {
      if (a !== (a = e[23])) {
        if (n) {
          ma();
          var i = n;
          ba(i.$$.fragment, 1, 0, function () {
            Pa(i, 1);
          }), ga();
        }
        a ? (Aa((n = new a({})).$$.fragment), ya(n.$$.fragment, 1), Ea(n, t, null)) : n = null;
      }
    },
    i: function i(e) {
      r || (n && ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      n && ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), n && Pa(n), i = !1, o();
    }
  };
}
function QJ(e) {
  var t;
  function n(e, t) {
    return e[22] ? ZJ : YJ;
  }
  var r = n(e),
    i = r(e);
  return {
    c: function c() {
      t = go("div"), i.c(), So(t, "class", "indicator svelte-17l1npl"), So(t, "aria-hidden", "true");
    },
    m: function m(e, n) {
      vo(e, t, n), i.m(t, null);
    },
    p: function p(e, o) {
      r === (r = n(e)) && i ? i.p(e, o) : (i.d(1), (i = r(e)) && (i.c(), i.m(t, null)));
    },
    d: function d(e) {
      e && po(t), i.d();
    }
  };
}
function YJ(e) {
  var t, n;
  return {
    c: function c() {
      t = yo("svg"), So(n = yo("path"), "d", "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747\n          3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0\n          1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502\n          0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0\n          0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"), So(t, "width", "100%"), So(t, "height", "100%"), So(t, "viewBox", "0 0 20 20"), So(t, "focusable", "false"), So(t, "aria-hidden", "true"), So(t, "class", "svelte-17l1npl");
    },
    m: function m(e, r) {
      vo(e, t, r), uo(t, n);
    },
    p: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function ZJ(e) {
  var t, n;
  return {
    c: function c() {
      t = new Do(!1), n = wo(), t.a = n;
    },
    m: function m(r, i) {
      t.m(e[22], r, i), vo(r, n, i);
    },
    p: function p(e, n) {
      4194304 & n[0] && t.p(e[22]);
    },
    d: function d(e) {
      e && po(n), e && t.d();
    }
  };
}
function XJ(e) {
  var t;
  return {
    c: function c() {
      (t = go("div")).innerHTML = '<svg class="spinner_icon svelte-17l1npl" viewBox="25 25 50 50"><circle class="spinner_path svelte-17l1npl" cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5" stroke-miterlimit="10"></circle></svg>', So(t, "class", "spinner svelte-17l1npl");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function eK(e) {
  var t,
    n,
    r,
    _i36,
    o = [e[34]];
  function a(t) {
    e[84](t);
  }
  var s = e[24];
  function u(e) {
    for (var t = {}, n = 0; n < o.length; n += 1) {
      t = Fi(t, o[n]);
    }
    return void 0 !== e[28] && (t.hoverItemIndex = e[28]), {
      props: t
    };
  }
  return s && (t = new s(u(e)), Xo.push(function () {
    return Oa(t, "hoverItemIndex", a);
  }), t.$on("itemSelected", e[43]), t.$on("itemCreated", e[44]), t.$on("closeList", e[45])), {
    c: function c() {
      t && Aa(t.$$.fragment), r = wo();
    },
    m: function m(e, n) {
      t && Ea(t, e, n), vo(e, r, n), _i36 = !0;
    },
    p: function p(e, i) {
      var c = 8 & i[1] ? _a(o, [$a(e[34])]) : {};
      if (!n && 268435456 & i[0] && (n = !0, c.hoverItemIndex = e[28], sa(function () {
        return n = !1;
      })), s !== (s = e[24])) {
        if (t) {
          ma();
          var l = t;
          ba(l.$$.fragment, 1, 0, function () {
            Pa(l, 1);
          }), ga();
        }
        s ? (t = new s(u(e)), Xo.push(function () {
          return Oa(t, "hoverItemIndex", a);
        }), t.$on("itemSelected", e[43]), t.$on("itemCreated", e[44]), t.$on("closeList", e[45]), Aa(t.$$.fragment), ya(t.$$.fragment, 1), Ea(t, r.parentNode, r)) : t = null;
      } else s && t.$set(c);
    },
    i: function i(e) {
      _i36 || (t && ya(t.$$.fragment, e), _i36 = !0);
    },
    o: function o(e) {
      t && ba(t.$$.fragment, e), _i36 = !1;
    },
    d: function d(e) {
      e && po(r), t && Pa(t, e);
    }
  };
}
function tK(e) {
  var t, n, r;
  return {
    c: function c() {
      So(t = go("input"), "name", n = e[16].name), So(t, "type", "hidden"), t.value = r = e[2] ? e[12](e[2]) : null, So(t, "class", "svelte-17l1npl");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: function p(e, i) {
      65536 & i[0] && n !== (n = e[16].name) && So(t, "name", n), 4100 & i[0] && r !== (r = e[2] ? e[12](e[2]) : null) && (t.value = r);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function nK(e) {
  for (var t, n = e[2], r = [], i = 0; i < n.length; i += 1) {
    r[i] = rK(HJ(e, n, i));
  }
  return {
    c: function c() {
      for (var e = 0; e < r.length; e += 1) {
        r[e].c();
      }
      t = wo();
    },
    m: function m(e, n) {
      for (var i = 0; i < r.length; i += 1) {
        r[i].m(e, n);
      }
      vo(e, t, n);
    },
    p: function p(e, i) {
      if (69636 & i[0]) {
        var o;
        for (n = e[2], o = 0; o < n.length; o += 1) {
          var a = HJ(e, n, o);
          r[o] ? r[o].p(a, i) : (r[o] = rK(a), r[o].c(), r[o].m(t.parentNode, t));
        }
        for (; o < r.length; o += 1) {
          r[o].d(1);
        }
        r.length = n.length;
      }
    },
    d: function d(e) {
      mo(r, e), e && po(t);
    }
  };
}
function rK(e) {
  var t, n, r;
  return {
    c: function c() {
      So(t = go("input"), "name", n = e[16].name), So(t, "type", "hidden"), t.value = r = e[103] ? e[12](e[103]) : null, So(t, "class", "svelte-17l1npl");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: function p(e, i) {
      65536 & i[0] && n !== (n = e[16].name) && So(t, "name", n), 4100 & i[0] && r !== (r = e[103] ? e[12](e[103]) : null) && (t.value = r);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function iK(e) {
  for (var t, n, r, i, o, a, s, u, _c18, l, f, h, d, v, _p11, _m13, g, y, b = e[1] && WJ(e), k = e[17] && UJ(e), w = e[35] && JJ(e), x = [{
      readOnly: s = !e[13]
    }, e[31], {
      placeholder: e[36]
    }, {
      style: e[14]
    }, {
      disabled: e[9]
    }], j = {}, S = 0; S < x.length; S += 1) {
    j = Fi(j, x[S]);
  }
  var C = !e[7] && e[29] && KJ(e),
    _ = e[37] && GJ(e),
    $ = !e[37] && (e[20] || e[19] && !e[2] || !e[13] && !e[9] && !e[4] && (e[29] && !e[15] || !e[29])) && QJ(e),
    O = e[4] && XJ(),
    A = e[5] && eK(e),
    E = (!e[7] || e[7] && !e[35]) && tK(e),
    P = e[7] && e[35] && nK(e);
  return {
    c: function c() {
      t = go("div"), n = go("span"), b && b.c(), r = ko(), k && k.c(), i = ko(), w && w.c(), o = ko(), a = go("input"), u = ko(), C && C.c(), _c18 = ko(), _ && _.c(), l = ko(), $ && $.c(), f = ko(), O && O.c(), h = ko(), A && A.c(), d = ko(), E && E.c(), v = ko(), P && P.c(), So(n, "aria-live", "polite"), So(n, "aria-atomic", "false"), So(n, "aria-relevant", "additions text"), So(n, "class", "a11yText svelte-17l1npl"), Co(a, j), To(a, "svelte-17l1npl", !0), So(t, "class", _p11 = "selectContainer " + e[21] + " svelte-17l1npl"), So(t, "style", e[11]), To(t, "hasError", e[10]), To(t, "multiSelect", e[7]), To(t, "disabled", e[9]), To(t, "focused", e[1]);
    },
    m: function m(s, p) {
      vo(s, t, p), uo(t, n), b && b.m(n, null), uo(t, r), k && k.m(t, null), uo(t, i), w && w.m(t, null), uo(t, o), uo(t, a), a.autofocus && a.focus(), e[82](a), Eo(a, e[3]), uo(t, u), C && C.m(t, null), uo(t, _c18), _ && _.m(t, null), uo(t, l), $ && $.m(t, null), uo(t, f), O && O.m(t, null), uo(t, h), A && A.m(t, null), uo(t, d), E && E.m(t, null), uo(t, v), P && P.m(t, null), e[85](t), _m13 = !0, g || (y = [xo(window, "click", e[41]), xo(window, "focusin", e[41]), xo(window, "keydown", e[39]), xo(a, "focus", e[40]), xo(a, "input", e[83]), xo(t, "click", e[42])], g = !0);
    },
    p: function p(e, r) {
      e[1] ? b ? b.p(e, r) : ((b = WJ(e)).c(), b.m(n, null)) : b && (b.d(1), b = null), e[17] ? k ? (k.p(e, r), 131072 & r[0] && ya(k, 1)) : ((k = UJ(e)).c(), ya(k, 1), k.m(t, i)) : k && (ma(), ba(k, 1, 1, function () {
        k = null;
      }), ga()), e[35] ? w ? (w.p(e, r), 16 & r[1] && ya(w, 1)) : ((w = JJ(e)).c(), ya(w, 1), w.m(t, o)) : w && (ma(), ba(w, 1, 1, function () {
        w = null;
      }), ga()), Co(a, j = _a(x, [(!_m13 || 8192 & r[0] && s !== (s = !e[13])) && {
        readOnly: s
      }, 1 & r[1] && e[31], (!_m13 || 32 & r[1]) && {
        placeholder: e[36]
      }, (!_m13 || 16384 & r[0]) && {
        style: e[14]
      }, (!_m13 || 512 & r[0]) && {
        disabled: e[9]
      }])), 8 & r[0] && a.value !== e[3] && Eo(a, e[3]), To(a, "svelte-17l1npl", !0), !e[7] && e[29] ? C ? (C.p(e, r), 536871040 & r[0] && ya(C, 1)) : ((C = KJ(e)).c(), ya(C, 1), C.m(t, _c18)) : C && (ma(), ba(C, 1, 1, function () {
        C = null;
      }), ga()), e[37] ? _ ? (_.p(e, r), 64 & r[1] && ya(_, 1)) : ((_ = GJ(e)).c(), ya(_, 1), _.m(t, l)) : _ && (ma(), ba(_, 1, 1, function () {
        _ = null;
      }), ga()), e[37] || !(e[20] || e[19] && !e[2]) && (e[13] || e[9] || e[4] || (!e[29] || e[15]) && e[29]) ? $ && ($.d(1), $ = null) : $ ? $.p(e, r) : (($ = QJ(e)).c(), $.m(t, f)), e[4] ? O || ((O = XJ()).c(), O.m(t, h)) : O && (O.d(1), O = null), e[5] ? A ? (A.p(e, r), 32 & r[0] && ya(A, 1)) : ((A = eK(e)).c(), ya(A, 1), A.m(t, d)) : A && (ma(), ba(A, 1, 1, function () {
        A = null;
      }), ga()), !e[7] || e[7] && !e[35] ? E ? E.p(e, r) : ((E = tK(e)).c(), E.m(t, v)) : E && (E.d(1), E = null), e[7] && e[35] ? P ? P.p(e, r) : ((P = nK(e)).c(), P.m(t, null)) : P && (P.d(1), P = null), (!_m13 || 2097152 & r[0] && _p11 !== (_p11 = "selectContainer " + e[21] + " svelte-17l1npl")) && So(t, "class", _p11), (!_m13 || 2048 & r[0]) && So(t, "style", e[11]), 2098176 & r[0] && To(t, "hasError", e[10]), 2097280 & r[0] && To(t, "multiSelect", e[7]), 2097664 & r[0] && To(t, "disabled", e[9]), 2097154 & r[0] && To(t, "focused", e[1]);
    },
    i: function i(e) {
      _m13 || (ya(k), ya(w), ya(C), ya(_), ya(A), _m13 = !0);
    },
    o: function o(e) {
      ba(k), ba(w), ba(C), ba(_), ba(A), _m13 = !1;
    },
    d: function d(n) {
      n && po(t), b && b.d(), k && k.d(), w && w.d(), e[82](null), C && C.d(), _ && _.d(), $ && $.d(), O && O.d(), A && A.d(), E && E.d(), P && P.d(), e[85](null), g = !1, Wi(y);
    }
  };
}
function oK(e) {
  return e.map(function (e, t) {
    return {
      index: t,
      value: e,
      label: "".concat(e)
    };
  });
}
function aK(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f = Go(),
    h = t.id,
    d = void 0 === h ? null : h,
    v = t.container,
    p = void 0 === v ? void 0 : v,
    m = t.input,
    g = void 0 === m ? void 0 : m,
    y = t.isMulti,
    b = void 0 !== y && y,
    k = t.multiFullItemClearable,
    w = void 0 !== k && k,
    x = t.isDisabled,
    j = void 0 !== x && x,
    S = t.isCreatable,
    C = void 0 !== S && S,
    _ = t.isFocused,
    $ = void 0 !== _ && _,
    O = t.value,
    A = void 0 === O ? null : O,
    E = t.filterText,
    P = void 0 === E ? "" : E,
    M = t.placeholder,
    I = void 0 === M ? "Select..." : M,
    T = t.placeholderAlwaysShow,
    N = void 0 !== T && T,
    R = t.items,
    D = void 0 === R ? null : R,
    z = t.itemFilter,
    L = void 0 === z ? function (e, t, n) {
      return "".concat(e).toLowerCase().includes(t.toLowerCase());
    } : z,
    B = t.groupBy,
    q = void 0 === B ? void 0 : B,
    F = t.groupFilter,
    V = void 0 === F ? function (e) {
      return e;
    } : F,
    H = t.isGroupHeaderSelectable,
    W = void 0 !== H && H,
    U = t.getGroupHeaderLabel,
    J = void 0 === U ? function (e) {
      return e[G] || e.id;
    } : U,
    K = t.labelIdentifier,
    G = void 0 === K ? "label" : K,
    Q = t.getOptionLabel,
    Y = void 0 === Q ? function (e, t) {
      return e.isCreator ? 'Create "'.concat(t, '"') : e[G];
    } : Q,
    Z = t.optionIdentifier,
    X = void 0 === Z ? "value" : Z,
    ee = t.loadOptions,
    te = void 0 === ee ? void 0 : ee,
    ne = t.hasError,
    re = void 0 !== ne && ne,
    ie = t.containerStyles,
    oe = void 0 === ie ? "" : ie,
    ae = t.getSelectionLabel,
    se = void 0 === ae ? function (e) {
      return e ? e[G] : null;
    } : ae,
    ue = t.createGroupHeaderItem,
    ce = void 0 === ue ? function (e) {
      return {
        value: e,
        label: e
      };
    } : ue,
    le = t.createItem,
    fe = void 0 === le ? function (e) {
      return {
        value: e,
        label: e
      };
    } : le,
    he = t.isSearchable,
    de = void 0 === he || he,
    ve = t.inputStyles,
    pe = void 0 === ve ? "" : ve,
    me = t.isClearable,
    ge = void 0 === me || me,
    ye = t.isWaiting,
    be = void 0 !== ye && ye,
    ke = t.listPlacement,
    we = void 0 === ke ? "auto" : ke,
    xe = t.listOpen,
    je = void 0 !== xe && xe,
    Se = t.isVirtualList,
    Ce = void 0 !== Se && Se,
    _e = t.loadOptionsInterval,
    $e = void 0 === _e ? 300 : _e,
    Oe = t.noOptionsMessage,
    Ae = void 0 === Oe ? "No options" : Oe,
    Ee = t.hideEmptyState,
    Pe = void 0 !== Ee && Ee,
    Me = t.inputAttributes,
    Ie = void 0 === Me ? {} : Me,
    Te = t.listAutoWidth,
    Ne = void 0 === Te || Te,
    Re = t.itemHeight,
    De = void 0 === Re ? 40 : Re,
    ze = t.Icon,
    Le = void 0 === ze ? void 0 : ze,
    Be = t.iconProps,
    qe = void 0 === Be ? {} : Be,
    Fe = t.showChevron,
    Ve = void 0 !== Fe && Fe,
    He = t.showIndicator,
    We = void 0 !== He && He,
    Ue = t.containerClasses,
    Je = void 0 === Ue ? "" : Ue,
    Ke = t.indicatorSvg,
    Ge = void 0 === Ke ? void 0 : Ke,
    Qe = t.listOffset,
    Ye = void 0 === Qe ? 5 : Qe,
    Ze = t.ClearIcon,
    Xe = void 0 === Ze ? FJ : Ze,
    et = t.Item,
    tt = void 0 === et ? iJ : et,
    nt = t.List,
    rt = void 0 === nt ? wJ : nt,
    it = t.Selection,
    ot = void 0 === it ? CJ : it,
    at = t.MultiSelection,
    st = void 0 === at ? MJ : at,
    ut = t.VirtualList,
    ct = void 0 === ut ? BJ : ut;
  function lt(e) {
    if (!(e.loadOptions && e.filterText.length > 0)) {
      if (!e.items) return [];
      e.items && e.items.length > 0 && "object" !== Li(e.items[0]) && (e.items = oK(e.items));
      var t = e.items.filter(function (t) {
        var n = L(Y(t, e.filterText), e.filterText, t);
        return n && e.isMulti && e.value && Array.isArray(e.value) && (n = !e.value.some(function (n) {
          return n[e.optionIdentifier] === t[e.optionIdentifier];
        })), n;
      });
      return e.groupBy && (t = function (e) {
        var t = [],
          n = {};
        e.forEach(function (e) {
          var r = q(e);
          t.includes(r) || (t.push(r), n[r] = [], r && n[r].push(Object.assign(ce(r, e), {
            id: r,
            isGroupHeader: !0,
            isSelectable: W
          }))), n[r].push(Object.assign({
            isGroupItem: !!r
          }, e));
        });
        var r = [];
        return V(t).forEach(function (e) {
          r.push.apply(r, Ii(n[e]));
        }), r;
      }(t)), e.isCreatable && (t = ft(t, e.filterText)), t;
    }
  }
  function ft(e, t) {
    if (0 === t.length) return e;
    var n = fe(t);
    return e[0] && t === e[0][G] ? e : (n.isCreator = !0, [].concat(Ii(e), [n]));
  }
  var ht,
    dt,
    vt,
    pt,
    mt,
    gt,
    yt,
    bt = t.selectedValue,
    kt = void 0 === bt ? null : bt,
    wt = function (e, t, n) {
      var r;
      return function () {
        var i = this,
          o = arguments,
          a = function a() {
            r = null, n || e.apply(i, o);
          },
          s = n && !r;
        clearTimeout(r), r = setTimeout(a, t), s && e.apply(i, o);
      };
    }(yi(mi().mark(function e() {
      var t;
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n(4, be = !0), e.next = 3, te(P).catch(function (e) {
                console.warn("svelte-select loadOptions error :>> ", e), f("error", {
                  type: "loadOptions",
                  details: e
                });
              });
            case 3:
              (t = e.sent) && !t.cancelled && (t ? (t && t.length > 0 && "object" !== Li(t[0]) && (t = oK(t)), n(81, r = Ii(t)), f("loaded", {
                items: r
              })) : n(81, r = []), C && n(81, r = ft(r, P)), n(4, be = !1), n(1, $ = !0), n(5, je = !0));
            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), $e);
  function xt() {
    var e = !0;
    if (A) {
      var t = [],
        r = [];
      A.forEach(function (n) {
        t.includes(n[X]) ? e = !1 : (t.push(n[X]), r.push(n));
      }), e || n(2, A = r);
    }
    return e;
  }
  function jt(e) {
    var t = e ? e[X] : A[X];
    return D.find(function (e) {
      return e[X] === t;
    });
  }
  function St(e) {
    var t = e.detail,
      r = A[t ? t.i : A.length - 1];
    1 === A.length ? n(2, A = void 0) : n(2, A = A.filter(function (e) {
      return e !== r;
    })), f("clear", r);
  }
  function Ct() {
    n(1, $ = !0), g && g.focus();
  }
  Uo(yi(mi().mark(function e() {
    return mi().wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            n(77, dt = A), n(78, vt = P), n(79, pt = $), n(80, mt = b);
          case 4:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))), Jo(function () {
    $ && g && g.focus();
  });
  var _t = t.ariaValues,
    $t = void 0 === _t ? function (e) {
      return "Option ".concat(e, ", selected.");
    } : _t,
    Ot = t.ariaListOpen,
    At = void 0 === Ot ? function (e, t) {
      return "You are currently focused on option ".concat(e, ". There are ").concat(t, " results available.");
    } : Ot,
    Et = t.ariaFocused,
    Pt = void 0 === Et ? function () {
      return "Select is focused, type to refine list, press down to open the menu.";
    } : Et;
  return e.$$set = function (e) {
    "id" in e && n(46, d = e.id), "container" in e && n(0, p = e.container), "input" in e && n(6, g = e.input), "isMulti" in e && n(7, b = e.isMulti), "multiFullItemClearable" in e && n(8, w = e.multiFullItemClearable), "isDisabled" in e && n(9, j = e.isDisabled), "isCreatable" in e && n(47, C = e.isCreatable), "isFocused" in e && n(1, $ = e.isFocused), "value" in e && n(2, A = e.value), "filterText" in e && n(3, P = e.filterText), "placeholder" in e && n(48, I = e.placeholder), "placeholderAlwaysShow" in e && n(49, N = e.placeholderAlwaysShow), "items" in e && n(50, D = e.items), "itemFilter" in e && n(51, L = e.itemFilter), "groupBy" in e && n(52, q = e.groupBy), "groupFilter" in e && n(53, V = e.groupFilter), "isGroupHeaderSelectable" in e && n(54, W = e.isGroupHeaderSelectable), "getGroupHeaderLabel" in e && n(55, J = e.getGroupHeaderLabel), "labelIdentifier" in e && n(56, G = e.labelIdentifier), "getOptionLabel" in e && n(57, Y = e.getOptionLabel), "optionIdentifier" in e && n(58, X = e.optionIdentifier), "loadOptions" in e && n(59, te = e.loadOptions), "hasError" in e && n(10, re = e.hasError), "containerStyles" in e && n(11, oe = e.containerStyles), "getSelectionLabel" in e && n(12, se = e.getSelectionLabel), "createGroupHeaderItem" in e && n(60, ce = e.createGroupHeaderItem), "createItem" in e && n(61, fe = e.createItem), "isSearchable" in e && n(13, de = e.isSearchable), "inputStyles" in e && n(14, pe = e.inputStyles), "isClearable" in e && n(15, ge = e.isClearable), "isWaiting" in e && n(4, be = e.isWaiting), "listPlacement" in e && n(63, we = e.listPlacement), "listOpen" in e && n(5, je = e.listOpen), "isVirtualList" in e && n(64, Ce = e.isVirtualList), "loadOptionsInterval" in e && n(65, $e = e.loadOptionsInterval), "noOptionsMessage" in e && n(66, Ae = e.noOptionsMessage), "hideEmptyState" in e && n(67, Pe = e.hideEmptyState), "inputAttributes" in e && n(16, Ie = e.inputAttributes), "listAutoWidth" in e && n(68, Ne = e.listAutoWidth), "itemHeight" in e && n(69, De = e.itemHeight), "Icon" in e && n(17, Le = e.Icon), "iconProps" in e && n(18, qe = e.iconProps), "showChevron" in e && n(19, Ve = e.showChevron), "showIndicator" in e && n(20, We = e.showIndicator), "containerClasses" in e && n(21, Je = e.containerClasses), "indicatorSvg" in e && n(22, Ge = e.indicatorSvg), "listOffset" in e && n(70, Ye = e.listOffset), "ClearIcon" in e && n(23, Xe = e.ClearIcon), "Item" in e && n(71, tt = e.Item), "List" in e && n(24, rt = e.List), "Selection" in e && n(25, ot = e.Selection), "MultiSelection" in e && n(26, st = e.MultiSelection), "VirtualList" in e && n(72, ct = e.VirtualList), "selectedValue" in e && n(73, kt = e.selectedValue), "ariaValues" in e && n(74, $t = e.ariaValues), "ariaListOpen" in e && n(75, At = e.ariaListOpen), "ariaFocused" in e && n(76, Pt = e.ariaFocused);
  }, e.$$.update = function () {
    var t, h;
    140 & e.$$.dirty[0] | 405340160 & e.$$.dirty[1] && n(81, r = lt({
      loadOptions: te,
      filterText: P,
      items: D,
      value: A,
      isMulti: b,
      optionIdentifier: X,
      groupBy: q,
      isCreatable: C
    })), 2048 & e.$$.dirty[2] && kt && console.warn("selectedValue is no longer used. Please use value instead."), 524288 & e.$$.dirty[1] && function (e) {
      e && 0 !== e.length && !e.some(function (e) {
        return "object" !== Li(e);
      }) && A && (b ? !A.some(function (e) {
        return !e || !e[X];
      }) : A[X]) && (Array.isArray(A) ? n(2, A = A.map(function (e) {
        return jt(e) || e;
      })) : n(2, A = jt() || A));
    }(D), 4 & e.$$.dirty[0] && A && ("string" == typeof A ? n(2, (Mi(t = {}, X, A), Mi(t, "label", A), A = t)) : b && Array.isArray(A) && A.length > 0 && n(2, A = A.map(function (e) {
      return "string" == typeof e ? {
        value: e,
        label: e
      } : e;
    }))), 73728 & e.$$.dirty[0] && (!Ie && de || (n(31, yt = Object.assign({
      autocapitalize: "none",
      autocomplete: "off",
      autocorrect: "off",
      spellcheck: !1,
      tabindex: 0,
      type: "text",
      "aria-autocomplete": "list"
    }, Ie)), d && n(31, yt.id = d, yt), de || n(31, yt.readonly = !0, yt))), 128 & e.$$.dirty[0] | 262144 & e.$$.dirty[2] && (b && A && (Array.isArray(A) ? n(2, A = Ii(A)) : n(2, A = [A])), mt && !b && A && n(2, A = null)), 132 & e.$$.dirty[0] && b && A && A.length > 1 && xt(), 4 & e.$$.dirty[0] && A && (b ? JSON.stringify(A) !== JSON.stringify(dt) && xt() && f("select", A) : dt && JSON.stringify(A[X]) === JSON.stringify(dt[X]) || f("select", A)), 132 & e.$$.dirty[0] | 32768 & e.$$.dirty[2] && !A && b && dt && f("select", A), 2 & e.$$.dirty[0] | 131072 & e.$$.dirty[2] && $ !== pt && ($ || je ? Ct() : g && g.blur()), 8 & e.$$.dirty[0] | 65536 & e.$$.dirty[2] && P !== vt && 0 !== P.length && (n(1, $ = !0), n(5, je = !0), te ? wt() : (n(5, je = !0), b && n(30, ht = void 0))), 12 & e.$$.dirty[0] && n(29, i = A && 0 === P.length), 536904208 & e.$$.dirty[0] && n(37, o = i && ge && !j && !be), 132 & e.$$.dirty[0] | 393216 & e.$$.dirty[1] && n(36, a = N && b ? I : A ? "" : I), 132 & e.$$.dirty[0] && n(35, s = b && A && A.length > 0), 141 & e.$$.dirty[0] | 218103808 & e.$$.dirty[1] | 526326 & e.$$.dirty[2] && n(34, u = {
      Item: tt,
      filterText: P,
      optionIdentifier: X,
      noOptionsMessage: Ae,
      hideEmptyState: Pe,
      isVirtualList: Ce,
      VirtualList: ct,
      value: A,
      isMulti: b,
      getGroupHeaderLabel: J,
      items: r,
      itemHeight: De,
      getOptionLabel: Y,
      listPlacement: we,
      parent: p,
      listAutoWidth: Ne,
      listOffset: Ye
    }), 132 & e.$$.dirty[0] && n(33, c = A ? (h = void 0, h = b && A.length > 0 ? A.map(function (e) {
      return se(e);
    }).join(", ") : se(A), $t(h)) : ""), 268435490 & e.$$.dirty[0] | 524288 & e.$$.dirty[2] && n(32, l = function () {
      if (!$ || !r || 0 === r.length) return "";
      var e = r[gt];
      if (je && e) {
        var t = se(e),
          n = r ? r.length : 0;
        return At(t, n);
      }
      return Pt();
    }());
  }, [p, $, A, P, be, je, g, b, w, j, re, oe, se, de, pe, ge, Ie, Le, qe, Ve, We, Je, Ge, Xe, rt, ot, st, function () {
    n(2, A = void 0), n(5, je = !1), f("clear", A), Ct();
  }, gt, i, ht, yt, l, c, u, s, a, o, St, function (e) {
    if ($) switch (e.key) {
      case "ArrowDown":
      case "ArrowUp":
        e.preventDefault(), n(5, je = !0), n(30, ht = void 0);
        break;
      case "Tab":
        je || n(1, $ = !1);
        break;
      case "Backspace":
        if (!b || P.length > 0) return;
        if (b && A && A.length > 0) {
          if (St(void 0 !== ht ? ht : A.length - 1), 0 === ht || void 0 === ht) break;
          n(30, ht = A.length > ht ? ht - 1 : void 0);
        }
        break;
      case "ArrowLeft":
        if (!b || P.length > 0) return;
        void 0 === ht ? n(30, ht = A.length - 1) : A.length > ht && 0 !== ht && n(30, ht -= 1);
        break;
      case "ArrowRight":
        if (!b || P.length > 0 || void 0 === ht) return;
        ht === A.length - 1 ? n(30, ht = void 0) : ht < A.length - 1 && n(30, ht += 1);
    }
  }, Ct, function (e) {
    if (p) {
      var t = e.path && e.path.length > 0 ? e.path[0] : e.target;
      p.contains(t) || p.contains(e.relatedTarget) || (n(1, $ = !1), n(5, je = !1), n(30, ht = void 0), g && g.blur());
    }
  }, function () {
    j || (n(1, $ = !0), n(5, je = !je));
  }, function (e) {
    var t = e.detail;
    if (t) {
      n(3, P = "");
      var r = Object.assign({}, t);
      r.isGroupHeader && !r.isSelectable || (n(2, A = b ? A ? A.concat([r]) : [r] : r), n(2, A), setTimeout(function () {
        n(5, je = !1), n(30, ht = void 0);
      }));
    }
  }, function (e) {
    var t = e.detail;
    b ? (n(2, A = A || []), n(2, A = [].concat(Ii(A), [fe(t)]))) : n(2, A = fe(t)), f("itemCreated", t), n(3, P = ""), n(5, je = !1), n(30, ht = void 0);
  }, function () {
    n(3, P = ""), n(5, je = !1);
  }, d, C, I, N, D, L, q, V, W, J, G, Y, X, te, ce, fe, function () {
    return r;
  }, we, Ce, $e, Ae, Pe, Ne, De, Ye, tt, ct, kt, $t, At, Pt, dt, vt, pt, mt, r, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(6, g = e);
    });
  }, function () {
    P = this.value, n(3, P);
  }, function (e) {
    n(28, gt = e);
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(0, p = e);
    });
  }];
}
var sK = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, aK, iK, Ji, {
      id: 46,
      container: 0,
      input: 6,
      isMulti: 7,
      multiFullItemClearable: 8,
      isDisabled: 9,
      isCreatable: 47,
      isFocused: 1,
      value: 2,
      filterText: 3,
      placeholder: 48,
      placeholderAlwaysShow: 49,
      items: 50,
      itemFilter: 51,
      groupBy: 52,
      groupFilter: 53,
      isGroupHeaderSelectable: 54,
      getGroupHeaderLabel: 55,
      labelIdentifier: 56,
      getOptionLabel: 57,
      optionIdentifier: 58,
      loadOptions: 59,
      hasError: 10,
      containerStyles: 11,
      getSelectionLabel: 12,
      createGroupHeaderItem: 60,
      createItem: 61,
      getFilteredItems: 62,
      isSearchable: 13,
      inputStyles: 14,
      isClearable: 15,
      isWaiting: 4,
      listPlacement: 63,
      listOpen: 5,
      isVirtualList: 64,
      loadOptionsInterval: 65,
      noOptionsMessage: 66,
      hideEmptyState: 67,
      inputAttributes: 16,
      listAutoWidth: 68,
      itemHeight: 69,
      Icon: 17,
      iconProps: 18,
      showChevron: 19,
      showIndicator: 20,
      containerClasses: 21,
      indicatorSvg: 22,
      listOffset: 70,
      ClearIcon: 23,
      Item: 71,
      List: 24,
      Selection: 25,
      MultiSelection: 26,
      VirtualList: 72,
      selectedValue: 73,
      handleClear: 27,
      ariaValues: 74,
      ariaListOpen: 75,
      ariaFocused: 76
    }, VJ, [-1, -1, -1, -1]), r;
  }
  return zi(n, [{
    key: "getFilteredItems",
    get: function get() {
      return this.$$.ctx[62];
    }
  }, {
    key: "handleClear",
    get: function get() {
      return this.$$.ctx[27];
    }
  }]), n;
}();
function uK(e) {
  co(e, "svelte-13taczd", "table.jse-transform-wizard.svelte-13taczd.svelte-13taczd{border-collapse:collapse;border-spacing:0;width:100%}table.jse-transform-wizard.svelte-13taczd input.svelte-13taczd{font-family:inherit;font-size:inherit}table.jse-transform-wizard.svelte-13taczd tr th.svelte-13taczd{font-weight:normal;text-align:left;width:60px}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd{width:100%;display:flex;flex-direction:row;margin-bottom:calc(0.5 * var(--jse-padding))}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer.jse-filter-path{flex:4;margin-right:calc(0.5 * var(--jse-padding))}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer.jse-filter-relation{flex:1.5;margin-right:calc(0.5 * var(--jse-padding))}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer.jse-sort-path{flex:3;margin-right:calc(0.5 * var(--jse-padding))}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer.jse-sort-direction{flex:1}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer.jse-projection-paths{flex:1}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal.svelte-13taczd .selectContainer input{box-sizing:border-box}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal .jse-filter-value.svelte-13taczd{flex:4;padding:4px 8px;border:var(--jse-input-border);border-radius:var(--jse-input-radius);outline:none;background:var(--jse-input-background);color:inherit}table.jse-transform-wizard.svelte-13taczd tr td .jse-horizontal .jse-filter-value.svelte-13taczd:focus{border:var(--jse-input-border-focus)}");
}
function cK(e) {
  var t, n, r, i, o, a, s, u, _c19, l, f, h, d, v, p, _m14, g, y, b, k, w, x, j, S, C, _, $, O, A, E, P, M, I, T, N;
  function R(t) {
    e[18](t);
  }
  var D = {
    containerClasses: "jse-filter-path",
    showIndicator: !0,
    items: e[6]
  };
  function z(t) {
    e[19](t);
  }
  void 0 !== e[0] && (D.value = e[0]), s = new sK({
    props: D
  }), Xo.push(function () {
    return Oa(s, "value", R);
  });
  var L = {
    containerClasses: "jse-filter-relation",
    showIndicator: !0,
    items: e[8]
  };
  function B(t) {
    e[21](t);
  }
  void 0 !== e[1] && (L.value = e[1]), l = new sK({
    props: L
  }), Xo.push(function () {
    return Oa(l, "value", z);
  });
  var q = {
    containerClasses: "jse-sort-path",
    showIndicator: !0,
    items: e[6]
  };
  function F(t) {
    e[22](t);
  }
  void 0 !== e[3] && (q.value = e[3]), k = new sK({
    props: q
  }), Xo.push(function () {
    return Oa(k, "value", B);
  });
  var V = {
    containerClasses: "jse-sort-direction",
    showIndicator: !0,
    items: e[9]
  };
  function H(t) {
    e[23](t);
  }
  void 0 !== e[4] && (V.value = e[4]), j = new sK({
    props: V
  }), Xo.push(function () {
    return Oa(j, "value", F);
  });
  var W = {
    containerClasses: "jse-projection-paths",
    isMulti: !0,
    showIndicator: !0,
    items: e[7]
  };
  return void 0 !== e[5] && (W.value = e[5]), P = new sK({
    props: W
  }), Xo.push(function () {
    return Oa(P, "value", H);
  }), {
    c: function c() {
      t = go("table"), n = go("tr"), (r = go("th")).textContent = "Filter", i = ko(), o = go("td"), a = go("div"), Aa(s.$$.fragment), _c19 = ko(), Aa(l.$$.fragment), h = ko(), d = go("input"), v = ko(), p = go("tr"), (_m14 = go("th")).textContent = "Sort", g = ko(), y = go("td"), b = go("div"), Aa(k.$$.fragment), x = ko(), Aa(j.$$.fragment), C = ko(), _ = go("tr"), ($ = go("th")).textContent = "Pick", O = ko(), A = go("td"), E = go("div"), Aa(P.$$.fragment), So(r, "class", "svelte-13taczd"), So(d, "class", "jse-filter-value svelte-13taczd"), So(a, "class", "jse-horizontal svelte-13taczd"), So(_m14, "class", "svelte-13taczd"), So(b, "class", "jse-horizontal svelte-13taczd"), So($, "class", "svelte-13taczd"), So(E, "class", "jse-horizontal svelte-13taczd"), So(t, "class", "jse-transform-wizard svelte-13taczd");
    },
    m: function m(u, f) {
      vo(u, t, f), uo(t, n), uo(n, r), uo(n, i), uo(n, o), uo(o, a), Ea(s, a, null), uo(a, _c19), Ea(l, a, null), uo(a, h), uo(a, d), Eo(d, e[2]), uo(t, v), uo(t, p), uo(p, _m14), uo(p, g), uo(p, y), uo(y, b), Ea(k, b, null), uo(b, x), Ea(j, b, null), uo(t, C), uo(t, _), uo(_, $), uo(_, O), uo(_, A), uo(A, E), Ea(P, E, null), I = !0, T || (N = xo(d, "input", e[20]), T = !0);
    },
    p: function p(e, t) {
      var n = {};
      64 & t[0] && (n.items = e[6]), !u && 1 & t[0] && (u = !0, n.value = e[0], sa(function () {
        return u = !1;
      })), s.$set(n);
      var r = {};
      !f && 2 & t[0] && (f = !0, r.value = e[1], sa(function () {
        return f = !1;
      })), l.$set(r), 4 & t[0] && d.value !== e[2] && Eo(d, e[2]);
      var i = {};
      64 & t[0] && (i.items = e[6]), !w && 8 & t[0] && (w = !0, i.value = e[3], sa(function () {
        return w = !1;
      })), k.$set(i);
      var o = {};
      !S && 16 & t[0] && (S = !0, o.value = e[4], sa(function () {
        return S = !1;
      })), j.$set(o);
      var a = {};
      128 & t[0] && (a.items = e[7]), !M && 32 & t[0] && (M = !0, a.value = e[5], sa(function () {
        return M = !1;
      })), P.$set(a);
    },
    i: function i(e) {
      I || (ya(s.$$.fragment, e), ya(l.$$.fragment, e), ya(k.$$.fragment, e), ya(j.$$.fragment, e), ya(P.$$.fragment, e), I = !0);
    },
    o: function o(e) {
      ba(s.$$.fragment, e), ba(l.$$.fragment, e), ba(k.$$.fragment, e), ba(j.$$.fragment, e), ba(P.$$.fragment, e), I = !1;
    },
    d: function d(e) {
      e && po(t), Pa(s), Pa(l), Pa(k), Pa(j), Pa(P), T = !1, N();
    }
  };
}
function lK(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f,
    h,
    d,
    v,
    p = Na("jsoneditor:TransformWizard"),
    m = t.json,
    g = t.queryOptions,
    y = void 0 === g ? {} : g,
    b = t.onChange,
    k = ["==", "!=", "<", "<=", ">", ">="].map(function (e) {
      return {
        value: e,
        label: e
      };
    }),
    w = [{
      value: "asc",
      label: "ascending"
    }, {
      value: "desc",
      label: "descending"
    }],
    x = (null === (u = null == y ? void 0 : y.filter) || void 0 === u ? void 0 : u.path) ? O(y.filter.path) : null,
    j = (null === (c = null == y ? void 0 : y.filter) || void 0 === c ? void 0 : c.relation) ? k.find(function (e) {
      return e.value === y.filter.relation;
    }) : null,
    S = (null === (l = null == y ? void 0 : y.filter) || void 0 === l ? void 0 : l.value) || "",
    C = (null === (f = null == y ? void 0 : y.sort) || void 0 === f ? void 0 : f.path) ? O(y.sort.path) : null,
    _ = (null === (h = null == y ? void 0 : y.sort) || void 0 === h ? void 0 : h.direction) ? w.find(function (e) {
      return e.value === y.sort.direction;
    }) : null,
    $ = (null === (d = null == y ? void 0 : y.projection) || void 0 === d ? void 0 : d.paths) ? y.projection.paths.map(O) : null;
  function O(e) {
    return {
      value: e,
      label: Ym(e) ? "(whole item)" : rC(e)
    };
  }
  return e.$$set = function (e) {
    "json" in e && n(11, m = e.json), "queryOptions" in e && n(10, y = e.queryOptions), "onChange" in e && n(12, b = e.onChange);
  }, e.$$.update = function () {
    2048 & e.$$.dirty[0] && n(17, r = Array.isArray(m)), 133120 & e.$$.dirty[0] && n(16, i = r ? Js(m) : []), 133120 & e.$$.dirty[0] && n(15, o = r ? Js(m, !0) : []), 65536 & e.$$.dirty[0] && n(6, a = i.map(O)), 32768 & e.$$.dirty[0] && n(7, s = o ? o.map(O) : []), 17472 & e.$$.dirty[0] && (null === n(14, v = null == y ? void 0 : y.filter) || void 0 === v ? void 0 : v.path) && a.find(function (e) {
      var t;
      return Zm(e.value, null === (t = null == y ? void 0 : y.filter) || void 0 === t ? void 0 : t.path);
    }), 1 & e.$$.dirty[0] && function (e) {
      var t;
      Zm(null === (t = null == y ? void 0 : y.filter) || void 0 === t ? void 0 : t.path, e) || (p("changeFilterPath", e), n(10, y = ks.exports.setIn(y, ["filter", "path"], e, !0)), b(y));
    }((null == x ? void 0 : x.value) || null), 2 & e.$$.dirty[0] && function (e) {
      var t;
      Zm(null === (t = null == y ? void 0 : y.filter) || void 0 === t ? void 0 : t.relation, e) || (p("changeFilterRelation", e), n(10, y = ks.exports.setIn(y, ["filter", "relation"], e, !0)), b(y));
    }((null == j ? void 0 : j.value) || null), 4 & e.$$.dirty[0] && function (e) {
      var t;
      Zm(null === (t = null == y ? void 0 : y.filter) || void 0 === t ? void 0 : t.value, e) || (p("changeFilterValue", e), n(10, y = ks.exports.setIn(y, ["filter", "value"], e, !0)), b(y));
    }(S || null), 8 & e.$$.dirty[0] && function (e) {
      var t;
      Zm(null === (t = null == y ? void 0 : y.sort) || void 0 === t ? void 0 : t.path, e) || (p("changeSortPath", e), n(10, y = ks.exports.setIn(y, ["sort", "path"], e, !0)), b(y));
    }((null == C ? void 0 : C.value) || null), 16 & e.$$.dirty[0] && function (e) {
      var t;
      Zm(null === (t = null == y ? void 0 : y.sort) || void 0 === t ? void 0 : t.direction, e) || (p("changeSortDirection", e), n(10, y = ks.exports.setIn(y, ["sort", "direction"], e, !0)), b(y));
    }((null == _ ? void 0 : _.value) || null), 32 & e.$$.dirty[0] && function (e) {
      var t;
      Zm(null === (t = null == y ? void 0 : y.projection) || void 0 === t ? void 0 : t.paths, e) || (p("changeProjectionPaths", e), n(10, y = ks.exports.setIn(y, ["projection", "paths"], e, !0)), b(y));
    }($ ? $.map(function (e) {
      return e.value;
    }) : null);
  }, [x, j, S, C, _, $, a, s, k, w, y, m, b, u, v, o, i, r, function (e) {
    n(0, x = e);
  }, function (e) {
    n(1, j = e);
  }, function () {
    S = this.value, n(2, S);
  }, function (e) {
    n(3, C = e);
  }, function (e) {
    n(4, _ = e);
  }, function (e) {
    n(5, $ = e);
  }];
}
var fK = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, lK, cK, Ki, {
      json: 11,
      queryOptions: 10,
      onChange: 12
    }, uK, [-1, -1]), r;
  }
  return zi(n);
}();
function hK(e) {
  co(e, "svelte-19cxesy", ".jse-select-query-language.svelte-19cxesy.svelte-19cxesy{position:relative;width:32px}.jse-select-query-language.svelte-19cxesy .jse-select-query-language-container.svelte-19cxesy{position:absolute;top:0;right:0;display:flex;flex-direction:column;box-shadow:var(--jse-controls-box-shadow)}.jse-select-query-language.svelte-19cxesy .jse-select-query-language-container .jse-query-language.svelte-19cxesy{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;text-align:left;padding:var(--jse-padding) calc(2 * var(--jse-padding));white-space:nowrap;color:var(--jse-context-menu-color);background:var(--jse-context-menu-background)}.jse-select-query-language.svelte-19cxesy .jse-select-query-language-container .jse-query-language.svelte-19cxesy:hover{background:var(--jse-context-menu-background-highlight)}");
}
function dK(e, t, n) {
  var r = e.slice();
  return r[5] = t[n], r;
}
function vK(e) {
  var t, n;
  return t = new KS({
    props: {
      data: pV
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: Bi,
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function pK(e) {
  var t, n;
  return t = new KS({
    props: {
      data: mV
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: Bi,
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function mK(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    c,
    l,
    f = e[5].name + "",
    h = [pK, vK],
    _d9 = [];
  function v(e, t) {
    return e[5].id === e[0] ? 0 : 1;
  }
  function p() {
    return e[4](e[5]);
  }
  return n = v(e), r = _d9[n] = h[n](e), {
    c: function c() {
      t = go("button"), r.c(), i = ko(), o = bo(f), a = ko(), So(t, "type", "button"), So(t, "class", "jse-query-language svelte-19cxesy"), So(t, "title", s = "Select ".concat(e[5].name, " as query language")), To(t, "selected", e[5].id === e[0]);
    },
    m: function m(e, r) {
      vo(e, t, r), _d9[n].m(t, null), uo(t, i), uo(t, o), uo(t, a), u = !0, c || (l = xo(t, "click", p), c = !0);
    },
    p: function p(a, c) {
      var l = n;
      (n = v(e = a)) === l ? _d9[n].p(e, c) : (ma(), ba(_d9[l], 1, 1, function () {
        _d9[l] = null;
      }), ga(), (r = _d9[n]) ? r.p(e, c) : (r = _d9[n] = h[n](e)).c(), ya(r, 1), r.m(t, i)), (!u || 2 & c) && f !== (f = e[5].name + "") && Ao(o, f), (!u || 2 & c && s !== (s = "Select ".concat(e[5].name, " as query language"))) && So(t, "title", s), 3 & c && To(t, "selected", e[5].id === e[0]);
    },
    i: function i(e) {
      u || (ya(r), u = !0);
    },
    o: function o(e) {
      ba(r), u = !1;
    },
    d: function d(e) {
      e && po(t), _d9[n].d(), c = !1, l();
    }
  };
}
function gK(e) {
  for (var t, n, r, _i37 = e[1], _o23 = [], a = 0; a < _i37.length; a += 1) {
    _o23[a] = mK(dK(e, _i37, a));
  }
  var s = function s(e) {
    return ba(_o23[e], 1, 1, function () {
      _o23[e] = null;
    });
  };
  return {
    c: function c() {
      t = go("div"), n = go("div");
      for (var e = 0; e < _o23.length; e += 1) {
        _o23[e].c();
      }
      So(n, "class", "jse-select-query-language-container svelte-19cxesy"), So(t, "class", "jse-select-query-language svelte-19cxesy");
    },
    m: function m(e, i) {
      vo(e, t, i), uo(t, n);
      for (var a = 0; a < _o23.length; a += 1) {
        _o23[a].m(n, null);
      }
      r = !0;
    },
    p: function p(e, t) {
      var r = xi(t, 1)[0];
      if (7 & r) {
        var a;
        for (_i37 = e[1], a = 0; a < _i37.length; a += 1) {
          var u = dK(e, _i37, a);
          _o23[a] ? (_o23[a].p(u, r), ya(_o23[a], 1)) : (_o23[a] = mK(u), _o23[a].c(), ya(_o23[a], 1), _o23[a].m(n, null));
        }
        for (ma(), a = _i37.length; a < _o23.length; a += 1) {
          s(a);
        }
        ga();
      }
    },
    i: function i(e) {
      if (!r) {
        for (var t = 0; t < _i37.length; t += 1) {
          ya(_o23[t]);
        }
        r = !0;
      }
    },
    o: function o(e) {
      _o23 = _o23.filter(Boolean);
      for (var t = 0; t < _o23.length; t += 1) {
        ba(_o23[t]);
      }
      r = !1;
    },
    d: function d(e) {
      e && po(t), mo(_o23, e);
    }
  };
}
function yK(e, t, n) {
  var r = t.queryLanguages,
    i = t.queryLanguageId,
    o = t.onChangeQueryLanguage;
  function a(e) {
    n(0, i = e), o(e);
  }
  return e.$$set = function (e) {
    "queryLanguages" in e && n(1, r = e.queryLanguages), "queryLanguageId" in e && n(0, i = e.queryLanguageId), "onChangeQueryLanguage" in e && n(3, o = e.onChangeQueryLanguage);
  }, [i, r, a, o, function (e) {
    return a(e.id);
  }];
}
var bK = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, yK, gK, Ji, {
      queryLanguages: 1,
      queryLanguageId: 0,
      onChangeQueryLanguage: 3
    }, hK), r;
  }
  return zi(n);
}();
function kK(e) {
  co(e, "svelte-d01h2s", ".jse-header.svelte-d01h2s.svelte-d01h2s{display:flex;background:var(--jse-theme-color);color:var(--jse-menu-color)}.jse-header.svelte-d01h2s .jse-title.svelte-d01h2s{flex:1;padding:5px;vertical-align:middle}.jse-header.svelte-d01h2s button.svelte-d01h2s{border:none;background:transparent;min-width:32px;color:inherit;cursor:pointer}.jse-header.svelte-d01h2s button.svelte-d01h2s:hover{background:rgba(255, 255, 255, 0.1)}");
}
function wK(e) {
  var t, n, r, i, o;
  return n = new KS({
    props: {
      data: fS
    }
  }), {
    c: function c() {
      t = go("button"), Aa(n.$$.fragment), So(t, "type", "button"), So(t, "class", "jse-config svelte-d01h2s"), So(t, "title", "Select a query language");
    },
    m: function m(a, s) {
      vo(a, t, s), Ea(n, t, null), e[6](t), r = !0, i || (o = xo(t, "click", e[3]), i = !0);
    },
    p: Bi,
    i: function i(e) {
      r || (ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), r = !1;
    },
    d: function d(r) {
      r && po(t), Pa(n), e[6](null), i = !1, o();
    }
  };
}
function xK(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    c,
    l = e[0].length > 1 && wK(e);
  return a = new KS({
    props: {
      data: kS
    }
  }), {
    c: function c() {
      t = go("div"), (n = go("div")).textContent = "Transform", r = ko(), l && l.c(), i = ko(), o = go("button"), Aa(a.$$.fragment), So(n, "class", "jse-title svelte-d01h2s"), So(o, "type", "button"), So(o, "class", "jse-close svelte-d01h2s"), So(t, "class", "jse-header svelte-d01h2s");
    },
    m: function m(f, h) {
      vo(f, t, h), uo(t, n), uo(t, r), l && l.m(t, null), uo(t, i), uo(t, o), Ea(a, o, null), s = !0, u || (c = xo(o, "click", e[2]), u = !0);
    },
    p: function p(e, n) {
      var r = xi(n, 1)[0];
      e[0].length > 1 ? l ? (l.p(e, r), 1 & r && ya(l, 1)) : ((l = wK(e)).c(), ya(l, 1), l.m(t, i)) : l && (ma(), ba(l, 1, 1, function () {
        l = null;
      }), ga());
    },
    i: function i(e) {
      s || (ya(l), ya(a.$$.fragment, e), s = !0);
    },
    o: function o(e) {
      ba(l), ba(a.$$.fragment, e), s = !1;
    },
    d: function d(e) {
      e && po(t), l && l.d(), Pa(a), u = !1, c();
    }
  };
}
function jK(e, t, n) {
  var r,
    i = t.queryLanguages,
    o = t.queryLanguageId,
    a = t.onChangeQueryLanguage,
    s = Yo("simple-modal").close,
    u = Yo("absolute-popup"),
    c = u.openAbsolutePopup,
    l = u.closeAbsolutePopup;
  return e.$$set = function (e) {
    "queryLanguages" in e && n(0, i = e.queryLanguages), "queryLanguageId" in e && n(4, o = e.queryLanguageId), "onChangeQueryLanguage" in e && n(5, a = e.onChangeQueryLanguage);
  }, [i, r, s, function () {
    c(bK, {
      queryLanguages: i,
      queryLanguageId: o,
      onChangeQueryLanguage: function onChangeQueryLanguage(e) {
        l(), a(e);
      }
    }, {
      position: "bottom",
      offsetTop: -2,
      offsetLeft: 0,
      anchor: r,
      closeOnOuterClick: !0
    });
  }, o, a, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(1, r = e);
    });
  }];
}
var SK = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, jK, xK, Ki, {
      queryLanguages: 0,
      queryLanguageId: 4,
      onChangeQueryLanguage: 5
    }, kK), r;
  }
  return zi(n);
}();
function CK(e) {
  co(e, "svelte-15uz9w0", ".jse-modal.svelte-15uz9w0.svelte-15uz9w0{--height:36px;--multiItemHeight:28px;--multiItemMargin:2px;--multiItemPadding:2px 8px;--multiClearTop:5px;--multiItemBorderRadius:6px;--clearSelectTop:2px;--clearSelectBottom:2px;--indicatorTop:8px;flex:1;display:flex;flex-direction:column;font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;background:var(--jse-modal-background);color:var(--jse-text-color)}.jse-modal.svelte-15uz9w0 .jse-contents.svelte-15uz9w0{padding:20px;overflow:auto}.jse-modal.svelte-15uz9w0 .jse-contents .jse-actions.svelte-15uz9w0{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding)}.jse-modal.svelte-15uz9w0 .jse-contents .jse-actions button.svelte-15uz9w0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;background:var(--jse-button-primary-background);color:var(--jse-button-primary-color);padding:var(--jse-padding) calc(2 * var(--jse-padding));border-radius:3px}.jse-modal.svelte-15uz9w0 .jse-contents .jse-actions button.svelte-15uz9w0:hover{background:var(--jse-button-primary-background-highlight)}.jse-modal.svelte-15uz9w0 .jse-contents .jse-actions button.svelte-15uz9w0:disabled{background:var(--jse-button-primary-background-disabled)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-modal-overlay-background)}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-content{flex:1;display:flex;max-height:calc(100vh - 6rem);padding:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents.svelte-15uz9w0{flex:1;display:flex;flex-direction:column;color:inherit;min-height:0;padding:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents.svelte-15uz9w0{flex:1;display:flex;gap:calc(2 * var(--jse-padding));min-height:0;box-sizing:border-box;padding:0 calc(2 * var(--jse-padding)) var(--jse-padding)}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents.svelte-15uz9w0{flex:1;display:flex;flex-direction:column}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents .jse-description.svelte-15uz9w0 p{margin:var(--jse-padding) 0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents .jse-description.svelte-15uz9w0 p:first-child{margin-top:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents .jse-description.svelte-15uz9w0 p:last-child{margin-bottom:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents .jse-description.svelte-15uz9w0 code{background:var(--jse-modal-code-background);font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono)}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents textarea.jse-query.svelte-15uz9w0{flex:1;outline:none;resize:vertical}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents.svelte-15uz9w0{flex:1;display:flex;flex-direction:column;gap:calc(2 * var(--jse-padding))}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents .jse-original-data.svelte-15uz9w0{flex:1;display:flex;flex-direction:column;min-height:0;box-sizing:border-box}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents .jse-original-data.jse-hide.svelte-15uz9w0{flex:none}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents .jse-preview-data.svelte-15uz9w0{flex:1;display:flex;flex-direction:column;min-height:0;box-sizing:border-box}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents.jse-hide-original-data.svelte-15uz9w0{flex-direction:column;gap:0;margin-bottom:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-actions.svelte-15uz9w0{padding:var(--jse-padding) calc(2 * var(--jse-padding)) calc(2 * var(--jse-padding))}@media screen and (max-width: 1200px){.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents.svelte-15uz9w0{flex-direction:column;overflow:auto}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-query-contents textarea.jse-query.svelte-15uz9w0{min-height:150px;flex:none}.jse-modal.jse-transform.svelte-15uz9w0 .jse-contents .jse-main-contents .jse-data-contents.svelte-15uz9w0 .jse-tree-mode{height:300px;flex:none}}.jse-modal.jse-transform.svelte-15uz9w0 .jse-label.svelte-15uz9w0{font-weight:bold;display:block;box-sizing:border-box}.jse-modal.jse-transform.svelte-15uz9w0 .jse-label .jse-label-inner.svelte-15uz9w0{margin-top:calc(2 * var(--jse-padding));margin-bottom:calc(0.5 * var(--jse-padding));box-sizing:border-box}.jse-modal.jse-transform.svelte-15uz9w0 .jse-label .jse-label-inner button.svelte-15uz9w0{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;font-weight:bold;padding:0}.jse-modal.jse-transform.svelte-15uz9w0 .jse-tree-mode{flex:1;background:var(--jse-input-background-readonly);box-shadow:none;box-sizing:border-box;--jse-main-border:var(--jse-input-border)}.jse-modal.jse-transform.svelte-15uz9w0 input.svelte-15uz9w0,.jse-modal.jse-transform.svelte-15uz9w0 textarea.svelte-15uz9w0{border:var(--jse-input-border);outline:none;box-sizing:border-box;padding:calc(0.5 * var(--jse-padding));font-family:var(--jse-font-family-mono);font-size:var(--jse-font-size-mono);color:inherit;background:var(--jse-input-background)}.jse-modal.jse-transform.svelte-15uz9w0 input.svelte-15uz9w0:focus,.jse-modal.jse-transform.svelte-15uz9w0 textarea.svelte-15uz9w0:focus{border:var(--jse-input-border-focus)}.jse-modal.jse-transform.svelte-15uz9w0 input.svelte-15uz9w0:read-only,.jse-modal.jse-transform.svelte-15uz9w0 textarea.svelte-15uz9w0:read-only{background:var(--jse-input-background-readonly)}.jse-modal.jse-transform.svelte-15uz9w0 .jse-preview.jse-error.svelte-15uz9w0{flex:1;background:var(--jse-input-background-readonly);border:var(--jse-input-border);color:var(--jse-error-color);padding:calc(0.5 * var(--jse-padding))}.jse-modal.jse-transform.svelte-15uz9w0 a{color:var(--jse-a-color)}.jse-modal.jse-transform.svelte-15uz9w0 a:hover{color:var(--jse-a-color-highlight)}");
}
function _K(e) {
  var t,
    n,
    r,
    i,
    _o24,
    a = [OK, $K],
    s = [];
  function u(e, n) {
    return 512 & n[0] && (t = null), null == t && (t = !!Array.isArray(e[9])), t ? 0 : 1;
  }
  return n = u(e, [-1, -1]), r = s[n] = a[n](e), {
    c: function c() {
      r.c(), i = wo();
    },
    m: function m(e, t) {
      s[n].m(e, t), vo(e, i, t), _o24 = !0;
    },
    p: function p(e, t) {
      var o = n;
      (n = u(e, t)) === o ? s[n].p(e, t) : (ma(), ba(s[o], 1, 1, function () {
        s[o] = null;
      }), ga(), (r = s[n]) ? r.p(e, t) : (r = s[n] = a[n](e)).c(), ya(r, 1), r.m(i.parentNode, i));
    },
    i: function i(e) {
      _o24 || (ya(r), _o24 = !0);
    },
    o: function o(e) {
      ba(r), _o24 = !1;
    },
    d: function d(e) {
      s[n].d(e), e && po(i);
    }
  };
}
function $K(e) {
  var t;
  return {
    c: function c() {
      t = bo("(Only available for arrays, not for objects)");
    },
    m: function m(e, n) {
      vo(e, t, n);
    },
    p: Bi,
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function OK(e) {
  var t, n;
  return t = new fK({
    props: {
      queryOptions: e[7],
      json: e[9],
      onChange: e[16]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      128 & n[0] && (r.queryOptions = e[7]), 512 & n[0] && (r.json = e[9]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function AK(e) {
  var t, n;
  return t = new CU({
    props: {
      externalContent: e[14],
      readOnly: !0,
      mainMenuBar: !1,
      navigationBar: !1,
      escapeControlCharacters: e[2],
      escapeUnicodeCharacters: e[3],
      onRenderValue: e[5],
      onError: console.error,
      onChange: kc,
      onFocus: kc,
      onBlur: kc,
      onSortModal: kc,
      onTransformModal: kc,
      onClassName: e[6]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      16384 & n[0] && (r.externalContent = e[14]), 4 & n[0] && (r.escapeControlCharacters = e[2]), 8 & n[0] && (r.escapeUnicodeCharacters = e[3]), 32 & n[0] && (r.onRenderValue = e[5]), 64 & n[0] && (r.onClassName = e[6]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function EK(e) {
  var t,
    n,
    r = e[12].toString() + "";
  return {
    c: function c() {
      t = go("div"), n = bo(r), So(t, "class", "jse-preview jse-error svelte-15uz9w0");
    },
    m: function m(e, r) {
      vo(e, t, r), uo(t, n);
    },
    p: function p(e, t) {
      4096 & t[0] && r !== (r = e[12].toString() + "") && Ao(n, r);
    },
    i: Bi,
    o: Bi,
    d: function d(e) {
      e && po(t);
    }
  };
}
function PK(e) {
  var t, n;
  return t = new CU({
    props: {
      externalContent: e[13],
      readOnly: !0,
      mainMenuBar: !1,
      navigationBar: !1,
      escapeControlCharacters: e[2],
      escapeUnicodeCharacters: e[3],
      onRenderValue: e[5],
      onError: console.error,
      onChange: kc,
      onFocus: kc,
      onBlur: kc,
      onSortModal: kc,
      onTransformModal: kc,
      onClassName: e[6]
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      8192 & n[0] && (r.externalContent = e[13]), 4 & n[0] && (r.escapeControlCharacters = e[2]), 8 & n[0] && (r.escapeUnicodeCharacters = e[3]), 32 & n[0] && (r.onRenderValue = e[5]), 64 & n[0] && (r.onClassName = e[6]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function MK(e) {
  var t,
    n,
    r,
    i,
    o,
    a,
    s,
    u,
    _c20,
    l,
    f,
    h,
    d,
    v,
    p,
    _m15,
    g,
    y,
    b,
    k,
    w,
    x,
    j,
    S,
    C,
    _,
    $,
    O,
    A,
    E,
    P,
    M,
    I,
    T,
    N,
    R,
    D,
    z,
    L,
    B,
    q,
    F,
    V,
    H,
    W,
    U,
    J,
    K = e[15](e[0]).description + "";
  t = new SK({
    props: {
      queryLanguages: e[4],
      queryLanguageId: e[0],
      onChangeQueryLanguage: e[21]
    }
  }), y = new KS({
    props: {
      data: e[10] ? Xj : eS
    }
  });
  var G = e[10] && _K(e);
  P = new KS({
    props: {
      data: e[11] ? Xj : eS
    }
  });
  var Q = e[11] && AK(e),
    Y = [PK, EK],
    Z = [];
  function X(e, t) {
    return e[12] ? 1 : 0;
  }
  return z = X(e), L = Z[z] = Y[z](e), {
    c: function c() {
      Aa(t.$$.fragment), n = ko(), r = go("div"), i = go("div"), o = go("div"), (a = go("div")).innerHTML = '<div class="jse-label-inner svelte-15uz9w0">Language</div>', s = ko(), u = go("div"), _c20 = ko(), (l = go("div")).innerHTML = '<div class="jse-label-inner svelte-15uz9w0">Path</div>', f = ko(), h = go("input"), v = ko(), p = go("div"), _m15 = go("div"), g = go("button"), Aa(y.$$.fragment), b = bo("\n                Wizard"), k = ko(), G && G.c(), w = ko(), (x = go("div")).innerHTML = '<div class="jse-label-inner svelte-15uz9w0">Query</div>', j = ko(), S = go("textarea"), C = ko(), _ = go("div"), $ = go("div"), O = go("div"), A = go("div"), E = go("button"), Aa(P.$$.fragment), M = bo("\n                  Original"), I = ko(), Q && Q.c(), T = ko(), N = go("div"), (R = go("div")).innerHTML = '<div class="jse-label-inner svelte-15uz9w0">Preview</div>', D = ko(), L.c(), B = ko(), q = go("div"), F = go("button"), V = bo("Transform"), So(a, "class", "jse-label svelte-15uz9w0"), So(u, "class", "jse-description svelte-15uz9w0"), So(l, "class", "jse-label svelte-15uz9w0"), So(h, "class", "jse-path svelte-15uz9w0"), So(h, "type", "text"), h.readOnly = !0, So(h, "title", "Selected path"), h.value = d = Ym(e[1]) ? "(whole document)" : rC(e[1]), So(g, "type", "button"), So(g, "class", "svelte-15uz9w0"), So(_m15, "class", "jse-label-inner svelte-15uz9w0"), So(p, "class", "jse-label svelte-15uz9w0"), So(x, "class", "jse-label svelte-15uz9w0"), So(S, "class", "jse-query svelte-15uz9w0"), So(S, "spellcheck", "false"), S.value = e[8], So(o, "class", "jse-query-contents svelte-15uz9w0"), So(E, "type", "button"), So(E, "class", "svelte-15uz9w0"), So(A, "class", "jse-label-inner svelte-15uz9w0"), So(O, "class", "jse-label svelte-15uz9w0"), So($, "class", "jse-original-data svelte-15uz9w0"), To($, "jse-hide", !e[11]), So(R, "class", "jse-label svelte-15uz9w0"), So(N, "class", "jse-preview-data svelte-15uz9w0"), So(_, "class", "jse-data-contents svelte-15uz9w0"), To(_, "jse-hide-original-data", !e[11]), So(i, "class", "jse-main-contents svelte-15uz9w0"), So(F, "type", "button"), So(F, "class", "jse-primary svelte-15uz9w0"), F.disabled = H = !!e[12], So(q, "class", "jse-actions svelte-15uz9w0"), So(r, "class", "jse-contents svelte-15uz9w0");
    },
    m: function m(d, L) {
      Ea(t, d, L), vo(d, n, L), vo(d, r, L), uo(r, i), uo(i, o), uo(o, a), uo(o, s), uo(o, u), u.innerHTML = K, uo(o, _c20), uo(o, l), uo(o, f), uo(o, h), uo(o, v), uo(o, p), uo(p, _m15), uo(_m15, g), Ea(y, g, null), uo(g, b), uo(o, k), G && G.m(o, null), uo(o, w), uo(o, x), uo(o, j), uo(o, S), uo(i, C), uo(i, _), uo(_, $), uo($, O), uo(O, A), uo(A, E), Ea(P, E, null), uo(E, M), uo($, I), Q && Q.m($, null), uo(_, T), uo(_, N), uo(N, R), uo(N, D), Z[z].m(N, null), uo(r, B), uo(r, q), uo(q, F), uo(F, V), W = !0, U || (J = [xo(g, "click", e[19]), xo(S, "input", e[17]), xo(E, "click", e[20]), xo(F, "click", e[18]), to(TK.call(null, F))], U = !0);
    },
    p: function p(e, n) {
      var r = {};
      16 & n[0] && (r.queryLanguages = e[4]), 1 & n[0] && (r.queryLanguageId = e[0]), t.$set(r), (!W || 1 & n[0]) && K !== (K = e[15](e[0]).description + "") && (u.innerHTML = K), (!W || 2 & n[0] && d !== (d = Ym(e[1]) ? "(whole document)" : rC(e[1])) && h.value !== d) && (h.value = d);
      var i = {};
      1024 & n[0] && (i.data = e[10] ? Xj : eS), y.$set(i), e[10] ? G ? (G.p(e, n), 1024 & n[0] && ya(G, 1)) : ((G = _K(e)).c(), ya(G, 1), G.m(o, w)) : G && (ma(), ba(G, 1, 1, function () {
        G = null;
      }), ga()), (!W || 256 & n[0]) && (S.value = e[8]);
      var a = {};
      2048 & n[0] && (a.data = e[11] ? Xj : eS), P.$set(a), e[11] ? Q ? (Q.p(e, n), 2048 & n[0] && ya(Q, 1)) : ((Q = AK(e)).c(), ya(Q, 1), Q.m($, null)) : Q && (ma(), ba(Q, 1, 1, function () {
        Q = null;
      }), ga()), 2048 & n[0] && To($, "jse-hide", !e[11]);
      var s = z;
      (z = X(e)) === s ? Z[z].p(e, n) : (ma(), ba(Z[s], 1, 1, function () {
        Z[s] = null;
      }), ga(), (L = Z[z]) ? L.p(e, n) : (L = Z[z] = Y[z](e)).c(), ya(L, 1), L.m(N, null)), 2048 & n[0] && To(_, "jse-hide-original-data", !e[11]), (!W || 4096 & n[0] && H !== (H = !!e[12])) && (F.disabled = H);
    },
    i: function i(e) {
      W || (ya(t.$$.fragment, e), ya(y.$$.fragment, e), ya(G), ya(P.$$.fragment, e), ya(Q), ya(L), W = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), ba(y.$$.fragment, e), ba(G), ba(P.$$.fragment, e), ba(Q), ba(L), W = !1;
    },
    d: function d(e) {
      Pa(t, e), e && po(n), e && po(r), Pa(y), G && G.d(), Pa(P), Q && Q.d(), Z[z].d(), U = !1, Wi(J);
    }
  };
}
function IK(e) {
  var t, n, r;
  return n = new Uj({
    props: {
      $$slots: {
        default: [MK]
      },
      $$scope: {
        ctx: e
      }
    }
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), So(t, "class", "jse-modal jse-transform svelte-15uz9w0");
    },
    m: function m(e, i) {
      vo(e, t, i), Ea(n, t, null), r = !0;
    },
    p: function p(e, t) {
      var r = {};
      32767 & t[0] | 8 & t[1] && (r.$$scope = {
        dirty: t,
        ctx: e
      }), n.$set(r);
    },
    i: function i(e) {
      r || (ya(n.$$.fragment, e), r = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), r = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n);
    }
  };
}
function TK(e) {
  e.focus();
}
function NK(e, t, n) {
  var r,
    i,
    o = Na("jsoneditor:TransformModal"),
    a = t.id,
    s = void 0 === a ? "transform-modal-" + ys() : a,
    u = t.json,
    c = t.selectedPath,
    l = void 0 === c ? [] : c,
    f = t.escapeControlCharacters,
    h = t.escapeUnicodeCharacters,
    d = t.queryLanguages,
    v = t.queryLanguageId,
    p = t.onChangeQueryLanguage,
    m = t.onRenderValue,
    g = t.onClassName,
    y = t.onTransform,
    b = Yo("simple-modal").close,
    k = "".concat(s, ":").concat(ks.exports.compileJSONPointer(l)),
    w = eJ[k] || {},
    x = !1 !== eJ.showWizard,
    j = !1 !== eJ.showOriginal,
    S = w.queryOptions || {},
    C = v === w.queryLanguageId && w.query ? w.query : A(v).createQuery(u, w.queryOptions || {}),
    _ = w.isManual || !1,
    $ = void 0,
    O = {
      text: ""
    };
  function A(e) {
    return d.find(function (t) {
      return t.id === e;
    }) || d[0];
  }
  var E = Ev(function (e, t) {
    try {
      o("previewTransform", {
        query: t
      });
      var r = A(v).executeQuery(e, t);
      n(13, O = {
        json: r
      }), n(12, $ = void 0);
    } catch (e) {
      n(13, O = {
        text: ""
      }), n(12, $ = e);
    }
  }, 300);
  return e.$$set = function (e) {
    "id" in e && n(22, s = e.id), "json" in e && n(23, u = e.json), "selectedPath" in e && n(1, l = e.selectedPath), "escapeControlCharacters" in e && n(2, f = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && n(3, h = e.escapeUnicodeCharacters), "queryLanguages" in e && n(4, d = e.queryLanguages), "queryLanguageId" in e && n(0, v = e.queryLanguageId), "onChangeQueryLanguage" in e && n(24, p = e.onChangeQueryLanguage), "onRenderValue" in e && n(5, m = e.onRenderValue), "onClassName" in e && n(6, g = e.onClassName), "onTransform" in e && n(25, y = e.onTransform);
  }, e.$$.update = function () {
    8388610 & e.$$.dirty[0] && n(9, r = ks.exports.getIn(u, l)), 512 & e.$$.dirty[0] && n(14, i = {
      json: r
    }), 768 & e.$$.dirty[0] && E(r, C), 201326977 & e.$$.dirty[0] && (n(26, eJ[k] = {
      queryOptions: S,
      query: C,
      queryLanguageId: v,
      isManual: _
    }, eJ), o("store state in memory", k, eJ[k]));
  }, [v, l, f, h, d, m, g, S, C, r, x, j, $, O, i, A, function (e) {
    n(7, S = e), n(8, C = A(v).createQuery(u, e)), n(27, _ = !1), o("updateQueryByWizard", {
      queryOptions: S,
      query: C,
      isManual: _
    });
  }, function (e) {
    n(8, C = e.target.value), n(27, _ = !0), o("handleChangeQuery", {
      query: C,
      isManual: _
    });
  }, function () {
    try {
      o("handleTransform", {
        query: C
      });
      var e = A(v).executeQuery(r, C);
      y([{
        op: "replace",
        path: ks.exports.compileJSONPointer(l),
        value: e
      }]), b();
    } catch (e) {
      console.error(e), n(13, O = {
        text: ""
      }), n(12, $ = e.toString());
    }
  }, function () {
    n(10, x = !x), n(26, eJ.showWizard = x, eJ);
  }, function () {
    n(11, j = !j), n(26, eJ.showOriginal = j, eJ);
  }, function (e) {
    o("handleChangeQueryLanguage", e), n(0, v = e), p(e);
    var t = A(v);
    n(8, C = t.createQuery(u, S)), n(27, _ = !1);
  }, s, u, p, y, eJ, _];
}
var RK = function (e) {
    ji(n, Ta);
    var t = Ci(n);
    function n(e) {
      var r;
      return Ri(this, n), Ia($i(r = t.call(this)), e, NK, IK, Ki, {
        id: 22,
        json: 23,
        selectedPath: 1,
        escapeControlCharacters: 2,
        escapeUnicodeCharacters: 3,
        queryLanguages: 4,
        queryLanguageId: 0,
        onChangeQueryLanguage: 24,
        onRenderValue: 5,
        onClassName: 6,
        onTransform: 25
      }, CK, [-1, -1]), r;
    }
    return zi(n);
  }(),
  DK = {};
function zK(e) {
  co(e, "svelte-ery7bx", ".jse-modal.svelte-ery7bx.svelte-ery7bx{--height:36px;--multiItemHeight:28px;--multiItemMargin:2px;--multiItemPadding:2px 8px;--multiClearTop:5px;--multiItemBorderRadius:6px;--clearSelectTop:2px;--clearSelectBottom:2px;--indicatorTop:8px;flex:1;display:flex;flex-direction:column;font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;background:var(--jse-modal-background);color:var(--jse-text-color)}.jse-modal.svelte-ery7bx .jse-contents.svelte-ery7bx{padding:20px;overflow:auto}.jse-modal.svelte-ery7bx .jse-contents .jse-actions.svelte-ery7bx{display:flex;flex-direction:row;justify-content:flex-end;padding-top:var(--jse-padding)}.jse-modal.svelte-ery7bx .jse-contents .jse-actions button.svelte-ery7bx{border:none;background:transparent;color:inherit;cursor:pointer;font-family:var(--jse-font-family);font-size:var(--jse-font-size);padding:5px;margin:0;background:var(--jse-button-primary-background);color:var(--jse-button-primary-color);padding:var(--jse-padding) calc(2 * var(--jse-padding));border-radius:3px}.jse-modal.svelte-ery7bx .jse-contents .jse-actions button.svelte-ery7bx:hover{background:var(--jse-button-primary-background-highlight)}.jse-modal.svelte-ery7bx .jse-contents .jse-actions button.svelte-ery7bx:disabled{background:var(--jse-button-primary-background-disabled)}.bg.jse-modal-bg{width:100%;height:100%;top:0;left:0;background:var(--jse-modal-overlay-background)}.bg.jse-modal-bg .jse-modal-window-wrap{margin:0}.bg.jse-modal-bg .jse-modal-window{max-width:90%;margin:4rem auto 2rem auto;border-radius:2px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-sort{width:400px}.bg.jse-modal-bg .jse-modal-window.jse-modal-window-transform{width:1200px;height:1200px;max-height:80%;display:flex}.bg.jse-modal-bg .jse-modal-content{flex:1;display:flex;max-height:calc(100vh - 6rem);padding:0}.jse-modal.jse-sort.svelte-ery7bx table.svelte-ery7bx{width:100%;border-collapse:collapse;border-spacing:0}.jse-modal.jse-sort.svelte-ery7bx table th.svelte-ery7bx,.jse-modal.jse-sort.svelte-ery7bx table td.svelte-ery7bx{text-align:left;vertical-align:middle;font-weight:normal;padding-bottom:var(--jse-padding)}.jse-modal.jse-sort.svelte-ery7bx table th input.jse-path.svelte-ery7bx,.jse-modal.jse-sort.svelte-ery7bx table td input.jse-path.svelte-ery7bx{width:100%;box-sizing:border-box;padding:6px 16px;border:var(--jse-input-border);border-radius:var(--jse-input-radius);font-family:inherit;font-size:inherit;background:inherit;color:inherit;outline:none}.jse-modal.jse-sort.svelte-ery7bx table th input.jse-path.svelte-ery7bx:read-only,.jse-modal.jse-sort.svelte-ery7bx table td input.jse-path.svelte-ery7bx:read-only{background:var(--jse-input-background-readonly)}.jse-modal.jse-sort.svelte-ery7bx table th.svelte-ery7bx .selectContainer input,.jse-modal.jse-sort.svelte-ery7bx table td.svelte-ery7bx .selectContainer input{box-sizing:border-box}.jse-modal.jse-sort.svelte-ery7bx .jse-space.svelte-ery7bx{height:200px}");
}
function LK(e) {
  var t, n, r, i, _o25, a, s;
  function u(t) {
    e[12](t);
  }
  var c = {
    showIndicator: !0,
    items: e[4]
  };
  return void 0 !== e[1] && (c.value = e[1]), _o25 = new sK({
    props: c
  }), Xo.push(function () {
    return Oa(_o25, "value", u);
  }), {
    c: function c() {
      t = go("tr"), (n = go("th")).textContent = "Property", r = ko(), i = go("td"), Aa(_o25.$$.fragment), So(n, "class", "svelte-ery7bx"), So(i, "class", "svelte-ery7bx");
    },
    m: function m(e, a) {
      vo(e, t, a), uo(t, n), uo(t, r), uo(t, i), Ea(_o25, i, null), s = !0;
    },
    p: function p(e, t) {
      var n = {};
      16 & t && (n.items = e[4]), !a && 2 & t && (a = !0, n.value = e[1], sa(function () {
        return a = !1;
      })), _o25.$set(n);
    },
    i: function i(e) {
      s || (ya(_o25.$$.fragment, e), s = !0);
    },
    o: function o(e) {
      ba(_o25.$$.fragment, e), s = !1;
    },
    d: function d(e) {
      e && po(t), Pa(_o25);
    }
  };
}
function BK(e) {
  var t, n, r, i, o, a, s, u, _c21, l, f, h, d, v, p, _m16, g, y, b, k, w, x, j, S, C, _, $, O, A, E, P, M;
  n = new FF({
    props: {
      title: e[3] ? "Sort array items" : "Sort object keys"
    }
  });
  var I = e[3] && (e[4].length > 1 || void 0 === e[1]) && LK(e);
  function T(t) {
    e[13](t);
  }
  var N = {
    showIndicator: !0,
    items: e[5],
    isClearable: !1
  };
  return void 0 !== e[2] && (N.value = e[2]), w = new sK({
    props: N
  }), Xo.push(function () {
    return Oa(w, "value", T);
  }), {
    c: function c() {
      t = go("div"), Aa(n.$$.fragment), r = ko(), i = go("div"), o = go("table"), (a = go("colgroup")).innerHTML = '<col width="25%"/> \n        <col width="75%"/>', s = ko(), u = go("tbody"), _c21 = go("tr"), (l = go("th")).textContent = "Path", f = ko(), h = go("td"), d = go("input"), p = ko(), I && I.c(), _m16 = ko(), g = go("tr"), (y = go("th")).textContent = "Direction", b = ko(), k = go("td"), Aa(w.$$.fragment), j = ko(), S = go("div"), C = ko(), _ = go("div"), $ = go("button"), O = bo("Sort"), So(l, "class", "svelte-ery7bx"), So(d, "class", "jse-path svelte-ery7bx"), So(d, "type", "text"), d.readOnly = !0, So(d, "title", "Selected path"), d.value = v = Ym(e[0]) ? "(whole document)" : rC(e[0]), So(h, "class", "svelte-ery7bx"), So(y, "class", "svelte-ery7bx"), So(k, "class", "svelte-ery7bx"), So(o, "class", "svelte-ery7bx"), So(S, "class", "jse-space svelte-ery7bx"), So($, "type", "button"), So($, "class", "jse-primary svelte-ery7bx"), $.disabled = A = !!e[3] && !e[1], So(_, "class", "jse-actions svelte-ery7bx"), So(i, "class", "jse-contents svelte-ery7bx"), So(t, "class", "jse-modal jse-sort svelte-ery7bx");
    },
    m: function m(v, x) {
      vo(v, t, x), Ea(n, t, null), uo(t, r), uo(t, i), uo(i, o), uo(o, a), uo(o, s), uo(o, u), uo(u, _c21), uo(_c21, l), uo(_c21, f), uo(_c21, h), uo(h, d), uo(u, p), I && I.m(u, null), uo(u, _m16), uo(u, g), uo(g, y), uo(g, b), uo(g, k), Ea(w, k, null), uo(i, j), uo(i, S), uo(i, C), uo(i, _), uo(_, $), uo($, O), E = !0, P || (M = [xo($, "click", e[6]), to(qK.call(null, $))], P = !0);
    },
    p: function p(e, t) {
      var r = xi(t, 1)[0],
        i = {};
      8 & r && (i.title = e[3] ? "Sort array items" : "Sort object keys"), n.$set(i), (!E || 1 & r && v !== (v = Ym(e[0]) ? "(whole document)" : rC(e[0])) && d.value !== v) && (d.value = v), e[3] && (e[4].length > 1 || void 0 === e[1]) ? I ? (I.p(e, r), 26 & r && ya(I, 1)) : ((I = LK(e)).c(), ya(I, 1), I.m(u, _m16)) : I && (ma(), ba(I, 1, 1, function () {
        I = null;
      }), ga());
      var o = {};
      !x && 4 & r && (x = !0, o.value = e[2], sa(function () {
        return x = !1;
      })), w.$set(o), (!E || 10 & r && A !== (A = !!e[3] && !e[1])) && ($.disabled = A);
    },
    i: function i(e) {
      E || (ya(n.$$.fragment, e), ya(I), ya(w.$$.fragment, e), E = !0);
    },
    o: function o(e) {
      ba(n.$$.fragment, e), ba(I), ba(w.$$.fragment, e), E = !1;
    },
    d: function d(e) {
      e && po(t), Pa(n), I && I.d(), Pa(w), P = !1, Wi(M);
    }
  };
}
function qK(e) {
  e.focus();
}
function FK(e, t, n) {
  var r,
    i,
    o,
    a = Na("jsoneditor:SortModal"),
    s = t.id,
    u = t.json,
    c = t.selectedPath,
    l = t.onSort,
    f = Yo("simple-modal").close,
    h = "".concat(s, ":").concat(ks.exports.compileJSONPointer(c)),
    d = ks.exports.getIn(u, c),
    v = {
      value: 1,
      label: "ascending"
    },
    p = [v, {
      value: -1,
      label: "descending"
    }],
    m = DK[h] && DK[h].selectedProperty || void 0,
    g = DK[h] && DK[h].selectedDirection || v;
  function y(e) {
    return {
      value: e,
      label: Ym(e) ? "(whole item)" : rC(e)
    };
  }
  return e.$$set = function (e) {
    "id" in e && n(7, s = e.id), "json" in e && n(8, u = e.json), "selectedPath" in e && n(0, c = e.selectedPath), "onSort" in e && n(9, l = e.onSort);
  }, e.$$.update = function () {
    8 & e.$$.dirty && n(11, i = r ? Js(d) : void 0), 2048 & e.$$.dirty && n(4, o = i ? i.map(y) : void 0), 18 & e.$$.dirty && void 0 === m && o && 1 === o.length && n(1, m = o[0]), 1030 & e.$$.dirty && (n(10, DK[h] = {
      selectedProperty: m,
      selectedDirection: g
    }, DK), a("store state in memory", h, DK[h]));
  }, n(3, r = Array.isArray(d)), [c, m, g, r, o, p, function () {
    if (r) {
      if (!m) return;
      var e = m.value,
        t = g.value,
        n = function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = WW(arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [], arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1),
            r = ks.exports.getIn(e, t);
          return [{
            op: "replace",
            path: ks.exports.compileJSONPointer(t),
            value: r.slice(0).sort(n)
          }];
        }(u, c, e, t);
      l(n);
    } else if (zs(d)) {
      var i = g.value,
        o = function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
            r = ks.exports.getIn(e, t),
            i = Object.keys(r).slice();
          i.sort(function (e, t) {
            return n * HW(e, t);
          });
          for (var o = [], a = 0; a < i.length; a++) {
            var s = i[a],
              u = ks.exports.compileJSONPointer(t.concat(s));
            o.push({
              op: "move",
              from: u,
              path: u
            });
          }
          return o;
        }(u, c, i);
      l(o);
    } else console.error("Cannot sort: no array or object");
    f();
  }, s, u, l, DK, i, function (e) {
    n(1, m = e), n(4, o), n(11, i), n(3, r);
  }, function (e) {
    n(2, g = e);
  }];
}
var VK = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, FK, BK, Ki, {
      id: 7,
      json: 8,
      selectedPath: 0,
      onSort: 9
    }, zK), r;
  }
  return zi(n);
}();
function HK(e, t, n) {
  var r = Yo("simple-modal");
  return [r.open, r.close];
}
var WK = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, HK, null, Ki, {
      open: 0,
      close: 1
    }), r;
  }
  return zi(n, [{
    key: "open",
    get: function get() {
      return this.$$.ctx[0];
    }
  }, {
    key: "close",
    get: function get() {
      return this.$$.ctx[1];
    }
  }]), n;
}();
function UK(e) {
  return e && !0 === e.space && 1 === Object.keys(e).length;
}
function JK(e) {
  co(e, "svelte-1ogdbp0", ':root{--jse-font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu,\n    Cantarell, "Helvetica Neue", sans-serif;--jse-font-family-mono:consolas, menlo, monaco, "Ubuntu Mono", "source-code-pro", monospace;--jse-font-size-mono:14px;--jse-font-size:16px;--jse-font-size-code-mode-search:80%;--jse-line-height:calc(1em + 4px);--jse-indent-size:calc(1em + 4px);--jse-color-picker-button-size:1em;--jse-padding:10px;--jse-theme-color:#3883fa;--jse-theme-color-highlight:#5f9dff;--jse-background-color:#fff;--jse-text-color:#4d4d4d;--jse-text-color-inverse:#fff;--jse-error-color:#ee5341;--jse-warning-color:#fdc539;--jse-main-border:1px solid #d7d7d7;--jse-menu-color:var(--jse-text-color-inverse);--jse-menu-button-size:32px;--jse-modal-background:#f5f5f5;--jse-modal-overlay-background:rgba(0, 0, 0, 0.3);--jse-modal-code-background:rgba(0, 0, 0, 0.05);--jse-panel-background:#ebebeb;--jse-panel-color:var(--jse-text-color);--jse-panel-color-readonly:#b2b2b2;--jse-panel-border:var(--jse-main-border);--jse-panel-button-color:inherit;--jse-panel-button-background:transparent;--jse-panel-button-color-highlight:var(--jse-text-color);--jse-panel-button-background-highlight:#e0e0e0;--jse-navigation-bar-color:#656565;--jse-navigation-bar-background:var(--jse-background-color);--jse-navigation-bar-background-highlight:#e5e5e5;--jse-navigation-bar-dropdown-color:#656565;--jse-context-menu-background:#656565;--jse-context-menu-background-highlight:#7a7a7a;--jse-context-menu-color:var(--jse-text-color-inverse);--jse-context-menu-color-disabled:#9d9d9d;--jse-context-menu-separator-color:#7a7a7a;--jse-context-menu-button-background:var(--jse-context-menu-background);--jse-context-menu-button-background-highlight:var(--jse-context-menu-background-highlight);--jse-context-menu-button-color:var(--jse-context-menu-color);--jse-context-menu-button-size:calc(1em + 4px);--jse-context-menu-tip-background:rgba(255, 255, 255, 0.2);--jse-context-menu-tip-color:inherit;--jse-key-color:#1a1a1a;--jse-value-color:#1a1a1a;--jse-value-color-number:#ee422e;--jse-value-color-boolean:#ff8c00;--jse-value-color-null:#004ed0;--jse-value-color-string:#008000;--jse-value-color-url:#008000;--jse-delimiter-color:rgba(0, 0, 0, 0.38);--jse-edit-outline:2px solid #656565;--jse-hover-background-color:rgba(0, 0, 0, 0.06);--jse-selection-background-color:#d3d3d3;--jse-selection-background-light-color:#e8e8e8;--jse-collapsed-items-background-color:#f5f5f5;--jse-collapsed-items-selected-background-color:#c2c2c2;--jse-collapsed-items-link-color:rgba(0, 0, 0, 0.38);--jse-collapsed-items-link-color-highlight:#ee5341;--jse-search-match-color:#ffe665;--jse-search-match-outline:1px solid #ffd700;--jse-search-match-active-color:#ffd700;--jse-search-match-active-outline:1px solid #e1be00;--jse-tag-background:rgba(0, 0, 0, 0.2);--jse-tag-color:var(--jse-text-color-inverse);--jse-controls-box-shadow:0 2px 6px 0 rgba(0, 0, 0, 0.24);--jse-input-background:var(--jse-background-color);--jse-input-background-readonly:transparent;--jse-input-border:1px solid #d8dbdf;--jse-input-border-focus:1px solid var(--jse-theme-color);--jse-input-radius:3px;--jse-button-background:#e0e0e0;--jse-button-background-highlight:#e7e7e7;--jse-button-color:var(--jse-text-color);--jse-button-primary-background:var(--jse-theme-color);--jse-button-primary-background-highlight:var(--jse-theme-color-highlight);--jse-button-primary-background-disabled:#9d9d9d;--jse-button-primary-color:var(--jse-text-color-inverse);--jse-a-color:#156fc5;--jse-a-color-highlight:#0f508d;--jse-message-error-background:var(--jse-error-color);--jse-message-error-color:var(--jse-text-color-inverse);--jse-message-warning-background:#ffde5c;--jse-message-warning-color:var(--jse-text-color);--jse-message-success-background:#9ac45d;--jse-message-success-color:var(--jse-text-color-inverse);--jse-message-info-background:#9d9d9d;--jse-message-info-color:var(--jse-text-color-inverse);--jse-message-action-background:rgba(255, 255, 255, 0.2);--jse-message-action-background-highlight:rgba(255, 255, 255, 0.3);--itemIsActiveBG:#3883fa;--border:1px solid #d8dbdf;--borderRadius:3px;--background:#fff;--jse-color-picker-background:var(--jse-panel-background);--jse-color-picker-border-box-shadow:#cbcbcb 0 0 0 1px}.jse-main.svelte-1ogdbp0{width:100%;height:100%;min-width:0;min-height:150px;font-family:var(--jse-font-family);font-size:var(--jse-font-size);line-height:normal;position:relative;display:flex;flex-direction:row}');
}
function KK(e) {
  var t,
    n,
    r = {
      readOnly: e[2],
      indentation: e[3],
      externalContent: e[0],
      mainMenuBar: e[5],
      navigationBar: e[6],
      escapeControlCharacters: e[8],
      escapeUnicodeCharacters: e[9],
      validator: e[10],
      onError: e[13],
      onChange: e[21],
      onRequestRepair: e[23],
      onRenderValue: e[11],
      onClassName: e[12],
      onFocus: e[25],
      onBlur: e[26],
      onRenderMenu: e[27],
      onSortModal: e[29],
      onTransformModal: e[28]
    };
  return t = new CU({
    props: r
  }), e[54](t), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      4 & n[0] && (r.readOnly = e[2]), 8 & n[0] && (r.indentation = e[3]), 1 & n[0] && (r.externalContent = e[0]), 32 & n[0] && (r.mainMenuBar = e[5]), 64 & n[0] && (r.navigationBar = e[6]), 256 & n[0] && (r.escapeControlCharacters = e[8]), 512 & n[0] && (r.escapeUnicodeCharacters = e[9]), 1024 & n[0] && (r.validator = e[10]), 8192 & n[0] && (r.onError = e[13]), 2048 & n[0] && (r.onRenderValue = e[11]), 4096 & n[0] && (r.onClassName = e[12]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(n) {
      e[54](null), Pa(t, n);
    }
  };
}
function GK(e) {
  var t,
    n,
    r = {
      text: e[20](e[0]),
      readOnly: e[2],
      indentation: e[3],
      tabSize: e[4],
      mainMenuBar: e[5],
      statusBar: e[7],
      escapeUnicodeCharacters: e[9],
      validator: e[10],
      onChange: e[22],
      onSwitchToTreeMode: e[24],
      onError: e[13],
      onFocus: e[25],
      onBlur: e[26],
      onRenderMenu: e[27],
      onSortModal: e[29],
      onTransformModal: e[28]
    };
  return t = new hF({
    props: r
  }), e[53](t), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      1 & n[0] && (r.text = e[20](e[0])), 4 & n[0] && (r.readOnly = e[2]), 8 & n[0] && (r.indentation = e[3]), 16 & n[0] && (r.tabSize = e[4]), 32 & n[0] && (r.mainMenuBar = e[5]), 128 & n[0] && (r.statusBar = e[7]), 512 & n[0] && (r.escapeUnicodeCharacters = e[9]), 1024 & n[0] && (r.validator = e[10]), 8192 & n[0] && (r.onError = e[13]), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(n) {
      e[53](null), Pa(t, n);
    }
  };
}
function QK(e) {
  var t,
    n,
    r,
    _i38,
    o = [GK, KK],
    a = [];
  function s(e, t) {
    return e[1] === Za ? 0 : 1;
  }
  return t = s(e), n = a[t] = o[t](e), {
    c: function c() {
      n.c(), r = wo();
    },
    m: function m(e, n) {
      a[t].m(e, n), vo(e, r, n), _i38 = !0;
    },
    p: function p(e, i) {
      var u = t;
      (t = s(e)) === u ? a[t].p(e, i) : (ma(), ba(a[u], 1, 1, function () {
        a[u] = null;
      }), ga(), (n = a[t]) ? n.p(e, i) : (n = a[t] = o[t](e)).c(), ya(n, 1), n.m(r.parentNode, r));
    },
    i: function i(e) {
      _i38 || (ya(n), _i38 = !0);
    },
    o: function o(e) {
      ba(n), _i38 = !1;
    },
    d: function d(e) {
      a[t].d(e), e && po(r);
    }
  };
}
function YK(e) {
  var t,
    n,
    r = e[14],
    _i39 = QK(e);
  return {
    c: function c() {
      t = go("div"), _i39.c(), So(t, "class", "jse-main svelte-1ogdbp0"), To(t, "jse-focus", e[15]);
    },
    m: function m(r, o) {
      vo(r, t, o), _i39.m(t, null), e[55](t), n = !0;
    },
    p: function p(e, n) {
      16384 & n[0] && Ki(r, r = e[14]) ? (ma(), ba(_i39, 1, 1, Bi), ga(), (_i39 = QK(e)).c(), ya(_i39, 1), _i39.m(t, null)) : _i39.p(e, n), 32768 & n[0] && To(t, "jse-focus", e[15]);
    },
    i: function i(e) {
      n || (ya(_i39), n = !0);
    },
    o: function o(e) {
      ba(_i39), n = !1;
    },
    d: function d(n) {
      n && po(t), _i39.d(n), e[55](null);
    }
  };
}
function ZK(e) {
  var t, n, r, _i40, _o26;
  function a(t) {
    e[52](t);
  }
  var s = {};
  return void 0 !== e[19] && (s.open = e[19]), t = new WK({
    props: s
  }), Xo.push(function () {
    return Oa(t, "open", a);
  }), _i40 = new Uj({
    props: {
      $$slots: {
        default: [YK]
      },
      $$scope: {
        ctx: e
      }
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment), r = ko(), Aa(_i40.$$.fragment);
    },
    m: function m(e, n) {
      Ea(t, e, n), vo(e, r, n), Ea(_i40, e, n), _o26 = !0;
    },
    p: function p(e, r) {
      var o = {};
      !n && 524288 & r[0] && (n = !0, o.open = e[19], sa(function () {
        return n = !1;
      })), t.$set(o);
      var a = {};
      524287 & r[0] | 1073741824 & r[1] && (a.$$scope = {
        dirty: r,
        ctx: e
      }), _i40.$set(a);
    },
    i: function i(e) {
      _o26 || (ya(t.$$.fragment, e), ya(_i40.$$.fragment, e), _o26 = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), ba(_i40.$$.fragment, e), _o26 = !1;
    },
    d: function d(e) {
      Pa(t, e), e && po(r), Pa(_i40, e);
    }
  };
}
function XK(e) {
  var t, n;
  return t = new Qa({
    props: {
      $$slots: {
        default: [ZK]
      },
      $$scope: {
        ctx: e
      }
    }
  }), {
    c: function c() {
      Aa(t.$$.fragment);
    },
    m: function m(e, r) {
      Ea(t, e, r), n = !0;
    },
    p: function p(e, n) {
      var r = {};
      1048575 & n[0] | 1073741824 & n[1] && (r.$$scope = {
        dirty: n,
        ctx: e
      }), t.$set(r);
    },
    i: function i(e) {
      n || (ya(t.$$.fragment, e), n = !0);
    },
    o: function o(e) {
      ba(t.$$.fragment, e), n = !1;
    },
    d: function d(e) {
      Pa(t, e);
    }
  };
}
function eG(e) {
  this.$set(e);
}
function tG() {
  this.$destroy();
}
function nG(e, t, n) {
  var r,
    i,
    o,
    a,
    s,
    u,
    c = Na("jsoneditor:Main"),
    l = t.content,
    f = void 0 === l ? {
      text: ""
    } : l,
    h = t.readOnly,
    d = void 0 !== h && h,
    v = t.indentation,
    p = void 0 === v ? 2 : v,
    m = t.tabSize,
    g = void 0 === m ? 4 : m,
    y = t.mode,
    b = void 0 === y ? Ya : y,
    k = t.mainMenuBar,
    w = void 0 === k || k,
    x = t.navigationBar,
    j = void 0 === x || x,
    S = t.statusBar,
    C = void 0 === S || S,
    _ = t.escapeControlCharacters,
    $ = void 0 !== _ && _,
    O = t.escapeUnicodeCharacters,
    A = void 0 !== O && O,
    E = t.validator,
    P = void 0 === E ? null : E,
    M = t.queryLanguages,
    I = void 0 === M ? [_U] : M,
    T = t.queryLanguageId,
    N = void 0 === T ? I[0].id : T,
    R = t.onChangeQueryLanguage,
    D = void 0 === R ? kc : R,
    z = t.onChange,
    L = void 0 === z ? null : z,
    B = t.onRenderValue,
    q = void 0 === B ? XU : B,
    F = t.onClassName,
    V = void 0 === F ? kc : F,
    H = t.onRenderMenu,
    W = void 0 === H ? kc : H,
    U = t.onChangeMode,
    J = void 0 === U ? kc : U,
    K = t.onError,
    G = void 0 === K ? function (e) {
      console.error(e), alert(e.toString());
    } : K,
    Q = t.onFocus,
    Y = void 0 === Q ? kc : Q,
    Z = t.onBlur,
    X = void 0 === Z ? kc : Z,
    ee = ys(),
    te = !1;
  function ne() {
    a ? a.focus() : o && o.focus();
  }
  function re(e, t, r) {
    n(0, f = e), L && L(e, t, r);
  }
  function ie() {
    return (ie = yi(mi().mark(function e() {
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n(1, b = Za), e.next = 3, oa();
            case 3:
              J(Za);
            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function oe() {
    return (oe = yi(mi().mark(function e() {
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n(1, b = Ya), e.next = 3, oa();
            case 3:
              J(Ya);
            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  function ae(e) {
    return se.apply(this, arguments);
  }
  function se() {
    return (se = yi(mi().mark(function e(t) {
      return mi().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (b !== t) {
                e.next = 2;
                break;
              }
              return e.abrupt("return");
            case 2:
              return n(1, b = t), e.next = 5, oa();
            case 5:
              ne(), J(t);
            case 7:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }
  var ue = {
    separator: !0
  };
  function ce(e) {
    c("handleChangeQueryLanguage", e), n(30, N = e), D(e);
  }
  return e.$$set = function (e) {
    "content" in e && n(0, f = e.content), "readOnly" in e && n(2, d = e.readOnly), "indentation" in e && n(3, p = e.indentation), "tabSize" in e && n(4, g = e.tabSize), "mode" in e && n(1, b = e.mode), "mainMenuBar" in e && n(5, w = e.mainMenuBar), "navigationBar" in e && n(6, j = e.navigationBar), "statusBar" in e && n(7, C = e.statusBar), "escapeControlCharacters" in e && n(8, $ = e.escapeControlCharacters), "escapeUnicodeCharacters" in e && n(9, A = e.escapeUnicodeCharacters), "validator" in e && n(10, P = e.validator), "queryLanguages" in e && n(31, I = e.queryLanguages), "queryLanguageId" in e && n(30, N = e.queryLanguageId), "onChangeQueryLanguage" in e && n(32, D = e.onChangeQueryLanguage), "onChange" in e && n(33, L = e.onChange), "onRenderValue" in e && n(11, q = e.onRenderValue), "onClassName" in e && n(12, V = e.onClassName), "onRenderMenu" in e && n(34, W = e.onRenderMenu), "onChangeMode" in e && n(35, J = e.onChangeMode), "onError" in e && n(13, G = e.onError), "onFocus" in e && n(36, Y = e.onFocus), "onBlur" in e && n(37, X = e.onBlur);
  }, e.$$.update = function () {
    if (1 & e.$$.dirty[0]) {
      var t = iu(f);
      t && console.error("Error: " + t);
    }
    2 & e.$$.dirty[0] && n(51, r = b === Za), 2 & e.$$.dirty[0] | 1048576 & e.$$.dirty[1] && (u = [{
      text: "code",
      title: "Switch to code mode (current mode: ".concat(b, ")"),
      className: "jse-group-button jse-first" + (r ? " jse-selected" : ""),
      onClick: function onClick() {
        return ae(Za);
      }
    }, {
      text: "tree",
      title: "Switch to tree mode (current mode: ".concat(b, ")"),
      className: "jse-group-button jse-last" + (r ? "" : " jse-selected"),
      onClick: function onClick() {
        return ae(Ya);
      }
    }]);
  }, [f, b, d, p, g, w, j, C, $, A, P, q, V, G, ee, te, i, o, a, s, function (e) {
    return ou(e) ? e.text : JSON.stringify(e.json, null, p);
  }, re, function (e, t) {
    re({
      text: e,
      json: void 0
    }, {
      text: t,
      json: void 0
    }, null);
  }, function () {
    return ie.apply(this, arguments);
  }, function () {
    return oe.apply(this, arguments);
  }, function () {
    n(15, te = !0), Y && Y();
  }, function () {
    n(15, te = !1), X && X();
  }, function (e, t) {
    var n = e === Ya || e === Za ? UK(t[0]) ? u.concat(t) : u.concat([ue], t) : t;
    return W(e, n) || n;
  }, function (e) {
    var t = e.id,
      n = e.json,
      r = e.selectedPath,
      i = e.onTransform,
      o = e.onClose;
    console.log("json", n), d || s(RK, {
      id: t,
      json: n,
      selectedPath: r,
      escapeControlCharacters: $,
      escapeUnicodeCharacters: A,
      queryLanguages: I,
      queryLanguageId: N,
      onChangeQueryLanguage: ce,
      onRenderValue: q,
      onClassName: V,
      onTransform: i
    }, fs, {
      onClose: o
    });
  }, function (e) {
    var t = e.id,
      n = e.json,
      r = e.selectedPath,
      i = e.onSort,
      o = e.onClose;
    d || s(VK, {
      id: t,
      json: n,
      selectedPath: r,
      onSort: i
    }, ls, {
      onClose: o
    });
  }, N, I, D, L, W, J, Y, X, function () {
    return f;
  }, function (e) {
    c("set");
    var t = iu(e);
    if (t) throw new Error(t);
    n(14, ee = ys()), n(0, f = e);
  }, function (e) {
    c("update");
    var t = iu(e);
    if (t) throw new Error(t);
    n(0, f = e);
  }, function (e) {
    if (ou(f)) try {
      n(0, f = {
        json: JSON.parse(f.text),
        text: void 0
      });
    } catch (e) {
      throw new Error("Cannot apply patch: current document contains invalid JSON");
    }
    return o ? o.patch(e) : a ? a.patch(e) : void 0;
  }, function (e) {
    if (o) return o.expand(e);
    throw new Error('Method expand is not available in mode "'.concat(b, '"'));
  }, function (e) {
    if (a) a.openTransformModal(e);else {
      if (!o) throw new Error('Method transform is not available in mode "'.concat(b, '"'));
      o.openTransformModal(e);
    }
  }, function () {
    return o ? o.acceptAutoRepair() : f;
  }, function (e) {
    if (o) return o.scrollTo(e);
    throw new Error('Method scrollTo is not available in mode "'.concat(b, '"'));
  }, function (e) {
    if (o) return o.findElement(e);
    throw new Error('Method findElement is not available in mode "'.concat(b, '"'));
  }, ne, function () {
    a && a.refresh();
  }, eG, tG, r, function (e) {
    n(19, s = e);
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(18, a = e);
    });
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(17, o = e);
    });
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(16, i = e);
    });
  }];
}
var rG = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, nG, XK, Ki, {
      content: 0,
      readOnly: 2,
      indentation: 3,
      tabSize: 4,
      mode: 1,
      mainMenuBar: 5,
      navigationBar: 6,
      statusBar: 7,
      escapeControlCharacters: 8,
      escapeUnicodeCharacters: 9,
      validator: 10,
      queryLanguages: 31,
      queryLanguageId: 30,
      onChangeQueryLanguage: 32,
      onChange: 33,
      onRenderValue: 11,
      onClassName: 12,
      onRenderMenu: 34,
      onChangeMode: 35,
      onError: 13,
      onFocus: 36,
      onBlur: 37,
      get: 38,
      set: 39,
      update: 40,
      patch: 41,
      expand: 42,
      transform: 43,
      acceptAutoRepair: 44,
      scrollTo: 45,
      findElement: 46,
      focus: 47,
      refresh: 48,
      updateProps: 49,
      destroy: 50
    }, JK, [-1, -1]), r;
  }
  return zi(n, [{
    key: "get",
    get: function get() {
      return this.$$.ctx[38];
    }
  }, {
    key: "set",
    get: function get() {
      return this.$$.ctx[39];
    }
  }, {
    key: "update",
    get: function get() {
      return this.$$.ctx[40];
    }
  }, {
    key: "patch",
    get: function get() {
      return this.$$.ctx[41];
    }
  }, {
    key: "expand",
    get: function get() {
      return this.$$.ctx[42];
    }
  }, {
    key: "transform",
    get: function get() {
      return this.$$.ctx[43];
    }
  }, {
    key: "acceptAutoRepair",
    get: function get() {
      return this.$$.ctx[44];
    }
  }, {
    key: "scrollTo",
    get: function get() {
      return this.$$.ctx[45];
    }
  }, {
    key: "findElement",
    get: function get() {
      return this.$$.ctx[46];
    }
  }, {
    key: "focus",
    get: function get() {
      return this.$$.ctx[47];
    }
  }, {
    key: "refresh",
    get: function get() {
      return this.$$.ctx[48];
    }
  }, {
    key: "updateProps",
    get: function get() {
      return eG;
    }
  }, {
    key: "destroy",
    get: function get() {
      return tG;
    }
  }]), n;
}();
function iG(e) {
  co(e, "svelte-rc6e9m", ".jse-value.jse-string.svelte-rc6e9m{color:var(--jse-value-color-string)}.jse-value.jse-object.svelte-rc6e9m,.jse-value.jse-array.svelte-rc6e9m{min-width:16px;color:var(--jse-delimiter-color)}.jse-value.jse-number.svelte-rc6e9m{color:var(--jse-value-color-number)}.jse-value.jse-boolean.svelte-rc6e9m{color:var(--jse-value-color-boolean)}.jse-value.jse-null.svelte-rc6e9m{color:var(--jse-value-color-null)}.jse-value.jse-invalid.svelte-rc6e9m{color:var(--jse-text-color)}.jse-value.jse-url.svelte-rc6e9m{color:var(--jse-value-color-url);text-decoration:underline}.jse-enum-value.svelte-rc6e9m{background:var(--jse-hover-background-color);border:none;padding:0;font-family:inherit;font-size:inherit;cursor:pointer;outline:none}.jse-enum-value.jse-selected.svelte-rc6e9m{background:var(--jse-selection-background-color);color:inherit}.jse-enum-value.jse-value.svelte-rc6e9m:focus{color:var(--jse-text-color)}.jse-json-node.jse-selected .jse-enum-value.svelte-rc6e9m{background:transparent}");
}
function oG(e, t, n) {
  var r = e.slice();
  return r[13] = t[n], r;
}
function aG(e) {
  var t,
    n,
    r,
    i = e[13].text + "";
  return {
    c: function c() {
      t = go("option"), n = bo(i), t.__value = r = e[13].value, t.value = t.__value;
    },
    m: function m(e, r) {
      vo(e, t, r), uo(t, n);
    },
    p: function p(e, o) {
      2 & o && i !== (i = e[13].text + "") && Ao(n, i), 2 & o && r !== (r = e[13].value) && (t.__value = r, t.value = t.__value);
    },
    d: function d(e) {
      e && po(t);
    }
  };
}
function sG(e) {
  for (var t, n, r, i, o = e[1], a = [], s = 0; s < o.length; s += 1) {
    a[s] = aG(oG(e, o, s));
  }
  return {
    c: function c() {
      t = go("select");
      for (var r = 0; r < a.length; r += 1) {
        a[r].c();
      }
      So(t, "class", n = eo("jse-enum-value ".concat(LU(e[3]))) + " svelte-rc6e9m"), void 0 === e[3] && aa(function () {
        return e[10].call(t);
      }), To(t, "jse-selected", e[0]);
    },
    m: function m(n, o) {
      vo(n, t, o);
      for (var s = 0; s < a.length; s += 1) {
        a[s].m(t, null);
      }
      Mo(t, e[3]), e[11](t), r || (i = [xo(t, "change", e[10]), xo(t, "change", e[4]), xo(t, "mousedown", uG)], r = !0);
    },
    p: function p(e, r) {
      var i = xi(r, 1)[0];
      if (2 & i) {
        var s;
        for (o = e[1], s = 0; s < o.length; s += 1) {
          var u = oG(e, o, s);
          a[s] ? a[s].p(u, i) : (a[s] = aG(u), a[s].c(), a[s].m(t, null));
        }
        for (; s < a.length; s += 1) {
          a[s].d(1);
        }
        a.length = o.length;
      }
      8 & i && n !== (n = eo("jse-enum-value ".concat(LU(e[3]))) + " svelte-rc6e9m") && So(t, "class", n), 8 & i && Mo(t, e[3]), 9 & i && To(t, "jse-selected", e[0]);
    },
    i: Bi,
    o: Bi,
    d: function d(n) {
      n && po(t), mo(a, n), e[11](null), r = !1, Wi(i);
    }
  };
}
function uG(e) {
  e.stopPropagation();
}
function cG(e, t, n) {
  var r,
    i = t.path,
    o = t.value,
    a = t.readOnly,
    s = t.isSelected,
    u = t.onPatch,
    c = t.onSelect,
    l = t.options,
    f = o;
  return e.$$set = function (e) {
    "path" in e && n(5, i = e.path), "value" in e && n(6, o = e.value), "readOnly" in e && n(7, a = e.readOnly), "isSelected" in e && n(0, s = e.isSelected), "onPatch" in e && n(8, u = e.onPatch), "onSelect" in e && n(9, c = e.onSelect), "options" in e && n(1, l = e.options);
  }, e.$$.update = function () {
    64 & e.$$.dirty && n(3, f = o), 1 & e.$$.dirty && function (e) {
      e && r && r.focus();
    }(s);
  }, [s, l, r, f, function (e) {
    e.stopPropagation(), a || (u([{
      op: "replace",
      path: ks.exports.compileJSONPointer(i),
      value: f
    }]), c({
      type: Wx,
      path: i
    }));
  }, i, o, a, u, c, function () {
    var e, t;
    t = (e = this).querySelector(":checked") || e.options[0], f = t && t.__value, n(3, f), n(6, o);
  }, function (e) {
    Xo[e ? "unshift" : "push"](function () {
      n(2, r = e), n(1, l);
    });
  }];
}
var lG = function (e) {
  ji(n, Ta);
  var t = Ci(n);
  function n(e) {
    var r;
    return Ri(this, n), Ia($i(r = t.call(this)), e, cG, sG, Ki, {
      path: 5,
      value: 6,
      readOnly: 7,
      isSelected: 0,
      onPatch: 8,
      onSelect: 9,
      options: 1
    }, iG), r;
  }
  return zi(n);
}();
function fG(e, t, n) {
  var r = dG(e, t || {}, n);
  return r ? hG(r) : null;
}
function hG(e) {
  if (e.enum) return e.enum;
  var t = e.oneOf || e.anyOf || e.allOf;
  if (t) {
    var n = t.filter(function (e) {
      return e.enum;
    });
    if (n.length > 0) return n[0].enum;
  }
  return null;
}
function dG(e, t, n) {
  for (var r, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e, o = n.slice(1, n.length), a = n[0], s = [i], u = 0, c = [i.oneOf, i.anyOf, i.allOf]; u < c.length; u++) {
    var l = c[u];
    Array.isArray(l) && (s = s.concat(l));
  }
  var f,
    h = bi(s);
  try {
    for (h.s(); !(f = h.n()).done;) {
      var d = f.value;
      if ("$ref" in (i = d) && "string" == typeof i.$ref) {
        var v = i.$ref;
        if (v in t) i = t[v];else {
          if (!v.startsWith("#/")) {
            if (1 === (null === (r = v.match(/#\//g)) || void 0 === r ? void 0 : r.length)) {
              var p = v.split("#/"),
                m = xi(p, 2),
                g = m[0],
                y = m[1];
              if (g in t) {
                var b = t[g],
                  k = {
                    $ref: "#/".concat(y)
                  },
                  w = [];
                return w.push(a), o.length > 0 && w.push.apply(w, Ii(o)), dG(b, t, w, k);
              }
              throw Error("Unable to resolve reference ".concat(v));
            }
            throw Error("Unable to resolve reference ".concat(v));
          }
          var x = v.substring(2).split("/");
          i = e;
          var j,
            S = bi(x);
          try {
            for (S.s(); !(j = S.n()).done;) {
              var C = j.value;
              if (!(C in i)) throw Error("Unable to resovle reference ".concat(v));
              i = i[C];
            }
          } catch (e) {
            S.e(e);
          } finally {
            S.f();
          }
        }
      }
      if (void 0 === a) return i;
      if ("string" != typeof a) {
        if ("number" == typeof a && "object" === Li(i.items) && null !== i.items) return dG(e, t, o, i = i.items);
      } else {
        if ("object" === Li(i.properties) && null !== i.properties && a in i.properties) return dG(e, t, o, i = i.properties[a]);
        if ("object" === Li(i.patternProperties) && null !== i.patternProperties) for (var _ in i.patternProperties) {
          if (a.match(_)) return dG(e, t, o, i = i.patternProperties[_]);
        }
        if ("object" === Li(i.additionalProperties)) return dG(e, t, o, i = i.additionalProperties);
      }
    }
  } catch (e) {
    h.e(e);
  } finally {
    h.f();
  }
  return null;
}
function vG(e, t, n) {
  var r = fG(t, n, e.path);
  if (r) {
    var i = e.value,
      o = e.path,
      a = e.readOnly,
      s = e.onPatch,
      u = e.onSelect,
      c = e.isSelected,
      l = r.map(function (e) {
        return {
          value: e,
          text: e
        };
      }),
      f = r.includes(e.value) ? l : [{
        value: i,
        text: i
      }].concat(l);
    return [{
      component: lG,
      props: {
        value: i,
        path: o,
        readOnly: a,
        onPatch: s,
        onSelect: u,
        isSelected: c,
        options: f
      }
    }];
  }
  return null;
}
function pG(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var mG = {
    exports: {}
  },
  gG = bs(mG.exports = function e(t, n, r) {
    function i(a, s) {
      if (!n[a]) {
        if (!t[a]) {
          if (!s && pG) return pG(a);
          if (o) return o(a, !0);
          var u = new Error("Cannot find module '" + a + "'");
          throw u.code = "MODULE_NOT_FOUND", u;
        }
        var c = n[a] = {
          exports: {}
        };
        t[a][0].call(c.exports, function (e) {
          return i(t[a][1][e] || e);
        }, c, c.exports, e, t, n, r);
      }
      return n[a].exports;
    }
    for (var o = pG, a = 0; a < r.length; a++) {
      i(r[a]);
    }
    return i;
  }({
    1: [function (n, r, i) {
      Object.defineProperty(i, "__esModule", {
        value: !0
      }), i.regexpCode = i.getEsmExportName = i.getProperty = i.safeStringify = i.stringify = i.strConcat = i.addCodeArg = i.str = i._ = i.nil = i._Code = i.Name = i.IDENTIFIER = i._CodeOrName = void 0;
      var o = zi(function e() {
        Ri(this, e);
      });
      i._CodeOrName = o, i.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
      var a = function (e) {
        ji(n, e);
        var t = Ci(n);
        function n(e) {
          var r;
          if (Ri(this, n), r = t.call(this), !i.IDENTIFIER.test(e)) throw new Error("CodeGen: name must be a valid identifier");
          return r.str = e, _i(r);
        }
        return zi(n, [{
          key: "toString",
          value: function value() {
            return this.str;
          }
        }, {
          key: "emptyStr",
          value: function value() {
            return !1;
          }
        }, {
          key: "names",
          get: function get() {
            return Mi({}, this.str, 1);
          }
        }]), n;
      }(o);
      i.Name = a;
      var s = function (e) {
        ji(n, e);
        var t = Ci(n);
        function n(e) {
          var r;
          return Ri(this, n), (r = t.call(this))._items = "string" == typeof e ? [e] : e, r;
        }
        return zi(n, [{
          key: "toString",
          value: function value() {
            return this.str;
          }
        }, {
          key: "emptyStr",
          value: function value() {
            if (this._items.length > 1) return !1;
            var e = this._items[0];
            return "" === e || '""' === e;
          }
        }, {
          key: "str",
          get: function get() {
            var e;
            return null !== (e = this._str) && void 0 !== e ? e : this._str = this._items.reduce(function (e, t) {
              return "".concat(e).concat(t);
            }, "");
          }
        }, {
          key: "names",
          get: function get() {
            var e;
            return null !== (e = this._names) && void 0 !== e ? e : this._names = this._items.reduce(function (e, t) {
              return t instanceof a && (e[t.str] = (e[t.str] || 0) + 1), e;
            }, {});
          }
        }]), n;
      }(o);
      function u(e) {
        for (var t = [e[0]], n = 0, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
          i[o - 1] = arguments[o];
        }
        for (; n < i.length;) {
          f(t, i[n]), t.push(e[++n]);
        }
        return new s(t);
      }
      i._Code = s, i.nil = new s(""), i._ = u;
      var c = new s("+");
      function l(e) {
        for (var t = [d(e[0])], n = 0, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) {
          i[o - 1] = arguments[o];
        }
        for (; n < i.length;) {
          t.push(c), f(t, i[n]), t.push(c, d(e[++n]));
        }
        return function (e) {
          for (var t = 1; t < e.length - 1;) {
            if (e[t] === c) {
              var n = h(e[t - 1], e[t + 1]);
              if (void 0 !== n) {
                e.splice(t - 1, 3, n);
                continue;
              }
              e[t++] = "+";
            }
            t++;
          }
        }(t), new s(t);
      }
      function f(e, t) {
        var n;
        t instanceof s ? e.push.apply(e, Ii(t._items)) : e.push(t instanceof a ? t : "number" == typeof (n = t) || "boolean" == typeof n || null === n ? n : d(Array.isArray(n) ? n.join(",") : n));
      }
      function h(e, t) {
        if ('""' === t) return e;
        if ('""' === e) return t;
        if ("string" == typeof e) {
          if (t instanceof a || '"' !== e[e.length - 1]) return;
          return "string" != typeof t ? "".concat(e.slice(0, -1)).concat(t, '"') : '"' === t[0] ? e.slice(0, -1) + t.slice(1) : void 0;
        }
        return "string" != typeof t || '"' !== t[0] || e instanceof a ? void 0 : '"'.concat(e).concat(t.slice(1));
      }
      function d(e) {
        return JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
      }
      i.str = l, i.addCodeArg = f, i.strConcat = function (t, n) {
        return n.emptyStr() ? t : t.emptyStr() ? n : l(e || (e = pi(["", "", ""])), t, n);
      }, i.stringify = function (e) {
        return new s(d(e));
      }, i.safeStringify = d, i.getProperty = function (e) {
        return "string" == typeof e && i.IDENTIFIER.test(e) ? new s(".".concat(e)) : u(t || (t = pi(["[", "]"])), e);
      }, i.getEsmExportName = function (e) {
        if ("string" == typeof e && i.IDENTIFIER.test(e)) return new s("".concat(e));
        throw new Error("CodeGen: invalid export name: ".concat(e, ", use explicit $id name mapping"));
      }, i.regexpCode = function (e) {
        return new s(e.toString());
      };
    }, {}],
    2: [function (e, t, u) {
      Object.defineProperty(u, "__esModule", {
        value: !0
      }), u.or = u.and = u.not = u.CodeGen = u.operators = u.varKinds = u.ValueScopeName = u.ValueScope = u.Scope = u.Name = u.regexpCode = u.stringify = u.getProperty = u.nil = u.strConcat = u.str = u._ = void 0;
      var c = e("./code"),
        l = e("./scope"),
        f = e("./code");
      Object.defineProperty(u, "_", {
        enumerable: !0,
        get: function get() {
          return f._;
        }
      }), Object.defineProperty(u, "str", {
        enumerable: !0,
        get: function get() {
          return f.str;
        }
      }), Object.defineProperty(u, "strConcat", {
        enumerable: !0,
        get: function get() {
          return f.strConcat;
        }
      }), Object.defineProperty(u, "nil", {
        enumerable: !0,
        get: function get() {
          return f.nil;
        }
      }), Object.defineProperty(u, "getProperty", {
        enumerable: !0,
        get: function get() {
          return f.getProperty;
        }
      }), Object.defineProperty(u, "stringify", {
        enumerable: !0,
        get: function get() {
          return f.stringify;
        }
      }), Object.defineProperty(u, "regexpCode", {
        enumerable: !0,
        get: function get() {
          return f.regexpCode;
        }
      }), Object.defineProperty(u, "Name", {
        enumerable: !0,
        get: function get() {
          return f.Name;
        }
      });
      var h = e("./scope");
      Object.defineProperty(u, "Scope", {
        enumerable: !0,
        get: function get() {
          return h.Scope;
        }
      }), Object.defineProperty(u, "ValueScope", {
        enumerable: !0,
        get: function get() {
          return h.ValueScope;
        }
      }), Object.defineProperty(u, "ValueScopeName", {
        enumerable: !0,
        get: function get() {
          return h.ValueScopeName;
        }
      }), Object.defineProperty(u, "varKinds", {
        enumerable: !0,
        get: function get() {
          return h.varKinds;
        }
      }), u.operators = {
        GT: new c._Code(">"),
        GTE: new c._Code(">="),
        LT: new c._Code("<"),
        LTE: new c._Code("<="),
        EQ: new c._Code("==="),
        NEQ: new c._Code("!=="),
        NOT: new c._Code("!"),
        OR: new c._Code("||"),
        AND: new c._Code("&&"),
        ADD: new c._Code("+")
      };
      var d = function () {
          function e() {
            Ri(this, e);
          }
          return zi(e, [{
            key: "optimizeNodes",
            value: function value() {
              return this;
            }
          }, {
            key: "optimizeNames",
            value: function value(e, t) {
              return this;
            }
          }]), e;
        }(),
        v = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e, r, i) {
            var o;
            return Ri(this, n), (o = t.call(this)).varKind = e, o.name = r, o.rhs = i, o;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              var t = e.es5,
                n = e._n;
              return "".concat(t ? l.varKinds.var : this.varKind, " ").concat(this.name).concat(void 0 === this.rhs ? "" : " = ".concat(this.rhs), ";") + n;
            }
          }, {
            key: "optimizeNames",
            value: function value(e, t) {
              if (e[this.name.str]) return this.rhs && (this.rhs = D(this.rhs, e, t)), this;
            }
          }, {
            key: "names",
            get: function get() {
              return this.rhs instanceof c._CodeOrName ? this.rhs.names : {};
            }
          }]), n;
        }(d),
        p = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e, r, i) {
            var o;
            return Ri(this, n), (o = t.call(this)).lhs = e, o.rhs = r, o.sideEffects = i, o;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              var t = e._n;
              return "".concat(this.lhs, " = ").concat(this.rhs, ";") + t;
            }
          }, {
            key: "optimizeNames",
            value: function value(e, t) {
              if (!(this.lhs instanceof c.Name) || e[this.lhs.str] || this.sideEffects) return this.rhs = D(this.rhs, e, t), this;
            }
          }, {
            key: "names",
            get: function get() {
              return R(this.lhs instanceof c.Name ? {} : Pi({}, this.lhs.names), this.rhs);
            }
          }]), n;
        }(d),
        m = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e, r, i, o) {
            var a;
            return Ri(this, n), (a = t.call(this, e, i, o)).op = r, a;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              var t = e._n;
              return "".concat(this.lhs, " ").concat(this.op, "= ").concat(this.rhs, ";") + t;
            }
          }]), n;
        }(p),
        g = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e) {
            var r;
            return Ri(this, n), (r = t.call(this)).label = e, r.names = {}, r;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              var t = e._n;
              return "".concat(this.label, ":") + t;
            }
          }]), n;
        }(d),
        y = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e) {
            var r;
            return Ri(this, n), (r = t.call(this)).label = e, r.names = {}, r;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              var t = e._n;
              return "break".concat(this.label ? " ".concat(this.label) : "", ";") + t;
            }
          }]), n;
        }(d),
        b = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e) {
            var r;
            return Ri(this, n), (r = t.call(this)).error = e, r;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              var t = e._n;
              return "throw ".concat(this.error, ";") + t;
            }
          }, {
            key: "names",
            get: function get() {
              return this.error.names;
            }
          }]), n;
        }(d),
        k = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e) {
            var r;
            return Ri(this, n), (r = t.call(this)).code = e, r;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              var t = e._n;
              return "".concat(this.code, ";") + t;
            }
          }, {
            key: "optimizeNodes",
            value: function value() {
              return "".concat(this.code) ? this : void 0;
            }
          }, {
            key: "optimizeNames",
            value: function value(e, t) {
              return this.code = D(this.code, e, t), this;
            }
          }, {
            key: "names",
            get: function get() {
              return this.code instanceof c._CodeOrName ? this.code.names : {};
            }
          }]), n;
        }(d),
        w = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n() {
            var e,
              r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            return Ri(this, n), (e = t.call(this)).nodes = r, e;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              return this.nodes.reduce(function (t, n) {
                return t + n.render(e);
              }, "");
            }
          }, {
            key: "optimizeNodes",
            value: function value() {
              for (var e = this.nodes, t = e.length; t--;) {
                var n = e[t].optimizeNodes();
                Array.isArray(n) ? e.splice.apply(e, [t, 1].concat(Ii(n))) : n ? e[t] = n : e.splice(t, 1);
              }
              return e.length > 0 ? this : void 0;
            }
          }, {
            key: "optimizeNames",
            value: function value(e, t) {
              for (var n = this.nodes, r = n.length; r--;) {
                var i = n[r];
                i.optimizeNames(e, t) || (z(e, i.names), n.splice(r, 1));
              }
              return n.length > 0 ? this : void 0;
            }
          }, {
            key: "names",
            get: function get() {
              return this.nodes.reduce(function (e, t) {
                return N(e, t.names);
              }, {});
            }
          }]), n;
        }(d),
        x = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n() {
            return Ri(this, n), t.apply(this, arguments);
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              return "{" + e._n + ki(Ai(n.prototype), "render", this).call(this, e) + "}" + e._n;
            }
          }]), n;
        }(w),
        j = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n() {
            return Ri(this, n), t.apply(this, arguments);
          }
          return zi(n);
        }(w),
        S = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n() {
            return Ri(this, n), t.apply(this, arguments);
          }
          return zi(n);
        }(x);
      S.kind = "else";
      var C = function (e) {
        ji(n, e);
        var t = Ci(n);
        function n(e, r) {
          var i;
          return Ri(this, n), (i = t.call(this, r)).condition = e, i;
        }
        return zi(n, [{
          key: "render",
          value: function value(e) {
            var t = "if(".concat(this.condition, ")") + ki(Ai(n.prototype), "render", this).call(this, e);
            return this.else && (t += "else " + this.else.render(e)), t;
          }
        }, {
          key: "optimizeNodes",
          value: function value() {
            ki(Ai(n.prototype), "optimizeNodes", this).call(this);
            var e = this.condition;
            if (!0 === e) return this.nodes;
            var t = this.else;
            if (t) {
              var r = t.optimizeNodes();
              t = this.else = Array.isArray(r) ? new S(r) : r;
            }
            return t ? !1 === e ? t instanceof n ? t : t.nodes : this.nodes.length ? this : new n(L(e), t instanceof n ? [t] : t.nodes) : !1 !== e && this.nodes.length ? this : void 0;
          }
        }, {
          key: "optimizeNames",
          value: function value(e, t) {
            var r;
            if (this.else = null === (r = this.else) || void 0 === r ? void 0 : r.optimizeNames(e, t), ki(Ai(n.prototype), "optimizeNames", this).call(this, e, t) || this.else) return this.condition = D(this.condition, e, t), this;
          }
        }, {
          key: "names",
          get: function get() {
            var e = ki(Ai(n.prototype), "names", this);
            return R(e, this.condition), this.else && N(e, this.else.names), e;
          }
        }]), n;
      }(x);
      C.kind = "if";
      var _ = function (e) {
        ji(n, e);
        var t = Ci(n);
        function n() {
          return Ri(this, n), t.apply(this, arguments);
        }
        return zi(n);
      }(x);
      _.kind = "for";
      var $ = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e) {
            var r;
            return Ri(this, n), (r = t.call(this)).iteration = e, r;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              return "for(".concat(this.iteration, ")") + ki(Ai(n.prototype), "render", this).call(this, e);
            }
          }, {
            key: "optimizeNames",
            value: function value(e, t) {
              if (ki(Ai(n.prototype), "optimizeNames", this).call(this, e, t)) return this.iteration = D(this.iteration, e, t), this;
            }
          }, {
            key: "names",
            get: function get() {
              return N(ki(Ai(n.prototype), "names", this), this.iteration.names);
            }
          }]), n;
        }(_),
        O = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e, r, i, o) {
            var a;
            return Ri(this, n), (a = t.call(this)).varKind = e, a.name = r, a.from = i, a.to = o, a;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              var t = e.es5 ? l.varKinds.var : this.varKind,
                r = this.name,
                i = this.from,
                o = this.to;
              return "for(".concat(t, " ").concat(r, "=").concat(i, "; ").concat(r, "<").concat(o, "; ").concat(r, "++)") + ki(Ai(n.prototype), "render", this).call(this, e);
            }
          }, {
            key: "names",
            get: function get() {
              var e = R(ki(Ai(n.prototype), "names", this), this.from);
              return R(e, this.to);
            }
          }]), n;
        }(_),
        A = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e, r, i, o) {
            var a;
            return Ri(this, n), (a = t.call(this)).loop = e, a.varKind = r, a.name = i, a.iterable = o, a;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              return "for(".concat(this.varKind, " ").concat(this.name, " ").concat(this.loop, " ").concat(this.iterable, ")") + ki(Ai(n.prototype), "render", this).call(this, e);
            }
          }, {
            key: "optimizeNames",
            value: function value(e, t) {
              if (ki(Ai(n.prototype), "optimizeNames", this).call(this, e, t)) return this.iterable = D(this.iterable, e, t), this;
            }
          }, {
            key: "names",
            get: function get() {
              return N(ki(Ai(n.prototype), "names", this), this.iterable.names);
            }
          }]), n;
        }(_),
        E = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e, r, i) {
            var o;
            return Ri(this, n), (o = t.call(this)).name = e, o.args = r, o.async = i, o;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              return "".concat(this.async ? "async " : "", "function ").concat(this.name, "(").concat(this.args, ")") + ki(Ai(n.prototype), "render", this).call(this, e);
            }
          }]), n;
        }(x);
      E.kind = "func";
      var P = function (e) {
        ji(n, e);
        var t = Ci(n);
        function n() {
          return Ri(this, n), t.apply(this, arguments);
        }
        return zi(n, [{
          key: "render",
          value: function value(e) {
            return "return " + ki(Ai(n.prototype), "render", this).call(this, e);
          }
        }]), n;
      }(w);
      P.kind = "return";
      var M = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n() {
            return Ri(this, n), t.apply(this, arguments);
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              var t = "try" + ki(Ai(n.prototype), "render", this).call(this, e);
              return this.catch && (t += this.catch.render(e)), this.finally && (t += this.finally.render(e)), t;
            }
          }, {
            key: "optimizeNodes",
            value: function value() {
              var e, t;
              return ki(Ai(n.prototype), "optimizeNodes", this).call(this), null === (e = this.catch) || void 0 === e || e.optimizeNodes(), null === (t = this.finally) || void 0 === t || t.optimizeNodes(), this;
            }
          }, {
            key: "optimizeNames",
            value: function value(e, t) {
              var r, i;
              return ki(Ai(n.prototype), "optimizeNames", this).call(this, e, t), null === (r = this.catch) || void 0 === r || r.optimizeNames(e, t), null === (i = this.finally) || void 0 === i || i.optimizeNames(e, t), this;
            }
          }, {
            key: "names",
            get: function get() {
              var e = ki(Ai(n.prototype), "names", this);
              return this.catch && N(e, this.catch.names), this.finally && N(e, this.finally.names), e;
            }
          }]), n;
        }(x),
        I = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n(e) {
            var r;
            return Ri(this, n), (r = t.call(this)).error = e, r;
          }
          return zi(n, [{
            key: "render",
            value: function value(e) {
              return "catch(".concat(this.error, ")") + ki(Ai(n.prototype), "render", this).call(this, e);
            }
          }]), n;
        }(x);
      I.kind = "catch";
      var T = function (e) {
        ji(n, e);
        var t = Ci(n);
        function n() {
          return Ri(this, n), t.apply(this, arguments);
        }
        return zi(n, [{
          key: "render",
          value: function value(e) {
            return "finally" + ki(Ai(n.prototype), "render", this).call(this, e);
          }
        }]), n;
      }(x);
      function N(e, t) {
        for (var n in t) {
          e[n] = (e[n] || 0) + (t[n] || 0);
        }
        return e;
      }
      function R(e, t) {
        return t instanceof c._CodeOrName ? N(e, t.names) : e;
      }
      function D(e, t, n) {
        return e instanceof c.Name ? i(e) : (r = e) instanceof c._Code && r._items.some(function (e) {
          return e instanceof c.Name && 1 === t[e.str] && void 0 !== n[e.str];
        }) ? new c._Code(e._items.reduce(function (e, t) {
          return t instanceof c.Name && (t = i(t)), t instanceof c._Code ? e.push.apply(e, Ii(t._items)) : e.push(t), e;
        }, [])) : e;
        var r;
        function i(e) {
          var r = n[e.str];
          return void 0 === r || 1 !== t[e.str] ? e : (delete t[e.str], r);
        }
      }
      function z(e, t) {
        for (var n in t) {
          e[n] = (e[n] || 0) - (t[n] || 0);
        }
      }
      function L(e) {
        return "boolean" == typeof e || "number" == typeof e || null === e ? !e : c._(n || (n = pi(["!", ""])), V(e));
      }
      T.kind = "finally", u.CodeGen = function () {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          Ri(this, e), this._values = {}, this._blockStarts = [], this._constants = {}, this.opts = Pi(Pi({}, n), {}, {
            _n: n.lines ? "\n" : ""
          }), this._extScope = t, this._scope = new l.Scope({
            parent: t
          }), this._nodes = [new j()];
        }
        return zi(e, [{
          key: "toString",
          value: function value() {
            return this._root.render(this.opts);
          }
        }, {
          key: "name",
          value: function value(e) {
            return this._scope.name(e);
          }
        }, {
          key: "scopeName",
          value: function value(e) {
            return this._extScope.name(e);
          }
        }, {
          key: "scopeValue",
          value: function value(e, t) {
            var n = this._extScope.value(e, t);
            return (this._values[n.prefix] || (this._values[n.prefix] = new Set())).add(n), n;
          }
        }, {
          key: "getScopeValue",
          value: function value(e, t) {
            return this._extScope.getValue(e, t);
          }
        }, {
          key: "scopeRefs",
          value: function value(e) {
            return this._extScope.scopeRefs(e, this._values);
          }
        }, {
          key: "scopeCode",
          value: function value() {
            return this._extScope.scopeCode(this._values);
          }
        }, {
          key: "_def",
          value: function value(e, t, n, r) {
            var i = this._scope.toName(t);
            return void 0 !== n && r && (this._constants[i.str] = n), this._leafNode(new v(e, i, n)), i;
          }
        }, {
          key: "const",
          value: function value(e, t, n) {
            return this._def(l.varKinds.const, e, t, n);
          }
        }, {
          key: "let",
          value: function value(e, t, n) {
            return this._def(l.varKinds.let, e, t, n);
          }
        }, {
          key: "var",
          value: function value(e, t, n) {
            return this._def(l.varKinds.var, e, t, n);
          }
        }, {
          key: "assign",
          value: function value(e, t, n) {
            return this._leafNode(new p(e, t, n));
          }
        }, {
          key: "add",
          value: function value(e, t) {
            return this._leafNode(new m(e, u.operators.ADD, t));
          }
        }, {
          key: "code",
          value: function value(e) {
            return "function" == typeof e ? e() : e !== c.nil && this._leafNode(new k(e)), this;
          }
        }, {
          key: "object",
          value: function value() {
            for (var e = ["{"], t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
              n[r] = arguments[r];
            }
            for (var i = 0, o = n; i < o.length; i++) {
              var a = xi(o[i], 2),
                s = a[0],
                u = a[1];
              e.length > 1 && e.push(","), e.push(s), (s !== u || this.opts.es5) && (e.push(":"), (0, c.addCodeArg)(e, u));
            }
            return e.push("}"), new c._Code(e);
          }
        }, {
          key: "if",
          value: function value(e, t, n) {
            if (this._blockNode(new C(e)), t && n) this.code(t).else().code(n).endIf();else if (t) this.code(t).endIf();else if (n) throw new Error('CodeGen: "else" body without "then" body');
            return this;
          }
        }, {
          key: "elseIf",
          value: function value(e) {
            return this._elseNode(new C(e));
          }
        }, {
          key: "else",
          value: function value() {
            return this._elseNode(new S());
          }
        }, {
          key: "endIf",
          value: function value() {
            return this._endBlockNode(C, S);
          }
        }, {
          key: "_for",
          value: function value(e, t) {
            return this._blockNode(e), t && this.code(t).endFor(), this;
          }
        }, {
          key: "for",
          value: function value(e, t) {
            return this._for(new $(e), t);
          }
        }, {
          key: "forRange",
          value: function value(e, t, n, r) {
            var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.opts.es5 ? l.varKinds.var : l.varKinds.let,
              o = this._scope.toName(e);
            return this._for(new O(i, o, t, n), function () {
              return r(o);
            });
          }
        }, {
          key: "forOf",
          value: function value(e, t, n) {
            var o = this,
              a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : l.varKinds.const,
              s = this._scope.toName(e);
            if (this.opts.es5) {
              var u = t instanceof c.Name ? t : this.var("_arr", t);
              return this.forRange("_i", 0, c._(r || (r = pi(["", ".length"])), u), function (e) {
                o.var(s, c._(i || (i = pi(["", "[", "]"])), u, e)), n(s);
              });
            }
            return this._for(new A("of", a, s, t), function () {
              return n(s);
            });
          }
        }, {
          key: "forIn",
          value: function value(e, t, n) {
            var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.opts.es5 ? l.varKinds.var : l.varKinds.const;
            if (this.opts.ownProperties) return this.forOf(e, c._(o || (o = pi(["Object.keys(", ")"])), t), n);
            var i = this._scope.toName(e);
            return this._for(new A("in", r, i, t), function () {
              return n(i);
            });
          }
        }, {
          key: "endFor",
          value: function value() {
            return this._endBlockNode(_);
          }
        }, {
          key: "label",
          value: function value(e) {
            return this._leafNode(new g(e));
          }
        }, {
          key: "break",
          value: function value(e) {
            return this._leafNode(new y(e));
          }
        }, {
          key: "return",
          value: function value(e) {
            var t = new P();
            if (this._blockNode(t), this.code(e), 1 !== t.nodes.length) throw new Error('CodeGen: "return" should have one node');
            return this._endBlockNode(P);
          }
        }, {
          key: "try",
          value: function value(e, t, n) {
            if (!t && !n) throw new Error('CodeGen: "try" without "catch" and "finally"');
            var r = new M();
            if (this._blockNode(r), this.code(e), t) {
              var i = this.name("e");
              this._currNode = r.catch = new I(i), t(i);
            }
            return n && (this._currNode = r.finally = new T(), this.code(n)), this._endBlockNode(I, T);
          }
        }, {
          key: "throw",
          value: function value(e) {
            return this._leafNode(new b(e));
          }
        }, {
          key: "block",
          value: function value(e, t) {
            return this._blockStarts.push(this._nodes.length), e && this.code(e).endBlock(t), this;
          }
        }, {
          key: "endBlock",
          value: function value(e) {
            var t = this._blockStarts.pop();
            if (void 0 === t) throw new Error("CodeGen: not in self-balancing block");
            var n = this._nodes.length - t;
            if (n < 0 || void 0 !== e && n !== e) throw new Error("CodeGen: wrong number of nodes: ".concat(n, " vs ").concat(e, " expected"));
            return this._nodes.length = t, this;
          }
        }, {
          key: "func",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : c.nil,
              n = arguments.length > 2 ? arguments[2] : void 0,
              r = arguments.length > 3 ? arguments[3] : void 0;
            return this._blockNode(new E(e, t, n)), r && this.code(r).endFunc(), this;
          }
        }, {
          key: "endFunc",
          value: function value() {
            return this._endBlockNode(E);
          }
        }, {
          key: "optimize",
          value: function value() {
            for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1; e-- > 0;) {
              this._root.optimizeNodes(), this._root.optimizeNames(this._root.names, this._constants);
            }
          }
        }, {
          key: "_leafNode",
          value: function value(e) {
            return this._currNode.nodes.push(e), this;
          }
        }, {
          key: "_blockNode",
          value: function value(e) {
            this._currNode.nodes.push(e), this._nodes.push(e);
          }
        }, {
          key: "_endBlockNode",
          value: function value(e, t) {
            var n = this._currNode;
            if (n instanceof e || t && n instanceof t) return this._nodes.pop(), this;
            throw new Error('CodeGen: not in block "'.concat(t ? "".concat(e.kind, "/").concat(t.kind) : e.kind, '"'));
          }
        }, {
          key: "_elseNode",
          value: function value(e) {
            var t = this._currNode;
            if (!(t instanceof C)) throw new Error('CodeGen: "else" without "if"');
            return this._currNode = t.else = e, this;
          }
        }, {
          key: "_root",
          get: function get() {
            return this._nodes[0];
          }
        }, {
          key: "_currNode",
          get: function get() {
            var e = this._nodes;
            return e[e.length - 1];
          },
          set: function set(e) {
            var t = this._nodes;
            t[t.length - 1] = e;
          }
        }]), e;
      }(), u.not = L;
      var B = F(u.operators.AND);
      u.and = function () {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }
        return t.reduce(B);
      };
      var q = F(u.operators.OR);
      function F(e) {
        return function (t, n) {
          return t === c.nil ? n : n === c.nil ? t : c._(a || (a = pi(["", " ", " ", ""])), V(t), e, V(n));
        };
      }
      function V(e) {
        return e instanceof c.Name ? e : c._(s || (s = pi(["(", ")"])), e);
      }
      u.or = function () {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }
        return t.reduce(q);
      };
    }, {
      "./code": 1,
      "./scope": 3
    }],
    3: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.ValueScope = n.ValueScopeName = n.Scope = n.varKinds = n.UsedValueState = void 0;
      var r,
        i = e("./code"),
        o = function (e) {
          ji(n, di(Error));
          var t = Ci(n);
          function n(e) {
            var r;
            return Ri(this, n), (r = t.call(this, 'CodeGen: "code" for '.concat(e, " not defined"))).value = e.value, r;
          }
          return zi(n);
        }();
      !function (e) {
        e[e.Started = 0] = "Started", e[e.Completed = 1] = "Completed";
      }(r = n.UsedValueState || (n.UsedValueState = {})), n.varKinds = {
        const: new i.Name("const"),
        let: new i.Name("let"),
        var: new i.Name("var")
      };
      var a = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.prefixes,
            r = t.parent;
          Ri(this, e), this._names = {}, this._prefixes = n, this._parent = r;
        }
        return zi(e, [{
          key: "toName",
          value: function value(e) {
            return e instanceof i.Name ? e : this.name(e);
          }
        }, {
          key: "name",
          value: function value(e) {
            return new i.Name(this._newName(e));
          }
        }, {
          key: "_newName",
          value: function value(e) {
            return "".concat(e).concat((this._names[e] || this._nameGroup(e)).index++);
          }
        }, {
          key: "_nameGroup",
          value: function value(e) {
            var t, n;
            if ((null === (n = null === (t = this._parent) || void 0 === t ? void 0 : t._prefixes) || void 0 === n ? void 0 : n.has(e)) || this._prefixes && !this._prefixes.has(e)) throw new Error('CodeGen: prefix "'.concat(e, '" is not allowed in this scope'));
            return this._names[e] = {
              prefix: e,
              index: 0
            };
          }
        }]), e;
      }();
      n.Scope = a;
      var s = function (e) {
        ji(n, e);
        var t = Ci(n);
        function n(e, r) {
          var i;
          return Ri(this, n), (i = t.call(this, r)).prefix = e, i;
        }
        return zi(n, [{
          key: "setValue",
          value: function value(e, t) {
            var n = t.property,
              r = t.itemIndex;
            this.value = e, this.scopePath = i._(u || (u = pi([".", "[", "]"])), new i.Name(n), r);
          }
        }]), n;
      }(i.Name);
      n.ValueScopeName = s;
      var d = i._(c || (c = pi(["\n"], ["\\n"])));
      n.ValueScope = function (e) {
        ji(a, e);
        var t = Ci(a);
        function a(e) {
          var n;
          return Ri(this, a), (n = t.call(this, e))._values = {}, n._scope = e.scope, n.opts = Pi(Pi({}, e), {}, {
            _n: e.lines ? d : i.nil
          }), n;
        }
        return zi(a, [{
          key: "get",
          value: function value() {
            return this._scope;
          }
        }, {
          key: "name",
          value: function value(e) {
            return new s(e, this._newName(e));
          }
        }, {
          key: "value",
          value: function value(e, t) {
            var n;
            if (void 0 === t.ref) throw new Error("CodeGen: ref must be passed in value");
            var r = this.toName(e),
              i = r.prefix,
              o = null !== (n = t.key) && void 0 !== n ? n : t.ref,
              a = this._values[i];
            if (a) {
              var s = a.get(o);
              if (s) return s;
            } else a = this._values[i] = new Map();
            a.set(o, r);
            var u = this._scope[i] || (this._scope[i] = []),
              c = u.length;
            return u[c] = t.ref, r.setValue(t, {
              property: i,
              itemIndex: c
            }), r;
          }
        }, {
          key: "getValue",
          value: function value(e, t) {
            var n = this._values[e];
            if (n) return n.get(t);
          }
        }, {
          key: "scopeRefs",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._values;
            return this._reduceValues(t, function (t) {
              if (void 0 === t.scopePath) throw new Error('CodeGen: name "'.concat(t, '" has no value'));
              return i._(l || (l = pi(["", "", ""])), e, t.scopePath);
            });
          }
        }, {
          key: "scopeCode",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._values,
              t = arguments.length > 1 ? arguments[1] : void 0,
              n = arguments.length > 2 ? arguments[2] : void 0;
            return this._reduceValues(e, function (e) {
              if (void 0 === e.value) throw new Error('CodeGen: name "'.concat(e, '" has no value'));
              return e.value.code;
            }, t, n);
          }
        }, {
          key: "_reduceValues",
          value: function value(e, t) {
            var a = this,
              s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              u = arguments.length > 3 ? arguments[3] : void 0,
              c = i.nil,
              l = function l(_l2) {
                var d = e[_l2];
                if (!d) return "continue";
                var v = s[_l2] = s[_l2] || new Map();
                d.forEach(function (e) {
                  if (!v.has(e)) {
                    v.set(e, r.Started);
                    var s = t(e);
                    if (s) c = i._(f || (f = pi(["", "", " ", " = ", ";", ""])), c, a.opts.es5 ? n.varKinds.var : n.varKinds.const, e, s, a.opts._n);else {
                      if (!(s = null == u ? void 0 : u(e))) throw new o(e);
                      c = i._(h || (h = pi(["", "", "", ""])), c, s, a.opts._n);
                    }
                    v.set(e, r.Completed);
                  }
                });
              };
            for (var d in e) {
              l(d);
            }
            return c;
          }
        }]), a;
      }(a);
    }, {
      "./code": 1
    }],
    4: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.extendErrors = n.resetErrorsCount = n.reportExtraError = n.reportError = n.keyword$DataError = n.keywordError = void 0;
      var r = e("./codegen"),
        i = e("./util"),
        o = e("./names");
      function a(e, t) {
        var n = e.const("err", t);
        e.if(r._(d || (d = pi(["", " === null"])), o.default.vErrors), function () {
          return e.assign(o.default.vErrors, r._(v || (v = pi(["[", "]"])), n));
        }, r._(p || (p = pi(["", ".push(", ")"])), o.default.vErrors, n)), e.code(r._(m || (m = pi(["", "++"])), o.default.errors));
      }
      function s(e, t) {
        var n = e.gen,
          i = e.validateName;
        e.schemaEnv.$async ? n.throw(r._(g || (g = pi(["new ", "(", ")"])), e.ValidationError, t)) : (n.assign(r._(y || (y = pi(["", ".errors"])), i), t), n.return(!1));
      }
      n.keywordError = {
        message: function message(e) {
          var t = e.keyword;
          return r.str(b || (b = pi(['must pass "', '" keyword validation'])), t);
        }
      }, n.keyword$DataError = {
        message: function message(e) {
          var t = e.keyword,
            n = e.schemaType;
          return n ? r.str(k || (k = pi(['"', '" keyword must be ', " ($data)"])), t, n) : r.str(w || (w = pi(['"', '" keyword is invalid ($data)'])), t);
        }
      }, n.reportError = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.keywordError,
          i = arguments.length > 2 ? arguments[2] : void 0,
          o = arguments.length > 3 ? arguments[3] : void 0,
          u = e.it,
          l = u.gen,
          f = u.compositeRule,
          h = u.allErrors,
          d = c(e, t, i);
        (null != o ? o : f || h) ? a(l, d) : s(u, r._(x || (x = pi(["[", "]"])), d));
      }, n.reportExtraError = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.keywordError,
          r = arguments.length > 2 ? arguments[2] : void 0,
          i = e.it,
          u = i.gen,
          l = i.compositeRule,
          f = i.allErrors;
        a(u, c(e, t, r)), l || f || s(i, o.default.vErrors);
      }, n.resetErrorsCount = function (e, t) {
        e.assign(o.default.errors, t), e.if(r._(j || (j = pi(["", " !== null"])), o.default.vErrors), function () {
          return e.if(t, function () {
            return e.assign(r._(S || (S = pi(["", ".length"])), o.default.vErrors), t);
          }, function () {
            return e.assign(o.default.vErrors, null);
          });
        });
      }, n.extendErrors = function (e) {
        var t = e.gen,
          n = e.keyword,
          i = e.schemaValue,
          a = e.data,
          s = e.errsCount,
          u = e.it;
        if (void 0 === s) throw new Error("ajv implementation error");
        var c = t.name("err");
        t.forRange("i", s, o.default.errors, function (e) {
          t.const(c, r._(C || (C = pi(["", "[", "]"])), o.default.vErrors, e)), t.if(r._(_ || (_ = pi(["", ".instancePath === undefined"])), c), function () {
            return t.assign(r._($ || ($ = pi(["", ".instancePath"])), c), (0, r.strConcat)(o.default.instancePath, u.errorPath));
          }), t.assign(r._(O || (O = pi(["", ".schemaPath"])), c), r.str(A || (A = pi(["", "/", ""])), u.errSchemaPath, n)), u.opts.verbose && (t.assign(r._(E || (E = pi(["", ".schema"])), c), i), t.assign(r._(P || (P = pi(["", ".data"])), c), a));
        });
      };
      var u = {
        keyword: new r.Name("keyword"),
        schemaPath: new r.Name("schemaPath"),
        params: new r.Name("params"),
        propertyName: new r.Name("propertyName"),
        message: new r.Name("message"),
        schema: new r.Name("schema"),
        parentSchema: new r.Name("parentSchema")
      };
      function c(e, t, n) {
        return !1 === e.it.createErrors ? r._(M || (M = pi(["{}"]))) : function (e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = e.gen,
            a = [l(e.it, n), f(e, n)];
          return function (e, t, n) {
            var i = t.params,
              a = t.message,
              s = e.keyword,
              c = e.data,
              l = e.schemaValue,
              f = e.it,
              h = f.opts,
              d = f.propertyName,
              v = f.topSchemaRef,
              p = f.schemaPath;
            n.push([u.keyword, s], [u.params, "function" == typeof i ? i(e) : i || r._(I || (I = pi(["{}"])))]), h.messages && n.push([u.message, "function" == typeof a ? a(e) : a]), h.verbose && n.push([u.schema, l], [u.parentSchema, r._(T || (T = pi(["", "", ""])), v, p)], [o.default.data, c]), d && n.push([u.propertyName, d]);
          }(e, t, a), i.object.apply(i, a);
        }(e, t, n);
      }
      function l(e, t) {
        var n = e.errorPath,
          a = t.instancePath,
          s = a ? r.str(N || (N = pi(["", "", ""])), n, (0, i.getErrorPath)(a, i.Type.Str)) : n;
        return [o.default.instancePath, (0, r.strConcat)(o.default.instancePath, s)];
      }
      function f(e, t) {
        var n = e.keyword,
          o = e.it.errSchemaPath,
          a = t.schemaPath,
          s = t.parentSchema ? o : r.str(R || (R = pi(["", "/", ""])), o, n);
        return a && (s = r.str(D || (D = pi(["", "", ""])), s, (0, i.getErrorPath)(a, i.Type.Str))), [u.schemaPath, s];
      }
    }, {
      "./codegen": 2,
      "./names": 6,
      "./util": 10
    }],
    5: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.resolveSchema = n.getCompilingSchema = n.resolveRef = n.compileSchema = n.SchemaEnv = void 0;
      var r = e("./codegen"),
        i = e("../runtime/validation_error"),
        o = e("./names"),
        a = e("./resolve"),
        s = e("./util"),
        u = e("./validate"),
        c = zi(function e(t) {
          var n, r;
          Ri(this, e), this.refs = {}, this.dynamicAnchors = {}, "object" == Li(t.schema) && (r = t.schema), this.schema = t.schema, this.schemaId = t.schemaId, this.root = t.root || this, this.baseId = null !== (n = t.baseId) && void 0 !== n ? n : (0, a.normalizeId)(null == r ? void 0 : r[t.schemaId || "$id"]), this.schemaPath = t.schemaPath, this.localRefs = t.localRefs, this.meta = t.meta, this.$async = null == r ? void 0 : r.$async, this.refs = {};
        });
      function l(e) {
        var t = h.call(this, e);
        if (t) return t;
        var n,
          s = (0, a.getFullPath)(this.opts.uriResolver, e.root.baseId),
          c = this.opts.code,
          l = c.es5,
          f = c.lines,
          d = this.opts.ownProperties,
          v = new r.CodeGen(this.scope, {
            es5: l,
            lines: f,
            ownProperties: d
          });
        e.$async && (n = v.scopeValue("Error", {
          ref: i.default,
          code: r._(z || (z = pi(['require("ajv/dist/runtime/validation_error").default'])))
        }));
        var p = v.scopeName("validate");
        e.validateName = p;
        var m,
          g = {
            gen: v,
            allErrors: this.opts.allErrors,
            data: o.default.data,
            parentData: o.default.parentData,
            parentDataProperty: o.default.parentDataProperty,
            dataNames: [o.default.data],
            dataPathArr: [r.nil],
            dataLevel: 0,
            dataTypes: [],
            definedProperties: new Set(),
            topSchemaRef: v.scopeValue("schema", !0 === this.opts.code.source ? {
              ref: e.schema,
              code: (0, r.stringify)(e.schema)
            } : {
              ref: e.schema
            }),
            validateName: p,
            ValidationError: n,
            schema: e.schema,
            schemaEnv: e,
            rootId: s,
            baseId: e.baseId || s,
            schemaPath: r.nil,
            errSchemaPath: e.schemaPath || (this.opts.jtd ? "" : "#"),
            errorPath: r._(L || (L = pi(['""']))),
            opts: this.opts,
            self: this
          };
        try {
          this._compilations.add(e), (0, u.validateFunctionCode)(g), v.optimize(this.opts.code.optimize);
          var y = v.toString();
          m = "".concat(v.scopeRefs(o.default.scope), "return ").concat(y), this.opts.code.process && (m = this.opts.code.process(m, e));
          var b = new Function("".concat(o.default.self), "".concat(o.default.scope), m)(this, this.scope.get());
          if (this.scope.value(p, {
            ref: b
          }), b.errors = null, b.schema = e.schema, b.schemaEnv = e, e.$async && (b.$async = !0), !0 === this.opts.code.source && (b.source = {
            validateName: p,
            validateCode: y,
            scopeValues: v._values
          }), this.opts.unevaluated) {
            var k = g.props,
              w = g.items;
            b.evaluated = {
              props: k instanceof r.Name ? void 0 : k,
              items: w instanceof r.Name ? void 0 : w,
              dynamicProps: k instanceof r.Name,
              dynamicItems: w instanceof r.Name
            }, b.source && (b.source.evaluated = (0, r.stringify)(b.evaluated));
          }
          return e.validate = b, e;
        } catch (t) {
          throw delete e.validate, delete e.validateName, m && this.logger.error("Error compiling schema, function code:", m), t;
        } finally {
          this._compilations.delete(e);
        }
      }
      function f(e) {
        return (0, a.inlineRef)(e.schema, this.opts.inlineRefs) ? e.schema : e.validate ? e : l.call(this, e);
      }
      function h(e) {
        var t,
          n,
          r,
          i = bi(this._compilations);
        try {
          for (i.s(); !(t = i.n()).done;) {
            var o = t.value;
            if ((n = o).schema === (r = e).schema && n.root === r.root && n.baseId === r.baseId) return o;
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
      }
      function d(e, t) {
        for (var n; "string" == typeof (n = this.refs[t]);) {
          t = n;
        }
        return n || this.schemas[t] || v.call(this, e, t);
      }
      function v(e, t) {
        var n = this.opts.uriResolver.parse(t),
          r = (0, a._getFullPath)(this.opts.uriResolver, n),
          i = (0, a.getFullPath)(this.opts.uriResolver, e.baseId, void 0);
        if (Object.keys(e.schema).length > 0 && r === i) return m.call(this, n, e);
        var o = (0, a.normalizeId)(r),
          s = this.refs[o] || this.schemas[o];
        if ("string" == typeof s) {
          var u = v.call(this, e, s);
          if ("object" != Li(null == u ? void 0 : u.schema)) return;
          return m.call(this, n, u);
        }
        if ("object" == Li(null == s ? void 0 : s.schema)) {
          if (s.validate || l.call(this, s), o === (0, a.normalizeId)(t)) {
            var f = s.schema,
              h = this.opts.schemaId,
              d = f[h];
            return d && (i = (0, a.resolveUrl)(this.opts.uriResolver, i, d)), new c({
              schema: f,
              schemaId: h,
              root: e,
              baseId: i
            });
          }
          return m.call(this, n, s);
        }
      }
      n.SchemaEnv = c, n.compileSchema = l, n.resolveRef = function (e, t, n) {
        var r;
        n = (0, a.resolveUrl)(this.opts.uriResolver, t, n);
        var i = e.refs[n];
        if (i) return i;
        var o = d.call(this, e, n);
        if (void 0 === o) {
          var s = null === (r = e.localRefs) || void 0 === r ? void 0 : r[n],
            u = this.opts.schemaId;
          s && (o = new c({
            schema: s,
            schemaId: u,
            root: e,
            baseId: t
          }));
        }
        return void 0 !== o ? e.refs[n] = f.call(this, o) : void 0;
      }, n.getCompilingSchema = h, n.resolveSchema = v;
      var p = new Set(["properties", "patternProperties", "enum", "dependencies", "definitions"]);
      function m(e, t) {
        var n,
          r = t.baseId,
          i = t.schema,
          o = t.root;
        if ("/" === (null === (n = e.fragment) || void 0 === n ? void 0 : n[0])) {
          var u,
            l,
            f = bi(e.fragment.slice(1).split("/"));
          try {
            for (f.s(); !(u = f.n()).done;) {
              var h = u.value;
              if ("boolean" == typeof i) return;
              var d = i[(0, s.unescapeFragment)(h)];
              if (void 0 === d) return;
              var m = "object" == Li(i = d) && i[this.opts.schemaId];
              !p.has(h) && m && (r = (0, a.resolveUrl)(this.opts.uriResolver, r, m));
            }
          } catch (e) {
            f.e(e);
          } finally {
            f.f();
          }
          if ("boolean" != typeof i && i.$ref && !(0, s.schemaHasRulesButRef)(i, this.RULES)) {
            var g = (0, a.resolveUrl)(this.opts.uriResolver, r, i.$ref);
            l = v.call(this, o, g);
          }
          var y = this.opts.schemaId;
          return (l = l || new c({
            schema: i,
            schemaId: y,
            root: o,
            baseId: r
          })).schema !== l.root.schema ? l : void 0;
        }
      }
    }, {
      "../runtime/validation_error": 24,
      "./codegen": 2,
      "./names": 6,
      "./resolve": 8,
      "./util": 10,
      "./validate": 15
    }],
    6: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("./codegen"),
        i = {
          data: new r.Name("data"),
          valCxt: new r.Name("valCxt"),
          instancePath: new r.Name("instancePath"),
          parentData: new r.Name("parentData"),
          parentDataProperty: new r.Name("parentDataProperty"),
          rootData: new r.Name("rootData"),
          dynamicAnchors: new r.Name("dynamicAnchors"),
          vErrors: new r.Name("vErrors"),
          errors: new r.Name("errors"),
          this: new r.Name("this"),
          self: new r.Name("self"),
          scope: new r.Name("scope"),
          json: new r.Name("json"),
          jsonPos: new r.Name("jsonPos"),
          jsonLen: new r.Name("jsonLen"),
          jsonPart: new r.Name("jsonPart")
        };
      n.default = i;
    }, {
      "./codegen": 2
    }],
    7: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("./resolve"),
        i = function (e) {
          ji(n, di(Error));
          var t = Ci(n);
          function n(e, i, o, a) {
            var s;
            return Ri(this, n), (s = t.call(this, a || "can't resolve reference ".concat(o, " from id ").concat(i))).missingRef = (0, r.resolveUrl)(e, i, o), s.missingSchema = (0, r.normalizeId)((0, r.getFullPath)(e, s.missingRef)), s;
          }
          return zi(n);
        }();
      n.default = i;
    }, {
      "./resolve": 8
    }],
    8: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.getSchemaRefs = n.resolveUrl = n.normalizeId = n._getFullPath = n.getFullPath = n.inlineRef = void 0;
      var r = e("./util"),
        i = e("fast-deep-equal"),
        o = e("json-schema-traverse"),
        a = new Set(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum", "const"]);
      n.inlineRef = function (e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        return "boolean" == typeof e || (!0 === t ? !u(e) : !!t && c(e) <= t);
      };
      var s = new Set(["$ref", "$recursiveRef", "$recursiveAnchor", "$dynamicRef", "$dynamicAnchor"]);
      function u(e) {
        for (var t in e) {
          if (s.has(t)) return !0;
          var n = e[t];
          if (Array.isArray(n) && n.some(u)) return !0;
          if ("object" == Li(n) && u(n)) return !0;
        }
        return !1;
      }
      function c(e) {
        var t = 0;
        for (var n in e) {
          if ("$ref" === n) return 1 / 0;
          if (t++, !a.has(n) && ("object" == Li(e[n]) && (0, r.eachItem)(e[n], function (e) {
            return t += c(e);
          }), 1 / 0 === t)) return 1 / 0;
        }
        return t;
      }
      function l(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        !1 !== (arguments.length > 2 ? arguments[2] : void 0) && (t = d(t));
        var n = e.parse(t);
        return f(e, n);
      }
      function f(e, t) {
        return e.serialize(t).split("#")[0] + "#";
      }
      n.getFullPath = l, n._getFullPath = f;
      var h = /#\/?$/;
      function d(e) {
        return e ? e.replace(h, "") : "";
      }
      n.normalizeId = d, n.resolveUrl = function (e, t, n) {
        return n = d(n), e.resolve(t, n);
      };
      var v = /^[a-z_][-a-z0-9._]*$/i;
      n.getSchemaRefs = function (e, t) {
        var n = this;
        if ("boolean" == typeof e) return {};
        var r = this.opts,
          a = r.schemaId,
          s = r.uriResolver,
          u = d(e[a] || t),
          c = {
            "": u
          },
          f = l(s, u, !1),
          h = {},
          p = new Set();
        return o(e, {
          allKeys: !0
        }, function (e, t, r, i) {
          if (void 0 !== i) {
            var o = f + t,
              s = c[i];
            "string" == typeof e[a] && (s = u.call(n, e[a])), l.call(n, e.$anchor), l.call(n, e.$dynamicAnchor), c[t] = s;
          }
          function u(t) {
            if (t = d(s ? (0, this.opts.uriResolver.resolve)(s, t) : t), p.has(t)) throw g(t);
            p.add(t);
            var n = this.refs[t];
            return "string" == typeof n && (n = this.refs[n]), "object" == Li(n) ? m(e, n.schema, t) : t !== d(o) && ("#" === t[0] ? (m(e, h[t], t), h[t] = e) : this.refs[t] = o), t;
          }
          function l(e) {
            if ("string" == typeof e) {
              if (!v.test(e)) throw new Error('invalid anchor "'.concat(e, '"'));
              u.call(this, "#".concat(e));
            }
          }
        }), h;
        function m(e, t, n) {
          if (void 0 !== t && !i(e, t)) throw g(n);
        }
        function g(e) {
          return new Error('reference "'.concat(e, '" resolves to more than one schema'));
        }
      };
    }, {
      "./util": 10,
      "fast-deep-equal": 63,
      "json-schema-traverse": 64
    }],
    9: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.getRules = n.isJSONType = void 0;
      var r = new Set(["string", "number", "integer", "boolean", "null", "object", "array"]);
      n.isJSONType = function (e) {
        return "string" == typeof e && r.has(e);
      }, n.getRules = function () {
        var e = {
          number: {
            type: "number",
            rules: []
          },
          string: {
            type: "string",
            rules: []
          },
          array: {
            type: "array",
            rules: []
          },
          object: {
            type: "object",
            rules: []
          }
        };
        return {
          types: Pi(Pi({}, e), {}, {
            integer: !0,
            boolean: !0,
            null: !0
          }),
          rules: [{
            rules: []
          }, e.number, e.string, e.array, e.object],
          post: {
            rules: []
          },
          all: {},
          keywords: {}
        };
      };
    }, {}],
    10: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.checkStrictMode = n.getErrorPath = n.Type = n.useFunc = n.setEvaluated = n.evaluatedPropsToName = n.mergeEvaluated = n.eachItem = n.unescapeJsonPointer = n.escapeJsonPointer = n.escapeFragment = n.unescapeFragment = n.schemaRefOrVal = n.schemaHasRulesButRef = n.schemaHasRules = n.checkUnknownRules = n.alwaysValidSchema = n.toHash = void 0;
      var r = e("./codegen"),
        i = e("./codegen/code");
      function o(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.schema,
          n = e.opts,
          r = e.self;
        if (n.strictSchema && "boolean" != typeof t) {
          var i = r.RULES.keywords;
          for (var o in t) {
            i[o] || v(e, 'unknown keyword: "'.concat(o, '"'));
          }
        }
      }
      function a(e, t) {
        if ("boolean" == typeof e) return !e;
        for (var n in e) {
          if (t[n]) return !0;
        }
        return !1;
      }
      function s(e) {
        return "number" == typeof e ? "".concat(e) : e.replace(/~/g, "~0").replace(/\//g, "~1");
      }
      function u(e) {
        return e.replace(/~1/g, "/").replace(/~0/g, "~");
      }
      function c(e) {
        var t = e.mergeNames,
          n = e.mergeToName,
          i = e.mergeValues,
          o = e.resultToName;
        return function (e, a, s, u) {
          var c = void 0 === s ? a : s instanceof r.Name ? (a instanceof r.Name ? t(e, a, s) : n(e, a, s), s) : a instanceof r.Name ? (n(e, s, a), a) : i(a, s);
          return u !== r.Name || c instanceof r.Name ? c : o(e, c);
        };
      }
      function l(e, t) {
        if (!0 === t) return e.var("props", !0);
        var n = e.var("props", r._(B || (B = pi(["{}"]))));
        return void 0 !== t && f(e, n, t), n;
      }
      function f(e, t, n) {
        Object.keys(n).forEach(function (n) {
          return e.assign(r._(q || (q = pi(["", "", ""])), t, (0, r.getProperty)(n)), !0);
        });
      }
      n.toHash = function (e) {
        var t,
          n = {},
          r = bi(e);
        try {
          for (r.s(); !(t = r.n()).done;) {
            n[t.value] = !0;
          }
        } catch (e) {
          r.e(e);
        } finally {
          r.f();
        }
        return n;
      }, n.alwaysValidSchema = function (e, t) {
        return "boolean" == typeof t ? t : 0 === Object.keys(t).length || (o(e, t), !a(t, e.self.RULES.all));
      }, n.checkUnknownRules = o, n.schemaHasRules = a, n.schemaHasRulesButRef = function (e, t) {
        if ("boolean" == typeof e) return !e;
        for (var n in e) {
          if ("$ref" !== n && t.all[n]) return !0;
        }
        return !1;
      }, n.schemaRefOrVal = function (e, t, n, i) {
        var o = e.topSchemaRef,
          a = e.schemaPath;
        if (!i) {
          if ("number" == typeof t || "boolean" == typeof t) return t;
          if ("string" == typeof t) return r._(F || (F = pi(["", ""])), t);
        }
        return r._(V || (V = pi(["", "", "", ""])), o, a, (0, r.getProperty)(n));
      }, n.unescapeFragment = function (e) {
        return u(decodeURIComponent(e));
      }, n.escapeFragment = function (e) {
        return encodeURIComponent(s(e));
      }, n.escapeJsonPointer = s, n.unescapeJsonPointer = u, n.eachItem = function (e, t) {
        if (Array.isArray(e)) {
          var n,
            r = bi(e);
          try {
            for (r.s(); !(n = r.n()).done;) {
              t(n.value);
            }
          } catch (e) {
            r.e(e);
          } finally {
            r.f();
          }
        } else t(e);
      }, n.mergeEvaluated = {
        props: c({
          mergeNames: function mergeNames(e, t, n) {
            return e.if(r._(H || (H = pi(["", " !== true && ", " !== undefined"])), n, t), function () {
              e.if(r._(W || (W = pi(["", " === true"])), t), function () {
                return e.assign(n, !0);
              }, function () {
                return e.assign(n, r._(U || (U = pi(["", " || {}"])), n)).code(r._(J || (J = pi(["Object.assign(", ", ", ")"])), n, t));
              });
            });
          },
          mergeToName: function mergeToName(e, t, n) {
            return e.if(r._(K || (K = pi(["", " !== true"])), n), function () {
              !0 === t ? e.assign(n, !0) : (e.assign(n, r._(G || (G = pi(["", " || {}"])), n)), f(e, n, t));
            });
          },
          mergeValues: function mergeValues(e, t) {
            return !0 === e || Pi(Pi({}, e), t);
          },
          resultToName: l
        }),
        items: c({
          mergeNames: function mergeNames(e, t, n) {
            return e.if(r._(Q || (Q = pi(["", " !== true && ", " !== undefined"])), n, t), function () {
              return e.assign(n, r._(Y || (Y = pi(["", " === true ? true : ", " > ", " ? ", " : ", ""])), t, n, t, n, t));
            });
          },
          mergeToName: function mergeToName(e, t, n) {
            return e.if(r._(Z || (Z = pi(["", " !== true"])), n), function () {
              return e.assign(n, !0 === t || r._(X || (X = pi(["", " > ", " ? ", " : ", ""])), n, t, n, t));
            });
          },
          mergeValues: function mergeValues(e, t) {
            return !0 === e || Math.max(e, t);
          },
          resultToName: function resultToName(e, t) {
            return e.var("items", t);
          }
        })
      }, n.evaluatedPropsToName = l, n.setEvaluated = f;
      var h,
        d = {};
      function v(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.opts.strictSchema;
        if (n) {
          if (t = "strict mode: ".concat(t), !0 === n) throw new Error(t);
          e.self.logger.warn(t);
        }
      }
      n.useFunc = function (e, t) {
        return e.scopeValue("func", {
          ref: t,
          code: d[t.code] || (d[t.code] = new i._Code(t.code))
        });
      }, function (e) {
        e[e.Num = 0] = "Num", e[e.Str = 1] = "Str";
      }(h = n.Type || (n.Type = {})), n.getErrorPath = function (e, t, n) {
        if (e instanceof r.Name) {
          var i = t === h.Num;
          return n ? i ? r._(ee || (ee = pi(['"[" + ', ' + "]"'])), e) : r._(te || (te = pi(['"[\'" + ', ' + "\']"'])), e) : i ? r._(ne || (ne = pi(['"/" + ', ""])), e) : r._(re || (re = pi(['"/" + ', '.replace(/~/g, "~0").replace(/\\//g, "~1")'], ['"/" + ', '.replace(/~/g, "~0").replace(/\\\\//g, "~1")'])), e);
        }
        return n ? (0, r.getProperty)(e).toString() : "/" + s(e);
      }, n.checkStrictMode = v;
    }, {
      "./codegen": 2,
      "./codegen/code": 1
    }],
    11: [function (e, t, n) {
      function r(e, t) {
        return t.rules.some(function (t) {
          return i(e, t);
        });
      }
      function i(e, t) {
        var n;
        return void 0 !== e[t.keyword] || (null === (n = t.definition.implements) || void 0 === n ? void 0 : n.some(function (t) {
          return void 0 !== e[t];
        }));
      }
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.shouldUseRule = n.shouldUseGroup = n.schemaHasRulesForType = void 0, n.schemaHasRulesForType = function (e, t) {
        var n = e.schema,
          i = e.self.RULES.types[t];
        return i && !0 !== i && r(n, i);
      }, n.shouldUseGroup = r, n.shouldUseRule = i;
    }, {}],
    12: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.boolOrEmptySchema = n.topBoolOrEmptySchema = void 0;
      var r = e("../errors"),
        i = e("../codegen"),
        o = e("../names"),
        a = {
          message: "boolean schema is false"
        };
      function s(e, t) {
        var n = e.gen,
          i = e.data;
        (0, r.reportError)({
          gen: n,
          keyword: "false schema",
          data: i,
          schema: !1,
          schemaCode: !1,
          schemaValue: !1,
          params: {},
          it: e
        }, a, void 0, t);
      }
      n.topBoolOrEmptySchema = function (e) {
        var t = e.gen,
          n = e.schema,
          r = e.validateName;
        !1 === n ? s(e, !1) : "object" == Li(n) && !0 === n.$async ? t.return(o.default.data) : (t.assign(i._(ie || (ie = pi(["", ".errors"])), r), null), t.return(!0));
      }, n.boolOrEmptySchema = function (e, t) {
        var n = e.gen;
        !1 === e.schema ? (n.var(t, !1), s(e)) : n.var(t, !0);
      };
    }, {
      "../codegen": 2,
      "../errors": 4,
      "../names": 6
    }],
    13: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.reportTypeError = n.checkDataTypes = n.checkDataType = n.coerceAndCheckDataType = n.getJSONTypes = n.getSchemaTypes = n.DataType = void 0;
      var r,
        i = e("../rules"),
        o = e("./applicability"),
        a = e("../errors"),
        s = e("../codegen"),
        u = e("../util");
      function c(e) {
        var t = Array.isArray(e) ? e : e ? [e] : [];
        if (t.every(i.isJSONType)) return t;
        throw new Error("type must be JSONType or JSONType[]: " + t.join(","));
      }
      !function (e) {
        e[e.Correct = 0] = "Correct", e[e.Wrong = 1] = "Wrong";
      }(r = n.DataType || (n.DataType = {})), n.getSchemaTypes = function (e) {
        var t = c(e.type);
        if (t.includes("null")) {
          if (!1 === e.nullable) throw new Error("type: null contradicts nullable: false");
        } else {
          if (!t.length && void 0 !== e.nullable) throw new Error('"nullable" cannot be used without "type"');
          !0 === e.nullable && t.push("null");
        }
        return t;
      }, n.getJSONTypes = c, n.coerceAndCheckDataType = function (e, t) {
        var n = e.gen,
          i = e.data,
          a = e.opts,
          u = function (e, t) {
            return t ? e.filter(function (e) {
              return l.has(e) || "array" === t && "array" === e;
            }) : [];
          }(t, a.coerceTypes),
          c = t.length > 0 && !(0 === u.length && 1 === t.length && (0, o.schemaHasRulesForType)(e, t[0]));
        if (c) {
          var f = h(t, i, a.strictNumbers, r.Wrong);
          n.if(f, function () {
            u.length ? function (e, t, n) {
              var r = e.gen,
                i = e.data,
                o = e.opts,
                a = r.let("dataType", s._(oe || (oe = pi(["typeof ", ""])), i)),
                u = r.let("coerced", s._(ae || (ae = pi(["undefined"]))));
              "array" === o.coerceTypes && r.if(s._(se || (se = pi(["", " == 'object' && Array.isArray(", ") && ", ".length == 1"])), a, i, i), function () {
                return r.assign(i, s._(ue || (ue = pi(["", "[0]"])), i)).assign(a, s._(ce || (ce = pi(["typeof ", ""])), i)).if(h(t, i, o.strictNumbers), function () {
                  return r.assign(u, i);
                });
              }), r.if(s._(le || (le = pi(["", " !== undefined"])), u));
              var c,
                f = bi(n);
              try {
                for (f.s(); !(c = f.n()).done;) {
                  var d = c.value;
                  (l.has(d) || "array" === d && "array" === o.coerceTypes) && p(d);
                }
              } catch (e) {
                f.e(e);
              } finally {
                f.f();
              }
              function p(e) {
                switch (e) {
                  case "string":
                    return void r.elseIf(s._(fe || (fe = pi(["", ' == "number" || ', ' == "boolean"'])), a, a)).assign(u, s._(he || (he = pi(['"" + ', ""])), i)).elseIf(s._(de || (de = pi(["", " === null"])), i)).assign(u, s._(ve || (ve = pi(['""']))));
                  case "number":
                    return void r.elseIf(s._(pe || (pe = pi(["", ' == "boolean" || ', " === null\n\t              || (", ' == "string" && ', " && ", " == +", ")"])), a, i, a, i, i, i)).assign(u, s._(me || (me = pi(["+", ""])), i));
                  case "integer":
                    return void r.elseIf(s._(ge || (ge = pi(["", ' === "boolean" || ', " === null\n\t              || (", ' === "string" && ', " && ", " == +", " && !(", " % 1))"])), a, i, a, i, i, i, i)).assign(u, s._(ye || (ye = pi(["+", ""])), i));
                  case "boolean":
                    return void r.elseIf(s._(be || (be = pi(["", ' === "false" || ', " === 0 || ", " === null"])), i, i, i)).assign(u, !1).elseIf(s._(ke || (ke = pi(["", ' === "true" || ', " === 1"])), i, i)).assign(u, !0);
                  case "null":
                    return r.elseIf(s._(we || (we = pi(["", ' === "" || ', " === 0 || ", " === false"])), i, i, i)), void r.assign(u, null);
                  case "array":
                    r.elseIf(s._(xe || (xe = pi(["", ' === "string" || ', ' === "number"\n\t              || ', ' === "boolean" || ', " === null"])), a, a, a, i)).assign(u, s._(je || (je = pi(["[", "]"])), i));
                }
              }
              r.else(), v(e), r.endIf(), r.if(s._(Se || (Se = pi(["", " !== undefined"])), u), function () {
                r.assign(i, u), function (e, t) {
                  var n = e.gen,
                    r = e.parentData,
                    i = e.parentDataProperty;
                  n.if(s._(Ce || (Ce = pi(["", " !== undefined"])), r), function () {
                    return n.assign(s._(_e || (_e = pi(["", "[", "]"])), r, i), t);
                  });
                }(e, u);
              });
            }(e, t, u) : v(e);
          });
        }
        return c;
      };
      var l = new Set(["string", "number", "integer", "boolean", "null"]);
      function f(e, t, n) {
        var i,
          o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : r.Correct,
          a = o === r.Correct ? s.operators.EQ : s.operators.NEQ;
        switch (e) {
          case "null":
            return s._($e || ($e = pi(["", " ", " null"])), t, a);
          case "array":
            i = s._(Oe || (Oe = pi(["Array.isArray(", ")"])), t);
            break;
          case "object":
            i = s._(Ae || (Ae = pi(["", " && typeof ", ' == "object" && !Array.isArray(', ")"])), t, t, t);
            break;
          case "integer":
            i = u(s._(Ee || (Ee = pi(["!(", " % 1) && !isNaN(", ")"])), t, t));
            break;
          case "number":
            i = u();
            break;
          default:
            return s._(Pe || (Pe = pi(["typeof ", " ", " ", ""])), t, a, e);
        }
        return o === r.Correct ? i : (0, s.not)(i);
        function u() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s.nil;
          return (0, s.and)(s._(Me || (Me = pi(["typeof ", ' == "number"'])), t), e, n ? s._(Ie || (Ie = pi(["isFinite(", ")"])), t) : s.nil);
        }
      }
      function h(e, t, n, r) {
        if (1 === e.length) return f(e[0], t, n, r);
        var i,
          o = (0, u.toHash)(e);
        if (o.array && o.object) {
          var a = s._(Te || (Te = pi(["typeof ", ' != "object"'])), t);
          i = o.null ? a : s._(Ne || (Ne = pi(["!", " || ", ""])), t, a), delete o.null, delete o.array, delete o.object;
        } else i = s.nil;
        for (var c in o.number && delete o.integer, o) {
          i = (0, s.and)(i, f(c, t, n, r));
        }
        return i;
      }
      n.checkDataType = f, n.checkDataTypes = h;
      var d = {
        message: function message(e) {
          var t = e.schema;
          return "must be ".concat(t);
        },
        params: function params(e) {
          var t = e.schema,
            n = e.schemaValue;
          return "string" == typeof t ? s._(Re || (Re = pi(["{type: ", "}"])), t) : s._(De || (De = pi(["{type: ", "}"])), n);
        }
      };
      function v(e) {
        var t = function (e) {
          var t = e.gen,
            n = e.data,
            r = e.schema,
            i = (0, u.schemaRefOrVal)(e, r, "type");
          return {
            gen: t,
            keyword: "type",
            data: n,
            schema: r.type,
            schemaCode: i,
            schemaValue: i,
            parentSchema: r,
            params: {},
            it: e
          };
        }(e);
        (0, a.reportError)(t, d);
      }
      n.reportTypeError = v;
    }, {
      "../codegen": 2,
      "../errors": 4,
      "../rules": 9,
      "../util": 10,
      "./applicability": 11
    }],
    14: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.assignDefaults = void 0;
      var r = e("../codegen"),
        i = e("../util");
      function o(e, t, n) {
        var o = e.gen,
          a = e.compositeRule,
          s = e.data,
          u = e.opts;
        if (void 0 !== n) {
          var c = r._(ze || (ze = pi(["", "", ""])), s, (0, r.getProperty)(t));
          if (a) (0, i.checkStrictMode)(e, "default is ignored for: ".concat(c));else {
            var l = r._(Le || (Le = pi(["", " === undefined"])), c);
            "empty" === u.useDefaults && (l = r._(Be || (Be = pi(["", " || ", " === null || ", ' === ""'])), l, c, c)), o.if(l, r._(qe || (qe = pi(["", " = ", ""])), c, (0, r.stringify)(n)));
          }
        }
      }
      n.assignDefaults = function (e, t) {
        var n = e.schema,
          r = n.properties,
          i = n.items;
        if ("object" === t && r) for (var a in r) {
          o(e, a, r[a].default);
        } else "array" === t && Array.isArray(i) && i.forEach(function (t, n) {
          return o(e, n, t.default);
        });
      };
    }, {
      "../codegen": 2,
      "../util": 10
    }],
    15: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.getData = n.KeywordCxt = n.validateFunctionCode = void 0;
      var r = e("./boolSchema"),
        i = e("./dataType"),
        o = e("./applicability"),
        a = e("./dataType"),
        s = e("./defaults"),
        u = e("./keyword"),
        c = e("./subschema"),
        l = e("../codegen"),
        f = e("../names"),
        h = e("../resolve"),
        d = e("../util"),
        v = e("../errors");
      function p(e, t) {
        var n = e.gen,
          r = e.validateName,
          i = e.schema,
          o = e.schemaEnv,
          a = e.opts;
        a.code.es5 ? n.func(r, l._(Fe || (Fe = pi(["", ", ", ""])), f.default.data, f.default.valCxt), o.$async, function () {
          n.code(l._(Ve || (Ve = pi(['"use strict"; ', ""])), m(i, a))), function (e, t) {
            e.if(f.default.valCxt, function () {
              e.var(f.default.instancePath, l._(He || (He = pi(["", ".", ""])), f.default.valCxt, f.default.instancePath)), e.var(f.default.parentData, l._(We || (We = pi(["", ".", ""])), f.default.valCxt, f.default.parentData)), e.var(f.default.parentDataProperty, l._(Ue || (Ue = pi(["", ".", ""])), f.default.valCxt, f.default.parentDataProperty)), e.var(f.default.rootData, l._(Je || (Je = pi(["", ".", ""])), f.default.valCxt, f.default.rootData)), t.dynamicRef && e.var(f.default.dynamicAnchors, l._(Ke || (Ke = pi(["", ".", ""])), f.default.valCxt, f.default.dynamicAnchors));
            }, function () {
              e.var(f.default.instancePath, l._(Ge || (Ge = pi(['""'])))), e.var(f.default.parentData, l._(Qe || (Qe = pi(["undefined"])))), e.var(f.default.parentDataProperty, l._(Ye || (Ye = pi(["undefined"])))), e.var(f.default.rootData, f.default.data), t.dynamicRef && e.var(f.default.dynamicAnchors, l._(Ze || (Ze = pi(["{}"]))));
            });
          }(n, a), n.code(t);
        }) : n.func(r, l._(Xe || (Xe = pi(["", ", ", ""])), f.default.data, function (e) {
          return l._(et || (et = pi(["{", '="", ', ", ", ", ", "=", "", "}={}"])), f.default.instancePath, f.default.parentData, f.default.parentDataProperty, f.default.rootData, f.default.data, e.dynamicRef ? l._(tt || (tt = pi([", ", "={}"])), f.default.dynamicAnchors) : l.nil);
        }(a)), o.$async, function () {
          return n.code(m(i, a)).code(t);
        });
      }
      function m(e, t) {
        var n = "object" == Li(e) && e[t.schemaId];
        return n && (t.code.source || t.code.process) ? l._(nt || (nt = pi(["/*# sourceURL=", " */"])), n) : l.nil;
      }
      function g(e, t) {
        b(e) && (k(e), y(e)) ? function (e, t) {
          var n = e.schema,
            r = e.gen;
          e.opts.$comment && n.$comment && x(e), function (e) {
            var t = e.schema[e.opts.schemaId];
            t && (e.baseId = (0, h.resolveUrl)(e.opts.uriResolver, e.baseId, t));
          }(e), function (e) {
            if (e.schema.$async && !e.schemaEnv.$async) throw new Error("async schema in sync schema");
          }(e);
          var i = r.const("_errs", f.default.errors);
          w(e, i), r.var(t, l._(rt || (rt = pi(["", " === ", ""])), i, f.default.errors));
        }(e, t) : (0, r.boolOrEmptySchema)(e, t);
      }
      function y(e) {
        var t = e.schema,
          n = e.self;
        if ("boolean" == typeof t) return !t;
        for (var r in t) {
          if (n.RULES.all[r]) return !0;
        }
        return !1;
      }
      function b(e) {
        return "boolean" != typeof e.schema;
      }
      function k(e) {
        (0, d.checkUnknownRules)(e), function (e) {
          var t = e.schema,
            n = e.errSchemaPath,
            r = e.opts,
            i = e.self;
          t.$ref && r.ignoreKeywordsWithRef && (0, d.schemaHasRulesButRef)(t, i.RULES) && i.logger.warn('$ref: keywords ignored in schema at path "'.concat(n, '"'));
        }(e);
      }
      function w(e, t) {
        if (e.opts.jtd) return j(e, [], !1, t);
        var n = (0, i.getSchemaTypes)(e.schema);
        j(e, n, !(0, i.coerceAndCheckDataType)(e, n), t);
      }
      function x(e) {
        var t = e.gen,
          n = e.schemaEnv,
          r = e.schema,
          i = e.errSchemaPath,
          o = e.opts,
          a = r.$comment;
        if (!0 === o.$comment) t.code(l._(it || (it = pi(["", ".logger.log(", ")"])), f.default.self, a));else if ("function" == typeof o.$comment) {
          var s = l.str(ot || (ot = pi(["", "/$comment"])), i),
            u = t.scopeValue("root", {
              ref: n.root
            });
          t.code(l._(at || (at = pi(["", ".opts.$comment(", ", ", ", ", ".schema)"])), f.default.self, a, s, u));
        }
      }
      function j(e, t, n, r) {
        var i = e.gen,
          s = e.schema,
          u = e.data,
          c = e.allErrors,
          h = e.opts,
          v = e.self.RULES;
        function p(d) {
          (0, o.shouldUseGroup)(s, d) && (d.type ? (i.if((0, a.checkDataType)(d.type, u, h.strictNumbers)), S(e, d), 1 === t.length && t[0] === d.type && n && (i.else(), (0, a.reportTypeError)(e)), i.endIf()) : S(e, d), c || i.if(l._(st || (st = pi(["", " === ", ""])), f.default.errors, r || 0)));
        }
        !s.$ref || !h.ignoreKeywordsWithRef && (0, d.schemaHasRulesButRef)(s, v) ? (h.jtd || function (e, t) {
          !e.schemaEnv.meta && e.opts.strictTypes && (function (e, t) {
            t.length && (e.dataTypes.length ? (t.forEach(function (t) {
              _(e.dataTypes, t) || $(e, 'type "'.concat(t, '" not allowed by context "').concat(e.dataTypes.join(","), '"'));
            }), e.dataTypes = e.dataTypes.filter(function (e) {
              return _(t, e);
            })) : e.dataTypes = t);
          }(e, t), e.opts.allowUnionTypes || function (e, t) {
            t.length > 1 && (2 !== t.length || !t.includes("null")) && $(e, "use allowUnionTypes to allow union type keyword");
          }(e, t), function (e, t) {
            var n = e.self.RULES.all;
            for (var r in n) {
              var i = n[r];
              if ("object" == Li(i) && (0, o.shouldUseRule)(e.schema, i)) {
                var a = i.definition.type;
                a.length && !a.some(function (e) {
                  return C(t, e);
                }) && $(e, 'missing type "'.concat(a.join(","), '" for keyword "').concat(r, '"'));
              }
            }
          }(e, e.dataTypes));
        }(e, t), i.block(function () {
          var e,
            t = bi(v.rules);
          try {
            for (t.s(); !(e = t.n()).done;) {
              p(e.value);
            }
          } catch (e) {
            t.e(e);
          } finally {
            t.f();
          }
          p(v.post);
        })) : i.block(function () {
          return A(e, "$ref", v.all.$ref.definition);
        });
      }
      function S(e, t) {
        var n = e.gen,
          r = e.schema;
        e.opts.useDefaults && (0, s.assignDefaults)(e, t.type), n.block(function () {
          var n,
            i = bi(t.rules);
          try {
            for (i.s(); !(n = i.n()).done;) {
              var a = n.value;
              (0, o.shouldUseRule)(r, a) && A(e, a.keyword, a.definition, t.type);
            }
          } catch (e) {
            i.e(e);
          } finally {
            i.f();
          }
        });
      }
      function C(e, t) {
        return e.includes(t) || "number" === t && e.includes("integer");
      }
      function _(e, t) {
        return e.includes(t) || "integer" === t && e.includes("number");
      }
      function $(e, t) {
        (0, d.checkStrictMode)(e, t += ' at "'.concat(e.schemaEnv.baseId + e.errSchemaPath, '" (strictTypes)'), e.opts.strictTypes);
      }
      n.validateFunctionCode = function (e) {
        b(e) && (k(e), y(e)) ? function (e) {
          var t = e.schema,
            n = e.opts,
            r = e.gen;
          p(e, function () {
            n.$comment && t.$comment && x(e), function (e) {
              var t = e.schema,
                n = e.opts;
              void 0 !== t.default && n.useDefaults && n.strictSchema && (0, d.checkStrictMode)(e, "default is ignored in the schema root");
            }(e), r.let(f.default.vErrors, null), r.let(f.default.errors, 0), n.unevaluated && function (e) {
              var t = e.gen,
                n = e.validateName;
              e.evaluated = t.const("evaluated", l._(ut || (ut = pi(["", ".evaluated"])), n)), t.if(l._(ct || (ct = pi(["", ".dynamicProps"])), e.evaluated), function () {
                return t.assign(l._(lt || (lt = pi(["", ".props"])), e.evaluated), l._(ft || (ft = pi(["undefined"]))));
              }), t.if(l._(ht || (ht = pi(["", ".dynamicItems"])), e.evaluated), function () {
                return t.assign(l._(dt || (dt = pi(["", ".items"])), e.evaluated), l._(vt || (vt = pi(["undefined"]))));
              });
            }(e), w(e), function (e) {
              var t = e.gen,
                n = e.schemaEnv,
                r = e.validateName,
                i = e.ValidationError,
                o = e.opts;
              n.$async ? t.if(l._(pt || (pt = pi(["", " === 0"])), f.default.errors), function () {
                return t.return(f.default.data);
              }, function () {
                return t.throw(l._(mt || (mt = pi(["new ", "(", ")"])), i, f.default.vErrors));
              }) : (t.assign(l._(gt || (gt = pi(["", ".errors"])), r), f.default.vErrors), o.unevaluated && function (e) {
                var t = e.gen,
                  n = e.evaluated,
                  r = e.props,
                  i = e.items;
                r instanceof l.Name && t.assign(l._(yt || (yt = pi(["", ".props"])), n), r), i instanceof l.Name && t.assign(l._(bt || (bt = pi(["", ".items"])), n), i);
              }(e), t.return(l._(kt || (kt = pi(["", " === 0"])), f.default.errors)));
            }(e);
          });
        }(e) : p(e, function () {
          return (0, r.topBoolOrEmptySchema)(e);
        });
      };
      var O = function () {
        function e(t, n, r) {
          if (Ri(this, e), (0, u.validateKeywordUsage)(t, n, r), this.gen = t.gen, this.allErrors = t.allErrors, this.keyword = r, this.data = t.data, this.schema = t.schema[r], this.$data = n.$data && t.opts.$data && this.schema && this.schema.$data, this.schemaValue = (0, d.schemaRefOrVal)(t, this.schema, r, this.$data), this.schemaType = n.schemaType, this.parentSchema = t.schema, this.params = {}, this.it = t, this.def = n, this.$data) this.schemaCode = t.gen.const("vSchema", M(this.$data, t));else if (this.schemaCode = this.schemaValue, !(0, u.validSchemaType)(this.schema, n.schemaType, n.allowUndefined)) throw new Error("".concat(r, " value must be ").concat(JSON.stringify(n.schemaType)));
          ("code" in n ? n.trackErrors : !1 !== n.errors) && (this.errsCount = t.gen.const("_errs", f.default.errors));
        }
        return zi(e, [{
          key: "result",
          value: function value(e, t, n) {
            this.failResult((0, l.not)(e), t, n);
          }
        }, {
          key: "failResult",
          value: function value(e, t, n) {
            this.gen.if(e), n ? n() : this.error(), t ? (this.gen.else(), t(), this.allErrors && this.gen.endIf()) : this.allErrors ? this.gen.endIf() : this.gen.else();
          }
        }, {
          key: "pass",
          value: function value(e, t) {
            this.failResult((0, l.not)(e), void 0, t);
          }
        }, {
          key: "fail",
          value: function value(e) {
            if (void 0 === e) return this.error(), void (this.allErrors || this.gen.if(!1));
            this.gen.if(e), this.error(), this.allErrors ? this.gen.endIf() : this.gen.else();
          }
        }, {
          key: "fail$data",
          value: function value(e) {
            if (!this.$data) return this.fail(e);
            var t = this.schemaCode;
            this.fail(l._(wt || (wt = pi(["", " !== undefined && (", ")"])), t, (0, l.or)(this.invalid$data(), e)));
          }
        }, {
          key: "error",
          value: function value(e, t, n) {
            if (t) return this.setParams(t), this._error(e, n), void this.setParams({});
            this._error(e, n);
          }
        }, {
          key: "_error",
          value: function value(e, t) {
            (e ? v.reportExtraError : v.reportError)(this, this.def.error, t);
          }
        }, {
          key: "$dataError",
          value: function value() {
            (0, v.reportError)(this, this.def.$dataError || v.keyword$DataError);
          }
        }, {
          key: "reset",
          value: function value() {
            if (void 0 === this.errsCount) throw new Error('add "trackErrors" to keyword definition');
            (0, v.resetErrorsCount)(this.gen, this.errsCount);
          }
        }, {
          key: "ok",
          value: function value(e) {
            this.allErrors || this.gen.if(e);
          }
        }, {
          key: "setParams",
          value: function value(e, t) {
            t ? Object.assign(this.params, e) : this.params = e;
          }
        }, {
          key: "block$data",
          value: function value(e, t) {
            var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : l.nil;
            this.gen.block(function () {
              n.check$data(e, r), t();
            });
          }
        }, {
          key: "check$data",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : l.nil,
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.nil;
            if (this.$data) {
              var n = this.gen,
                r = this.schemaCode,
                i = this.schemaType,
                o = this.def;
              n.if((0, l.or)(l._(xt || (xt = pi(["", " === undefined"])), r), t)), e !== l.nil && n.assign(e, !0), (i.length || o.validateSchema) && (n.elseIf(this.invalid$data()), this.$dataError(), e !== l.nil && n.assign(e, !1)), n.else();
            }
          }
        }, {
          key: "invalid$data",
          value: function value() {
            var e = this.gen,
              t = this.schemaCode,
              n = this.schemaType,
              r = this.def,
              i = this.it;
            return (0, l.or)(function () {
              if (n.length) {
                if (!(t instanceof l.Name)) throw new Error("ajv implementation error");
                var e = Array.isArray(n) ? n : [n];
                return l._(jt || (jt = pi(["", ""])), (0, a.checkDataTypes)(e, t, i.opts.strictNumbers, a.DataType.Wrong));
              }
              return l.nil;
            }(), function () {
              if (r.validateSchema) {
                var n = e.scopeValue("validate$data", {
                  ref: r.validateSchema
                });
                return l._(St || (St = pi(["!", "(", ")"])), n, t);
              }
              return l.nil;
            }());
          }
        }, {
          key: "subschema",
          value: function value(e, t) {
            var n = (0, c.getSubschema)(this.it, e);
            (0, c.extendSubschemaData)(n, this.it, e), (0, c.extendSubschemaMode)(n, e);
            var r = Pi(Pi(Pi({}, this.it), n), {}, {
              items: void 0,
              props: void 0
            });
            return g(r, t), r;
          }
        }, {
          key: "mergeEvaluated",
          value: function value(e, t) {
            var n = this.it,
              r = this.gen;
            n.opts.unevaluated && (!0 !== n.props && void 0 !== e.props && (n.props = d.mergeEvaluated.props(r, e.props, n.props, t)), !0 !== n.items && void 0 !== e.items && (n.items = d.mergeEvaluated.items(r, e.items, n.items, t)));
          }
        }, {
          key: "mergeValidEvaluated",
          value: function value(e, t) {
            var n = this,
              r = this.it,
              i = this.gen;
            if (r.opts.unevaluated && (!0 !== r.props || !0 !== r.items)) return i.if(t, function () {
              return n.mergeEvaluated(e, l.Name);
            }), !0;
          }
        }]), e;
      }();
      function A(e, t, n, r) {
        var i = new O(e, n, t);
        "code" in n ? n.code(i, r) : i.$data && n.validate ? (0, u.funcKeywordCode)(i, n) : "macro" in n ? (0, u.macroKeywordCode)(i, n) : (n.compile || n.validate) && (0, u.funcKeywordCode)(i, n);
      }
      n.KeywordCxt = O;
      var E = /^\/(?:[^~]|~0|~1)*$/,
        P = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
      function M(e, t) {
        var n,
          r,
          i = t.dataLevel,
          o = t.dataNames,
          a = t.dataPathArr;
        if ("" === e) return f.default.rootData;
        if ("/" === e[0]) {
          if (!E.test(e)) throw new Error("Invalid JSON-pointer: ".concat(e));
          n = e, r = f.default.rootData;
        } else {
          var s = P.exec(e);
          if (!s) throw new Error("Invalid JSON-pointer: ".concat(e));
          var u = +s[1];
          if ("#" === (n = s[2])) {
            if (u >= i) throw new Error(m("property/index", u));
            return a[i - u];
          }
          if (u > i) throw new Error(m("data", u));
          if (r = o[i - u], !n) return r;
        }
        var c,
          h = r,
          v = bi(n.split("/"));
        try {
          for (v.s(); !(c = v.n()).done;) {
            var p = c.value;
            p && (r = l._(Ct || (Ct = pi(["", "", ""])), r, (0, l.getProperty)((0, d.unescapeJsonPointer)(p))), h = l._(_t || (_t = pi(["", " && ", ""])), h, r));
          }
        } catch (e) {
          v.e(e);
        } finally {
          v.f();
        }
        return h;
        function m(e, t) {
          return "Cannot access ".concat(e, " ").concat(t, " levels up, current level is ").concat(i);
        }
      }
      n.getData = M;
    }, {
      "../codegen": 2,
      "../errors": 4,
      "../names": 6,
      "../resolve": 8,
      "../util": 10,
      "./applicability": 11,
      "./boolSchema": 12,
      "./dataType": 13,
      "./defaults": 14,
      "./keyword": 16,
      "./subschema": 17
    }],
    16: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.validateKeywordUsage = n.validSchemaType = n.funcKeywordCode = n.macroKeywordCode = void 0;
      var r = e("../codegen"),
        i = e("../names"),
        o = e("../../vocabularies/code"),
        a = e("../errors");
      function s(e) {
        var t = e.gen,
          n = e.data,
          i = e.it;
        t.if(i.parentData, function () {
          return t.assign(n, r._($t || ($t = pi(["", "[", "]"])), i.parentData, i.parentDataProperty));
        });
      }
      function u(e, t, n) {
        if (void 0 === n) throw new Error('keyword "'.concat(t, '" failed to compile'));
        return e.scopeValue("keyword", "function" == typeof n ? {
          ref: n
        } : {
          ref: n,
          code: (0, r.stringify)(n)
        });
      }
      n.macroKeywordCode = function (e, t) {
        var n = e.gen,
          i = e.keyword,
          o = e.schema,
          a = e.parentSchema,
          s = e.it,
          c = t.macro.call(s.self, o, a, s),
          l = u(n, i, c);
        !1 !== s.opts.validateSchema && s.self.validateSchema(c, !0);
        var f = n.name("valid");
        e.subschema({
          schema: c,
          schemaPath: r.nil,
          errSchemaPath: "".concat(s.errSchemaPath, "/").concat(i),
          topSchemaRef: l,
          compositeRule: !0
        }, f), e.pass(f, function () {
          return e.error(!0);
        });
      }, n.funcKeywordCode = function (e, t) {
        var n,
          c = e.gen,
          l = e.keyword,
          f = e.schema,
          h = e.parentSchema,
          d = e.$data,
          v = e.it;
        !function (e, t) {
          var n = e.schemaEnv;
          if (t.async && !n.$async) throw new Error("async keyword in sync schema");
        }(v, t);
        var p = !d && t.compile ? t.compile.call(v.self, f, h, v) : t.validate,
          m = u(c, l, p),
          g = c.let("valid");
        function y() {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t.async ? r._(Ot || (Ot = pi(["await "]))) : r.nil;
          c.assign(g, r._(At || (At = pi(["", "", ""])), n, (0, o.callValidateCode)(e, m, v.opts.passContext ? i.default.this : i.default.self, !("compile" in t && !d || !1 === t.schema))), t.modifying);
        }
        function b(e) {
          var n;
          c.if((0, r.not)(null !== (n = t.valid) && void 0 !== n ? n : g), e);
        }
        e.block$data(g, function () {
          if (!1 === t.errors) y(), t.modifying && s(e), b(function () {
            return e.error();
          });else {
            var n = t.async ? function () {
              var e = c.let("ruleErrs", null);
              return c.try(function () {
                return y(r._(Et || (Et = pi(["await "]))));
              }, function (t) {
                return c.assign(g, !1).if(r._(Pt || (Pt = pi(["", " instanceof ", ""])), t, v.ValidationError), function () {
                  return c.assign(e, r._(Mt || (Mt = pi(["", ".errors"])), t));
                }, function () {
                  return c.throw(t);
                });
              }), e;
            }() : function () {
              var e = r._(It || (It = pi(["", ".errors"])), m);
              return c.assign(e, null), y(r.nil), e;
            }();
            t.modifying && s(e), b(function () {
              return function (e, t) {
                var n = e.gen;
                n.if(r._(Tt || (Tt = pi(["Array.isArray(", ")"])), t), function () {
                  n.assign(i.default.vErrors, r._(Nt || (Nt = pi(["", " === null ? ", " : ", ".concat(", ")"])), i.default.vErrors, t, i.default.vErrors, t)).assign(i.default.errors, r._(Rt || (Rt = pi(["", ".length"])), i.default.vErrors)), (0, a.extendErrors)(e);
                }, function () {
                  return e.error();
                });
              }(e, n);
            });
          }
        }), e.ok(null !== (n = t.valid) && void 0 !== n ? n : g);
      }, n.validSchemaType = function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return !t.length || t.some(function (t) {
          return "array" === t ? Array.isArray(e) : "object" === t ? e && "object" == Li(e) && !Array.isArray(e) : Li(e) == t || n && void 0 === e;
        });
      }, n.validateKeywordUsage = function (e, t, n) {
        var r = e.schema,
          i = e.opts,
          o = e.self,
          a = e.errSchemaPath;
        if (Array.isArray(t.keyword) ? !t.keyword.includes(n) : t.keyword !== n) throw new Error("ajv implementation error");
        var s = t.dependencies;
        if (null == s ? void 0 : s.some(function (e) {
          return !Object.prototype.hasOwnProperty.call(r, e);
        })) throw new Error("parent schema must have dependencies of ".concat(n, ": ").concat(s.join(",")));
        if (t.validateSchema && !t.validateSchema(r[n])) {
          var u = 'keyword "'.concat(n, '" value is invalid at path "').concat(a, '": ') + o.errorsText(t.validateSchema.errors);
          if ("log" !== i.validateSchema) throw new Error(u);
          o.logger.error(u);
        }
      };
    }, {
      "../../vocabularies/code": 42,
      "../codegen": 2,
      "../errors": 4,
      "../names": 6
    }],
    17: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.extendSubschemaMode = n.extendSubschemaData = n.getSubschema = void 0;
      var r = e("../codegen"),
        i = e("../util");
      n.getSubschema = function (e, t) {
        var n = t.keyword,
          o = t.schemaProp,
          a = t.schema,
          s = t.schemaPath,
          u = t.errSchemaPath,
          c = t.topSchemaRef;
        if (void 0 !== n && void 0 !== a) throw new Error('both "keyword" and "schema" passed, only one allowed');
        if (void 0 !== n) {
          var l = e.schema[n];
          return void 0 === o ? {
            schema: l,
            schemaPath: r._(Dt || (Dt = pi(["", "", ""])), e.schemaPath, (0, r.getProperty)(n)),
            errSchemaPath: "".concat(e.errSchemaPath, "/").concat(n)
          } : {
            schema: l[o],
            schemaPath: r._(zt || (zt = pi(["", "", "", ""])), e.schemaPath, (0, r.getProperty)(n), (0, r.getProperty)(o)),
            errSchemaPath: "".concat(e.errSchemaPath, "/").concat(n, "/").concat((0, i.escapeFragment)(o))
          };
        }
        if (void 0 !== a) {
          if (void 0 === s || void 0 === u || void 0 === c) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
          return {
            schema: a,
            schemaPath: s,
            topSchemaRef: c,
            errSchemaPath: u
          };
        }
        throw new Error('either "keyword" or "schema" must be passed');
      }, n.extendSubschemaData = function (e, t, n) {
        var o = n.dataProp,
          a = n.dataPropType,
          s = n.data,
          u = n.dataTypes,
          c = n.propertyName;
        if (void 0 !== s && void 0 !== o) throw new Error('both "data" and "dataProp" passed, only one allowed');
        var l = t.gen;
        if (void 0 !== o) {
          var f = t.errorPath,
            h = t.dataPathArr,
            d = t.opts;
          v(l.let("data", r._(Lt || (Lt = pi(["", "", ""])), t.data, (0, r.getProperty)(o)), !0)), e.errorPath = r.str(Bt || (Bt = pi(["", "", ""])), f, (0, i.getErrorPath)(o, a, d.jsPropertySyntax)), e.parentDataProperty = r._(qt || (qt = pi(["", ""])), o), e.dataPathArr = [].concat(Ii(h), [e.parentDataProperty]);
        }
        function v(n) {
          e.data = n, e.dataLevel = t.dataLevel + 1, e.dataTypes = [], t.definedProperties = new Set(), e.parentData = t.data, e.dataNames = [].concat(Ii(t.dataNames), [n]);
        }
        void 0 !== s && (v(s instanceof r.Name ? s : l.let("data", s, !0)), void 0 !== c && (e.propertyName = c)), u && (e.dataTypes = u);
      }, n.extendSubschemaMode = function (e, t) {
        var n = t.jtdDiscriminator,
          r = t.jtdMetadata,
          i = t.compositeRule,
          o = t.createErrors,
          a = t.allErrors;
        void 0 !== i && (e.compositeRule = i), void 0 !== o && (e.createErrors = o), void 0 !== a && (e.allErrors = a), e.jtdDiscriminator = n, e.jtdMetadata = r;
      };
    }, {
      "../codegen": 2,
      "../util": 10
    }],
    18: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.CodeGen = n.Name = n.nil = n.stringify = n.str = n._ = n.KeywordCxt = void 0;
      var r = e("./compile/validate");
      Object.defineProperty(n, "KeywordCxt", {
        enumerable: !0,
        get: function get() {
          return r.KeywordCxt;
        }
      });
      var i = e("./compile/codegen");
      Object.defineProperty(n, "_", {
        enumerable: !0,
        get: function get() {
          return i._;
        }
      }), Object.defineProperty(n, "str", {
        enumerable: !0,
        get: function get() {
          return i.str;
        }
      }), Object.defineProperty(n, "stringify", {
        enumerable: !0,
        get: function get() {
          return i.stringify;
        }
      }), Object.defineProperty(n, "nil", {
        enumerable: !0,
        get: function get() {
          return i.nil;
        }
      }), Object.defineProperty(n, "Name", {
        enumerable: !0,
        get: function get() {
          return i.Name;
        }
      }), Object.defineProperty(n, "CodeGen", {
        enumerable: !0,
        get: function get() {
          return i.CodeGen;
        }
      });
      var o = e("./runtime/validation_error"),
        a = e("./compile/ref_error"),
        s = e("./compile/rules"),
        u = e("./compile"),
        c = e("./compile/codegen"),
        l = e("./compile/resolve"),
        f = e("./compile/validate/dataType"),
        h = e("./compile/util"),
        d = e("./refs/data.json"),
        v = e("./runtime/uri"),
        p = function p(e, t) {
          return new RegExp(e, t);
        };
      p.code = "new RegExp";
      var m = ["removeAdditional", "useDefaults", "coerceTypes"],
        g = new Set(["validate", "serialize", "parse", "wrapper", "root", "schema", "keyword", "pattern", "formats", "validate$data", "func", "obj", "Error"]),
        y = {
          errorDataPath: "",
          format: "`validateFormats: false` can be used instead.",
          nullable: '"nullable" keyword is supported by default.',
          jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
          extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
          missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
          processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
          sourceCode: "Use option `code: {source: true}`",
          strictDefaults: "It is default now, see option `strict`.",
          strictKeywords: "It is default now, see option `strict`.",
          uniqueItems: '"uniqueItems" keyword is always validated.',
          unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
          cache: "Map is used as cache, schema object as key.",
          serialize: "Map is used as cache, schema object as key.",
          ajvErrors: "It is default now."
        },
        b = {
          ignoreKeywordsWithRef: "",
          jsPropertySyntax: "",
          unicode: '"minLength"/"maxLength" account for unicode characters by default.'
        };
      function k(e) {
        var t,
          n,
          r,
          i,
          o,
          a,
          s,
          u,
          c,
          l,
          f,
          h,
          d,
          m,
          g,
          y,
          b,
          k,
          w,
          x,
          j,
          S,
          C,
          _,
          $,
          O = e.strict,
          A = null === (t = e.code) || void 0 === t ? void 0 : t.optimize,
          E = !0 === A || void 0 === A ? 1 : A || 0,
          P = null !== (r = null === (n = e.code) || void 0 === n ? void 0 : n.regExp) && void 0 !== r ? r : p,
          M = null !== (i = e.uriResolver) && void 0 !== i ? i : v.default;
        return {
          strictSchema: null === (a = null !== (o = e.strictSchema) && void 0 !== o ? o : O) || void 0 === a || a,
          strictNumbers: null === (u = null !== (s = e.strictNumbers) && void 0 !== s ? s : O) || void 0 === u || u,
          strictTypes: null !== (l = null !== (c = e.strictTypes) && void 0 !== c ? c : O) && void 0 !== l ? l : "log",
          strictTuples: null !== (h = null !== (f = e.strictTuples) && void 0 !== f ? f : O) && void 0 !== h ? h : "log",
          strictRequired: null !== (m = null !== (d = e.strictRequired) && void 0 !== d ? d : O) && void 0 !== m && m,
          code: e.code ? Pi(Pi({}, e.code), {}, {
            optimize: E,
            regExp: P
          }) : {
            optimize: E,
            regExp: P
          },
          loopRequired: null !== (g = e.loopRequired) && void 0 !== g ? g : 200,
          loopEnum: null !== (y = e.loopEnum) && void 0 !== y ? y : 200,
          meta: null === (b = e.meta) || void 0 === b || b,
          messages: null === (k = e.messages) || void 0 === k || k,
          inlineRefs: null === (w = e.inlineRefs) || void 0 === w || w,
          schemaId: null !== (x = e.schemaId) && void 0 !== x ? x : "$id",
          addUsedSchema: null === (j = e.addUsedSchema) || void 0 === j || j,
          validateSchema: null === (S = e.validateSchema) || void 0 === S || S,
          validateFormats: null === (C = e.validateFormats) || void 0 === C || C,
          unicodeRegExp: null === (_ = e.unicodeRegExp) || void 0 === _ || _,
          int32range: null === ($ = e.int32range) || void 0 === $ || $,
          uriResolver: M
        };
      }
      var w = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          Ri(this, e), this.schemas = {}, this.refs = {}, this.formats = {}, this._compilations = new Set(), this._loading = {}, this._cache = new Map(), t = this.opts = Pi(Pi({}, t), k(t));
          var n = this.opts.code,
            r = n.es5,
            i = n.lines;
          this.scope = new c.ValueScope({
            scope: {},
            prefixes: g,
            es5: r,
            lines: i
          }), this.logger = function (e) {
            if (!1 === e) return O;
            if (void 0 === e) return console;
            if (e.log && e.warn && e.error) return e;
            throw new Error("logger must implement log, warn and error methods");
          }(t.logger);
          var o = t.validateFormats;
          t.validateFormats = !1, this.RULES = (0, s.getRules)(), x.call(this, y, t, "NOT SUPPORTED"), x.call(this, b, t, "DEPRECATED", "warn"), this._metaOpts = $.call(this), t.formats && C.call(this), this._addVocabularies(), this._addDefaultMetaSchema(), t.keywords && _.call(this, t.keywords), "object" == Li(t.meta) && this.addMetaSchema(t.meta), S.call(this), t.validateFormats = o;
        }
        return zi(e, [{
          key: "_addVocabularies",
          value: function value() {
            this.addKeyword("$async");
          }
        }, {
          key: "_addDefaultMetaSchema",
          value: function value() {
            var e = this.opts,
              t = e.$data,
              n = e.meta,
              r = e.schemaId,
              i = d;
            "id" === r && ((i = Pi({}, d)).id = i.$id, delete i.$id), n && t && this.addMetaSchema(i, i[r], !1);
          }
        }, {
          key: "defaultMeta",
          value: function value() {
            var e = this.opts,
              t = e.meta,
              n = e.schemaId;
            return this.opts.defaultMeta = "object" == Li(t) ? t[n] || t : void 0;
          }
        }, {
          key: "validate",
          value: function value(e, t) {
            var n;
            if ("string" == typeof e) {
              if (!(n = this.getSchema(e))) throw new Error('no schema with key or ref "'.concat(e, '"'));
            } else n = this.compile(e);
            var r = n(t);
            return "$async" in n || (this.errors = n.errors), r;
          }
        }, {
          key: "compile",
          value: function value(e, t) {
            var n = this._addSchema(e, t);
            return n.validate || this._compileSchemaEnv(n);
          }
        }, {
          key: "compileAsync",
          value: function value(e, t) {
            if ("function" != typeof this.opts.loadSchema) throw new Error("options.loadSchema should be a function");
            var n = this.opts.loadSchema;
            return r.call(this, e, t);
            function r(e, t) {
              return i.apply(this, arguments);
            }
            function i() {
              return (i = yi(mi().mark(function e(t, n) {
                var r;
                return mi().wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        return e.next = 2, o.call(this, t.$schema);
                      case 2:
                        return r = this._addSchema(t, n), e.abrupt("return", r.validate || u.call(this, r));
                      case 4:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, this);
              }))).apply(this, arguments);
            }
            function o(e) {
              return s.apply(this, arguments);
            }
            function s() {
              return (s = yi(mi().mark(function e(t) {
                return mi().wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        if (e.t0 = t && !this.getSchema(t), !e.t0) {
                          e.next = 4;
                          break;
                        }
                        return e.next = 4, r.call(this, {
                          $ref: t
                        }, !0);
                      case 4:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, this);
              }))).apply(this, arguments);
            }
            function u(e) {
              return c.apply(this, arguments);
            }
            function c() {
              return (c = yi(mi().mark(function e(t) {
                return mi().wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        return e.prev = 0, e.abrupt("return", this._compileSchemaEnv(t));
                      case 4:
                        if (e.prev = 4, e.t0 = e.catch(0), e.t0 instanceof a.default) {
                          e.next = 8;
                          break;
                        }
                        throw e.t0;
                      case 8:
                        return l.call(this, e.t0), e.next = 11, f.call(this, e.t0.missingSchema);
                      case 11:
                        return e.abrupt("return", u.call(this, t));
                      case 12:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, this, [[0, 4]]);
              }))).apply(this, arguments);
            }
            function l(e) {
              var t = e.missingSchema,
                n = e.missingRef;
              if (this.refs[t]) throw new Error("AnySchema ".concat(t, " is loaded but ").concat(n, " cannot be resolved"));
            }
            function f(e) {
              return h.apply(this, arguments);
            }
            function h() {
              return (h = yi(mi().mark(function e(n) {
                var r;
                return mi().wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        return e.next = 2, d.call(this, n);
                      case 2:
                        if (r = e.sent, e.t0 = this.refs[n], e.t0) {
                          e.next = 7;
                          break;
                        }
                        return e.next = 7, o.call(this, r.$schema);
                      case 7:
                        this.refs[n] || this.addSchema(r, n, t);
                      case 8:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, this);
              }))).apply(this, arguments);
            }
            function d(e) {
              return v.apply(this, arguments);
            }
            function v() {
              return (v = yi(mi().mark(function e(t) {
                var r;
                return mi().wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        if (!(r = this._loading[t])) {
                          e.next = 3;
                          break;
                        }
                        return e.abrupt("return", r);
                      case 3:
                        return e.prev = 3, e.next = 6, this._loading[t] = n(t);
                      case 6:
                        return e.abrupt("return", e.sent);
                      case 7:
                        return e.prev = 7, delete this._loading[t], e.finish(7);
                      case 10:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, this, [[3,, 7, 10]]);
              }))).apply(this, arguments);
            }
          }
        }, {
          key: "addSchema",
          value: function value(e, t, n) {
            var r,
              i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.opts.validateSchema;
            if (Array.isArray(e)) {
              var o,
                a = bi(e);
              try {
                for (a.s(); !(o = a.n()).done;) {
                  var s = o.value;
                  this.addSchema(s, void 0, n, i);
                }
              } catch (e) {
                a.e(e);
              } finally {
                a.f();
              }
              return this;
            }
            if ("object" == Li(e)) {
              var u = this.opts.schemaId;
              if (void 0 !== (r = e[u]) && "string" != typeof r) throw new Error("schema ".concat(u, " must be string"));
            }
            return t = (0, l.normalizeId)(t || r), this._checkUnique(t), this.schemas[t] = this._addSchema(e, n, t, i, !0), this;
          }
        }, {
          key: "addMetaSchema",
          value: function value(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.opts.validateSchema;
            return this.addSchema(e, t, !0, n), this;
          }
        }, {
          key: "validateSchema",
          value: function value(e, t) {
            if ("boolean" == typeof e) return !0;
            var n;
            if (void 0 !== (n = e.$schema) && "string" != typeof n) throw new Error("$schema must be a string");
            if (!(n = n || this.opts.defaultMeta || this.defaultMeta())) return this.logger.warn("meta-schema not available"), this.errors = null, !0;
            var r = this.validate(n, e);
            if (!r && t) {
              var i = "schema is invalid: " + this.errorsText();
              if ("log" !== this.opts.validateSchema) throw new Error(i);
              this.logger.error(i);
            }
            return r;
          }
        }, {
          key: "getSchema",
          value: function value(e) {
            for (var t; "string" == typeof (t = j.call(this, e));) {
              e = t;
            }
            if (void 0 === t) {
              var n = this.opts.schemaId,
                r = new u.SchemaEnv({
                  schema: {},
                  schemaId: n
                });
              if (!(t = u.resolveSchema.call(this, r, e))) return;
              this.refs[e] = t;
            }
            return t.validate || this._compileSchemaEnv(t);
          }
        }, {
          key: "removeSchema",
          value: function value(e) {
            if (e instanceof RegExp) return this._removeAllSchemas(this.schemas, e), this._removeAllSchemas(this.refs, e), this;
            switch (Li(e)) {
              case "undefined":
                return this._removeAllSchemas(this.schemas), this._removeAllSchemas(this.refs), this._cache.clear(), this;
              case "string":
                var t = j.call(this, e);
                return "object" == Li(t) && this._cache.delete(t.schema), delete this.schemas[e], delete this.refs[e], this;
              case "object":
                this._cache.delete(e);
                var n = e[this.opts.schemaId];
                return n && (n = (0, l.normalizeId)(n), delete this.schemas[n], delete this.refs[n]), this;
              default:
                throw new Error("ajv.removeSchema: invalid parameter");
            }
          }
        }, {
          key: "addVocabulary",
          value: function value(e) {
            var t,
              n = bi(e);
            try {
              for (n.s(); !(t = n.n()).done;) {
                var r = t.value;
                this.addKeyword(r);
              }
            } catch (e) {
              n.e(e);
            } finally {
              n.f();
            }
            return this;
          }
        }, {
          key: "addKeyword",
          value: function value(e, t) {
            var n,
              r = this;
            if ("string" == typeof e) n = e, "object" == Li(t) && (this.logger.warn("these parameters are deprecated, see docs for addKeyword"), t.keyword = n);else {
              if ("object" != Li(e) || void 0 !== t) throw new Error("invalid addKeywords parameters");
              if (n = (t = e).keyword, Array.isArray(n) && !n.length) throw new Error("addKeywords: keyword must be string or non-empty array");
            }
            if (E.call(this, n, t), !t) return (0, h.eachItem)(n, function (e) {
              return P.call(r, e);
            }), this;
            I.call(this, t);
            var i = Pi(Pi({}, t), {}, {
              type: (0, f.getJSONTypes)(t.type),
              schemaType: (0, f.getJSONTypes)(t.schemaType)
            });
            return (0, h.eachItem)(n, 0 === i.type.length ? function (e) {
              return P.call(r, e, i);
            } : function (e) {
              return i.type.forEach(function (t) {
                return P.call(r, e, i, t);
              });
            }), this;
          }
        }, {
          key: "getKeyword",
          value: function value(e) {
            var t = this.RULES.all[e];
            return "object" == Li(t) ? t.definition : !!t;
          }
        }, {
          key: "removeKeyword",
          value: function value(e) {
            var t = this.RULES;
            delete t.keywords[e], delete t.all[e];
            var n,
              r = bi(t.rules);
            try {
              for (r.s(); !(n = r.n()).done;) {
                var i = n.value,
                  o = i.rules.findIndex(function (t) {
                    return t.keyword === e;
                  });
                o >= 0 && i.rules.splice(o, 1);
              }
            } catch (e) {
              r.e(e);
            } finally {
              r.f();
            }
            return this;
          }
        }, {
          key: "addFormat",
          value: function value(e, t) {
            return "string" == typeof t && (t = new RegExp(t)), this.formats[e] = t, this;
          }
        }, {
          key: "errorsText",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.errors,
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = t.separator,
              r = void 0 === n ? ", " : n,
              i = t.dataVar,
              o = void 0 === i ? "data" : i;
            return e && 0 !== e.length ? e.map(function (e) {
              return "".concat(o).concat(e.instancePath, " ").concat(e.message);
            }).reduce(function (e, t) {
              return e + r + t;
            }) : "No errors";
          }
        }, {
          key: "$dataMetaSchema",
          value: function value(e, t) {
            var n = this.RULES.all;
            e = JSON.parse(JSON.stringify(e));
            var r,
              i = bi(t);
            try {
              for (i.s(); !(r = i.n()).done;) {
                var o,
                  a = r.value.split("/").slice(1),
                  s = e,
                  u = bi(a);
                try {
                  for (u.s(); !(o = u.n()).done;) {
                    s = s[o.value];
                  }
                } catch (e) {
                  u.e(e);
                } finally {
                  u.f();
                }
                for (var c in n) {
                  var l = n[c];
                  if ("object" == Li(l)) {
                    var f = l.definition.$data,
                      h = s[c];
                    f && h && (s[c] = N(h));
                  }
                }
              }
            } catch (e) {
              i.e(e);
            } finally {
              i.f();
            }
            return e;
          }
        }, {
          key: "_removeAllSchemas",
          value: function value(e, t) {
            for (var n in e) {
              var r = e[n];
              t && !t.test(n) || ("string" == typeof r ? delete e[n] : r && !r.meta && (this._cache.delete(r.schema), delete e[n]));
            }
          }
        }, {
          key: "_addSchema",
          value: function value(e, t, n) {
            var r,
              i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.opts.validateSchema,
              o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.opts.addUsedSchema,
              a = this.opts.schemaId;
            if ("object" == Li(e)) r = e[a];else {
              if (this.opts.jtd) throw new Error("schema must be object");
              if ("boolean" != typeof e) throw new Error("schema must be object or boolean");
            }
            var s = this._cache.get(e);
            if (void 0 !== s) return s;
            n = (0, l.normalizeId)(r || n);
            var c = l.getSchemaRefs.call(this, e, n);
            return s = new u.SchemaEnv({
              schema: e,
              schemaId: a,
              meta: t,
              baseId: n,
              localRefs: c
            }), this._cache.set(s.schema, s), o && !n.startsWith("#") && (n && this._checkUnique(n), this.refs[n] = s), i && this.validateSchema(e, !0), s;
          }
        }, {
          key: "_checkUnique",
          value: function value(e) {
            if (this.schemas[e] || this.refs[e]) throw new Error('schema with key or id "'.concat(e, '" already exists'));
          }
        }, {
          key: "_compileSchemaEnv",
          value: function value(e) {
            if (e.meta ? this._compileMetaSchema(e) : u.compileSchema.call(this, e), !e.validate) throw new Error("ajv implementation error");
            return e.validate;
          }
        }, {
          key: "_compileMetaSchema",
          value: function value(e) {
            var t = this.opts;
            this.opts = this._metaOpts;
            try {
              u.compileSchema.call(this, e);
            } finally {
              this.opts = t;
            }
          }
        }]), e;
      }();
      function x(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "error";
        for (var i in e) {
          var o = i;
          o in t && this.logger[r]("".concat(n, ": option ").concat(i, ". ").concat(e[o]));
        }
      }
      function j(e) {
        return e = (0, l.normalizeId)(e), this.schemas[e] || this.refs[e];
      }
      function S() {
        var e = this.opts.schemas;
        if (e) if (Array.isArray(e)) this.addSchema(e);else for (var t in e) {
          this.addSchema(e[t], t);
        }
      }
      function C() {
        for (var e in this.opts.formats) {
          var t = this.opts.formats[e];
          t && this.addFormat(e, t);
        }
      }
      function _(e) {
        if (Array.isArray(e)) this.addVocabulary(e);else for (var t in this.logger.warn("keywords option as map is deprecated, pass array"), e) {
          var n = e[t];
          n.keyword || (n.keyword = t), this.addKeyword(n);
        }
      }
      function $() {
        var e,
          t = Pi({}, this.opts),
          n = bi(m);
        try {
          for (n.s(); !(e = n.n()).done;) {
            delete t[e.value];
          }
        } catch (e) {
          n.e(e);
        } finally {
          n.f();
        }
        return t;
      }
      n.default = w, w.ValidationError = o.default, w.MissingRefError = a.default;
      var O = {
          log: function log() {},
          warn: function warn() {},
          error: function error() {}
        },
        A = /^[a-z_$][a-z0-9_$:-]*$/i;
      function E(e, t) {
        var n = this.RULES;
        if ((0, h.eachItem)(e, function (e) {
          if (n.keywords[e]) throw new Error("Keyword ".concat(e, " is already defined"));
          if (!A.test(e)) throw new Error("Keyword ".concat(e, " has invalid name"));
        }), t && t.$data && !("code" in t) && !("validate" in t)) throw new Error('$data keyword must have "code" or "validate" function');
      }
      function P(e, t, n) {
        var r,
          i = this,
          o = null == t ? void 0 : t.post;
        if (n && o) throw new Error('keyword with "post" flag cannot have "type"');
        var a = this.RULES,
          s = o ? a.post : a.rules.find(function (e) {
            return e.type === n;
          });
        if (s || (s = {
          type: n,
          rules: []
        }, a.rules.push(s)), a.keywords[e] = !0, t) {
          var u = {
            keyword: e,
            definition: Pi(Pi({}, t), {}, {
              type: (0, f.getJSONTypes)(t.type),
              schemaType: (0, f.getJSONTypes)(t.schemaType)
            })
          };
          t.before ? M.call(this, s, u, t.before) : s.rules.push(u), a.all[e] = u, null === (r = t.implements) || void 0 === r || r.forEach(function (e) {
            return i.addKeyword(e);
          });
        }
      }
      function M(e, t, n) {
        var r = e.rules.findIndex(function (e) {
          return e.keyword === n;
        });
        r >= 0 ? e.rules.splice(r, 0, t) : (e.rules.push(t), this.logger.warn("rule ".concat(n, " is not defined")));
      }
      function I(e) {
        var t = e.metaSchema;
        void 0 !== t && (e.$data && this.opts.$data && (t = N(t)), e.validateSchema = this.compile(t, !0));
      }
      var T = {
        $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
      };
      function N(e) {
        return {
          anyOf: [e, T]
        };
      }
    }, {
      "./compile": 5,
      "./compile/codegen": 2,
      "./compile/ref_error": 7,
      "./compile/resolve": 8,
      "./compile/rules": 9,
      "./compile/util": 10,
      "./compile/validate": 15,
      "./compile/validate/dataType": 13,
      "./refs/data.json": 19,
      "./runtime/uri": 23,
      "./runtime/validation_error": 24
    }],
    19: [function (e, t, n) {
      t.exports = {
        $id: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#",
        description: "Meta-schema for $data reference (JSON AnySchema extension proposal)",
        type: "object",
        required: ["$data"],
        properties: {
          $data: {
            type: "string",
            anyOf: [{
              format: "relative-json-pointer"
            }, {
              format: "json-pointer"
            }]
          }
        },
        additionalProperties: !1
      };
    }, {}],
    20: [function (e, t, n) {
      t.exports = {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "http://json-schema.org/draft-07/schema#",
        title: "Core schema meta-schema",
        definitions: {
          schemaArray: {
            type: "array",
            minItems: 1,
            items: {
              $ref: "#"
            }
          },
          nonNegativeInteger: {
            type: "integer",
            minimum: 0
          },
          nonNegativeIntegerDefault0: {
            allOf: [{
              $ref: "#/definitions/nonNegativeInteger"
            }, {
              default: 0
            }]
          },
          simpleTypes: {
            enum: ["array", "boolean", "integer", "null", "number", "object", "string"]
          },
          stringArray: {
            type: "array",
            items: {
              type: "string"
            },
            uniqueItems: !0,
            default: []
          }
        },
        type: ["object", "boolean"],
        properties: {
          $id: {
            type: "string",
            format: "uri-reference"
          },
          $schema: {
            type: "string",
            format: "uri"
          },
          $ref: {
            type: "string",
            format: "uri-reference"
          },
          $comment: {
            type: "string"
          },
          title: {
            type: "string"
          },
          description: {
            type: "string"
          },
          default: !0,
          readOnly: {
            type: "boolean",
            default: !1
          },
          examples: {
            type: "array",
            items: !0
          },
          multipleOf: {
            type: "number",
            exclusiveMinimum: 0
          },
          maximum: {
            type: "number"
          },
          exclusiveMaximum: {
            type: "number"
          },
          minimum: {
            type: "number"
          },
          exclusiveMinimum: {
            type: "number"
          },
          maxLength: {
            $ref: "#/definitions/nonNegativeInteger"
          },
          minLength: {
            $ref: "#/definitions/nonNegativeIntegerDefault0"
          },
          pattern: {
            type: "string",
            format: "regex"
          },
          additionalItems: {
            $ref: "#"
          },
          items: {
            anyOf: [{
              $ref: "#"
            }, {
              $ref: "#/definitions/schemaArray"
            }],
            default: !0
          },
          maxItems: {
            $ref: "#/definitions/nonNegativeInteger"
          },
          minItems: {
            $ref: "#/definitions/nonNegativeIntegerDefault0"
          },
          uniqueItems: {
            type: "boolean",
            default: !1
          },
          contains: {
            $ref: "#"
          },
          maxProperties: {
            $ref: "#/definitions/nonNegativeInteger"
          },
          minProperties: {
            $ref: "#/definitions/nonNegativeIntegerDefault0"
          },
          required: {
            $ref: "#/definitions/stringArray"
          },
          additionalProperties: {
            $ref: "#"
          },
          definitions: {
            type: "object",
            additionalProperties: {
              $ref: "#"
            },
            default: {}
          },
          properties: {
            type: "object",
            additionalProperties: {
              $ref: "#"
            },
            default: {}
          },
          patternProperties: {
            type: "object",
            additionalProperties: {
              $ref: "#"
            },
            propertyNames: {
              format: "regex"
            },
            default: {}
          },
          dependencies: {
            type: "object",
            additionalProperties: {
              anyOf: [{
                $ref: "#"
              }, {
                $ref: "#/definitions/stringArray"
              }]
            }
          },
          propertyNames: {
            $ref: "#"
          },
          const: !0,
          enum: {
            type: "array",
            items: !0,
            minItems: 1,
            uniqueItems: !0
          },
          type: {
            anyOf: [{
              $ref: "#/definitions/simpleTypes"
            }, {
              type: "array",
              items: {
                $ref: "#/definitions/simpleTypes"
              },
              minItems: 1,
              uniqueItems: !0
            }]
          },
          format: {
            type: "string"
          },
          contentMediaType: {
            type: "string"
          },
          contentEncoding: {
            type: "string"
          },
          if: {
            $ref: "#"
          },
          then: {
            $ref: "#"
          },
          else: {
            $ref: "#"
          },
          allOf: {
            $ref: "#/definitions/schemaArray"
          },
          anyOf: {
            $ref: "#/definitions/schemaArray"
          },
          oneOf: {
            $ref: "#/definitions/schemaArray"
          },
          not: {
            $ref: "#"
          }
        },
        default: !0
      };
    }, {}],
    21: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("fast-deep-equal");
      r.code = 'require("ajv/dist/runtime/equal").default', n.default = r;
    }, {
      "fast-deep-equal": 63
    }],
    22: [function (e, t, n) {
      function r(e) {
        for (var t, n = e.length, r = 0, i = 0; i < n;) {
          r++, (t = e.charCodeAt(i++)) >= 55296 && t <= 56319 && i < n && 56320 == (64512 & (t = e.charCodeAt(i))) && i++;
        }
        return r;
      }
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.default = r, r.code = 'require("ajv/dist/runtime/ucs2length").default';
    }, {}],
    23: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("uri-js");
      r.code = 'require("ajv/dist/runtime/uri").default', n.default = r;
    }, {
      "uri-js": 65
    }],
    24: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = function (e) {
        ji(n, di(Error));
        var t = Ci(n);
        function n(e) {
          var r;
          return Ri(this, n), (r = t.call(this, "validation failed")).errors = e, r.ajv = r.validation = !0, r;
        }
        return zi(n);
      }();
      n.default = r;
    }, {}],
    25: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.validateAdditionalItems = void 0;
      var r = e("../../compile/codegen"),
        i = e("../../compile/util"),
        o = {
          keyword: "additionalItems",
          type: "array",
          schemaType: ["boolean", "object"],
          before: "uniqueItems",
          error: {
            message: function message(e) {
              var t = e.params.len;
              return r.str(Ft || (Ft = pi(["must NOT have more than ", " items"])), t);
            },
            params: function params(e) {
              var t = e.params.len;
              return r._(Vt || (Vt = pi(["{limit: ", "}"])), t);
            }
          },
          code: function code(e) {
            var t = e.parentSchema,
              n = e.it,
              r = t.items;
            Array.isArray(r) ? a(e, r) : (0, i.checkStrictMode)(n, '"additionalItems" is ignored when "items" is not an array of schemas');
          }
        };
      function a(e, t) {
        var n = e.gen,
          o = e.schema,
          a = e.data,
          s = e.keyword,
          u = e.it;
        u.items = !0;
        var c = n.const("len", r._(Ht || (Ht = pi(["", ".length"])), a));
        if (!1 === o) e.setParams({
          len: t.length
        }), e.pass(r._(Wt || (Wt = pi(["", " <= ", ""])), c, t.length));else if ("object" == Li(o) && !(0, i.alwaysValidSchema)(u, o)) {
          var l = n.var("valid", r._(Ut || (Ut = pi(["", " <= ", ""])), c, t.length));
          n.if((0, r.not)(l), function () {
            return function (o) {
              n.forRange("i", t.length, c, function (t) {
                e.subschema({
                  keyword: s,
                  dataProp: t,
                  dataPropType: i.Type.Num
                }, o), u.allErrors || n.if((0, r.not)(o), function () {
                  return n.break();
                });
              });
            }(l);
          }), e.ok(l);
        }
      }
      n.validateAdditionalItems = a, n.default = o;
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10
    }],
    26: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../code"),
        i = e("../../compile/codegen"),
        o = e("../../compile/names"),
        a = e("../../compile/util");
      n.default = {
        keyword: "additionalProperties",
        type: ["object"],
        schemaType: ["boolean", "object"],
        allowUndefined: !0,
        trackErrors: !0,
        error: {
          message: "must NOT have additional properties",
          params: function params(e) {
            var t = e.params;
            return i._(Jt || (Jt = pi(["{additionalProperty: ", "}"])), t.additionalProperty);
          }
        },
        code: function code(e) {
          var t = e.gen,
            n = e.schema,
            s = e.parentSchema,
            u = e.data,
            c = e.errsCount,
            l = e.it;
          if (!c) throw new Error("ajv implementation error");
          var f = l.allErrors,
            h = l.opts;
          if (l.props = !0, "all" === h.removeAdditional || !(0, a.alwaysValidSchema)(l, n)) {
            var d = (0, r.allSchemaProperties)(s.properties),
              v = (0, r.allSchemaProperties)(s.patternProperties);
            t.forIn("key", u, function (n) {
              d.length || v.length ? t.if(function (n) {
                var o;
                if (d.length > 8) {
                  var u = (0, a.schemaRefOrVal)(l, s.properties, "properties");
                  o = (0, r.isOwnProperty)(t, u, n);
                } else o = d.length ? i.or.apply(void 0, Ii(d.map(function (e) {
                  return i._(Gt || (Gt = pi(["", " === ", ""])), n, e);
                }))) : i.nil;
                return v.length && (o = i.or.apply(void 0, [o].concat(Ii(v.map(function (t) {
                  return i._(Qt || (Qt = pi(["", ".test(", ")"])), (0, r.usePattern)(e, t), n);
                }))))), (0, i.not)(o);
              }(n), function () {
                return m(n);
              }) : m(n);
            }), e.ok(i._(Yt || (Yt = pi(["", " === ", ""])), c, o.default.errors));
          }
          function p(e) {
            t.code(i._(Kt || (Kt = pi(["delete ", "[", "]"])), u, e));
          }
          function m(r) {
            if ("all" === h.removeAdditional || h.removeAdditional && !1 === n) p(r);else {
              if (!1 === n) return e.setParams({
                additionalProperty: r
              }), e.error(), void (f || t.break());
              if ("object" == Li(n) && !(0, a.alwaysValidSchema)(l, n)) {
                var o = t.name("valid");
                "failing" === h.removeAdditional ? (g(r, o, !1), t.if((0, i.not)(o), function () {
                  e.reset(), p(r);
                })) : (g(r, o), f || t.if((0, i.not)(o), function () {
                  return t.break();
                }));
              }
            }
          }
          function g(t, n, r) {
            var i = {
              keyword: "additionalProperties",
              dataProp: t,
              dataPropType: a.Type.Str
            };
            !1 === r && Object.assign(i, {
              compositeRule: !0,
              createErrors: !1,
              allErrors: !1
            }), e.subschema(i, n);
          }
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/names": 6,
      "../../compile/util": 10,
      "../code": 42
    }],
    27: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/util");
      n.default = {
        keyword: "allOf",
        schemaType: "array",
        code: function code(e) {
          var t = e.gen,
            n = e.schema,
            i = e.it;
          if (!Array.isArray(n)) throw new Error("ajv implementation error");
          var o = t.name("valid");
          n.forEach(function (t, n) {
            if (!(0, r.alwaysValidSchema)(i, t)) {
              var a = e.subschema({
                keyword: "allOf",
                schemaProp: n
              }, o);
              e.ok(o), e.mergeEvaluated(a);
            }
          });
        }
      };
    }, {
      "../../compile/util": 10
    }],
    28: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../code");
      n.default = {
        keyword: "anyOf",
        schemaType: "array",
        trackErrors: !0,
        code: r.validateUnion,
        error: {
          message: "must match a schema in anyOf"
        }
      };
    }, {
      "../code": 42
    }],
    29: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen"),
        i = e("../../compile/util");
      n.default = {
        keyword: "contains",
        type: "array",
        schemaType: ["object", "boolean"],
        before: "uniqueItems",
        trackErrors: !0,
        error: {
          message: function message(e) {
            var t = e.params,
              n = t.min,
              i = t.max;
            return void 0 === i ? r.str(Zt || (Zt = pi(["must contain at least ", " valid item(s)"])), n) : r.str(Xt || (Xt = pi(["must contain at least ", " and no more than ", " valid item(s)"])), n, i);
          },
          params: function params(e) {
            var t = e.params,
              n = t.min,
              i = t.max;
            return void 0 === i ? r._(en || (en = pi(["{minContains: ", "}"])), n) : r._(tn || (tn = pi(["{minContains: ", ", maxContains: ", "}"])), n, i);
          }
        },
        code: function code(e) {
          var t,
            n,
            o = e.gen,
            a = e.schema,
            s = e.parentSchema,
            u = e.data,
            c = e.it,
            l = s.minContains,
            f = s.maxContains;
          c.opts.next ? (t = void 0 === l ? 1 : l, n = f) : t = 1;
          var h = o.const("len", r._(nn || (nn = pi(["", ".length"])), u));
          if (e.setParams({
            min: t,
            max: n
          }), void 0 !== n || 0 !== t) {
            if (void 0 !== n && t > n) return (0, i.checkStrictMode)(c, '"minContains" > "maxContains" is always invalid'), void e.fail();
            if ((0, i.alwaysValidSchema)(c, a)) {
              var d = r._(rn || (rn = pi(["", " >= ", ""])), h, t);
              return void 0 !== n && (d = r._(on || (on = pi(["", " && ", " <= ", ""])), d, h, n)), void e.pass(d);
            }
            c.items = !0;
            var v = o.name("valid");
            void 0 === n && 1 === t ? m(v, function () {
              return o.if(v, function () {
                return o.break();
              });
            }) : 0 === t ? (o.let(v, !0), void 0 !== n && o.if(r._(ln || (ln = pi(["", ".length > 0"])), u), p)) : (o.let(v, !1), p()), e.result(v, function () {
              return e.reset();
            });
          } else (0, i.checkStrictMode)(c, '"minContains" == 0 without "maxContains": "contains" keyword ignored');
          function p() {
            var e = o.name("_valid"),
              i = o.let("count", 0);
            m(e, function () {
              return o.if(e, function () {
                return function (e) {
                  o.code(r._(an || (an = pi(["", "++"])), e)), void 0 === n ? o.if(r._(sn || (sn = pi(["", " >= ", ""])), e, t), function () {
                    return o.assign(v, !0).break();
                  }) : (o.if(r._(un || (un = pi(["", " > ", ""])), e, n), function () {
                    return o.assign(v, !1).break();
                  }), 1 === t ? o.assign(v, !0) : o.if(r._(cn || (cn = pi(["", " >= ", ""])), e, t), function () {
                    return o.assign(v, !0);
                  }));
                }(i);
              });
            });
          }
          function m(t, n) {
            o.forRange("i", 0, h, function (r) {
              e.subschema({
                keyword: "contains",
                dataProp: r,
                dataPropType: i.Type.Num,
                compositeRule: !0
              }, t), n();
            });
          }
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10
    }],
    30: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.validateSchemaDeps = n.validatePropertyDeps = n.error = void 0;
      var r = e("../../compile/codegen"),
        i = e("../../compile/util"),
        o = e("../code");
      n.error = {
        message: function message(e) {
          var t = e.params,
            n = t.property,
            i = t.depsCount,
            o = t.deps;
          return r.str(fn || (fn = pi(["must have ", " ", " when property ", " is present"])), 1 === i ? "property" : "properties", o, n);
        },
        params: function params(e) {
          var t = e.params,
            n = t.property,
            i = t.depsCount,
            o = t.deps,
            a = t.missingProperty;
          return r._(hn || (hn = pi(["{property: ", ",\n\t    missingProperty: ", ",\n\t    depsCount: ", ",\n\t    deps: ", "}"])), n, a, i, o);
        }
      };
      var a = {
        keyword: "dependencies",
        type: "object",
        schemaType: "object",
        error: n.error,
        code: function code(e) {
          var t = xi(function (e) {
              var t = e.schema,
                n = {},
                r = {};
              for (var i in t) {
                "__proto__" !== i && ((Array.isArray(t[i]) ? n : r)[i] = t[i]);
              }
              return [n, r];
            }(e), 2),
            n = t[0],
            r = t[1];
          s(e, n), u(e, r);
        }
      };
      function s(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.schema,
          n = e.gen,
          i = e.data,
          a = e.it;
        if (0 !== Object.keys(t).length) {
          var s = n.let("missing"),
            u = function u(_u2) {
              var c = t[_u2];
              if (0 === c.length) return "continue";
              var l = (0, o.propertyInData)(n, i, _u2, a.opts.ownProperties);
              e.setParams({
                property: _u2,
                depsCount: c.length,
                deps: c.join(", ")
              }), a.allErrors ? n.if(l, function () {
                var t,
                  n = bi(c);
                try {
                  for (n.s(); !(t = n.n()).done;) {
                    var r = t.value;
                    (0, o.checkReportMissingProp)(e, r);
                  }
                } catch (e) {
                  n.e(e);
                } finally {
                  n.f();
                }
              }) : (n.if(r._(dn || (dn = pi(["", " && (", ")"])), l, (0, o.checkMissingProp)(e, c, s))), (0, o.reportMissingProp)(e, s), n.else());
            };
          for (var c in t) {
            u(c);
          }
        }
      }
      function u(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.schema,
          n = e.gen,
          r = e.data,
          a = e.keyword,
          s = e.it,
          u = n.name("valid"),
          c = function c(_c22) {
            (0, i.alwaysValidSchema)(s, t[_c22]) || (n.if((0, o.propertyInData)(n, r, _c22, s.opts.ownProperties), function () {
              var t = e.subschema({
                keyword: a,
                schemaProp: _c22
              }, u);
              e.mergeValidEvaluated(t, u);
            }, function () {
              return n.var(u, !0);
            }), e.ok(u));
          };
        for (var l in t) {
          c(l);
        }
      }
      n.validatePropertyDeps = s, n.validateSchemaDeps = u, n.default = a;
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10,
      "../code": 42
    }],
    31: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen"),
        i = e("../../compile/util");
      function o(e, t) {
        var n = e.schema[t];
        return void 0 !== n && !(0, i.alwaysValidSchema)(e, n);
      }
      n.default = {
        keyword: "if",
        schemaType: ["object", "boolean"],
        trackErrors: !0,
        error: {
          message: function message(e) {
            var t = e.params;
            return r.str(vn || (vn = pi(['must match "', '" schema'])), t.ifClause);
          },
          params: function params(e) {
            var t = e.params;
            return r._(pn || (pn = pi(["{failingKeyword: ", "}"])), t.ifClause);
          }
        },
        code: function code(e) {
          var t = e.gen,
            n = e.parentSchema,
            a = e.it;
          void 0 === n.then && void 0 === n.else && (0, i.checkStrictMode)(a, '"if" without "then" and "else" is ignored');
          var s = o(a, "then"),
            u = o(a, "else");
          if (s || u) {
            var c = t.let("valid", !0),
              l = t.name("_valid");
            if (function () {
              var t = e.subschema({
                keyword: "if",
                compositeRule: !0,
                createErrors: !1,
                allErrors: !1
              }, l);
              e.mergeEvaluated(t);
            }(), e.reset(), s && u) {
              var f = t.let("ifClause");
              e.setParams({
                ifClause: f
              }), t.if(l, h("then", f), h("else", f));
            } else s ? t.if(l, h("then")) : t.if((0, r.not)(l), h("else"));
            e.pass(c, function () {
              return e.error(!0);
            });
          }
          function h(n, i) {
            return function () {
              var o = e.subschema({
                keyword: n
              }, l);
              t.assign(c, l), e.mergeValidEvaluated(o, c), i ? t.assign(i, r._(mn || (mn = pi(["", ""])), n)) : e.setParams({
                ifClause: n
              });
            };
          }
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10
    }],
    32: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("./additionalItems"),
        i = e("./prefixItems"),
        o = e("./items"),
        a = e("./items2020"),
        s = e("./contains"),
        u = e("./dependencies"),
        c = e("./propertyNames"),
        l = e("./additionalProperties"),
        f = e("./properties"),
        h = e("./patternProperties"),
        d = e("./not"),
        v = e("./anyOf"),
        p = e("./oneOf"),
        m = e("./allOf"),
        g = e("./if"),
        y = e("./thenElse");
      n.default = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
          t = [d.default, v.default, p.default, m.default, g.default, y.default, c.default, l.default, u.default, f.default, h.default];
        return e ? t.push(i.default, a.default) : t.push(r.default, o.default), t.push(s.default), t;
      };
    }, {
      "./additionalItems": 25,
      "./additionalProperties": 26,
      "./allOf": 27,
      "./anyOf": 28,
      "./contains": 29,
      "./dependencies": 30,
      "./if": 31,
      "./items": 33,
      "./items2020": 34,
      "./not": 35,
      "./oneOf": 36,
      "./patternProperties": 37,
      "./prefixItems": 38,
      "./properties": 39,
      "./propertyNames": 40,
      "./thenElse": 41
    }],
    33: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.validateTuple = void 0;
      var r = e("../../compile/codegen"),
        i = e("../../compile/util"),
        o = e("../code"),
        a = {
          keyword: "items",
          type: "array",
          schemaType: ["object", "array", "boolean"],
          before: "uniqueItems",
          code: function code(e) {
            var t = e.schema,
              n = e.it;
            if (Array.isArray(t)) return s(e, "additionalItems", t);
            n.items = !0, (0, i.alwaysValidSchema)(n, t) || e.ok((0, o.validateArray)(e));
          }
        };
      function s(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.schema,
          o = e.gen,
          a = e.parentSchema,
          s = e.data,
          u = e.keyword,
          c = e.it;
        !function (e) {
          var r = c.opts,
            o = c.errSchemaPath,
            a = n.length,
            s = a === e.minItems && (a === e.maxItems || !1 === e[t]);
          r.strictTuples && !s && (0, i.checkStrictMode)(c, '"'.concat(u, '" is ').concat(a, "-tuple, but minItems or maxItems/").concat(t, ' are not specified or different at path "').concat(o, '"'), r.strictTuples);
        }(a), c.opts.unevaluated && n.length && !0 !== c.items && (c.items = i.mergeEvaluated.items(o, n.length, c.items));
        var l = o.name("valid"),
          f = o.const("len", r._(gn || (gn = pi(["", ".length"])), s));
        n.forEach(function (t, n) {
          (0, i.alwaysValidSchema)(c, t) || (o.if(r._(yn || (yn = pi(["", " > ", ""])), f, n), function () {
            return e.subschema({
              keyword: u,
              schemaProp: n,
              dataProp: n
            }, l);
          }), e.ok(l));
        });
      }
      n.validateTuple = s, n.default = a;
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10,
      "../code": 42
    }],
    34: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen"),
        i = e("../../compile/util"),
        o = e("../code"),
        a = e("./additionalItems");
      n.default = {
        keyword: "items",
        type: "array",
        schemaType: ["object", "boolean"],
        before: "uniqueItems",
        error: {
          message: function message(e) {
            var t = e.params.len;
            return r.str(bn || (bn = pi(["must NOT have more than ", " items"])), t);
          },
          params: function params(e) {
            var t = e.params.len;
            return r._(kn || (kn = pi(["{limit: ", "}"])), t);
          }
        },
        code: function code(e) {
          var t = e.schema,
            n = e.parentSchema,
            r = e.it,
            s = n.prefixItems;
          r.items = !0, (0, i.alwaysValidSchema)(r, t) || (s ? (0, a.validateAdditionalItems)(e, s) : e.ok((0, o.validateArray)(e)));
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10,
      "../code": 42,
      "./additionalItems": 25
    }],
    35: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/util");
      n.default = {
        keyword: "not",
        schemaType: ["object", "boolean"],
        trackErrors: !0,
        code: function code(e) {
          var t = e.gen,
            n = e.schema,
            i = e.it;
          if ((0, r.alwaysValidSchema)(i, n)) e.fail();else {
            var o = t.name("valid");
            e.subschema({
              keyword: "not",
              compositeRule: !0,
              createErrors: !1,
              allErrors: !1
            }, o), e.failResult(o, function () {
              return e.reset();
            }, function () {
              return e.error();
            });
          }
        },
        error: {
          message: "must NOT be valid"
        }
      };
    }, {
      "../../compile/util": 10
    }],
    36: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen"),
        i = e("../../compile/util");
      n.default = {
        keyword: "oneOf",
        schemaType: "array",
        trackErrors: !0,
        error: {
          message: "must match exactly one schema in oneOf",
          params: function params(e) {
            var t = e.params;
            return r._(wn || (wn = pi(["{passingSchemas: ", "}"])), t.passing);
          }
        },
        code: function code(e) {
          var t = e.gen,
            n = e.schema,
            o = e.parentSchema,
            a = e.it;
          if (!Array.isArray(n)) throw new Error("ajv implementation error");
          if (!a.opts.discriminator || !o.discriminator) {
            var s = n,
              u = t.let("valid", !1),
              c = t.let("passing", null),
              l = t.name("_valid");
            e.setParams({
              passing: c
            }), t.block(function () {
              s.forEach(function (n, o) {
                var s;
                (0, i.alwaysValidSchema)(a, n) ? t.var(l, !0) : s = e.subschema({
                  keyword: "oneOf",
                  schemaProp: o,
                  compositeRule: !0
                }, l), o > 0 && t.if(r._(xn || (xn = pi(["", " && ", ""])), l, u)).assign(u, !1).assign(c, r._(jn || (jn = pi(["[", ", ", "]"])), c, o)).else(), t.if(l, function () {
                  t.assign(u, !0), t.assign(c, o), s && e.mergeEvaluated(s, r.Name);
                });
              });
            }), e.result(u, function () {
              return e.reset();
            }, function () {
              return e.error(!0);
            });
          }
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10
    }],
    37: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../code"),
        i = e("../../compile/codegen"),
        o = e("../../compile/util"),
        a = e("../../compile/util");
      n.default = {
        keyword: "patternProperties",
        type: "object",
        schemaType: "object",
        code: function code(e) {
          var t = e.gen,
            n = e.schema,
            s = e.data,
            u = e.parentSchema,
            c = e.it,
            l = c.opts,
            f = (0, r.allSchemaProperties)(n),
            h = f.filter(function (e) {
              return (0, o.alwaysValidSchema)(c, n[e]);
            });
          if (0 !== f.length && (h.length !== f.length || c.opts.unevaluated && !0 !== c.props)) {
            var d = l.strictSchema && !l.allowMatchingProperties && u.properties,
              v = t.name("valid");
            !0 === c.props || c.props instanceof i.Name || (c.props = (0, a.evaluatedPropsToName)(t, c.props));
            var p = c.props;
            !function () {
              var e,
                n = bi(f);
              try {
                for (n.s(); !(e = n.n()).done;) {
                  var r = e.value;
                  d && m(r), c.allErrors ? g(r) : (t.var(v, !0), g(r), t.if(v));
                }
              } catch (e) {
                n.e(e);
              } finally {
                n.f();
              }
            }();
          }
          function m(e) {
            for (var t in d) {
              new RegExp(e).test(t) && (0, o.checkStrictMode)(c, "property ".concat(t, " matches pattern ").concat(e, " (use allowMatchingProperties)"));
            }
          }
          function g(n) {
            t.forIn("key", s, function (o) {
              t.if(i._(Sn || (Sn = pi(["", ".test(", ")"])), (0, r.usePattern)(e, n), o), function () {
                var r = h.includes(n);
                r || e.subschema({
                  keyword: "patternProperties",
                  schemaProp: n,
                  dataProp: o,
                  dataPropType: a.Type.Str
                }, v), c.opts.unevaluated && !0 !== p ? t.assign(i._(Cn || (Cn = pi(["", "[", "]"])), p, o), !0) : r || c.allErrors || t.if((0, i.not)(v), function () {
                  return t.break();
                });
              });
            });
          }
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10,
      "../code": 42
    }],
    38: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("./items");
      n.default = {
        keyword: "prefixItems",
        type: "array",
        schemaType: ["array"],
        before: "uniqueItems",
        code: function code(e) {
          return (0, r.validateTuple)(e, "items");
        }
      };
    }, {
      "./items": 33
    }],
    39: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/validate"),
        i = e("../code"),
        o = e("../../compile/util"),
        a = e("./additionalProperties");
      n.default = {
        keyword: "properties",
        type: "object",
        schemaType: "object",
        code: function code(e) {
          var t = e.gen,
            n = e.schema,
            s = e.parentSchema,
            u = e.data,
            c = e.it;
          "all" === c.opts.removeAdditional && void 0 === s.additionalProperties && a.default.code(new r.KeywordCxt(c, a.default, "additionalProperties"));
          var l,
            f = (0, i.allSchemaProperties)(n),
            h = bi(f);
          try {
            for (h.s(); !(l = h.n()).done;) {
              var d = l.value;
              c.definedProperties.add(d);
            }
          } catch (e) {
            h.e(e);
          } finally {
            h.f();
          }
          c.opts.unevaluated && f.length && !0 !== c.props && (c.props = o.mergeEvaluated.props(t, (0, o.toHash)(f), c.props));
          var v = f.filter(function (e) {
            return !(0, o.alwaysValidSchema)(c, n[e]);
          });
          if (0 !== v.length) {
            var p,
              m = t.name("valid"),
              g = bi(v);
            try {
              for (g.s(); !(p = g.n()).done;) {
                var y = p.value;
                b(y) ? k(y) : (t.if((0, i.propertyInData)(t, u, y, c.opts.ownProperties)), k(y), c.allErrors || t.else().var(m, !0), t.endIf()), e.it.definedProperties.add(y), e.ok(m);
              }
            } catch (e) {
              g.e(e);
            } finally {
              g.f();
            }
          }
          function b(e) {
            return c.opts.useDefaults && !c.compositeRule && void 0 !== n[e].default;
          }
          function k(t) {
            e.subschema({
              keyword: "properties",
              schemaProp: t,
              dataProp: t
            }, m);
          }
        }
      };
    }, {
      "../../compile/util": 10,
      "../../compile/validate": 15,
      "../code": 42,
      "./additionalProperties": 26
    }],
    40: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen"),
        i = e("../../compile/util");
      n.default = {
        keyword: "propertyNames",
        type: "object",
        schemaType: ["object", "boolean"],
        error: {
          message: "property name must be valid",
          params: function params(e) {
            var t = e.params;
            return r._(_n || (_n = pi(["{propertyName: ", "}"])), t.propertyName);
          }
        },
        code: function code(e) {
          var t = e.gen,
            n = e.schema,
            o = e.data,
            a = e.it;
          if (!(0, i.alwaysValidSchema)(a, n)) {
            var s = t.name("valid");
            t.forIn("key", o, function (n) {
              e.setParams({
                propertyName: n
              }), e.subschema({
                keyword: "propertyNames",
                data: n,
                dataTypes: ["string"],
                propertyName: n,
                compositeRule: !0
              }, s), t.if((0, r.not)(s), function () {
                e.error(!0), a.allErrors || t.break();
              });
            }), e.ok(s);
          }
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10
    }],
    41: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/util");
      n.default = {
        keyword: ["then", "else"],
        schemaType: ["object", "boolean"],
        code: function code(e) {
          var t = e.keyword,
            n = e.parentSchema,
            i = e.it;
          void 0 === n.if && (0, r.checkStrictMode)(i, '"'.concat(t, '" without "if" is ignored'));
        }
      };
    }, {
      "../../compile/util": 10
    }],
    42: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.validateUnion = n.validateArray = n.usePattern = n.callValidateCode = n.schemaProperties = n.allSchemaProperties = n.noPropertyInData = n.propertyInData = n.isOwnProperty = n.hasPropFunc = n.reportMissingProp = n.checkMissingProp = n.checkReportMissingProp = void 0;
      var r = e("../compile/codegen"),
        i = e("../compile/util"),
        o = e("../compile/names"),
        a = e("../compile/util");
      function s(e) {
        return e.scopeValue("func", {
          ref: Object.prototype.hasOwnProperty,
          code: r._($n || ($n = pi(["Object.prototype.hasOwnProperty"])))
        });
      }
      function u(e, t, n) {
        return r._(On || (On = pi(["", ".call(", ", ", ")"])), s(e), t, n);
      }
      function c(e, t, n, i) {
        var o = r._(An || (An = pi(["", "", " === undefined"])), t, (0, r.getProperty)(n));
        return i ? (0, r.or)(o, (0, r.not)(u(e, t, n))) : o;
      }
      function l(e) {
        return e ? Object.keys(e).filter(function (e) {
          return "__proto__" !== e;
        }) : [];
      }
      n.checkReportMissingProp = function (e, t) {
        var n = e.gen,
          i = e.data,
          o = e.it;
        n.if(c(n, i, t, o.opts.ownProperties), function () {
          e.setParams({
            missingProperty: r._(En || (En = pi(["", ""])), t)
          }, !0), e.error();
        });
      }, n.checkMissingProp = function (e, t, n) {
        var i = e.gen,
          o = e.data,
          a = e.it.opts;
        return r.or.apply(void 0, Ii(t.map(function (e) {
          return (0, r.and)(c(i, o, e, a.ownProperties), r._(Pn || (Pn = pi(["", " = ", ""])), n, e));
        })));
      }, n.reportMissingProp = function (e, t) {
        e.setParams({
          missingProperty: t
        }, !0), e.error();
      }, n.hasPropFunc = s, n.isOwnProperty = u, n.propertyInData = function (e, t, n, i) {
        var o = r._(Mn || (Mn = pi(["", "", " !== undefined"])), t, (0, r.getProperty)(n));
        return i ? r._(In || (In = pi(["", " && ", ""])), o, u(e, t, n)) : o;
      }, n.noPropertyInData = c, n.allSchemaProperties = l, n.schemaProperties = function (e, t) {
        return l(t).filter(function (n) {
          return !(0, i.alwaysValidSchema)(e, t[n]);
        });
      }, n.callValidateCode = function (e, t, n, i) {
        var a = e.schemaCode,
          s = e.data,
          u = e.it,
          c = u.gen,
          l = u.topSchemaRef,
          f = u.schemaPath,
          h = u.errorPath,
          d = e.it,
          v = i ? r._(Tn || (Tn = pi(["", ", ", ", ", "", ""])), a, s, l, f) : s,
          p = [[o.default.instancePath, (0, r.strConcat)(o.default.instancePath, h)], [o.default.parentData, d.parentData], [o.default.parentDataProperty, d.parentDataProperty], [o.default.rootData, o.default.rootData]];
        d.opts.dynamicRef && p.push([o.default.dynamicAnchors, o.default.dynamicAnchors]);
        var m = r._(Nn || (Nn = pi(["", ", ", ""])), v, c.object.apply(c, p));
        return n !== r.nil ? r._(Rn || (Rn = pi(["", ".call(", ", ", ")"])), t, n, m) : r._(Dn || (Dn = pi(["", "(", ")"])), t, m);
      };
      var f = r._(zn || (zn = pi(["new RegExp"])));
      n.usePattern = function (e, t) {
        var n = e.gen,
          i = e.it.opts,
          o = i.unicodeRegExp ? "u" : "",
          s = i.code.regExp,
          u = s(t, o);
        return n.scopeValue("pattern", {
          key: u.toString(),
          ref: u,
          code: r._(Ln || (Ln = pi(["", "(", ", ", ")"])), "new RegExp" === s.code ? f : (0, a.useFunc)(n, s), t, o)
        });
      }, n.validateArray = function (e) {
        var t = e.gen,
          n = e.data,
          o = e.keyword,
          a = e.it,
          s = t.name("valid");
        if (a.allErrors) {
          var u = t.let("valid", !0);
          return c(function () {
            return t.assign(u, !1);
          }), u;
        }
        return t.var(s, !0), c(function () {
          return t.break();
        }), s;
        function c(a) {
          var u = t.const("len", r._(Bn || (Bn = pi(["", ".length"])), n));
          t.forRange("i", 0, u, function (n) {
            e.subschema({
              keyword: o,
              dataProp: n,
              dataPropType: i.Type.Num
            }, s), t.if((0, r.not)(s), a);
          });
        }
      }, n.validateUnion = function (e) {
        var t = e.gen,
          n = e.schema,
          o = e.keyword,
          a = e.it;
        if (!Array.isArray(n)) throw new Error("ajv implementation error");
        if (!n.some(function (e) {
          return (0, i.alwaysValidSchema)(a, e);
        }) || a.opts.unevaluated) {
          var s = t.let("valid", !1),
            u = t.name("_valid");
          t.block(function () {
            return n.forEach(function (n, i) {
              var a = e.subschema({
                keyword: o,
                schemaProp: i,
                compositeRule: !0
              }, u);
              t.assign(s, r._(qn || (qn = pi(["", " || ", ""])), s, u)), e.mergeValidEvaluated(a, u) || t.if((0, r.not)(s));
            });
          }), e.result(s, function () {
            return e.reset();
          }, function () {
            return e.error(!0);
          });
        }
      };
    }, {
      "../compile/codegen": 2,
      "../compile/names": 6,
      "../compile/util": 10
    }],
    43: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.default = {
        keyword: "id",
        code: function code() {
          throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
        }
      };
    }, {}],
    44: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("./id"),
        i = e("./ref");
      n.default = ["$schema", "$id", "$defs", "$vocabulary", {
        keyword: "$comment"
      }, "definitions", r.default, i.default];
    }, {
      "./id": 43,
      "./ref": 45
    }],
    45: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.callRef = n.getValidate = void 0;
      var r = e("../../compile/ref_error"),
        i = e("../code"),
        o = e("../../compile/codegen"),
        a = e("../../compile/names"),
        s = e("../../compile"),
        u = e("../../compile/util"),
        c = {
          keyword: "$ref",
          schemaType: "string",
          code: function code(e) {
            var t = e.gen,
              n = e.schema,
              i = e.it,
              a = i.baseId,
              u = i.schemaEnv,
              c = i.validateName,
              h = i.opts,
              d = i.self,
              v = u.root;
            if (("#" === n || "#/" === n) && a === v.baseId) return function () {
              if (u === v) return f(e, c, u, u.$async);
              var n = t.scopeValue("root", {
                ref: v
              });
              return f(e, o._(Fn || (Fn = pi(["", ".validate"])), n), v, v.$async);
            }();
            var p = s.resolveRef.call(d, v, a, n);
            if (void 0 === p) throw new r.default(i.opts.uriResolver, a, n);
            return p instanceof s.SchemaEnv ? function (t) {
              var n = l(e, t);
              f(e, n, t, t.$async);
            }(p) : function (r) {
              var i = t.scopeValue("schema", !0 === h.code.source ? {
                  ref: r,
                  code: (0, o.stringify)(r)
                } : {
                  ref: r
                }),
                a = t.name("valid"),
                s = e.subschema({
                  schema: r,
                  dataTypes: [],
                  schemaPath: o.nil,
                  topSchemaRef: i,
                  errSchemaPath: n
                }, a);
              e.mergeEvaluated(s), e.ok(a);
            }(p);
          }
        };
      function l(e, t) {
        var n = e.gen;
        return t.validate ? n.scopeValue("validate", {
          ref: t.validate
        }) : o._(Vn || (Vn = pi(["", ".validate"])), n.scopeValue("wrapper", {
          ref: t
        }));
      }
      function f(e, t, n, r) {
        var s = e.gen,
          c = e.it,
          l = c.allErrors,
          f = c.schemaEnv,
          h = c.opts.passContext ? a.default.this : o.nil;
        function d(e) {
          var t = o._(Hn || (Hn = pi(["", ".errors"])), e);
          s.assign(a.default.vErrors, o._(Wn || (Wn = pi(["", " === null ? ", " : ", ".concat(", ")"])), a.default.vErrors, t, a.default.vErrors, t)), s.assign(a.default.errors, o._(Un || (Un = pi(["", ".length"])), a.default.vErrors));
        }
        function v(e) {
          var t;
          if (c.opts.unevaluated) {
            var r = null === (t = null == n ? void 0 : n.validate) || void 0 === t ? void 0 : t.evaluated;
            if (!0 !== c.props) if (r && !r.dynamicProps) void 0 !== r.props && (c.props = u.mergeEvaluated.props(s, r.props, c.props));else {
              var i = s.var("props", o._(Jn || (Jn = pi(["", ".evaluated.props"])), e));
              c.props = u.mergeEvaluated.props(s, i, c.props, o.Name);
            }
            if (!0 !== c.items) if (r && !r.dynamicItems) void 0 !== r.items && (c.items = u.mergeEvaluated.items(s, r.items, c.items));else {
              var a = s.var("items", o._(Kn || (Kn = pi(["", ".evaluated.items"])), e));
              c.items = u.mergeEvaluated.items(s, a, c.items, o.Name);
            }
          }
        }
        r ? function () {
          if (!f.$async) throw new Error("async schema referenced by sync schema");
          var n = s.let("valid");
          s.try(function () {
            s.code(o._(Gn || (Gn = pi(["await ", ""])), (0, i.callValidateCode)(e, t, h))), v(t), l || s.assign(n, !0);
          }, function (e) {
            s.if(o._(Qn || (Qn = pi(["!(", " instanceof ", ")"])), e, c.ValidationError), function () {
              return s.throw(e);
            }), d(e), l || s.assign(n, !1);
          }), e.ok(n);
        }() : e.result((0, i.callValidateCode)(e, t, h), function () {
          return v(t);
        }, function () {
          return d(t);
        });
      }
      n.getValidate = l, n.callRef = f, n.default = c;
    }, {
      "../../compile": 5,
      "../../compile/codegen": 2,
      "../../compile/names": 6,
      "../../compile/ref_error": 7,
      "../../compile/util": 10,
      "../code": 42
    }],
    46: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen"),
        i = e("../discriminator/types"),
        o = e("../../compile"),
        a = e("../../compile/util");
      n.default = {
        keyword: "discriminator",
        type: "object",
        schemaType: "object",
        error: {
          message: function message(e) {
            var t = e.params,
              n = t.discrError,
              r = t.tagName;
            return n === i.DiscrError.Tag ? 'tag "'.concat(r, '" must be string') : 'value of tag "'.concat(r, '" must be in oneOf');
          },
          params: function params(e) {
            var t = e.params,
              n = t.discrError,
              i = t.tag,
              o = t.tagName;
            return r._(Yn || (Yn = pi(["{error: ", ", tag: ", ", tagValue: ", "}"])), n, o, i);
          }
        },
        code: function code(e) {
          var t = e.gen,
            n = e.data,
            s = e.schema,
            u = e.parentSchema,
            c = e.it,
            l = u.oneOf;
          if (!c.opts.discriminator) throw new Error("discriminator: requires discriminator option");
          var f = s.propertyName;
          if ("string" != typeof f) throw new Error("discriminator: requires propertyName");
          if (s.mapping) throw new Error("discriminator: mapping is not supported");
          if (!l) throw new Error("discriminator: requires oneOf keyword");
          var h = t.let("valid", !1),
            d = t.const("tag", r._(Zn || (Zn = pi(["", "", ""])), n, (0, r.getProperty)(f)));
          function v(n) {
            var i = t.name("valid"),
              o = e.subschema({
                keyword: "oneOf",
                schemaProp: n
              }, i);
            return e.mergeEvaluated(o, r.Name), i;
          }
          t.if(r._(Xn || (Xn = pi(["typeof ", ' == "string"'])), d), function () {
            return function () {
              var n = function () {
                for (var e, t = {}, n = d(u), r = !0, i = 0; i < l.length; i++) {
                  var s = l[i];
                  (null == s ? void 0 : s.$ref) && !(0, a.schemaHasRulesButRef)(s, c.self.RULES) && (s = o.resolveRef.call(c.self, c.schemaEnv.root, c.baseId, null == s ? void 0 : s.$ref)) instanceof o.SchemaEnv && (s = s.schema);
                  var h = null === (e = null == s ? void 0 : s.properties) || void 0 === e ? void 0 : e[f];
                  if ("object" != Li(h)) throw new Error('discriminator: oneOf subschemas (or referenced schemas) must have "properties/'.concat(f, '"'));
                  r = r && (n || d(s)), v(h, i);
                }
                if (!r) throw new Error('discriminator: "'.concat(f, '" must be required'));
                return t;
                function d(e) {
                  var t = e.required;
                  return Array.isArray(t) && t.includes(f);
                }
                function v(e, t) {
                  if (e.const) p(e.const, t);else {
                    if (!e.enum) throw new Error('discriminator: "properties/'.concat(f, '" must have "const" or "enum"'));
                    var n,
                      r = bi(e.enum);
                    try {
                      for (r.s(); !(n = r.n()).done;) {
                        p(n.value, t);
                      }
                    } catch (e) {
                      r.e(e);
                    } finally {
                      r.f();
                    }
                  }
                }
                function p(e, n) {
                  if ("string" != typeof e || e in t) throw new Error('discriminator: "'.concat(f, '" values must be unique strings'));
                  t[e] = n;
                }
              }();
              for (var s in t.if(!1), n) {
                t.elseIf(r._(er || (er = pi(["", " === ", ""])), d, s)), t.assign(h, v(n[s]));
              }
              t.else(), e.error(!1, {
                discrError: i.DiscrError.Mapping,
                tag: d,
                tagName: f
              }), t.endIf();
            }();
          }, function () {
            return e.error(!1, {
              discrError: i.DiscrError.Tag,
              tag: d,
              tagName: f
            });
          }), e.ok(h);
        }
      };
    }, {
      "../../compile": 5,
      "../../compile/codegen": 2,
      "../../compile/util": 10,
      "../discriminator/types": 47
    }],
    47: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.DiscrError = void 0, function (e) {
        e.Tag = "tag", e.Mapping = "mapping";
      }(n.DiscrError || (n.DiscrError = {}));
    }, {}],
    48: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("./core"),
        i = e("./validation"),
        o = e("./applicator"),
        a = e("./format"),
        s = e("./metadata"),
        u = [r.default, i.default, (0, o.default)(), a.default, s.metadataVocabulary, s.contentVocabulary];
      n.default = u;
    }, {
      "./applicator": 32,
      "./core": 44,
      "./format": 50,
      "./metadata": 51,
      "./validation": 54
    }],
    49: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen");
      n.default = {
        keyword: "format",
        type: ["number", "string"],
        schemaType: "string",
        $data: !0,
        error: {
          message: function message(e) {
            var t = e.schemaCode;
            return r.str(tr || (tr = pi(['must match format "', '"'])), t);
          },
          params: function params(e) {
            var t = e.schemaCode;
            return r._(nr || (nr = pi(["{format: ", "}"])), t);
          }
        },
        code: function code(e, t) {
          var n = e.gen,
            i = e.data,
            o = e.$data,
            a = e.schema,
            s = e.schemaCode,
            u = e.it,
            c = u.opts,
            l = u.errSchemaPath,
            f = u.schemaEnv,
            h = u.self;
          c.validateFormats && (o ? function () {
            var o = n.scopeValue("formats", {
                ref: h.formats,
                code: c.code.formats
              }),
              a = n.const("fDef", r._(rr || (rr = pi(["", "[", "]"])), o, s)),
              u = n.let("fType"),
              l = n.let("format");
            n.if(r._(ir || (ir = pi(["typeof ", ' == "object" && !(', " instanceof RegExp)"])), a, a), function () {
              return n.assign(u, r._(or || (or = pi(["", '.type || "string"'])), a)).assign(l, r._(ar || (ar = pi(["", ".validate"])), a));
            }, function () {
              return n.assign(u, r._(sr || (sr = pi(['"string"'])))).assign(l, a);
            }), e.fail$data((0, r.or)(!1 === c.strictSchema ? r.nil : r._(ur || (ur = pi(["", " && !", ""])), s, l), function () {
              var e = f.$async ? r._(cr || (cr = pi(["(", ".async ? await ", "(", ") : ", "(", "))"])), a, l, i, l, i) : r._(lr || (lr = pi(["", "(", ")"])), l, i),
                n = r._(fr || (fr = pi(["(typeof ", ' == "function" ? ', " : ", ".test(", "))"])), l, e, l, i);
              return r._(hr || (hr = pi(["", " && ", " !== true && ", " === ", " && !", ""])), l, l, u, t, n);
            }()));
          }() : function () {
            var o = h.formats[a];
            if (o) {
              if (!0 !== o) {
                var s = xi(function (e) {
                    var t = e instanceof RegExp ? (0, r.regexpCode)(e) : c.code.formats ? r._(dr || (dr = pi(["", "", ""])), c.code.formats, (0, r.getProperty)(a)) : void 0,
                      i = n.scopeValue("formats", {
                        key: a,
                        ref: e,
                        code: t
                      });
                    return "object" != Li(e) || e instanceof RegExp ? ["string", e, i] : [e.type || "string", e.validate, r._(vr || (vr = pi(["", ".validate"])), i)];
                  }(o), 3),
                  u = s[0],
                  d = s[1],
                  v = s[2];
                u === t && e.pass(function () {
                  if ("object" == Li(o) && !(o instanceof RegExp) && o.async) {
                    if (!f.$async) throw new Error("async format in sync schema");
                    return r._(pr || (pr = pi(["await ", "(", ")"])), v, i);
                  }
                  return "function" == typeof d ? r._(mr || (mr = pi(["", "(", ")"])), v, i) : r._(gr || (gr = pi(["", ".test(", ")"])), v, i);
                }());
              }
            } else !function () {
              if (!1 !== c.strictSchema) throw new Error(e());
              function e() {
                return 'unknown format "'.concat(a, '" ignored in schema at path "').concat(l, '"');
              }
              h.logger.warn(e());
            }();
          }());
        }
      };
    }, {
      "../../compile/codegen": 2
    }],
    50: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("./format");
      n.default = [r.default];
    }, {
      "./format": 49
    }],
    51: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.contentVocabulary = n.metadataVocabulary = void 0, n.metadataVocabulary = ["title", "description", "default", "deprecated", "readOnly", "writeOnly", "examples"], n.contentVocabulary = ["contentMediaType", "contentEncoding", "contentSchema"];
    }, {}],
    52: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen"),
        i = e("../../compile/util"),
        o = e("../../runtime/equal");
      n.default = {
        keyword: "const",
        $data: !0,
        error: {
          message: "must be equal to constant",
          params: function params(e) {
            var t = e.schemaCode;
            return r._(yr || (yr = pi(["{allowedValue: ", "}"])), t);
          }
        },
        code: function code(e) {
          var t = e.gen,
            n = e.data,
            a = e.$data,
            s = e.schemaCode,
            u = e.schema;
          a || u && "object" == Li(u) ? e.fail$data(r._(br || (br = pi(["!", "(", ", ", ")"])), (0, i.useFunc)(t, o.default), n, s)) : e.fail(r._(kr || (kr = pi(["", " !== ", ""])), u, n));
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10,
      "../../runtime/equal": 21
    }],
    53: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen"),
        i = e("../../compile/util"),
        o = e("../../runtime/equal");
      n.default = {
        keyword: "enum",
        schemaType: "array",
        $data: !0,
        error: {
          message: "must be equal to one of the allowed values",
          params: function params(e) {
            var t = e.schemaCode;
            return r._(wr || (wr = pi(["{allowedValues: ", "}"])), t);
          }
        },
        code: function code(e) {
          var t,
            n = e.gen,
            a = e.data,
            s = e.$data,
            u = e.schema,
            c = e.schemaCode,
            l = e.it;
          if (!s && 0 === u.length) throw new Error("enum must have non-empty array");
          var f,
            h = function h() {
              return null != t ? t : t = (0, i.useFunc)(n, o.default);
            };
          if (u.length >= l.opts.loopEnum || s) f = n.let("valid"), e.block$data(f, function () {
            n.assign(f, !1), n.forOf("v", c, function (e) {
              return n.if(r._(xr || (xr = pi(["", "(", ", ", ")"])), h(), a, e), function () {
                return n.assign(f, !0).break();
              });
            });
          });else {
            if (!Array.isArray(u)) throw new Error("ajv implementation error");
            var d = n.const("vSchema", c);
            f = r.or.apply(void 0, Ii(u.map(function (e, t) {
              return function (e, t) {
                var n = u[t];
                return "object" == Li(n) && null !== n ? r._(jr || (jr = pi(["", "(", ", ", "[", "])"])), h(), a, e, t) : r._(Sr || (Sr = pi(["", " === ", ""])), a, n);
              }(d, t);
            })));
          }
          e.pass(f);
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10,
      "../../runtime/equal": 21
    }],
    54: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("./limitNumber"),
        i = e("./multipleOf"),
        o = e("./limitLength"),
        a = e("./pattern"),
        s = e("./limitProperties"),
        u = e("./required"),
        c = e("./limitItems"),
        l = e("./uniqueItems"),
        f = e("./const"),
        h = e("./enum");
      n.default = [r.default, i.default, o.default, a.default, s.default, u.default, c.default, l.default, {
        keyword: "type",
        schemaType: ["string", "array"]
      }, {
        keyword: "nullable",
        schemaType: "boolean"
      }, f.default, h.default];
    }, {
      "./const": 52,
      "./enum": 53,
      "./limitItems": 55,
      "./limitLength": 56,
      "./limitNumber": 57,
      "./limitProperties": 58,
      "./multipleOf": 59,
      "./pattern": 60,
      "./required": 61,
      "./uniqueItems": 62
    }],
    55: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen");
      n.default = {
        keyword: ["maxItems", "minItems"],
        type: "array",
        schemaType: "number",
        $data: !0,
        error: {
          message: function message(e) {
            var t = e.keyword,
              n = e.schemaCode;
            return r.str(Cr || (Cr = pi(["must NOT have ", " than ", " items"])), "maxItems" === t ? "more" : "fewer", n);
          },
          params: function params(e) {
            var t = e.schemaCode;
            return r._(_r || (_r = pi(["{limit: ", "}"])), t);
          }
        },
        code: function code(e) {
          var t = e.keyword,
            n = e.data,
            i = e.schemaCode;
          e.fail$data(r._($r || ($r = pi(["", ".length ", " ", ""])), n, "maxItems" === t ? r.operators.GT : r.operators.LT, i));
        }
      };
    }, {
      "../../compile/codegen": 2
    }],
    56: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen"),
        i = e("../../compile/util"),
        o = e("../../runtime/ucs2length");
      n.default = {
        keyword: ["maxLength", "minLength"],
        type: "string",
        schemaType: "number",
        $data: !0,
        error: {
          message: function message(e) {
            var t = e.keyword,
              n = e.schemaCode;
            return r.str(Or || (Or = pi(["must NOT have ", " than ", " characters"])), "maxLength" === t ? "more" : "fewer", n);
          },
          params: function params(e) {
            var t = e.schemaCode;
            return r._(Ar || (Ar = pi(["{limit: ", "}"])), t);
          }
        },
        code: function code(e) {
          var t = e.keyword,
            n = e.data,
            a = e.schemaCode,
            s = e.it,
            u = "maxLength" === t ? r.operators.GT : r.operators.LT,
            c = !1 === s.opts.unicode ? r._(Er || (Er = pi(["", ".length"])), n) : r._(Pr || (Pr = pi(["", "(", ")"])), (0, i.useFunc)(e.gen, o.default), n);
          e.fail$data(r._(Mr || (Mr = pi(["", " ", " ", ""])), c, u, a));
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10,
      "../../runtime/ucs2length": 22
    }],
    57: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen"),
        i = r.operators,
        o = {
          maximum: {
            okStr: "<=",
            ok: i.LTE,
            fail: i.GT
          },
          minimum: {
            okStr: ">=",
            ok: i.GTE,
            fail: i.LT
          },
          exclusiveMaximum: {
            okStr: "<",
            ok: i.LT,
            fail: i.GTE
          },
          exclusiveMinimum: {
            okStr: ">",
            ok: i.GT,
            fail: i.LTE
          }
        },
        a = {
          message: function message(e) {
            var t = e.keyword,
              n = e.schemaCode;
            return r.str(Ir || (Ir = pi(["must be ", " ", ""])), o[t].okStr, n);
          },
          params: function params(e) {
            var t = e.keyword,
              n = e.schemaCode;
            return r._(Tr || (Tr = pi(["{comparison: ", ", limit: ", "}"])), o[t].okStr, n);
          }
        },
        s = {
          keyword: Object.keys(o),
          type: "number",
          schemaType: "number",
          $data: !0,
          error: a,
          code: function code(e) {
            var t = e.keyword,
              n = e.data,
              i = e.schemaCode;
            e.fail$data(r._(Nr || (Nr = pi(["", " ", " ", " || isNaN(", ")"])), n, o[t].fail, i, n));
          }
        };
      n.default = s;
    }, {
      "../../compile/codegen": 2
    }],
    58: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen");
      n.default = {
        keyword: ["maxProperties", "minProperties"],
        type: "object",
        schemaType: "number",
        $data: !0,
        error: {
          message: function message(e) {
            var t = e.keyword,
              n = e.schemaCode;
            return r.str(Rr || (Rr = pi(["must NOT have ", " than ", " properties"])), "maxProperties" === t ? "more" : "fewer", n);
          },
          params: function params(e) {
            var t = e.schemaCode;
            return r._(Dr || (Dr = pi(["{limit: ", "}"])), t);
          }
        },
        code: function code(e) {
          var t = e.keyword,
            n = e.data,
            i = e.schemaCode;
          e.fail$data(r._(zr || (zr = pi(["Object.keys(", ").length ", " ", ""])), n, "maxProperties" === t ? r.operators.GT : r.operators.LT, i));
        }
      };
    }, {
      "../../compile/codegen": 2
    }],
    59: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/codegen");
      n.default = {
        keyword: "multipleOf",
        type: "number",
        schemaType: "number",
        $data: !0,
        error: {
          message: function message(e) {
            var t = e.schemaCode;
            return r.str(Lr || (Lr = pi(["must be multiple of ", ""])), t);
          },
          params: function params(e) {
            var t = e.schemaCode;
            return r._(Br || (Br = pi(["{multipleOf: ", "}"])), t);
          }
        },
        code: function code(e) {
          var t = e.gen,
            n = e.data,
            i = e.schemaCode,
            o = e.it.opts.multipleOfPrecision,
            a = t.let("res"),
            s = o ? r._(qr || (qr = pi(["Math.abs(Math.round(", ") - ", ") > 1e-", ""])), a, a, o) : r._(Fr || (Fr = pi(["", " !== parseInt(", ")"])), a, a);
          e.fail$data(r._(Vr || (Vr = pi(["(", " === 0 || (", " = ", "/", ", ", "))"])), i, a, n, i, s));
        }
      };
    }, {
      "../../compile/codegen": 2
    }],
    60: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../code"),
        i = e("../../compile/codegen");
      n.default = {
        keyword: "pattern",
        type: "string",
        schemaType: "string",
        $data: !0,
        error: {
          message: function message(e) {
            var t = e.schemaCode;
            return i.str(Hr || (Hr = pi(['must match pattern "', '"'])), t);
          },
          params: function params(e) {
            var t = e.schemaCode;
            return i._(Wr || (Wr = pi(["{pattern: ", "}"])), t);
          }
        },
        code: function code(e) {
          var t = e.data,
            n = e.$data,
            o = e.schema,
            a = e.schemaCode,
            s = e.it,
            u = n ? i._(Ur || (Ur = pi(["(new RegExp(", ", ", "))"])), a, s.opts.unicodeRegExp ? "u" : "") : (0, r.usePattern)(e, o);
          e.fail$data(i._(Jr || (Jr = pi(["!", ".test(", ")"])), u, t));
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../code": 42
    }],
    61: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../code"),
        i = e("../../compile/codegen"),
        o = e("../../compile/util");
      n.default = {
        keyword: "required",
        type: "object",
        schemaType: "array",
        $data: !0,
        error: {
          message: function message(e) {
            var t = e.params.missingProperty;
            return i.str(Kr || (Kr = pi(["must have required property '", "'"])), t);
          },
          params: function params(e) {
            var t = e.params.missingProperty;
            return i._(Gr || (Gr = pi(["{missingProperty: ", "}"])), t);
          }
        },
        code: function code(e) {
          var t = e.gen,
            n = e.schema,
            a = e.schemaCode,
            s = e.data,
            u = e.$data,
            c = e.it,
            l = c.opts;
          if (u || 0 !== n.length) {
            var f = n.length >= l.loopRequired;
            if (c.allErrors ? function () {
              if (f || u) e.block$data(i.nil, g);else {
                var t,
                  o = bi(n);
                try {
                  for (o.s(); !(t = o.n()).done;) {
                    var a = t.value;
                    (0, r.checkReportMissingProp)(e, a);
                  }
                } catch (e) {
                  o.e(e);
                } finally {
                  o.f();
                }
              }
            }() : function () {
              var o = t.let("missing");
              if (f || u) {
                var c = t.let("valid", !0);
                e.block$data(c, function () {
                  return function (n, o) {
                    e.setParams({
                      missingProperty: n
                    }), t.forOf(n, a, function () {
                      t.assign(o, (0, r.propertyInData)(t, s, n, l.ownProperties)), t.if((0, i.not)(o), function () {
                        e.error(), t.break();
                      });
                    }, i.nil);
                  }(o, c);
                }), e.ok(c);
              } else t.if((0, r.checkMissingProp)(e, n, o)), (0, r.reportMissingProp)(e, o), t.else();
            }(), l.strictRequired) {
              var h,
                d = e.parentSchema.properties,
                v = e.it.definedProperties,
                p = bi(n);
              try {
                for (p.s(); !(h = p.n()).done;) {
                  var m = h.value;
                  void 0 !== (null == d ? void 0 : d[m]) || v.has(m) || (0, o.checkStrictMode)(c, 'required property "'.concat(m, '" is not defined at "').concat(c.schemaEnv.baseId + c.errSchemaPath, '" (strictRequired)'), c.opts.strictRequired);
                }
              } catch (e) {
                p.e(e);
              } finally {
                p.f();
              }
            }
          }
          function g() {
            t.forOf("prop", a, function (n) {
              e.setParams({
                missingProperty: n
              }), t.if((0, r.noPropertyInData)(t, s, n, l.ownProperties), function () {
                return e.error();
              });
            });
          }
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10,
      "../code": 42
    }],
    62: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = e("../../compile/validate/dataType"),
        i = e("../../compile/codegen"),
        o = e("../../compile/util"),
        a = e("../../runtime/equal");
      n.default = {
        keyword: "uniqueItems",
        type: "array",
        schemaType: "boolean",
        $data: !0,
        error: {
          message: function message(e) {
            var t = e.params,
              n = t.i,
              r = t.j;
            return i.str(Qr || (Qr = pi(["must NOT have duplicate items (items ## ", " and ", " are identical)"])), r, n);
          },
          params: function params(e) {
            var t = e.params,
              n = t.i,
              r = t.j;
            return i._(Yr || (Yr = pi(["{i: ", ", j: ", "}"])), n, r);
          }
        },
        code: function code(e) {
          var t = e.gen,
            n = e.data,
            s = e.$data,
            u = e.schema,
            c = e.parentSchema,
            l = e.schemaCode,
            f = e.it;
          if (s || u) {
            var h = t.let("valid"),
              d = c.items ? (0, r.getSchemaTypes)(c.items) : [];
            e.block$data(h, function () {
              var r = t.let("i", i._(li || (li = pi(["", ".length"])), n)),
                o = t.let("j");
              e.setParams({
                i: r,
                j: o
              }), t.assign(h, !0), t.if(i._(fi || (fi = pi(["", " > 1"])), r), function () {
                return (d.length > 0 && !d.some(function (e) {
                  return "object" === e || "array" === e;
                }) ? v : p)(r, o);
              });
            }, i._(hi || (hi = pi(["", " === false"])), l)), e.ok(h);
          }
          function v(o, a) {
            var s = t.name("item"),
              u = (0, r.checkDataTypes)(d, s, f.opts.strictNumbers, r.DataType.Wrong),
              c = t.const("indices", i._(Zr || (Zr = pi(["{}"]))));
            t.for(i._(Xr || (Xr = pi([";", "--;"])), o), function () {
              t.let(s, i._(ei || (ei = pi(["", "[", "]"])), n, o)), t.if(u, i._(ti || (ti = pi(["continue"])))), d.length > 1 && t.if(i._(ni || (ni = pi(["typeof ", ' == "string"'])), s), i._(ri || (ri = pi(["", ' += "_"'])), s)), t.if(i._(ii || (ii = pi(["typeof ", "[", '] == "number"'])), c, s), function () {
                t.assign(a, i._(oi || (oi = pi(["", "[", "]"])), c, s)), e.error(), t.assign(h, !1).break();
              }).code(i._(ai || (ai = pi(["", "[", "] = ", ""])), c, s, o));
            });
          }
          function p(r, s) {
            var u = (0, o.useFunc)(t, a.default),
              c = t.name("outer");
            t.label(c).for(i._(si || (si = pi([";", "--;"])), r), function () {
              return t.for(i._(ui || (ui = pi(["", " = ", "; ", "--;"])), s, r, s), function () {
                return t.if(i._(ci || (ci = pi(["", "(", "[", "], ", "[", "])"])), u, n, r, n, s), function () {
                  e.error(), t.assign(h, !1).break(c);
                });
              });
            });
          }
        }
      };
    }, {
      "../../compile/codegen": 2,
      "../../compile/util": 10,
      "../../compile/validate/dataType": 13,
      "../../runtime/equal": 21
    }],
    63: [function (e, t, n) {
      t.exports = function e(t, n) {
        if (t === n) return !0;
        if (t && n && "object" == Li(t) && "object" == Li(n)) {
          if (t.constructor !== n.constructor) return !1;
          var r, i, o;
          if (Array.isArray(t)) {
            if ((r = t.length) != n.length) return !1;
            for (i = r; 0 != i--;) {
              if (!e(t[i], n[i])) return !1;
            }
            return !0;
          }
          if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
          if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
          if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
          if ((r = (o = Object.keys(t)).length) !== Object.keys(n).length) return !1;
          for (i = r; 0 != i--;) {
            if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
          }
          for (i = r; 0 != i--;) {
            var a = o[i];
            if (!e(t[a], n[a])) return !1;
          }
          return !0;
        }
        return t != t && n != n;
      };
    }, {}],
    64: [function (e, t, n) {
      var r = t.exports = function (e, t, n) {
        "function" == typeof t && (n = t, t = {}), i(t, "function" == typeof (n = t.cb || n) ? n : n.pre || function () {}, n.post || function () {}, e, "", e);
      };
      function i(e, t, n, o, a, s, u, c, l, f) {
        if (o && "object" == Li(o) && !Array.isArray(o)) {
          for (var h in t(o, a, s, u, c, l, f), o) {
            var d = o[h];
            if (Array.isArray(d)) {
              if (h in r.arrayKeywords) for (var v = 0; v < d.length; v++) {
                i(e, t, n, d[v], a + "/" + h + "/" + v, s, a, h, o, v);
              }
            } else if (h in r.propsKeywords) {
              if (d && "object" == Li(d)) for (var p in d) {
                i(e, t, n, d[p], a + "/" + h + "/" + p.replace(/~/g, "~0").replace(/\//g, "~1"), s, a, h, o, p);
              }
            } else (h in r.keywords || e.allKeys && !(h in r.skipKeywords)) && i(e, t, n, d, a + "/" + h, s, a, h, o);
          }
          n(o, a, s, u, c, l, f);
        }
      }
      r.keywords = {
        additionalItems: !0,
        items: !0,
        contains: !0,
        additionalProperties: !0,
        propertyNames: !0,
        not: !0,
        if: !0,
        then: !0,
        else: !0
      }, r.arrayKeywords = {
        items: !0,
        allOf: !0,
        anyOf: !0,
        oneOf: !0
      }, r.propsKeywords = {
        $defs: !0,
        definitions: !0,
        properties: !0,
        patternProperties: !0,
        dependencies: !0
      }, r.skipKeywords = {
        default: !0,
        enum: !0,
        const: !0,
        required: !0,
        maximum: !0,
        minimum: !0,
        exclusiveMaximum: !0,
        exclusiveMinimum: !0,
        multipleOf: !0,
        maxLength: !0,
        minLength: !0,
        pattern: !0,
        format: !0,
        maxItems: !0,
        minItems: !0,
        uniqueItems: !0,
        maxProperties: !0,
        minProperties: !0
      };
    }, {}],
    65: [function (e, t, n) {
      /** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */!function (e, r) {
        r("object" == Li(n) && void 0 !== t ? n : e.URI = e.URI || {});
      }(this, function (e) {
        function t() {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }
          if (t.length > 1) {
            t[0] = t[0].slice(0, -1);
            for (var r = t.length - 1, i = 1; i < r; ++i) {
              t[i] = t[i].slice(1, -1);
            }
            return t[r] = t[r].slice(1), t.join("");
          }
          return t[0];
        }
        function n(e) {
          return "(?:" + e + ")";
        }
        function r(e) {
          return void 0 === e ? "undefined" : null === e ? "null" : Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();
        }
        function i(e) {
          return e.toUpperCase();
        }
        function o(e) {
          var r = "[A-Za-z]",
            i = "[0-9]",
            o = t(i, "[A-Fa-f]"),
            a = n(n("%[EFef]" + o + "%" + o + o + "%" + o + o) + "|" + n("%[89A-Fa-f]" + o + "%" + o + o) + "|" + n("%" + o + o)),
            s = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",
            u = t("[\\:\\/\\?\\#\\[\\]\\@]", s),
            c = e ? "[\\uE000-\\uF8FF]" : "[]",
            l = t(r, i, "[\\-\\.\\_\\~]", e ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]");
          n(r + t(r, i, "[\\+\\-\\.]") + "*"), n(n(a + "|" + t(l, s, "[\\:]")) + "*");
          var f = n(n("25[0-5]") + "|" + n("2[0-4][0-9]") + "|" + n("1[0-9][0-9]") + "|" + n("0?[1-9][0-9]") + "|0?0?" + i),
            h = n(f + "\\." + f + "\\." + f + "\\." + f),
            d = n(o + "{1,4}"),
            v = n(n(d + "\\:" + d) + "|" + h),
            p = n(n(d + "\\:") + "{6}" + v),
            m = n("\\:\\:" + n(d + "\\:") + "{5}" + v),
            g = n(n(d) + "?\\:\\:" + n(d + "\\:") + "{4}" + v),
            y = n(n(n(d + "\\:") + "{0,1}" + d) + "?\\:\\:" + n(d + "\\:") + "{3}" + v),
            b = n(n(n(d + "\\:") + "{0,2}" + d) + "?\\:\\:" + n(d + "\\:") + "{2}" + v),
            k = n(n(n(d + "\\:") + "{0,3}" + d) + "?\\:\\:" + d + "\\:" + v),
            w = n(n(n(d + "\\:") + "{0,4}" + d) + "?\\:\\:" + v),
            x = n(n(n(d + "\\:") + "{0,5}" + d) + "?\\:\\:" + d),
            j = n(n(n(d + "\\:") + "{0,6}" + d) + "?\\:\\:"),
            S = n([p, m, g, y, b, k, w, x, j].join("|")),
            C = n(n(l + "|" + a) + "+");
          n("[vV]" + o + "+\\." + t(l, s, "[\\:]") + "+"), n(n(a + "|" + t(l, s)) + "*");
          var _ = n(a + "|" + t(l, s, "[\\:\\@]"));
          return n(n(a + "|" + t(l, s, "[\\@]")) + "+"), n(n(_ + "|" + t("[\\/\\?]", c)) + "*"), {
            NOT_SCHEME: new RegExp(t("[^]", r, i, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(t("[^\\%\\:]", l, s), "g"),
            NOT_HOST: new RegExp(t("[^\\%\\[\\]\\:]", l, s), "g"),
            NOT_PATH: new RegExp(t("[^\\%\\/\\:\\@]", l, s), "g"),
            NOT_PATH_NOSCHEME: new RegExp(t("[^\\%\\/\\@]", l, s), "g"),
            NOT_QUERY: new RegExp(t("[^\\%]", l, s, "[\\:\\@\\/\\?]", c), "g"),
            NOT_FRAGMENT: new RegExp(t("[^\\%]", l, s, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(t("[^]", l, s), "g"),
            UNRESERVED: new RegExp(l, "g"),
            OTHER_CHARS: new RegExp(t("[^\\%]", l, u), "g"),
            PCT_ENCODED: new RegExp(a, "g"),
            IPV4ADDRESS: new RegExp("^(" + h + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + S + ")" + n(n("\\%25|\\%(?!" + o + "{2})") + "(" + C + ")") + "?\\]?$")
          };
        }
        var a = o(!1),
          s = o(!0),
          u = function u(e, t) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return function (e, t) {
              var n = [],
                r = !0,
                i = !1,
                o = void 0;
              try {
                for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
                  ;
                }
              } catch (e) {
                i = !0, o = e;
              } finally {
                try {
                  !r && s.return && s.return();
                } finally {
                  if (i) throw o;
                }
              }
              return n;
            }(e, t);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          },
          c = 2147483647,
          l = 36,
          f = /^xn--/,
          h = /[^\0-\x7E]/,
          d = /[\x2E\u3002\uFF0E\uFF61]/g,
          v = {
            overflow: "Overflow: input needs wider integers to process",
            "not-basic": "Illegal input >= 0x80 (not a basic code point)",
            "invalid-input": "Invalid input"
          },
          p = Math.floor,
          m = String.fromCharCode;
        function g(e) {
          throw new RangeError(v[e]);
        }
        function y(e, t) {
          var n = e.split("@"),
            r = "";
          n.length > 1 && (r = n[0] + "@", e = n[1]);
          var i = function (e, t) {
            for (var n = [], r = e.length; r--;) {
              n[r] = t(e[r]);
            }
            return n;
          }((e = e.replace(d, ".")).split("."), t).join(".");
          return r + i;
        }
        function b(e) {
          for (var t = [], n = 0, r = e.length; n < r;) {
            var i = e.charCodeAt(n++);
            if (i >= 55296 && i <= 56319 && n < r) {
              var o = e.charCodeAt(n++);
              56320 == (64512 & o) ? t.push(((1023 & i) << 10) + (1023 & o) + 65536) : (t.push(i), n--);
            } else t.push(i);
          }
          return t;
        }
        var k = function k(e, t) {
            return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
          },
          w = function w(e, t, n) {
            var r = 0;
            for (e = n ? p(e / 700) : e >> 1, e += p(e / t); e > 455; r += l) {
              e = p(e / 35);
            }
            return p(r + 36 * e / (e + 38));
          },
          x = function x(e) {
            var t,
              n = [],
              r = e.length,
              i = 0,
              o = 128,
              a = 72,
              s = e.lastIndexOf("-");
            s < 0 && (s = 0);
            for (var u = 0; u < s; ++u) {
              e.charCodeAt(u) >= 128 && g("not-basic"), n.push(e.charCodeAt(u));
            }
            for (var f = s > 0 ? s + 1 : 0; f < r;) {
              for (var h = i, d = 1, v = l;; v += l) {
                f >= r && g("invalid-input");
                var m = (t = e.charCodeAt(f++)) - 48 < 10 ? t - 22 : t - 65 < 26 ? t - 65 : t - 97 < 26 ? t - 97 : l;
                (m >= l || m > p((c - i) / d)) && g("overflow"), i += m * d;
                var y = v <= a ? 1 : v >= a + 26 ? 26 : v - a;
                if (m < y) break;
                var b = l - y;
                d > p(c / b) && g("overflow"), d *= b;
              }
              var k = n.length + 1;
              a = w(i - h, k, 0 == h), p(i / k) > c - o && g("overflow"), o += p(i / k), i %= k, n.splice(i++, 0, o);
            }
            return String.fromCodePoint.apply(String, n);
          },
          j = function j(e) {
            var t = [],
              n = (e = b(e)).length,
              r = 128,
              i = 0,
              o = 72,
              a = !0,
              s = !1,
              u = void 0;
            try {
              for (var f, h = e[Symbol.iterator](); !(a = (f = h.next()).done); a = !0) {
                var d = f.value;
                d < 128 && t.push(m(d));
              }
            } catch (e) {
              s = !0, u = e;
            } finally {
              try {
                !a && h.return && h.return();
              } finally {
                if (s) throw u;
              }
            }
            var v = t.length,
              y = v;
            for (v && t.push("-"); y < n;) {
              var x = c,
                j = !0,
                S = !1,
                C = void 0;
              try {
                for (var _, $ = e[Symbol.iterator](); !(j = (_ = $.next()).done); j = !0) {
                  var O = _.value;
                  O >= r && O < x && (x = O);
                }
              } catch (e) {
                S = !0, C = e;
              } finally {
                try {
                  !j && $.return && $.return();
                } finally {
                  if (S) throw C;
                }
              }
              var A = y + 1;
              x - r > p((c - i) / A) && g("overflow"), i += (x - r) * A, r = x;
              var E = !0,
                P = !1,
                M = void 0;
              try {
                for (var I, T = e[Symbol.iterator](); !(E = (I = T.next()).done); E = !0) {
                  var N = I.value;
                  if (N < r && ++i > c && g("overflow"), N == r) {
                    for (var R = i, D = l;; D += l) {
                      var z = D <= o ? 1 : D >= o + 26 ? 26 : D - o;
                      if (R < z) break;
                      var L = R - z,
                        B = l - z;
                      t.push(m(k(z + L % B, 0))), R = p(L / B);
                    }
                    t.push(m(k(R, 0))), o = w(i, A, y == v), i = 0, ++y;
                  }
                }
              } catch (e) {
                P = !0, M = e;
              } finally {
                try {
                  !E && T.return && T.return();
                } finally {
                  if (P) throw M;
                }
              }
              ++i, ++r;
            }
            return t.join("");
          },
          S = function S(e) {
            return y(e, function (e) {
              return h.test(e) ? "xn--" + j(e) : e;
            });
          },
          C = function C(e) {
            return y(e, function (e) {
              return f.test(e) ? x(e.slice(4).toLowerCase()) : e;
            });
          },
          _ = {};
        function $(e) {
          var t = e.charCodeAt(0);
          return t < 16 ? "%0" + t.toString(16).toUpperCase() : t < 128 ? "%" + t.toString(16).toUpperCase() : t < 2048 ? "%" + (t >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & t | 128).toString(16).toUpperCase() : "%" + (t >> 12 | 224).toString(16).toUpperCase() + "%" + (t >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & t | 128).toString(16).toUpperCase();
        }
        function O(e) {
          for (var t = "", n = 0, r = e.length; n < r;) {
            var i = parseInt(e.substr(n + 1, 2), 16);
            if (i < 128) t += String.fromCharCode(i), n += 3;else if (i >= 194 && i < 224) {
              if (r - n >= 6) {
                var o = parseInt(e.substr(n + 4, 2), 16);
                t += String.fromCharCode((31 & i) << 6 | 63 & o);
              } else t += e.substr(n, 6);
              n += 6;
            } else if (i >= 224) {
              if (r - n >= 9) {
                var a = parseInt(e.substr(n + 4, 2), 16),
                  s = parseInt(e.substr(n + 7, 2), 16);
                t += String.fromCharCode((15 & i) << 12 | (63 & a) << 6 | 63 & s);
              } else t += e.substr(n, 9);
              n += 9;
            } else t += e.substr(n, 3), n += 3;
          }
          return t;
        }
        function A(e, t) {
          function n(e) {
            var n = O(e);
            return n.match(t.UNRESERVED) ? n : e;
          }
          return e.scheme && (e.scheme = String(e.scheme).replace(t.PCT_ENCODED, n).toLowerCase().replace(t.NOT_SCHEME, "")), void 0 !== e.userinfo && (e.userinfo = String(e.userinfo).replace(t.PCT_ENCODED, n).replace(t.NOT_USERINFO, $).replace(t.PCT_ENCODED, i)), void 0 !== e.host && (e.host = String(e.host).replace(t.PCT_ENCODED, n).toLowerCase().replace(t.NOT_HOST, $).replace(t.PCT_ENCODED, i)), void 0 !== e.path && (e.path = String(e.path).replace(t.PCT_ENCODED, n).replace(e.scheme ? t.NOT_PATH : t.NOT_PATH_NOSCHEME, $).replace(t.PCT_ENCODED, i)), void 0 !== e.query && (e.query = String(e.query).replace(t.PCT_ENCODED, n).replace(t.NOT_QUERY, $).replace(t.PCT_ENCODED, i)), void 0 !== e.fragment && (e.fragment = String(e.fragment).replace(t.PCT_ENCODED, n).replace(t.NOT_FRAGMENT, $).replace(t.PCT_ENCODED, i)), e;
        }
        function E(e) {
          return e.replace(/^0*(.*)/, "$1") || "0";
        }
        function P(e, t) {
          var n = e.match(t.IPV4ADDRESS) || [],
            r = u(n, 2)[1];
          return r ? r.split(".").map(E).join(".") : e;
        }
        function M(e, t) {
          var n = e.match(t.IPV6ADDRESS) || [],
            r = u(n, 3),
            i = r[1],
            o = r[2];
          if (i) {
            for (var a = i.toLowerCase().split("::").reverse(), s = u(a, 2), c = s[0], l = s[1], f = l ? l.split(":").map(E) : [], h = c.split(":").map(E), d = t.IPV4ADDRESS.test(h[h.length - 1]), v = d ? 7 : 8, p = h.length - v, m = Array(v), g = 0; g < v; ++g) {
              m[g] = f[g] || h[p + g] || "";
            }
            d && (m[v - 1] = P(m[v - 1], t));
            var y = m.reduce(function (e, t, n) {
                if (!t || "0" === t) {
                  var r = e[e.length - 1];
                  r && r.index + r.length === n ? r.length++ : e.push({
                    index: n,
                    length: 1
                  });
                }
                return e;
              }, []).sort(function (e, t) {
                return t.length - e.length;
              })[0],
              b = void 0;
            if (y && y.length > 1) {
              var k = m.slice(0, y.index),
                w = m.slice(y.index + y.length);
              b = k.join(":") + "::" + w.join(":");
            } else b = m.join(":");
            return o && (b += "%" + o), b;
          }
          return e;
        }
        var I = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i,
          T = void 0 === "".match(/(){0}/)[1];
        function N(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = {},
            r = !1 !== t.iri ? s : a;
          "suffix" === t.reference && (e = (t.scheme ? t.scheme + ":" : "") + "//" + e);
          var i = e.match(I);
          if (i) {
            T ? (n.scheme = i[1], n.userinfo = i[3], n.host = i[4], n.port = parseInt(i[5], 10), n.path = i[6] || "", n.query = i[7], n.fragment = i[8], isNaN(n.port) && (n.port = i[5])) : (n.scheme = i[1] || void 0, n.userinfo = -1 !== e.indexOf("@") ? i[3] : void 0, n.host = -1 !== e.indexOf("//") ? i[4] : void 0, n.port = parseInt(i[5], 10), n.path = i[6] || "", n.query = -1 !== e.indexOf("?") ? i[7] : void 0, n.fragment = -1 !== e.indexOf("#") ? i[8] : void 0, isNaN(n.port) && (n.port = e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? i[4] : void 0)), n.host && (n.host = M(P(n.host, r), r)), n.reference = void 0 !== n.scheme || void 0 !== n.userinfo || void 0 !== n.host || void 0 !== n.port || n.path || void 0 !== n.query ? void 0 === n.scheme ? "relative" : void 0 === n.fragment ? "absolute" : "uri" : "same-document", t.reference && "suffix" !== t.reference && t.reference !== n.reference && (n.error = n.error || "URI is not a " + t.reference + " reference.");
            var o = _[(t.scheme || n.scheme || "").toLowerCase()];
            if (t.unicodeSupport || o && o.unicodeSupport) A(n, r);else {
              if (n.host && (t.domainHost || o && o.domainHost)) try {
                n.host = S(n.host.replace(r.PCT_ENCODED, O).toLowerCase());
              } catch (e) {
                n.error = n.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
              }
              A(n, a);
            }
            o && o.parse && o.parse(n, t);
          } else n.error = n.error || "URI can not be parsed.";
          return n;
        }
        function R(e, t) {
          var n = !1 !== t.iri ? s : a,
            r = [];
          return void 0 !== e.userinfo && (r.push(e.userinfo), r.push("@")), void 0 !== e.host && r.push(M(P(String(e.host), n), n).replace(n.IPV6ADDRESS, function (e, t, n) {
            return "[" + t + (n ? "%25" + n : "") + "]";
          })), "number" != typeof e.port && "string" != typeof e.port || (r.push(":"), r.push(String(e.port))), r.length ? r.join("") : void 0;
        }
        var D = /^\.\.?\//,
          z = /^\/\.(\/|$)/,
          L = /^\/\.\.(\/|$)/,
          B = /^\/?(?:.|\n)*?(?=\/|$)/;
        function q(e) {
          for (var t = []; e.length;) {
            if (e.match(D)) e = e.replace(D, "");else if (e.match(z)) e = e.replace(z, "/");else if (e.match(L)) e = e.replace(L, "/"), t.pop();else if ("." === e || ".." === e) e = "";else {
              var n = e.match(B);
              if (!n) throw new Error("Unexpected dot segment condition");
              var r = n[0];
              e = e.slice(r.length), t.push(r);
            }
          }
          return t.join("");
        }
        function F(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.iri ? s : a,
            r = [],
            i = _[(t.scheme || e.scheme || "").toLowerCase()];
          if (i && i.serialize && i.serialize(e, t), e.host) if (n.IPV6ADDRESS.test(e.host)) ;else if (t.domainHost || i && i.domainHost) try {
            e.host = t.iri ? C(e.host) : S(e.host.replace(n.PCT_ENCODED, O).toLowerCase());
          } catch (n) {
            e.error = e.error || "Host's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + n;
          }
          A(e, n), "suffix" !== t.reference && e.scheme && (r.push(e.scheme), r.push(":"));
          var o = R(e, t);
          if (void 0 !== o && ("suffix" !== t.reference && r.push("//"), r.push(o), e.path && "/" !== e.path.charAt(0) && r.push("/")), void 0 !== e.path) {
            var u = e.path;
            t.absolutePath || i && i.absolutePath || (u = q(u)), void 0 === o && (u = u.replace(/^\/\//, "/%2F")), r.push(u);
          }
          return void 0 !== e.query && (r.push("?"), r.push(e.query)), void 0 !== e.fragment && (r.push("#"), r.push(e.fragment)), r.join("");
        }
        function V(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = {};
          return arguments[3] || (e = N(F(e, n), n), t = N(F(t, n), n)), !(n = n || {}).tolerant && t.scheme ? (r.scheme = t.scheme, r.userinfo = t.userinfo, r.host = t.host, r.port = t.port, r.path = q(t.path || ""), r.query = t.query) : (void 0 !== t.userinfo || void 0 !== t.host || void 0 !== t.port ? (r.userinfo = t.userinfo, r.host = t.host, r.port = t.port, r.path = q(t.path || ""), r.query = t.query) : (t.path ? ("/" === t.path.charAt(0) ? r.path = q(t.path) : (r.path = void 0 === e.userinfo && void 0 === e.host && void 0 === e.port || e.path ? e.path ? e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path : t.path : "/" + t.path, r.path = q(r.path)), r.query = t.query) : (r.path = e.path, r.query = void 0 !== t.query ? t.query : e.query), r.userinfo = e.userinfo, r.host = e.host, r.port = e.port), r.scheme = e.scheme), r.fragment = t.fragment, r;
        }
        function H(e, t) {
          return e && e.toString().replace(t && t.iri ? s.PCT_ENCODED : a.PCT_ENCODED, O);
        }
        var W = {
            scheme: "http",
            domainHost: !0,
            parse: function parse(e, t) {
              return e.host || (e.error = e.error || "HTTP URIs must have a host."), e;
            },
            serialize: function serialize(e, t) {
              var n = "https" === String(e.scheme).toLowerCase();
              return e.port !== (n ? 443 : 80) && "" !== e.port || (e.port = void 0), e.path || (e.path = "/"), e;
            }
          },
          U = {
            scheme: "https",
            domainHost: W.domainHost,
            parse: W.parse,
            serialize: W.serialize
          };
        function J(e) {
          return "boolean" == typeof e.secure ? e.secure : "wss" === String(e.scheme).toLowerCase();
        }
        var K = {
            scheme: "ws",
            domainHost: !0,
            parse: function parse(e, t) {
              var n = e;
              return n.secure = J(n), n.resourceName = (n.path || "/") + (n.query ? "?" + n.query : ""), n.path = void 0, n.query = void 0, n;
            },
            serialize: function serialize(e, t) {
              if (e.port !== (J(e) ? 443 : 80) && "" !== e.port || (e.port = void 0), "boolean" == typeof e.secure && (e.scheme = e.secure ? "wss" : "ws", e.secure = void 0), e.resourceName) {
                var n = e.resourceName.split("?"),
                  r = u(n, 2),
                  i = r[0],
                  o = r[1];
                e.path = i && "/" !== i ? i : void 0, e.query = o, e.resourceName = void 0;
              }
              return e.fragment = void 0, e;
            }
          },
          G = {
            scheme: "wss",
            domainHost: K.domainHost,
            parse: K.parse,
            serialize: K.serialize
          },
          Q = {},
          Y = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]",
          Z = "[0-9A-Fa-f]",
          X = n(n("%[EFef][0-9A-Fa-f]%" + Z + Z + "%" + Z + Z) + "|" + n("%[89A-Fa-f][0-9A-Fa-f]%" + Z + Z) + "|" + n("%" + Z + Z)),
          ee = t("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'),
          te = new RegExp(Y, "g"),
          ne = new RegExp(X, "g"),
          re = new RegExp(t("[^]", "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", "[\\.]", '[\\"]', ee), "g"),
          ie = new RegExp(t("[^]", Y, "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]"), "g"),
          oe = ie;
        function ae(e) {
          var t = O(e);
          return t.match(te) ? t : e;
        }
        var se = {
            scheme: "mailto",
            parse: function parse(e, t) {
              var n = e,
                r = n.to = n.path ? n.path.split(",") : [];
              if (n.path = void 0, n.query) {
                for (var i = !1, o = {}, a = n.query.split("&"), s = 0, u = a.length; s < u; ++s) {
                  var c = a[s].split("=");
                  switch (c[0]) {
                    case "to":
                      for (var l = c[1].split(","), f = 0, h = l.length; f < h; ++f) {
                        r.push(l[f]);
                      }
                      break;
                    case "subject":
                      n.subject = H(c[1], t);
                      break;
                    case "body":
                      n.body = H(c[1], t);
                      break;
                    default:
                      i = !0, o[H(c[0], t)] = H(c[1], t);
                  }
                }
                i && (n.headers = o);
              }
              n.query = void 0;
              for (var d = 0, v = r.length; d < v; ++d) {
                var p = r[d].split("@");
                if (p[0] = H(p[0]), t.unicodeSupport) p[1] = H(p[1], t).toLowerCase();else try {
                  p[1] = S(H(p[1], t).toLowerCase());
                } catch (e) {
                  n.error = n.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                r[d] = p.join("@");
              }
              return n;
            },
            serialize: function serialize(e, t) {
              var n,
                r = e,
                o = null != (n = e.to) ? n instanceof Array ? n : "number" != typeof n.length || n.split || n.setInterval || n.call ? [n] : Array.prototype.slice.call(n) : [];
              if (o) {
                for (var a = 0, s = o.length; a < s; ++a) {
                  var u = String(o[a]),
                    c = u.lastIndexOf("@"),
                    l = u.slice(0, c).replace(ne, ae).replace(ne, i).replace(re, $),
                    f = u.slice(c + 1);
                  try {
                    f = t.iri ? C(f) : S(H(f, t).toLowerCase());
                  } catch (e) {
                    r.error = r.error || "Email address's domain name can not be converted to " + (t.iri ? "Unicode" : "ASCII") + " via punycode: " + e;
                  }
                  o[a] = l + "@" + f;
                }
                r.path = o.join(",");
              }
              var h = e.headers = e.headers || {};
              e.subject && (h.subject = e.subject), e.body && (h.body = e.body);
              var d = [];
              for (var v in h) {
                h[v] !== Q[v] && d.push(v.replace(ne, ae).replace(ne, i).replace(ie, $) + "=" + h[v].replace(ne, ae).replace(ne, i).replace(oe, $));
              }
              return d.length && (r.query = d.join("&")), r;
            }
          },
          ue = /^([^\:]+)\:(.*)/,
          ce = {
            scheme: "urn",
            parse: function parse(e, t) {
              var n = e.path && e.path.match(ue),
                r = e;
              if (n) {
                var i = t.scheme || r.scheme || "urn",
                  o = n[1].toLowerCase(),
                  a = n[2],
                  s = _[i + ":" + (t.nid || o)];
                r.nid = o, r.nss = a, r.path = void 0, s && (r = s.parse(r, t));
              } else r.error = r.error || "URN can not be parsed.";
              return r;
            },
            serialize: function serialize(e, t) {
              var n = e.nid,
                r = _[(t.scheme || e.scheme || "urn") + ":" + (t.nid || n)];
              r && (e = r.serialize(e, t));
              var i = e;
              return i.path = (n || t.nid) + ":" + e.nss, i;
            }
          },
          le = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/,
          fe = {
            scheme: "urn:uuid",
            parse: function parse(e, t) {
              var n = e;
              return n.uuid = n.nss, n.nss = void 0, t.tolerant || n.uuid && n.uuid.match(le) || (n.error = n.error || "UUID is not valid."), n;
            },
            serialize: function serialize(e, t) {
              var n = e;
              return n.nss = (e.uuid || "").toLowerCase(), n;
            }
          };
        _[W.scheme] = W, _[U.scheme] = U, _[K.scheme] = K, _[G.scheme] = G, _[se.scheme] = se, _[ce.scheme] = ce, _[fe.scheme] = fe, e.SCHEMES = _, e.pctEncChar = $, e.pctDecChars = O, e.parse = N, e.removeDotSegments = q, e.serialize = F, e.resolveComponents = V, e.resolve = function (e, t, n) {
          var r = function (e, t) {
            var n = {
              scheme: "null"
            };
            if (t) for (var r in t) {
              n[r] = t[r];
            }
            return n;
          }(0, n);
          return F(V(N(e, r), N(t, r), r, !0), r);
        }, e.normalize = function (e, t) {
          return "string" == typeof e ? e = F(N(e, t), t) : "object" === r(e) && (e = N(F(e, t), t)), e;
        }, e.equal = function (e, t, n) {
          return "string" == typeof e ? e = F(N(e, n), n) : "object" === r(e) && (e = F(e, n)), "string" == typeof t ? t = F(N(t, n), n) : "object" === r(t) && (t = F(t, n)), e === t;
        }, e.escapeComponent = function (e, t) {
          return e && e.toString().replace(t && t.iri ? s.ESCAPE : a.ESCAPE, $);
        }, e.unescapeComponent = H, Object.defineProperty(e, "__esModule", {
          value: !0
        });
      });
    }, {}],
    ajv: [function (e, t, n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.CodeGen = n.Name = n.nil = n.stringify = n.str = n._ = n.KeywordCxt = void 0;
      var r = e("./core"),
        i = e("./vocabularies/draft7"),
        o = e("./vocabularies/discriminator"),
        a = e("./refs/json-schema-draft-07.json"),
        s = ["/properties"],
        u = "http://json-schema.org/draft-07/schema",
        c = function (e) {
          ji(n, e);
          var t = Ci(n);
          function n() {
            return Ri(this, n), t.apply(this, arguments);
          }
          return zi(n, [{
            key: "_addVocabularies",
            value: function value() {
              var e = this;
              ki(Ai(n.prototype), "_addVocabularies", this).call(this), i.default.forEach(function (t) {
                return e.addVocabulary(t);
              }), this.opts.discriminator && this.addKeyword(o.default);
            }
          }, {
            key: "_addDefaultMetaSchema",
            value: function value() {
              if (ki(Ai(n.prototype), "_addDefaultMetaSchema", this).call(this), this.opts.meta) {
                var e = this.opts.$data ? this.$dataMetaSchema(a, s) : a;
                this.addMetaSchema(e, u, !1), this.refs["http://json-schema.org/schema"] = u;
              }
            }
          }, {
            key: "defaultMeta",
            value: function value() {
              return this.opts.defaultMeta = ki(Ai(n.prototype), "defaultMeta", this).call(this) || (this.getSchema(u) ? u : void 0);
            }
          }]), n;
        }(r.default);
      t.exports = n = c, Object.defineProperty(n, "__esModule", {
        value: !0
      }), n.default = c;
      var l = e("./compile/validate");
      Object.defineProperty(n, "KeywordCxt", {
        enumerable: !0,
        get: function get() {
          return l.KeywordCxt;
        }
      });
      var f = e("./compile/codegen");
      Object.defineProperty(n, "_", {
        enumerable: !0,
        get: function get() {
          return f._;
        }
      }), Object.defineProperty(n, "str", {
        enumerable: !0,
        get: function get() {
          return f.str;
        }
      }), Object.defineProperty(n, "stringify", {
        enumerable: !0,
        get: function get() {
          return f.stringify;
        }
      }), Object.defineProperty(n, "nil", {
        enumerable: !0,
        get: function get() {
          return f.nil;
        }
      }), Object.defineProperty(n, "Name", {
        enumerable: !0,
        get: function get() {
          return f.Name;
        }
      }), Object.defineProperty(n, "CodeGen", {
        enumerable: !0,
        get: function get() {
          return f.CodeGen;
        }
      });
    }, {
      "./compile/codegen": 2,
      "./compile/validate": 15,
      "./core": 18,
      "./refs/json-schema-draft-07.json": 20,
      "./vocabularies/discriminator": 46,
      "./vocabularies/draft7": 48
    }]
  }, {}, [])("ajv"));
function yG(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
    n = new gG({
      allErrors: !0,
      verbose: !0,
      $data: !0
    });
  t && Object.keys(t).forEach(function (e) {
    n.addSchema(t[e], e);
  });
  var r = n.compile(e);
  return function (e) {
    return r(e), (r.errors || []).map(kG).map(function (t) {
      return bG(e, t);
    });
  };
}
function bG(e, t) {
  return {
    path: px(e, t.instancePath),
    message: t.message
  };
}
function kG(e) {
  if ("enum" === e.keyword && Array.isArray(e.schema)) {
    var t = e.schema;
    if (t) {
      if ((t = t.map(function (e) {
        return JSON.stringify(e);
      })).length > 5) {
        var n = ["(" + (t.length - 5) + " more...)"];
        (t = t.slice(0, 5)).push(n);
      }
      e.message = "should be equal to one of: " + t.join(", ");
    }
  }
  return "additionalProperties" === e.keyword && (e.message = "should NOT have additional property: " + e.params.additionalProperty), e;
}
var wG = {
  id: "lodash",
  name: "Lodash",
  description: '\n<p>\n  Enter a JavaScript function to filter, sort, or transform the data.\n  You can use <a href="https://lodash.com" target="_blank" rel="noopener noreferrer">Lodash</a>\n  functions like <code>_.map</code>, <code>_.filter</code>,\n  <code>_.orderBy</code>, <code>_.sortBy</code>, <code>_.groupBy</code>,\n  <code>_.pick</code>, <code>_.uniq</code>, <code>_.get</code>, etcetera.\n</p>\n',
  createQuery: function createQuery(e, t) {
    var n = t.filter,
      r = t.sort,
      i = t.projection,
      o = [];
    if (n && n.path && n.relation && n.value) {
      var a = "item => item".concat(iC(n.path)),
        s = "string" == typeof bF(n.value) ? "'".concat(n.value, "'") : n.value;
      o.push("  data = _.filter(data, ".concat(a, " ").concat(n.relation, " ").concat(s, ")\n"));
    }
    r && r.path && r.direction && o.push("  data = _.orderBy(data, ['".concat(function (e) {
      return rC(e).replace(/^\./, "");
    }(r.path), "'], ['").concat(r.direction, "'])\n"));
    if (i && i.paths) if (i.paths.length > 1) {
      var u = i.paths.map(function (e) {
        var t = Gv(e) || "item";
        return "    ".concat(JSON.stringify(t), ": item").concat(iC(e));
      });
      o.push("  data = _.map(data, item => ({\n".concat(u.join(",\n"), "\n  }))\n"));
    } else {
      var c = i.paths[0];
      o.push("  data = _.map(data, item => item".concat(iC(c), ")\n"));
    }
    return o.push("  return data\n"), "function query (data) {\n".concat(o.join(""), "}");
  },
  executeQuery: function executeQuery(e, t) {
    var n = new Function("_", '"use strict";\n\n' + t + '\n\nif (typeof query !== "function") {\n  throw new Error("Cannot execute query: expecting a function named \'query\' but is undefined")\n}\n\nreturn query;\n')(vx)(e);
    return void 0 !== n ? n : null;
  }
};
var xG = {};
!function (e) {
  function t(e) {
    return null !== e && "[object Array]" === Object.prototype.toString.call(e);
  }
  function n(e) {
    return null !== e && "[object Object]" === Object.prototype.toString.call(e);
  }
  function r(e, i) {
    if (e === i) return !0;
    if (Object.prototype.toString.call(e) !== Object.prototype.toString.call(i)) return !1;
    if (!0 === t(e)) {
      if (e.length !== i.length) return !1;
      for (var o = 0; o < e.length; o++) {
        if (!1 === r(e[o], i[o])) return !1;
      }
      return !0;
    }
    if (!0 === n(e)) {
      var a = {};
      for (var s in e) {
        if (hasOwnProperty.call(e, s)) {
          if (!1 === r(e[s], i[s])) return !1;
          a[s] = !0;
        }
      }
      for (var u in i) {
        if (hasOwnProperty.call(i, u) && !0 !== a[u]) return !1;
      }
      return !0;
    }
    return !1;
  }
  function i(e) {
    if ("" === e || !1 === e || null === e) return !0;
    if (t(e) && 0 === e.length) return !0;
    if (n(e)) {
      for (var r in e) {
        if (e.hasOwnProperty(r)) return !1;
      }
      return !0;
    }
    return !1;
  }
  var o;
  o = "function" == typeof String.prototype.trimLeft ? function (e) {
    return e.trimLeft();
  } : function (e) {
    return e.match(/^\s*(.*)/)[1];
  };
  var a = 0,
    s = 2,
    u = {
      0: "number",
      1: "any",
      2: "string",
      3: "array",
      4: "object",
      5: "boolean",
      6: "expression",
      7: "null",
      8: "Array<number>",
      9: "Array<string>"
    },
    c = "EOF",
    l = "UnquotedIdentifier",
    f = "QuotedIdentifier",
    h = "Rbracket",
    d = "Rparen",
    v = "Comma",
    p = "Colon",
    m = "Rbrace",
    g = "Number",
    y = "Current",
    b = "Expref",
    k = "Pipe",
    w = "Or",
    x = "And",
    j = "EQ",
    S = "GT",
    C = "LT",
    _ = "GTE",
    $ = "LTE",
    O = "NE",
    A = "Flatten",
    E = "Star",
    P = "Filter",
    M = "Dot",
    I = "Not",
    T = "Lbrace",
    N = "Lbracket",
    R = "Lparen",
    D = "Literal",
    z = {
      ".": M,
      "*": E,
      ",": v,
      ":": p,
      "{": T,
      "}": m,
      "]": h,
      "(": R,
      ")": d,
      "@": y
    },
    L = {
      "<": !0,
      ">": !0,
      "=": !0,
      "!": !0
    },
    B = {
      " ": !0,
      "\t": !0,
      "\n": !0
    };
  function q(e) {
    return e >= "0" && e <= "9" || "-" === e;
  }
  function F() {}
  F.prototype = {
    tokenize: function tokenize(e) {
      var t,
        n,
        r,
        i,
        o = [];
      for (this._current = 0; this._current < e.length;) {
        if ((i = e[this._current]) >= "a" && i <= "z" || i >= "A" && i <= "Z" || "_" === i) t = this._current, n = this._consumeUnquotedIdentifier(e), o.push({
          type: l,
          value: n,
          start: t
        });else if (void 0 !== z[e[this._current]]) o.push({
          type: z[e[this._current]],
          value: e[this._current],
          start: this._current
        }), this._current++;else if (q(e[this._current])) r = this._consumeNumber(e), o.push(r);else if ("[" === e[this._current]) r = this._consumeLBracket(e), o.push(r);else if ('"' === e[this._current]) t = this._current, n = this._consumeQuotedIdentifier(e), o.push({
          type: f,
          value: n,
          start: t
        });else if ("'" === e[this._current]) t = this._current, n = this._consumeRawStringLiteral(e), o.push({
          type: D,
          value: n,
          start: t
        });else if ("`" === e[this._current]) {
          t = this._current;
          var a = this._consumeLiteral(e);
          o.push({
            type: D,
            value: a,
            start: t
          });
        } else if (void 0 !== L[e[this._current]]) o.push(this._consumeOperator(e));else if (void 0 !== B[e[this._current]]) this._current++;else if ("&" === e[this._current]) t = this._current, this._current++, "&" === e[this._current] ? (this._current++, o.push({
          type: x,
          value: "&&",
          start: t
        })) : o.push({
          type: b,
          value: "&",
          start: t
        });else {
          if ("|" !== e[this._current]) {
            var s = new Error("Unknown character:" + e[this._current]);
            throw s.name = "LexerError", s;
          }
          t = this._current, this._current++, "|" === e[this._current] ? (this._current++, o.push({
            type: w,
            value: "||",
            start: t
          })) : o.push({
            type: k,
            value: "|",
            start: t
          });
        }
      }
      return o;
    },
    _consumeUnquotedIdentifier: function _consumeUnquotedIdentifier(e) {
      var t,
        n = this._current;
      for (this._current++; this._current < e.length && ((t = e[this._current]) >= "a" && t <= "z" || t >= "A" && t <= "Z" || t >= "0" && t <= "9" || "_" === t);) {
        this._current++;
      }
      return e.slice(n, this._current);
    },
    _consumeQuotedIdentifier: function _consumeQuotedIdentifier(e) {
      var t = this._current;
      this._current++;
      for (var n = e.length; '"' !== e[this._current] && this._current < n;) {
        var r = this._current;
        "\\" !== e[r] || "\\" !== e[r + 1] && '"' !== e[r + 1] ? r++ : r += 2, this._current = r;
      }
      return this._current++, JSON.parse(e.slice(t, this._current));
    },
    _consumeRawStringLiteral: function _consumeRawStringLiteral(e) {
      var t = this._current;
      this._current++;
      for (var n = e.length; "'" !== e[this._current] && this._current < n;) {
        var r = this._current;
        "\\" !== e[r] || "\\" !== e[r + 1] && "'" !== e[r + 1] ? r++ : r += 2, this._current = r;
      }
      return this._current++, e.slice(t + 1, this._current - 1).replace("\\'", "'");
    },
    _consumeNumber: function _consumeNumber(e) {
      var t = this._current;
      this._current++;
      for (var n = e.length; q(e[this._current]) && this._current < n;) {
        this._current++;
      }
      var r = parseInt(e.slice(t, this._current));
      return {
        type: g,
        value: r,
        start: t
      };
    },
    _consumeLBracket: function _consumeLBracket(e) {
      var t = this._current;
      return this._current++, "?" === e[this._current] ? (this._current++, {
        type: P,
        value: "[?",
        start: t
      }) : "]" === e[this._current] ? (this._current++, {
        type: A,
        value: "[]",
        start: t
      }) : {
        type: N,
        value: "[",
        start: t
      };
    },
    _consumeOperator: function _consumeOperator(e) {
      var t = this._current,
        n = e[t];
      return this._current++, "!" === n ? "=" === e[this._current] ? (this._current++, {
        type: O,
        value: "!=",
        start: t
      }) : {
        type: I,
        value: "!",
        start: t
      } : "<" === n ? "=" === e[this._current] ? (this._current++, {
        type: $,
        value: "<=",
        start: t
      }) : {
        type: C,
        value: "<",
        start: t
      } : ">" === n ? "=" === e[this._current] ? (this._current++, {
        type: _,
        value: ">=",
        start: t
      }) : {
        type: S,
        value: ">",
        start: t
      } : "=" === n && "=" === e[this._current] ? (this._current++, {
        type: j,
        value: "==",
        start: t
      }) : void 0;
    },
    _consumeLiteral: function _consumeLiteral(e) {
      this._current++;
      for (var t, n = this._current, r = e.length; "`" !== e[this._current] && this._current < r;) {
        var i = this._current;
        "\\" !== e[i] || "\\" !== e[i + 1] && "`" !== e[i + 1] ? i++ : i += 2, this._current = i;
      }
      var a = o(e.slice(n, this._current));
      return a = a.replace("\\`", "`"), t = this._looksLikeJSON(a) ? JSON.parse(a) : JSON.parse('"' + a + '"'), this._current++, t;
    },
    _looksLikeJSON: function _looksLikeJSON(e) {
      if ("" === e) return !1;
      if ('[{"'.indexOf(e[0]) >= 0) return !0;
      if (["true", "false", "null"].indexOf(e) >= 0) return !0;
      if (!("-0123456789".indexOf(e[0]) >= 0)) return !1;
      try {
        return JSON.parse(e), !0;
      } catch (e) {
        return !1;
      }
    }
  };
  var V = {};
  function H() {}
  function W(e) {
    this.runtime = e;
  }
  function U(e) {
    this._interpreter = e, this.functionTable = {
      abs: {
        _func: this._functionAbs,
        _signature: [{
          types: [a]
        }]
      },
      avg: {
        _func: this._functionAvg,
        _signature: [{
          types: [8]
        }]
      },
      ceil: {
        _func: this._functionCeil,
        _signature: [{
          types: [a]
        }]
      },
      contains: {
        _func: this._functionContains,
        _signature: [{
          types: [s, 3]
        }, {
          types: [1]
        }]
      },
      ends_with: {
        _func: this._functionEndsWith,
        _signature: [{
          types: [s]
        }, {
          types: [s]
        }]
      },
      floor: {
        _func: this._functionFloor,
        _signature: [{
          types: [a]
        }]
      },
      length: {
        _func: this._functionLength,
        _signature: [{
          types: [s, 3, 4]
        }]
      },
      map: {
        _func: this._functionMap,
        _signature: [{
          types: [6]
        }, {
          types: [3]
        }]
      },
      max: {
        _func: this._functionMax,
        _signature: [{
          types: [8, 9]
        }]
      },
      merge: {
        _func: this._functionMerge,
        _signature: [{
          types: [4],
          variadic: !0
        }]
      },
      max_by: {
        _func: this._functionMaxBy,
        _signature: [{
          types: [3]
        }, {
          types: [6]
        }]
      },
      sum: {
        _func: this._functionSum,
        _signature: [{
          types: [8]
        }]
      },
      starts_with: {
        _func: this._functionStartsWith,
        _signature: [{
          types: [s]
        }, {
          types: [s]
        }]
      },
      min: {
        _func: this._functionMin,
        _signature: [{
          types: [8, 9]
        }]
      },
      min_by: {
        _func: this._functionMinBy,
        _signature: [{
          types: [3]
        }, {
          types: [6]
        }]
      },
      type: {
        _func: this._functionType,
        _signature: [{
          types: [1]
        }]
      },
      keys: {
        _func: this._functionKeys,
        _signature: [{
          types: [4]
        }]
      },
      values: {
        _func: this._functionValues,
        _signature: [{
          types: [4]
        }]
      },
      sort: {
        _func: this._functionSort,
        _signature: [{
          types: [9, 8]
        }]
      },
      sort_by: {
        _func: this._functionSortBy,
        _signature: [{
          types: [3]
        }, {
          types: [6]
        }]
      },
      join: {
        _func: this._functionJoin,
        _signature: [{
          types: [s]
        }, {
          types: [9]
        }]
      },
      reverse: {
        _func: this._functionReverse,
        _signature: [{
          types: [s, 3]
        }]
      },
      to_array: {
        _func: this._functionToArray,
        _signature: [{
          types: [1]
        }]
      },
      to_string: {
        _func: this._functionToString,
        _signature: [{
          types: [1]
        }]
      },
      to_number: {
        _func: this._functionToNumber,
        _signature: [{
          types: [1]
        }]
      },
      not_null: {
        _func: this._functionNotNull,
        _signature: [{
          types: [1],
          variadic: !0
        }]
      }
    };
  }
  V.EOF = 0, V.UnquotedIdentifier = 0, V.QuotedIdentifier = 0, V.Rbracket = 0, V.Rparen = 0, V.Comma = 0, V.Rbrace = 0, V.Number = 0, V.Current = 0, V.Expref = 0, V.Pipe = 1, V.Or = 2, V.And = 3, V.EQ = 5, V.GT = 5, V.LT = 5, V.GTE = 5, V.LTE = 5, V.NE = 5, V.Flatten = 9, V.Star = 20, V.Filter = 21, V.Dot = 40, V.Not = 45, V.Lbrace = 50, V.Lbracket = 55, V.Lparen = 60, H.prototype = {
    parse: function parse(e) {
      this._loadTokens(e), this.index = 0;
      var t = this.expression(0);
      if (this._lookahead(0) !== c) {
        var n = this._lookaheadToken(0),
          r = new Error("Unexpected token type: " + n.type + ", value: " + n.value);
        throw r.name = "ParserError", r;
      }
      return t;
    },
    _loadTokens: function _loadTokens(e) {
      var t = new F().tokenize(e);
      t.push({
        type: c,
        value: "",
        start: e.length
      }), this.tokens = t;
    },
    expression: function expression(e) {
      var t = this._lookaheadToken(0);
      this._advance();
      for (var n = this.nud(t), r = this._lookahead(0); e < V[r];) {
        this._advance(), n = this.led(r, n), r = this._lookahead(0);
      }
      return n;
    },
    _lookahead: function _lookahead(e) {
      return this.tokens[this.index + e].type;
    },
    _lookaheadToken: function _lookaheadToken(e) {
      return this.tokens[this.index + e];
    },
    _advance: function _advance() {
      this.index++;
    },
    nud: function nud(e) {
      var t, n;
      switch (e.type) {
        case D:
          return {
            type: "Literal",
            value: e.value
          };
        case l:
          return {
            type: "Field",
            name: e.value
          };
        case f:
          var r = {
            type: "Field",
            name: e.value
          };
          if (this._lookahead(0) === R) throw new Error("Quoted identifier not allowed for function names.");
          return r;
        case I:
          return {
            type: "NotExpression",
            children: [t = this.expression(V.Not)]
          };
        case E:
          return t = null, {
            type: "ValueProjection",
            children: [{
              type: "Identity"
            }, t = this._lookahead(0) === h ? {
              type: "Identity"
            } : this._parseProjectionRHS(V.Star)]
          };
        case P:
          return this.led(e.type, {
            type: "Identity"
          });
        case T:
          return this._parseMultiselectHash();
        case A:
          return {
            type: "Projection",
            children: [{
              type: A,
              children: [{
                type: "Identity"
              }]
            }, t = this._parseProjectionRHS(V.Flatten)]
          };
        case N:
          return this._lookahead(0) === g || this._lookahead(0) === p ? (t = this._parseIndexExpression(), this._projectIfSlice({
            type: "Identity"
          }, t)) : this._lookahead(0) === E && this._lookahead(1) === h ? (this._advance(), this._advance(), {
            type: "Projection",
            children: [{
              type: "Identity"
            }, t = this._parseProjectionRHS(V.Star)]
          }) : this._parseMultiselectList();
        case y:
          return {
            type: y
          };
        case b:
          return {
            type: "ExpressionReference",
            children: [n = this.expression(V.Expref)]
          };
        case R:
          for (var i = []; this._lookahead(0) !== d;) {
            this._lookahead(0) === y ? (n = {
              type: y
            }, this._advance()) : n = this.expression(0), i.push(n);
          }
          return this._match(d), i[0];
        default:
          this._errorToken(e);
      }
    },
    led: function led(e, t) {
      var n;
      switch (e) {
        case M:
          var r = V.Dot;
          return this._lookahead(0) !== E ? {
            type: "Subexpression",
            children: [t, n = this._parseDotRHS(r)]
          } : (this._advance(), {
            type: "ValueProjection",
            children: [t, n = this._parseProjectionRHS(r)]
          });
        case k:
          return n = this.expression(V.Pipe), {
            type: k,
            children: [t, n]
          };
        case w:
          return {
            type: "OrExpression",
            children: [t, n = this.expression(V.Or)]
          };
        case x:
          return {
            type: "AndExpression",
            children: [t, n = this.expression(V.And)]
          };
        case R:
          for (var i, o = t.name, a = []; this._lookahead(0) !== d;) {
            this._lookahead(0) === y ? (i = {
              type: y
            }, this._advance()) : i = this.expression(0), this._lookahead(0) === v && this._match(v), a.push(i);
          }
          return this._match(d), {
            type: "Function",
            name: o,
            children: a
          };
        case P:
          var s = this.expression(0);
          return this._match(h), {
            type: "FilterProjection",
            children: [t, n = this._lookahead(0) === A ? {
              type: "Identity"
            } : this._parseProjectionRHS(V.Filter), s]
          };
        case A:
          return {
            type: "Projection",
            children: [{
              type: A,
              children: [t]
            }, this._parseProjectionRHS(V.Flatten)]
          };
        case j:
        case O:
        case S:
        case _:
        case C:
        case $:
          return this._parseComparator(t, e);
        case N:
          var u = this._lookaheadToken(0);
          return u.type === g || u.type === p ? (n = this._parseIndexExpression(), this._projectIfSlice(t, n)) : (this._match(E), this._match(h), {
            type: "Projection",
            children: [t, n = this._parseProjectionRHS(V.Star)]
          });
        default:
          this._errorToken(this._lookaheadToken(0));
      }
    },
    _match: function _match(e) {
      if (this._lookahead(0) !== e) {
        var t = this._lookaheadToken(0),
          n = new Error("Expected " + e + ", got: " + t.type);
        throw n.name = "ParserError", n;
      }
      this._advance();
    },
    _errorToken: function _errorToken(e) {
      var t = new Error("Invalid token (" + e.type + '): "' + e.value + '"');
      throw t.name = "ParserError", t;
    },
    _parseIndexExpression: function _parseIndexExpression() {
      if (this._lookahead(0) === p || this._lookahead(1) === p) return this._parseSliceExpression();
      var e = {
        type: "Index",
        value: this._lookaheadToken(0).value
      };
      return this._advance(), this._match(h), e;
    },
    _projectIfSlice: function _projectIfSlice(e, t) {
      var n = {
        type: "IndexExpression",
        children: [e, t]
      };
      return "Slice" === t.type ? {
        type: "Projection",
        children: [n, this._parseProjectionRHS(V.Star)]
      } : n;
    },
    _parseSliceExpression: function _parseSliceExpression() {
      for (var e = [null, null, null], t = 0, n = this._lookahead(0); n !== h && t < 3;) {
        if (n === p) t++, this._advance();else {
          if (n !== g) {
            var r = this._lookahead(0),
              i = new Error("Syntax error, unexpected token: " + r.value + "(" + r.type + ")");
            throw i.name = "Parsererror", i;
          }
          e[t] = this._lookaheadToken(0).value, this._advance();
        }
        n = this._lookahead(0);
      }
      return this._match(h), {
        type: "Slice",
        children: e
      };
    },
    _parseComparator: function _parseComparator(e, t) {
      return {
        type: "Comparator",
        name: t,
        children: [e, this.expression(V[t])]
      };
    },
    _parseDotRHS: function _parseDotRHS(e) {
      var t = this._lookahead(0);
      return [l, f, E].indexOf(t) >= 0 ? this.expression(e) : t === N ? (this._match(N), this._parseMultiselectList()) : t === T ? (this._match(T), this._parseMultiselectHash()) : void 0;
    },
    _parseProjectionRHS: function _parseProjectionRHS(e) {
      var t;
      if (V[this._lookahead(0)] < 10) t = {
        type: "Identity"
      };else if (this._lookahead(0) === N) t = this.expression(e);else if (this._lookahead(0) === P) t = this.expression(e);else {
        if (this._lookahead(0) !== M) {
          var n = this._lookaheadToken(0),
            r = new Error("Sytanx error, unexpected token: " + n.value + "(" + n.type + ")");
          throw r.name = "ParserError", r;
        }
        this._match(M), t = this._parseDotRHS(e);
      }
      return t;
    },
    _parseMultiselectList: function _parseMultiselectList() {
      for (var e = []; this._lookahead(0) !== h;) {
        var t = this.expression(0);
        if (e.push(t), this._lookahead(0) === v && (this._match(v), this._lookahead(0) === h)) throw new Error("Unexpected token Rbracket");
      }
      return this._match(h), {
        type: "MultiSelectList",
        children: e
      };
    },
    _parseMultiselectHash: function _parseMultiselectHash() {
      for (var e, t, n, r = [], i = [l, f];;) {
        if (e = this._lookaheadToken(0), i.indexOf(e.type) < 0) throw new Error("Expecting an identifier token, got: " + e.type);
        if (t = e.value, this._advance(), this._match(p), n = {
          type: "KeyValuePair",
          name: t,
          value: this.expression(0)
        }, r.push(n), this._lookahead(0) === v) this._match(v);else if (this._lookahead(0) === m) {
          this._match(m);
          break;
        }
      }
      return {
        type: "MultiSelectHash",
        children: r
      };
    }
  }, W.prototype = {
    search: function search(e, t) {
      return this.visit(e, t);
    },
    visit: function visit(e, o) {
      var a, s, u, c, l, f, h, d, v;
      switch (e.type) {
        case "Field":
          return null !== o && n(o) ? void 0 === (f = o[e.name]) ? null : f : null;
        case "Subexpression":
          for (u = this.visit(e.children[0], o), v = 1; v < e.children.length; v++) {
            if (null === (u = this.visit(e.children[1], u))) return null;
          }
          return u;
        case "IndexExpression":
          return h = this.visit(e.children[0], o), this.visit(e.children[1], h);
        case "Index":
          if (!t(o)) return null;
          var p = e.value;
          return p < 0 && (p = o.length + p), void 0 === (u = o[p]) && (u = null), u;
        case "Slice":
          if (!t(o)) return null;
          var m = e.children.slice(0),
            g = this.computeSliceParams(o.length, m),
            w = g[0],
            x = g[1],
            E = g[2];
          if (u = [], E > 0) for (v = w; v < x; v += E) {
            u.push(o[v]);
          } else for (v = w; v > x; v += E) {
            u.push(o[v]);
          }
          return u;
        case "Projection":
          var P = this.visit(e.children[0], o);
          if (!t(P)) return null;
          for (d = [], v = 0; v < P.length; v++) {
            null !== (s = this.visit(e.children[1], P[v])) && d.push(s);
          }
          return d;
        case "ValueProjection":
          if (!n(P = this.visit(e.children[0], o))) return null;
          d = [];
          var M = function (e) {
            for (var t = Object.keys(e), n = [], r = 0; r < t.length; r++) {
              n.push(e[t[r]]);
            }
            return n;
          }(P);
          for (v = 0; v < M.length; v++) {
            null !== (s = this.visit(e.children[1], M[v])) && d.push(s);
          }
          return d;
        case "FilterProjection":
          if (!t(P = this.visit(e.children[0], o))) return null;
          var I = [],
            T = [];
          for (v = 0; v < P.length; v++) {
            i(a = this.visit(e.children[2], P[v])) || I.push(P[v]);
          }
          for (var N = 0; N < I.length; N++) {
            null !== (s = this.visit(e.children[1], I[N])) && T.push(s);
          }
          return T;
        case "Comparator":
          switch (c = this.visit(e.children[0], o), l = this.visit(e.children[1], o), e.name) {
            case j:
              u = r(c, l);
              break;
            case O:
              u = !r(c, l);
              break;
            case S:
              u = c > l;
              break;
            case _:
              u = c >= l;
              break;
            case C:
              u = c < l;
              break;
            case $:
              u = c <= l;
              break;
            default:
              throw new Error("Unknown comparator: " + e.name);
          }
          return u;
        case A:
          var R = this.visit(e.children[0], o);
          if (!t(R)) return null;
          var D = [];
          for (v = 0; v < R.length; v++) {
            t(s = R[v]) ? D.push.apply(D, s) : D.push(s);
          }
          return D;
        case "Identity":
          return o;
        case "MultiSelectList":
          if (null === o) return null;
          for (d = [], v = 0; v < e.children.length; v++) {
            d.push(this.visit(e.children[v], o));
          }
          return d;
        case "MultiSelectHash":
          if (null === o) return null;
          var z;
          for (d = {}, v = 0; v < e.children.length; v++) {
            d[(z = e.children[v]).name] = this.visit(z.value, o);
          }
          return d;
        case "OrExpression":
          return i(a = this.visit(e.children[0], o)) && (a = this.visit(e.children[1], o)), a;
        case "AndExpression":
          return !0 === i(c = this.visit(e.children[0], o)) ? c : this.visit(e.children[1], o);
        case "NotExpression":
          return i(c = this.visit(e.children[0], o));
        case "Literal":
          return e.value;
        case k:
          return h = this.visit(e.children[0], o), this.visit(e.children[1], h);
        case y:
          return o;
        case "Function":
          var L = [];
          for (v = 0; v < e.children.length; v++) {
            L.push(this.visit(e.children[v], o));
          }
          return this.runtime.callFunction(e.name, L);
        case "ExpressionReference":
          var B = e.children[0];
          return B.jmespathType = b, B;
        default:
          throw new Error("Unknown node type: " + e.type);
      }
    },
    computeSliceParams: function computeSliceParams(e, t) {
      var n = t[0],
        r = t[1],
        i = t[2],
        o = [null, null, null];
      if (null === i) i = 1;else if (0 === i) {
        var a = new Error("Invalid slice, step cannot be 0");
        throw a.name = "RuntimeError", a;
      }
      var s = i < 0;
      return n = null === n ? s ? e - 1 : 0 : this.capSliceRange(e, n, i), r = null === r ? s ? -1 : e : this.capSliceRange(e, r, i), o[0] = n, o[1] = r, o[2] = i, o;
    },
    capSliceRange: function capSliceRange(e, t, n) {
      return t < 0 ? (t += e) < 0 && (t = n < 0 ? -1 : 0) : t >= e && (t = n < 0 ? e - 1 : e), t;
    }
  }, U.prototype = {
    callFunction: function callFunction(e, t) {
      var n = this.functionTable[e];
      if (void 0 === n) throw new Error("Unknown function: " + e + "()");
      return this._validateArgs(e, t, n._signature), n._func.call(this, t);
    },
    _validateArgs: function _validateArgs(e, t, n) {
      var r, i, o, a;
      if (n[n.length - 1].variadic) {
        if (t.length < n.length) throw r = 1 === n.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes at least" + n.length + r + " but received " + t.length);
      } else if (t.length !== n.length) throw r = 1 === n.length ? " argument" : " arguments", new Error("ArgumentError: " + e + "() takes " + n.length + r + " but received " + t.length);
      for (var s = 0; s < n.length; s++) {
        a = !1, i = n[s].types, o = this._getTypeName(t[s]);
        for (var c = 0; c < i.length; c++) {
          if (this._typeMatches(o, i[c], t[s])) {
            a = !0;
            break;
          }
        }
        if (!a) {
          var l = i.map(function (e) {
            return u[e];
          }).join(",");
          throw new Error("TypeError: " + e + "() expected argument " + (s + 1) + " to be type " + l + " but received type " + u[o] + " instead.");
        }
      }
    },
    _typeMatches: function _typeMatches(e, t, n) {
      if (1 === t) return !0;
      if (9 !== t && 8 !== t && 3 !== t) return e === t;
      if (3 === t) return 3 === e;
      if (3 === e) {
        var r;
        8 === t ? r = a : 9 === t && (r = s);
        for (var i = 0; i < n.length; i++) {
          if (!this._typeMatches(this._getTypeName(n[i]), r, n[i])) return !1;
        }
        return !0;
      }
    },
    _getTypeName: function _getTypeName(e) {
      switch (Object.prototype.toString.call(e)) {
        case "[object String]":
          return s;
        case "[object Number]":
          return a;
        case "[object Array]":
          return 3;
        case "[object Boolean]":
          return 5;
        case "[object Null]":
          return 7;
        case "[object Object]":
          return e.jmespathType === b ? 6 : 4;
      }
    },
    _functionStartsWith: function _functionStartsWith(e) {
      return 0 === e[0].lastIndexOf(e[1]);
    },
    _functionEndsWith: function _functionEndsWith(e) {
      var t = e[0],
        n = e[1];
      return -1 !== t.indexOf(n, t.length - n.length);
    },
    _functionReverse: function _functionReverse(e) {
      if (this._getTypeName(e[0]) === s) {
        for (var t = e[0], n = "", r = t.length - 1; r >= 0; r--) {
          n += t[r];
        }
        return n;
      }
      var i = e[0].slice(0);
      return i.reverse(), i;
    },
    _functionAbs: function _functionAbs(e) {
      return Math.abs(e[0]);
    },
    _functionCeil: function _functionCeil(e) {
      return Math.ceil(e[0]);
    },
    _functionAvg: function _functionAvg(e) {
      for (var t = 0, n = e[0], r = 0; r < n.length; r++) {
        t += n[r];
      }
      return t / n.length;
    },
    _functionContains: function _functionContains(e) {
      return e[0].indexOf(e[1]) >= 0;
    },
    _functionFloor: function _functionFloor(e) {
      return Math.floor(e[0]);
    },
    _functionLength: function _functionLength(e) {
      return n(e[0]) ? Object.keys(e[0]).length : e[0].length;
    },
    _functionMap: function _functionMap(e) {
      for (var t = [], n = this._interpreter, r = e[0], i = e[1], o = 0; o < i.length; o++) {
        t.push(n.visit(r, i[o]));
      }
      return t;
    },
    _functionMerge: function _functionMerge(e) {
      for (var t = {}, n = 0; n < e.length; n++) {
        var r = e[n];
        for (var i in r) {
          t[i] = r[i];
        }
      }
      return t;
    },
    _functionMax: function _functionMax(e) {
      if (e[0].length > 0) {
        if (this._getTypeName(e[0][0]) === a) return Math.max.apply(Math, e[0]);
        for (var t = e[0], n = t[0], r = 1; r < t.length; r++) {
          n.localeCompare(t[r]) < 0 && (n = t[r]);
        }
        return n;
      }
      return null;
    },
    _functionMin: function _functionMin(e) {
      if (e[0].length > 0) {
        if (this._getTypeName(e[0][0]) === a) return Math.min.apply(Math, e[0]);
        for (var t = e[0], n = t[0], r = 1; r < t.length; r++) {
          t[r].localeCompare(n) < 0 && (n = t[r]);
        }
        return n;
      }
      return null;
    },
    _functionSum: function _functionSum(e) {
      for (var t = 0, n = e[0], r = 0; r < n.length; r++) {
        t += n[r];
      }
      return t;
    },
    _functionType: function _functionType(e) {
      switch (this._getTypeName(e[0])) {
        case a:
          return "number";
        case s:
          return "string";
        case 3:
          return "array";
        case 4:
          return "object";
        case 5:
          return "boolean";
        case 6:
          return "expref";
        case 7:
          return "null";
      }
    },
    _functionKeys: function _functionKeys(e) {
      return Object.keys(e[0]);
    },
    _functionValues: function _functionValues(e) {
      for (var t = e[0], n = Object.keys(t), r = [], i = 0; i < n.length; i++) {
        r.push(t[n[i]]);
      }
      return r;
    },
    _functionJoin: function _functionJoin(e) {
      var t = e[0];
      return e[1].join(t);
    },
    _functionToArray: function _functionToArray(e) {
      return 3 === this._getTypeName(e[0]) ? e[0] : [e[0]];
    },
    _functionToString: function _functionToString(e) {
      return this._getTypeName(e[0]) === s ? e[0] : JSON.stringify(e[0]);
    },
    _functionToNumber: function _functionToNumber(e) {
      var t,
        n = this._getTypeName(e[0]);
      return n === a ? e[0] : n !== s || (t = +e[0], isNaN(t)) ? null : t;
    },
    _functionNotNull: function _functionNotNull(e) {
      for (var t = 0; t < e.length; t++) {
        if (7 !== this._getTypeName(e[t])) return e[t];
      }
      return null;
    },
    _functionSort: function _functionSort(e) {
      var t = e[0].slice(0);
      return t.sort(), t;
    },
    _functionSortBy: function _functionSortBy(e) {
      var t = e[0].slice(0);
      if (0 === t.length) return t;
      var n = this._interpreter,
        r = e[1],
        i = this._getTypeName(n.visit(r, t[0]));
      if ([a, s].indexOf(i) < 0) throw new Error("TypeError");
      for (var o = this, u = [], c = 0; c < t.length; c++) {
        u.push([c, t[c]]);
      }
      u.sort(function (e, t) {
        var a = n.visit(r, e[1]),
          s = n.visit(r, t[1]);
        if (o._getTypeName(a) !== i) throw new Error("TypeError: expected " + i + ", received " + o._getTypeName(a));
        if (o._getTypeName(s) !== i) throw new Error("TypeError: expected " + i + ", received " + o._getTypeName(s));
        return a > s ? 1 : a < s ? -1 : e[0] - t[0];
      });
      for (var l = 0; l < u.length; l++) {
        t[l] = u[l][1];
      }
      return t;
    },
    _functionMaxBy: function _functionMaxBy(e) {
      for (var t, n, r = e[1], i = e[0], o = this.createKeyFunction(r, [a, s]), u = -1 / 0, c = 0; c < i.length; c++) {
        (n = o(i[c])) > u && (u = n, t = i[c]);
      }
      return t;
    },
    _functionMinBy: function _functionMinBy(e) {
      for (var t, n, r = e[1], i = e[0], o = this.createKeyFunction(r, [a, s]), u = 1 / 0, c = 0; c < i.length; c++) {
        (n = o(i[c])) < u && (u = n, t = i[c]);
      }
      return t;
    },
    createKeyFunction: function createKeyFunction(e, t) {
      var n = this,
        r = this._interpreter;
      return function (i) {
        var o = r.visit(e, i);
        if (t.indexOf(n._getTypeName(o)) < 0) {
          var a = "TypeError: expected one of " + t + ", received " + n._getTypeName(o);
          throw new Error(a);
        }
        return o;
      };
    }
  }, e.tokenize = function (e) {
    return new F().tokenize(e);
  }, e.compile = function (e) {
    return new H().parse(e);
  }, e.search = function (e, t) {
    var n = new H(),
      r = new U(),
      i = new W(r);
    r._interpreter = i;
    var o = n.parse(t);
    return i.search(o, e);
  }, e.strictDeepEqual = r;
}(xG);
var jG = {
  id: "jmespath",
  name: "JMESPath",
  description: '\n<p>\n  Enter a <a href="https://jmespath.org" target="_blank" rel="noopener noreferrer">JMESPath</a> query \n  to filter, sort, or transform the JSON data.\n To learn JMESPath, go to <a href="https://jmespath.org/tutorial.html" target="_blank" rel="noopener noreferrer">the interactive tutorial</a>.\n</p>\n',
  createQuery: function createQuery(e, t) {
    var n = t.sort,
      r = t.filter,
      i = t.projection,
      o = "";
    if (r && r.path && r.relation && r.value) {
      var a = ["0"].concat(r.path),
        s = ks.exports.getIn(e, a),
        u = bF(r.value),
        c = "string" == typeof s && null != u ? JSON.stringify(r.value) : JSON.stringify(u);
      o += "[? " + SG(r.path) + " " + r.relation + " `" + c + "`]";
    } else o += Array.isArray(e) ? "[*]" : "@";
    n && n.path && n.direction && ("desc" === n.direction ? o += " | reverse(sort_by(@, &" + SG(n.path) + "))" : o += " | sort_by(@, &" + SG(n.path) + ")");
    if (i && i.paths) if ("]" !== o[o.length - 1] && (o += " | [*]"), 1 === i.paths.length) {
      var l = i.paths[0];
      o += 0 === l.length ? "" : "." + SG(l);
    } else i.paths.length > 1 && (o += ".{" + i.paths.map(function (e) {
      return e[e.length - 1] + ": " + SG(e);
    }).join(", ") + "}");
    return o;
  },
  executeQuery: function executeQuery(e, t) {
    return xG.search(e, t);
  }
};
function SG(e) {
  if (0 === e.length) return "@";
  var t = e.map(function (e) {
    return "number" == typeof e ? "[" + e + "]" : "string" == typeof e && e.match(/^[A-Za-z\d_$]+$/) ? "." + e : '."' + String(e) + '"';
  }).join("");
  return "." === t[0] ? t.slice(1) : t;
}
/*!
 * vanilla-picker v2.12.1
 * https://vanilla-picker.js.org
 *
 * Copyright 2017-2021 Andreas Borgen (https://github.com/Sphinxxxx), Adam Brooks (https://github.com/dissimulate)
 * Released under the ISC license.
 */
var CG = function CG(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  },
  _G = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }
    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
  $G = function $G(e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) return function (e, t) {
      var n = [],
        r = !0,
        i = !1,
        o = void 0;
      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        i = !0, o = e;
      } finally {
        try {
          !r && s.return && s.return();
        } finally {
          if (i) throw o;
        }
      }
      return n;
    }(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
String.prototype.startsWith = String.prototype.startsWith || function (e) {
  return 0 === this.indexOf(e);
}, String.prototype.padStart = String.prototype.padStart || function (e, t) {
  for (var n = this; n.length < e;) {
    n = t + n;
  }
  return n;
};
var OG = {
  cb: "0f8ff",
  tqw: "aebd7",
  q: "-ffff",
  qmrn: "7fffd4",
  zr: "0ffff",
  bg: "5f5dc",
  bsq: "e4c4",
  bck: "---",
  nch: "ebcd",
  b: "--ff",
  bvt: "8a2be2",
  brwn: "a52a2a",
  brw: "deb887",
  ctb: "5f9ea0",
  hrt: "7fff-",
  chcT: "d2691e",
  cr: "7f50",
  rnw: "6495ed",
  crns: "8dc",
  crms: "dc143c",
  cn: "-ffff",
  Db: "--8b",
  Dcn: "-8b8b",
  Dgnr: "b8860b",
  Dgr: "a9a9a9",
  Dgrn: "-64-",
  Dkhk: "bdb76b",
  Dmgn: "8b-8b",
  Dvgr: "556b2f",
  Drng: "8c-",
  Drch: "9932cc",
  Dr: "8b--",
  Dsmn: "e9967a",
  Dsgr: "8fbc8f",
  DsTb: "483d8b",
  DsTg: "2f4f4f",
  Dtrq: "-ced1",
  Dvt: "94-d3",
  ppnk: "1493",
  pskb: "-bfff",
  mgr: "696969",
  grb: "1e90ff",
  rbrc: "b22222",
  rwht: "af0",
  stg: "228b22",
  chs: "-ff",
  gnsb: "dcdcdc",
  st: "8f8ff",
  g: "d7-",
  gnr: "daa520",
  gr: "808080",
  grn: "-8-0",
  grnw: "adff2f",
  hnw: "0fff0",
  htpn: "69b4",
  nnr: "cd5c5c",
  ng: "4b-82",
  vr: "0",
  khk: "0e68c",
  vnr: "e6e6fa",
  nrb: "0f5",
  wngr: "7cfc-",
  mnch: "acd",
  Lb: "add8e6",
  Lcr: "08080",
  Lcn: "e0ffff",
  Lgnr: "afad2",
  Lgr: "d3d3d3",
  Lgrn: "90ee90",
  Lpnk: "b6c1",
  Lsmn: "a07a",
  Lsgr: "20b2aa",
  Lskb: "87cefa",
  LsTg: "778899",
  Lstb: "b0c4de",
  Lw: "e0",
  m: "-ff-",
  mgrn: "32cd32",
  nn: "af0e6",
  mgnt: "-ff",
  mrn: "8--0",
  mqm: "66cdaa",
  mmb: "--cd",
  mmrc: "ba55d3",
  mmpr: "9370db",
  msg: "3cb371",
  mmsT: "7b68ee",
  "": "-fa9a",
  mtr: "48d1cc",
  mmvt: "c71585",
  mnLb: "191970",
  ntc: "5fffa",
  mstr: "e4e1",
  mccs: "e4b5",
  vjw: "dead",
  nv: "--80",
  c: "df5e6",
  v: "808-0",
  vrb: "6b8e23",
  rng: "a5-",
  rngr: "45-",
  rch: "da70d6",
  pgnr: "eee8aa",
  pgrn: "98fb98",
  ptrq: "afeeee",
  pvtr: "db7093",
  ppwh: "efd5",
  pchp: "dab9",
  pr: "cd853f",
  pnk: "c0cb",
  pm: "dda0dd",
  pwrb: "b0e0e6",
  prp: "8-080",
  cc: "663399",
  r: "--",
  sbr: "bc8f8f",
  rb: "4169e1",
  sbrw: "8b4513",
  smn: "a8072",
  nbr: "4a460",
  sgrn: "2e8b57",
  ssh: "5ee",
  snn: "a0522d",
  svr: "c0c0c0",
  skb: "87ceeb",
  sTb: "6a5acd",
  sTgr: "708090",
  snw: "afa",
  n: "-ff7f",
  stb: "4682b4",
  tn: "d2b48c",
  t: "-8080",
  thst: "d8bfd8",
  tmT: "6347",
  trqs: "40e0d0",
  vt: "ee82ee",
  whT: "5deb3",
  wht: "",
  hts: "5f5f5",
  w: "-",
  wgrn: "9acd32"
};
function AG(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
    n = t > 0 ? e.toFixed(t).replace(/0+$/, "").replace(/\.$/, "") : e.toString();
  return n || "0";
}
var EG = function () {
    function e(t, n, r, i) {
      CG(this, e);
      var o = this;
      if (void 0 === t) ;else if (Array.isArray(t)) this.rgba = t;else if (void 0 === r) {
        var a = t && "" + t;
        a && function (t) {
          if (t.startsWith("hsl")) {
            var n = t.match(/([\-\d\.e]+)/g).map(Number),
              r = $G(n, 4),
              i = r[0],
              a = r[1],
              s = r[2],
              u = r[3];
            void 0 === u && (u = 1), i /= 360, a /= 100, s /= 100, o.hsla = [i, a, s, u];
          } else if (t.startsWith("rgb")) {
            var c = t.match(/([\-\d\.e]+)/g).map(Number),
              l = $G(c, 4),
              f = l[0],
              h = l[1],
              d = l[2],
              v = l[3];
            void 0 === v && (v = 1), o.rgba = [f, h, d, v];
          } else t.startsWith("#") ? o.rgba = e.hexToRgb(t) : o.rgba = e.nameToRgb(t) || e.hexToRgb(t);
        }(a.toLowerCase());
      } else this.rgba = [t, n, r, void 0 === i ? 1 : i];
    }
    return _G(e, [{
      key: "printRGB",
      value: function value(e) {
        var t = (e ? this.rgba : this.rgba.slice(0, 3)).map(function (e, t) {
          return AG(e, 3 === t ? 3 : 0);
        });
        return e ? "rgba(" + t + ")" : "rgb(" + t + ")";
      }
    }, {
      key: "printHSL",
      value: function value(e) {
        var t = [360, 100, 100, 1],
          n = ["", "%", "%", ""],
          r = (e ? this.hsla : this.hsla.slice(0, 3)).map(function (e, r) {
            return AG(e * t[r], 3 === r ? 3 : 1) + n[r];
          });
        return e ? "hsla(" + r + ")" : "hsl(" + r + ")";
      }
    }, {
      key: "printHex",
      value: function value(e) {
        var t = this.hex;
        return e ? t : t.substring(0, 7);
      }
    }, {
      key: "rgba",
      get: function get() {
        if (this._rgba) return this._rgba;
        if (!this._hsla) throw new Error("No color is set");
        return this._rgba = e.hslToRgb(this._hsla);
      },
      set: function set(e) {
        3 === e.length && (e[3] = 1), this._rgba = e, this._hsla = null;
      }
    }, {
      key: "rgbString",
      get: function get() {
        return this.printRGB();
      }
    }, {
      key: "rgbaString",
      get: function get() {
        return this.printRGB(!0);
      }
    }, {
      key: "hsla",
      get: function get() {
        if (this._hsla) return this._hsla;
        if (!this._rgba) throw new Error("No color is set");
        return this._hsla = e.rgbToHsl(this._rgba);
      },
      set: function set(e) {
        3 === e.length && (e[3] = 1), this._hsla = e, this._rgba = null;
      }
    }, {
      key: "hslString",
      get: function get() {
        return this.printHSL();
      }
    }, {
      key: "hslaString",
      get: function get() {
        return this.printHSL(!0);
      }
    }, {
      key: "hex",
      get: function get() {
        return "#" + this.rgba.map(function (e, t) {
          return t < 3 ? e.toString(16) : Math.round(255 * e).toString(16);
        }).map(function (e) {
          return e.padStart(2, "0");
        }).join("");
      },
      set: function set(t) {
        this.rgba = e.hexToRgb(t);
      }
    }], [{
      key: "hexToRgb",
      value: function value(e) {
        var t = (e.startsWith("#") ? e.slice(1) : e).replace(/^(\w{3})$/, "$1F").replace(/^(\w)(\w)(\w)(\w)$/, "$1$1$2$2$3$3$4$4").replace(/^(\w{6})$/, "$1FF");
        if (!t.match(/^([0-9a-fA-F]{8})$/)) throw new Error("Unknown hex color; " + e);
        var n = t.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function (e) {
          return parseInt(e, 16);
        });
        return n[3] = n[3] / 255, n;
      }
    }, {
      key: "nameToRgb",
      value: function value(t) {
        var n = t.toLowerCase().replace("at", "T").replace(/[aeiouyldf]/g, "").replace("ght", "L").replace("rk", "D").slice(-5, 4),
          r = OG[n];
        return void 0 === r ? r : e.hexToRgb(r.replace(/\-/g, "00").padStart(6, "f"));
      }
    }, {
      key: "rgbToHsl",
      value: function value(e) {
        var t = $G(e, 4),
          n = t[0],
          r = t[1],
          i = t[2],
          o = t[3];
        n /= 255, r /= 255, i /= 255;
        var a = Math.max(n, r, i),
          s = Math.min(n, r, i),
          u = void 0,
          c = void 0,
          l = (a + s) / 2;
        if (a === s) u = c = 0;else {
          var f = a - s;
          switch (c = l > .5 ? f / (2 - a - s) : f / (a + s), a) {
            case n:
              u = (r - i) / f + (r < i ? 6 : 0);
              break;
            case r:
              u = (i - n) / f + 2;
              break;
            case i:
              u = (n - r) / f + 4;
          }
          u /= 6;
        }
        return [u, c, l, o];
      }
    }, {
      key: "hslToRgb",
      value: function value(e) {
        var t = $G(e, 4),
          n = t[0],
          r = t[1],
          i = t[2],
          o = t[3],
          a = void 0,
          s = void 0,
          u = void 0;
        if (0 === r) a = s = u = i;else {
          var c = function c(e, t, n) {
              return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
            },
            l = i < .5 ? i * (1 + r) : i + r - i * r,
            f = 2 * i - l;
          a = c(f, l, n + 1 / 3), s = c(f, l, n), u = c(f, l, n - 1 / 3);
        }
        var h = [255 * a, 255 * s, 255 * u].map(Math.round);
        return h[3] = o, h;
      }
    }]), e;
  }(),
  PG = function () {
    function e() {
      CG(this, e), this._events = [];
    }
    return _G(e, [{
      key: "add",
      value: function value(e, t, n) {
        e.addEventListener(t, n, !1), this._events.push({
          target: e,
          type: t,
          handler: n
        });
      }
    }, {
      key: "remove",
      value: function value(t, n, r) {
        this._events = this._events.filter(function (i) {
          var o = !0;
          return t && t !== i.target && (o = !1), n && n !== i.type && (o = !1), r && r !== i.handler && (o = !1), o && e._doRemove(i.target, i.type, i.handler), !o;
        });
      }
    }, {
      key: "destroy",
      value: function value() {
        this._events.forEach(function (t) {
          return e._doRemove(t.target, t.type, t.handler);
        }), this._events = [];
      }
    }], [{
      key: "_doRemove",
      value: function value(e, t, n) {
        e.removeEventListener(t, n, !1);
      }
    }]), e;
  }();
function MG(e, t, n) {
  var r = !1;
  function i(e, t, n) {
    return Math.max(t, Math.min(e, n));
  }
  function o(e, o, a) {
    if (a && (r = !0), r) {
      e.preventDefault();
      var s = t.getBoundingClientRect(),
        u = s.width,
        c = s.height,
        l = o.clientX,
        f = o.clientY,
        h = i(l - s.left, 0, u),
        d = i(f - s.top, 0, c);
      n(h / u, d / c);
    }
  }
  function a(e, t) {
    1 === (void 0 === e.buttons ? e.which : e.buttons) ? o(e, e, t) : r = !1;
  }
  function s(e, t) {
    1 === e.touches.length ? o(e, e.touches[0], t) : r = !1;
  }
  e.add(t, "mousedown", function (e) {
    a(e, !0);
  }), e.add(t, "touchstart", function (e) {
    s(e, !0);
  }), e.add(window, "mousemove", a), e.add(t, "touchmove", s), e.add(window, "mouseup", function (e) {
    r = !1;
  }), e.add(t, "touchend", function (e) {
    r = !1;
  }), e.add(t, "touchcancel", function (e) {
    r = !1;
  });
}
function IG(e, t) {
  return (t || document).querySelector(e);
}
function TG(e) {
  e.preventDefault(), e.stopPropagation();
}
function NG(e, t, n, r, i) {
  e.add(t, "keydown", function (e) {
    n.indexOf(e.key) >= 0 && (i && TG(e), r(e));
  });
}
var RG = function () {
    function e(t) {
      CG(this, e), this.settings = {
        popup: "right",
        layout: "default",
        alpha: !0,
        editor: !0,
        editorFormat: "hex",
        cancelButton: !1,
        defaultColor: "#0cf"
      }, this._events = new PG(), this.onChange = null, this.onDone = null, this.onOpen = null, this.onClose = null, this.setOptions(t);
    }
    return _G(e, [{
      key: "setOptions",
      value: function value(e) {
        var t = this;
        if (e) {
          var n = this.settings;
          if (e instanceof HTMLElement) n.parent = e;else {
            n.parent && e.parent && n.parent !== e.parent && (this._events.remove(n.parent), this._popupInited = !1), function (e, t, n) {
              for (var r in e) {
                n && n.indexOf(r) >= 0 || (t[r] = e[r]);
              }
            }(e, n), e.onChange && (this.onChange = e.onChange), e.onDone && (this.onDone = e.onDone), e.onOpen && (this.onOpen = e.onOpen), e.onClose && (this.onClose = e.onClose);
            var r = e.color || e.colour;
            r && this._setColor(r);
          }
          var i = n.parent;
          if (i && n.popup && !this._popupInited) {
            var o = function o(e) {
              return t.openHandler(e);
            };
            this._events.add(i, "click", o), NG(this._events, i, [" ", "Spacebar", "Enter"], o), this._popupInited = !0;
          } else e.parent && !n.popup && this.show();
        }
      }
    }, {
      key: "openHandler",
      value: function value(e) {
        if (this.show()) {
          e && e.preventDefault(), this.settings.parent.style.pointerEvents = "none";
          var t = e && "keydown" === e.type ? this._domEdit : this.domElement;
          setTimeout(function () {
            return t.focus();
          }, 100), this.onOpen && this.onOpen(this.colour);
        }
      }
    }, {
      key: "closeHandler",
      value: function value(e) {
        var t = e && e.type,
          n = !1;
        if (e) {
          if ("mousedown" === t || "focusin" === t) {
            var r = (this.__containedEvent || 0) + 100;
            e.timeStamp > r && (n = !0);
          } else TG(e), n = !0;
        } else n = !0;
        n && this.hide() && (this.settings.parent.style.pointerEvents = "", "mousedown" !== t && this.settings.parent.focus(), this.onClose && this.onClose(this.colour));
      }
    }, {
      key: "movePopup",
      value: function value(e, t) {
        this.closeHandler(), this.setOptions(e), t && this.openHandler();
      }
    }, {
      key: "setColor",
      value: function value(e, t) {
        this._setColor(e, {
          silent: t
        });
      }
    }, {
      key: "_setColor",
      value: function value(e, t) {
        if ("string" == typeof e && (e = e.trim()), e) {
          t = t || {};
          var n = void 0;
          try {
            n = new EG(e);
          } catch (e) {
            if (t.failSilently) return;
            throw e;
          }
          if (!this.settings.alpha) {
            var r = n.hsla;
            r[3] = 1, n.hsla = r;
          }
          this.colour = this.color = n, this._setHSLA(null, null, null, null, t);
        }
      }
    }, {
      key: "setColour",
      value: function value(e, t) {
        this.setColor(e, t);
      }
    }, {
      key: "show",
      value: function value() {
        if (!this.settings.parent) return !1;
        if (this.domElement) {
          var e = this._toggleDOM(!0);
          return this._setPosition(), e;
        }
        var t,
          n,
          r = this.settings.template || '<div class="picker_wrapper" tabindex="-1"><div class="picker_arrow"></div><div class="picker_hue picker_slider"><div class="picker_selector"></div></div><div class="picker_sl"><div class="picker_selector"></div></div><div class="picker_alpha picker_slider"><div class="picker_selector"></div></div><div class="picker_editor"><input aria-label="Type a color name or hex value"/></div><div class="picker_sample"></div><div class="picker_done"><button>Ok</button></div><div class="picker_cancel"><button>Cancel</button></div></div>',
          i = (t = r, (n = document.createElement("div")).innerHTML = t, n.firstElementChild);
        return this.domElement = i, this._domH = IG(".picker_hue", i), this._domSL = IG(".picker_sl", i), this._domA = IG(".picker_alpha", i), this._domEdit = IG(".picker_editor input", i), this._domSample = IG(".picker_sample", i), this._domOkay = IG(".picker_done button", i), this._domCancel = IG(".picker_cancel button", i), i.classList.add("layout_" + this.settings.layout), this.settings.alpha || i.classList.add("no_alpha"), this.settings.editor || i.classList.add("no_editor"), this.settings.cancelButton || i.classList.add("no_cancel"), this._ifPopup(function () {
          return i.classList.add("popup");
        }), this._setPosition(), this.colour ? this._updateUI() : this._setColor(this.settings.defaultColor), this._bindEvents(), !0;
      }
    }, {
      key: "hide",
      value: function value() {
        return this._toggleDOM(!1);
      }
    }, {
      key: "destroy",
      value: function value() {
        this._events.destroy(), this.domElement && this.settings.parent.removeChild(this.domElement);
      }
    }, {
      key: "_bindEvents",
      value: function value() {
        var e = this,
          t = this,
          n = this.domElement,
          r = this._events;
        function i(e, t, n) {
          r.add(e, t, n);
        }
        i(n, "click", function (e) {
          return e.preventDefault();
        }), MG(r, this._domH, function (e, n) {
          return t._setHSLA(e);
        }), MG(r, this._domSL, function (e, n) {
          return t._setHSLA(null, e, 1 - n);
        }), this.settings.alpha && MG(r, this._domA, function (e, n) {
          return t._setHSLA(null, null, null, 1 - n);
        });
        var o = this._domEdit;
        i(o, "input", function (e) {
          t._setColor(this.value, {
            fromEditor: !0,
            failSilently: !0
          });
        }), i(o, "focus", function (e) {
          var t = this;
          t.selectionStart === t.selectionEnd && t.select();
        }), this._ifPopup(function () {
          var t = function t(_t2) {
            return e.closeHandler(_t2);
          };
          i(window, "mousedown", t), i(window, "focusin", t), NG(r, n, ["Esc", "Escape"], t);
          var o = function o(t) {
            e.__containedEvent = t.timeStamp;
          };
          i(n, "mousedown", o), i(n, "focusin", o), i(e._domCancel, "click", t);
        });
        var a = function a(t) {
          e._ifPopup(function () {
            return e.closeHandler(t);
          }), e.onDone && e.onDone(e.colour);
        };
        i(this._domOkay, "click", a), NG(r, n, ["Enter"], a);
      }
    }, {
      key: "_setPosition",
      value: function value() {
        var e = this.settings.parent,
          t = this.domElement;
        e !== t.parentNode && e.appendChild(t), this._ifPopup(function (n) {
          "static" === getComputedStyle(e).position && (e.style.position = "relative");
          var r = !0 === n ? "popup_right" : "popup_" + n;
          ["popup_top", "popup_bottom", "popup_left", "popup_right"].forEach(function (e) {
            e === r ? t.classList.add(e) : t.classList.remove(e);
          }), t.classList.add(r);
        });
      }
    }, {
      key: "_setHSLA",
      value: function value(e, t, n, r, i) {
        i = i || {};
        var o = this.colour,
          a = o.hsla;
        [e, t, n, r].forEach(function (e, t) {
          (e || 0 === e) && (a[t] = e);
        }), o.hsla = a, this._updateUI(i), this.onChange && !i.silent && this.onChange(o);
      }
    }, {
      key: "_updateUI",
      value: function value(e) {
        if (this.domElement) {
          e = e || {};
          var t = this.colour,
            n = t.hsla,
            r = "hsl(" + 360 * n[0] + ", 100%, 50%)",
            i = t.hslString,
            o = t.hslaString,
            a = this._domH,
            s = this._domSL,
            u = this._domA,
            c = IG(".picker_selector", a),
            l = IG(".picker_selector", s),
            f = IG(".picker_selector", u);
          y(0, c, n[0]), this._domSL.style.backgroundColor = this._domH.style.color = r, y(0, l, n[1]), b(0, l, 1 - n[2]), s.style.color = i, b(0, f, 1 - n[3]);
          var h = i,
            d = h.replace("hsl", "hsla").replace(")", ", 0)"),
            v = "linear-gradient(" + [h, d] + ")";
          if (this._domA.style.background = v + ", linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0 / 2em 2em,\n                   linear-gradient(45deg, lightgrey 25%,       white 25%,       white 75%, lightgrey 75%) 1em 1em / 2em 2em", !e.fromEditor) {
            var p = this.settings.editorFormat,
              m = this.settings.alpha,
              g = void 0;
            switch (p) {
              case "rgb":
                g = t.printRGB(m);
                break;
              case "hsl":
                g = t.printHSL(m);
                break;
              default:
                g = t.printHex(m);
            }
            this._domEdit.value = g;
          }
          this._domSample.style.color = o;
        }
        function y(e, t, n) {
          t.style.left = 100 * n + "%";
        }
        function b(e, t, n) {
          t.style.top = 100 * n + "%";
        }
      }
    }, {
      key: "_ifPopup",
      value: function value(e, t) {
        this.settings.parent && this.settings.popup ? e && e(this.settings.popup) : t && t();
      }
    }, {
      key: "_toggleDOM",
      value: function value(e) {
        var t = this.domElement;
        if (!t) return !1;
        var n = e ? "" : "none",
          r = t.style.display !== n;
        return r && (t.style.display = n), r;
      }
    }]), e;
  }(),
  DG = document.createElement("style");
DG.textContent = '.picker_wrapper.no_alpha .picker_alpha{display:none}.picker_wrapper.no_editor .picker_editor{position:absolute;z-index:-1;opacity:0}.picker_wrapper.no_cancel .picker_cancel{display:none}.layout_default.picker_wrapper{display:flex;flex-flow:row wrap;justify-content:space-between;align-items:stretch;font-size:10px;width:25em;padding:.5em}.layout_default.picker_wrapper input,.layout_default.picker_wrapper button{font-size:1rem}.layout_default.picker_wrapper>*{margin:.5em}.layout_default.picker_wrapper::before{content:"";display:block;width:100%;height:0;order:1}.layout_default .picker_slider,.layout_default .picker_selector{padding:1em}.layout_default .picker_hue{width:100%}.layout_default .picker_sl{flex:1 1 auto}.layout_default .picker_sl::before{content:"";display:block;padding-bottom:100%}.layout_default .picker_editor{order:1;width:6.5rem}.layout_default .picker_editor input{width:100%;height:100%}.layout_default .picker_sample{order:1;flex:1 1 auto}.layout_default .picker_done,.layout_default .picker_cancel{order:1}.picker_wrapper{box-sizing:border-box;background:#f2f2f2;box-shadow:0 0 0 1px silver;cursor:default;font-family:sans-serif;color:#444;pointer-events:auto}.picker_wrapper:focus{outline:none}.picker_wrapper button,.picker_wrapper input{box-sizing:border-box;border:none;box-shadow:0 0 0 1px silver;outline:none}.picker_wrapper button:focus,.picker_wrapper button:active,.picker_wrapper input:focus,.picker_wrapper input:active{box-shadow:0 0 2px 1px #1e90ff}.picker_wrapper button{padding:.4em .6em;cursor:pointer;background-color:#f5f5f5;background-image:linear-gradient(0deg, gainsboro, transparent)}.picker_wrapper button:active{background-image:linear-gradient(0deg, transparent, gainsboro)}.picker_wrapper button:hover{background-color:#fff}.picker_selector{position:absolute;z-index:1;display:block;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);border:2px solid #fff;border-radius:100%;box-shadow:0 0 3px 1px #67b9ff;background:currentColor;cursor:pointer}.picker_slider .picker_selector{border-radius:2px}.picker_hue{position:relative;background-image:linear-gradient(90deg, red, yellow, lime, cyan, blue, magenta, red);box-shadow:0 0 0 1px silver}.picker_sl{position:relative;box-shadow:0 0 0 1px silver;background-image:linear-gradient(180deg, white, rgba(255, 255, 255, 0) 50%),linear-gradient(0deg, black, rgba(0, 0, 0, 0) 50%),linear-gradient(90deg, #808080, rgba(128, 128, 128, 0))}.picker_alpha,.picker_sample{position:relative;background:linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0/2em 2em,linear-gradient(45deg, lightgrey 25%, white 25%, white 75%, lightgrey 75%) 1em 1em/2em 2em;box-shadow:0 0 0 1px silver}.picker_alpha .picker_selector,.picker_sample .picker_selector{background:none}.picker_editor input{font-family:monospace;padding:.2em .4em}.picker_sample::before{content:"";position:absolute;display:block;width:100%;height:100%;background:currentColor}.picker_arrow{position:absolute;z-index:-1}.picker_wrapper.popup{position:absolute;z-index:2;margin:1.5em}.picker_wrapper.popup,.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{background:#f2f2f2;box-shadow:0 0 10px 1px rgba(0,0,0,.4)}.picker_wrapper.popup .picker_arrow{width:3em;height:3em;margin:0}.picker_wrapper.popup .picker_arrow::before,.picker_wrapper.popup .picker_arrow::after{content:"";display:block;position:absolute;top:0;left:0;z-index:-99}.picker_wrapper.popup .picker_arrow::before{width:100%;height:100%;-webkit-transform:skew(45deg);transform:skew(45deg);-webkit-transform-origin:0 100%;transform-origin:0 100%}.picker_wrapper.popup .picker_arrow::after{width:150%;height:150%;box-shadow:none}.popup.popup_top{bottom:100%;left:0}.popup.popup_top .picker_arrow{bottom:0;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.popup.popup_bottom{top:100%;left:0}.popup.popup_bottom .picker_arrow{top:0;left:0;-webkit-transform:rotate(90deg) scale(1, -1);transform:rotate(90deg) scale(1, -1)}.popup.popup_left{top:0;right:100%}.popup.popup_left .picker_arrow{top:0;right:0;-webkit-transform:scale(-1, 1);transform:scale(-1, 1)}.popup.popup_right{top:0;left:100%}.popup.popup_right .picker_arrow{top:0;left:0}', document.documentElement.firstElementChild.appendChild(DG), RG.StyleElement = DG;
var zG = Object.freeze({
    __proto__: null,
    default: RG
  }),
  LG = ks.exports.compileJSONPointer,
  BG = ks.exports.deleteIn,
  qG = ks.exports.existsIn,
  FG = ks.exports.getIn,
  VG = ks.exports.immutableJSONPatch,
  HG = ks.exports.insertAt,
  WG = ks.exports.parseJSONPointer,
  UG = ks.exports.revertJSONPatch,
  JG = ks.exports.setIn,
  KG = ks.exports.updateIn;
export { EU as BooleanToggle, zU as ColorPicker, FU as EditableValue, lG as EnumValue, rG as JSONEditor, KU as ReadonlyValue, VK as SortModal, ZU as TimestampTag, RK as TransformModal, LG as compileJSONPointer, yG as createAjvValidator, BG as deleteIn, su as estimateSerializedSize, qG as existsIn, hG as findEnum, dG as findSchema, FG as getIn, fG as getJSONSchemaOptions, VG as immutableJSONPatch, HG as insertAt, au as isLargeContent, UK as isMenuSpaceItem, ou as isTextContent, _U as javascriptQueryLanguage, jG as jmespathQueryLanguage, wG as lodashQueryLanguage, WG as parseJSONPointer, px as parseJSONPointerWithArrayIndices, vG as renderJSONSchemaEnum, XU as renderValue, UG as revertJSONPatch, JG as setIn, KG as updateIn };